import { gql } from '@apollo/client/core'
import * as VueApolloComposable from '@vue/apollo-composable'
import type * as VueCompositionApi from 'vue'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
export type ReactiveFunction<TParam> = () => TParam
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Date: { input: any; output: any }
  DateTime: { input: any; output: any }
  Hex: { input: any; output: any }
  Json: { input: any; output: any }
  Long: { input: any; output: any }
  RGBAHue: { input: any; output: any }
  RGBATransparency: { input: any; output: any }
  RichTextAST: { input: any; output: any }
}

export type Aggregate = {
  __typename?: 'Aggregate'
  count: Scalars['Int']['output']
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounter = Entity &
  Node & {
    __typename?: 'AnimatedCounter'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<AnimatedCounter>
    /** List of AnimatedCounter versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<AnimatedCounter>
    /** If specified, this will be prefixed before the counter value. */
    prefix?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    start?: Maybe<Scalars['Int']['output']>
    /** Will be shown under the counter value. */
    subhead?: Maybe<Scalars['String']['output']>
    /** If specified, this will be appended after the counter value. */
    suffix?: Maybe<Scalars['String']['output']>
    target: Scalars['Int']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** In the animated counter section this model represents one counter settings */
export type AnimatedCounterUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type AnimatedCounterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: AnimatedCounterWhereUniqueInput
}

/** A connection to a list of items. */
export type AnimatedCounterConnection = {
  __typename?: 'AnimatedCounterConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<AnimatedCounterEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type AnimatedCounterCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AnimatedCounterCreateLocalizationsInput>
  /** prefix input for default locale (de) */
  prefix?: InputMaybe<Scalars['String']['input']>
  sectionCounter?: InputMaybe<SectionByTheNumbersCreateOneInlineInput>
  start?: InputMaybe<Scalars['Int']['input']>
  /** subhead input for default locale (de) */
  subhead?: InputMaybe<Scalars['String']['input']>
  /** suffix input for default locale (de) */
  suffix?: InputMaybe<Scalars['String']['input']>
  target: Scalars['Int']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type AnimatedCounterCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  prefix?: InputMaybe<Scalars['String']['input']>
  subhead?: InputMaybe<Scalars['String']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type AnimatedCounterCreateLocalizationInput = {
  /** Localization input */
  data: AnimatedCounterCreateLocalizationDataInput
  locale: Locale
}

export type AnimatedCounterCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AnimatedCounterCreateLocalizationInput>>
}

export type AnimatedCounterCreateManyInlineInput = {
  /** Connect multiple existing AnimatedCounter documents */
  connect?: InputMaybe<Array<AnimatedCounterWhereUniqueInput>>
  /** Create and connect multiple existing AnimatedCounter documents */
  create?: InputMaybe<Array<AnimatedCounterCreateInput>>
}

export type AnimatedCounterCreateOneInlineInput = {
  /** Connect one existing AnimatedCounter document */
  connect?: InputMaybe<AnimatedCounterWhereUniqueInput>
  /** Create and connect one AnimatedCounter document */
  create?: InputMaybe<AnimatedCounterCreateInput>
}

/** An edge in a connection. */
export type AnimatedCounterEdge = {
  __typename?: 'AnimatedCounterEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: AnimatedCounter
}

/** Identifies documents */
export type AnimatedCounterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnimatedCounterWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnimatedCounterWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnimatedCounterWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<AnimatedCounterWhereStageInput>
  documentInStages_none?: InputMaybe<AnimatedCounterWhereStageInput>
  documentInStages_some?: InputMaybe<AnimatedCounterWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  start?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  start_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  start_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  start_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  start_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  start_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  start_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  start_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  target?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  target_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  target_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  target_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  target_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  target_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  target_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  target_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum AnimatedCounterOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PrefixAsc = 'prefix_ASC',
  PrefixDesc = 'prefix_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StartAsc = 'start_ASC',
  StartDesc = 'start_DESC',
  SubheadAsc = 'subhead_ASC',
  SubheadDesc = 'subhead_DESC',
  SuffixAsc = 'suffix_ASC',
  SuffixDesc = 'suffix_DESC',
  TargetAsc = 'target_ASC',
  TargetDesc = 'target_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type AnimatedCounterUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<AnimatedCounterUpdateLocalizationsInput>
  /** prefix input for default locale (de) */
  prefix?: InputMaybe<Scalars['String']['input']>
  sectionCounter?: InputMaybe<SectionByTheNumbersUpdateOneInlineInput>
  start?: InputMaybe<Scalars['Int']['input']>
  /** subhead input for default locale (de) */
  subhead?: InputMaybe<Scalars['String']['input']>
  /** suffix input for default locale (de) */
  suffix?: InputMaybe<Scalars['String']['input']>
  target?: InputMaybe<Scalars['Int']['input']>
}

export type AnimatedCounterUpdateLocalizationDataInput = {
  prefix?: InputMaybe<Scalars['String']['input']>
  subhead?: InputMaybe<Scalars['String']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
}

export type AnimatedCounterUpdateLocalizationInput = {
  data: AnimatedCounterUpdateLocalizationDataInput
  locale: Locale
}

export type AnimatedCounterUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AnimatedCounterCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<AnimatedCounterUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<AnimatedCounterUpsertLocalizationInput>>
}

export type AnimatedCounterUpdateManyInlineInput = {
  /** Connect multiple existing AnimatedCounter documents */
  connect?: InputMaybe<Array<AnimatedCounterConnectInput>>
  /** Create and connect multiple AnimatedCounter documents */
  create?: InputMaybe<Array<AnimatedCounterCreateInput>>
  /** Delete multiple AnimatedCounter documents */
  delete?: InputMaybe<Array<AnimatedCounterWhereUniqueInput>>
  /** Disconnect multiple AnimatedCounter documents */
  disconnect?: InputMaybe<Array<AnimatedCounterWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing AnimatedCounter documents */
  set?: InputMaybe<Array<AnimatedCounterWhereUniqueInput>>
  /** Update multiple AnimatedCounter documents */
  update?: InputMaybe<Array<AnimatedCounterUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple AnimatedCounter documents */
  upsert?: InputMaybe<Array<AnimatedCounterUpsertWithNestedWhereUniqueInput>>
}

export type AnimatedCounterUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<AnimatedCounterUpdateManyLocalizationsInput>
  /** prefix input for default locale (de) */
  prefix?: InputMaybe<Scalars['String']['input']>
  start?: InputMaybe<Scalars['Int']['input']>
  /** subhead input for default locale (de) */
  subhead?: InputMaybe<Scalars['String']['input']>
  /** suffix input for default locale (de) */
  suffix?: InputMaybe<Scalars['String']['input']>
  target?: InputMaybe<Scalars['Int']['input']>
}

export type AnimatedCounterUpdateManyLocalizationDataInput = {
  prefix?: InputMaybe<Scalars['String']['input']>
  subhead?: InputMaybe<Scalars['String']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
}

export type AnimatedCounterUpdateManyLocalizationInput = {
  data: AnimatedCounterUpdateManyLocalizationDataInput
  locale: Locale
}

export type AnimatedCounterUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AnimatedCounterUpdateManyLocalizationInput>>
}

export type AnimatedCounterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnimatedCounterUpdateManyInput
  /** Document search */
  where: AnimatedCounterWhereInput
}

export type AnimatedCounterUpdateOneInlineInput = {
  /** Connect existing AnimatedCounter document */
  connect?: InputMaybe<AnimatedCounterWhereUniqueInput>
  /** Create and connect one AnimatedCounter document */
  create?: InputMaybe<AnimatedCounterCreateInput>
  /** Delete currently connected AnimatedCounter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected AnimatedCounter document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single AnimatedCounter document */
  update?: InputMaybe<AnimatedCounterUpdateWithNestedWhereUniqueInput>
  /** Upsert single AnimatedCounter document */
  upsert?: InputMaybe<AnimatedCounterUpsertWithNestedWhereUniqueInput>
}

export type AnimatedCounterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnimatedCounterUpdateInput
  /** Unique document search */
  where: AnimatedCounterWhereUniqueInput
}

export type AnimatedCounterUpsertInput = {
  /** Create document if it didn't exist */
  create: AnimatedCounterCreateInput
  /** Update document if it exists */
  update: AnimatedCounterUpdateInput
}

export type AnimatedCounterUpsertLocalizationInput = {
  create: AnimatedCounterCreateLocalizationDataInput
  locale: Locale
  update: AnimatedCounterUpdateLocalizationDataInput
}

export type AnimatedCounterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnimatedCounterUpsertInput
  /** Unique document search */
  where: AnimatedCounterWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type AnimatedCounterWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type AnimatedCounterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnimatedCounterWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnimatedCounterWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnimatedCounterWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<AnimatedCounterWhereStageInput>
  documentInStages_none?: InputMaybe<AnimatedCounterWhereStageInput>
  documentInStages_some?: InputMaybe<AnimatedCounterWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  prefix?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  prefix_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  prefix_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  prefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  prefix_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  prefix_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  prefix_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  prefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  prefix_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  prefix_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  start?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  start_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  start_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  start_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  start_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  start_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  start_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  start_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  subhead?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subhead_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subhead_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subhead_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subhead_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subhead_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subhead_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subhead_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subhead_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subhead_starts_with?: InputMaybe<Scalars['String']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  suffix_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  suffix_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  suffix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  suffix_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  suffix_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  suffix_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  suffix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  suffix_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  suffix_starts_with?: InputMaybe<Scalars['String']['input']>
  target?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  target_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  target_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  target_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  target_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  target_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  target_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  target_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AnimatedCounterWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnimatedCounterWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnimatedCounterWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnimatedCounterWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AnimatedCounterWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References AnimatedCounter record uniquely */
export type AnimatedCounterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type Article = Entity &
  Node & {
    __typename?: 'Article'
    articleCategories: Array<ArticleCategory>
    articleType: ArticleType
    /** Authors of German article content */
    authors: Array<Author>
    authorsEn: Array<Author>
    body: ArticleBodyRichText
    /** Optional button displayed on article page. Can be used as eg download button for briefing information. */
    callToAction: Array<ArticleCta>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<Article>
    /** Featured image or short video */
    featuredMedia: Asset
    /** Featured Media Portrait for Article */
    featuredMediaPortrait?: Maybe<Asset>
    hideNewsletterBox?: Maybe<Scalars['Boolean']['output']>
    /** List of Article versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Article>
    onlyEnglish: Scalars['Boolean']['output']
    /** Page views based on Google Analytics */
    pageViews: Scalars['Int']['output']
    publishDateTime: Scalars['DateTime']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    reviewsAgencies: Array<ReviewsAgency>
    reviewsProductCategories: Array<ReviewsProductCategory>
    reviewsProducts: Array<ReviewsProduct>
    scheduledIn: Array<ScheduledOperation>
    /** Optional configuration if you want to have specific SEO Attributes. By default seo.title = article.title, seo.description = article.snippet, seo.ogImage = article.featuredImage, seo.ogTitle = seo.title, seo ogDescription = seo.description */
    seoAttributes?: Maybe<Seo>
    showTableOfContents?: Maybe<Scalars['Boolean']['output']>
    slug: Scalars['String']['output']
    /** Short snippet from the article which will be used on category pages and preview cards to tease the article. */
    snippet: Scalars['String']['output']
    /** Highlight sponsored articles */
    sponsored?: Maybe<Scalars['Boolean']['output']>
    /** System stage field */
    stage: Stage
    subtitle?: Maybe<Scalars['String']['output']>
    tags: Array<Tag>
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    /** VG Wort integration data assigned to German article content (autogenerated on save) */
    vgWort?: Maybe<VgWort>
    /** System workflow field */
    workflowStep?: Maybe<Workflow>
  }

export type ArticleArticleCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleCategoryWhereInput>
}

export type ArticleAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<AuthorOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AuthorWhereInput>
}

export type ArticleAuthorsEnArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<AuthorOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AuthorWhereInput>
}

export type ArticleCallToActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleCtaOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleCtaWhereInput>
}

export type ArticleCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ArticleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type ArticleFeaturedMediaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type ArticleFeaturedMediaPortraitArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type ArticleHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type ArticleLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type ArticlePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ArticlePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleReviewsAgenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsAgencyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsAgencyWhereInput>
}

export type ArticleReviewsProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsProductCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductCategoryWhereInput>
}

export type ArticleReviewsProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsProductOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductWhereInput>
}

export type ArticleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type ArticleSeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TagOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TagWhereInput>
}

export type ArticleUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ArticleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleVgWortArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleBodyRichText = {
  __typename?: 'ArticleBodyRichText'
  /** Returns HTMl representation */
  html: Scalars['String']['output']
  json: Scalars['RichTextAST']['output']
  /** Returns Markdown representation */
  markdown: Scalars['String']['output']
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output']
  references: Array<ArticleBodyRichTextEmbeddedTypes>
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output']
}

export type ArticleBodyRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
}

export type ArticleBodyRichTextEmbeddedTypes =
  | Asset
  | Author
  | HtmlEmbed
  | ImageGalleryEmbed
  | ReviewsAgency
  | ReviewsProduct
  | ReviewsProductCategory
  | ReviewsProductWidget
  | SocialEmbed

export type ArticleCategory = Entity &
  Node & {
    __typename?: 'ArticleCategory'
    articles: Array<Article>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<ArticleCategory>
    /** List of ArticleCategory versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<ArticleCategory>
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** Optional configuration if you want to have specific SEO Attributes. */
    seoAttributes?: Maybe<Seo>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    /** Optional wordpress reference used by importer */
    wpId?: Maybe<Scalars['String']['output']>
  }

export type ArticleCategoryArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleWhereInput>
}

export type ArticleCategoryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ArticleCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type ArticleCategoryHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type ArticleCategoryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type ArticleCategoryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ArticleCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type ArticleCategorySeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleCategoryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ArticleCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticleCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ArticleCategoryWhereUniqueInput
}

/** A connection to a list of items. */
export type ArticleCategoryConnection = {
  __typename?: 'ArticleCategoryConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ArticleCategoryEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ArticleCategoryCreateInput = {
  articleByCategory?: InputMaybe<ArticlesByTagCreateOneInlineInput>
  articles?: InputMaybe<ArticleCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hubPageArticleListTileArticleCategories?: InputMaybe<HubPageArticleListTileCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ArticleCategoryCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  slug: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type ArticleCategoryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ArticleCategoryCreateLocalizationInput = {
  /** Localization input */
  data: ArticleCategoryCreateLocalizationDataInput
  locale: Locale
}

export type ArticleCategoryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ArticleCategoryCreateLocalizationInput>>
}

export type ArticleCategoryCreateManyInlineInput = {
  /** Connect multiple existing ArticleCategory documents */
  connect?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>
  /** Create and connect multiple existing ArticleCategory documents */
  create?: InputMaybe<Array<ArticleCategoryCreateInput>>
}

export type ArticleCategoryCreateOneInlineInput = {
  /** Connect one existing ArticleCategory document */
  connect?: InputMaybe<ArticleCategoryWhereUniqueInput>
  /** Create and connect one ArticleCategory document */
  create?: InputMaybe<ArticleCategoryCreateInput>
}

/** An edge in a connection. */
export type ArticleCategoryEdge = {
  __typename?: 'ArticleCategoryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ArticleCategory
}

/** Identifies documents */
export type ArticleCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleCategoryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleCategoryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleCategoryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ArticleCategoryWhereStageInput>
  documentInStages_none?: InputMaybe<ArticleCategoryWhereStageInput>
  documentInStages_some?: InputMaybe<ArticleCategoryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum ArticleCategoryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WpIdAsc = 'wpId_ASC',
  WpIdDesc = 'wpId_DESC',
}

export type ArticleCategoryUpdateInput = {
  articleByCategory?: InputMaybe<ArticlesByTagUpdateOneInlineInput>
  articles?: InputMaybe<ArticleUpdateManyInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hubPageArticleListTileArticleCategories?: InputMaybe<HubPageArticleListTileUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<ArticleCategoryUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type ArticleCategoryUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ArticleCategoryUpdateLocalizationInput = {
  data: ArticleCategoryUpdateLocalizationDataInput
  locale: Locale
}

export type ArticleCategoryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ArticleCategoryCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ArticleCategoryUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ArticleCategoryUpsertLocalizationInput>>
}

export type ArticleCategoryUpdateManyInlineInput = {
  /** Connect multiple existing ArticleCategory documents */
  connect?: InputMaybe<Array<ArticleCategoryConnectInput>>
  /** Create and connect multiple ArticleCategory documents */
  create?: InputMaybe<Array<ArticleCategoryCreateInput>>
  /** Delete multiple ArticleCategory documents */
  delete?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>
  /** Disconnect multiple ArticleCategory documents */
  disconnect?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ArticleCategory documents */
  set?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>
  /** Update multiple ArticleCategory documents */
  update?: InputMaybe<Array<ArticleCategoryUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ArticleCategory documents */
  upsert?: InputMaybe<Array<ArticleCategoryUpsertWithNestedWhereUniqueInput>>
}

export type ArticleCategoryUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ArticleCategoryUpdateManyLocalizationsInput>
}

export type ArticleCategoryUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type ArticleCategoryUpdateManyLocalizationInput = {
  data: ArticleCategoryUpdateManyLocalizationDataInput
  locale: Locale
}

export type ArticleCategoryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ArticleCategoryUpdateManyLocalizationInput>>
}

export type ArticleCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticleCategoryUpdateManyInput
  /** Document search */
  where: ArticleCategoryWhereInput
}

export type ArticleCategoryUpdateOneInlineInput = {
  /** Connect existing ArticleCategory document */
  connect?: InputMaybe<ArticleCategoryWhereUniqueInput>
  /** Create and connect one ArticleCategory document */
  create?: InputMaybe<ArticleCategoryCreateInput>
  /** Delete currently connected ArticleCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ArticleCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ArticleCategory document */
  update?: InputMaybe<ArticleCategoryUpdateWithNestedWhereUniqueInput>
  /** Upsert single ArticleCategory document */
  upsert?: InputMaybe<ArticleCategoryUpsertWithNestedWhereUniqueInput>
}

export type ArticleCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticleCategoryUpdateInput
  /** Unique document search */
  where: ArticleCategoryWhereUniqueInput
}

export type ArticleCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticleCategoryCreateInput
  /** Update document if it exists */
  update: ArticleCategoryUpdateInput
}

export type ArticleCategoryUpsertLocalizationInput = {
  create: ArticleCategoryCreateLocalizationDataInput
  locale: Locale
  update: ArticleCategoryUpdateLocalizationDataInput
}

export type ArticleCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticleCategoryUpsertInput
  /** Unique document search */
  where: ArticleCategoryWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ArticleCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ArticleCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleCategoryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleCategoryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleCategoryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<ArticleCategoryWhereStageInput>
  documentInStages_none?: InputMaybe<ArticleCategoryWhereStageInput>
  documentInStages_some?: InputMaybe<ArticleCategoryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleCategoryWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleCategoryWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleCategoryWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleCategoryWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ArticleCategory record uniquely */
export type ArticleCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type ArticleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ArticleWhereUniqueInput
}

/** A connection to a list of items. */
export type ArticleConnection = {
  __typename?: 'ArticleConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ArticleEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ArticleCreateInput = {
  articleCategories?: InputMaybe<ArticleCategoryCreateManyInlineInput>
  articlePageViewCount?: InputMaybe<ArticlePageViewCreateOneInlineInput>
  articleType: ArticleType
  authors?: InputMaybe<AuthorCreateManyInlineInput>
  authorsEn?: InputMaybe<AuthorCreateManyInlineInput>
  /** body input for default locale (de) */
  body: Scalars['RichTextAST']['input']
  callToAction?: InputMaybe<ArticleCtaCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  featuredMedia: AssetCreateOneInlineInput
  featuredMediaPortrait?: InputMaybe<AssetCreateOneInlineInput>
  hideNewsletterBox?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ArticleCreateLocalizationsInput>
  onlyEnglish: Scalars['Boolean']['input']
  pageViews: Scalars['Int']['input']
  publishDateTime: Scalars['DateTime']['input']
  reviewsAgencies?: InputMaybe<ReviewsAgencyCreateManyInlineInput>
  reviewsProductCategories?: InputMaybe<ReviewsProductCategoryCreateManyInlineInput>
  reviewsProducts?: InputMaybe<ReviewsProductCreateManyInlineInput>
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>
  /** slug input for default locale (de) */
  slug: Scalars['String']['input']
  /** snippet input for default locale (de) */
  snippet: Scalars['String']['input']
  sponsored?: InputMaybe<Scalars['Boolean']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<TagCreateManyInlineInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  vgWort?: InputMaybe<VgWortCreateOneInlineInput>
  workflowStep?: InputMaybe<Workflow>
}

export type ArticleCreateLocalizationDataInput = {
  body: Scalars['RichTextAST']['input']
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  slug: Scalars['String']['input']
  snippet: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ArticleCreateLocalizationInput = {
  /** Localization input */
  data: ArticleCreateLocalizationDataInput
  locale: Locale
}

export type ArticleCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ArticleCreateLocalizationInput>>
}

export type ArticleCreateManyInlineInput = {
  /** Connect multiple existing Article documents */
  connect?: InputMaybe<Array<ArticleWhereUniqueInput>>
  /** Create and connect multiple existing Article documents */
  create?: InputMaybe<Array<ArticleCreateInput>>
}

export type ArticleCreateOneInlineInput = {
  /** Connect one existing Article document */
  connect?: InputMaybe<ArticleWhereUniqueInput>
  /** Create and connect one Article document */
  create?: InputMaybe<ArticleCreateInput>
}

/** Simple button call to action placed inside article content */
export type ArticleCta = Entity & {
  __typename?: 'ArticleCta'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<ArticleCta>
  /** Text displayed on the button */
  name: Scalars['String']['output']
  openInNewTab?: Maybe<Scalars['Boolean']['output']>
  position: ElementPosition
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url: Scalars['String']['output']
}

/** Simple button call to action placed inside article content */
export type ArticleCtaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Simple button call to action placed inside article content */
export type ArticleCtaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ArticleCtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ArticleCtaWhereUniqueInput
}

/** A connection to a list of items. */
export type ArticleCtaConnection = {
  __typename?: 'ArticleCtaConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ArticleCtaEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ArticleCtaCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ArticleCtaCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>
  position: ElementPosition
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  url: Scalars['String']['input']
}

export type ArticleCtaCreateLocalizationDataInput = {
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ArticleCtaCreateLocalizationInput = {
  /** Localization input */
  data: ArticleCtaCreateLocalizationDataInput
  locale: Locale
}

export type ArticleCtaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ArticleCtaCreateLocalizationInput>>
}

export type ArticleCtaCreateManyInlineInput = {
  /** Create and connect multiple existing ArticleCta documents */
  create?: InputMaybe<Array<ArticleCtaCreateInput>>
}

export type ArticleCtaCreateOneInlineInput = {
  /** Create and connect one ArticleCta document */
  create?: InputMaybe<ArticleCtaCreateInput>
}

export type ArticleCtaCreateWithPositionInput = {
  /** Document to create */
  data: ArticleCtaCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type ArticleCtaEdge = {
  __typename?: 'ArticleCtaEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ArticleCta
}

/** Identifies documents */
export type ArticleCtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleCtaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleCtaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleCtaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>
  position?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum ArticleCtaOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OpenInNewTabAsc = 'openInNewTab_ASC',
  OpenInNewTabDesc = 'openInNewTab_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
}

export type ArticleCtaParent = Article

export type ArticleCtaParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>
}

export type ArticleCtaParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>
}

export type ArticleCtaParentCreateManyInlineInput = {
  /** Connect multiple existing ArticleCtaParent documents */
  connect?: InputMaybe<Array<ArticleCtaParentWhereUniqueInput>>
  /** Create and connect multiple existing ArticleCtaParent documents */
  create?: InputMaybe<Array<ArticleCtaParentCreateInput>>
}

export type ArticleCtaParentCreateOneInlineInput = {
  /** Connect one existing ArticleCtaParent document */
  connect?: InputMaybe<ArticleCtaParentWhereUniqueInput>
  /** Create and connect one ArticleCtaParent document */
  create?: InputMaybe<ArticleCtaParentCreateInput>
}

export type ArticleCtaParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>
}

export type ArticleCtaParentUpdateManyInlineInput = {
  /** Connect multiple existing ArticleCtaParent documents */
  connect?: InputMaybe<Array<ArticleCtaParentConnectInput>>
  /** Create and connect multiple ArticleCtaParent documents */
  create?: InputMaybe<Array<ArticleCtaParentCreateInput>>
  /** Delete multiple ArticleCtaParent documents */
  delete?: InputMaybe<Array<ArticleCtaParentWhereUniqueInput>>
  /** Disconnect multiple ArticleCtaParent documents */
  disconnect?: InputMaybe<Array<ArticleCtaParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ArticleCtaParent documents */
  set?: InputMaybe<Array<ArticleCtaParentWhereUniqueInput>>
  /** Update multiple ArticleCtaParent documents */
  update?: InputMaybe<Array<ArticleCtaParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ArticleCtaParent documents */
  upsert?: InputMaybe<Array<ArticleCtaParentUpsertWithNestedWhereUniqueInput>>
}

export type ArticleCtaParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>
}

export type ArticleCtaParentUpdateOneInlineInput = {
  /** Connect existing ArticleCtaParent document */
  connect?: InputMaybe<ArticleCtaParentWhereUniqueInput>
  /** Create and connect one ArticleCtaParent document */
  create?: InputMaybe<ArticleCtaParentCreateInput>
  /** Delete currently connected ArticleCtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ArticleCtaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ArticleCtaParent document */
  update?: InputMaybe<ArticleCtaParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single ArticleCtaParent document */
  upsert?: InputMaybe<ArticleCtaParentUpsertWithNestedWhereUniqueInput>
}

export type ArticleCtaParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>
}

export type ArticleCtaParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>
}

export type ArticleCtaParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>
}

export type ArticleCtaParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>
}

export type ArticleCtaUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<ArticleCtaUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>
  position?: InputMaybe<ElementPosition>
  url?: InputMaybe<Scalars['String']['input']>
}

export type ArticleCtaUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ArticleCtaUpdateLocalizationInput = {
  data: ArticleCtaUpdateLocalizationDataInput
  locale: Locale
}

export type ArticleCtaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ArticleCtaCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ArticleCtaUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ArticleCtaUpsertLocalizationInput>>
}

export type ArticleCtaUpdateManyInlineInput = {
  /** Create and connect multiple ArticleCta component instances */
  create?: InputMaybe<Array<ArticleCtaCreateWithPositionInput>>
  /** Delete multiple ArticleCta documents */
  delete?: InputMaybe<Array<ArticleCtaWhereUniqueInput>>
  /** Update multiple ArticleCta component instances */
  update?: InputMaybe<Array<ArticleCtaUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple ArticleCta component instances */
  upsert?: InputMaybe<Array<ArticleCtaUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type ArticleCtaUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<ArticleCtaUpdateManyLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>
  position?: InputMaybe<ElementPosition>
  url?: InputMaybe<Scalars['String']['input']>
}

export type ArticleCtaUpdateManyLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ArticleCtaUpdateManyLocalizationInput = {
  data: ArticleCtaUpdateManyLocalizationDataInput
  locale: Locale
}

export type ArticleCtaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ArticleCtaUpdateManyLocalizationInput>>
}

export type ArticleCtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticleCtaUpdateManyInput
  /** Document search */
  where: ArticleCtaWhereInput
}

export type ArticleCtaUpdateOneInlineInput = {
  /** Create and connect one ArticleCta document */
  create?: InputMaybe<ArticleCtaCreateInput>
  /** Delete currently connected ArticleCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ArticleCta document */
  update?: InputMaybe<ArticleCtaUpdateWithNestedWhereUniqueInput>
  /** Upsert single ArticleCta document */
  upsert?: InputMaybe<ArticleCtaUpsertWithNestedWhereUniqueInput>
}

export type ArticleCtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ArticleCtaUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ArticleCtaWhereUniqueInput
}

export type ArticleCtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticleCtaUpdateInput
  /** Unique document search */
  where: ArticleCtaWhereUniqueInput
}

export type ArticleCtaUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticleCtaCreateInput
  /** Update document if it exists */
  update: ArticleCtaUpdateInput
}

export type ArticleCtaUpsertLocalizationInput = {
  create: ArticleCtaCreateLocalizationDataInput
  locale: Locale
  update: ArticleCtaUpdateLocalizationDataInput
}

export type ArticleCtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ArticleCtaUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ArticleCtaWhereUniqueInput
}

export type ArticleCtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticleCtaUpsertInput
  /** Unique document search */
  where: ArticleCtaWhereUniqueInput
}

/** Identifies documents */
export type ArticleCtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleCtaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleCtaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleCtaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>
  position?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** References ArticleCta record uniquely */
export type ArticleCtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** An edge in a connection. */
export type ArticleEdge = {
  __typename?: 'ArticleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Article
}

/** Identifies documents */
export type ArticleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articleCategories_every?: InputMaybe<ArticleCategoryWhereInput>
  articleCategories_none?: InputMaybe<ArticleCategoryWhereInput>
  articleCategories_some?: InputMaybe<ArticleCategoryWhereInput>
  articleType?: InputMaybe<ArticleType>
  /** All values that are contained in given list. */
  articleType_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  /** Any other value that exists and is not equal to the given value. */
  articleType_not?: InputMaybe<ArticleType>
  /** All values that are not contained in given list. */
  articleType_not_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  authorsEn_every?: InputMaybe<AuthorWhereInput>
  authorsEn_none?: InputMaybe<AuthorWhereInput>
  authorsEn_some?: InputMaybe<AuthorWhereInput>
  authors_every?: InputMaybe<AuthorWhereInput>
  authors_none?: InputMaybe<AuthorWhereInput>
  authors_some?: InputMaybe<AuthorWhereInput>
  callToAction_every?: InputMaybe<ArticleCtaWhereInput>
  callToAction_none?: InputMaybe<ArticleCtaWhereInput>
  callToAction_some?: InputMaybe<ArticleCtaWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ArticleWhereStageInput>
  documentInStages_none?: InputMaybe<ArticleWhereStageInput>
  documentInStages_some?: InputMaybe<ArticleWhereStageInput>
  featuredMedia?: InputMaybe<AssetWhereInput>
  featuredMediaPortrait?: InputMaybe<AssetWhereInput>
  hideNewsletterBox?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideNewsletterBox_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  onlyEnglish?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  onlyEnglish_not?: InputMaybe<Scalars['Boolean']['input']>
  pageViews?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageViews_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageViews_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageViews_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageViews_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageViews_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageViews_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageViews_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  publishDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reviewsAgencies_every?: InputMaybe<ReviewsAgencyWhereInput>
  reviewsAgencies_none?: InputMaybe<ReviewsAgencyWhereInput>
  reviewsAgencies_some?: InputMaybe<ReviewsAgencyWhereInput>
  reviewsProductCategories_every?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_none?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_some?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProducts_every?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_none?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_some?: InputMaybe<ReviewsProductWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showTableOfContents_not?: InputMaybe<Scalars['Boolean']['input']>
  sponsored?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  sponsored_not?: InputMaybe<Scalars['Boolean']['input']>
  tags_every?: InputMaybe<TagWhereInput>
  tags_none?: InputMaybe<TagWhereInput>
  tags_some?: InputMaybe<TagWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  vgWort?: InputMaybe<VgWortWhereInput>
  workflowStep?: InputMaybe<Workflow>
  /** All values that are contained in given list. */
  workflowStep_in?: InputMaybe<Array<InputMaybe<Workflow>>>
  /** Any other value that exists and is not equal to the given value. */
  workflowStep_not?: InputMaybe<Workflow>
  /** All values that are not contained in given list. */
  workflowStep_not_in?: InputMaybe<Array<InputMaybe<Workflow>>>
}

export enum ArticleOrderByInput {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HideNewsletterBoxAsc = 'hideNewsletterBox_ASC',
  HideNewsletterBoxDesc = 'hideNewsletterBox_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OnlyEnglishAsc = 'onlyEnglish_ASC',
  OnlyEnglishDesc = 'onlyEnglish_DESC',
  PageViewsAsc = 'pageViews_ASC',
  PageViewsDesc = 'pageViews_DESC',
  PublishDateTimeAsc = 'publishDateTime_ASC',
  PublishDateTimeDesc = 'publishDateTime_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShowTableOfContentsAsc = 'showTableOfContents_ASC',
  ShowTableOfContentsDesc = 'showTableOfContents_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SnippetAsc = 'snippet_ASC',
  SnippetDesc = 'snippet_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WorkflowStepAsc = 'workflowStep_ASC',
  WorkflowStepDesc = 'workflowStep_DESC',
}

/** Article pageViews in the last 30 days */
export type ArticlePageView = Entity &
  Node & {
    __typename?: 'ArticlePageView'
    article: Article
    /** Slug of the article. Required for upserting data. */
    articleSlug: Scalars['String']['output']
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<ArticlePageView>
    /** List of ArticlePageView versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Locale of the page view. */
    pageViewLocale: Scalars['String']['output']
    /** Number of page views in the last 30 days based on Google Analytics */
    pageViews: Scalars['Int']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Article pageViews in the last 30 days */
export type ArticlePageViewArticleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Article pageViews in the last 30 days */
export type ArticlePageViewCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Article pageViews in the last 30 days */
export type ArticlePageViewDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Article pageViews in the last 30 days */
export type ArticlePageViewHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Article pageViews in the last 30 days */
export type ArticlePageViewPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Article pageViews in the last 30 days */
export type ArticlePageViewScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Article pageViews in the last 30 days */
export type ArticlePageViewUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticlePageViewConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ArticlePageViewWhereUniqueInput
}

/** A connection to a list of items. */
export type ArticlePageViewConnection = {
  __typename?: 'ArticlePageViewConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ArticlePageViewEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ArticlePageViewCreateInput = {
  article: ArticleCreateOneInlineInput
  articleSlug: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  pageViewLocale: Scalars['String']['input']
  pageViews: Scalars['Int']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ArticlePageViewCreateManyInlineInput = {
  /** Connect multiple existing ArticlePageView documents */
  connect?: InputMaybe<Array<ArticlePageViewWhereUniqueInput>>
  /** Create and connect multiple existing ArticlePageView documents */
  create?: InputMaybe<Array<ArticlePageViewCreateInput>>
}

export type ArticlePageViewCreateOneInlineInput = {
  /** Connect one existing ArticlePageView document */
  connect?: InputMaybe<ArticlePageViewWhereUniqueInput>
  /** Create and connect one ArticlePageView document */
  create?: InputMaybe<ArticlePageViewCreateInput>
}

/** An edge in a connection. */
export type ArticlePageViewEdge = {
  __typename?: 'ArticlePageViewEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ArticlePageView
}

/** Identifies documents */
export type ArticlePageViewManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticlePageViewWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticlePageViewWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticlePageViewWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  article?: InputMaybe<ArticleWhereInput>
  articleSlug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  articleSlug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  articleSlug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  articleSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  articleSlug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  articleSlug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  articleSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  articleSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  articleSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  articleSlug_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ArticlePageViewWhereStageInput>
  documentInStages_none?: InputMaybe<ArticlePageViewWhereStageInput>
  documentInStages_some?: InputMaybe<ArticlePageViewWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  pageViewLocale?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pageViewLocale_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pageViewLocale_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pageViewLocale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pageViewLocale_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pageViewLocale_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pageViewLocale_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pageViewLocale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pageViewLocale_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pageViewLocale_starts_with?: InputMaybe<Scalars['String']['input']>
  pageViews?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageViews_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageViews_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageViews_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageViews_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageViews_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageViews_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageViews_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ArticlePageViewOrderByInput {
  ArticleSlugAsc = 'articleSlug_ASC',
  ArticleSlugDesc = 'articleSlug_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PageViewLocaleAsc = 'pageViewLocale_ASC',
  PageViewLocaleDesc = 'pageViewLocale_DESC',
  PageViewsAsc = 'pageViews_ASC',
  PageViewsDesc = 'pageViews_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ArticlePageViewUpdateInput = {
  article?: InputMaybe<ArticleUpdateOneInlineInput>
  articleSlug?: InputMaybe<Scalars['String']['input']>
  pageViewLocale?: InputMaybe<Scalars['String']['input']>
  pageViews?: InputMaybe<Scalars['Int']['input']>
}

export type ArticlePageViewUpdateManyInlineInput = {
  /** Connect multiple existing ArticlePageView documents */
  connect?: InputMaybe<Array<ArticlePageViewConnectInput>>
  /** Create and connect multiple ArticlePageView documents */
  create?: InputMaybe<Array<ArticlePageViewCreateInput>>
  /** Delete multiple ArticlePageView documents */
  delete?: InputMaybe<Array<ArticlePageViewWhereUniqueInput>>
  /** Disconnect multiple ArticlePageView documents */
  disconnect?: InputMaybe<Array<ArticlePageViewWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ArticlePageView documents */
  set?: InputMaybe<Array<ArticlePageViewWhereUniqueInput>>
  /** Update multiple ArticlePageView documents */
  update?: InputMaybe<Array<ArticlePageViewUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ArticlePageView documents */
  upsert?: InputMaybe<Array<ArticlePageViewUpsertWithNestedWhereUniqueInput>>
}

export type ArticlePageViewUpdateManyInput = {
  pageViewLocale?: InputMaybe<Scalars['String']['input']>
  pageViews?: InputMaybe<Scalars['Int']['input']>
}

export type ArticlePageViewUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticlePageViewUpdateManyInput
  /** Document search */
  where: ArticlePageViewWhereInput
}

export type ArticlePageViewUpdateOneInlineInput = {
  /** Connect existing ArticlePageView document */
  connect?: InputMaybe<ArticlePageViewWhereUniqueInput>
  /** Create and connect one ArticlePageView document */
  create?: InputMaybe<ArticlePageViewCreateInput>
  /** Delete currently connected ArticlePageView document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ArticlePageView document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ArticlePageView document */
  update?: InputMaybe<ArticlePageViewUpdateWithNestedWhereUniqueInput>
  /** Upsert single ArticlePageView document */
  upsert?: InputMaybe<ArticlePageViewUpsertWithNestedWhereUniqueInput>
}

export type ArticlePageViewUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticlePageViewUpdateInput
  /** Unique document search */
  where: ArticlePageViewWhereUniqueInput
}

export type ArticlePageViewUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticlePageViewCreateInput
  /** Update document if it exists */
  update: ArticlePageViewUpdateInput
}

export type ArticlePageViewUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticlePageViewUpsertInput
  /** Unique document search */
  where: ArticlePageViewWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ArticlePageViewWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ArticlePageViewWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticlePageViewWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticlePageViewWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticlePageViewWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  article?: InputMaybe<ArticleWhereInput>
  articleSlug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  articleSlug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  articleSlug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  articleSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  articleSlug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  articleSlug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  articleSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  articleSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  articleSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  articleSlug_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ArticlePageViewWhereStageInput>
  documentInStages_none?: InputMaybe<ArticlePageViewWhereStageInput>
  documentInStages_some?: InputMaybe<ArticlePageViewWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  pageViewLocale?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pageViewLocale_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pageViewLocale_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pageViewLocale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pageViewLocale_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pageViewLocale_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pageViewLocale_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pageViewLocale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pageViewLocale_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pageViewLocale_starts_with?: InputMaybe<Scalars['String']['input']>
  pageViews?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageViews_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageViews_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageViews_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageViews_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageViews_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageViews_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageViews_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticlePageViewWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticlePageViewWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticlePageViewWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticlePageViewWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticlePageViewWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ArticlePageView record uniquely */
export type ArticlePageViewWhereUniqueInput = {
  articleSlug?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum ArticleType {
  ContentHubArticle = 'ContentHubArticle',
  DailyArticle = 'DailyArticle',
  EducationArticle = 'EducationArticle',
  GrowthHubArticle = 'GrowthHubArticle',
  JobsHrArticle = 'JobsHrArticle',
  OmrxArticle = 'OmrxArticle',
}

export type ArticleUpdateInput = {
  articleCategories?: InputMaybe<ArticleCategoryUpdateManyInlineInput>
  articlePageViewCount?: InputMaybe<ArticlePageViewUpdateOneInlineInput>
  articleType?: InputMaybe<ArticleType>
  authors?: InputMaybe<AuthorUpdateManyInlineInput>
  authorsEn?: InputMaybe<AuthorUpdateManyInlineInput>
  /** body input for default locale (de) */
  body?: InputMaybe<Scalars['RichTextAST']['input']>
  callToAction?: InputMaybe<ArticleCtaUpdateManyInlineInput>
  featuredMedia?: InputMaybe<AssetUpdateOneInlineInput>
  featuredMediaPortrait?: InputMaybe<AssetUpdateOneInlineInput>
  hideNewsletterBox?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ArticleUpdateLocalizationsInput>
  onlyEnglish?: InputMaybe<Scalars['Boolean']['input']>
  pageViews?: InputMaybe<Scalars['Int']['input']>
  publishDateTime?: InputMaybe<Scalars['DateTime']['input']>
  reviewsAgencies?: InputMaybe<ReviewsAgencyUpdateManyInlineInput>
  reviewsProductCategories?: InputMaybe<ReviewsProductCategoryUpdateManyInlineInput>
  reviewsProducts?: InputMaybe<ReviewsProductUpdateManyInlineInput>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>
  /** slug input for default locale (de) */
  slug?: InputMaybe<Scalars['String']['input']>
  /** snippet input for default locale (de) */
  snippet?: InputMaybe<Scalars['String']['input']>
  sponsored?: InputMaybe<Scalars['Boolean']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<TagUpdateManyInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  vgWort?: InputMaybe<VgWortUpdateOneInlineInput>
  workflowStep?: InputMaybe<Workflow>
}

export type ArticleUpdateLocalizationDataInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  snippet?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ArticleUpdateLocalizationInput = {
  data: ArticleUpdateLocalizationDataInput
  locale: Locale
}

export type ArticleUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ArticleCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ArticleUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ArticleUpsertLocalizationInput>>
}

export type ArticleUpdateManyInlineInput = {
  /** Connect multiple existing Article documents */
  connect?: InputMaybe<Array<ArticleConnectInput>>
  /** Create and connect multiple Article documents */
  create?: InputMaybe<Array<ArticleCreateInput>>
  /** Delete multiple Article documents */
  delete?: InputMaybe<Array<ArticleWhereUniqueInput>>
  /** Disconnect multiple Article documents */
  disconnect?: InputMaybe<Array<ArticleWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Article documents */
  set?: InputMaybe<Array<ArticleWhereUniqueInput>>
  /** Update multiple Article documents */
  update?: InputMaybe<Array<ArticleUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Article documents */
  upsert?: InputMaybe<Array<ArticleUpsertWithNestedWhereUniqueInput>>
}

export type ArticleUpdateManyInput = {
  articleType?: InputMaybe<ArticleType>
  /** body input for default locale (de) */
  body?: InputMaybe<Scalars['RichTextAST']['input']>
  hideNewsletterBox?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ArticleUpdateManyLocalizationsInput>
  onlyEnglish?: InputMaybe<Scalars['Boolean']['input']>
  pageViews?: InputMaybe<Scalars['Int']['input']>
  publishDateTime?: InputMaybe<Scalars['DateTime']['input']>
  showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>
  /** snippet input for default locale (de) */
  snippet?: InputMaybe<Scalars['String']['input']>
  sponsored?: InputMaybe<Scalars['Boolean']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  workflowStep?: InputMaybe<Workflow>
}

export type ArticleUpdateManyLocalizationDataInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>
  snippet?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ArticleUpdateManyLocalizationInput = {
  data: ArticleUpdateManyLocalizationDataInput
  locale: Locale
}

export type ArticleUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ArticleUpdateManyLocalizationInput>>
}

export type ArticleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticleUpdateManyInput
  /** Document search */
  where: ArticleWhereInput
}

export type ArticleUpdateOneInlineInput = {
  /** Connect existing Article document */
  connect?: InputMaybe<ArticleWhereUniqueInput>
  /** Create and connect one Article document */
  create?: InputMaybe<ArticleCreateInput>
  /** Delete currently connected Article document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Article document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Article document */
  update?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>
  /** Upsert single Article document */
  upsert?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>
}

export type ArticleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticleUpdateInput
  /** Unique document search */
  where: ArticleWhereUniqueInput
}

export type ArticleUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticleCreateInput
  /** Update document if it exists */
  update: ArticleUpdateInput
}

export type ArticleUpsertLocalizationInput = {
  create: ArticleCreateLocalizationDataInput
  locale: Locale
  update: ArticleUpdateLocalizationDataInput
}

export type ArticleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticleUpsertInput
  /** Unique document search */
  where: ArticleWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ArticleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ArticleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articleCategories_every?: InputMaybe<ArticleCategoryWhereInput>
  articleCategories_none?: InputMaybe<ArticleCategoryWhereInput>
  articleCategories_some?: InputMaybe<ArticleCategoryWhereInput>
  articleType?: InputMaybe<ArticleType>
  /** All values that are contained in given list. */
  articleType_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  /** Any other value that exists and is not equal to the given value. */
  articleType_not?: InputMaybe<ArticleType>
  /** All values that are not contained in given list. */
  articleType_not_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  authorsEn_every?: InputMaybe<AuthorWhereInput>
  authorsEn_none?: InputMaybe<AuthorWhereInput>
  authorsEn_some?: InputMaybe<AuthorWhereInput>
  authors_every?: InputMaybe<AuthorWhereInput>
  authors_none?: InputMaybe<AuthorWhereInput>
  authors_some?: InputMaybe<AuthorWhereInput>
  callToAction_every?: InputMaybe<ArticleCtaWhereInput>
  callToAction_none?: InputMaybe<ArticleCtaWhereInput>
  callToAction_some?: InputMaybe<ArticleCtaWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ArticleWhereStageInput>
  documentInStages_none?: InputMaybe<ArticleWhereStageInput>
  documentInStages_some?: InputMaybe<ArticleWhereStageInput>
  featuredMedia?: InputMaybe<AssetWhereInput>
  featuredMediaPortrait?: InputMaybe<AssetWhereInput>
  hideNewsletterBox?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideNewsletterBox_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  onlyEnglish?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  onlyEnglish_not?: InputMaybe<Scalars['Boolean']['input']>
  pageViews?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageViews_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageViews_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageViews_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageViews_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageViews_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageViews_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageViews_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  publishDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reviewsAgencies_every?: InputMaybe<ReviewsAgencyWhereInput>
  reviewsAgencies_none?: InputMaybe<ReviewsAgencyWhereInput>
  reviewsAgencies_some?: InputMaybe<ReviewsAgencyWhereInput>
  reviewsProductCategories_every?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_none?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_some?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProducts_every?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_none?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_some?: InputMaybe<ReviewsProductWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showTableOfContents_not?: InputMaybe<Scalars['Boolean']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  snippet?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  snippet_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  snippet_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  snippet_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  snippet_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  snippet_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  snippet_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  snippet_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  snippet_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  snippet_starts_with?: InputMaybe<Scalars['String']['input']>
  sponsored?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  sponsored_not?: InputMaybe<Scalars['Boolean']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  tags_every?: InputMaybe<TagWhereInput>
  tags_none?: InputMaybe<TagWhereInput>
  tags_some?: InputMaybe<TagWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  vgWort?: InputMaybe<VgWortWhereInput>
  workflowStep?: InputMaybe<Workflow>
  /** All values that are contained in given list. */
  workflowStep_in?: InputMaybe<Array<InputMaybe<Workflow>>>
  /** Any other value that exists and is not equal to the given value. */
  workflowStep_not?: InputMaybe<Workflow>
  /** All values that are not contained in given list. */
  workflowStep_not_in?: InputMaybe<Array<InputMaybe<Workflow>>>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Article record uniquely */
export type ArticleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type ArticlesByTag = Entity & {
  __typename?: 'ArticlesByTag'
  category?: Maybe<ArticleCategory>
  ctaText?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Leave empty for unlimited */
  limit?: Maybe<Scalars['Int']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<ArticlesByTag>
  /** System stage field */
  stage: Stage
  tag?: Maybe<Tag>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ArticlesByTagCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticlesByTagLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type ArticlesByTagTagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ArticlesByTagUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ArticlesByTagConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ArticlesByTagWhereUniqueInput
}

/** A connection to a list of items. */
export type ArticlesByTagConnection = {
  __typename?: 'ArticlesByTagConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ArticlesByTagEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ArticlesByTagCreateInput = {
  category?: InputMaybe<ArticleCategoryCreateOneInlineInput>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ArticlesByTagCreateLocalizationsInput>
  tag?: InputMaybe<TagCreateOneInlineInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ArticlesByTagCreateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ArticlesByTagCreateLocalizationInput = {
  /** Localization input */
  data: ArticlesByTagCreateLocalizationDataInput
  locale: Locale
}

export type ArticlesByTagCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ArticlesByTagCreateLocalizationInput>>
}

export type ArticlesByTagCreateManyInlineInput = {
  /** Create and connect multiple existing ArticlesByTag documents */
  create?: InputMaybe<Array<ArticlesByTagCreateInput>>
}

export type ArticlesByTagCreateOneInlineInput = {
  /** Create and connect one ArticlesByTag document */
  create?: InputMaybe<ArticlesByTagCreateInput>
}

export type ArticlesByTagCreateWithPositionInput = {
  /** Document to create */
  data: ArticlesByTagCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type ArticlesByTagEdge = {
  __typename?: 'ArticlesByTagEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ArticlesByTag
}

/** Identifies documents */
export type ArticlesByTagManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticlesByTagWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticlesByTagWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticlesByTagWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<ArticleCategoryWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  tag?: InputMaybe<TagWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum ArticlesByTagOrderByInput {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LimitAsc = 'limit_ASC',
  LimitDesc = 'limit_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ArticlesByTagParent = EventPage

export type ArticlesByTagParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type ArticlesByTagParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type ArticlesByTagParentCreateManyInlineInput = {
  /** Connect multiple existing ArticlesByTagParent documents */
  connect?: InputMaybe<Array<ArticlesByTagParentWhereUniqueInput>>
  /** Create and connect multiple existing ArticlesByTagParent documents */
  create?: InputMaybe<Array<ArticlesByTagParentCreateInput>>
}

export type ArticlesByTagParentCreateOneInlineInput = {
  /** Connect one existing ArticlesByTagParent document */
  connect?: InputMaybe<ArticlesByTagParentWhereUniqueInput>
  /** Create and connect one ArticlesByTagParent document */
  create?: InputMaybe<ArticlesByTagParentCreateInput>
}

export type ArticlesByTagParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type ArticlesByTagParentUpdateManyInlineInput = {
  /** Connect multiple existing ArticlesByTagParent documents */
  connect?: InputMaybe<Array<ArticlesByTagParentConnectInput>>
  /** Create and connect multiple ArticlesByTagParent documents */
  create?: InputMaybe<Array<ArticlesByTagParentCreateInput>>
  /** Delete multiple ArticlesByTagParent documents */
  delete?: InputMaybe<Array<ArticlesByTagParentWhereUniqueInput>>
  /** Disconnect multiple ArticlesByTagParent documents */
  disconnect?: InputMaybe<Array<ArticlesByTagParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ArticlesByTagParent documents */
  set?: InputMaybe<Array<ArticlesByTagParentWhereUniqueInput>>
  /** Update multiple ArticlesByTagParent documents */
  update?: InputMaybe<Array<ArticlesByTagParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ArticlesByTagParent documents */
  upsert?: InputMaybe<Array<ArticlesByTagParentUpsertWithNestedWhereUniqueInput>>
}

export type ArticlesByTagParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type ArticlesByTagParentUpdateOneInlineInput = {
  /** Connect existing ArticlesByTagParent document */
  connect?: InputMaybe<ArticlesByTagParentWhereUniqueInput>
  /** Create and connect one ArticlesByTagParent document */
  create?: InputMaybe<ArticlesByTagParentCreateInput>
  /** Delete currently connected ArticlesByTagParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ArticlesByTagParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ArticlesByTagParent document */
  update?: InputMaybe<ArticlesByTagParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single ArticlesByTagParent document */
  upsert?: InputMaybe<ArticlesByTagParentUpsertWithNestedWhereUniqueInput>
}

export type ArticlesByTagParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type ArticlesByTagParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type ArticlesByTagParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type ArticlesByTagParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type ArticlesByTagUpdateInput = {
  category?: InputMaybe<ArticleCategoryUpdateOneInlineInput>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ArticlesByTagUpdateLocalizationsInput>
  tag?: InputMaybe<TagUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ArticlesByTagUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ArticlesByTagUpdateLocalizationInput = {
  data: ArticlesByTagUpdateLocalizationDataInput
  locale: Locale
}

export type ArticlesByTagUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ArticlesByTagCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ArticlesByTagUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ArticlesByTagUpsertLocalizationInput>>
}

export type ArticlesByTagUpdateManyInlineInput = {
  /** Create and connect multiple ArticlesByTag component instances */
  create?: InputMaybe<Array<ArticlesByTagCreateWithPositionInput>>
  /** Delete multiple ArticlesByTag documents */
  delete?: InputMaybe<Array<ArticlesByTagWhereUniqueInput>>
  /** Update multiple ArticlesByTag component instances */
  update?: InputMaybe<Array<ArticlesByTagUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple ArticlesByTag component instances */
  upsert?: InputMaybe<Array<ArticlesByTagUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type ArticlesByTagUpdateManyInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ArticlesByTagUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ArticlesByTagUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ArticlesByTagUpdateManyLocalizationInput = {
  data: ArticlesByTagUpdateManyLocalizationDataInput
  locale: Locale
}

export type ArticlesByTagUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ArticlesByTagUpdateManyLocalizationInput>>
}

export type ArticlesByTagUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticlesByTagUpdateManyInput
  /** Document search */
  where: ArticlesByTagWhereInput
}

export type ArticlesByTagUpdateOneInlineInput = {
  /** Create and connect one ArticlesByTag document */
  create?: InputMaybe<ArticlesByTagCreateInput>
  /** Delete currently connected ArticlesByTag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ArticlesByTag document */
  update?: InputMaybe<ArticlesByTagUpdateWithNestedWhereUniqueInput>
  /** Upsert single ArticlesByTag document */
  upsert?: InputMaybe<ArticlesByTagUpsertWithNestedWhereUniqueInput>
}

export type ArticlesByTagUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ArticlesByTagUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ArticlesByTagWhereUniqueInput
}

export type ArticlesByTagUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticlesByTagUpdateInput
  /** Unique document search */
  where: ArticlesByTagWhereUniqueInput
}

export type ArticlesByTagUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticlesByTagCreateInput
  /** Update document if it exists */
  update: ArticlesByTagUpdateInput
}

export type ArticlesByTagUpsertLocalizationInput = {
  create: ArticlesByTagCreateLocalizationDataInput
  locale: Locale
  update: ArticlesByTagUpdateLocalizationDataInput
}

export type ArticlesByTagUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ArticlesByTagUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ArticlesByTagWhereUniqueInput
}

export type ArticlesByTagUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticlesByTagUpsertInput
  /** Unique document search */
  where: ArticlesByTagWhereUniqueInput
}

/** Identifies documents */
export type ArticlesByTagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticlesByTagWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticlesByTagWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticlesByTagWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<ArticleCategoryWhereInput>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  tag?: InputMaybe<TagWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References ArticlesByTag record uniquely */
export type ArticlesByTagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Asset system model */
export type Asset = Entity &
  Node & {
    __typename?: 'Asset'
    backgroundImagePartnerCompany: Array<PartnerCompany>
    contentReferenceCoverImage: Array<ContentReference>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Asset description for end users */
    description?: Maybe<Scalars['String']['output']>
    /** URL to open on image click */
    destinationUrl?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<Asset>
    eventAppPageAdsLogo: Array<EventAppPage>
    eventFeaturedImage: Array<Event>
    featuredImageArticle: Array<Article>
    /** The file name */
    fileName: Scalars['String']['output']
    /** The file handle */
    handle: Scalars['String']['output']
    headerLogo?: Maybe<Header>
    headerMobileLogo?: Maybe<Header>
    /** The height of the file */
    height?: Maybe<Scalars['Float']['output']>
    heroEventAppPageImage: Array<EventAppPage>
    /** List of Asset versions */
    history: Array<Version>
    hotelLogo?: Maybe<Hotel>
    /** The unique identifier */
    id: Scalars['ID']['output']
    jobImage: Array<JobListing>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Asset>
    logoPartnerCompany: Array<PartnerCompany>
    /** The mime type of the file */
    mimeType?: Maybe<Scalars['String']['output']>
    omrPartnerLogo?: Maybe<OmrPartner>
    podcastGroupBackgroundImage: Array<PodcastGroup>
    podcastGroupKeyVisual: Array<PodcastGroup>
    podcastGroupMobileBackgroundImage: Array<PodcastGroup>
    profilePhotoAuthor: Array<Author>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** The file size */
    size?: Maybe<Scalars['Float']['output']>
    /** System stage field */
    stage: Stage
    tabContentImage?: Maybe<TabContent>
    /** The required title attribute specifies an alternate text for an asset, if the asset cannot be displayed. Usually it describes shortly asset itself. */
    title?: Maybe<Scalars['String']['output']>
    topicPageThumbnailImage: Array<TopicPage>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
    upload?: Maybe<AssetUpload>
    /** Get the url for the asset with provided transformations applied. */
    url: Scalars['String']['output']
    /** The file width */
    width?: Maybe<Scalars['Float']['output']>
    /** wpSourceUrl */
    wpSourceUrl?: Maybe<Scalars['String']['output']>
  }

/** Asset system model */
export type AssetBackgroundImagePartnerCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PartnerCompanyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PartnerCompanyWhereInput>
}

/** Asset system model */
export type AssetContentReferenceCoverImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ContentReferenceOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ContentReferenceWhereInput>
}

/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Asset system model */
export type AssetEventAppPageAdsLogoArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventAppPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventAppPageWhereInput>
}

/** Asset system model */
export type AssetEventFeaturedImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventWhereInput>
}

/** Asset system model */
export type AssetFeaturedImageArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleWhereInput>
}

/** Asset system model */
export type AssetHeaderLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Asset system model */
export type AssetHeaderMobileLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Asset system model */
export type AssetHeroEventAppPageImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventAppPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventAppPageWhereInput>
}

/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Asset system model */
export type AssetHotelLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Asset system model */
export type AssetJobImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<JobListingOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<JobListingWhereInput>
}

/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Asset system model */
export type AssetLogoPartnerCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PartnerCompanyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PartnerCompanyWhereInput>
}

/** Asset system model */
export type AssetOmrPartnerLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Asset system model */
export type AssetPodcastGroupBackgroundImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PodcastGroupOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastGroupWhereInput>
}

/** Asset system model */
export type AssetPodcastGroupKeyVisualArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PodcastGroupOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastGroupWhereInput>
}

/** Asset system model */
export type AssetPodcastGroupMobileBackgroundImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PodcastGroupOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastGroupWhereInput>
}

/** Asset system model */
export type AssetProfilePhotoAuthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<AuthorOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AuthorWhereInput>
}

/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Asset system model */
export type AssetTabContentImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Asset system model */
export type AssetTopicPageThumbnailImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TopicPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageWhereInput>
}

/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>
}

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: AssetWhereUniqueInput
}

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<AssetEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type AssetCreateInput = {
  appStoreButton?: InputMaybe<SectionAppCtaCreateManyInlineInput>
  articleFeaturedMediaPortrait?: InputMaybe<ArticleCreateManyInlineInput>
  background?: InputMaybe<SectionHeroCreateOneInlineInput>
  backgroundImagePartnerCompany?: InputMaybe<PartnerCompanyCreateManyInlineInput>
  banner?: InputMaybe<SectionBannerCreateOneInlineInput>
  bulletPointListImage?: InputMaybe<BulletPointListCreateOneInlineInput>
  careerPageDecorationImage?: InputMaybe<CareerPageSectionHeroCreateManyInlineInput>
  careerPageHeroImage?: InputMaybe<CareerPageSectionHeroCreateManyInlineInput>
  contactPhoto?: InputMaybe<ContactCreateOneInlineInput>
  contentBackgroundLeft?: InputMaybe<SectionFramesHeroCreateManyInlineInput>
  contentBackgroundRight?: InputMaybe<SectionFramesHeroCreateManyInlineInput>
  contentReferenceCoverImage?: InputMaybe<ContentReferenceCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  ctaImageSectionCta?: InputMaybe<SectionCtaCreateManyInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  destinationUrl?: InputMaybe<Scalars['String']['input']>
  downloadDe?: InputMaybe<DownloadCreateOneInlineInput>
  downloadEn?: InputMaybe<DownloadCreateOneInlineInput>
  eventAppAdImage?: InputMaybe<EventAppAdCreateManyInlineInput>
  eventAppCardImage?: InputMaybe<EventAppCardCreateManyInlineInput>
  eventAppPageAdsLogo?: InputMaybe<EventAppPageCreateManyInlineInput>
  eventFeaturedImage?: InputMaybe<EventCreateManyInlineInput>
  explanationStepPicture?: InputMaybe<ExplanationStepCreateOneInlineInput>
  featuredImageArticle?: InputMaybe<ArticleCreateManyInlineInput>
  fileName?: InputMaybe<Scalars['String']['input']>
  genericHeroLogo?: InputMaybe<SectionFramesHeroCreateManyInlineInput>
  headerLogo?: InputMaybe<HeaderCreateOneInlineInput>
  headerMobileLogo?: InputMaybe<HeaderCreateOneInlineInput>
  headerPromoImage?: InputMaybe<HeaderPromoCreateManyInlineInput>
  heroEventAppPageImage?: InputMaybe<EventAppPageCreateManyInlineInput>
  heroImageDesktopImage?: InputMaybe<HeroImageCreateManyInlineInput>
  heroImageLaptopImage?: InputMaybe<HeroImageCreateManyInlineInput>
  heroImageMobileImage?: InputMaybe<HeroImageCreateManyInlineInput>
  heroImageTabletImage?: InputMaybe<HeroImageCreateManyInlineInput>
  heroLogo?: InputMaybe<SectionHeroCreateOneInlineInput>
  heroMobileBackground?: InputMaybe<SectionHeroCreateOneInlineInput>
  heroVideo?: InputMaybe<HeroImageCreateManyInlineInput>
  hotelLogo?: InputMaybe<HotelCreateOneInlineInput>
  hubContentEntryImage?: InputMaybe<HubContentEntryCreateManyInlineInput>
  hubPageContentSliderItemImage?: InputMaybe<HubPageContentSliderItemCreateManyInlineInput>
  hubPageContentTileImage?: InputMaybe<HubPageContentTileCreateManyInlineInput>
  hubPageHeroSliderItemImage?: InputMaybe<HubPageHeroSliderItemCreateManyInlineInput>
  hubPageHeroSliderItemPortraitImage?: InputMaybe<HubPageHeroSliderItemCreateManyInlineInput>
  hubPageImageTileImage?: InputMaybe<HubPageImageTileCreateManyInlineInput>
  hubPageSocialMediaTileImage?: InputMaybe<HubPageSocialMediaTileCreateManyInlineInput>
  image?: InputMaybe<SlideCreateOneInlineInput>
  imageGalleryEmbed?: InputMaybe<ImageGalleryEmbedCreateManyInlineInput>
  jobImage?: InputMaybe<JobListingCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>
  logo?: InputMaybe<SectionBannerCreateOneInlineInput>
  logoPartnerCompany?: InputMaybe<PartnerCompanyCreateManyInlineInput>
  media?: InputMaybe<RichTextMediaCreateManyInlineInput>
  ogImageSseo?: InputMaybe<SeoCreateManyInlineInput>
  omrPartnerLogo?: InputMaybe<OmrPartnerCreateOneInlineInput>
  partnerBadgePartnerLogo?: InputMaybe<PartnerBadgeCreateManyInlineInput>
  partnerLogo?: InputMaybe<SectionCtaCreateManyInlineInput>
  playStoreButton?: InputMaybe<SectionAppCtaCreateManyInlineInput>
  podcastGroupBackgroundImage?: InputMaybe<PodcastGroupCreateManyInlineInput>
  podcastGroupKeyVisual?: InputMaybe<PodcastGroupCreateManyInlineInput>
  podcastGroupMobileBackgroundImage?: InputMaybe<PodcastGroupCreateManyInlineInput>
  previewimage?: InputMaybe<DownloadCreateOneInlineInput>
  profilePhotoAuthor?: InputMaybe<AuthorCreateManyInlineInput>
  sectionImageSlider?: InputMaybe<SectionImageSliderCreateManyInlineInput>
  sectionQuoteSignatureImage?: InputMaybe<SectionQuoteCreateManyInlineInput>
  sectionStyledHeroDesktopImage?: InputMaybe<SectionStyledHeroCreateManyInlineInput>
  sectionStyledHeroLaptopImage?: InputMaybe<SectionStyledHeroCreateManyInlineInput>
  sectionStyledHeroMobileImage?: InputMaybe<SectionStyledHeroCreateManyInlineInput>
  sectionStyledHeroTabletImage?: InputMaybe<SectionStyledHeroCreateManyInlineInput>
  sectionTeaserDesktopImage?: InputMaybe<SectionTeaserCreateManyInlineInput>
  sectionTeaserLaptopImage?: InputMaybe<SectionTeaserCreateManyInlineInput>
  sectionTeaserMobileImage?: InputMaybe<SectionTeaserCreateManyInlineInput>
  sectionTeaserTabletImage?: InputMaybe<SectionTeaserCreateManyInlineInput>
  sectionTestimonialImage?: InputMaybe<SectionTestimonialCreateOneInlineInput>
  sectionTestimonialSignatureImage?: InputMaybe<SectionTestimonialCreateOneInlineInput>
  socialLinkLogo?: InputMaybe<SocialLinkCreateOneInlineInput>
  tabContentImage?: InputMaybe<TabContentCreateOneInlineInput>
  teaserBackground?: InputMaybe<SectionTeaserCreateOneInlineInput>
  textMediaBannerDesktopAsset?: InputMaybe<TextMediaBannerCreateOneInlineInput>
  textMediaBannerMobileAsset?: InputMaybe<TextMediaBannerCreateOneInlineInput>
  textMediaImage?: InputMaybe<TextMediaCreateOneInlineInput>
  textMediaTextBanner?: InputMaybe<TextMediaCreateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  titleDecoration?: InputMaybe<SectionHeroCreateOneInlineInput>
  topicPageThumbnailImage?: InputMaybe<TopicPageCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>
  video?: InputMaybe<SectionHeroCreateOneInlineInput>
  wpSourceUrl?: InputMaybe<Scalars['String']['input']>
}

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  fileName?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>
}

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput
  locale: Locale
}

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>
}

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>
}

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>
}

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Asset
}

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  backgroundImagePartnerCompany_every?: InputMaybe<PartnerCompanyWhereInput>
  backgroundImagePartnerCompany_none?: InputMaybe<PartnerCompanyWhereInput>
  backgroundImagePartnerCompany_some?: InputMaybe<PartnerCompanyWhereInput>
  contentReferenceCoverImage_every?: InputMaybe<ContentReferenceWhereInput>
  contentReferenceCoverImage_none?: InputMaybe<ContentReferenceWhereInput>
  contentReferenceCoverImage_some?: InputMaybe<ContentReferenceWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  destinationUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  destinationUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  destinationUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  destinationUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  destinationUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  destinationUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  destinationUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  destinationUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  destinationUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  destinationUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<AssetWhereStageInput>
  documentInStages_none?: InputMaybe<AssetWhereStageInput>
  documentInStages_some?: InputMaybe<AssetWhereStageInput>
  eventAppPageAdsLogo_every?: InputMaybe<EventAppPageWhereInput>
  eventAppPageAdsLogo_none?: InputMaybe<EventAppPageWhereInput>
  eventAppPageAdsLogo_some?: InputMaybe<EventAppPageWhereInput>
  eventFeaturedImage_every?: InputMaybe<EventWhereInput>
  eventFeaturedImage_none?: InputMaybe<EventWhereInput>
  eventFeaturedImage_some?: InputMaybe<EventWhereInput>
  featuredImageArticle_every?: InputMaybe<ArticleWhereInput>
  featuredImageArticle_none?: InputMaybe<ArticleWhereInput>
  featuredImageArticle_some?: InputMaybe<ArticleWhereInput>
  headerLogo?: InputMaybe<HeaderWhereInput>
  headerMobileLogo?: InputMaybe<HeaderWhereInput>
  heroEventAppPageImage_every?: InputMaybe<EventAppPageWhereInput>
  heroEventAppPageImage_none?: InputMaybe<EventAppPageWhereInput>
  heroEventAppPageImage_some?: InputMaybe<EventAppPageWhereInput>
  hotelLogo?: InputMaybe<HotelWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  jobImage_every?: InputMaybe<JobListingWhereInput>
  jobImage_none?: InputMaybe<JobListingWhereInput>
  jobImage_some?: InputMaybe<JobListingWhereInput>
  logoPartnerCompany_every?: InputMaybe<PartnerCompanyWhereInput>
  logoPartnerCompany_none?: InputMaybe<PartnerCompanyWhereInput>
  logoPartnerCompany_some?: InputMaybe<PartnerCompanyWhereInput>
  omrPartnerLogo?: InputMaybe<OmrPartnerWhereInput>
  podcastGroupBackgroundImage_every?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupBackgroundImage_none?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupBackgroundImage_some?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupKeyVisual_every?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupKeyVisual_none?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupKeyVisual_some?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupMobileBackgroundImage_every?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupMobileBackgroundImage_none?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupMobileBackgroundImage_some?: InputMaybe<PodcastGroupWhereInput>
  profilePhotoAuthor_every?: InputMaybe<AuthorWhereInput>
  profilePhotoAuthor_none?: InputMaybe<AuthorWhereInput>
  profilePhotoAuthor_some?: InputMaybe<AuthorWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  tabContentImage?: InputMaybe<TabContentWhereInput>
  topicPageThumbnailImage_every?: InputMaybe<TopicPageWhereInput>
  topicPageThumbnailImage_none?: InputMaybe<TopicPageWhereInput>
  topicPageThumbnailImage_some?: InputMaybe<TopicPageWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  upload?: InputMaybe<AssetUploadWhereInput>
  wpSourceUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpSourceUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpSourceUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpSourceUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpSourceUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpSourceUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpSourceUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpSourceUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpSourceUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpSourceUrl_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum AssetOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DestinationUrlAsc = 'destinationUrl_ASC',
  DestinationUrlDesc = 'destinationUrl_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC',
  WpSourceUrlAsc = 'wpSourceUrl_ASC',
  WpSourceUrlDesc = 'wpSourceUrl_DESC',
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>
  upload?: InputMaybe<AssetUploadWhereInput>
}

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>
  image?: InputMaybe<ImageTransformationInput>
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>
}

export type AssetUpdateInput = {
  appStoreButton?: InputMaybe<SectionAppCtaUpdateManyInlineInput>
  articleFeaturedMediaPortrait?: InputMaybe<ArticleUpdateManyInlineInput>
  background?: InputMaybe<SectionHeroUpdateOneInlineInput>
  backgroundImagePartnerCompany?: InputMaybe<PartnerCompanyUpdateManyInlineInput>
  banner?: InputMaybe<SectionBannerUpdateOneInlineInput>
  bulletPointListImage?: InputMaybe<BulletPointListUpdateOneInlineInput>
  careerPageDecorationImage?: InputMaybe<CareerPageSectionHeroUpdateManyInlineInput>
  careerPageHeroImage?: InputMaybe<CareerPageSectionHeroUpdateManyInlineInput>
  contactPhoto?: InputMaybe<ContactUpdateOneInlineInput>
  contentBackgroundLeft?: InputMaybe<SectionFramesHeroUpdateManyInlineInput>
  contentBackgroundRight?: InputMaybe<SectionFramesHeroUpdateManyInlineInput>
  contentReferenceCoverImage?: InputMaybe<ContentReferenceUpdateManyInlineInput>
  ctaImageSectionCta?: InputMaybe<SectionCtaUpdateManyInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  destinationUrl?: InputMaybe<Scalars['String']['input']>
  downloadDe?: InputMaybe<DownloadUpdateOneInlineInput>
  downloadEn?: InputMaybe<DownloadUpdateOneInlineInput>
  eventAppAdImage?: InputMaybe<EventAppAdUpdateManyInlineInput>
  eventAppCardImage?: InputMaybe<EventAppCardUpdateManyInlineInput>
  eventAppPageAdsLogo?: InputMaybe<EventAppPageUpdateManyInlineInput>
  eventFeaturedImage?: InputMaybe<EventUpdateManyInlineInput>
  explanationStepPicture?: InputMaybe<ExplanationStepUpdateOneInlineInput>
  featuredImageArticle?: InputMaybe<ArticleUpdateManyInlineInput>
  fileName?: InputMaybe<Scalars['String']['input']>
  genericHeroLogo?: InputMaybe<SectionFramesHeroUpdateManyInlineInput>
  headerLogo?: InputMaybe<HeaderUpdateOneInlineInput>
  headerMobileLogo?: InputMaybe<HeaderUpdateOneInlineInput>
  headerPromoImage?: InputMaybe<HeaderPromoUpdateManyInlineInput>
  heroEventAppPageImage?: InputMaybe<EventAppPageUpdateManyInlineInput>
  heroImageDesktopImage?: InputMaybe<HeroImageUpdateManyInlineInput>
  heroImageLaptopImage?: InputMaybe<HeroImageUpdateManyInlineInput>
  heroImageMobileImage?: InputMaybe<HeroImageUpdateManyInlineInput>
  heroImageTabletImage?: InputMaybe<HeroImageUpdateManyInlineInput>
  heroLogo?: InputMaybe<SectionHeroUpdateOneInlineInput>
  heroMobileBackground?: InputMaybe<SectionHeroUpdateOneInlineInput>
  heroVideo?: InputMaybe<HeroImageUpdateManyInlineInput>
  hotelLogo?: InputMaybe<HotelUpdateOneInlineInput>
  hubContentEntryImage?: InputMaybe<HubContentEntryUpdateManyInlineInput>
  hubPageContentSliderItemImage?: InputMaybe<HubPageContentSliderItemUpdateManyInlineInput>
  hubPageContentTileImage?: InputMaybe<HubPageContentTileUpdateManyInlineInput>
  hubPageHeroSliderItemImage?: InputMaybe<HubPageHeroSliderItemUpdateManyInlineInput>
  hubPageHeroSliderItemPortraitImage?: InputMaybe<HubPageHeroSliderItemUpdateManyInlineInput>
  hubPageImageTileImage?: InputMaybe<HubPageImageTileUpdateManyInlineInput>
  hubPageSocialMediaTileImage?: InputMaybe<HubPageSocialMediaTileUpdateManyInlineInput>
  image?: InputMaybe<SlideUpdateOneInlineInput>
  imageGalleryEmbed?: InputMaybe<ImageGalleryEmbedUpdateManyInlineInput>
  jobImage?: InputMaybe<JobListingUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>
  logo?: InputMaybe<SectionBannerUpdateOneInlineInput>
  logoPartnerCompany?: InputMaybe<PartnerCompanyUpdateManyInlineInput>
  media?: InputMaybe<RichTextMediaUpdateManyInlineInput>
  ogImageSseo?: InputMaybe<SeoUpdateManyInlineInput>
  omrPartnerLogo?: InputMaybe<OmrPartnerUpdateOneInlineInput>
  partnerBadgePartnerLogo?: InputMaybe<PartnerBadgeUpdateManyInlineInput>
  partnerLogo?: InputMaybe<SectionCtaUpdateManyInlineInput>
  playStoreButton?: InputMaybe<SectionAppCtaUpdateManyInlineInput>
  podcastGroupBackgroundImage?: InputMaybe<PodcastGroupUpdateManyInlineInput>
  podcastGroupKeyVisual?: InputMaybe<PodcastGroupUpdateManyInlineInput>
  podcastGroupMobileBackgroundImage?: InputMaybe<PodcastGroupUpdateManyInlineInput>
  previewimage?: InputMaybe<DownloadUpdateOneInlineInput>
  profilePhotoAuthor?: InputMaybe<AuthorUpdateManyInlineInput>
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>
  sectionImageSlider?: InputMaybe<SectionImageSliderUpdateManyInlineInput>
  sectionQuoteSignatureImage?: InputMaybe<SectionQuoteUpdateManyInlineInput>
  sectionStyledHeroDesktopImage?: InputMaybe<SectionStyledHeroUpdateManyInlineInput>
  sectionStyledHeroLaptopImage?: InputMaybe<SectionStyledHeroUpdateManyInlineInput>
  sectionStyledHeroMobileImage?: InputMaybe<SectionStyledHeroUpdateManyInlineInput>
  sectionStyledHeroTabletImage?: InputMaybe<SectionStyledHeroUpdateManyInlineInput>
  sectionTeaserDesktopImage?: InputMaybe<SectionTeaserUpdateManyInlineInput>
  sectionTeaserLaptopImage?: InputMaybe<SectionTeaserUpdateManyInlineInput>
  sectionTeaserMobileImage?: InputMaybe<SectionTeaserUpdateManyInlineInput>
  sectionTeaserTabletImage?: InputMaybe<SectionTeaserUpdateManyInlineInput>
  sectionTestimonialImage?: InputMaybe<SectionTestimonialUpdateOneInlineInput>
  sectionTestimonialSignatureImage?: InputMaybe<SectionTestimonialUpdateOneInlineInput>
  socialLinkLogo?: InputMaybe<SocialLinkUpdateOneInlineInput>
  tabContentImage?: InputMaybe<TabContentUpdateOneInlineInput>
  teaserBackground?: InputMaybe<SectionTeaserUpdateOneInlineInput>
  textMediaBannerDesktopAsset?: InputMaybe<TextMediaBannerUpdateOneInlineInput>
  textMediaBannerMobileAsset?: InputMaybe<TextMediaBannerUpdateOneInlineInput>
  textMediaImage?: InputMaybe<TextMediaUpdateOneInlineInput>
  textMediaTextBanner?: InputMaybe<TextMediaUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  titleDecoration?: InputMaybe<SectionHeroUpdateOneInlineInput>
  topicPageThumbnailImage?: InputMaybe<TopicPageUpdateManyInlineInput>
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>
  video?: InputMaybe<SectionHeroUpdateOneInlineInput>
  wpSourceUrl?: InputMaybe<Scalars['String']['input']>
}

export type AssetUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  fileName?: InputMaybe<Scalars['String']['input']>
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>
}

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput
  locale: Locale
}

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>
}

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>
}

export type AssetUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  destinationUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<AssetUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type AssetUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type AssetUpdateManyLocalizationInput = {
  data: AssetUpdateManyLocalizationDataInput
  locale: Locale
}

export type AssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateManyLocalizationInput>>
}

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput
  /** Document search */
  where: AssetWhereInput
}

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>
}

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput
  /** Unique document search */
  where: AssetWhereUniqueInput
}

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload'
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>
}

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError'
  code: Scalars['String']['output']
  message: Scalars['String']['output']
}

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData'
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output']
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output']
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output']
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output']
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output']
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output']
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output']
}

/** System Asset Upload Status */
export enum AssetUploadStatus {
  AssetCreatePending = 'ASSET_CREATE_PENDING',
  AssetErrorUpload = 'ASSET_ERROR_UPLOAD',
  AssetUpdatePending = 'ASSET_UPDATE_PENDING',
  AssetUploadComplete = 'ASSET_UPLOAD_COMPLETE',
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  status?: InputMaybe<AssetUploadStatus>
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>
}

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  status?: InputMaybe<AssetUploadStatus>
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>
}

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput
  /** Update document if it exists */
  update: AssetUpdateInput
}

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput
  locale: Locale
  update: AssetUpdateLocalizationDataInput
}

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput
  /** Unique document search */
  where: AssetWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  backgroundImagePartnerCompany_every?: InputMaybe<PartnerCompanyWhereInput>
  backgroundImagePartnerCompany_none?: InputMaybe<PartnerCompanyWhereInput>
  backgroundImagePartnerCompany_some?: InputMaybe<PartnerCompanyWhereInput>
  contentReferenceCoverImage_every?: InputMaybe<ContentReferenceWhereInput>
  contentReferenceCoverImage_none?: InputMaybe<ContentReferenceWhereInput>
  contentReferenceCoverImage_some?: InputMaybe<ContentReferenceWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  destinationUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  destinationUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  destinationUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  destinationUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  destinationUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  destinationUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  destinationUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  destinationUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  destinationUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  destinationUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<AssetWhereStageInput>
  documentInStages_none?: InputMaybe<AssetWhereStageInput>
  documentInStages_some?: InputMaybe<AssetWhereStageInput>
  eventAppPageAdsLogo_every?: InputMaybe<EventAppPageWhereInput>
  eventAppPageAdsLogo_none?: InputMaybe<EventAppPageWhereInput>
  eventAppPageAdsLogo_some?: InputMaybe<EventAppPageWhereInput>
  eventFeaturedImage_every?: InputMaybe<EventWhereInput>
  eventFeaturedImage_none?: InputMaybe<EventWhereInput>
  eventFeaturedImage_some?: InputMaybe<EventWhereInput>
  featuredImageArticle_every?: InputMaybe<ArticleWhereInput>
  featuredImageArticle_none?: InputMaybe<ArticleWhereInput>
  featuredImageArticle_some?: InputMaybe<ArticleWhereInput>
  fileName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>
  headerLogo?: InputMaybe<HeaderWhereInput>
  headerMobileLogo?: InputMaybe<HeaderWhereInput>
  height?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  heroEventAppPageImage_every?: InputMaybe<EventAppPageWhereInput>
  heroEventAppPageImage_none?: InputMaybe<EventAppPageWhereInput>
  heroEventAppPageImage_some?: InputMaybe<EventAppPageWhereInput>
  hotelLogo?: InputMaybe<HotelWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  jobImage_every?: InputMaybe<JobListingWhereInput>
  jobImage_none?: InputMaybe<JobListingWhereInput>
  jobImage_some?: InputMaybe<JobListingWhereInput>
  logoPartnerCompany_every?: InputMaybe<PartnerCompanyWhereInput>
  logoPartnerCompany_none?: InputMaybe<PartnerCompanyWhereInput>
  logoPartnerCompany_some?: InputMaybe<PartnerCompanyWhereInput>
  mimeType?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>
  omrPartnerLogo?: InputMaybe<OmrPartnerWhereInput>
  podcastGroupBackgroundImage_every?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupBackgroundImage_none?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupBackgroundImage_some?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupKeyVisual_every?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupKeyVisual_none?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupKeyVisual_some?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupMobileBackgroundImage_every?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupMobileBackgroundImage_none?: InputMaybe<PodcastGroupWhereInput>
  podcastGroupMobileBackgroundImage_some?: InputMaybe<PodcastGroupWhereInput>
  profilePhotoAuthor_every?: InputMaybe<AuthorWhereInput>
  profilePhotoAuthor_none?: InputMaybe<AuthorWhereInput>
  profilePhotoAuthor_some?: InputMaybe<AuthorWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  size?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  tabContentImage?: InputMaybe<TabContentWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  topicPageThumbnailImage_every?: InputMaybe<TopicPageWhereInput>
  topicPageThumbnailImage_none?: InputMaybe<TopicPageWhereInput>
  topicPageThumbnailImage_some?: InputMaybe<TopicPageWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  upload?: InputMaybe<AssetUploadWhereInput>
  width?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  wpSourceUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpSourceUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpSourceUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpSourceUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpSourceUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpSourceUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpSourceUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpSourceUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpSourceUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpSourceUrl_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  wpSourceUrl?: InputMaybe<Scalars['String']['input']>
}

/** Content author */
export type Author = Entity &
  Node & {
    __typename?: 'Author'
    articles: Array<Article>
    /** Authors of English article content */
    articlesEn: Array<Article>
    authorType?: Maybe<AuthorType>
    avatar?: Maybe<Asset>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<Author>
    email?: Maybe<Scalars['String']['output']>
    externalLink?: Maybe<Scalars['String']['output']>
    facebookProfile?: Maybe<Scalars['String']['output']>
    /** List of Author versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    instagramProfile?: Maybe<Scalars['String']['output']>
    landingPages: Array<LandingPage>
    linkedInProfile?: Maybe<Scalars['String']['output']>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Author>
    name: Scalars['String']['output']
    occupation?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    seoAttributes?: Maybe<Seo>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    topicPages: Array<TopicPage>
    twitterProfile?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    /** Optional wordpress reference used by importer */
    wpId?: Maybe<Scalars['String']['output']>
  }

/** Content author */
export type AuthorArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleWhereInput>
}

/** Content author */
export type AuthorArticlesEnArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleWhereInput>
}

/** Content author */
export type AuthorAvatarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Content author */
export type AuthorCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Content author */
export type AuthorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content author */
export type AuthorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Content author */
export type AuthorHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Content author */
export type AuthorLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<LandingPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LandingPageWhereInput>
}

/** Content author */
export type AuthorLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Content author */
export type AuthorPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Content author */
export type AuthorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content author */
export type AuthorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Content author */
export type AuthorSeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content author */
export type AuthorTopicPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TopicPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageWhereInput>
}

/** Content author */
export type AuthorUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Content author */
export type AuthorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type AuthorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: AuthorWhereUniqueInput
}

/** A connection to a list of items. */
export type AuthorConnection = {
  __typename?: 'AuthorConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<AuthorEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type AuthorCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>
  articlesEn?: InputMaybe<ArticleCreateManyInlineInput>
  authorType?: InputMaybe<AuthorType>
  avatar?: InputMaybe<AssetCreateOneInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  externalLink?: InputMaybe<Scalars['String']['input']>
  facebookProfile?: InputMaybe<Scalars['String']['input']>
  instagramProfile?: InputMaybe<Scalars['String']['input']>
  landingPages?: InputMaybe<LandingPageCreateManyInlineInput>
  linkedInProfile?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AuthorCreateLocalizationsInput>
  name: Scalars['String']['input']
  occupation?: InputMaybe<Scalars['String']['input']>
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  slug: Scalars['String']['input']
  topicPages?: InputMaybe<TopicPageCreateManyInlineInput>
  twitterProfile?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type AuthorCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type AuthorCreateLocalizationInput = {
  /** Localization input */
  data: AuthorCreateLocalizationDataInput
  locale: Locale
}

export type AuthorCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AuthorCreateLocalizationInput>>
}

export type AuthorCreateManyInlineInput = {
  /** Connect multiple existing Author documents */
  connect?: InputMaybe<Array<AuthorWhereUniqueInput>>
  /** Create and connect multiple existing Author documents */
  create?: InputMaybe<Array<AuthorCreateInput>>
}

export type AuthorCreateOneInlineInput = {
  /** Connect one existing Author document */
  connect?: InputMaybe<AuthorWhereUniqueInput>
  /** Create and connect one Author document */
  create?: InputMaybe<AuthorCreateInput>
}

/** An edge in a connection. */
export type AuthorEdge = {
  __typename?: 'AuthorEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Author
}

/** Identifies documents */
export type AuthorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articlesEn_every?: InputMaybe<ArticleWhereInput>
  articlesEn_none?: InputMaybe<ArticleWhereInput>
  articlesEn_some?: InputMaybe<ArticleWhereInput>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  authorType?: InputMaybe<AuthorType>
  /** All values that are contained in given list. */
  authorType_in?: InputMaybe<Array<InputMaybe<AuthorType>>>
  /** Any other value that exists and is not equal to the given value. */
  authorType_not?: InputMaybe<AuthorType>
  /** All values that are not contained in given list. */
  authorType_not_in?: InputMaybe<Array<InputMaybe<AuthorType>>>
  avatar?: InputMaybe<AssetWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<AuthorWhereStageInput>
  documentInStages_none?: InputMaybe<AuthorWhereStageInput>
  documentInStages_some?: InputMaybe<AuthorWhereStageInput>
  email?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>
  externalLink?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  externalLink_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  externalLink_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  externalLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  externalLink_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  externalLink_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  externalLink_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  externalLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  externalLink_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  externalLink_starts_with?: InputMaybe<Scalars['String']['input']>
  facebookProfile?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  facebookProfile_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  facebookProfile_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  facebookProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  facebookProfile_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  facebookProfile_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  facebookProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  facebookProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  facebookProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  facebookProfile_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  instagramProfile?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  instagramProfile_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  instagramProfile_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  instagramProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  instagramProfile_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  instagramProfile_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  instagramProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  instagramProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  instagramProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  instagramProfile_starts_with?: InputMaybe<Scalars['String']['input']>
  landingPages_every?: InputMaybe<LandingPageWhereInput>
  landingPages_none?: InputMaybe<LandingPageWhereInput>
  landingPages_some?: InputMaybe<LandingPageWhereInput>
  linkedInProfile?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedInProfile_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedInProfile_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedInProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedInProfile_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedInProfile_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedInProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedInProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedInProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedInProfile_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  occupation?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  occupation_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  occupation_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  occupation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  occupation_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  occupation_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  occupation_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  occupation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  occupation_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  occupation_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  topicPages_every?: InputMaybe<TopicPageWhereInput>
  topicPages_none?: InputMaybe<TopicPageWhereInput>
  topicPages_some?: InputMaybe<TopicPageWhereInput>
  twitterProfile?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  twitterProfile_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  twitterProfile_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  twitterProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  twitterProfile_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  twitterProfile_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  twitterProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  twitterProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  twitterProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  twitterProfile_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum AuthorOrderByInput {
  AuthorTypeAsc = 'authorType_ASC',
  AuthorTypeDesc = 'authorType_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  FacebookProfileAsc = 'facebookProfile_ASC',
  FacebookProfileDesc = 'facebookProfile_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InstagramProfileAsc = 'instagramProfile_ASC',
  InstagramProfileDesc = 'instagramProfile_DESC',
  LinkedInProfileAsc = 'linkedInProfile_ASC',
  LinkedInProfileDesc = 'linkedInProfile_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OccupationAsc = 'occupation_ASC',
  OccupationDesc = 'occupation_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TwitterProfileAsc = 'twitterProfile_ASC',
  TwitterProfileDesc = 'twitterProfile_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WpIdAsc = 'wpId_ASC',
  WpIdDesc = 'wpId_DESC',
}

export enum AuthorType {
  ContentTeam = 'ContentTeam',
  DailyTeam = 'DailyTeam',
  Freelancer = 'Freelancer',
  Guest = 'Guest',
  JobsTeam = 'JobsTeam',
  OmrTeam = 'OMRTeam',
}

export type AuthorUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>
  articlesEn?: InputMaybe<ArticleUpdateManyInlineInput>
  authorType?: InputMaybe<AuthorType>
  avatar?: InputMaybe<AssetUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  externalLink?: InputMaybe<Scalars['String']['input']>
  facebookProfile?: InputMaybe<Scalars['String']['input']>
  instagramProfile?: InputMaybe<Scalars['String']['input']>
  landingPages?: InputMaybe<LandingPageUpdateManyInlineInput>
  linkedInProfile?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<AuthorUpdateLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  occupation?: InputMaybe<Scalars['String']['input']>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  topicPages?: InputMaybe<TopicPageUpdateManyInlineInput>
  twitterProfile?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type AuthorUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type AuthorUpdateLocalizationInput = {
  data: AuthorUpdateLocalizationDataInput
  locale: Locale
}

export type AuthorUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AuthorCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<AuthorUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<AuthorUpsertLocalizationInput>>
}

export type AuthorUpdateManyInlineInput = {
  /** Connect multiple existing Author documents */
  connect?: InputMaybe<Array<AuthorConnectInput>>
  /** Create and connect multiple Author documents */
  create?: InputMaybe<Array<AuthorCreateInput>>
  /** Delete multiple Author documents */
  delete?: InputMaybe<Array<AuthorWhereUniqueInput>>
  /** Disconnect multiple Author documents */
  disconnect?: InputMaybe<Array<AuthorWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Author documents */
  set?: InputMaybe<Array<AuthorWhereUniqueInput>>
  /** Update multiple Author documents */
  update?: InputMaybe<Array<AuthorUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Author documents */
  upsert?: InputMaybe<Array<AuthorUpsertWithNestedWhereUniqueInput>>
}

export type AuthorUpdateManyInput = {
  authorType?: InputMaybe<AuthorType>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  externalLink?: InputMaybe<Scalars['String']['input']>
  facebookProfile?: InputMaybe<Scalars['String']['input']>
  instagramProfile?: InputMaybe<Scalars['String']['input']>
  linkedInProfile?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<AuthorUpdateManyLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  occupation?: InputMaybe<Scalars['String']['input']>
  twitterProfile?: InputMaybe<Scalars['String']['input']>
}

export type AuthorUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type AuthorUpdateManyLocalizationInput = {
  data: AuthorUpdateManyLocalizationDataInput
  locale: Locale
}

export type AuthorUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AuthorUpdateManyLocalizationInput>>
}

export type AuthorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AuthorUpdateManyInput
  /** Document search */
  where: AuthorWhereInput
}

export type AuthorUpdateOneInlineInput = {
  /** Connect existing Author document */
  connect?: InputMaybe<AuthorWhereUniqueInput>
  /** Create and connect one Author document */
  create?: InputMaybe<AuthorCreateInput>
  /** Delete currently connected Author document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Author document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Author document */
  update?: InputMaybe<AuthorUpdateWithNestedWhereUniqueInput>
  /** Upsert single Author document */
  upsert?: InputMaybe<AuthorUpsertWithNestedWhereUniqueInput>
}

export type AuthorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AuthorUpdateInput
  /** Unique document search */
  where: AuthorWhereUniqueInput
}

export type AuthorUpsertInput = {
  /** Create document if it didn't exist */
  create: AuthorCreateInput
  /** Update document if it exists */
  update: AuthorUpdateInput
}

export type AuthorUpsertLocalizationInput = {
  create: AuthorCreateLocalizationDataInput
  locale: Locale
  update: AuthorUpdateLocalizationDataInput
}

export type AuthorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AuthorUpsertInput
  /** Unique document search */
  where: AuthorWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type AuthorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type AuthorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articlesEn_every?: InputMaybe<ArticleWhereInput>
  articlesEn_none?: InputMaybe<ArticleWhereInput>
  articlesEn_some?: InputMaybe<ArticleWhereInput>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  authorType?: InputMaybe<AuthorType>
  /** All values that are contained in given list. */
  authorType_in?: InputMaybe<Array<InputMaybe<AuthorType>>>
  /** Any other value that exists and is not equal to the given value. */
  authorType_not?: InputMaybe<AuthorType>
  /** All values that are not contained in given list. */
  authorType_not_in?: InputMaybe<Array<InputMaybe<AuthorType>>>
  avatar?: InputMaybe<AssetWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<AuthorWhereStageInput>
  documentInStages_none?: InputMaybe<AuthorWhereStageInput>
  documentInStages_some?: InputMaybe<AuthorWhereStageInput>
  email?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>
  externalLink?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  externalLink_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  externalLink_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  externalLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  externalLink_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  externalLink_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  externalLink_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  externalLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  externalLink_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  externalLink_starts_with?: InputMaybe<Scalars['String']['input']>
  facebookProfile?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  facebookProfile_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  facebookProfile_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  facebookProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  facebookProfile_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  facebookProfile_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  facebookProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  facebookProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  facebookProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  facebookProfile_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  instagramProfile?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  instagramProfile_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  instagramProfile_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  instagramProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  instagramProfile_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  instagramProfile_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  instagramProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  instagramProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  instagramProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  instagramProfile_starts_with?: InputMaybe<Scalars['String']['input']>
  landingPages_every?: InputMaybe<LandingPageWhereInput>
  landingPages_none?: InputMaybe<LandingPageWhereInput>
  landingPages_some?: InputMaybe<LandingPageWhereInput>
  linkedInProfile?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedInProfile_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedInProfile_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedInProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedInProfile_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedInProfile_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedInProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedInProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedInProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedInProfile_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  occupation?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  occupation_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  occupation_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  occupation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  occupation_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  occupation_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  occupation_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  occupation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  occupation_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  occupation_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  topicPages_every?: InputMaybe<TopicPageWhereInput>
  topicPages_none?: InputMaybe<TopicPageWhereInput>
  topicPages_some?: InputMaybe<TopicPageWhereInput>
  twitterProfile?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  twitterProfile_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  twitterProfile_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  twitterProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  twitterProfile_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  twitterProfile_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  twitterProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  twitterProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  twitterProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  twitterProfile_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AuthorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AuthorWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Author record uniquely */
export type AuthorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type BatchPayload = {
  __typename?: 'BatchPayload'
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output']
}

export type Benefit = Entity & {
  __typename?: 'Benefit'
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<Benefit>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type BenefitLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type BenefitUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type BenefitConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: BenefitWhereUniqueInput
}

/** A connection to a list of items. */
export type BenefitConnection = {
  __typename?: 'BenefitConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<BenefitEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type BenefitCreateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<BenefitCreateLocalizationsInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BenefitCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BenefitCreateLocalizationInput = {
  /** Localization input */
  data: BenefitCreateLocalizationDataInput
  locale: Locale
}

export type BenefitCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<BenefitCreateLocalizationInput>>
}

export type BenefitCreateManyInlineInput = {
  /** Create and connect multiple existing Benefit documents */
  create?: InputMaybe<Array<BenefitCreateInput>>
}

export type BenefitCreateOneInlineInput = {
  /** Create and connect one Benefit document */
  create?: InputMaybe<BenefitCreateInput>
}

export type BenefitCreateWithPositionInput = {
  /** Document to create */
  data: BenefitCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type BenefitEdge = {
  __typename?: 'BenefitEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Benefit
}

/** Identifies documents */
export type BenefitManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum BenefitOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type BenefitParent = BenefitsSection

export type BenefitParentConnectInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionConnectInput>
}

export type BenefitParentCreateInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionCreateInput>
}

export type BenefitParentCreateManyInlineInput = {
  /** Create and connect multiple existing BenefitParent documents */
  create?: InputMaybe<Array<BenefitParentCreateInput>>
}

export type BenefitParentCreateOneInlineInput = {
  /** Create and connect one BenefitParent document */
  create?: InputMaybe<BenefitParentCreateInput>
}

export type BenefitParentCreateWithPositionInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionCreateWithPositionInput>
}

export type BenefitParentUpdateInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionUpdateInput>
}

export type BenefitParentUpdateManyInlineInput = {
  /** Create and connect multiple BenefitParent component instances */
  create?: InputMaybe<Array<BenefitParentCreateWithPositionInput>>
  /** Delete multiple BenefitParent documents */
  delete?: InputMaybe<Array<BenefitParentWhereUniqueInput>>
  /** Update multiple BenefitParent component instances */
  update?: InputMaybe<Array<BenefitParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple BenefitParent component instances */
  upsert?: InputMaybe<Array<BenefitParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type BenefitParentUpdateManyWithNestedWhereInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionUpdateManyWithNestedWhereInput>
}

export type BenefitParentUpdateOneInlineInput = {
  /** Create and connect one BenefitParent document */
  create?: InputMaybe<BenefitParentCreateInput>
  /** Delete currently connected BenefitParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single BenefitParent document */
  update?: InputMaybe<BenefitParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single BenefitParent document */
  upsert?: InputMaybe<BenefitParentUpsertWithNestedWhereUniqueInput>
}

export type BenefitParentUpdateWithNestedWhereUniqueAndPositionInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionUpdateWithNestedWhereUniqueAndPositionInput>
}

export type BenefitParentUpdateWithNestedWhereUniqueInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionUpdateWithNestedWhereUniqueInput>
}

export type BenefitParentUpsertWithNestedWhereUniqueAndPositionInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionUpsertWithNestedWhereUniqueAndPositionInput>
}

export type BenefitParentUpsertWithNestedWhereUniqueInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionUpsertWithNestedWhereUniqueInput>
}

export type BenefitParentWhereInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionWhereInput>
}

export type BenefitParentWhereUniqueInput = {
  BenefitsSection?: InputMaybe<BenefitsSectionWhereUniqueInput>
}

export type BenefitUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<BenefitUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitUpdateLocalizationInput = {
  data: BenefitUpdateLocalizationDataInput
  locale: Locale
}

export type BenefitUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<BenefitCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<BenefitUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<BenefitUpsertLocalizationInput>>
}

export type BenefitUpdateManyInlineInput = {
  /** Create and connect multiple Benefit component instances */
  create?: InputMaybe<Array<BenefitCreateWithPositionInput>>
  /** Delete multiple Benefit documents */
  delete?: InputMaybe<Array<BenefitWhereUniqueInput>>
  /** Update multiple Benefit component instances */
  update?: InputMaybe<Array<BenefitUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple Benefit component instances */
  upsert?: InputMaybe<Array<BenefitUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type BenefitUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<BenefitUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitUpdateManyLocalizationInput = {
  data: BenefitUpdateManyLocalizationDataInput
  locale: Locale
}

export type BenefitUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<BenefitUpdateManyLocalizationInput>>
}

export type BenefitUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BenefitUpdateManyInput
  /** Document search */
  where: BenefitWhereInput
}

export type BenefitUpdateOneInlineInput = {
  /** Create and connect one Benefit document */
  create?: InputMaybe<BenefitCreateInput>
  /** Delete currently connected Benefit document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Benefit document */
  update?: InputMaybe<BenefitUpdateWithNestedWhereUniqueInput>
  /** Upsert single Benefit document */
  upsert?: InputMaybe<BenefitUpsertWithNestedWhereUniqueInput>
}

export type BenefitUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<BenefitUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: BenefitWhereUniqueInput
}

export type BenefitUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BenefitUpdateInput
  /** Unique document search */
  where: BenefitWhereUniqueInput
}

export type BenefitUpsertInput = {
  /** Create document if it didn't exist */
  create: BenefitCreateInput
  /** Update document if it exists */
  update: BenefitUpdateInput
}

export type BenefitUpsertLocalizationInput = {
  create: BenefitCreateLocalizationDataInput
  locale: Locale
  update: BenefitUpdateLocalizationDataInput
}

export type BenefitUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<BenefitUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: BenefitWhereUniqueInput
}

export type BenefitUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BenefitUpsertInput
  /** Unique document search */
  where: BenefitWhereUniqueInput
}

/** Identifies documents */
export type BenefitWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References Benefit record uniquely */
export type BenefitWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type BenefitsCard = Entity & {
  __typename?: 'BenefitsCard'
  benefitsSection: Array<BenefitsSection>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<BenefitsCard>
  /** System stage field */
  stage: Stage
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type BenefitsCardBenefitsSectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<BenefitsSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BenefitsSectionWhereInput>
}

export type BenefitsCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type BenefitsCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type BenefitsCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: BenefitsCardWhereUniqueInput
}

/** A connection to a list of items. */
export type BenefitsCardConnection = {
  __typename?: 'BenefitsCardConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<BenefitsCardEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type BenefitsCardCreateInput = {
  benefitsSection?: InputMaybe<BenefitsSectionCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<BenefitsCardCreateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BenefitsCardCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BenefitsCardCreateLocalizationInput = {
  /** Localization input */
  data: BenefitsCardCreateLocalizationDataInput
  locale: Locale
}

export type BenefitsCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<BenefitsCardCreateLocalizationInput>>
}

export type BenefitsCardCreateManyInlineInput = {
  /** Create and connect multiple existing BenefitsCard documents */
  create?: InputMaybe<Array<BenefitsCardCreateInput>>
}

export type BenefitsCardCreateOneInlineInput = {
  /** Create and connect one BenefitsCard document */
  create?: InputMaybe<BenefitsCardCreateInput>
}

export type BenefitsCardCreateWithPositionInput = {
  /** Document to create */
  data: BenefitsCardCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type BenefitsCardEdge = {
  __typename?: 'BenefitsCardEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: BenefitsCard
}

/** Identifies documents */
export type BenefitsCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitsCardWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitsCardWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitsCardWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  benefitsSection_every?: InputMaybe<BenefitsSectionWhereInput>
  benefitsSection_none?: InputMaybe<BenefitsSectionWhereInput>
  benefitsSection_some?: InputMaybe<BenefitsSectionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum BenefitsCardOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type BenefitsCardParent = SectionStorytelling

export type BenefitsCardParentConnectInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingConnectInput>
}

export type BenefitsCardParentCreateInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingCreateInput>
}

export type BenefitsCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing BenefitsCardParent documents */
  create?: InputMaybe<Array<BenefitsCardParentCreateInput>>
}

export type BenefitsCardParentCreateOneInlineInput = {
  /** Create and connect one BenefitsCardParent document */
  create?: InputMaybe<BenefitsCardParentCreateInput>
}

export type BenefitsCardParentCreateWithPositionInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingCreateWithPositionInput>
}

export type BenefitsCardParentUpdateInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingUpdateInput>
}

export type BenefitsCardParentUpdateManyInlineInput = {
  /** Create and connect multiple BenefitsCardParent component instances */
  create?: InputMaybe<Array<BenefitsCardParentCreateWithPositionInput>>
  /** Delete multiple BenefitsCardParent documents */
  delete?: InputMaybe<Array<BenefitsCardParentWhereUniqueInput>>
  /** Update multiple BenefitsCardParent component instances */
  update?: InputMaybe<Array<BenefitsCardParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple BenefitsCardParent component instances */
  upsert?: InputMaybe<Array<BenefitsCardParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type BenefitsCardParentUpdateManyWithNestedWhereInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingUpdateManyWithNestedWhereInput>
}

export type BenefitsCardParentUpdateOneInlineInput = {
  /** Create and connect one BenefitsCardParent document */
  create?: InputMaybe<BenefitsCardParentCreateInput>
  /** Delete currently connected BenefitsCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single BenefitsCardParent document */
  update?: InputMaybe<BenefitsCardParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single BenefitsCardParent document */
  upsert?: InputMaybe<BenefitsCardParentUpsertWithNestedWhereUniqueInput>
}

export type BenefitsCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingUpdateWithNestedWhereUniqueAndPositionInput>
}

export type BenefitsCardParentUpdateWithNestedWhereUniqueInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingUpdateWithNestedWhereUniqueInput>
}

export type BenefitsCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingUpsertWithNestedWhereUniqueAndPositionInput>
}

export type BenefitsCardParentUpsertWithNestedWhereUniqueInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingUpsertWithNestedWhereUniqueInput>
}

export type BenefitsCardParentWhereInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingWhereInput>
}

export type BenefitsCardParentWhereUniqueInput = {
  SectionStorytelling?: InputMaybe<SectionStorytellingWhereUniqueInput>
}

export type BenefitsCardUpdateInput = {
  benefitsSection?: InputMaybe<BenefitsSectionUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<BenefitsCardUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitsCardUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitsCardUpdateLocalizationInput = {
  data: BenefitsCardUpdateLocalizationDataInput
  locale: Locale
}

export type BenefitsCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<BenefitsCardCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<BenefitsCardUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<BenefitsCardUpsertLocalizationInput>>
}

export type BenefitsCardUpdateManyInlineInput = {
  /** Create and connect multiple BenefitsCard component instances */
  create?: InputMaybe<Array<BenefitsCardCreateWithPositionInput>>
  /** Delete multiple BenefitsCard documents */
  delete?: InputMaybe<Array<BenefitsCardWhereUniqueInput>>
  /** Update multiple BenefitsCard component instances */
  update?: InputMaybe<Array<BenefitsCardUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple BenefitsCard component instances */
  upsert?: InputMaybe<Array<BenefitsCardUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type BenefitsCardUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<BenefitsCardUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitsCardUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitsCardUpdateManyLocalizationInput = {
  data: BenefitsCardUpdateManyLocalizationDataInput
  locale: Locale
}

export type BenefitsCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<BenefitsCardUpdateManyLocalizationInput>>
}

export type BenefitsCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BenefitsCardUpdateManyInput
  /** Document search */
  where: BenefitsCardWhereInput
}

export type BenefitsCardUpdateOneInlineInput = {
  /** Create and connect one BenefitsCard document */
  create?: InputMaybe<BenefitsCardCreateInput>
  /** Delete currently connected BenefitsCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single BenefitsCard document */
  update?: InputMaybe<BenefitsCardUpdateWithNestedWhereUniqueInput>
  /** Upsert single BenefitsCard document */
  upsert?: InputMaybe<BenefitsCardUpsertWithNestedWhereUniqueInput>
}

export type BenefitsCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<BenefitsCardUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: BenefitsCardWhereUniqueInput
}

export type BenefitsCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BenefitsCardUpdateInput
  /** Unique document search */
  where: BenefitsCardWhereUniqueInput
}

export type BenefitsCardUpsertInput = {
  /** Create document if it didn't exist */
  create: BenefitsCardCreateInput
  /** Update document if it exists */
  update: BenefitsCardUpdateInput
}

export type BenefitsCardUpsertLocalizationInput = {
  create: BenefitsCardCreateLocalizationDataInput
  locale: Locale
  update: BenefitsCardUpdateLocalizationDataInput
}

export type BenefitsCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<BenefitsCardUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: BenefitsCardWhereUniqueInput
}

export type BenefitsCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BenefitsCardUpsertInput
  /** Unique document search */
  where: BenefitsCardWhereUniqueInput
}

/** Identifies documents */
export type BenefitsCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitsCardWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitsCardWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitsCardWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  benefitsSection_every?: InputMaybe<BenefitsSectionWhereInput>
  benefitsSection_none?: InputMaybe<BenefitsSectionWhereInput>
  benefitsSection_some?: InputMaybe<BenefitsSectionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References BenefitsCard record uniquely */
export type BenefitsCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type BenefitsSection = Entity & {
  __typename?: 'BenefitsSection'
  benefit: Array<Benefit>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<BenefitsSection>
  /** System stage field */
  stage: Stage
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type BenefitsSectionBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<BenefitOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BenefitWhereInput>
}

export type BenefitsSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type BenefitsSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type BenefitsSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: BenefitsSectionWhereUniqueInput
}

/** A connection to a list of items. */
export type BenefitsSectionConnection = {
  __typename?: 'BenefitsSectionConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<BenefitsSectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type BenefitsSectionCreateInput = {
  benefit?: InputMaybe<BenefitCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<BenefitsSectionCreateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BenefitsSectionCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BenefitsSectionCreateLocalizationInput = {
  /** Localization input */
  data: BenefitsSectionCreateLocalizationDataInput
  locale: Locale
}

export type BenefitsSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<BenefitsSectionCreateLocalizationInput>>
}

export type BenefitsSectionCreateManyInlineInput = {
  /** Create and connect multiple existing BenefitsSection documents */
  create?: InputMaybe<Array<BenefitsSectionCreateInput>>
}

export type BenefitsSectionCreateOneInlineInput = {
  /** Create and connect one BenefitsSection document */
  create?: InputMaybe<BenefitsSectionCreateInput>
}

export type BenefitsSectionCreateWithPositionInput = {
  /** Document to create */
  data: BenefitsSectionCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type BenefitsSectionEdge = {
  __typename?: 'BenefitsSectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: BenefitsSection
}

/** Identifies documents */
export type BenefitsSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitsSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitsSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitsSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  benefit_every?: InputMaybe<BenefitWhereInput>
  benefit_none?: InputMaybe<BenefitWhereInput>
  benefit_some?: InputMaybe<BenefitWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum BenefitsSectionOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type BenefitsSectionParent = BenefitsCard

export type BenefitsSectionParentConnectInput = {
  BenefitsCard?: InputMaybe<BenefitsCardConnectInput>
}

export type BenefitsSectionParentCreateInput = {
  BenefitsCard?: InputMaybe<BenefitsCardCreateInput>
}

export type BenefitsSectionParentCreateManyInlineInput = {
  /** Create and connect multiple existing BenefitsSectionParent documents */
  create?: InputMaybe<Array<BenefitsSectionParentCreateInput>>
}

export type BenefitsSectionParentCreateOneInlineInput = {
  /** Create and connect one BenefitsSectionParent document */
  create?: InputMaybe<BenefitsSectionParentCreateInput>
}

export type BenefitsSectionParentCreateWithPositionInput = {
  BenefitsCard?: InputMaybe<BenefitsCardCreateWithPositionInput>
}

export type BenefitsSectionParentUpdateInput = {
  BenefitsCard?: InputMaybe<BenefitsCardUpdateInput>
}

export type BenefitsSectionParentUpdateManyInlineInput = {
  /** Create and connect multiple BenefitsSectionParent component instances */
  create?: InputMaybe<Array<BenefitsSectionParentCreateWithPositionInput>>
  /** Delete multiple BenefitsSectionParent documents */
  delete?: InputMaybe<Array<BenefitsSectionParentWhereUniqueInput>>
  /** Update multiple BenefitsSectionParent component instances */
  update?: InputMaybe<Array<BenefitsSectionParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple BenefitsSectionParent component instances */
  upsert?: InputMaybe<Array<BenefitsSectionParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type BenefitsSectionParentUpdateManyWithNestedWhereInput = {
  BenefitsCard?: InputMaybe<BenefitsCardUpdateManyWithNestedWhereInput>
}

export type BenefitsSectionParentUpdateOneInlineInput = {
  /** Create and connect one BenefitsSectionParent document */
  create?: InputMaybe<BenefitsSectionParentCreateInput>
  /** Delete currently connected BenefitsSectionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single BenefitsSectionParent document */
  update?: InputMaybe<BenefitsSectionParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single BenefitsSectionParent document */
  upsert?: InputMaybe<BenefitsSectionParentUpsertWithNestedWhereUniqueInput>
}

export type BenefitsSectionParentUpdateWithNestedWhereUniqueAndPositionInput = {
  BenefitsCard?: InputMaybe<BenefitsCardUpdateWithNestedWhereUniqueAndPositionInput>
}

export type BenefitsSectionParentUpdateWithNestedWhereUniqueInput = {
  BenefitsCard?: InputMaybe<BenefitsCardUpdateWithNestedWhereUniqueInput>
}

export type BenefitsSectionParentUpsertWithNestedWhereUniqueAndPositionInput = {
  BenefitsCard?: InputMaybe<BenefitsCardUpsertWithNestedWhereUniqueAndPositionInput>
}

export type BenefitsSectionParentUpsertWithNestedWhereUniqueInput = {
  BenefitsCard?: InputMaybe<BenefitsCardUpsertWithNestedWhereUniqueInput>
}

export type BenefitsSectionParentWhereInput = {
  BenefitsCard?: InputMaybe<BenefitsCardWhereInput>
}

export type BenefitsSectionParentWhereUniqueInput = {
  BenefitsCard?: InputMaybe<BenefitsCardWhereUniqueInput>
}

export type BenefitsSectionUpdateInput = {
  benefit?: InputMaybe<BenefitUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<BenefitsSectionUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitsSectionUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitsSectionUpdateLocalizationInput = {
  data: BenefitsSectionUpdateLocalizationDataInput
  locale: Locale
}

export type BenefitsSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<BenefitsSectionCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<BenefitsSectionUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<BenefitsSectionUpsertLocalizationInput>>
}

export type BenefitsSectionUpdateManyInlineInput = {
  /** Create and connect multiple BenefitsSection component instances */
  create?: InputMaybe<Array<BenefitsSectionCreateWithPositionInput>>
  /** Delete multiple BenefitsSection documents */
  delete?: InputMaybe<Array<BenefitsSectionWhereUniqueInput>>
  /** Update multiple BenefitsSection component instances */
  update?: InputMaybe<Array<BenefitsSectionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple BenefitsSection component instances */
  upsert?: InputMaybe<Array<BenefitsSectionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type BenefitsSectionUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<BenefitsSectionUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitsSectionUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type BenefitsSectionUpdateManyLocalizationInput = {
  data: BenefitsSectionUpdateManyLocalizationDataInput
  locale: Locale
}

export type BenefitsSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<BenefitsSectionUpdateManyLocalizationInput>>
}

export type BenefitsSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BenefitsSectionUpdateManyInput
  /** Document search */
  where: BenefitsSectionWhereInput
}

export type BenefitsSectionUpdateOneInlineInput = {
  /** Create and connect one BenefitsSection document */
  create?: InputMaybe<BenefitsSectionCreateInput>
  /** Delete currently connected BenefitsSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single BenefitsSection document */
  update?: InputMaybe<BenefitsSectionUpdateWithNestedWhereUniqueInput>
  /** Upsert single BenefitsSection document */
  upsert?: InputMaybe<BenefitsSectionUpsertWithNestedWhereUniqueInput>
}

export type BenefitsSectionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<BenefitsSectionUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: BenefitsSectionWhereUniqueInput
}

export type BenefitsSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BenefitsSectionUpdateInput
  /** Unique document search */
  where: BenefitsSectionWhereUniqueInput
}

export type BenefitsSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: BenefitsSectionCreateInput
  /** Update document if it exists */
  update: BenefitsSectionUpdateInput
}

export type BenefitsSectionUpsertLocalizationInput = {
  create: BenefitsSectionCreateLocalizationDataInput
  locale: Locale
  update: BenefitsSectionUpdateLocalizationDataInput
}

export type BenefitsSectionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<BenefitsSectionUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: BenefitsSectionWhereUniqueInput
}

export type BenefitsSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BenefitsSectionUpsertInput
  /** Unique document search */
  where: BenefitsSectionWhereUniqueInput
}

/** Identifies documents */
export type BenefitsSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitsSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitsSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitsSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  benefit_every?: InputMaybe<BenefitWhereInput>
  benefit_none?: InputMaybe<BenefitWhereInput>
  benefit_some?: InputMaybe<BenefitWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References BenefitsSection record uniquely */
export type BenefitsSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type Booth = Entity &
  Node & {
    __typename?: 'Booth'
    boothNumber?: Maybe<Scalars['String']['output']>
    boothType?: Maybe<BoothType>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<Booth>
    event?: Maybe<Event>
    /** List of Booth versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Booth>
    partnerCompany?: Maybe<PartnerCompany>
    physicalLocation?: Maybe<PhysicalLocation>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    title?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

export type BoothCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type BoothCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type BoothDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type BoothEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type BoothHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type BoothLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type BoothPartnerCompanyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type BoothPhysicalLocationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type BoothPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type BoothPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type BoothScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type BoothUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type BoothUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type BoothConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: BoothWhereUniqueInput
}

/** A connection to a list of items. */
export type BoothConnection = {
  __typename?: 'BoothConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<BoothEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type BoothCreateInput = {
  boothNumber?: InputMaybe<Scalars['String']['input']>
  boothType?: InputMaybe<BoothType>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  event?: InputMaybe<EventCreateOneInlineInput>
  eventBooth?: InputMaybe<EventCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<BoothCreateLocalizationsInput>
  partnerCompany?: InputMaybe<PartnerCompanyCreateOneInlineInput>
  physicalLocation?: InputMaybe<PhysicalLocationCreateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BoothCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BoothCreateLocalizationInput = {
  /** Localization input */
  data: BoothCreateLocalizationDataInput
  locale: Locale
}

export type BoothCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<BoothCreateLocalizationInput>>
}

export type BoothCreateManyInlineInput = {
  /** Connect multiple existing Booth documents */
  connect?: InputMaybe<Array<BoothWhereUniqueInput>>
  /** Create and connect multiple existing Booth documents */
  create?: InputMaybe<Array<BoothCreateInput>>
}

export type BoothCreateOneInlineInput = {
  /** Connect one existing Booth document */
  connect?: InputMaybe<BoothWhereUniqueInput>
  /** Create and connect one Booth document */
  create?: InputMaybe<BoothCreateInput>
}

/** An edge in a connection. */
export type BoothEdge = {
  __typename?: 'BoothEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Booth
}

/** Identifies documents */
export type BoothManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BoothWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BoothWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BoothWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  boothNumber?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  boothNumber_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  boothNumber_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  boothNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  boothNumber_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  boothNumber_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  boothNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  boothNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  boothNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  boothNumber_starts_with?: InputMaybe<Scalars['String']['input']>
  boothType?: InputMaybe<BoothType>
  /** All values that are contained in given list. */
  boothType_in?: InputMaybe<Array<InputMaybe<BoothType>>>
  /** Any other value that exists and is not equal to the given value. */
  boothType_not?: InputMaybe<BoothType>
  /** All values that are not contained in given list. */
  boothType_not_in?: InputMaybe<Array<InputMaybe<BoothType>>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<BoothWhereStageInput>
  documentInStages_none?: InputMaybe<BoothWhereStageInput>
  documentInStages_some?: InputMaybe<BoothWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyWhereInput>
  physicalLocation?: InputMaybe<PhysicalLocationWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum BoothOrderByInput {
  BoothNumberAsc = 'boothNumber_ASC',
  BoothNumberDesc = 'boothNumber_DESC',
  BoothTypeAsc = 'boothType_ASC',
  BoothTypeDesc = 'boothType_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export enum BoothType {
  CoExhibitorBooth = 'CoExhibitorBooth',
  SeacontainerBooth = 'SeacontainerBooth',
  StartupBooth = 'StartupBooth',
  SystemBooth = 'SystemBooth',
}

export type BoothUpdateInput = {
  boothNumber?: InputMaybe<Scalars['String']['input']>
  boothType?: InputMaybe<BoothType>
  event?: InputMaybe<EventUpdateOneInlineInput>
  eventBooth?: InputMaybe<EventUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<BoothUpdateLocalizationsInput>
  partnerCompany?: InputMaybe<PartnerCompanyUpdateOneInlineInput>
  physicalLocation?: InputMaybe<PhysicalLocationUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BoothUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type BoothUpdateLocalizationInput = {
  data: BoothUpdateLocalizationDataInput
  locale: Locale
}

export type BoothUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<BoothCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<BoothUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<BoothUpsertLocalizationInput>>
}

export type BoothUpdateManyInlineInput = {
  /** Connect multiple existing Booth documents */
  connect?: InputMaybe<Array<BoothConnectInput>>
  /** Create and connect multiple Booth documents */
  create?: InputMaybe<Array<BoothCreateInput>>
  /** Delete multiple Booth documents */
  delete?: InputMaybe<Array<BoothWhereUniqueInput>>
  /** Disconnect multiple Booth documents */
  disconnect?: InputMaybe<Array<BoothWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Booth documents */
  set?: InputMaybe<Array<BoothWhereUniqueInput>>
  /** Update multiple Booth documents */
  update?: InputMaybe<Array<BoothUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Booth documents */
  upsert?: InputMaybe<Array<BoothUpsertWithNestedWhereUniqueInput>>
}

export type BoothUpdateManyInput = {
  boothNumber?: InputMaybe<Scalars['String']['input']>
  boothType?: InputMaybe<BoothType>
  /** Optional updates to localizations */
  localizations?: InputMaybe<BoothUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BoothUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type BoothUpdateManyLocalizationInput = {
  data: BoothUpdateManyLocalizationDataInput
  locale: Locale
}

export type BoothUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<BoothUpdateManyLocalizationInput>>
}

export type BoothUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BoothUpdateManyInput
  /** Document search */
  where: BoothWhereInput
}

export type BoothUpdateOneInlineInput = {
  /** Connect existing Booth document */
  connect?: InputMaybe<BoothWhereUniqueInput>
  /** Create and connect one Booth document */
  create?: InputMaybe<BoothCreateInput>
  /** Delete currently connected Booth document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Booth document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Booth document */
  update?: InputMaybe<BoothUpdateWithNestedWhereUniqueInput>
  /** Upsert single Booth document */
  upsert?: InputMaybe<BoothUpsertWithNestedWhereUniqueInput>
}

export type BoothUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BoothUpdateInput
  /** Unique document search */
  where: BoothWhereUniqueInput
}

export type BoothUpsertInput = {
  /** Create document if it didn't exist */
  create: BoothCreateInput
  /** Update document if it exists */
  update: BoothUpdateInput
}

export type BoothUpsertLocalizationInput = {
  create: BoothCreateLocalizationDataInput
  locale: Locale
  update: BoothUpdateLocalizationDataInput
}

export type BoothUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BoothUpsertInput
  /** Unique document search */
  where: BoothWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type BoothWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type BoothWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BoothWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BoothWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BoothWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  boothNumber?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  boothNumber_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  boothNumber_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  boothNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  boothNumber_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  boothNumber_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  boothNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  boothNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  boothNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  boothNumber_starts_with?: InputMaybe<Scalars['String']['input']>
  boothType?: InputMaybe<BoothType>
  /** All values that are contained in given list. */
  boothType_in?: InputMaybe<Array<InputMaybe<BoothType>>>
  /** Any other value that exists and is not equal to the given value. */
  boothType_not?: InputMaybe<BoothType>
  /** All values that are not contained in given list. */
  boothType_not_in?: InputMaybe<Array<InputMaybe<BoothType>>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<BoothWhereStageInput>
  documentInStages_none?: InputMaybe<BoothWhereStageInput>
  documentInStages_some?: InputMaybe<BoothWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyWhereInput>
  physicalLocation?: InputMaybe<PhysicalLocationWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BoothWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BoothWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BoothWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BoothWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BoothWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Booth record uniquely */
export type BoothWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type BulletPointList = Entity & {
  __typename?: 'BulletPointList'
  /** The unique identifier */
  id: Scalars['ID']['output']
  image: Asset
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<BulletPointList>
  points: Array<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  styleVariant?: Maybe<ComponentStyle>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type BulletPointListImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type BulletPointListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type BulletPointListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type BulletPointListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: BulletPointListWhereUniqueInput
}

/** A connection to a list of items. */
export type BulletPointListConnection = {
  __typename?: 'BulletPointListConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<BulletPointListEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type BulletPointListCreateInput = {
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<BulletPointListCreateLocalizationsInput>
  /** points input for default locale (de) */
  points: Array<Scalars['String']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BulletPointListCreateLocalizationDataInput = {
  points: Array<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BulletPointListCreateLocalizationInput = {
  /** Localization input */
  data: BulletPointListCreateLocalizationDataInput
  locale: Locale
}

export type BulletPointListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<BulletPointListCreateLocalizationInput>>
}

export type BulletPointListCreateManyInlineInput = {
  /** Create and connect multiple existing BulletPointList documents */
  create?: InputMaybe<Array<BulletPointListCreateInput>>
}

export type BulletPointListCreateOneInlineInput = {
  /** Create and connect one BulletPointList document */
  create?: InputMaybe<BulletPointListCreateInput>
}

export type BulletPointListCreateWithPositionInput = {
  /** Document to create */
  data: BulletPointListCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type BulletPointListEdge = {
  __typename?: 'BulletPointListEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: BulletPointList
}

/** Identifies documents */
export type BulletPointListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BulletPointListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BulletPointListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BulletPointListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum BulletPointListOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PointsAsc = 'points_ASC',
  PointsDesc = 'points_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type BulletPointListParent = EventPage

export type BulletPointListParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type BulletPointListParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type BulletPointListParentCreateManyInlineInput = {
  /** Connect multiple existing BulletPointListParent documents */
  connect?: InputMaybe<Array<BulletPointListParentWhereUniqueInput>>
  /** Create and connect multiple existing BulletPointListParent documents */
  create?: InputMaybe<Array<BulletPointListParentCreateInput>>
}

export type BulletPointListParentCreateOneInlineInput = {
  /** Connect one existing BulletPointListParent document */
  connect?: InputMaybe<BulletPointListParentWhereUniqueInput>
  /** Create and connect one BulletPointListParent document */
  create?: InputMaybe<BulletPointListParentCreateInput>
}

export type BulletPointListParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type BulletPointListParentUpdateManyInlineInput = {
  /** Connect multiple existing BulletPointListParent documents */
  connect?: InputMaybe<Array<BulletPointListParentConnectInput>>
  /** Create and connect multiple BulletPointListParent documents */
  create?: InputMaybe<Array<BulletPointListParentCreateInput>>
  /** Delete multiple BulletPointListParent documents */
  delete?: InputMaybe<Array<BulletPointListParentWhereUniqueInput>>
  /** Disconnect multiple BulletPointListParent documents */
  disconnect?: InputMaybe<Array<BulletPointListParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing BulletPointListParent documents */
  set?: InputMaybe<Array<BulletPointListParentWhereUniqueInput>>
  /** Update multiple BulletPointListParent documents */
  update?: InputMaybe<Array<BulletPointListParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple BulletPointListParent documents */
  upsert?: InputMaybe<Array<BulletPointListParentUpsertWithNestedWhereUniqueInput>>
}

export type BulletPointListParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type BulletPointListParentUpdateOneInlineInput = {
  /** Connect existing BulletPointListParent document */
  connect?: InputMaybe<BulletPointListParentWhereUniqueInput>
  /** Create and connect one BulletPointListParent document */
  create?: InputMaybe<BulletPointListParentCreateInput>
  /** Delete currently connected BulletPointListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected BulletPointListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single BulletPointListParent document */
  update?: InputMaybe<BulletPointListParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single BulletPointListParent document */
  upsert?: InputMaybe<BulletPointListParentUpsertWithNestedWhereUniqueInput>
}

export type BulletPointListParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type BulletPointListParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type BulletPointListParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type BulletPointListParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type BulletPointListUpdateInput = {
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<BulletPointListUpdateLocalizationsInput>
  /** points input for default locale (de) */
  points?: InputMaybe<Array<Scalars['String']['input']>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BulletPointListUpdateLocalizationDataInput = {
  points?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type BulletPointListUpdateLocalizationInput = {
  data: BulletPointListUpdateLocalizationDataInput
  locale: Locale
}

export type BulletPointListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<BulletPointListCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<BulletPointListUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<BulletPointListUpsertLocalizationInput>>
}

export type BulletPointListUpdateManyInlineInput = {
  /** Create and connect multiple BulletPointList component instances */
  create?: InputMaybe<Array<BulletPointListCreateWithPositionInput>>
  /** Delete multiple BulletPointList documents */
  delete?: InputMaybe<Array<BulletPointListWhereUniqueInput>>
  /** Update multiple BulletPointList component instances */
  update?: InputMaybe<Array<BulletPointListUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple BulletPointList component instances */
  upsert?: InputMaybe<Array<BulletPointListUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type BulletPointListUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<BulletPointListUpdateManyLocalizationsInput>
  /** points input for default locale (de) */
  points?: InputMaybe<Array<Scalars['String']['input']>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type BulletPointListUpdateManyLocalizationDataInput = {
  points?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type BulletPointListUpdateManyLocalizationInput = {
  data: BulletPointListUpdateManyLocalizationDataInput
  locale: Locale
}

export type BulletPointListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<BulletPointListUpdateManyLocalizationInput>>
}

export type BulletPointListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BulletPointListUpdateManyInput
  /** Document search */
  where: BulletPointListWhereInput
}

export type BulletPointListUpdateOneInlineInput = {
  /** Create and connect one BulletPointList document */
  create?: InputMaybe<BulletPointListCreateInput>
  /** Delete currently connected BulletPointList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single BulletPointList document */
  update?: InputMaybe<BulletPointListUpdateWithNestedWhereUniqueInput>
  /** Upsert single BulletPointList document */
  upsert?: InputMaybe<BulletPointListUpsertWithNestedWhereUniqueInput>
}

export type BulletPointListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<BulletPointListUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: BulletPointListWhereUniqueInput
}

export type BulletPointListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BulletPointListUpdateInput
  /** Unique document search */
  where: BulletPointListWhereUniqueInput
}

export type BulletPointListUpsertInput = {
  /** Create document if it didn't exist */
  create: BulletPointListCreateInput
  /** Update document if it exists */
  update: BulletPointListUpdateInput
}

export type BulletPointListUpsertLocalizationInput = {
  create: BulletPointListCreateLocalizationDataInput
  locale: Locale
  update: BulletPointListUpdateLocalizationDataInput
}

export type BulletPointListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<BulletPointListUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: BulletPointListWhereUniqueInput
}

export type BulletPointListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BulletPointListUpsertInput
  /** Unique document search */
  where: BulletPointListWhereUniqueInput
}

/** Identifies documents */
export type BulletPointListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BulletPointListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BulletPointListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BulletPointListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  points?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  points_contains_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  points_contains_none?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  points_contains_some?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  points_not?: InputMaybe<Array<Scalars['String']['input']>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References BulletPointList record uniquely */
export type BulletPointListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Link or button call to action configuration */
export type CallToAction = Entity & {
  __typename?: 'CallToAction'
  /** May not be supported by your component yet. */
  callToActionSemanticButtonSize?: Maybe<SemanticButtonSizeEnum>
  /** May not be supported by your component yet. */
  callToActionSemanticButtonStyle?: Maybe<SemanticButtonStyleEnum>
  /** DEPRECATED: Use Semantic Button Style */
  color?: Maybe<CallToActionColor>
  /**
   * Use for external links if:
   * 1. user-generated content
   * 2. paid/sponsored link
   * 3. affiliate links
   */
  external?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Link or button label */
  label: Scalars['String']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<CallToAction>
  /** Icon for the Explanation Step. Reference: https://lucide.dev/icons/ */
  lucideIcon?: Maybe<LucideIcon>
  /** DEPRECATED: Use Semantic Button Size */
  size?: Maybe<CallToActionSize>
  /** System stage field */
  stage: Stage
  /** Link target (defaults to _self) */
  target?: Maybe<Scalars['String']['output']>
  /** Tracking identifier which will be used to generate data-track attribute for action */
  trackingId?: Maybe<Scalars['String']['output']>
  /** DEPRECATED: Use Semantic Button Style */
  type?: Maybe<CallToActionType>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url: Scalars['String']['output']
}

/** Link or button call to action configuration */
export type CallToActionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Link or button call to action configuration */
export type CallToActionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export enum CallToActionColor {
  Black = 'black',
  Mint = 'mint',
  Purple = 'purple',
  White = 'white',
  Yellow = 'yellow',
}

export type CallToActionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: CallToActionWhereUniqueInput
}

/** A connection to a list of items. */
export type CallToActionConnection = {
  __typename?: 'CallToActionConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<CallToActionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type CallToActionCreateInput = {
  callToActionSemanticButtonSize?: InputMaybe<SemanticButtonSizeEnum>
  callToActionSemanticButtonStyle?: InputMaybe<SemanticButtonStyleEnum>
  color?: InputMaybe<CallToActionColor>
  external?: InputMaybe<Scalars['Boolean']['input']>
  /** label input for default locale (de) */
  label: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CallToActionCreateLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  size?: InputMaybe<CallToActionSize>
  target?: InputMaybe<Scalars['String']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<CallToActionType>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** url input for default locale (de) */
  url: Scalars['String']['input']
}

export type CallToActionCreateLocalizationDataInput = {
  label: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  url: Scalars['String']['input']
}

export type CallToActionCreateLocalizationInput = {
  /** Localization input */
  data: CallToActionCreateLocalizationDataInput
  locale: Locale
}

export type CallToActionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CallToActionCreateLocalizationInput>>
}

export type CallToActionCreateManyInlineInput = {
  /** Create and connect multiple existing CallToAction documents */
  create?: InputMaybe<Array<CallToActionCreateInput>>
}

export type CallToActionCreateOneInlineInput = {
  /** Create and connect one CallToAction document */
  create?: InputMaybe<CallToActionCreateInput>
}

export type CallToActionCreateWithPositionInput = {
  /** Document to create */
  data: CallToActionCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type CallToActionEdge = {
  __typename?: 'CallToActionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: CallToAction
}

/** Identifies documents */
export type CallToActionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CallToActionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CallToActionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CallToActionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  callToActionSemanticButtonSize?: InputMaybe<SemanticButtonSizeEnum>
  /** All values that are contained in given list. */
  callToActionSemanticButtonSize_in?: InputMaybe<Array<InputMaybe<SemanticButtonSizeEnum>>>
  /** Any other value that exists and is not equal to the given value. */
  callToActionSemanticButtonSize_not?: InputMaybe<SemanticButtonSizeEnum>
  /** All values that are not contained in given list. */
  callToActionSemanticButtonSize_not_in?: InputMaybe<Array<InputMaybe<SemanticButtonSizeEnum>>>
  callToActionSemanticButtonStyle?: InputMaybe<SemanticButtonStyleEnum>
  /** All values that are contained in given list. */
  callToActionSemanticButtonStyle_in?: InputMaybe<Array<InputMaybe<SemanticButtonStyleEnum>>>
  /** Any other value that exists and is not equal to the given value. */
  callToActionSemanticButtonStyle_not?: InputMaybe<SemanticButtonStyleEnum>
  /** All values that are not contained in given list. */
  callToActionSemanticButtonStyle_not_in?: InputMaybe<Array<InputMaybe<SemanticButtonStyleEnum>>>
  color?: InputMaybe<CallToActionColor>
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CallToActionColor>>>
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CallToActionColor>
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CallToActionColor>>>
  external?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  external_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  lucideIcon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  lucideIcon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  lucideIcon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  lucideIcon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  size?: InputMaybe<CallToActionSize>
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<CallToActionSize>>>
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<CallToActionSize>
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<CallToActionSize>>>
  target?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  target_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  target_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  target_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  target_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  target_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  target_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  target_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  target_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  target_starts_with?: InputMaybe<Scalars['String']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  trackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  trackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  trackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  trackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  trackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  trackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  trackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  trackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  trackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<CallToActionType>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<CallToActionType>>>
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<CallToActionType>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<CallToActionType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum CallToActionOrderByInput {
  CallToActionSemanticButtonSizeAsc = 'callToActionSemanticButtonSize_ASC',
  CallToActionSemanticButtonSizeDesc = 'callToActionSemanticButtonSize_DESC',
  CallToActionSemanticButtonStyleAsc = 'callToActionSemanticButtonStyle_ASC',
  CallToActionSemanticButtonStyleDesc = 'callToActionSemanticButtonStyle_DESC',
  ColorAsc = 'color_ASC',
  ColorDesc = 'color_DESC',
  ExternalAsc = 'external_ASC',
  ExternalDesc = 'external_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LucideIconAsc = 'lucideIcon_ASC',
  LucideIconDesc = 'lucideIcon_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  TargetAsc = 'target_ASC',
  TargetDesc = 'target_DESC',
  TrackingIdAsc = 'trackingId_ASC',
  TrackingIdDesc = 'trackingId_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
}

export type CallToActionParent =
  | CareerPageSectionCareersList
  | CareerPageSectionHero
  | ExplanationStep
  | HeaderMenuItem
  | HeaderPromo
  | HubPageContentSliderItem
  | HubPageContentTile
  | HubPageCountdownHero
  | HubPageHeroSliderItem
  | HubPageInfoTile
  | HubPagePartnerCompanyTile
  | HubPageReferenceListTile
  | HubPageSpeakerTile
  | JobListing
  | NewsletterAudience
  | SectionByTheNumbers
  | SectionContact
  | SectionEventOffersTimetable
  | SectionExplanationBlocks
  | SectionFestivalTimetable
  | SectionFlipCounter
  | SectionHero
  | SectionIntro
  | SectionMyomrExhibitors
  | SectionNewsletter
  | SectionSlimCta
  | SectionSpeakers
  | SectionStyledHero
  | SectionTeaser
  | SectionTestimonial
  | TextMedia
  | TextMediaBanner

export type CallToActionParentConnectInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListConnectInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroConnectInput>
  ExplanationStep?: InputMaybe<ExplanationStepConnectInput>
  HeaderMenuItem?: InputMaybe<HeaderMenuItemConnectInput>
  HeaderPromo?: InputMaybe<HeaderPromoConnectInput>
  HubPageContentSliderItem?: InputMaybe<HubPageContentSliderItemConnectInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileConnectInput>
  HubPageCountdownHero?: InputMaybe<HubPageCountdownHeroConnectInput>
  HubPageHeroSliderItem?: InputMaybe<HubPageHeroSliderItemConnectInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileConnectInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileConnectInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileConnectInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileConnectInput>
  JobListing?: InputMaybe<JobListingConnectInput>
  NewsletterAudience?: InputMaybe<NewsletterAudienceConnectInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersConnectInput>
  SectionContact?: InputMaybe<SectionContactConnectInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableConnectInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksConnectInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableConnectInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterConnectInput>
  SectionHero?: InputMaybe<SectionHeroConnectInput>
  SectionIntro?: InputMaybe<SectionIntroConnectInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsConnectInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterConnectInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaConnectInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersConnectInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroConnectInput>
  SectionTeaser?: InputMaybe<SectionTeaserConnectInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialConnectInput>
  TextMedia?: InputMaybe<TextMediaConnectInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerConnectInput>
}

export type CallToActionParentCreateInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListCreateInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroCreateInput>
  ExplanationStep?: InputMaybe<ExplanationStepCreateInput>
  HeaderMenuItem?: InputMaybe<HeaderMenuItemCreateInput>
  HeaderPromo?: InputMaybe<HeaderPromoCreateInput>
  HubPageContentSliderItem?: InputMaybe<HubPageContentSliderItemCreateInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileCreateInput>
  HubPageCountdownHero?: InputMaybe<HubPageCountdownHeroCreateInput>
  HubPageHeroSliderItem?: InputMaybe<HubPageHeroSliderItemCreateInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileCreateInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileCreateInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileCreateInput>
  JobListing?: InputMaybe<JobListingCreateInput>
  NewsletterAudience?: InputMaybe<NewsletterAudienceCreateInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersCreateInput>
  SectionContact?: InputMaybe<SectionContactCreateInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableCreateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableCreateInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterCreateInput>
  SectionHero?: InputMaybe<SectionHeroCreateInput>
  SectionIntro?: InputMaybe<SectionIntroCreateInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsCreateInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterCreateInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaCreateInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersCreateInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateInput>
  SectionTeaser?: InputMaybe<SectionTeaserCreateInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialCreateInput>
  TextMedia?: InputMaybe<TextMediaCreateInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerCreateInput>
}

export type CallToActionParentCreateManyInlineInput = {
  /** Connect multiple existing CallToActionParent documents */
  connect?: InputMaybe<Array<CallToActionParentWhereUniqueInput>>
  /** Create and connect multiple existing CallToActionParent documents */
  create?: InputMaybe<Array<CallToActionParentCreateInput>>
}

export type CallToActionParentCreateOneInlineInput = {
  /** Connect one existing CallToActionParent document */
  connect?: InputMaybe<CallToActionParentWhereUniqueInput>
  /** Create and connect one CallToActionParent document */
  create?: InputMaybe<CallToActionParentCreateInput>
}

export type CallToActionParentUpdateInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpdateInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpdateInput>
  ExplanationStep?: InputMaybe<ExplanationStepUpdateInput>
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateInput>
  HeaderPromo?: InputMaybe<HeaderPromoUpdateInput>
  HubPageContentSliderItem?: InputMaybe<HubPageContentSliderItemUpdateInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateInput>
  HubPageCountdownHero?: InputMaybe<HubPageCountdownHeroUpdateInput>
  HubPageHeroSliderItem?: InputMaybe<HubPageHeroSliderItemUpdateInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateInput>
  JobListing?: InputMaybe<JobListingUpdateInput>
  NewsletterAudience?: InputMaybe<NewsletterAudienceUpdateInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateInput>
  SectionContact?: InputMaybe<SectionContactUpdateInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpdateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpdateInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpdateInput>
  SectionHero?: InputMaybe<SectionHeroUpdateInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpdateInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpdateInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpdateInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpdateInput>
  TextMedia?: InputMaybe<TextMediaUpdateInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpdateInput>
}

export type CallToActionParentUpdateManyInlineInput = {
  /** Connect multiple existing CallToActionParent documents */
  connect?: InputMaybe<Array<CallToActionParentConnectInput>>
  /** Create and connect multiple CallToActionParent documents */
  create?: InputMaybe<Array<CallToActionParentCreateInput>>
  /** Delete multiple CallToActionParent documents */
  delete?: InputMaybe<Array<CallToActionParentWhereUniqueInput>>
  /** Disconnect multiple CallToActionParent documents */
  disconnect?: InputMaybe<Array<CallToActionParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing CallToActionParent documents */
  set?: InputMaybe<Array<CallToActionParentWhereUniqueInput>>
  /** Update multiple CallToActionParent documents */
  update?: InputMaybe<Array<CallToActionParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple CallToActionParent documents */
  upsert?: InputMaybe<Array<CallToActionParentUpsertWithNestedWhereUniqueInput>>
}

export type CallToActionParentUpdateManyWithNestedWhereInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpdateManyWithNestedWhereInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpdateManyWithNestedWhereInput>
  ExplanationStep?: InputMaybe<ExplanationStepUpdateManyWithNestedWhereInput>
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateManyWithNestedWhereInput>
  HeaderPromo?: InputMaybe<HeaderPromoUpdateManyWithNestedWhereInput>
  HubPageContentSliderItem?: InputMaybe<HubPageContentSliderItemUpdateManyWithNestedWhereInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateManyWithNestedWhereInput>
  HubPageCountdownHero?: InputMaybe<HubPageCountdownHeroUpdateManyWithNestedWhereInput>
  HubPageHeroSliderItem?: InputMaybe<HubPageHeroSliderItemUpdateManyWithNestedWhereInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateManyWithNestedWhereInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateManyWithNestedWhereInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateManyWithNestedWhereInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateManyWithNestedWhereInput>
  JobListing?: InputMaybe<JobListingUpdateManyWithNestedWhereInput>
  NewsletterAudience?: InputMaybe<NewsletterAudienceUpdateManyWithNestedWhereInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateManyWithNestedWhereInput>
  SectionContact?: InputMaybe<SectionContactUpdateManyWithNestedWhereInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpdateManyWithNestedWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateManyWithNestedWhereInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpdateManyWithNestedWhereInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpdateManyWithNestedWhereInput>
  SectionHero?: InputMaybe<SectionHeroUpdateManyWithNestedWhereInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateManyWithNestedWhereInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpdateManyWithNestedWhereInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateManyWithNestedWhereInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpdateManyWithNestedWhereInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpdateManyWithNestedWhereInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateManyWithNestedWhereInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateManyWithNestedWhereInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpdateManyWithNestedWhereInput>
  TextMedia?: InputMaybe<TextMediaUpdateManyWithNestedWhereInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpdateManyWithNestedWhereInput>
}

export type CallToActionParentUpdateOneInlineInput = {
  /** Connect existing CallToActionParent document */
  connect?: InputMaybe<CallToActionParentWhereUniqueInput>
  /** Create and connect one CallToActionParent document */
  create?: InputMaybe<CallToActionParentCreateInput>
  /** Delete currently connected CallToActionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected CallToActionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single CallToActionParent document */
  update?: InputMaybe<CallToActionParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single CallToActionParent document */
  upsert?: InputMaybe<CallToActionParentUpsertWithNestedWhereUniqueInput>
}

export type CallToActionParentUpdateWithNestedWhereUniqueInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpdateWithNestedWhereUniqueInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpdateWithNestedWhereUniqueInput>
  ExplanationStep?: InputMaybe<ExplanationStepUpdateWithNestedWhereUniqueInput>
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateWithNestedWhereUniqueInput>
  HeaderPromo?: InputMaybe<HeaderPromoUpdateWithNestedWhereUniqueInput>
  HubPageContentSliderItem?: InputMaybe<HubPageContentSliderItemUpdateWithNestedWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateWithNestedWhereUniqueInput>
  HubPageCountdownHero?: InputMaybe<HubPageCountdownHeroUpdateWithNestedWhereUniqueInput>
  HubPageHeroSliderItem?: InputMaybe<HubPageHeroSliderItemUpdateWithNestedWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateWithNestedWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateWithNestedWhereUniqueInput>
  JobListing?: InputMaybe<JobListingUpdateWithNestedWhereUniqueInput>
  NewsletterAudience?: InputMaybe<NewsletterAudienceUpdateWithNestedWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateWithNestedWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpdateWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpdateWithNestedWhereUniqueInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpdateWithNestedWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroUpdateWithNestedWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateWithNestedWhereUniqueInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpdateWithNestedWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateWithNestedWhereUniqueInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpdateWithNestedWhereUniqueInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpdateWithNestedWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateWithNestedWhereUniqueInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpdateWithNestedWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaUpdateWithNestedWhereUniqueInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpdateWithNestedWhereUniqueInput>
}

export type CallToActionParentUpsertWithNestedWhereUniqueInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpsertWithNestedWhereUniqueInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpsertWithNestedWhereUniqueInput>
  ExplanationStep?: InputMaybe<ExplanationStepUpsertWithNestedWhereUniqueInput>
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpsertWithNestedWhereUniqueInput>
  HeaderPromo?: InputMaybe<HeaderPromoUpsertWithNestedWhereUniqueInput>
  HubPageContentSliderItem?: InputMaybe<HubPageContentSliderItemUpsertWithNestedWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpsertWithNestedWhereUniqueInput>
  HubPageCountdownHero?: InputMaybe<HubPageCountdownHeroUpsertWithNestedWhereUniqueInput>
  HubPageHeroSliderItem?: InputMaybe<HubPageHeroSliderItemUpsertWithNestedWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpsertWithNestedWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpsertWithNestedWhereUniqueInput>
  JobListing?: InputMaybe<JobListingUpsertWithNestedWhereUniqueInput>
  NewsletterAudience?: InputMaybe<NewsletterAudienceUpsertWithNestedWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpsertWithNestedWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpsertWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpsertWithNestedWhereUniqueInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpsertWithNestedWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroUpsertWithNestedWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroUpsertWithNestedWhereUniqueInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpsertWithNestedWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpsertWithNestedWhereUniqueInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpsertWithNestedWhereUniqueInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpsertWithNestedWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpsertWithNestedWhereUniqueInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpsertWithNestedWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaUpsertWithNestedWhereUniqueInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpsertWithNestedWhereUniqueInput>
}

export type CallToActionParentWhereInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListWhereInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroWhereInput>
  ExplanationStep?: InputMaybe<ExplanationStepWhereInput>
  HeaderMenuItem?: InputMaybe<HeaderMenuItemWhereInput>
  HeaderPromo?: InputMaybe<HeaderPromoWhereInput>
  HubPageContentSliderItem?: InputMaybe<HubPageContentSliderItemWhereInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileWhereInput>
  HubPageCountdownHero?: InputMaybe<HubPageCountdownHeroWhereInput>
  HubPageHeroSliderItem?: InputMaybe<HubPageHeroSliderItemWhereInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileWhereInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileWhereInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileWhereInput>
  JobListing?: InputMaybe<JobListingWhereInput>
  NewsletterAudience?: InputMaybe<NewsletterAudienceWhereInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersWhereInput>
  SectionContact?: InputMaybe<SectionContactWhereInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableWhereInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterWhereInput>
  SectionHero?: InputMaybe<SectionHeroWhereInput>
  SectionIntro?: InputMaybe<SectionIntroWhereInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsWhereInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterWhereInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaWhereInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersWhereInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereInput>
  SectionTeaser?: InputMaybe<SectionTeaserWhereInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialWhereInput>
  TextMedia?: InputMaybe<TextMediaWhereInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerWhereInput>
}

export type CallToActionParentWhereUniqueInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListWhereUniqueInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroWhereUniqueInput>
  ExplanationStep?: InputMaybe<ExplanationStepWhereUniqueInput>
  HeaderMenuItem?: InputMaybe<HeaderMenuItemWhereUniqueInput>
  HeaderPromo?: InputMaybe<HeaderPromoWhereUniqueInput>
  HubPageContentSliderItem?: InputMaybe<HubPageContentSliderItemWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileWhereUniqueInput>
  HubPageCountdownHero?: InputMaybe<HubPageCountdownHeroWhereUniqueInput>
  HubPageHeroSliderItem?: InputMaybe<HubPageHeroSliderItemWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileWhereUniqueInput>
  JobListing?: InputMaybe<JobListingWhereUniqueInput>
  NewsletterAudience?: InputMaybe<NewsletterAudienceWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactWhereUniqueInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereUniqueInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableWhereUniqueInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroWhereUniqueInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterWhereUniqueInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaWhereUniqueInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserWhereUniqueInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaWhereUniqueInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerWhereUniqueInput>
}

export enum CallToActionSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

export enum CallToActionType {
  Ghost = 'ghost',
  Primary = 'primary',
  Secondary = 'secondary',
  Text = 'text',
}

export type CallToActionUpdateInput = {
  callToActionSemanticButtonSize?: InputMaybe<SemanticButtonSizeEnum>
  callToActionSemanticButtonStyle?: InputMaybe<SemanticButtonStyleEnum>
  color?: InputMaybe<CallToActionColor>
  external?: InputMaybe<Scalars['Boolean']['input']>
  /** label input for default locale (de) */
  label?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<CallToActionUpdateLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  size?: InputMaybe<CallToActionSize>
  target?: InputMaybe<Scalars['String']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<CallToActionType>
  /** url input for default locale (de) */
  url?: InputMaybe<Scalars['String']['input']>
}

export type CallToActionUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type CallToActionUpdateLocalizationInput = {
  data: CallToActionUpdateLocalizationDataInput
  locale: Locale
}

export type CallToActionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CallToActionCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<CallToActionUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<CallToActionUpsertLocalizationInput>>
}

export type CallToActionUpdateManyInlineInput = {
  /** Create and connect multiple CallToAction component instances */
  create?: InputMaybe<Array<CallToActionCreateWithPositionInput>>
  /** Delete multiple CallToAction documents */
  delete?: InputMaybe<Array<CallToActionWhereUniqueInput>>
  /** Update multiple CallToAction component instances */
  update?: InputMaybe<Array<CallToActionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple CallToAction component instances */
  upsert?: InputMaybe<Array<CallToActionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type CallToActionUpdateManyInput = {
  callToActionSemanticButtonSize?: InputMaybe<SemanticButtonSizeEnum>
  callToActionSemanticButtonStyle?: InputMaybe<SemanticButtonStyleEnum>
  color?: InputMaybe<CallToActionColor>
  external?: InputMaybe<Scalars['Boolean']['input']>
  /** label input for default locale (de) */
  label?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<CallToActionUpdateManyLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  size?: InputMaybe<CallToActionSize>
  target?: InputMaybe<Scalars['String']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<CallToActionType>
  /** url input for default locale (de) */
  url?: InputMaybe<Scalars['String']['input']>
}

export type CallToActionUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type CallToActionUpdateManyLocalizationInput = {
  data: CallToActionUpdateManyLocalizationDataInput
  locale: Locale
}

export type CallToActionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CallToActionUpdateManyLocalizationInput>>
}

export type CallToActionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CallToActionUpdateManyInput
  /** Document search */
  where: CallToActionWhereInput
}

export type CallToActionUpdateOneInlineInput = {
  /** Create and connect one CallToAction document */
  create?: InputMaybe<CallToActionCreateInput>
  /** Delete currently connected CallToAction document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single CallToAction document */
  update?: InputMaybe<CallToActionUpdateWithNestedWhereUniqueInput>
  /** Upsert single CallToAction document */
  upsert?: InputMaybe<CallToActionUpsertWithNestedWhereUniqueInput>
}

export type CallToActionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CallToActionUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: CallToActionWhereUniqueInput
}

export type CallToActionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CallToActionUpdateInput
  /** Unique document search */
  where: CallToActionWhereUniqueInput
}

export type CallToActionUpsertInput = {
  /** Create document if it didn't exist */
  create: CallToActionCreateInput
  /** Update document if it exists */
  update: CallToActionUpdateInput
}

export type CallToActionUpsertLocalizationInput = {
  create: CallToActionCreateLocalizationDataInput
  locale: Locale
  update: CallToActionUpdateLocalizationDataInput
}

export type CallToActionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CallToActionUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: CallToActionWhereUniqueInput
}

export type CallToActionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CallToActionUpsertInput
  /** Unique document search */
  where: CallToActionWhereUniqueInput
}

/** Identifies documents */
export type CallToActionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CallToActionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CallToActionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CallToActionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  callToActionSemanticButtonSize?: InputMaybe<SemanticButtonSizeEnum>
  /** All values that are contained in given list. */
  callToActionSemanticButtonSize_in?: InputMaybe<Array<InputMaybe<SemanticButtonSizeEnum>>>
  /** Any other value that exists and is not equal to the given value. */
  callToActionSemanticButtonSize_not?: InputMaybe<SemanticButtonSizeEnum>
  /** All values that are not contained in given list. */
  callToActionSemanticButtonSize_not_in?: InputMaybe<Array<InputMaybe<SemanticButtonSizeEnum>>>
  callToActionSemanticButtonStyle?: InputMaybe<SemanticButtonStyleEnum>
  /** All values that are contained in given list. */
  callToActionSemanticButtonStyle_in?: InputMaybe<Array<InputMaybe<SemanticButtonStyleEnum>>>
  /** Any other value that exists and is not equal to the given value. */
  callToActionSemanticButtonStyle_not?: InputMaybe<SemanticButtonStyleEnum>
  /** All values that are not contained in given list. */
  callToActionSemanticButtonStyle_not_in?: InputMaybe<Array<InputMaybe<SemanticButtonStyleEnum>>>
  color?: InputMaybe<CallToActionColor>
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CallToActionColor>>>
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CallToActionColor>
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CallToActionColor>>>
  external?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  external_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>
  lucideIcon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  lucideIcon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  lucideIcon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  lucideIcon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  size?: InputMaybe<CallToActionSize>
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<CallToActionSize>>>
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<CallToActionSize>
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<CallToActionSize>>>
  target?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  target_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  target_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  target_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  target_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  target_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  target_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  target_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  target_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  target_starts_with?: InputMaybe<Scalars['String']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  trackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  trackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  trackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  trackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  trackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  trackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  trackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  trackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  trackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<CallToActionType>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<CallToActionType>>>
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<CallToActionType>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<CallToActionType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** References CallToAction record uniquely */
export type CallToActionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** OMR Career page to list all career opportunities at OMR */
export type CareerPage = Entity &
  Node & {
    __typename?: 'CareerPage'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<CareerPage>
    /** List of CareerPage versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Identifier of the career page to distinguish it from other career pages */
    identifier: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** List of sections available for the career page. */
    sections: Array<CareerPagesectionsUnion>
    /** Optional configuration to specify page meta tags */
    seoAttributes?: Maybe<Seo>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** OMR Career page to list all career opportunities at OMR */
export type CareerPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** OMR Career page to list all career opportunities at OMR */
export type CareerPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** OMR Career page to list all career opportunities at OMR */
export type CareerPageHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** OMR Career page to list all career opportunities at OMR */
export type CareerPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** OMR Career page to list all career opportunities at OMR */
export type CareerPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** OMR Career page to list all career opportunities at OMR */
export type CareerPageSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

/** OMR Career page to list all career opportunities at OMR */
export type CareerPageSeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** OMR Career page to list all career opportunities at OMR */
export type CareerPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type CareerPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: CareerPageWhereUniqueInput
}

/** A connection to a list of items. */
export type CareerPageConnection = {
  __typename?: 'CareerPageConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<CareerPageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type CareerPageCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  identifier: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CareerPageCreateLocalizationsInput>
  sections?: InputMaybe<CareerPagesectionsUnionCreateManyInlineInput>
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CareerPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CareerPageCreateLocalizationInput = {
  /** Localization input */
  data: CareerPageCreateLocalizationDataInput
  locale: Locale
}

export type CareerPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CareerPageCreateLocalizationInput>>
}

export type CareerPageCreateManyInlineInput = {
  /** Connect multiple existing CareerPage documents */
  connect?: InputMaybe<Array<CareerPageWhereUniqueInput>>
  /** Create and connect multiple existing CareerPage documents */
  create?: InputMaybe<Array<CareerPageCreateInput>>
}

export type CareerPageCreateOneInlineInput = {
  /** Connect one existing CareerPage document */
  connect?: InputMaybe<CareerPageWhereUniqueInput>
  /** Create and connect one CareerPage document */
  create?: InputMaybe<CareerPageCreateInput>
}

/** An edge in a connection. */
export type CareerPageEdge = {
  __typename?: 'CareerPageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: CareerPage
}

/** Identifies documents */
export type CareerPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CareerPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CareerPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CareerPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<CareerPageWhereStageInput>
  documentInStages_none?: InputMaybe<CareerPageWhereStageInput>
  documentInStages_some?: InputMaybe<CareerPageWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  identifier_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  identifier_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  identifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  identifier_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  identifier_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  identifier_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  identifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  identifier_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  identifier_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  /** All values in which the union is empty. */
  sections_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  sections_some?: InputMaybe<CareerPagesectionsUnionWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum CareerPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Careers List for Career Pages */
export type CareerPageSectionCareersList = Entity & {
  __typename?: 'CareerPageSectionCareersList'
  cta?: Maybe<CallToAction>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<CareerPageSectionCareersList>
  maxJobListings?: Maybe<Scalars['Int']['output']>
  showFilter?: Maybe<Scalars['Boolean']['output']>
  showPagination?: Maybe<Scalars['Boolean']['output']>
  /** System stage field */
  stage: Stage
  /** Title for Career Hero */
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Careers List for Career Pages */
export type CareerPageSectionCareersListCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Careers List for Career Pages */
export type CareerPageSectionCareersListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Careers List for Career Pages */
export type CareerPageSectionCareersListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type CareerPageSectionCareersListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: CareerPageSectionCareersListWhereUniqueInput
}

/** A connection to a list of items. */
export type CareerPageSectionCareersListConnection = {
  __typename?: 'CareerPageSectionCareersListConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<CareerPageSectionCareersListEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type CareerPageSectionCareersListCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CareerPageSectionCareersListCreateLocalizationsInput>
  maxJobListings?: InputMaybe<Scalars['Int']['input']>
  showFilter?: InputMaybe<Scalars['Boolean']['input']>
  showPagination?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CareerPageSectionCareersListCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CareerPageSectionCareersListCreateLocalizationInput = {
  /** Localization input */
  data: CareerPageSectionCareersListCreateLocalizationDataInput
  locale: Locale
}

export type CareerPageSectionCareersListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CareerPageSectionCareersListCreateLocalizationInput>>
}

export type CareerPageSectionCareersListCreateManyInlineInput = {
  /** Create and connect multiple existing CareerPageSectionCareersList documents */
  create?: InputMaybe<Array<CareerPageSectionCareersListCreateInput>>
}

export type CareerPageSectionCareersListCreateOneInlineInput = {
  /** Create and connect one CareerPageSectionCareersList document */
  create?: InputMaybe<CareerPageSectionCareersListCreateInput>
}

export type CareerPageSectionCareersListCreateWithPositionInput = {
  /** Document to create */
  data: CareerPageSectionCareersListCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type CareerPageSectionCareersListEdge = {
  __typename?: 'CareerPageSectionCareersListEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: CareerPageSectionCareersList
}

/** Identifies documents */
export type CareerPageSectionCareersListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CareerPageSectionCareersListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CareerPageSectionCareersListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CareerPageSectionCareersListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  maxJobListings?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  maxJobListings_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  maxJobListings_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  maxJobListings_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  maxJobListings_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  maxJobListings_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  maxJobListings_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  maxJobListings_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  showFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  showPagination?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showPagination_not?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum CareerPageSectionCareersListOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MaxJobListingsAsc = 'maxJobListings_ASC',
  MaxJobListingsDesc = 'maxJobListings_DESC',
  ShowFilterAsc = 'showFilter_ASC',
  ShowFilterDesc = 'showFilter_DESC',
  ShowPaginationAsc = 'showPagination_ASC',
  ShowPaginationDesc = 'showPagination_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type CareerPageSectionCareersListParent = CareerPage

export type CareerPageSectionCareersListParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
}

export type CareerPageSectionCareersListParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
}

export type CareerPageSectionCareersListParentCreateManyInlineInput = {
  /** Connect multiple existing CareerPageSectionCareersListParent documents */
  connect?: InputMaybe<Array<CareerPageSectionCareersListParentWhereUniqueInput>>
  /** Create and connect multiple existing CareerPageSectionCareersListParent documents */
  create?: InputMaybe<Array<CareerPageSectionCareersListParentCreateInput>>
}

export type CareerPageSectionCareersListParentCreateOneInlineInput = {
  /** Connect one existing CareerPageSectionCareersListParent document */
  connect?: InputMaybe<CareerPageSectionCareersListParentWhereUniqueInput>
  /** Create and connect one CareerPageSectionCareersListParent document */
  create?: InputMaybe<CareerPageSectionCareersListParentCreateInput>
}

export type CareerPageSectionCareersListParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
}

export type CareerPageSectionCareersListParentUpdateManyInlineInput = {
  /** Connect multiple existing CareerPageSectionCareersListParent documents */
  connect?: InputMaybe<Array<CareerPageSectionCareersListParentConnectInput>>
  /** Create and connect multiple CareerPageSectionCareersListParent documents */
  create?: InputMaybe<Array<CareerPageSectionCareersListParentCreateInput>>
  /** Delete multiple CareerPageSectionCareersListParent documents */
  delete?: InputMaybe<Array<CareerPageSectionCareersListParentWhereUniqueInput>>
  /** Disconnect multiple CareerPageSectionCareersListParent documents */
  disconnect?: InputMaybe<Array<CareerPageSectionCareersListParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing CareerPageSectionCareersListParent documents */
  set?: InputMaybe<Array<CareerPageSectionCareersListParentWhereUniqueInput>>
  /** Update multiple CareerPageSectionCareersListParent documents */
  update?: InputMaybe<Array<CareerPageSectionCareersListParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple CareerPageSectionCareersListParent documents */
  upsert?: InputMaybe<Array<CareerPageSectionCareersListParentUpsertWithNestedWhereUniqueInput>>
}

export type CareerPageSectionCareersListParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
}

export type CareerPageSectionCareersListParentUpdateOneInlineInput = {
  /** Connect existing CareerPageSectionCareersListParent document */
  connect?: InputMaybe<CareerPageSectionCareersListParentWhereUniqueInput>
  /** Create and connect one CareerPageSectionCareersListParent document */
  create?: InputMaybe<CareerPageSectionCareersListParentCreateInput>
  /** Delete currently connected CareerPageSectionCareersListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected CareerPageSectionCareersListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single CareerPageSectionCareersListParent document */
  update?: InputMaybe<CareerPageSectionCareersListParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single CareerPageSectionCareersListParent document */
  upsert?: InputMaybe<CareerPageSectionCareersListParentUpsertWithNestedWhereUniqueInput>
}

export type CareerPageSectionCareersListParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
}

export type CareerPageSectionCareersListParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
}

export type CareerPageSectionCareersListParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
}

export type CareerPageSectionCareersListParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
}

export type CareerPageSectionCareersListUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<CareerPageSectionCareersListUpdateLocalizationsInput>
  maxJobListings?: InputMaybe<Scalars['Int']['input']>
  showFilter?: InputMaybe<Scalars['Boolean']['input']>
  showPagination?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageSectionCareersListUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageSectionCareersListUpdateLocalizationInput = {
  data: CareerPageSectionCareersListUpdateLocalizationDataInput
  locale: Locale
}

export type CareerPageSectionCareersListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CareerPageSectionCareersListCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<CareerPageSectionCareersListUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<CareerPageSectionCareersListUpsertLocalizationInput>>
}

export type CareerPageSectionCareersListUpdateManyInlineInput = {
  /** Create and connect multiple CareerPageSectionCareersList component instances */
  create?: InputMaybe<Array<CareerPageSectionCareersListCreateWithPositionInput>>
  /** Delete multiple CareerPageSectionCareersList documents */
  delete?: InputMaybe<Array<CareerPageSectionCareersListWhereUniqueInput>>
  /** Update multiple CareerPageSectionCareersList component instances */
  update?: InputMaybe<Array<CareerPageSectionCareersListUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple CareerPageSectionCareersList component instances */
  upsert?: InputMaybe<Array<CareerPageSectionCareersListUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type CareerPageSectionCareersListUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<CareerPageSectionCareersListUpdateManyLocalizationsInput>
  maxJobListings?: InputMaybe<Scalars['Int']['input']>
  showFilter?: InputMaybe<Scalars['Boolean']['input']>
  showPagination?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageSectionCareersListUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageSectionCareersListUpdateManyLocalizationInput = {
  data: CareerPageSectionCareersListUpdateManyLocalizationDataInput
  locale: Locale
}

export type CareerPageSectionCareersListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CareerPageSectionCareersListUpdateManyLocalizationInput>>
}

export type CareerPageSectionCareersListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CareerPageSectionCareersListUpdateManyInput
  /** Document search */
  where: CareerPageSectionCareersListWhereInput
}

export type CareerPageSectionCareersListUpdateOneInlineInput = {
  /** Create and connect one CareerPageSectionCareersList document */
  create?: InputMaybe<CareerPageSectionCareersListCreateInput>
  /** Delete currently connected CareerPageSectionCareersList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single CareerPageSectionCareersList document */
  update?: InputMaybe<CareerPageSectionCareersListUpdateWithNestedWhereUniqueInput>
  /** Upsert single CareerPageSectionCareersList document */
  upsert?: InputMaybe<CareerPageSectionCareersListUpsertWithNestedWhereUniqueInput>
}

export type CareerPageSectionCareersListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CareerPageSectionCareersListUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: CareerPageSectionCareersListWhereUniqueInput
}

export type CareerPageSectionCareersListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CareerPageSectionCareersListUpdateInput
  /** Unique document search */
  where: CareerPageSectionCareersListWhereUniqueInput
}

export type CareerPageSectionCareersListUpsertInput = {
  /** Create document if it didn't exist */
  create: CareerPageSectionCareersListCreateInput
  /** Update document if it exists */
  update: CareerPageSectionCareersListUpdateInput
}

export type CareerPageSectionCareersListUpsertLocalizationInput = {
  create: CareerPageSectionCareersListCreateLocalizationDataInput
  locale: Locale
  update: CareerPageSectionCareersListUpdateLocalizationDataInput
}

export type CareerPageSectionCareersListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CareerPageSectionCareersListUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: CareerPageSectionCareersListWhereUniqueInput
}

export type CareerPageSectionCareersListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CareerPageSectionCareersListUpsertInput
  /** Unique document search */
  where: CareerPageSectionCareersListWhereUniqueInput
}

/** Identifies documents */
export type CareerPageSectionCareersListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CareerPageSectionCareersListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CareerPageSectionCareersListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CareerPageSectionCareersListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  maxJobListings?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  maxJobListings_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  maxJobListings_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  maxJobListings_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  maxJobListings_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  maxJobListings_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  maxJobListings_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  maxJobListings_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  showFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  showPagination?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showPagination_not?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References CareerPageSectionCareersList record uniquely */
export type CareerPageSectionCareersListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Hero Section for Career Pages */
export type CareerPageSectionHero = Entity & {
  __typename?: 'CareerPageSectionHero'
  cta?: Maybe<CallToAction>
  /** Decoration for Career Hero */
  decoration?: Maybe<Asset>
  /** Last word of the Home Page Hero, or the whole title for subpages */
  highlightedTitle?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Image for Career Hero, will be used for 50% image on main page, or full width background on subpages */
  image: Asset
  isSubpageHero?: Maybe<Scalars['Boolean']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<CareerPageSectionHero>
  /** System stage field */
  stage: Stage
  /** Career hero intro text */
  subtitle?: Maybe<Scalars['String']['output']>
  /** Title for Career Hero */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Hero Section for Career Pages */
export type CareerPageSectionHeroCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero Section for Career Pages */
export type CareerPageSectionHeroDecorationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Hero Section for Career Pages */
export type CareerPageSectionHeroImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Hero Section for Career Pages */
export type CareerPageSectionHeroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Hero Section for Career Pages */
export type CareerPageSectionHeroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type CareerPageSectionHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: CareerPageSectionHeroWhereUniqueInput
}

/** A connection to a list of items. */
export type CareerPageSectionHeroConnection = {
  __typename?: 'CareerPageSectionHeroConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<CareerPageSectionHeroEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type CareerPageSectionHeroCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  decoration?: InputMaybe<AssetCreateOneInlineInput>
  /** highlightedTitle input for default locale (de) */
  highlightedTitle?: InputMaybe<Scalars['String']['input']>
  image: AssetCreateOneInlineInput
  isSubpageHero?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CareerPageSectionHeroCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CareerPageSectionHeroCreateLocalizationDataInput = {
  highlightedTitle?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CareerPageSectionHeroCreateLocalizationInput = {
  /** Localization input */
  data: CareerPageSectionHeroCreateLocalizationDataInput
  locale: Locale
}

export type CareerPageSectionHeroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CareerPageSectionHeroCreateLocalizationInput>>
}

export type CareerPageSectionHeroCreateManyInlineInput = {
  /** Create and connect multiple existing CareerPageSectionHero documents */
  create?: InputMaybe<Array<CareerPageSectionHeroCreateInput>>
}

export type CareerPageSectionHeroCreateOneInlineInput = {
  /** Create and connect one CareerPageSectionHero document */
  create?: InputMaybe<CareerPageSectionHeroCreateInput>
}

export type CareerPageSectionHeroCreateWithPositionInput = {
  /** Document to create */
  data: CareerPageSectionHeroCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type CareerPageSectionHeroEdge = {
  __typename?: 'CareerPageSectionHeroEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: CareerPageSectionHero
}

/** Identifies documents */
export type CareerPageSectionHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CareerPageSectionHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CareerPageSectionHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CareerPageSectionHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  decoration?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  isSubpageHero?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isSubpageHero_not?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum CareerPageSectionHeroOrderByInput {
  HighlightedTitleAsc = 'highlightedTitle_ASC',
  HighlightedTitleDesc = 'highlightedTitle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsSubpageHeroAsc = 'isSubpageHero_ASC',
  IsSubpageHeroDesc = 'isSubpageHero_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type CareerPageSectionHeroParent = CareerPage

export type CareerPageSectionHeroParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
}

export type CareerPageSectionHeroParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
}

export type CareerPageSectionHeroParentCreateManyInlineInput = {
  /** Connect multiple existing CareerPageSectionHeroParent documents */
  connect?: InputMaybe<Array<CareerPageSectionHeroParentWhereUniqueInput>>
  /** Create and connect multiple existing CareerPageSectionHeroParent documents */
  create?: InputMaybe<Array<CareerPageSectionHeroParentCreateInput>>
}

export type CareerPageSectionHeroParentCreateOneInlineInput = {
  /** Connect one existing CareerPageSectionHeroParent document */
  connect?: InputMaybe<CareerPageSectionHeroParentWhereUniqueInput>
  /** Create and connect one CareerPageSectionHeroParent document */
  create?: InputMaybe<CareerPageSectionHeroParentCreateInput>
}

export type CareerPageSectionHeroParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
}

export type CareerPageSectionHeroParentUpdateManyInlineInput = {
  /** Connect multiple existing CareerPageSectionHeroParent documents */
  connect?: InputMaybe<Array<CareerPageSectionHeroParentConnectInput>>
  /** Create and connect multiple CareerPageSectionHeroParent documents */
  create?: InputMaybe<Array<CareerPageSectionHeroParentCreateInput>>
  /** Delete multiple CareerPageSectionHeroParent documents */
  delete?: InputMaybe<Array<CareerPageSectionHeroParentWhereUniqueInput>>
  /** Disconnect multiple CareerPageSectionHeroParent documents */
  disconnect?: InputMaybe<Array<CareerPageSectionHeroParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing CareerPageSectionHeroParent documents */
  set?: InputMaybe<Array<CareerPageSectionHeroParentWhereUniqueInput>>
  /** Update multiple CareerPageSectionHeroParent documents */
  update?: InputMaybe<Array<CareerPageSectionHeroParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple CareerPageSectionHeroParent documents */
  upsert?: InputMaybe<Array<CareerPageSectionHeroParentUpsertWithNestedWhereUniqueInput>>
}

export type CareerPageSectionHeroParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
}

export type CareerPageSectionHeroParentUpdateOneInlineInput = {
  /** Connect existing CareerPageSectionHeroParent document */
  connect?: InputMaybe<CareerPageSectionHeroParentWhereUniqueInput>
  /** Create and connect one CareerPageSectionHeroParent document */
  create?: InputMaybe<CareerPageSectionHeroParentCreateInput>
  /** Delete currently connected CareerPageSectionHeroParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected CareerPageSectionHeroParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single CareerPageSectionHeroParent document */
  update?: InputMaybe<CareerPageSectionHeroParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single CareerPageSectionHeroParent document */
  upsert?: InputMaybe<CareerPageSectionHeroParentUpsertWithNestedWhereUniqueInput>
}

export type CareerPageSectionHeroParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
}

export type CareerPageSectionHeroParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
}

export type CareerPageSectionHeroParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
}

export type CareerPageSectionHeroParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
}

export type CareerPageSectionHeroUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  decoration?: InputMaybe<AssetUpdateOneInlineInput>
  /** highlightedTitle input for default locale (de) */
  highlightedTitle?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  isSubpageHero?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<CareerPageSectionHeroUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageSectionHeroUpdateLocalizationDataInput = {
  highlightedTitle?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageSectionHeroUpdateLocalizationInput = {
  data: CareerPageSectionHeroUpdateLocalizationDataInput
  locale: Locale
}

export type CareerPageSectionHeroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CareerPageSectionHeroCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<CareerPageSectionHeroUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<CareerPageSectionHeroUpsertLocalizationInput>>
}

export type CareerPageSectionHeroUpdateManyInlineInput = {
  /** Create and connect multiple CareerPageSectionHero component instances */
  create?: InputMaybe<Array<CareerPageSectionHeroCreateWithPositionInput>>
  /** Delete multiple CareerPageSectionHero documents */
  delete?: InputMaybe<Array<CareerPageSectionHeroWhereUniqueInput>>
  /** Update multiple CareerPageSectionHero component instances */
  update?: InputMaybe<Array<CareerPageSectionHeroUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple CareerPageSectionHero component instances */
  upsert?: InputMaybe<Array<CareerPageSectionHeroUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type CareerPageSectionHeroUpdateManyInput = {
  /** highlightedTitle input for default locale (de) */
  highlightedTitle?: InputMaybe<Scalars['String']['input']>
  isSubpageHero?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<CareerPageSectionHeroUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageSectionHeroUpdateManyLocalizationDataInput = {
  highlightedTitle?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageSectionHeroUpdateManyLocalizationInput = {
  data: CareerPageSectionHeroUpdateManyLocalizationDataInput
  locale: Locale
}

export type CareerPageSectionHeroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CareerPageSectionHeroUpdateManyLocalizationInput>>
}

export type CareerPageSectionHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CareerPageSectionHeroUpdateManyInput
  /** Document search */
  where: CareerPageSectionHeroWhereInput
}

export type CareerPageSectionHeroUpdateOneInlineInput = {
  /** Create and connect one CareerPageSectionHero document */
  create?: InputMaybe<CareerPageSectionHeroCreateInput>
  /** Delete currently connected CareerPageSectionHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single CareerPageSectionHero document */
  update?: InputMaybe<CareerPageSectionHeroUpdateWithNestedWhereUniqueInput>
  /** Upsert single CareerPageSectionHero document */
  upsert?: InputMaybe<CareerPageSectionHeroUpsertWithNestedWhereUniqueInput>
}

export type CareerPageSectionHeroUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CareerPageSectionHeroUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: CareerPageSectionHeroWhereUniqueInput
}

export type CareerPageSectionHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CareerPageSectionHeroUpdateInput
  /** Unique document search */
  where: CareerPageSectionHeroWhereUniqueInput
}

export type CareerPageSectionHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: CareerPageSectionHeroCreateInput
  /** Update document if it exists */
  update: CareerPageSectionHeroUpdateInput
}

export type CareerPageSectionHeroUpsertLocalizationInput = {
  create: CareerPageSectionHeroCreateLocalizationDataInput
  locale: Locale
  update: CareerPageSectionHeroUpdateLocalizationDataInput
}

export type CareerPageSectionHeroUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CareerPageSectionHeroUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: CareerPageSectionHeroWhereUniqueInput
}

export type CareerPageSectionHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CareerPageSectionHeroUpsertInput
  /** Unique document search */
  where: CareerPageSectionHeroWhereUniqueInput
}

/** Identifies documents */
export type CareerPageSectionHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CareerPageSectionHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CareerPageSectionHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CareerPageSectionHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  decoration?: InputMaybe<AssetWhereInput>
  highlightedTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  highlightedTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  highlightedTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  highlightedTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  highlightedTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  highlightedTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  highlightedTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  highlightedTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  highlightedTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  highlightedTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  isSubpageHero?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isSubpageHero_not?: InputMaybe<Scalars['Boolean']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References CareerPageSectionHero record uniquely */
export type CareerPageSectionHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type CareerPageUpdateInput = {
  identifier?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<CareerPageUpdateLocalizationsInput>
  sections?: InputMaybe<CareerPagesectionsUnionUpdateManyInlineInput>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
}

export type CareerPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CareerPageCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
}

export type CareerPageUpdateManyInlineInput = {
  /** Connect multiple existing CareerPage documents */
  connect?: InputMaybe<Array<CareerPageConnectInput>>
  /** Create and connect multiple CareerPage documents */
  create?: InputMaybe<Array<CareerPageCreateInput>>
  /** Delete multiple CareerPage documents */
  delete?: InputMaybe<Array<CareerPageWhereUniqueInput>>
  /** Disconnect multiple CareerPage documents */
  disconnect?: InputMaybe<Array<CareerPageWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing CareerPage documents */
  set?: InputMaybe<Array<CareerPageWhereUniqueInput>>
  /** Update multiple CareerPage documents */
  update?: InputMaybe<Array<CareerPageUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple CareerPage documents */
  upsert?: InputMaybe<Array<CareerPageUpsertWithNestedWhereUniqueInput>>
}

export type CareerPageUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type CareerPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CareerPageUpdateManyInput
  /** Document search */
  where: CareerPageWhereInput
}

export type CareerPageUpdateOneInlineInput = {
  /** Connect existing CareerPage document */
  connect?: InputMaybe<CareerPageWhereUniqueInput>
  /** Create and connect one CareerPage document */
  create?: InputMaybe<CareerPageCreateInput>
  /** Delete currently connected CareerPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected CareerPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single CareerPage document */
  update?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  /** Upsert single CareerPage document */
  upsert?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
}

export type CareerPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CareerPageUpdateInput
  /** Unique document search */
  where: CareerPageWhereUniqueInput
}

export type CareerPageUpsertInput = {
  /** Create document if it didn't exist */
  create: CareerPageCreateInput
  /** Update document if it exists */
  update: CareerPageUpdateInput
}

export type CareerPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CareerPageUpsertInput
  /** Unique document search */
  where: CareerPageWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type CareerPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type CareerPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CareerPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CareerPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CareerPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<CareerPageWhereStageInput>
  documentInStages_none?: InputMaybe<CareerPageWhereStageInput>
  documentInStages_some?: InputMaybe<CareerPageWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  identifier_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  identifier_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  identifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  identifier_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  identifier_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  identifier_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  identifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  identifier_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  identifier_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  /** All values in which the union is empty. */
  sections_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  sections_some?: InputMaybe<CareerPagesectionsUnionWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CareerPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CareerPageWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CareerPageWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CareerPageWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CareerPageWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References CareerPage record uniquely */
export type CareerPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
}

export type CareerPagesectionsUnion =
  | CareerPageSectionCareersList
  | CareerPageSectionHero
  | Faq
  | RichContent
  | SectionContact
  | SectionCta
  | SectionExplanationBlocks
  | SectionImageSlider
  | SectionIntro
  | SectionStyledHero
  | SectionTeaser
  | SectionVideo
  | TextMedia

export type CareerPagesectionsUnionConnectInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListConnectInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroConnectInput>
  Faq?: InputMaybe<FaqConnectInput>
  RichContent?: InputMaybe<RichContentConnectInput>
  SectionContact?: InputMaybe<SectionContactConnectInput>
  SectionCta?: InputMaybe<SectionCtaConnectInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksConnectInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderConnectInput>
  SectionIntro?: InputMaybe<SectionIntroConnectInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroConnectInput>
  SectionTeaser?: InputMaybe<SectionTeaserConnectInput>
  SectionVideo?: InputMaybe<SectionVideoConnectInput>
  TextMedia?: InputMaybe<TextMediaConnectInput>
}

export type CareerPagesectionsUnionCreateInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListCreateInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroCreateInput>
  Faq?: InputMaybe<FaqCreateInput>
  RichContent?: InputMaybe<RichContentCreateInput>
  SectionContact?: InputMaybe<SectionContactCreateInput>
  SectionCta?: InputMaybe<SectionCtaCreateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderCreateInput>
  SectionIntro?: InputMaybe<SectionIntroCreateInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateInput>
  SectionTeaser?: InputMaybe<SectionTeaserCreateInput>
  SectionVideo?: InputMaybe<SectionVideoCreateInput>
  TextMedia?: InputMaybe<TextMediaCreateInput>
}

export type CareerPagesectionsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CareerPagesectionsUnion documents */
  create?: InputMaybe<Array<CareerPagesectionsUnionCreateInput>>
}

export type CareerPagesectionsUnionCreateOneInlineInput = {
  /** Create and connect one CareerPagesectionsUnion document */
  create?: InputMaybe<CareerPagesectionsUnionCreateInput>
}

export type CareerPagesectionsUnionCreateWithPositionInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListCreateWithPositionInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroCreateWithPositionInput>
  Faq?: InputMaybe<FaqCreateWithPositionInput>
  RichContent?: InputMaybe<RichContentCreateWithPositionInput>
  SectionContact?: InputMaybe<SectionContactCreateWithPositionInput>
  SectionCta?: InputMaybe<SectionCtaCreateWithPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateWithPositionInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderCreateWithPositionInput>
  SectionIntro?: InputMaybe<SectionIntroCreateWithPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateWithPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserCreateWithPositionInput>
  SectionVideo?: InputMaybe<SectionVideoCreateWithPositionInput>
  TextMedia?: InputMaybe<TextMediaCreateWithPositionInput>
}

export type CareerPagesectionsUnionUpdateInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpdateInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpdateInput>
  Faq?: InputMaybe<FaqUpdateInput>
  RichContent?: InputMaybe<RichContentUpdateInput>
  SectionContact?: InputMaybe<SectionContactUpdateInput>
  SectionCta?: InputMaybe<SectionCtaUpdateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpdateInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateInput>
  TextMedia?: InputMaybe<TextMediaUpdateInput>
}

export type CareerPagesectionsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CareerPagesectionsUnion component instances */
  create?: InputMaybe<Array<CareerPagesectionsUnionCreateWithPositionInput>>
  /** Delete multiple CareerPagesectionsUnion documents */
  delete?: InputMaybe<Array<CareerPagesectionsUnionWhereUniqueInput>>
  /** Update multiple CareerPagesectionsUnion component instances */
  update?: InputMaybe<Array<CareerPagesectionsUnionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple CareerPagesectionsUnion component instances */
  upsert?: InputMaybe<Array<CareerPagesectionsUnionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type CareerPagesectionsUnionUpdateManyWithNestedWhereInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpdateManyWithNestedWhereInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpdateManyWithNestedWhereInput>
  Faq?: InputMaybe<FaqUpdateManyWithNestedWhereInput>
  RichContent?: InputMaybe<RichContentUpdateManyWithNestedWhereInput>
  SectionContact?: InputMaybe<SectionContactUpdateManyWithNestedWhereInput>
  SectionCta?: InputMaybe<SectionCtaUpdateManyWithNestedWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateManyWithNestedWhereInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpdateManyWithNestedWhereInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateManyWithNestedWhereInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateManyWithNestedWhereInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateManyWithNestedWhereInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateManyWithNestedWhereInput>
  TextMedia?: InputMaybe<TextMediaUpdateManyWithNestedWhereInput>
}

export type CareerPagesectionsUnionUpdateOneInlineInput = {
  /** Create and connect one CareerPagesectionsUnion document */
  create?: InputMaybe<CareerPagesectionsUnionCreateInput>
  /** Delete currently connected CareerPagesectionsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single CareerPagesectionsUnion document */
  update?: InputMaybe<CareerPagesectionsUnionUpdateWithNestedWhereUniqueInput>
  /** Upsert single CareerPagesectionsUnion document */
  upsert?: InputMaybe<CareerPagesectionsUnionUpsertWithNestedWhereUniqueInput>
}

export type CareerPagesectionsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpdateWithNestedWhereUniqueAndPositionInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpdateWithNestedWhereUniqueAndPositionInput>
  Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueAndPositionInput>
  RichContent?: InputMaybe<RichContentUpdateWithNestedWhereUniqueAndPositionInput>
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueAndPositionInput>
  SectionCta?: InputMaybe<SectionCtaUpdateWithNestedWhereUniqueAndPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueAndPositionInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpdateWithNestedWhereUniqueAndPositionInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateWithNestedWhereUniqueAndPositionInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateWithNestedWhereUniqueAndPositionInput>
  TextMedia?: InputMaybe<TextMediaUpdateWithNestedWhereUniqueAndPositionInput>
}

export type CareerPagesectionsUnionUpdateWithNestedWhereUniqueInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpdateWithNestedWhereUniqueInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpdateWithNestedWhereUniqueInput>
  Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>
  RichContent?: InputMaybe<RichContentUpdateWithNestedWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaUpdateWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpdateWithNestedWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateWithNestedWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateWithNestedWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateWithNestedWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaUpdateWithNestedWhereUniqueInput>
}

export type CareerPagesectionsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpsertWithNestedWhereUniqueAndPositionInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpsertWithNestedWhereUniqueAndPositionInput>
  Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueAndPositionInput>
  RichContent?: InputMaybe<RichContentUpsertWithNestedWhereUniqueAndPositionInput>
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueAndPositionInput>
  SectionCta?: InputMaybe<SectionCtaUpsertWithNestedWhereUniqueAndPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueAndPositionInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpsertWithNestedWhereUniqueAndPositionInput>
  SectionIntro?: InputMaybe<SectionIntroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpsertWithNestedWhereUniqueAndPositionInput>
  SectionVideo?: InputMaybe<SectionVideoUpsertWithNestedWhereUniqueAndPositionInput>
  TextMedia?: InputMaybe<TextMediaUpsertWithNestedWhereUniqueAndPositionInput>
}

export type CareerPagesectionsUnionUpsertWithNestedWhereUniqueInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListUpsertWithNestedWhereUniqueInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroUpsertWithNestedWhereUniqueInput>
  Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>
  RichContent?: InputMaybe<RichContentUpsertWithNestedWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaUpsertWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpsertWithNestedWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroUpsertWithNestedWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpsertWithNestedWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoUpsertWithNestedWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaUpsertWithNestedWhereUniqueInput>
}

export type CareerPagesectionsUnionWhereInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListWhereInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroWhereInput>
  Faq?: InputMaybe<FaqWhereInput>
  RichContent?: InputMaybe<RichContentWhereInput>
  SectionContact?: InputMaybe<SectionContactWhereInput>
  SectionCta?: InputMaybe<SectionCtaWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderWhereInput>
  SectionIntro?: InputMaybe<SectionIntroWhereInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereInput>
  SectionTeaser?: InputMaybe<SectionTeaserWhereInput>
  SectionVideo?: InputMaybe<SectionVideoWhereInput>
  TextMedia?: InputMaybe<TextMediaWhereInput>
}

export type CareerPagesectionsUnionWhereUniqueInput = {
  CareerPageSectionCareersList?: InputMaybe<CareerPageSectionCareersListWhereUniqueInput>
  CareerPageSectionHero?: InputMaybe<CareerPageSectionHeroWhereUniqueInput>
  Faq?: InputMaybe<FaqWhereUniqueInput>
  RichContent?: InputMaybe<RichContentWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereUniqueInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaWhereUniqueInput>
}

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color'
  css: Scalars['String']['output']
  hex: Scalars['Hex']['output']
  rgba: Rgba
}

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>
  rgba?: InputMaybe<RgbaInput>
}

/** How many columns should the layout have in desktop mode, how it breaks down on mobile will be handled in the individual component */
export enum ColumnLayout {
  Four = 'four',
  Six = 'six',
  Three = 'three',
}

export enum ComponentStyle {
  Black = 'black',
  Blank = 'blank',
  Grey = 'grey',
  Purple = 'purple',
  White = 'white',
  Yellow = 'yellow',
}

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>
}

export type Contact = Entity & {
  __typename?: 'Contact'
  /** Enable icons for contact details (phone and email). */
  contactIcons?: Maybe<Scalars['Boolean']['output']>
  contactPhoto: Asset
  /** Defines a decoration pattern to use with the component it is used for. */
  decorationPattern?: Maybe<DecorationPattern>
  department?: Maybe<Scalars['String']['output']>
  departmentUrl?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  email?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<Contact>
  phone?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ContactContactPhotoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type ContactLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type ContactUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ContactConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ContactWhereUniqueInput
}

/** A connection to a list of items. */
export type ContactConnection = {
  __typename?: 'ContactConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ContactEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ContactCreateInput = {
  contactIcons?: InputMaybe<Scalars['Boolean']['input']>
  contactPhoto: AssetCreateOneInlineInput
  decorationPattern?: InputMaybe<DecorationPattern>
  /** department input for default locale (de) */
  department?: InputMaybe<Scalars['String']['input']>
  /** departmentUrl input for default locale (de) */
  departmentUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  email?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ContactCreateLocalizationsInput>
  phone?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ContactCreateLocalizationDataInput = {
  department?: InputMaybe<Scalars['String']['input']>
  departmentUrl?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ContactCreateLocalizationInput = {
  /** Localization input */
  data: ContactCreateLocalizationDataInput
  locale: Locale
}

export type ContactCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ContactCreateLocalizationInput>>
}

export type ContactCreateManyInlineInput = {
  /** Create and connect multiple existing Contact documents */
  create?: InputMaybe<Array<ContactCreateInput>>
}

export type ContactCreateOneInlineInput = {
  /** Create and connect one Contact document */
  create?: InputMaybe<ContactCreateInput>
}

export type ContactCreateWithPositionInput = {
  /** Document to create */
  data: ContactCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type ContactEdge = {
  __typename?: 'ContactEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Contact
}

/** Identifies documents */
export type ContactManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  contactIcons?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  contactIcons_not?: InputMaybe<Scalars['Boolean']['input']>
  contactPhoto?: InputMaybe<AssetWhereInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  email?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  phone_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  phone_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  phone_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  phone_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  phone_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  phone_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  phone_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum ContactOrderByInput {
  ContactIconsAsc = 'contactIcons_ASC',
  ContactIconsDesc = 'contactIcons_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DepartmentUrlAsc = 'departmentUrl_ASC',
  DepartmentUrlDesc = 'departmentUrl_DESC',
  DepartmentAsc = 'department_ASC',
  DepartmentDesc = 'department_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ContactParent = SectionContact

export type ContactParentConnectInput = {
  SectionContact?: InputMaybe<SectionContactConnectInput>
}

export type ContactParentCreateInput = {
  SectionContact?: InputMaybe<SectionContactCreateInput>
}

export type ContactParentCreateManyInlineInput = {
  /** Create and connect multiple existing ContactParent documents */
  create?: InputMaybe<Array<ContactParentCreateInput>>
}

export type ContactParentCreateOneInlineInput = {
  /** Create and connect one ContactParent document */
  create?: InputMaybe<ContactParentCreateInput>
}

export type ContactParentCreateWithPositionInput = {
  SectionContact?: InputMaybe<SectionContactCreateWithPositionInput>
}

export type ContactParentUpdateInput = {
  SectionContact?: InputMaybe<SectionContactUpdateInput>
}

export type ContactParentUpdateManyInlineInput = {
  /** Create and connect multiple ContactParent component instances */
  create?: InputMaybe<Array<ContactParentCreateWithPositionInput>>
  /** Delete multiple ContactParent documents */
  delete?: InputMaybe<Array<ContactParentWhereUniqueInput>>
  /** Update multiple ContactParent component instances */
  update?: InputMaybe<Array<ContactParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple ContactParent component instances */
  upsert?: InputMaybe<Array<ContactParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type ContactParentUpdateManyWithNestedWhereInput = {
  SectionContact?: InputMaybe<SectionContactUpdateManyWithNestedWhereInput>
}

export type ContactParentUpdateOneInlineInput = {
  /** Create and connect one ContactParent document */
  create?: InputMaybe<ContactParentCreateInput>
  /** Delete currently connected ContactParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ContactParent document */
  update?: InputMaybe<ContactParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single ContactParent document */
  upsert?: InputMaybe<ContactParentUpsertWithNestedWhereUniqueInput>
}

export type ContactParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueAndPositionInput>
}

export type ContactParentUpdateWithNestedWhereUniqueInput = {
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueInput>
}

export type ContactParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueAndPositionInput>
}

export type ContactParentUpsertWithNestedWhereUniqueInput = {
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueInput>
}

export type ContactParentWhereInput = {
  SectionContact?: InputMaybe<SectionContactWhereInput>
}

export type ContactParentWhereUniqueInput = {
  SectionContact?: InputMaybe<SectionContactWhereUniqueInput>
}

export type ContactUpdateInput = {
  contactIcons?: InputMaybe<Scalars['Boolean']['input']>
  contactPhoto?: InputMaybe<AssetUpdateOneInlineInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** department input for default locale (de) */
  department?: InputMaybe<Scalars['String']['input']>
  /** departmentUrl input for default locale (de) */
  departmentUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ContactUpdateLocalizationsInput>
  phone?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ContactUpdateLocalizationDataInput = {
  department?: InputMaybe<Scalars['String']['input']>
  departmentUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ContactUpdateLocalizationInput = {
  data: ContactUpdateLocalizationDataInput
  locale: Locale
}

export type ContactUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ContactCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ContactUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ContactUpsertLocalizationInput>>
}

export type ContactUpdateManyInlineInput = {
  /** Create and connect multiple Contact component instances */
  create?: InputMaybe<Array<ContactCreateWithPositionInput>>
  /** Delete multiple Contact documents */
  delete?: InputMaybe<Array<ContactWhereUniqueInput>>
  /** Update multiple Contact component instances */
  update?: InputMaybe<Array<ContactUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple Contact component instances */
  upsert?: InputMaybe<Array<ContactUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type ContactUpdateManyInput = {
  contactIcons?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** department input for default locale (de) */
  department?: InputMaybe<Scalars['String']['input']>
  /** departmentUrl input for default locale (de) */
  departmentUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ContactUpdateManyLocalizationsInput>
  phone?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ContactUpdateManyLocalizationDataInput = {
  department?: InputMaybe<Scalars['String']['input']>
  departmentUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ContactUpdateManyLocalizationInput = {
  data: ContactUpdateManyLocalizationDataInput
  locale: Locale
}

export type ContactUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ContactUpdateManyLocalizationInput>>
}

export type ContactUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContactUpdateManyInput
  /** Document search */
  where: ContactWhereInput
}

export type ContactUpdateOneInlineInput = {
  /** Create and connect one Contact document */
  create?: InputMaybe<ContactCreateInput>
  /** Delete currently connected Contact document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Contact document */
  update?: InputMaybe<ContactUpdateWithNestedWhereUniqueInput>
  /** Upsert single Contact document */
  upsert?: InputMaybe<ContactUpsertWithNestedWhereUniqueInput>
}

export type ContactUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContactUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ContactWhereUniqueInput
}

export type ContactUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContactUpdateInput
  /** Unique document search */
  where: ContactWhereUniqueInput
}

export type ContactUpsertInput = {
  /** Create document if it didn't exist */
  create: ContactCreateInput
  /** Update document if it exists */
  update: ContactUpdateInput
}

export type ContactUpsertLocalizationInput = {
  create: ContactCreateLocalizationDataInput
  locale: Locale
  update: ContactUpdateLocalizationDataInput
}

export type ContactUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContactUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ContactWhereUniqueInput
}

export type ContactUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContactUpsertInput
  /** Unique document search */
  where: ContactWhereUniqueInput
}

/** Identifies documents */
export type ContactWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  contactIcons?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  contactIcons_not?: InputMaybe<Scalars['Boolean']['input']>
  contactPhoto?: InputMaybe<AssetWhereInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  department?: InputMaybe<Scalars['String']['input']>
  departmentUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  departmentUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  departmentUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  departmentUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  departmentUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  departmentUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  departmentUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  departmentUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  departmentUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  departmentUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  department_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  department_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  department_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  department_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  department_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  department_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  department_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  department_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  department_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  phone_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  phone_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  phone_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  phone_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  phone_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  phone_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  phone_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References Contact record uniquely */
export type ContactWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Generic content reference */
export type ContentReference = Entity &
  Node & {
    __typename?: 'ContentReference'
    coverImage?: Maybe<Asset>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Description of the content reference */
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<ContentReference>
    externalUrl: Scalars['String']['output']
    /** List of ContentReference versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<ContentReference>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    /** Please provide external reference if possible. Will make it easier for us to migrate content in the future. */
    reference?: Maybe<Scalars['String']['output']>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** Subtitle of the reference */
    subtitle?: Maybe<Scalars['String']['output']>
    /** Title of the reference */
    title: Scalars['String']['output']
    /** Type of the content reference. Will be used as tab name. */
    type: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Generic content reference */
export type ContentReferenceCoverImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Generic content reference */
export type ContentReferenceCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Generic content reference */
export type ContentReferenceCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Generic content reference */
export type ContentReferenceDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Generic content reference */
export type ContentReferenceHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Generic content reference */
export type ContentReferenceLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Generic content reference */
export type ContentReferencePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Generic content reference */
export type ContentReferencePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Generic content reference */
export type ContentReferenceScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Generic content reference */
export type ContentReferenceUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Generic content reference */
export type ContentReferenceUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ContentReferenceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ContentReferenceWhereUniqueInput
}

/** A connection to a list of items. */
export type ContentReferenceConnection = {
  __typename?: 'ContentReferenceConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ContentReferenceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ContentReferenceCreateInput = {
  coverImage?: InputMaybe<AssetCreateOneInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** externalUrl input for default locale (de) */
  externalUrl: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ContentReferenceCreateLocalizationsInput>
  reference?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  /** type input for default locale (de) */
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ContentReferenceCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  externalUrl: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ContentReferenceCreateLocalizationInput = {
  /** Localization input */
  data: ContentReferenceCreateLocalizationDataInput
  locale: Locale
}

export type ContentReferenceCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ContentReferenceCreateLocalizationInput>>
}

export type ContentReferenceCreateManyInlineInput = {
  /** Connect multiple existing ContentReference documents */
  connect?: InputMaybe<Array<ContentReferenceWhereUniqueInput>>
  /** Create and connect multiple existing ContentReference documents */
  create?: InputMaybe<Array<ContentReferenceCreateInput>>
}

export type ContentReferenceCreateOneInlineInput = {
  /** Connect one existing ContentReference document */
  connect?: InputMaybe<ContentReferenceWhereUniqueInput>
  /** Create and connect one ContentReference document */
  create?: InputMaybe<ContentReferenceCreateInput>
}

/** An edge in a connection. */
export type ContentReferenceEdge = {
  __typename?: 'ContentReferenceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ContentReference
}

/** Identifies documents */
export type ContentReferenceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentReferenceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentReferenceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentReferenceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  coverImage?: InputMaybe<AssetWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ContentReferenceWhereStageInput>
  documentInStages_none?: InputMaybe<ContentReferenceWhereStageInput>
  documentInStages_some?: InputMaybe<ContentReferenceWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reference?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  reference_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  reference_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  reference_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  reference_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  reference_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  reference_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  reference_starts_with?: InputMaybe<Scalars['String']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ContentReferenceOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReferenceAsc = 'reference_ASC',
  ReferenceDesc = 'reference_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ContentReferenceUpdateInput = {
  coverImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** externalUrl input for default locale (de) */
  externalUrl?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ContentReferenceUpdateLocalizationsInput>
  reference?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  /** type input for default locale (de) */
  type?: InputMaybe<Scalars['String']['input']>
}

export type ContentReferenceUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  externalUrl?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type ContentReferenceUpdateLocalizationInput = {
  data: ContentReferenceUpdateLocalizationDataInput
  locale: Locale
}

export type ContentReferenceUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ContentReferenceCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ContentReferenceUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ContentReferenceUpsertLocalizationInput>>
}

export type ContentReferenceUpdateManyInlineInput = {
  /** Connect multiple existing ContentReference documents */
  connect?: InputMaybe<Array<ContentReferenceConnectInput>>
  /** Create and connect multiple ContentReference documents */
  create?: InputMaybe<Array<ContentReferenceCreateInput>>
  /** Delete multiple ContentReference documents */
  delete?: InputMaybe<Array<ContentReferenceWhereUniqueInput>>
  /** Disconnect multiple ContentReference documents */
  disconnect?: InputMaybe<Array<ContentReferenceWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ContentReference documents */
  set?: InputMaybe<Array<ContentReferenceWhereUniqueInput>>
  /** Update multiple ContentReference documents */
  update?: InputMaybe<Array<ContentReferenceUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ContentReference documents */
  upsert?: InputMaybe<Array<ContentReferenceUpsertWithNestedWhereUniqueInput>>
}

export type ContentReferenceUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** externalUrl input for default locale (de) */
  externalUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ContentReferenceUpdateManyLocalizationsInput>
  reference?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  /** type input for default locale (de) */
  type?: InputMaybe<Scalars['String']['input']>
}

export type ContentReferenceUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  externalUrl?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type ContentReferenceUpdateManyLocalizationInput = {
  data: ContentReferenceUpdateManyLocalizationDataInput
  locale: Locale
}

export type ContentReferenceUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ContentReferenceUpdateManyLocalizationInput>>
}

export type ContentReferenceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentReferenceUpdateManyInput
  /** Document search */
  where: ContentReferenceWhereInput
}

export type ContentReferenceUpdateOneInlineInput = {
  /** Connect existing ContentReference document */
  connect?: InputMaybe<ContentReferenceWhereUniqueInput>
  /** Create and connect one ContentReference document */
  create?: InputMaybe<ContentReferenceCreateInput>
  /** Delete currently connected ContentReference document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ContentReference document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ContentReference document */
  update?: InputMaybe<ContentReferenceUpdateWithNestedWhereUniqueInput>
  /** Upsert single ContentReference document */
  upsert?: InputMaybe<ContentReferenceUpsertWithNestedWhereUniqueInput>
}

export type ContentReferenceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentReferenceUpdateInput
  /** Unique document search */
  where: ContentReferenceWhereUniqueInput
}

export type ContentReferenceUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentReferenceCreateInput
  /** Update document if it exists */
  update: ContentReferenceUpdateInput
}

export type ContentReferenceUpsertLocalizationInput = {
  create: ContentReferenceCreateLocalizationDataInput
  locale: Locale
  update: ContentReferenceUpdateLocalizationDataInput
}

export type ContentReferenceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentReferenceUpsertInput
  /** Unique document search */
  where: ContentReferenceWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ContentReferenceWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ContentReferenceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentReferenceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentReferenceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentReferenceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  coverImage?: InputMaybe<AssetWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<ContentReferenceWhereStageInput>
  documentInStages_none?: InputMaybe<ContentReferenceWhereStageInput>
  documentInStages_some?: InputMaybe<ContentReferenceWhereStageInput>
  externalUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  externalUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  externalUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  externalUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  externalUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  externalUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reference?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  reference_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  reference_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  reference_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  reference_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  reference_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  reference_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  reference_starts_with?: InputMaybe<Scalars['String']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  type_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  type_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  type_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  type_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContentReferenceWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentReferenceWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentReferenceWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentReferenceWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContentReferenceWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ContentReference record uniquely */
export type ContentReferenceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum CustomerType {
  BrandedRoomBooth = 'BrandedRoomBooth',
  BreakEvent = 'BreakEvent',
  CareerMeetup = 'CareerMeetup',
  CoexhibitorBooth = 'CoexhibitorBooth',
  CreatorLoungeBooth = 'CreatorLoungeBooth',
  DeepDive = 'DeepDive',
  DigitalMasterclass = 'DigitalMasterclass',
  Event = 'Event',
  GastroBooth = 'GastroBooth',
  GuidedTour = 'GuidedTour',
  Masterclass = 'Masterclass',
  MeetingRoomBooth = 'MeetingRoomBooth',
  PremiumBooth = 'PremiumBooth',
  PremiumExpoTurnkeyBooth = 'PremiumExpoTurnkeyBooth',
  PremiumLoungeBooth = 'PremiumLoungeBooth',
  PremiumOutdoorBooth = 'PremiumOutdoorBooth',
  SamplingBooth = 'SamplingBooth',
  SeacontainerBooth = 'SeacontainerBooth',
  SideEvent = 'SideEvent',
  StageSlot = 'StageSlot',
  StartupBooth = 'StartupBooth',
  SystemBooth = 'SystemBooth',
  TinySpaceBooth = 'TinySpaceBooth',
  TurnkeySaasAreaBooth = 'TurnkeySaasAreaBooth',
}

/** Defines a decoration pattern to use with the component is is used for. */
export enum DecorationPattern {
  AboutFestivalSlider = 'aboutFestivalSlider',
  ArtistsSlider = 'artistsSlider',
  Bahn = 'bahn',
  ContactPurple = 'contactPurple',
  ContactWhite = 'contactWhite',
  Exhibitor = 'exhibitor',
  GetApp = 'getApp',
  Getaticket = 'getaticket',
  HomeFullwidthSlider = 'homeFullwidthSlider',
  NoDecorationFaq = 'noDecorationFaq',
  Omr24CtaRocket = 'omr24CTARocket',
  Omr24CtaSign = 'omr24CTASign',
  Omr24CtaSubmarine = 'omr24CTASubmarine',
  Omr24Contact = 'omr24Contact',
  Omr24CtaApp = 'omr24CtaApp',
  Omr24CtaHotels = 'omr24CtaHotels',
  Omr24Faq = 'omr24Faq',
  Omr24Newsletter = 'omr24Newsletter',
  Omr24SubscibeTeaser = 'omr24SubscibeTeaser',
  Omr25CtaExhibitor = 'omr25CtaExhibitor',
  Omr26CtaExhibitor = 'omr26CtaExhibitor',
  Omr26CtaSpeakersProfile = 'omr26CtaSpeakersProfile',
  PremiumPartner = 'premiumPartner',
  SustainabilityFaq = 'sustainabilityFAQ',
  SustainabilityFaqIntro = 'sustainabilityFAQIntro',
  SustainabilityIntro = 'sustainabilityIntro',
  SustainabilitySticky = 'sustainabilitySticky',
  TextMediaBanner = 'textMediaBanner',
  TextMediaBannerFullWidth = 'textMediaBannerFullWidth',
}

export enum DecorationStyle {
  Circle = 'circle',
  Cross = 'cross',
  MatchBubbles = 'matchBubbles',
  None = 'none',
  Square = 'square',
  Triangle = 'triangle',
}

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AutoImage = 'autoImage',
  Avif = 'avif',
  Bmp = 'bmp',
  Gif = 'gif',
  Heic = 'heic',
  Jpg = 'jpg',
  Png = 'png',
  Svg = 'svg',
  Tiff = 'tiff',
  Webp = 'webp',
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>
}

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>
}

export type DocumentVersion = {
  __typename?: 'DocumentVersion'
  createdAt: Scalars['DateTime']['output']
  data?: Maybe<Scalars['Json']['output']>
  id: Scalars['ID']['output']
  revision: Scalars['Int']['output']
  stage: Stage
}

export type Download = Entity & {
  __typename?: 'Download'
  date: Scalars['DateTime']['output']
  description: Scalars['String']['output']
  downloadDe?: Maybe<Asset>
  downloadEn?: Maybe<Asset>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<Download>
  previewimage?: Maybe<Asset>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type DownloadDownloadDeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type DownloadDownloadEnArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type DownloadLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type DownloadPreviewimageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type DownloadUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type DownloadConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: DownloadWhereUniqueInput
}

/** A connection to a list of items. */
export type DownloadConnection = {
  __typename?: 'DownloadConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<DownloadEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type DownloadCreateInput = {
  date: Scalars['DateTime']['input']
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  downloadDe?: InputMaybe<AssetCreateOneInlineInput>
  downloadEn?: InputMaybe<AssetCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<DownloadCreateLocalizationsInput>
  previewimage?: InputMaybe<AssetCreateOneInlineInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type DownloadCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type DownloadCreateLocalizationInput = {
  /** Localization input */
  data: DownloadCreateLocalizationDataInput
  locale: Locale
}

export type DownloadCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<DownloadCreateLocalizationInput>>
}

export type DownloadCreateManyInlineInput = {
  /** Create and connect multiple existing Download documents */
  create?: InputMaybe<Array<DownloadCreateInput>>
}

export type DownloadCreateOneInlineInput = {
  /** Create and connect one Download document */
  create?: InputMaybe<DownloadCreateInput>
}

export type DownloadCreateWithPositionInput = {
  /** Document to create */
  data: DownloadCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type DownloadEdge = {
  __typename?: 'DownloadEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Download
}

/** Identifies documents */
export type DownloadManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  downloadDe?: InputMaybe<AssetWhereInput>
  downloadEn?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  previewimage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum DownloadOrderByInput {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type DownloadParent = SectionDownloads | TabContent

export type DownloadParentConnectInput = {
  SectionDownloads?: InputMaybe<SectionDownloadsConnectInput>
  TabContent?: InputMaybe<TabContentConnectInput>
}

export type DownloadParentCreateInput = {
  SectionDownloads?: InputMaybe<SectionDownloadsCreateInput>
  TabContent?: InputMaybe<TabContentCreateInput>
}

export type DownloadParentCreateManyInlineInput = {
  /** Connect multiple existing DownloadParent documents */
  connect?: InputMaybe<Array<DownloadParentWhereUniqueInput>>
  /** Create and connect multiple existing DownloadParent documents */
  create?: InputMaybe<Array<DownloadParentCreateInput>>
}

export type DownloadParentCreateOneInlineInput = {
  /** Connect one existing DownloadParent document */
  connect?: InputMaybe<DownloadParentWhereUniqueInput>
  /** Create and connect one DownloadParent document */
  create?: InputMaybe<DownloadParentCreateInput>
}

export type DownloadParentUpdateInput = {
  SectionDownloads?: InputMaybe<SectionDownloadsUpdateInput>
  TabContent?: InputMaybe<TabContentUpdateInput>
}

export type DownloadParentUpdateManyInlineInput = {
  /** Connect multiple existing DownloadParent documents */
  connect?: InputMaybe<Array<DownloadParentConnectInput>>
  /** Create and connect multiple DownloadParent documents */
  create?: InputMaybe<Array<DownloadParentCreateInput>>
  /** Delete multiple DownloadParent documents */
  delete?: InputMaybe<Array<DownloadParentWhereUniqueInput>>
  /** Disconnect multiple DownloadParent documents */
  disconnect?: InputMaybe<Array<DownloadParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing DownloadParent documents */
  set?: InputMaybe<Array<DownloadParentWhereUniqueInput>>
  /** Update multiple DownloadParent documents */
  update?: InputMaybe<Array<DownloadParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple DownloadParent documents */
  upsert?: InputMaybe<Array<DownloadParentUpsertWithNestedWhereUniqueInput>>
}

export type DownloadParentUpdateManyWithNestedWhereInput = {
  SectionDownloads?: InputMaybe<SectionDownloadsUpdateManyWithNestedWhereInput>
  TabContent?: InputMaybe<TabContentUpdateManyWithNestedWhereInput>
}

export type DownloadParentUpdateOneInlineInput = {
  /** Connect existing DownloadParent document */
  connect?: InputMaybe<DownloadParentWhereUniqueInput>
  /** Create and connect one DownloadParent document */
  create?: InputMaybe<DownloadParentCreateInput>
  /** Delete currently connected DownloadParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected DownloadParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single DownloadParent document */
  update?: InputMaybe<DownloadParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single DownloadParent document */
  upsert?: InputMaybe<DownloadParentUpsertWithNestedWhereUniqueInput>
}

export type DownloadParentUpdateWithNestedWhereUniqueInput = {
  SectionDownloads?: InputMaybe<SectionDownloadsUpdateWithNestedWhereUniqueInput>
  TabContent?: InputMaybe<TabContentUpdateWithNestedWhereUniqueInput>
}

export type DownloadParentUpsertWithNestedWhereUniqueInput = {
  SectionDownloads?: InputMaybe<SectionDownloadsUpsertWithNestedWhereUniqueInput>
  TabContent?: InputMaybe<TabContentUpsertWithNestedWhereUniqueInput>
}

export type DownloadParentWhereInput = {
  SectionDownloads?: InputMaybe<SectionDownloadsWhereInput>
  TabContent?: InputMaybe<TabContentWhereInput>
}

export type DownloadParentWhereUniqueInput = {
  SectionDownloads?: InputMaybe<SectionDownloadsWhereUniqueInput>
  TabContent?: InputMaybe<TabContentWhereUniqueInput>
}

export type DownloadUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  downloadDe?: InputMaybe<AssetUpdateOneInlineInput>
  downloadEn?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<DownloadUpdateLocalizationsInput>
  previewimage?: InputMaybe<AssetUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type DownloadUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type DownloadUpdateLocalizationInput = {
  data: DownloadUpdateLocalizationDataInput
  locale: Locale
}

export type DownloadUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<DownloadCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<DownloadUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<DownloadUpsertLocalizationInput>>
}

export type DownloadUpdateManyInlineInput = {
  /** Create and connect multiple Download component instances */
  create?: InputMaybe<Array<DownloadCreateWithPositionInput>>
  /** Delete multiple Download documents */
  delete?: InputMaybe<Array<DownloadWhereUniqueInput>>
  /** Update multiple Download component instances */
  update?: InputMaybe<Array<DownloadUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple Download component instances */
  upsert?: InputMaybe<Array<DownloadUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type DownloadUpdateManyInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<DownloadUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type DownloadUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type DownloadUpdateManyLocalizationInput = {
  data: DownloadUpdateManyLocalizationDataInput
  locale: Locale
}

export type DownloadUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<DownloadUpdateManyLocalizationInput>>
}

export type DownloadUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DownloadUpdateManyInput
  /** Document search */
  where: DownloadWhereInput
}

export type DownloadUpdateOneInlineInput = {
  /** Create and connect one Download document */
  create?: InputMaybe<DownloadCreateInput>
  /** Delete currently connected Download document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Download document */
  update?: InputMaybe<DownloadUpdateWithNestedWhereUniqueInput>
  /** Upsert single Download document */
  upsert?: InputMaybe<DownloadUpsertWithNestedWhereUniqueInput>
}

export type DownloadUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<DownloadUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: DownloadWhereUniqueInput
}

export type DownloadUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DownloadUpdateInput
  /** Unique document search */
  where: DownloadWhereUniqueInput
}

export type DownloadUpsertInput = {
  /** Create document if it didn't exist */
  create: DownloadCreateInput
  /** Update document if it exists */
  update: DownloadUpdateInput
}

export type DownloadUpsertLocalizationInput = {
  create: DownloadCreateLocalizationDataInput
  locale: Locale
  update: DownloadUpdateLocalizationDataInput
}

export type DownloadUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<DownloadUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: DownloadWhereUniqueInput
}

export type DownloadUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DownloadUpsertInput
  /** Unique document search */
  where: DownloadWhereUniqueInput
}

/** Identifies documents */
export type DownloadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  downloadDe?: InputMaybe<AssetWhereInput>
  downloadEn?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  previewimage?: InputMaybe<AssetWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References Download record uniquely */
export type DownloadWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Educational report */
export type EducationReport = Entity &
  Node & {
    __typename?: 'EducationReport'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    currency: Scalars['String']['output']
    /** Description of the report */
    description: Scalars['String']['output']
    /** Get the document in other stages */
    documentInStages: Array<EducationReport>
    /** List of EducationReport versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    imageUrl: Scalars['String']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<EducationReport>
    onlineStoreUrl: Scalars['String']['output']
    price: Scalars['Float']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** Title of the report */
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Educational report */
export type EducationReportCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Educational report */
export type EducationReportCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Educational report */
export type EducationReportDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Educational report */
export type EducationReportHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Educational report */
export type EducationReportLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Educational report */
export type EducationReportPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Educational report */
export type EducationReportPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Educational report */
export type EducationReportScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Educational report */
export type EducationReportUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Educational report */
export type EducationReportUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EducationReportConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EducationReportWhereUniqueInput
}

/** A connection to a list of items. */
export type EducationReportConnection = {
  __typename?: 'EducationReportConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EducationReportEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EducationReportCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  currency: Scalars['String']['input']
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  imageUrl: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EducationReportCreateLocalizationsInput>
  /** onlineStoreUrl input for default locale (de) */
  onlineStoreUrl: Scalars['String']['input']
  price: Scalars['Float']['input']
  slug: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EducationReportCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description: Scalars['String']['input']
  onlineStoreUrl: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EducationReportCreateLocalizationInput = {
  /** Localization input */
  data: EducationReportCreateLocalizationDataInput
  locale: Locale
}

export type EducationReportCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EducationReportCreateLocalizationInput>>
}

export type EducationReportCreateManyInlineInput = {
  /** Connect multiple existing EducationReport documents */
  connect?: InputMaybe<Array<EducationReportWhereUniqueInput>>
  /** Create and connect multiple existing EducationReport documents */
  create?: InputMaybe<Array<EducationReportCreateInput>>
}

export type EducationReportCreateOneInlineInput = {
  /** Connect one existing EducationReport document */
  connect?: InputMaybe<EducationReportWhereUniqueInput>
  /** Create and connect one EducationReport document */
  create?: InputMaybe<EducationReportCreateInput>
}

/** An edge in a connection. */
export type EducationReportEdge = {
  __typename?: 'EducationReportEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EducationReport
}

/** Identifies documents */
export type EducationReportManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EducationReportWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EducationReportWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EducationReportWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  currency?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  currency_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  currency_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  currency_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  currency_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  currency_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  currency_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  currency_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  currency_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  currency_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<EducationReportWhereStageInput>
  documentInStages_none?: InputMaybe<EducationReportWhereStageInput>
  documentInStages_some?: InputMaybe<EducationReportWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  imageUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  imageUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  imageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  imageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  imageUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  price_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  price_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  price_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  price_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  price_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  price_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum EducationReportOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  CurrencyAsc = 'currency_ASC',
  CurrencyDesc = 'currency_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  OnlineStoreUrlAsc = 'onlineStoreUrl_ASC',
  OnlineStoreUrlDesc = 'onlineStoreUrl_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EducationReportUpdateInput = {
  currency?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<EducationReportUpdateLocalizationsInput>
  /** onlineStoreUrl input for default locale (de) */
  onlineStoreUrl?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EducationReportUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  onlineStoreUrl?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type EducationReportUpdateLocalizationInput = {
  data: EducationReportUpdateLocalizationDataInput
  locale: Locale
}

export type EducationReportUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EducationReportCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EducationReportUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EducationReportUpsertLocalizationInput>>
}

export type EducationReportUpdateManyInlineInput = {
  /** Connect multiple existing EducationReport documents */
  connect?: InputMaybe<Array<EducationReportConnectInput>>
  /** Create and connect multiple EducationReport documents */
  create?: InputMaybe<Array<EducationReportCreateInput>>
  /** Delete multiple EducationReport documents */
  delete?: InputMaybe<Array<EducationReportWhereUniqueInput>>
  /** Disconnect multiple EducationReport documents */
  disconnect?: InputMaybe<Array<EducationReportWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing EducationReport documents */
  set?: InputMaybe<Array<EducationReportWhereUniqueInput>>
  /** Update multiple EducationReport documents */
  update?: InputMaybe<Array<EducationReportUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple EducationReport documents */
  upsert?: InputMaybe<Array<EducationReportUpsertWithNestedWhereUniqueInput>>
}

export type EducationReportUpdateManyInput = {
  currency?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<EducationReportUpdateManyLocalizationsInput>
  price?: InputMaybe<Scalars['Float']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EducationReportUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type EducationReportUpdateManyLocalizationInput = {
  data: EducationReportUpdateManyLocalizationDataInput
  locale: Locale
}

export type EducationReportUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EducationReportUpdateManyLocalizationInput>>
}

export type EducationReportUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EducationReportUpdateManyInput
  /** Document search */
  where: EducationReportWhereInput
}

export type EducationReportUpdateOneInlineInput = {
  /** Connect existing EducationReport document */
  connect?: InputMaybe<EducationReportWhereUniqueInput>
  /** Create and connect one EducationReport document */
  create?: InputMaybe<EducationReportCreateInput>
  /** Delete currently connected EducationReport document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected EducationReport document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EducationReport document */
  update?: InputMaybe<EducationReportUpdateWithNestedWhereUniqueInput>
  /** Upsert single EducationReport document */
  upsert?: InputMaybe<EducationReportUpsertWithNestedWhereUniqueInput>
}

export type EducationReportUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EducationReportUpdateInput
  /** Unique document search */
  where: EducationReportWhereUniqueInput
}

export type EducationReportUpsertInput = {
  /** Create document if it didn't exist */
  create: EducationReportCreateInput
  /** Update document if it exists */
  update: EducationReportUpdateInput
}

export type EducationReportUpsertLocalizationInput = {
  create: EducationReportCreateLocalizationDataInput
  locale: Locale
  update: EducationReportUpdateLocalizationDataInput
}

export type EducationReportUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EducationReportUpsertInput
  /** Unique document search */
  where: EducationReportWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type EducationReportWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type EducationReportWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EducationReportWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EducationReportWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EducationReportWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  currency?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  currency_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  currency_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  currency_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  currency_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  currency_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  currency_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  currency_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  currency_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  currency_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<EducationReportWhereStageInput>
  documentInStages_none?: InputMaybe<EducationReportWhereStageInput>
  documentInStages_some?: InputMaybe<EducationReportWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  imageUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  imageUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  imageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  imageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  imageUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  onlineStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  onlineStoreUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  onlineStoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  onlineStoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  onlineStoreUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  onlineStoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  onlineStoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  onlineStoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  onlineStoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  onlineStoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  price_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  price_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  price_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  price_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  price_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  price_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type EducationReportWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EducationReportWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EducationReportWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EducationReportWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<EducationReportWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References EducationReport record uniquely */
export type EducationReportWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

/** Educational seminar */
export type EducationSeminar = Entity &
  Node & {
    __typename?: 'EducationSeminar'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    currency: Scalars['String']['output']
    /** Description of the seminar */
    description: Scalars['String']['output']
    /** Get the document in other stages */
    documentInStages: Array<EducationSeminar>
    /** List of EducationSeminar versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    imageUrl: Scalars['String']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<EducationSeminar>
    onlineStoreUrl: Scalars['String']['output']
    price: Scalars['Float']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** Title of the seminar */
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Educational seminar */
export type EducationSeminarCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Educational seminar */
export type EducationSeminarCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Educational seminar */
export type EducationSeminarDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Educational seminar */
export type EducationSeminarHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Educational seminar */
export type EducationSeminarLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Educational seminar */
export type EducationSeminarPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Educational seminar */
export type EducationSeminarPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Educational seminar */
export type EducationSeminarScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Educational seminar */
export type EducationSeminarUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Educational seminar */
export type EducationSeminarUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EducationSeminarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EducationSeminarWhereUniqueInput
}

/** A connection to a list of items. */
export type EducationSeminarConnection = {
  __typename?: 'EducationSeminarConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EducationSeminarEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EducationSeminarCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  currency: Scalars['String']['input']
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  imageUrl: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EducationSeminarCreateLocalizationsInput>
  /** onlineStoreUrl input for default locale (de) */
  onlineStoreUrl: Scalars['String']['input']
  price: Scalars['Float']['input']
  slug: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EducationSeminarCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description: Scalars['String']['input']
  onlineStoreUrl: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EducationSeminarCreateLocalizationInput = {
  /** Localization input */
  data: EducationSeminarCreateLocalizationDataInput
  locale: Locale
}

export type EducationSeminarCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EducationSeminarCreateLocalizationInput>>
}

export type EducationSeminarCreateManyInlineInput = {
  /** Connect multiple existing EducationSeminar documents */
  connect?: InputMaybe<Array<EducationSeminarWhereUniqueInput>>
  /** Create and connect multiple existing EducationSeminar documents */
  create?: InputMaybe<Array<EducationSeminarCreateInput>>
}

export type EducationSeminarCreateOneInlineInput = {
  /** Connect one existing EducationSeminar document */
  connect?: InputMaybe<EducationSeminarWhereUniqueInput>
  /** Create and connect one EducationSeminar document */
  create?: InputMaybe<EducationSeminarCreateInput>
}

/** An edge in a connection. */
export type EducationSeminarEdge = {
  __typename?: 'EducationSeminarEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EducationSeminar
}

/** Identifies documents */
export type EducationSeminarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EducationSeminarWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EducationSeminarWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EducationSeminarWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  currency?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  currency_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  currency_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  currency_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  currency_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  currency_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  currency_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  currency_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  currency_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  currency_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<EducationSeminarWhereStageInput>
  documentInStages_none?: InputMaybe<EducationSeminarWhereStageInput>
  documentInStages_some?: InputMaybe<EducationSeminarWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  imageUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  imageUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  imageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  imageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  imageUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  price_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  price_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  price_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  price_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  price_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  price_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum EducationSeminarOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  CurrencyAsc = 'currency_ASC',
  CurrencyDesc = 'currency_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  OnlineStoreUrlAsc = 'onlineStoreUrl_ASC',
  OnlineStoreUrlDesc = 'onlineStoreUrl_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EducationSeminarUpdateInput = {
  currency?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<EducationSeminarUpdateLocalizationsInput>
  /** onlineStoreUrl input for default locale (de) */
  onlineStoreUrl?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EducationSeminarUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  onlineStoreUrl?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type EducationSeminarUpdateLocalizationInput = {
  data: EducationSeminarUpdateLocalizationDataInput
  locale: Locale
}

export type EducationSeminarUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EducationSeminarCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EducationSeminarUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EducationSeminarUpsertLocalizationInput>>
}

export type EducationSeminarUpdateManyInlineInput = {
  /** Connect multiple existing EducationSeminar documents */
  connect?: InputMaybe<Array<EducationSeminarConnectInput>>
  /** Create and connect multiple EducationSeminar documents */
  create?: InputMaybe<Array<EducationSeminarCreateInput>>
  /** Delete multiple EducationSeminar documents */
  delete?: InputMaybe<Array<EducationSeminarWhereUniqueInput>>
  /** Disconnect multiple EducationSeminar documents */
  disconnect?: InputMaybe<Array<EducationSeminarWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing EducationSeminar documents */
  set?: InputMaybe<Array<EducationSeminarWhereUniqueInput>>
  /** Update multiple EducationSeminar documents */
  update?: InputMaybe<Array<EducationSeminarUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple EducationSeminar documents */
  upsert?: InputMaybe<Array<EducationSeminarUpsertWithNestedWhereUniqueInput>>
}

export type EducationSeminarUpdateManyInput = {
  currency?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<EducationSeminarUpdateManyLocalizationsInput>
  price?: InputMaybe<Scalars['Float']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EducationSeminarUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type EducationSeminarUpdateManyLocalizationInput = {
  data: EducationSeminarUpdateManyLocalizationDataInput
  locale: Locale
}

export type EducationSeminarUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EducationSeminarUpdateManyLocalizationInput>>
}

export type EducationSeminarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EducationSeminarUpdateManyInput
  /** Document search */
  where: EducationSeminarWhereInput
}

export type EducationSeminarUpdateOneInlineInput = {
  /** Connect existing EducationSeminar document */
  connect?: InputMaybe<EducationSeminarWhereUniqueInput>
  /** Create and connect one EducationSeminar document */
  create?: InputMaybe<EducationSeminarCreateInput>
  /** Delete currently connected EducationSeminar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected EducationSeminar document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EducationSeminar document */
  update?: InputMaybe<EducationSeminarUpdateWithNestedWhereUniqueInput>
  /** Upsert single EducationSeminar document */
  upsert?: InputMaybe<EducationSeminarUpsertWithNestedWhereUniqueInput>
}

export type EducationSeminarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EducationSeminarUpdateInput
  /** Unique document search */
  where: EducationSeminarWhereUniqueInput
}

export type EducationSeminarUpsertInput = {
  /** Create document if it didn't exist */
  create: EducationSeminarCreateInput
  /** Update document if it exists */
  update: EducationSeminarUpdateInput
}

export type EducationSeminarUpsertLocalizationInput = {
  create: EducationSeminarCreateLocalizationDataInput
  locale: Locale
  update: EducationSeminarUpdateLocalizationDataInput
}

export type EducationSeminarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EducationSeminarUpsertInput
  /** Unique document search */
  where: EducationSeminarWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type EducationSeminarWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type EducationSeminarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EducationSeminarWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EducationSeminarWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EducationSeminarWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  currency?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  currency_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  currency_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  currency_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  currency_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  currency_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  currency_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  currency_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  currency_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  currency_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<EducationSeminarWhereStageInput>
  documentInStages_none?: InputMaybe<EducationSeminarWhereStageInput>
  documentInStages_some?: InputMaybe<EducationSeminarWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  imageUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  imageUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  imageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  imageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  imageUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  onlineStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  onlineStoreUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  onlineStoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  onlineStoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  onlineStoreUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  onlineStoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  onlineStoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  onlineStoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  onlineStoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  onlineStoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  price_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  price_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  price_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  price_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  price_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  price_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type EducationSeminarWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EducationSeminarWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EducationSeminarWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EducationSeminarWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<EducationSeminarWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References EducationSeminar record uniquely */
export type EducationSeminarWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export enum ElementPosition {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Right = 'right',
  Top = 'top',
}

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output']
  /** The Stage of an object */
  stage: Stage
}

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** In the animated counter section this model represents one counter settings */
  AnimatedCounter = 'AnimatedCounter',
  Article = 'Article',
  ArticleCategory = 'ArticleCategory',
  /** Simple button call to action placed inside article content */
  ArticleCta = 'ArticleCta',
  /** Article pageViews in the last 30 days */
  ArticlePageView = 'ArticlePageView',
  ArticlesByTag = 'ArticlesByTag',
  /** Asset system model */
  Asset = 'Asset',
  /** Content author */
  Author = 'Author',
  Benefit = 'Benefit',
  BenefitsCard = 'BenefitsCard',
  BenefitsSection = 'BenefitsSection',
  Booth = 'Booth',
  BulletPointList = 'BulletPointList',
  /** Link or button call to action configuration */
  CallToAction = 'CallToAction',
  /** OMR Career page to list all career opportunities at OMR */
  CareerPage = 'CareerPage',
  /** Careers List for Career Pages */
  CareerPageSectionCareersList = 'CareerPageSectionCareersList',
  /** Hero Section for Career Pages */
  CareerPageSectionHero = 'CareerPageSectionHero',
  Contact = 'Contact',
  /** Generic content reference */
  ContentReference = 'ContentReference',
  Download = 'Download',
  /** Educational report */
  EducationReport = 'EducationReport',
  /** Educational seminar */
  EducationSeminar = 'EducationSeminar',
  Event = 'Event',
  /** Event app Ad */
  EventAppAd = 'EventAppAd',
  /** [EventApp] Card component */
  EventAppCard = 'EventAppCard',
  /** [EventApp] Text Content: Simple article title with markdown body used on festival mobile app to show content */
  EventAppCardContent = 'EventAppCardContent',
  /** Event App content */
  EventAppPage = 'EventAppPage',
  /** [EventApp] Section component */
  EventAppSection = 'EventAppSection',
  EventPage = 'EventPage',
  /** Event Stage synchronised from myomr service */
  EventStage = 'EventStage',
  /** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
  ExhibitorListOrder = 'ExhibitorListOrder',
  ExplanationStep = 'ExplanationStep',
  /** Section showing some frequently asked questions. */
  Faq = 'Faq',
  /** A question and answer in our FAQs */
  FaqQuestion = 'FaqQuestion',
  /** OMR footer */
  Footer = 'Footer',
  /** OMR footer link */
  FooterLink = 'FooterLink',
  /** Glossary model with term explanation */
  Glossary = 'Glossary',
  /** Header */
  Header = 'Header',
  /** Header menu item */
  HeaderMenuItem = 'HeaderMenuItem',
  HeaderPromo = 'HeaderPromo',
  /** Header submenu item */
  HeaderSubMenuItem = 'HeaderSubMenuItem',
  /** Header sub-submenu item */
  HeaderSubSubMenuItem = 'HeaderSubSubMenuItem',
  /** Image/Video component with breakpoint variants and positioning options */
  HeroImage = 'HeroImage',
  /** Highlighted text for Section Styled Hero */
  HighlightedText = 'HighlightedText',
  Hotel = 'Hotel',
  /** Raw HTML code to be rendered on the page */
  HtmlEmbed = 'HtmlEmbed',
  /** Provides manual control over content for a hub page reference list tiles. */
  HubContentEntry = 'HubContentEntry',
  /** Hub page to unfiy content accros all departments */
  HubPage = 'HubPage',
  /** EPOM Ad Tile */
  HubPageAdTile = 'HubPageAdTile',
  /** Article List Tile for Hub Page Sections */
  HubPageArticleListTile = 'HubPageArticleListTile',
  /** Content Slider Item for Hub Pages */
  HubPageContentSliderItem = 'HubPageContentSliderItem',
  /** Content slider tile for Hub Page Sections */
  HubPageContentSliderTile = 'HubPageContentSliderTile',
  /** Content Tile for Hub Page Sections */
  HubPageContentTile = 'HubPageContentTile',
  /** Countdown hero driving theCountdownHero component on Hub Pages */
  HubPageCountdownHero = 'HubPageCountdownHero',
  /** Hero Slider Item for Hub Pages */
  HubPageHeroSliderItem = 'HubPageHeroSliderItem',
  /** Image Tile for Hub Page Sections */
  HubPageImageTile = 'HubPageImageTile',
  /** Info Tile for Hub Page Sections */
  HubPageInfoTile = 'HubPageInfoTile',
  /** Latest Article Tile for Hub Page Sections */
  HubPageLatestArticleTile = 'HubPageLatestArticleTile',
  /** Newsletter Subscription Tile for Hub Page Sections */
  HubPageNewsletterSubscriptionTile = 'HubPageNewsletterSubscriptionTile',
  /** Partner Company Tile for Hub Page Sections */
  HubPagePartnerCompanyTile = 'HubPagePartnerCompanyTile',
  /** Component used for linking references with additional content */
  HubPageReference = 'HubPageReference',
  /** Reference List Tile for Hub Page Sections */
  HubPageReferenceListTile = 'HubPageReferenceListTile',
  /** Reviews Top Products Tile for Hub Page Sections */
  HubPageReviewsTopProductsTile = 'HubPageReviewsTopProductsTile',
  /** Content Library Section for Hub Pages */
  HubPageSectionContentLibrary = 'HubPageSectionContentLibrary',
  /** Festival Events Section for Hub Pages */
  HubPageSectionFestivalEvents = 'HubPageSectionFestivalEvents',
  /** General Section for Hub Pages */
  HubPageSectionGeneral = 'HubPageSectionGeneral',
  /** Podcasts Section for Hub Pages */
  HubPageSectionPodcasts = 'HubPageSectionPodcasts',
  /** Social Media Tile for Hub Page Sections */
  HubPageSocialMediaTile = 'HubPageSocialMediaTile',
  /** Speaker Tile for Hub Page Sections */
  HubPageSpeakerTile = 'HubPageSpeakerTile',
  /** A static hub tile */
  HubPageStaticTile = 'HubPageStaticTile',
  /** Tile sizes for Hub Page Sections */
  HubPageTileSizes = 'HubPageTileSizes',
  /** Image gallery to be embedded in the rich text editor */
  ImageGalleryEmbed = 'ImageGalleryEmbed',
  ImageSlider = 'ImageSlider',
  Interest = 'Interest',
  JobListing = 'JobListing',
  /** A journey through the application specified by interest tags */
  Journey = 'Journey',
  /** Configuration for static landing page */
  LandingPage = 'LandingPage',
  /** Model to hold configuration options for pages to show in OMR Manage. */
  ManageContentConfig = 'ManageContentConfig',
  /** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
  MapMarker = 'MapMarker',
  /** Icon used for Map marker in the CustomMap component. */
  MapMarkerIcon = 'MapMarkerIcon',
  /** Single newsletter audience as a entry point to newsletter subscriptions. */
  NewsletterAudience = 'NewsletterAudience',
  Notification = 'Notification',
  OmrPartner = 'OMRPartner',
  PartnerBadge = 'PartnerBadge',
  /** Partner companies */
  PartnerCompany = 'PartnerCompany',
  PhysicalLocation = 'PhysicalLocation',
  /** Podigee podcast episodes */
  PodcastEpisode = 'PodcastEpisode',
  /** Podcast Groups */
  PodcastGroup = 'PodcastGroup',
  /** Component used when linking to a podcast group */
  PodcastGroupLink = 'PodcastGroupLink',
  PpcReviewsProduct = 'PpcReviewsProduct',
  /** Section showing some quick actions. */
  PreviewCardList = 'PreviewCardList',
  /** Pricing Tier for B2B Landing Pages */
  PricingTier = 'PricingTier',
  ProcessStep = 'ProcessStep',
  /** a stand with food at the festival */
  RecommendationFood = 'RecommendationFood',
  /** a place to go at night during the festival */
  RecommendationNightOut = 'RecommendationNightOut',
  /** Reviews Agencies synchronised from reviews-api service */
  ReviewsAgency = 'ReviewsAgency',
  /** Row in a Features Table */
  ReviewsFeatureRow = 'ReviewsFeatureRow',
  /** Section of Features */
  ReviewsFeaturesSection = 'ReviewsFeaturesSection',
  /** Reviews Products synchronised from reviews-api service */
  ReviewsProduct = 'ReviewsProduct',
  /** Reviews Category for Products or Agencies */
  ReviewsProductCategory = 'ReviewsProductCategory',
  /** Widgets to display pre-configurate productgroups in Contenthub */
  ReviewsProductWidget = 'ReviewsProductWidget',
  RichContent = 'RichContent',
  /** Section component for richt text with media. */
  RichTextMedia = 'RichTextMedia',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  /** Area on the page that could be linked to with an anchor */
  SectionAnchorTarget = 'SectionAnchorTarget',
  /** Call to action for App Download */
  SectionAppCta = 'SectionAppCta',
  SectionBanner = 'SectionBanner',
  /** Section displaying items with bold numbers with the description below and optional call to action */
  SectionByTheNumbers = 'SectionByTheNumbers',
  /** Text will be collapsed and only title will be shown */
  SectionCollapsedRichContent = 'SectionCollapsedRichContent',
  SectionContact = 'SectionContact',
  /** Section to reference different content items. */
  SectionContentReference = 'SectionContentReference',
  SectionCta = 'SectionCta',
  /** Showing a curated list of speakers */
  SectionCuratedSpeakerList = 'SectionCuratedSpeakerList',
  SectionDownloads = 'SectionDownloads',
  /** Shows timetable for Event offers in list view modes. */
  SectionEventOffersTimetable = 'SectionEventOffersTimetable',
  /** Section displaying items in columns with picture title description and optional call to action */
  SectionExplanationBlocks = 'SectionExplanationBlocks',
  /** Shows timetable for Festival stages in 2D and list view modes. */
  SectionFestivalTimetable = 'SectionFestivalTimetable',
  /** Section Flip Counter component */
  SectionFlipCounter = 'SectionFlipCounter',
  SectionFramesHero = 'SectionFramesHero',
  SectionHero = 'SectionHero',
  /** Section showing the list of hotels. */
  SectionHotel = 'SectionHotel',
  /** Embed a Hubspot form section on the page */
  SectionHubspotForm = 'SectionHubspotForm',
  /** Image slider component. */
  SectionImageSlider = 'SectionImageSlider',
  SectionIntro = 'SectionIntro',
  SectionJobList = 'SectionJobList',
  SectionLivestreams = 'SectionLivestreams',
  /** Manage the logged in user's interests */
  SectionManageInterests = 'SectionManageInterests',
  /** Map component using OpenStreetMap to showcase markers on it. */
  SectionMap = 'SectionMap',
  /** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
  SectionMyomrExhibitors = 'SectionMyomrExhibitors',
  /** Section showing a sorted list of Exhibitors from MyOMR datasource. */
  SectionMyomrExhibitorsList = 'SectionMyomrExhibitorsList',
  /** Section showing newsletter subscription form. */
  SectionNewsletter = 'SectionNewsletter',
  /** Section showing newsletter audiences where user can subscribe. */
  SectionNewsletterAudience = 'SectionNewsletterAudience',
  /** Logo field of OMR partners with external linking. Partners/Media Partners etc. */
  SectionOmrPartner = 'SectionOMRPartner',
  /** One shot component for static content. */
  SectionOneShot = 'SectionOneShot',
  /** Section for Pricing Tiers */
  SectionPricingTiers = 'SectionPricingTiers',
  /** Section representing quote */
  SectionQuote = 'SectionQuote',
  /** show a grid of places to eat or go out at night during the festival */
  SectionRecommendations = 'SectionRecommendations',
  /** Table build of Reviews Feature Sections */
  SectionReviewsFeaturesTable = 'SectionReviewsFeaturesTable',
  /** Section for Slim CTA */
  SectionSlimCta = 'SectionSlimCta',
  /** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
  SectionSpeakers = 'SectionSpeakers',
  SectionStorytelling = 'SectionStorytelling',
  /** Hero section with predefined styles */
  SectionStyledHero = 'SectionStyledHero',
  /** Section showing a tab view on desktop and accordions on mobile. */
  SectionTab = 'SectionTab',
  SectionTeaser = 'SectionTeaser',
  /** Section representing single testimonial */
  SectionTestimonial = 'SectionTestimonial',
  SectionTicketsTable = 'SectionTicketsTable',
  /** Section consisting of responsive tiles */
  SectionTiles = 'SectionTiles',
  /** Section showing a video with a title. */
  SectionVideo = 'SectionVideo',
  Seo = 'Seo',
  SeoContentAttribute = 'SeoContentAttribute',
  /** Site section for different OMR business units. */
  SiteSection = 'SiteSection',
  Slide = 'Slide',
  /** Social media related links */
  Social = 'Social',
  /** Social embeds for Blog Content. Instagram, Podigee, Tiktok etc */
  SocialEmbed = 'SocialEmbed',
  SocialLink = 'SocialLink',
  Speaker = 'Speaker',
  /** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
  SpeakerListOrder = 'SpeakerListOrder',
  SubscriptionTeaser = 'SubscriptionTeaser',
  TabContent = 'TabContent',
  /** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
  Tag = 'Tag',
  /** A section with multiple testimonials rendered as a slider. */
  TestimonialSlider = 'TestimonialSlider',
  /** A section representing media asset next to text content with optional CTA */
  TextMedia = 'TextMedia',
  TextMediaBanner = 'TextMediaBanner',
  /** A single ticket column rendered in a SectionTicketsTable. */
  TicketsTableColumn = 'TicketsTableColumn',
  TicketsTableRow = 'TicketsTableRow',
  /** Base model for all topic pages. */
  TopicPage = 'TopicPage',
  /** Topc page category */
  TopicPageCategory = 'TopicPageCategory',
  /** Section component for topic pages. */
  TopicPageSection = 'TopicPageSection',
  /** User system model */
  User = 'User',
  /** VG Wort integration data */
  VgWort = 'VGWort',
  YtEmbed = 'YTEmbed',
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input']
  locale?: InputMaybe<Locale>
  stage: Stage
  /** The Type name of an object */
  typename: EntityTypeName
}

export type Event = Entity &
  Node & {
    __typename?: 'Event'
    agbUrl?: Maybe<Scalars['String']['output']>
    artists: Array<Speaker>
    booths: Array<Booth>
    companyLogoUrl?: Maybe<Scalars['String']['output']>
    companyName?: Maybe<Scalars['String']['output']>
    companyWebsite?: Maybe<Scalars['String']['output']>
    connectedEvent: Array<Event>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    digitalOnly?: Maybe<Scalars['Boolean']['output']>
    /** Get the document in other stages */
    documentInStages: Array<Event>
    duration?: Maybe<Scalars['String']['output']>
    enableCheckin?: Maybe<Scalars['Boolean']['output']>
    endDateTime?: Maybe<Scalars['DateTime']['output']>
    eventAppPageContentEvent: Array<EventAppPage>
    eventFormat?: Maybe<Scalars['String']['output']>
    eventStage?: Maybe<EventStage>
    exhibitors: Array<PartnerCompany>
    externalEvent?: Maybe<Scalars['Boolean']['output']>
    externalEventUrl?: Maybe<Scalars['String']['output']>
    featuredImage?: Maybe<Asset>
    footerAddress?: Maybe<Scalars['String']['output']>
    footerCompany?: Maybe<Scalars['String']['output']>
    /** List of Event versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    language?: Maybe<Scalars['String']['output']>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Event>
    locationAddress?: Maybe<Scalars['String']['output']>
    locationName?: Maybe<Scalars['String']['output']>
    /** also knows as title */
    name: Scalars['String']['output']
    parentEvent?: Maybe<Event>
    privacyUrl?: Maybe<Scalars['String']['output']>
    published?: Maybe<Scalars['Boolean']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    speakers: Array<Speaker>
    /** System stage field */
    stage: Stage
    startDateTime?: Maybe<Scalars['DateTime']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    type?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    website?: Maybe<Scalars['String']['output']>
  }

export type EventArtistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SpeakerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerWhereInput>
}

export type EventBoothsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<BoothOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BoothWhereInput>
}

export type EventConnectedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventWhereInput>
}

export type EventCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type EventEventAppPageContentEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventAppPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventAppPageWhereInput>
}

export type EventEventStageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventExhibitorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PartnerCompanyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PartnerCompanyWhereInput>
}

export type EventFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type EventHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type EventLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type EventParentEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type EventSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SpeakerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerWhereInput>
}

export type EventUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Event app Ad */
export type EventAppAd = Entity & {
  __typename?: 'EventAppAd'
  analyticsRef?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  image?: Maybe<Asset>
  link?: Maybe<Scalars['String']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<EventAppAd>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Event app Ad */
export type EventAppAdImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Event app Ad */
export type EventAppAdLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Event app Ad */
export type EventAppAdUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventAppAdConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EventAppAdWhereUniqueInput
}

/** A connection to a list of items. */
export type EventAppAdConnection = {
  __typename?: 'EventAppAdConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EventAppAdEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EventAppAdCreateInput = {
  /** analyticsRef input for default locale (de) */
  analyticsRef?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<AssetCreateOneInlineInput>
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EventAppAdCreateLocalizationsInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppAdCreateLocalizationDataInput = {
  analyticsRef?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppAdCreateLocalizationInput = {
  /** Localization input */
  data: EventAppAdCreateLocalizationDataInput
  locale: Locale
}

export type EventAppAdCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EventAppAdCreateLocalizationInput>>
}

export type EventAppAdCreateManyInlineInput = {
  /** Create and connect multiple existing EventAppAd documents */
  create?: InputMaybe<Array<EventAppAdCreateInput>>
}

export type EventAppAdCreateOneInlineInput = {
  /** Create and connect one EventAppAd document */
  create?: InputMaybe<EventAppAdCreateInput>
}

export type EventAppAdCreateWithPositionInput = {
  /** Document to create */
  data: EventAppAdCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type EventAppAdEdge = {
  __typename?: 'EventAppAdEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EventAppAd
}

/** Identifies documents */
export type EventAppAdManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppAdWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppAdWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppAdWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum EventAppAdOrderByInput {
  AnalyticsRefAsc = 'analyticsRef_ASC',
  AnalyticsRefDesc = 'analyticsRef_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EventAppAdParent = EventAppPage

export type EventAppAdParentConnectInput = {
  EventAppPage?: InputMaybe<EventAppPageConnectInput>
}

export type EventAppAdParentCreateInput = {
  EventAppPage?: InputMaybe<EventAppPageCreateInput>
}

export type EventAppAdParentCreateManyInlineInput = {
  /** Connect multiple existing EventAppAdParent documents */
  connect?: InputMaybe<Array<EventAppAdParentWhereUniqueInput>>
  /** Create and connect multiple existing EventAppAdParent documents */
  create?: InputMaybe<Array<EventAppAdParentCreateInput>>
}

export type EventAppAdParentCreateOneInlineInput = {
  /** Connect one existing EventAppAdParent document */
  connect?: InputMaybe<EventAppAdParentWhereUniqueInput>
  /** Create and connect one EventAppAdParent document */
  create?: InputMaybe<EventAppAdParentCreateInput>
}

export type EventAppAdParentUpdateInput = {
  EventAppPage?: InputMaybe<EventAppPageUpdateInput>
}

export type EventAppAdParentUpdateManyInlineInput = {
  /** Connect multiple existing EventAppAdParent documents */
  connect?: InputMaybe<Array<EventAppAdParentConnectInput>>
  /** Create and connect multiple EventAppAdParent documents */
  create?: InputMaybe<Array<EventAppAdParentCreateInput>>
  /** Delete multiple EventAppAdParent documents */
  delete?: InputMaybe<Array<EventAppAdParentWhereUniqueInput>>
  /** Disconnect multiple EventAppAdParent documents */
  disconnect?: InputMaybe<Array<EventAppAdParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing EventAppAdParent documents */
  set?: InputMaybe<Array<EventAppAdParentWhereUniqueInput>>
  /** Update multiple EventAppAdParent documents */
  update?: InputMaybe<Array<EventAppAdParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple EventAppAdParent documents */
  upsert?: InputMaybe<Array<EventAppAdParentUpsertWithNestedWhereUniqueInput>>
}

export type EventAppAdParentUpdateManyWithNestedWhereInput = {
  EventAppPage?: InputMaybe<EventAppPageUpdateManyWithNestedWhereInput>
}

export type EventAppAdParentUpdateOneInlineInput = {
  /** Connect existing EventAppAdParent document */
  connect?: InputMaybe<EventAppAdParentWhereUniqueInput>
  /** Create and connect one EventAppAdParent document */
  create?: InputMaybe<EventAppAdParentCreateInput>
  /** Delete currently connected EventAppAdParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected EventAppAdParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppAdParent document */
  update?: InputMaybe<EventAppAdParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppAdParent document */
  upsert?: InputMaybe<EventAppAdParentUpsertWithNestedWhereUniqueInput>
}

export type EventAppAdParentUpdateWithNestedWhereUniqueInput = {
  EventAppPage?: InputMaybe<EventAppPageUpdateWithNestedWhereUniqueInput>
}

export type EventAppAdParentUpsertWithNestedWhereUniqueInput = {
  EventAppPage?: InputMaybe<EventAppPageUpsertWithNestedWhereUniqueInput>
}

export type EventAppAdParentWhereInput = {
  EventAppPage?: InputMaybe<EventAppPageWhereInput>
}

export type EventAppAdParentWhereUniqueInput = {
  EventAppPage?: InputMaybe<EventAppPageWhereUniqueInput>
}

export type EventAppAdUpdateInput = {
  /** analyticsRef input for default locale (de) */
  analyticsRef?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<EventAppAdUpdateLocalizationsInput>
}

export type EventAppAdUpdateLocalizationDataInput = {
  analyticsRef?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<Scalars['String']['input']>
}

export type EventAppAdUpdateLocalizationInput = {
  data: EventAppAdUpdateLocalizationDataInput
  locale: Locale
}

export type EventAppAdUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EventAppAdCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppAdUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EventAppAdUpsertLocalizationInput>>
}

export type EventAppAdUpdateManyInlineInput = {
  /** Create and connect multiple EventAppAd component instances */
  create?: InputMaybe<Array<EventAppAdCreateWithPositionInput>>
  /** Delete multiple EventAppAd documents */
  delete?: InputMaybe<Array<EventAppAdWhereUniqueInput>>
  /** Update multiple EventAppAd component instances */
  update?: InputMaybe<Array<EventAppAdUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple EventAppAd component instances */
  upsert?: InputMaybe<Array<EventAppAdUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type EventAppAdUpdateManyInput = {
  /** analyticsRef input for default locale (de) */
  analyticsRef?: InputMaybe<Scalars['String']['input']>
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<EventAppAdUpdateManyLocalizationsInput>
}

export type EventAppAdUpdateManyLocalizationDataInput = {
  analyticsRef?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<Scalars['String']['input']>
}

export type EventAppAdUpdateManyLocalizationInput = {
  data: EventAppAdUpdateManyLocalizationDataInput
  locale: Locale
}

export type EventAppAdUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppAdUpdateManyLocalizationInput>>
}

export type EventAppAdUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EventAppAdUpdateManyInput
  /** Document search */
  where: EventAppAdWhereInput
}

export type EventAppAdUpdateOneInlineInput = {
  /** Create and connect one EventAppAd document */
  create?: InputMaybe<EventAppAdCreateInput>
  /** Delete currently connected EventAppAd document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppAd document */
  update?: InputMaybe<EventAppAdUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppAd document */
  upsert?: InputMaybe<EventAppAdUpsertWithNestedWhereUniqueInput>
}

export type EventAppAdUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<EventAppAdUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: EventAppAdWhereUniqueInput
}

export type EventAppAdUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EventAppAdUpdateInput
  /** Unique document search */
  where: EventAppAdWhereUniqueInput
}

export type EventAppAdUpsertInput = {
  /** Create document if it didn't exist */
  create: EventAppAdCreateInput
  /** Update document if it exists */
  update: EventAppAdUpdateInput
}

export type EventAppAdUpsertLocalizationInput = {
  create: EventAppAdCreateLocalizationDataInput
  locale: Locale
  update: EventAppAdUpdateLocalizationDataInput
}

export type EventAppAdUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<EventAppAdUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: EventAppAdWhereUniqueInput
}

export type EventAppAdUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EventAppAdUpsertInput
  /** Unique document search */
  where: EventAppAdWhereUniqueInput
}

/** Identifies documents */
export type EventAppAdWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppAdWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppAdWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppAdWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  analyticsRef?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  analyticsRef_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  analyticsRef_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  analyticsRef_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  analyticsRef_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  analyticsRef_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  analyticsRef_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  analyticsRef_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  analyticsRef_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  analyticsRef_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  link?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References EventAppAd record uniquely */
export type EventAppAdWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** [EventApp] Card component */
export type EventAppCard = Entity & {
  __typename?: 'EventAppCard'
  content?: Maybe<EventAppCardContent>
  extraContent: Array<HubPageContentTile>
  /** The unique identifier */
  id: Scalars['ID']['output']
  image?: Maybe<Asset>
  interests: Array<Interest>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<EventAppCard>
  newsletterSubscriptionTile?: Maybe<HubPageNewsletterSubscriptionTile>
  /** Add the slug at the end of this url com.omr.app://discover/content-details/ and use it to generate a QR code here https://www.qr-code-generator.com/ */
  slug?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** please select custom if you want to add content */
  type: EventAppCardType
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** [EventApp] Card component */
export type EventAppCardContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** [EventApp] Card component */
export type EventAppCardExtraContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<HubPageContentTileOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubPageContentTileWhereInput>
}

/** [EventApp] Card component */
export type EventAppCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** [EventApp] Card component */
export type EventAppCardInterestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestWhereInput>
}

/** [EventApp] Card component */
export type EventAppCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** [EventApp] Card component */
export type EventAppCardNewsletterSubscriptionTileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** [EventApp] Card component */
export type EventAppCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventAppCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EventAppCardWhereUniqueInput
}

/** A connection to a list of items. */
export type EventAppCardConnection = {
  __typename?: 'EventAppCardConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EventAppCardEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** [EventApp] Text Content: Simple article title with markdown body used on festival mobile app to show content */
export type EventAppCardContent = Entity & {
  __typename?: 'EventAppCardContent'
  body: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<EventAppCardContent>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** [EventApp] Text Content: Simple article title with markdown body used on festival mobile app to show content */
export type EventAppCardContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** [EventApp] Text Content: Simple article title with markdown body used on festival mobile app to show content */
export type EventAppCardContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventAppCardContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EventAppCardContentWhereUniqueInput
}

/** A connection to a list of items. */
export type EventAppCardContentConnection = {
  __typename?: 'EventAppCardContentConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EventAppCardContentEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EventAppCardContentCreateInput = {
  /** body input for default locale (de) */
  body: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EventAppCardContentCreateLocalizationsInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppCardContentCreateLocalizationDataInput = {
  body: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppCardContentCreateLocalizationInput = {
  /** Localization input */
  data: EventAppCardContentCreateLocalizationDataInput
  locale: Locale
}

export type EventAppCardContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EventAppCardContentCreateLocalizationInput>>
}

export type EventAppCardContentCreateManyInlineInput = {
  /** Create and connect multiple existing EventAppCardContent documents */
  create?: InputMaybe<Array<EventAppCardContentCreateInput>>
}

export type EventAppCardContentCreateOneInlineInput = {
  /** Create and connect one EventAppCardContent document */
  create?: InputMaybe<EventAppCardContentCreateInput>
}

export type EventAppCardContentCreateWithPositionInput = {
  /** Document to create */
  data: EventAppCardContentCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type EventAppCardContentEdge = {
  __typename?: 'EventAppCardContentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EventAppCardContent
}

/** Identifies documents */
export type EventAppCardContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppCardContentWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppCardContentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppCardContentWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum EventAppCardContentOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EventAppCardContentParent = EventAppCard

export type EventAppCardContentParentConnectInput = {
  EventAppCard?: InputMaybe<EventAppCardConnectInput>
}

export type EventAppCardContentParentCreateInput = {
  EventAppCard?: InputMaybe<EventAppCardCreateInput>
}

export type EventAppCardContentParentCreateManyInlineInput = {
  /** Create and connect multiple existing EventAppCardContentParent documents */
  create?: InputMaybe<Array<EventAppCardContentParentCreateInput>>
}

export type EventAppCardContentParentCreateOneInlineInput = {
  /** Create and connect one EventAppCardContentParent document */
  create?: InputMaybe<EventAppCardContentParentCreateInput>
}

export type EventAppCardContentParentCreateWithPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardCreateWithPositionInput>
}

export type EventAppCardContentParentUpdateInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateInput>
}

export type EventAppCardContentParentUpdateManyInlineInput = {
  /** Create and connect multiple EventAppCardContentParent component instances */
  create?: InputMaybe<Array<EventAppCardContentParentCreateWithPositionInput>>
  /** Delete multiple EventAppCardContentParent documents */
  delete?: InputMaybe<Array<EventAppCardContentParentWhereUniqueInput>>
  /** Update multiple EventAppCardContentParent component instances */
  update?: InputMaybe<Array<EventAppCardContentParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple EventAppCardContentParent component instances */
  upsert?: InputMaybe<Array<EventAppCardContentParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type EventAppCardContentParentUpdateManyWithNestedWhereInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateManyWithNestedWhereInput>
}

export type EventAppCardContentParentUpdateOneInlineInput = {
  /** Create and connect one EventAppCardContentParent document */
  create?: InputMaybe<EventAppCardContentParentCreateInput>
  /** Delete currently connected EventAppCardContentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppCardContentParent document */
  update?: InputMaybe<EventAppCardContentParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppCardContentParent document */
  upsert?: InputMaybe<EventAppCardContentParentUpsertWithNestedWhereUniqueInput>
}

export type EventAppCardContentParentUpdateWithNestedWhereUniqueAndPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateWithNestedWhereUniqueAndPositionInput>
}

export type EventAppCardContentParentUpdateWithNestedWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateWithNestedWhereUniqueInput>
}

export type EventAppCardContentParentUpsertWithNestedWhereUniqueAndPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardUpsertWithNestedWhereUniqueAndPositionInput>
}

export type EventAppCardContentParentUpsertWithNestedWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardUpsertWithNestedWhereUniqueInput>
}

export type EventAppCardContentParentWhereInput = {
  EventAppCard?: InputMaybe<EventAppCardWhereInput>
}

export type EventAppCardContentParentWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardWhereUniqueInput>
}

export type EventAppCardContentUpdateInput = {
  /** body input for default locale (de) */
  body?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<EventAppCardContentUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppCardContentUpdateLocalizationDataInput = {
  body?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppCardContentUpdateLocalizationInput = {
  data: EventAppCardContentUpdateLocalizationDataInput
  locale: Locale
}

export type EventAppCardContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EventAppCardContentCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppCardContentUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EventAppCardContentUpsertLocalizationInput>>
}

export type EventAppCardContentUpdateManyInlineInput = {
  /** Create and connect multiple EventAppCardContent component instances */
  create?: InputMaybe<Array<EventAppCardContentCreateWithPositionInput>>
  /** Delete multiple EventAppCardContent documents */
  delete?: InputMaybe<Array<EventAppCardContentWhereUniqueInput>>
  /** Update multiple EventAppCardContent component instances */
  update?: InputMaybe<Array<EventAppCardContentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple EventAppCardContent component instances */
  upsert?: InputMaybe<Array<EventAppCardContentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type EventAppCardContentUpdateManyInput = {
  /** body input for default locale (de) */
  body?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<EventAppCardContentUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppCardContentUpdateManyLocalizationDataInput = {
  body?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppCardContentUpdateManyLocalizationInput = {
  data: EventAppCardContentUpdateManyLocalizationDataInput
  locale: Locale
}

export type EventAppCardContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppCardContentUpdateManyLocalizationInput>>
}

export type EventAppCardContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EventAppCardContentUpdateManyInput
  /** Document search */
  where: EventAppCardContentWhereInput
}

export type EventAppCardContentUpdateOneInlineInput = {
  /** Create and connect one EventAppCardContent document */
  create?: InputMaybe<EventAppCardContentCreateInput>
  /** Delete currently connected EventAppCardContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppCardContent document */
  update?: InputMaybe<EventAppCardContentUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppCardContent document */
  upsert?: InputMaybe<EventAppCardContentUpsertWithNestedWhereUniqueInput>
}

export type EventAppCardContentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<EventAppCardContentUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: EventAppCardContentWhereUniqueInput
}

export type EventAppCardContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EventAppCardContentUpdateInput
  /** Unique document search */
  where: EventAppCardContentWhereUniqueInput
}

export type EventAppCardContentUpsertInput = {
  /** Create document if it didn't exist */
  create: EventAppCardContentCreateInput
  /** Update document if it exists */
  update: EventAppCardContentUpdateInput
}

export type EventAppCardContentUpsertLocalizationInput = {
  create: EventAppCardContentCreateLocalizationDataInput
  locale: Locale
  update: EventAppCardContentUpdateLocalizationDataInput
}

export type EventAppCardContentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<EventAppCardContentUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: EventAppCardContentWhereUniqueInput
}

export type EventAppCardContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EventAppCardContentUpsertInput
  /** Unique document search */
  where: EventAppCardContentWhereUniqueInput
}

/** Identifies documents */
export type EventAppCardContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppCardContentWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppCardContentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppCardContentWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  body?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References EventAppCardContent record uniquely */
export type EventAppCardContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type EventAppCardCreateInput = {
  content?: InputMaybe<EventAppCardContentCreateOneInlineInput>
  extraContent?: InputMaybe<HubPageContentTileCreateManyInlineInput>
  image?: InputMaybe<AssetCreateOneInlineInput>
  interests?: InputMaybe<InterestCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EventAppCardCreateLocalizationsInput>
  newsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileCreateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  type: EventAppCardType
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppCardCreateLocalizationDataInput = {
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppCardCreateLocalizationInput = {
  /** Localization input */
  data: EventAppCardCreateLocalizationDataInput
  locale: Locale
}

export type EventAppCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EventAppCardCreateLocalizationInput>>
}

export type EventAppCardCreateManyInlineInput = {
  /** Create and connect multiple existing EventAppCard documents */
  create?: InputMaybe<Array<EventAppCardCreateInput>>
}

export type EventAppCardCreateOneInlineInput = {
  /** Create and connect one EventAppCard document */
  create?: InputMaybe<EventAppCardCreateInput>
}

export type EventAppCardCreateWithPositionInput = {
  /** Document to create */
  data: EventAppCardCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type EventAppCardEdge = {
  __typename?: 'EventAppCardEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EventAppCard
}

/** Identifies documents */
export type EventAppCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppCardWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppCardWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppCardWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  content?: InputMaybe<EventAppCardContentWhereInput>
  extraContent_every?: InputMaybe<HubPageContentTileWhereInput>
  extraContent_none?: InputMaybe<HubPageContentTileWhereInput>
  extraContent_some?: InputMaybe<HubPageContentTileWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  interests_every?: InputMaybe<InterestWhereInput>
  interests_none?: InputMaybe<InterestWhereInput>
  interests_some?: InputMaybe<InterestWhereInput>
  newsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<EventAppCardType>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<EventAppCardType>>>
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<EventAppCardType>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<EventAppCardType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum EventAppCardOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EventAppCardParent = EventAppSection

export type EventAppCardParentConnectInput = {
  EventAppSection?: InputMaybe<EventAppSectionConnectInput>
}

export type EventAppCardParentCreateInput = {
  EventAppSection?: InputMaybe<EventAppSectionCreateInput>
}

export type EventAppCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing EventAppCardParent documents */
  create?: InputMaybe<Array<EventAppCardParentCreateInput>>
}

export type EventAppCardParentCreateOneInlineInput = {
  /** Create and connect one EventAppCardParent document */
  create?: InputMaybe<EventAppCardParentCreateInput>
}

export type EventAppCardParentCreateWithPositionInput = {
  EventAppSection?: InputMaybe<EventAppSectionCreateWithPositionInput>
}

export type EventAppCardParentUpdateInput = {
  EventAppSection?: InputMaybe<EventAppSectionUpdateInput>
}

export type EventAppCardParentUpdateManyInlineInput = {
  /** Create and connect multiple EventAppCardParent component instances */
  create?: InputMaybe<Array<EventAppCardParentCreateWithPositionInput>>
  /** Delete multiple EventAppCardParent documents */
  delete?: InputMaybe<Array<EventAppCardParentWhereUniqueInput>>
  /** Update multiple EventAppCardParent component instances */
  update?: InputMaybe<Array<EventAppCardParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple EventAppCardParent component instances */
  upsert?: InputMaybe<Array<EventAppCardParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type EventAppCardParentUpdateManyWithNestedWhereInput = {
  EventAppSection?: InputMaybe<EventAppSectionUpdateManyWithNestedWhereInput>
}

export type EventAppCardParentUpdateOneInlineInput = {
  /** Create and connect one EventAppCardParent document */
  create?: InputMaybe<EventAppCardParentCreateInput>
  /** Delete currently connected EventAppCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppCardParent document */
  update?: InputMaybe<EventAppCardParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppCardParent document */
  upsert?: InputMaybe<EventAppCardParentUpsertWithNestedWhereUniqueInput>
}

export type EventAppCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  EventAppSection?: InputMaybe<EventAppSectionUpdateWithNestedWhereUniqueAndPositionInput>
}

export type EventAppCardParentUpdateWithNestedWhereUniqueInput = {
  EventAppSection?: InputMaybe<EventAppSectionUpdateWithNestedWhereUniqueInput>
}

export type EventAppCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  EventAppSection?: InputMaybe<EventAppSectionUpsertWithNestedWhereUniqueAndPositionInput>
}

export type EventAppCardParentUpsertWithNestedWhereUniqueInput = {
  EventAppSection?: InputMaybe<EventAppSectionUpsertWithNestedWhereUniqueInput>
}

export type EventAppCardParentWhereInput = {
  EventAppSection?: InputMaybe<EventAppSectionWhereInput>
}

export type EventAppCardParentWhereUniqueInput = {
  EventAppSection?: InputMaybe<EventAppSectionWhereUniqueInput>
}

export enum EventAppCardType {
  Artists = 'artists',
  Custom = 'custom',
  Exhibitors = 'exhibitors',
  Gastro = 'gastro',
  GuidedTours = 'guided_tours',
  Journey = 'journey',
  Masterclasses = 'masterclasses',
  SideEvents = 'side_events',
  Speakers = 'speakers',
}

export type EventAppCardUpdateInput = {
  content?: InputMaybe<EventAppCardContentUpdateOneInlineInput>
  extraContent?: InputMaybe<HubPageContentTileUpdateManyInlineInput>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  interests?: InputMaybe<InterestUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<EventAppCardUpdateLocalizationsInput>
  newsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<EventAppCardType>
}

export type EventAppCardUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppCardUpdateLocalizationInput = {
  data: EventAppCardUpdateLocalizationDataInput
  locale: Locale
}

export type EventAppCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EventAppCardCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppCardUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EventAppCardUpsertLocalizationInput>>
}

export type EventAppCardUpdateManyInlineInput = {
  /** Create and connect multiple EventAppCard component instances */
  create?: InputMaybe<Array<EventAppCardCreateWithPositionInput>>
  /** Delete multiple EventAppCard documents */
  delete?: InputMaybe<Array<EventAppCardWhereUniqueInput>>
  /** Update multiple EventAppCard component instances */
  update?: InputMaybe<Array<EventAppCardUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple EventAppCard component instances */
  upsert?: InputMaybe<Array<EventAppCardUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type EventAppCardUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<EventAppCardUpdateManyLocalizationsInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<EventAppCardType>
}

export type EventAppCardUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppCardUpdateManyLocalizationInput = {
  data: EventAppCardUpdateManyLocalizationDataInput
  locale: Locale
}

export type EventAppCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppCardUpdateManyLocalizationInput>>
}

export type EventAppCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EventAppCardUpdateManyInput
  /** Document search */
  where: EventAppCardWhereInput
}

export type EventAppCardUpdateOneInlineInput = {
  /** Create and connect one EventAppCard document */
  create?: InputMaybe<EventAppCardCreateInput>
  /** Delete currently connected EventAppCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppCard document */
  update?: InputMaybe<EventAppCardUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppCard document */
  upsert?: InputMaybe<EventAppCardUpsertWithNestedWhereUniqueInput>
}

export type EventAppCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<EventAppCardUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: EventAppCardWhereUniqueInput
}

export type EventAppCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EventAppCardUpdateInput
  /** Unique document search */
  where: EventAppCardWhereUniqueInput
}

export type EventAppCardUpsertInput = {
  /** Create document if it didn't exist */
  create: EventAppCardCreateInput
  /** Update document if it exists */
  update: EventAppCardUpdateInput
}

export type EventAppCardUpsertLocalizationInput = {
  create: EventAppCardCreateLocalizationDataInput
  locale: Locale
  update: EventAppCardUpdateLocalizationDataInput
}

export type EventAppCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<EventAppCardUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: EventAppCardWhereUniqueInput
}

export type EventAppCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EventAppCardUpsertInput
  /** Unique document search */
  where: EventAppCardWhereUniqueInput
}

/** Identifies documents */
export type EventAppCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppCardWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppCardWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppCardWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  content?: InputMaybe<EventAppCardContentWhereInput>
  extraContent_every?: InputMaybe<HubPageContentTileWhereInput>
  extraContent_none?: InputMaybe<HubPageContentTileWhereInput>
  extraContent_some?: InputMaybe<HubPageContentTileWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  interests_every?: InputMaybe<InterestWhereInput>
  interests_none?: InputMaybe<InterestWhereInput>
  interests_some?: InputMaybe<InterestWhereInput>
  newsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<EventAppCardType>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<EventAppCardType>>>
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<EventAppCardType>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<EventAppCardType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References EventAppCard record uniquely */
export type EventAppCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Event App content */
export type EventAppPage = Entity &
  Node & {
    __typename?: 'EventAppPage'
    ads: Array<EventAppAd>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<EventAppPage>
    event: Event
    heroImage: Asset
    /** List of EventAppPage versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<EventAppPage>
    logo: Array<Asset>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    sections: Array<EventAppSection>
    /** System stage field */
    stage: Stage
    subtitle: Scalars['String']['output']
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Event App content */
export type EventAppPageAdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventAppAdOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventAppAdWhereInput>
}

/** Event App content */
export type EventAppPageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Event App content */
export type EventAppPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Event App content */
export type EventAppPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Event App content */
export type EventAppPageEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Event App content */
export type EventAppPageHeroImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Event App content */
export type EventAppPageHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Event App content */
export type EventAppPageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Event App content */
export type EventAppPageLogoArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<AssetOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AssetWhereInput>
}

/** Event App content */
export type EventAppPagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Event App content */
export type EventAppPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Event App content */
export type EventAppPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Event App content */
export type EventAppPageSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventAppSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventAppSectionWhereInput>
}

/** Event App content */
export type EventAppPageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Event App content */
export type EventAppPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventAppPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EventAppPageWhereUniqueInput
}

/** A connection to a list of items. */
export type EventAppPageConnection = {
  __typename?: 'EventAppPageConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EventAppPageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EventAppPageCreateInput = {
  ads?: InputMaybe<EventAppAdCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  event: EventCreateOneInlineInput
  heroImage: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EventAppPageCreateLocalizationsInput>
  logo?: InputMaybe<AssetCreateManyInlineInput>
  sections?: InputMaybe<EventAppSectionCreateManyInlineInput>
  /** subtitle input for default locale (de) */
  subtitle: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  subtitle: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppPageCreateLocalizationInput = {
  /** Localization input */
  data: EventAppPageCreateLocalizationDataInput
  locale: Locale
}

export type EventAppPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EventAppPageCreateLocalizationInput>>
}

export type EventAppPageCreateManyInlineInput = {
  /** Connect multiple existing EventAppPage documents */
  connect?: InputMaybe<Array<EventAppPageWhereUniqueInput>>
  /** Create and connect multiple existing EventAppPage documents */
  create?: InputMaybe<Array<EventAppPageCreateInput>>
}

export type EventAppPageCreateOneInlineInput = {
  /** Connect one existing EventAppPage document */
  connect?: InputMaybe<EventAppPageWhereUniqueInput>
  /** Create and connect one EventAppPage document */
  create?: InputMaybe<EventAppPageCreateInput>
}

/** An edge in a connection. */
export type EventAppPageEdge = {
  __typename?: 'EventAppPageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EventAppPage
}

/** Identifies documents */
export type EventAppPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ads_every?: InputMaybe<EventAppAdWhereInput>
  ads_none?: InputMaybe<EventAppAdWhereInput>
  ads_some?: InputMaybe<EventAppAdWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<EventAppPageWhereStageInput>
  documentInStages_none?: InputMaybe<EventAppPageWhereStageInput>
  documentInStages_some?: InputMaybe<EventAppPageWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  heroImage?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo_every?: InputMaybe<AssetWhereInput>
  logo_none?: InputMaybe<AssetWhereInput>
  logo_some?: InputMaybe<AssetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  sections_every?: InputMaybe<EventAppSectionWhereInput>
  sections_none?: InputMaybe<EventAppSectionWhereInput>
  sections_some?: InputMaybe<EventAppSectionWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum EventAppPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EventAppPageUpdateInput = {
  ads?: InputMaybe<EventAppAdUpdateManyInlineInput>
  event?: InputMaybe<EventUpdateOneInlineInput>
  heroImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<EventAppPageUpdateLocalizationsInput>
  logo?: InputMaybe<AssetUpdateManyInlineInput>
  sections?: InputMaybe<EventAppSectionUpdateManyInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppPageUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppPageUpdateLocalizationInput = {
  data: EventAppPageUpdateLocalizationDataInput
  locale: Locale
}

export type EventAppPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EventAppPageCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppPageUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EventAppPageUpsertLocalizationInput>>
}

export type EventAppPageUpdateManyInlineInput = {
  /** Connect multiple existing EventAppPage documents */
  connect?: InputMaybe<Array<EventAppPageConnectInput>>
  /** Create and connect multiple EventAppPage documents */
  create?: InputMaybe<Array<EventAppPageCreateInput>>
  /** Delete multiple EventAppPage documents */
  delete?: InputMaybe<Array<EventAppPageWhereUniqueInput>>
  /** Disconnect multiple EventAppPage documents */
  disconnect?: InputMaybe<Array<EventAppPageWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing EventAppPage documents */
  set?: InputMaybe<Array<EventAppPageWhereUniqueInput>>
  /** Update multiple EventAppPage documents */
  update?: InputMaybe<Array<EventAppPageUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple EventAppPage documents */
  upsert?: InputMaybe<Array<EventAppPageUpsertWithNestedWhereUniqueInput>>
}

export type EventAppPageUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<EventAppPageUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppPageUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppPageUpdateManyLocalizationInput = {
  data: EventAppPageUpdateManyLocalizationDataInput
  locale: Locale
}

export type EventAppPageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppPageUpdateManyLocalizationInput>>
}

export type EventAppPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EventAppPageUpdateManyInput
  /** Document search */
  where: EventAppPageWhereInput
}

export type EventAppPageUpdateOneInlineInput = {
  /** Connect existing EventAppPage document */
  connect?: InputMaybe<EventAppPageWhereUniqueInput>
  /** Create and connect one EventAppPage document */
  create?: InputMaybe<EventAppPageCreateInput>
  /** Delete currently connected EventAppPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected EventAppPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppPage document */
  update?: InputMaybe<EventAppPageUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppPage document */
  upsert?: InputMaybe<EventAppPageUpsertWithNestedWhereUniqueInput>
}

export type EventAppPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EventAppPageUpdateInput
  /** Unique document search */
  where: EventAppPageWhereUniqueInput
}

export type EventAppPageUpsertInput = {
  /** Create document if it didn't exist */
  create: EventAppPageCreateInput
  /** Update document if it exists */
  update: EventAppPageUpdateInput
}

export type EventAppPageUpsertLocalizationInput = {
  create: EventAppPageCreateLocalizationDataInput
  locale: Locale
  update: EventAppPageUpdateLocalizationDataInput
}

export type EventAppPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EventAppPageUpsertInput
  /** Unique document search */
  where: EventAppPageWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type EventAppPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type EventAppPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ads_every?: InputMaybe<EventAppAdWhereInput>
  ads_none?: InputMaybe<EventAppAdWhereInput>
  ads_some?: InputMaybe<EventAppAdWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<EventAppPageWhereStageInput>
  documentInStages_none?: InputMaybe<EventAppPageWhereStageInput>
  documentInStages_some?: InputMaybe<EventAppPageWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  heroImage?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo_every?: InputMaybe<AssetWhereInput>
  logo_none?: InputMaybe<AssetWhereInput>
  logo_some?: InputMaybe<AssetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  sections_every?: InputMaybe<EventAppSectionWhereInput>
  sections_none?: InputMaybe<EventAppSectionWhereInput>
  sections_some?: InputMaybe<EventAppSectionWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type EventAppPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppPageWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppPageWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppPageWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<EventAppPageWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References EventAppPage record uniquely */
export type EventAppPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** [EventApp] Section component */
export type EventAppSection = Entity & {
  __typename?: 'EventAppSection'
  cards: Array<EventAppCard>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<EventAppSection>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** [EventApp] Section component */
export type EventAppSectionCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventAppCardOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventAppCardWhereInput>
}

/** [EventApp] Section component */
export type EventAppSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** [EventApp] Section component */
export type EventAppSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventAppSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EventAppSectionWhereUniqueInput
}

/** A connection to a list of items. */
export type EventAppSectionConnection = {
  __typename?: 'EventAppSectionConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EventAppSectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EventAppSectionCreateInput = {
  cards?: InputMaybe<EventAppCardCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EventAppSectionCreateLocalizationsInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppSectionCreateLocalizationDataInput = {
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventAppSectionCreateLocalizationInput = {
  /** Localization input */
  data: EventAppSectionCreateLocalizationDataInput
  locale: Locale
}

export type EventAppSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EventAppSectionCreateLocalizationInput>>
}

export type EventAppSectionCreateManyInlineInput = {
  /** Create and connect multiple existing EventAppSection documents */
  create?: InputMaybe<Array<EventAppSectionCreateInput>>
}

export type EventAppSectionCreateOneInlineInput = {
  /** Create and connect one EventAppSection document */
  create?: InputMaybe<EventAppSectionCreateInput>
}

export type EventAppSectionCreateWithPositionInput = {
  /** Document to create */
  data: EventAppSectionCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type EventAppSectionEdge = {
  __typename?: 'EventAppSectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EventAppSection
}

/** Identifies documents */
export type EventAppSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cards_every?: InputMaybe<EventAppCardWhereInput>
  cards_none?: InputMaybe<EventAppCardWhereInput>
  cards_some?: InputMaybe<EventAppCardWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum EventAppSectionOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EventAppSectionParent = EventAppPage

export type EventAppSectionParentConnectInput = {
  EventAppPage?: InputMaybe<EventAppPageConnectInput>
}

export type EventAppSectionParentCreateInput = {
  EventAppPage?: InputMaybe<EventAppPageCreateInput>
}

export type EventAppSectionParentCreateManyInlineInput = {
  /** Connect multiple existing EventAppSectionParent documents */
  connect?: InputMaybe<Array<EventAppSectionParentWhereUniqueInput>>
  /** Create and connect multiple existing EventAppSectionParent documents */
  create?: InputMaybe<Array<EventAppSectionParentCreateInput>>
}

export type EventAppSectionParentCreateOneInlineInput = {
  /** Connect one existing EventAppSectionParent document */
  connect?: InputMaybe<EventAppSectionParentWhereUniqueInput>
  /** Create and connect one EventAppSectionParent document */
  create?: InputMaybe<EventAppSectionParentCreateInput>
}

export type EventAppSectionParentUpdateInput = {
  EventAppPage?: InputMaybe<EventAppPageUpdateInput>
}

export type EventAppSectionParentUpdateManyInlineInput = {
  /** Connect multiple existing EventAppSectionParent documents */
  connect?: InputMaybe<Array<EventAppSectionParentConnectInput>>
  /** Create and connect multiple EventAppSectionParent documents */
  create?: InputMaybe<Array<EventAppSectionParentCreateInput>>
  /** Delete multiple EventAppSectionParent documents */
  delete?: InputMaybe<Array<EventAppSectionParentWhereUniqueInput>>
  /** Disconnect multiple EventAppSectionParent documents */
  disconnect?: InputMaybe<Array<EventAppSectionParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing EventAppSectionParent documents */
  set?: InputMaybe<Array<EventAppSectionParentWhereUniqueInput>>
  /** Update multiple EventAppSectionParent documents */
  update?: InputMaybe<Array<EventAppSectionParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple EventAppSectionParent documents */
  upsert?: InputMaybe<Array<EventAppSectionParentUpsertWithNestedWhereUniqueInput>>
}

export type EventAppSectionParentUpdateManyWithNestedWhereInput = {
  EventAppPage?: InputMaybe<EventAppPageUpdateManyWithNestedWhereInput>
}

export type EventAppSectionParentUpdateOneInlineInput = {
  /** Connect existing EventAppSectionParent document */
  connect?: InputMaybe<EventAppSectionParentWhereUniqueInput>
  /** Create and connect one EventAppSectionParent document */
  create?: InputMaybe<EventAppSectionParentCreateInput>
  /** Delete currently connected EventAppSectionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected EventAppSectionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppSectionParent document */
  update?: InputMaybe<EventAppSectionParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppSectionParent document */
  upsert?: InputMaybe<EventAppSectionParentUpsertWithNestedWhereUniqueInput>
}

export type EventAppSectionParentUpdateWithNestedWhereUniqueInput = {
  EventAppPage?: InputMaybe<EventAppPageUpdateWithNestedWhereUniqueInput>
}

export type EventAppSectionParentUpsertWithNestedWhereUniqueInput = {
  EventAppPage?: InputMaybe<EventAppPageUpsertWithNestedWhereUniqueInput>
}

export type EventAppSectionParentWhereInput = {
  EventAppPage?: InputMaybe<EventAppPageWhereInput>
}

export type EventAppSectionParentWhereUniqueInput = {
  EventAppPage?: InputMaybe<EventAppPageWhereUniqueInput>
}

export type EventAppSectionUpdateInput = {
  cards?: InputMaybe<EventAppCardUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<EventAppSectionUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppSectionUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppSectionUpdateLocalizationInput = {
  data: EventAppSectionUpdateLocalizationDataInput
  locale: Locale
}

export type EventAppSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EventAppSectionCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppSectionUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EventAppSectionUpsertLocalizationInput>>
}

export type EventAppSectionUpdateManyInlineInput = {
  /** Create and connect multiple EventAppSection component instances */
  create?: InputMaybe<Array<EventAppSectionCreateWithPositionInput>>
  /** Delete multiple EventAppSection documents */
  delete?: InputMaybe<Array<EventAppSectionWhereUniqueInput>>
  /** Update multiple EventAppSection component instances */
  update?: InputMaybe<Array<EventAppSectionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple EventAppSection component instances */
  upsert?: InputMaybe<Array<EventAppSectionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type EventAppSectionUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<EventAppSectionUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppSectionUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type EventAppSectionUpdateManyLocalizationInput = {
  data: EventAppSectionUpdateManyLocalizationDataInput
  locale: Locale
}

export type EventAppSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EventAppSectionUpdateManyLocalizationInput>>
}

export type EventAppSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EventAppSectionUpdateManyInput
  /** Document search */
  where: EventAppSectionWhereInput
}

export type EventAppSectionUpdateOneInlineInput = {
  /** Create and connect one EventAppSection document */
  create?: InputMaybe<EventAppSectionCreateInput>
  /** Delete currently connected EventAppSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventAppSection document */
  update?: InputMaybe<EventAppSectionUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventAppSection document */
  upsert?: InputMaybe<EventAppSectionUpsertWithNestedWhereUniqueInput>
}

export type EventAppSectionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<EventAppSectionUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: EventAppSectionWhereUniqueInput
}

export type EventAppSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EventAppSectionUpdateInput
  /** Unique document search */
  where: EventAppSectionWhereUniqueInput
}

export type EventAppSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: EventAppSectionCreateInput
  /** Update document if it exists */
  update: EventAppSectionUpdateInput
}

export type EventAppSectionUpsertLocalizationInput = {
  create: EventAppSectionCreateLocalizationDataInput
  locale: Locale
  update: EventAppSectionUpdateLocalizationDataInput
}

export type EventAppSectionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<EventAppSectionUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: EventAppSectionWhereUniqueInput
}

export type EventAppSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EventAppSectionUpsertInput
  /** Unique document search */
  where: EventAppSectionWhereUniqueInput
}

/** Identifies documents */
export type EventAppSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventAppSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventAppSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventAppSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cards_every?: InputMaybe<EventAppCardWhereInput>
  cards_none?: InputMaybe<EventAppCardWhereInput>
  cards_some?: InputMaybe<EventAppCardWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References EventAppSection record uniquely */
export type EventAppSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type EventConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EventWhereUniqueInput
}

/** A connection to a list of items. */
export type EventConnection = {
  __typename?: 'EventConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EventEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EventCreateInput = {
  agbUrl?: InputMaybe<Scalars['String']['input']>
  artists?: InputMaybe<SpeakerCreateManyInlineInput>
  booths?: InputMaybe<BoothCreateManyInlineInput>
  clai9mwl31it101tccfahfkdl?: InputMaybe<EventPageCreateManyInlineInput>
  cle5lekfc1l7l01ul0hgghv9f?: InputMaybe<BoothCreateManyInlineInput>
  companyLogoUrl?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  companyWebsite?: InputMaybe<Scalars['String']['input']>
  connectedEvent?: InputMaybe<EventCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  digitalOnly?: InputMaybe<Scalars['Boolean']['input']>
  duration?: InputMaybe<Scalars['String']['input']>
  enableCheckin?: InputMaybe<Scalars['Boolean']['input']>
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>
  event?: InputMaybe<NotificationCreateOneInlineInput>
  eventAppPageContentEvent?: InputMaybe<EventAppPageCreateManyInlineInput>
  eventFormat?: InputMaybe<Scalars['String']['input']>
  eventStage?: InputMaybe<EventStageCreateOneInlineInput>
  exhibitorFullListEvent?: InputMaybe<SectionMyomrExhibitorsListCreateManyInlineInput>
  exhibitorOrderEvent?: InputMaybe<ExhibitorListOrderCreateManyInlineInput>
  exhibitors?: InputMaybe<PartnerCompanyCreateManyInlineInput>
  externalEvent?: InputMaybe<Scalars['Boolean']['input']>
  externalEventUrl?: InputMaybe<Scalars['String']['input']>
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>
  footerAddress?: InputMaybe<Scalars['String']['input']>
  footerCompany?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EventCreateLocalizationsInput>
  locationAddress?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  parentEvent?: InputMaybe<EventCreateOneInlineInput>
  privacyUrl?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  sectionMyomrExhibitorsEvent?: InputMaybe<SectionMyomrExhibitorsCreateManyInlineInput>
  sectionSpeakersEvent?: InputMaybe<SectionSpeakersCreateManyInlineInput>
  slug: Scalars['String']['input']
  speakerOrderEvent?: InputMaybe<SpeakerListOrderCreateManyInlineInput>
  speakers?: InputMaybe<SpeakerCreateManyInlineInput>
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type EventCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventCreateLocalizationInput = {
  /** Localization input */
  data: EventCreateLocalizationDataInput
  locale: Locale
}

export type EventCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EventCreateLocalizationInput>>
}

export type EventCreateManyInlineInput = {
  /** Connect multiple existing Event documents */
  connect?: InputMaybe<Array<EventWhereUniqueInput>>
  /** Create and connect multiple existing Event documents */
  create?: InputMaybe<Array<EventCreateInput>>
}

export type EventCreateOneInlineInput = {
  /** Connect one existing Event document */
  connect?: InputMaybe<EventWhereUniqueInput>
  /** Create and connect one Event document */
  create?: InputMaybe<EventCreateInput>
}

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Event
}

/** Identifies documents */
export type EventManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  agbUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  agbUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  agbUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  agbUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  agbUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  agbUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  agbUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  agbUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  agbUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  agbUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  artists_every?: InputMaybe<SpeakerWhereInput>
  artists_none?: InputMaybe<SpeakerWhereInput>
  artists_some?: InputMaybe<SpeakerWhereInput>
  booths_every?: InputMaybe<BoothWhereInput>
  booths_none?: InputMaybe<BoothWhereInput>
  booths_some?: InputMaybe<BoothWhereInput>
  companyLogoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyLogoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  companyLogoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  companyLogoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  companyLogoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  companyLogoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  companyLogoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  companyLogoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  companyLogoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  companyLogoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  companyName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  companyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  companyName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  companyName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  companyName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  companyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  companyName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  companyName_starts_with?: InputMaybe<Scalars['String']['input']>
  companyWebsite?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyWebsite_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  companyWebsite_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  companyWebsite_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  companyWebsite_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  companyWebsite_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  companyWebsite_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  companyWebsite_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  companyWebsite_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  companyWebsite_starts_with?: InputMaybe<Scalars['String']['input']>
  connectedEvent_every?: InputMaybe<EventWhereInput>
  connectedEvent_none?: InputMaybe<EventWhereInput>
  connectedEvent_some?: InputMaybe<EventWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  digitalOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  digitalOnly_not?: InputMaybe<Scalars['Boolean']['input']>
  documentInStages_every?: InputMaybe<EventWhereStageInput>
  documentInStages_none?: InputMaybe<EventWhereStageInput>
  documentInStages_some?: InputMaybe<EventWhereStageInput>
  duration?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  duration_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  duration_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  duration_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  duration_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  duration_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  duration_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  duration_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  duration_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  duration_starts_with?: InputMaybe<Scalars['String']['input']>
  enableCheckin?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableCheckin_not?: InputMaybe<Scalars['Boolean']['input']>
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  endDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  endDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  endDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  endDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  endDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  endDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  endDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  eventAppPageContentEvent_every?: InputMaybe<EventAppPageWhereInput>
  eventAppPageContentEvent_none?: InputMaybe<EventAppPageWhereInput>
  eventAppPageContentEvent_some?: InputMaybe<EventAppPageWhereInput>
  eventFormat?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  eventFormat_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  eventFormat_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  eventFormat_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  eventFormat_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  eventFormat_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  eventFormat_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  eventFormat_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  eventFormat_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  eventFormat_starts_with?: InputMaybe<Scalars['String']['input']>
  eventStage?: InputMaybe<EventStageWhereInput>
  exhibitors_every?: InputMaybe<PartnerCompanyWhereInput>
  exhibitors_none?: InputMaybe<PartnerCompanyWhereInput>
  exhibitors_some?: InputMaybe<PartnerCompanyWhereInput>
  externalEvent?: InputMaybe<Scalars['Boolean']['input']>
  externalEventUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  externalEventUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  externalEventUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  externalEventUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  externalEventUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  externalEventUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  externalEventUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  externalEventUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  externalEventUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  externalEventUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  /** Any other value that exists and is not equal to the given value. */
  externalEvent_not?: InputMaybe<Scalars['Boolean']['input']>
  featuredImage?: InputMaybe<AssetWhereInput>
  footerAddress?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  footerAddress_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  footerAddress_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  footerAddress_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  footerAddress_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  footerAddress_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  footerAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  footerAddress_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  footerAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  footerAddress_starts_with?: InputMaybe<Scalars['String']['input']>
  footerCompany?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  footerCompany_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  footerCompany_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  footerCompany_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  footerCompany_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  footerCompany_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  footerCompany_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  footerCompany_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  footerCompany_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  footerCompany_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  language_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  language_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  language_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  language_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  language_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  language_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  language_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  language_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  language_starts_with?: InputMaybe<Scalars['String']['input']>
  locationAddress?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  locationAddress_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  locationAddress_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  locationAddress_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  locationAddress_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  locationAddress_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  locationAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  locationAddress_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  locationAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  locationAddress_starts_with?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  locationName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  locationName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  locationName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  locationName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  locationName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  locationName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  locationName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  locationName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  locationName_starts_with?: InputMaybe<Scalars['String']['input']>
  parentEvent?: InputMaybe<EventWhereInput>
  privacyUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  privacyUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  privacyUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  privacyUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  privacyUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  privacyUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  privacyUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  privacyUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  privacyUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  privacyUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Boolean']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  speakers_every?: InputMaybe<SpeakerWhereInput>
  speakers_none?: InputMaybe<SpeakerWhereInput>
  speakers_some?: InputMaybe<SpeakerWhereInput>
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  startDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  startDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  startDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  startDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  startDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  startDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  startDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  type_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  type_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  type_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  type_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  website?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum EventOrderByInput {
  AgbUrlAsc = 'agbUrl_ASC',
  AgbUrlDesc = 'agbUrl_DESC',
  CompanyLogoUrlAsc = 'companyLogoUrl_ASC',
  CompanyLogoUrlDesc = 'companyLogoUrl_DESC',
  CompanyNameAsc = 'companyName_ASC',
  CompanyNameDesc = 'companyName_DESC',
  CompanyWebsiteAsc = 'companyWebsite_ASC',
  CompanyWebsiteDesc = 'companyWebsite_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DigitalOnlyAsc = 'digitalOnly_ASC',
  DigitalOnlyDesc = 'digitalOnly_DESC',
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  EnableCheckinAsc = 'enableCheckin_ASC',
  EnableCheckinDesc = 'enableCheckin_DESC',
  EndDateTimeAsc = 'endDateTime_ASC',
  EndDateTimeDesc = 'endDateTime_DESC',
  EventFormatAsc = 'eventFormat_ASC',
  EventFormatDesc = 'eventFormat_DESC',
  ExternalEventUrlAsc = 'externalEventUrl_ASC',
  ExternalEventUrlDesc = 'externalEventUrl_DESC',
  ExternalEventAsc = 'externalEvent_ASC',
  ExternalEventDesc = 'externalEvent_DESC',
  FooterAddressAsc = 'footerAddress_ASC',
  FooterAddressDesc = 'footerAddress_DESC',
  FooterCompanyAsc = 'footerCompany_ASC',
  FooterCompanyDesc = 'footerCompany_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LanguageAsc = 'language_ASC',
  LanguageDesc = 'language_DESC',
  LocationAddressAsc = 'locationAddress_ASC',
  LocationAddressDesc = 'locationAddress_DESC',
  LocationNameAsc = 'locationName_ASC',
  LocationNameDesc = 'locationName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PrivacyUrlAsc = 'privacyUrl_ASC',
  PrivacyUrlDesc = 'privacyUrl_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StartDateTimeAsc = 'startDateTime_ASC',
  StartDateTimeDesc = 'startDateTime_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WebsiteAsc = 'website_ASC',
  WebsiteDesc = 'website_DESC',
}

export type EventPage = Entity &
  Node & {
    __typename?: 'EventPage'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<EventPage>
    event?: Maybe<Event>
    /** List of EventPage versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<EventPage>
    pageLayout: Array<EventPagepageLayoutUnion>
    pageName: Scalars['String']['output']
    /** Parent event page to setup hierarchy between pages. */
    parentPage?: Maybe<EventPage>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    seoSettings?: Maybe<Seo>
    /** Should be unique within the scope of an event */
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

export type EventPageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type EventPageEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventPageHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type EventPageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type EventPagePageLayoutArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

export type EventPageParentPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventPagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type EventPageSeoSettingsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventPageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type EventPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EventPageWhereUniqueInput
}

/** A connection to a list of items. */
export type EventPageConnection = {
  __typename?: 'EventPageConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EventPageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EventPageCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  event?: InputMaybe<EventCreateOneInlineInput>
  eventPage?: InputMaybe<SectionCtaCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EventPageCreateLocalizationsInput>
  pageLayout?: InputMaybe<EventPagepageLayoutUnionCreateManyInlineInput>
  /** pageName input for default locale (de) */
  pageName: Scalars['String']['input']
  pageParents?: InputMaybe<EventPageCreateManyInlineInput>
  parentPage?: InputMaybe<EventPageCreateOneInlineInput>
  seoSettings?: InputMaybe<SeoCreateOneInlineInput>
  slug: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  pageName: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventPageCreateLocalizationInput = {
  /** Localization input */
  data: EventPageCreateLocalizationDataInput
  locale: Locale
}

export type EventPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EventPageCreateLocalizationInput>>
}

export type EventPageCreateManyInlineInput = {
  /** Connect multiple existing EventPage documents */
  connect?: InputMaybe<Array<EventPageWhereUniqueInput>>
  /** Create and connect multiple existing EventPage documents */
  create?: InputMaybe<Array<EventPageCreateInput>>
}

export type EventPageCreateOneInlineInput = {
  /** Connect one existing EventPage document */
  connect?: InputMaybe<EventPageWhereUniqueInput>
  /** Create and connect one EventPage document */
  create?: InputMaybe<EventPageCreateInput>
}

/** An edge in a connection. */
export type EventPageEdge = {
  __typename?: 'EventPageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EventPage
}

/** Identifies documents */
export type EventPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<EventPageWhereStageInput>
  documentInStages_none?: InputMaybe<EventPageWhereStageInput>
  documentInStages_some?: InputMaybe<EventPageWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty. */
  pageLayout_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  pageLayout_some?: InputMaybe<EventPagepageLayoutUnionWhereInput>
  parentPage?: InputMaybe<EventPageWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoSettings?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum EventPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EventPageUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  event?: InputMaybe<EventUpdateOneInlineInput>
  eventPage?: InputMaybe<SectionCtaUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<EventPageUpdateLocalizationsInput>
  pageLayout?: InputMaybe<EventPagepageLayoutUnionUpdateManyInlineInput>
  /** pageName input for default locale (de) */
  pageName?: InputMaybe<Scalars['String']['input']>
  pageParents?: InputMaybe<EventPageUpdateManyInlineInput>
  parentPage?: InputMaybe<EventPageUpdateOneInlineInput>
  seoSettings?: InputMaybe<SeoUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type EventPageUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  pageName?: InputMaybe<Scalars['String']['input']>
}

export type EventPageUpdateLocalizationInput = {
  data: EventPageUpdateLocalizationDataInput
  locale: Locale
}

export type EventPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EventPageCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EventPageUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EventPageUpsertLocalizationInput>>
}

export type EventPageUpdateManyInlineInput = {
  /** Connect multiple existing EventPage documents */
  connect?: InputMaybe<Array<EventPageConnectInput>>
  /** Create and connect multiple EventPage documents */
  create?: InputMaybe<Array<EventPageCreateInput>>
  /** Delete multiple EventPage documents */
  delete?: InputMaybe<Array<EventPageWhereUniqueInput>>
  /** Disconnect multiple EventPage documents */
  disconnect?: InputMaybe<Array<EventPageWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing EventPage documents */
  set?: InputMaybe<Array<EventPageWhereUniqueInput>>
  /** Update multiple EventPage documents */
  update?: InputMaybe<Array<EventPageUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple EventPage documents */
  upsert?: InputMaybe<Array<EventPageUpsertWithNestedWhereUniqueInput>>
}

export type EventPageUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<EventPageUpdateManyLocalizationsInput>
  /** pageName input for default locale (de) */
  pageName?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type EventPageUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  pageName?: InputMaybe<Scalars['String']['input']>
}

export type EventPageUpdateManyLocalizationInput = {
  data: EventPageUpdateManyLocalizationDataInput
  locale: Locale
}

export type EventPageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EventPageUpdateManyLocalizationInput>>
}

export type EventPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EventPageUpdateManyInput
  /** Document search */
  where: EventPageWhereInput
}

export type EventPageUpdateOneInlineInput = {
  /** Connect existing EventPage document */
  connect?: InputMaybe<EventPageWhereUniqueInput>
  /** Create and connect one EventPage document */
  create?: InputMaybe<EventPageCreateInput>
  /** Delete currently connected EventPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected EventPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventPage document */
  update?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventPage document */
  upsert?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type EventPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EventPageUpdateInput
  /** Unique document search */
  where: EventPageWhereUniqueInput
}

export type EventPageUpsertInput = {
  /** Create document if it didn't exist */
  create: EventPageCreateInput
  /** Update document if it exists */
  update: EventPageUpdateInput
}

export type EventPageUpsertLocalizationInput = {
  create: EventPageCreateLocalizationDataInput
  locale: Locale
  update: EventPageUpdateLocalizationDataInput
}

export type EventPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EventPageUpsertInput
  /** Unique document search */
  where: EventPageWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type EventPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type EventPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<EventPageWhereStageInput>
  documentInStages_none?: InputMaybe<EventPageWhereStageInput>
  documentInStages_some?: InputMaybe<EventPageWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty. */
  pageLayout_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  pageLayout_some?: InputMaybe<EventPagepageLayoutUnionWhereInput>
  pageName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pageName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pageName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pageName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pageName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pageName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pageName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pageName_starts_with?: InputMaybe<Scalars['String']['input']>
  parentPage?: InputMaybe<EventPageWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoSettings?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type EventPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventPageWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventPageWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventPageWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<EventPageWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References EventPage record uniquely */
export type EventPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type EventPagepageLayoutUnion =
  | ArticlesByTag
  | BulletPointList
  | Faq
  | ImageSlider
  | PreviewCardList
  | ProcessStep
  | RichContent
  | SectionAnchorTarget
  | SectionAppCta
  | SectionBanner
  | SectionByTheNumbers
  | SectionContact
  | SectionCta
  | SectionDownloads
  | SectionEventOffersTimetable
  | SectionExplanationBlocks
  | SectionFestivalTimetable
  | SectionFlipCounter
  | SectionHero
  | SectionHotel
  | SectionHubspotForm
  | SectionIntro
  | SectionJobList
  | SectionLivestreams
  | SectionManageInterests
  | SectionMap
  | SectionMyomrExhibitors
  | SectionMyomrExhibitorsList
  | SectionNewsletter
  | SectionOmrPartner
  | SectionRecommendations
  | SectionSpeakers
  | SectionStorytelling
  | SectionStyledHero
  | SectionTab
  | SectionTeaser
  | SectionTicketsTable
  | SectionTiles
  | SectionVideo
  | SubscriptionTeaser
  | TestimonialSlider
  | TextMedia

export type EventPagepageLayoutUnionConnectInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagConnectInput>
  BulletPointList?: InputMaybe<BulletPointListConnectInput>
  Faq?: InputMaybe<FaqConnectInput>
  ImageSlider?: InputMaybe<ImageSliderConnectInput>
  PreviewCardList?: InputMaybe<PreviewCardListConnectInput>
  ProcessStep?: InputMaybe<ProcessStepConnectInput>
  RichContent?: InputMaybe<RichContentConnectInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetConnectInput>
  SectionAppCta?: InputMaybe<SectionAppCtaConnectInput>
  SectionBanner?: InputMaybe<SectionBannerConnectInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersConnectInput>
  SectionContact?: InputMaybe<SectionContactConnectInput>
  SectionCta?: InputMaybe<SectionCtaConnectInput>
  SectionDownloads?: InputMaybe<SectionDownloadsConnectInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableConnectInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksConnectInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableConnectInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterConnectInput>
  SectionHero?: InputMaybe<SectionHeroConnectInput>
  SectionHotel?: InputMaybe<SectionHotelConnectInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormConnectInput>
  SectionIntro?: InputMaybe<SectionIntroConnectInput>
  SectionJobList?: InputMaybe<SectionJobListConnectInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsConnectInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsConnectInput>
  SectionMap?: InputMaybe<SectionMapConnectInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsConnectInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListConnectInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterConnectInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerConnectInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsConnectInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersConnectInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingConnectInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroConnectInput>
  SectionTab?: InputMaybe<SectionTabConnectInput>
  SectionTeaser?: InputMaybe<SectionTeaserConnectInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
  SectionVideo?: InputMaybe<SectionVideoConnectInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserConnectInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderConnectInput>
  TextMedia?: InputMaybe<TextMediaConnectInput>
}

export type EventPagepageLayoutUnionCreateInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagCreateInput>
  BulletPointList?: InputMaybe<BulletPointListCreateInput>
  Faq?: InputMaybe<FaqCreateInput>
  ImageSlider?: InputMaybe<ImageSliderCreateInput>
  PreviewCardList?: InputMaybe<PreviewCardListCreateInput>
  ProcessStep?: InputMaybe<ProcessStepCreateInput>
  RichContent?: InputMaybe<RichContentCreateInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetCreateInput>
  SectionAppCta?: InputMaybe<SectionAppCtaCreateInput>
  SectionBanner?: InputMaybe<SectionBannerCreateInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersCreateInput>
  SectionContact?: InputMaybe<SectionContactCreateInput>
  SectionCta?: InputMaybe<SectionCtaCreateInput>
  SectionDownloads?: InputMaybe<SectionDownloadsCreateInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableCreateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableCreateInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterCreateInput>
  SectionHero?: InputMaybe<SectionHeroCreateInput>
  SectionHotel?: InputMaybe<SectionHotelCreateInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormCreateInput>
  SectionIntro?: InputMaybe<SectionIntroCreateInput>
  SectionJobList?: InputMaybe<SectionJobListCreateInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsCreateInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsCreateInput>
  SectionMap?: InputMaybe<SectionMapCreateInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsCreateInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListCreateInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterCreateInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerCreateInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsCreateInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersCreateInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingCreateInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateInput>
  SectionTab?: InputMaybe<SectionTabCreateInput>
  SectionTeaser?: InputMaybe<SectionTeaserCreateInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
  SectionVideo?: InputMaybe<SectionVideoCreateInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserCreateInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderCreateInput>
  TextMedia?: InputMaybe<TextMediaCreateInput>
}

export type EventPagepageLayoutUnionCreateManyInlineInput = {
  /** Create and connect multiple existing EventPagepageLayoutUnion documents */
  create?: InputMaybe<Array<EventPagepageLayoutUnionCreateInput>>
}

export type EventPagepageLayoutUnionCreateOneInlineInput = {
  /** Create and connect one EventPagepageLayoutUnion document */
  create?: InputMaybe<EventPagepageLayoutUnionCreateInput>
}

export type EventPagepageLayoutUnionCreateWithPositionInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagCreateWithPositionInput>
  BulletPointList?: InputMaybe<BulletPointListCreateWithPositionInput>
  Faq?: InputMaybe<FaqCreateWithPositionInput>
  ImageSlider?: InputMaybe<ImageSliderCreateWithPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListCreateWithPositionInput>
  ProcessStep?: InputMaybe<ProcessStepCreateWithPositionInput>
  RichContent?: InputMaybe<RichContentCreateWithPositionInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetCreateWithPositionInput>
  SectionAppCta?: InputMaybe<SectionAppCtaCreateWithPositionInput>
  SectionBanner?: InputMaybe<SectionBannerCreateWithPositionInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersCreateWithPositionInput>
  SectionContact?: InputMaybe<SectionContactCreateWithPositionInput>
  SectionCta?: InputMaybe<SectionCtaCreateWithPositionInput>
  SectionDownloads?: InputMaybe<SectionDownloadsCreateWithPositionInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableCreateWithPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateWithPositionInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableCreateWithPositionInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterCreateWithPositionInput>
  SectionHero?: InputMaybe<SectionHeroCreateWithPositionInput>
  SectionHotel?: InputMaybe<SectionHotelCreateWithPositionInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormCreateWithPositionInput>
  SectionIntro?: InputMaybe<SectionIntroCreateWithPositionInput>
  SectionJobList?: InputMaybe<SectionJobListCreateWithPositionInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsCreateWithPositionInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsCreateWithPositionInput>
  SectionMap?: InputMaybe<SectionMapCreateWithPositionInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsCreateWithPositionInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListCreateWithPositionInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterCreateWithPositionInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerCreateWithPositionInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsCreateWithPositionInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersCreateWithPositionInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingCreateWithPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateWithPositionInput>
  SectionTab?: InputMaybe<SectionTabCreateWithPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserCreateWithPositionInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
  SectionVideo?: InputMaybe<SectionVideoCreateWithPositionInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserCreateWithPositionInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderCreateWithPositionInput>
  TextMedia?: InputMaybe<TextMediaCreateWithPositionInput>
}

export type EventPagepageLayoutUnionUpdateInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagUpdateInput>
  BulletPointList?: InputMaybe<BulletPointListUpdateInput>
  Faq?: InputMaybe<FaqUpdateInput>
  ImageSlider?: InputMaybe<ImageSliderUpdateInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateInput>
  ProcessStep?: InputMaybe<ProcessStepUpdateInput>
  RichContent?: InputMaybe<RichContentUpdateInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpdateInput>
  SectionAppCta?: InputMaybe<SectionAppCtaUpdateInput>
  SectionBanner?: InputMaybe<SectionBannerUpdateInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateInput>
  SectionContact?: InputMaybe<SectionContactUpdateInput>
  SectionCta?: InputMaybe<SectionCtaUpdateInput>
  SectionDownloads?: InputMaybe<SectionDownloadsUpdateInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpdateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpdateInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpdateInput>
  SectionHero?: InputMaybe<SectionHeroUpdateInput>
  SectionHotel?: InputMaybe<SectionHotelUpdateInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpdateInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateInput>
  SectionJobList?: InputMaybe<SectionJobListUpdateInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpdateInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsUpdateInput>
  SectionMap?: InputMaybe<SectionMapUpdateInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpdateInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListUpdateInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpdateInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsUpdateInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpdateInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingUpdateInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateInput>
  SectionTab?: InputMaybe<SectionTabUpdateInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpdateInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateInput>
  TextMedia?: InputMaybe<TextMediaUpdateInput>
}

export type EventPagepageLayoutUnionUpdateManyInlineInput = {
  /** Create and connect multiple EventPagepageLayoutUnion component instances */
  create?: InputMaybe<Array<EventPagepageLayoutUnionCreateWithPositionInput>>
  /** Delete multiple EventPagepageLayoutUnion documents */
  delete?: InputMaybe<Array<EventPagepageLayoutUnionWhereUniqueInput>>
  /** Update multiple EventPagepageLayoutUnion component instances */
  update?: InputMaybe<Array<EventPagepageLayoutUnionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple EventPagepageLayoutUnion component instances */
  upsert?: InputMaybe<Array<EventPagepageLayoutUnionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type EventPagepageLayoutUnionUpdateManyWithNestedWhereInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagUpdateManyWithNestedWhereInput>
  BulletPointList?: InputMaybe<BulletPointListUpdateManyWithNestedWhereInput>
  Faq?: InputMaybe<FaqUpdateManyWithNestedWhereInput>
  ImageSlider?: InputMaybe<ImageSliderUpdateManyWithNestedWhereInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateManyWithNestedWhereInput>
  ProcessStep?: InputMaybe<ProcessStepUpdateManyWithNestedWhereInput>
  RichContent?: InputMaybe<RichContentUpdateManyWithNestedWhereInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpdateManyWithNestedWhereInput>
  SectionAppCta?: InputMaybe<SectionAppCtaUpdateManyWithNestedWhereInput>
  SectionBanner?: InputMaybe<SectionBannerUpdateManyWithNestedWhereInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateManyWithNestedWhereInput>
  SectionContact?: InputMaybe<SectionContactUpdateManyWithNestedWhereInput>
  SectionCta?: InputMaybe<SectionCtaUpdateManyWithNestedWhereInput>
  SectionDownloads?: InputMaybe<SectionDownloadsUpdateManyWithNestedWhereInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpdateManyWithNestedWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateManyWithNestedWhereInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpdateManyWithNestedWhereInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpdateManyWithNestedWhereInput>
  SectionHero?: InputMaybe<SectionHeroUpdateManyWithNestedWhereInput>
  SectionHotel?: InputMaybe<SectionHotelUpdateManyWithNestedWhereInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpdateManyWithNestedWhereInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateManyWithNestedWhereInput>
  SectionJobList?: InputMaybe<SectionJobListUpdateManyWithNestedWhereInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpdateManyWithNestedWhereInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsUpdateManyWithNestedWhereInput>
  SectionMap?: InputMaybe<SectionMapUpdateManyWithNestedWhereInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpdateManyWithNestedWhereInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListUpdateManyWithNestedWhereInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateManyWithNestedWhereInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpdateManyWithNestedWhereInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsUpdateManyWithNestedWhereInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpdateManyWithNestedWhereInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingUpdateManyWithNestedWhereInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateManyWithNestedWhereInput>
  SectionTab?: InputMaybe<SectionTabUpdateManyWithNestedWhereInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateManyWithNestedWhereInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateManyWithNestedWhereInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpdateManyWithNestedWhereInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateManyWithNestedWhereInput>
  TextMedia?: InputMaybe<TextMediaUpdateManyWithNestedWhereInput>
}

export type EventPagepageLayoutUnionUpdateOneInlineInput = {
  /** Create and connect one EventPagepageLayoutUnion document */
  create?: InputMaybe<EventPagepageLayoutUnionCreateInput>
  /** Delete currently connected EventPagepageLayoutUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventPagepageLayoutUnion document */
  update?: InputMaybe<EventPagepageLayoutUnionUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventPagepageLayoutUnion document */
  upsert?: InputMaybe<EventPagepageLayoutUnionUpsertWithNestedWhereUniqueInput>
}

export type EventPagepageLayoutUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagUpdateWithNestedWhereUniqueAndPositionInput>
  BulletPointList?: InputMaybe<BulletPointListUpdateWithNestedWhereUniqueAndPositionInput>
  Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueAndPositionInput>
  ImageSlider?: InputMaybe<ImageSliderUpdateWithNestedWhereUniqueAndPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateWithNestedWhereUniqueAndPositionInput>
  ProcessStep?: InputMaybe<ProcessStepUpdateWithNestedWhereUniqueAndPositionInput>
  RichContent?: InputMaybe<RichContentUpdateWithNestedWhereUniqueAndPositionInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpdateWithNestedWhereUniqueAndPositionInput>
  SectionAppCta?: InputMaybe<SectionAppCtaUpdateWithNestedWhereUniqueAndPositionInput>
  SectionBanner?: InputMaybe<SectionBannerUpdateWithNestedWhereUniqueAndPositionInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateWithNestedWhereUniqueAndPositionInput>
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueAndPositionInput>
  SectionCta?: InputMaybe<SectionCtaUpdateWithNestedWhereUniqueAndPositionInput>
  SectionDownloads?: InputMaybe<SectionDownloadsUpdateWithNestedWhereUniqueAndPositionInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpdateWithNestedWhereUniqueAndPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueAndPositionInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpdateWithNestedWhereUniqueAndPositionInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpdateWithNestedWhereUniqueAndPositionInput>
  SectionHero?: InputMaybe<SectionHeroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionHotel?: InputMaybe<SectionHotelUpdateWithNestedWhereUniqueAndPositionInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpdateWithNestedWhereUniqueAndPositionInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionJobList?: InputMaybe<SectionJobListUpdateWithNestedWhereUniqueAndPositionInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpdateWithNestedWhereUniqueAndPositionInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsUpdateWithNestedWhereUniqueAndPositionInput>
  SectionMap?: InputMaybe<SectionMapUpdateWithNestedWhereUniqueAndPositionInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpdateWithNestedWhereUniqueAndPositionInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListUpdateWithNestedWhereUniqueAndPositionInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateWithNestedWhereUniqueAndPositionInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpdateWithNestedWhereUniqueAndPositionInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsUpdateWithNestedWhereUniqueAndPositionInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpdateWithNestedWhereUniqueAndPositionInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingUpdateWithNestedWhereUniqueAndPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTab?: InputMaybe<SectionTabUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateWithNestedWhereUniqueAndPositionInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpdateWithNestedWhereUniqueAndPositionInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateWithNestedWhereUniqueAndPositionInput>
  TextMedia?: InputMaybe<TextMediaUpdateWithNestedWhereUniqueAndPositionInput>
}

export type EventPagepageLayoutUnionUpdateWithNestedWhereUniqueInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagUpdateWithNestedWhereUniqueInput>
  BulletPointList?: InputMaybe<BulletPointListUpdateWithNestedWhereUniqueInput>
  Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>
  ImageSlider?: InputMaybe<ImageSliderUpdateWithNestedWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateWithNestedWhereUniqueInput>
  ProcessStep?: InputMaybe<ProcessStepUpdateWithNestedWhereUniqueInput>
  RichContent?: InputMaybe<RichContentUpdateWithNestedWhereUniqueInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpdateWithNestedWhereUniqueInput>
  SectionAppCta?: InputMaybe<SectionAppCtaUpdateWithNestedWhereUniqueInput>
  SectionBanner?: InputMaybe<SectionBannerUpdateWithNestedWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateWithNestedWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaUpdateWithNestedWhereUniqueInput>
  SectionDownloads?: InputMaybe<SectionDownloadsUpdateWithNestedWhereUniqueInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpdateWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpdateWithNestedWhereUniqueInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpdateWithNestedWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroUpdateWithNestedWhereUniqueInput>
  SectionHotel?: InputMaybe<SectionHotelUpdateWithNestedWhereUniqueInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpdateWithNestedWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateWithNestedWhereUniqueInput>
  SectionJobList?: InputMaybe<SectionJobListUpdateWithNestedWhereUniqueInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpdateWithNestedWhereUniqueInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsUpdateWithNestedWhereUniqueInput>
  SectionMap?: InputMaybe<SectionMapUpdateWithNestedWhereUniqueInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpdateWithNestedWhereUniqueInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListUpdateWithNestedWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateWithNestedWhereUniqueInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpdateWithNestedWhereUniqueInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsUpdateWithNestedWhereUniqueInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpdateWithNestedWhereUniqueInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingUpdateWithNestedWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueInput>
  SectionTab?: InputMaybe<SectionTabUpdateWithNestedWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateWithNestedWhereUniqueInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateWithNestedWhereUniqueInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpdateWithNestedWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateWithNestedWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaUpdateWithNestedWhereUniqueInput>
}

export type EventPagepageLayoutUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagUpsertWithNestedWhereUniqueAndPositionInput>
  BulletPointList?: InputMaybe<BulletPointListUpsertWithNestedWhereUniqueAndPositionInput>
  Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueAndPositionInput>
  ImageSlider?: InputMaybe<ImageSliderUpsertWithNestedWhereUniqueAndPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpsertWithNestedWhereUniqueAndPositionInput>
  ProcessStep?: InputMaybe<ProcessStepUpsertWithNestedWhereUniqueAndPositionInput>
  RichContent?: InputMaybe<RichContentUpsertWithNestedWhereUniqueAndPositionInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpsertWithNestedWhereUniqueAndPositionInput>
  SectionAppCta?: InputMaybe<SectionAppCtaUpsertWithNestedWhereUniqueAndPositionInput>
  SectionBanner?: InputMaybe<SectionBannerUpsertWithNestedWhereUniqueAndPositionInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpsertWithNestedWhereUniqueAndPositionInput>
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueAndPositionInput>
  SectionCta?: InputMaybe<SectionCtaUpsertWithNestedWhereUniqueAndPositionInput>
  SectionDownloads?: InputMaybe<SectionDownloadsUpsertWithNestedWhereUniqueAndPositionInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpsertWithNestedWhereUniqueAndPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueAndPositionInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpsertWithNestedWhereUniqueAndPositionInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpsertWithNestedWhereUniqueAndPositionInput>
  SectionHero?: InputMaybe<SectionHeroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionHotel?: InputMaybe<SectionHotelUpsertWithNestedWhereUniqueAndPositionInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpsertWithNestedWhereUniqueAndPositionInput>
  SectionIntro?: InputMaybe<SectionIntroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionJobList?: InputMaybe<SectionJobListUpsertWithNestedWhereUniqueAndPositionInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpsertWithNestedWhereUniqueAndPositionInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsUpsertWithNestedWhereUniqueAndPositionInput>
  SectionMap?: InputMaybe<SectionMapUpsertWithNestedWhereUniqueAndPositionInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpsertWithNestedWhereUniqueAndPositionInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListUpsertWithNestedWhereUniqueAndPositionInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpsertWithNestedWhereUniqueAndPositionInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpsertWithNestedWhereUniqueAndPositionInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsUpsertWithNestedWhereUniqueAndPositionInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpsertWithNestedWhereUniqueAndPositionInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingUpsertWithNestedWhereUniqueAndPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTab?: InputMaybe<SectionTabUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
  SectionVideo?: InputMaybe<SectionVideoUpsertWithNestedWhereUniqueAndPositionInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpsertWithNestedWhereUniqueAndPositionInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpsertWithNestedWhereUniqueAndPositionInput>
  TextMedia?: InputMaybe<TextMediaUpsertWithNestedWhereUniqueAndPositionInput>
}

export type EventPagepageLayoutUnionUpsertWithNestedWhereUniqueInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagUpsertWithNestedWhereUniqueInput>
  BulletPointList?: InputMaybe<BulletPointListUpsertWithNestedWhereUniqueInput>
  Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>
  ImageSlider?: InputMaybe<ImageSliderUpsertWithNestedWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpsertWithNestedWhereUniqueInput>
  ProcessStep?: InputMaybe<ProcessStepUpsertWithNestedWhereUniqueInput>
  RichContent?: InputMaybe<RichContentUpsertWithNestedWhereUniqueInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpsertWithNestedWhereUniqueInput>
  SectionAppCta?: InputMaybe<SectionAppCtaUpsertWithNestedWhereUniqueInput>
  SectionBanner?: InputMaybe<SectionBannerUpsertWithNestedWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpsertWithNestedWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaUpsertWithNestedWhereUniqueInput>
  SectionDownloads?: InputMaybe<SectionDownloadsUpsertWithNestedWhereUniqueInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableUpsertWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableUpsertWithNestedWhereUniqueInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterUpsertWithNestedWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroUpsertWithNestedWhereUniqueInput>
  SectionHotel?: InputMaybe<SectionHotelUpsertWithNestedWhereUniqueInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpsertWithNestedWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroUpsertWithNestedWhereUniqueInput>
  SectionJobList?: InputMaybe<SectionJobListUpsertWithNestedWhereUniqueInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpsertWithNestedWhereUniqueInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsUpsertWithNestedWhereUniqueInput>
  SectionMap?: InputMaybe<SectionMapUpsertWithNestedWhereUniqueInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpsertWithNestedWhereUniqueInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListUpsertWithNestedWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpsertWithNestedWhereUniqueInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpsertWithNestedWhereUniqueInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsUpsertWithNestedWhereUniqueInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersUpsertWithNestedWhereUniqueInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingUpsertWithNestedWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueInput>
  SectionTab?: InputMaybe<SectionTabUpsertWithNestedWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpsertWithNestedWhereUniqueInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoUpsertWithNestedWhereUniqueInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpsertWithNestedWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpsertWithNestedWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaUpsertWithNestedWhereUniqueInput>
}

export type EventPagepageLayoutUnionWhereInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagWhereInput>
  BulletPointList?: InputMaybe<BulletPointListWhereInput>
  Faq?: InputMaybe<FaqWhereInput>
  ImageSlider?: InputMaybe<ImageSliderWhereInput>
  PreviewCardList?: InputMaybe<PreviewCardListWhereInput>
  ProcessStep?: InputMaybe<ProcessStepWhereInput>
  RichContent?: InputMaybe<RichContentWhereInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetWhereInput>
  SectionAppCta?: InputMaybe<SectionAppCtaWhereInput>
  SectionBanner?: InputMaybe<SectionBannerWhereInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersWhereInput>
  SectionContact?: InputMaybe<SectionContactWhereInput>
  SectionCta?: InputMaybe<SectionCtaWhereInput>
  SectionDownloads?: InputMaybe<SectionDownloadsWhereInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableWhereInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterWhereInput>
  SectionHero?: InputMaybe<SectionHeroWhereInput>
  SectionHotel?: InputMaybe<SectionHotelWhereInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormWhereInput>
  SectionIntro?: InputMaybe<SectionIntroWhereInput>
  SectionJobList?: InputMaybe<SectionJobListWhereInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsWhereInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsWhereInput>
  SectionMap?: InputMaybe<SectionMapWhereInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsWhereInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListWhereInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterWhereInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerWhereInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsWhereInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersWhereInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingWhereInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereInput>
  SectionTab?: InputMaybe<SectionTabWhereInput>
  SectionTeaser?: InputMaybe<SectionTeaserWhereInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
  SectionVideo?: InputMaybe<SectionVideoWhereInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserWhereInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderWhereInput>
  TextMedia?: InputMaybe<TextMediaWhereInput>
}

export type EventPagepageLayoutUnionWhereUniqueInput = {
  ArticlesByTag?: InputMaybe<ArticlesByTagWhereUniqueInput>
  BulletPointList?: InputMaybe<BulletPointListWhereUniqueInput>
  Faq?: InputMaybe<FaqWhereUniqueInput>
  ImageSlider?: InputMaybe<ImageSliderWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListWhereUniqueInput>
  ProcessStep?: InputMaybe<ProcessStepWhereUniqueInput>
  RichContent?: InputMaybe<RichContentWhereUniqueInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetWhereUniqueInput>
  SectionAppCta?: InputMaybe<SectionAppCtaWhereUniqueInput>
  SectionBanner?: InputMaybe<SectionBannerWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaWhereUniqueInput>
  SectionDownloads?: InputMaybe<SectionDownloadsWhereUniqueInput>
  SectionEventOffersTimetable?: InputMaybe<SectionEventOffersTimetableWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereUniqueInput>
  SectionFestivalTimetable?: InputMaybe<SectionFestivalTimetableWhereUniqueInput>
  SectionFlipCounter?: InputMaybe<SectionFlipCounterWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroWhereUniqueInput>
  SectionHotel?: InputMaybe<SectionHotelWhereUniqueInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroWhereUniqueInput>
  SectionJobList?: InputMaybe<SectionJobListWhereUniqueInput>
  SectionLivestreams?: InputMaybe<SectionLivestreamsWhereUniqueInput>
  SectionManageInterests?: InputMaybe<SectionManageInterestsWhereUniqueInput>
  SectionMap?: InputMaybe<SectionMapWhereUniqueInput>
  SectionMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsWhereUniqueInput>
  SectionMyomrExhibitorsList?: InputMaybe<SectionMyomrExhibitorsListWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterWhereUniqueInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerWhereUniqueInput>
  SectionRecommendations?: InputMaybe<SectionRecommendationsWhereUniqueInput>
  SectionSpeakers?: InputMaybe<SectionSpeakersWhereUniqueInput>
  SectionStorytelling?: InputMaybe<SectionStorytellingWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereUniqueInput>
  SectionTab?: InputMaybe<SectionTabWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserWhereUniqueInput>
  SectionTicketsTable?: InputMaybe<SectionTicketsTableWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoWhereUniqueInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaWhereUniqueInput>
}

/** Event Stage synchronised from myomr service */
export type EventStage = Entity &
  Node & {
    __typename?: 'EventStage'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<EventStage>
    events: Array<Event>
    /** List of EventStage versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<EventStage>
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    subtitle?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Event Stage synchronised from myomr service */
export type EventStageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Event Stage synchronised from myomr service */
export type EventStageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Event Stage synchronised from myomr service */
export type EventStageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Event Stage synchronised from myomr service */
export type EventStageEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventWhereInput>
}

/** Event Stage synchronised from myomr service */
export type EventStageHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Event Stage synchronised from myomr service */
export type EventStageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Event Stage synchronised from myomr service */
export type EventStagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Event Stage synchronised from myomr service */
export type EventStagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Event Stage synchronised from myomr service */
export type EventStageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Event Stage synchronised from myomr service */
export type EventStageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Event Stage synchronised from myomr service */
export type EventStageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type EventStageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: EventStageWhereUniqueInput
}

/** A connection to a list of items. */
export type EventStageConnection = {
  __typename?: 'EventStageConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<EventStageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EventStageCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  events?: InputMaybe<EventCreateManyInlineInput>
  festivalTimetableStages?: InputMaybe<SectionFestivalTimetableCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<EventStageCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
  speakerSections?: InputMaybe<SectionSpeakersCreateManyInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventStageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  name: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type EventStageCreateLocalizationInput = {
  /** Localization input */
  data: EventStageCreateLocalizationDataInput
  locale: Locale
}

export type EventStageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<EventStageCreateLocalizationInput>>
}

export type EventStageCreateManyInlineInput = {
  /** Connect multiple existing EventStage documents */
  connect?: InputMaybe<Array<EventStageWhereUniqueInput>>
  /** Create and connect multiple existing EventStage documents */
  create?: InputMaybe<Array<EventStageCreateInput>>
}

export type EventStageCreateOneInlineInput = {
  /** Connect one existing EventStage document */
  connect?: InputMaybe<EventStageWhereUniqueInput>
  /** Create and connect one EventStage document */
  create?: InputMaybe<EventStageCreateInput>
}

/** An edge in a connection. */
export type EventStageEdge = {
  __typename?: 'EventStageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: EventStage
}

/** Identifies documents */
export type EventStageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventStageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventStageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventStageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<EventStageWhereStageInput>
  documentInStages_none?: InputMaybe<EventStageWhereStageInput>
  documentInStages_some?: InputMaybe<EventStageWhereStageInput>
  events_every?: InputMaybe<EventWhereInput>
  events_none?: InputMaybe<EventWhereInput>
  events_some?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum EventStageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type EventStageUpdateInput = {
  events?: InputMaybe<EventUpdateManyInlineInput>
  festivalTimetableStages?: InputMaybe<SectionFestivalTimetableUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<EventStageUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  speakerSections?: InputMaybe<SectionSpeakersUpdateManyInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type EventStageUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type EventStageUpdateLocalizationInput = {
  data: EventStageUpdateLocalizationDataInput
  locale: Locale
}

export type EventStageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EventStageCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EventStageUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EventStageUpsertLocalizationInput>>
}

export type EventStageUpdateManyInlineInput = {
  /** Connect multiple existing EventStage documents */
  connect?: InputMaybe<Array<EventStageConnectInput>>
  /** Create and connect multiple EventStage documents */
  create?: InputMaybe<Array<EventStageCreateInput>>
  /** Delete multiple EventStage documents */
  delete?: InputMaybe<Array<EventStageWhereUniqueInput>>
  /** Disconnect multiple EventStage documents */
  disconnect?: InputMaybe<Array<EventStageWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing EventStage documents */
  set?: InputMaybe<Array<EventStageWhereUniqueInput>>
  /** Update multiple EventStage documents */
  update?: InputMaybe<Array<EventStageUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple EventStage documents */
  upsert?: InputMaybe<Array<EventStageUpsertWithNestedWhereUniqueInput>>
}

export type EventStageUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<EventStageUpdateManyLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type EventStageUpdateManyLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type EventStageUpdateManyLocalizationInput = {
  data: EventStageUpdateManyLocalizationDataInput
  locale: Locale
}

export type EventStageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EventStageUpdateManyLocalizationInput>>
}

export type EventStageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EventStageUpdateManyInput
  /** Document search */
  where: EventStageWhereInput
}

export type EventStageUpdateOneInlineInput = {
  /** Connect existing EventStage document */
  connect?: InputMaybe<EventStageWhereUniqueInput>
  /** Create and connect one EventStage document */
  create?: InputMaybe<EventStageCreateInput>
  /** Delete currently connected EventStage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected EventStage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single EventStage document */
  update?: InputMaybe<EventStageUpdateWithNestedWhereUniqueInput>
  /** Upsert single EventStage document */
  upsert?: InputMaybe<EventStageUpsertWithNestedWhereUniqueInput>
}

export type EventStageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EventStageUpdateInput
  /** Unique document search */
  where: EventStageWhereUniqueInput
}

export type EventStageUpsertInput = {
  /** Create document if it didn't exist */
  create: EventStageCreateInput
  /** Update document if it exists */
  update: EventStageUpdateInput
}

export type EventStageUpsertLocalizationInput = {
  create: EventStageCreateLocalizationDataInput
  locale: Locale
  update: EventStageUpdateLocalizationDataInput
}

export type EventStageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EventStageUpsertInput
  /** Unique document search */
  where: EventStageWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type EventStageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type EventStageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventStageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventStageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventStageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<EventStageWhereStageInput>
  documentInStages_none?: InputMaybe<EventStageWhereStageInput>
  documentInStages_some?: InputMaybe<EventStageWhereStageInput>
  events_every?: InputMaybe<EventWhereInput>
  events_none?: InputMaybe<EventWhereInput>
  events_some?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type EventStageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventStageWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventStageWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventStageWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<EventStageWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References EventStage record uniquely */
export type EventStageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type EventUpdateInput = {
  agbUrl?: InputMaybe<Scalars['String']['input']>
  artists?: InputMaybe<SpeakerUpdateManyInlineInput>
  booths?: InputMaybe<BoothUpdateManyInlineInput>
  clai9mwl31it101tccfahfkdl?: InputMaybe<EventPageUpdateManyInlineInput>
  cle5lekfc1l7l01ul0hgghv9f?: InputMaybe<BoothUpdateManyInlineInput>
  companyLogoUrl?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  companyWebsite?: InputMaybe<Scalars['String']['input']>
  connectedEvent?: InputMaybe<EventUpdateManyInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  digitalOnly?: InputMaybe<Scalars['Boolean']['input']>
  duration?: InputMaybe<Scalars['String']['input']>
  enableCheckin?: InputMaybe<Scalars['Boolean']['input']>
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>
  event?: InputMaybe<NotificationUpdateOneInlineInput>
  eventAppPageContentEvent?: InputMaybe<EventAppPageUpdateManyInlineInput>
  eventFormat?: InputMaybe<Scalars['String']['input']>
  eventStage?: InputMaybe<EventStageUpdateOneInlineInput>
  exhibitorFullListEvent?: InputMaybe<SectionMyomrExhibitorsListUpdateManyInlineInput>
  exhibitorOrderEvent?: InputMaybe<ExhibitorListOrderUpdateManyInlineInput>
  exhibitors?: InputMaybe<PartnerCompanyUpdateManyInlineInput>
  externalEvent?: InputMaybe<Scalars['Boolean']['input']>
  externalEventUrl?: InputMaybe<Scalars['String']['input']>
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>
  footerAddress?: InputMaybe<Scalars['String']['input']>
  footerCompany?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<EventUpdateLocalizationsInput>
  locationAddress?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  parentEvent?: InputMaybe<EventUpdateOneInlineInput>
  privacyUrl?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  sectionMyomrExhibitorsEvent?: InputMaybe<SectionMyomrExhibitorsUpdateManyInlineInput>
  sectionSpeakersEvent?: InputMaybe<SectionSpeakersUpdateManyInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  speakerOrderEvent?: InputMaybe<SpeakerListOrderUpdateManyInlineInput>
  speakers?: InputMaybe<SpeakerUpdateManyInlineInput>
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type EventUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type EventUpdateLocalizationInput = {
  data: EventUpdateLocalizationDataInput
  locale: Locale
}

export type EventUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<EventCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<EventUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<EventUpsertLocalizationInput>>
}

export type EventUpdateManyInlineInput = {
  /** Connect multiple existing Event documents */
  connect?: InputMaybe<Array<EventConnectInput>>
  /** Create and connect multiple Event documents */
  create?: InputMaybe<Array<EventCreateInput>>
  /** Delete multiple Event documents */
  delete?: InputMaybe<Array<EventWhereUniqueInput>>
  /** Disconnect multiple Event documents */
  disconnect?: InputMaybe<Array<EventWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Event documents */
  set?: InputMaybe<Array<EventWhereUniqueInput>>
  /** Update multiple Event documents */
  update?: InputMaybe<Array<EventUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Event documents */
  upsert?: InputMaybe<Array<EventUpsertWithNestedWhereUniqueInput>>
}

export type EventUpdateManyInput = {
  agbUrl?: InputMaybe<Scalars['String']['input']>
  companyLogoUrl?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  companyWebsite?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  digitalOnly?: InputMaybe<Scalars['Boolean']['input']>
  duration?: InputMaybe<Scalars['String']['input']>
  enableCheckin?: InputMaybe<Scalars['Boolean']['input']>
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>
  eventFormat?: InputMaybe<Scalars['String']['input']>
  externalEvent?: InputMaybe<Scalars['Boolean']['input']>
  externalEventUrl?: InputMaybe<Scalars['String']['input']>
  footerAddress?: InputMaybe<Scalars['String']['input']>
  footerCompany?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<EventUpdateManyLocalizationsInput>
  locationAddress?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  privacyUrl?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type EventUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type EventUpdateManyLocalizationInput = {
  data: EventUpdateManyLocalizationDataInput
  locale: Locale
}

export type EventUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<EventUpdateManyLocalizationInput>>
}

export type EventUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EventUpdateManyInput
  /** Document search */
  where: EventWhereInput
}

export type EventUpdateOneInlineInput = {
  /** Connect existing Event document */
  connect?: InputMaybe<EventWhereUniqueInput>
  /** Create and connect one Event document */
  create?: InputMaybe<EventCreateInput>
  /** Delete currently connected Event document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Event document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Event document */
  update?: InputMaybe<EventUpdateWithNestedWhereUniqueInput>
  /** Upsert single Event document */
  upsert?: InputMaybe<EventUpsertWithNestedWhereUniqueInput>
}

export type EventUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EventUpdateInput
  /** Unique document search */
  where: EventWhereUniqueInput
}

export type EventUpsertInput = {
  /** Create document if it didn't exist */
  create: EventCreateInput
  /** Update document if it exists */
  update: EventUpdateInput
}

export type EventUpsertLocalizationInput = {
  create: EventCreateLocalizationDataInput
  locale: Locale
  update: EventUpdateLocalizationDataInput
}

export type EventUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EventUpsertInput
  /** Unique document search */
  where: EventWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type EventWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type EventWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  agbUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  agbUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  agbUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  agbUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  agbUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  agbUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  agbUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  agbUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  agbUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  agbUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  artists_every?: InputMaybe<SpeakerWhereInput>
  artists_none?: InputMaybe<SpeakerWhereInput>
  artists_some?: InputMaybe<SpeakerWhereInput>
  booths_every?: InputMaybe<BoothWhereInput>
  booths_none?: InputMaybe<BoothWhereInput>
  booths_some?: InputMaybe<BoothWhereInput>
  companyLogoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyLogoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  companyLogoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  companyLogoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  companyLogoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  companyLogoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  companyLogoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  companyLogoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  companyLogoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  companyLogoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  companyName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  companyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  companyName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  companyName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  companyName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  companyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  companyName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  companyName_starts_with?: InputMaybe<Scalars['String']['input']>
  companyWebsite?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyWebsite_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  companyWebsite_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  companyWebsite_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  companyWebsite_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  companyWebsite_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  companyWebsite_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  companyWebsite_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  companyWebsite_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  companyWebsite_starts_with?: InputMaybe<Scalars['String']['input']>
  connectedEvent_every?: InputMaybe<EventWhereInput>
  connectedEvent_none?: InputMaybe<EventWhereInput>
  connectedEvent_some?: InputMaybe<EventWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  digitalOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  digitalOnly_not?: InputMaybe<Scalars['Boolean']['input']>
  documentInStages_every?: InputMaybe<EventWhereStageInput>
  documentInStages_none?: InputMaybe<EventWhereStageInput>
  documentInStages_some?: InputMaybe<EventWhereStageInput>
  duration?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  duration_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  duration_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  duration_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  duration_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  duration_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  duration_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  duration_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  duration_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  duration_starts_with?: InputMaybe<Scalars['String']['input']>
  enableCheckin?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableCheckin_not?: InputMaybe<Scalars['Boolean']['input']>
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  endDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  endDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  endDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  endDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  endDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  endDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  endDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  eventAppPageContentEvent_every?: InputMaybe<EventAppPageWhereInput>
  eventAppPageContentEvent_none?: InputMaybe<EventAppPageWhereInput>
  eventAppPageContentEvent_some?: InputMaybe<EventAppPageWhereInput>
  eventFormat?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  eventFormat_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  eventFormat_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  eventFormat_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  eventFormat_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  eventFormat_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  eventFormat_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  eventFormat_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  eventFormat_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  eventFormat_starts_with?: InputMaybe<Scalars['String']['input']>
  eventStage?: InputMaybe<EventStageWhereInput>
  exhibitors_every?: InputMaybe<PartnerCompanyWhereInput>
  exhibitors_none?: InputMaybe<PartnerCompanyWhereInput>
  exhibitors_some?: InputMaybe<PartnerCompanyWhereInput>
  externalEvent?: InputMaybe<Scalars['Boolean']['input']>
  externalEventUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  externalEventUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  externalEventUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  externalEventUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  externalEventUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  externalEventUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  externalEventUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  externalEventUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  externalEventUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  externalEventUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  /** Any other value that exists and is not equal to the given value. */
  externalEvent_not?: InputMaybe<Scalars['Boolean']['input']>
  featuredImage?: InputMaybe<AssetWhereInput>
  footerAddress?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  footerAddress_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  footerAddress_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  footerAddress_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  footerAddress_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  footerAddress_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  footerAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  footerAddress_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  footerAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  footerAddress_starts_with?: InputMaybe<Scalars['String']['input']>
  footerCompany?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  footerCompany_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  footerCompany_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  footerCompany_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  footerCompany_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  footerCompany_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  footerCompany_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  footerCompany_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  footerCompany_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  footerCompany_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  language_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  language_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  language_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  language_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  language_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  language_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  language_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  language_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  language_starts_with?: InputMaybe<Scalars['String']['input']>
  locationAddress?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  locationAddress_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  locationAddress_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  locationAddress_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  locationAddress_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  locationAddress_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  locationAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  locationAddress_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  locationAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  locationAddress_starts_with?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  locationName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  locationName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  locationName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  locationName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  locationName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  locationName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  locationName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  locationName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  locationName_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  parentEvent?: InputMaybe<EventWhereInput>
  privacyUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  privacyUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  privacyUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  privacyUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  privacyUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  privacyUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  privacyUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  privacyUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  privacyUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  privacyUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Boolean']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  speakers_every?: InputMaybe<SpeakerWhereInput>
  speakers_none?: InputMaybe<SpeakerWhereInput>
  speakers_some?: InputMaybe<SpeakerWhereInput>
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  startDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  startDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  startDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  startDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  startDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  startDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  startDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  type_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  type_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  type_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  type_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  website?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type EventWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EventWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EventWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EventWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<EventWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Event record uniquely */
export type EventWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrder = Entity &
  Node & {
    __typename?: 'ExhibitorListOrder'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<ExhibitorListOrder>
    event: Event
    /** The order of exhibitors. */
    exhibitors: Array<PartnerCompany>
    /** List of ExhibitorListOrder versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrderCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrderDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrderEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrderExhibitorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PartnerCompanyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PartnerCompanyWhereInput>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrderHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrderPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrderScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on exhibitors pages or in the mobile app. */
export type ExhibitorListOrderUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ExhibitorListOrderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ExhibitorListOrderWhereUniqueInput
}

/** A connection to a list of items. */
export type ExhibitorListOrderConnection = {
  __typename?: 'ExhibitorListOrderConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ExhibitorListOrderEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ExhibitorListOrderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  event: EventCreateOneInlineInput
  exhibitors: PartnerCompanyCreateManyInlineInput
  hubPagePartnerCompanyTilePartnerCompanies?: InputMaybe<HubPagePartnerCompanyTileCreateOneInlineInput>
  sectionsMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsCreateManyInlineInput>
  slug: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ExhibitorListOrderCreateManyInlineInput = {
  /** Connect multiple existing ExhibitorListOrder documents */
  connect?: InputMaybe<Array<ExhibitorListOrderWhereUniqueInput>>
  /** Create and connect multiple existing ExhibitorListOrder documents */
  create?: InputMaybe<Array<ExhibitorListOrderCreateInput>>
}

export type ExhibitorListOrderCreateOneInlineInput = {
  /** Connect one existing ExhibitorListOrder document */
  connect?: InputMaybe<ExhibitorListOrderWhereUniqueInput>
  /** Create and connect one ExhibitorListOrder document */
  create?: InputMaybe<ExhibitorListOrderCreateInput>
}

/** An edge in a connection. */
export type ExhibitorListOrderEdge = {
  __typename?: 'ExhibitorListOrderEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ExhibitorListOrder
}

/** Identifies documents */
export type ExhibitorListOrderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExhibitorListOrderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExhibitorListOrderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExhibitorListOrderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ExhibitorListOrderWhereStageInput>
  documentInStages_none?: InputMaybe<ExhibitorListOrderWhereStageInput>
  documentInStages_some?: InputMaybe<ExhibitorListOrderWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  exhibitors_every?: InputMaybe<PartnerCompanyWhereInput>
  exhibitors_none?: InputMaybe<PartnerCompanyWhereInput>
  exhibitors_some?: InputMaybe<PartnerCompanyWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ExhibitorListOrderOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ExhibitorListOrderUpdateInput = {
  event?: InputMaybe<EventUpdateOneInlineInput>
  exhibitors?: InputMaybe<PartnerCompanyUpdateManyInlineInput>
  hubPagePartnerCompanyTilePartnerCompanies?: InputMaybe<HubPagePartnerCompanyTileUpdateOneInlineInput>
  sectionsMyomrExhibitors?: InputMaybe<SectionMyomrExhibitorsUpdateManyInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type ExhibitorListOrderUpdateManyInlineInput = {
  /** Connect multiple existing ExhibitorListOrder documents */
  connect?: InputMaybe<Array<ExhibitorListOrderConnectInput>>
  /** Create and connect multiple ExhibitorListOrder documents */
  create?: InputMaybe<Array<ExhibitorListOrderCreateInput>>
  /** Delete multiple ExhibitorListOrder documents */
  delete?: InputMaybe<Array<ExhibitorListOrderWhereUniqueInput>>
  /** Disconnect multiple ExhibitorListOrder documents */
  disconnect?: InputMaybe<Array<ExhibitorListOrderWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ExhibitorListOrder documents */
  set?: InputMaybe<Array<ExhibitorListOrderWhereUniqueInput>>
  /** Update multiple ExhibitorListOrder documents */
  update?: InputMaybe<Array<ExhibitorListOrderUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ExhibitorListOrder documents */
  upsert?: InputMaybe<Array<ExhibitorListOrderUpsertWithNestedWhereUniqueInput>>
}

export type ExhibitorListOrderUpdateManyInput = {
  slug?: InputMaybe<Scalars['String']['input']>
}

export type ExhibitorListOrderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ExhibitorListOrderUpdateManyInput
  /** Document search */
  where: ExhibitorListOrderWhereInput
}

export type ExhibitorListOrderUpdateOneInlineInput = {
  /** Connect existing ExhibitorListOrder document */
  connect?: InputMaybe<ExhibitorListOrderWhereUniqueInput>
  /** Create and connect one ExhibitorListOrder document */
  create?: InputMaybe<ExhibitorListOrderCreateInput>
  /** Delete currently connected ExhibitorListOrder document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ExhibitorListOrder document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ExhibitorListOrder document */
  update?: InputMaybe<ExhibitorListOrderUpdateWithNestedWhereUniqueInput>
  /** Upsert single ExhibitorListOrder document */
  upsert?: InputMaybe<ExhibitorListOrderUpsertWithNestedWhereUniqueInput>
}

export type ExhibitorListOrderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ExhibitorListOrderUpdateInput
  /** Unique document search */
  where: ExhibitorListOrderWhereUniqueInput
}

export type ExhibitorListOrderUpsertInput = {
  /** Create document if it didn't exist */
  create: ExhibitorListOrderCreateInput
  /** Update document if it exists */
  update: ExhibitorListOrderUpdateInput
}

export type ExhibitorListOrderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ExhibitorListOrderUpsertInput
  /** Unique document search */
  where: ExhibitorListOrderWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ExhibitorListOrderWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ExhibitorListOrderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExhibitorListOrderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExhibitorListOrderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExhibitorListOrderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ExhibitorListOrderWhereStageInput>
  documentInStages_none?: InputMaybe<ExhibitorListOrderWhereStageInput>
  documentInStages_some?: InputMaybe<ExhibitorListOrderWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  exhibitors_every?: InputMaybe<PartnerCompanyWhereInput>
  exhibitors_none?: InputMaybe<PartnerCompanyWhereInput>
  exhibitors_some?: InputMaybe<PartnerCompanyWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ExhibitorListOrderWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExhibitorListOrderWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExhibitorListOrderWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExhibitorListOrderWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ExhibitorListOrderWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ExhibitorListOrder record uniquely */
export type ExhibitorListOrderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type ExplanationStep = Entity & {
  __typename?: 'ExplanationStep'
  cta?: Maybe<CallToAction>
  description: Scalars['String']['output']
  /** DEPRECATED: Use Lucide Icon instead */
  icon?: Maybe<IconEnum>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<ExplanationStep>
  /** Icon for the Explanation Step. Reference: https://lucide.dev/icons/ */
  lucideIcon?: Maybe<LucideIcon>
  picture?: Maybe<Asset>
  /** System stage field */
  stage: Stage
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ExplanationStepCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ExplanationStepLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type ExplanationStepPictureArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type ExplanationStepUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ExplanationStepConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ExplanationStepWhereUniqueInput
}

/** A connection to a list of items. */
export type ExplanationStepConnection = {
  __typename?: 'ExplanationStepConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ExplanationStepEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ExplanationStepCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  icon?: InputMaybe<IconEnum>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ExplanationStepCreateLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  picture?: InputMaybe<AssetCreateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ExplanationStepCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ExplanationStepCreateLocalizationInput = {
  /** Localization input */
  data: ExplanationStepCreateLocalizationDataInput
  locale: Locale
}

export type ExplanationStepCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ExplanationStepCreateLocalizationInput>>
}

export type ExplanationStepCreateManyInlineInput = {
  /** Create and connect multiple existing ExplanationStep documents */
  create?: InputMaybe<Array<ExplanationStepCreateInput>>
}

export type ExplanationStepCreateOneInlineInput = {
  /** Create and connect one ExplanationStep document */
  create?: InputMaybe<ExplanationStepCreateInput>
}

export type ExplanationStepCreateWithPositionInput = {
  /** Document to create */
  data: ExplanationStepCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type ExplanationStepEdge = {
  __typename?: 'ExplanationStepEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ExplanationStep
}

/** Identifies documents */
export type ExplanationStepManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExplanationStepWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExplanationStepWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExplanationStepWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  icon?: InputMaybe<IconEnum>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<IconEnum>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<IconEnum>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<IconEnum>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  lucideIcon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  lucideIcon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  lucideIcon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  lucideIcon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  picture?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum ExplanationStepOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LucideIconAsc = 'lucideIcon_ASC',
  LucideIconDesc = 'lucideIcon_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ExplanationStepParent = SectionByTheNumbers | SectionExplanationBlocks

export type ExplanationStepParentConnectInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersConnectInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksConnectInput>
}

export type ExplanationStepParentCreateInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersCreateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateInput>
}

export type ExplanationStepParentCreateManyInlineInput = {
  /** Create and connect multiple existing ExplanationStepParent documents */
  create?: InputMaybe<Array<ExplanationStepParentCreateInput>>
}

export type ExplanationStepParentCreateOneInlineInput = {
  /** Create and connect one ExplanationStepParent document */
  create?: InputMaybe<ExplanationStepParentCreateInput>
}

export type ExplanationStepParentCreateWithPositionInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersCreateWithPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateWithPositionInput>
}

export type ExplanationStepParentUpdateInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateInput>
}

export type ExplanationStepParentUpdateManyInlineInput = {
  /** Create and connect multiple ExplanationStepParent component instances */
  create?: InputMaybe<Array<ExplanationStepParentCreateWithPositionInput>>
  /** Delete multiple ExplanationStepParent documents */
  delete?: InputMaybe<Array<ExplanationStepParentWhereUniqueInput>>
  /** Update multiple ExplanationStepParent component instances */
  update?: InputMaybe<Array<ExplanationStepParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple ExplanationStepParent component instances */
  upsert?: InputMaybe<Array<ExplanationStepParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type ExplanationStepParentUpdateManyWithNestedWhereInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateManyWithNestedWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateManyWithNestedWhereInput>
}

export type ExplanationStepParentUpdateOneInlineInput = {
  /** Create and connect one ExplanationStepParent document */
  create?: InputMaybe<ExplanationStepParentCreateInput>
  /** Delete currently connected ExplanationStepParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ExplanationStepParent document */
  update?: InputMaybe<ExplanationStepParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single ExplanationStepParent document */
  upsert?: InputMaybe<ExplanationStepParentUpsertWithNestedWhereUniqueInput>
}

export type ExplanationStepParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateWithNestedWhereUniqueAndPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueAndPositionInput>
}

export type ExplanationStepParentUpdateWithNestedWhereUniqueInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueInput>
}

export type ExplanationStepParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpsertWithNestedWhereUniqueAndPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueAndPositionInput>
}

export type ExplanationStepParentUpsertWithNestedWhereUniqueInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpsertWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueInput>
}

export type ExplanationStepParentWhereInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereInput>
}

export type ExplanationStepParentWhereUniqueInput = {
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereUniqueInput>
}

export type ExplanationStepUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<IconEnum>
  /** Manage document localizations */
  localizations?: InputMaybe<ExplanationStepUpdateLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  picture?: InputMaybe<AssetUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ExplanationStepUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ExplanationStepUpdateLocalizationInput = {
  data: ExplanationStepUpdateLocalizationDataInput
  locale: Locale
}

export type ExplanationStepUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ExplanationStepCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ExplanationStepUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ExplanationStepUpsertLocalizationInput>>
}

export type ExplanationStepUpdateManyInlineInput = {
  /** Create and connect multiple ExplanationStep component instances */
  create?: InputMaybe<Array<ExplanationStepCreateWithPositionInput>>
  /** Delete multiple ExplanationStep documents */
  delete?: InputMaybe<Array<ExplanationStepWhereUniqueInput>>
  /** Update multiple ExplanationStep component instances */
  update?: InputMaybe<Array<ExplanationStepUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple ExplanationStep component instances */
  upsert?: InputMaybe<Array<ExplanationStepUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type ExplanationStepUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<IconEnum>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ExplanationStepUpdateManyLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ExplanationStepUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ExplanationStepUpdateManyLocalizationInput = {
  data: ExplanationStepUpdateManyLocalizationDataInput
  locale: Locale
}

export type ExplanationStepUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ExplanationStepUpdateManyLocalizationInput>>
}

export type ExplanationStepUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ExplanationStepUpdateManyInput
  /** Document search */
  where: ExplanationStepWhereInput
}

export type ExplanationStepUpdateOneInlineInput = {
  /** Create and connect one ExplanationStep document */
  create?: InputMaybe<ExplanationStepCreateInput>
  /** Delete currently connected ExplanationStep document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ExplanationStep document */
  update?: InputMaybe<ExplanationStepUpdateWithNestedWhereUniqueInput>
  /** Upsert single ExplanationStep document */
  upsert?: InputMaybe<ExplanationStepUpsertWithNestedWhereUniqueInput>
}

export type ExplanationStepUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ExplanationStepUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ExplanationStepWhereUniqueInput
}

export type ExplanationStepUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ExplanationStepUpdateInput
  /** Unique document search */
  where: ExplanationStepWhereUniqueInput
}

export type ExplanationStepUpsertInput = {
  /** Create document if it didn't exist */
  create: ExplanationStepCreateInput
  /** Update document if it exists */
  update: ExplanationStepUpdateInput
}

export type ExplanationStepUpsertLocalizationInput = {
  create: ExplanationStepCreateLocalizationDataInput
  locale: Locale
  update: ExplanationStepUpdateLocalizationDataInput
}

export type ExplanationStepUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ExplanationStepUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ExplanationStepWhereUniqueInput
}

export type ExplanationStepUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ExplanationStepUpsertInput
  /** Unique document search */
  where: ExplanationStepWhereUniqueInput
}

/** Identifies documents */
export type ExplanationStepWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExplanationStepWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExplanationStepWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExplanationStepWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<IconEnum>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<IconEnum>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<IconEnum>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<IconEnum>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  lucideIcon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  lucideIcon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  lucideIcon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  lucideIcon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  picture?: InputMaybe<AssetWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References ExplanationStep record uniquely */
export type ExplanationStepWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section showing some frequently asked questions. */
export type Faq = Entity & {
  __typename?: 'Faq'
  ctaText?: Maybe<Scalars['String']['output']>
  ctaUrl?: Maybe<Scalars['String']['output']>
  /** Select a decoration pattern for this component. */
  decorationPattern?: Maybe<DecorationPattern>
  description: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<Faq>
  questions: Array<FaqQuestion>
  /** System stage field */
  stage: Stage
  styleVariant?: Maybe<ComponentStyle>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Display FAQs in a vertical layout? */
  verticalLayout?: Maybe<Scalars['Boolean']['output']>
  /** Sets white BG and removes ? decorations. */
  whiteTheme?: Maybe<Scalars['Boolean']['output']>
}

/** Section showing some frequently asked questions. */
export type FaqLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing some frequently asked questions. */
export type FaqQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<FaqQuestionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FaqQuestionWhereInput>
}

/** Section showing some frequently asked questions. */
export type FaqUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type FaqConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: FaqWhereUniqueInput
}

/** A connection to a list of items. */
export type FaqConnection = {
  __typename?: 'FaqConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<FaqEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type FaqCreateInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FaqCreateLocalizationsInput>
  questions?: InputMaybe<FaqQuestionCreateManyInlineInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  verticalLayout?: InputMaybe<Scalars['Boolean']['input']>
  whiteTheme?: InputMaybe<Scalars['Boolean']['input']>
}

export type FaqCreateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type FaqCreateLocalizationInput = {
  /** Localization input */
  data: FaqCreateLocalizationDataInput
  locale: Locale
}

export type FaqCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FaqCreateLocalizationInput>>
}

export type FaqCreateManyInlineInput = {
  /** Create and connect multiple existing Faq documents */
  create?: InputMaybe<Array<FaqCreateInput>>
}

export type FaqCreateOneInlineInput = {
  /** Create and connect one Faq document */
  create?: InputMaybe<FaqCreateInput>
}

export type FaqCreateWithPositionInput = {
  /** Document to create */
  data: FaqCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type FaqEdge = {
  __typename?: 'FaqEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Faq
}

/** Identifies documents */
export type FaqManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  questions_every?: InputMaybe<FaqQuestionWhereInput>
  questions_none?: InputMaybe<FaqQuestionWhereInput>
  questions_some?: InputMaybe<FaqQuestionWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  verticalLayout?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  verticalLayout_not?: InputMaybe<Scalars['Boolean']['input']>
  whiteTheme?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  whiteTheme_not?: InputMaybe<Scalars['Boolean']['input']>
}

export enum FaqOrderByInput {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VerticalLayoutAsc = 'verticalLayout_ASC',
  VerticalLayoutDesc = 'verticalLayout_DESC',
  WhiteThemeAsc = 'whiteTheme_ASC',
  WhiteThemeDesc = 'whiteTheme_DESC',
}

export type FaqParent = CareerPage | EventPage | LandingPage

export type FaqParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type FaqParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type FaqParentCreateManyInlineInput = {
  /** Connect multiple existing FaqParent documents */
  connect?: InputMaybe<Array<FaqParentWhereUniqueInput>>
  /** Create and connect multiple existing FaqParent documents */
  create?: InputMaybe<Array<FaqParentCreateInput>>
}

export type FaqParentCreateOneInlineInput = {
  /** Connect one existing FaqParent document */
  connect?: InputMaybe<FaqParentWhereUniqueInput>
  /** Create and connect one FaqParent document */
  create?: InputMaybe<FaqParentCreateInput>
}

export type FaqParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type FaqParentUpdateManyInlineInput = {
  /** Connect multiple existing FaqParent documents */
  connect?: InputMaybe<Array<FaqParentConnectInput>>
  /** Create and connect multiple FaqParent documents */
  create?: InputMaybe<Array<FaqParentCreateInput>>
  /** Delete multiple FaqParent documents */
  delete?: InputMaybe<Array<FaqParentWhereUniqueInput>>
  /** Disconnect multiple FaqParent documents */
  disconnect?: InputMaybe<Array<FaqParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing FaqParent documents */
  set?: InputMaybe<Array<FaqParentWhereUniqueInput>>
  /** Update multiple FaqParent documents */
  update?: InputMaybe<Array<FaqParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple FaqParent documents */
  upsert?: InputMaybe<Array<FaqParentUpsertWithNestedWhereUniqueInput>>
}

export type FaqParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type FaqParentUpdateOneInlineInput = {
  /** Connect existing FaqParent document */
  connect?: InputMaybe<FaqParentWhereUniqueInput>
  /** Create and connect one FaqParent document */
  create?: InputMaybe<FaqParentCreateInput>
  /** Delete currently connected FaqParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected FaqParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single FaqParent document */
  update?: InputMaybe<FaqParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single FaqParent document */
  upsert?: InputMaybe<FaqParentUpsertWithNestedWhereUniqueInput>
}

export type FaqParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type FaqParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type FaqParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type FaqParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

/** A question and answer in our FAQs */
export type FaqQuestion = Entity &
  Node & {
    __typename?: 'FaqQuestion'
    answer?: Maybe<Scalars['String']['output']>
    /** Rich text answer. If provided, this field will take precendence over answer field. */
    answerRte?: Maybe<RichText>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<FaqQuestion>
    /** List of FaqQuestion versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<FaqQuestion>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    question?: Maybe<Scalars['String']['output']>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** A question and answer in our FAQs */
export type FaqQuestionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A question and answer in our FAQs */
export type FaqQuestionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** A question and answer in our FAQs */
export type FaqQuestionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** A question and answer in our FAQs */
export type FaqQuestionHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** A question and answer in our FAQs */
export type FaqQuestionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** A question and answer in our FAQs */
export type FaqQuestionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A question and answer in our FAQs */
export type FaqQuestionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** A question and answer in our FAQs */
export type FaqQuestionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** A question and answer in our FAQs */
export type FaqQuestionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A question and answer in our FAQs */
export type FaqQuestionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type FaqQuestionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: FaqQuestionWhereUniqueInput
}

/** A connection to a list of items. */
export type FaqQuestionConnection = {
  __typename?: 'FaqQuestionConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<FaqQuestionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type FaqQuestionCreateInput = {
  /** answer input for default locale (de) */
  answer?: InputMaybe<Scalars['String']['input']>
  /** answerRte input for default locale (de) */
  answerRte?: InputMaybe<Scalars['RichTextAST']['input']>
  clg59ifj401sp01ujct3nhkyj?: InputMaybe<FaqCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FaqQuestionCreateLocalizationsInput>
  /** question input for default locale (de) */
  question?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type FaqQuestionCreateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>
  answerRte?: InputMaybe<Scalars['RichTextAST']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  question?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type FaqQuestionCreateLocalizationInput = {
  /** Localization input */
  data: FaqQuestionCreateLocalizationDataInput
  locale: Locale
}

export type FaqQuestionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FaqQuestionCreateLocalizationInput>>
}

export type FaqQuestionCreateManyInlineInput = {
  /** Connect multiple existing FaqQuestion documents */
  connect?: InputMaybe<Array<FaqQuestionWhereUniqueInput>>
  /** Create and connect multiple existing FaqQuestion documents */
  create?: InputMaybe<Array<FaqQuestionCreateInput>>
}

export type FaqQuestionCreateOneInlineInput = {
  /** Connect one existing FaqQuestion document */
  connect?: InputMaybe<FaqQuestionWhereUniqueInput>
  /** Create and connect one FaqQuestion document */
  create?: InputMaybe<FaqQuestionCreateInput>
}

/** An edge in a connection. */
export type FaqQuestionEdge = {
  __typename?: 'FaqQuestionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: FaqQuestion
}

/** Identifies documents */
export type FaqQuestionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqQuestionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqQuestionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqQuestionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<FaqQuestionWhereStageInput>
  documentInStages_none?: InputMaybe<FaqQuestionWhereStageInput>
  documentInStages_some?: InputMaybe<FaqQuestionWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum FaqQuestionOrderByInput {
  AnswerAsc = 'answer_ASC',
  AnswerDesc = 'answer_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type FaqQuestionUpdateInput = {
  /** answer input for default locale (de) */
  answer?: InputMaybe<Scalars['String']['input']>
  /** answerRte input for default locale (de) */
  answerRte?: InputMaybe<Scalars['RichTextAST']['input']>
  clg59ifj401sp01ujct3nhkyj?: InputMaybe<FaqUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<FaqQuestionUpdateLocalizationsInput>
  /** question input for default locale (de) */
  question?: InputMaybe<Scalars['String']['input']>
}

export type FaqQuestionUpdateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>
  answerRte?: InputMaybe<Scalars['RichTextAST']['input']>
  question?: InputMaybe<Scalars['String']['input']>
}

export type FaqQuestionUpdateLocalizationInput = {
  data: FaqQuestionUpdateLocalizationDataInput
  locale: Locale
}

export type FaqQuestionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FaqQuestionCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<FaqQuestionUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<FaqQuestionUpsertLocalizationInput>>
}

export type FaqQuestionUpdateManyInlineInput = {
  /** Connect multiple existing FaqQuestion documents */
  connect?: InputMaybe<Array<FaqQuestionConnectInput>>
  /** Create and connect multiple FaqQuestion documents */
  create?: InputMaybe<Array<FaqQuestionCreateInput>>
  /** Delete multiple FaqQuestion documents */
  delete?: InputMaybe<Array<FaqQuestionWhereUniqueInput>>
  /** Disconnect multiple FaqQuestion documents */
  disconnect?: InputMaybe<Array<FaqQuestionWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing FaqQuestion documents */
  set?: InputMaybe<Array<FaqQuestionWhereUniqueInput>>
  /** Update multiple FaqQuestion documents */
  update?: InputMaybe<Array<FaqQuestionUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple FaqQuestion documents */
  upsert?: InputMaybe<Array<FaqQuestionUpsertWithNestedWhereUniqueInput>>
}

export type FaqQuestionUpdateManyInput = {
  /** answer input for default locale (de) */
  answer?: InputMaybe<Scalars['String']['input']>
  /** answerRte input for default locale (de) */
  answerRte?: InputMaybe<Scalars['RichTextAST']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<FaqQuestionUpdateManyLocalizationsInput>
  /** question input for default locale (de) */
  question?: InputMaybe<Scalars['String']['input']>
}

export type FaqQuestionUpdateManyLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>
  answerRte?: InputMaybe<Scalars['RichTextAST']['input']>
  question?: InputMaybe<Scalars['String']['input']>
}

export type FaqQuestionUpdateManyLocalizationInput = {
  data: FaqQuestionUpdateManyLocalizationDataInput
  locale: Locale
}

export type FaqQuestionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FaqQuestionUpdateManyLocalizationInput>>
}

export type FaqQuestionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqQuestionUpdateManyInput
  /** Document search */
  where: FaqQuestionWhereInput
}

export type FaqQuestionUpdateOneInlineInput = {
  /** Connect existing FaqQuestion document */
  connect?: InputMaybe<FaqQuestionWhereUniqueInput>
  /** Create and connect one FaqQuestion document */
  create?: InputMaybe<FaqQuestionCreateInput>
  /** Delete currently connected FaqQuestion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected FaqQuestion document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single FaqQuestion document */
  update?: InputMaybe<FaqQuestionUpdateWithNestedWhereUniqueInput>
  /** Upsert single FaqQuestion document */
  upsert?: InputMaybe<FaqQuestionUpsertWithNestedWhereUniqueInput>
}

export type FaqQuestionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqQuestionUpdateInput
  /** Unique document search */
  where: FaqQuestionWhereUniqueInput
}

export type FaqQuestionUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqQuestionCreateInput
  /** Update document if it exists */
  update: FaqQuestionUpdateInput
}

export type FaqQuestionUpsertLocalizationInput = {
  create: FaqQuestionCreateLocalizationDataInput
  locale: Locale
  update: FaqQuestionUpdateLocalizationDataInput
}

export type FaqQuestionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqQuestionUpsertInput
  /** Unique document search */
  where: FaqQuestionWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type FaqQuestionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type FaqQuestionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqQuestionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqQuestionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqQuestionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  answer?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  answer_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  answer_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  answer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  answer_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  answer_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  answer_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  answer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  answer_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  answer_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<FaqQuestionWhereStageInput>
  documentInStages_none?: InputMaybe<FaqQuestionWhereStageInput>
  documentInStages_some?: InputMaybe<FaqQuestionWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  question?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqQuestionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqQuestionWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqQuestionWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqQuestionWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqQuestionWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References FaqQuestion record uniquely */
export type FaqQuestionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type FaqUpdateInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<FaqUpdateLocalizationsInput>
  questions?: InputMaybe<FaqQuestionUpdateManyInlineInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  verticalLayout?: InputMaybe<Scalars['Boolean']['input']>
  whiteTheme?: InputMaybe<Scalars['Boolean']['input']>
}

export type FaqUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type FaqUpdateLocalizationInput = {
  data: FaqUpdateLocalizationDataInput
  locale: Locale
}

export type FaqUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FaqCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<FaqUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<FaqUpsertLocalizationInput>>
}

export type FaqUpdateManyInlineInput = {
  /** Create and connect multiple Faq component instances */
  create?: InputMaybe<Array<FaqCreateWithPositionInput>>
  /** Delete multiple Faq documents */
  delete?: InputMaybe<Array<FaqWhereUniqueInput>>
  /** Update multiple Faq component instances */
  update?: InputMaybe<Array<FaqUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple Faq component instances */
  upsert?: InputMaybe<Array<FaqUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type FaqUpdateManyInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<FaqUpdateManyLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  verticalLayout?: InputMaybe<Scalars['Boolean']['input']>
  whiteTheme?: InputMaybe<Scalars['Boolean']['input']>
}

export type FaqUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type FaqUpdateManyLocalizationInput = {
  data: FaqUpdateManyLocalizationDataInput
  locale: Locale
}

export type FaqUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FaqUpdateManyLocalizationInput>>
}

export type FaqUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqUpdateManyInput
  /** Document search */
  where: FaqWhereInput
}

export type FaqUpdateOneInlineInput = {
  /** Create and connect one Faq document */
  create?: InputMaybe<FaqCreateInput>
  /** Delete currently connected Faq document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Faq document */
  update?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>
  /** Upsert single Faq document */
  upsert?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>
}

export type FaqUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FaqUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: FaqWhereUniqueInput
}

export type FaqUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqUpdateInput
  /** Unique document search */
  where: FaqWhereUniqueInput
}

export type FaqUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqCreateInput
  /** Update document if it exists */
  update: FaqUpdateInput
}

export type FaqUpsertLocalizationInput = {
  create: FaqCreateLocalizationDataInput
  locale: Locale
  update: FaqUpdateLocalizationDataInput
}

export type FaqUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FaqUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: FaqWhereUniqueInput
}

export type FaqUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqUpsertInput
  /** Unique document search */
  where: FaqWhereUniqueInput
}

/** Identifies documents */
export type FaqWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  questions_every?: InputMaybe<FaqQuestionWhereInput>
  questions_none?: InputMaybe<FaqQuestionWhereInput>
  questions_some?: InputMaybe<FaqQuestionWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  verticalLayout?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  verticalLayout_not?: InputMaybe<Scalars['Boolean']['input']>
  whiteTheme?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  whiteTheme_not?: InputMaybe<Scalars['Boolean']['input']>
}

/** References Faq record uniquely */
export type FaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** the type of food on offer at this particular food stand */
export enum FestivalFoodType {
  Fish = 'fish',
  Meat = 'meat',
  Vegan = 'vegan',
  Veggie = 'veggie',
}

/** the type of place recommended for a night on the town during the festival */
export enum FestivalNightOutType {
  Bar = 'bar',
  Club = 'club',
}

/** OMR footer */
export type Footer = Entity &
  Node & {
    __typename?: 'Footer'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<Footer>
    /** List of Footer versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    omrFooterLinks: Array<FooterLink>
    omrFooterSocials: Array<SocialLink>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** OMR footer */
export type FooterCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** OMR footer */
export type FooterDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** OMR footer */
export type FooterHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** OMR footer */
export type FooterOmrFooterLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<FooterLinkOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FooterLinkWhereInput>
}

/** OMR footer */
export type FooterOmrFooterSocialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SocialLinkOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SocialLinkWhereInput>
}

/** OMR footer */
export type FooterPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** OMR footer */
export type FooterScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** OMR footer */
export type FooterUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type FooterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: FooterWhereUniqueInput
}

/** A connection to a list of items. */
export type FooterConnection = {
  __typename?: 'FooterConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<FooterEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type FooterCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FooterCreateLocalizationsInput>
  omrFooterLinks?: InputMaybe<FooterLinkCreateManyInlineInput>
  omrFooterSocials?: InputMaybe<SocialLinkCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type FooterCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type FooterCreateLocalizationInput = {
  /** Localization input */
  data: FooterCreateLocalizationDataInput
  locale: Locale
}

export type FooterCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FooterCreateLocalizationInput>>
}

export type FooterCreateManyInlineInput = {
  /** Connect multiple existing Footer documents */
  connect?: InputMaybe<Array<FooterWhereUniqueInput>>
  /** Create and connect multiple existing Footer documents */
  create?: InputMaybe<Array<FooterCreateInput>>
}

export type FooterCreateOneInlineInput = {
  /** Connect one existing Footer document */
  connect?: InputMaybe<FooterWhereUniqueInput>
  /** Create and connect one Footer document */
  create?: InputMaybe<FooterCreateInput>
}

/** An edge in a connection. */
export type FooterEdge = {
  __typename?: 'FooterEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Footer
}

/** OMR footer link */
export type FooterLink = Entity & {
  __typename?: 'FooterLink'
  /** The unique identifier */
  id: Scalars['ID']['output']
  link?: Maybe<Scalars['String']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<FooterLink>
  name?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** OMR footer link */
export type FooterLinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** OMR footer link */
export type FooterLinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type FooterLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: FooterLinkWhereUniqueInput
}

/** A connection to a list of items. */
export type FooterLinkConnection = {
  __typename?: 'FooterLinkConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<FooterLinkEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type FooterLinkCreateInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FooterLinkCreateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type FooterLinkCreateLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type FooterLinkCreateLocalizationInput = {
  /** Localization input */
  data: FooterLinkCreateLocalizationDataInput
  locale: Locale
}

export type FooterLinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FooterLinkCreateLocalizationInput>>
}

export type FooterLinkCreateManyInlineInput = {
  /** Create and connect multiple existing FooterLink documents */
  create?: InputMaybe<Array<FooterLinkCreateInput>>
}

export type FooterLinkCreateOneInlineInput = {
  /** Create and connect one FooterLink document */
  create?: InputMaybe<FooterLinkCreateInput>
}

export type FooterLinkCreateWithPositionInput = {
  /** Document to create */
  data: FooterLinkCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type FooterLinkEdge = {
  __typename?: 'FooterLinkEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: FooterLink
}

/** Identifies documents */
export type FooterLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterLinkWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterLinkWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterLinkWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum FooterLinkOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type FooterLinkParent = Footer

export type FooterLinkParentConnectInput = {
  Footer?: InputMaybe<FooterConnectInput>
}

export type FooterLinkParentCreateInput = {
  Footer?: InputMaybe<FooterCreateInput>
}

export type FooterLinkParentCreateManyInlineInput = {
  /** Connect multiple existing FooterLinkParent documents */
  connect?: InputMaybe<Array<FooterLinkParentWhereUniqueInput>>
  /** Create and connect multiple existing FooterLinkParent documents */
  create?: InputMaybe<Array<FooterLinkParentCreateInput>>
}

export type FooterLinkParentCreateOneInlineInput = {
  /** Connect one existing FooterLinkParent document */
  connect?: InputMaybe<FooterLinkParentWhereUniqueInput>
  /** Create and connect one FooterLinkParent document */
  create?: InputMaybe<FooterLinkParentCreateInput>
}

export type FooterLinkParentUpdateInput = {
  Footer?: InputMaybe<FooterUpdateInput>
}

export type FooterLinkParentUpdateManyInlineInput = {
  /** Connect multiple existing FooterLinkParent documents */
  connect?: InputMaybe<Array<FooterLinkParentConnectInput>>
  /** Create and connect multiple FooterLinkParent documents */
  create?: InputMaybe<Array<FooterLinkParentCreateInput>>
  /** Delete multiple FooterLinkParent documents */
  delete?: InputMaybe<Array<FooterLinkParentWhereUniqueInput>>
  /** Disconnect multiple FooterLinkParent documents */
  disconnect?: InputMaybe<Array<FooterLinkParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing FooterLinkParent documents */
  set?: InputMaybe<Array<FooterLinkParentWhereUniqueInput>>
  /** Update multiple FooterLinkParent documents */
  update?: InputMaybe<Array<FooterLinkParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple FooterLinkParent documents */
  upsert?: InputMaybe<Array<FooterLinkParentUpsertWithNestedWhereUniqueInput>>
}

export type FooterLinkParentUpdateManyWithNestedWhereInput = {
  Footer?: InputMaybe<FooterUpdateManyWithNestedWhereInput>
}

export type FooterLinkParentUpdateOneInlineInput = {
  /** Connect existing FooterLinkParent document */
  connect?: InputMaybe<FooterLinkParentWhereUniqueInput>
  /** Create and connect one FooterLinkParent document */
  create?: InputMaybe<FooterLinkParentCreateInput>
  /** Delete currently connected FooterLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected FooterLinkParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single FooterLinkParent document */
  update?: InputMaybe<FooterLinkParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single FooterLinkParent document */
  upsert?: InputMaybe<FooterLinkParentUpsertWithNestedWhereUniqueInput>
}

export type FooterLinkParentUpdateWithNestedWhereUniqueInput = {
  Footer?: InputMaybe<FooterUpdateWithNestedWhereUniqueInput>
}

export type FooterLinkParentUpsertWithNestedWhereUniqueInput = {
  Footer?: InputMaybe<FooterUpsertWithNestedWhereUniqueInput>
}

export type FooterLinkParentWhereInput = {
  Footer?: InputMaybe<FooterWhereInput>
}

export type FooterLinkParentWhereUniqueInput = {
  Footer?: InputMaybe<FooterWhereUniqueInput>
}

export type FooterLinkUpdateInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<FooterLinkUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
}

export type FooterLinkUpdateLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type FooterLinkUpdateLocalizationInput = {
  data: FooterLinkUpdateLocalizationDataInput
  locale: Locale
}

export type FooterLinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FooterLinkCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<FooterLinkUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<FooterLinkUpsertLocalizationInput>>
}

export type FooterLinkUpdateManyInlineInput = {
  /** Create and connect multiple FooterLink component instances */
  create?: InputMaybe<Array<FooterLinkCreateWithPositionInput>>
  /** Delete multiple FooterLink documents */
  delete?: InputMaybe<Array<FooterLinkWhereUniqueInput>>
  /** Update multiple FooterLink component instances */
  update?: InputMaybe<Array<FooterLinkUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple FooterLink component instances */
  upsert?: InputMaybe<Array<FooterLinkUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type FooterLinkUpdateManyInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<FooterLinkUpdateManyLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
}

export type FooterLinkUpdateManyLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type FooterLinkUpdateManyLocalizationInput = {
  data: FooterLinkUpdateManyLocalizationDataInput
  locale: Locale
}

export type FooterLinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FooterLinkUpdateManyLocalizationInput>>
}

export type FooterLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FooterLinkUpdateManyInput
  /** Document search */
  where: FooterLinkWhereInput
}

export type FooterLinkUpdateOneInlineInput = {
  /** Create and connect one FooterLink document */
  create?: InputMaybe<FooterLinkCreateInput>
  /** Delete currently connected FooterLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single FooterLink document */
  update?: InputMaybe<FooterLinkUpdateWithNestedWhereUniqueInput>
  /** Upsert single FooterLink document */
  upsert?: InputMaybe<FooterLinkUpsertWithNestedWhereUniqueInput>
}

export type FooterLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FooterLinkUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: FooterLinkWhereUniqueInput
}

export type FooterLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FooterLinkUpdateInput
  /** Unique document search */
  where: FooterLinkWhereUniqueInput
}

export type FooterLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: FooterLinkCreateInput
  /** Update document if it exists */
  update: FooterLinkUpdateInput
}

export type FooterLinkUpsertLocalizationInput = {
  create: FooterLinkCreateLocalizationDataInput
  locale: Locale
  update: FooterLinkUpdateLocalizationDataInput
}

export type FooterLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FooterLinkUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: FooterLinkWhereUniqueInput
}

export type FooterLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FooterLinkUpsertInput
  /** Unique document search */
  where: FooterLinkWhereUniqueInput
}

/** Identifies documents */
export type FooterLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterLinkWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterLinkWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterLinkWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References FooterLink record uniquely */
export type FooterLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Identifies documents */
export type FooterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<FooterWhereStageInput>
  documentInStages_none?: InputMaybe<FooterWhereStageInput>
  documentInStages_some?: InputMaybe<FooterWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  omrFooterLinks_every?: InputMaybe<FooterLinkWhereInput>
  omrFooterLinks_none?: InputMaybe<FooterLinkWhereInput>
  omrFooterLinks_some?: InputMaybe<FooterLinkWhereInput>
  omrFooterSocials_every?: InputMaybe<SocialLinkWhereInput>
  omrFooterSocials_none?: InputMaybe<SocialLinkWhereInput>
  omrFooterSocials_some?: InputMaybe<SocialLinkWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum FooterOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type FooterUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<FooterUpdateLocalizationsInput>
  omrFooterLinks?: InputMaybe<FooterLinkUpdateManyInlineInput>
  omrFooterSocials?: InputMaybe<SocialLinkUpdateManyInlineInput>
}

export type FooterUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FooterCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
}

export type FooterUpdateManyInlineInput = {
  /** Connect multiple existing Footer documents */
  connect?: InputMaybe<Array<FooterConnectInput>>
  /** Create and connect multiple Footer documents */
  create?: InputMaybe<Array<FooterCreateInput>>
  /** Delete multiple Footer documents */
  delete?: InputMaybe<Array<FooterWhereUniqueInput>>
  /** Disconnect multiple Footer documents */
  disconnect?: InputMaybe<Array<FooterWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Footer documents */
  set?: InputMaybe<Array<FooterWhereUniqueInput>>
  /** Update multiple Footer documents */
  update?: InputMaybe<Array<FooterUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Footer documents */
  upsert?: InputMaybe<Array<FooterUpsertWithNestedWhereUniqueInput>>
}

export type FooterUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type FooterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FooterUpdateManyInput
  /** Document search */
  where: FooterWhereInput
}

export type FooterUpdateOneInlineInput = {
  /** Connect existing Footer document */
  connect?: InputMaybe<FooterWhereUniqueInput>
  /** Create and connect one Footer document */
  create?: InputMaybe<FooterCreateInput>
  /** Delete currently connected Footer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Footer document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Footer document */
  update?: InputMaybe<FooterUpdateWithNestedWhereUniqueInput>
  /** Upsert single Footer document */
  upsert?: InputMaybe<FooterUpsertWithNestedWhereUniqueInput>
}

export type FooterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FooterUpdateInput
  /** Unique document search */
  where: FooterWhereUniqueInput
}

export type FooterUpsertInput = {
  /** Create document if it didn't exist */
  create: FooterCreateInput
  /** Update document if it exists */
  update: FooterUpdateInput
}

export type FooterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FooterUpsertInput
  /** Unique document search */
  where: FooterWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type FooterWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type FooterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<FooterWhereStageInput>
  documentInStages_none?: InputMaybe<FooterWhereStageInput>
  documentInStages_some?: InputMaybe<FooterWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  omrFooterLinks_every?: InputMaybe<FooterLinkWhereInput>
  omrFooterLinks_none?: InputMaybe<FooterLinkWhereInput>
  omrFooterLinks_some?: InputMaybe<FooterLinkWhereInput>
  omrFooterSocials_every?: InputMaybe<SocialLinkWhereInput>
  omrFooterSocials_none?: InputMaybe<SocialLinkWhereInput>
  omrFooterSocials_some?: InputMaybe<SocialLinkWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FooterWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FooterWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Footer record uniquely */
export type FooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Glossary model with term explanation */
export type Glossary = Entity &
  Node & {
    __typename?: 'Glossary'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description: GlossaryDescriptionRichText
    /** Get the document in other stages */
    documentInStages: Array<Glossary>
    /** List of Glossary versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Glossary>
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** Optional configuration if you want to have specific SEO Attributes. */
    seoAttributes?: Maybe<Seo>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    topicPageRedirect?: Maybe<TopicPage>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    /** Optional wordpress reference used by importer */
    wpId?: Maybe<Scalars['String']['output']>
  }

/** Glossary model with term explanation */
export type GlossaryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Glossary model with term explanation */
export type GlossaryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Glossary model with term explanation */
export type GlossaryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Glossary model with term explanation */
export type GlossaryHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Glossary model with term explanation */
export type GlossaryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Glossary model with term explanation */
export type GlossaryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Glossary model with term explanation */
export type GlossaryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Glossary model with term explanation */
export type GlossaryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Glossary model with term explanation */
export type GlossarySeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Glossary model with term explanation */
export type GlossaryTopicPageRedirectArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Glossary model with term explanation */
export type GlossaryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Glossary model with term explanation */
export type GlossaryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type GlossaryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: GlossaryWhereUniqueInput
}

/** A connection to a list of items. */
export type GlossaryConnection = {
  __typename?: 'GlossaryConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<GlossaryEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type GlossaryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description: Scalars['RichTextAST']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GlossaryCreateLocalizationsInput>
  name: Scalars['String']['input']
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  slug: Scalars['String']['input']
  topicPageRedirect?: InputMaybe<TopicPageCreateOneInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type GlossaryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description: Scalars['RichTextAST']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type GlossaryCreateLocalizationInput = {
  /** Localization input */
  data: GlossaryCreateLocalizationDataInput
  locale: Locale
}

export type GlossaryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GlossaryCreateLocalizationInput>>
}

export type GlossaryCreateManyInlineInput = {
  /** Connect multiple existing Glossary documents */
  connect?: InputMaybe<Array<GlossaryWhereUniqueInput>>
  /** Create and connect multiple existing Glossary documents */
  create?: InputMaybe<Array<GlossaryCreateInput>>
}

export type GlossaryCreateOneInlineInput = {
  /** Connect one existing Glossary document */
  connect?: InputMaybe<GlossaryWhereUniqueInput>
  /** Create and connect one Glossary document */
  create?: InputMaybe<GlossaryCreateInput>
}

export type GlossaryDescriptionRichText = {
  __typename?: 'GlossaryDescriptionRichText'
  /** Returns HTMl representation */
  html: Scalars['String']['output']
  json: Scalars['RichTextAST']['output']
  /** Returns Markdown representation */
  markdown: Scalars['String']['output']
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output']
  references: Array<GlossaryDescriptionRichTextEmbeddedTypes>
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output']
}

export type GlossaryDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
}

export type GlossaryDescriptionRichTextEmbeddedTypes = Asset | HtmlEmbed | ReviewsProduct | ReviewsProductCategory | SocialEmbed

/** An edge in a connection. */
export type GlossaryEdge = {
  __typename?: 'GlossaryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Glossary
}

/** Identifies documents */
export type GlossaryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlossaryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlossaryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlossaryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<GlossaryWhereStageInput>
  documentInStages_none?: InputMaybe<GlossaryWhereStageInput>
  documentInStages_some?: InputMaybe<GlossaryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  topicPageRedirect?: InputMaybe<TopicPageWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum GlossaryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WpIdAsc = 'wpId_ASC',
  WpIdDesc = 'wpId_DESC',
}

export type GlossaryUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<GlossaryUpdateLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  topicPageRedirect?: InputMaybe<TopicPageUpdateOneInlineInput>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type GlossaryUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type GlossaryUpdateLocalizationInput = {
  data: GlossaryUpdateLocalizationDataInput
  locale: Locale
}

export type GlossaryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GlossaryCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<GlossaryUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<GlossaryUpsertLocalizationInput>>
}

export type GlossaryUpdateManyInlineInput = {
  /** Connect multiple existing Glossary documents */
  connect?: InputMaybe<Array<GlossaryConnectInput>>
  /** Create and connect multiple Glossary documents */
  create?: InputMaybe<Array<GlossaryCreateInput>>
  /** Delete multiple Glossary documents */
  delete?: InputMaybe<Array<GlossaryWhereUniqueInput>>
  /** Disconnect multiple Glossary documents */
  disconnect?: InputMaybe<Array<GlossaryWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Glossary documents */
  set?: InputMaybe<Array<GlossaryWhereUniqueInput>>
  /** Update multiple Glossary documents */
  update?: InputMaybe<Array<GlossaryUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Glossary documents */
  upsert?: InputMaybe<Array<GlossaryUpsertWithNestedWhereUniqueInput>>
}

export type GlossaryUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<GlossaryUpdateManyLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
}

export type GlossaryUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type GlossaryUpdateManyLocalizationInput = {
  data: GlossaryUpdateManyLocalizationDataInput
  locale: Locale
}

export type GlossaryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GlossaryUpdateManyLocalizationInput>>
}

export type GlossaryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GlossaryUpdateManyInput
  /** Document search */
  where: GlossaryWhereInput
}

export type GlossaryUpdateOneInlineInput = {
  /** Connect existing Glossary document */
  connect?: InputMaybe<GlossaryWhereUniqueInput>
  /** Create and connect one Glossary document */
  create?: InputMaybe<GlossaryCreateInput>
  /** Delete currently connected Glossary document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Glossary document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Glossary document */
  update?: InputMaybe<GlossaryUpdateWithNestedWhereUniqueInput>
  /** Upsert single Glossary document */
  upsert?: InputMaybe<GlossaryUpsertWithNestedWhereUniqueInput>
}

export type GlossaryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GlossaryUpdateInput
  /** Unique document search */
  where: GlossaryWhereUniqueInput
}

export type GlossaryUpsertInput = {
  /** Create document if it didn't exist */
  create: GlossaryCreateInput
  /** Update document if it exists */
  update: GlossaryUpdateInput
}

export type GlossaryUpsertLocalizationInput = {
  create: GlossaryCreateLocalizationDataInput
  locale: Locale
  update: GlossaryUpdateLocalizationDataInput
}

export type GlossaryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GlossaryUpsertInput
  /** Unique document search */
  where: GlossaryWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type GlossaryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type GlossaryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlossaryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlossaryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlossaryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<GlossaryWhereStageInput>
  documentInStages_none?: InputMaybe<GlossaryWhereStageInput>
  documentInStages_some?: InputMaybe<GlossaryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  topicPageRedirect?: InputMaybe<TopicPageWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GlossaryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlossaryWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlossaryWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlossaryWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GlossaryWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Glossary record uniquely */
export type GlossaryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

/** Header */
export type Header = Entity &
  Node & {
    __typename?: 'Header'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<Header>
    /** List of Header versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    logo?: Maybe<Asset>
    mobileLogo?: Maybe<Asset>
    omrHeaderMenuItems: Array<HeaderMenuItem>
    omrHeaderPartners: Array<OmrPartner>
    omrHeaderSocials: Array<SocialLink>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Header */
export type HeaderCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Header */
export type HeaderDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Header */
export type HeaderHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Header */
export type HeaderLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Header */
export type HeaderMobileLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Header */
export type HeaderOmrHeaderMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<HeaderMenuItemOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HeaderMenuItemWhereInput>
}

/** Header */
export type HeaderOmrHeaderPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<OmrPartnerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<OmrPartnerWhereInput>
}

/** Header */
export type HeaderOmrHeaderSocialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SocialLinkOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SocialLinkWhereInput>
}

/** Header */
export type HeaderPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Header */
export type HeaderScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Header */
export type HeaderUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HeaderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HeaderWhereUniqueInput
}

/** A connection to a list of items. */
export type HeaderConnection = {
  __typename?: 'HeaderConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HeaderEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HeaderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HeaderCreateLocalizationsInput>
  logo?: InputMaybe<AssetCreateOneInlineInput>
  mobileLogo?: InputMaybe<AssetCreateOneInlineInput>
  omrHeaderMenuItems?: InputMaybe<HeaderMenuItemCreateManyInlineInput>
  omrHeaderPartners?: InputMaybe<OmrPartnerCreateManyInlineInput>
  omrHeaderSocials?: InputMaybe<SocialLinkCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderCreateLocalizationInput = {
  /** Localization input */
  data: HeaderCreateLocalizationDataInput
  locale: Locale
}

export type HeaderCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HeaderCreateLocalizationInput>>
}

export type HeaderCreateManyInlineInput = {
  /** Connect multiple existing Header documents */
  connect?: InputMaybe<Array<HeaderWhereUniqueInput>>
  /** Create and connect multiple existing Header documents */
  create?: InputMaybe<Array<HeaderCreateInput>>
}

export type HeaderCreateOneInlineInput = {
  /** Connect one existing Header document */
  connect?: InputMaybe<HeaderWhereUniqueInput>
  /** Create and connect one Header document */
  create?: InputMaybe<HeaderCreateInput>
}

/** An edge in a connection. */
export type HeaderEdge = {
  __typename?: 'HeaderEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Header
}

/** Identifies documents */
export type HeaderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HeaderWhereStageInput>
  documentInStages_none?: InputMaybe<HeaderWhereStageInput>
  documentInStages_some?: InputMaybe<HeaderWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  mobileLogo?: InputMaybe<AssetWhereInput>
  omrHeaderMenuItems_every?: InputMaybe<HeaderMenuItemWhereInput>
  omrHeaderMenuItems_none?: InputMaybe<HeaderMenuItemWhereInput>
  omrHeaderMenuItems_some?: InputMaybe<HeaderMenuItemWhereInput>
  omrHeaderPartners_every?: InputMaybe<OmrPartnerWhereInput>
  omrHeaderPartners_none?: InputMaybe<OmrPartnerWhereInput>
  omrHeaderPartners_some?: InputMaybe<OmrPartnerWhereInput>
  omrHeaderSocials_every?: InputMaybe<SocialLinkWhereInput>
  omrHeaderSocials_none?: InputMaybe<SocialLinkWhereInput>
  omrHeaderSocials_some?: InputMaybe<SocialLinkWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** Header menu item */
export type HeaderMenuItem = Entity & {
  __typename?: 'HeaderMenuItem'
  /** The unique identifier */
  id: Scalars['ID']['output']
  link: Scalars['String']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HeaderMenuItem>
  name: Scalars['String']['output']
  omrHeaderSubmenuCta?: Maybe<CallToAction>
  omrHeaderSubmenuItems: Array<HeaderSubMenuItem>
  promo?: Maybe<HeaderPromo>
  slug: Scalars['String']['output']
  /** System stage field */
  stage: Stage
  /** Header menu item subtitle */
  subtitle: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Header menu item */
export type HeaderMenuItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Header menu item */
export type HeaderMenuItemOmrHeaderSubmenuCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Header menu item */
export type HeaderMenuItemOmrHeaderSubmenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<HeaderSubMenuItemOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HeaderSubMenuItemWhereInput>
}

/** Header menu item */
export type HeaderMenuItemPromoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Header menu item */
export type HeaderMenuItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HeaderMenuItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HeaderMenuItemWhereUniqueInput
}

/** A connection to a list of items. */
export type HeaderMenuItemConnection = {
  __typename?: 'HeaderMenuItemConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HeaderMenuItemEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HeaderMenuItemCreateInput = {
  /** link input for default locale (de) */
  link: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HeaderMenuItemCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  omrHeaderSubmenuCta?: InputMaybe<CallToActionCreateOneInlineInput>
  omrHeaderSubmenuItems?: InputMaybe<HeaderSubMenuItemCreateManyInlineInput>
  promo?: InputMaybe<HeaderPromoCreateOneInlineInput>
  slug: Scalars['String']['input']
  /** subtitle input for default locale (de) */
  subtitle: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderMenuItemCreateLocalizationDataInput = {
  link: Scalars['String']['input']
  name: Scalars['String']['input']
  subtitle: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderMenuItemCreateLocalizationInput = {
  /** Localization input */
  data: HeaderMenuItemCreateLocalizationDataInput
  locale: Locale
}

export type HeaderMenuItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HeaderMenuItemCreateLocalizationInput>>
}

export type HeaderMenuItemCreateManyInlineInput = {
  /** Create and connect multiple existing HeaderMenuItem documents */
  create?: InputMaybe<Array<HeaderMenuItemCreateInput>>
}

export type HeaderMenuItemCreateOneInlineInput = {
  /** Create and connect one HeaderMenuItem document */
  create?: InputMaybe<HeaderMenuItemCreateInput>
}

export type HeaderMenuItemCreateWithPositionInput = {
  /** Document to create */
  data: HeaderMenuItemCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HeaderMenuItemEdge = {
  __typename?: 'HeaderMenuItemEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HeaderMenuItem
}

/** Identifies documents */
export type HeaderMenuItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderMenuItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderMenuItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderMenuItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  omrHeaderSubmenuCta?: InputMaybe<CallToActionWhereInput>
  omrHeaderSubmenuItems_every?: InputMaybe<HeaderSubMenuItemWhereInput>
  omrHeaderSubmenuItems_none?: InputMaybe<HeaderSubMenuItemWhereInput>
  omrHeaderSubmenuItems_some?: InputMaybe<HeaderSubMenuItemWhereInput>
  promo?: InputMaybe<HeaderPromoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HeaderMenuItemOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HeaderMenuItemParent = Header

export type HeaderMenuItemParentConnectInput = {
  Header?: InputMaybe<HeaderConnectInput>
}

export type HeaderMenuItemParentCreateInput = {
  Header?: InputMaybe<HeaderCreateInput>
}

export type HeaderMenuItemParentCreateManyInlineInput = {
  /** Connect multiple existing HeaderMenuItemParent documents */
  connect?: InputMaybe<Array<HeaderMenuItemParentWhereUniqueInput>>
  /** Create and connect multiple existing HeaderMenuItemParent documents */
  create?: InputMaybe<Array<HeaderMenuItemParentCreateInput>>
}

export type HeaderMenuItemParentCreateOneInlineInput = {
  /** Connect one existing HeaderMenuItemParent document */
  connect?: InputMaybe<HeaderMenuItemParentWhereUniqueInput>
  /** Create and connect one HeaderMenuItemParent document */
  create?: InputMaybe<HeaderMenuItemParentCreateInput>
}

export type HeaderMenuItemParentUpdateInput = {
  Header?: InputMaybe<HeaderUpdateInput>
}

export type HeaderMenuItemParentUpdateManyInlineInput = {
  /** Connect multiple existing HeaderMenuItemParent documents */
  connect?: InputMaybe<Array<HeaderMenuItemParentConnectInput>>
  /** Create and connect multiple HeaderMenuItemParent documents */
  create?: InputMaybe<Array<HeaderMenuItemParentCreateInput>>
  /** Delete multiple HeaderMenuItemParent documents */
  delete?: InputMaybe<Array<HeaderMenuItemParentWhereUniqueInput>>
  /** Disconnect multiple HeaderMenuItemParent documents */
  disconnect?: InputMaybe<Array<HeaderMenuItemParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HeaderMenuItemParent documents */
  set?: InputMaybe<Array<HeaderMenuItemParentWhereUniqueInput>>
  /** Update multiple HeaderMenuItemParent documents */
  update?: InputMaybe<Array<HeaderMenuItemParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HeaderMenuItemParent documents */
  upsert?: InputMaybe<Array<HeaderMenuItemParentUpsertWithNestedWhereUniqueInput>>
}

export type HeaderMenuItemParentUpdateManyWithNestedWhereInput = {
  Header?: InputMaybe<HeaderUpdateManyWithNestedWhereInput>
}

export type HeaderMenuItemParentUpdateOneInlineInput = {
  /** Connect existing HeaderMenuItemParent document */
  connect?: InputMaybe<HeaderMenuItemParentWhereUniqueInput>
  /** Create and connect one HeaderMenuItemParent document */
  create?: InputMaybe<HeaderMenuItemParentCreateInput>
  /** Delete currently connected HeaderMenuItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HeaderMenuItemParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeaderMenuItemParent document */
  update?: InputMaybe<HeaderMenuItemParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeaderMenuItemParent document */
  upsert?: InputMaybe<HeaderMenuItemParentUpsertWithNestedWhereUniqueInput>
}

export type HeaderMenuItemParentUpdateWithNestedWhereUniqueInput = {
  Header?: InputMaybe<HeaderUpdateWithNestedWhereUniqueInput>
}

export type HeaderMenuItemParentUpsertWithNestedWhereUniqueInput = {
  Header?: InputMaybe<HeaderUpsertWithNestedWhereUniqueInput>
}

export type HeaderMenuItemParentWhereInput = {
  Header?: InputMaybe<HeaderWhereInput>
}

export type HeaderMenuItemParentWhereUniqueInput = {
  Header?: InputMaybe<HeaderWhereUniqueInput>
}

export type HeaderMenuItemUpdateInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<HeaderMenuItemUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  omrHeaderSubmenuCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  omrHeaderSubmenuItems?: InputMaybe<HeaderSubMenuItemUpdateManyInlineInput>
  promo?: InputMaybe<HeaderPromoUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HeaderMenuItemUpdateLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HeaderMenuItemUpdateLocalizationInput = {
  data: HeaderMenuItemUpdateLocalizationDataInput
  locale: Locale
}

export type HeaderMenuItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HeaderMenuItemCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HeaderMenuItemUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HeaderMenuItemUpsertLocalizationInput>>
}

export type HeaderMenuItemUpdateManyInlineInput = {
  /** Create and connect multiple HeaderMenuItem component instances */
  create?: InputMaybe<Array<HeaderMenuItemCreateWithPositionInput>>
  /** Delete multiple HeaderMenuItem documents */
  delete?: InputMaybe<Array<HeaderMenuItemWhereUniqueInput>>
  /** Update multiple HeaderMenuItem component instances */
  update?: InputMaybe<Array<HeaderMenuItemUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeaderMenuItem component instances */
  upsert?: InputMaybe<Array<HeaderMenuItemUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeaderMenuItemUpdateManyInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HeaderMenuItemUpdateManyLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HeaderMenuItemUpdateManyLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HeaderMenuItemUpdateManyLocalizationInput = {
  data: HeaderMenuItemUpdateManyLocalizationDataInput
  locale: Locale
}

export type HeaderMenuItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HeaderMenuItemUpdateManyLocalizationInput>>
}

export type HeaderMenuItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeaderMenuItemUpdateManyInput
  /** Document search */
  where: HeaderMenuItemWhereInput
}

export type HeaderMenuItemUpdateOneInlineInput = {
  /** Create and connect one HeaderMenuItem document */
  create?: InputMaybe<HeaderMenuItemCreateInput>
  /** Delete currently connected HeaderMenuItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeaderMenuItem document */
  update?: InputMaybe<HeaderMenuItemUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeaderMenuItem document */
  upsert?: InputMaybe<HeaderMenuItemUpsertWithNestedWhereUniqueInput>
}

export type HeaderMenuItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HeaderMenuItemUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeaderMenuItemWhereUniqueInput
}

export type HeaderMenuItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeaderMenuItemUpdateInput
  /** Unique document search */
  where: HeaderMenuItemWhereUniqueInput
}

export type HeaderMenuItemUpsertInput = {
  /** Create document if it didn't exist */
  create: HeaderMenuItemCreateInput
  /** Update document if it exists */
  update: HeaderMenuItemUpdateInput
}

export type HeaderMenuItemUpsertLocalizationInput = {
  create: HeaderMenuItemCreateLocalizationDataInput
  locale: Locale
  update: HeaderMenuItemUpdateLocalizationDataInput
}

export type HeaderMenuItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HeaderMenuItemUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeaderMenuItemWhereUniqueInput
}

export type HeaderMenuItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeaderMenuItemUpsertInput
  /** Unique document search */
  where: HeaderMenuItemWhereUniqueInput
}

/** Identifies documents */
export type HeaderMenuItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderMenuItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderMenuItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderMenuItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  omrHeaderSubmenuCta?: InputMaybe<CallToActionWhereInput>
  omrHeaderSubmenuItems_every?: InputMaybe<HeaderSubMenuItemWhereInput>
  omrHeaderSubmenuItems_none?: InputMaybe<HeaderSubMenuItemWhereInput>
  omrHeaderSubmenuItems_some?: InputMaybe<HeaderSubMenuItemWhereInput>
  promo?: InputMaybe<HeaderPromoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HeaderMenuItem record uniquely */
export type HeaderMenuItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum HeaderOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HeaderPromo = Entity & {
  __typename?: 'HeaderPromo'
  cta?: Maybe<CallToAction>
  /** The unique identifier */
  id: Scalars['ID']['output']
  image: Asset
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HeaderPromo>
  /** System stage field */
  stage: Stage
  subtitle?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type HeaderPromoCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HeaderPromoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type HeaderPromoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type HeaderPromoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HeaderPromoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HeaderPromoWhereUniqueInput
}

/** A connection to a list of items. */
export type HeaderPromoConnection = {
  __typename?: 'HeaderPromoConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HeaderPromoEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HeaderPromoCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HeaderPromoCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderPromoCreateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderPromoCreateLocalizationInput = {
  /** Localization input */
  data: HeaderPromoCreateLocalizationDataInput
  locale: Locale
}

export type HeaderPromoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HeaderPromoCreateLocalizationInput>>
}

export type HeaderPromoCreateManyInlineInput = {
  /** Create and connect multiple existing HeaderPromo documents */
  create?: InputMaybe<Array<HeaderPromoCreateInput>>
}

export type HeaderPromoCreateOneInlineInput = {
  /** Create and connect one HeaderPromo document */
  create?: InputMaybe<HeaderPromoCreateInput>
}

export type HeaderPromoCreateWithPositionInput = {
  /** Document to create */
  data: HeaderPromoCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HeaderPromoEdge = {
  __typename?: 'HeaderPromoEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HeaderPromo
}

/** Identifies documents */
export type HeaderPromoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderPromoWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderPromoWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderPromoWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HeaderPromoOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HeaderPromoParent = HeaderMenuItem

export type HeaderPromoParentConnectInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemConnectInput>
}

export type HeaderPromoParentCreateInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemCreateInput>
}

export type HeaderPromoParentCreateManyInlineInput = {
  /** Create and connect multiple existing HeaderPromoParent documents */
  create?: InputMaybe<Array<HeaderPromoParentCreateInput>>
}

export type HeaderPromoParentCreateOneInlineInput = {
  /** Create and connect one HeaderPromoParent document */
  create?: InputMaybe<HeaderPromoParentCreateInput>
}

export type HeaderPromoParentCreateWithPositionInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemCreateWithPositionInput>
}

export type HeaderPromoParentUpdateInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateInput>
}

export type HeaderPromoParentUpdateManyInlineInput = {
  /** Create and connect multiple HeaderPromoParent component instances */
  create?: InputMaybe<Array<HeaderPromoParentCreateWithPositionInput>>
  /** Delete multiple HeaderPromoParent documents */
  delete?: InputMaybe<Array<HeaderPromoParentWhereUniqueInput>>
  /** Update multiple HeaderPromoParent component instances */
  update?: InputMaybe<Array<HeaderPromoParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeaderPromoParent component instances */
  upsert?: InputMaybe<Array<HeaderPromoParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeaderPromoParentUpdateManyWithNestedWhereInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateManyWithNestedWhereInput>
}

export type HeaderPromoParentUpdateOneInlineInput = {
  /** Create and connect one HeaderPromoParent document */
  create?: InputMaybe<HeaderPromoParentCreateInput>
  /** Delete currently connected HeaderPromoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeaderPromoParent document */
  update?: InputMaybe<HeaderPromoParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeaderPromoParent document */
  upsert?: InputMaybe<HeaderPromoParentUpsertWithNestedWhereUniqueInput>
}

export type HeaderPromoParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HeaderPromoParentUpdateWithNestedWhereUniqueInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateWithNestedWhereUniqueInput>
}

export type HeaderPromoParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HeaderPromoParentUpsertWithNestedWhereUniqueInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpsertWithNestedWhereUniqueInput>
}

export type HeaderPromoParentWhereInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemWhereInput>
}

export type HeaderPromoParentWhereUniqueInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemWhereUniqueInput>
}

export type HeaderPromoUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HeaderPromoUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HeaderPromoUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HeaderPromoUpdateLocalizationInput = {
  data: HeaderPromoUpdateLocalizationDataInput
  locale: Locale
}

export type HeaderPromoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HeaderPromoCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HeaderPromoUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HeaderPromoUpsertLocalizationInput>>
}

export type HeaderPromoUpdateManyInlineInput = {
  /** Create and connect multiple HeaderPromo component instances */
  create?: InputMaybe<Array<HeaderPromoCreateWithPositionInput>>
  /** Delete multiple HeaderPromo documents */
  delete?: InputMaybe<Array<HeaderPromoWhereUniqueInput>>
  /** Update multiple HeaderPromo component instances */
  update?: InputMaybe<Array<HeaderPromoUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeaderPromo component instances */
  upsert?: InputMaybe<Array<HeaderPromoUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeaderPromoUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<HeaderPromoUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HeaderPromoUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HeaderPromoUpdateManyLocalizationInput = {
  data: HeaderPromoUpdateManyLocalizationDataInput
  locale: Locale
}

export type HeaderPromoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HeaderPromoUpdateManyLocalizationInput>>
}

export type HeaderPromoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeaderPromoUpdateManyInput
  /** Document search */
  where: HeaderPromoWhereInput
}

export type HeaderPromoUpdateOneInlineInput = {
  /** Create and connect one HeaderPromo document */
  create?: InputMaybe<HeaderPromoCreateInput>
  /** Delete currently connected HeaderPromo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeaderPromo document */
  update?: InputMaybe<HeaderPromoUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeaderPromo document */
  upsert?: InputMaybe<HeaderPromoUpsertWithNestedWhereUniqueInput>
}

export type HeaderPromoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HeaderPromoUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeaderPromoWhereUniqueInput
}

export type HeaderPromoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeaderPromoUpdateInput
  /** Unique document search */
  where: HeaderPromoWhereUniqueInput
}

export type HeaderPromoUpsertInput = {
  /** Create document if it didn't exist */
  create: HeaderPromoCreateInput
  /** Update document if it exists */
  update: HeaderPromoUpdateInput
}

export type HeaderPromoUpsertLocalizationInput = {
  create: HeaderPromoCreateLocalizationDataInput
  locale: Locale
  update: HeaderPromoUpdateLocalizationDataInput
}

export type HeaderPromoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HeaderPromoUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeaderPromoWhereUniqueInput
}

export type HeaderPromoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeaderPromoUpsertInput
  /** Unique document search */
  where: HeaderPromoWhereUniqueInput
}

/** Identifies documents */
export type HeaderPromoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderPromoWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderPromoWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderPromoWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HeaderPromo record uniquely */
export type HeaderPromoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Header submenu item */
export type HeaderSubMenuItem = Entity & {
  __typename?: 'HeaderSubMenuItem'
  /** The unique identifier */
  id: Scalars['ID']['output']
  link: Scalars['String']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HeaderSubMenuItem>
  /** Reference: https://lucide.dev/icons/ */
  lucideIcon?: Maybe<LucideIcon>
  name: Scalars['String']['output']
  omrHeaderSubSubmenuItems: Array<HeaderSubSubMenuItem>
  /** System stage field */
  stage: Stage
  subtitle?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Header submenu item */
export type HeaderSubMenuItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Header submenu item */
export type HeaderSubMenuItemOmrHeaderSubSubmenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<HeaderSubSubMenuItemOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HeaderSubSubMenuItemWhereInput>
}

/** Header submenu item */
export type HeaderSubMenuItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HeaderSubMenuItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HeaderSubMenuItemWhereUniqueInput
}

/** A connection to a list of items. */
export type HeaderSubMenuItemConnection = {
  __typename?: 'HeaderSubMenuItemConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HeaderSubMenuItemEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HeaderSubMenuItemCreateInput = {
  /** link input for default locale (de) */
  link: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HeaderSubMenuItemCreateLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  omrHeaderSubSubmenuItems?: InputMaybe<HeaderSubSubMenuItemCreateManyInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderSubMenuItemCreateLocalizationDataInput = {
  link: Scalars['String']['input']
  name: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderSubMenuItemCreateLocalizationInput = {
  /** Localization input */
  data: HeaderSubMenuItemCreateLocalizationDataInput
  locale: Locale
}

export type HeaderSubMenuItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HeaderSubMenuItemCreateLocalizationInput>>
}

export type HeaderSubMenuItemCreateManyInlineInput = {
  /** Create and connect multiple existing HeaderSubMenuItem documents */
  create?: InputMaybe<Array<HeaderSubMenuItemCreateInput>>
}

export type HeaderSubMenuItemCreateOneInlineInput = {
  /** Create and connect one HeaderSubMenuItem document */
  create?: InputMaybe<HeaderSubMenuItemCreateInput>
}

export type HeaderSubMenuItemCreateWithPositionInput = {
  /** Document to create */
  data: HeaderSubMenuItemCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HeaderSubMenuItemEdge = {
  __typename?: 'HeaderSubMenuItemEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HeaderSubMenuItem
}

/** Identifies documents */
export type HeaderSubMenuItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderSubMenuItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderSubMenuItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderSubMenuItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  lucideIcon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  lucideIcon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  lucideIcon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  lucideIcon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  omrHeaderSubSubmenuItems_every?: InputMaybe<HeaderSubSubMenuItemWhereInput>
  omrHeaderSubSubmenuItems_none?: InputMaybe<HeaderSubSubMenuItemWhereInput>
  omrHeaderSubSubmenuItems_some?: InputMaybe<HeaderSubSubMenuItemWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HeaderSubMenuItemOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  LucideIconAsc = 'lucideIcon_ASC',
  LucideIconDesc = 'lucideIcon_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HeaderSubMenuItemParent = HeaderMenuItem

export type HeaderSubMenuItemParentConnectInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemConnectInput>
}

export type HeaderSubMenuItemParentCreateInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemCreateInput>
}

export type HeaderSubMenuItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing HeaderSubMenuItemParent documents */
  create?: InputMaybe<Array<HeaderSubMenuItemParentCreateInput>>
}

export type HeaderSubMenuItemParentCreateOneInlineInput = {
  /** Create and connect one HeaderSubMenuItemParent document */
  create?: InputMaybe<HeaderSubMenuItemParentCreateInput>
}

export type HeaderSubMenuItemParentCreateWithPositionInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemCreateWithPositionInput>
}

export type HeaderSubMenuItemParentUpdateInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateInput>
}

export type HeaderSubMenuItemParentUpdateManyInlineInput = {
  /** Create and connect multiple HeaderSubMenuItemParent component instances */
  create?: InputMaybe<Array<HeaderSubMenuItemParentCreateWithPositionInput>>
  /** Delete multiple HeaderSubMenuItemParent documents */
  delete?: InputMaybe<Array<HeaderSubMenuItemParentWhereUniqueInput>>
  /** Update multiple HeaderSubMenuItemParent component instances */
  update?: InputMaybe<Array<HeaderSubMenuItemParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeaderSubMenuItemParent component instances */
  upsert?: InputMaybe<Array<HeaderSubMenuItemParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeaderSubMenuItemParentUpdateManyWithNestedWhereInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateManyWithNestedWhereInput>
}

export type HeaderSubMenuItemParentUpdateOneInlineInput = {
  /** Create and connect one HeaderSubMenuItemParent document */
  create?: InputMaybe<HeaderSubMenuItemParentCreateInput>
  /** Delete currently connected HeaderSubMenuItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeaderSubMenuItemParent document */
  update?: InputMaybe<HeaderSubMenuItemParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeaderSubMenuItemParent document */
  upsert?: InputMaybe<HeaderSubMenuItemParentUpsertWithNestedWhereUniqueInput>
}

export type HeaderSubMenuItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HeaderSubMenuItemParentUpdateWithNestedWhereUniqueInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpdateWithNestedWhereUniqueInput>
}

export type HeaderSubMenuItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HeaderSubMenuItemParentUpsertWithNestedWhereUniqueInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemUpsertWithNestedWhereUniqueInput>
}

export type HeaderSubMenuItemParentWhereInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemWhereInput>
}

export type HeaderSubMenuItemParentWhereUniqueInput = {
  HeaderMenuItem?: InputMaybe<HeaderMenuItemWhereUniqueInput>
}

export type HeaderSubMenuItemUpdateInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<HeaderSubMenuItemUpdateLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  omrHeaderSubSubmenuItems?: InputMaybe<HeaderSubSubMenuItemUpdateManyInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HeaderSubMenuItemUpdateLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HeaderSubMenuItemUpdateLocalizationInput = {
  data: HeaderSubMenuItemUpdateLocalizationDataInput
  locale: Locale
}

export type HeaderSubMenuItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HeaderSubMenuItemCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HeaderSubMenuItemUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HeaderSubMenuItemUpsertLocalizationInput>>
}

export type HeaderSubMenuItemUpdateManyInlineInput = {
  /** Create and connect multiple HeaderSubMenuItem component instances */
  create?: InputMaybe<Array<HeaderSubMenuItemCreateWithPositionInput>>
  /** Delete multiple HeaderSubMenuItem documents */
  delete?: InputMaybe<Array<HeaderSubMenuItemWhereUniqueInput>>
  /** Update multiple HeaderSubMenuItem component instances */
  update?: InputMaybe<Array<HeaderSubMenuItemUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeaderSubMenuItem component instances */
  upsert?: InputMaybe<Array<HeaderSubMenuItemUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeaderSubMenuItemUpdateManyInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HeaderSubMenuItemUpdateManyLocalizationsInput>
  lucideIcon?: InputMaybe<LucideIcon>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HeaderSubMenuItemUpdateManyLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HeaderSubMenuItemUpdateManyLocalizationInput = {
  data: HeaderSubMenuItemUpdateManyLocalizationDataInput
  locale: Locale
}

export type HeaderSubMenuItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HeaderSubMenuItemUpdateManyLocalizationInput>>
}

export type HeaderSubMenuItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeaderSubMenuItemUpdateManyInput
  /** Document search */
  where: HeaderSubMenuItemWhereInput
}

export type HeaderSubMenuItemUpdateOneInlineInput = {
  /** Create and connect one HeaderSubMenuItem document */
  create?: InputMaybe<HeaderSubMenuItemCreateInput>
  /** Delete currently connected HeaderSubMenuItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeaderSubMenuItem document */
  update?: InputMaybe<HeaderSubMenuItemUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeaderSubMenuItem document */
  upsert?: InputMaybe<HeaderSubMenuItemUpsertWithNestedWhereUniqueInput>
}

export type HeaderSubMenuItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HeaderSubMenuItemUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeaderSubMenuItemWhereUniqueInput
}

export type HeaderSubMenuItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeaderSubMenuItemUpdateInput
  /** Unique document search */
  where: HeaderSubMenuItemWhereUniqueInput
}

export type HeaderSubMenuItemUpsertInput = {
  /** Create document if it didn't exist */
  create: HeaderSubMenuItemCreateInput
  /** Update document if it exists */
  update: HeaderSubMenuItemUpdateInput
}

export type HeaderSubMenuItemUpsertLocalizationInput = {
  create: HeaderSubMenuItemCreateLocalizationDataInput
  locale: Locale
  update: HeaderSubMenuItemUpdateLocalizationDataInput
}

export type HeaderSubMenuItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HeaderSubMenuItemUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeaderSubMenuItemWhereUniqueInput
}

export type HeaderSubMenuItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeaderSubMenuItemUpsertInput
  /** Unique document search */
  where: HeaderSubMenuItemWhereUniqueInput
}

/** Identifies documents */
export type HeaderSubMenuItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderSubMenuItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderSubMenuItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderSubMenuItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>
  lucideIcon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  lucideIcon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  lucideIcon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  lucideIcon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  omrHeaderSubSubmenuItems_every?: InputMaybe<HeaderSubSubMenuItemWhereInput>
  omrHeaderSubSubmenuItems_none?: InputMaybe<HeaderSubSubMenuItemWhereInput>
  omrHeaderSubSubmenuItems_some?: InputMaybe<HeaderSubSubMenuItemWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HeaderSubMenuItem record uniquely */
export type HeaderSubMenuItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Header sub-submenu item */
export type HeaderSubSubMenuItem = Entity & {
  __typename?: 'HeaderSubSubMenuItem'
  /** The unique identifier */
  id: Scalars['ID']['output']
  link: Scalars['String']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HeaderSubSubMenuItem>
  name: Scalars['String']['output']
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Header sub-submenu item */
export type HeaderSubSubMenuItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Header sub-submenu item */
export type HeaderSubSubMenuItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HeaderSubSubMenuItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HeaderSubSubMenuItemWhereUniqueInput
}

/** A connection to a list of items. */
export type HeaderSubSubMenuItemConnection = {
  __typename?: 'HeaderSubSubMenuItemConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HeaderSubSubMenuItemEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HeaderSubSubMenuItemCreateInput = {
  /** link input for default locale (de) */
  link: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HeaderSubSubMenuItemCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderSubSubMenuItemCreateLocalizationDataInput = {
  link: Scalars['String']['input']
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HeaderSubSubMenuItemCreateLocalizationInput = {
  /** Localization input */
  data: HeaderSubSubMenuItemCreateLocalizationDataInput
  locale: Locale
}

export type HeaderSubSubMenuItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HeaderSubSubMenuItemCreateLocalizationInput>>
}

export type HeaderSubSubMenuItemCreateManyInlineInput = {
  /** Create and connect multiple existing HeaderSubSubMenuItem documents */
  create?: InputMaybe<Array<HeaderSubSubMenuItemCreateInput>>
}

export type HeaderSubSubMenuItemCreateOneInlineInput = {
  /** Create and connect one HeaderSubSubMenuItem document */
  create?: InputMaybe<HeaderSubSubMenuItemCreateInput>
}

export type HeaderSubSubMenuItemCreateWithPositionInput = {
  /** Document to create */
  data: HeaderSubSubMenuItemCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HeaderSubSubMenuItemEdge = {
  __typename?: 'HeaderSubSubMenuItemEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HeaderSubSubMenuItem
}

/** Identifies documents */
export type HeaderSubSubMenuItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderSubSubMenuItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderSubSubMenuItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderSubSubMenuItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HeaderSubSubMenuItemOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HeaderSubSubMenuItemParent = HeaderSubMenuItem

export type HeaderSubSubMenuItemParentConnectInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemConnectInput>
}

export type HeaderSubSubMenuItemParentCreateInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemCreateInput>
}

export type HeaderSubSubMenuItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing HeaderSubSubMenuItemParent documents */
  create?: InputMaybe<Array<HeaderSubSubMenuItemParentCreateInput>>
}

export type HeaderSubSubMenuItemParentCreateOneInlineInput = {
  /** Create and connect one HeaderSubSubMenuItemParent document */
  create?: InputMaybe<HeaderSubSubMenuItemParentCreateInput>
}

export type HeaderSubSubMenuItemParentCreateWithPositionInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemCreateWithPositionInput>
}

export type HeaderSubSubMenuItemParentUpdateInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemUpdateInput>
}

export type HeaderSubSubMenuItemParentUpdateManyInlineInput = {
  /** Create and connect multiple HeaderSubSubMenuItemParent component instances */
  create?: InputMaybe<Array<HeaderSubSubMenuItemParentCreateWithPositionInput>>
  /** Delete multiple HeaderSubSubMenuItemParent documents */
  delete?: InputMaybe<Array<HeaderSubSubMenuItemParentWhereUniqueInput>>
  /** Update multiple HeaderSubSubMenuItemParent component instances */
  update?: InputMaybe<Array<HeaderSubSubMenuItemParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeaderSubSubMenuItemParent component instances */
  upsert?: InputMaybe<Array<HeaderSubSubMenuItemParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeaderSubSubMenuItemParentUpdateManyWithNestedWhereInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemUpdateManyWithNestedWhereInput>
}

export type HeaderSubSubMenuItemParentUpdateOneInlineInput = {
  /** Create and connect one HeaderSubSubMenuItemParent document */
  create?: InputMaybe<HeaderSubSubMenuItemParentCreateInput>
  /** Delete currently connected HeaderSubSubMenuItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeaderSubSubMenuItemParent document */
  update?: InputMaybe<HeaderSubSubMenuItemParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeaderSubSubMenuItemParent document */
  upsert?: InputMaybe<HeaderSubSubMenuItemParentUpsertWithNestedWhereUniqueInput>
}

export type HeaderSubSubMenuItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HeaderSubSubMenuItemParentUpdateWithNestedWhereUniqueInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemUpdateWithNestedWhereUniqueInput>
}

export type HeaderSubSubMenuItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HeaderSubSubMenuItemParentUpsertWithNestedWhereUniqueInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemUpsertWithNestedWhereUniqueInput>
}

export type HeaderSubSubMenuItemParentWhereInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemWhereInput>
}

export type HeaderSubSubMenuItemParentWhereUniqueInput = {
  HeaderSubMenuItem?: InputMaybe<HeaderSubMenuItemWhereUniqueInput>
}

export type HeaderSubSubMenuItemUpdateInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<HeaderSubSubMenuItemUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
}

export type HeaderSubSubMenuItemUpdateLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type HeaderSubSubMenuItemUpdateLocalizationInput = {
  data: HeaderSubSubMenuItemUpdateLocalizationDataInput
  locale: Locale
}

export type HeaderSubSubMenuItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HeaderSubSubMenuItemCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HeaderSubSubMenuItemUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HeaderSubSubMenuItemUpsertLocalizationInput>>
}

export type HeaderSubSubMenuItemUpdateManyInlineInput = {
  /** Create and connect multiple HeaderSubSubMenuItem component instances */
  create?: InputMaybe<Array<HeaderSubSubMenuItemCreateWithPositionInput>>
  /** Delete multiple HeaderSubSubMenuItem documents */
  delete?: InputMaybe<Array<HeaderSubSubMenuItemWhereUniqueInput>>
  /** Update multiple HeaderSubSubMenuItem component instances */
  update?: InputMaybe<Array<HeaderSubSubMenuItemUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeaderSubSubMenuItem component instances */
  upsert?: InputMaybe<Array<HeaderSubSubMenuItemUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeaderSubSubMenuItemUpdateManyInput = {
  /** link input for default locale (de) */
  link?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HeaderSubSubMenuItemUpdateManyLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
}

export type HeaderSubSubMenuItemUpdateManyLocalizationDataInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type HeaderSubSubMenuItemUpdateManyLocalizationInput = {
  data: HeaderSubSubMenuItemUpdateManyLocalizationDataInput
  locale: Locale
}

export type HeaderSubSubMenuItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HeaderSubSubMenuItemUpdateManyLocalizationInput>>
}

export type HeaderSubSubMenuItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeaderSubSubMenuItemUpdateManyInput
  /** Document search */
  where: HeaderSubSubMenuItemWhereInput
}

export type HeaderSubSubMenuItemUpdateOneInlineInput = {
  /** Create and connect one HeaderSubSubMenuItem document */
  create?: InputMaybe<HeaderSubSubMenuItemCreateInput>
  /** Delete currently connected HeaderSubSubMenuItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeaderSubSubMenuItem document */
  update?: InputMaybe<HeaderSubSubMenuItemUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeaderSubSubMenuItem document */
  upsert?: InputMaybe<HeaderSubSubMenuItemUpsertWithNestedWhereUniqueInput>
}

export type HeaderSubSubMenuItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HeaderSubSubMenuItemUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeaderSubSubMenuItemWhereUniqueInput
}

export type HeaderSubSubMenuItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeaderSubSubMenuItemUpdateInput
  /** Unique document search */
  where: HeaderSubSubMenuItemWhereUniqueInput
}

export type HeaderSubSubMenuItemUpsertInput = {
  /** Create document if it didn't exist */
  create: HeaderSubSubMenuItemCreateInput
  /** Update document if it exists */
  update: HeaderSubSubMenuItemUpdateInput
}

export type HeaderSubSubMenuItemUpsertLocalizationInput = {
  create: HeaderSubSubMenuItemCreateLocalizationDataInput
  locale: Locale
  update: HeaderSubSubMenuItemUpdateLocalizationDataInput
}

export type HeaderSubSubMenuItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HeaderSubSubMenuItemUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeaderSubSubMenuItemWhereUniqueInput
}

export type HeaderSubSubMenuItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeaderSubSubMenuItemUpsertInput
  /** Unique document search */
  where: HeaderSubSubMenuItemWhereUniqueInput
}

/** Identifies documents */
export type HeaderSubSubMenuItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderSubSubMenuItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderSubSubMenuItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderSubSubMenuItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HeaderSubSubMenuItem record uniquely */
export type HeaderSubSubMenuItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type HeaderUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<HeaderUpdateLocalizationsInput>
  logo?: InputMaybe<AssetUpdateOneInlineInput>
  mobileLogo?: InputMaybe<AssetUpdateOneInlineInput>
  omrHeaderMenuItems?: InputMaybe<HeaderMenuItemUpdateManyInlineInput>
  omrHeaderPartners?: InputMaybe<OmrPartnerUpdateManyInlineInput>
  omrHeaderSocials?: InputMaybe<SocialLinkUpdateManyInlineInput>
}

export type HeaderUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HeaderCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
}

export type HeaderUpdateManyInlineInput = {
  /** Connect multiple existing Header documents */
  connect?: InputMaybe<Array<HeaderConnectInput>>
  /** Create and connect multiple Header documents */
  create?: InputMaybe<Array<HeaderCreateInput>>
  /** Delete multiple Header documents */
  delete?: InputMaybe<Array<HeaderWhereUniqueInput>>
  /** Disconnect multiple Header documents */
  disconnect?: InputMaybe<Array<HeaderWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Header documents */
  set?: InputMaybe<Array<HeaderWhereUniqueInput>>
  /** Update multiple Header documents */
  update?: InputMaybe<Array<HeaderUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Header documents */
  upsert?: InputMaybe<Array<HeaderUpsertWithNestedWhereUniqueInput>>
}

export type HeaderUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type HeaderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeaderUpdateManyInput
  /** Document search */
  where: HeaderWhereInput
}

export type HeaderUpdateOneInlineInput = {
  /** Connect existing Header document */
  connect?: InputMaybe<HeaderWhereUniqueInput>
  /** Create and connect one Header document */
  create?: InputMaybe<HeaderCreateInput>
  /** Delete currently connected Header document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Header document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Header document */
  update?: InputMaybe<HeaderUpdateWithNestedWhereUniqueInput>
  /** Upsert single Header document */
  upsert?: InputMaybe<HeaderUpsertWithNestedWhereUniqueInput>
}

export type HeaderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeaderUpdateInput
  /** Unique document search */
  where: HeaderWhereUniqueInput
}

export type HeaderUpsertInput = {
  /** Create document if it didn't exist */
  create: HeaderCreateInput
  /** Update document if it exists */
  update: HeaderUpdateInput
}

export type HeaderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeaderUpsertInput
  /** Unique document search */
  where: HeaderWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type HeaderWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type HeaderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HeaderWhereStageInput>
  documentInStages_none?: InputMaybe<HeaderWhereStageInput>
  documentInStages_some?: InputMaybe<HeaderWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  mobileLogo?: InputMaybe<AssetWhereInput>
  omrHeaderMenuItems_every?: InputMaybe<HeaderMenuItemWhereInput>
  omrHeaderMenuItems_none?: InputMaybe<HeaderMenuItemWhereInput>
  omrHeaderMenuItems_some?: InputMaybe<HeaderMenuItemWhereInput>
  omrHeaderPartners_every?: InputMaybe<OmrPartnerWhereInput>
  omrHeaderPartners_none?: InputMaybe<OmrPartnerWhereInput>
  omrHeaderPartners_some?: InputMaybe<OmrPartnerWhereInput>
  omrHeaderSocials_every?: InputMaybe<SocialLinkWhereInput>
  omrHeaderSocials_none?: InputMaybe<SocialLinkWhereInput>
  omrHeaderSocials_some?: InputMaybe<SocialLinkWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeaderWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeaderWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeaderWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeaderWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeaderWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Header record uniquely */
export type HeaderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Image/Video component with breakpoint variants and positioning options */
export type HeroImage = Entity & {
  __typename?: 'HeroImage'
  /** 4:3 aspect ratio image - only applicable for primary landing page split image style */
  constrainImage?: Maybe<Scalars['Boolean']['output']>
  /** Desktop image */
  desktopImage?: Maybe<Asset>
  /** Horizontal position of the image */
  horizontalDesktopPosition?: Maybe<HeroImageHorizontalPosition>
  /** Horizontal position of the image */
  horizontalMobilePosition?: Maybe<HeroImageHorizontalPosition>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Optional: Laptop image */
  laptopImage?: Maybe<Asset>
  /** Mobile image */
  mobileImage?: Maybe<Asset>
  /** System stage field */
  stage: Stage
  /** Optional: Tablet image */
  tabletImage?: Maybe<Asset>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Vertical position of the image */
  verticalDesktopPosition?: Maybe<HeroImageVerticalPosition>
  /** Vertical position of the image */
  verticalMobilePosition?: Maybe<HeroImageVerticalPosition>
  /** Video asset for video variants, positioning is controlled by the image positioning. Setting an image will use that as the placeholder for the video. */
  video?: Maybe<Asset>
  /** Automatically plays and loops the video. Off by default. */
  videoAutoplay?: Maybe<Scalars['Boolean']['output']>
}

/** Image/Video component with breakpoint variants and positioning options */
export type HeroImageDesktopImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Image/Video component with breakpoint variants and positioning options */
export type HeroImageLaptopImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Image/Video component with breakpoint variants and positioning options */
export type HeroImageMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Image/Video component with breakpoint variants and positioning options */
export type HeroImageTabletImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Image/Video component with breakpoint variants and positioning options */
export type HeroImageVideoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type HeroImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HeroImageWhereUniqueInput
}

/** A connection to a list of items. */
export type HeroImageConnection = {
  __typename?: 'HeroImageConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HeroImageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HeroImageCreateInput = {
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  desktopImage?: InputMaybe<AssetCreateOneInlineInput>
  horizontalDesktopPosition?: InputMaybe<HeroImageHorizontalPosition>
  horizontalMobilePosition?: InputMaybe<HeroImageHorizontalPosition>
  laptopImage?: InputMaybe<AssetCreateOneInlineInput>
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>
  tabletImage?: InputMaybe<AssetCreateOneInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  verticalDesktopPosition?: InputMaybe<HeroImageVerticalPosition>
  verticalMobilePosition?: InputMaybe<HeroImageVerticalPosition>
  video?: InputMaybe<AssetCreateOneInlineInput>
  videoAutoplay?: InputMaybe<Scalars['Boolean']['input']>
}

export type HeroImageCreateManyInlineInput = {
  /** Create and connect multiple existing HeroImage documents */
  create?: InputMaybe<Array<HeroImageCreateInput>>
}

export type HeroImageCreateOneInlineInput = {
  /** Create and connect one HeroImage document */
  create?: InputMaybe<HeroImageCreateInput>
}

export type HeroImageCreateWithPositionInput = {
  /** Document to create */
  data: HeroImageCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HeroImageEdge = {
  __typename?: 'HeroImageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HeroImage
}

/** Horizontal position of the image */
export enum HeroImageHorizontalPosition {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

/** Identifies documents */
export type HeroImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroImageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroImageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroImageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  constrainImage_not?: InputMaybe<Scalars['Boolean']['input']>
  desktopImage?: InputMaybe<AssetWhereInput>
  horizontalDesktopPosition?: InputMaybe<HeroImageHorizontalPosition>
  /** All values that are contained in given list. */
  horizontalDesktopPosition_in?: InputMaybe<Array<InputMaybe<HeroImageHorizontalPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  horizontalDesktopPosition_not?: InputMaybe<HeroImageHorizontalPosition>
  /** All values that are not contained in given list. */
  horizontalDesktopPosition_not_in?: InputMaybe<Array<InputMaybe<HeroImageHorizontalPosition>>>
  horizontalMobilePosition?: InputMaybe<HeroImageHorizontalPosition>
  /** All values that are contained in given list. */
  horizontalMobilePosition_in?: InputMaybe<Array<InputMaybe<HeroImageHorizontalPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  horizontalMobilePosition_not?: InputMaybe<HeroImageHorizontalPosition>
  /** All values that are not contained in given list. */
  horizontalMobilePosition_not_in?: InputMaybe<Array<InputMaybe<HeroImageHorizontalPosition>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  laptopImage?: InputMaybe<AssetWhereInput>
  mobileImage?: InputMaybe<AssetWhereInput>
  tabletImage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  verticalDesktopPosition?: InputMaybe<HeroImageVerticalPosition>
  /** All values that are contained in given list. */
  verticalDesktopPosition_in?: InputMaybe<Array<InputMaybe<HeroImageVerticalPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  verticalDesktopPosition_not?: InputMaybe<HeroImageVerticalPosition>
  /** All values that are not contained in given list. */
  verticalDesktopPosition_not_in?: InputMaybe<Array<InputMaybe<HeroImageVerticalPosition>>>
  verticalMobilePosition?: InputMaybe<HeroImageVerticalPosition>
  /** All values that are contained in given list. */
  verticalMobilePosition_in?: InputMaybe<Array<InputMaybe<HeroImageVerticalPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  verticalMobilePosition_not?: InputMaybe<HeroImageVerticalPosition>
  /** All values that are not contained in given list. */
  verticalMobilePosition_not_in?: InputMaybe<Array<InputMaybe<HeroImageVerticalPosition>>>
  video?: InputMaybe<AssetWhereInput>
  videoAutoplay?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  videoAutoplay_not?: InputMaybe<Scalars['Boolean']['input']>
}

export enum HeroImageOrderByInput {
  ConstrainImageAsc = 'constrainImage_ASC',
  ConstrainImageDesc = 'constrainImage_DESC',
  HorizontalDesktopPositionAsc = 'horizontalDesktopPosition_ASC',
  HorizontalDesktopPositionDesc = 'horizontalDesktopPosition_DESC',
  HorizontalMobilePositionAsc = 'horizontalMobilePosition_ASC',
  HorizontalMobilePositionDesc = 'horizontalMobilePosition_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VerticalDesktopPositionAsc = 'verticalDesktopPosition_ASC',
  VerticalDesktopPositionDesc = 'verticalDesktopPosition_DESC',
  VerticalMobilePositionAsc = 'verticalMobilePosition_ASC',
  VerticalMobilePositionDesc = 'verticalMobilePosition_DESC',
  VideoAutoplayAsc = 'videoAutoplay_ASC',
  VideoAutoplayDesc = 'videoAutoplay_DESC',
}

export type HeroImageParent = SectionStyledHero

export type HeroImageParentConnectInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroConnectInput>
}

export type HeroImageParentCreateInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateInput>
}

export type HeroImageParentCreateManyInlineInput = {
  /** Create and connect multiple existing HeroImageParent documents */
  create?: InputMaybe<Array<HeroImageParentCreateInput>>
}

export type HeroImageParentCreateOneInlineInput = {
  /** Create and connect one HeroImageParent document */
  create?: InputMaybe<HeroImageParentCreateInput>
}

export type HeroImageParentCreateWithPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateWithPositionInput>
}

export type HeroImageParentUpdateInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateInput>
}

export type HeroImageParentUpdateManyInlineInput = {
  /** Create and connect multiple HeroImageParent component instances */
  create?: InputMaybe<Array<HeroImageParentCreateWithPositionInput>>
  /** Delete multiple HeroImageParent documents */
  delete?: InputMaybe<Array<HeroImageParentWhereUniqueInput>>
  /** Update multiple HeroImageParent component instances */
  update?: InputMaybe<Array<HeroImageParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeroImageParent component instances */
  upsert?: InputMaybe<Array<HeroImageParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeroImageParentUpdateManyWithNestedWhereInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateManyWithNestedWhereInput>
}

export type HeroImageParentUpdateOneInlineInput = {
  /** Create and connect one HeroImageParent document */
  create?: InputMaybe<HeroImageParentCreateInput>
  /** Delete currently connected HeroImageParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeroImageParent document */
  update?: InputMaybe<HeroImageParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeroImageParent document */
  upsert?: InputMaybe<HeroImageParentUpsertWithNestedWhereUniqueInput>
}

export type HeroImageParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HeroImageParentUpdateWithNestedWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueInput>
}

export type HeroImageParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HeroImageParentUpsertWithNestedWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueInput>
}

export type HeroImageParentWhereInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereInput>
}

export type HeroImageParentWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereUniqueInput>
}

export type HeroImageUpdateInput = {
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  desktopImage?: InputMaybe<AssetUpdateOneInlineInput>
  horizontalDesktopPosition?: InputMaybe<HeroImageHorizontalPosition>
  horizontalMobilePosition?: InputMaybe<HeroImageHorizontalPosition>
  laptopImage?: InputMaybe<AssetUpdateOneInlineInput>
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>
  tabletImage?: InputMaybe<AssetUpdateOneInlineInput>
  verticalDesktopPosition?: InputMaybe<HeroImageVerticalPosition>
  verticalMobilePosition?: InputMaybe<HeroImageVerticalPosition>
  video?: InputMaybe<AssetUpdateOneInlineInput>
  videoAutoplay?: InputMaybe<Scalars['Boolean']['input']>
}

export type HeroImageUpdateManyInlineInput = {
  /** Create and connect multiple HeroImage component instances */
  create?: InputMaybe<Array<HeroImageCreateWithPositionInput>>
  /** Delete multiple HeroImage documents */
  delete?: InputMaybe<Array<HeroImageWhereUniqueInput>>
  /** Update multiple HeroImage component instances */
  update?: InputMaybe<Array<HeroImageUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HeroImage component instances */
  upsert?: InputMaybe<Array<HeroImageUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HeroImageUpdateManyInput = {
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  horizontalDesktopPosition?: InputMaybe<HeroImageHorizontalPosition>
  horizontalMobilePosition?: InputMaybe<HeroImageHorizontalPosition>
  verticalDesktopPosition?: InputMaybe<HeroImageVerticalPosition>
  verticalMobilePosition?: InputMaybe<HeroImageVerticalPosition>
  videoAutoplay?: InputMaybe<Scalars['Boolean']['input']>
}

export type HeroImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroImageUpdateManyInput
  /** Document search */
  where: HeroImageWhereInput
}

export type HeroImageUpdateOneInlineInput = {
  /** Create and connect one HeroImage document */
  create?: InputMaybe<HeroImageCreateInput>
  /** Delete currently connected HeroImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HeroImage document */
  update?: InputMaybe<HeroImageUpdateWithNestedWhereUniqueInput>
  /** Upsert single HeroImage document */
  upsert?: InputMaybe<HeroImageUpsertWithNestedWhereUniqueInput>
}

export type HeroImageUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HeroImageUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeroImageWhereUniqueInput
}

export type HeroImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroImageUpdateInput
  /** Unique document search */
  where: HeroImageWhereUniqueInput
}

export type HeroImageUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroImageCreateInput
  /** Update document if it exists */
  update: HeroImageUpdateInput
}

export type HeroImageUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HeroImageUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HeroImageWhereUniqueInput
}

export type HeroImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroImageUpsertInput
  /** Unique document search */
  where: HeroImageWhereUniqueInput
}

/** Vertical position of the image */
export enum HeroImageVerticalPosition {
  Bottom = 'bottom',
  Center = 'center',
  Top = 'top',
}

/** Identifies documents */
export type HeroImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroImageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroImageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroImageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  constrainImage_not?: InputMaybe<Scalars['Boolean']['input']>
  desktopImage?: InputMaybe<AssetWhereInput>
  horizontalDesktopPosition?: InputMaybe<HeroImageHorizontalPosition>
  /** All values that are contained in given list. */
  horizontalDesktopPosition_in?: InputMaybe<Array<InputMaybe<HeroImageHorizontalPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  horizontalDesktopPosition_not?: InputMaybe<HeroImageHorizontalPosition>
  /** All values that are not contained in given list. */
  horizontalDesktopPosition_not_in?: InputMaybe<Array<InputMaybe<HeroImageHorizontalPosition>>>
  horizontalMobilePosition?: InputMaybe<HeroImageHorizontalPosition>
  /** All values that are contained in given list. */
  horizontalMobilePosition_in?: InputMaybe<Array<InputMaybe<HeroImageHorizontalPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  horizontalMobilePosition_not?: InputMaybe<HeroImageHorizontalPosition>
  /** All values that are not contained in given list. */
  horizontalMobilePosition_not_in?: InputMaybe<Array<InputMaybe<HeroImageHorizontalPosition>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  laptopImage?: InputMaybe<AssetWhereInput>
  mobileImage?: InputMaybe<AssetWhereInput>
  tabletImage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  verticalDesktopPosition?: InputMaybe<HeroImageVerticalPosition>
  /** All values that are contained in given list. */
  verticalDesktopPosition_in?: InputMaybe<Array<InputMaybe<HeroImageVerticalPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  verticalDesktopPosition_not?: InputMaybe<HeroImageVerticalPosition>
  /** All values that are not contained in given list. */
  verticalDesktopPosition_not_in?: InputMaybe<Array<InputMaybe<HeroImageVerticalPosition>>>
  verticalMobilePosition?: InputMaybe<HeroImageVerticalPosition>
  /** All values that are contained in given list. */
  verticalMobilePosition_in?: InputMaybe<Array<InputMaybe<HeroImageVerticalPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  verticalMobilePosition_not?: InputMaybe<HeroImageVerticalPosition>
  /** All values that are not contained in given list. */
  verticalMobilePosition_not_in?: InputMaybe<Array<InputMaybe<HeroImageVerticalPosition>>>
  video?: InputMaybe<AssetWhereInput>
  videoAutoplay?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  videoAutoplay_not?: InputMaybe<Scalars['Boolean']['input']>
}

/** References HeroImage record uniquely */
export type HeroImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Highlighted text for Section Styled Hero */
export type HighlightedText = Entity & {
  __typename?: 'HighlightedText'
  /** See OMR Component Library for reference: https://bit.ly/4qKjF6o */
  headlineCase?: Maybe<HighlightedTextCase>
  /** See OMR Component Library for reference: https://bit.ly/4qKjF6o */
  headlineSize?: Maybe<HighlightedTextSize>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HighlightedText>
  /** System stage field */
  stage: Stage
  style: HighlightedTextStyle
  text: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Highlighted text for Section Styled Hero */
export type HighlightedTextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Highlighted text for Section Styled Hero */
export type HighlightedTextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Headline Text Size for Styled Hero */
export enum HighlightedTextCase {
  Standard = 'standard',
  Uppercase = 'uppercase',
}

export type HighlightedTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HighlightedTextWhereUniqueInput
}

/** A connection to a list of items. */
export type HighlightedTextConnection = {
  __typename?: 'HighlightedTextConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HighlightedTextEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HighlightedTextCreateInput = {
  headlineCase?: InputMaybe<HighlightedTextCase>
  headlineSize?: InputMaybe<HighlightedTextSize>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HighlightedTextCreateLocalizationsInput>
  style: HighlightedTextStyle
  /** text input for default locale (de) */
  text: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HighlightedTextCreateLocalizationDataInput = {
  text: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HighlightedTextCreateLocalizationInput = {
  /** Localization input */
  data: HighlightedTextCreateLocalizationDataInput
  locale: Locale
}

export type HighlightedTextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HighlightedTextCreateLocalizationInput>>
}

export type HighlightedTextCreateManyInlineInput = {
  /** Create and connect multiple existing HighlightedText documents */
  create?: InputMaybe<Array<HighlightedTextCreateInput>>
}

export type HighlightedTextCreateOneInlineInput = {
  /** Create and connect one HighlightedText document */
  create?: InputMaybe<HighlightedTextCreateInput>
}

export type HighlightedTextCreateWithPositionInput = {
  /** Document to create */
  data: HighlightedTextCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HighlightedTextEdge = {
  __typename?: 'HighlightedTextEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HighlightedText
}

/** Identifies documents */
export type HighlightedTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HighlightedTextWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HighlightedTextWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HighlightedTextWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  headlineCase?: InputMaybe<HighlightedTextCase>
  /** All values that are contained in given list. */
  headlineCase_in?: InputMaybe<Array<InputMaybe<HighlightedTextCase>>>
  /** Any other value that exists and is not equal to the given value. */
  headlineCase_not?: InputMaybe<HighlightedTextCase>
  /** All values that are not contained in given list. */
  headlineCase_not_in?: InputMaybe<Array<InputMaybe<HighlightedTextCase>>>
  headlineSize?: InputMaybe<HighlightedTextSize>
  /** All values that are contained in given list. */
  headlineSize_in?: InputMaybe<Array<InputMaybe<HighlightedTextSize>>>
  /** Any other value that exists and is not equal to the given value. */
  headlineSize_not?: InputMaybe<HighlightedTextSize>
  /** All values that are not contained in given list. */
  headlineSize_not_in?: InputMaybe<Array<InputMaybe<HighlightedTextSize>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  style?: InputMaybe<HighlightedTextStyle>
  /** All values that are contained in given list. */
  style_in?: InputMaybe<Array<InputMaybe<HighlightedTextStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  style_not?: InputMaybe<HighlightedTextStyle>
  /** All values that are not contained in given list. */
  style_not_in?: InputMaybe<Array<InputMaybe<HighlightedTextStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HighlightedTextOrderByInput {
  HeadlineCaseAsc = 'headlineCase_ASC',
  HeadlineCaseDesc = 'headlineCase_DESC',
  HeadlineSizeAsc = 'headlineSize_ASC',
  HeadlineSizeDesc = 'headlineSize_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StyleAsc = 'style_ASC',
  StyleDesc = 'style_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HighlightedTextParent = SectionStyledHero

export type HighlightedTextParentConnectInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroConnectInput>
}

export type HighlightedTextParentCreateInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateInput>
}

export type HighlightedTextParentCreateManyInlineInput = {
  /** Create and connect multiple existing HighlightedTextParent documents */
  create?: InputMaybe<Array<HighlightedTextParentCreateInput>>
}

export type HighlightedTextParentCreateOneInlineInput = {
  /** Create and connect one HighlightedTextParent document */
  create?: InputMaybe<HighlightedTextParentCreateInput>
}

export type HighlightedTextParentCreateWithPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateWithPositionInput>
}

export type HighlightedTextParentUpdateInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateInput>
}

export type HighlightedTextParentUpdateManyInlineInput = {
  /** Create and connect multiple HighlightedTextParent component instances */
  create?: InputMaybe<Array<HighlightedTextParentCreateWithPositionInput>>
  /** Delete multiple HighlightedTextParent documents */
  delete?: InputMaybe<Array<HighlightedTextParentWhereUniqueInput>>
  /** Update multiple HighlightedTextParent component instances */
  update?: InputMaybe<Array<HighlightedTextParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HighlightedTextParent component instances */
  upsert?: InputMaybe<Array<HighlightedTextParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HighlightedTextParentUpdateManyWithNestedWhereInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateManyWithNestedWhereInput>
}

export type HighlightedTextParentUpdateOneInlineInput = {
  /** Create and connect one HighlightedTextParent document */
  create?: InputMaybe<HighlightedTextParentCreateInput>
  /** Delete currently connected HighlightedTextParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HighlightedTextParent document */
  update?: InputMaybe<HighlightedTextParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HighlightedTextParent document */
  upsert?: InputMaybe<HighlightedTextParentUpsertWithNestedWhereUniqueInput>
}

export type HighlightedTextParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HighlightedTextParentUpdateWithNestedWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueInput>
}

export type HighlightedTextParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HighlightedTextParentUpsertWithNestedWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueInput>
}

export type HighlightedTextParentWhereInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereInput>
}

export type HighlightedTextParentWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereUniqueInput>
}

/** Headline Text Size for Styled Hero */
export enum HighlightedTextSize {
  HeadlineLarge = 'headline_large',
  HeadlineMedium = 'headline_medium',
  HeadlineSmall = 'headline_small',
}

/** Style for Highlighted Text - inherits from Theme and Style of Section Styled Hero */
export enum HighlightedTextStyle {
  BlackAndWhite = 'blackAndWhite',
  Color = 'color',
  Default = 'default',
  PurpleAndWhite = 'purpleAndWhite',
  WhiteAndBlack = 'whiteAndBlack',
}

export type HighlightedTextUpdateInput = {
  headlineCase?: InputMaybe<HighlightedTextCase>
  headlineSize?: InputMaybe<HighlightedTextSize>
  /** Manage document localizations */
  localizations?: InputMaybe<HighlightedTextUpdateLocalizationsInput>
  style?: InputMaybe<HighlightedTextStyle>
  /** text input for default locale (de) */
  text?: InputMaybe<Scalars['String']['input']>
}

export type HighlightedTextUpdateLocalizationDataInput = {
  text?: InputMaybe<Scalars['String']['input']>
}

export type HighlightedTextUpdateLocalizationInput = {
  data: HighlightedTextUpdateLocalizationDataInput
  locale: Locale
}

export type HighlightedTextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HighlightedTextCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HighlightedTextUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HighlightedTextUpsertLocalizationInput>>
}

export type HighlightedTextUpdateManyInlineInput = {
  /** Create and connect multiple HighlightedText component instances */
  create?: InputMaybe<Array<HighlightedTextCreateWithPositionInput>>
  /** Delete multiple HighlightedText documents */
  delete?: InputMaybe<Array<HighlightedTextWhereUniqueInput>>
  /** Update multiple HighlightedText component instances */
  update?: InputMaybe<Array<HighlightedTextUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HighlightedText component instances */
  upsert?: InputMaybe<Array<HighlightedTextUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HighlightedTextUpdateManyInput = {
  headlineCase?: InputMaybe<HighlightedTextCase>
  headlineSize?: InputMaybe<HighlightedTextSize>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HighlightedTextUpdateManyLocalizationsInput>
  style?: InputMaybe<HighlightedTextStyle>
  /** text input for default locale (de) */
  text?: InputMaybe<Scalars['String']['input']>
}

export type HighlightedTextUpdateManyLocalizationDataInput = {
  text?: InputMaybe<Scalars['String']['input']>
}

export type HighlightedTextUpdateManyLocalizationInput = {
  data: HighlightedTextUpdateManyLocalizationDataInput
  locale: Locale
}

export type HighlightedTextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HighlightedTextUpdateManyLocalizationInput>>
}

export type HighlightedTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HighlightedTextUpdateManyInput
  /** Document search */
  where: HighlightedTextWhereInput
}

export type HighlightedTextUpdateOneInlineInput = {
  /** Create and connect one HighlightedText document */
  create?: InputMaybe<HighlightedTextCreateInput>
  /** Delete currently connected HighlightedText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HighlightedText document */
  update?: InputMaybe<HighlightedTextUpdateWithNestedWhereUniqueInput>
  /** Upsert single HighlightedText document */
  upsert?: InputMaybe<HighlightedTextUpsertWithNestedWhereUniqueInput>
}

export type HighlightedTextUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HighlightedTextUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HighlightedTextWhereUniqueInput
}

export type HighlightedTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HighlightedTextUpdateInput
  /** Unique document search */
  where: HighlightedTextWhereUniqueInput
}

export type HighlightedTextUpsertInput = {
  /** Create document if it didn't exist */
  create: HighlightedTextCreateInput
  /** Update document if it exists */
  update: HighlightedTextUpdateInput
}

export type HighlightedTextUpsertLocalizationInput = {
  create: HighlightedTextCreateLocalizationDataInput
  locale: Locale
  update: HighlightedTextUpdateLocalizationDataInput
}

export type HighlightedTextUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HighlightedTextUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HighlightedTextWhereUniqueInput
}

export type HighlightedTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HighlightedTextUpsertInput
  /** Unique document search */
  where: HighlightedTextWhereUniqueInput
}

/** Identifies documents */
export type HighlightedTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HighlightedTextWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HighlightedTextWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HighlightedTextWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  headlineCase?: InputMaybe<HighlightedTextCase>
  /** All values that are contained in given list. */
  headlineCase_in?: InputMaybe<Array<InputMaybe<HighlightedTextCase>>>
  /** Any other value that exists and is not equal to the given value. */
  headlineCase_not?: InputMaybe<HighlightedTextCase>
  /** All values that are not contained in given list. */
  headlineCase_not_in?: InputMaybe<Array<InputMaybe<HighlightedTextCase>>>
  headlineSize?: InputMaybe<HighlightedTextSize>
  /** All values that are contained in given list. */
  headlineSize_in?: InputMaybe<Array<InputMaybe<HighlightedTextSize>>>
  /** Any other value that exists and is not equal to the given value. */
  headlineSize_not?: InputMaybe<HighlightedTextSize>
  /** All values that are not contained in given list. */
  headlineSize_not_in?: InputMaybe<Array<InputMaybe<HighlightedTextSize>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  style?: InputMaybe<HighlightedTextStyle>
  /** All values that are contained in given list. */
  style_in?: InputMaybe<Array<InputMaybe<HighlightedTextStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  style_not?: InputMaybe<HighlightedTextStyle>
  /** All values that are not contained in given list. */
  style_not_in?: InputMaybe<Array<InputMaybe<HighlightedTextStyle>>>
  text?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HighlightedText record uniquely */
export type HighlightedTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type Hotel = Entity &
  Node & {
    __typename?: 'Hotel'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description: Scalars['String']['output']
    distance: Scalars['String']['output']
    /** Get the document in other stages */
    documentInStages: Array<Hotel>
    /** List of Hotel versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Hotel>
    logo: Asset
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    rating: Scalars['String']['output']
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    url: Scalars['String']['output']
  }

export type HotelCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HotelCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HotelDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type HotelHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type HotelLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type HotelLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type HotelPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HotelPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HotelScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type HotelUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HotelUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HotelConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HotelWhereUniqueInput
}

/** A connection to a list of items. */
export type HotelConnection = {
  __typename?: 'HotelConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HotelEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HotelCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  /** distance input for default locale (de) */
  distance: Scalars['String']['input']
  hotelInSection?: InputMaybe<SectionHotelCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HotelCreateLocalizationsInput>
  logo: AssetCreateOneInlineInput
  name: Scalars['String']['input']
  /** rating input for default locale (de) */
  rating: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** url input for default locale (de) */
  url: Scalars['String']['input']
}

export type HotelCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description: Scalars['String']['input']
  distance: Scalars['String']['input']
  rating: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  url: Scalars['String']['input']
}

export type HotelCreateLocalizationInput = {
  /** Localization input */
  data: HotelCreateLocalizationDataInput
  locale: Locale
}

export type HotelCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HotelCreateLocalizationInput>>
}

export type HotelCreateManyInlineInput = {
  /** Connect multiple existing Hotel documents */
  connect?: InputMaybe<Array<HotelWhereUniqueInput>>
  /** Create and connect multiple existing Hotel documents */
  create?: InputMaybe<Array<HotelCreateInput>>
}

export type HotelCreateOneInlineInput = {
  /** Connect one existing Hotel document */
  connect?: InputMaybe<HotelWhereUniqueInput>
  /** Create and connect one Hotel document */
  create?: InputMaybe<HotelCreateInput>
}

/** An edge in a connection. */
export type HotelEdge = {
  __typename?: 'HotelEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Hotel
}

/** Identifies documents */
export type HotelManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HotelWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HotelWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HotelWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HotelWhereStageInput>
  documentInStages_none?: InputMaybe<HotelWhereStageInput>
  documentInStages_some?: InputMaybe<HotelWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum HotelOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DistanceAsc = 'distance_ASC',
  DistanceDesc = 'distance_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  RatingAsc = 'rating_ASC',
  RatingDesc = 'rating_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
}

export type HotelUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** distance input for default locale (de) */
  distance?: InputMaybe<Scalars['String']['input']>
  hotelInSection?: InputMaybe<SectionHotelUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HotelUpdateLocalizationsInput>
  logo?: InputMaybe<AssetUpdateOneInlineInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** rating input for default locale (de) */
  rating?: InputMaybe<Scalars['String']['input']>
  /** url input for default locale (de) */
  url?: InputMaybe<Scalars['String']['input']>
}

export type HotelUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  distance?: InputMaybe<Scalars['String']['input']>
  rating?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type HotelUpdateLocalizationInput = {
  data: HotelUpdateLocalizationDataInput
  locale: Locale
}

export type HotelUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HotelCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HotelUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HotelUpsertLocalizationInput>>
}

export type HotelUpdateManyInlineInput = {
  /** Connect multiple existing Hotel documents */
  connect?: InputMaybe<Array<HotelConnectInput>>
  /** Create and connect multiple Hotel documents */
  create?: InputMaybe<Array<HotelCreateInput>>
  /** Delete multiple Hotel documents */
  delete?: InputMaybe<Array<HotelWhereUniqueInput>>
  /** Disconnect multiple Hotel documents */
  disconnect?: InputMaybe<Array<HotelWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Hotel documents */
  set?: InputMaybe<Array<HotelWhereUniqueInput>>
  /** Update multiple Hotel documents */
  update?: InputMaybe<Array<HotelUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Hotel documents */
  upsert?: InputMaybe<Array<HotelUpsertWithNestedWhereUniqueInput>>
}

export type HotelUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** distance input for default locale (de) */
  distance?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HotelUpdateManyLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** rating input for default locale (de) */
  rating?: InputMaybe<Scalars['String']['input']>
  /** url input for default locale (de) */
  url?: InputMaybe<Scalars['String']['input']>
}

export type HotelUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  distance?: InputMaybe<Scalars['String']['input']>
  rating?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type HotelUpdateManyLocalizationInput = {
  data: HotelUpdateManyLocalizationDataInput
  locale: Locale
}

export type HotelUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HotelUpdateManyLocalizationInput>>
}

export type HotelUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HotelUpdateManyInput
  /** Document search */
  where: HotelWhereInput
}

export type HotelUpdateOneInlineInput = {
  /** Connect existing Hotel document */
  connect?: InputMaybe<HotelWhereUniqueInput>
  /** Create and connect one Hotel document */
  create?: InputMaybe<HotelCreateInput>
  /** Delete currently connected Hotel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Hotel document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Hotel document */
  update?: InputMaybe<HotelUpdateWithNestedWhereUniqueInput>
  /** Upsert single Hotel document */
  upsert?: InputMaybe<HotelUpsertWithNestedWhereUniqueInput>
}

export type HotelUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HotelUpdateInput
  /** Unique document search */
  where: HotelWhereUniqueInput
}

export type HotelUpsertInput = {
  /** Create document if it didn't exist */
  create: HotelCreateInput
  /** Update document if it exists */
  update: HotelUpdateInput
}

export type HotelUpsertLocalizationInput = {
  create: HotelCreateLocalizationDataInput
  locale: Locale
  update: HotelUpdateLocalizationDataInput
}

export type HotelUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HotelUpsertInput
  /** Unique document search */
  where: HotelWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type HotelWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type HotelWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HotelWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HotelWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HotelWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  distance?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  distance_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  distance_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  distance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  distance_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  distance_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  distance_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  distance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  distance_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  distance_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<HotelWhereStageInput>
  documentInStages_none?: InputMaybe<HotelWhereStageInput>
  documentInStages_some?: InputMaybe<HotelWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  rating?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  rating_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  rating_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  rating_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  rating_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  rating_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  rating_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  rating_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  rating_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  rating_starts_with?: InputMaybe<Scalars['String']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HotelWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HotelWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HotelWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HotelWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HotelWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Hotel record uniquely */
export type HotelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Raw HTML code to be rendered on the page */
export type HtmlEmbed = Entity &
  Node & {
    __typename?: 'HtmlEmbed'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<HtmlEmbed>
    /** List of HtmlEmbed versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    rawHtml: Scalars['String']['output']
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** Descriptive title for HTML snippet */
    title?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    /** Optional wordpress reference used by importer */
    wpId?: Maybe<Scalars['String']['output']>
  }

/** Raw HTML code to be rendered on the page */
export type HtmlEmbedCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Raw HTML code to be rendered on the page */
export type HtmlEmbedDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Raw HTML code to be rendered on the page */
export type HtmlEmbedHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Raw HTML code to be rendered on the page */
export type HtmlEmbedPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Raw HTML code to be rendered on the page */
export type HtmlEmbedScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Raw HTML code to be rendered on the page */
export type HtmlEmbedUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HtmlEmbedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HtmlEmbedWhereUniqueInput
}

/** A connection to a list of items. */
export type HtmlEmbedConnection = {
  __typename?: 'HtmlEmbedConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HtmlEmbedEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HtmlEmbedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  rawHtml: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type HtmlEmbedCreateManyInlineInput = {
  /** Connect multiple existing HtmlEmbed documents */
  connect?: InputMaybe<Array<HtmlEmbedWhereUniqueInput>>
  /** Create and connect multiple existing HtmlEmbed documents */
  create?: InputMaybe<Array<HtmlEmbedCreateInput>>
}

export type HtmlEmbedCreateOneInlineInput = {
  /** Connect one existing HtmlEmbed document */
  connect?: InputMaybe<HtmlEmbedWhereUniqueInput>
  /** Create and connect one HtmlEmbed document */
  create?: InputMaybe<HtmlEmbedCreateInput>
}

/** An edge in a connection. */
export type HtmlEmbedEdge = {
  __typename?: 'HtmlEmbedEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HtmlEmbed
}

/** Identifies documents */
export type HtmlEmbedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HtmlEmbedWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HtmlEmbedWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HtmlEmbedWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HtmlEmbedWhereStageInput>
  documentInStages_none?: InputMaybe<HtmlEmbedWhereStageInput>
  documentInStages_some?: InputMaybe<HtmlEmbedWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  rawHtml?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  rawHtml_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  rawHtml_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  rawHtml_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  rawHtml_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  rawHtml_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  rawHtml_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  rawHtml_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  rawHtml_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  rawHtml_starts_with?: InputMaybe<Scalars['String']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum HtmlEmbedOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  RawHtmlAsc = 'rawHtml_ASC',
  RawHtmlDesc = 'rawHtml_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WpIdAsc = 'wpId_ASC',
  WpIdDesc = 'wpId_DESC',
}

export type HtmlEmbedUpdateInput = {
  rawHtml?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type HtmlEmbedUpdateManyInlineInput = {
  /** Connect multiple existing HtmlEmbed documents */
  connect?: InputMaybe<Array<HtmlEmbedConnectInput>>
  /** Create and connect multiple HtmlEmbed documents */
  create?: InputMaybe<Array<HtmlEmbedCreateInput>>
  /** Delete multiple HtmlEmbed documents */
  delete?: InputMaybe<Array<HtmlEmbedWhereUniqueInput>>
  /** Disconnect multiple HtmlEmbed documents */
  disconnect?: InputMaybe<Array<HtmlEmbedWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HtmlEmbed documents */
  set?: InputMaybe<Array<HtmlEmbedWhereUniqueInput>>
  /** Update multiple HtmlEmbed documents */
  update?: InputMaybe<Array<HtmlEmbedUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HtmlEmbed documents */
  upsert?: InputMaybe<Array<HtmlEmbedUpsertWithNestedWhereUniqueInput>>
}

export type HtmlEmbedUpdateManyInput = {
  rawHtml?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HtmlEmbedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HtmlEmbedUpdateManyInput
  /** Document search */
  where: HtmlEmbedWhereInput
}

export type HtmlEmbedUpdateOneInlineInput = {
  /** Connect existing HtmlEmbed document */
  connect?: InputMaybe<HtmlEmbedWhereUniqueInput>
  /** Create and connect one HtmlEmbed document */
  create?: InputMaybe<HtmlEmbedCreateInput>
  /** Delete currently connected HtmlEmbed document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HtmlEmbed document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HtmlEmbed document */
  update?: InputMaybe<HtmlEmbedUpdateWithNestedWhereUniqueInput>
  /** Upsert single HtmlEmbed document */
  upsert?: InputMaybe<HtmlEmbedUpsertWithNestedWhereUniqueInput>
}

export type HtmlEmbedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HtmlEmbedUpdateInput
  /** Unique document search */
  where: HtmlEmbedWhereUniqueInput
}

export type HtmlEmbedUpsertInput = {
  /** Create document if it didn't exist */
  create: HtmlEmbedCreateInput
  /** Update document if it exists */
  update: HtmlEmbedUpdateInput
}

export type HtmlEmbedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HtmlEmbedUpsertInput
  /** Unique document search */
  where: HtmlEmbedWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type HtmlEmbedWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type HtmlEmbedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HtmlEmbedWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HtmlEmbedWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HtmlEmbedWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HtmlEmbedWhereStageInput>
  documentInStages_none?: InputMaybe<HtmlEmbedWhereStageInput>
  documentInStages_some?: InputMaybe<HtmlEmbedWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  rawHtml?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  rawHtml_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  rawHtml_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  rawHtml_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  rawHtml_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  rawHtml_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  rawHtml_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  rawHtml_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  rawHtml_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  rawHtml_starts_with?: InputMaybe<Scalars['String']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HtmlEmbedWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HtmlEmbedWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HtmlEmbedWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HtmlEmbedWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HtmlEmbedWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References HtmlEmbed record uniquely */
export type HtmlEmbedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntry = Entity &
  Node & {
    __typename?: 'HubContentEntry'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<HubContentEntry>
    /** List of HubContentEntry versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Image for Hub Content Entry */
    image: Asset
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<HubContentEntry>
    overline?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    subtitle?: Maybe<Scalars['String']['output']>
    targetUrl: Scalars['String']['output']
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Provides manual control over content for a hub page reference list tiles. */
export type HubContentEntryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HubContentEntryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubContentEntryWhereUniqueInput
}

/** A connection to a list of items. */
export type HubContentEntryConnection = {
  __typename?: 'HubContentEntryConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubContentEntryEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubContentEntryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubContentEntryCreateLocalizationsInput>
  /** overline input for default locale (de) */
  overline?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** targetUrl input for default locale (de) */
  targetUrl: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubContentEntryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  overline?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  targetUrl: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubContentEntryCreateLocalizationInput = {
  /** Localization input */
  data: HubContentEntryCreateLocalizationDataInput
  locale: Locale
}

export type HubContentEntryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubContentEntryCreateLocalizationInput>>
}

export type HubContentEntryCreateManyInlineInput = {
  /** Connect multiple existing HubContentEntry documents */
  connect?: InputMaybe<Array<HubContentEntryWhereUniqueInput>>
  /** Create and connect multiple existing HubContentEntry documents */
  create?: InputMaybe<Array<HubContentEntryCreateInput>>
}

export type HubContentEntryCreateOneInlineInput = {
  /** Connect one existing HubContentEntry document */
  connect?: InputMaybe<HubContentEntryWhereUniqueInput>
  /** Create and connect one HubContentEntry document */
  create?: InputMaybe<HubContentEntryCreateInput>
}

/** An edge in a connection. */
export type HubContentEntryEdge = {
  __typename?: 'HubContentEntryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubContentEntry
}

/** Identifies documents */
export type HubContentEntryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubContentEntryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubContentEntryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubContentEntryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HubContentEntryWhereStageInput>
  documentInStages_none?: InputMaybe<HubContentEntryWhereStageInput>
  documentInStages_some?: InputMaybe<HubContentEntryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum HubContentEntryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OverlineAsc = 'overline_ASC',
  OverlineDesc = 'overline_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TargetUrlAsc = 'targetUrl_ASC',
  TargetUrlDesc = 'targetUrl_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubContentEntryUpdateInput = {
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HubContentEntryUpdateLocalizationsInput>
  /** overline input for default locale (de) */
  overline?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** targetUrl input for default locale (de) */
  targetUrl?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubContentEntryUpdateLocalizationDataInput = {
  overline?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  targetUrl?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubContentEntryUpdateLocalizationInput = {
  data: HubContentEntryUpdateLocalizationDataInput
  locale: Locale
}

export type HubContentEntryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubContentEntryCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubContentEntryUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubContentEntryUpsertLocalizationInput>>
}

export type HubContentEntryUpdateManyInlineInput = {
  /** Connect multiple existing HubContentEntry documents */
  connect?: InputMaybe<Array<HubContentEntryConnectInput>>
  /** Create and connect multiple HubContentEntry documents */
  create?: InputMaybe<Array<HubContentEntryCreateInput>>
  /** Delete multiple HubContentEntry documents */
  delete?: InputMaybe<Array<HubContentEntryWhereUniqueInput>>
  /** Disconnect multiple HubContentEntry documents */
  disconnect?: InputMaybe<Array<HubContentEntryWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HubContentEntry documents */
  set?: InputMaybe<Array<HubContentEntryWhereUniqueInput>>
  /** Update multiple HubContentEntry documents */
  update?: InputMaybe<Array<HubContentEntryUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HubContentEntry documents */
  upsert?: InputMaybe<Array<HubContentEntryUpsertWithNestedWhereUniqueInput>>
}

export type HubContentEntryUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubContentEntryUpdateManyLocalizationsInput>
  /** overline input for default locale (de) */
  overline?: InputMaybe<Scalars['String']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** targetUrl input for default locale (de) */
  targetUrl?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubContentEntryUpdateManyLocalizationDataInput = {
  overline?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  targetUrl?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubContentEntryUpdateManyLocalizationInput = {
  data: HubContentEntryUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubContentEntryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubContentEntryUpdateManyLocalizationInput>>
}

export type HubContentEntryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubContentEntryUpdateManyInput
  /** Document search */
  where: HubContentEntryWhereInput
}

export type HubContentEntryUpdateOneInlineInput = {
  /** Connect existing HubContentEntry document */
  connect?: InputMaybe<HubContentEntryWhereUniqueInput>
  /** Create and connect one HubContentEntry document */
  create?: InputMaybe<HubContentEntryCreateInput>
  /** Delete currently connected HubContentEntry document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HubContentEntry document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubContentEntry document */
  update?: InputMaybe<HubContentEntryUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubContentEntry document */
  upsert?: InputMaybe<HubContentEntryUpsertWithNestedWhereUniqueInput>
}

export type HubContentEntryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubContentEntryUpdateInput
  /** Unique document search */
  where: HubContentEntryWhereUniqueInput
}

export type HubContentEntryUpsertInput = {
  /** Create document if it didn't exist */
  create: HubContentEntryCreateInput
  /** Update document if it exists */
  update: HubContentEntryUpdateInput
}

export type HubContentEntryUpsertLocalizationInput = {
  create: HubContentEntryCreateLocalizationDataInput
  locale: Locale
  update: HubContentEntryUpdateLocalizationDataInput
}

export type HubContentEntryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubContentEntryUpsertInput
  /** Unique document search */
  where: HubContentEntryWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type HubContentEntryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type HubContentEntryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubContentEntryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubContentEntryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubContentEntryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HubContentEntryWhereStageInput>
  documentInStages_none?: InputMaybe<HubContentEntryWhereStageInput>
  documentInStages_some?: InputMaybe<HubContentEntryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  overline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  overline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  overline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  overline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  overline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  overline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  overline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  overline_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  targetUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  targetUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  targetUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  targetUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  targetUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  targetUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  targetUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  targetUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  targetUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  targetUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HubContentEntryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubContentEntryWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubContentEntryWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubContentEntryWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HubContentEntryWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References HubContentEntry record uniquely */
export type HubContentEntryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Hub page to unfiy content accros all departments */
export type HubPage = Entity &
  Node & {
    __typename?: 'HubPage'
    /** Optional countdown hero for this Hub Page */
    countdownHero?: Maybe<HubPageCountdownHero>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<HubPage>
    /** Hero Slider for Hub Pages */
    heroSlider: Array<HubPageHeroSliderItem>
    /** List of HubPage versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Identifier of the hub page to distinguish it from other hub pages */
    identifier: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** List of sections. Each section includes the content of content navigation slider. */
    sections: Array<HubPagesectionsUnion>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Hub page to unfiy content accros all departments */
export type HubPageCountdownHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hub page to unfiy content accros all departments */
export type HubPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hub page to unfiy content accros all departments */
export type HubPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Hub page to unfiy content accros all departments */
export type HubPageHeroSliderArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<HubPageHeroSliderItemOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubPageHeroSliderItemWhereInput>
}

/** Hub page to unfiy content accros all departments */
export type HubPageHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Hub page to unfiy content accros all departments */
export type HubPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hub page to unfiy content accros all departments */
export type HubPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Hub page to unfiy content accros all departments */
export type HubPageSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

/** Hub page to unfiy content accros all departments */
export type HubPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** EPOM Ad Tile */
export type HubPageAdTile = Entity & {
  __typename?: 'HubPageAdTile'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** EPOM Placement key */
  placementKey: Scalars['String']['output']
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Ad Tile */
  tileSizes: HubPageTileSizes
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** EPOM Ad Tile */
export type HubPageAdTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HubPageAdTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageAdTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageAdTileConnection = {
  __typename?: 'HubPageAdTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageAdTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageAdTileCreateInput = {
  placementKey: Scalars['String']['input']
  tileSizes: HubPageTileSizesCreateOneInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageAdTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageAdTile documents */
  create?: InputMaybe<Array<HubPageAdTileCreateInput>>
}

export type HubPageAdTileCreateOneInlineInput = {
  /** Create and connect one HubPageAdTile document */
  create?: InputMaybe<HubPageAdTileCreateInput>
}

export type HubPageAdTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageAdTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageAdTileEdge = {
  __typename?: 'HubPageAdTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageAdTile
}

/** Identifies documents */
export type HubPageAdTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageAdTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageAdTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageAdTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  placementKey?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  placementKey_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  placementKey_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  placementKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  placementKey_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  placementKey_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  placementKey_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  placementKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  placementKey_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  placementKey_starts_with?: InputMaybe<Scalars['String']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageAdTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PlacementKeyAsc = 'placementKey_ASC',
  PlacementKeyDesc = 'placementKey_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageAdTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageAdTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageAdTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageAdTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageAdTileParent documents */
  create?: InputMaybe<Array<HubPageAdTileParentCreateInput>>
}

export type HubPageAdTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageAdTileParent document */
  create?: InputMaybe<HubPageAdTileParentCreateInput>
}

export type HubPageAdTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageAdTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageAdTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageAdTileParent component instances */
  create?: InputMaybe<Array<HubPageAdTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageAdTileParent documents */
  delete?: InputMaybe<Array<HubPageAdTileParentWhereUniqueInput>>
  /** Update multiple HubPageAdTileParent component instances */
  update?: InputMaybe<Array<HubPageAdTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageAdTileParent component instances */
  upsert?: InputMaybe<Array<HubPageAdTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageAdTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageAdTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageAdTileParent document */
  create?: InputMaybe<HubPageAdTileParentCreateInput>
  /** Delete currently connected HubPageAdTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageAdTileParent document */
  update?: InputMaybe<HubPageAdTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageAdTileParent document */
  upsert?: InputMaybe<HubPageAdTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageAdTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageAdTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageAdTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageAdTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageAdTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageAdTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageAdTileUpdateInput = {
  placementKey?: InputMaybe<Scalars['String']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
}

export type HubPageAdTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageAdTile component instances */
  create?: InputMaybe<Array<HubPageAdTileCreateWithPositionInput>>
  /** Delete multiple HubPageAdTile documents */
  delete?: InputMaybe<Array<HubPageAdTileWhereUniqueInput>>
  /** Update multiple HubPageAdTile component instances */
  update?: InputMaybe<Array<HubPageAdTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageAdTile component instances */
  upsert?: InputMaybe<Array<HubPageAdTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageAdTileUpdateManyInput = {
  placementKey?: InputMaybe<Scalars['String']['input']>
}

export type HubPageAdTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageAdTileUpdateManyInput
  /** Document search */
  where: HubPageAdTileWhereInput
}

export type HubPageAdTileUpdateOneInlineInput = {
  /** Create and connect one HubPageAdTile document */
  create?: InputMaybe<HubPageAdTileCreateInput>
  /** Delete currently connected HubPageAdTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageAdTile document */
  update?: InputMaybe<HubPageAdTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageAdTile document */
  upsert?: InputMaybe<HubPageAdTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageAdTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageAdTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageAdTileWhereUniqueInput
}

export type HubPageAdTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageAdTileUpdateInput
  /** Unique document search */
  where: HubPageAdTileWhereUniqueInput
}

export type HubPageAdTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageAdTileCreateInput
  /** Update document if it exists */
  update: HubPageAdTileUpdateInput
}

export type HubPageAdTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageAdTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageAdTileWhereUniqueInput
}

export type HubPageAdTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageAdTileUpsertInput
  /** Unique document search */
  where: HubPageAdTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageAdTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageAdTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageAdTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageAdTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  placementKey?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  placementKey_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  placementKey_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  placementKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  placementKey_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  placementKey_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  placementKey_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  placementKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  placementKey_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  placementKey_starts_with?: InputMaybe<Scalars['String']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageAdTile record uniquely */
export type HubPageAdTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Article List Tile for Hub Page Sections */
export type HubPageArticleListTile = Entity & {
  __typename?: 'HubPageArticleListTile'
  /** Optional filter: only include articles in these categories */
  articleCategories: Array<ArticleCategory>
  articleType: ArticleType
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Number of latest articles to skip */
  skipArticles?: Maybe<Scalars['Int']['output']>
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Article List Tile */
  tileSizes: HubPageTileSizes
  /** Tracking identifier which will be used to generate data-track attribute */
  trackingId?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Article List Tile for Hub Page Sections */
export type HubPageArticleListTileArticleCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleCategoryWhereInput>
}

/** Article List Tile for Hub Page Sections */
export type HubPageArticleListTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HubPageArticleListTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageArticleListTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageArticleListTileConnection = {
  __typename?: 'HubPageArticleListTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageArticleListTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageArticleListTileCreateInput = {
  articleCategories?: InputMaybe<ArticleCategoryCreateManyInlineInput>
  articleType: ArticleType
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  tileSizes: HubPageTileSizesCreateOneInlineInput
  trackingId?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageArticleListTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageArticleListTile documents */
  create?: InputMaybe<Array<HubPageArticleListTileCreateInput>>
}

export type HubPageArticleListTileCreateOneInlineInput = {
  /** Create and connect one HubPageArticleListTile document */
  create?: InputMaybe<HubPageArticleListTileCreateInput>
}

export type HubPageArticleListTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageArticleListTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageArticleListTileEdge = {
  __typename?: 'HubPageArticleListTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageArticleListTile
}

/** Identifies documents */
export type HubPageArticleListTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageArticleListTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageArticleListTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageArticleListTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articleCategories_every?: InputMaybe<ArticleCategoryWhereInput>
  articleCategories_none?: InputMaybe<ArticleCategoryWhereInput>
  articleCategories_some?: InputMaybe<ArticleCategoryWhereInput>
  articleType?: InputMaybe<ArticleType>
  /** All values that are contained in given list. */
  articleType_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  /** Any other value that exists and is not equal to the given value. */
  articleType_not?: InputMaybe<ArticleType>
  /** All values that are not contained in given list. */
  articleType_not_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  skipArticles_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  skipArticles_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  skipArticles_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  skipArticles_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  skipArticles_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  skipArticles_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  skipArticles_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  trackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  trackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  trackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  trackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  trackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  trackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  trackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  trackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  trackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageArticleListTileOrderByInput {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SkipArticlesAsc = 'skipArticles_ASC',
  SkipArticlesDesc = 'skipArticles_DESC',
  TrackingIdAsc = 'trackingId_ASC',
  TrackingIdDesc = 'trackingId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageArticleListTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageArticleListTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageArticleListTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageArticleListTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageArticleListTileParent documents */
  create?: InputMaybe<Array<HubPageArticleListTileParentCreateInput>>
}

export type HubPageArticleListTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageArticleListTileParent document */
  create?: InputMaybe<HubPageArticleListTileParentCreateInput>
}

export type HubPageArticleListTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageArticleListTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageArticleListTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageArticleListTileParent component instances */
  create?: InputMaybe<Array<HubPageArticleListTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageArticleListTileParent documents */
  delete?: InputMaybe<Array<HubPageArticleListTileParentWhereUniqueInput>>
  /** Update multiple HubPageArticleListTileParent component instances */
  update?: InputMaybe<Array<HubPageArticleListTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageArticleListTileParent component instances */
  upsert?: InputMaybe<Array<HubPageArticleListTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageArticleListTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageArticleListTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageArticleListTileParent document */
  create?: InputMaybe<HubPageArticleListTileParentCreateInput>
  /** Delete currently connected HubPageArticleListTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageArticleListTileParent document */
  update?: InputMaybe<HubPageArticleListTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageArticleListTileParent document */
  upsert?: InputMaybe<HubPageArticleListTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageArticleListTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageArticleListTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageArticleListTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageArticleListTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageArticleListTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageArticleListTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageArticleListTileUpdateInput = {
  articleCategories?: InputMaybe<ArticleCategoryUpdateManyInlineInput>
  articleType?: InputMaybe<ArticleType>
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
}

export type HubPageArticleListTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageArticleListTile component instances */
  create?: InputMaybe<Array<HubPageArticleListTileCreateWithPositionInput>>
  /** Delete multiple HubPageArticleListTile documents */
  delete?: InputMaybe<Array<HubPageArticleListTileWhereUniqueInput>>
  /** Update multiple HubPageArticleListTile component instances */
  update?: InputMaybe<Array<HubPageArticleListTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageArticleListTile component instances */
  upsert?: InputMaybe<Array<HubPageArticleListTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageArticleListTileUpdateManyInput = {
  articleType?: InputMaybe<ArticleType>
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
}

export type HubPageArticleListTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageArticleListTileUpdateManyInput
  /** Document search */
  where: HubPageArticleListTileWhereInput
}

export type HubPageArticleListTileUpdateOneInlineInput = {
  /** Create and connect one HubPageArticleListTile document */
  create?: InputMaybe<HubPageArticleListTileCreateInput>
  /** Delete currently connected HubPageArticleListTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageArticleListTile document */
  update?: InputMaybe<HubPageArticleListTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageArticleListTile document */
  upsert?: InputMaybe<HubPageArticleListTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageArticleListTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageArticleListTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageArticleListTileWhereUniqueInput
}

export type HubPageArticleListTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageArticleListTileUpdateInput
  /** Unique document search */
  where: HubPageArticleListTileWhereUniqueInput
}

export type HubPageArticleListTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageArticleListTileCreateInput
  /** Update document if it exists */
  update: HubPageArticleListTileUpdateInput
}

export type HubPageArticleListTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageArticleListTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageArticleListTileWhereUniqueInput
}

export type HubPageArticleListTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageArticleListTileUpsertInput
  /** Unique document search */
  where: HubPageArticleListTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageArticleListTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageArticleListTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageArticleListTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageArticleListTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articleCategories_every?: InputMaybe<ArticleCategoryWhereInput>
  articleCategories_none?: InputMaybe<ArticleCategoryWhereInput>
  articleCategories_some?: InputMaybe<ArticleCategoryWhereInput>
  articleType?: InputMaybe<ArticleType>
  /** All values that are contained in given list. */
  articleType_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  /** Any other value that exists and is not equal to the given value. */
  articleType_not?: InputMaybe<ArticleType>
  /** All values that are not contained in given list. */
  articleType_not_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  skipArticles_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  skipArticles_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  skipArticles_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  skipArticles_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  skipArticles_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  skipArticles_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  skipArticles_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  trackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  trackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  trackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  trackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  trackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  trackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  trackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  trackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  trackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageArticleListTile record uniquely */
export type HubPageArticleListTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type HubPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageConnection = {
  __typename?: 'HubPageConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Content Slider Item for Hub Pages */
export type HubPageContentSliderItem = Entity & {
  __typename?: 'HubPageContentSliderItem'
  cta: CallToAction
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Image for Hub Page Content Slider Item */
  image: Asset
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageContentSliderItem>
  /** System stage field */
  stage: Stage
  /** Content slider item subtitle */
  subtitle?: Maybe<Scalars['String']['output']>
  tag?: Maybe<Tag>
  theme: OmrThemeVariant
  /** Content slider item title */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content Slider Item for Hub Pages */
export type HubPageContentSliderItemCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Slider Item for Hub Pages */
export type HubPageContentSliderItemImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Content Slider Item for Hub Pages */
export type HubPageContentSliderItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Content Slider Item for Hub Pages */
export type HubPageContentSliderItemTagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Slider Item for Hub Pages */
export type HubPageContentSliderItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageContentSliderItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageContentSliderItemWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageContentSliderItemConnection = {
  __typename?: 'HubPageContentSliderItemConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageContentSliderItemEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageContentSliderItemCreateInput = {
  cta: CallToActionCreateOneInlineInput
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageContentSliderItemCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<TagCreateOneInlineInput>
  theme: OmrThemeVariant
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageContentSliderItemCreateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageContentSliderItemCreateLocalizationInput = {
  /** Localization input */
  data: HubPageContentSliderItemCreateLocalizationDataInput
  locale: Locale
}

export type HubPageContentSliderItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageContentSliderItemCreateLocalizationInput>>
}

export type HubPageContentSliderItemCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageContentSliderItem documents */
  create?: InputMaybe<Array<HubPageContentSliderItemCreateInput>>
}

export type HubPageContentSliderItemCreateOneInlineInput = {
  /** Create and connect one HubPageContentSliderItem document */
  create?: InputMaybe<HubPageContentSliderItemCreateInput>
}

export type HubPageContentSliderItemCreateWithPositionInput = {
  /** Document to create */
  data: HubPageContentSliderItemCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageContentSliderItemEdge = {
  __typename?: 'HubPageContentSliderItemEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageContentSliderItem
}

/** Identifies documents */
export type HubPageContentSliderItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageContentSliderItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageContentSliderItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageContentSliderItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  tag?: InputMaybe<TagWhereInput>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageContentSliderItemOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageContentSliderItemParent = HubPageContentSliderTile

export type HubPageContentSliderItemParentConnectInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileConnectInput>
}

export type HubPageContentSliderItemParentCreateInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileCreateInput>
}

export type HubPageContentSliderItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageContentSliderItemParent documents */
  create?: InputMaybe<Array<HubPageContentSliderItemParentCreateInput>>
}

export type HubPageContentSliderItemParentCreateOneInlineInput = {
  /** Create and connect one HubPageContentSliderItemParent document */
  create?: InputMaybe<HubPageContentSliderItemParentCreateInput>
}

export type HubPageContentSliderItemParentCreateWithPositionInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileCreateWithPositionInput>
}

export type HubPageContentSliderItemParentUpdateInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpdateInput>
}

export type HubPageContentSliderItemParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageContentSliderItemParent component instances */
  create?: InputMaybe<Array<HubPageContentSliderItemParentCreateWithPositionInput>>
  /** Delete multiple HubPageContentSliderItemParent documents */
  delete?: InputMaybe<Array<HubPageContentSliderItemParentWhereUniqueInput>>
  /** Update multiple HubPageContentSliderItemParent component instances */
  update?: InputMaybe<Array<HubPageContentSliderItemParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageContentSliderItemParent component instances */
  upsert?: InputMaybe<Array<HubPageContentSliderItemParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageContentSliderItemParentUpdateManyWithNestedWhereInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpdateManyWithNestedWhereInput>
}

export type HubPageContentSliderItemParentUpdateOneInlineInput = {
  /** Create and connect one HubPageContentSliderItemParent document */
  create?: InputMaybe<HubPageContentSliderItemParentCreateInput>
  /** Delete currently connected HubPageContentSliderItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageContentSliderItemParent document */
  update?: InputMaybe<HubPageContentSliderItemParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageContentSliderItemParent document */
  upsert?: InputMaybe<HubPageContentSliderItemParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentSliderItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageContentSliderItemParentUpdateWithNestedWhereUniqueInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpdateWithNestedWhereUniqueInput>
}

export type HubPageContentSliderItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageContentSliderItemParentUpsertWithNestedWhereUniqueInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentSliderItemParentWhereInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileWhereInput>
}

export type HubPageContentSliderItemParentWhereUniqueInput = {
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileWhereUniqueInput>
}

export type HubPageContentSliderItemUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageContentSliderItemUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<TagUpdateOneInlineInput>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentSliderItemUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentSliderItemUpdateLocalizationInput = {
  data: HubPageContentSliderItemUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageContentSliderItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageContentSliderItemCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageContentSliderItemUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageContentSliderItemUpsertLocalizationInput>>
}

export type HubPageContentSliderItemUpdateManyInlineInput = {
  /** Create and connect multiple HubPageContentSliderItem component instances */
  create?: InputMaybe<Array<HubPageContentSliderItemCreateWithPositionInput>>
  /** Delete multiple HubPageContentSliderItem documents */
  delete?: InputMaybe<Array<HubPageContentSliderItemWhereUniqueInput>>
  /** Update multiple HubPageContentSliderItem component instances */
  update?: InputMaybe<Array<HubPageContentSliderItemUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageContentSliderItem component instances */
  upsert?: InputMaybe<Array<HubPageContentSliderItemUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageContentSliderItemUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageContentSliderItemUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentSliderItemUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentSliderItemUpdateManyLocalizationInput = {
  data: HubPageContentSliderItemUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageContentSliderItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageContentSliderItemUpdateManyLocalizationInput>>
}

export type HubPageContentSliderItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageContentSliderItemUpdateManyInput
  /** Document search */
  where: HubPageContentSliderItemWhereInput
}

export type HubPageContentSliderItemUpdateOneInlineInput = {
  /** Create and connect one HubPageContentSliderItem document */
  create?: InputMaybe<HubPageContentSliderItemCreateInput>
  /** Delete currently connected HubPageContentSliderItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageContentSliderItem document */
  update?: InputMaybe<HubPageContentSliderItemUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageContentSliderItem document */
  upsert?: InputMaybe<HubPageContentSliderItemUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentSliderItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageContentSliderItemUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageContentSliderItemWhereUniqueInput
}

export type HubPageContentSliderItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageContentSliderItemUpdateInput
  /** Unique document search */
  where: HubPageContentSliderItemWhereUniqueInput
}

export type HubPageContentSliderItemUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageContentSliderItemCreateInput
  /** Update document if it exists */
  update: HubPageContentSliderItemUpdateInput
}

export type HubPageContentSliderItemUpsertLocalizationInput = {
  create: HubPageContentSliderItemCreateLocalizationDataInput
  locale: Locale
  update: HubPageContentSliderItemUpdateLocalizationDataInput
}

export type HubPageContentSliderItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageContentSliderItemUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageContentSliderItemWhereUniqueInput
}

export type HubPageContentSliderItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageContentSliderItemUpsertInput
  /** Unique document search */
  where: HubPageContentSliderItemWhereUniqueInput
}

/** Identifies documents */
export type HubPageContentSliderItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageContentSliderItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageContentSliderItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageContentSliderItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<TagWhereInput>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageContentSliderItem record uniquely */
export type HubPageContentSliderItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Content slider tile for Hub Page Sections */
export type HubPageContentSliderTile = Entity & {
  __typename?: 'HubPageContentSliderTile'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Slides for Hub Page Content Slider Tile */
  slides: Array<HubPageContentSliderItem>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content slider tile for Hub Page Sections */
export type HubPageContentSliderTileSlidesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<HubPageContentSliderItemOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubPageContentSliderItemWhereInput>
}

export type HubPageContentSliderTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageContentSliderTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageContentSliderTileConnection = {
  __typename?: 'HubPageContentSliderTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageContentSliderTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageContentSliderTileCreateInput = {
  slides?: InputMaybe<HubPageContentSliderItemCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageContentSliderTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageContentSliderTile documents */
  create?: InputMaybe<Array<HubPageContentSliderTileCreateInput>>
}

export type HubPageContentSliderTileCreateOneInlineInput = {
  /** Create and connect one HubPageContentSliderTile document */
  create?: InputMaybe<HubPageContentSliderTileCreateInput>
}

export type HubPageContentSliderTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageContentSliderTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageContentSliderTileEdge = {
  __typename?: 'HubPageContentSliderTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageContentSliderTile
}

/** Identifies documents */
export type HubPageContentSliderTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageContentSliderTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageContentSliderTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageContentSliderTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  slides_every?: InputMaybe<HubPageContentSliderItemWhereInput>
  slides_none?: InputMaybe<HubPageContentSliderItemWhereInput>
  slides_some?: InputMaybe<HubPageContentSliderItemWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageContentSliderTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageContentSliderTileParent = HubPageSectionGeneral

export type HubPageContentSliderTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
}

export type HubPageContentSliderTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
}

export type HubPageContentSliderTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageContentSliderTileParent documents */
  create?: InputMaybe<Array<HubPageContentSliderTileParentCreateInput>>
}

export type HubPageContentSliderTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageContentSliderTileParent document */
  create?: InputMaybe<HubPageContentSliderTileParentCreateInput>
}

export type HubPageContentSliderTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
}

export type HubPageContentSliderTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
}

export type HubPageContentSliderTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageContentSliderTileParent component instances */
  create?: InputMaybe<Array<HubPageContentSliderTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageContentSliderTileParent documents */
  delete?: InputMaybe<Array<HubPageContentSliderTileParentWhereUniqueInput>>
  /** Update multiple HubPageContentSliderTileParent component instances */
  update?: InputMaybe<Array<HubPageContentSliderTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageContentSliderTileParent component instances */
  upsert?: InputMaybe<Array<HubPageContentSliderTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageContentSliderTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
}

export type HubPageContentSliderTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageContentSliderTileParent document */
  create?: InputMaybe<HubPageContentSliderTileParentCreateInput>
  /** Delete currently connected HubPageContentSliderTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageContentSliderTileParent document */
  update?: InputMaybe<HubPageContentSliderTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageContentSliderTileParent document */
  upsert?: InputMaybe<HubPageContentSliderTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentSliderTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageContentSliderTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
}

export type HubPageContentSliderTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageContentSliderTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentSliderTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
}

export type HubPageContentSliderTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
}

export type HubPageContentSliderTileUpdateInput = {
  slides?: InputMaybe<HubPageContentSliderItemUpdateManyInlineInput>
}

export type HubPageContentSliderTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageContentSliderTile component instances */
  create?: InputMaybe<Array<HubPageContentSliderTileCreateWithPositionInput>>
  /** Delete multiple HubPageContentSliderTile documents */
  delete?: InputMaybe<Array<HubPageContentSliderTileWhereUniqueInput>>
  /** Update multiple HubPageContentSliderTile component instances */
  update?: InputMaybe<Array<HubPageContentSliderTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageContentSliderTile component instances */
  upsert?: InputMaybe<Array<HubPageContentSliderTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageContentSliderTileUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentSliderTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageContentSliderTileUpdateManyInput
  /** Document search */
  where: HubPageContentSliderTileWhereInput
}

export type HubPageContentSliderTileUpdateOneInlineInput = {
  /** Create and connect one HubPageContentSliderTile document */
  create?: InputMaybe<HubPageContentSliderTileCreateInput>
  /** Delete currently connected HubPageContentSliderTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageContentSliderTile document */
  update?: InputMaybe<HubPageContentSliderTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageContentSliderTile document */
  upsert?: InputMaybe<HubPageContentSliderTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentSliderTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageContentSliderTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageContentSliderTileWhereUniqueInput
}

export type HubPageContentSliderTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageContentSliderTileUpdateInput
  /** Unique document search */
  where: HubPageContentSliderTileWhereUniqueInput
}

export type HubPageContentSliderTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageContentSliderTileCreateInput
  /** Update document if it exists */
  update: HubPageContentSliderTileUpdateInput
}

export type HubPageContentSliderTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageContentSliderTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageContentSliderTileWhereUniqueInput
}

export type HubPageContentSliderTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageContentSliderTileUpsertInput
  /** Unique document search */
  where: HubPageContentSliderTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageContentSliderTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageContentSliderTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageContentSliderTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageContentSliderTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  slides_every?: InputMaybe<HubPageContentSliderItemWhereInput>
  slides_none?: InputMaybe<HubPageContentSliderItemWhereInput>
  slides_some?: InputMaybe<HubPageContentSliderItemWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageContentSliderTile record uniquely */
export type HubPageContentSliderTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Content Tile for Hub Page Sections */
export type HubPageContentTile = Entity & {
  __typename?: 'HubPageContentTile'
  cta: CallToAction
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Image for Hub Page Content Tile */
  image: Asset
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageContentTile>
  /** System stage field */
  stage: Stage
  /** Content tile subtitle */
  subtitle?: Maybe<Scalars['String']['output']>
  tag?: Maybe<Tag>
  /** Theme for Hub Page Content Tile */
  theme: OmrThemeVariant
  /** Tile sizes for Hub Page Content Tile */
  tileSizes: HubPageTileSizes
  /** Content tile title */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content Tile for Hub Page Sections */
export type HubPageContentTileCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Tile for Hub Page Sections */
export type HubPageContentTileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Content Tile for Hub Page Sections */
export type HubPageContentTileLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Content Tile for Hub Page Sections */
export type HubPageContentTileTagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Tile for Hub Page Sections */
export type HubPageContentTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Tile for Hub Page Sections */
export type HubPageContentTileUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageContentTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageContentTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageContentTileConnection = {
  __typename?: 'HubPageContentTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageContentTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageContentTileCreateInput = {
  cta: CallToActionCreateOneInlineInput
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageContentTileCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<TagCreateOneInlineInput>
  theme: OmrThemeVariant
  tileSizes: HubPageTileSizesCreateOneInlineInput
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageContentTileCreateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageContentTileCreateLocalizationInput = {
  /** Localization input */
  data: HubPageContentTileCreateLocalizationDataInput
  locale: Locale
}

export type HubPageContentTileCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageContentTileCreateLocalizationInput>>
}

export type HubPageContentTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageContentTile documents */
  create?: InputMaybe<Array<HubPageContentTileCreateInput>>
}

export type HubPageContentTileCreateOneInlineInput = {
  /** Create and connect one HubPageContentTile document */
  create?: InputMaybe<HubPageContentTileCreateInput>
}

export type HubPageContentTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageContentTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageContentTileEdge = {
  __typename?: 'HubPageContentTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageContentTile
}

/** Identifies documents */
export type HubPageContentTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageContentTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageContentTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageContentTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  tag?: InputMaybe<TagWhereInput>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageContentTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageContentTileParent = EventAppCard | HubPageSectionGeneral | SectionTiles

export type HubPageContentTileParentConnectInput = {
  EventAppCard?: InputMaybe<EventAppCardConnectInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageContentTileParentCreateInput = {
  EventAppCard?: InputMaybe<EventAppCardCreateInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageContentTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageContentTileParent documents */
  create?: InputMaybe<Array<HubPageContentTileParentCreateInput>>
}

export type HubPageContentTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageContentTileParent document */
  create?: InputMaybe<HubPageContentTileParentCreateInput>
}

export type HubPageContentTileParentCreateWithPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardCreateWithPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageContentTileParentUpdateInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageContentTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageContentTileParent component instances */
  create?: InputMaybe<Array<HubPageContentTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageContentTileParent documents */
  delete?: InputMaybe<Array<HubPageContentTileParentWhereUniqueInput>>
  /** Update multiple HubPageContentTileParent component instances */
  update?: InputMaybe<Array<HubPageContentTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageContentTileParent component instances */
  upsert?: InputMaybe<Array<HubPageContentTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageContentTileParentUpdateManyWithNestedWhereInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateManyWithNestedWhereInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageContentTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageContentTileParent document */
  create?: InputMaybe<HubPageContentTileParentCreateInput>
  /** Delete currently connected HubPageContentTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageContentTileParent document */
  update?: InputMaybe<HubPageContentTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageContentTileParent document */
  upsert?: InputMaybe<HubPageContentTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageContentTileParentUpdateWithNestedWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateWithNestedWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageContentTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageContentTileParentUpsertWithNestedWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardUpsertWithNestedWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentTileParentWhereInput = {
  EventAppCard?: InputMaybe<EventAppCardWhereInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageContentTileParentWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageContentTileUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageContentTileUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<TagUpdateOneInlineInput>
  theme?: InputMaybe<OmrThemeVariant>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentTileUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentTileUpdateLocalizationInput = {
  data: HubPageContentTileUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageContentTileUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageContentTileCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageContentTileUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageContentTileUpsertLocalizationInput>>
}

export type HubPageContentTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageContentTile component instances */
  create?: InputMaybe<Array<HubPageContentTileCreateWithPositionInput>>
  /** Delete multiple HubPageContentTile documents */
  delete?: InputMaybe<Array<HubPageContentTileWhereUniqueInput>>
  /** Update multiple HubPageContentTile component instances */
  update?: InputMaybe<Array<HubPageContentTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageContentTile component instances */
  upsert?: InputMaybe<Array<HubPageContentTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageContentTileUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageContentTileUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentTileUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageContentTileUpdateManyLocalizationInput = {
  data: HubPageContentTileUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageContentTileUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageContentTileUpdateManyLocalizationInput>>
}

export type HubPageContentTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageContentTileUpdateManyInput
  /** Document search */
  where: HubPageContentTileWhereInput
}

export type HubPageContentTileUpdateOneInlineInput = {
  /** Create and connect one HubPageContentTile document */
  create?: InputMaybe<HubPageContentTileCreateInput>
  /** Delete currently connected HubPageContentTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageContentTile document */
  update?: InputMaybe<HubPageContentTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageContentTile document */
  upsert?: InputMaybe<HubPageContentTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageContentTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageContentTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageContentTileWhereUniqueInput
}

export type HubPageContentTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageContentTileUpdateInput
  /** Unique document search */
  where: HubPageContentTileWhereUniqueInput
}

export type HubPageContentTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageContentTileCreateInput
  /** Update document if it exists */
  update: HubPageContentTileUpdateInput
}

export type HubPageContentTileUpsertLocalizationInput = {
  create: HubPageContentTileCreateLocalizationDataInput
  locale: Locale
  update: HubPageContentTileUpdateLocalizationDataInput
}

export type HubPageContentTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageContentTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageContentTileWhereUniqueInput
}

export type HubPageContentTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageContentTileUpsertInput
  /** Unique document search */
  where: HubPageContentTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageContentTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageContentTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageContentTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageContentTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<TagWhereInput>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageContentTile record uniquely */
export type HubPageContentTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHero = Entity &
  Node & {
    __typename?: 'HubPageCountdownHero'
    /** Target date and time the countdown runs to */
    countdownTarget: Scalars['DateTime']['output']
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Call to action element - if not specified, Phrase values will be used (target is festival tickets by default) */
    cta: CallToAction
    /** Localized list of desktop headline text items */
    desktopHeadline: Array<Scalars['String']['output']>
    /** Use this to hide the countdown hero without removing it */
    disabled?: Maybe<Scalars['Boolean']['output']>
    /** Get the document in other stages */
    documentInStages: Array<HubPageCountdownHero>
    /** List of HubPageCountdownHero versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Internal label to identify this countdown hero in the content list */
    internalName: Scalars['String']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<HubPageCountdownHero>
    /** Localized list of mobile headline text items */
    mobileHeadline: Array<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Countdown hero driving theCountdownHero component on Hub Pages */
export type HubPageCountdownHeroUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HubPageCountdownHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageCountdownHeroWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageCountdownHeroConnection = {
  __typename?: 'HubPageCountdownHeroConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageCountdownHeroEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageCountdownHeroCreateInput = {
  countdownTarget: Scalars['DateTime']['input']
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  cta: CallToActionCreateOneInlineInput
  /** desktopHeadline input for default locale (de) */
  desktopHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  hubPage?: InputMaybe<HubPageCreateManyInlineInput>
  internalName: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageCountdownHeroCreateLocalizationsInput>
  /** mobileHeadline input for default locale (de) */
  mobileHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageCountdownHeroCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  desktopHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  mobileHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageCountdownHeroCreateLocalizationInput = {
  /** Localization input */
  data: HubPageCountdownHeroCreateLocalizationDataInput
  locale: Locale
}

export type HubPageCountdownHeroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageCountdownHeroCreateLocalizationInput>>
}

export type HubPageCountdownHeroCreateManyInlineInput = {
  /** Connect multiple existing HubPageCountdownHero documents */
  connect?: InputMaybe<Array<HubPageCountdownHeroWhereUniqueInput>>
  /** Create and connect multiple existing HubPageCountdownHero documents */
  create?: InputMaybe<Array<HubPageCountdownHeroCreateInput>>
}

export type HubPageCountdownHeroCreateOneInlineInput = {
  /** Connect one existing HubPageCountdownHero document */
  connect?: InputMaybe<HubPageCountdownHeroWhereUniqueInput>
  /** Create and connect one HubPageCountdownHero document */
  create?: InputMaybe<HubPageCountdownHeroCreateInput>
}

/** An edge in a connection. */
export type HubPageCountdownHeroEdge = {
  __typename?: 'HubPageCountdownHeroEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageCountdownHero
}

/** Identifies documents */
export type HubPageCountdownHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageCountdownHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageCountdownHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageCountdownHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  countdownTarget?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  countdownTarget_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  countdownTarget_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  countdownTarget_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  countdownTarget_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  countdownTarget_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  countdownTarget_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  countdownTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  cta?: InputMaybe<CallToActionWhereInput>
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  disabled_not?: InputMaybe<Scalars['Boolean']['input']>
  documentInStages_every?: InputMaybe<HubPageCountdownHeroWhereStageInput>
  documentInStages_none?: InputMaybe<HubPageCountdownHeroWhereStageInput>
  documentInStages_some?: InputMaybe<HubPageCountdownHeroWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  internalName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  internalName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  internalName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  internalName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  internalName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  internalName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  internalName_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum HubPageCountdownHeroOrderByInput {
  CountdownTargetAsc = 'countdownTarget_ASC',
  CountdownTargetDesc = 'countdownTarget_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DesktopHeadlineAsc = 'desktopHeadline_ASC',
  DesktopHeadlineDesc = 'desktopHeadline_DESC',
  DisabledAsc = 'disabled_ASC',
  DisabledDesc = 'disabled_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  MobileHeadlineAsc = 'mobileHeadline_ASC',
  MobileHeadlineDesc = 'mobileHeadline_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageCountdownHeroUpdateInput = {
  countdownTarget?: InputMaybe<Scalars['DateTime']['input']>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** desktopHeadline input for default locale (de) */
  desktopHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  hubPage?: InputMaybe<HubPageUpdateManyInlineInput>
  internalName?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageCountdownHeroUpdateLocalizationsInput>
  /** mobileHeadline input for default locale (de) */
  mobileHeadline?: InputMaybe<Array<Scalars['String']['input']>>
}

export type HubPageCountdownHeroUpdateLocalizationDataInput = {
  desktopHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  mobileHeadline?: InputMaybe<Array<Scalars['String']['input']>>
}

export type HubPageCountdownHeroUpdateLocalizationInput = {
  data: HubPageCountdownHeroUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageCountdownHeroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageCountdownHeroCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageCountdownHeroUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageCountdownHeroUpsertLocalizationInput>>
}

export type HubPageCountdownHeroUpdateManyInlineInput = {
  /** Connect multiple existing HubPageCountdownHero documents */
  connect?: InputMaybe<Array<HubPageCountdownHeroConnectInput>>
  /** Create and connect multiple HubPageCountdownHero documents */
  create?: InputMaybe<Array<HubPageCountdownHeroCreateInput>>
  /** Delete multiple HubPageCountdownHero documents */
  delete?: InputMaybe<Array<HubPageCountdownHeroWhereUniqueInput>>
  /** Disconnect multiple HubPageCountdownHero documents */
  disconnect?: InputMaybe<Array<HubPageCountdownHeroWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HubPageCountdownHero documents */
  set?: InputMaybe<Array<HubPageCountdownHeroWhereUniqueInput>>
  /** Update multiple HubPageCountdownHero documents */
  update?: InputMaybe<Array<HubPageCountdownHeroUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HubPageCountdownHero documents */
  upsert?: InputMaybe<Array<HubPageCountdownHeroUpsertWithNestedWhereUniqueInput>>
}

export type HubPageCountdownHeroUpdateManyInput = {
  countdownTarget?: InputMaybe<Scalars['DateTime']['input']>
  /** desktopHeadline input for default locale (de) */
  desktopHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  internalName?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageCountdownHeroUpdateManyLocalizationsInput>
  /** mobileHeadline input for default locale (de) */
  mobileHeadline?: InputMaybe<Array<Scalars['String']['input']>>
}

export type HubPageCountdownHeroUpdateManyLocalizationDataInput = {
  desktopHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  mobileHeadline?: InputMaybe<Array<Scalars['String']['input']>>
}

export type HubPageCountdownHeroUpdateManyLocalizationInput = {
  data: HubPageCountdownHeroUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageCountdownHeroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageCountdownHeroUpdateManyLocalizationInput>>
}

export type HubPageCountdownHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageCountdownHeroUpdateManyInput
  /** Document search */
  where: HubPageCountdownHeroWhereInput
}

export type HubPageCountdownHeroUpdateOneInlineInput = {
  /** Connect existing HubPageCountdownHero document */
  connect?: InputMaybe<HubPageCountdownHeroWhereUniqueInput>
  /** Create and connect one HubPageCountdownHero document */
  create?: InputMaybe<HubPageCountdownHeroCreateInput>
  /** Delete currently connected HubPageCountdownHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HubPageCountdownHero document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageCountdownHero document */
  update?: InputMaybe<HubPageCountdownHeroUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageCountdownHero document */
  upsert?: InputMaybe<HubPageCountdownHeroUpsertWithNestedWhereUniqueInput>
}

export type HubPageCountdownHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageCountdownHeroUpdateInput
  /** Unique document search */
  where: HubPageCountdownHeroWhereUniqueInput
}

export type HubPageCountdownHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageCountdownHeroCreateInput
  /** Update document if it exists */
  update: HubPageCountdownHeroUpdateInput
}

export type HubPageCountdownHeroUpsertLocalizationInput = {
  create: HubPageCountdownHeroCreateLocalizationDataInput
  locale: Locale
  update: HubPageCountdownHeroUpdateLocalizationDataInput
}

export type HubPageCountdownHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageCountdownHeroUpsertInput
  /** Unique document search */
  where: HubPageCountdownHeroWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type HubPageCountdownHeroWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type HubPageCountdownHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageCountdownHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageCountdownHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageCountdownHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  countdownTarget?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  countdownTarget_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  countdownTarget_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  countdownTarget_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  countdownTarget_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  countdownTarget_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  countdownTarget_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  countdownTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  cta?: InputMaybe<CallToActionWhereInput>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  desktopHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  desktopHeadline_contains_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  desktopHeadline_contains_none?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  desktopHeadline_contains_some?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  desktopHeadline_not?: InputMaybe<Array<Scalars['String']['input']>>
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  disabled_not?: InputMaybe<Scalars['Boolean']['input']>
  documentInStages_every?: InputMaybe<HubPageCountdownHeroWhereStageInput>
  documentInStages_none?: InputMaybe<HubPageCountdownHeroWhereStageInput>
  documentInStages_some?: InputMaybe<HubPageCountdownHeroWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  internalName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  internalName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  internalName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  internalName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  internalName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  internalName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  internalName_starts_with?: InputMaybe<Scalars['String']['input']>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  mobileHeadline?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  mobileHeadline_contains_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  mobileHeadline_contains_none?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  mobileHeadline_contains_some?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  mobileHeadline_not?: InputMaybe<Array<Scalars['String']['input']>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HubPageCountdownHeroWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageCountdownHeroWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageCountdownHeroWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageCountdownHeroWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HubPageCountdownHeroWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References HubPageCountdownHero record uniquely */
export type HubPageCountdownHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type HubPageCreateInput = {
  countdownHero?: InputMaybe<HubPageCountdownHeroCreateOneInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  heroSlider?: InputMaybe<HubPageHeroSliderItemCreateManyInlineInput>
  identifier: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageCreateLocalizationsInput>
  sections?: InputMaybe<HubPagesectionsUnionCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageCreateLocalizationInput = {
  /** Localization input */
  data: HubPageCreateLocalizationDataInput
  locale: Locale
}

export type HubPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageCreateLocalizationInput>>
}

export type HubPageCreateManyInlineInput = {
  /** Connect multiple existing HubPage documents */
  connect?: InputMaybe<Array<HubPageWhereUniqueInput>>
  /** Create and connect multiple existing HubPage documents */
  create?: InputMaybe<Array<HubPageCreateInput>>
}

export type HubPageCreateOneInlineInput = {
  /** Connect one existing HubPage document */
  connect?: InputMaybe<HubPageWhereUniqueInput>
  /** Create and connect one HubPage document */
  create?: InputMaybe<HubPageCreateInput>
}

/** An edge in a connection. */
export type HubPageEdge = {
  __typename?: 'HubPageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPage
}

/** Hero Slider Item for Hub Pages */
export type HubPageHeroSliderItem = Entity & {
  __typename?: 'HubPageHeroSliderItem'
  ctaPrimary?: Maybe<CallToAction>
  ctaSecondary?: Maybe<CallToAction>
  /** Headline for Hub Page Hero Slider Item */
  headline: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Image for Hub Page Hero Slider Item; dimension 3:2, align image details on the right */
  image: Asset
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageHeroSliderItem>
  /** Portrait Image, used on mobile */
  portraitImage?: Maybe<Asset>
  /** Use this to show/hide Hub Page Hero Slider Item */
  published: Scalars['Boolean']['output']
  /** System stage field */
  stage: Stage
  /** Subtitle for Hub Page Hero Slider Item */
  subtitle: Scalars['String']['output']
  /** Theme for Hub Page Hero Slider Item */
  theme: OmrThemeVariant
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Hero Slider Item for Hub Pages */
export type HubPageHeroSliderItemCtaPrimaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero Slider Item for Hub Pages */
export type HubPageHeroSliderItemCtaSecondaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero Slider Item for Hub Pages */
export type HubPageHeroSliderItemImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Hero Slider Item for Hub Pages */
export type HubPageHeroSliderItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Hero Slider Item for Hub Pages */
export type HubPageHeroSliderItemPortraitImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Hero Slider Item for Hub Pages */
export type HubPageHeroSliderItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageHeroSliderItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageHeroSliderItemWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageHeroSliderItemConnection = {
  __typename?: 'HubPageHeroSliderItemConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageHeroSliderItemEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageHeroSliderItemCreateInput = {
  ctaPrimary?: InputMaybe<CallToActionCreateOneInlineInput>
  ctaSecondary?: InputMaybe<CallToActionCreateOneInlineInput>
  /** headline input for default locale (de) */
  headline: Scalars['String']['input']
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageHeroSliderItemCreateLocalizationsInput>
  portraitImage?: InputMaybe<AssetCreateOneInlineInput>
  published: Scalars['Boolean']['input']
  /** subtitle input for default locale (de) */
  subtitle: Scalars['String']['input']
  theme: OmrThemeVariant
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageHeroSliderItemCreateLocalizationDataInput = {
  headline: Scalars['String']['input']
  subtitle: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageHeroSliderItemCreateLocalizationInput = {
  /** Localization input */
  data: HubPageHeroSliderItemCreateLocalizationDataInput
  locale: Locale
}

export type HubPageHeroSliderItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageHeroSliderItemCreateLocalizationInput>>
}

export type HubPageHeroSliderItemCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageHeroSliderItem documents */
  create?: InputMaybe<Array<HubPageHeroSliderItemCreateInput>>
}

export type HubPageHeroSliderItemCreateOneInlineInput = {
  /** Create and connect one HubPageHeroSliderItem document */
  create?: InputMaybe<HubPageHeroSliderItemCreateInput>
}

export type HubPageHeroSliderItemCreateWithPositionInput = {
  /** Document to create */
  data: HubPageHeroSliderItemCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageHeroSliderItemEdge = {
  __typename?: 'HubPageHeroSliderItemEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageHeroSliderItem
}

/** Identifies documents */
export type HubPageHeroSliderItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageHeroSliderItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageHeroSliderItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageHeroSliderItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ctaPrimary?: InputMaybe<CallToActionWhereInput>
  ctaSecondary?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  portraitImage?: InputMaybe<AssetWhereInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Boolean']['input']>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageHeroSliderItemOrderByInput {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageHeroSliderItemParent = HubPage

export type HubPageHeroSliderItemParentConnectInput = {
  HubPage?: InputMaybe<HubPageConnectInput>
}

export type HubPageHeroSliderItemParentCreateInput = {
  HubPage?: InputMaybe<HubPageCreateInput>
}

export type HubPageHeroSliderItemParentCreateManyInlineInput = {
  /** Connect multiple existing HubPageHeroSliderItemParent documents */
  connect?: InputMaybe<Array<HubPageHeroSliderItemParentWhereUniqueInput>>
  /** Create and connect multiple existing HubPageHeroSliderItemParent documents */
  create?: InputMaybe<Array<HubPageHeroSliderItemParentCreateInput>>
}

export type HubPageHeroSliderItemParentCreateOneInlineInput = {
  /** Connect one existing HubPageHeroSliderItemParent document */
  connect?: InputMaybe<HubPageHeroSliderItemParentWhereUniqueInput>
  /** Create and connect one HubPageHeroSliderItemParent document */
  create?: InputMaybe<HubPageHeroSliderItemParentCreateInput>
}

export type HubPageHeroSliderItemParentUpdateInput = {
  HubPage?: InputMaybe<HubPageUpdateInput>
}

export type HubPageHeroSliderItemParentUpdateManyInlineInput = {
  /** Connect multiple existing HubPageHeroSliderItemParent documents */
  connect?: InputMaybe<Array<HubPageHeroSliderItemParentConnectInput>>
  /** Create and connect multiple HubPageHeroSliderItemParent documents */
  create?: InputMaybe<Array<HubPageHeroSliderItemParentCreateInput>>
  /** Delete multiple HubPageHeroSliderItemParent documents */
  delete?: InputMaybe<Array<HubPageHeroSliderItemParentWhereUniqueInput>>
  /** Disconnect multiple HubPageHeroSliderItemParent documents */
  disconnect?: InputMaybe<Array<HubPageHeroSliderItemParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HubPageHeroSliderItemParent documents */
  set?: InputMaybe<Array<HubPageHeroSliderItemParentWhereUniqueInput>>
  /** Update multiple HubPageHeroSliderItemParent documents */
  update?: InputMaybe<Array<HubPageHeroSliderItemParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HubPageHeroSliderItemParent documents */
  upsert?: InputMaybe<Array<HubPageHeroSliderItemParentUpsertWithNestedWhereUniqueInput>>
}

export type HubPageHeroSliderItemParentUpdateManyWithNestedWhereInput = {
  HubPage?: InputMaybe<HubPageUpdateManyWithNestedWhereInput>
}

export type HubPageHeroSliderItemParentUpdateOneInlineInput = {
  /** Connect existing HubPageHeroSliderItemParent document */
  connect?: InputMaybe<HubPageHeroSliderItemParentWhereUniqueInput>
  /** Create and connect one HubPageHeroSliderItemParent document */
  create?: InputMaybe<HubPageHeroSliderItemParentCreateInput>
  /** Delete currently connected HubPageHeroSliderItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HubPageHeroSliderItemParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageHeroSliderItemParent document */
  update?: InputMaybe<HubPageHeroSliderItemParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageHeroSliderItemParent document */
  upsert?: InputMaybe<HubPageHeroSliderItemParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageHeroSliderItemParentUpdateWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpdateWithNestedWhereUniqueInput>
}

export type HubPageHeroSliderItemParentUpsertWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpsertWithNestedWhereUniqueInput>
}

export type HubPageHeroSliderItemParentWhereInput = {
  HubPage?: InputMaybe<HubPageWhereInput>
}

export type HubPageHeroSliderItemParentWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageWhereUniqueInput>
}

export type HubPageHeroSliderItemUpdateInput = {
  ctaPrimary?: InputMaybe<CallToActionUpdateOneInlineInput>
  ctaSecondary?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageHeroSliderItemUpdateLocalizationsInput>
  portraitImage?: InputMaybe<AssetUpdateOneInlineInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  theme?: InputMaybe<OmrThemeVariant>
}

export type HubPageHeroSliderItemUpdateLocalizationDataInput = {
  headline?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HubPageHeroSliderItemUpdateLocalizationInput = {
  data: HubPageHeroSliderItemUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageHeroSliderItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageHeroSliderItemCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageHeroSliderItemUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageHeroSliderItemUpsertLocalizationInput>>
}

export type HubPageHeroSliderItemUpdateManyInlineInput = {
  /** Create and connect multiple HubPageHeroSliderItem component instances */
  create?: InputMaybe<Array<HubPageHeroSliderItemCreateWithPositionInput>>
  /** Delete multiple HubPageHeroSliderItem documents */
  delete?: InputMaybe<Array<HubPageHeroSliderItemWhereUniqueInput>>
  /** Update multiple HubPageHeroSliderItem component instances */
  update?: InputMaybe<Array<HubPageHeroSliderItemUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageHeroSliderItem component instances */
  upsert?: InputMaybe<Array<HubPageHeroSliderItemUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageHeroSliderItemUpdateManyInput = {
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageHeroSliderItemUpdateManyLocalizationsInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  theme?: InputMaybe<OmrThemeVariant>
}

export type HubPageHeroSliderItemUpdateManyLocalizationDataInput = {
  headline?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type HubPageHeroSliderItemUpdateManyLocalizationInput = {
  data: HubPageHeroSliderItemUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageHeroSliderItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageHeroSliderItemUpdateManyLocalizationInput>>
}

export type HubPageHeroSliderItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageHeroSliderItemUpdateManyInput
  /** Document search */
  where: HubPageHeroSliderItemWhereInput
}

export type HubPageHeroSliderItemUpdateOneInlineInput = {
  /** Create and connect one HubPageHeroSliderItem document */
  create?: InputMaybe<HubPageHeroSliderItemCreateInput>
  /** Delete currently connected HubPageHeroSliderItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageHeroSliderItem document */
  update?: InputMaybe<HubPageHeroSliderItemUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageHeroSliderItem document */
  upsert?: InputMaybe<HubPageHeroSliderItemUpsertWithNestedWhereUniqueInput>
}

export type HubPageHeroSliderItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageHeroSliderItemUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageHeroSliderItemWhereUniqueInput
}

export type HubPageHeroSliderItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageHeroSliderItemUpdateInput
  /** Unique document search */
  where: HubPageHeroSliderItemWhereUniqueInput
}

export type HubPageHeroSliderItemUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageHeroSliderItemCreateInput
  /** Update document if it exists */
  update: HubPageHeroSliderItemUpdateInput
}

export type HubPageHeroSliderItemUpsertLocalizationInput = {
  create: HubPageHeroSliderItemCreateLocalizationDataInput
  locale: Locale
  update: HubPageHeroSliderItemUpdateLocalizationDataInput
}

export type HubPageHeroSliderItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageHeroSliderItemUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageHeroSliderItemWhereUniqueInput
}

export type HubPageHeroSliderItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageHeroSliderItemUpsertInput
  /** Unique document search */
  where: HubPageHeroSliderItemWhereUniqueInput
}

/** Identifies documents */
export type HubPageHeroSliderItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageHeroSliderItemWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageHeroSliderItemWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageHeroSliderItemWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ctaPrimary?: InputMaybe<CallToActionWhereInput>
  ctaSecondary?: InputMaybe<CallToActionWhereInput>
  headline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  portraitImage?: InputMaybe<AssetWhereInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Boolean']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageHeroSliderItem record uniquely */
export type HubPageHeroSliderItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Image Tile for Hub Page Sections */
export type HubPageImageTile = Entity & {
  __typename?: 'HubPageImageTile'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Use transparent png for best results */
  image: Asset
  /** Object fit of the image */
  objectFit: ObjectFit
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Image Tile */
  tileSizes: HubPageTileSizes
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Image Tile for Hub Page Sections */
export type HubPageImageTileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Image Tile for Hub Page Sections */
export type HubPageImageTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HubPageImageTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageImageTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageImageTileConnection = {
  __typename?: 'HubPageImageTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageImageTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageImageTileCreateInput = {
  image: AssetCreateOneInlineInput
  objectFit: ObjectFit
  tileSizes: HubPageTileSizesCreateOneInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageImageTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageImageTile documents */
  create?: InputMaybe<Array<HubPageImageTileCreateInput>>
}

export type HubPageImageTileCreateOneInlineInput = {
  /** Create and connect one HubPageImageTile document */
  create?: InputMaybe<HubPageImageTileCreateInput>
}

export type HubPageImageTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageImageTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageImageTileEdge = {
  __typename?: 'HubPageImageTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageImageTile
}

/** Identifies documents */
export type HubPageImageTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageImageTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageImageTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageImageTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  objectFit?: InputMaybe<ObjectFit>
  /** All values that are contained in given list. */
  objectFit_in?: InputMaybe<Array<InputMaybe<ObjectFit>>>
  /** Any other value that exists and is not equal to the given value. */
  objectFit_not?: InputMaybe<ObjectFit>
  /** All values that are not contained in given list. */
  objectFit_not_in?: InputMaybe<Array<InputMaybe<ObjectFit>>>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageImageTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ObjectFitAsc = 'objectFit_ASC',
  ObjectFitDesc = 'objectFit_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageImageTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageImageTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageImageTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageImageTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageImageTileParent documents */
  create?: InputMaybe<Array<HubPageImageTileParentCreateInput>>
}

export type HubPageImageTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageImageTileParent document */
  create?: InputMaybe<HubPageImageTileParentCreateInput>
}

export type HubPageImageTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageImageTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageImageTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageImageTileParent component instances */
  create?: InputMaybe<Array<HubPageImageTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageImageTileParent documents */
  delete?: InputMaybe<Array<HubPageImageTileParentWhereUniqueInput>>
  /** Update multiple HubPageImageTileParent component instances */
  update?: InputMaybe<Array<HubPageImageTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageImageTileParent component instances */
  upsert?: InputMaybe<Array<HubPageImageTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageImageTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageImageTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageImageTileParent document */
  create?: InputMaybe<HubPageImageTileParentCreateInput>
  /** Delete currently connected HubPageImageTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageImageTileParent document */
  update?: InputMaybe<HubPageImageTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageImageTileParent document */
  upsert?: InputMaybe<HubPageImageTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageImageTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageImageTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageImageTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageImageTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageImageTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageImageTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageImageTileUpdateInput = {
  image?: InputMaybe<AssetUpdateOneInlineInput>
  objectFit?: InputMaybe<ObjectFit>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
}

export type HubPageImageTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageImageTile component instances */
  create?: InputMaybe<Array<HubPageImageTileCreateWithPositionInput>>
  /** Delete multiple HubPageImageTile documents */
  delete?: InputMaybe<Array<HubPageImageTileWhereUniqueInput>>
  /** Update multiple HubPageImageTile component instances */
  update?: InputMaybe<Array<HubPageImageTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageImageTile component instances */
  upsert?: InputMaybe<Array<HubPageImageTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageImageTileUpdateManyInput = {
  objectFit?: InputMaybe<ObjectFit>
}

export type HubPageImageTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageImageTileUpdateManyInput
  /** Document search */
  where: HubPageImageTileWhereInput
}

export type HubPageImageTileUpdateOneInlineInput = {
  /** Create and connect one HubPageImageTile document */
  create?: InputMaybe<HubPageImageTileCreateInput>
  /** Delete currently connected HubPageImageTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageImageTile document */
  update?: InputMaybe<HubPageImageTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageImageTile document */
  upsert?: InputMaybe<HubPageImageTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageImageTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageImageTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageImageTileWhereUniqueInput
}

export type HubPageImageTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageImageTileUpdateInput
  /** Unique document search */
  where: HubPageImageTileWhereUniqueInput
}

export type HubPageImageTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageImageTileCreateInput
  /** Update document if it exists */
  update: HubPageImageTileUpdateInput
}

export type HubPageImageTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageImageTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageImageTileWhereUniqueInput
}

export type HubPageImageTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageImageTileUpsertInput
  /** Unique document search */
  where: HubPageImageTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageImageTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageImageTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageImageTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageImageTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  objectFit?: InputMaybe<ObjectFit>
  /** All values that are contained in given list. */
  objectFit_in?: InputMaybe<Array<InputMaybe<ObjectFit>>>
  /** Any other value that exists and is not equal to the given value. */
  objectFit_not?: InputMaybe<ObjectFit>
  /** All values that are not contained in given list. */
  objectFit_not_in?: InputMaybe<Array<InputMaybe<ObjectFit>>>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageImageTile record uniquely */
export type HubPageImageTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Info Tile for Hub Page Sections */
export type HubPageInfoTile = Entity & {
  __typename?: 'HubPageInfoTile'
  /** Info Tile content */
  body: Scalars['String']['output']
  /** Decoration of the info tile */
  decoration: HubPageInfoTileDecoration
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageInfoTile>
  primaryCta: CallToAction
  secondaryCta?: Maybe<CallToAction>
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Info Tile */
  tileSizes: HubPageTileSizes
  /** Info Tile title */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Info Tile for Hub Page Sections */
export type HubPageInfoTileLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Info Tile for Hub Page Sections */
export type HubPageInfoTilePrimaryCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Info Tile for Hub Page Sections */
export type HubPageInfoTileSecondaryCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Info Tile for Hub Page Sections */
export type HubPageInfoTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Info Tile for Hub Page Sections */
export type HubPageInfoTileUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageInfoTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageInfoTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageInfoTileConnection = {
  __typename?: 'HubPageInfoTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageInfoTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageInfoTileCreateInput = {
  /** body input for default locale (de) */
  body: Scalars['String']['input']
  decoration: HubPageInfoTileDecoration
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageInfoTileCreateLocalizationsInput>
  primaryCta: CallToActionCreateOneInlineInput
  secondaryCta?: InputMaybe<CallToActionCreateOneInlineInput>
  tileSizes: HubPageTileSizesCreateOneInlineInput
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageInfoTileCreateLocalizationDataInput = {
  body: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageInfoTileCreateLocalizationInput = {
  /** Localization input */
  data: HubPageInfoTileCreateLocalizationDataInput
  locale: Locale
}

export type HubPageInfoTileCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageInfoTileCreateLocalizationInput>>
}

export type HubPageInfoTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageInfoTile documents */
  create?: InputMaybe<Array<HubPageInfoTileCreateInput>>
}

export type HubPageInfoTileCreateOneInlineInput = {
  /** Create and connect one HubPageInfoTile document */
  create?: InputMaybe<HubPageInfoTileCreateInput>
}

export type HubPageInfoTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageInfoTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** Defines the decoration of the info tile */
export enum HubPageInfoTileDecoration {
  BlueCircle = 'blueCircle',
  PurpleDots = 'purpleDots',
}

/** An edge in a connection. */
export type HubPageInfoTileEdge = {
  __typename?: 'HubPageInfoTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageInfoTile
}

/** Identifies documents */
export type HubPageInfoTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageInfoTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageInfoTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageInfoTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  decoration?: InputMaybe<HubPageInfoTileDecoration>
  /** All values that are contained in given list. */
  decoration_in?: InputMaybe<Array<InputMaybe<HubPageInfoTileDecoration>>>
  /** Any other value that exists and is not equal to the given value. */
  decoration_not?: InputMaybe<HubPageInfoTileDecoration>
  /** All values that are not contained in given list. */
  decoration_not_in?: InputMaybe<Array<InputMaybe<HubPageInfoTileDecoration>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  primaryCta?: InputMaybe<CallToActionWhereInput>
  secondaryCta?: InputMaybe<CallToActionWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageInfoTileOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  DecorationAsc = 'decoration_ASC',
  DecorationDesc = 'decoration_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageInfoTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageInfoTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageInfoTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageInfoTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageInfoTileParent documents */
  create?: InputMaybe<Array<HubPageInfoTileParentCreateInput>>
}

export type HubPageInfoTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageInfoTileParent document */
  create?: InputMaybe<HubPageInfoTileParentCreateInput>
}

export type HubPageInfoTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageInfoTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageInfoTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageInfoTileParent component instances */
  create?: InputMaybe<Array<HubPageInfoTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageInfoTileParent documents */
  delete?: InputMaybe<Array<HubPageInfoTileParentWhereUniqueInput>>
  /** Update multiple HubPageInfoTileParent component instances */
  update?: InputMaybe<Array<HubPageInfoTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageInfoTileParent component instances */
  upsert?: InputMaybe<Array<HubPageInfoTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageInfoTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageInfoTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageInfoTileParent document */
  create?: InputMaybe<HubPageInfoTileParentCreateInput>
  /** Delete currently connected HubPageInfoTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageInfoTileParent document */
  update?: InputMaybe<HubPageInfoTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageInfoTileParent document */
  upsert?: InputMaybe<HubPageInfoTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageInfoTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageInfoTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageInfoTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageInfoTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageInfoTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageInfoTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageInfoTileUpdateInput = {
  /** body input for default locale (de) */
  body?: InputMaybe<Scalars['String']['input']>
  decoration?: InputMaybe<HubPageInfoTileDecoration>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageInfoTileUpdateLocalizationsInput>
  primaryCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  secondaryCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageInfoTileUpdateLocalizationDataInput = {
  body?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageInfoTileUpdateLocalizationInput = {
  data: HubPageInfoTileUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageInfoTileUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageInfoTileCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageInfoTileUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageInfoTileUpsertLocalizationInput>>
}

export type HubPageInfoTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageInfoTile component instances */
  create?: InputMaybe<Array<HubPageInfoTileCreateWithPositionInput>>
  /** Delete multiple HubPageInfoTile documents */
  delete?: InputMaybe<Array<HubPageInfoTileWhereUniqueInput>>
  /** Update multiple HubPageInfoTile component instances */
  update?: InputMaybe<Array<HubPageInfoTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageInfoTile component instances */
  upsert?: InputMaybe<Array<HubPageInfoTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageInfoTileUpdateManyInput = {
  /** body input for default locale (de) */
  body?: InputMaybe<Scalars['String']['input']>
  decoration?: InputMaybe<HubPageInfoTileDecoration>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageInfoTileUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageInfoTileUpdateManyLocalizationDataInput = {
  body?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageInfoTileUpdateManyLocalizationInput = {
  data: HubPageInfoTileUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageInfoTileUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageInfoTileUpdateManyLocalizationInput>>
}

export type HubPageInfoTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageInfoTileUpdateManyInput
  /** Document search */
  where: HubPageInfoTileWhereInput
}

export type HubPageInfoTileUpdateOneInlineInput = {
  /** Create and connect one HubPageInfoTile document */
  create?: InputMaybe<HubPageInfoTileCreateInput>
  /** Delete currently connected HubPageInfoTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageInfoTile document */
  update?: InputMaybe<HubPageInfoTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageInfoTile document */
  upsert?: InputMaybe<HubPageInfoTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageInfoTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageInfoTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageInfoTileWhereUniqueInput
}

export type HubPageInfoTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageInfoTileUpdateInput
  /** Unique document search */
  where: HubPageInfoTileWhereUniqueInput
}

export type HubPageInfoTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageInfoTileCreateInput
  /** Update document if it exists */
  update: HubPageInfoTileUpdateInput
}

export type HubPageInfoTileUpsertLocalizationInput = {
  create: HubPageInfoTileCreateLocalizationDataInput
  locale: Locale
  update: HubPageInfoTileUpdateLocalizationDataInput
}

export type HubPageInfoTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageInfoTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageInfoTileWhereUniqueInput
}

export type HubPageInfoTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageInfoTileUpsertInput
  /** Unique document search */
  where: HubPageInfoTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageInfoTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageInfoTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageInfoTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageInfoTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  body?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>
  decoration?: InputMaybe<HubPageInfoTileDecoration>
  /** All values that are contained in given list. */
  decoration_in?: InputMaybe<Array<InputMaybe<HubPageInfoTileDecoration>>>
  /** Any other value that exists and is not equal to the given value. */
  decoration_not?: InputMaybe<HubPageInfoTileDecoration>
  /** All values that are not contained in given list. */
  decoration_not_in?: InputMaybe<Array<InputMaybe<HubPageInfoTileDecoration>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  primaryCta?: InputMaybe<CallToActionWhereInput>
  secondaryCta?: InputMaybe<CallToActionWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageInfoTile record uniquely */
export type HubPageInfoTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Latest Article Tile for Hub Page Sections */
export type HubPageLatestArticleTile = Entity & {
  __typename?: 'HubPageLatestArticleTile'
  articleType: ArticleType
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Number of latest articles to skip */
  skipArticles?: Maybe<Scalars['Int']['output']>
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Latest Article Tile */
  tileSizes: HubPageTileSizes
  /** Tracking identifier which will be used to generate data-track attribute */
  trackingId?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Latest Article Tile for Hub Page Sections */
export type HubPageLatestArticleTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HubPageLatestArticleTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageLatestArticleTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageLatestArticleTileConnection = {
  __typename?: 'HubPageLatestArticleTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageLatestArticleTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageLatestArticleTileCreateInput = {
  articleType: ArticleType
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  tileSizes: HubPageTileSizesCreateOneInlineInput
  trackingId?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageLatestArticleTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageLatestArticleTile documents */
  create?: InputMaybe<Array<HubPageLatestArticleTileCreateInput>>
}

export type HubPageLatestArticleTileCreateOneInlineInput = {
  /** Create and connect one HubPageLatestArticleTile document */
  create?: InputMaybe<HubPageLatestArticleTileCreateInput>
}

export type HubPageLatestArticleTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageLatestArticleTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageLatestArticleTileEdge = {
  __typename?: 'HubPageLatestArticleTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageLatestArticleTile
}

/** Identifies documents */
export type HubPageLatestArticleTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageLatestArticleTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageLatestArticleTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageLatestArticleTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articleType?: InputMaybe<ArticleType>
  /** All values that are contained in given list. */
  articleType_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  /** Any other value that exists and is not equal to the given value. */
  articleType_not?: InputMaybe<ArticleType>
  /** All values that are not contained in given list. */
  articleType_not_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  skipArticles_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  skipArticles_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  skipArticles_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  skipArticles_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  skipArticles_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  skipArticles_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  skipArticles_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  trackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  trackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  trackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  trackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  trackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  trackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  trackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  trackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  trackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageLatestArticleTileOrderByInput {
  ArticleTypeAsc = 'articleType_ASC',
  ArticleTypeDesc = 'articleType_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SkipArticlesAsc = 'skipArticles_ASC',
  SkipArticlesDesc = 'skipArticles_DESC',
  TrackingIdAsc = 'trackingId_ASC',
  TrackingIdDesc = 'trackingId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageLatestArticleTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageLatestArticleTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageLatestArticleTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageLatestArticleTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageLatestArticleTileParent documents */
  create?: InputMaybe<Array<HubPageLatestArticleTileParentCreateInput>>
}

export type HubPageLatestArticleTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageLatestArticleTileParent document */
  create?: InputMaybe<HubPageLatestArticleTileParentCreateInput>
}

export type HubPageLatestArticleTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageLatestArticleTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageLatestArticleTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageLatestArticleTileParent component instances */
  create?: InputMaybe<Array<HubPageLatestArticleTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageLatestArticleTileParent documents */
  delete?: InputMaybe<Array<HubPageLatestArticleTileParentWhereUniqueInput>>
  /** Update multiple HubPageLatestArticleTileParent component instances */
  update?: InputMaybe<Array<HubPageLatestArticleTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageLatestArticleTileParent component instances */
  upsert?: InputMaybe<Array<HubPageLatestArticleTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageLatestArticleTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageLatestArticleTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageLatestArticleTileParent document */
  create?: InputMaybe<HubPageLatestArticleTileParentCreateInput>
  /** Delete currently connected HubPageLatestArticleTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageLatestArticleTileParent document */
  update?: InputMaybe<HubPageLatestArticleTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageLatestArticleTileParent document */
  upsert?: InputMaybe<HubPageLatestArticleTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageLatestArticleTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageLatestArticleTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageLatestArticleTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageLatestArticleTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageLatestArticleTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageLatestArticleTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageLatestArticleTileUpdateInput = {
  articleType?: InputMaybe<ArticleType>
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
}

export type HubPageLatestArticleTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageLatestArticleTile component instances */
  create?: InputMaybe<Array<HubPageLatestArticleTileCreateWithPositionInput>>
  /** Delete multiple HubPageLatestArticleTile documents */
  delete?: InputMaybe<Array<HubPageLatestArticleTileWhereUniqueInput>>
  /** Update multiple HubPageLatestArticleTile component instances */
  update?: InputMaybe<Array<HubPageLatestArticleTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageLatestArticleTile component instances */
  upsert?: InputMaybe<Array<HubPageLatestArticleTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageLatestArticleTileUpdateManyInput = {
  articleType?: InputMaybe<ArticleType>
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
}

export type HubPageLatestArticleTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageLatestArticleTileUpdateManyInput
  /** Document search */
  where: HubPageLatestArticleTileWhereInput
}

export type HubPageLatestArticleTileUpdateOneInlineInput = {
  /** Create and connect one HubPageLatestArticleTile document */
  create?: InputMaybe<HubPageLatestArticleTileCreateInput>
  /** Delete currently connected HubPageLatestArticleTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageLatestArticleTile document */
  update?: InputMaybe<HubPageLatestArticleTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageLatestArticleTile document */
  upsert?: InputMaybe<HubPageLatestArticleTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageLatestArticleTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageLatestArticleTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageLatestArticleTileWhereUniqueInput
}

export type HubPageLatestArticleTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageLatestArticleTileUpdateInput
  /** Unique document search */
  where: HubPageLatestArticleTileWhereUniqueInput
}

export type HubPageLatestArticleTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageLatestArticleTileCreateInput
  /** Update document if it exists */
  update: HubPageLatestArticleTileUpdateInput
}

export type HubPageLatestArticleTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageLatestArticleTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageLatestArticleTileWhereUniqueInput
}

export type HubPageLatestArticleTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageLatestArticleTileUpsertInput
  /** Unique document search */
  where: HubPageLatestArticleTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageLatestArticleTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageLatestArticleTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageLatestArticleTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageLatestArticleTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articleType?: InputMaybe<ArticleType>
  /** All values that are contained in given list. */
  articleType_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  /** Any other value that exists and is not equal to the given value. */
  articleType_not?: InputMaybe<ArticleType>
  /** All values that are not contained in given list. */
  articleType_not_in?: InputMaybe<Array<InputMaybe<ArticleType>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  skipArticles?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  skipArticles_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  skipArticles_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  skipArticles_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  skipArticles_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  skipArticles_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  skipArticles_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  skipArticles_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  trackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  trackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  trackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  trackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  trackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  trackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  trackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  trackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  trackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageLatestArticleTile record uniquely */
export type HubPageLatestArticleTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Identifies documents */
export type HubPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  countdownHero?: InputMaybe<HubPageCountdownHeroWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HubPageWhereStageInput>
  documentInStages_none?: InputMaybe<HubPageWhereStageInput>
  documentInStages_some?: InputMaybe<HubPageWhereStageInput>
  heroSlider_every?: InputMaybe<HubPageHeroSliderItemWhereInput>
  heroSlider_none?: InputMaybe<HubPageHeroSliderItemWhereInput>
  heroSlider_some?: InputMaybe<HubPageHeroSliderItemWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  identifier_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  identifier_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  identifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  identifier_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  identifier_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  identifier_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  identifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  identifier_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  identifier_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  /** All values in which the union is empty. */
  sections_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  sections_some?: InputMaybe<HubPagesectionsUnionWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** Newsletter Subscription Tile for Hub Page Sections */
export type HubPageNewsletterSubscriptionTile = Entity & {
  __typename?: 'HubPageNewsletterSubscriptionTile'
  /** Audiences to target for newsletter subscription */
  audiences: Array<NewsletterAudience>
  ctaHeadline?: Maybe<Scalars['String']['output']>
  ctaLabel: Scalars['String']['output']
  description: Scalars['String']['output']
  headline: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageNewsletterSubscriptionTile>
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Newsletter Subscription Tile */
  tileSizes: HubPageTileSizes
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Newsletter Subscription Tile for Hub Page Sections */
export type HubPageNewsletterSubscriptionTileAudiencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<NewsletterAudienceOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<NewsletterAudienceWhereInput>
}

/** Newsletter Subscription Tile for Hub Page Sections */
export type HubPageNewsletterSubscriptionTileLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Newsletter Subscription Tile for Hub Page Sections */
export type HubPageNewsletterSubscriptionTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Newsletter Subscription Tile for Hub Page Sections */
export type HubPageNewsletterSubscriptionTileUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageNewsletterSubscriptionTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageNewsletterSubscriptionTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageNewsletterSubscriptionTileConnection = {
  __typename?: 'HubPageNewsletterSubscriptionTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageNewsletterSubscriptionTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageNewsletterSubscriptionTileCreateInput = {
  audiences: NewsletterAudienceCreateManyInlineInput
  /** ctaHeadline input for default locale (de) */
  ctaHeadline?: InputMaybe<Scalars['String']['input']>
  /** ctaLabel input for default locale (de) */
  ctaLabel: Scalars['String']['input']
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  /** headline input for default locale (de) */
  headline: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageNewsletterSubscriptionTileCreateLocalizationsInput>
  tileSizes: HubPageTileSizesCreateOneInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageNewsletterSubscriptionTileCreateLocalizationDataInput = {
  ctaHeadline?: InputMaybe<Scalars['String']['input']>
  ctaLabel: Scalars['String']['input']
  description: Scalars['String']['input']
  headline: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageNewsletterSubscriptionTileCreateLocalizationInput = {
  /** Localization input */
  data: HubPageNewsletterSubscriptionTileCreateLocalizationDataInput
  locale: Locale
}

export type HubPageNewsletterSubscriptionTileCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageNewsletterSubscriptionTileCreateLocalizationInput>>
}

export type HubPageNewsletterSubscriptionTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageNewsletterSubscriptionTile documents */
  create?: InputMaybe<Array<HubPageNewsletterSubscriptionTileCreateInput>>
}

export type HubPageNewsletterSubscriptionTileCreateOneInlineInput = {
  /** Create and connect one HubPageNewsletterSubscriptionTile document */
  create?: InputMaybe<HubPageNewsletterSubscriptionTileCreateInput>
}

export type HubPageNewsletterSubscriptionTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageNewsletterSubscriptionTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageNewsletterSubscriptionTileEdge = {
  __typename?: 'HubPageNewsletterSubscriptionTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageNewsletterSubscriptionTile
}

/** Identifies documents */
export type HubPageNewsletterSubscriptionTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageNewsletterSubscriptionTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageNewsletterSubscriptionTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageNewsletterSubscriptionTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audiences_every?: InputMaybe<NewsletterAudienceWhereInput>
  audiences_none?: InputMaybe<NewsletterAudienceWhereInput>
  audiences_some?: InputMaybe<NewsletterAudienceWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageNewsletterSubscriptionTileOrderByInput {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLabelAsc = 'ctaLabel_ASC',
  CtaLabelDesc = 'ctaLabel_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageNewsletterSubscriptionTileParent = EventAppCard | HubPageSectionGeneral | SectionTiles

export type HubPageNewsletterSubscriptionTileParentConnectInput = {
  EventAppCard?: InputMaybe<EventAppCardConnectInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageNewsletterSubscriptionTileParentCreateInput = {
  EventAppCard?: InputMaybe<EventAppCardCreateInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageNewsletterSubscriptionTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageNewsletterSubscriptionTileParent documents */
  create?: InputMaybe<Array<HubPageNewsletterSubscriptionTileParentCreateInput>>
}

export type HubPageNewsletterSubscriptionTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageNewsletterSubscriptionTileParent document */
  create?: InputMaybe<HubPageNewsletterSubscriptionTileParentCreateInput>
}

export type HubPageNewsletterSubscriptionTileParentCreateWithPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardCreateWithPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageNewsletterSubscriptionTileParentUpdateInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageNewsletterSubscriptionTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageNewsletterSubscriptionTileParent component instances */
  create?: InputMaybe<Array<HubPageNewsletterSubscriptionTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageNewsletterSubscriptionTileParent documents */
  delete?: InputMaybe<Array<HubPageNewsletterSubscriptionTileParentWhereUniqueInput>>
  /** Update multiple HubPageNewsletterSubscriptionTileParent component instances */
  update?: InputMaybe<Array<HubPageNewsletterSubscriptionTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageNewsletterSubscriptionTileParent component instances */
  upsert?: InputMaybe<Array<HubPageNewsletterSubscriptionTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageNewsletterSubscriptionTileParentUpdateManyWithNestedWhereInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateManyWithNestedWhereInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageNewsletterSubscriptionTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageNewsletterSubscriptionTileParent document */
  create?: InputMaybe<HubPageNewsletterSubscriptionTileParentCreateInput>
  /** Delete currently connected HubPageNewsletterSubscriptionTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageNewsletterSubscriptionTileParent document */
  update?: InputMaybe<HubPageNewsletterSubscriptionTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageNewsletterSubscriptionTileParent document */
  upsert?: InputMaybe<HubPageNewsletterSubscriptionTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageNewsletterSubscriptionTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageNewsletterSubscriptionTileParentUpdateWithNestedWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardUpdateWithNestedWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageNewsletterSubscriptionTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  EventAppCard?: InputMaybe<EventAppCardUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageNewsletterSubscriptionTileParentUpsertWithNestedWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardUpsertWithNestedWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageNewsletterSubscriptionTileParentWhereInput = {
  EventAppCard?: InputMaybe<EventAppCardWhereInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageNewsletterSubscriptionTileParentWhereUniqueInput = {
  EventAppCard?: InputMaybe<EventAppCardWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageNewsletterSubscriptionTileUpdateInput = {
  audiences?: InputMaybe<NewsletterAudienceUpdateManyInlineInput>
  /** ctaHeadline input for default locale (de) */
  ctaHeadline?: InputMaybe<Scalars['String']['input']>
  /** ctaLabel input for default locale (de) */
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateLocalizationsInput>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
}

export type HubPageNewsletterSubscriptionTileUpdateLocalizationDataInput = {
  ctaHeadline?: InputMaybe<Scalars['String']['input']>
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  headline?: InputMaybe<Scalars['String']['input']>
}

export type HubPageNewsletterSubscriptionTileUpdateLocalizationInput = {
  data: HubPageNewsletterSubscriptionTileUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageNewsletterSubscriptionTileUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageNewsletterSubscriptionTileCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageNewsletterSubscriptionTileUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageNewsletterSubscriptionTileUpsertLocalizationInput>>
}

export type HubPageNewsletterSubscriptionTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageNewsletterSubscriptionTile component instances */
  create?: InputMaybe<Array<HubPageNewsletterSubscriptionTileCreateWithPositionInput>>
  /** Delete multiple HubPageNewsletterSubscriptionTile documents */
  delete?: InputMaybe<Array<HubPageNewsletterSubscriptionTileWhereUniqueInput>>
  /** Update multiple HubPageNewsletterSubscriptionTile component instances */
  update?: InputMaybe<Array<HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageNewsletterSubscriptionTile component instances */
  upsert?: InputMaybe<Array<HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageNewsletterSubscriptionTileUpdateManyInput = {
  /** ctaHeadline input for default locale (de) */
  ctaHeadline?: InputMaybe<Scalars['String']['input']>
  /** ctaLabel input for default locale (de) */
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateManyLocalizationsInput>
}

export type HubPageNewsletterSubscriptionTileUpdateManyLocalizationDataInput = {
  ctaHeadline?: InputMaybe<Scalars['String']['input']>
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  headline?: InputMaybe<Scalars['String']['input']>
}

export type HubPageNewsletterSubscriptionTileUpdateManyLocalizationInput = {
  data: HubPageNewsletterSubscriptionTileUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageNewsletterSubscriptionTileUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageNewsletterSubscriptionTileUpdateManyLocalizationInput>>
}

export type HubPageNewsletterSubscriptionTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageNewsletterSubscriptionTileUpdateManyInput
  /** Document search */
  where: HubPageNewsletterSubscriptionTileWhereInput
}

export type HubPageNewsletterSubscriptionTileUpdateOneInlineInput = {
  /** Create and connect one HubPageNewsletterSubscriptionTile document */
  create?: InputMaybe<HubPageNewsletterSubscriptionTileCreateInput>
  /** Delete currently connected HubPageNewsletterSubscriptionTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageNewsletterSubscriptionTile document */
  update?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageNewsletterSubscriptionTile document */
  upsert?: InputMaybe<HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageNewsletterSubscriptionTileWhereUniqueInput
}

export type HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageNewsletterSubscriptionTileUpdateInput
  /** Unique document search */
  where: HubPageNewsletterSubscriptionTileWhereUniqueInput
}

export type HubPageNewsletterSubscriptionTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageNewsletterSubscriptionTileCreateInput
  /** Update document if it exists */
  update: HubPageNewsletterSubscriptionTileUpdateInput
}

export type HubPageNewsletterSubscriptionTileUpsertLocalizationInput = {
  create: HubPageNewsletterSubscriptionTileCreateLocalizationDataInput
  locale: Locale
  update: HubPageNewsletterSubscriptionTileUpdateLocalizationDataInput
}

export type HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageNewsletterSubscriptionTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageNewsletterSubscriptionTileWhereUniqueInput
}

export type HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageNewsletterSubscriptionTileUpsertInput
  /** Unique document search */
  where: HubPageNewsletterSubscriptionTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageNewsletterSubscriptionTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageNewsletterSubscriptionTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageNewsletterSubscriptionTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageNewsletterSubscriptionTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audiences_every?: InputMaybe<NewsletterAudienceWhereInput>
  audiences_none?: InputMaybe<NewsletterAudienceWhereInput>
  audiences_some?: InputMaybe<NewsletterAudienceWhereInput>
  ctaHeadline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaHeadline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaHeadline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaHeadline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaHeadline_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  headline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageNewsletterSubscriptionTile record uniquely */
export type HubPageNewsletterSubscriptionTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum HubPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Partner Company Tile for Hub Page Sections */
export type HubPagePartnerCompanyTile = Entity & {
  __typename?: 'HubPagePartnerCompanyTile'
  /** Call to action for Hub Page Partner Company Tile */
  cta: CallToAction
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPagePartnerCompanyTile>
  /** Link to list of partner companies shown in this tile */
  partnerCompanies: ExhibitorListOrder
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Partner Company Tile */
  tileSizes: HubPageTileSizes
  /** Partner company tile title */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Partner Company Tile for Hub Page Sections */
export type HubPagePartnerCompanyTileCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Partner Company Tile for Hub Page Sections */
export type HubPagePartnerCompanyTileLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Partner Company Tile for Hub Page Sections */
export type HubPagePartnerCompanyTilePartnerCompaniesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Partner Company Tile for Hub Page Sections */
export type HubPagePartnerCompanyTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Partner Company Tile for Hub Page Sections */
export type HubPagePartnerCompanyTileUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPagePartnerCompanyTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPagePartnerCompanyTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPagePartnerCompanyTileConnection = {
  __typename?: 'HubPagePartnerCompanyTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPagePartnerCompanyTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPagePartnerCompanyTileCreateInput = {
  cta: CallToActionCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPagePartnerCompanyTileCreateLocalizationsInput>
  partnerCompanies: ExhibitorListOrderCreateOneInlineInput
  tileSizes: HubPageTileSizesCreateOneInlineInput
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPagePartnerCompanyTileCreateLocalizationDataInput = {
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPagePartnerCompanyTileCreateLocalizationInput = {
  /** Localization input */
  data: HubPagePartnerCompanyTileCreateLocalizationDataInput
  locale: Locale
}

export type HubPagePartnerCompanyTileCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPagePartnerCompanyTileCreateLocalizationInput>>
}

export type HubPagePartnerCompanyTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPagePartnerCompanyTile documents */
  create?: InputMaybe<Array<HubPagePartnerCompanyTileCreateInput>>
}

export type HubPagePartnerCompanyTileCreateOneInlineInput = {
  /** Create and connect one HubPagePartnerCompanyTile document */
  create?: InputMaybe<HubPagePartnerCompanyTileCreateInput>
}

export type HubPagePartnerCompanyTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPagePartnerCompanyTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPagePartnerCompanyTileEdge = {
  __typename?: 'HubPagePartnerCompanyTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPagePartnerCompanyTile
}

/** Identifies documents */
export type HubPagePartnerCompanyTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPagePartnerCompanyTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPagePartnerCompanyTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPagePartnerCompanyTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  partnerCompanies?: InputMaybe<ExhibitorListOrderWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPagePartnerCompanyTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPagePartnerCompanyTileParent = HubPageSectionGeneral | SectionTiles

export type HubPagePartnerCompanyTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPagePartnerCompanyTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPagePartnerCompanyTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPagePartnerCompanyTileParent documents */
  create?: InputMaybe<Array<HubPagePartnerCompanyTileParentCreateInput>>
}

export type HubPagePartnerCompanyTileParentCreateOneInlineInput = {
  /** Create and connect one HubPagePartnerCompanyTileParent document */
  create?: InputMaybe<HubPagePartnerCompanyTileParentCreateInput>
}

export type HubPagePartnerCompanyTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPagePartnerCompanyTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPagePartnerCompanyTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPagePartnerCompanyTileParent component instances */
  create?: InputMaybe<Array<HubPagePartnerCompanyTileParentCreateWithPositionInput>>
  /** Delete multiple HubPagePartnerCompanyTileParent documents */
  delete?: InputMaybe<Array<HubPagePartnerCompanyTileParentWhereUniqueInput>>
  /** Update multiple HubPagePartnerCompanyTileParent component instances */
  update?: InputMaybe<Array<HubPagePartnerCompanyTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPagePartnerCompanyTileParent component instances */
  upsert?: InputMaybe<Array<HubPagePartnerCompanyTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPagePartnerCompanyTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPagePartnerCompanyTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPagePartnerCompanyTileParent document */
  create?: InputMaybe<HubPagePartnerCompanyTileParentCreateInput>
  /** Delete currently connected HubPagePartnerCompanyTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPagePartnerCompanyTileParent document */
  update?: InputMaybe<HubPagePartnerCompanyTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPagePartnerCompanyTileParent document */
  upsert?: InputMaybe<HubPagePartnerCompanyTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPagePartnerCompanyTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPagePartnerCompanyTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPagePartnerCompanyTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPagePartnerCompanyTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPagePartnerCompanyTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPagePartnerCompanyTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPagePartnerCompanyTileUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPagePartnerCompanyTileUpdateLocalizationsInput>
  partnerCompanies?: InputMaybe<ExhibitorListOrderUpdateOneInlineInput>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPagePartnerCompanyTileUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPagePartnerCompanyTileUpdateLocalizationInput = {
  data: HubPagePartnerCompanyTileUpdateLocalizationDataInput
  locale: Locale
}

export type HubPagePartnerCompanyTileUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPagePartnerCompanyTileCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPagePartnerCompanyTileUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPagePartnerCompanyTileUpsertLocalizationInput>>
}

export type HubPagePartnerCompanyTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPagePartnerCompanyTile component instances */
  create?: InputMaybe<Array<HubPagePartnerCompanyTileCreateWithPositionInput>>
  /** Delete multiple HubPagePartnerCompanyTile documents */
  delete?: InputMaybe<Array<HubPagePartnerCompanyTileWhereUniqueInput>>
  /** Update multiple HubPagePartnerCompanyTile component instances */
  update?: InputMaybe<Array<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPagePartnerCompanyTile component instances */
  upsert?: InputMaybe<Array<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPagePartnerCompanyTileUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPagePartnerCompanyTileUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPagePartnerCompanyTileUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPagePartnerCompanyTileUpdateManyLocalizationInput = {
  data: HubPagePartnerCompanyTileUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPagePartnerCompanyTileUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPagePartnerCompanyTileUpdateManyLocalizationInput>>
}

export type HubPagePartnerCompanyTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPagePartnerCompanyTileUpdateManyInput
  /** Document search */
  where: HubPagePartnerCompanyTileWhereInput
}

export type HubPagePartnerCompanyTileUpdateOneInlineInput = {
  /** Create and connect one HubPagePartnerCompanyTile document */
  create?: InputMaybe<HubPagePartnerCompanyTileCreateInput>
  /** Delete currently connected HubPagePartnerCompanyTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPagePartnerCompanyTile document */
  update?: InputMaybe<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPagePartnerCompanyTile document */
  upsert?: InputMaybe<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueInput>
}

export type HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPagePartnerCompanyTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPagePartnerCompanyTileWhereUniqueInput
}

export type HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPagePartnerCompanyTileUpdateInput
  /** Unique document search */
  where: HubPagePartnerCompanyTileWhereUniqueInput
}

export type HubPagePartnerCompanyTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPagePartnerCompanyTileCreateInput
  /** Update document if it exists */
  update: HubPagePartnerCompanyTileUpdateInput
}

export type HubPagePartnerCompanyTileUpsertLocalizationInput = {
  create: HubPagePartnerCompanyTileCreateLocalizationDataInput
  locale: Locale
  update: HubPagePartnerCompanyTileUpdateLocalizationDataInput
}

export type HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPagePartnerCompanyTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPagePartnerCompanyTileWhereUniqueInput
}

export type HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPagePartnerCompanyTileUpsertInput
  /** Unique document search */
  where: HubPagePartnerCompanyTileWhereUniqueInput
}

/** Identifies documents */
export type HubPagePartnerCompanyTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPagePartnerCompanyTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPagePartnerCompanyTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPagePartnerCompanyTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  partnerCompanies?: InputMaybe<ExhibitorListOrderWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPagePartnerCompanyTile record uniquely */
export type HubPagePartnerCompanyTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Component used for linking references with additional content */
export type HubPageReference = Entity & {
  __typename?: 'HubPageReference'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Reference to content items. */
  reference?: Maybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9z>
  /** System stage field */
  stage: Stage
  tag?: Maybe<Tag>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Component used for linking references with additional content */
export type HubPageReferenceReferenceArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Component used for linking references with additional content */
export type HubPageReferenceTagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HubPageReferenceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageReferenceWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageReferenceConnection = {
  __typename?: 'HubPageReferenceConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageReferenceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageReferenceCreateInput = {
  reference?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zCreateOneInlineInput>
  tag?: InputMaybe<TagCreateOneInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageReferenceCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageReference documents */
  create?: InputMaybe<Array<HubPageReferenceCreateInput>>
}

export type HubPageReferenceCreateOneInlineInput = {
  /** Create and connect one HubPageReference document */
  create?: InputMaybe<HubPageReferenceCreateInput>
}

export type HubPageReferenceCreateWithPositionInput = {
  /** Document to create */
  data: HubPageReferenceCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageReferenceEdge = {
  __typename?: 'HubPageReferenceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageReference
}

/** Reference List Tile for Hub Page Sections */
export type HubPageReferenceListTile = Entity & {
  __typename?: 'HubPageReferenceListTile'
  cta?: Maybe<CallToAction>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageReferenceListTile>
  /** Content references for Hub Page Reference List Tile */
  references: Array<HubPageReference>
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Reference List Tile */
  tileSizes: HubPageTileSizes
  /** Reference List Tile title */
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Reference List Tile for Hub Page Sections */
export type HubPageReferenceListTileCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reference List Tile for Hub Page Sections */
export type HubPageReferenceListTileLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Reference List Tile for Hub Page Sections */
export type HubPageReferenceListTileReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<HubPageReferenceOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubPageReferenceWhereInput>
}

/** Reference List Tile for Hub Page Sections */
export type HubPageReferenceListTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reference List Tile for Hub Page Sections */
export type HubPageReferenceListTileUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageReferenceListTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageReferenceListTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageReferenceListTileConnection = {
  __typename?: 'HubPageReferenceListTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageReferenceListTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageReferenceListTileCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageReferenceListTileCreateLocalizationsInput>
  references?: InputMaybe<HubPageReferenceCreateManyInlineInput>
  tileSizes: HubPageTileSizesCreateOneInlineInput
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageReferenceListTileCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageReferenceListTileCreateLocalizationInput = {
  /** Localization input */
  data: HubPageReferenceListTileCreateLocalizationDataInput
  locale: Locale
}

export type HubPageReferenceListTileCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageReferenceListTileCreateLocalizationInput>>
}

export type HubPageReferenceListTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageReferenceListTile documents */
  create?: InputMaybe<Array<HubPageReferenceListTileCreateInput>>
}

export type HubPageReferenceListTileCreateOneInlineInput = {
  /** Create and connect one HubPageReferenceListTile document */
  create?: InputMaybe<HubPageReferenceListTileCreateInput>
}

export type HubPageReferenceListTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageReferenceListTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageReferenceListTileEdge = {
  __typename?: 'HubPageReferenceListTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageReferenceListTile
}

/** Identifies documents */
export type HubPageReferenceListTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageReferenceListTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageReferenceListTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageReferenceListTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  references_every?: InputMaybe<HubPageReferenceWhereInput>
  references_none?: InputMaybe<HubPageReferenceWhereInput>
  references_some?: InputMaybe<HubPageReferenceWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageReferenceListTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageReferenceListTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageReferenceListTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageReferenceListTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageReferenceListTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageReferenceListTileParent documents */
  create?: InputMaybe<Array<HubPageReferenceListTileParentCreateInput>>
}

export type HubPageReferenceListTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageReferenceListTileParent document */
  create?: InputMaybe<HubPageReferenceListTileParentCreateInput>
}

export type HubPageReferenceListTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageReferenceListTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageReferenceListTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageReferenceListTileParent component instances */
  create?: InputMaybe<Array<HubPageReferenceListTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageReferenceListTileParent documents */
  delete?: InputMaybe<Array<HubPageReferenceListTileParentWhereUniqueInput>>
  /** Update multiple HubPageReferenceListTileParent component instances */
  update?: InputMaybe<Array<HubPageReferenceListTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageReferenceListTileParent component instances */
  upsert?: InputMaybe<Array<HubPageReferenceListTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageReferenceListTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageReferenceListTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageReferenceListTileParent document */
  create?: InputMaybe<HubPageReferenceListTileParentCreateInput>
  /** Delete currently connected HubPageReferenceListTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageReferenceListTileParent document */
  update?: InputMaybe<HubPageReferenceListTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageReferenceListTileParent document */
  upsert?: InputMaybe<HubPageReferenceListTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageReferenceListTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageReferenceListTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageReferenceListTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageReferenceListTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageReferenceListTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageReferenceListTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageReferenceListTileUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageReferenceListTileUpdateLocalizationsInput>
  references?: InputMaybe<HubPageReferenceUpdateManyInlineInput>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageReferenceListTileUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageReferenceListTileUpdateLocalizationInput = {
  data: HubPageReferenceListTileUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageReferenceListTileUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageReferenceListTileCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageReferenceListTileUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageReferenceListTileUpsertLocalizationInput>>
}

export type HubPageReferenceListTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageReferenceListTile component instances */
  create?: InputMaybe<Array<HubPageReferenceListTileCreateWithPositionInput>>
  /** Delete multiple HubPageReferenceListTile documents */
  delete?: InputMaybe<Array<HubPageReferenceListTileWhereUniqueInput>>
  /** Update multiple HubPageReferenceListTile component instances */
  update?: InputMaybe<Array<HubPageReferenceListTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageReferenceListTile component instances */
  upsert?: InputMaybe<Array<HubPageReferenceListTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageReferenceListTileUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageReferenceListTileUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageReferenceListTileUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageReferenceListTileUpdateManyLocalizationInput = {
  data: HubPageReferenceListTileUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageReferenceListTileUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageReferenceListTileUpdateManyLocalizationInput>>
}

export type HubPageReferenceListTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageReferenceListTileUpdateManyInput
  /** Document search */
  where: HubPageReferenceListTileWhereInput
}

export type HubPageReferenceListTileUpdateOneInlineInput = {
  /** Create and connect one HubPageReferenceListTile document */
  create?: InputMaybe<HubPageReferenceListTileCreateInput>
  /** Delete currently connected HubPageReferenceListTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageReferenceListTile document */
  update?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageReferenceListTile document */
  upsert?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageReferenceListTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageReferenceListTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageReferenceListTileWhereUniqueInput
}

export type HubPageReferenceListTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageReferenceListTileUpdateInput
  /** Unique document search */
  where: HubPageReferenceListTileWhereUniqueInput
}

export type HubPageReferenceListTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageReferenceListTileCreateInput
  /** Update document if it exists */
  update: HubPageReferenceListTileUpdateInput
}

export type HubPageReferenceListTileUpsertLocalizationInput = {
  create: HubPageReferenceListTileCreateLocalizationDataInput
  locale: Locale
  update: HubPageReferenceListTileUpdateLocalizationDataInput
}

export type HubPageReferenceListTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageReferenceListTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageReferenceListTileWhereUniqueInput
}

export type HubPageReferenceListTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageReferenceListTileUpsertInput
  /** Unique document search */
  where: HubPageReferenceListTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageReferenceListTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageReferenceListTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageReferenceListTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageReferenceListTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  references_every?: InputMaybe<HubPageReferenceWhereInput>
  references_none?: InputMaybe<HubPageReferenceWhereInput>
  references_some?: InputMaybe<HubPageReferenceWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageReferenceListTile record uniquely */
export type HubPageReferenceListTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Identifies documents */
export type HubPageReferenceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageReferenceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageReferenceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageReferenceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is connected to the given models */
  reference?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereInput>
  /** All values in which the union is empty */
  reference_empty?: InputMaybe<Scalars['Boolean']['input']>
  tag?: InputMaybe<TagWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageReferenceOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageReferenceParent = HubPageReferenceListTile

export type HubPageReferenceParentConnectInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileConnectInput>
}

export type HubPageReferenceParentCreateInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateInput>
}

export type HubPageReferenceParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageReferenceParent documents */
  create?: InputMaybe<Array<HubPageReferenceParentCreateInput>>
}

export type HubPageReferenceParentCreateOneInlineInput = {
  /** Create and connect one HubPageReferenceParent document */
  create?: InputMaybe<HubPageReferenceParentCreateInput>
}

export type HubPageReferenceParentCreateWithPositionInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateWithPositionInput>
}

export type HubPageReferenceParentUpdateInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateInput>
}

export type HubPageReferenceParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageReferenceParent component instances */
  create?: InputMaybe<Array<HubPageReferenceParentCreateWithPositionInput>>
  /** Delete multiple HubPageReferenceParent documents */
  delete?: InputMaybe<Array<HubPageReferenceParentWhereUniqueInput>>
  /** Update multiple HubPageReferenceParent component instances */
  update?: InputMaybe<Array<HubPageReferenceParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageReferenceParent component instances */
  upsert?: InputMaybe<Array<HubPageReferenceParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageReferenceParentUpdateManyWithNestedWhereInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateManyWithNestedWhereInput>
}

export type HubPageReferenceParentUpdateOneInlineInput = {
  /** Create and connect one HubPageReferenceParent document */
  create?: InputMaybe<HubPageReferenceParentCreateInput>
  /** Delete currently connected HubPageReferenceParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageReferenceParent document */
  update?: InputMaybe<HubPageReferenceParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageReferenceParent document */
  upsert?: InputMaybe<HubPageReferenceParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageReferenceParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageReferenceParentUpdateWithNestedWhereUniqueInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueInput>
}

export type HubPageReferenceParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageReferenceParentUpsertWithNestedWhereUniqueInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageReferenceParentWhereInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereInput>
}

export type HubPageReferenceParentWhereUniqueInput = {
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereUniqueInput>
}

export type HubPageReferenceUpdateInput = {
  reference?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpdateOneInlineInput>
  tag?: InputMaybe<TagUpdateOneInlineInput>
}

export type HubPageReferenceUpdateManyInlineInput = {
  /** Create and connect multiple HubPageReference component instances */
  create?: InputMaybe<Array<HubPageReferenceCreateWithPositionInput>>
  /** Delete multiple HubPageReference documents */
  delete?: InputMaybe<Array<HubPageReferenceWhereUniqueInput>>
  /** Update multiple HubPageReference component instances */
  update?: InputMaybe<Array<HubPageReferenceUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageReference component instances */
  upsert?: InputMaybe<Array<HubPageReferenceUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageReferenceUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type HubPageReferenceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageReferenceUpdateManyInput
  /** Document search */
  where: HubPageReferenceWhereInput
}

export type HubPageReferenceUpdateOneInlineInput = {
  /** Create and connect one HubPageReference document */
  create?: InputMaybe<HubPageReferenceCreateInput>
  /** Delete currently connected HubPageReference document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageReference document */
  update?: InputMaybe<HubPageReferenceUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageReference document */
  upsert?: InputMaybe<HubPageReferenceUpsertWithNestedWhereUniqueInput>
}

export type HubPageReferenceUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageReferenceUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageReferenceWhereUniqueInput
}

export type HubPageReferenceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageReferenceUpdateInput
  /** Unique document search */
  where: HubPageReferenceWhereUniqueInput
}

export type HubPageReferenceUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageReferenceCreateInput
  /** Update document if it exists */
  update: HubPageReferenceUpdateInput
}

export type HubPageReferenceUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageReferenceUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageReferenceWhereUniqueInput
}

export type HubPageReferenceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageReferenceUpsertInput
  /** Unique document search */
  where: HubPageReferenceWhereUniqueInput
}

/** Identifies documents */
export type HubPageReferenceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageReferenceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageReferenceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageReferenceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is connected to the given models */
  reference?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereInput>
  /** All values in which the union is empty */
  reference_empty?: InputMaybe<Scalars['Boolean']['input']>
  tag?: InputMaybe<TagWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageReference record uniquely */
export type HubPageReferenceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Reviews Top Products Tile for Hub Page Sections */
export type HubPageReviewsTopProductsTile = Entity & {
  __typename?: 'HubPageReviewsTopProductsTile'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type HubPageReviewsTopProductsTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageReviewsTopProductsTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageReviewsTopProductsTileConnection = {
  __typename?: 'HubPageReviewsTopProductsTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageReviewsTopProductsTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageReviewsTopProductsTileCreateInput = {
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageReviewsTopProductsTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageReviewsTopProductsTile documents */
  create?: InputMaybe<Array<HubPageReviewsTopProductsTileCreateInput>>
}

export type HubPageReviewsTopProductsTileCreateOneInlineInput = {
  /** Create and connect one HubPageReviewsTopProductsTile document */
  create?: InputMaybe<HubPageReviewsTopProductsTileCreateInput>
}

export type HubPageReviewsTopProductsTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageReviewsTopProductsTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageReviewsTopProductsTileEdge = {
  __typename?: 'HubPageReviewsTopProductsTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageReviewsTopProductsTile
}

/** Identifies documents */
export type HubPageReviewsTopProductsTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageReviewsTopProductsTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageReviewsTopProductsTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageReviewsTopProductsTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageReviewsTopProductsTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageReviewsTopProductsTileParent = HubPageSectionGeneral

export type HubPageReviewsTopProductsTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
}

export type HubPageReviewsTopProductsTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
}

export type HubPageReviewsTopProductsTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageReviewsTopProductsTileParent documents */
  create?: InputMaybe<Array<HubPageReviewsTopProductsTileParentCreateInput>>
}

export type HubPageReviewsTopProductsTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageReviewsTopProductsTileParent document */
  create?: InputMaybe<HubPageReviewsTopProductsTileParentCreateInput>
}

export type HubPageReviewsTopProductsTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
}

export type HubPageReviewsTopProductsTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
}

export type HubPageReviewsTopProductsTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageReviewsTopProductsTileParent component instances */
  create?: InputMaybe<Array<HubPageReviewsTopProductsTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageReviewsTopProductsTileParent documents */
  delete?: InputMaybe<Array<HubPageReviewsTopProductsTileParentWhereUniqueInput>>
  /** Update multiple HubPageReviewsTopProductsTileParent component instances */
  update?: InputMaybe<Array<HubPageReviewsTopProductsTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageReviewsTopProductsTileParent component instances */
  upsert?: InputMaybe<Array<HubPageReviewsTopProductsTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageReviewsTopProductsTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
}

export type HubPageReviewsTopProductsTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageReviewsTopProductsTileParent document */
  create?: InputMaybe<HubPageReviewsTopProductsTileParentCreateInput>
  /** Delete currently connected HubPageReviewsTopProductsTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageReviewsTopProductsTileParent document */
  update?: InputMaybe<HubPageReviewsTopProductsTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageReviewsTopProductsTileParent document */
  upsert?: InputMaybe<HubPageReviewsTopProductsTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageReviewsTopProductsTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageReviewsTopProductsTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
}

export type HubPageReviewsTopProductsTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageReviewsTopProductsTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
}

export type HubPageReviewsTopProductsTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
}

export type HubPageReviewsTopProductsTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
}

export type HubPageReviewsTopProductsTileUpdateInput = {
  /** No fields in update input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type HubPageReviewsTopProductsTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageReviewsTopProductsTile component instances */
  create?: InputMaybe<Array<HubPageReviewsTopProductsTileCreateWithPositionInput>>
  /** Delete multiple HubPageReviewsTopProductsTile documents */
  delete?: InputMaybe<Array<HubPageReviewsTopProductsTileWhereUniqueInput>>
  /** Update multiple HubPageReviewsTopProductsTile component instances */
  update?: InputMaybe<Array<HubPageReviewsTopProductsTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageReviewsTopProductsTile component instances */
  upsert?: InputMaybe<Array<HubPageReviewsTopProductsTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageReviewsTopProductsTileUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type HubPageReviewsTopProductsTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageReviewsTopProductsTileUpdateManyInput
  /** Document search */
  where: HubPageReviewsTopProductsTileWhereInput
}

export type HubPageReviewsTopProductsTileUpdateOneInlineInput = {
  /** Create and connect one HubPageReviewsTopProductsTile document */
  create?: InputMaybe<HubPageReviewsTopProductsTileCreateInput>
  /** Delete currently connected HubPageReviewsTopProductsTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageReviewsTopProductsTile document */
  update?: InputMaybe<HubPageReviewsTopProductsTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageReviewsTopProductsTile document */
  upsert?: InputMaybe<HubPageReviewsTopProductsTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageReviewsTopProductsTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageReviewsTopProductsTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageReviewsTopProductsTileWhereUniqueInput
}

export type HubPageReviewsTopProductsTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageReviewsTopProductsTileUpdateInput
  /** Unique document search */
  where: HubPageReviewsTopProductsTileWhereUniqueInput
}

export type HubPageReviewsTopProductsTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageReviewsTopProductsTileCreateInput
  /** Update document if it exists */
  update: HubPageReviewsTopProductsTileUpdateInput
}

export type HubPageReviewsTopProductsTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageReviewsTopProductsTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageReviewsTopProductsTileWhereUniqueInput
}

export type HubPageReviewsTopProductsTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageReviewsTopProductsTileUpsertInput
  /** Unique document search */
  where: HubPageReviewsTopProductsTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageReviewsTopProductsTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageReviewsTopProductsTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageReviewsTopProductsTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageReviewsTopProductsTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageReviewsTopProductsTile record uniquely */
export type HubPageReviewsTopProductsTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Content Library Section for Hub Pages */
export type HubPageSectionContentLibrary = Entity & {
  __typename?: 'HubPageSectionContentLibrary'
  /** Icon for Hub Page Section */
  icon: LucideIcon
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageSectionContentLibrary>
  /** System stage field */
  stage: Stage
  /** Section subtitle */
  subtitle: Scalars['String']['output']
  /** Title/headline for the section. Used for content navigation slider. */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content Library Section for Hub Pages */
export type HubPageSectionContentLibraryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Content Library Section for Hub Pages */
export type HubPageSectionContentLibraryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageSectionContentLibraryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageSectionContentLibraryWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageSectionContentLibraryConnection = {
  __typename?: 'HubPageSectionContentLibraryConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageSectionContentLibraryEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageSectionContentLibraryCreateInput = {
  icon: LucideIcon
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageSectionContentLibraryCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSectionContentLibraryCreateLocalizationDataInput = {
  subtitle: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSectionContentLibraryCreateLocalizationInput = {
  /** Localization input */
  data: HubPageSectionContentLibraryCreateLocalizationDataInput
  locale: Locale
}

export type HubPageSectionContentLibraryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageSectionContentLibraryCreateLocalizationInput>>
}

export type HubPageSectionContentLibraryCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSectionContentLibrary documents */
  create?: InputMaybe<Array<HubPageSectionContentLibraryCreateInput>>
}

export type HubPageSectionContentLibraryCreateOneInlineInput = {
  /** Create and connect one HubPageSectionContentLibrary document */
  create?: InputMaybe<HubPageSectionContentLibraryCreateInput>
}

export type HubPageSectionContentLibraryCreateWithPositionInput = {
  /** Document to create */
  data: HubPageSectionContentLibraryCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageSectionContentLibraryEdge = {
  __typename?: 'HubPageSectionContentLibraryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageSectionContentLibrary
}

/** Identifies documents */
export type HubPageSectionContentLibraryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSectionContentLibraryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSectionContentLibraryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSectionContentLibraryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageSectionContentLibraryOrderByInput {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageSectionContentLibraryParent = HubPage

export type HubPageSectionContentLibraryParentConnectInput = {
  HubPage?: InputMaybe<HubPageConnectInput>
}

export type HubPageSectionContentLibraryParentCreateInput = {
  HubPage?: InputMaybe<HubPageCreateInput>
}

export type HubPageSectionContentLibraryParentCreateManyInlineInput = {
  /** Connect multiple existing HubPageSectionContentLibraryParent documents */
  connect?: InputMaybe<Array<HubPageSectionContentLibraryParentWhereUniqueInput>>
  /** Create and connect multiple existing HubPageSectionContentLibraryParent documents */
  create?: InputMaybe<Array<HubPageSectionContentLibraryParentCreateInput>>
}

export type HubPageSectionContentLibraryParentCreateOneInlineInput = {
  /** Connect one existing HubPageSectionContentLibraryParent document */
  connect?: InputMaybe<HubPageSectionContentLibraryParentWhereUniqueInput>
  /** Create and connect one HubPageSectionContentLibraryParent document */
  create?: InputMaybe<HubPageSectionContentLibraryParentCreateInput>
}

export type HubPageSectionContentLibraryParentUpdateInput = {
  HubPage?: InputMaybe<HubPageUpdateInput>
}

export type HubPageSectionContentLibraryParentUpdateManyInlineInput = {
  /** Connect multiple existing HubPageSectionContentLibraryParent documents */
  connect?: InputMaybe<Array<HubPageSectionContentLibraryParentConnectInput>>
  /** Create and connect multiple HubPageSectionContentLibraryParent documents */
  create?: InputMaybe<Array<HubPageSectionContentLibraryParentCreateInput>>
  /** Delete multiple HubPageSectionContentLibraryParent documents */
  delete?: InputMaybe<Array<HubPageSectionContentLibraryParentWhereUniqueInput>>
  /** Disconnect multiple HubPageSectionContentLibraryParent documents */
  disconnect?: InputMaybe<Array<HubPageSectionContentLibraryParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HubPageSectionContentLibraryParent documents */
  set?: InputMaybe<Array<HubPageSectionContentLibraryParentWhereUniqueInput>>
  /** Update multiple HubPageSectionContentLibraryParent documents */
  update?: InputMaybe<Array<HubPageSectionContentLibraryParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HubPageSectionContentLibraryParent documents */
  upsert?: InputMaybe<Array<HubPageSectionContentLibraryParentUpsertWithNestedWhereUniqueInput>>
}

export type HubPageSectionContentLibraryParentUpdateManyWithNestedWhereInput = {
  HubPage?: InputMaybe<HubPageUpdateManyWithNestedWhereInput>
}

export type HubPageSectionContentLibraryParentUpdateOneInlineInput = {
  /** Connect existing HubPageSectionContentLibraryParent document */
  connect?: InputMaybe<HubPageSectionContentLibraryParentWhereUniqueInput>
  /** Create and connect one HubPageSectionContentLibraryParent document */
  create?: InputMaybe<HubPageSectionContentLibraryParentCreateInput>
  /** Delete currently connected HubPageSectionContentLibraryParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HubPageSectionContentLibraryParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionContentLibraryParent document */
  update?: InputMaybe<HubPageSectionContentLibraryParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionContentLibraryParent document */
  upsert?: InputMaybe<HubPageSectionContentLibraryParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionContentLibraryParentUpdateWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpdateWithNestedWhereUniqueInput>
}

export type HubPageSectionContentLibraryParentUpsertWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionContentLibraryParentWhereInput = {
  HubPage?: InputMaybe<HubPageWhereInput>
}

export type HubPageSectionContentLibraryParentWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageWhereUniqueInput>
}

export type HubPageSectionContentLibraryUpdateInput = {
  icon?: InputMaybe<LucideIcon>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageSectionContentLibraryUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionContentLibraryUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionContentLibraryUpdateLocalizationInput = {
  data: HubPageSectionContentLibraryUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageSectionContentLibraryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageSectionContentLibraryCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSectionContentLibraryUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageSectionContentLibraryUpsertLocalizationInput>>
}

export type HubPageSectionContentLibraryUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSectionContentLibrary component instances */
  create?: InputMaybe<Array<HubPageSectionContentLibraryCreateWithPositionInput>>
  /** Delete multiple HubPageSectionContentLibrary documents */
  delete?: InputMaybe<Array<HubPageSectionContentLibraryWhereUniqueInput>>
  /** Update multiple HubPageSectionContentLibrary component instances */
  update?: InputMaybe<Array<HubPageSectionContentLibraryUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSectionContentLibrary component instances */
  upsert?: InputMaybe<Array<HubPageSectionContentLibraryUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSectionContentLibraryUpdateManyInput = {
  icon?: InputMaybe<LucideIcon>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageSectionContentLibraryUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionContentLibraryUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionContentLibraryUpdateManyLocalizationInput = {
  data: HubPageSectionContentLibraryUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageSectionContentLibraryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSectionContentLibraryUpdateManyLocalizationInput>>
}

export type HubPageSectionContentLibraryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageSectionContentLibraryUpdateManyInput
  /** Document search */
  where: HubPageSectionContentLibraryWhereInput
}

export type HubPageSectionContentLibraryUpdateOneInlineInput = {
  /** Create and connect one HubPageSectionContentLibrary document */
  create?: InputMaybe<HubPageSectionContentLibraryCreateInput>
  /** Delete currently connected HubPageSectionContentLibrary document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionContentLibrary document */
  update?: InputMaybe<HubPageSectionContentLibraryUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionContentLibrary document */
  upsert?: InputMaybe<HubPageSectionContentLibraryUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionContentLibraryUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageSectionContentLibraryUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSectionContentLibraryWhereUniqueInput
}

export type HubPageSectionContentLibraryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageSectionContentLibraryUpdateInput
  /** Unique document search */
  where: HubPageSectionContentLibraryWhereUniqueInput
}

export type HubPageSectionContentLibraryUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageSectionContentLibraryCreateInput
  /** Update document if it exists */
  update: HubPageSectionContentLibraryUpdateInput
}

export type HubPageSectionContentLibraryUpsertLocalizationInput = {
  create: HubPageSectionContentLibraryCreateLocalizationDataInput
  locale: Locale
  update: HubPageSectionContentLibraryUpdateLocalizationDataInput
}

export type HubPageSectionContentLibraryUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageSectionContentLibraryUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSectionContentLibraryWhereUniqueInput
}

export type HubPageSectionContentLibraryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageSectionContentLibraryUpsertInput
  /** Unique document search */
  where: HubPageSectionContentLibraryWhereUniqueInput
}

/** Identifies documents */
export type HubPageSectionContentLibraryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSectionContentLibraryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSectionContentLibraryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSectionContentLibraryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageSectionContentLibrary record uniquely */
export type HubPageSectionContentLibraryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Festival Events Section for Hub Pages */
export type HubPageSectionFestivalEvents = Entity & {
  __typename?: 'HubPageSectionFestivalEvents'
  /** Icon for Hub Page Section */
  icon: LucideIcon
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageSectionFestivalEvents>
  /** System stage field */
  stage: Stage
  /** Section subtitle */
  subtitle: Scalars['String']['output']
  /** Title/headline for the section. Used for content navigation slider. */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Festival Events Section for Hub Pages */
export type HubPageSectionFestivalEventsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Festival Events Section for Hub Pages */
export type HubPageSectionFestivalEventsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageSectionFestivalEventsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageSectionFestivalEventsWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageSectionFestivalEventsConnection = {
  __typename?: 'HubPageSectionFestivalEventsConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageSectionFestivalEventsEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageSectionFestivalEventsCreateInput = {
  icon: LucideIcon
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageSectionFestivalEventsCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSectionFestivalEventsCreateLocalizationDataInput = {
  subtitle: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSectionFestivalEventsCreateLocalizationInput = {
  /** Localization input */
  data: HubPageSectionFestivalEventsCreateLocalizationDataInput
  locale: Locale
}

export type HubPageSectionFestivalEventsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageSectionFestivalEventsCreateLocalizationInput>>
}

export type HubPageSectionFestivalEventsCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSectionFestivalEvents documents */
  create?: InputMaybe<Array<HubPageSectionFestivalEventsCreateInput>>
}

export type HubPageSectionFestivalEventsCreateOneInlineInput = {
  /** Create and connect one HubPageSectionFestivalEvents document */
  create?: InputMaybe<HubPageSectionFestivalEventsCreateInput>
}

export type HubPageSectionFestivalEventsCreateWithPositionInput = {
  /** Document to create */
  data: HubPageSectionFestivalEventsCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageSectionFestivalEventsEdge = {
  __typename?: 'HubPageSectionFestivalEventsEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageSectionFestivalEvents
}

/** Identifies documents */
export type HubPageSectionFestivalEventsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSectionFestivalEventsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSectionFestivalEventsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSectionFestivalEventsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageSectionFestivalEventsOrderByInput {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageSectionFestivalEventsParent = HubPage

export type HubPageSectionFestivalEventsParentConnectInput = {
  HubPage?: InputMaybe<HubPageConnectInput>
}

export type HubPageSectionFestivalEventsParentCreateInput = {
  HubPage?: InputMaybe<HubPageCreateInput>
}

export type HubPageSectionFestivalEventsParentCreateManyInlineInput = {
  /** Connect multiple existing HubPageSectionFestivalEventsParent documents */
  connect?: InputMaybe<Array<HubPageSectionFestivalEventsParentWhereUniqueInput>>
  /** Create and connect multiple existing HubPageSectionFestivalEventsParent documents */
  create?: InputMaybe<Array<HubPageSectionFestivalEventsParentCreateInput>>
}

export type HubPageSectionFestivalEventsParentCreateOneInlineInput = {
  /** Connect one existing HubPageSectionFestivalEventsParent document */
  connect?: InputMaybe<HubPageSectionFestivalEventsParentWhereUniqueInput>
  /** Create and connect one HubPageSectionFestivalEventsParent document */
  create?: InputMaybe<HubPageSectionFestivalEventsParentCreateInput>
}

export type HubPageSectionFestivalEventsParentUpdateInput = {
  HubPage?: InputMaybe<HubPageUpdateInput>
}

export type HubPageSectionFestivalEventsParentUpdateManyInlineInput = {
  /** Connect multiple existing HubPageSectionFestivalEventsParent documents */
  connect?: InputMaybe<Array<HubPageSectionFestivalEventsParentConnectInput>>
  /** Create and connect multiple HubPageSectionFestivalEventsParent documents */
  create?: InputMaybe<Array<HubPageSectionFestivalEventsParentCreateInput>>
  /** Delete multiple HubPageSectionFestivalEventsParent documents */
  delete?: InputMaybe<Array<HubPageSectionFestivalEventsParentWhereUniqueInput>>
  /** Disconnect multiple HubPageSectionFestivalEventsParent documents */
  disconnect?: InputMaybe<Array<HubPageSectionFestivalEventsParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HubPageSectionFestivalEventsParent documents */
  set?: InputMaybe<Array<HubPageSectionFestivalEventsParentWhereUniqueInput>>
  /** Update multiple HubPageSectionFestivalEventsParent documents */
  update?: InputMaybe<Array<HubPageSectionFestivalEventsParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HubPageSectionFestivalEventsParent documents */
  upsert?: InputMaybe<Array<HubPageSectionFestivalEventsParentUpsertWithNestedWhereUniqueInput>>
}

export type HubPageSectionFestivalEventsParentUpdateManyWithNestedWhereInput = {
  HubPage?: InputMaybe<HubPageUpdateManyWithNestedWhereInput>
}

export type HubPageSectionFestivalEventsParentUpdateOneInlineInput = {
  /** Connect existing HubPageSectionFestivalEventsParent document */
  connect?: InputMaybe<HubPageSectionFestivalEventsParentWhereUniqueInput>
  /** Create and connect one HubPageSectionFestivalEventsParent document */
  create?: InputMaybe<HubPageSectionFestivalEventsParentCreateInput>
  /** Delete currently connected HubPageSectionFestivalEventsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HubPageSectionFestivalEventsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionFestivalEventsParent document */
  update?: InputMaybe<HubPageSectionFestivalEventsParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionFestivalEventsParent document */
  upsert?: InputMaybe<HubPageSectionFestivalEventsParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionFestivalEventsParentUpdateWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpdateWithNestedWhereUniqueInput>
}

export type HubPageSectionFestivalEventsParentUpsertWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionFestivalEventsParentWhereInput = {
  HubPage?: InputMaybe<HubPageWhereInput>
}

export type HubPageSectionFestivalEventsParentWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageWhereUniqueInput>
}

export type HubPageSectionFestivalEventsUpdateInput = {
  icon?: InputMaybe<LucideIcon>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageSectionFestivalEventsUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionFestivalEventsUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionFestivalEventsUpdateLocalizationInput = {
  data: HubPageSectionFestivalEventsUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageSectionFestivalEventsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageSectionFestivalEventsCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSectionFestivalEventsUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageSectionFestivalEventsUpsertLocalizationInput>>
}

export type HubPageSectionFestivalEventsUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSectionFestivalEvents component instances */
  create?: InputMaybe<Array<HubPageSectionFestivalEventsCreateWithPositionInput>>
  /** Delete multiple HubPageSectionFestivalEvents documents */
  delete?: InputMaybe<Array<HubPageSectionFestivalEventsWhereUniqueInput>>
  /** Update multiple HubPageSectionFestivalEvents component instances */
  update?: InputMaybe<Array<HubPageSectionFestivalEventsUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSectionFestivalEvents component instances */
  upsert?: InputMaybe<Array<HubPageSectionFestivalEventsUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSectionFestivalEventsUpdateManyInput = {
  icon?: InputMaybe<LucideIcon>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageSectionFestivalEventsUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionFestivalEventsUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionFestivalEventsUpdateManyLocalizationInput = {
  data: HubPageSectionFestivalEventsUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageSectionFestivalEventsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSectionFestivalEventsUpdateManyLocalizationInput>>
}

export type HubPageSectionFestivalEventsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageSectionFestivalEventsUpdateManyInput
  /** Document search */
  where: HubPageSectionFestivalEventsWhereInput
}

export type HubPageSectionFestivalEventsUpdateOneInlineInput = {
  /** Create and connect one HubPageSectionFestivalEvents document */
  create?: InputMaybe<HubPageSectionFestivalEventsCreateInput>
  /** Delete currently connected HubPageSectionFestivalEvents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionFestivalEvents document */
  update?: InputMaybe<HubPageSectionFestivalEventsUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionFestivalEvents document */
  upsert?: InputMaybe<HubPageSectionFestivalEventsUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionFestivalEventsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageSectionFestivalEventsUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSectionFestivalEventsWhereUniqueInput
}

export type HubPageSectionFestivalEventsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageSectionFestivalEventsUpdateInput
  /** Unique document search */
  where: HubPageSectionFestivalEventsWhereUniqueInput
}

export type HubPageSectionFestivalEventsUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageSectionFestivalEventsCreateInput
  /** Update document if it exists */
  update: HubPageSectionFestivalEventsUpdateInput
}

export type HubPageSectionFestivalEventsUpsertLocalizationInput = {
  create: HubPageSectionFestivalEventsCreateLocalizationDataInput
  locale: Locale
  update: HubPageSectionFestivalEventsUpdateLocalizationDataInput
}

export type HubPageSectionFestivalEventsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageSectionFestivalEventsUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSectionFestivalEventsWhereUniqueInput
}

export type HubPageSectionFestivalEventsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageSectionFestivalEventsUpsertInput
  /** Unique document search */
  where: HubPageSectionFestivalEventsWhereUniqueInput
}

/** Identifies documents */
export type HubPageSectionFestivalEventsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSectionFestivalEventsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSectionFestivalEventsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSectionFestivalEventsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageSectionFestivalEvents record uniquely */
export type HubPageSectionFestivalEventsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** General Section for Hub Pages */
export type HubPageSectionGeneral = Entity & {
  __typename?: 'HubPageSectionGeneral'
  /** Icon for Hub Page Section */
  icon: LucideIcon
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageSectionGeneral>
  /** System stage field */
  stage: Stage
  /** Section subtitle */
  subtitle: Scalars['String']['output']
  /** List of section tiles. */
  tiles: Array<HubPageSectionGeneraltilesUnion>
  /** Title/headline for the section. Used for content navigation slider. */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** General Section for Hub Pages */
export type HubPageSectionGeneralLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** General Section for Hub Pages */
export type HubPageSectionGeneralTilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

/** General Section for Hub Pages */
export type HubPageSectionGeneralUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageSectionGeneralConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageSectionGeneralWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageSectionGeneralConnection = {
  __typename?: 'HubPageSectionGeneralConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageSectionGeneralEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageSectionGeneralCreateInput = {
  icon: LucideIcon
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageSectionGeneralCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle: Scalars['String']['input']
  tiles?: InputMaybe<HubPageSectionGeneraltilesUnionCreateManyInlineInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSectionGeneralCreateLocalizationDataInput = {
  subtitle: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSectionGeneralCreateLocalizationInput = {
  /** Localization input */
  data: HubPageSectionGeneralCreateLocalizationDataInput
  locale: Locale
}

export type HubPageSectionGeneralCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageSectionGeneralCreateLocalizationInput>>
}

export type HubPageSectionGeneralCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSectionGeneral documents */
  create?: InputMaybe<Array<HubPageSectionGeneralCreateInput>>
}

export type HubPageSectionGeneralCreateOneInlineInput = {
  /** Create and connect one HubPageSectionGeneral document */
  create?: InputMaybe<HubPageSectionGeneralCreateInput>
}

export type HubPageSectionGeneralCreateWithPositionInput = {
  /** Document to create */
  data: HubPageSectionGeneralCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageSectionGeneralEdge = {
  __typename?: 'HubPageSectionGeneralEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageSectionGeneral
}

/** Identifies documents */
export type HubPageSectionGeneralManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSectionGeneralWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSectionGeneralWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSectionGeneralWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty. */
  tiles_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  tiles_some?: InputMaybe<HubPageSectionGeneraltilesUnionWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageSectionGeneralOrderByInput {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageSectionGeneralParent = HubPage

export type HubPageSectionGeneralParentConnectInput = {
  HubPage?: InputMaybe<HubPageConnectInput>
}

export type HubPageSectionGeneralParentCreateInput = {
  HubPage?: InputMaybe<HubPageCreateInput>
}

export type HubPageSectionGeneralParentCreateManyInlineInput = {
  /** Connect multiple existing HubPageSectionGeneralParent documents */
  connect?: InputMaybe<Array<HubPageSectionGeneralParentWhereUniqueInput>>
  /** Create and connect multiple existing HubPageSectionGeneralParent documents */
  create?: InputMaybe<Array<HubPageSectionGeneralParentCreateInput>>
}

export type HubPageSectionGeneralParentCreateOneInlineInput = {
  /** Connect one existing HubPageSectionGeneralParent document */
  connect?: InputMaybe<HubPageSectionGeneralParentWhereUniqueInput>
  /** Create and connect one HubPageSectionGeneralParent document */
  create?: InputMaybe<HubPageSectionGeneralParentCreateInput>
}

export type HubPageSectionGeneralParentUpdateInput = {
  HubPage?: InputMaybe<HubPageUpdateInput>
}

export type HubPageSectionGeneralParentUpdateManyInlineInput = {
  /** Connect multiple existing HubPageSectionGeneralParent documents */
  connect?: InputMaybe<Array<HubPageSectionGeneralParentConnectInput>>
  /** Create and connect multiple HubPageSectionGeneralParent documents */
  create?: InputMaybe<Array<HubPageSectionGeneralParentCreateInput>>
  /** Delete multiple HubPageSectionGeneralParent documents */
  delete?: InputMaybe<Array<HubPageSectionGeneralParentWhereUniqueInput>>
  /** Disconnect multiple HubPageSectionGeneralParent documents */
  disconnect?: InputMaybe<Array<HubPageSectionGeneralParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HubPageSectionGeneralParent documents */
  set?: InputMaybe<Array<HubPageSectionGeneralParentWhereUniqueInput>>
  /** Update multiple HubPageSectionGeneralParent documents */
  update?: InputMaybe<Array<HubPageSectionGeneralParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HubPageSectionGeneralParent documents */
  upsert?: InputMaybe<Array<HubPageSectionGeneralParentUpsertWithNestedWhereUniqueInput>>
}

export type HubPageSectionGeneralParentUpdateManyWithNestedWhereInput = {
  HubPage?: InputMaybe<HubPageUpdateManyWithNestedWhereInput>
}

export type HubPageSectionGeneralParentUpdateOneInlineInput = {
  /** Connect existing HubPageSectionGeneralParent document */
  connect?: InputMaybe<HubPageSectionGeneralParentWhereUniqueInput>
  /** Create and connect one HubPageSectionGeneralParent document */
  create?: InputMaybe<HubPageSectionGeneralParentCreateInput>
  /** Delete currently connected HubPageSectionGeneralParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HubPageSectionGeneralParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionGeneralParent document */
  update?: InputMaybe<HubPageSectionGeneralParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionGeneralParent document */
  upsert?: InputMaybe<HubPageSectionGeneralParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionGeneralParentUpdateWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpdateWithNestedWhereUniqueInput>
}

export type HubPageSectionGeneralParentUpsertWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionGeneralParentWhereInput = {
  HubPage?: InputMaybe<HubPageWhereInput>
}

export type HubPageSectionGeneralParentWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageWhereUniqueInput>
}

export type HubPageSectionGeneralUpdateInput = {
  icon?: InputMaybe<LucideIcon>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageSectionGeneralUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tiles?: InputMaybe<HubPageSectionGeneraltilesUnionUpdateManyInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionGeneralUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionGeneralUpdateLocalizationInput = {
  data: HubPageSectionGeneralUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageSectionGeneralUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageSectionGeneralCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSectionGeneralUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageSectionGeneralUpsertLocalizationInput>>
}

export type HubPageSectionGeneralUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSectionGeneral component instances */
  create?: InputMaybe<Array<HubPageSectionGeneralCreateWithPositionInput>>
  /** Delete multiple HubPageSectionGeneral documents */
  delete?: InputMaybe<Array<HubPageSectionGeneralWhereUniqueInput>>
  /** Update multiple HubPageSectionGeneral component instances */
  update?: InputMaybe<Array<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSectionGeneral component instances */
  upsert?: InputMaybe<Array<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSectionGeneralUpdateManyInput = {
  icon?: InputMaybe<LucideIcon>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageSectionGeneralUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionGeneralUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionGeneralUpdateManyLocalizationInput = {
  data: HubPageSectionGeneralUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageSectionGeneralUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSectionGeneralUpdateManyLocalizationInput>>
}

export type HubPageSectionGeneralUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageSectionGeneralUpdateManyInput
  /** Document search */
  where: HubPageSectionGeneralWhereInput
}

export type HubPageSectionGeneralUpdateOneInlineInput = {
  /** Create and connect one HubPageSectionGeneral document */
  create?: InputMaybe<HubPageSectionGeneralCreateInput>
  /** Delete currently connected HubPageSectionGeneral document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionGeneral document */
  update?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionGeneral document */
  upsert?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageSectionGeneralUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSectionGeneralWhereUniqueInput
}

export type HubPageSectionGeneralUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageSectionGeneralUpdateInput
  /** Unique document search */
  where: HubPageSectionGeneralWhereUniqueInput
}

export type HubPageSectionGeneralUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageSectionGeneralCreateInput
  /** Update document if it exists */
  update: HubPageSectionGeneralUpdateInput
}

export type HubPageSectionGeneralUpsertLocalizationInput = {
  create: HubPageSectionGeneralCreateLocalizationDataInput
  locale: Locale
  update: HubPageSectionGeneralUpdateLocalizationDataInput
}

export type HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageSectionGeneralUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSectionGeneralWhereUniqueInput
}

export type HubPageSectionGeneralUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageSectionGeneralUpsertInput
  /** Unique document search */
  where: HubPageSectionGeneralWhereUniqueInput
}

/** Identifies documents */
export type HubPageSectionGeneralWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSectionGeneralWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSectionGeneralWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSectionGeneralWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values in which the union is empty. */
  tiles_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  tiles_some?: InputMaybe<HubPageSectionGeneraltilesUnionWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageSectionGeneral record uniquely */
export type HubPageSectionGeneralWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type HubPageSectionGeneraltilesUnion =
  | HubPageAdTile
  | HubPageArticleListTile
  | HubPageContentSliderTile
  | HubPageContentTile
  | HubPageImageTile
  | HubPageInfoTile
  | HubPageLatestArticleTile
  | HubPageNewsletterSubscriptionTile
  | HubPagePartnerCompanyTile
  | HubPageReferenceListTile
  | HubPageReviewsTopProductsTile
  | HubPageSocialMediaTile
  | HubPageSpeakerTile
  | HubPageStaticTile

export type HubPageSectionGeneraltilesUnionConnectInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileConnectInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileConnectInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileConnectInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileConnectInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileConnectInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileConnectInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileConnectInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileConnectInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileConnectInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileConnectInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileConnectInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileConnectInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileConnectInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileConnectInput>
}

export type HubPageSectionGeneraltilesUnionCreateInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileCreateInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileCreateInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileCreateInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileCreateInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileCreateInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileCreateInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileCreateInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileCreateInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileCreateInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileCreateInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileCreateInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileCreateInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileCreateInput>
}

export type HubPageSectionGeneraltilesUnionCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSectionGeneraltilesUnion documents */
  create?: InputMaybe<Array<HubPageSectionGeneraltilesUnionCreateInput>>
}

export type HubPageSectionGeneraltilesUnionCreateOneInlineInput = {
  /** Create and connect one HubPageSectionGeneraltilesUnion document */
  create?: InputMaybe<HubPageSectionGeneraltilesUnionCreateInput>
}

export type HubPageSectionGeneraltilesUnionCreateWithPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileCreateWithPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileCreateWithPositionInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileCreateWithPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileCreateWithPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileCreateWithPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileCreateWithPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileCreateWithPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileCreateWithPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileCreateWithPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateWithPositionInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileCreateWithPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileCreateWithPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileCreateWithPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileCreateWithPositionInput>
}

export type HubPageSectionGeneraltilesUnionUpdateInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpdateInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileUpdateInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateInput>
}

export type HubPageSectionGeneraltilesUnionUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSectionGeneraltilesUnion component instances */
  create?: InputMaybe<Array<HubPageSectionGeneraltilesUnionCreateWithPositionInput>>
  /** Delete multiple HubPageSectionGeneraltilesUnion documents */
  delete?: InputMaybe<Array<HubPageSectionGeneraltilesUnionWhereUniqueInput>>
  /** Update multiple HubPageSectionGeneraltilesUnion component instances */
  update?: InputMaybe<Array<HubPageSectionGeneraltilesUnionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSectionGeneraltilesUnion component instances */
  upsert?: InputMaybe<Array<HubPageSectionGeneraltilesUnionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSectionGeneraltilesUnionUpdateManyWithNestedWhereInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateManyWithNestedWhereInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateManyWithNestedWhereInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpdateManyWithNestedWhereInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateManyWithNestedWhereInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateManyWithNestedWhereInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateManyWithNestedWhereInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateManyWithNestedWhereInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateManyWithNestedWhereInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateManyWithNestedWhereInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateManyWithNestedWhereInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileUpdateManyWithNestedWhereInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateManyWithNestedWhereInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateManyWithNestedWhereInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateManyWithNestedWhereInput>
}

export type HubPageSectionGeneraltilesUnionUpdateOneInlineInput = {
  /** Create and connect one HubPageSectionGeneraltilesUnion document */
  create?: InputMaybe<HubPageSectionGeneraltilesUnionCreateInput>
  /** Delete currently connected HubPageSectionGeneraltilesUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionGeneraltilesUnion document */
  update?: InputMaybe<HubPageSectionGeneraltilesUnionUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionGeneraltilesUnion document */
  upsert?: InputMaybe<HubPageSectionGeneraltilesUnionUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionGeneraltilesUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageSectionGeneraltilesUnionUpdateWithNestedWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateWithNestedWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateWithNestedWhereUniqueInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpdateWithNestedWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateWithNestedWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateWithNestedWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateWithNestedWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateWithNestedWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileUpdateWithNestedWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateWithNestedWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateWithNestedWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateWithNestedWhereUniqueInput>
}

export type HubPageSectionGeneraltilesUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageSectionGeneraltilesUnionUpsertWithNestedWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpsertWithNestedWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpsertWithNestedWhereUniqueInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileUpsertWithNestedWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpsertWithNestedWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpsertWithNestedWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpsertWithNestedWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpsertWithNestedWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileUpsertWithNestedWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpsertWithNestedWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpsertWithNestedWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionGeneraltilesUnionWhereInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileWhereInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileWhereInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileWhereInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileWhereInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileWhereInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileWhereInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileWhereInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileWhereInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileWhereInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileWhereInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileWhereInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileWhereInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileWhereInput>
}

export type HubPageSectionGeneraltilesUnionWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileWhereUniqueInput>
  HubPageContentSliderTile?: InputMaybe<HubPageContentSliderTileWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereUniqueInput>
  HubPageReviewsTopProductsTile?: InputMaybe<HubPageReviewsTopProductsTileWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileWhereUniqueInput>
}

/** Podcasts Section for Hub Pages */
export type HubPageSectionPodcasts = Entity & {
  __typename?: 'HubPageSectionPodcasts'
  /** List of Podcast Groups with Audio Previews */
  audioPlayerPodcastTrailer: Array<PodcastGroupLink>
  /** Icon for Hub Page Section */
  icon: LucideIcon
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageSectionPodcasts>
  /** List of featured podcast groups */
  portfolioSlider: Array<PodcastGroupLink>
  /** System stage field */
  stage: Stage
  /** Section subtitle */
  subtitle: Scalars['String']['output']
  /** Title/headline for the section. Used for content navigation slider. */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Podcasts Section for Hub Pages */
export type HubPageSectionPodcastsAudioPlayerPodcastTrailerArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PodcastGroupLinkOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastGroupLinkWhereInput>
}

/** Podcasts Section for Hub Pages */
export type HubPageSectionPodcastsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Podcasts Section for Hub Pages */
export type HubPageSectionPodcastsPortfolioSliderArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PodcastGroupLinkOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastGroupLinkWhereInput>
}

/** Podcasts Section for Hub Pages */
export type HubPageSectionPodcastsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageSectionPodcastsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageSectionPodcastsWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageSectionPodcastsConnection = {
  __typename?: 'HubPageSectionPodcastsConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageSectionPodcastsEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageSectionPodcastsCreateInput = {
  audioPlayerPodcastTrailer?: InputMaybe<PodcastGroupLinkCreateManyInlineInput>
  icon: LucideIcon
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageSectionPodcastsCreateLocalizationsInput>
  portfolioSlider?: InputMaybe<PodcastGroupLinkCreateManyInlineInput>
  /** subtitle input for default locale (de) */
  subtitle: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSectionPodcastsCreateLocalizationDataInput = {
  subtitle: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSectionPodcastsCreateLocalizationInput = {
  /** Localization input */
  data: HubPageSectionPodcastsCreateLocalizationDataInput
  locale: Locale
}

export type HubPageSectionPodcastsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageSectionPodcastsCreateLocalizationInput>>
}

export type HubPageSectionPodcastsCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSectionPodcasts documents */
  create?: InputMaybe<Array<HubPageSectionPodcastsCreateInput>>
}

export type HubPageSectionPodcastsCreateOneInlineInput = {
  /** Create and connect one HubPageSectionPodcasts document */
  create?: InputMaybe<HubPageSectionPodcastsCreateInput>
}

export type HubPageSectionPodcastsCreateWithPositionInput = {
  /** Document to create */
  data: HubPageSectionPodcastsCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageSectionPodcastsEdge = {
  __typename?: 'HubPageSectionPodcastsEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageSectionPodcasts
}

/** Identifies documents */
export type HubPageSectionPodcastsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSectionPodcastsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSectionPodcastsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSectionPodcastsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audioPlayerPodcastTrailer_every?: InputMaybe<PodcastGroupLinkWhereInput>
  audioPlayerPodcastTrailer_none?: InputMaybe<PodcastGroupLinkWhereInput>
  audioPlayerPodcastTrailer_some?: InputMaybe<PodcastGroupLinkWhereInput>
  icon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  portfolioSlider_every?: InputMaybe<PodcastGroupLinkWhereInput>
  portfolioSlider_none?: InputMaybe<PodcastGroupLinkWhereInput>
  portfolioSlider_some?: InputMaybe<PodcastGroupLinkWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageSectionPodcastsOrderByInput {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageSectionPodcastsParent = HubPage

export type HubPageSectionPodcastsParentConnectInput = {
  HubPage?: InputMaybe<HubPageConnectInput>
}

export type HubPageSectionPodcastsParentCreateInput = {
  HubPage?: InputMaybe<HubPageCreateInput>
}

export type HubPageSectionPodcastsParentCreateManyInlineInput = {
  /** Connect multiple existing HubPageSectionPodcastsParent documents */
  connect?: InputMaybe<Array<HubPageSectionPodcastsParentWhereUniqueInput>>
  /** Create and connect multiple existing HubPageSectionPodcastsParent documents */
  create?: InputMaybe<Array<HubPageSectionPodcastsParentCreateInput>>
}

export type HubPageSectionPodcastsParentCreateOneInlineInput = {
  /** Connect one existing HubPageSectionPodcastsParent document */
  connect?: InputMaybe<HubPageSectionPodcastsParentWhereUniqueInput>
  /** Create and connect one HubPageSectionPodcastsParent document */
  create?: InputMaybe<HubPageSectionPodcastsParentCreateInput>
}

export type HubPageSectionPodcastsParentUpdateInput = {
  HubPage?: InputMaybe<HubPageUpdateInput>
}

export type HubPageSectionPodcastsParentUpdateManyInlineInput = {
  /** Connect multiple existing HubPageSectionPodcastsParent documents */
  connect?: InputMaybe<Array<HubPageSectionPodcastsParentConnectInput>>
  /** Create and connect multiple HubPageSectionPodcastsParent documents */
  create?: InputMaybe<Array<HubPageSectionPodcastsParentCreateInput>>
  /** Delete multiple HubPageSectionPodcastsParent documents */
  delete?: InputMaybe<Array<HubPageSectionPodcastsParentWhereUniqueInput>>
  /** Disconnect multiple HubPageSectionPodcastsParent documents */
  disconnect?: InputMaybe<Array<HubPageSectionPodcastsParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HubPageSectionPodcastsParent documents */
  set?: InputMaybe<Array<HubPageSectionPodcastsParentWhereUniqueInput>>
  /** Update multiple HubPageSectionPodcastsParent documents */
  update?: InputMaybe<Array<HubPageSectionPodcastsParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HubPageSectionPodcastsParent documents */
  upsert?: InputMaybe<Array<HubPageSectionPodcastsParentUpsertWithNestedWhereUniqueInput>>
}

export type HubPageSectionPodcastsParentUpdateManyWithNestedWhereInput = {
  HubPage?: InputMaybe<HubPageUpdateManyWithNestedWhereInput>
}

export type HubPageSectionPodcastsParentUpdateOneInlineInput = {
  /** Connect existing HubPageSectionPodcastsParent document */
  connect?: InputMaybe<HubPageSectionPodcastsParentWhereUniqueInput>
  /** Create and connect one HubPageSectionPodcastsParent document */
  create?: InputMaybe<HubPageSectionPodcastsParentCreateInput>
  /** Delete currently connected HubPageSectionPodcastsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HubPageSectionPodcastsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionPodcastsParent document */
  update?: InputMaybe<HubPageSectionPodcastsParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionPodcastsParent document */
  upsert?: InputMaybe<HubPageSectionPodcastsParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionPodcastsParentUpdateWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpdateWithNestedWhereUniqueInput>
}

export type HubPageSectionPodcastsParentUpsertWithNestedWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionPodcastsParentWhereInput = {
  HubPage?: InputMaybe<HubPageWhereInput>
}

export type HubPageSectionPodcastsParentWhereUniqueInput = {
  HubPage?: InputMaybe<HubPageWhereUniqueInput>
}

export type HubPageSectionPodcastsUpdateInput = {
  audioPlayerPodcastTrailer?: InputMaybe<PodcastGroupLinkUpdateManyInlineInput>
  icon?: InputMaybe<LucideIcon>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageSectionPodcastsUpdateLocalizationsInput>
  portfolioSlider?: InputMaybe<PodcastGroupLinkUpdateManyInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionPodcastsUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionPodcastsUpdateLocalizationInput = {
  data: HubPageSectionPodcastsUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageSectionPodcastsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageSectionPodcastsCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSectionPodcastsUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageSectionPodcastsUpsertLocalizationInput>>
}

export type HubPageSectionPodcastsUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSectionPodcasts component instances */
  create?: InputMaybe<Array<HubPageSectionPodcastsCreateWithPositionInput>>
  /** Delete multiple HubPageSectionPodcasts documents */
  delete?: InputMaybe<Array<HubPageSectionPodcastsWhereUniqueInput>>
  /** Update multiple HubPageSectionPodcasts component instances */
  update?: InputMaybe<Array<HubPageSectionPodcastsUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSectionPodcasts component instances */
  upsert?: InputMaybe<Array<HubPageSectionPodcastsUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSectionPodcastsUpdateManyInput = {
  icon?: InputMaybe<LucideIcon>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageSectionPodcastsUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionPodcastsUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSectionPodcastsUpdateManyLocalizationInput = {
  data: HubPageSectionPodcastsUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageSectionPodcastsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSectionPodcastsUpdateManyLocalizationInput>>
}

export type HubPageSectionPodcastsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageSectionPodcastsUpdateManyInput
  /** Document search */
  where: HubPageSectionPodcastsWhereInput
}

export type HubPageSectionPodcastsUpdateOneInlineInput = {
  /** Create and connect one HubPageSectionPodcasts document */
  create?: InputMaybe<HubPageSectionPodcastsCreateInput>
  /** Delete currently connected HubPageSectionPodcasts document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSectionPodcasts document */
  update?: InputMaybe<HubPageSectionPodcastsUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSectionPodcasts document */
  upsert?: InputMaybe<HubPageSectionPodcastsUpsertWithNestedWhereUniqueInput>
}

export type HubPageSectionPodcastsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageSectionPodcastsUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSectionPodcastsWhereUniqueInput
}

export type HubPageSectionPodcastsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageSectionPodcastsUpdateInput
  /** Unique document search */
  where: HubPageSectionPodcastsWhereUniqueInput
}

export type HubPageSectionPodcastsUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageSectionPodcastsCreateInput
  /** Update document if it exists */
  update: HubPageSectionPodcastsUpdateInput
}

export type HubPageSectionPodcastsUpsertLocalizationInput = {
  create: HubPageSectionPodcastsCreateLocalizationDataInput
  locale: Locale
  update: HubPageSectionPodcastsUpdateLocalizationDataInput
}

export type HubPageSectionPodcastsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageSectionPodcastsUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSectionPodcastsWhereUniqueInput
}

export type HubPageSectionPodcastsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageSectionPodcastsUpsertInput
  /** Unique document search */
  where: HubPageSectionPodcastsWhereUniqueInput
}

/** Identifies documents */
export type HubPageSectionPodcastsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSectionPodcastsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSectionPodcastsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSectionPodcastsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audioPlayerPodcastTrailer_every?: InputMaybe<PodcastGroupLinkWhereInput>
  audioPlayerPodcastTrailer_none?: InputMaybe<PodcastGroupLinkWhereInput>
  audioPlayerPodcastTrailer_some?: InputMaybe<PodcastGroupLinkWhereInput>
  icon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  portfolioSlider_every?: InputMaybe<PodcastGroupLinkWhereInput>
  portfolioSlider_none?: InputMaybe<PodcastGroupLinkWhereInput>
  portfolioSlider_some?: InputMaybe<PodcastGroupLinkWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageSectionPodcasts record uniquely */
export type HubPageSectionPodcastsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Social Media Tile for Hub Page Sections */
export type HubPageSocialMediaTile = Entity & {
  __typename?: 'HubPageSocialMediaTile'
  /** Social media channel name */
  accountName: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Image for Hub Page Social Media Tile */
  image: Asset
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageSocialMediaTile>
  /** System stage field */
  stage: Stage
  /** Social media channel subtitle */
  subtitle?: Maybe<Scalars['String']['output']>
  /** Tile sizes for Hub Page Social Media Tile */
  tileSizes: HubPageTileSizes
  /** Tracking identifier which will be used to generate data-track attribute */
  trackingId?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Social media channel URL */
  url: Scalars['String']['output']
}

/** Social Media Tile for Hub Page Sections */
export type HubPageSocialMediaTileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Social Media Tile for Hub Page Sections */
export type HubPageSocialMediaTileLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Social Media Tile for Hub Page Sections */
export type HubPageSocialMediaTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Social Media Tile for Hub Page Sections */
export type HubPageSocialMediaTileUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageSocialMediaTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageSocialMediaTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageSocialMediaTileConnection = {
  __typename?: 'HubPageSocialMediaTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageSocialMediaTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageSocialMediaTileCreateInput = {
  /** accountName input for default locale (de) */
  accountName: Scalars['String']['input']
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageSocialMediaTileCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tileSizes: HubPageTileSizesCreateOneInlineInput
  trackingId?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** url input for default locale (de) */
  url: Scalars['String']['input']
}

export type HubPageSocialMediaTileCreateLocalizationDataInput = {
  accountName: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  url: Scalars['String']['input']
}

export type HubPageSocialMediaTileCreateLocalizationInput = {
  /** Localization input */
  data: HubPageSocialMediaTileCreateLocalizationDataInput
  locale: Locale
}

export type HubPageSocialMediaTileCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageSocialMediaTileCreateLocalizationInput>>
}

export type HubPageSocialMediaTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSocialMediaTile documents */
  create?: InputMaybe<Array<HubPageSocialMediaTileCreateInput>>
}

export type HubPageSocialMediaTileCreateOneInlineInput = {
  /** Create and connect one HubPageSocialMediaTile document */
  create?: InputMaybe<HubPageSocialMediaTileCreateInput>
}

export type HubPageSocialMediaTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageSocialMediaTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageSocialMediaTileEdge = {
  __typename?: 'HubPageSocialMediaTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageSocialMediaTile
}

/** Identifies documents */
export type HubPageSocialMediaTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSocialMediaTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSocialMediaTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSocialMediaTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  trackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  trackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  trackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  trackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  trackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  trackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  trackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  trackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  trackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageSocialMediaTileOrderByInput {
  AccountNameAsc = 'accountName_ASC',
  AccountNameDesc = 'accountName_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TrackingIdAsc = 'trackingId_ASC',
  TrackingIdDesc = 'trackingId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
}

export type HubPageSocialMediaTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageSocialMediaTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageSocialMediaTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageSocialMediaTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSocialMediaTileParent documents */
  create?: InputMaybe<Array<HubPageSocialMediaTileParentCreateInput>>
}

export type HubPageSocialMediaTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageSocialMediaTileParent document */
  create?: InputMaybe<HubPageSocialMediaTileParentCreateInput>
}

export type HubPageSocialMediaTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageSocialMediaTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageSocialMediaTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSocialMediaTileParent component instances */
  create?: InputMaybe<Array<HubPageSocialMediaTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageSocialMediaTileParent documents */
  delete?: InputMaybe<Array<HubPageSocialMediaTileParentWhereUniqueInput>>
  /** Update multiple HubPageSocialMediaTileParent component instances */
  update?: InputMaybe<Array<HubPageSocialMediaTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSocialMediaTileParent component instances */
  upsert?: InputMaybe<Array<HubPageSocialMediaTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSocialMediaTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageSocialMediaTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageSocialMediaTileParent document */
  create?: InputMaybe<HubPageSocialMediaTileParentCreateInput>
  /** Delete currently connected HubPageSocialMediaTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSocialMediaTileParent document */
  update?: InputMaybe<HubPageSocialMediaTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSocialMediaTileParent document */
  upsert?: InputMaybe<HubPageSocialMediaTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageSocialMediaTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageSocialMediaTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageSocialMediaTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageSocialMediaTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageSocialMediaTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageSocialMediaTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageSocialMediaTileUpdateInput = {
  /** accountName input for default locale (de) */
  accountName?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageSocialMediaTileUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** url input for default locale (de) */
  url?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSocialMediaTileUpdateLocalizationDataInput = {
  accountName?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSocialMediaTileUpdateLocalizationInput = {
  data: HubPageSocialMediaTileUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageSocialMediaTileUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageSocialMediaTileCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSocialMediaTileUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageSocialMediaTileUpsertLocalizationInput>>
}

export type HubPageSocialMediaTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSocialMediaTile component instances */
  create?: InputMaybe<Array<HubPageSocialMediaTileCreateWithPositionInput>>
  /** Delete multiple HubPageSocialMediaTile documents */
  delete?: InputMaybe<Array<HubPageSocialMediaTileWhereUniqueInput>>
  /** Update multiple HubPageSocialMediaTile component instances */
  update?: InputMaybe<Array<HubPageSocialMediaTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSocialMediaTile component instances */
  upsert?: InputMaybe<Array<HubPageSocialMediaTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSocialMediaTileUpdateManyInput = {
  /** accountName input for default locale (de) */
  accountName?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageSocialMediaTileUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** url input for default locale (de) */
  url?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSocialMediaTileUpdateManyLocalizationDataInput = {
  accountName?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSocialMediaTileUpdateManyLocalizationInput = {
  data: HubPageSocialMediaTileUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageSocialMediaTileUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSocialMediaTileUpdateManyLocalizationInput>>
}

export type HubPageSocialMediaTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageSocialMediaTileUpdateManyInput
  /** Document search */
  where: HubPageSocialMediaTileWhereInput
}

export type HubPageSocialMediaTileUpdateOneInlineInput = {
  /** Create and connect one HubPageSocialMediaTile document */
  create?: InputMaybe<HubPageSocialMediaTileCreateInput>
  /** Delete currently connected HubPageSocialMediaTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSocialMediaTile document */
  update?: InputMaybe<HubPageSocialMediaTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSocialMediaTile document */
  upsert?: InputMaybe<HubPageSocialMediaTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageSocialMediaTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageSocialMediaTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSocialMediaTileWhereUniqueInput
}

export type HubPageSocialMediaTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageSocialMediaTileUpdateInput
  /** Unique document search */
  where: HubPageSocialMediaTileWhereUniqueInput
}

export type HubPageSocialMediaTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageSocialMediaTileCreateInput
  /** Update document if it exists */
  update: HubPageSocialMediaTileUpdateInput
}

export type HubPageSocialMediaTileUpsertLocalizationInput = {
  create: HubPageSocialMediaTileCreateLocalizationDataInput
  locale: Locale
  update: HubPageSocialMediaTileUpdateLocalizationDataInput
}

export type HubPageSocialMediaTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageSocialMediaTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSocialMediaTileWhereUniqueInput
}

export type HubPageSocialMediaTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageSocialMediaTileUpsertInput
  /** Unique document search */
  where: HubPageSocialMediaTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageSocialMediaTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSocialMediaTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSocialMediaTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSocialMediaTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  accountName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  accountName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  accountName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  accountName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  accountName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  accountName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  accountName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  accountName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  accountName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  accountName_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  trackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  trackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  trackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  trackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  trackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  trackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  trackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  trackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  trackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  trackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** References HubPageSocialMediaTile record uniquely */
export type HubPageSocialMediaTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Speaker Tile for Hub Page Sections */
export type HubPageSpeakerTile = Entity & {
  __typename?: 'HubPageSpeakerTile'
  /** Call to action for Hub Page Speaker Tile */
  cta: CallToAction
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<HubPageSpeakerTile>
  /** Link to list of speakers shown in this tile */
  speakers: SpeakerListOrder
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Speaker Tile */
  tileSizes: HubPageTileSizes
  /** Speaker tile title */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Speaker Tile for Hub Page Sections */
export type HubPageSpeakerTileCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Speaker Tile for Hub Page Sections */
export type HubPageSpeakerTileLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Speaker Tile for Hub Page Sections */
export type HubPageSpeakerTileSpeakersArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Speaker Tile for Hub Page Sections */
export type HubPageSpeakerTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Speaker Tile for Hub Page Sections */
export type HubPageSpeakerTileUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type HubPageSpeakerTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageSpeakerTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageSpeakerTileConnection = {
  __typename?: 'HubPageSpeakerTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageSpeakerTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageSpeakerTileCreateInput = {
  cta: CallToActionCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HubPageSpeakerTileCreateLocalizationsInput>
  speakers: SpeakerListOrderCreateOneInlineInput
  tileSizes: HubPageTileSizesCreateOneInlineInput
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSpeakerTileCreateLocalizationDataInput = {
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageSpeakerTileCreateLocalizationInput = {
  /** Localization input */
  data: HubPageSpeakerTileCreateLocalizationDataInput
  locale: Locale
}

export type HubPageSpeakerTileCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HubPageSpeakerTileCreateLocalizationInput>>
}

export type HubPageSpeakerTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSpeakerTile documents */
  create?: InputMaybe<Array<HubPageSpeakerTileCreateInput>>
}

export type HubPageSpeakerTileCreateOneInlineInput = {
  /** Create and connect one HubPageSpeakerTile document */
  create?: InputMaybe<HubPageSpeakerTileCreateInput>
}

export type HubPageSpeakerTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageSpeakerTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageSpeakerTileEdge = {
  __typename?: 'HubPageSpeakerTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageSpeakerTile
}

/** Identifies documents */
export type HubPageSpeakerTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSpeakerTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSpeakerTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSpeakerTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  speakers?: InputMaybe<SpeakerListOrderWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageSpeakerTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageSpeakerTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageSpeakerTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageSpeakerTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageSpeakerTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageSpeakerTileParent documents */
  create?: InputMaybe<Array<HubPageSpeakerTileParentCreateInput>>
}

export type HubPageSpeakerTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageSpeakerTileParent document */
  create?: InputMaybe<HubPageSpeakerTileParentCreateInput>
}

export type HubPageSpeakerTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageSpeakerTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageSpeakerTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSpeakerTileParent component instances */
  create?: InputMaybe<Array<HubPageSpeakerTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageSpeakerTileParent documents */
  delete?: InputMaybe<Array<HubPageSpeakerTileParentWhereUniqueInput>>
  /** Update multiple HubPageSpeakerTileParent component instances */
  update?: InputMaybe<Array<HubPageSpeakerTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSpeakerTileParent component instances */
  upsert?: InputMaybe<Array<HubPageSpeakerTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSpeakerTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageSpeakerTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageSpeakerTileParent document */
  create?: InputMaybe<HubPageSpeakerTileParentCreateInput>
  /** Delete currently connected HubPageSpeakerTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSpeakerTileParent document */
  update?: InputMaybe<HubPageSpeakerTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSpeakerTileParent document */
  upsert?: InputMaybe<HubPageSpeakerTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageSpeakerTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageSpeakerTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageSpeakerTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageSpeakerTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageSpeakerTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageSpeakerTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export type HubPageSpeakerTileUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageSpeakerTileUpdateLocalizationsInput>
  speakers?: InputMaybe<SpeakerListOrderUpdateOneInlineInput>
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSpeakerTileUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSpeakerTileUpdateLocalizationInput = {
  data: HubPageSpeakerTileUpdateLocalizationDataInput
  locale: Locale
}

export type HubPageSpeakerTileUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageSpeakerTileCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSpeakerTileUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<HubPageSpeakerTileUpsertLocalizationInput>>
}

export type HubPageSpeakerTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageSpeakerTile component instances */
  create?: InputMaybe<Array<HubPageSpeakerTileCreateWithPositionInput>>
  /** Delete multiple HubPageSpeakerTile documents */
  delete?: InputMaybe<Array<HubPageSpeakerTileWhereUniqueInput>>
  /** Update multiple HubPageSpeakerTile component instances */
  update?: InputMaybe<Array<HubPageSpeakerTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageSpeakerTile component instances */
  upsert?: InputMaybe<Array<HubPageSpeakerTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageSpeakerTileUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<HubPageSpeakerTileUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSpeakerTileUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type HubPageSpeakerTileUpdateManyLocalizationInput = {
  data: HubPageSpeakerTileUpdateManyLocalizationDataInput
  locale: Locale
}

export type HubPageSpeakerTileUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HubPageSpeakerTileUpdateManyLocalizationInput>>
}

export type HubPageSpeakerTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageSpeakerTileUpdateManyInput
  /** Document search */
  where: HubPageSpeakerTileWhereInput
}

export type HubPageSpeakerTileUpdateOneInlineInput = {
  /** Create and connect one HubPageSpeakerTile document */
  create?: InputMaybe<HubPageSpeakerTileCreateInput>
  /** Delete currently connected HubPageSpeakerTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageSpeakerTile document */
  update?: InputMaybe<HubPageSpeakerTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageSpeakerTile document */
  upsert?: InputMaybe<HubPageSpeakerTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageSpeakerTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageSpeakerTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSpeakerTileWhereUniqueInput
}

export type HubPageSpeakerTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageSpeakerTileUpdateInput
  /** Unique document search */
  where: HubPageSpeakerTileWhereUniqueInput
}

export type HubPageSpeakerTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageSpeakerTileCreateInput
  /** Update document if it exists */
  update: HubPageSpeakerTileUpdateInput
}

export type HubPageSpeakerTileUpsertLocalizationInput = {
  create: HubPageSpeakerTileCreateLocalizationDataInput
  locale: Locale
  update: HubPageSpeakerTileUpdateLocalizationDataInput
}

export type HubPageSpeakerTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageSpeakerTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageSpeakerTileWhereUniqueInput
}

export type HubPageSpeakerTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageSpeakerTileUpsertInput
  /** Unique document search */
  where: HubPageSpeakerTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageSpeakerTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageSpeakerTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageSpeakerTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageSpeakerTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  speakers?: InputMaybe<SpeakerListOrderWhereInput>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageSpeakerTile record uniquely */
export type HubPageSpeakerTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** A static hub tile */
export type HubPageStaticTile = Entity & {
  __typename?: 'HubPageStaticTile'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System stage field */
  stage: Stage
  /** Tile sizes for Hub Page Static Tile */
  tileSizes: HubPageTileSizes
  /** Option to identify which tile to render */
  tileType: HubPageStaticTileType
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** A static hub tile */
export type HubPageStaticTileTileSizesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type HubPageStaticTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageStaticTileWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageStaticTileConnection = {
  __typename?: 'HubPageStaticTileConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageStaticTileEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageStaticTileCreateInput = {
  tileSizes: HubPageTileSizesCreateOneInlineInput
  tileType: HubPageStaticTileType
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageStaticTileCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageStaticTile documents */
  create?: InputMaybe<Array<HubPageStaticTileCreateInput>>
}

export type HubPageStaticTileCreateOneInlineInput = {
  /** Create and connect one HubPageStaticTile document */
  create?: InputMaybe<HubPageStaticTileCreateInput>
}

export type HubPageStaticTileCreateWithPositionInput = {
  /** Document to create */
  data: HubPageStaticTileCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageStaticTileEdge = {
  __typename?: 'HubPageStaticTileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageStaticTile
}

/** Identifies documents */
export type HubPageStaticTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageStaticTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageStaticTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageStaticTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  tileType?: InputMaybe<HubPageStaticTileType>
  /** All values that are contained in given list. */
  tileType_in?: InputMaybe<Array<InputMaybe<HubPageStaticTileType>>>
  /** Any other value that exists and is not equal to the given value. */
  tileType_not?: InputMaybe<HubPageStaticTileType>
  /** All values that are not contained in given list. */
  tileType_not_in?: InputMaybe<Array<InputMaybe<HubPageStaticTileType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageStaticTileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TileTypeAsc = 'tileType_ASC',
  TileTypeDesc = 'tileType_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageStaticTileParent = HubPageSectionGeneral | SectionTiles

export type HubPageStaticTileParentConnectInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
}

export type HubPageStaticTileParentCreateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
}

export type HubPageStaticTileParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageStaticTileParent documents */
  create?: InputMaybe<Array<HubPageStaticTileParentCreateInput>>
}

export type HubPageStaticTileParentCreateOneInlineInput = {
  /** Create and connect one HubPageStaticTileParent document */
  create?: InputMaybe<HubPageStaticTileParentCreateInput>
}

export type HubPageStaticTileParentCreateWithPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
}

export type HubPageStaticTileParentUpdateInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
}

export type HubPageStaticTileParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageStaticTileParent component instances */
  create?: InputMaybe<Array<HubPageStaticTileParentCreateWithPositionInput>>
  /** Delete multiple HubPageStaticTileParent documents */
  delete?: InputMaybe<Array<HubPageStaticTileParentWhereUniqueInput>>
  /** Update multiple HubPageStaticTileParent component instances */
  update?: InputMaybe<Array<HubPageStaticTileParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageStaticTileParent component instances */
  upsert?: InputMaybe<Array<HubPageStaticTileParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageStaticTileParentUpdateManyWithNestedWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
}

export type HubPageStaticTileParentUpdateOneInlineInput = {
  /** Create and connect one HubPageStaticTileParent document */
  create?: InputMaybe<HubPageStaticTileParentCreateInput>
  /** Delete currently connected HubPageStaticTileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageStaticTileParent document */
  update?: InputMaybe<HubPageStaticTileParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageStaticTileParent document */
  upsert?: InputMaybe<HubPageStaticTileParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageStaticTileParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageStaticTileParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
}

export type HubPageStaticTileParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageStaticTileParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type HubPageStaticTileParentWhereInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
}

export type HubPageStaticTileParentWhereUniqueInput = {
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
}

export enum HubPageStaticTileType {
  TopJobsTile = 'TopJobsTile',
}

export type HubPageStaticTileUpdateInput = {
  tileSizes?: InputMaybe<HubPageTileSizesUpdateOneInlineInput>
  tileType?: InputMaybe<HubPageStaticTileType>
}

export type HubPageStaticTileUpdateManyInlineInput = {
  /** Create and connect multiple HubPageStaticTile component instances */
  create?: InputMaybe<Array<HubPageStaticTileCreateWithPositionInput>>
  /** Delete multiple HubPageStaticTile documents */
  delete?: InputMaybe<Array<HubPageStaticTileWhereUniqueInput>>
  /** Update multiple HubPageStaticTile component instances */
  update?: InputMaybe<Array<HubPageStaticTileUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageStaticTile component instances */
  upsert?: InputMaybe<Array<HubPageStaticTileUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageStaticTileUpdateManyInput = {
  tileType?: InputMaybe<HubPageStaticTileType>
}

export type HubPageStaticTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageStaticTileUpdateManyInput
  /** Document search */
  where: HubPageStaticTileWhereInput
}

export type HubPageStaticTileUpdateOneInlineInput = {
  /** Create and connect one HubPageStaticTile document */
  create?: InputMaybe<HubPageStaticTileCreateInput>
  /** Delete currently connected HubPageStaticTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageStaticTile document */
  update?: InputMaybe<HubPageStaticTileUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageStaticTile document */
  upsert?: InputMaybe<HubPageStaticTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageStaticTileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageStaticTileUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageStaticTileWhereUniqueInput
}

export type HubPageStaticTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageStaticTileUpdateInput
  /** Unique document search */
  where: HubPageStaticTileWhereUniqueInput
}

export type HubPageStaticTileUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageStaticTileCreateInput
  /** Update document if it exists */
  update: HubPageStaticTileUpdateInput
}

export type HubPageStaticTileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageStaticTileUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageStaticTileWhereUniqueInput
}

export type HubPageStaticTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageStaticTileUpsertInput
  /** Unique document search */
  where: HubPageStaticTileWhereUniqueInput
}

/** Identifies documents */
export type HubPageStaticTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageStaticTileWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageStaticTileWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageStaticTileWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  tileSizes?: InputMaybe<HubPageTileSizesWhereInput>
  tileType?: InputMaybe<HubPageStaticTileType>
  /** All values that are contained in given list. */
  tileType_in?: InputMaybe<Array<InputMaybe<HubPageStaticTileType>>>
  /** Any other value that exists and is not equal to the given value. */
  tileType_not?: InputMaybe<HubPageStaticTileType>
  /** All values that are not contained in given list. */
  tileType_not_in?: InputMaybe<Array<InputMaybe<HubPageStaticTileType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageStaticTile record uniquely */
export type HubPageStaticTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Defines the size of the tile */
export enum HubPageTileSize {
  Full = 'full',
  Half = 'half',
  Hidden = 'hidden',
  OneThird = 'oneThird',
  TwoThirds = 'twoThirds',
}

/** Tile sizes for Hub Page Sections */
export type HubPageTileSizes = Entity & {
  __typename?: 'HubPageTileSizes'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Size of the tile on laptop and desktop */
  laptopSize: HubPageTileSize
  /** Size of the tile on mobile */
  mobileSize: HubPageTileSize
  /** System stage field */
  stage: Stage
  /** Size of the tile on tablet */
  tabletSize: HubPageTileSize
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type HubPageTileSizesConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: HubPageTileSizesWhereUniqueInput
}

/** A connection to a list of items. */
export type HubPageTileSizesConnection = {
  __typename?: 'HubPageTileSizesConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<HubPageTileSizesEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type HubPageTileSizesCreateInput = {
  laptopSize: HubPageTileSize
  mobileSize: HubPageTileSize
  tabletSize: HubPageTileSize
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type HubPageTileSizesCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageTileSizes documents */
  create?: InputMaybe<Array<HubPageTileSizesCreateInput>>
}

export type HubPageTileSizesCreateOneInlineInput = {
  /** Create and connect one HubPageTileSizes document */
  create?: InputMaybe<HubPageTileSizesCreateInput>
}

export type HubPageTileSizesCreateWithPositionInput = {
  /** Document to create */
  data: HubPageTileSizesCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type HubPageTileSizesEdge = {
  __typename?: 'HubPageTileSizesEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: HubPageTileSizes
}

/** Identifies documents */
export type HubPageTileSizesManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageTileSizesWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageTileSizesWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageTileSizesWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  laptopSize?: InputMaybe<HubPageTileSize>
  /** All values that are contained in given list. */
  laptopSize_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  /** Any other value that exists and is not equal to the given value. */
  laptopSize_not?: InputMaybe<HubPageTileSize>
  /** All values that are not contained in given list. */
  laptopSize_not_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  mobileSize?: InputMaybe<HubPageTileSize>
  /** All values that are contained in given list. */
  mobileSize_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  /** Any other value that exists and is not equal to the given value. */
  mobileSize_not?: InputMaybe<HubPageTileSize>
  /** All values that are not contained in given list. */
  mobileSize_not_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  tabletSize?: InputMaybe<HubPageTileSize>
  /** All values that are contained in given list. */
  tabletSize_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  /** Any other value that exists and is not equal to the given value. */
  tabletSize_not?: InputMaybe<HubPageTileSize>
  /** All values that are not contained in given list. */
  tabletSize_not_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum HubPageTileSizesOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LaptopSizeAsc = 'laptopSize_ASC',
  LaptopSizeDesc = 'laptopSize_DESC',
  MobileSizeAsc = 'mobileSize_ASC',
  MobileSizeDesc = 'mobileSize_DESC',
  TabletSizeAsc = 'tabletSize_ASC',
  TabletSizeDesc = 'tabletSize_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type HubPageTileSizesParent =
  | HubPageAdTile
  | HubPageArticleListTile
  | HubPageContentTile
  | HubPageImageTile
  | HubPageInfoTile
  | HubPageLatestArticleTile
  | HubPageNewsletterSubscriptionTile
  | HubPagePartnerCompanyTile
  | HubPageReferenceListTile
  | HubPageSocialMediaTile
  | HubPageSpeakerTile
  | HubPageStaticTile

export type HubPageTileSizesParentConnectInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileConnectInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileConnectInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileConnectInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileConnectInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileConnectInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileConnectInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileConnectInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileConnectInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileConnectInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileConnectInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileConnectInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileConnectInput>
}

export type HubPageTileSizesParentCreateInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileCreateInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileCreateInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileCreateInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileCreateInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileCreateInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileCreateInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileCreateInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileCreateInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileCreateInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileCreateInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileCreateInput>
}

export type HubPageTileSizesParentCreateManyInlineInput = {
  /** Create and connect multiple existing HubPageTileSizesParent documents */
  create?: InputMaybe<Array<HubPageTileSizesParentCreateInput>>
}

export type HubPageTileSizesParentCreateOneInlineInput = {
  /** Create and connect one HubPageTileSizesParent document */
  create?: InputMaybe<HubPageTileSizesParentCreateInput>
}

export type HubPageTileSizesParentCreateWithPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileCreateWithPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileCreateWithPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileCreateWithPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileCreateWithPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileCreateWithPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileCreateWithPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileCreateWithPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileCreateWithPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateWithPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileCreateWithPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileCreateWithPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileCreateWithPositionInput>
}

export type HubPageTileSizesParentUpdateInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateInput>
}

export type HubPageTileSizesParentUpdateManyInlineInput = {
  /** Create and connect multiple HubPageTileSizesParent component instances */
  create?: InputMaybe<Array<HubPageTileSizesParentCreateWithPositionInput>>
  /** Delete multiple HubPageTileSizesParent documents */
  delete?: InputMaybe<Array<HubPageTileSizesParentWhereUniqueInput>>
  /** Update multiple HubPageTileSizesParent component instances */
  update?: InputMaybe<Array<HubPageTileSizesParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageTileSizesParent component instances */
  upsert?: InputMaybe<Array<HubPageTileSizesParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageTileSizesParentUpdateManyWithNestedWhereInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateManyWithNestedWhereInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateManyWithNestedWhereInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateManyWithNestedWhereInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateManyWithNestedWhereInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateManyWithNestedWhereInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateManyWithNestedWhereInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateManyWithNestedWhereInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateManyWithNestedWhereInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateManyWithNestedWhereInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateManyWithNestedWhereInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateManyWithNestedWhereInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateManyWithNestedWhereInput>
}

export type HubPageTileSizesParentUpdateOneInlineInput = {
  /** Create and connect one HubPageTileSizesParent document */
  create?: InputMaybe<HubPageTileSizesParentCreateInput>
  /** Delete currently connected HubPageTileSizesParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageTileSizesParent document */
  update?: InputMaybe<HubPageTileSizesParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageTileSizesParent document */
  upsert?: InputMaybe<HubPageTileSizesParentUpsertWithNestedWhereUniqueInput>
}

export type HubPageTileSizesParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPageTileSizesParentUpdateWithNestedWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateWithNestedWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateWithNestedWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateWithNestedWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateWithNestedWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateWithNestedWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateWithNestedWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateWithNestedWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateWithNestedWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateWithNestedWhereUniqueInput>
}

export type HubPageTileSizesParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPageTileSizesParentUpsertWithNestedWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpsertWithNestedWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpsertWithNestedWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpsertWithNestedWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpsertWithNestedWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpsertWithNestedWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpsertWithNestedWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpsertWithNestedWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpsertWithNestedWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpsertWithNestedWhereUniqueInput>
}

export type HubPageTileSizesParentWhereInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileWhereInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileWhereInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileWhereInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileWhereInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileWhereInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileWhereInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileWhereInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileWhereInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileWhereInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileWhereInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileWhereInput>
}

export type HubPageTileSizesParentWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileWhereUniqueInput>
}

export type HubPageTileSizesUpdateInput = {
  laptopSize?: InputMaybe<HubPageTileSize>
  mobileSize?: InputMaybe<HubPageTileSize>
  tabletSize?: InputMaybe<HubPageTileSize>
}

export type HubPageTileSizesUpdateManyInlineInput = {
  /** Create and connect multiple HubPageTileSizes component instances */
  create?: InputMaybe<Array<HubPageTileSizesCreateWithPositionInput>>
  /** Delete multiple HubPageTileSizes documents */
  delete?: InputMaybe<Array<HubPageTileSizesWhereUniqueInput>>
  /** Update multiple HubPageTileSizes component instances */
  update?: InputMaybe<Array<HubPageTileSizesUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPageTileSizes component instances */
  upsert?: InputMaybe<Array<HubPageTileSizesUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPageTileSizesUpdateManyInput = {
  laptopSize?: InputMaybe<HubPageTileSize>
  mobileSize?: InputMaybe<HubPageTileSize>
  tabletSize?: InputMaybe<HubPageTileSize>
}

export type HubPageTileSizesUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageTileSizesUpdateManyInput
  /** Document search */
  where: HubPageTileSizesWhereInput
}

export type HubPageTileSizesUpdateOneInlineInput = {
  /** Create and connect one HubPageTileSizes document */
  create?: InputMaybe<HubPageTileSizesCreateInput>
  /** Delete currently connected HubPageTileSizes document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPageTileSizes document */
  update?: InputMaybe<HubPageTileSizesUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPageTileSizes document */
  upsert?: InputMaybe<HubPageTileSizesUpsertWithNestedWhereUniqueInput>
}

export type HubPageTileSizesUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubPageTileSizesUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageTileSizesWhereUniqueInput
}

export type HubPageTileSizesUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageTileSizesUpdateInput
  /** Unique document search */
  where: HubPageTileSizesWhereUniqueInput
}

export type HubPageTileSizesUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageTileSizesCreateInput
  /** Update document if it exists */
  update: HubPageTileSizesUpdateInput
}

export type HubPageTileSizesUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubPageTileSizesUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: HubPageTileSizesWhereUniqueInput
}

export type HubPageTileSizesUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageTileSizesUpsertInput
  /** Unique document search */
  where: HubPageTileSizesWhereUniqueInput
}

/** Identifies documents */
export type HubPageTileSizesWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageTileSizesWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageTileSizesWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageTileSizesWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  laptopSize?: InputMaybe<HubPageTileSize>
  /** All values that are contained in given list. */
  laptopSize_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  /** Any other value that exists and is not equal to the given value. */
  laptopSize_not?: InputMaybe<HubPageTileSize>
  /** All values that are not contained in given list. */
  laptopSize_not_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  mobileSize?: InputMaybe<HubPageTileSize>
  /** All values that are contained in given list. */
  mobileSize_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  /** Any other value that exists and is not equal to the given value. */
  mobileSize_not?: InputMaybe<HubPageTileSize>
  /** All values that are not contained in given list. */
  mobileSize_not_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  tabletSize?: InputMaybe<HubPageTileSize>
  /** All values that are contained in given list. */
  tabletSize_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  /** Any other value that exists and is not equal to the given value. */
  tabletSize_not?: InputMaybe<HubPageTileSize>
  /** All values that are not contained in given list. */
  tabletSize_not_in?: InputMaybe<Array<InputMaybe<HubPageTileSize>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References HubPageTileSizes record uniquely */
export type HubPageTileSizesWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type HubPageUpdateInput = {
  countdownHero?: InputMaybe<HubPageCountdownHeroUpdateOneInlineInput>
  heroSlider?: InputMaybe<HubPageHeroSliderItemUpdateManyInlineInput>
  identifier?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<HubPageUpdateLocalizationsInput>
  sections?: InputMaybe<HubPagesectionsUnionUpdateManyInlineInput>
}

export type HubPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HubPageCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
}

export type HubPageUpdateManyInlineInput = {
  /** Connect multiple existing HubPage documents */
  connect?: InputMaybe<Array<HubPageConnectInput>>
  /** Create and connect multiple HubPage documents */
  create?: InputMaybe<Array<HubPageCreateInput>>
  /** Delete multiple HubPage documents */
  delete?: InputMaybe<Array<HubPageWhereUniqueInput>>
  /** Disconnect multiple HubPage documents */
  disconnect?: InputMaybe<Array<HubPageWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing HubPage documents */
  set?: InputMaybe<Array<HubPageWhereUniqueInput>>
  /** Update multiple HubPage documents */
  update?: InputMaybe<Array<HubPageUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple HubPage documents */
  upsert?: InputMaybe<Array<HubPageUpsertWithNestedWhereUniqueInput>>
}

export type HubPageUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type HubPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubPageUpdateManyInput
  /** Document search */
  where: HubPageWhereInput
}

export type HubPageUpdateOneInlineInput = {
  /** Connect existing HubPage document */
  connect?: InputMaybe<HubPageWhereUniqueInput>
  /** Create and connect one HubPage document */
  create?: InputMaybe<HubPageCreateInput>
  /** Delete currently connected HubPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected HubPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPage document */
  update?: InputMaybe<HubPageUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPage document */
  upsert?: InputMaybe<HubPageUpsertWithNestedWhereUniqueInput>
}

export type HubPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubPageUpdateInput
  /** Unique document search */
  where: HubPageWhereUniqueInput
}

export type HubPageUpsertInput = {
  /** Create document if it didn't exist */
  create: HubPageCreateInput
  /** Update document if it exists */
  update: HubPageUpdateInput
}

export type HubPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubPageUpsertInput
  /** Unique document search */
  where: HubPageWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type HubPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type HubPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  countdownHero?: InputMaybe<HubPageCountdownHeroWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<HubPageWhereStageInput>
  documentInStages_none?: InputMaybe<HubPageWhereStageInput>
  documentInStages_some?: InputMaybe<HubPageWhereStageInput>
  heroSlider_every?: InputMaybe<HubPageHeroSliderItemWhereInput>
  heroSlider_none?: InputMaybe<HubPageHeroSliderItemWhereInput>
  heroSlider_some?: InputMaybe<HubPageHeroSliderItemWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  identifier_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  identifier_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  identifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  identifier_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  identifier_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  identifier_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  identifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  identifier_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  identifier_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  /** All values in which the union is empty. */
  sections_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  sections_some?: InputMaybe<HubPagesectionsUnionWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HubPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubPageWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubPageWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubPageWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HubPageWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References HubPage record uniquely */
export type HubPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
}

export type HubPagesectionsUnion =
  | HubPageSectionContentLibrary
  | HubPageSectionFestivalEvents
  | HubPageSectionGeneral
  | HubPageSectionPodcasts

export type HubPagesectionsUnionConnectInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryConnectInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsConnectInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralConnectInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsConnectInput>
}

export type HubPagesectionsUnionCreateInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryCreateInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsCreateInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsCreateInput>
}

export type HubPagesectionsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing HubPagesectionsUnion documents */
  create?: InputMaybe<Array<HubPagesectionsUnionCreateInput>>
}

export type HubPagesectionsUnionCreateOneInlineInput = {
  /** Create and connect one HubPagesectionsUnion document */
  create?: InputMaybe<HubPagesectionsUnionCreateInput>
}

export type HubPagesectionsUnionCreateWithPositionInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryCreateWithPositionInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsCreateWithPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralCreateWithPositionInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsCreateWithPositionInput>
}

export type HubPagesectionsUnionUpdateInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryUpdateInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsUpdateInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpdateInput>
}

export type HubPagesectionsUnionUpdateManyInlineInput = {
  /** Create and connect multiple HubPagesectionsUnion component instances */
  create?: InputMaybe<Array<HubPagesectionsUnionCreateWithPositionInput>>
  /** Delete multiple HubPagesectionsUnion documents */
  delete?: InputMaybe<Array<HubPagesectionsUnionWhereUniqueInput>>
  /** Update multiple HubPagesectionsUnion component instances */
  update?: InputMaybe<Array<HubPagesectionsUnionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple HubPagesectionsUnion component instances */
  upsert?: InputMaybe<Array<HubPagesectionsUnionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type HubPagesectionsUnionUpdateManyWithNestedWhereInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryUpdateManyWithNestedWhereInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsUpdateManyWithNestedWhereInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateManyWithNestedWhereInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpdateManyWithNestedWhereInput>
}

export type HubPagesectionsUnionUpdateOneInlineInput = {
  /** Create and connect one HubPagesectionsUnion document */
  create?: InputMaybe<HubPagesectionsUnionCreateInput>
  /** Delete currently connected HubPagesectionsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single HubPagesectionsUnion document */
  update?: InputMaybe<HubPagesectionsUnionUpdateWithNestedWhereUniqueInput>
  /** Upsert single HubPagesectionsUnion document */
  upsert?: InputMaybe<HubPagesectionsUnionUpsertWithNestedWhereUniqueInput>
}

export type HubPagesectionsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpdateWithNestedWhereUniqueAndPositionInput>
}

export type HubPagesectionsUnionUpdateWithNestedWhereUniqueInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryUpdateWithNestedWhereUniqueInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsUpdateWithNestedWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpdateWithNestedWhereUniqueInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpdateWithNestedWhereUniqueInput>
}

export type HubPagesectionsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpsertWithNestedWhereUniqueAndPositionInput>
}

export type HubPagesectionsUnionUpsertWithNestedWhereUniqueInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryUpsertWithNestedWhereUniqueInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsUpsertWithNestedWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralUpsertWithNestedWhereUniqueInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpsertWithNestedWhereUniqueInput>
}

export type HubPagesectionsUnionWhereInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryWhereInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsWhereInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsWhereInput>
}

export type HubPagesectionsUnionWhereUniqueInput = {
  HubPageSectionContentLibrary?: InputMaybe<HubPageSectionContentLibraryWhereUniqueInput>
  HubPageSectionFestivalEvents?: InputMaybe<HubPageSectionFestivalEventsWhereUniqueInput>
  HubPageSectionGeneral?: InputMaybe<HubPageSectionGeneralWhereUniqueInput>
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsWhereUniqueInput>
}

export enum IconEnum {
  MdiAccountMultipleOutline = 'mdiAccountMultipleOutline',
  MdiChat = 'mdiChat',
  MdiHomeCityOutline = 'mdiHomeCityOutline',
  MdiMapMarkerOutline = 'mdiMapMarkerOutline',
  MdiStarOutline = 'mdiStarOutline',
  MdiTarget = 'mdiTarget',
}

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input']
}

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input']
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input']
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input']
}

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input']
}

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input']
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input']
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input']
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input']
}

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  Crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  Max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  Scale = 'scale',
}

/** Image gallery to be embedded in the rich text editor */
export type ImageGalleryEmbed = Entity &
  Node & {
    __typename?: 'ImageGalleryEmbed'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<ImageGalleryEmbed>
    /** List of ImageGalleryEmbed versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Images to be displayed in the gallery */
    images: Array<Asset>
    /** Name of the gallery to distinguish it from other galleries */
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Image gallery to be embedded in the rich text editor */
export type ImageGalleryEmbedCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Image gallery to be embedded in the rich text editor */
export type ImageGalleryEmbedDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Image gallery to be embedded in the rich text editor */
export type ImageGalleryEmbedHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Image gallery to be embedded in the rich text editor */
export type ImageGalleryEmbedImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<AssetOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AssetWhereInput>
}

/** Image gallery to be embedded in the rich text editor */
export type ImageGalleryEmbedPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Image gallery to be embedded in the rich text editor */
export type ImageGalleryEmbedScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Image gallery to be embedded in the rich text editor */
export type ImageGalleryEmbedUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ImageGalleryEmbedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ImageGalleryEmbedWhereUniqueInput
}

/** A connection to a list of items. */
export type ImageGalleryEmbedConnection = {
  __typename?: 'ImageGalleryEmbedConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ImageGalleryEmbedEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ImageGalleryEmbedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  images: AssetCreateManyInlineInput
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ImageGalleryEmbedCreateManyInlineInput = {
  /** Connect multiple existing ImageGalleryEmbed documents */
  connect?: InputMaybe<Array<ImageGalleryEmbedWhereUniqueInput>>
  /** Create and connect multiple existing ImageGalleryEmbed documents */
  create?: InputMaybe<Array<ImageGalleryEmbedCreateInput>>
}

export type ImageGalleryEmbedCreateOneInlineInput = {
  /** Connect one existing ImageGalleryEmbed document */
  connect?: InputMaybe<ImageGalleryEmbedWhereUniqueInput>
  /** Create and connect one ImageGalleryEmbed document */
  create?: InputMaybe<ImageGalleryEmbedCreateInput>
}

/** An edge in a connection. */
export type ImageGalleryEmbedEdge = {
  __typename?: 'ImageGalleryEmbedEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ImageGalleryEmbed
}

/** Identifies documents */
export type ImageGalleryEmbedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageGalleryEmbedWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageGalleryEmbedWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageGalleryEmbedWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ImageGalleryEmbedWhereStageInput>
  documentInStages_none?: InputMaybe<ImageGalleryEmbedWhereStageInput>
  documentInStages_some?: InputMaybe<ImageGalleryEmbedWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  images_every?: InputMaybe<AssetWhereInput>
  images_none?: InputMaybe<AssetWhereInput>
  images_some?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ImageGalleryEmbedOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ImageGalleryEmbedUpdateInput = {
  images?: InputMaybe<AssetUpdateManyInlineInput>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ImageGalleryEmbedUpdateManyInlineInput = {
  /** Connect multiple existing ImageGalleryEmbed documents */
  connect?: InputMaybe<Array<ImageGalleryEmbedConnectInput>>
  /** Create and connect multiple ImageGalleryEmbed documents */
  create?: InputMaybe<Array<ImageGalleryEmbedCreateInput>>
  /** Delete multiple ImageGalleryEmbed documents */
  delete?: InputMaybe<Array<ImageGalleryEmbedWhereUniqueInput>>
  /** Disconnect multiple ImageGalleryEmbed documents */
  disconnect?: InputMaybe<Array<ImageGalleryEmbedWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ImageGalleryEmbed documents */
  set?: InputMaybe<Array<ImageGalleryEmbedWhereUniqueInput>>
  /** Update multiple ImageGalleryEmbed documents */
  update?: InputMaybe<Array<ImageGalleryEmbedUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ImageGalleryEmbed documents */
  upsert?: InputMaybe<Array<ImageGalleryEmbedUpsertWithNestedWhereUniqueInput>>
}

export type ImageGalleryEmbedUpdateManyInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ImageGalleryEmbedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageGalleryEmbedUpdateManyInput
  /** Document search */
  where: ImageGalleryEmbedWhereInput
}

export type ImageGalleryEmbedUpdateOneInlineInput = {
  /** Connect existing ImageGalleryEmbed document */
  connect?: InputMaybe<ImageGalleryEmbedWhereUniqueInput>
  /** Create and connect one ImageGalleryEmbed document */
  create?: InputMaybe<ImageGalleryEmbedCreateInput>
  /** Delete currently connected ImageGalleryEmbed document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ImageGalleryEmbed document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ImageGalleryEmbed document */
  update?: InputMaybe<ImageGalleryEmbedUpdateWithNestedWhereUniqueInput>
  /** Upsert single ImageGalleryEmbed document */
  upsert?: InputMaybe<ImageGalleryEmbedUpsertWithNestedWhereUniqueInput>
}

export type ImageGalleryEmbedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageGalleryEmbedUpdateInput
  /** Unique document search */
  where: ImageGalleryEmbedWhereUniqueInput
}

export type ImageGalleryEmbedUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageGalleryEmbedCreateInput
  /** Update document if it exists */
  update: ImageGalleryEmbedUpdateInput
}

export type ImageGalleryEmbedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageGalleryEmbedUpsertInput
  /** Unique document search */
  where: ImageGalleryEmbedWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ImageGalleryEmbedWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ImageGalleryEmbedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageGalleryEmbedWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageGalleryEmbedWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageGalleryEmbedWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ImageGalleryEmbedWhereStageInput>
  documentInStages_none?: InputMaybe<ImageGalleryEmbedWhereStageInput>
  documentInStages_some?: InputMaybe<ImageGalleryEmbedWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  images_every?: InputMaybe<AssetWhereInput>
  images_none?: InputMaybe<AssetWhereInput>
  images_some?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ImageGalleryEmbedWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageGalleryEmbedWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageGalleryEmbedWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageGalleryEmbedWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ImageGalleryEmbedWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ImageGalleryEmbed record uniquely */
export type ImageGalleryEmbedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input']
}

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>
}

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input']
}

export type ImageSlider = Entity & {
  __typename?: 'ImageSlider'
  /** Defines a decoration pattern to use with the component is is used for. */
  decorationPattern?: Maybe<DecorationPattern>
  description?: Maybe<Scalars['String']['output']>
  fullScreenWidth?: Maybe<Scalars['Boolean']['output']>
  fullWidth?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<ImageSlider>
  slide: Array<Slide>
  sliderLayout?: Maybe<SliderLayout>
  /** System stage field */
  stage: Stage
  styleVariant?: Maybe<ComponentStyle>
  theme?: Maybe<OmrThemeVariant>
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ImageSliderLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type ImageSliderSlideArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SlideOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SlideWhereInput>
}

export type ImageSliderUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ImageSliderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ImageSliderWhereUniqueInput
}

/** A connection to a list of items. */
export type ImageSliderConnection = {
  __typename?: 'ImageSliderConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ImageSliderEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ImageSliderCreateInput = {
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  fullScreenWidth?: InputMaybe<Scalars['Boolean']['input']>
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ImageSliderCreateLocalizationsInput>
  slide: SlideCreateManyInlineInput
  sliderLayout?: InputMaybe<SliderLayout>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ImageSliderCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ImageSliderCreateLocalizationInput = {
  /** Localization input */
  data: ImageSliderCreateLocalizationDataInput
  locale: Locale
}

export type ImageSliderCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ImageSliderCreateLocalizationInput>>
}

export type ImageSliderCreateManyInlineInput = {
  /** Create and connect multiple existing ImageSlider documents */
  create?: InputMaybe<Array<ImageSliderCreateInput>>
}

export type ImageSliderCreateOneInlineInput = {
  /** Create and connect one ImageSlider document */
  create?: InputMaybe<ImageSliderCreateInput>
}

export type ImageSliderCreateWithPositionInput = {
  /** Document to create */
  data: ImageSliderCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type ImageSliderEdge = {
  __typename?: 'ImageSliderEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ImageSlider
}

/** Identifies documents */
export type ImageSliderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageSliderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageSliderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageSliderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  fullScreenWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  fullScreenWidth_not?: InputMaybe<Scalars['Boolean']['input']>
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  slide_every?: InputMaybe<SlideWhereInput>
  slide_none?: InputMaybe<SlideWhereInput>
  slide_some?: InputMaybe<SlideWhereInput>
  sliderLayout?: InputMaybe<SliderLayout>
  /** All values that are contained in given list. */
  sliderLayout_in?: InputMaybe<Array<InputMaybe<SliderLayout>>>
  /** Any other value that exists and is not equal to the given value. */
  sliderLayout_not?: InputMaybe<SliderLayout>
  /** All values that are not contained in given list. */
  sliderLayout_not_in?: InputMaybe<Array<InputMaybe<SliderLayout>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum ImageSliderOrderByInput {
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  FullScreenWidthAsc = 'fullScreenWidth_ASC',
  FullScreenWidthDesc = 'fullScreenWidth_DESC',
  FullWidthAsc = 'fullWidth_ASC',
  FullWidthDesc = 'fullWidth_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SliderLayoutAsc = 'sliderLayout_ASC',
  SliderLayoutDesc = 'sliderLayout_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ImageSliderParent = EventPage

export type ImageSliderParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type ImageSliderParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type ImageSliderParentCreateManyInlineInput = {
  /** Connect multiple existing ImageSliderParent documents */
  connect?: InputMaybe<Array<ImageSliderParentWhereUniqueInput>>
  /** Create and connect multiple existing ImageSliderParent documents */
  create?: InputMaybe<Array<ImageSliderParentCreateInput>>
}

export type ImageSliderParentCreateOneInlineInput = {
  /** Connect one existing ImageSliderParent document */
  connect?: InputMaybe<ImageSliderParentWhereUniqueInput>
  /** Create and connect one ImageSliderParent document */
  create?: InputMaybe<ImageSliderParentCreateInput>
}

export type ImageSliderParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type ImageSliderParentUpdateManyInlineInput = {
  /** Connect multiple existing ImageSliderParent documents */
  connect?: InputMaybe<Array<ImageSliderParentConnectInput>>
  /** Create and connect multiple ImageSliderParent documents */
  create?: InputMaybe<Array<ImageSliderParentCreateInput>>
  /** Delete multiple ImageSliderParent documents */
  delete?: InputMaybe<Array<ImageSliderParentWhereUniqueInput>>
  /** Disconnect multiple ImageSliderParent documents */
  disconnect?: InputMaybe<Array<ImageSliderParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ImageSliderParent documents */
  set?: InputMaybe<Array<ImageSliderParentWhereUniqueInput>>
  /** Update multiple ImageSliderParent documents */
  update?: InputMaybe<Array<ImageSliderParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ImageSliderParent documents */
  upsert?: InputMaybe<Array<ImageSliderParentUpsertWithNestedWhereUniqueInput>>
}

export type ImageSliderParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type ImageSliderParentUpdateOneInlineInput = {
  /** Connect existing ImageSliderParent document */
  connect?: InputMaybe<ImageSliderParentWhereUniqueInput>
  /** Create and connect one ImageSliderParent document */
  create?: InputMaybe<ImageSliderParentCreateInput>
  /** Delete currently connected ImageSliderParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ImageSliderParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ImageSliderParent document */
  update?: InputMaybe<ImageSliderParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single ImageSliderParent document */
  upsert?: InputMaybe<ImageSliderParentUpsertWithNestedWhereUniqueInput>
}

export type ImageSliderParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type ImageSliderParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type ImageSliderParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type ImageSliderParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type ImageSliderUpdateInput = {
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  fullScreenWidth?: InputMaybe<Scalars['Boolean']['input']>
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ImageSliderUpdateLocalizationsInput>
  slide?: InputMaybe<SlideUpdateManyInlineInput>
  sliderLayout?: InputMaybe<SliderLayout>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ImageSliderUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ImageSliderUpdateLocalizationInput = {
  data: ImageSliderUpdateLocalizationDataInput
  locale: Locale
}

export type ImageSliderUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ImageSliderCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ImageSliderUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ImageSliderUpsertLocalizationInput>>
}

export type ImageSliderUpdateManyInlineInput = {
  /** Create and connect multiple ImageSlider component instances */
  create?: InputMaybe<Array<ImageSliderCreateWithPositionInput>>
  /** Delete multiple ImageSlider documents */
  delete?: InputMaybe<Array<ImageSliderWhereUniqueInput>>
  /** Update multiple ImageSlider component instances */
  update?: InputMaybe<Array<ImageSliderUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple ImageSlider component instances */
  upsert?: InputMaybe<Array<ImageSliderUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type ImageSliderUpdateManyInput = {
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  fullScreenWidth?: InputMaybe<Scalars['Boolean']['input']>
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ImageSliderUpdateManyLocalizationsInput>
  sliderLayout?: InputMaybe<SliderLayout>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ImageSliderUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ImageSliderUpdateManyLocalizationInput = {
  data: ImageSliderUpdateManyLocalizationDataInput
  locale: Locale
}

export type ImageSliderUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ImageSliderUpdateManyLocalizationInput>>
}

export type ImageSliderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageSliderUpdateManyInput
  /** Document search */
  where: ImageSliderWhereInput
}

export type ImageSliderUpdateOneInlineInput = {
  /** Create and connect one ImageSlider document */
  create?: InputMaybe<ImageSliderCreateInput>
  /** Delete currently connected ImageSlider document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ImageSlider document */
  update?: InputMaybe<ImageSliderUpdateWithNestedWhereUniqueInput>
  /** Upsert single ImageSlider document */
  upsert?: InputMaybe<ImageSliderUpsertWithNestedWhereUniqueInput>
}

export type ImageSliderUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ImageSliderUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ImageSliderWhereUniqueInput
}

export type ImageSliderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageSliderUpdateInput
  /** Unique document search */
  where: ImageSliderWhereUniqueInput
}

export type ImageSliderUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageSliderCreateInput
  /** Update document if it exists */
  update: ImageSliderUpdateInput
}

export type ImageSliderUpsertLocalizationInput = {
  create: ImageSliderCreateLocalizationDataInput
  locale: Locale
  update: ImageSliderUpdateLocalizationDataInput
}

export type ImageSliderUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ImageSliderUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ImageSliderWhereUniqueInput
}

export type ImageSliderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageSliderUpsertInput
  /** Unique document search */
  where: ImageSliderWhereUniqueInput
}

/** Identifies documents */
export type ImageSliderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageSliderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageSliderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageSliderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  fullScreenWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  fullScreenWidth_not?: InputMaybe<Scalars['Boolean']['input']>
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  slide_every?: InputMaybe<SlideWhereInput>
  slide_none?: InputMaybe<SlideWhereInput>
  slide_some?: InputMaybe<SlideWhereInput>
  sliderLayout?: InputMaybe<SliderLayout>
  /** All values that are contained in given list. */
  sliderLayout_in?: InputMaybe<Array<InputMaybe<SliderLayout>>>
  /** Any other value that exists and is not equal to the given value. */
  sliderLayout_not?: InputMaybe<SliderLayout>
  /** All values that are not contained in given list. */
  sliderLayout_not_in?: InputMaybe<Array<InputMaybe<SliderLayout>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References ImageSlider record uniquely */
export type ImageSliderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>
}

export type Interest = Entity &
  Node & {
    __typename?: 'Interest'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<Interest>
    /** List of Interest versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    partnerCompanies: Array<PartnerCompany>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    speakers: Array<Speaker>
    /** System stage field */
    stage: Stage
    /** Name */
    text: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

export type InterestCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type InterestDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type InterestHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type InterestPartnerCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PartnerCompanyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PartnerCompanyWhereInput>
}

export type InterestPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type InterestScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type InterestSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SpeakerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerWhereInput>
}

export type InterestUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type InterestConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: InterestWhereUniqueInput
}

/** A connection to a list of items. */
export type InterestConnection = {
  __typename?: 'InterestConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<InterestEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type InterestCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  eventAppCardInterests?: InputMaybe<EventAppCardCreateManyInlineInput>
  journeyInterests?: InputMaybe<JourneyCreateManyInlineInput>
  partnerCompanies?: InputMaybe<PartnerCompanyCreateManyInlineInput>
  sectionEventOffersTimetableInterestFilter?: InputMaybe<SectionEventOffersTimetableCreateManyInlineInput>
  sectionExhibitorsInterest?: InputMaybe<SectionMyomrExhibitorsCreateManyInlineInput>
  sectionFestivalTimetableInterestsFilter?: InputMaybe<SectionFestivalTimetableCreateManyInlineInput>
  sectionMyomrExhibitorsInterestsFilter?: InputMaybe<SectionMyomrExhibitorsCreateManyInlineInput>
  sectionSpeakersInterest?: InputMaybe<SectionSpeakersCreateManyInlineInput>
  sectionSpeakersInterestsFilter?: InputMaybe<SectionSpeakersCreateManyInlineInput>
  slug: Scalars['String']['input']
  speakers?: InputMaybe<SpeakerCreateManyInlineInput>
  text: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type InterestCreateManyInlineInput = {
  /** Connect multiple existing Interest documents */
  connect?: InputMaybe<Array<InterestWhereUniqueInput>>
  /** Create and connect multiple existing Interest documents */
  create?: InputMaybe<Array<InterestCreateInput>>
}

export type InterestCreateOneInlineInput = {
  /** Connect one existing Interest document */
  connect?: InputMaybe<InterestWhereUniqueInput>
  /** Create and connect one Interest document */
  create?: InputMaybe<InterestCreateInput>
}

/** An edge in a connection. */
export type InterestEdge = {
  __typename?: 'InterestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Interest
}

/** Identifies documents */
export type InterestManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<InterestWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<InterestWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<InterestWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<InterestWhereStageInput>
  documentInStages_none?: InputMaybe<InterestWhereStageInput>
  documentInStages_some?: InputMaybe<InterestWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  partnerCompanies_every?: InputMaybe<PartnerCompanyWhereInput>
  partnerCompanies_none?: InputMaybe<PartnerCompanyWhereInput>
  partnerCompanies_some?: InputMaybe<PartnerCompanyWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  speakers_every?: InputMaybe<SpeakerWhereInput>
  speakers_none?: InputMaybe<SpeakerWhereInput>
  speakers_some?: InputMaybe<SpeakerWhereInput>
  text?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum InterestOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type InterestUpdateInput = {
  eventAppCardInterests?: InputMaybe<EventAppCardUpdateManyInlineInput>
  journeyInterests?: InputMaybe<JourneyUpdateManyInlineInput>
  partnerCompanies?: InputMaybe<PartnerCompanyUpdateManyInlineInput>
  sectionEventOffersTimetableInterestFilter?: InputMaybe<SectionEventOffersTimetableUpdateManyInlineInput>
  sectionExhibitorsInterest?: InputMaybe<SectionMyomrExhibitorsUpdateManyInlineInput>
  sectionFestivalTimetableInterestsFilter?: InputMaybe<SectionFestivalTimetableUpdateManyInlineInput>
  sectionMyomrExhibitorsInterestsFilter?: InputMaybe<SectionMyomrExhibitorsUpdateManyInlineInput>
  sectionSpeakersInterest?: InputMaybe<SectionSpeakersUpdateManyInlineInput>
  sectionSpeakersInterestsFilter?: InputMaybe<SectionSpeakersUpdateManyInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  speakers?: InputMaybe<SpeakerUpdateManyInlineInput>
  text?: InputMaybe<Scalars['String']['input']>
}

export type InterestUpdateManyInlineInput = {
  /** Connect multiple existing Interest documents */
  connect?: InputMaybe<Array<InterestConnectInput>>
  /** Create and connect multiple Interest documents */
  create?: InputMaybe<Array<InterestCreateInput>>
  /** Delete multiple Interest documents */
  delete?: InputMaybe<Array<InterestWhereUniqueInput>>
  /** Disconnect multiple Interest documents */
  disconnect?: InputMaybe<Array<InterestWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Interest documents */
  set?: InputMaybe<Array<InterestWhereUniqueInput>>
  /** Update multiple Interest documents */
  update?: InputMaybe<Array<InterestUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Interest documents */
  upsert?: InputMaybe<Array<InterestUpsertWithNestedWhereUniqueInput>>
}

export type InterestUpdateManyInput = {
  text?: InputMaybe<Scalars['String']['input']>
}

export type InterestUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: InterestUpdateManyInput
  /** Document search */
  where: InterestWhereInput
}

export type InterestUpdateOneInlineInput = {
  /** Connect existing Interest document */
  connect?: InputMaybe<InterestWhereUniqueInput>
  /** Create and connect one Interest document */
  create?: InputMaybe<InterestCreateInput>
  /** Delete currently connected Interest document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Interest document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Interest document */
  update?: InputMaybe<InterestUpdateWithNestedWhereUniqueInput>
  /** Upsert single Interest document */
  upsert?: InputMaybe<InterestUpsertWithNestedWhereUniqueInput>
}

export type InterestUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: InterestUpdateInput
  /** Unique document search */
  where: InterestWhereUniqueInput
}

export type InterestUpsertInput = {
  /** Create document if it didn't exist */
  create: InterestCreateInput
  /** Update document if it exists */
  update: InterestUpdateInput
}

export type InterestUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: InterestUpsertInput
  /** Unique document search */
  where: InterestWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type InterestWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type InterestWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<InterestWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<InterestWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<InterestWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<InterestWhereStageInput>
  documentInStages_none?: InputMaybe<InterestWhereStageInput>
  documentInStages_some?: InputMaybe<InterestWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  partnerCompanies_every?: InputMaybe<PartnerCompanyWhereInput>
  partnerCompanies_none?: InputMaybe<PartnerCompanyWhereInput>
  partnerCompanies_some?: InputMaybe<PartnerCompanyWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  speakers_every?: InputMaybe<SpeakerWhereInput>
  speakers_none?: InputMaybe<SpeakerWhereInput>
  speakers_some?: InputMaybe<SpeakerWhereInput>
  text?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type InterestWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<InterestWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<InterestWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<InterestWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<InterestWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Interest record uniquely */
export type InterestWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type JobListing = Entity &
  Node & {
    __typename?: 'JobListing'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<JobListing>
    /** List of JobListing versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    jobCta?: Maybe<CallToAction>
    jobImage?: Maybe<Asset>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<JobListing>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    styleVariant?: Maybe<ComponentStyle>
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

export type JobListingCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type JobListingCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type JobListingDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type JobListingHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type JobListingJobCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type JobListingJobImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type JobListingLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type JobListingPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type JobListingPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type JobListingScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type JobListingUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type JobListingUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type JobListingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: JobListingWhereUniqueInput
}

/** A connection to a list of items. */
export type JobListingConnection = {
  __typename?: 'JobListingConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<JobListingEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type JobListingCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  jobCta?: InputMaybe<CallToActionCreateOneInlineInput>
  jobImage?: InputMaybe<AssetCreateOneInlineInput>
  jobsInList?: InputMaybe<SectionJobListCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<JobListingCreateLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type JobListingCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type JobListingCreateLocalizationInput = {
  /** Localization input */
  data: JobListingCreateLocalizationDataInput
  locale: Locale
}

export type JobListingCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<JobListingCreateLocalizationInput>>
}

export type JobListingCreateManyInlineInput = {
  /** Connect multiple existing JobListing documents */
  connect?: InputMaybe<Array<JobListingWhereUniqueInput>>
  /** Create and connect multiple existing JobListing documents */
  create?: InputMaybe<Array<JobListingCreateInput>>
}

export type JobListingCreateOneInlineInput = {
  /** Connect one existing JobListing document */
  connect?: InputMaybe<JobListingWhereUniqueInput>
  /** Create and connect one JobListing document */
  create?: InputMaybe<JobListingCreateInput>
}

/** An edge in a connection. */
export type JobListingEdge = {
  __typename?: 'JobListingEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: JobListing
}

/** Identifies documents */
export type JobListingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobListingWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobListingWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobListingWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<JobListingWhereStageInput>
  documentInStages_none?: InputMaybe<JobListingWhereStageInput>
  documentInStages_some?: InputMaybe<JobListingWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  jobCta?: InputMaybe<CallToActionWhereInput>
  jobImage?: InputMaybe<AssetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum JobListingOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type JobListingUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  jobCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  jobImage?: InputMaybe<AssetUpdateOneInlineInput>
  jobsInList?: InputMaybe<SectionJobListUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<JobListingUpdateLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type JobListingUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type JobListingUpdateLocalizationInput = {
  data: JobListingUpdateLocalizationDataInput
  locale: Locale
}

export type JobListingUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<JobListingCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<JobListingUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<JobListingUpsertLocalizationInput>>
}

export type JobListingUpdateManyInlineInput = {
  /** Connect multiple existing JobListing documents */
  connect?: InputMaybe<Array<JobListingConnectInput>>
  /** Create and connect multiple JobListing documents */
  create?: InputMaybe<Array<JobListingCreateInput>>
  /** Delete multiple JobListing documents */
  delete?: InputMaybe<Array<JobListingWhereUniqueInput>>
  /** Disconnect multiple JobListing documents */
  disconnect?: InputMaybe<Array<JobListingWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing JobListing documents */
  set?: InputMaybe<Array<JobListingWhereUniqueInput>>
  /** Update multiple JobListing documents */
  update?: InputMaybe<Array<JobListingUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple JobListing documents */
  upsert?: InputMaybe<Array<JobListingUpsertWithNestedWhereUniqueInput>>
}

export type JobListingUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<JobListingUpdateManyLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type JobListingUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type JobListingUpdateManyLocalizationInput = {
  data: JobListingUpdateManyLocalizationDataInput
  locale: Locale
}

export type JobListingUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<JobListingUpdateManyLocalizationInput>>
}

export type JobListingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: JobListingUpdateManyInput
  /** Document search */
  where: JobListingWhereInput
}

export type JobListingUpdateOneInlineInput = {
  /** Connect existing JobListing document */
  connect?: InputMaybe<JobListingWhereUniqueInput>
  /** Create and connect one JobListing document */
  create?: InputMaybe<JobListingCreateInput>
  /** Delete currently connected JobListing document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected JobListing document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single JobListing document */
  update?: InputMaybe<JobListingUpdateWithNestedWhereUniqueInput>
  /** Upsert single JobListing document */
  upsert?: InputMaybe<JobListingUpsertWithNestedWhereUniqueInput>
}

export type JobListingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: JobListingUpdateInput
  /** Unique document search */
  where: JobListingWhereUniqueInput
}

export type JobListingUpsertInput = {
  /** Create document if it didn't exist */
  create: JobListingCreateInput
  /** Update document if it exists */
  update: JobListingUpdateInput
}

export type JobListingUpsertLocalizationInput = {
  create: JobListingCreateLocalizationDataInput
  locale: Locale
  update: JobListingUpdateLocalizationDataInput
}

export type JobListingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: JobListingUpsertInput
  /** Unique document search */
  where: JobListingWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type JobListingWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type JobListingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobListingWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobListingWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobListingWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<JobListingWhereStageInput>
  documentInStages_none?: InputMaybe<JobListingWhereStageInput>
  documentInStages_some?: InputMaybe<JobListingWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  jobCta?: InputMaybe<CallToActionWhereInput>
  jobImage?: InputMaybe<AssetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type JobListingWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobListingWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobListingWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobListingWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<JobListingWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References JobListing record uniquely */
export type JobListingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** A journey through the application specified by interest tags */
export type Journey = Entity &
  Node & {
    __typename?: 'Journey'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<Journey>
    /** List of Journey versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    interests: Array<Interest>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Journey>
    name?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** A journey through the application specified by interest tags */
export type JourneyCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A journey through the application specified by interest tags */
export type JourneyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** A journey through the application specified by interest tags */
export type JourneyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** A journey through the application specified by interest tags */
export type JourneyHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** A journey through the application specified by interest tags */
export type JourneyInterestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestWhereInput>
}

/** A journey through the application specified by interest tags */
export type JourneyLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** A journey through the application specified by interest tags */
export type JourneyPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A journey through the application specified by interest tags */
export type JourneyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** A journey through the application specified by interest tags */
export type JourneyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** A journey through the application specified by interest tags */
export type JourneyUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A journey through the application specified by interest tags */
export type JourneyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type JourneyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: JourneyWhereUniqueInput
}

/** A connection to a list of items. */
export type JourneyConnection = {
  __typename?: 'JourneyConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<JourneyEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type JourneyCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  interests?: InputMaybe<InterestCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<JourneyCreateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type JourneyCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type JourneyCreateLocalizationInput = {
  /** Localization input */
  data: JourneyCreateLocalizationDataInput
  locale: Locale
}

export type JourneyCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<JourneyCreateLocalizationInput>>
}

export type JourneyCreateManyInlineInput = {
  /** Connect multiple existing Journey documents */
  connect?: InputMaybe<Array<JourneyWhereUniqueInput>>
  /** Create and connect multiple existing Journey documents */
  create?: InputMaybe<Array<JourneyCreateInput>>
}

export type JourneyCreateOneInlineInput = {
  /** Connect one existing Journey document */
  connect?: InputMaybe<JourneyWhereUniqueInput>
  /** Create and connect one Journey document */
  create?: InputMaybe<JourneyCreateInput>
}

/** An edge in a connection. */
export type JourneyEdge = {
  __typename?: 'JourneyEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Journey
}

/** Identifies documents */
export type JourneyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JourneyWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JourneyWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JourneyWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<JourneyWhereStageInput>
  documentInStages_none?: InputMaybe<JourneyWhereStageInput>
  documentInStages_some?: InputMaybe<JourneyWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interests_every?: InputMaybe<InterestWhereInput>
  interests_none?: InputMaybe<InterestWhereInput>
  interests_some?: InputMaybe<InterestWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum JourneyOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type JourneyUpdateInput = {
  interests?: InputMaybe<InterestUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<JourneyUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
}

export type JourneyUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type JourneyUpdateLocalizationInput = {
  data: JourneyUpdateLocalizationDataInput
  locale: Locale
}

export type JourneyUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<JourneyCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<JourneyUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<JourneyUpsertLocalizationInput>>
}

export type JourneyUpdateManyInlineInput = {
  /** Connect multiple existing Journey documents */
  connect?: InputMaybe<Array<JourneyConnectInput>>
  /** Create and connect multiple Journey documents */
  create?: InputMaybe<Array<JourneyCreateInput>>
  /** Delete multiple Journey documents */
  delete?: InputMaybe<Array<JourneyWhereUniqueInput>>
  /** Disconnect multiple Journey documents */
  disconnect?: InputMaybe<Array<JourneyWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Journey documents */
  set?: InputMaybe<Array<JourneyWhereUniqueInput>>
  /** Update multiple Journey documents */
  update?: InputMaybe<Array<JourneyUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Journey documents */
  upsert?: InputMaybe<Array<JourneyUpsertWithNestedWhereUniqueInput>>
}

export type JourneyUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<JourneyUpdateManyLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
}

export type JourneyUpdateManyLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type JourneyUpdateManyLocalizationInput = {
  data: JourneyUpdateManyLocalizationDataInput
  locale: Locale
}

export type JourneyUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<JourneyUpdateManyLocalizationInput>>
}

export type JourneyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: JourneyUpdateManyInput
  /** Document search */
  where: JourneyWhereInput
}

export type JourneyUpdateOneInlineInput = {
  /** Connect existing Journey document */
  connect?: InputMaybe<JourneyWhereUniqueInput>
  /** Create and connect one Journey document */
  create?: InputMaybe<JourneyCreateInput>
  /** Delete currently connected Journey document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Journey document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Journey document */
  update?: InputMaybe<JourneyUpdateWithNestedWhereUniqueInput>
  /** Upsert single Journey document */
  upsert?: InputMaybe<JourneyUpsertWithNestedWhereUniqueInput>
}

export type JourneyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: JourneyUpdateInput
  /** Unique document search */
  where: JourneyWhereUniqueInput
}

export type JourneyUpsertInput = {
  /** Create document if it didn't exist */
  create: JourneyCreateInput
  /** Update document if it exists */
  update: JourneyUpdateInput
}

export type JourneyUpsertLocalizationInput = {
  create: JourneyCreateLocalizationDataInput
  locale: Locale
  update: JourneyUpdateLocalizationDataInput
}

export type JourneyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: JourneyUpsertInput
  /** Unique document search */
  where: JourneyWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type JourneyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type JourneyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JourneyWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JourneyWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JourneyWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<JourneyWhereStageInput>
  documentInStages_none?: InputMaybe<JourneyWhereStageInput>
  documentInStages_some?: InputMaybe<JourneyWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interests_every?: InputMaybe<InterestWhereInput>
  interests_none?: InputMaybe<InterestWhereInput>
  interests_some?: InputMaybe<InterestWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type JourneyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JourneyWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JourneyWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JourneyWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<JourneyWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Journey record uniquely */
export type JourneyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Configuration for static landing page */
export type LandingPage = Entity &
  Node & {
    __typename?: 'LandingPage'
    /** Author displayed in the author box on this landing page */
    author?: Maybe<Author>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<LandingPage>
    /** List of LandingPage versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<LandingPage>
    /** Ordered list of landing page components */
    pageLayout: Array<LandingPagepageLayoutUnion>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** Optional configuration to specify page meta tags */
    seoAttributes?: Maybe<Seo>
    /** Optional configuration if you want to have specific SEO Content Attributes. */
    seoContentAttributes?: Maybe<SeoContentAttribute>
    siteSection?: Maybe<SiteSection>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** Landing page title */
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Configuration for static landing page */
export type LandingPageAuthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Configuration for static landing page */
export type LandingPageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Configuration for static landing page */
export type LandingPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Configuration for static landing page */
export type LandingPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Configuration for static landing page */
export type LandingPageHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Configuration for static landing page */
export type LandingPageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Configuration for static landing page */
export type LandingPagePageLayoutArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

/** Configuration for static landing page */
export type LandingPagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Configuration for static landing page */
export type LandingPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Configuration for static landing page */
export type LandingPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Configuration for static landing page */
export type LandingPageSeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Configuration for static landing page */
export type LandingPageSeoContentAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Configuration for static landing page */
export type LandingPageSiteSectionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Configuration for static landing page */
export type LandingPageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Configuration for static landing page */
export type LandingPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type LandingPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: LandingPageWhereUniqueInput
}

/** A connection to a list of items. */
export type LandingPageConnection = {
  __typename?: 'LandingPageConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<LandingPageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type LandingPageCreateInput = {
  author?: InputMaybe<AuthorCreateOneInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<LandingPageCreateLocalizationsInput>
  pageLayout?: InputMaybe<LandingPagepageLayoutUnionCreateManyInlineInput>
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  seoContentAttributes?: InputMaybe<SeoContentAttributeCreateOneInlineInput>
  siteSection?: InputMaybe<SiteSectionCreateOneInlineInput>
  slug: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type LandingPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type LandingPageCreateLocalizationInput = {
  /** Localization input */
  data: LandingPageCreateLocalizationDataInput
  locale: Locale
}

export type LandingPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<LandingPageCreateLocalizationInput>>
}

export type LandingPageCreateManyInlineInput = {
  /** Connect multiple existing LandingPage documents */
  connect?: InputMaybe<Array<LandingPageWhereUniqueInput>>
  /** Create and connect multiple existing LandingPage documents */
  create?: InputMaybe<Array<LandingPageCreateInput>>
}

export type LandingPageCreateOneInlineInput = {
  /** Connect one existing LandingPage document */
  connect?: InputMaybe<LandingPageWhereUniqueInput>
  /** Create and connect one LandingPage document */
  create?: InputMaybe<LandingPageCreateInput>
}

/** An edge in a connection. */
export type LandingPageEdge = {
  __typename?: 'LandingPageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: LandingPage
}

/** Identifies documents */
export type LandingPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LandingPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LandingPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LandingPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  author?: InputMaybe<AuthorWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<LandingPageWhereStageInput>
  documentInStages_none?: InputMaybe<LandingPageWhereStageInput>
  documentInStages_some?: InputMaybe<LandingPageWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty. */
  pageLayout_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  pageLayout_some?: InputMaybe<LandingPagepageLayoutUnionWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  seoContentAttributes?: InputMaybe<SeoContentAttributeWhereInput>
  siteSection?: InputMaybe<SiteSectionWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum LandingPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type LandingPageUpdateInput = {
  author?: InputMaybe<AuthorUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<LandingPageUpdateLocalizationsInput>
  pageLayout?: InputMaybe<LandingPagepageLayoutUnionUpdateManyInlineInput>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  seoContentAttributes?: InputMaybe<SeoContentAttributeUpdateOneInlineInput>
  siteSection?: InputMaybe<SiteSectionUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type LandingPageUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type LandingPageUpdateLocalizationInput = {
  data: LandingPageUpdateLocalizationDataInput
  locale: Locale
}

export type LandingPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<LandingPageCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<LandingPageUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<LandingPageUpsertLocalizationInput>>
}

export type LandingPageUpdateManyInlineInput = {
  /** Connect multiple existing LandingPage documents */
  connect?: InputMaybe<Array<LandingPageConnectInput>>
  /** Create and connect multiple LandingPage documents */
  create?: InputMaybe<Array<LandingPageCreateInput>>
  /** Delete multiple LandingPage documents */
  delete?: InputMaybe<Array<LandingPageWhereUniqueInput>>
  /** Disconnect multiple LandingPage documents */
  disconnect?: InputMaybe<Array<LandingPageWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing LandingPage documents */
  set?: InputMaybe<Array<LandingPageWhereUniqueInput>>
  /** Update multiple LandingPage documents */
  update?: InputMaybe<Array<LandingPageUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple LandingPage documents */
  upsert?: InputMaybe<Array<LandingPageUpsertWithNestedWhereUniqueInput>>
}

export type LandingPageUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<LandingPageUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type LandingPageUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type LandingPageUpdateManyLocalizationInput = {
  data: LandingPageUpdateManyLocalizationDataInput
  locale: Locale
}

export type LandingPageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<LandingPageUpdateManyLocalizationInput>>
}

export type LandingPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LandingPageUpdateManyInput
  /** Document search */
  where: LandingPageWhereInput
}

export type LandingPageUpdateOneInlineInput = {
  /** Connect existing LandingPage document */
  connect?: InputMaybe<LandingPageWhereUniqueInput>
  /** Create and connect one LandingPage document */
  create?: InputMaybe<LandingPageCreateInput>
  /** Delete currently connected LandingPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected LandingPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single LandingPage document */
  update?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
  /** Upsert single LandingPage document */
  upsert?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type LandingPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LandingPageUpdateInput
  /** Unique document search */
  where: LandingPageWhereUniqueInput
}

export type LandingPageUpsertInput = {
  /** Create document if it didn't exist */
  create: LandingPageCreateInput
  /** Update document if it exists */
  update: LandingPageUpdateInput
}

export type LandingPageUpsertLocalizationInput = {
  create: LandingPageCreateLocalizationDataInput
  locale: Locale
  update: LandingPageUpdateLocalizationDataInput
}

export type LandingPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LandingPageUpsertInput
  /** Unique document search */
  where: LandingPageWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type LandingPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type LandingPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LandingPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LandingPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LandingPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  author?: InputMaybe<AuthorWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<LandingPageWhereStageInput>
  documentInStages_none?: InputMaybe<LandingPageWhereStageInput>
  documentInStages_some?: InputMaybe<LandingPageWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty. */
  pageLayout_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  pageLayout_some?: InputMaybe<LandingPagepageLayoutUnionWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  seoContentAttributes?: InputMaybe<SeoContentAttributeWhereInput>
  siteSection?: InputMaybe<SiteSectionWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LandingPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LandingPageWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LandingPageWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LandingPageWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LandingPageWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References LandingPage record uniquely */
export type LandingPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type LandingPagepageLayoutUnion =
  | Faq
  | PpcReviewsProduct
  | PreviewCardList
  | RichContent
  | SectionAnchorTarget
  | SectionBanner
  | SectionByTheNumbers
  | SectionContact
  | SectionCta
  | SectionCuratedSpeakerList
  | SectionExplanationBlocks
  | SectionFramesHero
  | SectionHero
  | SectionHubspotForm
  | SectionImageSlider
  | SectionIntro
  | SectionNewsletter
  | SectionNewsletterAudience
  | SectionOmrPartner
  | SectionOneShot
  | SectionPricingTiers
  | SectionReviewsFeaturesTable
  | SectionSlimCta
  | SectionStyledHero
  | SectionTab
  | SectionTeaser
  | SectionTestimonial
  | SectionTiles
  | SectionVideo
  | SubscriptionTeaser
  | TestimonialSlider
  | TextMedia
  | TextMediaBanner

export type LandingPagepageLayoutUnionConnectInput = {
  Faq?: InputMaybe<FaqConnectInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductConnectInput>
  PreviewCardList?: InputMaybe<PreviewCardListConnectInput>
  RichContent?: InputMaybe<RichContentConnectInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetConnectInput>
  SectionBanner?: InputMaybe<SectionBannerConnectInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersConnectInput>
  SectionContact?: InputMaybe<SectionContactConnectInput>
  SectionCta?: InputMaybe<SectionCtaConnectInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListConnectInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksConnectInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroConnectInput>
  SectionHero?: InputMaybe<SectionHeroConnectInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormConnectInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderConnectInput>
  SectionIntro?: InputMaybe<SectionIntroConnectInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterConnectInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceConnectInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerConnectInput>
  SectionOneShot?: InputMaybe<SectionOneShotConnectInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersConnectInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableConnectInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaConnectInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroConnectInput>
  SectionTab?: InputMaybe<SectionTabConnectInput>
  SectionTeaser?: InputMaybe<SectionTeaserConnectInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialConnectInput>
  SectionTiles?: InputMaybe<SectionTilesConnectInput>
  SectionVideo?: InputMaybe<SectionVideoConnectInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserConnectInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderConnectInput>
  TextMedia?: InputMaybe<TextMediaConnectInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerConnectInput>
}

export type LandingPagepageLayoutUnionCreateInput = {
  Faq?: InputMaybe<FaqCreateInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductCreateInput>
  PreviewCardList?: InputMaybe<PreviewCardListCreateInput>
  RichContent?: InputMaybe<RichContentCreateInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetCreateInput>
  SectionBanner?: InputMaybe<SectionBannerCreateInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersCreateInput>
  SectionContact?: InputMaybe<SectionContactCreateInput>
  SectionCta?: InputMaybe<SectionCtaCreateInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListCreateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroCreateInput>
  SectionHero?: InputMaybe<SectionHeroCreateInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormCreateInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderCreateInput>
  SectionIntro?: InputMaybe<SectionIntroCreateInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterCreateInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceCreateInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerCreateInput>
  SectionOneShot?: InputMaybe<SectionOneShotCreateInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersCreateInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableCreateInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaCreateInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateInput>
  SectionTab?: InputMaybe<SectionTabCreateInput>
  SectionTeaser?: InputMaybe<SectionTeaserCreateInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialCreateInput>
  SectionTiles?: InputMaybe<SectionTilesCreateInput>
  SectionVideo?: InputMaybe<SectionVideoCreateInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserCreateInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderCreateInput>
  TextMedia?: InputMaybe<TextMediaCreateInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerCreateInput>
}

export type LandingPagepageLayoutUnionCreateManyInlineInput = {
  /** Create and connect multiple existing LandingPagepageLayoutUnion documents */
  create?: InputMaybe<Array<LandingPagepageLayoutUnionCreateInput>>
}

export type LandingPagepageLayoutUnionCreateOneInlineInput = {
  /** Create and connect one LandingPagepageLayoutUnion document */
  create?: InputMaybe<LandingPagepageLayoutUnionCreateInput>
}

export type LandingPagepageLayoutUnionCreateWithPositionInput = {
  Faq?: InputMaybe<FaqCreateWithPositionInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductCreateWithPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListCreateWithPositionInput>
  RichContent?: InputMaybe<RichContentCreateWithPositionInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetCreateWithPositionInput>
  SectionBanner?: InputMaybe<SectionBannerCreateWithPositionInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersCreateWithPositionInput>
  SectionContact?: InputMaybe<SectionContactCreateWithPositionInput>
  SectionCta?: InputMaybe<SectionCtaCreateWithPositionInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListCreateWithPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksCreateWithPositionInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroCreateWithPositionInput>
  SectionHero?: InputMaybe<SectionHeroCreateWithPositionInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormCreateWithPositionInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderCreateWithPositionInput>
  SectionIntro?: InputMaybe<SectionIntroCreateWithPositionInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterCreateWithPositionInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceCreateWithPositionInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerCreateWithPositionInput>
  SectionOneShot?: InputMaybe<SectionOneShotCreateWithPositionInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersCreateWithPositionInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableCreateWithPositionInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaCreateWithPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateWithPositionInput>
  SectionTab?: InputMaybe<SectionTabCreateWithPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserCreateWithPositionInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialCreateWithPositionInput>
  SectionTiles?: InputMaybe<SectionTilesCreateWithPositionInput>
  SectionVideo?: InputMaybe<SectionVideoCreateWithPositionInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserCreateWithPositionInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderCreateWithPositionInput>
  TextMedia?: InputMaybe<TextMediaCreateWithPositionInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerCreateWithPositionInput>
}

export type LandingPagepageLayoutUnionUpdateInput = {
  Faq?: InputMaybe<FaqUpdateInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductUpdateInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateInput>
  RichContent?: InputMaybe<RichContentUpdateInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpdateInput>
  SectionBanner?: InputMaybe<SectionBannerUpdateInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateInput>
  SectionContact?: InputMaybe<SectionContactUpdateInput>
  SectionCta?: InputMaybe<SectionCtaUpdateInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListUpdateInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroUpdateInput>
  SectionHero?: InputMaybe<SectionHeroUpdateInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpdateInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpdateInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceUpdateInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpdateInput>
  SectionOneShot?: InputMaybe<SectionOneShotUpdateInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersUpdateInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableUpdateInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpdateInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateInput>
  SectionTab?: InputMaybe<SectionTabUpdateInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpdateInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpdateInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateInput>
  TextMedia?: InputMaybe<TextMediaUpdateInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpdateInput>
}

export type LandingPagepageLayoutUnionUpdateManyInlineInput = {
  /** Create and connect multiple LandingPagepageLayoutUnion component instances */
  create?: InputMaybe<Array<LandingPagepageLayoutUnionCreateWithPositionInput>>
  /** Delete multiple LandingPagepageLayoutUnion documents */
  delete?: InputMaybe<Array<LandingPagepageLayoutUnionWhereUniqueInput>>
  /** Update multiple LandingPagepageLayoutUnion component instances */
  update?: InputMaybe<Array<LandingPagepageLayoutUnionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple LandingPagepageLayoutUnion component instances */
  upsert?: InputMaybe<Array<LandingPagepageLayoutUnionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type LandingPagepageLayoutUnionUpdateManyWithNestedWhereInput = {
  Faq?: InputMaybe<FaqUpdateManyWithNestedWhereInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductUpdateManyWithNestedWhereInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateManyWithNestedWhereInput>
  RichContent?: InputMaybe<RichContentUpdateManyWithNestedWhereInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpdateManyWithNestedWhereInput>
  SectionBanner?: InputMaybe<SectionBannerUpdateManyWithNestedWhereInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateManyWithNestedWhereInput>
  SectionContact?: InputMaybe<SectionContactUpdateManyWithNestedWhereInput>
  SectionCta?: InputMaybe<SectionCtaUpdateManyWithNestedWhereInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListUpdateManyWithNestedWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateManyWithNestedWhereInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroUpdateManyWithNestedWhereInput>
  SectionHero?: InputMaybe<SectionHeroUpdateManyWithNestedWhereInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpdateManyWithNestedWhereInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpdateManyWithNestedWhereInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateManyWithNestedWhereInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateManyWithNestedWhereInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceUpdateManyWithNestedWhereInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpdateManyWithNestedWhereInput>
  SectionOneShot?: InputMaybe<SectionOneShotUpdateManyWithNestedWhereInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersUpdateManyWithNestedWhereInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableUpdateManyWithNestedWhereInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpdateManyWithNestedWhereInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateManyWithNestedWhereInput>
  SectionTab?: InputMaybe<SectionTabUpdateManyWithNestedWhereInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateManyWithNestedWhereInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpdateManyWithNestedWhereInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateManyWithNestedWhereInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateManyWithNestedWhereInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpdateManyWithNestedWhereInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateManyWithNestedWhereInput>
  TextMedia?: InputMaybe<TextMediaUpdateManyWithNestedWhereInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpdateManyWithNestedWhereInput>
}

export type LandingPagepageLayoutUnionUpdateOneInlineInput = {
  /** Create and connect one LandingPagepageLayoutUnion document */
  create?: InputMaybe<LandingPagepageLayoutUnionCreateInput>
  /** Delete currently connected LandingPagepageLayoutUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single LandingPagepageLayoutUnion document */
  update?: InputMaybe<LandingPagepageLayoutUnionUpdateWithNestedWhereUniqueInput>
  /** Upsert single LandingPagepageLayoutUnion document */
  upsert?: InputMaybe<LandingPagepageLayoutUnionUpsertWithNestedWhereUniqueInput>
}

export type LandingPagepageLayoutUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueAndPositionInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductUpdateWithNestedWhereUniqueAndPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateWithNestedWhereUniqueAndPositionInput>
  RichContent?: InputMaybe<RichContentUpdateWithNestedWhereUniqueAndPositionInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpdateWithNestedWhereUniqueAndPositionInput>
  SectionBanner?: InputMaybe<SectionBannerUpdateWithNestedWhereUniqueAndPositionInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateWithNestedWhereUniqueAndPositionInput>
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueAndPositionInput>
  SectionCta?: InputMaybe<SectionCtaUpdateWithNestedWhereUniqueAndPositionInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListUpdateWithNestedWhereUniqueAndPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueAndPositionInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionHero?: InputMaybe<SectionHeroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpdateWithNestedWhereUniqueAndPositionInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpdateWithNestedWhereUniqueAndPositionInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateWithNestedWhereUniqueAndPositionInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceUpdateWithNestedWhereUniqueAndPositionInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpdateWithNestedWhereUniqueAndPositionInput>
  SectionOneShot?: InputMaybe<SectionOneShotUpdateWithNestedWhereUniqueAndPositionInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersUpdateWithNestedWhereUniqueAndPositionInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableUpdateWithNestedWhereUniqueAndPositionInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpdateWithNestedWhereUniqueAndPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTab?: InputMaybe<SectionTabUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpdateWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateWithNestedWhereUniqueAndPositionInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpdateWithNestedWhereUniqueAndPositionInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateWithNestedWhereUniqueAndPositionInput>
  TextMedia?: InputMaybe<TextMediaUpdateWithNestedWhereUniqueAndPositionInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpdateWithNestedWhereUniqueAndPositionInput>
}

export type LandingPagepageLayoutUnionUpdateWithNestedWhereUniqueInput = {
  Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductUpdateWithNestedWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateWithNestedWhereUniqueInput>
  RichContent?: InputMaybe<RichContentUpdateWithNestedWhereUniqueInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpdateWithNestedWhereUniqueInput>
  SectionBanner?: InputMaybe<SectionBannerUpdateWithNestedWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpdateWithNestedWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaUpdateWithNestedWhereUniqueInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListUpdateWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroUpdateWithNestedWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroUpdateWithNestedWhereUniqueInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpdateWithNestedWhereUniqueInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpdateWithNestedWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroUpdateWithNestedWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpdateWithNestedWhereUniqueInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceUpdateWithNestedWhereUniqueInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpdateWithNestedWhereUniqueInput>
  SectionOneShot?: InputMaybe<SectionOneShotUpdateWithNestedWhereUniqueInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersUpdateWithNestedWhereUniqueInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableUpdateWithNestedWhereUniqueInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpdateWithNestedWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueInput>
  SectionTab?: InputMaybe<SectionTabUpdateWithNestedWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpdateWithNestedWhereUniqueInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpdateWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoUpdateWithNestedWhereUniqueInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpdateWithNestedWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateWithNestedWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaUpdateWithNestedWhereUniqueInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpdateWithNestedWhereUniqueInput>
}

export type LandingPagepageLayoutUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueAndPositionInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductUpsertWithNestedWhereUniqueAndPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpsertWithNestedWhereUniqueAndPositionInput>
  RichContent?: InputMaybe<RichContentUpsertWithNestedWhereUniqueAndPositionInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpsertWithNestedWhereUniqueAndPositionInput>
  SectionBanner?: InputMaybe<SectionBannerUpsertWithNestedWhereUniqueAndPositionInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpsertWithNestedWhereUniqueAndPositionInput>
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueAndPositionInput>
  SectionCta?: InputMaybe<SectionCtaUpsertWithNestedWhereUniqueAndPositionInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListUpsertWithNestedWhereUniqueAndPositionInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueAndPositionInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionHero?: InputMaybe<SectionHeroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpsertWithNestedWhereUniqueAndPositionInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpsertWithNestedWhereUniqueAndPositionInput>
  SectionIntro?: InputMaybe<SectionIntroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpsertWithNestedWhereUniqueAndPositionInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceUpsertWithNestedWhereUniqueAndPositionInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpsertWithNestedWhereUniqueAndPositionInput>
  SectionOneShot?: InputMaybe<SectionOneShotUpsertWithNestedWhereUniqueAndPositionInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersUpsertWithNestedWhereUniqueAndPositionInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableUpsertWithNestedWhereUniqueAndPositionInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpsertWithNestedWhereUniqueAndPositionInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTab?: InputMaybe<SectionTabUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpsertWithNestedWhereUniqueAndPositionInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>
  SectionVideo?: InputMaybe<SectionVideoUpsertWithNestedWhereUniqueAndPositionInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpsertWithNestedWhereUniqueAndPositionInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpsertWithNestedWhereUniqueAndPositionInput>
  TextMedia?: InputMaybe<TextMediaUpsertWithNestedWhereUniqueAndPositionInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpsertWithNestedWhereUniqueAndPositionInput>
}

export type LandingPagepageLayoutUnionUpsertWithNestedWhereUniqueInput = {
  Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductUpsertWithNestedWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpsertWithNestedWhereUniqueInput>
  RichContent?: InputMaybe<RichContentUpsertWithNestedWhereUniqueInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetUpsertWithNestedWhereUniqueInput>
  SectionBanner?: InputMaybe<SectionBannerUpsertWithNestedWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersUpsertWithNestedWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaUpsertWithNestedWhereUniqueInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListUpsertWithNestedWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroUpsertWithNestedWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroUpsertWithNestedWhereUniqueInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormUpsertWithNestedWhereUniqueInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderUpsertWithNestedWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroUpsertWithNestedWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterUpsertWithNestedWhereUniqueInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceUpsertWithNestedWhereUniqueInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerUpsertWithNestedWhereUniqueInput>
  SectionOneShot?: InputMaybe<SectionOneShotUpsertWithNestedWhereUniqueInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersUpsertWithNestedWhereUniqueInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableUpsertWithNestedWhereUniqueInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaUpsertWithNestedWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueInput>
  SectionTab?: InputMaybe<SectionTabUpsertWithNestedWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserUpsertWithNestedWhereUniqueInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialUpsertWithNestedWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoUpsertWithNestedWhereUniqueInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserUpsertWithNestedWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpsertWithNestedWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaUpsertWithNestedWhereUniqueInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerUpsertWithNestedWhereUniqueInput>
}

export type LandingPagepageLayoutUnionWhereInput = {
  Faq?: InputMaybe<FaqWhereInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductWhereInput>
  PreviewCardList?: InputMaybe<PreviewCardListWhereInput>
  RichContent?: InputMaybe<RichContentWhereInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetWhereInput>
  SectionBanner?: InputMaybe<SectionBannerWhereInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersWhereInput>
  SectionContact?: InputMaybe<SectionContactWhereInput>
  SectionCta?: InputMaybe<SectionCtaWhereInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListWhereInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroWhereInput>
  SectionHero?: InputMaybe<SectionHeroWhereInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormWhereInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderWhereInput>
  SectionIntro?: InputMaybe<SectionIntroWhereInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterWhereInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceWhereInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerWhereInput>
  SectionOneShot?: InputMaybe<SectionOneShotWhereInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersWhereInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableWhereInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaWhereInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereInput>
  SectionTab?: InputMaybe<SectionTabWhereInput>
  SectionTeaser?: InputMaybe<SectionTeaserWhereInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialWhereInput>
  SectionTiles?: InputMaybe<SectionTilesWhereInput>
  SectionVideo?: InputMaybe<SectionVideoWhereInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserWhereInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderWhereInput>
  TextMedia?: InputMaybe<TextMediaWhereInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerWhereInput>
}

export type LandingPagepageLayoutUnionWhereUniqueInput = {
  Faq?: InputMaybe<FaqWhereUniqueInput>
  PpcReviewsProduct?: InputMaybe<PpcReviewsProductWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListWhereUniqueInput>
  RichContent?: InputMaybe<RichContentWhereUniqueInput>
  SectionAnchorTarget?: InputMaybe<SectionAnchorTargetWhereUniqueInput>
  SectionBanner?: InputMaybe<SectionBannerWhereUniqueInput>
  SectionByTheNumbers?: InputMaybe<SectionByTheNumbersWhereUniqueInput>
  SectionContact?: InputMaybe<SectionContactWhereUniqueInput>
  SectionCta?: InputMaybe<SectionCtaWhereUniqueInput>
  SectionCuratedSpeakerList?: InputMaybe<SectionCuratedSpeakerListWhereUniqueInput>
  SectionExplanationBlocks?: InputMaybe<SectionExplanationBlocksWhereUniqueInput>
  SectionFramesHero?: InputMaybe<SectionFramesHeroWhereUniqueInput>
  SectionHero?: InputMaybe<SectionHeroWhereUniqueInput>
  SectionHubspotForm?: InputMaybe<SectionHubspotFormWhereUniqueInput>
  SectionImageSlider?: InputMaybe<SectionImageSliderWhereUniqueInput>
  SectionIntro?: InputMaybe<SectionIntroWhereUniqueInput>
  SectionNewsletter?: InputMaybe<SectionNewsletterWhereUniqueInput>
  SectionNewsletterAudience?: InputMaybe<SectionNewsletterAudienceWhereUniqueInput>
  SectionOMRPartner?: InputMaybe<SectionOmrPartnerWhereUniqueInput>
  SectionOneShot?: InputMaybe<SectionOneShotWhereUniqueInput>
  SectionPricingTiers?: InputMaybe<SectionPricingTiersWhereUniqueInput>
  SectionReviewsFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableWhereUniqueInput>
  SectionSlimCta?: InputMaybe<SectionSlimCtaWhereUniqueInput>
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereUniqueInput>
  SectionTab?: InputMaybe<SectionTabWhereUniqueInput>
  SectionTeaser?: InputMaybe<SectionTeaserWhereUniqueInput>
  SectionTestimonial?: InputMaybe<SectionTestimonialWhereUniqueInput>
  SectionTiles?: InputMaybe<SectionTilesWhereUniqueInput>
  SectionVideo?: InputMaybe<SectionVideoWhereUniqueInput>
  SubscriptionTeaser?: InputMaybe<SubscriptionTeaserWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderWhereUniqueInput>
  TextMedia?: InputMaybe<TextMediaWhereUniqueInput>
  TextMediaBanner?: InputMaybe<TextMediaBannerWhereUniqueInput>
}

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  De = 'de',
  En = 'en',
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location'
  distance: Scalars['Float']['output']
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput
}

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

/** Lucide Icon */
export enum LucideIcon {
  Accessibility = 'accessibility',
  Apple = 'apple',
  ArrowDownUp = 'arrow_down_up',
  ArrowRight = 'arrow_right',
  AtSign = 'at_sign',
  Award = 'award',
  BadgePercent = 'badge_percent',
  Banana = 'banana',
  BicepsFlexed = 'biceps_flexed',
  Bike = 'bike',
  Binary = 'binary',
  BookOpen = 'book_open',
  Brain = 'brain',
  Briefcase = 'briefcase',
  BriefcaseBusiness = 'briefcaseBusiness',
  Building2 = 'building2',
  CalendarCheck = 'calendar_check',
  Candy = 'candy',
  ChartBarBig = 'chart_bar_big',
  ChevronDoubleRight = 'chevron_double_right',
  ChevronRight = 'chevron_right',
  ChevronUp = 'chevron_up',
  Contact = 'contact',
  CreditCard = 'credit_card',
  Dices = 'dices',
  Earth = 'earth',
  Feather = 'feather',
  Fingerprint = 'fingerprint',
  Footprints = 'footprints',
  GalleryHorizontal = 'gallery_horizontal',
  GitCompare = 'gitCompare',
  Glasses = 'glasses',
  Globe = 'globe',
  GraduationCap = 'graduationCap',
  Grid = 'grid',
  Hammer = 'hammer',
  HandHeart = 'hand_heart',
  HandMetal = 'hand_metal',
  Handbag = 'handbag',
  Headphones = 'headphones',
  House = 'house',
  HouseHeart = 'house_heart',
  Layers = 'layers',
  LibraryBig = 'libraryBig',
  Magnet = 'magnet',
  MapPin = 'map_pin',
  Megaphone = 'megaphone',
  MessageCircle = 'message_circle',
  MessageSquare = 'message_square',
  Mic = 'mic',
  MicVocal = 'mic_vocal',
  Monitor = 'monitor',
  MousePointerClick = 'mouse_pointer_click',
  Network = 'network',
  Newspaper = 'newspaper',
  PartyPopper = 'party_popper',
  Phone = 'phone',
  Pizza = 'pizza',
  Presentation = 'presentation',
  Repeat = 'repeat',
  Rocket = 'rocket',
  Search = 'search',
  Share = 'share',
  Share_2 = 'share_2',
  Signpost = 'signpost',
  Sparkles = 'sparkles',
  Speech = 'speech',
  Star = 'star',
  Target = 'target',
  Terminal = 'terminal',
  Ticket = 'ticket',
  TrendingUp = 'trending_up',
  Users = 'users',
  Wallet = 'wallet',
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfig = Entity &
  Node & {
    __typename?: 'ManageContentConfig'
    /** Slug to use in manage when user is not logged in - if not provided, item is not accesible for anonymous users. */
    anonymousSlug?: Maybe<Scalars['String']['output']>
    /** Slug of the page to show. */
    contentSlug: Scalars['String']['output']
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** The reference content page will be shown for the user with the given customer type. */
    customerTypes: Array<CustomerType>
    /** Get the document in other stages */
    documentInStages: Array<ManageContentConfig>
    /** List of ManageContentConfig versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<ManageContentConfig>
    /** Slug to use in manage when user is logged in - if not provided, item is not accessible with logged in url and not showing up in the Manage sidebar. */
    loggedInSlug?: Maybe<Scalars['String']['output']>
    /** Title to use in OMR Manage sidebar. */
    menuTitle?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Model to hold configuration options for pages to show in OMR Manage. */
export type ManageContentConfigUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ManageContentConfigConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ManageContentConfigWhereUniqueInput
}

/** A connection to a list of items. */
export type ManageContentConfigConnection = {
  __typename?: 'ManageContentConfigConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ManageContentConfigEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ManageContentConfigCreateInput = {
  anonymousSlug?: InputMaybe<Scalars['String']['input']>
  contentSlug: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  customerTypes?: InputMaybe<Array<CustomerType>>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ManageContentConfigCreateLocalizationsInput>
  loggedInSlug?: InputMaybe<Scalars['String']['input']>
  /** menuTitle input for default locale (de) */
  menuTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ManageContentConfigCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  menuTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ManageContentConfigCreateLocalizationInput = {
  /** Localization input */
  data: ManageContentConfigCreateLocalizationDataInput
  locale: Locale
}

export type ManageContentConfigCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ManageContentConfigCreateLocalizationInput>>
}

export type ManageContentConfigCreateManyInlineInput = {
  /** Connect multiple existing ManageContentConfig documents */
  connect?: InputMaybe<Array<ManageContentConfigWhereUniqueInput>>
  /** Create and connect multiple existing ManageContentConfig documents */
  create?: InputMaybe<Array<ManageContentConfigCreateInput>>
}

export type ManageContentConfigCreateOneInlineInput = {
  /** Connect one existing ManageContentConfig document */
  connect?: InputMaybe<ManageContentConfigWhereUniqueInput>
  /** Create and connect one ManageContentConfig document */
  create?: InputMaybe<ManageContentConfigCreateInput>
}

/** An edge in a connection. */
export type ManageContentConfigEdge = {
  __typename?: 'ManageContentConfigEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ManageContentConfig
}

/** Identifies documents */
export type ManageContentConfigManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ManageContentConfigWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ManageContentConfigWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ManageContentConfigWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  anonymousSlug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  anonymousSlug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  anonymousSlug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  anonymousSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  anonymousSlug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  anonymousSlug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  anonymousSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  anonymousSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  anonymousSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  anonymousSlug_starts_with?: InputMaybe<Scalars['String']['input']>
  contentSlug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  contentSlug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  contentSlug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  contentSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  contentSlug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  contentSlug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  contentSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  contentSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  contentSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  contentSlug_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  customerTypes?: InputMaybe<Array<CustomerType>>
  /** Matches if the field array contains *all* items provided to the filter */
  customerTypes_contains_all?: InputMaybe<Array<CustomerType>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  customerTypes_contains_none?: InputMaybe<Array<CustomerType>>
  /** Matches if the field array contains at least one item provided to the filter */
  customerTypes_contains_some?: InputMaybe<Array<CustomerType>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  customerTypes_not?: InputMaybe<Array<CustomerType>>
  documentInStages_every?: InputMaybe<ManageContentConfigWhereStageInput>
  documentInStages_none?: InputMaybe<ManageContentConfigWhereStageInput>
  documentInStages_some?: InputMaybe<ManageContentConfigWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  loggedInSlug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  loggedInSlug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  loggedInSlug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  loggedInSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  loggedInSlug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  loggedInSlug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  loggedInSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  loggedInSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  loggedInSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  loggedInSlug_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ManageContentConfigOrderByInput {
  AnonymousSlugAsc = 'anonymousSlug_ASC',
  AnonymousSlugDesc = 'anonymousSlug_DESC',
  ContentSlugAsc = 'contentSlug_ASC',
  ContentSlugDesc = 'contentSlug_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  CustomerTypesAsc = 'customerTypes_ASC',
  CustomerTypesDesc = 'customerTypes_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LoggedInSlugAsc = 'loggedInSlug_ASC',
  LoggedInSlugDesc = 'loggedInSlug_DESC',
  MenuTitleAsc = 'menuTitle_ASC',
  MenuTitleDesc = 'menuTitle_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ManageContentConfigUpdateInput = {
  anonymousSlug?: InputMaybe<Scalars['String']['input']>
  contentSlug?: InputMaybe<Scalars['String']['input']>
  customerTypes?: InputMaybe<Array<CustomerType>>
  /** Manage document localizations */
  localizations?: InputMaybe<ManageContentConfigUpdateLocalizationsInput>
  loggedInSlug?: InputMaybe<Scalars['String']['input']>
  /** menuTitle input for default locale (de) */
  menuTitle?: InputMaybe<Scalars['String']['input']>
}

export type ManageContentConfigUpdateLocalizationDataInput = {
  menuTitle?: InputMaybe<Scalars['String']['input']>
}

export type ManageContentConfigUpdateLocalizationInput = {
  data: ManageContentConfigUpdateLocalizationDataInput
  locale: Locale
}

export type ManageContentConfigUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ManageContentConfigCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ManageContentConfigUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ManageContentConfigUpsertLocalizationInput>>
}

export type ManageContentConfigUpdateManyInlineInput = {
  /** Connect multiple existing ManageContentConfig documents */
  connect?: InputMaybe<Array<ManageContentConfigConnectInput>>
  /** Create and connect multiple ManageContentConfig documents */
  create?: InputMaybe<Array<ManageContentConfigCreateInput>>
  /** Delete multiple ManageContentConfig documents */
  delete?: InputMaybe<Array<ManageContentConfigWhereUniqueInput>>
  /** Disconnect multiple ManageContentConfig documents */
  disconnect?: InputMaybe<Array<ManageContentConfigWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ManageContentConfig documents */
  set?: InputMaybe<Array<ManageContentConfigWhereUniqueInput>>
  /** Update multiple ManageContentConfig documents */
  update?: InputMaybe<Array<ManageContentConfigUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ManageContentConfig documents */
  upsert?: InputMaybe<Array<ManageContentConfigUpsertWithNestedWhereUniqueInput>>
}

export type ManageContentConfigUpdateManyInput = {
  anonymousSlug?: InputMaybe<Scalars['String']['input']>
  contentSlug?: InputMaybe<Scalars['String']['input']>
  customerTypes?: InputMaybe<Array<CustomerType>>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ManageContentConfigUpdateManyLocalizationsInput>
  loggedInSlug?: InputMaybe<Scalars['String']['input']>
  /** menuTitle input for default locale (de) */
  menuTitle?: InputMaybe<Scalars['String']['input']>
}

export type ManageContentConfigUpdateManyLocalizationDataInput = {
  menuTitle?: InputMaybe<Scalars['String']['input']>
}

export type ManageContentConfigUpdateManyLocalizationInput = {
  data: ManageContentConfigUpdateManyLocalizationDataInput
  locale: Locale
}

export type ManageContentConfigUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ManageContentConfigUpdateManyLocalizationInput>>
}

export type ManageContentConfigUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ManageContentConfigUpdateManyInput
  /** Document search */
  where: ManageContentConfigWhereInput
}

export type ManageContentConfigUpdateOneInlineInput = {
  /** Connect existing ManageContentConfig document */
  connect?: InputMaybe<ManageContentConfigWhereUniqueInput>
  /** Create and connect one ManageContentConfig document */
  create?: InputMaybe<ManageContentConfigCreateInput>
  /** Delete currently connected ManageContentConfig document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ManageContentConfig document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ManageContentConfig document */
  update?: InputMaybe<ManageContentConfigUpdateWithNestedWhereUniqueInput>
  /** Upsert single ManageContentConfig document */
  upsert?: InputMaybe<ManageContentConfigUpsertWithNestedWhereUniqueInput>
}

export type ManageContentConfigUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ManageContentConfigUpdateInput
  /** Unique document search */
  where: ManageContentConfigWhereUniqueInput
}

export type ManageContentConfigUpsertInput = {
  /** Create document if it didn't exist */
  create: ManageContentConfigCreateInput
  /** Update document if it exists */
  update: ManageContentConfigUpdateInput
}

export type ManageContentConfigUpsertLocalizationInput = {
  create: ManageContentConfigCreateLocalizationDataInput
  locale: Locale
  update: ManageContentConfigUpdateLocalizationDataInput
}

export type ManageContentConfigUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ManageContentConfigUpsertInput
  /** Unique document search */
  where: ManageContentConfigWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ManageContentConfigWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ManageContentConfigWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ManageContentConfigWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ManageContentConfigWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ManageContentConfigWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  anonymousSlug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  anonymousSlug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  anonymousSlug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  anonymousSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  anonymousSlug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  anonymousSlug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  anonymousSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  anonymousSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  anonymousSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  anonymousSlug_starts_with?: InputMaybe<Scalars['String']['input']>
  contentSlug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  contentSlug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  contentSlug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  contentSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  contentSlug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  contentSlug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  contentSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  contentSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  contentSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  contentSlug_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  customerTypes?: InputMaybe<Array<CustomerType>>
  /** Matches if the field array contains *all* items provided to the filter */
  customerTypes_contains_all?: InputMaybe<Array<CustomerType>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  customerTypes_contains_none?: InputMaybe<Array<CustomerType>>
  /** Matches if the field array contains at least one item provided to the filter */
  customerTypes_contains_some?: InputMaybe<Array<CustomerType>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  customerTypes_not?: InputMaybe<Array<CustomerType>>
  documentInStages_every?: InputMaybe<ManageContentConfigWhereStageInput>
  documentInStages_none?: InputMaybe<ManageContentConfigWhereStageInput>
  documentInStages_some?: InputMaybe<ManageContentConfigWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  loggedInSlug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  loggedInSlug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  loggedInSlug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  loggedInSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  loggedInSlug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  loggedInSlug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  loggedInSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  loggedInSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  loggedInSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  loggedInSlug_starts_with?: InputMaybe<Scalars['String']['input']>
  menuTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  menuTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  menuTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  menuTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  menuTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  menuTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  menuTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  menuTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  menuTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  menuTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ManageContentConfigWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ManageContentConfigWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ManageContentConfigWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ManageContentConfigWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ManageContentConfigWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ManageContentConfig record uniquely */
export type ManageContentConfigWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarker = Entity &
  Node & {
    __typename?: 'MapMarker'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<MapMarker>
    /** Custom extra content in the custom map popup rendered as the last section of the popup. */
    extraContent?: Maybe<RichText>
    /** List of MapMarker versions */
    history: Array<Version>
    /** Icon displayed on the map. */
    icon?: Maybe<MapMarkerIcon>
    /** The unique identifier */
    id: Scalars['ID']['output']
    linkoutUrl?: Maybe<Scalars['String']['output']>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<MapMarker>
    location: Location
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerIconArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Map marker used in the CustomMap component to highligh important places and provide more information about them. */
export type MapMarkerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type MapMarkerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: MapMarkerWhereUniqueInput
}

/** A connection to a list of items. */
export type MapMarkerConnection = {
  __typename?: 'MapMarkerConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<MapMarkerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type MapMarkerCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  extraContent?: InputMaybe<Scalars['RichTextAST']['input']>
  icon?: InputMaybe<MapMarkerIconCreateOneInlineInput>
  linkoutUrl?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<MapMarkerCreateLocalizationsInput>
  location: LocationInput
  sectionCustomMap?: InputMaybe<SectionMapCreateManyInlineInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type MapMarkerCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type MapMarkerCreateLocalizationInput = {
  /** Localization input */
  data: MapMarkerCreateLocalizationDataInput
  locale: Locale
}

export type MapMarkerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<MapMarkerCreateLocalizationInput>>
}

export type MapMarkerCreateManyInlineInput = {
  /** Connect multiple existing MapMarker documents */
  connect?: InputMaybe<Array<MapMarkerWhereUniqueInput>>
  /** Create and connect multiple existing MapMarker documents */
  create?: InputMaybe<Array<MapMarkerCreateInput>>
}

export type MapMarkerCreateOneInlineInput = {
  /** Connect one existing MapMarker document */
  connect?: InputMaybe<MapMarkerWhereUniqueInput>
  /** Create and connect one MapMarker document */
  create?: InputMaybe<MapMarkerCreateInput>
}

/** An edge in a connection. */
export type MapMarkerEdge = {
  __typename?: 'MapMarkerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: MapMarker
}

/** Icon used for Map marker in the CustomMap component. */
export type MapMarkerIcon = Entity &
  Node & {
    __typename?: 'MapMarkerIcon'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<MapMarkerIcon>
    /** List of MapMarkerIcon versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    mapMarker: Array<MapMarker>
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    url: Scalars['String']['output']
  }

/** Icon used for Map marker in the CustomMap component. */
export type MapMarkerIconCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Icon used for Map marker in the CustomMap component. */
export type MapMarkerIconDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Icon used for Map marker in the CustomMap component. */
export type MapMarkerIconHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Icon used for Map marker in the CustomMap component. */
export type MapMarkerIconMapMarkerArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<MapMarkerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MapMarkerWhereInput>
}

/** Icon used for Map marker in the CustomMap component. */
export type MapMarkerIconPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Icon used for Map marker in the CustomMap component. */
export type MapMarkerIconScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Icon used for Map marker in the CustomMap component. */
export type MapMarkerIconUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type MapMarkerIconConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: MapMarkerIconWhereUniqueInput
}

/** A connection to a list of items. */
export type MapMarkerIconConnection = {
  __typename?: 'MapMarkerIconConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<MapMarkerIconEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type MapMarkerIconCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  mapMarker?: InputMaybe<MapMarkerCreateManyInlineInput>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  url: Scalars['String']['input']
}

export type MapMarkerIconCreateManyInlineInput = {
  /** Connect multiple existing MapMarkerIcon documents */
  connect?: InputMaybe<Array<MapMarkerIconWhereUniqueInput>>
  /** Create and connect multiple existing MapMarkerIcon documents */
  create?: InputMaybe<Array<MapMarkerIconCreateInput>>
}

export type MapMarkerIconCreateOneInlineInput = {
  /** Connect one existing MapMarkerIcon document */
  connect?: InputMaybe<MapMarkerIconWhereUniqueInput>
  /** Create and connect one MapMarkerIcon document */
  create?: InputMaybe<MapMarkerIconCreateInput>
}

/** An edge in a connection. */
export type MapMarkerIconEdge = {
  __typename?: 'MapMarkerIconEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: MapMarkerIcon
}

/** Identifies documents */
export type MapMarkerIconManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MapMarkerIconWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MapMarkerIconWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MapMarkerIconWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<MapMarkerIconWhereStageInput>
  documentInStages_none?: InputMaybe<MapMarkerIconWhereStageInput>
  documentInStages_some?: InputMaybe<MapMarkerIconWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  mapMarker_every?: InputMaybe<MapMarkerWhereInput>
  mapMarker_none?: InputMaybe<MapMarkerWhereInput>
  mapMarker_some?: InputMaybe<MapMarkerWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum MapMarkerIconOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
}

export type MapMarkerIconUpdateInput = {
  mapMarker?: InputMaybe<MapMarkerUpdateManyInlineInput>
  name?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MapMarkerIconUpdateManyInlineInput = {
  /** Connect multiple existing MapMarkerIcon documents */
  connect?: InputMaybe<Array<MapMarkerIconConnectInput>>
  /** Create and connect multiple MapMarkerIcon documents */
  create?: InputMaybe<Array<MapMarkerIconCreateInput>>
  /** Delete multiple MapMarkerIcon documents */
  delete?: InputMaybe<Array<MapMarkerIconWhereUniqueInput>>
  /** Disconnect multiple MapMarkerIcon documents */
  disconnect?: InputMaybe<Array<MapMarkerIconWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing MapMarkerIcon documents */
  set?: InputMaybe<Array<MapMarkerIconWhereUniqueInput>>
  /** Update multiple MapMarkerIcon documents */
  update?: InputMaybe<Array<MapMarkerIconUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple MapMarkerIcon documents */
  upsert?: InputMaybe<Array<MapMarkerIconUpsertWithNestedWhereUniqueInput>>
}

export type MapMarkerIconUpdateManyInput = {
  name?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MapMarkerIconUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MapMarkerIconUpdateManyInput
  /** Document search */
  where: MapMarkerIconWhereInput
}

export type MapMarkerIconUpdateOneInlineInput = {
  /** Connect existing MapMarkerIcon document */
  connect?: InputMaybe<MapMarkerIconWhereUniqueInput>
  /** Create and connect one MapMarkerIcon document */
  create?: InputMaybe<MapMarkerIconCreateInput>
  /** Delete currently connected MapMarkerIcon document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected MapMarkerIcon document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single MapMarkerIcon document */
  update?: InputMaybe<MapMarkerIconUpdateWithNestedWhereUniqueInput>
  /** Upsert single MapMarkerIcon document */
  upsert?: InputMaybe<MapMarkerIconUpsertWithNestedWhereUniqueInput>
}

export type MapMarkerIconUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MapMarkerIconUpdateInput
  /** Unique document search */
  where: MapMarkerIconWhereUniqueInput
}

export type MapMarkerIconUpsertInput = {
  /** Create document if it didn't exist */
  create: MapMarkerIconCreateInput
  /** Update document if it exists */
  update: MapMarkerIconUpdateInput
}

export type MapMarkerIconUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MapMarkerIconUpsertInput
  /** Unique document search */
  where: MapMarkerIconWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type MapMarkerIconWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type MapMarkerIconWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MapMarkerIconWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MapMarkerIconWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MapMarkerIconWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<MapMarkerIconWhereStageInput>
  documentInStages_none?: InputMaybe<MapMarkerIconWhereStageInput>
  documentInStages_some?: InputMaybe<MapMarkerIconWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  mapMarker_every?: InputMaybe<MapMarkerWhereInput>
  mapMarker_none?: InputMaybe<MapMarkerWhereInput>
  mapMarker_some?: InputMaybe<MapMarkerWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MapMarkerIconWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MapMarkerIconWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MapMarkerIconWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MapMarkerIconWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MapMarkerIconWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References MapMarkerIcon record uniquely */
export type MapMarkerIconWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Identifies documents */
export type MapMarkerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MapMarkerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MapMarkerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MapMarkerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<MapMarkerWhereStageInput>
  documentInStages_none?: InputMaybe<MapMarkerWhereStageInput>
  documentInStages_some?: InputMaybe<MapMarkerWhereStageInput>
  icon?: InputMaybe<MapMarkerIconWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  linkoutUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkoutUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkoutUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkoutUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkoutUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkoutUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkoutUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkoutUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkoutUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkoutUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum MapMarkerOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkoutUrlAsc = 'linkoutUrl_ASC',
  LinkoutUrlDesc = 'linkoutUrl_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type MapMarkerUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  extraContent?: InputMaybe<Scalars['RichTextAST']['input']>
  icon?: InputMaybe<MapMarkerIconUpdateOneInlineInput>
  linkoutUrl?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<MapMarkerUpdateLocalizationsInput>
  location?: InputMaybe<LocationInput>
  sectionCustomMap?: InputMaybe<SectionMapUpdateManyInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type MapMarkerUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type MapMarkerUpdateLocalizationInput = {
  data: MapMarkerUpdateLocalizationDataInput
  locale: Locale
}

export type MapMarkerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<MapMarkerCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<MapMarkerUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<MapMarkerUpsertLocalizationInput>>
}

export type MapMarkerUpdateManyInlineInput = {
  /** Connect multiple existing MapMarker documents */
  connect?: InputMaybe<Array<MapMarkerConnectInput>>
  /** Create and connect multiple MapMarker documents */
  create?: InputMaybe<Array<MapMarkerCreateInput>>
  /** Delete multiple MapMarker documents */
  delete?: InputMaybe<Array<MapMarkerWhereUniqueInput>>
  /** Disconnect multiple MapMarker documents */
  disconnect?: InputMaybe<Array<MapMarkerWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing MapMarker documents */
  set?: InputMaybe<Array<MapMarkerWhereUniqueInput>>
  /** Update multiple MapMarker documents */
  update?: InputMaybe<Array<MapMarkerUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple MapMarker documents */
  upsert?: InputMaybe<Array<MapMarkerUpsertWithNestedWhereUniqueInput>>
}

export type MapMarkerUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  extraContent?: InputMaybe<Scalars['RichTextAST']['input']>
  linkoutUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<MapMarkerUpdateManyLocalizationsInput>
  location?: InputMaybe<LocationInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type MapMarkerUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type MapMarkerUpdateManyLocalizationInput = {
  data: MapMarkerUpdateManyLocalizationDataInput
  locale: Locale
}

export type MapMarkerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<MapMarkerUpdateManyLocalizationInput>>
}

export type MapMarkerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MapMarkerUpdateManyInput
  /** Document search */
  where: MapMarkerWhereInput
}

export type MapMarkerUpdateOneInlineInput = {
  /** Connect existing MapMarker document */
  connect?: InputMaybe<MapMarkerWhereUniqueInput>
  /** Create and connect one MapMarker document */
  create?: InputMaybe<MapMarkerCreateInput>
  /** Delete currently connected MapMarker document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected MapMarker document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single MapMarker document */
  update?: InputMaybe<MapMarkerUpdateWithNestedWhereUniqueInput>
  /** Upsert single MapMarker document */
  upsert?: InputMaybe<MapMarkerUpsertWithNestedWhereUniqueInput>
}

export type MapMarkerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MapMarkerUpdateInput
  /** Unique document search */
  where: MapMarkerWhereUniqueInput
}

export type MapMarkerUpsertInput = {
  /** Create document if it didn't exist */
  create: MapMarkerCreateInput
  /** Update document if it exists */
  update: MapMarkerUpdateInput
}

export type MapMarkerUpsertLocalizationInput = {
  create: MapMarkerCreateLocalizationDataInput
  locale: Locale
  update: MapMarkerUpdateLocalizationDataInput
}

export type MapMarkerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MapMarkerUpsertInput
  /** Unique document search */
  where: MapMarkerWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type MapMarkerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type MapMarkerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MapMarkerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MapMarkerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MapMarkerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<MapMarkerWhereStageInput>
  documentInStages_none?: InputMaybe<MapMarkerWhereStageInput>
  documentInStages_some?: InputMaybe<MapMarkerWhereStageInput>
  icon?: InputMaybe<MapMarkerIconWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  linkoutUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkoutUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkoutUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkoutUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkoutUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkoutUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkoutUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkoutUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkoutUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkoutUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MapMarkerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MapMarkerWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MapMarkerWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MapMarkerWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MapMarkerWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References MapMarker record uniquely */
export type MapMarkerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Create one animatedCounter */
  createAnimatedCounter?: Maybe<AnimatedCounter>
  /** Create one article */
  createArticle?: Maybe<Article>
  /** Create one articleCategory */
  createArticleCategory?: Maybe<ArticleCategory>
  /** Create one articlePageView */
  createArticlePageView?: Maybe<ArticlePageView>
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>
  /** Create one author */
  createAuthor?: Maybe<Author>
  /** Create one booth */
  createBooth?: Maybe<Booth>
  /** Create one careerPage */
  createCareerPage?: Maybe<CareerPage>
  /** Create one contentReference */
  createContentReference?: Maybe<ContentReference>
  /** Create one educationReport */
  createEducationReport?: Maybe<EducationReport>
  /** Create one educationSeminar */
  createEducationSeminar?: Maybe<EducationSeminar>
  /** Create one event */
  createEvent?: Maybe<Event>
  /** Create one eventAppPage */
  createEventAppPage?: Maybe<EventAppPage>
  /** Create one eventPage */
  createEventPage?: Maybe<EventPage>
  /** Create one eventStage */
  createEventStage?: Maybe<EventStage>
  /** Create one exhibitorListOrder */
  createExhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Create one faqQuestion */
  createFaqQuestion?: Maybe<FaqQuestion>
  /** Create one footer */
  createFooter?: Maybe<Footer>
  /** Create one glossary */
  createGlossary?: Maybe<Glossary>
  /** Create one header */
  createHeader?: Maybe<Header>
  /** Create one hotel */
  createHotel?: Maybe<Hotel>
  /** Create one htmlEmbed */
  createHtmlEmbed?: Maybe<HtmlEmbed>
  /** Create one hubContentEntry */
  createHubContentEntry?: Maybe<HubContentEntry>
  /** Create one hubPage */
  createHubPage?: Maybe<HubPage>
  /** Create one hubPageCountdownHero */
  createHubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Create one imageGalleryEmbed */
  createImageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Create one interest */
  createInterest?: Maybe<Interest>
  /** Create one jobListing */
  createJobListing?: Maybe<JobListing>
  /** Create one journey */
  createJourney?: Maybe<Journey>
  /** Create one landingPage */
  createLandingPage?: Maybe<LandingPage>
  /** Create one manageContentConfig */
  createManageContentConfig?: Maybe<ManageContentConfig>
  /** Create one mapMarker */
  createMapMarker?: Maybe<MapMarker>
  /** Create one mapMarkerIcon */
  createMapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Create one newsletterAudience */
  createNewsletterAudience?: Maybe<NewsletterAudience>
  /** Create one notification */
  createNotification?: Maybe<Notification>
  /** Create one oMRPartner */
  createOMRPartner?: Maybe<OmrPartner>
  /** Create one partnerCompany */
  createPartnerCompany?: Maybe<PartnerCompany>
  /** Create one physicalLocation */
  createPhysicalLocation?: Maybe<PhysicalLocation>
  /** Create one podcastEpisode */
  createPodcastEpisode?: Maybe<PodcastEpisode>
  /** Create one podcastGroup */
  createPodcastGroup?: Maybe<PodcastGroup>
  /** Create one pricingTier */
  createPricingTier?: Maybe<PricingTier>
  /** Create one recommendationFood */
  createRecommendationFood?: Maybe<RecommendationFood>
  /** Create one recommendationNightOut */
  createRecommendationNightOut?: Maybe<RecommendationNightOut>
  /** Create one reviewsAgency */
  createReviewsAgency?: Maybe<ReviewsAgency>
  /** Create one reviewsFeatureRow */
  createReviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Create one reviewsFeaturesSection */
  createReviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Create one reviewsProduct */
  createReviewsProduct?: Maybe<ReviewsProduct>
  /** Create one reviewsProductCategory */
  createReviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Create one reviewsProductWidget */
  createReviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>
  /** Create one siteSection */
  createSiteSection?: Maybe<SiteSection>
  /** Create one socialEmbed */
  createSocialEmbed?: Maybe<SocialEmbed>
  /** Create one speaker */
  createSpeaker?: Maybe<Speaker>
  /** Create one speakerListOrder */
  createSpeakerListOrder?: Maybe<SpeakerListOrder>
  /** Create one tabContent */
  createTabContent?: Maybe<TabContent>
  /** Create one tag */
  createTag?: Maybe<Tag>
  /** Create one ticketsTableColumn */
  createTicketsTableColumn?: Maybe<TicketsTableColumn>
  /** Create one topicPage */
  createTopicPage?: Maybe<TopicPage>
  /** Create one topicPageCategory */
  createTopicPageCategory?: Maybe<TopicPageCategory>
  /** Create one vGWort */
  createVGWort?: Maybe<VgWort>
  /** Delete one animatedCounter from _all_ existing stages. Returns deleted document. */
  deleteAnimatedCounter?: Maybe<AnimatedCounter>
  /** Delete one article from _all_ existing stages. Returns deleted document. */
  deleteArticle?: Maybe<Article>
  /** Delete one articleCategory from _all_ existing stages. Returns deleted document. */
  deleteArticleCategory?: Maybe<ArticleCategory>
  /** Delete one articlePageView from _all_ existing stages. Returns deleted document. */
  deleteArticlePageView?: Maybe<ArticlePageView>
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>
  /** Delete one author from _all_ existing stages. Returns deleted document. */
  deleteAuthor?: Maybe<Author>
  /** Delete one booth from _all_ existing stages. Returns deleted document. */
  deleteBooth?: Maybe<Booth>
  /** Delete one careerPage from _all_ existing stages. Returns deleted document. */
  deleteCareerPage?: Maybe<CareerPage>
  /** Delete one contentReference from _all_ existing stages. Returns deleted document. */
  deleteContentReference?: Maybe<ContentReference>
  /** Delete one educationReport from _all_ existing stages. Returns deleted document. */
  deleteEducationReport?: Maybe<EducationReport>
  /** Delete one educationSeminar from _all_ existing stages. Returns deleted document. */
  deleteEducationSeminar?: Maybe<EducationSeminar>
  /** Delete one event from _all_ existing stages. Returns deleted document. */
  deleteEvent?: Maybe<Event>
  /** Delete one eventAppPage from _all_ existing stages. Returns deleted document. */
  deleteEventAppPage?: Maybe<EventAppPage>
  /** Delete one eventPage from _all_ existing stages. Returns deleted document. */
  deleteEventPage?: Maybe<EventPage>
  /** Delete one eventStage from _all_ existing stages. Returns deleted document. */
  deleteEventStage?: Maybe<EventStage>
  /** Delete one exhibitorListOrder from _all_ existing stages. Returns deleted document. */
  deleteExhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Delete one faqQuestion from _all_ existing stages. Returns deleted document. */
  deleteFaqQuestion?: Maybe<FaqQuestion>
  /** Delete one footer from _all_ existing stages. Returns deleted document. */
  deleteFooter?: Maybe<Footer>
  /** Delete one glossary from _all_ existing stages. Returns deleted document. */
  deleteGlossary?: Maybe<Glossary>
  /** Delete one header from _all_ existing stages. Returns deleted document. */
  deleteHeader?: Maybe<Header>
  /** Delete one hotel from _all_ existing stages. Returns deleted document. */
  deleteHotel?: Maybe<Hotel>
  /** Delete one htmlEmbed from _all_ existing stages. Returns deleted document. */
  deleteHtmlEmbed?: Maybe<HtmlEmbed>
  /** Delete one hubContentEntry from _all_ existing stages. Returns deleted document. */
  deleteHubContentEntry?: Maybe<HubContentEntry>
  /** Delete one hubPage from _all_ existing stages. Returns deleted document. */
  deleteHubPage?: Maybe<HubPage>
  /** Delete one hubPageCountdownHero from _all_ existing stages. Returns deleted document. */
  deleteHubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Delete one imageGalleryEmbed from _all_ existing stages. Returns deleted document. */
  deleteImageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Delete one interest from _all_ existing stages. Returns deleted document. */
  deleteInterest?: Maybe<Interest>
  /** Delete one jobListing from _all_ existing stages. Returns deleted document. */
  deleteJobListing?: Maybe<JobListing>
  /** Delete one journey from _all_ existing stages. Returns deleted document. */
  deleteJourney?: Maybe<Journey>
  /** Delete one landingPage from _all_ existing stages. Returns deleted document. */
  deleteLandingPage?: Maybe<LandingPage>
  /** Delete one manageContentConfig from _all_ existing stages. Returns deleted document. */
  deleteManageContentConfig?: Maybe<ManageContentConfig>
  /**
   * Delete many AnimatedCounter documents
   * @deprecated Please use the new paginated many mutation (deleteManyAnimatedCountersConnection)
   */
  deleteManyAnimatedCounters: BatchPayload
  /** Delete many AnimatedCounter documents, return deleted documents */
  deleteManyAnimatedCountersConnection: AnimatedCounterConnection
  /**
   * Delete many ArticleCategory documents
   * @deprecated Please use the new paginated many mutation (deleteManyArticleCategoriesConnection)
   */
  deleteManyArticleCategories: BatchPayload
  /** Delete many ArticleCategory documents, return deleted documents */
  deleteManyArticleCategoriesConnection: ArticleCategoryConnection
  /**
   * Delete many ArticlePageView documents
   * @deprecated Please use the new paginated many mutation (deleteManyArticlePageViewsConnection)
   */
  deleteManyArticlePageViews: BatchPayload
  /** Delete many ArticlePageView documents, return deleted documents */
  deleteManyArticlePageViewsConnection: ArticlePageViewConnection
  /**
   * Delete many Article documents
   * @deprecated Please use the new paginated many mutation (deleteManyArticlesConnection)
   */
  deleteManyArticles: BatchPayload
  /** Delete many Article documents, return deleted documents */
  deleteManyArticlesConnection: ArticleConnection
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection
  /**
   * Delete many Author documents
   * @deprecated Please use the new paginated many mutation (deleteManyAuthorsConnection)
   */
  deleteManyAuthors: BatchPayload
  /** Delete many Author documents, return deleted documents */
  deleteManyAuthorsConnection: AuthorConnection
  /**
   * Delete many Booth documents
   * @deprecated Please use the new paginated many mutation (deleteManyBoothsConnection)
   */
  deleteManyBooths: BatchPayload
  /** Delete many Booth documents, return deleted documents */
  deleteManyBoothsConnection: BoothConnection
  /**
   * Delete many CareerPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyCareerPagesConnection)
   */
  deleteManyCareerPages: BatchPayload
  /** Delete many CareerPage documents, return deleted documents */
  deleteManyCareerPagesConnection: CareerPageConnection
  /**
   * Delete many ContentReference documents
   * @deprecated Please use the new paginated many mutation (deleteManyContentReferencesConnection)
   */
  deleteManyContentReferences: BatchPayload
  /** Delete many ContentReference documents, return deleted documents */
  deleteManyContentReferencesConnection: ContentReferenceConnection
  /**
   * Delete many EducationReport documents
   * @deprecated Please use the new paginated many mutation (deleteManyEducationReportsConnection)
   */
  deleteManyEducationReports: BatchPayload
  /** Delete many EducationReport documents, return deleted documents */
  deleteManyEducationReportsConnection: EducationReportConnection
  /**
   * Delete many EducationSeminar documents
   * @deprecated Please use the new paginated many mutation (deleteManyEducationSeminarsConnection)
   */
  deleteManyEducationSeminars: BatchPayload
  /** Delete many EducationSeminar documents, return deleted documents */
  deleteManyEducationSeminarsConnection: EducationSeminarConnection
  /**
   * Delete many EventAppPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyEventAppPagesConnection)
   */
  deleteManyEventAppPages: BatchPayload
  /** Delete many EventAppPage documents, return deleted documents */
  deleteManyEventAppPagesConnection: EventAppPageConnection
  /**
   * Delete many EventPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyEventPagesConnection)
   */
  deleteManyEventPages: BatchPayload
  /** Delete many EventPage documents, return deleted documents */
  deleteManyEventPagesConnection: EventPageConnection
  /**
   * Delete many EventStage documents
   * @deprecated Please use the new paginated many mutation (deleteManyEventStagesConnection)
   */
  deleteManyEventStages: BatchPayload
  /** Delete many EventStage documents, return deleted documents */
  deleteManyEventStagesConnection: EventStageConnection
  /**
   * Delete many Event documents
   * @deprecated Please use the new paginated many mutation (deleteManyEventsConnection)
   */
  deleteManyEvents: BatchPayload
  /** Delete many Event documents, return deleted documents */
  deleteManyEventsConnection: EventConnection
  /**
   * Delete many ExhibitorListOrder documents
   * @deprecated Please use the new paginated many mutation (deleteManyExhibitorListOrdersConnection)
   */
  deleteManyExhibitorListOrders: BatchPayload
  /** Delete many ExhibitorListOrder documents, return deleted documents */
  deleteManyExhibitorListOrdersConnection: ExhibitorListOrderConnection
  /**
   * Delete many FaqQuestion documents
   * @deprecated Please use the new paginated many mutation (deleteManyFaqQuestionsConnection)
   */
  deleteManyFaqQuestions: BatchPayload
  /** Delete many FaqQuestion documents, return deleted documents */
  deleteManyFaqQuestionsConnection: FaqQuestionConnection
  /**
   * Delete many Footer documents
   * @deprecated Please use the new paginated many mutation (deleteManyFootersConnection)
   */
  deleteManyFooters: BatchPayload
  /** Delete many Footer documents, return deleted documents */
  deleteManyFootersConnection: FooterConnection
  /**
   * Delete many Glossary documents
   * @deprecated Please use the new paginated many mutation (deleteManyGlossariesConnection)
   */
  deleteManyGlossaries: BatchPayload
  /** Delete many Glossary documents, return deleted documents */
  deleteManyGlossariesConnection: GlossaryConnection
  /**
   * Delete many Header documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeadersConnection)
   */
  deleteManyHeaders: BatchPayload
  /** Delete many Header documents, return deleted documents */
  deleteManyHeadersConnection: HeaderConnection
  /**
   * Delete many Hotel documents
   * @deprecated Please use the new paginated many mutation (deleteManyHotelsConnection)
   */
  deleteManyHotels: BatchPayload
  /** Delete many Hotel documents, return deleted documents */
  deleteManyHotelsConnection: HotelConnection
  /**
   * Delete many HtmlEmbed documents
   * @deprecated Please use the new paginated many mutation (deleteManyHtmlEmbedsConnection)
   */
  deleteManyHtmlEmbeds: BatchPayload
  /** Delete many HtmlEmbed documents, return deleted documents */
  deleteManyHtmlEmbedsConnection: HtmlEmbedConnection
  /**
   * Delete many HubContentEntry documents
   * @deprecated Please use the new paginated many mutation (deleteManyHubContentEntriesConnection)
   */
  deleteManyHubContentEntries: BatchPayload
  /** Delete many HubContentEntry documents, return deleted documents */
  deleteManyHubContentEntriesConnection: HubContentEntryConnection
  /**
   * Delete many HubPageCountdownHero documents
   * @deprecated Please use the new paginated many mutation (deleteManyHubPageCountdownHeroesConnection)
   */
  deleteManyHubPageCountdownHeroes: BatchPayload
  /** Delete many HubPageCountdownHero documents, return deleted documents */
  deleteManyHubPageCountdownHeroesConnection: HubPageCountdownHeroConnection
  /**
   * Delete many HubPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyHubPagesConnection)
   */
  deleteManyHubPages: BatchPayload
  /** Delete many HubPage documents, return deleted documents */
  deleteManyHubPagesConnection: HubPageConnection
  /**
   * Delete many ImageGalleryEmbed documents
   * @deprecated Please use the new paginated many mutation (deleteManyImageGalleryEmbedsConnection)
   */
  deleteManyImageGalleryEmbeds: BatchPayload
  /** Delete many ImageGalleryEmbed documents, return deleted documents */
  deleteManyImageGalleryEmbedsConnection: ImageGalleryEmbedConnection
  /**
   * Delete many Interest documents
   * @deprecated Please use the new paginated many mutation (deleteManyInterestsConnection)
   */
  deleteManyInterests: BatchPayload
  /** Delete many Interest documents, return deleted documents */
  deleteManyInterestsConnection: InterestConnection
  /**
   * Delete many JobListing documents
   * @deprecated Please use the new paginated many mutation (deleteManyJobListingsConnection)
   */
  deleteManyJobListings: BatchPayload
  /** Delete many JobListing documents, return deleted documents */
  deleteManyJobListingsConnection: JobListingConnection
  /**
   * Delete many Journey documents
   * @deprecated Please use the new paginated many mutation (deleteManyJourneysConnection)
   */
  deleteManyJourneys: BatchPayload
  /** Delete many Journey documents, return deleted documents */
  deleteManyJourneysConnection: JourneyConnection
  /**
   * Delete many LandingPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyLandingPagesConnection)
   */
  deleteManyLandingPages: BatchPayload
  /** Delete many LandingPage documents, return deleted documents */
  deleteManyLandingPagesConnection: LandingPageConnection
  /**
   * Delete many ManageContentConfig documents
   * @deprecated Please use the new paginated many mutation (deleteManyManageContentConfigsConnection)
   */
  deleteManyManageContentConfigs: BatchPayload
  /** Delete many ManageContentConfig documents, return deleted documents */
  deleteManyManageContentConfigsConnection: ManageContentConfigConnection
  /**
   * Delete many MapMarkerIcon documents
   * @deprecated Please use the new paginated many mutation (deleteManyMapMarkerIconsConnection)
   */
  deleteManyMapMarkerIcons: BatchPayload
  /** Delete many MapMarkerIcon documents, return deleted documents */
  deleteManyMapMarkerIconsConnection: MapMarkerIconConnection
  /**
   * Delete many MapMarker documents
   * @deprecated Please use the new paginated many mutation (deleteManyMapMarkersConnection)
   */
  deleteManyMapMarkers: BatchPayload
  /** Delete many MapMarker documents, return deleted documents */
  deleteManyMapMarkersConnection: MapMarkerConnection
  /**
   * Delete many NewsletterAudience documents
   * @deprecated Please use the new paginated many mutation (deleteManyNewsletterAudiencesConnection)
   */
  deleteManyNewsletterAudiences: BatchPayload
  /** Delete many NewsletterAudience documents, return deleted documents */
  deleteManyNewsletterAudiencesConnection: NewsletterAudienceConnection
  /**
   * Delete many Notification documents
   * @deprecated Please use the new paginated many mutation (deleteManyNotificationsConnection)
   */
  deleteManyNotifications: BatchPayload
  /** Delete many Notification documents, return deleted documents */
  deleteManyNotificationsConnection: NotificationConnection
  /**
   * Delete many OMRPartner documents
   * @deprecated Please use the new paginated many mutation (deleteManyOMRPartnersConnection)
   */
  deleteManyOMRPartners: BatchPayload
  /** Delete many OMRPartner documents, return deleted documents */
  deleteManyOMRPartnersConnection: OmrPartnerConnection
  /**
   * Delete many PartnerCompany documents
   * @deprecated Please use the new paginated many mutation (deleteManyPartnerCompaniesConnection)
   */
  deleteManyPartnerCompanies: BatchPayload
  /** Delete many PartnerCompany documents, return deleted documents */
  deleteManyPartnerCompaniesConnection: PartnerCompanyConnection
  /**
   * Delete many PhysicalLocation documents
   * @deprecated Please use the new paginated many mutation (deleteManyPhysicalLocationsConnection)
   */
  deleteManyPhysicalLocations: BatchPayload
  /** Delete many PhysicalLocation documents, return deleted documents */
  deleteManyPhysicalLocationsConnection: PhysicalLocationConnection
  /**
   * Delete many PodcastEpisode documents
   * @deprecated Please use the new paginated many mutation (deleteManyPodcastEpisodesConnection)
   */
  deleteManyPodcastEpisodes: BatchPayload
  /** Delete many PodcastEpisode documents, return deleted documents */
  deleteManyPodcastEpisodesConnection: PodcastEpisodeConnection
  /**
   * Delete many PodcastGroup documents
   * @deprecated Please use the new paginated many mutation (deleteManyPodcastGroupsConnection)
   */
  deleteManyPodcastGroups: BatchPayload
  /** Delete many PodcastGroup documents, return deleted documents */
  deleteManyPodcastGroupsConnection: PodcastGroupConnection
  /**
   * Delete many PricingTier documents
   * @deprecated Please use the new paginated many mutation (deleteManyPricingTiersConnection)
   */
  deleteManyPricingTiers: BatchPayload
  /** Delete many PricingTier documents, return deleted documents */
  deleteManyPricingTiersConnection: PricingTierConnection
  /**
   * Delete many RecommendationFood documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecommendationsFoodConnection)
   */
  deleteManyRecommendationsFood: BatchPayload
  /** Delete many RecommendationFood documents, return deleted documents */
  deleteManyRecommendationsFoodConnection: RecommendationFoodConnection
  /**
   * Delete many RecommendationNightOut documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecommendationsNightOutConnection)
   */
  deleteManyRecommendationsNightOut: BatchPayload
  /** Delete many RecommendationNightOut documents, return deleted documents */
  deleteManyRecommendationsNightOutConnection: RecommendationNightOutConnection
  /**
   * Delete many ReviewsAgency documents
   * @deprecated Please use the new paginated many mutation (deleteManyReviewsAgenciesConnection)
   */
  deleteManyReviewsAgencies: BatchPayload
  /** Delete many ReviewsAgency documents, return deleted documents */
  deleteManyReviewsAgenciesConnection: ReviewsAgencyConnection
  /**
   * Delete many ReviewsFeatureRow documents
   * @deprecated Please use the new paginated many mutation (deleteManyReviewsFeatureRowsConnection)
   */
  deleteManyReviewsFeatureRows: BatchPayload
  /** Delete many ReviewsFeatureRow documents, return deleted documents */
  deleteManyReviewsFeatureRowsConnection: ReviewsFeatureRowConnection
  /**
   * Delete many ReviewsFeaturesSection documents
   * @deprecated Please use the new paginated many mutation (deleteManyReviewsFeaturesSectionsConnection)
   */
  deleteManyReviewsFeaturesSections: BatchPayload
  /** Delete many ReviewsFeaturesSection documents, return deleted documents */
  deleteManyReviewsFeaturesSectionsConnection: ReviewsFeaturesSectionConnection
  /**
   * Delete many ReviewsProductCategory documents
   * @deprecated Please use the new paginated many mutation (deleteManyReviewsProductCategoriesConnection)
   */
  deleteManyReviewsProductCategories: BatchPayload
  /** Delete many ReviewsProductCategory documents, return deleted documents */
  deleteManyReviewsProductCategoriesConnection: ReviewsProductCategoryConnection
  /**
   * Delete many ReviewsProductWidget documents
   * @deprecated Please use the new paginated many mutation (deleteManyReviewsProductWidgetsConnection)
   */
  deleteManyReviewsProductWidgets: BatchPayload
  /** Delete many ReviewsProductWidget documents, return deleted documents */
  deleteManyReviewsProductWidgetsConnection: ReviewsProductWidgetConnection
  /**
   * Delete many ReviewsProduct documents
   * @deprecated Please use the new paginated many mutation (deleteManyReviewsProductsConnection)
   */
  deleteManyReviewsProducts: BatchPayload
  /** Delete many ReviewsProduct documents, return deleted documents */
  deleteManyReviewsProductsConnection: ReviewsProductConnection
  /**
   * Delete many SiteSection documents
   * @deprecated Please use the new paginated many mutation (deleteManySiteSectionsConnection)
   */
  deleteManySiteSections: BatchPayload
  /** Delete many SiteSection documents, return deleted documents */
  deleteManySiteSectionsConnection: SiteSectionConnection
  /**
   * Delete many SocialEmbed documents
   * @deprecated Please use the new paginated many mutation (deleteManySocialEmbedsConnection)
   */
  deleteManySocialEmbeds: BatchPayload
  /** Delete many SocialEmbed documents, return deleted documents */
  deleteManySocialEmbedsConnection: SocialEmbedConnection
  /**
   * Delete many SpeakerListOrder documents
   * @deprecated Please use the new paginated many mutation (deleteManySpeakerListOrdersConnection)
   */
  deleteManySpeakerListOrders: BatchPayload
  /** Delete many SpeakerListOrder documents, return deleted documents */
  deleteManySpeakerListOrdersConnection: SpeakerListOrderConnection
  /**
   * Delete many Speaker documents
   * @deprecated Please use the new paginated many mutation (deleteManySpeakersConnection)
   */
  deleteManySpeakers: BatchPayload
  /** Delete many Speaker documents, return deleted documents */
  deleteManySpeakersConnection: SpeakerConnection
  /**
   * Delete many TabContent documents
   * @deprecated Please use the new paginated many mutation (deleteManyTabContentsConnection)
   */
  deleteManyTabContents: BatchPayload
  /** Delete many TabContent documents, return deleted documents */
  deleteManyTabContentsConnection: TabContentConnection
  /**
   * Delete many Tag documents
   * @deprecated Please use the new paginated many mutation (deleteManyTagsConnection)
   */
  deleteManyTags: BatchPayload
  /** Delete many Tag documents, return deleted documents */
  deleteManyTagsConnection: TagConnection
  /**
   * Delete many TicketsTableColumn documents
   * @deprecated Please use the new paginated many mutation (deleteManyTicketsTableColumnsConnection)
   */
  deleteManyTicketsTableColumns: BatchPayload
  /** Delete many TicketsTableColumn documents, return deleted documents */
  deleteManyTicketsTableColumnsConnection: TicketsTableColumnConnection
  /**
   * Delete many TopicPageCategory documents
   * @deprecated Please use the new paginated many mutation (deleteManyTopicPageCategoriesConnection)
   */
  deleteManyTopicPageCategories: BatchPayload
  /** Delete many TopicPageCategory documents, return deleted documents */
  deleteManyTopicPageCategoriesConnection: TopicPageCategoryConnection
  /**
   * Delete many TopicPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyTopicPagesConnection)
   */
  deleteManyTopicPages: BatchPayload
  /** Delete many TopicPage documents, return deleted documents */
  deleteManyTopicPagesConnection: TopicPageConnection
  /**
   * Delete many VGWort documents
   * @deprecated Please use the new paginated many mutation (deleteManyVGWortsConnection)
   */
  deleteManyVGWorts: BatchPayload
  /** Delete many VGWort documents, return deleted documents */
  deleteManyVGWortsConnection: VgWortConnection
  /** Delete one mapMarker from _all_ existing stages. Returns deleted document. */
  deleteMapMarker?: Maybe<MapMarker>
  /** Delete one mapMarkerIcon from _all_ existing stages. Returns deleted document. */
  deleteMapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Delete one newsletterAudience from _all_ existing stages. Returns deleted document. */
  deleteNewsletterAudience?: Maybe<NewsletterAudience>
  /** Delete one notification from _all_ existing stages. Returns deleted document. */
  deleteNotification?: Maybe<Notification>
  /** Delete one oMRPartner from _all_ existing stages. Returns deleted document. */
  deleteOMRPartner?: Maybe<OmrPartner>
  /** Delete one partnerCompany from _all_ existing stages. Returns deleted document. */
  deletePartnerCompany?: Maybe<PartnerCompany>
  /** Delete one physicalLocation from _all_ existing stages. Returns deleted document. */
  deletePhysicalLocation?: Maybe<PhysicalLocation>
  /** Delete one podcastEpisode from _all_ existing stages. Returns deleted document. */
  deletePodcastEpisode?: Maybe<PodcastEpisode>
  /** Delete one podcastGroup from _all_ existing stages. Returns deleted document. */
  deletePodcastGroup?: Maybe<PodcastGroup>
  /** Delete one pricingTier from _all_ existing stages. Returns deleted document. */
  deletePricingTier?: Maybe<PricingTier>
  /** Delete one recommendationFood from _all_ existing stages. Returns deleted document. */
  deleteRecommendationFood?: Maybe<RecommendationFood>
  /** Delete one recommendationNightOut from _all_ existing stages. Returns deleted document. */
  deleteRecommendationNightOut?: Maybe<RecommendationNightOut>
  /** Delete one reviewsAgency from _all_ existing stages. Returns deleted document. */
  deleteReviewsAgency?: Maybe<ReviewsAgency>
  /** Delete one reviewsFeatureRow from _all_ existing stages. Returns deleted document. */
  deleteReviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Delete one reviewsFeaturesSection from _all_ existing stages. Returns deleted document. */
  deleteReviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Delete one reviewsProduct from _all_ existing stages. Returns deleted document. */
  deleteReviewsProduct?: Maybe<ReviewsProduct>
  /** Delete one reviewsProductCategory from _all_ existing stages. Returns deleted document. */
  deleteReviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Delete one reviewsProductWidget from _all_ existing stages. Returns deleted document. */
  deleteReviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>
  /** Delete one siteSection from _all_ existing stages. Returns deleted document. */
  deleteSiteSection?: Maybe<SiteSection>
  /** Delete one socialEmbed from _all_ existing stages. Returns deleted document. */
  deleteSocialEmbed?: Maybe<SocialEmbed>
  /** Delete one speaker from _all_ existing stages. Returns deleted document. */
  deleteSpeaker?: Maybe<Speaker>
  /** Delete one speakerListOrder from _all_ existing stages. Returns deleted document. */
  deleteSpeakerListOrder?: Maybe<SpeakerListOrder>
  /** Delete one tabContent from _all_ existing stages. Returns deleted document. */
  deleteTabContent?: Maybe<TabContent>
  /** Delete one tag from _all_ existing stages. Returns deleted document. */
  deleteTag?: Maybe<Tag>
  /** Delete one ticketsTableColumn from _all_ existing stages. Returns deleted document. */
  deleteTicketsTableColumn?: Maybe<TicketsTableColumn>
  /** Delete one topicPage from _all_ existing stages. Returns deleted document. */
  deleteTopicPage?: Maybe<TopicPage>
  /** Delete one topicPageCategory from _all_ existing stages. Returns deleted document. */
  deleteTopicPageCategory?: Maybe<TopicPageCategory>
  /** Delete one vGWort from _all_ existing stages. Returns deleted document. */
  deleteVGWort?: Maybe<VgWort>
  /** Publish one animatedCounter */
  publishAnimatedCounter?: Maybe<AnimatedCounter>
  /** Publish one article */
  publishArticle?: Maybe<Article>
  /** Publish one articleCategory */
  publishArticleCategory?: Maybe<ArticleCategory>
  /** Publish one articlePageView */
  publishArticlePageView?: Maybe<ArticlePageView>
  /** Publish one asset */
  publishAsset?: Maybe<Asset>
  /** Publish one author */
  publishAuthor?: Maybe<Author>
  /** Publish one booth */
  publishBooth?: Maybe<Booth>
  /** Publish one careerPage */
  publishCareerPage?: Maybe<CareerPage>
  /** Publish one contentReference */
  publishContentReference?: Maybe<ContentReference>
  /** Publish one educationReport */
  publishEducationReport?: Maybe<EducationReport>
  /** Publish one educationSeminar */
  publishEducationSeminar?: Maybe<EducationSeminar>
  /** Publish one event */
  publishEvent?: Maybe<Event>
  /** Publish one eventAppPage */
  publishEventAppPage?: Maybe<EventAppPage>
  /** Publish one eventPage */
  publishEventPage?: Maybe<EventPage>
  /** Publish one eventStage */
  publishEventStage?: Maybe<EventStage>
  /** Publish one exhibitorListOrder */
  publishExhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Publish one faqQuestion */
  publishFaqQuestion?: Maybe<FaqQuestion>
  /** Publish one footer */
  publishFooter?: Maybe<Footer>
  /** Publish one glossary */
  publishGlossary?: Maybe<Glossary>
  /** Publish one header */
  publishHeader?: Maybe<Header>
  /** Publish one hotel */
  publishHotel?: Maybe<Hotel>
  /** Publish one htmlEmbed */
  publishHtmlEmbed?: Maybe<HtmlEmbed>
  /** Publish one hubContentEntry */
  publishHubContentEntry?: Maybe<HubContentEntry>
  /** Publish one hubPage */
  publishHubPage?: Maybe<HubPage>
  /** Publish one hubPageCountdownHero */
  publishHubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Publish one imageGalleryEmbed */
  publishImageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Publish one interest */
  publishInterest?: Maybe<Interest>
  /** Publish one jobListing */
  publishJobListing?: Maybe<JobListing>
  /** Publish one journey */
  publishJourney?: Maybe<Journey>
  /** Publish one landingPage */
  publishLandingPage?: Maybe<LandingPage>
  /** Publish one manageContentConfig */
  publishManageContentConfig?: Maybe<ManageContentConfig>
  /**
   * Publish many AnimatedCounter documents
   * @deprecated Please use the new paginated many mutation (publishManyAnimatedCountersConnection)
   */
  publishManyAnimatedCounters: BatchPayload
  /** Publish many AnimatedCounter documents */
  publishManyAnimatedCountersConnection: AnimatedCounterConnection
  /**
   * Publish many ArticleCategory documents
   * @deprecated Please use the new paginated many mutation (publishManyArticleCategoriesConnection)
   */
  publishManyArticleCategories: BatchPayload
  /** Publish many ArticleCategory documents */
  publishManyArticleCategoriesConnection: ArticleCategoryConnection
  /**
   * Publish many ArticlePageView documents
   * @deprecated Please use the new paginated many mutation (publishManyArticlePageViewsConnection)
   */
  publishManyArticlePageViews: BatchPayload
  /** Publish many ArticlePageView documents */
  publishManyArticlePageViewsConnection: ArticlePageViewConnection
  /**
   * Publish many Article documents
   * @deprecated Please use the new paginated many mutation (publishManyArticlesConnection)
   */
  publishManyArticles: BatchPayload
  /** Publish many Article documents */
  publishManyArticlesConnection: ArticleConnection
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection
  /**
   * Publish many Author documents
   * @deprecated Please use the new paginated many mutation (publishManyAuthorsConnection)
   */
  publishManyAuthors: BatchPayload
  /** Publish many Author documents */
  publishManyAuthorsConnection: AuthorConnection
  /**
   * Publish many Booth documents
   * @deprecated Please use the new paginated many mutation (publishManyBoothsConnection)
   */
  publishManyBooths: BatchPayload
  /** Publish many Booth documents */
  publishManyBoothsConnection: BoothConnection
  /**
   * Publish many CareerPage documents
   * @deprecated Please use the new paginated many mutation (publishManyCareerPagesConnection)
   */
  publishManyCareerPages: BatchPayload
  /** Publish many CareerPage documents */
  publishManyCareerPagesConnection: CareerPageConnection
  /**
   * Publish many ContentReference documents
   * @deprecated Please use the new paginated many mutation (publishManyContentReferencesConnection)
   */
  publishManyContentReferences: BatchPayload
  /** Publish many ContentReference documents */
  publishManyContentReferencesConnection: ContentReferenceConnection
  /**
   * Publish many EducationReport documents
   * @deprecated Please use the new paginated many mutation (publishManyEducationReportsConnection)
   */
  publishManyEducationReports: BatchPayload
  /** Publish many EducationReport documents */
  publishManyEducationReportsConnection: EducationReportConnection
  /**
   * Publish many EducationSeminar documents
   * @deprecated Please use the new paginated many mutation (publishManyEducationSeminarsConnection)
   */
  publishManyEducationSeminars: BatchPayload
  /** Publish many EducationSeminar documents */
  publishManyEducationSeminarsConnection: EducationSeminarConnection
  /**
   * Publish many EventAppPage documents
   * @deprecated Please use the new paginated many mutation (publishManyEventAppPagesConnection)
   */
  publishManyEventAppPages: BatchPayload
  /** Publish many EventAppPage documents */
  publishManyEventAppPagesConnection: EventAppPageConnection
  /**
   * Publish many EventPage documents
   * @deprecated Please use the new paginated many mutation (publishManyEventPagesConnection)
   */
  publishManyEventPages: BatchPayload
  /** Publish many EventPage documents */
  publishManyEventPagesConnection: EventPageConnection
  /**
   * Publish many EventStage documents
   * @deprecated Please use the new paginated many mutation (publishManyEventStagesConnection)
   */
  publishManyEventStages: BatchPayload
  /** Publish many EventStage documents */
  publishManyEventStagesConnection: EventStageConnection
  /**
   * Publish many Event documents
   * @deprecated Please use the new paginated many mutation (publishManyEventsConnection)
   */
  publishManyEvents: BatchPayload
  /** Publish many Event documents */
  publishManyEventsConnection: EventConnection
  /**
   * Publish many ExhibitorListOrder documents
   * @deprecated Please use the new paginated many mutation (publishManyExhibitorListOrdersConnection)
   */
  publishManyExhibitorListOrders: BatchPayload
  /** Publish many ExhibitorListOrder documents */
  publishManyExhibitorListOrdersConnection: ExhibitorListOrderConnection
  /**
   * Publish many FaqQuestion documents
   * @deprecated Please use the new paginated many mutation (publishManyFaqQuestionsConnection)
   */
  publishManyFaqQuestions: BatchPayload
  /** Publish many FaqQuestion documents */
  publishManyFaqQuestionsConnection: FaqQuestionConnection
  /**
   * Publish many Footer documents
   * @deprecated Please use the new paginated many mutation (publishManyFootersConnection)
   */
  publishManyFooters: BatchPayload
  /** Publish many Footer documents */
  publishManyFootersConnection: FooterConnection
  /**
   * Publish many Glossary documents
   * @deprecated Please use the new paginated many mutation (publishManyGlossariesConnection)
   */
  publishManyGlossaries: BatchPayload
  /** Publish many Glossary documents */
  publishManyGlossariesConnection: GlossaryConnection
  /**
   * Publish many Header documents
   * @deprecated Please use the new paginated many mutation (publishManyHeadersConnection)
   */
  publishManyHeaders: BatchPayload
  /** Publish many Header documents */
  publishManyHeadersConnection: HeaderConnection
  /**
   * Publish many Hotel documents
   * @deprecated Please use the new paginated many mutation (publishManyHotelsConnection)
   */
  publishManyHotels: BatchPayload
  /** Publish many Hotel documents */
  publishManyHotelsConnection: HotelConnection
  /**
   * Publish many HtmlEmbed documents
   * @deprecated Please use the new paginated many mutation (publishManyHtmlEmbedsConnection)
   */
  publishManyHtmlEmbeds: BatchPayload
  /** Publish many HtmlEmbed documents */
  publishManyHtmlEmbedsConnection: HtmlEmbedConnection
  /**
   * Publish many HubContentEntry documents
   * @deprecated Please use the new paginated many mutation (publishManyHubContentEntriesConnection)
   */
  publishManyHubContentEntries: BatchPayload
  /** Publish many HubContentEntry documents */
  publishManyHubContentEntriesConnection: HubContentEntryConnection
  /**
   * Publish many HubPageCountdownHero documents
   * @deprecated Please use the new paginated many mutation (publishManyHubPageCountdownHeroesConnection)
   */
  publishManyHubPageCountdownHeroes: BatchPayload
  /** Publish many HubPageCountdownHero documents */
  publishManyHubPageCountdownHeroesConnection: HubPageCountdownHeroConnection
  /**
   * Publish many HubPage documents
   * @deprecated Please use the new paginated many mutation (publishManyHubPagesConnection)
   */
  publishManyHubPages: BatchPayload
  /** Publish many HubPage documents */
  publishManyHubPagesConnection: HubPageConnection
  /**
   * Publish many ImageGalleryEmbed documents
   * @deprecated Please use the new paginated many mutation (publishManyImageGalleryEmbedsConnection)
   */
  publishManyImageGalleryEmbeds: BatchPayload
  /** Publish many ImageGalleryEmbed documents */
  publishManyImageGalleryEmbedsConnection: ImageGalleryEmbedConnection
  /**
   * Publish many Interest documents
   * @deprecated Please use the new paginated many mutation (publishManyInterestsConnection)
   */
  publishManyInterests: BatchPayload
  /** Publish many Interest documents */
  publishManyInterestsConnection: InterestConnection
  /**
   * Publish many JobListing documents
   * @deprecated Please use the new paginated many mutation (publishManyJobListingsConnection)
   */
  publishManyJobListings: BatchPayload
  /** Publish many JobListing documents */
  publishManyJobListingsConnection: JobListingConnection
  /**
   * Publish many Journey documents
   * @deprecated Please use the new paginated many mutation (publishManyJourneysConnection)
   */
  publishManyJourneys: BatchPayload
  /** Publish many Journey documents */
  publishManyJourneysConnection: JourneyConnection
  /**
   * Publish many LandingPage documents
   * @deprecated Please use the new paginated many mutation (publishManyLandingPagesConnection)
   */
  publishManyLandingPages: BatchPayload
  /** Publish many LandingPage documents */
  publishManyLandingPagesConnection: LandingPageConnection
  /**
   * Publish many ManageContentConfig documents
   * @deprecated Please use the new paginated many mutation (publishManyManageContentConfigsConnection)
   */
  publishManyManageContentConfigs: BatchPayload
  /** Publish many ManageContentConfig documents */
  publishManyManageContentConfigsConnection: ManageContentConfigConnection
  /**
   * Publish many MapMarkerIcon documents
   * @deprecated Please use the new paginated many mutation (publishManyMapMarkerIconsConnection)
   */
  publishManyMapMarkerIcons: BatchPayload
  /** Publish many MapMarkerIcon documents */
  publishManyMapMarkerIconsConnection: MapMarkerIconConnection
  /**
   * Publish many MapMarker documents
   * @deprecated Please use the new paginated many mutation (publishManyMapMarkersConnection)
   */
  publishManyMapMarkers: BatchPayload
  /** Publish many MapMarker documents */
  publishManyMapMarkersConnection: MapMarkerConnection
  /**
   * Publish many NewsletterAudience documents
   * @deprecated Please use the new paginated many mutation (publishManyNewsletterAudiencesConnection)
   */
  publishManyNewsletterAudiences: BatchPayload
  /** Publish many NewsletterAudience documents */
  publishManyNewsletterAudiencesConnection: NewsletterAudienceConnection
  /**
   * Publish many Notification documents
   * @deprecated Please use the new paginated many mutation (publishManyNotificationsConnection)
   */
  publishManyNotifications: BatchPayload
  /** Publish many Notification documents */
  publishManyNotificationsConnection: NotificationConnection
  /**
   * Publish many OMRPartner documents
   * @deprecated Please use the new paginated many mutation (publishManyOMRPartnersConnection)
   */
  publishManyOMRPartners: BatchPayload
  /** Publish many OMRPartner documents */
  publishManyOMRPartnersConnection: OmrPartnerConnection
  /**
   * Publish many PartnerCompany documents
   * @deprecated Please use the new paginated many mutation (publishManyPartnerCompaniesConnection)
   */
  publishManyPartnerCompanies: BatchPayload
  /** Publish many PartnerCompany documents */
  publishManyPartnerCompaniesConnection: PartnerCompanyConnection
  /**
   * Publish many PhysicalLocation documents
   * @deprecated Please use the new paginated many mutation (publishManyPhysicalLocationsConnection)
   */
  publishManyPhysicalLocations: BatchPayload
  /** Publish many PhysicalLocation documents */
  publishManyPhysicalLocationsConnection: PhysicalLocationConnection
  /**
   * Publish many PodcastEpisode documents
   * @deprecated Please use the new paginated many mutation (publishManyPodcastEpisodesConnection)
   */
  publishManyPodcastEpisodes: BatchPayload
  /** Publish many PodcastEpisode documents */
  publishManyPodcastEpisodesConnection: PodcastEpisodeConnection
  /**
   * Publish many PodcastGroup documents
   * @deprecated Please use the new paginated many mutation (publishManyPodcastGroupsConnection)
   */
  publishManyPodcastGroups: BatchPayload
  /** Publish many PodcastGroup documents */
  publishManyPodcastGroupsConnection: PodcastGroupConnection
  /**
   * Publish many PricingTier documents
   * @deprecated Please use the new paginated many mutation (publishManyPricingTiersConnection)
   */
  publishManyPricingTiers: BatchPayload
  /** Publish many PricingTier documents */
  publishManyPricingTiersConnection: PricingTierConnection
  /**
   * Publish many RecommendationFood documents
   * @deprecated Please use the new paginated many mutation (publishManyRecommendationsFoodConnection)
   */
  publishManyRecommendationsFood: BatchPayload
  /** Publish many RecommendationFood documents */
  publishManyRecommendationsFoodConnection: RecommendationFoodConnection
  /**
   * Publish many RecommendationNightOut documents
   * @deprecated Please use the new paginated many mutation (publishManyRecommendationsNightOutConnection)
   */
  publishManyRecommendationsNightOut: BatchPayload
  /** Publish many RecommendationNightOut documents */
  publishManyRecommendationsNightOutConnection: RecommendationNightOutConnection
  /**
   * Publish many ReviewsAgency documents
   * @deprecated Please use the new paginated many mutation (publishManyReviewsAgenciesConnection)
   */
  publishManyReviewsAgencies: BatchPayload
  /** Publish many ReviewsAgency documents */
  publishManyReviewsAgenciesConnection: ReviewsAgencyConnection
  /**
   * Publish many ReviewsFeatureRow documents
   * @deprecated Please use the new paginated many mutation (publishManyReviewsFeatureRowsConnection)
   */
  publishManyReviewsFeatureRows: BatchPayload
  /** Publish many ReviewsFeatureRow documents */
  publishManyReviewsFeatureRowsConnection: ReviewsFeatureRowConnection
  /**
   * Publish many ReviewsFeaturesSection documents
   * @deprecated Please use the new paginated many mutation (publishManyReviewsFeaturesSectionsConnection)
   */
  publishManyReviewsFeaturesSections: BatchPayload
  /** Publish many ReviewsFeaturesSection documents */
  publishManyReviewsFeaturesSectionsConnection: ReviewsFeaturesSectionConnection
  /**
   * Publish many ReviewsProductCategory documents
   * @deprecated Please use the new paginated many mutation (publishManyReviewsProductCategoriesConnection)
   */
  publishManyReviewsProductCategories: BatchPayload
  /** Publish many ReviewsProductCategory documents */
  publishManyReviewsProductCategoriesConnection: ReviewsProductCategoryConnection
  /**
   * Publish many ReviewsProductWidget documents
   * @deprecated Please use the new paginated many mutation (publishManyReviewsProductWidgetsConnection)
   */
  publishManyReviewsProductWidgets: BatchPayload
  /** Publish many ReviewsProductWidget documents */
  publishManyReviewsProductWidgetsConnection: ReviewsProductWidgetConnection
  /**
   * Publish many ReviewsProduct documents
   * @deprecated Please use the new paginated many mutation (publishManyReviewsProductsConnection)
   */
  publishManyReviewsProducts: BatchPayload
  /** Publish many ReviewsProduct documents */
  publishManyReviewsProductsConnection: ReviewsProductConnection
  /**
   * Publish many SiteSection documents
   * @deprecated Please use the new paginated many mutation (publishManySiteSectionsConnection)
   */
  publishManySiteSections: BatchPayload
  /** Publish many SiteSection documents */
  publishManySiteSectionsConnection: SiteSectionConnection
  /**
   * Publish many SocialEmbed documents
   * @deprecated Please use the new paginated many mutation (publishManySocialEmbedsConnection)
   */
  publishManySocialEmbeds: BatchPayload
  /** Publish many SocialEmbed documents */
  publishManySocialEmbedsConnection: SocialEmbedConnection
  /**
   * Publish many SpeakerListOrder documents
   * @deprecated Please use the new paginated many mutation (publishManySpeakerListOrdersConnection)
   */
  publishManySpeakerListOrders: BatchPayload
  /** Publish many SpeakerListOrder documents */
  publishManySpeakerListOrdersConnection: SpeakerListOrderConnection
  /**
   * Publish many Speaker documents
   * @deprecated Please use the new paginated many mutation (publishManySpeakersConnection)
   */
  publishManySpeakers: BatchPayload
  /** Publish many Speaker documents */
  publishManySpeakersConnection: SpeakerConnection
  /**
   * Publish many TabContent documents
   * @deprecated Please use the new paginated many mutation (publishManyTabContentsConnection)
   */
  publishManyTabContents: BatchPayload
  /** Publish many TabContent documents */
  publishManyTabContentsConnection: TabContentConnection
  /**
   * Publish many Tag documents
   * @deprecated Please use the new paginated many mutation (publishManyTagsConnection)
   */
  publishManyTags: BatchPayload
  /** Publish many Tag documents */
  publishManyTagsConnection: TagConnection
  /**
   * Publish many TicketsTableColumn documents
   * @deprecated Please use the new paginated many mutation (publishManyTicketsTableColumnsConnection)
   */
  publishManyTicketsTableColumns: BatchPayload
  /** Publish many TicketsTableColumn documents */
  publishManyTicketsTableColumnsConnection: TicketsTableColumnConnection
  /**
   * Publish many TopicPageCategory documents
   * @deprecated Please use the new paginated many mutation (publishManyTopicPageCategoriesConnection)
   */
  publishManyTopicPageCategories: BatchPayload
  /** Publish many TopicPageCategory documents */
  publishManyTopicPageCategoriesConnection: TopicPageCategoryConnection
  /**
   * Publish many TopicPage documents
   * @deprecated Please use the new paginated many mutation (publishManyTopicPagesConnection)
   */
  publishManyTopicPages: BatchPayload
  /** Publish many TopicPage documents */
  publishManyTopicPagesConnection: TopicPageConnection
  /**
   * Publish many VGWort documents
   * @deprecated Please use the new paginated many mutation (publishManyVGWortsConnection)
   */
  publishManyVGWorts: BatchPayload
  /** Publish many VGWort documents */
  publishManyVGWortsConnection: VgWortConnection
  /** Publish one mapMarker */
  publishMapMarker?: Maybe<MapMarker>
  /** Publish one mapMarkerIcon */
  publishMapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Publish one newsletterAudience */
  publishNewsletterAudience?: Maybe<NewsletterAudience>
  /** Publish one notification */
  publishNotification?: Maybe<Notification>
  /** Publish one oMRPartner */
  publishOMRPartner?: Maybe<OmrPartner>
  /** Publish one partnerCompany */
  publishPartnerCompany?: Maybe<PartnerCompany>
  /** Publish one physicalLocation */
  publishPhysicalLocation?: Maybe<PhysicalLocation>
  /** Publish one podcastEpisode */
  publishPodcastEpisode?: Maybe<PodcastEpisode>
  /** Publish one podcastGroup */
  publishPodcastGroup?: Maybe<PodcastGroup>
  /** Publish one pricingTier */
  publishPricingTier?: Maybe<PricingTier>
  /** Publish one recommendationFood */
  publishRecommendationFood?: Maybe<RecommendationFood>
  /** Publish one recommendationNightOut */
  publishRecommendationNightOut?: Maybe<RecommendationNightOut>
  /** Publish one reviewsAgency */
  publishReviewsAgency?: Maybe<ReviewsAgency>
  /** Publish one reviewsFeatureRow */
  publishReviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Publish one reviewsFeaturesSection */
  publishReviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Publish one reviewsProduct */
  publishReviewsProduct?: Maybe<ReviewsProduct>
  /** Publish one reviewsProductCategory */
  publishReviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Publish one reviewsProductWidget */
  publishReviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Publish one siteSection */
  publishSiteSection?: Maybe<SiteSection>
  /** Publish one socialEmbed */
  publishSocialEmbed?: Maybe<SocialEmbed>
  /** Publish one speaker */
  publishSpeaker?: Maybe<Speaker>
  /** Publish one speakerListOrder */
  publishSpeakerListOrder?: Maybe<SpeakerListOrder>
  /** Publish one tabContent */
  publishTabContent?: Maybe<TabContent>
  /** Publish one tag */
  publishTag?: Maybe<Tag>
  /** Publish one ticketsTableColumn */
  publishTicketsTableColumn?: Maybe<TicketsTableColumn>
  /** Publish one topicPage */
  publishTopicPage?: Maybe<TopicPage>
  /** Publish one topicPageCategory */
  publishTopicPageCategory?: Maybe<TopicPageCategory>
  /** Publish one vGWort */
  publishVGWort?: Maybe<VgWort>
  /** Schedule to publish one animatedCounter */
  schedulePublishAnimatedCounter?: Maybe<AnimatedCounter>
  /** Schedule to publish one article */
  schedulePublishArticle?: Maybe<Article>
  /** Schedule to publish one articleCategory */
  schedulePublishArticleCategory?: Maybe<ArticleCategory>
  /** Schedule to publish one articlePageView */
  schedulePublishArticlePageView?: Maybe<ArticlePageView>
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>
  /** Schedule to publish one author */
  schedulePublishAuthor?: Maybe<Author>
  /** Schedule to publish one booth */
  schedulePublishBooth?: Maybe<Booth>
  /** Schedule to publish one careerPage */
  schedulePublishCareerPage?: Maybe<CareerPage>
  /** Schedule to publish one contentReference */
  schedulePublishContentReference?: Maybe<ContentReference>
  /** Schedule to publish one educationReport */
  schedulePublishEducationReport?: Maybe<EducationReport>
  /** Schedule to publish one educationSeminar */
  schedulePublishEducationSeminar?: Maybe<EducationSeminar>
  /** Schedule to publish one event */
  schedulePublishEvent?: Maybe<Event>
  /** Schedule to publish one eventAppPage */
  schedulePublishEventAppPage?: Maybe<EventAppPage>
  /** Schedule to publish one eventPage */
  schedulePublishEventPage?: Maybe<EventPage>
  /** Schedule to publish one eventStage */
  schedulePublishEventStage?: Maybe<EventStage>
  /** Schedule to publish one exhibitorListOrder */
  schedulePublishExhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Schedule to publish one faqQuestion */
  schedulePublishFaqQuestion?: Maybe<FaqQuestion>
  /** Schedule to publish one footer */
  schedulePublishFooter?: Maybe<Footer>
  /** Schedule to publish one glossary */
  schedulePublishGlossary?: Maybe<Glossary>
  /** Schedule to publish one header */
  schedulePublishHeader?: Maybe<Header>
  /** Schedule to publish one hotel */
  schedulePublishHotel?: Maybe<Hotel>
  /** Schedule to publish one htmlEmbed */
  schedulePublishHtmlEmbed?: Maybe<HtmlEmbed>
  /** Schedule to publish one hubContentEntry */
  schedulePublishHubContentEntry?: Maybe<HubContentEntry>
  /** Schedule to publish one hubPage */
  schedulePublishHubPage?: Maybe<HubPage>
  /** Schedule to publish one hubPageCountdownHero */
  schedulePublishHubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Schedule to publish one imageGalleryEmbed */
  schedulePublishImageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Schedule to publish one interest */
  schedulePublishInterest?: Maybe<Interest>
  /** Schedule to publish one jobListing */
  schedulePublishJobListing?: Maybe<JobListing>
  /** Schedule to publish one journey */
  schedulePublishJourney?: Maybe<Journey>
  /** Schedule to publish one landingPage */
  schedulePublishLandingPage?: Maybe<LandingPage>
  /** Schedule to publish one manageContentConfig */
  schedulePublishManageContentConfig?: Maybe<ManageContentConfig>
  /** Schedule to publish one mapMarker */
  schedulePublishMapMarker?: Maybe<MapMarker>
  /** Schedule to publish one mapMarkerIcon */
  schedulePublishMapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Schedule to publish one newsletterAudience */
  schedulePublishNewsletterAudience?: Maybe<NewsletterAudience>
  /** Schedule to publish one notification */
  schedulePublishNotification?: Maybe<Notification>
  /** Schedule to publish one oMRPartner */
  schedulePublishOMRPartner?: Maybe<OmrPartner>
  /** Schedule to publish one partnerCompany */
  schedulePublishPartnerCompany?: Maybe<PartnerCompany>
  /** Schedule to publish one physicalLocation */
  schedulePublishPhysicalLocation?: Maybe<PhysicalLocation>
  /** Schedule to publish one podcastEpisode */
  schedulePublishPodcastEpisode?: Maybe<PodcastEpisode>
  /** Schedule to publish one podcastGroup */
  schedulePublishPodcastGroup?: Maybe<PodcastGroup>
  /** Schedule to publish one pricingTier */
  schedulePublishPricingTier?: Maybe<PricingTier>
  /** Schedule to publish one recommendationFood */
  schedulePublishRecommendationFood?: Maybe<RecommendationFood>
  /** Schedule to publish one recommendationNightOut */
  schedulePublishRecommendationNightOut?: Maybe<RecommendationNightOut>
  /** Schedule to publish one reviewsAgency */
  schedulePublishReviewsAgency?: Maybe<ReviewsAgency>
  /** Schedule to publish one reviewsFeatureRow */
  schedulePublishReviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Schedule to publish one reviewsFeaturesSection */
  schedulePublishReviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Schedule to publish one reviewsProduct */
  schedulePublishReviewsProduct?: Maybe<ReviewsProduct>
  /** Schedule to publish one reviewsProductCategory */
  schedulePublishReviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Schedule to publish one reviewsProductWidget */
  schedulePublishReviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Schedule to publish one siteSection */
  schedulePublishSiteSection?: Maybe<SiteSection>
  /** Schedule to publish one socialEmbed */
  schedulePublishSocialEmbed?: Maybe<SocialEmbed>
  /** Schedule to publish one speaker */
  schedulePublishSpeaker?: Maybe<Speaker>
  /** Schedule to publish one speakerListOrder */
  schedulePublishSpeakerListOrder?: Maybe<SpeakerListOrder>
  /** Schedule to publish one tabContent */
  schedulePublishTabContent?: Maybe<TabContent>
  /** Schedule to publish one tag */
  schedulePublishTag?: Maybe<Tag>
  /** Schedule to publish one ticketsTableColumn */
  schedulePublishTicketsTableColumn?: Maybe<TicketsTableColumn>
  /** Schedule to publish one topicPage */
  schedulePublishTopicPage?: Maybe<TopicPage>
  /** Schedule to publish one topicPageCategory */
  schedulePublishTopicPageCategory?: Maybe<TopicPageCategory>
  /** Schedule to publish one vGWort */
  schedulePublishVGWort?: Maybe<VgWort>
  /** Unpublish one animatedCounter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAnimatedCounter?: Maybe<AnimatedCounter>
  /** Unpublish one article from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishArticle?: Maybe<Article>
  /** Unpublish one articleCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishArticleCategory?: Maybe<ArticleCategory>
  /** Unpublish one articlePageView from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishArticlePageView?: Maybe<ArticlePageView>
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>
  /** Unpublish one author from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAuthor?: Maybe<Author>
  /** Unpublish one booth from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBooth?: Maybe<Booth>
  /** Unpublish one careerPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCareerPage?: Maybe<CareerPage>
  /** Unpublish one contentReference from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishContentReference?: Maybe<ContentReference>
  /** Unpublish one educationReport from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishEducationReport?: Maybe<EducationReport>
  /** Unpublish one educationSeminar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishEducationSeminar?: Maybe<EducationSeminar>
  /** Unpublish one event from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishEvent?: Maybe<Event>
  /** Unpublish one eventAppPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishEventAppPage?: Maybe<EventAppPage>
  /** Unpublish one eventPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishEventPage?: Maybe<EventPage>
  /** Unpublish one eventStage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishEventStage?: Maybe<EventStage>
  /** Unpublish one exhibitorListOrder from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishExhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Unpublish one faqQuestion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFaqQuestion?: Maybe<FaqQuestion>
  /** Unpublish one footer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFooter?: Maybe<Footer>
  /** Unpublish one glossary from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGlossary?: Maybe<Glossary>
  /** Unpublish one header from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeader?: Maybe<Header>
  /** Unpublish one hotel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHotel?: Maybe<Hotel>
  /** Unpublish one htmlEmbed from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHtmlEmbed?: Maybe<HtmlEmbed>
  /** Unpublish one hubContentEntry from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHubContentEntry?: Maybe<HubContentEntry>
  /** Unpublish one hubPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHubPage?: Maybe<HubPage>
  /** Unpublish one hubPageCountdownHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Unpublish one imageGalleryEmbed from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishImageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Unpublish one interest from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishInterest?: Maybe<Interest>
  /** Unpublish one jobListing from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishJobListing?: Maybe<JobListing>
  /** Unpublish one journey from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishJourney?: Maybe<Journey>
  /** Unpublish one landingPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLandingPage?: Maybe<LandingPage>
  /** Unpublish one manageContentConfig from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishManageContentConfig?: Maybe<ManageContentConfig>
  /** Unpublish one mapMarker from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMapMarker?: Maybe<MapMarker>
  /** Unpublish one mapMarkerIcon from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Unpublish one newsletterAudience from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNewsletterAudience?: Maybe<NewsletterAudience>
  /** Unpublish one notification from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNotification?: Maybe<Notification>
  /** Unpublish one oMRPartner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishOMRPartner?: Maybe<OmrPartner>
  /** Unpublish one partnerCompany from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPartnerCompany?: Maybe<PartnerCompany>
  /** Unpublish one physicalLocation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPhysicalLocation?: Maybe<PhysicalLocation>
  /** Unpublish one podcastEpisode from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPodcastEpisode?: Maybe<PodcastEpisode>
  /** Unpublish one podcastGroup from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPodcastGroup?: Maybe<PodcastGroup>
  /** Unpublish one pricingTier from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPricingTier?: Maybe<PricingTier>
  /** Unpublish one recommendationFood from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecommendationFood?: Maybe<RecommendationFood>
  /** Unpublish one recommendationNightOut from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecommendationNightOut?: Maybe<RecommendationNightOut>
  /** Unpublish one reviewsAgency from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishReviewsAgency?: Maybe<ReviewsAgency>
  /** Unpublish one reviewsFeatureRow from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishReviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Unpublish one reviewsFeaturesSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishReviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Unpublish one reviewsProduct from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishReviewsProduct?: Maybe<ReviewsProduct>
  /** Unpublish one reviewsProductCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishReviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Unpublish one reviewsProductWidget from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishReviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Unpublish one siteSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSiteSection?: Maybe<SiteSection>
  /** Unpublish one socialEmbed from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSocialEmbed?: Maybe<SocialEmbed>
  /** Unpublish one speaker from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSpeaker?: Maybe<Speaker>
  /** Unpublish one speakerListOrder from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSpeakerListOrder?: Maybe<SpeakerListOrder>
  /** Unpublish one tabContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTabContent?: Maybe<TabContent>
  /** Unpublish one tag from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTag?: Maybe<Tag>
  /** Unpublish one ticketsTableColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTicketsTableColumn?: Maybe<TicketsTableColumn>
  /** Unpublish one topicPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTopicPage?: Maybe<TopicPage>
  /** Unpublish one topicPageCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTopicPageCategory?: Maybe<TopicPageCategory>
  /** Unpublish one vGWort from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishVGWort?: Maybe<VgWort>
  /** Transition one article in workflow. */
  transitionStepArticle?: Maybe<Article>
  /** Unpublish one animatedCounter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAnimatedCounter?: Maybe<AnimatedCounter>
  /** Unpublish one article from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishArticle?: Maybe<Article>
  /** Unpublish one articleCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishArticleCategory?: Maybe<ArticleCategory>
  /** Unpublish one articlePageView from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishArticlePageView?: Maybe<ArticlePageView>
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>
  /** Unpublish one author from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAuthor?: Maybe<Author>
  /** Unpublish one booth from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBooth?: Maybe<Booth>
  /** Unpublish one careerPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCareerPage?: Maybe<CareerPage>
  /** Unpublish one contentReference from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishContentReference?: Maybe<ContentReference>
  /** Unpublish one educationReport from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishEducationReport?: Maybe<EducationReport>
  /** Unpublish one educationSeminar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishEducationSeminar?: Maybe<EducationSeminar>
  /** Unpublish one event from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishEvent?: Maybe<Event>
  /** Unpublish one eventAppPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishEventAppPage?: Maybe<EventAppPage>
  /** Unpublish one eventPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishEventPage?: Maybe<EventPage>
  /** Unpublish one eventStage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishEventStage?: Maybe<EventStage>
  /** Unpublish one exhibitorListOrder from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishExhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Unpublish one faqQuestion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFaqQuestion?: Maybe<FaqQuestion>
  /** Unpublish one footer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFooter?: Maybe<Footer>
  /** Unpublish one glossary from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGlossary?: Maybe<Glossary>
  /** Unpublish one header from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeader?: Maybe<Header>
  /** Unpublish one hotel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHotel?: Maybe<Hotel>
  /** Unpublish one htmlEmbed from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHtmlEmbed?: Maybe<HtmlEmbed>
  /** Unpublish one hubContentEntry from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHubContentEntry?: Maybe<HubContentEntry>
  /** Unpublish one hubPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHubPage?: Maybe<HubPage>
  /** Unpublish one hubPageCountdownHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Unpublish one imageGalleryEmbed from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishImageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Unpublish one interest from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishInterest?: Maybe<Interest>
  /** Unpublish one jobListing from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishJobListing?: Maybe<JobListing>
  /** Unpublish one journey from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishJourney?: Maybe<Journey>
  /** Unpublish one landingPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLandingPage?: Maybe<LandingPage>
  /** Unpublish one manageContentConfig from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishManageContentConfig?: Maybe<ManageContentConfig>
  /**
   * Unpublish many AnimatedCounter documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAnimatedCountersConnection)
   */
  unpublishManyAnimatedCounters: BatchPayload
  /** Find many AnimatedCounter documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAnimatedCountersConnection: AnimatedCounterConnection
  /**
   * Unpublish many ArticleCategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyArticleCategoriesConnection)
   */
  unpublishManyArticleCategories: BatchPayload
  /** Find many ArticleCategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyArticleCategoriesConnection: ArticleCategoryConnection
  /**
   * Unpublish many ArticlePageView documents
   * @deprecated Please use the new paginated many mutation (unpublishManyArticlePageViewsConnection)
   */
  unpublishManyArticlePageViews: BatchPayload
  /** Find many ArticlePageView documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyArticlePageViewsConnection: ArticlePageViewConnection
  /**
   * Unpublish many Article documents
   * @deprecated Please use the new paginated many mutation (unpublishManyArticlesConnection)
   */
  unpublishManyArticles: BatchPayload
  /** Find many Article documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyArticlesConnection: ArticleConnection
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection
  /**
   * Unpublish many Author documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAuthorsConnection)
   */
  unpublishManyAuthors: BatchPayload
  /** Find many Author documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAuthorsConnection: AuthorConnection
  /**
   * Unpublish many Booth documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBoothsConnection)
   */
  unpublishManyBooths: BatchPayload
  /** Find many Booth documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBoothsConnection: BoothConnection
  /**
   * Unpublish many CareerPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCareerPagesConnection)
   */
  unpublishManyCareerPages: BatchPayload
  /** Find many CareerPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCareerPagesConnection: CareerPageConnection
  /**
   * Unpublish many ContentReference documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContentReferencesConnection)
   */
  unpublishManyContentReferences: BatchPayload
  /** Find many ContentReference documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContentReferencesConnection: ContentReferenceConnection
  /**
   * Unpublish many EducationReport documents
   * @deprecated Please use the new paginated many mutation (unpublishManyEducationReportsConnection)
   */
  unpublishManyEducationReports: BatchPayload
  /** Find many EducationReport documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyEducationReportsConnection: EducationReportConnection
  /**
   * Unpublish many EducationSeminar documents
   * @deprecated Please use the new paginated many mutation (unpublishManyEducationSeminarsConnection)
   */
  unpublishManyEducationSeminars: BatchPayload
  /** Find many EducationSeminar documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyEducationSeminarsConnection: EducationSeminarConnection
  /**
   * Unpublish many EventAppPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyEventAppPagesConnection)
   */
  unpublishManyEventAppPages: BatchPayload
  /** Find many EventAppPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyEventAppPagesConnection: EventAppPageConnection
  /**
   * Unpublish many EventPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyEventPagesConnection)
   */
  unpublishManyEventPages: BatchPayload
  /** Find many EventPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyEventPagesConnection: EventPageConnection
  /**
   * Unpublish many EventStage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyEventStagesConnection)
   */
  unpublishManyEventStages: BatchPayload
  /** Find many EventStage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyEventStagesConnection: EventStageConnection
  /**
   * Unpublish many Event documents
   * @deprecated Please use the new paginated many mutation (unpublishManyEventsConnection)
   */
  unpublishManyEvents: BatchPayload
  /** Find many Event documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyEventsConnection: EventConnection
  /**
   * Unpublish many ExhibitorListOrder documents
   * @deprecated Please use the new paginated many mutation (unpublishManyExhibitorListOrdersConnection)
   */
  unpublishManyExhibitorListOrders: BatchPayload
  /** Find many ExhibitorListOrder documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyExhibitorListOrdersConnection: ExhibitorListOrderConnection
  /**
   * Unpublish many FaqQuestion documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFaqQuestionsConnection)
   */
  unpublishManyFaqQuestions: BatchPayload
  /** Find many FaqQuestion documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFaqQuestionsConnection: FaqQuestionConnection
  /**
   * Unpublish many Footer documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFootersConnection)
   */
  unpublishManyFooters: BatchPayload
  /** Find many Footer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFootersConnection: FooterConnection
  /**
   * Unpublish many Glossary documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGlossariesConnection)
   */
  unpublishManyGlossaries: BatchPayload
  /** Find many Glossary documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGlossariesConnection: GlossaryConnection
  /**
   * Unpublish many Header documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeadersConnection)
   */
  unpublishManyHeaders: BatchPayload
  /** Find many Header documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeadersConnection: HeaderConnection
  /**
   * Unpublish many Hotel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHotelsConnection)
   */
  unpublishManyHotels: BatchPayload
  /** Find many Hotel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHotelsConnection: HotelConnection
  /**
   * Unpublish many HtmlEmbed documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHtmlEmbedsConnection)
   */
  unpublishManyHtmlEmbeds: BatchPayload
  /** Find many HtmlEmbed documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHtmlEmbedsConnection: HtmlEmbedConnection
  /**
   * Unpublish many HubContentEntry documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHubContentEntriesConnection)
   */
  unpublishManyHubContentEntries: BatchPayload
  /** Find many HubContentEntry documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHubContentEntriesConnection: HubContentEntryConnection
  /**
   * Unpublish many HubPageCountdownHero documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHubPageCountdownHeroesConnection)
   */
  unpublishManyHubPageCountdownHeroes: BatchPayload
  /** Find many HubPageCountdownHero documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHubPageCountdownHeroesConnection: HubPageCountdownHeroConnection
  /**
   * Unpublish many HubPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHubPagesConnection)
   */
  unpublishManyHubPages: BatchPayload
  /** Find many HubPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHubPagesConnection: HubPageConnection
  /**
   * Unpublish many ImageGalleryEmbed documents
   * @deprecated Please use the new paginated many mutation (unpublishManyImageGalleryEmbedsConnection)
   */
  unpublishManyImageGalleryEmbeds: BatchPayload
  /** Find many ImageGalleryEmbed documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyImageGalleryEmbedsConnection: ImageGalleryEmbedConnection
  /**
   * Unpublish many Interest documents
   * @deprecated Please use the new paginated many mutation (unpublishManyInterestsConnection)
   */
  unpublishManyInterests: BatchPayload
  /** Find many Interest documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyInterestsConnection: InterestConnection
  /**
   * Unpublish many JobListing documents
   * @deprecated Please use the new paginated many mutation (unpublishManyJobListingsConnection)
   */
  unpublishManyJobListings: BatchPayload
  /** Find many JobListing documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyJobListingsConnection: JobListingConnection
  /**
   * Unpublish many Journey documents
   * @deprecated Please use the new paginated many mutation (unpublishManyJourneysConnection)
   */
  unpublishManyJourneys: BatchPayload
  /** Find many Journey documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyJourneysConnection: JourneyConnection
  /**
   * Unpublish many LandingPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLandingPagesConnection)
   */
  unpublishManyLandingPages: BatchPayload
  /** Find many LandingPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLandingPagesConnection: LandingPageConnection
  /**
   * Unpublish many ManageContentConfig documents
   * @deprecated Please use the new paginated many mutation (unpublishManyManageContentConfigsConnection)
   */
  unpublishManyManageContentConfigs: BatchPayload
  /** Find many ManageContentConfig documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyManageContentConfigsConnection: ManageContentConfigConnection
  /**
   * Unpublish many MapMarkerIcon documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMapMarkerIconsConnection)
   */
  unpublishManyMapMarkerIcons: BatchPayload
  /** Find many MapMarkerIcon documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMapMarkerIconsConnection: MapMarkerIconConnection
  /**
   * Unpublish many MapMarker documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMapMarkersConnection)
   */
  unpublishManyMapMarkers: BatchPayload
  /** Find many MapMarker documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMapMarkersConnection: MapMarkerConnection
  /**
   * Unpublish many NewsletterAudience documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNewsletterAudiencesConnection)
   */
  unpublishManyNewsletterAudiences: BatchPayload
  /** Find many NewsletterAudience documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNewsletterAudiencesConnection: NewsletterAudienceConnection
  /**
   * Unpublish many Notification documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNotificationsConnection)
   */
  unpublishManyNotifications: BatchPayload
  /** Find many Notification documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNotificationsConnection: NotificationConnection
  /**
   * Unpublish many OMRPartner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyOMRPartnersConnection)
   */
  unpublishManyOMRPartners: BatchPayload
  /** Find many OMRPartner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyOMRPartnersConnection: OmrPartnerConnection
  /**
   * Unpublish many PartnerCompany documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPartnerCompaniesConnection)
   */
  unpublishManyPartnerCompanies: BatchPayload
  /** Find many PartnerCompany documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPartnerCompaniesConnection: PartnerCompanyConnection
  /**
   * Unpublish many PhysicalLocation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPhysicalLocationsConnection)
   */
  unpublishManyPhysicalLocations: BatchPayload
  /** Find many PhysicalLocation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPhysicalLocationsConnection: PhysicalLocationConnection
  /**
   * Unpublish many PodcastEpisode documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPodcastEpisodesConnection)
   */
  unpublishManyPodcastEpisodes: BatchPayload
  /** Find many PodcastEpisode documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPodcastEpisodesConnection: PodcastEpisodeConnection
  /**
   * Unpublish many PodcastGroup documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPodcastGroupsConnection)
   */
  unpublishManyPodcastGroups: BatchPayload
  /** Find many PodcastGroup documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPodcastGroupsConnection: PodcastGroupConnection
  /**
   * Unpublish many PricingTier documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPricingTiersConnection)
   */
  unpublishManyPricingTiers: BatchPayload
  /** Find many PricingTier documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPricingTiersConnection: PricingTierConnection
  /**
   * Unpublish many RecommendationFood documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecommendationsFoodConnection)
   */
  unpublishManyRecommendationsFood: BatchPayload
  /** Find many RecommendationFood documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecommendationsFoodConnection: RecommendationFoodConnection
  /**
   * Unpublish many RecommendationNightOut documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecommendationsNightOutConnection)
   */
  unpublishManyRecommendationsNightOut: BatchPayload
  /** Find many RecommendationNightOut documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecommendationsNightOutConnection: RecommendationNightOutConnection
  /**
   * Unpublish many ReviewsAgency documents
   * @deprecated Please use the new paginated many mutation (unpublishManyReviewsAgenciesConnection)
   */
  unpublishManyReviewsAgencies: BatchPayload
  /** Find many ReviewsAgency documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyReviewsAgenciesConnection: ReviewsAgencyConnection
  /**
   * Unpublish many ReviewsFeatureRow documents
   * @deprecated Please use the new paginated many mutation (unpublishManyReviewsFeatureRowsConnection)
   */
  unpublishManyReviewsFeatureRows: BatchPayload
  /** Find many ReviewsFeatureRow documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyReviewsFeatureRowsConnection: ReviewsFeatureRowConnection
  /**
   * Unpublish many ReviewsFeaturesSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyReviewsFeaturesSectionsConnection)
   */
  unpublishManyReviewsFeaturesSections: BatchPayload
  /** Find many ReviewsFeaturesSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyReviewsFeaturesSectionsConnection: ReviewsFeaturesSectionConnection
  /**
   * Unpublish many ReviewsProductCategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyReviewsProductCategoriesConnection)
   */
  unpublishManyReviewsProductCategories: BatchPayload
  /** Find many ReviewsProductCategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyReviewsProductCategoriesConnection: ReviewsProductCategoryConnection
  /**
   * Unpublish many ReviewsProductWidget documents
   * @deprecated Please use the new paginated many mutation (unpublishManyReviewsProductWidgetsConnection)
   */
  unpublishManyReviewsProductWidgets: BatchPayload
  /** Find many ReviewsProductWidget documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyReviewsProductWidgetsConnection: ReviewsProductWidgetConnection
  /**
   * Unpublish many ReviewsProduct documents
   * @deprecated Please use the new paginated many mutation (unpublishManyReviewsProductsConnection)
   */
  unpublishManyReviewsProducts: BatchPayload
  /** Find many ReviewsProduct documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyReviewsProductsConnection: ReviewsProductConnection
  /**
   * Unpublish many SiteSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManySiteSectionsConnection)
   */
  unpublishManySiteSections: BatchPayload
  /** Find many SiteSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySiteSectionsConnection: SiteSectionConnection
  /**
   * Unpublish many SocialEmbed documents
   * @deprecated Please use the new paginated many mutation (unpublishManySocialEmbedsConnection)
   */
  unpublishManySocialEmbeds: BatchPayload
  /** Find many SocialEmbed documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySocialEmbedsConnection: SocialEmbedConnection
  /**
   * Unpublish many SpeakerListOrder documents
   * @deprecated Please use the new paginated many mutation (unpublishManySpeakerListOrdersConnection)
   */
  unpublishManySpeakerListOrders: BatchPayload
  /** Find many SpeakerListOrder documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySpeakerListOrdersConnection: SpeakerListOrderConnection
  /**
   * Unpublish many Speaker documents
   * @deprecated Please use the new paginated many mutation (unpublishManySpeakersConnection)
   */
  unpublishManySpeakers: BatchPayload
  /** Find many Speaker documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySpeakersConnection: SpeakerConnection
  /**
   * Unpublish many TabContent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTabContentsConnection)
   */
  unpublishManyTabContents: BatchPayload
  /** Find many TabContent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTabContentsConnection: TabContentConnection
  /**
   * Unpublish many Tag documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTagsConnection)
   */
  unpublishManyTags: BatchPayload
  /** Find many Tag documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTagsConnection: TagConnection
  /**
   * Unpublish many TicketsTableColumn documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTicketsTableColumnsConnection)
   */
  unpublishManyTicketsTableColumns: BatchPayload
  /** Find many TicketsTableColumn documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTicketsTableColumnsConnection: TicketsTableColumnConnection
  /**
   * Unpublish many TopicPageCategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTopicPageCategoriesConnection)
   */
  unpublishManyTopicPageCategories: BatchPayload
  /** Find many TopicPageCategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTopicPageCategoriesConnection: TopicPageCategoryConnection
  /**
   * Unpublish many TopicPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTopicPagesConnection)
   */
  unpublishManyTopicPages: BatchPayload
  /** Find many TopicPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTopicPagesConnection: TopicPageConnection
  /**
   * Unpublish many VGWort documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVGWortsConnection)
   */
  unpublishManyVGWorts: BatchPayload
  /** Find many VGWort documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVGWortsConnection: VgWortConnection
  /** Unpublish one mapMarker from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMapMarker?: Maybe<MapMarker>
  /** Unpublish one mapMarkerIcon from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Unpublish one newsletterAudience from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNewsletterAudience?: Maybe<NewsletterAudience>
  /** Unpublish one notification from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNotification?: Maybe<Notification>
  /** Unpublish one oMRPartner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishOMRPartner?: Maybe<OmrPartner>
  /** Unpublish one partnerCompany from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPartnerCompany?: Maybe<PartnerCompany>
  /** Unpublish one physicalLocation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPhysicalLocation?: Maybe<PhysicalLocation>
  /** Unpublish one podcastEpisode from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPodcastEpisode?: Maybe<PodcastEpisode>
  /** Unpublish one podcastGroup from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPodcastGroup?: Maybe<PodcastGroup>
  /** Unpublish one pricingTier from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPricingTier?: Maybe<PricingTier>
  /** Unpublish one recommendationFood from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecommendationFood?: Maybe<RecommendationFood>
  /** Unpublish one recommendationNightOut from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecommendationNightOut?: Maybe<RecommendationNightOut>
  /** Unpublish one reviewsAgency from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishReviewsAgency?: Maybe<ReviewsAgency>
  /** Unpublish one reviewsFeatureRow from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishReviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Unpublish one reviewsFeaturesSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishReviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Unpublish one reviewsProduct from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishReviewsProduct?: Maybe<ReviewsProduct>
  /** Unpublish one reviewsProductCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishReviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Unpublish one reviewsProductWidget from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishReviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Unpublish one siteSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSiteSection?: Maybe<SiteSection>
  /** Unpublish one socialEmbed from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSocialEmbed?: Maybe<SocialEmbed>
  /** Unpublish one speaker from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSpeaker?: Maybe<Speaker>
  /** Unpublish one speakerListOrder from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSpeakerListOrder?: Maybe<SpeakerListOrder>
  /** Unpublish one tabContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTabContent?: Maybe<TabContent>
  /** Unpublish one tag from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTag?: Maybe<Tag>
  /** Unpublish one ticketsTableColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTicketsTableColumn?: Maybe<TicketsTableColumn>
  /** Unpublish one topicPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTopicPage?: Maybe<TopicPage>
  /** Unpublish one topicPageCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTopicPageCategory?: Maybe<TopicPageCategory>
  /** Unpublish one vGWort from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishVGWort?: Maybe<VgWort>
  /** Update one animatedCounter */
  updateAnimatedCounter?: Maybe<AnimatedCounter>
  /** Update one article */
  updateArticle?: Maybe<Article>
  /** Update one articleCategory */
  updateArticleCategory?: Maybe<ArticleCategory>
  /** Update one articlePageView */
  updateArticlePageView?: Maybe<ArticlePageView>
  /** Update one asset */
  updateAsset?: Maybe<Asset>
  /** Update one author */
  updateAuthor?: Maybe<Author>
  /** Update one booth */
  updateBooth?: Maybe<Booth>
  /** Update one careerPage */
  updateCareerPage?: Maybe<CareerPage>
  /** Update one contentReference */
  updateContentReference?: Maybe<ContentReference>
  /** Update one educationReport */
  updateEducationReport?: Maybe<EducationReport>
  /** Update one educationSeminar */
  updateEducationSeminar?: Maybe<EducationSeminar>
  /** Update one event */
  updateEvent?: Maybe<Event>
  /** Update one eventAppPage */
  updateEventAppPage?: Maybe<EventAppPage>
  /** Update one eventPage */
  updateEventPage?: Maybe<EventPage>
  /** Update one eventStage */
  updateEventStage?: Maybe<EventStage>
  /** Update one exhibitorListOrder */
  updateExhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Update one faqQuestion */
  updateFaqQuestion?: Maybe<FaqQuestion>
  /** Update one footer */
  updateFooter?: Maybe<Footer>
  /** Update one glossary */
  updateGlossary?: Maybe<Glossary>
  /** Update one header */
  updateHeader?: Maybe<Header>
  /** Update one hotel */
  updateHotel?: Maybe<Hotel>
  /** Update one htmlEmbed */
  updateHtmlEmbed?: Maybe<HtmlEmbed>
  /** Update one hubContentEntry */
  updateHubContentEntry?: Maybe<HubContentEntry>
  /** Update one hubPage */
  updateHubPage?: Maybe<HubPage>
  /** Update one hubPageCountdownHero */
  updateHubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Update one imageGalleryEmbed */
  updateImageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Update one interest */
  updateInterest?: Maybe<Interest>
  /** Update one jobListing */
  updateJobListing?: Maybe<JobListing>
  /** Update one journey */
  updateJourney?: Maybe<Journey>
  /** Update one landingPage */
  updateLandingPage?: Maybe<LandingPage>
  /** Update one manageContentConfig */
  updateManageContentConfig?: Maybe<ManageContentConfig>
  /**
   * Update many animatedCounters
   * @deprecated Please use the new paginated many mutation (updateManyAnimatedCountersConnection)
   */
  updateManyAnimatedCounters: BatchPayload
  /** Update many AnimatedCounter documents */
  updateManyAnimatedCountersConnection: AnimatedCounterConnection
  /**
   * Update many articleCategories
   * @deprecated Please use the new paginated many mutation (updateManyArticleCategoriesConnection)
   */
  updateManyArticleCategories: BatchPayload
  /** Update many ArticleCategory documents */
  updateManyArticleCategoriesConnection: ArticleCategoryConnection
  /**
   * Update many articlePageViews
   * @deprecated Please use the new paginated many mutation (updateManyArticlePageViewsConnection)
   */
  updateManyArticlePageViews: BatchPayload
  /** Update many ArticlePageView documents */
  updateManyArticlePageViewsConnection: ArticlePageViewConnection
  /**
   * Update many articles
   * @deprecated Please use the new paginated many mutation (updateManyArticlesConnection)
   */
  updateManyArticles: BatchPayload
  /** Update many Article documents */
  updateManyArticlesConnection: ArticleConnection
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection
  /**
   * Update many authors
   * @deprecated Please use the new paginated many mutation (updateManyAuthorsConnection)
   */
  updateManyAuthors: BatchPayload
  /** Update many Author documents */
  updateManyAuthorsConnection: AuthorConnection
  /**
   * Update many booths
   * @deprecated Please use the new paginated many mutation (updateManyBoothsConnection)
   */
  updateManyBooths: BatchPayload
  /** Update many Booth documents */
  updateManyBoothsConnection: BoothConnection
  /**
   * Update many careerPages
   * @deprecated Please use the new paginated many mutation (updateManyCareerPagesConnection)
   */
  updateManyCareerPages: BatchPayload
  /** Update many CareerPage documents */
  updateManyCareerPagesConnection: CareerPageConnection
  /**
   * Update many contentReferences
   * @deprecated Please use the new paginated many mutation (updateManyContentReferencesConnection)
   */
  updateManyContentReferences: BatchPayload
  /** Update many ContentReference documents */
  updateManyContentReferencesConnection: ContentReferenceConnection
  /**
   * Update many educationReports
   * @deprecated Please use the new paginated many mutation (updateManyEducationReportsConnection)
   */
  updateManyEducationReports: BatchPayload
  /** Update many EducationReport documents */
  updateManyEducationReportsConnection: EducationReportConnection
  /**
   * Update many educationSeminars
   * @deprecated Please use the new paginated many mutation (updateManyEducationSeminarsConnection)
   */
  updateManyEducationSeminars: BatchPayload
  /** Update many EducationSeminar documents */
  updateManyEducationSeminarsConnection: EducationSeminarConnection
  /**
   * Update many eventAppPages
   * @deprecated Please use the new paginated many mutation (updateManyEventAppPagesConnection)
   */
  updateManyEventAppPages: BatchPayload
  /** Update many EventAppPage documents */
  updateManyEventAppPagesConnection: EventAppPageConnection
  /**
   * Update many eventPages
   * @deprecated Please use the new paginated many mutation (updateManyEventPagesConnection)
   */
  updateManyEventPages: BatchPayload
  /** Update many EventPage documents */
  updateManyEventPagesConnection: EventPageConnection
  /**
   * Update many eventStages
   * @deprecated Please use the new paginated many mutation (updateManyEventStagesConnection)
   */
  updateManyEventStages: BatchPayload
  /** Update many EventStage documents */
  updateManyEventStagesConnection: EventStageConnection
  /**
   * Update many events
   * @deprecated Please use the new paginated many mutation (updateManyEventsConnection)
   */
  updateManyEvents: BatchPayload
  /** Update many Event documents */
  updateManyEventsConnection: EventConnection
  /**
   * Update many exhibitorListOrders
   * @deprecated Please use the new paginated many mutation (updateManyExhibitorListOrdersConnection)
   */
  updateManyExhibitorListOrders: BatchPayload
  /** Update many ExhibitorListOrder documents */
  updateManyExhibitorListOrdersConnection: ExhibitorListOrderConnection
  /**
   * Update many faqQuestions
   * @deprecated Please use the new paginated many mutation (updateManyFaqQuestionsConnection)
   */
  updateManyFaqQuestions: BatchPayload
  /** Update many FaqQuestion documents */
  updateManyFaqQuestionsConnection: FaqQuestionConnection
  /**
   * Update many footers
   * @deprecated Please use the new paginated many mutation (updateManyFootersConnection)
   */
  updateManyFooters: BatchPayload
  /** Update many Footer documents */
  updateManyFootersConnection: FooterConnection
  /**
   * Update many glossaries
   * @deprecated Please use the new paginated many mutation (updateManyGlossariesConnection)
   */
  updateManyGlossaries: BatchPayload
  /** Update many Glossary documents */
  updateManyGlossariesConnection: GlossaryConnection
  /**
   * Update many headers
   * @deprecated Please use the new paginated many mutation (updateManyHeadersConnection)
   */
  updateManyHeaders: BatchPayload
  /** Update many Header documents */
  updateManyHeadersConnection: HeaderConnection
  /**
   * Update many hotels
   * @deprecated Please use the new paginated many mutation (updateManyHotelsConnection)
   */
  updateManyHotels: BatchPayload
  /** Update many Hotel documents */
  updateManyHotelsConnection: HotelConnection
  /**
   * Update many htmlEmbeds
   * @deprecated Please use the new paginated many mutation (updateManyHtmlEmbedsConnection)
   */
  updateManyHtmlEmbeds: BatchPayload
  /** Update many HtmlEmbed documents */
  updateManyHtmlEmbedsConnection: HtmlEmbedConnection
  /**
   * Update many hubContentEntries
   * @deprecated Please use the new paginated many mutation (updateManyHubContentEntriesConnection)
   */
  updateManyHubContentEntries: BatchPayload
  /** Update many HubContentEntry documents */
  updateManyHubContentEntriesConnection: HubContentEntryConnection
  /**
   * Update many hubPageCountdownHeroes
   * @deprecated Please use the new paginated many mutation (updateManyHubPageCountdownHeroesConnection)
   */
  updateManyHubPageCountdownHeroes: BatchPayload
  /** Update many HubPageCountdownHero documents */
  updateManyHubPageCountdownHeroesConnection: HubPageCountdownHeroConnection
  /**
   * Update many hubPages
   * @deprecated Please use the new paginated many mutation (updateManyHubPagesConnection)
   */
  updateManyHubPages: BatchPayload
  /** Update many HubPage documents */
  updateManyHubPagesConnection: HubPageConnection
  /**
   * Update many imageGalleryEmbeds
   * @deprecated Please use the new paginated many mutation (updateManyImageGalleryEmbedsConnection)
   */
  updateManyImageGalleryEmbeds: BatchPayload
  /** Update many ImageGalleryEmbed documents */
  updateManyImageGalleryEmbedsConnection: ImageGalleryEmbedConnection
  /**
   * Update many interests
   * @deprecated Please use the new paginated many mutation (updateManyInterestsConnection)
   */
  updateManyInterests: BatchPayload
  /** Update many Interest documents */
  updateManyInterestsConnection: InterestConnection
  /**
   * Update many jobListings
   * @deprecated Please use the new paginated many mutation (updateManyJobListingsConnection)
   */
  updateManyJobListings: BatchPayload
  /** Update many JobListing documents */
  updateManyJobListingsConnection: JobListingConnection
  /**
   * Update many journeys
   * @deprecated Please use the new paginated many mutation (updateManyJourneysConnection)
   */
  updateManyJourneys: BatchPayload
  /** Update many Journey documents */
  updateManyJourneysConnection: JourneyConnection
  /**
   * Update many landingPages
   * @deprecated Please use the new paginated many mutation (updateManyLandingPagesConnection)
   */
  updateManyLandingPages: BatchPayload
  /** Update many LandingPage documents */
  updateManyLandingPagesConnection: LandingPageConnection
  /**
   * Update many manageContentConfigs
   * @deprecated Please use the new paginated many mutation (updateManyManageContentConfigsConnection)
   */
  updateManyManageContentConfigs: BatchPayload
  /** Update many ManageContentConfig documents */
  updateManyManageContentConfigsConnection: ManageContentConfigConnection
  /**
   * Update many mapMarkerIcons
   * @deprecated Please use the new paginated many mutation (updateManyMapMarkerIconsConnection)
   */
  updateManyMapMarkerIcons: BatchPayload
  /** Update many MapMarkerIcon documents */
  updateManyMapMarkerIconsConnection: MapMarkerIconConnection
  /**
   * Update many mapMarkers
   * @deprecated Please use the new paginated many mutation (updateManyMapMarkersConnection)
   */
  updateManyMapMarkers: BatchPayload
  /** Update many MapMarker documents */
  updateManyMapMarkersConnection: MapMarkerConnection
  /**
   * Update many newsletterAudiences
   * @deprecated Please use the new paginated many mutation (updateManyNewsletterAudiencesConnection)
   */
  updateManyNewsletterAudiences: BatchPayload
  /** Update many NewsletterAudience documents */
  updateManyNewsletterAudiencesConnection: NewsletterAudienceConnection
  /**
   * Update many notifications
   * @deprecated Please use the new paginated many mutation (updateManyNotificationsConnection)
   */
  updateManyNotifications: BatchPayload
  /** Update many Notification documents */
  updateManyNotificationsConnection: NotificationConnection
  /**
   * Update many oMRPartners
   * @deprecated Please use the new paginated many mutation (updateManyOMRPartnersConnection)
   */
  updateManyOMRPartners: BatchPayload
  /** Update many OMRPartner documents */
  updateManyOMRPartnersConnection: OmrPartnerConnection
  /**
   * Update many partnerCompanies
   * @deprecated Please use the new paginated many mutation (updateManyPartnerCompaniesConnection)
   */
  updateManyPartnerCompanies: BatchPayload
  /** Update many PartnerCompany documents */
  updateManyPartnerCompaniesConnection: PartnerCompanyConnection
  /**
   * Update many physicalLocations
   * @deprecated Please use the new paginated many mutation (updateManyPhysicalLocationsConnection)
   */
  updateManyPhysicalLocations: BatchPayload
  /** Update many PhysicalLocation documents */
  updateManyPhysicalLocationsConnection: PhysicalLocationConnection
  /**
   * Update many podcastEpisodes
   * @deprecated Please use the new paginated many mutation (updateManyPodcastEpisodesConnection)
   */
  updateManyPodcastEpisodes: BatchPayload
  /** Update many PodcastEpisode documents */
  updateManyPodcastEpisodesConnection: PodcastEpisodeConnection
  /**
   * Update many podcastGroups
   * @deprecated Please use the new paginated many mutation (updateManyPodcastGroupsConnection)
   */
  updateManyPodcastGroups: BatchPayload
  /** Update many PodcastGroup documents */
  updateManyPodcastGroupsConnection: PodcastGroupConnection
  /**
   * Update many pricingTiers
   * @deprecated Please use the new paginated many mutation (updateManyPricingTiersConnection)
   */
  updateManyPricingTiers: BatchPayload
  /** Update many PricingTier documents */
  updateManyPricingTiersConnection: PricingTierConnection
  /**
   * Update many recommendationsFood
   * @deprecated Please use the new paginated many mutation (updateManyRecommendationsFoodConnection)
   */
  updateManyRecommendationsFood: BatchPayload
  /** Update many RecommendationFood documents */
  updateManyRecommendationsFoodConnection: RecommendationFoodConnection
  /**
   * Update many recommendationsNightOut
   * @deprecated Please use the new paginated many mutation (updateManyRecommendationsNightOutConnection)
   */
  updateManyRecommendationsNightOut: BatchPayload
  /** Update many RecommendationNightOut documents */
  updateManyRecommendationsNightOutConnection: RecommendationNightOutConnection
  /**
   * Update many reviewsAgencies
   * @deprecated Please use the new paginated many mutation (updateManyReviewsAgenciesConnection)
   */
  updateManyReviewsAgencies: BatchPayload
  /** Update many ReviewsAgency documents */
  updateManyReviewsAgenciesConnection: ReviewsAgencyConnection
  /**
   * Update many reviewsFeatureRows
   * @deprecated Please use the new paginated many mutation (updateManyReviewsFeatureRowsConnection)
   */
  updateManyReviewsFeatureRows: BatchPayload
  /** Update many ReviewsFeatureRow documents */
  updateManyReviewsFeatureRowsConnection: ReviewsFeatureRowConnection
  /**
   * Update many reviewsFeaturesSections
   * @deprecated Please use the new paginated many mutation (updateManyReviewsFeaturesSectionsConnection)
   */
  updateManyReviewsFeaturesSections: BatchPayload
  /** Update many ReviewsFeaturesSection documents */
  updateManyReviewsFeaturesSectionsConnection: ReviewsFeaturesSectionConnection
  /**
   * Update many reviewsProductCategories
   * @deprecated Please use the new paginated many mutation (updateManyReviewsProductCategoriesConnection)
   */
  updateManyReviewsProductCategories: BatchPayload
  /** Update many ReviewsProductCategory documents */
  updateManyReviewsProductCategoriesConnection: ReviewsProductCategoryConnection
  /**
   * Update many reviewsProductWidgets
   * @deprecated Please use the new paginated many mutation (updateManyReviewsProductWidgetsConnection)
   */
  updateManyReviewsProductWidgets: BatchPayload
  /** Update many ReviewsProductWidget documents */
  updateManyReviewsProductWidgetsConnection: ReviewsProductWidgetConnection
  /**
   * Update many reviewsProducts
   * @deprecated Please use the new paginated many mutation (updateManyReviewsProductsConnection)
   */
  updateManyReviewsProducts: BatchPayload
  /** Update many ReviewsProduct documents */
  updateManyReviewsProductsConnection: ReviewsProductConnection
  /**
   * Update many siteSections
   * @deprecated Please use the new paginated many mutation (updateManySiteSectionsConnection)
   */
  updateManySiteSections: BatchPayload
  /** Update many SiteSection documents */
  updateManySiteSectionsConnection: SiteSectionConnection
  /**
   * Update many socialEmbeds
   * @deprecated Please use the new paginated many mutation (updateManySocialEmbedsConnection)
   */
  updateManySocialEmbeds: BatchPayload
  /** Update many SocialEmbed documents */
  updateManySocialEmbedsConnection: SocialEmbedConnection
  /**
   * Update many speakerListOrders
   * @deprecated Please use the new paginated many mutation (updateManySpeakerListOrdersConnection)
   */
  updateManySpeakerListOrders: BatchPayload
  /** Update many SpeakerListOrder documents */
  updateManySpeakerListOrdersConnection: SpeakerListOrderConnection
  /**
   * Update many speakers
   * @deprecated Please use the new paginated many mutation (updateManySpeakersConnection)
   */
  updateManySpeakers: BatchPayload
  /** Update many Speaker documents */
  updateManySpeakersConnection: SpeakerConnection
  /**
   * Update many tabContents
   * @deprecated Please use the new paginated many mutation (updateManyTabContentsConnection)
   */
  updateManyTabContents: BatchPayload
  /** Update many TabContent documents */
  updateManyTabContentsConnection: TabContentConnection
  /**
   * Update many tags
   * @deprecated Please use the new paginated many mutation (updateManyTagsConnection)
   */
  updateManyTags: BatchPayload
  /** Update many Tag documents */
  updateManyTagsConnection: TagConnection
  /**
   * Update many ticketsTableColumns
   * @deprecated Please use the new paginated many mutation (updateManyTicketsTableColumnsConnection)
   */
  updateManyTicketsTableColumns: BatchPayload
  /** Update many TicketsTableColumn documents */
  updateManyTicketsTableColumnsConnection: TicketsTableColumnConnection
  /**
   * Update many topicPageCategories
   * @deprecated Please use the new paginated many mutation (updateManyTopicPageCategoriesConnection)
   */
  updateManyTopicPageCategories: BatchPayload
  /** Update many TopicPageCategory documents */
  updateManyTopicPageCategoriesConnection: TopicPageCategoryConnection
  /**
   * Update many topicPages
   * @deprecated Please use the new paginated many mutation (updateManyTopicPagesConnection)
   */
  updateManyTopicPages: BatchPayload
  /** Update many TopicPage documents */
  updateManyTopicPagesConnection: TopicPageConnection
  /**
   * Update many vGWorts
   * @deprecated Please use the new paginated many mutation (updateManyVGWortsConnection)
   */
  updateManyVGWorts: BatchPayload
  /** Update many VGWort documents */
  updateManyVGWortsConnection: VgWortConnection
  /** Update one mapMarker */
  updateMapMarker?: Maybe<MapMarker>
  /** Update one mapMarkerIcon */
  updateMapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Update one newsletterAudience */
  updateNewsletterAudience?: Maybe<NewsletterAudience>
  /** Update one notification */
  updateNotification?: Maybe<Notification>
  /** Update one oMRPartner */
  updateOMRPartner?: Maybe<OmrPartner>
  /** Update one partnerCompany */
  updatePartnerCompany?: Maybe<PartnerCompany>
  /** Update one physicalLocation */
  updatePhysicalLocation?: Maybe<PhysicalLocation>
  /** Update one podcastEpisode */
  updatePodcastEpisode?: Maybe<PodcastEpisode>
  /** Update one podcastGroup */
  updatePodcastGroup?: Maybe<PodcastGroup>
  /** Update one pricingTier */
  updatePricingTier?: Maybe<PricingTier>
  /** Update one recommendationFood */
  updateRecommendationFood?: Maybe<RecommendationFood>
  /** Update one recommendationNightOut */
  updateRecommendationNightOut?: Maybe<RecommendationNightOut>
  /** Update one reviewsAgency */
  updateReviewsAgency?: Maybe<ReviewsAgency>
  /** Update one reviewsFeatureRow */
  updateReviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Update one reviewsFeaturesSection */
  updateReviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Update one reviewsProduct */
  updateReviewsProduct?: Maybe<ReviewsProduct>
  /** Update one reviewsProductCategory */
  updateReviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Update one reviewsProductWidget */
  updateReviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>
  /** Update one siteSection */
  updateSiteSection?: Maybe<SiteSection>
  /** Update one socialEmbed */
  updateSocialEmbed?: Maybe<SocialEmbed>
  /** Update one speaker */
  updateSpeaker?: Maybe<Speaker>
  /** Update one speakerListOrder */
  updateSpeakerListOrder?: Maybe<SpeakerListOrder>
  /** Update one tabContent */
  updateTabContent?: Maybe<TabContent>
  /** Update one tag */
  updateTag?: Maybe<Tag>
  /** Update one ticketsTableColumn */
  updateTicketsTableColumn?: Maybe<TicketsTableColumn>
  /** Update one topicPage */
  updateTopicPage?: Maybe<TopicPage>
  /** Update one topicPageCategory */
  updateTopicPageCategory?: Maybe<TopicPageCategory>
  /** Update one vGWort */
  updateVGWort?: Maybe<VgWort>
  /** Upsert one animatedCounter */
  upsertAnimatedCounter?: Maybe<AnimatedCounter>
  /** Upsert one article */
  upsertArticle?: Maybe<Article>
  /** Upsert one articleCategory */
  upsertArticleCategory?: Maybe<ArticleCategory>
  /** Upsert one articlePageView */
  upsertArticlePageView?: Maybe<ArticlePageView>
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>
  /** Upsert one author */
  upsertAuthor?: Maybe<Author>
  /** Upsert one booth */
  upsertBooth?: Maybe<Booth>
  /** Upsert one careerPage */
  upsertCareerPage?: Maybe<CareerPage>
  /** Upsert one contentReference */
  upsertContentReference?: Maybe<ContentReference>
  /** Upsert one educationReport */
  upsertEducationReport?: Maybe<EducationReport>
  /** Upsert one educationSeminar */
  upsertEducationSeminar?: Maybe<EducationSeminar>
  /** Upsert one event */
  upsertEvent?: Maybe<Event>
  /** Upsert one eventAppPage */
  upsertEventAppPage?: Maybe<EventAppPage>
  /** Upsert one eventPage */
  upsertEventPage?: Maybe<EventPage>
  /** Upsert one eventStage */
  upsertEventStage?: Maybe<EventStage>
  /** Upsert one exhibitorListOrder */
  upsertExhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Upsert one faqQuestion */
  upsertFaqQuestion?: Maybe<FaqQuestion>
  /** Upsert one footer */
  upsertFooter?: Maybe<Footer>
  /** Upsert one glossary */
  upsertGlossary?: Maybe<Glossary>
  /** Upsert one header */
  upsertHeader?: Maybe<Header>
  /** Upsert one hotel */
  upsertHotel?: Maybe<Hotel>
  /** Upsert one htmlEmbed */
  upsertHtmlEmbed?: Maybe<HtmlEmbed>
  /** Upsert one hubContentEntry */
  upsertHubContentEntry?: Maybe<HubContentEntry>
  /** Upsert one hubPage */
  upsertHubPage?: Maybe<HubPage>
  /** Upsert one hubPageCountdownHero */
  upsertHubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Upsert one imageGalleryEmbed */
  upsertImageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Upsert one interest */
  upsertInterest?: Maybe<Interest>
  /** Upsert one jobListing */
  upsertJobListing?: Maybe<JobListing>
  /** Upsert one journey */
  upsertJourney?: Maybe<Journey>
  /** Upsert one landingPage */
  upsertLandingPage?: Maybe<LandingPage>
  /** Upsert one manageContentConfig */
  upsertManageContentConfig?: Maybe<ManageContentConfig>
  /** Upsert one mapMarker */
  upsertMapMarker?: Maybe<MapMarker>
  /** Upsert one mapMarkerIcon */
  upsertMapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Upsert one newsletterAudience */
  upsertNewsletterAudience?: Maybe<NewsletterAudience>
  /** Upsert one notification */
  upsertNotification?: Maybe<Notification>
  /** Upsert one oMRPartner */
  upsertOMRPartner?: Maybe<OmrPartner>
  /** Upsert one partnerCompany */
  upsertPartnerCompany?: Maybe<PartnerCompany>
  /** Upsert one physicalLocation */
  upsertPhysicalLocation?: Maybe<PhysicalLocation>
  /** Upsert one podcastEpisode */
  upsertPodcastEpisode?: Maybe<PodcastEpisode>
  /** Upsert one podcastGroup */
  upsertPodcastGroup?: Maybe<PodcastGroup>
  /** Upsert one pricingTier */
  upsertPricingTier?: Maybe<PricingTier>
  /** Upsert one recommendationFood */
  upsertRecommendationFood?: Maybe<RecommendationFood>
  /** Upsert one recommendationNightOut */
  upsertRecommendationNightOut?: Maybe<RecommendationNightOut>
  /** Upsert one reviewsAgency */
  upsertReviewsAgency?: Maybe<ReviewsAgency>
  /** Upsert one reviewsFeatureRow */
  upsertReviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Upsert one reviewsFeaturesSection */
  upsertReviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Upsert one reviewsProduct */
  upsertReviewsProduct?: Maybe<ReviewsProduct>
  /** Upsert one reviewsProductCategory */
  upsertReviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Upsert one reviewsProductWidget */
  upsertReviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Upsert one siteSection */
  upsertSiteSection?: Maybe<SiteSection>
  /** Upsert one socialEmbed */
  upsertSocialEmbed?: Maybe<SocialEmbed>
  /** Upsert one speaker */
  upsertSpeaker?: Maybe<Speaker>
  /** Upsert one speakerListOrder */
  upsertSpeakerListOrder?: Maybe<SpeakerListOrder>
  /** Upsert one tabContent */
  upsertTabContent?: Maybe<TabContent>
  /** Upsert one tag */
  upsertTag?: Maybe<Tag>
  /** Upsert one ticketsTableColumn */
  upsertTicketsTableColumn?: Maybe<TicketsTableColumn>
  /** Upsert one topicPage */
  upsertTopicPage?: Maybe<TopicPage>
  /** Upsert one topicPageCategory */
  upsertTopicPageCategory?: Maybe<TopicPageCategory>
  /** Upsert one vGWort */
  upsertVGWort?: Maybe<VgWort>
}

export type MutationCreateAnimatedCounterArgs = {
  data: AnimatedCounterCreateInput
}

export type MutationCreateArticleArgs = {
  data: ArticleCreateInput
}

export type MutationCreateArticleCategoryArgs = {
  data: ArticleCategoryCreateInput
}

export type MutationCreateArticlePageViewArgs = {
  data: ArticlePageViewCreateInput
}

export type MutationCreateAssetArgs = {
  data: AssetCreateInput
}

export type MutationCreateAuthorArgs = {
  data: AuthorCreateInput
}

export type MutationCreateBoothArgs = {
  data: BoothCreateInput
}

export type MutationCreateCareerPageArgs = {
  data: CareerPageCreateInput
}

export type MutationCreateContentReferenceArgs = {
  data: ContentReferenceCreateInput
}

export type MutationCreateEducationReportArgs = {
  data: EducationReportCreateInput
}

export type MutationCreateEducationSeminarArgs = {
  data: EducationSeminarCreateInput
}

export type MutationCreateEventArgs = {
  data: EventCreateInput
}

export type MutationCreateEventAppPageArgs = {
  data: EventAppPageCreateInput
}

export type MutationCreateEventPageArgs = {
  data: EventPageCreateInput
}

export type MutationCreateEventStageArgs = {
  data: EventStageCreateInput
}

export type MutationCreateExhibitorListOrderArgs = {
  data: ExhibitorListOrderCreateInput
}

export type MutationCreateFaqQuestionArgs = {
  data: FaqQuestionCreateInput
}

export type MutationCreateFooterArgs = {
  data: FooterCreateInput
}

export type MutationCreateGlossaryArgs = {
  data: GlossaryCreateInput
}

export type MutationCreateHeaderArgs = {
  data: HeaderCreateInput
}

export type MutationCreateHotelArgs = {
  data: HotelCreateInput
}

export type MutationCreateHtmlEmbedArgs = {
  data: HtmlEmbedCreateInput
}

export type MutationCreateHubContentEntryArgs = {
  data: HubContentEntryCreateInput
}

export type MutationCreateHubPageArgs = {
  data: HubPageCreateInput
}

export type MutationCreateHubPageCountdownHeroArgs = {
  data: HubPageCountdownHeroCreateInput
}

export type MutationCreateImageGalleryEmbedArgs = {
  data: ImageGalleryEmbedCreateInput
}

export type MutationCreateInterestArgs = {
  data: InterestCreateInput
}

export type MutationCreateJobListingArgs = {
  data: JobListingCreateInput
}

export type MutationCreateJourneyArgs = {
  data: JourneyCreateInput
}

export type MutationCreateLandingPageArgs = {
  data: LandingPageCreateInput
}

export type MutationCreateManageContentConfigArgs = {
  data: ManageContentConfigCreateInput
}

export type MutationCreateMapMarkerArgs = {
  data: MapMarkerCreateInput
}

export type MutationCreateMapMarkerIconArgs = {
  data: MapMarkerIconCreateInput
}

export type MutationCreateNewsletterAudienceArgs = {
  data: NewsletterAudienceCreateInput
}

export type MutationCreateNotificationArgs = {
  data: NotificationCreateInput
}

export type MutationCreateOmrPartnerArgs = {
  data: OmrPartnerCreateInput
}

export type MutationCreatePartnerCompanyArgs = {
  data: PartnerCompanyCreateInput
}

export type MutationCreatePhysicalLocationArgs = {
  data: PhysicalLocationCreateInput
}

export type MutationCreatePodcastEpisodeArgs = {
  data: PodcastEpisodeCreateInput
}

export type MutationCreatePodcastGroupArgs = {
  data: PodcastGroupCreateInput
}

export type MutationCreatePricingTierArgs = {
  data: PricingTierCreateInput
}

export type MutationCreateRecommendationFoodArgs = {
  data: RecommendationFoodCreateInput
}

export type MutationCreateRecommendationNightOutArgs = {
  data: RecommendationNightOutCreateInput
}

export type MutationCreateReviewsAgencyArgs = {
  data: ReviewsAgencyCreateInput
}

export type MutationCreateReviewsFeatureRowArgs = {
  data: ReviewsFeatureRowCreateInput
}

export type MutationCreateReviewsFeaturesSectionArgs = {
  data: ReviewsFeaturesSectionCreateInput
}

export type MutationCreateReviewsProductArgs = {
  data: ReviewsProductCreateInput
}

export type MutationCreateReviewsProductCategoryArgs = {
  data: ReviewsProductCategoryCreateInput
}

export type MutationCreateReviewsProductWidgetArgs = {
  data: ReviewsProductWidgetCreateInput
}

export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput
}

export type MutationCreateSiteSectionArgs = {
  data: SiteSectionCreateInput
}

export type MutationCreateSocialEmbedArgs = {
  data: SocialEmbedCreateInput
}

export type MutationCreateSpeakerArgs = {
  data: SpeakerCreateInput
}

export type MutationCreateSpeakerListOrderArgs = {
  data: SpeakerListOrderCreateInput
}

export type MutationCreateTabContentArgs = {
  data: TabContentCreateInput
}

export type MutationCreateTagArgs = {
  data: TagCreateInput
}

export type MutationCreateTicketsTableColumnArgs = {
  data: TicketsTableColumnCreateInput
}

export type MutationCreateTopicPageArgs = {
  data: TopicPageCreateInput
}

export type MutationCreateTopicPageCategoryArgs = {
  data: TopicPageCategoryCreateInput
}

export type MutationCreateVgWortArgs = {
  data: VgWortCreateInput
}

export type MutationDeleteAnimatedCounterArgs = {
  where: AnimatedCounterWhereUniqueInput
}

export type MutationDeleteArticleArgs = {
  where: ArticleWhereUniqueInput
}

export type MutationDeleteArticleCategoryArgs = {
  where: ArticleCategoryWhereUniqueInput
}

export type MutationDeleteArticlePageViewArgs = {
  where: ArticlePageViewWhereUniqueInput
}

export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput
}

export type MutationDeleteAuthorArgs = {
  where: AuthorWhereUniqueInput
}

export type MutationDeleteBoothArgs = {
  where: BoothWhereUniqueInput
}

export type MutationDeleteCareerPageArgs = {
  where: CareerPageWhereUniqueInput
}

export type MutationDeleteContentReferenceArgs = {
  where: ContentReferenceWhereUniqueInput
}

export type MutationDeleteEducationReportArgs = {
  where: EducationReportWhereUniqueInput
}

export type MutationDeleteEducationSeminarArgs = {
  where: EducationSeminarWhereUniqueInput
}

export type MutationDeleteEventArgs = {
  where: EventWhereUniqueInput
}

export type MutationDeleteEventAppPageArgs = {
  where: EventAppPageWhereUniqueInput
}

export type MutationDeleteEventPageArgs = {
  where: EventPageWhereUniqueInput
}

export type MutationDeleteEventStageArgs = {
  where: EventStageWhereUniqueInput
}

export type MutationDeleteExhibitorListOrderArgs = {
  where: ExhibitorListOrderWhereUniqueInput
}

export type MutationDeleteFaqQuestionArgs = {
  where: FaqQuestionWhereUniqueInput
}

export type MutationDeleteFooterArgs = {
  where: FooterWhereUniqueInput
}

export type MutationDeleteGlossaryArgs = {
  where: GlossaryWhereUniqueInput
}

export type MutationDeleteHeaderArgs = {
  where: HeaderWhereUniqueInput
}

export type MutationDeleteHotelArgs = {
  where: HotelWhereUniqueInput
}

export type MutationDeleteHtmlEmbedArgs = {
  where: HtmlEmbedWhereUniqueInput
}

export type MutationDeleteHubContentEntryArgs = {
  where: HubContentEntryWhereUniqueInput
}

export type MutationDeleteHubPageArgs = {
  where: HubPageWhereUniqueInput
}

export type MutationDeleteHubPageCountdownHeroArgs = {
  where: HubPageCountdownHeroWhereUniqueInput
}

export type MutationDeleteImageGalleryEmbedArgs = {
  where: ImageGalleryEmbedWhereUniqueInput
}

export type MutationDeleteInterestArgs = {
  where: InterestWhereUniqueInput
}

export type MutationDeleteJobListingArgs = {
  where: JobListingWhereUniqueInput
}

export type MutationDeleteJourneyArgs = {
  where: JourneyWhereUniqueInput
}

export type MutationDeleteLandingPageArgs = {
  where: LandingPageWhereUniqueInput
}

export type MutationDeleteManageContentConfigArgs = {
  where: ManageContentConfigWhereUniqueInput
}

export type MutationDeleteManyAnimatedCountersArgs = {
  where?: InputMaybe<AnimatedCounterManyWhereInput>
}

export type MutationDeleteManyAnimatedCountersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AnimatedCounterManyWhereInput>
}

export type MutationDeleteManyArticleCategoriesArgs = {
  where?: InputMaybe<ArticleCategoryManyWhereInput>
}

export type MutationDeleteManyArticleCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleCategoryManyWhereInput>
}

export type MutationDeleteManyArticlePageViewsArgs = {
  where?: InputMaybe<ArticlePageViewManyWhereInput>
}

export type MutationDeleteManyArticlePageViewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticlePageViewManyWhereInput>
}

export type MutationDeleteManyArticlesArgs = {
  where?: InputMaybe<ArticleManyWhereInput>
}

export type MutationDeleteManyArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleManyWhereInput>
}

export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>
}

export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AssetManyWhereInput>
}

export type MutationDeleteManyAuthorsArgs = {
  where?: InputMaybe<AuthorManyWhereInput>
}

export type MutationDeleteManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AuthorManyWhereInput>
}

export type MutationDeleteManyBoothsArgs = {
  where?: InputMaybe<BoothManyWhereInput>
}

export type MutationDeleteManyBoothsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BoothManyWhereInput>
}

export type MutationDeleteManyCareerPagesArgs = {
  where?: InputMaybe<CareerPageManyWhereInput>
}

export type MutationDeleteManyCareerPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<CareerPageManyWhereInput>
}

export type MutationDeleteManyContentReferencesArgs = {
  where?: InputMaybe<ContentReferenceManyWhereInput>
}

export type MutationDeleteManyContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ContentReferenceManyWhereInput>
}

export type MutationDeleteManyEducationReportsArgs = {
  where?: InputMaybe<EducationReportManyWhereInput>
}

export type MutationDeleteManyEducationReportsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EducationReportManyWhereInput>
}

export type MutationDeleteManyEducationSeminarsArgs = {
  where?: InputMaybe<EducationSeminarManyWhereInput>
}

export type MutationDeleteManyEducationSeminarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EducationSeminarManyWhereInput>
}

export type MutationDeleteManyEventAppPagesArgs = {
  where?: InputMaybe<EventAppPageManyWhereInput>
}

export type MutationDeleteManyEventAppPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventAppPageManyWhereInput>
}

export type MutationDeleteManyEventPagesArgs = {
  where?: InputMaybe<EventPageManyWhereInput>
}

export type MutationDeleteManyEventPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventPageManyWhereInput>
}

export type MutationDeleteManyEventStagesArgs = {
  where?: InputMaybe<EventStageManyWhereInput>
}

export type MutationDeleteManyEventStagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventStageManyWhereInput>
}

export type MutationDeleteManyEventsArgs = {
  where?: InputMaybe<EventManyWhereInput>
}

export type MutationDeleteManyEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventManyWhereInput>
}

export type MutationDeleteManyExhibitorListOrdersArgs = {
  where?: InputMaybe<ExhibitorListOrderManyWhereInput>
}

export type MutationDeleteManyExhibitorListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ExhibitorListOrderManyWhereInput>
}

export type MutationDeleteManyFaqQuestionsArgs = {
  where?: InputMaybe<FaqQuestionManyWhereInput>
}

export type MutationDeleteManyFaqQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FaqQuestionManyWhereInput>
}

export type MutationDeleteManyFootersArgs = {
  where?: InputMaybe<FooterManyWhereInput>
}

export type MutationDeleteManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FooterManyWhereInput>
}

export type MutationDeleteManyGlossariesArgs = {
  where?: InputMaybe<GlossaryManyWhereInput>
}

export type MutationDeleteManyGlossariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<GlossaryManyWhereInput>
}

export type MutationDeleteManyHeadersArgs = {
  where?: InputMaybe<HeaderManyWhereInput>
}

export type MutationDeleteManyHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HeaderManyWhereInput>
}

export type MutationDeleteManyHotelsArgs = {
  where?: InputMaybe<HotelManyWhereInput>
}

export type MutationDeleteManyHotelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HotelManyWhereInput>
}

export type MutationDeleteManyHtmlEmbedsArgs = {
  where?: InputMaybe<HtmlEmbedManyWhereInput>
}

export type MutationDeleteManyHtmlEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HtmlEmbedManyWhereInput>
}

export type MutationDeleteManyHubContentEntriesArgs = {
  where?: InputMaybe<HubContentEntryManyWhereInput>
}

export type MutationDeleteManyHubContentEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubContentEntryManyWhereInput>
}

export type MutationDeleteManyHubPageCountdownHeroesArgs = {
  where?: InputMaybe<HubPageCountdownHeroManyWhereInput>
}

export type MutationDeleteManyHubPageCountdownHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubPageCountdownHeroManyWhereInput>
}

export type MutationDeleteManyHubPagesArgs = {
  where?: InputMaybe<HubPageManyWhereInput>
}

export type MutationDeleteManyHubPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubPageManyWhereInput>
}

export type MutationDeleteManyImageGalleryEmbedsArgs = {
  where?: InputMaybe<ImageGalleryEmbedManyWhereInput>
}

export type MutationDeleteManyImageGalleryEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ImageGalleryEmbedManyWhereInput>
}

export type MutationDeleteManyInterestsArgs = {
  where?: InputMaybe<InterestManyWhereInput>
}

export type MutationDeleteManyInterestsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestManyWhereInput>
}

export type MutationDeleteManyJobListingsArgs = {
  where?: InputMaybe<JobListingManyWhereInput>
}

export type MutationDeleteManyJobListingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<JobListingManyWhereInput>
}

export type MutationDeleteManyJourneysArgs = {
  where?: InputMaybe<JourneyManyWhereInput>
}

export type MutationDeleteManyJourneysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<JourneyManyWhereInput>
}

export type MutationDeleteManyLandingPagesArgs = {
  where?: InputMaybe<LandingPageManyWhereInput>
}

export type MutationDeleteManyLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LandingPageManyWhereInput>
}

export type MutationDeleteManyManageContentConfigsArgs = {
  where?: InputMaybe<ManageContentConfigManyWhereInput>
}

export type MutationDeleteManyManageContentConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ManageContentConfigManyWhereInput>
}

export type MutationDeleteManyMapMarkerIconsArgs = {
  where?: InputMaybe<MapMarkerIconManyWhereInput>
}

export type MutationDeleteManyMapMarkerIconsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MapMarkerIconManyWhereInput>
}

export type MutationDeleteManyMapMarkersArgs = {
  where?: InputMaybe<MapMarkerManyWhereInput>
}

export type MutationDeleteManyMapMarkersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MapMarkerManyWhereInput>
}

export type MutationDeleteManyNewsletterAudiencesArgs = {
  where?: InputMaybe<NewsletterAudienceManyWhereInput>
}

export type MutationDeleteManyNewsletterAudiencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<NewsletterAudienceManyWhereInput>
}

export type MutationDeleteManyNotificationsArgs = {
  where?: InputMaybe<NotificationManyWhereInput>
}

export type MutationDeleteManyNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<NotificationManyWhereInput>
}

export type MutationDeleteManyOmrPartnersArgs = {
  where?: InputMaybe<OmrPartnerManyWhereInput>
}

export type MutationDeleteManyOmrPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<OmrPartnerManyWhereInput>
}

export type MutationDeleteManyPartnerCompaniesArgs = {
  where?: InputMaybe<PartnerCompanyManyWhereInput>
}

export type MutationDeleteManyPartnerCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PartnerCompanyManyWhereInput>
}

export type MutationDeleteManyPhysicalLocationsArgs = {
  where?: InputMaybe<PhysicalLocationManyWhereInput>
}

export type MutationDeleteManyPhysicalLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PhysicalLocationManyWhereInput>
}

export type MutationDeleteManyPodcastEpisodesArgs = {
  where?: InputMaybe<PodcastEpisodeManyWhereInput>
}

export type MutationDeleteManyPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastEpisodeManyWhereInput>
}

export type MutationDeleteManyPodcastGroupsArgs = {
  where?: InputMaybe<PodcastGroupManyWhereInput>
}

export type MutationDeleteManyPodcastGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastGroupManyWhereInput>
}

export type MutationDeleteManyPricingTiersArgs = {
  where?: InputMaybe<PricingTierManyWhereInput>
}

export type MutationDeleteManyPricingTiersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PricingTierManyWhereInput>
}

export type MutationDeleteManyRecommendationsFoodArgs = {
  where?: InputMaybe<RecommendationFoodManyWhereInput>
}

export type MutationDeleteManyRecommendationsFoodConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<RecommendationFoodManyWhereInput>
}

export type MutationDeleteManyRecommendationsNightOutArgs = {
  where?: InputMaybe<RecommendationNightOutManyWhereInput>
}

export type MutationDeleteManyRecommendationsNightOutConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<RecommendationNightOutManyWhereInput>
}

export type MutationDeleteManyReviewsAgenciesArgs = {
  where?: InputMaybe<ReviewsAgencyManyWhereInput>
}

export type MutationDeleteManyReviewsAgenciesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsAgencyManyWhereInput>
}

export type MutationDeleteManyReviewsFeatureRowsArgs = {
  where?: InputMaybe<ReviewsFeatureRowManyWhereInput>
}

export type MutationDeleteManyReviewsFeatureRowsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsFeatureRowManyWhereInput>
}

export type MutationDeleteManyReviewsFeaturesSectionsArgs = {
  where?: InputMaybe<ReviewsFeaturesSectionManyWhereInput>
}

export type MutationDeleteManyReviewsFeaturesSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsFeaturesSectionManyWhereInput>
}

export type MutationDeleteManyReviewsProductCategoriesArgs = {
  where?: InputMaybe<ReviewsProductCategoryManyWhereInput>
}

export type MutationDeleteManyReviewsProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductCategoryManyWhereInput>
}

export type MutationDeleteManyReviewsProductWidgetsArgs = {
  where?: InputMaybe<ReviewsProductWidgetManyWhereInput>
}

export type MutationDeleteManyReviewsProductWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductWidgetManyWhereInput>
}

export type MutationDeleteManyReviewsProductsArgs = {
  where?: InputMaybe<ReviewsProductManyWhereInput>
}

export type MutationDeleteManyReviewsProductsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductManyWhereInput>
}

export type MutationDeleteManySiteSectionsArgs = {
  where?: InputMaybe<SiteSectionManyWhereInput>
}

export type MutationDeleteManySiteSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SiteSectionManyWhereInput>
}

export type MutationDeleteManySocialEmbedsArgs = {
  where?: InputMaybe<SocialEmbedManyWhereInput>
}

export type MutationDeleteManySocialEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SocialEmbedManyWhereInput>
}

export type MutationDeleteManySpeakerListOrdersArgs = {
  where?: InputMaybe<SpeakerListOrderManyWhereInput>
}

export type MutationDeleteManySpeakerListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerListOrderManyWhereInput>
}

export type MutationDeleteManySpeakersArgs = {
  where?: InputMaybe<SpeakerManyWhereInput>
}

export type MutationDeleteManySpeakersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerManyWhereInput>
}

export type MutationDeleteManyTabContentsArgs = {
  where?: InputMaybe<TabContentManyWhereInput>
}

export type MutationDeleteManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TabContentManyWhereInput>
}

export type MutationDeleteManyTagsArgs = {
  where?: InputMaybe<TagManyWhereInput>
}

export type MutationDeleteManyTagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TagManyWhereInput>
}

export type MutationDeleteManyTicketsTableColumnsArgs = {
  where?: InputMaybe<TicketsTableColumnManyWhereInput>
}

export type MutationDeleteManyTicketsTableColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TicketsTableColumnManyWhereInput>
}

export type MutationDeleteManyTopicPageCategoriesArgs = {
  where?: InputMaybe<TopicPageCategoryManyWhereInput>
}

export type MutationDeleteManyTopicPageCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageCategoryManyWhereInput>
}

export type MutationDeleteManyTopicPagesArgs = {
  where?: InputMaybe<TopicPageManyWhereInput>
}

export type MutationDeleteManyTopicPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageManyWhereInput>
}

export type MutationDeleteManyVgWortsArgs = {
  where?: InputMaybe<VgWortManyWhereInput>
}

export type MutationDeleteManyVgWortsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<VgWortManyWhereInput>
}

export type MutationDeleteMapMarkerArgs = {
  where: MapMarkerWhereUniqueInput
}

export type MutationDeleteMapMarkerIconArgs = {
  where: MapMarkerIconWhereUniqueInput
}

export type MutationDeleteNewsletterAudienceArgs = {
  where: NewsletterAudienceWhereUniqueInput
}

export type MutationDeleteNotificationArgs = {
  where: NotificationWhereUniqueInput
}

export type MutationDeleteOmrPartnerArgs = {
  where: OmrPartnerWhereUniqueInput
}

export type MutationDeletePartnerCompanyArgs = {
  where: PartnerCompanyWhereUniqueInput
}

export type MutationDeletePhysicalLocationArgs = {
  where: PhysicalLocationWhereUniqueInput
}

export type MutationDeletePodcastEpisodeArgs = {
  where: PodcastEpisodeWhereUniqueInput
}

export type MutationDeletePodcastGroupArgs = {
  where: PodcastGroupWhereUniqueInput
}

export type MutationDeletePricingTierArgs = {
  where: PricingTierWhereUniqueInput
}

export type MutationDeleteRecommendationFoodArgs = {
  where: RecommendationFoodWhereUniqueInput
}

export type MutationDeleteRecommendationNightOutArgs = {
  where: RecommendationNightOutWhereUniqueInput
}

export type MutationDeleteReviewsAgencyArgs = {
  where: ReviewsAgencyWhereUniqueInput
}

export type MutationDeleteReviewsFeatureRowArgs = {
  where: ReviewsFeatureRowWhereUniqueInput
}

export type MutationDeleteReviewsFeaturesSectionArgs = {
  where: ReviewsFeaturesSectionWhereUniqueInput
}

export type MutationDeleteReviewsProductArgs = {
  where: ReviewsProductWhereUniqueInput
}

export type MutationDeleteReviewsProductCategoryArgs = {
  where: ReviewsProductCategoryWhereUniqueInput
}

export type MutationDeleteReviewsProductWidgetArgs = {
  where: ReviewsProductWidgetWhereUniqueInput
}

export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput
}

export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput
}

export type MutationDeleteSiteSectionArgs = {
  where: SiteSectionWhereUniqueInput
}

export type MutationDeleteSocialEmbedArgs = {
  where: SocialEmbedWhereUniqueInput
}

export type MutationDeleteSpeakerArgs = {
  where: SpeakerWhereUniqueInput
}

export type MutationDeleteSpeakerListOrderArgs = {
  where: SpeakerListOrderWhereUniqueInput
}

export type MutationDeleteTabContentArgs = {
  where: TabContentWhereUniqueInput
}

export type MutationDeleteTagArgs = {
  where: TagWhereUniqueInput
}

export type MutationDeleteTicketsTableColumnArgs = {
  where: TicketsTableColumnWhereUniqueInput
}

export type MutationDeleteTopicPageArgs = {
  where: TopicPageWhereUniqueInput
}

export type MutationDeleteTopicPageCategoryArgs = {
  where: TopicPageCategoryWhereUniqueInput
}

export type MutationDeleteVgWortArgs = {
  where: VgWortWhereUniqueInput
}

export type MutationPublishAnimatedCounterArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: AnimatedCounterWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishArticleArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ArticleWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishArticleCategoryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ArticleCategoryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishArticlePageViewArgs = {
  to?: Array<Stage>
  where: ArticlePageViewWhereUniqueInput
}

export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: AssetWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishAuthorArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: AuthorWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishBoothArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: BoothWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishCareerPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: CareerPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishContentReferenceArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ContentReferenceWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishEducationReportArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: EducationReportWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishEducationSeminarArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: EducationSeminarWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishEventArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: EventWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishEventAppPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: EventAppPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishEventPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: EventPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishEventStageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: EventStageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishExhibitorListOrderArgs = {
  to?: Array<Stage>
  where: ExhibitorListOrderWhereUniqueInput
}

export type MutationPublishFaqQuestionArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: FaqQuestionWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishFooterArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: FooterWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishGlossaryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: GlossaryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishHeaderArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: HeaderWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishHotelArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: HotelWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishHtmlEmbedArgs = {
  to?: Array<Stage>
  where: HtmlEmbedWhereUniqueInput
}

export type MutationPublishHubContentEntryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: HubContentEntryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishHubPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: HubPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishHubPageCountdownHeroArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: HubPageCountdownHeroWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishImageGalleryEmbedArgs = {
  to?: Array<Stage>
  where: ImageGalleryEmbedWhereUniqueInput
}

export type MutationPublishInterestArgs = {
  to?: Array<Stage>
  where: InterestWhereUniqueInput
}

export type MutationPublishJobListingArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: JobListingWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishJourneyArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: JourneyWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishLandingPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: LandingPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManageContentConfigArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ManageContentConfigWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyAnimatedCountersArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<AnimatedCounterManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyAnimatedCountersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<AnimatedCounterManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyArticleCategoriesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ArticleCategoryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyArticleCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ArticleCategoryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyArticlePageViewsArgs = {
  to?: Array<Stage>
  where?: InputMaybe<ArticlePageViewManyWhereInput>
}

export type MutationPublishManyArticlePageViewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ArticlePageViewManyWhereInput>
}

export type MutationPublishManyArticlesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ArticleManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ArticleManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<AssetManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<AssetManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyAuthorsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<AuthorManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<AuthorManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyBoothsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<BoothManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyBoothsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<BoothManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyCareerPagesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<CareerPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyCareerPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<CareerPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyContentReferencesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ContentReferenceManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ContentReferenceManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEducationReportsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EducationReportManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEducationReportsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EducationReportManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEducationSeminarsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EducationSeminarManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEducationSeminarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EducationSeminarManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEventAppPagesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EventAppPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEventAppPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EventAppPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEventPagesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EventPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEventPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EventPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEventStagesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EventStageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEventStagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EventStageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEventsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EventManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<EventManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyExhibitorListOrdersArgs = {
  to?: Array<Stage>
  where?: InputMaybe<ExhibitorListOrderManyWhereInput>
}

export type MutationPublishManyExhibitorListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ExhibitorListOrderManyWhereInput>
}

export type MutationPublishManyFaqQuestionsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<FaqQuestionManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyFaqQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<FaqQuestionManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyFootersArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<FooterManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<FooterManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyGlossariesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<GlossaryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyGlossariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<GlossaryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHeadersArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HeaderManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HeaderManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHotelsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HotelManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHotelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HotelManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHtmlEmbedsArgs = {
  to?: Array<Stage>
  where?: InputMaybe<HtmlEmbedManyWhereInput>
}

export type MutationPublishManyHtmlEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HtmlEmbedManyWhereInput>
}

export type MutationPublishManyHubContentEntriesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HubContentEntryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHubContentEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HubContentEntryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHubPageCountdownHeroesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HubPageCountdownHeroManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHubPageCountdownHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HubPageCountdownHeroManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHubPagesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HubPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyHubPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<HubPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyImageGalleryEmbedsArgs = {
  to?: Array<Stage>
  where?: InputMaybe<ImageGalleryEmbedManyWhereInput>
}

export type MutationPublishManyImageGalleryEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ImageGalleryEmbedManyWhereInput>
}

export type MutationPublishManyInterestsArgs = {
  to?: Array<Stage>
  where?: InputMaybe<InterestManyWhereInput>
}

export type MutationPublishManyInterestsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<InterestManyWhereInput>
}

export type MutationPublishManyJobListingsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<JobListingManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyJobListingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<JobListingManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyJourneysArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<JourneyManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyJourneysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<JourneyManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyLandingPagesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<LandingPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<LandingPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyManageContentConfigsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ManageContentConfigManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyManageContentConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ManageContentConfigManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyMapMarkerIconsArgs = {
  to?: Array<Stage>
  where?: InputMaybe<MapMarkerIconManyWhereInput>
}

export type MutationPublishManyMapMarkerIconsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<MapMarkerIconManyWhereInput>
}

export type MutationPublishManyMapMarkersArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<MapMarkerManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyMapMarkersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<MapMarkerManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyNewsletterAudiencesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<NewsletterAudienceManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyNewsletterAudiencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<NewsletterAudienceManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyNotificationsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<NotificationManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<NotificationManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyOmrPartnersArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<OmrPartnerManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyOmrPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<OmrPartnerManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyPartnerCompaniesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PartnerCompanyManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyPartnerCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PartnerCompanyManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyPhysicalLocationsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PhysicalLocationManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyPhysicalLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PhysicalLocationManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyPodcastEpisodesArgs = {
  to?: Array<Stage>
  where?: InputMaybe<PodcastEpisodeManyWhereInput>
}

export type MutationPublishManyPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PodcastEpisodeManyWhereInput>
}

export type MutationPublishManyPodcastGroupsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PodcastGroupManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyPodcastGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PodcastGroupManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyPricingTiersArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PricingTierManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyPricingTiersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<PricingTierManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyRecommendationsFoodArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<RecommendationFoodManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyRecommendationsFoodConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<RecommendationFoodManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyRecommendationsNightOutArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<RecommendationNightOutManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyRecommendationsNightOutConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<RecommendationNightOutManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsAgenciesArgs = {
  to?: Array<Stage>
  where?: InputMaybe<ReviewsAgencyManyWhereInput>
}

export type MutationPublishManyReviewsAgenciesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsAgencyManyWhereInput>
}

export type MutationPublishManyReviewsFeatureRowsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsFeatureRowManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsFeatureRowsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsFeatureRowManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsFeaturesSectionsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsFeaturesSectionManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsFeaturesSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsFeaturesSectionManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsProductCategoriesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsProductCategoryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsProductCategoryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsProductWidgetsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsProductWidgetManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsProductWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsProductWidgetManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsProductsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsProductManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyReviewsProductsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<ReviewsProductManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManySiteSectionsArgs = {
  to?: Array<Stage>
  where?: InputMaybe<SiteSectionManyWhereInput>
}

export type MutationPublishManySiteSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<SiteSectionManyWhereInput>
}

export type MutationPublishManySocialEmbedsArgs = {
  to?: Array<Stage>
  where?: InputMaybe<SocialEmbedManyWhereInput>
}

export type MutationPublishManySocialEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<SocialEmbedManyWhereInput>
}

export type MutationPublishManySpeakerListOrdersArgs = {
  to?: Array<Stage>
  where?: InputMaybe<SpeakerListOrderManyWhereInput>
}

export type MutationPublishManySpeakerListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<SpeakerListOrderManyWhereInput>
}

export type MutationPublishManySpeakersArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<SpeakerManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManySpeakersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<SpeakerManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTabContentsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TabContentManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TabContentManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTagsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TagManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TagManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTicketsTableColumnsArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TicketsTableColumnManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTicketsTableColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TicketsTableColumnManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTopicPageCategoriesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TopicPageCategoryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTopicPageCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TopicPageCategoryManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTopicPagesArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TopicPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyTopicPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<TopicPageManyWhereInput>
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishManyVgWortsArgs = {
  to?: Array<Stage>
  where?: InputMaybe<VgWortManyWhereInput>
}

export type MutationPublishManyVgWortsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  to?: Array<Stage>
  where?: InputMaybe<VgWortManyWhereInput>
}

export type MutationPublishMapMarkerArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: MapMarkerWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishMapMarkerIconArgs = {
  to?: Array<Stage>
  where: MapMarkerIconWhereUniqueInput
}

export type MutationPublishNewsletterAudienceArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: NewsletterAudienceWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishNotificationArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: NotificationWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishOmrPartnerArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: OmrPartnerWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishPartnerCompanyArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: PartnerCompanyWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishPhysicalLocationArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: PhysicalLocationWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishPodcastEpisodeArgs = {
  to?: Array<Stage>
  where: PodcastEpisodeWhereUniqueInput
}

export type MutationPublishPodcastGroupArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: PodcastGroupWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishPricingTierArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: PricingTierWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishRecommendationFoodArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: RecommendationFoodWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishRecommendationNightOutArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: RecommendationNightOutWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishReviewsAgencyArgs = {
  to?: Array<Stage>
  where: ReviewsAgencyWhereUniqueInput
}

export type MutationPublishReviewsFeatureRowArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ReviewsFeatureRowWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishReviewsFeaturesSectionArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ReviewsFeaturesSectionWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishReviewsProductArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ReviewsProductWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishReviewsProductCategoryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ReviewsProductCategoryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishReviewsProductWidgetArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: ReviewsProductWidgetWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishSiteSectionArgs = {
  to?: Array<Stage>
  where: SiteSectionWhereUniqueInput
}

export type MutationPublishSocialEmbedArgs = {
  to?: Array<Stage>
  where: SocialEmbedWhereUniqueInput
}

export type MutationPublishSpeakerArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: SpeakerWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishSpeakerListOrderArgs = {
  to?: Array<Stage>
  where: SpeakerListOrderWhereUniqueInput
}

export type MutationPublishTabContentArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: TabContentWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishTagArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: TagWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishTicketsTableColumnArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: TicketsTableColumnWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishTopicPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: TopicPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishTopicPageCategoryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  to?: Array<Stage>
  where: TopicPageCategoryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPublishVgWortArgs = {
  to?: Array<Stage>
  where: VgWortWhereUniqueInput
}

export type MutationSchedulePublishAnimatedCounterArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: AnimatedCounterWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishArticleArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ArticleWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishArticleCategoryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ArticleCategoryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishArticlePageViewArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ArticlePageViewWhereUniqueInput
}

export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: AssetWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishAuthorArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: AuthorWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishBoothArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: BoothWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishCareerPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: CareerPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishContentReferenceArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ContentReferenceWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishEducationReportArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: EducationReportWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishEducationSeminarArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: EducationSeminarWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishEventArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: EventWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishEventAppPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: EventAppPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishEventPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: EventPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishEventStageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: EventStageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishExhibitorListOrderArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ExhibitorListOrderWhereUniqueInput
}

export type MutationSchedulePublishFaqQuestionArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: FaqQuestionWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishFooterArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: FooterWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishGlossaryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: GlossaryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishHeaderArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: HeaderWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishHotelArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: HotelWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishHtmlEmbedArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: HtmlEmbedWhereUniqueInput
}

export type MutationSchedulePublishHubContentEntryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: HubContentEntryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishHubPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: HubPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishHubPageCountdownHeroArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: HubPageCountdownHeroWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishImageGalleryEmbedArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ImageGalleryEmbedWhereUniqueInput
}

export type MutationSchedulePublishInterestArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: InterestWhereUniqueInput
}

export type MutationSchedulePublishJobListingArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: JobListingWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishJourneyArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: JourneyWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishLandingPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: LandingPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishManageContentConfigArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ManageContentConfigWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishMapMarkerArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: MapMarkerWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishMapMarkerIconArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: MapMarkerIconWhereUniqueInput
}

export type MutationSchedulePublishNewsletterAudienceArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: NewsletterAudienceWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishNotificationArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: NotificationWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishOmrPartnerArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: OmrPartnerWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishPartnerCompanyArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: PartnerCompanyWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishPhysicalLocationArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: PhysicalLocationWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishPodcastEpisodeArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: PodcastEpisodeWhereUniqueInput
}

export type MutationSchedulePublishPodcastGroupArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: PodcastGroupWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishPricingTierArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: PricingTierWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishRecommendationFoodArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: RecommendationFoodWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishRecommendationNightOutArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: RecommendationNightOutWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishReviewsAgencyArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ReviewsAgencyWhereUniqueInput
}

export type MutationSchedulePublishReviewsFeatureRowArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ReviewsFeatureRowWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishReviewsFeaturesSectionArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ReviewsFeaturesSectionWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishReviewsProductArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ReviewsProductWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishReviewsProductCategoryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ReviewsProductCategoryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishReviewsProductWidgetArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: ReviewsProductWidgetWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishSiteSectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: SiteSectionWhereUniqueInput
}

export type MutationSchedulePublishSocialEmbedArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: SocialEmbedWhereUniqueInput
}

export type MutationSchedulePublishSpeakerArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: SpeakerWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishSpeakerListOrderArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: SpeakerListOrderWhereUniqueInput
}

export type MutationSchedulePublishTabContentArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: TabContentWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishTagArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: TagWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishTicketsTableColumnArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: TicketsTableColumnWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishTopicPageArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: TopicPageWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishTopicPageCategoryArgs = {
  locales?: InputMaybe<Array<Locale>>
  publishBase?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: TopicPageCategoryWhereUniqueInput
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSchedulePublishVgWortArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  to?: Array<Stage>
  where: VgWortWhereUniqueInput
}

export type MutationScheduleUnpublishAnimatedCounterArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: AnimatedCounterWhereUniqueInput
}

export type MutationScheduleUnpublishArticleArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ArticleWhereUniqueInput
}

export type MutationScheduleUnpublishArticleCategoryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ArticleCategoryWhereUniqueInput
}

export type MutationScheduleUnpublishArticlePageViewArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: ArticlePageViewWhereUniqueInput
}

export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: AssetWhereUniqueInput
}

export type MutationScheduleUnpublishAuthorArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: AuthorWhereUniqueInput
}

export type MutationScheduleUnpublishBoothArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: BoothWhereUniqueInput
}

export type MutationScheduleUnpublishCareerPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: CareerPageWhereUniqueInput
}

export type MutationScheduleUnpublishContentReferenceArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ContentReferenceWhereUniqueInput
}

export type MutationScheduleUnpublishEducationReportArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EducationReportWhereUniqueInput
}

export type MutationScheduleUnpublishEducationSeminarArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EducationSeminarWhereUniqueInput
}

export type MutationScheduleUnpublishEventArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EventWhereUniqueInput
}

export type MutationScheduleUnpublishEventAppPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EventAppPageWhereUniqueInput
}

export type MutationScheduleUnpublishEventPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EventPageWhereUniqueInput
}

export type MutationScheduleUnpublishEventStageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EventStageWhereUniqueInput
}

export type MutationScheduleUnpublishExhibitorListOrderArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: ExhibitorListOrderWhereUniqueInput
}

export type MutationScheduleUnpublishFaqQuestionArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: FaqQuestionWhereUniqueInput
}

export type MutationScheduleUnpublishFooterArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: FooterWhereUniqueInput
}

export type MutationScheduleUnpublishGlossaryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: GlossaryWhereUniqueInput
}

export type MutationScheduleUnpublishHeaderArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HeaderWhereUniqueInput
}

export type MutationScheduleUnpublishHotelArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HotelWhereUniqueInput
}

export type MutationScheduleUnpublishHtmlEmbedArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: HtmlEmbedWhereUniqueInput
}

export type MutationScheduleUnpublishHubContentEntryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HubContentEntryWhereUniqueInput
}

export type MutationScheduleUnpublishHubPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HubPageWhereUniqueInput
}

export type MutationScheduleUnpublishHubPageCountdownHeroArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HubPageCountdownHeroWhereUniqueInput
}

export type MutationScheduleUnpublishImageGalleryEmbedArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: ImageGalleryEmbedWhereUniqueInput
}

export type MutationScheduleUnpublishInterestArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: InterestWhereUniqueInput
}

export type MutationScheduleUnpublishJobListingArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: JobListingWhereUniqueInput
}

export type MutationScheduleUnpublishJourneyArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: JourneyWhereUniqueInput
}

export type MutationScheduleUnpublishLandingPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: LandingPageWhereUniqueInput
}

export type MutationScheduleUnpublishManageContentConfigArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ManageContentConfigWhereUniqueInput
}

export type MutationScheduleUnpublishMapMarkerArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: MapMarkerWhereUniqueInput
}

export type MutationScheduleUnpublishMapMarkerIconArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: MapMarkerIconWhereUniqueInput
}

export type MutationScheduleUnpublishNewsletterAudienceArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: NewsletterAudienceWhereUniqueInput
}

export type MutationScheduleUnpublishNotificationArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: NotificationWhereUniqueInput
}

export type MutationScheduleUnpublishOmrPartnerArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: OmrPartnerWhereUniqueInput
}

export type MutationScheduleUnpublishPartnerCompanyArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: PartnerCompanyWhereUniqueInput
}

export type MutationScheduleUnpublishPhysicalLocationArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: PhysicalLocationWhereUniqueInput
}

export type MutationScheduleUnpublishPodcastEpisodeArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: PodcastEpisodeWhereUniqueInput
}

export type MutationScheduleUnpublishPodcastGroupArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: PodcastGroupWhereUniqueInput
}

export type MutationScheduleUnpublishPricingTierArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: PricingTierWhereUniqueInput
}

export type MutationScheduleUnpublishRecommendationFoodArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: RecommendationFoodWhereUniqueInput
}

export type MutationScheduleUnpublishRecommendationNightOutArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: RecommendationNightOutWhereUniqueInput
}

export type MutationScheduleUnpublishReviewsAgencyArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: ReviewsAgencyWhereUniqueInput
}

export type MutationScheduleUnpublishReviewsFeatureRowArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsFeatureRowWhereUniqueInput
}

export type MutationScheduleUnpublishReviewsFeaturesSectionArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsFeaturesSectionWhereUniqueInput
}

export type MutationScheduleUnpublishReviewsProductArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsProductWhereUniqueInput
}

export type MutationScheduleUnpublishReviewsProductCategoryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsProductCategoryWhereUniqueInput
}

export type MutationScheduleUnpublishReviewsProductWidgetArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsProductWidgetWhereUniqueInput
}

export type MutationScheduleUnpublishSiteSectionArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: SiteSectionWhereUniqueInput
}

export type MutationScheduleUnpublishSocialEmbedArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: SocialEmbedWhereUniqueInput
}

export type MutationScheduleUnpublishSpeakerArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: SpeakerWhereUniqueInput
}

export type MutationScheduleUnpublishSpeakerListOrderArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: SpeakerListOrderWhereUniqueInput
}

export type MutationScheduleUnpublishTabContentArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TabContentWhereUniqueInput
}

export type MutationScheduleUnpublishTagArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TagWhereUniqueInput
}

export type MutationScheduleUnpublishTicketsTableColumnArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TicketsTableColumnWhereUniqueInput
}

export type MutationScheduleUnpublishTopicPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TopicPageWhereUniqueInput
}

export type MutationScheduleUnpublishTopicPageCategoryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TopicPageCategoryWhereUniqueInput
}

export type MutationScheduleUnpublishVgWortArgs = {
  from?: Array<Stage>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  releaseId?: InputMaybe<Scalars['String']['input']>
  where: VgWortWhereUniqueInput
}

export type MutationTransitionStepArticleArgs = {
  from?: InputMaybe<Workflow>
  to: Workflow
  where: ArticleWhereUniqueInput
}

export type MutationUnpublishAnimatedCounterArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: AnimatedCounterWhereUniqueInput
}

export type MutationUnpublishArticleArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ArticleWhereUniqueInput
}

export type MutationUnpublishArticleCategoryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ArticleCategoryWhereUniqueInput
}

export type MutationUnpublishArticlePageViewArgs = {
  from?: Array<Stage>
  where: ArticlePageViewWhereUniqueInput
}

export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: AssetWhereUniqueInput
}

export type MutationUnpublishAuthorArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: AuthorWhereUniqueInput
}

export type MutationUnpublishBoothArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: BoothWhereUniqueInput
}

export type MutationUnpublishCareerPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: CareerPageWhereUniqueInput
}

export type MutationUnpublishContentReferenceArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ContentReferenceWhereUniqueInput
}

export type MutationUnpublishEducationReportArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EducationReportWhereUniqueInput
}

export type MutationUnpublishEducationSeminarArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EducationSeminarWhereUniqueInput
}

export type MutationUnpublishEventArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EventWhereUniqueInput
}

export type MutationUnpublishEventAppPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EventAppPageWhereUniqueInput
}

export type MutationUnpublishEventPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EventPageWhereUniqueInput
}

export type MutationUnpublishEventStageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: EventStageWhereUniqueInput
}

export type MutationUnpublishExhibitorListOrderArgs = {
  from?: Array<Stage>
  where: ExhibitorListOrderWhereUniqueInput
}

export type MutationUnpublishFaqQuestionArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: FaqQuestionWhereUniqueInput
}

export type MutationUnpublishFooterArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: FooterWhereUniqueInput
}

export type MutationUnpublishGlossaryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: GlossaryWhereUniqueInput
}

export type MutationUnpublishHeaderArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HeaderWhereUniqueInput
}

export type MutationUnpublishHotelArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HotelWhereUniqueInput
}

export type MutationUnpublishHtmlEmbedArgs = {
  from?: Array<Stage>
  where: HtmlEmbedWhereUniqueInput
}

export type MutationUnpublishHubContentEntryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HubContentEntryWhereUniqueInput
}

export type MutationUnpublishHubPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HubPageWhereUniqueInput
}

export type MutationUnpublishHubPageCountdownHeroArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: HubPageCountdownHeroWhereUniqueInput
}

export type MutationUnpublishImageGalleryEmbedArgs = {
  from?: Array<Stage>
  where: ImageGalleryEmbedWhereUniqueInput
}

export type MutationUnpublishInterestArgs = {
  from?: Array<Stage>
  where: InterestWhereUniqueInput
}

export type MutationUnpublishJobListingArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: JobListingWhereUniqueInput
}

export type MutationUnpublishJourneyArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: JourneyWhereUniqueInput
}

export type MutationUnpublishLandingPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: LandingPageWhereUniqueInput
}

export type MutationUnpublishManageContentConfigArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ManageContentConfigWhereUniqueInput
}

export type MutationUnpublishManyAnimatedCountersArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<AnimatedCounterManyWhereInput>
}

export type MutationUnpublishManyAnimatedCountersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<AnimatedCounterManyWhereInput>
}

export type MutationUnpublishManyArticleCategoriesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ArticleCategoryManyWhereInput>
}

export type MutationUnpublishManyArticleCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ArticleCategoryManyWhereInput>
}

export type MutationUnpublishManyArticlePageViewsArgs = {
  from?: Array<Stage>
  where?: InputMaybe<ArticlePageViewManyWhereInput>
}

export type MutationUnpublishManyArticlePageViewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<ArticlePageViewManyWhereInput>
}

export type MutationUnpublishManyArticlesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ArticleManyWhereInput>
}

export type MutationUnpublishManyArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ArticleManyWhereInput>
}

export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<AssetManyWhereInput>
}

export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<AssetManyWhereInput>
}

export type MutationUnpublishManyAuthorsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<AuthorManyWhereInput>
}

export type MutationUnpublishManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<AuthorManyWhereInput>
}

export type MutationUnpublishManyBoothsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<BoothManyWhereInput>
}

export type MutationUnpublishManyBoothsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<BoothManyWhereInput>
}

export type MutationUnpublishManyCareerPagesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CareerPageManyWhereInput>
}

export type MutationUnpublishManyCareerPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CareerPageManyWhereInput>
}

export type MutationUnpublishManyContentReferencesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ContentReferenceManyWhereInput>
}

export type MutationUnpublishManyContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ContentReferenceManyWhereInput>
}

export type MutationUnpublishManyEducationReportsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EducationReportManyWhereInput>
}

export type MutationUnpublishManyEducationReportsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EducationReportManyWhereInput>
}

export type MutationUnpublishManyEducationSeminarsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EducationSeminarManyWhereInput>
}

export type MutationUnpublishManyEducationSeminarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EducationSeminarManyWhereInput>
}

export type MutationUnpublishManyEventAppPagesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EventAppPageManyWhereInput>
}

export type MutationUnpublishManyEventAppPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EventAppPageManyWhereInput>
}

export type MutationUnpublishManyEventPagesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EventPageManyWhereInput>
}

export type MutationUnpublishManyEventPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EventPageManyWhereInput>
}

export type MutationUnpublishManyEventStagesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EventStageManyWhereInput>
}

export type MutationUnpublishManyEventStagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EventStageManyWhereInput>
}

export type MutationUnpublishManyEventsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EventManyWhereInput>
}

export type MutationUnpublishManyEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<EventManyWhereInput>
}

export type MutationUnpublishManyExhibitorListOrdersArgs = {
  from?: Array<Stage>
  where?: InputMaybe<ExhibitorListOrderManyWhereInput>
}

export type MutationUnpublishManyExhibitorListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<ExhibitorListOrderManyWhereInput>
}

export type MutationUnpublishManyFaqQuestionsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<FaqQuestionManyWhereInput>
}

export type MutationUnpublishManyFaqQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<FaqQuestionManyWhereInput>
}

export type MutationUnpublishManyFootersArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<FooterManyWhereInput>
}

export type MutationUnpublishManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<FooterManyWhereInput>
}

export type MutationUnpublishManyGlossariesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<GlossaryManyWhereInput>
}

export type MutationUnpublishManyGlossariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<GlossaryManyWhereInput>
}

export type MutationUnpublishManyHeadersArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HeaderManyWhereInput>
}

export type MutationUnpublishManyHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HeaderManyWhereInput>
}

export type MutationUnpublishManyHotelsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HotelManyWhereInput>
}

export type MutationUnpublishManyHotelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HotelManyWhereInput>
}

export type MutationUnpublishManyHtmlEmbedsArgs = {
  from?: Array<Stage>
  where?: InputMaybe<HtmlEmbedManyWhereInput>
}

export type MutationUnpublishManyHtmlEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<HtmlEmbedManyWhereInput>
}

export type MutationUnpublishManyHubContentEntriesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HubContentEntryManyWhereInput>
}

export type MutationUnpublishManyHubContentEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HubContentEntryManyWhereInput>
}

export type MutationUnpublishManyHubPageCountdownHeroesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HubPageCountdownHeroManyWhereInput>
}

export type MutationUnpublishManyHubPageCountdownHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HubPageCountdownHeroManyWhereInput>
}

export type MutationUnpublishManyHubPagesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HubPageManyWhereInput>
}

export type MutationUnpublishManyHubPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<HubPageManyWhereInput>
}

export type MutationUnpublishManyImageGalleryEmbedsArgs = {
  from?: Array<Stage>
  where?: InputMaybe<ImageGalleryEmbedManyWhereInput>
}

export type MutationUnpublishManyImageGalleryEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<ImageGalleryEmbedManyWhereInput>
}

export type MutationUnpublishManyInterestsArgs = {
  from?: Array<Stage>
  where?: InputMaybe<InterestManyWhereInput>
}

export type MutationUnpublishManyInterestsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<InterestManyWhereInput>
}

export type MutationUnpublishManyJobListingsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<JobListingManyWhereInput>
}

export type MutationUnpublishManyJobListingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<JobListingManyWhereInput>
}

export type MutationUnpublishManyJourneysArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<JourneyManyWhereInput>
}

export type MutationUnpublishManyJourneysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<JourneyManyWhereInput>
}

export type MutationUnpublishManyLandingPagesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<LandingPageManyWhereInput>
}

export type MutationUnpublishManyLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<LandingPageManyWhereInput>
}

export type MutationUnpublishManyManageContentConfigsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ManageContentConfigManyWhereInput>
}

export type MutationUnpublishManyManageContentConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ManageContentConfigManyWhereInput>
}

export type MutationUnpublishManyMapMarkerIconsArgs = {
  from?: Array<Stage>
  where?: InputMaybe<MapMarkerIconManyWhereInput>
}

export type MutationUnpublishManyMapMarkerIconsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<MapMarkerIconManyWhereInput>
}

export type MutationUnpublishManyMapMarkersArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<MapMarkerManyWhereInput>
}

export type MutationUnpublishManyMapMarkersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<MapMarkerManyWhereInput>
}

export type MutationUnpublishManyNewsletterAudiencesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<NewsletterAudienceManyWhereInput>
}

export type MutationUnpublishManyNewsletterAudiencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<NewsletterAudienceManyWhereInput>
}

export type MutationUnpublishManyNotificationsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<NotificationManyWhereInput>
}

export type MutationUnpublishManyNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<NotificationManyWhereInput>
}

export type MutationUnpublishManyOmrPartnersArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<OmrPartnerManyWhereInput>
}

export type MutationUnpublishManyOmrPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<OmrPartnerManyWhereInput>
}

export type MutationUnpublishManyPartnerCompaniesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PartnerCompanyManyWhereInput>
}

export type MutationUnpublishManyPartnerCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PartnerCompanyManyWhereInput>
}

export type MutationUnpublishManyPhysicalLocationsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PhysicalLocationManyWhereInput>
}

export type MutationUnpublishManyPhysicalLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PhysicalLocationManyWhereInput>
}

export type MutationUnpublishManyPodcastEpisodesArgs = {
  from?: Array<Stage>
  where?: InputMaybe<PodcastEpisodeManyWhereInput>
}

export type MutationUnpublishManyPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<PodcastEpisodeManyWhereInput>
}

export type MutationUnpublishManyPodcastGroupsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PodcastGroupManyWhereInput>
}

export type MutationUnpublishManyPodcastGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PodcastGroupManyWhereInput>
}

export type MutationUnpublishManyPricingTiersArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PricingTierManyWhereInput>
}

export type MutationUnpublishManyPricingTiersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PricingTierManyWhereInput>
}

export type MutationUnpublishManyRecommendationsFoodArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<RecommendationFoodManyWhereInput>
}

export type MutationUnpublishManyRecommendationsFoodConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<RecommendationFoodManyWhereInput>
}

export type MutationUnpublishManyRecommendationsNightOutArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<RecommendationNightOutManyWhereInput>
}

export type MutationUnpublishManyRecommendationsNightOutConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<RecommendationNightOutManyWhereInput>
}

export type MutationUnpublishManyReviewsAgenciesArgs = {
  from?: Array<Stage>
  where?: InputMaybe<ReviewsAgencyManyWhereInput>
}

export type MutationUnpublishManyReviewsAgenciesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<ReviewsAgencyManyWhereInput>
}

export type MutationUnpublishManyReviewsFeatureRowsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsFeatureRowManyWhereInput>
}

export type MutationUnpublishManyReviewsFeatureRowsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsFeatureRowManyWhereInput>
}

export type MutationUnpublishManyReviewsFeaturesSectionsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsFeaturesSectionManyWhereInput>
}

export type MutationUnpublishManyReviewsFeaturesSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsFeaturesSectionManyWhereInput>
}

export type MutationUnpublishManyReviewsProductCategoriesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsProductCategoryManyWhereInput>
}

export type MutationUnpublishManyReviewsProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsProductCategoryManyWhereInput>
}

export type MutationUnpublishManyReviewsProductWidgetsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsProductWidgetManyWhereInput>
}

export type MutationUnpublishManyReviewsProductWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsProductWidgetManyWhereInput>
}

export type MutationUnpublishManyReviewsProductsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsProductManyWhereInput>
}

export type MutationUnpublishManyReviewsProductsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ReviewsProductManyWhereInput>
}

export type MutationUnpublishManySiteSectionsArgs = {
  from?: Array<Stage>
  where?: InputMaybe<SiteSectionManyWhereInput>
}

export type MutationUnpublishManySiteSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<SiteSectionManyWhereInput>
}

export type MutationUnpublishManySocialEmbedsArgs = {
  from?: Array<Stage>
  where?: InputMaybe<SocialEmbedManyWhereInput>
}

export type MutationUnpublishManySocialEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<SocialEmbedManyWhereInput>
}

export type MutationUnpublishManySpeakerListOrdersArgs = {
  from?: Array<Stage>
  where?: InputMaybe<SpeakerListOrderManyWhereInput>
}

export type MutationUnpublishManySpeakerListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<SpeakerListOrderManyWhereInput>
}

export type MutationUnpublishManySpeakersArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<SpeakerManyWhereInput>
}

export type MutationUnpublishManySpeakersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<SpeakerManyWhereInput>
}

export type MutationUnpublishManyTabContentsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TabContentManyWhereInput>
}

export type MutationUnpublishManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TabContentManyWhereInput>
}

export type MutationUnpublishManyTagsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TagManyWhereInput>
}

export type MutationUnpublishManyTagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TagManyWhereInput>
}

export type MutationUnpublishManyTicketsTableColumnsArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TicketsTableColumnManyWhereInput>
}

export type MutationUnpublishManyTicketsTableColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TicketsTableColumnManyWhereInput>
}

export type MutationUnpublishManyTopicPageCategoriesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TopicPageCategoryManyWhereInput>
}

export type MutationUnpublishManyTopicPageCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TopicPageCategoryManyWhereInput>
}

export type MutationUnpublishManyTopicPagesArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TopicPageManyWhereInput>
}

export type MutationUnpublishManyTopicPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<TopicPageManyWhereInput>
}

export type MutationUnpublishManyVgWortsArgs = {
  from?: Array<Stage>
  where?: InputMaybe<VgWortManyWhereInput>
}

export type MutationUnpublishManyVgWortsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  from?: Array<Stage>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: InputMaybe<Stage>
  where?: InputMaybe<VgWortManyWhereInput>
}

export type MutationUnpublishMapMarkerArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: MapMarkerWhereUniqueInput
}

export type MutationUnpublishMapMarkerIconArgs = {
  from?: Array<Stage>
  where: MapMarkerIconWhereUniqueInput
}

export type MutationUnpublishNewsletterAudienceArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: NewsletterAudienceWhereUniqueInput
}

export type MutationUnpublishNotificationArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: NotificationWhereUniqueInput
}

export type MutationUnpublishOmrPartnerArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: OmrPartnerWhereUniqueInput
}

export type MutationUnpublishPartnerCompanyArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: PartnerCompanyWhereUniqueInput
}

export type MutationUnpublishPhysicalLocationArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: PhysicalLocationWhereUniqueInput
}

export type MutationUnpublishPodcastEpisodeArgs = {
  from?: Array<Stage>
  where: PodcastEpisodeWhereUniqueInput
}

export type MutationUnpublishPodcastGroupArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: PodcastGroupWhereUniqueInput
}

export type MutationUnpublishPricingTierArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: PricingTierWhereUniqueInput
}

export type MutationUnpublishRecommendationFoodArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: RecommendationFoodWhereUniqueInput
}

export type MutationUnpublishRecommendationNightOutArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: RecommendationNightOutWhereUniqueInput
}

export type MutationUnpublishReviewsAgencyArgs = {
  from?: Array<Stage>
  where: ReviewsAgencyWhereUniqueInput
}

export type MutationUnpublishReviewsFeatureRowArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsFeatureRowWhereUniqueInput
}

export type MutationUnpublishReviewsFeaturesSectionArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsFeaturesSectionWhereUniqueInput
}

export type MutationUnpublishReviewsProductArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsProductWhereUniqueInput
}

export type MutationUnpublishReviewsProductCategoryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsProductCategoryWhereUniqueInput
}

export type MutationUnpublishReviewsProductWidgetArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: ReviewsProductWidgetWhereUniqueInput
}

export type MutationUnpublishSiteSectionArgs = {
  from?: Array<Stage>
  where: SiteSectionWhereUniqueInput
}

export type MutationUnpublishSocialEmbedArgs = {
  from?: Array<Stage>
  where: SocialEmbedWhereUniqueInput
}

export type MutationUnpublishSpeakerArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: SpeakerWhereUniqueInput
}

export type MutationUnpublishSpeakerListOrderArgs = {
  from?: Array<Stage>
  where: SpeakerListOrderWhereUniqueInput
}

export type MutationUnpublishTabContentArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TabContentWhereUniqueInput
}

export type MutationUnpublishTagArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TagWhereUniqueInput
}

export type MutationUnpublishTicketsTableColumnArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TicketsTableColumnWhereUniqueInput
}

export type MutationUnpublishTopicPageArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TopicPageWhereUniqueInput
}

export type MutationUnpublishTopicPageCategoryArgs = {
  from?: Array<Stage>
  locales?: InputMaybe<Array<Locale>>
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>
  where: TopicPageCategoryWhereUniqueInput
}

export type MutationUnpublishVgWortArgs = {
  from?: Array<Stage>
  where: VgWortWhereUniqueInput
}

export type MutationUpdateAnimatedCounterArgs = {
  data: AnimatedCounterUpdateInput
  where: AnimatedCounterWhereUniqueInput
}

export type MutationUpdateArticleArgs = {
  data: ArticleUpdateInput
  where: ArticleWhereUniqueInput
}

export type MutationUpdateArticleCategoryArgs = {
  data: ArticleCategoryUpdateInput
  where: ArticleCategoryWhereUniqueInput
}

export type MutationUpdateArticlePageViewArgs = {
  data: ArticlePageViewUpdateInput
  where: ArticlePageViewWhereUniqueInput
}

export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput
  where: AssetWhereUniqueInput
}

export type MutationUpdateAuthorArgs = {
  data: AuthorUpdateInput
  where: AuthorWhereUniqueInput
}

export type MutationUpdateBoothArgs = {
  data: BoothUpdateInput
  where: BoothWhereUniqueInput
}

export type MutationUpdateCareerPageArgs = {
  data: CareerPageUpdateInput
  where: CareerPageWhereUniqueInput
}

export type MutationUpdateContentReferenceArgs = {
  data: ContentReferenceUpdateInput
  where: ContentReferenceWhereUniqueInput
}

export type MutationUpdateEducationReportArgs = {
  data: EducationReportUpdateInput
  where: EducationReportWhereUniqueInput
}

export type MutationUpdateEducationSeminarArgs = {
  data: EducationSeminarUpdateInput
  where: EducationSeminarWhereUniqueInput
}

export type MutationUpdateEventArgs = {
  data: EventUpdateInput
  where: EventWhereUniqueInput
}

export type MutationUpdateEventAppPageArgs = {
  data: EventAppPageUpdateInput
  where: EventAppPageWhereUniqueInput
}

export type MutationUpdateEventPageArgs = {
  data: EventPageUpdateInput
  where: EventPageWhereUniqueInput
}

export type MutationUpdateEventStageArgs = {
  data: EventStageUpdateInput
  where: EventStageWhereUniqueInput
}

export type MutationUpdateExhibitorListOrderArgs = {
  data: ExhibitorListOrderUpdateInput
  where: ExhibitorListOrderWhereUniqueInput
}

export type MutationUpdateFaqQuestionArgs = {
  data: FaqQuestionUpdateInput
  where: FaqQuestionWhereUniqueInput
}

export type MutationUpdateFooterArgs = {
  data: FooterUpdateInput
  where: FooterWhereUniqueInput
}

export type MutationUpdateGlossaryArgs = {
  data: GlossaryUpdateInput
  where: GlossaryWhereUniqueInput
}

export type MutationUpdateHeaderArgs = {
  data: HeaderUpdateInput
  where: HeaderWhereUniqueInput
}

export type MutationUpdateHotelArgs = {
  data: HotelUpdateInput
  where: HotelWhereUniqueInput
}

export type MutationUpdateHtmlEmbedArgs = {
  data: HtmlEmbedUpdateInput
  where: HtmlEmbedWhereUniqueInput
}

export type MutationUpdateHubContentEntryArgs = {
  data: HubContentEntryUpdateInput
  where: HubContentEntryWhereUniqueInput
}

export type MutationUpdateHubPageArgs = {
  data: HubPageUpdateInput
  where: HubPageWhereUniqueInput
}

export type MutationUpdateHubPageCountdownHeroArgs = {
  data: HubPageCountdownHeroUpdateInput
  where: HubPageCountdownHeroWhereUniqueInput
}

export type MutationUpdateImageGalleryEmbedArgs = {
  data: ImageGalleryEmbedUpdateInput
  where: ImageGalleryEmbedWhereUniqueInput
}

export type MutationUpdateInterestArgs = {
  data: InterestUpdateInput
  where: InterestWhereUniqueInput
}

export type MutationUpdateJobListingArgs = {
  data: JobListingUpdateInput
  where: JobListingWhereUniqueInput
}

export type MutationUpdateJourneyArgs = {
  data: JourneyUpdateInput
  where: JourneyWhereUniqueInput
}

export type MutationUpdateLandingPageArgs = {
  data: LandingPageUpdateInput
  where: LandingPageWhereUniqueInput
}

export type MutationUpdateManageContentConfigArgs = {
  data: ManageContentConfigUpdateInput
  where: ManageContentConfigWhereUniqueInput
}

export type MutationUpdateManyAnimatedCountersArgs = {
  data: AnimatedCounterUpdateManyInput
  where?: InputMaybe<AnimatedCounterManyWhereInput>
}

export type MutationUpdateManyAnimatedCountersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: AnimatedCounterUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AnimatedCounterManyWhereInput>
}

export type MutationUpdateManyArticleCategoriesArgs = {
  data: ArticleCategoryUpdateManyInput
  where?: InputMaybe<ArticleCategoryManyWhereInput>
}

export type MutationUpdateManyArticleCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ArticleCategoryUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleCategoryManyWhereInput>
}

export type MutationUpdateManyArticlePageViewsArgs = {
  data: ArticlePageViewUpdateManyInput
  where?: InputMaybe<ArticlePageViewManyWhereInput>
}

export type MutationUpdateManyArticlePageViewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ArticlePageViewUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticlePageViewManyWhereInput>
}

export type MutationUpdateManyArticlesArgs = {
  data: ArticleUpdateManyInput
  where?: InputMaybe<ArticleManyWhereInput>
}

export type MutationUpdateManyArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ArticleUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleManyWhereInput>
}

export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput
  where?: InputMaybe<AssetManyWhereInput>
}

export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: AssetUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AssetManyWhereInput>
}

export type MutationUpdateManyAuthorsArgs = {
  data: AuthorUpdateManyInput
  where?: InputMaybe<AuthorManyWhereInput>
}

export type MutationUpdateManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: AuthorUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AuthorManyWhereInput>
}

export type MutationUpdateManyBoothsArgs = {
  data: BoothUpdateManyInput
  where?: InputMaybe<BoothManyWhereInput>
}

export type MutationUpdateManyBoothsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: BoothUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BoothManyWhereInput>
}

export type MutationUpdateManyCareerPagesArgs = {
  data: CareerPageUpdateManyInput
  where?: InputMaybe<CareerPageManyWhereInput>
}

export type MutationUpdateManyCareerPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: CareerPageUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<CareerPageManyWhereInput>
}

export type MutationUpdateManyContentReferencesArgs = {
  data: ContentReferenceUpdateManyInput
  where?: InputMaybe<ContentReferenceManyWhereInput>
}

export type MutationUpdateManyContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ContentReferenceUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ContentReferenceManyWhereInput>
}

export type MutationUpdateManyEducationReportsArgs = {
  data: EducationReportUpdateManyInput
  where?: InputMaybe<EducationReportManyWhereInput>
}

export type MutationUpdateManyEducationReportsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: EducationReportUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EducationReportManyWhereInput>
}

export type MutationUpdateManyEducationSeminarsArgs = {
  data: EducationSeminarUpdateManyInput
  where?: InputMaybe<EducationSeminarManyWhereInput>
}

export type MutationUpdateManyEducationSeminarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: EducationSeminarUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EducationSeminarManyWhereInput>
}

export type MutationUpdateManyEventAppPagesArgs = {
  data: EventAppPageUpdateManyInput
  where?: InputMaybe<EventAppPageManyWhereInput>
}

export type MutationUpdateManyEventAppPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: EventAppPageUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventAppPageManyWhereInput>
}

export type MutationUpdateManyEventPagesArgs = {
  data: EventPageUpdateManyInput
  where?: InputMaybe<EventPageManyWhereInput>
}

export type MutationUpdateManyEventPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: EventPageUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventPageManyWhereInput>
}

export type MutationUpdateManyEventStagesArgs = {
  data: EventStageUpdateManyInput
  where?: InputMaybe<EventStageManyWhereInput>
}

export type MutationUpdateManyEventStagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: EventStageUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventStageManyWhereInput>
}

export type MutationUpdateManyEventsArgs = {
  data: EventUpdateManyInput
  where?: InputMaybe<EventManyWhereInput>
}

export type MutationUpdateManyEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: EventUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventManyWhereInput>
}

export type MutationUpdateManyExhibitorListOrdersArgs = {
  data: ExhibitorListOrderUpdateManyInput
  where?: InputMaybe<ExhibitorListOrderManyWhereInput>
}

export type MutationUpdateManyExhibitorListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ExhibitorListOrderUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ExhibitorListOrderManyWhereInput>
}

export type MutationUpdateManyFaqQuestionsArgs = {
  data: FaqQuestionUpdateManyInput
  where?: InputMaybe<FaqQuestionManyWhereInput>
}

export type MutationUpdateManyFaqQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: FaqQuestionUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FaqQuestionManyWhereInput>
}

export type MutationUpdateManyFootersArgs = {
  data: FooterUpdateManyInput
  where?: InputMaybe<FooterManyWhereInput>
}

export type MutationUpdateManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: FooterUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FooterManyWhereInput>
}

export type MutationUpdateManyGlossariesArgs = {
  data: GlossaryUpdateManyInput
  where?: InputMaybe<GlossaryManyWhereInput>
}

export type MutationUpdateManyGlossariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: GlossaryUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<GlossaryManyWhereInput>
}

export type MutationUpdateManyHeadersArgs = {
  data: HeaderUpdateManyInput
  where?: InputMaybe<HeaderManyWhereInput>
}

export type MutationUpdateManyHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: HeaderUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HeaderManyWhereInput>
}

export type MutationUpdateManyHotelsArgs = {
  data: HotelUpdateManyInput
  where?: InputMaybe<HotelManyWhereInput>
}

export type MutationUpdateManyHotelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: HotelUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HotelManyWhereInput>
}

export type MutationUpdateManyHtmlEmbedsArgs = {
  data: HtmlEmbedUpdateManyInput
  where?: InputMaybe<HtmlEmbedManyWhereInput>
}

export type MutationUpdateManyHtmlEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: HtmlEmbedUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HtmlEmbedManyWhereInput>
}

export type MutationUpdateManyHubContentEntriesArgs = {
  data: HubContentEntryUpdateManyInput
  where?: InputMaybe<HubContentEntryManyWhereInput>
}

export type MutationUpdateManyHubContentEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: HubContentEntryUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubContentEntryManyWhereInput>
}

export type MutationUpdateManyHubPageCountdownHeroesArgs = {
  data: HubPageCountdownHeroUpdateManyInput
  where?: InputMaybe<HubPageCountdownHeroManyWhereInput>
}

export type MutationUpdateManyHubPageCountdownHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: HubPageCountdownHeroUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubPageCountdownHeroManyWhereInput>
}

export type MutationUpdateManyHubPagesArgs = {
  data: HubPageUpdateManyInput
  where?: InputMaybe<HubPageManyWhereInput>
}

export type MutationUpdateManyHubPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: HubPageUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HubPageManyWhereInput>
}

export type MutationUpdateManyImageGalleryEmbedsArgs = {
  data: ImageGalleryEmbedUpdateManyInput
  where?: InputMaybe<ImageGalleryEmbedManyWhereInput>
}

export type MutationUpdateManyImageGalleryEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ImageGalleryEmbedUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ImageGalleryEmbedManyWhereInput>
}

export type MutationUpdateManyInterestsArgs = {
  data: InterestUpdateManyInput
  where?: InputMaybe<InterestManyWhereInput>
}

export type MutationUpdateManyInterestsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: InterestUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestManyWhereInput>
}

export type MutationUpdateManyJobListingsArgs = {
  data: JobListingUpdateManyInput
  where?: InputMaybe<JobListingManyWhereInput>
}

export type MutationUpdateManyJobListingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: JobListingUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<JobListingManyWhereInput>
}

export type MutationUpdateManyJourneysArgs = {
  data: JourneyUpdateManyInput
  where?: InputMaybe<JourneyManyWhereInput>
}

export type MutationUpdateManyJourneysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: JourneyUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<JourneyManyWhereInput>
}

export type MutationUpdateManyLandingPagesArgs = {
  data: LandingPageUpdateManyInput
  where?: InputMaybe<LandingPageManyWhereInput>
}

export type MutationUpdateManyLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: LandingPageUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LandingPageManyWhereInput>
}

export type MutationUpdateManyManageContentConfigsArgs = {
  data: ManageContentConfigUpdateManyInput
  where?: InputMaybe<ManageContentConfigManyWhereInput>
}

export type MutationUpdateManyManageContentConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ManageContentConfigUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ManageContentConfigManyWhereInput>
}

export type MutationUpdateManyMapMarkerIconsArgs = {
  data: MapMarkerIconUpdateManyInput
  where?: InputMaybe<MapMarkerIconManyWhereInput>
}

export type MutationUpdateManyMapMarkerIconsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: MapMarkerIconUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MapMarkerIconManyWhereInput>
}

export type MutationUpdateManyMapMarkersArgs = {
  data: MapMarkerUpdateManyInput
  where?: InputMaybe<MapMarkerManyWhereInput>
}

export type MutationUpdateManyMapMarkersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: MapMarkerUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MapMarkerManyWhereInput>
}

export type MutationUpdateManyNewsletterAudiencesArgs = {
  data: NewsletterAudienceUpdateManyInput
  where?: InputMaybe<NewsletterAudienceManyWhereInput>
}

export type MutationUpdateManyNewsletterAudiencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: NewsletterAudienceUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<NewsletterAudienceManyWhereInput>
}

export type MutationUpdateManyNotificationsArgs = {
  data: NotificationUpdateManyInput
  where?: InputMaybe<NotificationManyWhereInput>
}

export type MutationUpdateManyNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: NotificationUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<NotificationManyWhereInput>
}

export type MutationUpdateManyOmrPartnersArgs = {
  data: OmrPartnerUpdateManyInput
  where?: InputMaybe<OmrPartnerManyWhereInput>
}

export type MutationUpdateManyOmrPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: OmrPartnerUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<OmrPartnerManyWhereInput>
}

export type MutationUpdateManyPartnerCompaniesArgs = {
  data: PartnerCompanyUpdateManyInput
  where?: InputMaybe<PartnerCompanyManyWhereInput>
}

export type MutationUpdateManyPartnerCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: PartnerCompanyUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PartnerCompanyManyWhereInput>
}

export type MutationUpdateManyPhysicalLocationsArgs = {
  data: PhysicalLocationUpdateManyInput
  where?: InputMaybe<PhysicalLocationManyWhereInput>
}

export type MutationUpdateManyPhysicalLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: PhysicalLocationUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PhysicalLocationManyWhereInput>
}

export type MutationUpdateManyPodcastEpisodesArgs = {
  data: PodcastEpisodeUpdateManyInput
  where?: InputMaybe<PodcastEpisodeManyWhereInput>
}

export type MutationUpdateManyPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: PodcastEpisodeUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastEpisodeManyWhereInput>
}

export type MutationUpdateManyPodcastGroupsArgs = {
  data: PodcastGroupUpdateManyInput
  where?: InputMaybe<PodcastGroupManyWhereInput>
}

export type MutationUpdateManyPodcastGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: PodcastGroupUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PodcastGroupManyWhereInput>
}

export type MutationUpdateManyPricingTiersArgs = {
  data: PricingTierUpdateManyInput
  where?: InputMaybe<PricingTierManyWhereInput>
}

export type MutationUpdateManyPricingTiersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: PricingTierUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PricingTierManyWhereInput>
}

export type MutationUpdateManyRecommendationsFoodArgs = {
  data: RecommendationFoodUpdateManyInput
  where?: InputMaybe<RecommendationFoodManyWhereInput>
}

export type MutationUpdateManyRecommendationsFoodConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: RecommendationFoodUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<RecommendationFoodManyWhereInput>
}

export type MutationUpdateManyRecommendationsNightOutArgs = {
  data: RecommendationNightOutUpdateManyInput
  where?: InputMaybe<RecommendationNightOutManyWhereInput>
}

export type MutationUpdateManyRecommendationsNightOutConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: RecommendationNightOutUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<RecommendationNightOutManyWhereInput>
}

export type MutationUpdateManyReviewsAgenciesArgs = {
  data: ReviewsAgencyUpdateManyInput
  where?: InputMaybe<ReviewsAgencyManyWhereInput>
}

export type MutationUpdateManyReviewsAgenciesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ReviewsAgencyUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsAgencyManyWhereInput>
}

export type MutationUpdateManyReviewsFeatureRowsArgs = {
  data: ReviewsFeatureRowUpdateManyInput
  where?: InputMaybe<ReviewsFeatureRowManyWhereInput>
}

export type MutationUpdateManyReviewsFeatureRowsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ReviewsFeatureRowUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsFeatureRowManyWhereInput>
}

export type MutationUpdateManyReviewsFeaturesSectionsArgs = {
  data: ReviewsFeaturesSectionUpdateManyInput
  where?: InputMaybe<ReviewsFeaturesSectionManyWhereInput>
}

export type MutationUpdateManyReviewsFeaturesSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ReviewsFeaturesSectionUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsFeaturesSectionManyWhereInput>
}

export type MutationUpdateManyReviewsProductCategoriesArgs = {
  data: ReviewsProductCategoryUpdateManyInput
  where?: InputMaybe<ReviewsProductCategoryManyWhereInput>
}

export type MutationUpdateManyReviewsProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ReviewsProductCategoryUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductCategoryManyWhereInput>
}

export type MutationUpdateManyReviewsProductWidgetsArgs = {
  data: ReviewsProductWidgetUpdateManyInput
  where?: InputMaybe<ReviewsProductWidgetManyWhereInput>
}

export type MutationUpdateManyReviewsProductWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ReviewsProductWidgetUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductWidgetManyWhereInput>
}

export type MutationUpdateManyReviewsProductsArgs = {
  data: ReviewsProductUpdateManyInput
  where?: InputMaybe<ReviewsProductManyWhereInput>
}

export type MutationUpdateManyReviewsProductsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: ReviewsProductUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductManyWhereInput>
}

export type MutationUpdateManySiteSectionsArgs = {
  data: SiteSectionUpdateManyInput
  where?: InputMaybe<SiteSectionManyWhereInput>
}

export type MutationUpdateManySiteSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: SiteSectionUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SiteSectionManyWhereInput>
}

export type MutationUpdateManySocialEmbedsArgs = {
  data: SocialEmbedUpdateManyInput
  where?: InputMaybe<SocialEmbedManyWhereInput>
}

export type MutationUpdateManySocialEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: SocialEmbedUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SocialEmbedManyWhereInput>
}

export type MutationUpdateManySpeakerListOrdersArgs = {
  data: SpeakerListOrderUpdateManyInput
  where?: InputMaybe<SpeakerListOrderManyWhereInput>
}

export type MutationUpdateManySpeakerListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: SpeakerListOrderUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerListOrderManyWhereInput>
}

export type MutationUpdateManySpeakersArgs = {
  data: SpeakerUpdateManyInput
  where?: InputMaybe<SpeakerManyWhereInput>
}

export type MutationUpdateManySpeakersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: SpeakerUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerManyWhereInput>
}

export type MutationUpdateManyTabContentsArgs = {
  data: TabContentUpdateManyInput
  where?: InputMaybe<TabContentManyWhereInput>
}

export type MutationUpdateManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: TabContentUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TabContentManyWhereInput>
}

export type MutationUpdateManyTagsArgs = {
  data: TagUpdateManyInput
  where?: InputMaybe<TagManyWhereInput>
}

export type MutationUpdateManyTagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: TagUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TagManyWhereInput>
}

export type MutationUpdateManyTicketsTableColumnsArgs = {
  data: TicketsTableColumnUpdateManyInput
  where?: InputMaybe<TicketsTableColumnManyWhereInput>
}

export type MutationUpdateManyTicketsTableColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: TicketsTableColumnUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TicketsTableColumnManyWhereInput>
}

export type MutationUpdateManyTopicPageCategoriesArgs = {
  data: TopicPageCategoryUpdateManyInput
  where?: InputMaybe<TopicPageCategoryManyWhereInput>
}

export type MutationUpdateManyTopicPageCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: TopicPageCategoryUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageCategoryManyWhereInput>
}

export type MutationUpdateManyTopicPagesArgs = {
  data: TopicPageUpdateManyInput
  where?: InputMaybe<TopicPageManyWhereInput>
}

export type MutationUpdateManyTopicPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: TopicPageUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageManyWhereInput>
}

export type MutationUpdateManyVgWortsArgs = {
  data: VgWortUpdateManyInput
  where?: InputMaybe<VgWortManyWhereInput>
}

export type MutationUpdateManyVgWortsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  before?: InputMaybe<Scalars['ID']['input']>
  data: VgWortUpdateManyInput
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<VgWortManyWhereInput>
}

export type MutationUpdateMapMarkerArgs = {
  data: MapMarkerUpdateInput
  where: MapMarkerWhereUniqueInput
}

export type MutationUpdateMapMarkerIconArgs = {
  data: MapMarkerIconUpdateInput
  where: MapMarkerIconWhereUniqueInput
}

export type MutationUpdateNewsletterAudienceArgs = {
  data: NewsletterAudienceUpdateInput
  where: NewsletterAudienceWhereUniqueInput
}

export type MutationUpdateNotificationArgs = {
  data: NotificationUpdateInput
  where: NotificationWhereUniqueInput
}

export type MutationUpdateOmrPartnerArgs = {
  data: OmrPartnerUpdateInput
  where: OmrPartnerWhereUniqueInput
}

export type MutationUpdatePartnerCompanyArgs = {
  data: PartnerCompanyUpdateInput
  where: PartnerCompanyWhereUniqueInput
}

export type MutationUpdatePhysicalLocationArgs = {
  data: PhysicalLocationUpdateInput
  where: PhysicalLocationWhereUniqueInput
}

export type MutationUpdatePodcastEpisodeArgs = {
  data: PodcastEpisodeUpdateInput
  where: PodcastEpisodeWhereUniqueInput
}

export type MutationUpdatePodcastGroupArgs = {
  data: PodcastGroupUpdateInput
  where: PodcastGroupWhereUniqueInput
}

export type MutationUpdatePricingTierArgs = {
  data: PricingTierUpdateInput
  where: PricingTierWhereUniqueInput
}

export type MutationUpdateRecommendationFoodArgs = {
  data: RecommendationFoodUpdateInput
  where: RecommendationFoodWhereUniqueInput
}

export type MutationUpdateRecommendationNightOutArgs = {
  data: RecommendationNightOutUpdateInput
  where: RecommendationNightOutWhereUniqueInput
}

export type MutationUpdateReviewsAgencyArgs = {
  data: ReviewsAgencyUpdateInput
  where: ReviewsAgencyWhereUniqueInput
}

export type MutationUpdateReviewsFeatureRowArgs = {
  data: ReviewsFeatureRowUpdateInput
  where: ReviewsFeatureRowWhereUniqueInput
}

export type MutationUpdateReviewsFeaturesSectionArgs = {
  data: ReviewsFeaturesSectionUpdateInput
  where: ReviewsFeaturesSectionWhereUniqueInput
}

export type MutationUpdateReviewsProductArgs = {
  data: ReviewsProductUpdateInput
  where: ReviewsProductWhereUniqueInput
}

export type MutationUpdateReviewsProductCategoryArgs = {
  data: ReviewsProductCategoryUpdateInput
  where: ReviewsProductCategoryWhereUniqueInput
}

export type MutationUpdateReviewsProductWidgetArgs = {
  data: ReviewsProductWidgetUpdateInput
  where: ReviewsProductWidgetWhereUniqueInput
}

export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput
  where: ScheduledReleaseWhereUniqueInput
}

export type MutationUpdateSiteSectionArgs = {
  data: SiteSectionUpdateInput
  where: SiteSectionWhereUniqueInput
}

export type MutationUpdateSocialEmbedArgs = {
  data: SocialEmbedUpdateInput
  where: SocialEmbedWhereUniqueInput
}

export type MutationUpdateSpeakerArgs = {
  data: SpeakerUpdateInput
  where: SpeakerWhereUniqueInput
}

export type MutationUpdateSpeakerListOrderArgs = {
  data: SpeakerListOrderUpdateInput
  where: SpeakerListOrderWhereUniqueInput
}

export type MutationUpdateTabContentArgs = {
  data: TabContentUpdateInput
  where: TabContentWhereUniqueInput
}

export type MutationUpdateTagArgs = {
  data: TagUpdateInput
  where: TagWhereUniqueInput
}

export type MutationUpdateTicketsTableColumnArgs = {
  data: TicketsTableColumnUpdateInput
  where: TicketsTableColumnWhereUniqueInput
}

export type MutationUpdateTopicPageArgs = {
  data: TopicPageUpdateInput
  where: TopicPageWhereUniqueInput
}

export type MutationUpdateTopicPageCategoryArgs = {
  data: TopicPageCategoryUpdateInput
  where: TopicPageCategoryWhereUniqueInput
}

export type MutationUpdateVgWortArgs = {
  data: VgWortUpdateInput
  where: VgWortWhereUniqueInput
}

export type MutationUpsertAnimatedCounterArgs = {
  upsert: AnimatedCounterUpsertInput
  where: AnimatedCounterWhereUniqueInput
}

export type MutationUpsertArticleArgs = {
  upsert: ArticleUpsertInput
  where: ArticleWhereUniqueInput
}

export type MutationUpsertArticleCategoryArgs = {
  upsert: ArticleCategoryUpsertInput
  where: ArticleCategoryWhereUniqueInput
}

export type MutationUpsertArticlePageViewArgs = {
  upsert: ArticlePageViewUpsertInput
  where: ArticlePageViewWhereUniqueInput
}

export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput
  where: AssetWhereUniqueInput
}

export type MutationUpsertAuthorArgs = {
  upsert: AuthorUpsertInput
  where: AuthorWhereUniqueInput
}

export type MutationUpsertBoothArgs = {
  upsert: BoothUpsertInput
  where: BoothWhereUniqueInput
}

export type MutationUpsertCareerPageArgs = {
  upsert: CareerPageUpsertInput
  where: CareerPageWhereUniqueInput
}

export type MutationUpsertContentReferenceArgs = {
  upsert: ContentReferenceUpsertInput
  where: ContentReferenceWhereUniqueInput
}

export type MutationUpsertEducationReportArgs = {
  upsert: EducationReportUpsertInput
  where: EducationReportWhereUniqueInput
}

export type MutationUpsertEducationSeminarArgs = {
  upsert: EducationSeminarUpsertInput
  where: EducationSeminarWhereUniqueInput
}

export type MutationUpsertEventArgs = {
  upsert: EventUpsertInput
  where: EventWhereUniqueInput
}

export type MutationUpsertEventAppPageArgs = {
  upsert: EventAppPageUpsertInput
  where: EventAppPageWhereUniqueInput
}

export type MutationUpsertEventPageArgs = {
  upsert: EventPageUpsertInput
  where: EventPageWhereUniqueInput
}

export type MutationUpsertEventStageArgs = {
  upsert: EventStageUpsertInput
  where: EventStageWhereUniqueInput
}

export type MutationUpsertExhibitorListOrderArgs = {
  upsert: ExhibitorListOrderUpsertInput
  where: ExhibitorListOrderWhereUniqueInput
}

export type MutationUpsertFaqQuestionArgs = {
  upsert: FaqQuestionUpsertInput
  where: FaqQuestionWhereUniqueInput
}

export type MutationUpsertFooterArgs = {
  upsert: FooterUpsertInput
  where: FooterWhereUniqueInput
}

export type MutationUpsertGlossaryArgs = {
  upsert: GlossaryUpsertInput
  where: GlossaryWhereUniqueInput
}

export type MutationUpsertHeaderArgs = {
  upsert: HeaderUpsertInput
  where: HeaderWhereUniqueInput
}

export type MutationUpsertHotelArgs = {
  upsert: HotelUpsertInput
  where: HotelWhereUniqueInput
}

export type MutationUpsertHtmlEmbedArgs = {
  upsert: HtmlEmbedUpsertInput
  where: HtmlEmbedWhereUniqueInput
}

export type MutationUpsertHubContentEntryArgs = {
  upsert: HubContentEntryUpsertInput
  where: HubContentEntryWhereUniqueInput
}

export type MutationUpsertHubPageArgs = {
  upsert: HubPageUpsertInput
  where: HubPageWhereUniqueInput
}

export type MutationUpsertHubPageCountdownHeroArgs = {
  upsert: HubPageCountdownHeroUpsertInput
  where: HubPageCountdownHeroWhereUniqueInput
}

export type MutationUpsertImageGalleryEmbedArgs = {
  upsert: ImageGalleryEmbedUpsertInput
  where: ImageGalleryEmbedWhereUniqueInput
}

export type MutationUpsertInterestArgs = {
  upsert: InterestUpsertInput
  where: InterestWhereUniqueInput
}

export type MutationUpsertJobListingArgs = {
  upsert: JobListingUpsertInput
  where: JobListingWhereUniqueInput
}

export type MutationUpsertJourneyArgs = {
  upsert: JourneyUpsertInput
  where: JourneyWhereUniqueInput
}

export type MutationUpsertLandingPageArgs = {
  upsert: LandingPageUpsertInput
  where: LandingPageWhereUniqueInput
}

export type MutationUpsertManageContentConfigArgs = {
  upsert: ManageContentConfigUpsertInput
  where: ManageContentConfigWhereUniqueInput
}

export type MutationUpsertMapMarkerArgs = {
  upsert: MapMarkerUpsertInput
  where: MapMarkerWhereUniqueInput
}

export type MutationUpsertMapMarkerIconArgs = {
  upsert: MapMarkerIconUpsertInput
  where: MapMarkerIconWhereUniqueInput
}

export type MutationUpsertNewsletterAudienceArgs = {
  upsert: NewsletterAudienceUpsertInput
  where: NewsletterAudienceWhereUniqueInput
}

export type MutationUpsertNotificationArgs = {
  upsert: NotificationUpsertInput
  where: NotificationWhereUniqueInput
}

export type MutationUpsertOmrPartnerArgs = {
  upsert: OmrPartnerUpsertInput
  where: OmrPartnerWhereUniqueInput
}

export type MutationUpsertPartnerCompanyArgs = {
  upsert: PartnerCompanyUpsertInput
  where: PartnerCompanyWhereUniqueInput
}

export type MutationUpsertPhysicalLocationArgs = {
  upsert: PhysicalLocationUpsertInput
  where: PhysicalLocationWhereUniqueInput
}

export type MutationUpsertPodcastEpisodeArgs = {
  upsert: PodcastEpisodeUpsertInput
  where: PodcastEpisodeWhereUniqueInput
}

export type MutationUpsertPodcastGroupArgs = {
  upsert: PodcastGroupUpsertInput
  where: PodcastGroupWhereUniqueInput
}

export type MutationUpsertPricingTierArgs = {
  upsert: PricingTierUpsertInput
  where: PricingTierWhereUniqueInput
}

export type MutationUpsertRecommendationFoodArgs = {
  upsert: RecommendationFoodUpsertInput
  where: RecommendationFoodWhereUniqueInput
}

export type MutationUpsertRecommendationNightOutArgs = {
  upsert: RecommendationNightOutUpsertInput
  where: RecommendationNightOutWhereUniqueInput
}

export type MutationUpsertReviewsAgencyArgs = {
  upsert: ReviewsAgencyUpsertInput
  where: ReviewsAgencyWhereUniqueInput
}

export type MutationUpsertReviewsFeatureRowArgs = {
  upsert: ReviewsFeatureRowUpsertInput
  where: ReviewsFeatureRowWhereUniqueInput
}

export type MutationUpsertReviewsFeaturesSectionArgs = {
  upsert: ReviewsFeaturesSectionUpsertInput
  where: ReviewsFeaturesSectionWhereUniqueInput
}

export type MutationUpsertReviewsProductArgs = {
  upsert: ReviewsProductUpsertInput
  where: ReviewsProductWhereUniqueInput
}

export type MutationUpsertReviewsProductCategoryArgs = {
  upsert: ReviewsProductCategoryUpsertInput
  where: ReviewsProductCategoryWhereUniqueInput
}

export type MutationUpsertReviewsProductWidgetArgs = {
  upsert: ReviewsProductWidgetUpsertInput
  where: ReviewsProductWidgetWhereUniqueInput
}

export type MutationUpsertSiteSectionArgs = {
  upsert: SiteSectionUpsertInput
  where: SiteSectionWhereUniqueInput
}

export type MutationUpsertSocialEmbedArgs = {
  upsert: SocialEmbedUpsertInput
  where: SocialEmbedWhereUniqueInput
}

export type MutationUpsertSpeakerArgs = {
  upsert: SpeakerUpsertInput
  where: SpeakerWhereUniqueInput
}

export type MutationUpsertSpeakerListOrderArgs = {
  upsert: SpeakerListOrderUpsertInput
  where: SpeakerListOrderWhereUniqueInput
}

export type MutationUpsertTabContentArgs = {
  upsert: TabContentUpsertInput
  where: TabContentWhereUniqueInput
}

export type MutationUpsertTagArgs = {
  upsert: TagUpsertInput
  where: TagWhereUniqueInput
}

export type MutationUpsertTicketsTableColumnArgs = {
  upsert: TicketsTableColumnUpsertInput
  where: TicketsTableColumnWhereUniqueInput
}

export type MutationUpsertTopicPageArgs = {
  upsert: TopicPageUpsertInput
  where: TopicPageWhereUniqueInput
}

export type MutationUpsertTopicPageCategoryArgs = {
  upsert: TopicPageCategoryUpsertInput
  where: TopicPageCategoryWhereUniqueInput
}

export type MutationUpsertVgWortArgs = {
  upsert: VgWortUpsertInput
  where: VgWortWhereUniqueInput
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudience = Entity &
  Node & {
    __typename?: 'NewsletterAudience'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<NewsletterAudience>
    /** List of NewsletterAudience versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<NewsletterAudience>
    name: Scalars['String']['output']
    previewCta?: Maybe<CallToAction>
    /** Private only audience for logged in users */
    private?: Maybe<Scalars['Boolean']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** Used in Newsletter Subscription Tile to display multiple audiences. If not provided, the name will be used. */
    shortName?: Maybe<Scalars['String']['output']>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudienceCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudienceCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudienceDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudienceHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudienceLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudiencePreviewCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudiencePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudiencePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudienceScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudienceUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Single newsletter audience as a entry point to newsletter subscriptions. */
export type NewsletterAudienceUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type NewsletterAudienceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: NewsletterAudienceWhereUniqueInput
}

/** A connection to a list of items. */
export type NewsletterAudienceConnection = {
  __typename?: 'NewsletterAudienceConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<NewsletterAudienceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type NewsletterAudienceCreateInput = {
  audienceInSection?: InputMaybe<SectionNewsletterAudienceCreateOneInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hubPageNewsletterSubscriptionTileAudiences?: InputMaybe<HubPageNewsletterSubscriptionTileCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<NewsletterAudienceCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  previewCta?: InputMaybe<CallToActionCreateOneInlineInput>
  private?: InputMaybe<Scalars['Boolean']['input']>
  /** shortName input for default locale (de) */
  shortName?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type NewsletterAudienceCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  shortName?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type NewsletterAudienceCreateLocalizationInput = {
  /** Localization input */
  data: NewsletterAudienceCreateLocalizationDataInput
  locale: Locale
}

export type NewsletterAudienceCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<NewsletterAudienceCreateLocalizationInput>>
}

export type NewsletterAudienceCreateManyInlineInput = {
  /** Connect multiple existing NewsletterAudience documents */
  connect?: InputMaybe<Array<NewsletterAudienceWhereUniqueInput>>
  /** Create and connect multiple existing NewsletterAudience documents */
  create?: InputMaybe<Array<NewsletterAudienceCreateInput>>
}

export type NewsletterAudienceCreateOneInlineInput = {
  /** Connect one existing NewsletterAudience document */
  connect?: InputMaybe<NewsletterAudienceWhereUniqueInput>
  /** Create and connect one NewsletterAudience document */
  create?: InputMaybe<NewsletterAudienceCreateInput>
}

/** An edge in a connection. */
export type NewsletterAudienceEdge = {
  __typename?: 'NewsletterAudienceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: NewsletterAudience
}

/** Identifies documents */
export type NewsletterAudienceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterAudienceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterAudienceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterAudienceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<NewsletterAudienceWhereStageInput>
  documentInStages_none?: InputMaybe<NewsletterAudienceWhereStageInput>
  documentInStages_some?: InputMaybe<NewsletterAudienceWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  previewCta?: InputMaybe<CallToActionWhereInput>
  private?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  private_not?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum NewsletterAudienceOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PrivateAsc = 'private_ASC',
  PrivateDesc = 'private_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShortNameAsc = 'shortName_ASC',
  ShortNameDesc = 'shortName_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type NewsletterAudienceUpdateInput = {
  audienceInSection?: InputMaybe<SectionNewsletterAudienceUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hubPageNewsletterSubscriptionTileAudiences?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<NewsletterAudienceUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  previewCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  private?: InputMaybe<Scalars['Boolean']['input']>
  /** shortName input for default locale (de) */
  shortName?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type NewsletterAudienceUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  shortName?: InputMaybe<Scalars['String']['input']>
}

export type NewsletterAudienceUpdateLocalizationInput = {
  data: NewsletterAudienceUpdateLocalizationDataInput
  locale: Locale
}

export type NewsletterAudienceUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<NewsletterAudienceCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<NewsletterAudienceUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<NewsletterAudienceUpsertLocalizationInput>>
}

export type NewsletterAudienceUpdateManyInlineInput = {
  /** Connect multiple existing NewsletterAudience documents */
  connect?: InputMaybe<Array<NewsletterAudienceConnectInput>>
  /** Create and connect multiple NewsletterAudience documents */
  create?: InputMaybe<Array<NewsletterAudienceCreateInput>>
  /** Delete multiple NewsletterAudience documents */
  delete?: InputMaybe<Array<NewsletterAudienceWhereUniqueInput>>
  /** Disconnect multiple NewsletterAudience documents */
  disconnect?: InputMaybe<Array<NewsletterAudienceWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing NewsletterAudience documents */
  set?: InputMaybe<Array<NewsletterAudienceWhereUniqueInput>>
  /** Update multiple NewsletterAudience documents */
  update?: InputMaybe<Array<NewsletterAudienceUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple NewsletterAudience documents */
  upsert?: InputMaybe<Array<NewsletterAudienceUpsertWithNestedWhereUniqueInput>>
}

export type NewsletterAudienceUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<NewsletterAudienceUpdateManyLocalizationsInput>
  private?: InputMaybe<Scalars['Boolean']['input']>
  /** shortName input for default locale (de) */
  shortName?: InputMaybe<Scalars['String']['input']>
}

export type NewsletterAudienceUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  shortName?: InputMaybe<Scalars['String']['input']>
}

export type NewsletterAudienceUpdateManyLocalizationInput = {
  data: NewsletterAudienceUpdateManyLocalizationDataInput
  locale: Locale
}

export type NewsletterAudienceUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<NewsletterAudienceUpdateManyLocalizationInput>>
}

export type NewsletterAudienceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NewsletterAudienceUpdateManyInput
  /** Document search */
  where: NewsletterAudienceWhereInput
}

export type NewsletterAudienceUpdateOneInlineInput = {
  /** Connect existing NewsletterAudience document */
  connect?: InputMaybe<NewsletterAudienceWhereUniqueInput>
  /** Create and connect one NewsletterAudience document */
  create?: InputMaybe<NewsletterAudienceCreateInput>
  /** Delete currently connected NewsletterAudience document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected NewsletterAudience document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single NewsletterAudience document */
  update?: InputMaybe<NewsletterAudienceUpdateWithNestedWhereUniqueInput>
  /** Upsert single NewsletterAudience document */
  upsert?: InputMaybe<NewsletterAudienceUpsertWithNestedWhereUniqueInput>
}

export type NewsletterAudienceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NewsletterAudienceUpdateInput
  /** Unique document search */
  where: NewsletterAudienceWhereUniqueInput
}

export type NewsletterAudienceUpsertInput = {
  /** Create document if it didn't exist */
  create: NewsletterAudienceCreateInput
  /** Update document if it exists */
  update: NewsletterAudienceUpdateInput
}

export type NewsletterAudienceUpsertLocalizationInput = {
  create: NewsletterAudienceCreateLocalizationDataInput
  locale: Locale
  update: NewsletterAudienceUpdateLocalizationDataInput
}

export type NewsletterAudienceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NewsletterAudienceUpsertInput
  /** Unique document search */
  where: NewsletterAudienceWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type NewsletterAudienceWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type NewsletterAudienceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterAudienceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterAudienceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterAudienceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<NewsletterAudienceWhereStageInput>
  documentInStages_none?: InputMaybe<NewsletterAudienceWhereStageInput>
  documentInStages_some?: InputMaybe<NewsletterAudienceWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  previewCta?: InputMaybe<CallToActionWhereInput>
  private?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  private_not?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  shortName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  shortName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  shortName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  shortName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  shortName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  shortName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  shortName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  shortName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  shortName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  shortName_starts_with?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NewsletterAudienceWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterAudienceWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterAudienceWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterAudienceWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NewsletterAudienceWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References NewsletterAudience record uniquely */
export type NewsletterAudienceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output']
  /** The Stage of an object */
  stage: Stage
}

export type Notification = Entity &
  Node & {
    __typename?: 'Notification'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<Notification>
    event: Event
    /** List of Notification versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Notification>
    message: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

export type NotificationCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type NotificationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type NotificationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type NotificationEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type NotificationHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type NotificationLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type NotificationPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type NotificationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type NotificationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type NotificationUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type NotificationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type NotificationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: NotificationWhereUniqueInput
}

/** A connection to a list of items. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<NotificationEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type NotificationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  event: EventCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<NotificationCreateLocalizationsInput>
  message: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type NotificationCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type NotificationCreateLocalizationInput = {
  /** Localization input */
  data: NotificationCreateLocalizationDataInput
  locale: Locale
}

export type NotificationCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<NotificationCreateLocalizationInput>>
}

export type NotificationCreateManyInlineInput = {
  /** Connect multiple existing Notification documents */
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>
  /** Create and connect multiple existing Notification documents */
  create?: InputMaybe<Array<NotificationCreateInput>>
}

export type NotificationCreateOneInlineInput = {
  /** Connect one existing Notification document */
  connect?: InputMaybe<NotificationWhereUniqueInput>
  /** Create and connect one Notification document */
  create?: InputMaybe<NotificationCreateInput>
}

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Notification
}

/** Identifies documents */
export type NotificationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<NotificationWhereStageInput>
  documentInStages_none?: InputMaybe<NotificationWhereStageInput>
  documentInStages_some?: InputMaybe<NotificationWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum NotificationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MessageAsc = 'message_ASC',
  MessageDesc = 'message_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type NotificationUpdateInput = {
  event?: InputMaybe<EventUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<NotificationUpdateLocalizationsInput>
  message?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type NotificationUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type NotificationUpdateLocalizationInput = {
  data: NotificationUpdateLocalizationDataInput
  locale: Locale
}

export type NotificationUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<NotificationCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<NotificationUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<NotificationUpsertLocalizationInput>>
}

export type NotificationUpdateManyInlineInput = {
  /** Connect multiple existing Notification documents */
  connect?: InputMaybe<Array<NotificationConnectInput>>
  /** Create and connect multiple Notification documents */
  create?: InputMaybe<Array<NotificationCreateInput>>
  /** Delete multiple Notification documents */
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>
  /** Disconnect multiple Notification documents */
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Notification documents */
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>
  /** Update multiple Notification documents */
  update?: InputMaybe<Array<NotificationUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Notification documents */
  upsert?: InputMaybe<Array<NotificationUpsertWithNestedWhereUniqueInput>>
}

export type NotificationUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<NotificationUpdateManyLocalizationsInput>
  message?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type NotificationUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type NotificationUpdateManyLocalizationInput = {
  data: NotificationUpdateManyLocalizationDataInput
  locale: Locale
}

export type NotificationUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<NotificationUpdateManyLocalizationInput>>
}

export type NotificationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NotificationUpdateManyInput
  /** Document search */
  where: NotificationWhereInput
}

export type NotificationUpdateOneInlineInput = {
  /** Connect existing Notification document */
  connect?: InputMaybe<NotificationWhereUniqueInput>
  /** Create and connect one Notification document */
  create?: InputMaybe<NotificationCreateInput>
  /** Delete currently connected Notification document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Notification document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Notification document */
  update?: InputMaybe<NotificationUpdateWithNestedWhereUniqueInput>
  /** Upsert single Notification document */
  upsert?: InputMaybe<NotificationUpsertWithNestedWhereUniqueInput>
}

export type NotificationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NotificationUpdateInput
  /** Unique document search */
  where: NotificationWhereUniqueInput
}

export type NotificationUpsertInput = {
  /** Create document if it didn't exist */
  create: NotificationCreateInput
  /** Update document if it exists */
  update: NotificationUpdateInput
}

export type NotificationUpsertLocalizationInput = {
  create: NotificationCreateLocalizationDataInput
  locale: Locale
  update: NotificationUpdateLocalizationDataInput
}

export type NotificationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NotificationUpsertInput
  /** Unique document search */
  where: NotificationWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type NotificationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type NotificationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<NotificationWhereStageInput>
  documentInStages_none?: InputMaybe<NotificationWhereStageInput>
  documentInStages_some?: InputMaybe<NotificationWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NotificationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NotificationWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Notification record uniquely */
export type NotificationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type OmrPartner = Entity &
  Node & {
    __typename?: 'OMRPartner'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<OmrPartner>
    /** List of OMRPartner versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<OmrPartner>
    logo: Asset
    name: Scalars['String']['output']
    partnerUrl?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

export type OmrPartnerCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type OmrPartnerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type OmrPartnerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type OmrPartnerHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type OmrPartnerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type OmrPartnerLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type OmrPartnerPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type OmrPartnerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type OmrPartnerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type OmrPartnerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type OmrPartnerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type OmrPartnerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: OmrPartnerWhereUniqueInput
}

/** A connection to a list of items. */
export type OmrPartnerConnection = {
  __typename?: 'OMRPartnerConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<OmrPartnerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type OmrPartnerCreateInput = {
  clt4mem3805vq07umhpbmhrvj?: InputMaybe<SectionOmrPartnerCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<OmrPartnerCreateLocalizationsInput>
  logo: AssetCreateOneInlineInput
  name: Scalars['String']['input']
  omrHeader?: InputMaybe<HeaderCreateOneInlineInput>
  /** partnerUrl input for default locale (de) */
  partnerUrl?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type OmrPartnerCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  partnerUrl?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type OmrPartnerCreateLocalizationInput = {
  /** Localization input */
  data: OmrPartnerCreateLocalizationDataInput
  locale: Locale
}

export type OmrPartnerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<OmrPartnerCreateLocalizationInput>>
}

export type OmrPartnerCreateManyInlineInput = {
  /** Connect multiple existing OMRPartner documents */
  connect?: InputMaybe<Array<OmrPartnerWhereUniqueInput>>
  /** Create and connect multiple existing OMRPartner documents */
  create?: InputMaybe<Array<OmrPartnerCreateInput>>
}

export type OmrPartnerCreateOneInlineInput = {
  /** Connect one existing OMRPartner document */
  connect?: InputMaybe<OmrPartnerWhereUniqueInput>
  /** Create and connect one OMRPartner document */
  create?: InputMaybe<OmrPartnerCreateInput>
}

/** An edge in a connection. */
export type OmrPartnerEdge = {
  __typename?: 'OMRPartnerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: OmrPartner
}

/** Identifies documents */
export type OmrPartnerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<OmrPartnerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<OmrPartnerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<OmrPartnerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<OmrPartnerWhereStageInput>
  documentInStages_none?: InputMaybe<OmrPartnerWhereStageInput>
  documentInStages_some?: InputMaybe<OmrPartnerWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum OmrPartnerOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PartnerUrlAsc = 'partnerUrl_ASC',
  PartnerUrlDesc = 'partnerUrl_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type OmrPartnerUpdateInput = {
  clt4mem3805vq07umhpbmhrvj?: InputMaybe<SectionOmrPartnerUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<OmrPartnerUpdateLocalizationsInput>
  logo?: InputMaybe<AssetUpdateOneInlineInput>
  name?: InputMaybe<Scalars['String']['input']>
  omrHeader?: InputMaybe<HeaderUpdateOneInlineInput>
  /** partnerUrl input for default locale (de) */
  partnerUrl?: InputMaybe<Scalars['String']['input']>
}

export type OmrPartnerUpdateLocalizationDataInput = {
  partnerUrl?: InputMaybe<Scalars['String']['input']>
}

export type OmrPartnerUpdateLocalizationInput = {
  data: OmrPartnerUpdateLocalizationDataInput
  locale: Locale
}

export type OmrPartnerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<OmrPartnerCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<OmrPartnerUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<OmrPartnerUpsertLocalizationInput>>
}

export type OmrPartnerUpdateManyInlineInput = {
  /** Connect multiple existing OMRPartner documents */
  connect?: InputMaybe<Array<OmrPartnerConnectInput>>
  /** Create and connect multiple OMRPartner documents */
  create?: InputMaybe<Array<OmrPartnerCreateInput>>
  /** Delete multiple OMRPartner documents */
  delete?: InputMaybe<Array<OmrPartnerWhereUniqueInput>>
  /** Disconnect multiple OMRPartner documents */
  disconnect?: InputMaybe<Array<OmrPartnerWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing OMRPartner documents */
  set?: InputMaybe<Array<OmrPartnerWhereUniqueInput>>
  /** Update multiple OMRPartner documents */
  update?: InputMaybe<Array<OmrPartnerUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple OMRPartner documents */
  upsert?: InputMaybe<Array<OmrPartnerUpsertWithNestedWhereUniqueInput>>
}

export type OmrPartnerUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<OmrPartnerUpdateManyLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** partnerUrl input for default locale (de) */
  partnerUrl?: InputMaybe<Scalars['String']['input']>
}

export type OmrPartnerUpdateManyLocalizationDataInput = {
  partnerUrl?: InputMaybe<Scalars['String']['input']>
}

export type OmrPartnerUpdateManyLocalizationInput = {
  data: OmrPartnerUpdateManyLocalizationDataInput
  locale: Locale
}

export type OmrPartnerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<OmrPartnerUpdateManyLocalizationInput>>
}

export type OmrPartnerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: OmrPartnerUpdateManyInput
  /** Document search */
  where: OmrPartnerWhereInput
}

export type OmrPartnerUpdateOneInlineInput = {
  /** Connect existing OMRPartner document */
  connect?: InputMaybe<OmrPartnerWhereUniqueInput>
  /** Create and connect one OMRPartner document */
  create?: InputMaybe<OmrPartnerCreateInput>
  /** Delete currently connected OMRPartner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected OMRPartner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single OMRPartner document */
  update?: InputMaybe<OmrPartnerUpdateWithNestedWhereUniqueInput>
  /** Upsert single OMRPartner document */
  upsert?: InputMaybe<OmrPartnerUpsertWithNestedWhereUniqueInput>
}

export type OmrPartnerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: OmrPartnerUpdateInput
  /** Unique document search */
  where: OmrPartnerWhereUniqueInput
}

export type OmrPartnerUpsertInput = {
  /** Create document if it didn't exist */
  create: OmrPartnerCreateInput
  /** Update document if it exists */
  update: OmrPartnerUpdateInput
}

export type OmrPartnerUpsertLocalizationInput = {
  create: OmrPartnerCreateLocalizationDataInput
  locale: Locale
  update: OmrPartnerUpdateLocalizationDataInput
}

export type OmrPartnerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: OmrPartnerUpsertInput
  /** Unique document search */
  where: OmrPartnerWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type OmrPartnerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type OmrPartnerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<OmrPartnerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<OmrPartnerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<OmrPartnerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<OmrPartnerWhereStageInput>
  documentInStages_none?: InputMaybe<OmrPartnerWhereStageInput>
  documentInStages_some?: InputMaybe<OmrPartnerWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  partnerUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  partnerUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  partnerUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  partnerUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  partnerUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  partnerUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  partnerUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  partnerUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  partnerUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  partnerUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type OmrPartnerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<OmrPartnerWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<OmrPartnerWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<OmrPartnerWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<OmrPartnerWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References OMRPartner record uniquely */
export type OmrPartnerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Defines how the content of image is positioned in the container */
export enum ObjectFit {
  Contain = 'contain',
  Cover = 'cover',
}

/** Choose a style. Default is White/Black depending on the dark/light theme. */
export enum OmrStyleVariant {
  Default = 'default',
  PrimarySubtle = 'primarySubtle',
  PrimarySubtler = 'primarySubtler',
  PrimarySubtlest = 'primarySubtlest',
  SecondarySubtle = 'secondarySubtle',
  SecondarySubtler = 'secondarySubtler',
  SecondarySubtlest = 'secondarySubtlest',
}

/** Either light or dark theme variant */
export enum OmrThemeVariant {
  Dark = 'dark',
  Light = 'light',
}

/** Vertical padding sizes */
export enum PaddingSize {
  PaddingFull = 'padding_full',
  PaddingLg = 'padding_lg',
  PaddingMd = 'padding_md',
  PaddingNone = 'padding_none',
  PaddingSm = 'padding_sm',
  PaddingXl = 'padding_xl',
  PaddingXs = 'padding_xs',
  PaddingXxs = 'padding_xxs',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>
}

export type PartnerBadge = Entity & {
  __typename?: 'PartnerBadge'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<PartnerBadge>
  partnerBadgeLabel: Scalars['String']['output']
  /** The logo will have a max height of 48px so use the correct aspect ratio. Refer to OMR Component Library for examples */
  partnerBadgeLogo: Asset
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PartnerBadgeLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type PartnerBadgePartnerBadgeLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type PartnerBadgeUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type PartnerBadgeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PartnerBadgeWhereUniqueInput
}

/** A connection to a list of items. */
export type PartnerBadgeConnection = {
  __typename?: 'PartnerBadgeConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PartnerBadgeEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PartnerBadgeCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PartnerBadgeCreateLocalizationsInput>
  /** partnerBadgeLabel input for default locale (de) */
  partnerBadgeLabel: Scalars['String']['input']
  partnerBadgeLogo: AssetCreateOneInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PartnerBadgeCreateLocalizationDataInput = {
  partnerBadgeLabel: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PartnerBadgeCreateLocalizationInput = {
  /** Localization input */
  data: PartnerBadgeCreateLocalizationDataInput
  locale: Locale
}

export type PartnerBadgeCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PartnerBadgeCreateLocalizationInput>>
}

export type PartnerBadgeCreateManyInlineInput = {
  /** Create and connect multiple existing PartnerBadge documents */
  create?: InputMaybe<Array<PartnerBadgeCreateInput>>
}

export type PartnerBadgeCreateOneInlineInput = {
  /** Create and connect one PartnerBadge document */
  create?: InputMaybe<PartnerBadgeCreateInput>
}

export type PartnerBadgeCreateWithPositionInput = {
  /** Document to create */
  data: PartnerBadgeCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type PartnerBadgeEdge = {
  __typename?: 'PartnerBadgeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PartnerBadge
}

/** Identifies documents */
export type PartnerBadgeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PartnerBadgeWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PartnerBadgeWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PartnerBadgeWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  partnerBadgeLogo?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum PartnerBadgeOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PartnerBadgeLabelAsc = 'partnerBadgeLabel_ASC',
  PartnerBadgeLabelDesc = 'partnerBadgeLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type PartnerBadgeParent = SectionStyledHero

export type PartnerBadgeParentConnectInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroConnectInput>
}

export type PartnerBadgeParentCreateInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateInput>
}

export type PartnerBadgeParentCreateManyInlineInput = {
  /** Create and connect multiple existing PartnerBadgeParent documents */
  create?: InputMaybe<Array<PartnerBadgeParentCreateInput>>
}

export type PartnerBadgeParentCreateOneInlineInput = {
  /** Create and connect one PartnerBadgeParent document */
  create?: InputMaybe<PartnerBadgeParentCreateInput>
}

export type PartnerBadgeParentCreateWithPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroCreateWithPositionInput>
}

export type PartnerBadgeParentUpdateInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateInput>
}

export type PartnerBadgeParentUpdateManyInlineInput = {
  /** Create and connect multiple PartnerBadgeParent component instances */
  create?: InputMaybe<Array<PartnerBadgeParentCreateWithPositionInput>>
  /** Delete multiple PartnerBadgeParent documents */
  delete?: InputMaybe<Array<PartnerBadgeParentWhereUniqueInput>>
  /** Update multiple PartnerBadgeParent component instances */
  update?: InputMaybe<Array<PartnerBadgeParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple PartnerBadgeParent component instances */
  upsert?: InputMaybe<Array<PartnerBadgeParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type PartnerBadgeParentUpdateManyWithNestedWhereInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateManyWithNestedWhereInput>
}

export type PartnerBadgeParentUpdateOneInlineInput = {
  /** Create and connect one PartnerBadgeParent document */
  create?: InputMaybe<PartnerBadgeParentCreateInput>
  /** Delete currently connected PartnerBadgeParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PartnerBadgeParent document */
  update?: InputMaybe<PartnerBadgeParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single PartnerBadgeParent document */
  upsert?: InputMaybe<PartnerBadgeParentUpsertWithNestedWhereUniqueInput>
}

export type PartnerBadgeParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueAndPositionInput>
}

export type PartnerBadgeParentUpdateWithNestedWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueInput>
}

export type PartnerBadgeParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueAndPositionInput>
}

export type PartnerBadgeParentUpsertWithNestedWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueInput>
}

export type PartnerBadgeParentWhereInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereInput>
}

export type PartnerBadgeParentWhereUniqueInput = {
  SectionStyledHero?: InputMaybe<SectionStyledHeroWhereUniqueInput>
}

export type PartnerBadgeUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<PartnerBadgeUpdateLocalizationsInput>
  /** partnerBadgeLabel input for default locale (de) */
  partnerBadgeLabel?: InputMaybe<Scalars['String']['input']>
  partnerBadgeLogo?: InputMaybe<AssetUpdateOneInlineInput>
}

export type PartnerBadgeUpdateLocalizationDataInput = {
  partnerBadgeLabel?: InputMaybe<Scalars['String']['input']>
}

export type PartnerBadgeUpdateLocalizationInput = {
  data: PartnerBadgeUpdateLocalizationDataInput
  locale: Locale
}

export type PartnerBadgeUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PartnerBadgeCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<PartnerBadgeUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<PartnerBadgeUpsertLocalizationInput>>
}

export type PartnerBadgeUpdateManyInlineInput = {
  /** Create and connect multiple PartnerBadge component instances */
  create?: InputMaybe<Array<PartnerBadgeCreateWithPositionInput>>
  /** Delete multiple PartnerBadge documents */
  delete?: InputMaybe<Array<PartnerBadgeWhereUniqueInput>>
  /** Update multiple PartnerBadge component instances */
  update?: InputMaybe<Array<PartnerBadgeUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple PartnerBadge component instances */
  upsert?: InputMaybe<Array<PartnerBadgeUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type PartnerBadgeUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<PartnerBadgeUpdateManyLocalizationsInput>
  /** partnerBadgeLabel input for default locale (de) */
  partnerBadgeLabel?: InputMaybe<Scalars['String']['input']>
}

export type PartnerBadgeUpdateManyLocalizationDataInput = {
  partnerBadgeLabel?: InputMaybe<Scalars['String']['input']>
}

export type PartnerBadgeUpdateManyLocalizationInput = {
  data: PartnerBadgeUpdateManyLocalizationDataInput
  locale: Locale
}

export type PartnerBadgeUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PartnerBadgeUpdateManyLocalizationInput>>
}

export type PartnerBadgeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PartnerBadgeUpdateManyInput
  /** Document search */
  where: PartnerBadgeWhereInput
}

export type PartnerBadgeUpdateOneInlineInput = {
  /** Create and connect one PartnerBadge document */
  create?: InputMaybe<PartnerBadgeCreateInput>
  /** Delete currently connected PartnerBadge document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PartnerBadge document */
  update?: InputMaybe<PartnerBadgeUpdateWithNestedWhereUniqueInput>
  /** Upsert single PartnerBadge document */
  upsert?: InputMaybe<PartnerBadgeUpsertWithNestedWhereUniqueInput>
}

export type PartnerBadgeUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<PartnerBadgeUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: PartnerBadgeWhereUniqueInput
}

export type PartnerBadgeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PartnerBadgeUpdateInput
  /** Unique document search */
  where: PartnerBadgeWhereUniqueInput
}

export type PartnerBadgeUpsertInput = {
  /** Create document if it didn't exist */
  create: PartnerBadgeCreateInput
  /** Update document if it exists */
  update: PartnerBadgeUpdateInput
}

export type PartnerBadgeUpsertLocalizationInput = {
  create: PartnerBadgeCreateLocalizationDataInput
  locale: Locale
  update: PartnerBadgeUpdateLocalizationDataInput
}

export type PartnerBadgeUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<PartnerBadgeUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: PartnerBadgeWhereUniqueInput
}

export type PartnerBadgeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PartnerBadgeUpsertInput
  /** Unique document search */
  where: PartnerBadgeWhereUniqueInput
}

/** Identifies documents */
export type PartnerBadgeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PartnerBadgeWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PartnerBadgeWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PartnerBadgeWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  partnerBadgeLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  partnerBadgeLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  partnerBadgeLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  partnerBadgeLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  partnerBadgeLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  partnerBadgeLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  partnerBadgeLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  partnerBadgeLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  partnerBadgeLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  partnerBadgeLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  partnerBadgeLogo?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References PartnerBadge record uniquely */
export type PartnerBadgeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Partner companies */
export type PartnerCompany = Entity &
  Node & {
    __typename?: 'PartnerCompany'
    /** Background image used on partner list items */
    backgroundImage?: Maybe<Asset>
    booths: Array<Booth>
    contact_id?: Maybe<Scalars['Int']['output']>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    displayed_on_website?: Maybe<Scalars['Boolean']['output']>
    /** Get the document in other stages */
    documentInStages: Array<PartnerCompany>
    eventsAsExhibitor: Array<Event>
    facebook?: Maybe<Scalars['String']['output']>
    /** List of PartnerCompany versions */
    history: Array<Version>
    /** Set order of partner company at omr.com page. Partner company will be not listed if value not provided */
    homePageOrder?: Maybe<Scalars['Int']['output']>
    /** The unique identifier */
    id: Scalars['ID']['output']
    instagram?: Maybe<Scalars['String']['output']>
    interests: Array<Interest>
    linkedIn?: Maybe<Scalars['String']['output']>
    linkedin?: Maybe<Scalars['String']['output']>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<PartnerCompany>
    logo?: Maybe<Asset>
    logoUrl?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    omrJobsUrl?: Maybe<Scalars['String']['output']>
    /** Custom partner page url */
    pageUrl?: Maybe<Scalars['String']['output']>
    premium?: Maybe<Scalars['Boolean']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    reviewsProducts: Array<ReviewsProduct>
    scheduledIn: Array<ScheduledOperation>
    shortDescription?: Maybe<Scalars['String']['output']>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    twitter?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    webLogoUrl?: Maybe<Scalars['String']['output']>
    website?: Maybe<Scalars['String']['output']>
    youtube?: Maybe<Scalars['String']['output']>
  }

/** Partner companies */
export type PartnerCompanyBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Partner companies */
export type PartnerCompanyBoothsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<BoothOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BoothWhereInput>
}

/** Partner companies */
export type PartnerCompanyCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Partner companies */
export type PartnerCompanyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Partner companies */
export type PartnerCompanyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Partner companies */
export type PartnerCompanyEventsAsExhibitorArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventWhereInput>
}

/** Partner companies */
export type PartnerCompanyHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Partner companies */
export type PartnerCompanyInterestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestWhereInput>
}

/** Partner companies */
export type PartnerCompanyLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Partner companies */
export type PartnerCompanyLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Partner companies */
export type PartnerCompanyPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Partner companies */
export type PartnerCompanyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Partner companies */
export type PartnerCompanyReviewsProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsProductOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductWhereInput>
}

/** Partner companies */
export type PartnerCompanyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Partner companies */
export type PartnerCompanyUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Partner companies */
export type PartnerCompanyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PartnerCompanyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PartnerCompanyWhereUniqueInput
}

/** A connection to a list of items. */
export type PartnerCompanyConnection = {
  __typename?: 'PartnerCompanyConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PartnerCompanyEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PartnerCompanyCreateInput = {
  backgroundImage?: InputMaybe<AssetCreateOneInlineInput>
  booths?: InputMaybe<BoothCreateManyInlineInput>
  contact_id?: InputMaybe<Scalars['Int']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  displayed_on_website?: InputMaybe<Scalars['Boolean']['input']>
  eventsAsExhibitor?: InputMaybe<EventCreateManyInlineInput>
  exhibitorOrder?: InputMaybe<ExhibitorListOrderCreateManyInlineInput>
  facebook?: InputMaybe<Scalars['String']['input']>
  homePageOrder?: InputMaybe<Scalars['Int']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  interests?: InputMaybe<InterestCreateManyInlineInput>
  linkedIn?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PartnerCompanyCreateLocalizationsInput>
  logo?: InputMaybe<AssetCreateOneInlineInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  omrJobsUrl?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  premium?: InputMaybe<Scalars['Boolean']['input']>
  reviewsProducts?: InputMaybe<ReviewsProductCreateManyInlineInput>
  /** shortDescription input for default locale (de) */
  shortDescription?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
  speaker?: InputMaybe<SpeakerCreateOneInlineInput>
  twitter?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  webLogoUrl?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCompanyCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  shortDescription?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PartnerCompanyCreateLocalizationInput = {
  /** Localization input */
  data: PartnerCompanyCreateLocalizationDataInput
  locale: Locale
}

export type PartnerCompanyCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PartnerCompanyCreateLocalizationInput>>
}

export type PartnerCompanyCreateManyInlineInput = {
  /** Connect multiple existing PartnerCompany documents */
  connect?: InputMaybe<Array<PartnerCompanyWhereUniqueInput>>
  /** Create and connect multiple existing PartnerCompany documents */
  create?: InputMaybe<Array<PartnerCompanyCreateInput>>
}

export type PartnerCompanyCreateOneInlineInput = {
  /** Connect one existing PartnerCompany document */
  connect?: InputMaybe<PartnerCompanyWhereUniqueInput>
  /** Create and connect one PartnerCompany document */
  create?: InputMaybe<PartnerCompanyCreateInput>
}

/** An edge in a connection. */
export type PartnerCompanyEdge = {
  __typename?: 'PartnerCompanyEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PartnerCompany
}

/** Identifies documents */
export type PartnerCompanyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PartnerCompanyWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PartnerCompanyWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PartnerCompanyWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  backgroundImage?: InputMaybe<AssetWhereInput>
  booths_every?: InputMaybe<BoothWhereInput>
  booths_none?: InputMaybe<BoothWhereInput>
  booths_some?: InputMaybe<BoothWhereInput>
  contact_id?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  contact_id_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  contact_id_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  contact_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  contact_id_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  contact_id_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  contact_id_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  contact_id_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  displayed_on_website?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  displayed_on_website_not?: InputMaybe<Scalars['Boolean']['input']>
  documentInStages_every?: InputMaybe<PartnerCompanyWhereStageInput>
  documentInStages_none?: InputMaybe<PartnerCompanyWhereStageInput>
  documentInStages_some?: InputMaybe<PartnerCompanyWhereStageInput>
  eventsAsExhibitor_every?: InputMaybe<EventWhereInput>
  eventsAsExhibitor_none?: InputMaybe<EventWhereInput>
  eventsAsExhibitor_some?: InputMaybe<EventWhereInput>
  facebook?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  facebook_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  facebook_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  facebook_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  facebook_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  facebook_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  facebook_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  facebook_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  facebook_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  facebook_starts_with?: InputMaybe<Scalars['String']['input']>
  homePageOrder?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  homePageOrder_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  homePageOrder_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  homePageOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  homePageOrder_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  homePageOrder_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  homePageOrder_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  homePageOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  instagram_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  instagram_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  instagram_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  instagram_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  instagram_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  instagram_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  instagram_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  instagram_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  instagram_starts_with?: InputMaybe<Scalars['String']['input']>
  interests_every?: InputMaybe<InterestWhereInput>
  interests_none?: InputMaybe<InterestWhereInput>
  interests_some?: InputMaybe<InterestWhereInput>
  linkedIn?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedIn_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedIn_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedIn_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedIn_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedIn_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedIn_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedIn_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedIn_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedIn_starts_with?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedin_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedin_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedin_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedin_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedin_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedin_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedin_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedin_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedin_starts_with?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<AssetWhereInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  logoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  logoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  logoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  logoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  logoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  logoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  logoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  omrJobsUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  omrJobsUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  omrJobsUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  omrJobsUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  omrJobsUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  omrJobsUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  omrJobsUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  omrJobsUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  omrJobsUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  omrJobsUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pageUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pageUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pageUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pageUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pageUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  premium?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  premium_not?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reviewsProducts_every?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_none?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_some?: InputMaybe<ReviewsProductWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  twitter_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  twitter_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  twitter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  twitter_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  twitter_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  twitter_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  twitter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  twitter_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  twitter_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  webLogoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  webLogoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  webLogoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  webLogoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  webLogoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  webLogoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  webLogoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  webLogoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  webLogoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  webLogoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  youtube_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  youtube_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  youtube_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  youtube_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  youtube_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  youtube_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  youtube_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  youtube_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  youtube_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum PartnerCompanyOrderByInput {
  ContactIdAsc = 'contact_id_ASC',
  ContactIdDesc = 'contact_id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DisplayedOnWebsiteAsc = 'displayed_on_website_ASC',
  DisplayedOnWebsiteDesc = 'displayed_on_website_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HomePageOrderAsc = 'homePageOrder_ASC',
  HomePageOrderDesc = 'homePageOrder_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LinkedInAsc = 'linkedIn_ASC',
  LinkedInDesc = 'linkedIn_DESC',
  LinkedinAsc = 'linkedin_ASC',
  LinkedinDesc = 'linkedin_DESC',
  LogoUrlAsc = 'logoUrl_ASC',
  LogoUrlDesc = 'logoUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OmrJobsUrlAsc = 'omrJobsUrl_ASC',
  OmrJobsUrlDesc = 'omrJobsUrl_DESC',
  PageUrlAsc = 'pageUrl_ASC',
  PageUrlDesc = 'pageUrl_DESC',
  PremiumAsc = 'premium_ASC',
  PremiumDesc = 'premium_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WebLogoUrlAsc = 'webLogoUrl_ASC',
  WebLogoUrlDesc = 'webLogoUrl_DESC',
  WebsiteAsc = 'website_ASC',
  WebsiteDesc = 'website_DESC',
  YoutubeAsc = 'youtube_ASC',
  YoutubeDesc = 'youtube_DESC',
}

export type PartnerCompanyUpdateInput = {
  backgroundImage?: InputMaybe<AssetUpdateOneInlineInput>
  booths?: InputMaybe<BoothUpdateManyInlineInput>
  contact_id?: InputMaybe<Scalars['Int']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  displayed_on_website?: InputMaybe<Scalars['Boolean']['input']>
  eventsAsExhibitor?: InputMaybe<EventUpdateManyInlineInput>
  exhibitorOrder?: InputMaybe<ExhibitorListOrderUpdateManyInlineInput>
  facebook?: InputMaybe<Scalars['String']['input']>
  homePageOrder?: InputMaybe<Scalars['Int']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  interests?: InputMaybe<InterestUpdateManyInlineInput>
  linkedIn?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<PartnerCompanyUpdateLocalizationsInput>
  logo?: InputMaybe<AssetUpdateOneInlineInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  omrJobsUrl?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  premium?: InputMaybe<Scalars['Boolean']['input']>
  reviewsProducts?: InputMaybe<ReviewsProductUpdateManyInlineInput>
  /** shortDescription input for default locale (de) */
  shortDescription?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  speaker?: InputMaybe<SpeakerUpdateOneInlineInput>
  twitter?: InputMaybe<Scalars['String']['input']>
  webLogoUrl?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCompanyUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  shortDescription?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCompanyUpdateLocalizationInput = {
  data: PartnerCompanyUpdateLocalizationDataInput
  locale: Locale
}

export type PartnerCompanyUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PartnerCompanyCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<PartnerCompanyUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<PartnerCompanyUpsertLocalizationInput>>
}

export type PartnerCompanyUpdateManyInlineInput = {
  /** Connect multiple existing PartnerCompany documents */
  connect?: InputMaybe<Array<PartnerCompanyConnectInput>>
  /** Create and connect multiple PartnerCompany documents */
  create?: InputMaybe<Array<PartnerCompanyCreateInput>>
  /** Delete multiple PartnerCompany documents */
  delete?: InputMaybe<Array<PartnerCompanyWhereUniqueInput>>
  /** Disconnect multiple PartnerCompany documents */
  disconnect?: InputMaybe<Array<PartnerCompanyWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing PartnerCompany documents */
  set?: InputMaybe<Array<PartnerCompanyWhereUniqueInput>>
  /** Update multiple PartnerCompany documents */
  update?: InputMaybe<Array<PartnerCompanyUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple PartnerCompany documents */
  upsert?: InputMaybe<Array<PartnerCompanyUpsertWithNestedWhereUniqueInput>>
}

export type PartnerCompanyUpdateManyInput = {
  contact_id?: InputMaybe<Scalars['Int']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  displayed_on_website?: InputMaybe<Scalars['Boolean']['input']>
  facebook?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  linkedIn?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<PartnerCompanyUpdateManyLocalizationsInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  omrJobsUrl?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  premium?: InputMaybe<Scalars['Boolean']['input']>
  /** shortDescription input for default locale (de) */
  shortDescription?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  webLogoUrl?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCompanyUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  shortDescription?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCompanyUpdateManyLocalizationInput = {
  data: PartnerCompanyUpdateManyLocalizationDataInput
  locale: Locale
}

export type PartnerCompanyUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PartnerCompanyUpdateManyLocalizationInput>>
}

export type PartnerCompanyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PartnerCompanyUpdateManyInput
  /** Document search */
  where: PartnerCompanyWhereInput
}

export type PartnerCompanyUpdateOneInlineInput = {
  /** Connect existing PartnerCompany document */
  connect?: InputMaybe<PartnerCompanyWhereUniqueInput>
  /** Create and connect one PartnerCompany document */
  create?: InputMaybe<PartnerCompanyCreateInput>
  /** Delete currently connected PartnerCompany document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected PartnerCompany document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PartnerCompany document */
  update?: InputMaybe<PartnerCompanyUpdateWithNestedWhereUniqueInput>
  /** Upsert single PartnerCompany document */
  upsert?: InputMaybe<PartnerCompanyUpsertWithNestedWhereUniqueInput>
}

export type PartnerCompanyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PartnerCompanyUpdateInput
  /** Unique document search */
  where: PartnerCompanyWhereUniqueInput
}

export type PartnerCompanyUpsertInput = {
  /** Create document if it didn't exist */
  create: PartnerCompanyCreateInput
  /** Update document if it exists */
  update: PartnerCompanyUpdateInput
}

export type PartnerCompanyUpsertLocalizationInput = {
  create: PartnerCompanyCreateLocalizationDataInput
  locale: Locale
  update: PartnerCompanyUpdateLocalizationDataInput
}

export type PartnerCompanyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PartnerCompanyUpsertInput
  /** Unique document search */
  where: PartnerCompanyWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type PartnerCompanyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type PartnerCompanyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PartnerCompanyWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PartnerCompanyWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PartnerCompanyWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  backgroundImage?: InputMaybe<AssetWhereInput>
  booths_every?: InputMaybe<BoothWhereInput>
  booths_none?: InputMaybe<BoothWhereInput>
  booths_some?: InputMaybe<BoothWhereInput>
  contact_id?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  contact_id_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  contact_id_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  contact_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  contact_id_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  contact_id_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  contact_id_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  contact_id_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  displayed_on_website?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  displayed_on_website_not?: InputMaybe<Scalars['Boolean']['input']>
  documentInStages_every?: InputMaybe<PartnerCompanyWhereStageInput>
  documentInStages_none?: InputMaybe<PartnerCompanyWhereStageInput>
  documentInStages_some?: InputMaybe<PartnerCompanyWhereStageInput>
  eventsAsExhibitor_every?: InputMaybe<EventWhereInput>
  eventsAsExhibitor_none?: InputMaybe<EventWhereInput>
  eventsAsExhibitor_some?: InputMaybe<EventWhereInput>
  facebook?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  facebook_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  facebook_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  facebook_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  facebook_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  facebook_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  facebook_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  facebook_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  facebook_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  facebook_starts_with?: InputMaybe<Scalars['String']['input']>
  homePageOrder?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  homePageOrder_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  homePageOrder_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  homePageOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  homePageOrder_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  homePageOrder_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  homePageOrder_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  homePageOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  instagram_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  instagram_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  instagram_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  instagram_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  instagram_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  instagram_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  instagram_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  instagram_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  instagram_starts_with?: InputMaybe<Scalars['String']['input']>
  interests_every?: InputMaybe<InterestWhereInput>
  interests_none?: InputMaybe<InterestWhereInput>
  interests_some?: InputMaybe<InterestWhereInput>
  linkedIn?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedIn_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedIn_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedIn_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedIn_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedIn_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedIn_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedIn_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedIn_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedIn_starts_with?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedin_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedin_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedin_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedin_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedin_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedin_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedin_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedin_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedin_starts_with?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<AssetWhereInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  logoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  logoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  logoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  logoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  logoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  logoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  logoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  omrJobsUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  omrJobsUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  omrJobsUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  omrJobsUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  omrJobsUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  omrJobsUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  omrJobsUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  omrJobsUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  omrJobsUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  omrJobsUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pageUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pageUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pageUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pageUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pageUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  premium?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  premium_not?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reviewsProducts_every?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_none?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_some?: InputMaybe<ReviewsProductWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  shortDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  twitter_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  twitter_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  twitter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  twitter_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  twitter_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  twitter_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  twitter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  twitter_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  twitter_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  webLogoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  webLogoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  webLogoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  webLogoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  webLogoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  webLogoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  webLogoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  webLogoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  webLogoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  webLogoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  youtube_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  youtube_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  youtube_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  youtube_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  youtube_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  youtube_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  youtube_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  youtube_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  youtube_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PartnerCompanyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PartnerCompanyWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PartnerCompanyWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PartnerCompanyWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PartnerCompanyWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References PartnerCompany record uniquely */
export type PartnerCompanyWhereUniqueInput = {
  homePageOrder?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type PhysicalLocation = Entity &
  Node & {
    __typename?: 'PhysicalLocation'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<PhysicalLocation>
    /** List of PhysicalLocation versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<PhysicalLocation>
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

export type PhysicalLocationCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type PhysicalLocationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PhysicalLocationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type PhysicalLocationHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type PhysicalLocationLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type PhysicalLocationPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type PhysicalLocationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PhysicalLocationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type PhysicalLocationUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type PhysicalLocationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PhysicalLocationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PhysicalLocationWhereUniqueInput
}

/** A connection to a list of items. */
export type PhysicalLocationConnection = {
  __typename?: 'PhysicalLocationConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PhysicalLocationEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PhysicalLocationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PhysicalLocationCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  physicalLocation?: InputMaybe<BoothCreateOneInlineInput>
  slug: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PhysicalLocationCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PhysicalLocationCreateLocalizationInput = {
  /** Localization input */
  data: PhysicalLocationCreateLocalizationDataInput
  locale: Locale
}

export type PhysicalLocationCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PhysicalLocationCreateLocalizationInput>>
}

export type PhysicalLocationCreateManyInlineInput = {
  /** Connect multiple existing PhysicalLocation documents */
  connect?: InputMaybe<Array<PhysicalLocationWhereUniqueInput>>
  /** Create and connect multiple existing PhysicalLocation documents */
  create?: InputMaybe<Array<PhysicalLocationCreateInput>>
}

export type PhysicalLocationCreateOneInlineInput = {
  /** Connect one existing PhysicalLocation document */
  connect?: InputMaybe<PhysicalLocationWhereUniqueInput>
  /** Create and connect one PhysicalLocation document */
  create?: InputMaybe<PhysicalLocationCreateInput>
}

/** An edge in a connection. */
export type PhysicalLocationEdge = {
  __typename?: 'PhysicalLocationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PhysicalLocation
}

/** Identifies documents */
export type PhysicalLocationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PhysicalLocationWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PhysicalLocationWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PhysicalLocationWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<PhysicalLocationWhereStageInput>
  documentInStages_none?: InputMaybe<PhysicalLocationWhereStageInput>
  documentInStages_some?: InputMaybe<PhysicalLocationWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum PhysicalLocationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type PhysicalLocationUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<PhysicalLocationUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  physicalLocation?: InputMaybe<BoothUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type PhysicalLocationUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type PhysicalLocationUpdateLocalizationInput = {
  data: PhysicalLocationUpdateLocalizationDataInput
  locale: Locale
}

export type PhysicalLocationUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PhysicalLocationCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<PhysicalLocationUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<PhysicalLocationUpsertLocalizationInput>>
}

export type PhysicalLocationUpdateManyInlineInput = {
  /** Connect multiple existing PhysicalLocation documents */
  connect?: InputMaybe<Array<PhysicalLocationConnectInput>>
  /** Create and connect multiple PhysicalLocation documents */
  create?: InputMaybe<Array<PhysicalLocationCreateInput>>
  /** Delete multiple PhysicalLocation documents */
  delete?: InputMaybe<Array<PhysicalLocationWhereUniqueInput>>
  /** Disconnect multiple PhysicalLocation documents */
  disconnect?: InputMaybe<Array<PhysicalLocationWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing PhysicalLocation documents */
  set?: InputMaybe<Array<PhysicalLocationWhereUniqueInput>>
  /** Update multiple PhysicalLocation documents */
  update?: InputMaybe<Array<PhysicalLocationUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple PhysicalLocation documents */
  upsert?: InputMaybe<Array<PhysicalLocationUpsertWithNestedWhereUniqueInput>>
}

export type PhysicalLocationUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<PhysicalLocationUpdateManyLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
}

export type PhysicalLocationUpdateManyLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type PhysicalLocationUpdateManyLocalizationInput = {
  data: PhysicalLocationUpdateManyLocalizationDataInput
  locale: Locale
}

export type PhysicalLocationUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PhysicalLocationUpdateManyLocalizationInput>>
}

export type PhysicalLocationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PhysicalLocationUpdateManyInput
  /** Document search */
  where: PhysicalLocationWhereInput
}

export type PhysicalLocationUpdateOneInlineInput = {
  /** Connect existing PhysicalLocation document */
  connect?: InputMaybe<PhysicalLocationWhereUniqueInput>
  /** Create and connect one PhysicalLocation document */
  create?: InputMaybe<PhysicalLocationCreateInput>
  /** Delete currently connected PhysicalLocation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected PhysicalLocation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PhysicalLocation document */
  update?: InputMaybe<PhysicalLocationUpdateWithNestedWhereUniqueInput>
  /** Upsert single PhysicalLocation document */
  upsert?: InputMaybe<PhysicalLocationUpsertWithNestedWhereUniqueInput>
}

export type PhysicalLocationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PhysicalLocationUpdateInput
  /** Unique document search */
  where: PhysicalLocationWhereUniqueInput
}

export type PhysicalLocationUpsertInput = {
  /** Create document if it didn't exist */
  create: PhysicalLocationCreateInput
  /** Update document if it exists */
  update: PhysicalLocationUpdateInput
}

export type PhysicalLocationUpsertLocalizationInput = {
  create: PhysicalLocationCreateLocalizationDataInput
  locale: Locale
  update: PhysicalLocationUpdateLocalizationDataInput
}

export type PhysicalLocationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PhysicalLocationUpsertInput
  /** Unique document search */
  where: PhysicalLocationWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type PhysicalLocationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type PhysicalLocationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PhysicalLocationWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PhysicalLocationWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PhysicalLocationWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<PhysicalLocationWhereStageInput>
  documentInStages_none?: InputMaybe<PhysicalLocationWhereStageInput>
  documentInStages_some?: InputMaybe<PhysicalLocationWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PhysicalLocationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PhysicalLocationWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PhysicalLocationWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PhysicalLocationWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PhysicalLocationWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References PhysicalLocation record uniquely */
export type PhysicalLocationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

/** Podigee podcast episodes */
export type PodcastEpisode = Entity &
  Node & {
    __typename?: 'PodcastEpisode'
    authors: Scalars['String']['output']
    coverImage?: Maybe<Scalars['String']['output']>
    createDateTime: Scalars['DateTime']['output']
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Description of the podcast episode */
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<PodcastEpisode>
    duration: Scalars['Int']['output']
    /** List of PodcastEpisode versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    lastSyncTimestamp?: Maybe<Scalars['DateTime']['output']>
    number: Scalars['Int']['output']
    permalink: Scalars['String']['output']
    /** Name of the podcast */
    podcastName: Scalars['String']['output']
    /** Podigee podcast episode id */
    podigeeId: Scalars['Int']['output']
    /** Podigee podcast id */
    podigeePodcastId: Scalars['Int']['output']
    publishDateTime: Scalars['DateTime']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    season: Scalars['Int']['output']
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** Subtitle of the podcast episode */
    subtitle?: Maybe<Scalars['String']['output']>
    /** Title of the podcast episode */
    title: Scalars['String']['output']
    updateDateTime: Scalars['DateTime']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Podigee podcast episodes */
export type PodcastEpisodeCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Podigee podcast episodes */
export type PodcastEpisodeDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Podigee podcast episodes */
export type PodcastEpisodeHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Podigee podcast episodes */
export type PodcastEpisodePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Podigee podcast episodes */
export type PodcastEpisodeScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Podigee podcast episodes */
export type PodcastEpisodeUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PodcastEpisodeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PodcastEpisodeWhereUniqueInput
}

/** A connection to a list of items. */
export type PodcastEpisodeConnection = {
  __typename?: 'PodcastEpisodeConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PodcastEpisodeEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PodcastEpisodeCreateInput = {
  authors: Scalars['String']['input']
  coverImage?: InputMaybe<Scalars['String']['input']>
  createDateTime: Scalars['DateTime']['input']
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  duration: Scalars['Int']['input']
  lastSyncTimestamp?: InputMaybe<Scalars['DateTime']['input']>
  number: Scalars['Int']['input']
  permalink: Scalars['String']['input']
  podcastName: Scalars['String']['input']
  podigeeId: Scalars['Int']['input']
  podigeePodcastId: Scalars['Int']['input']
  publishDateTime: Scalars['DateTime']['input']
  season: Scalars['Int']['input']
  slug: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updateDateTime: Scalars['DateTime']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PodcastEpisodeCreateManyInlineInput = {
  /** Connect multiple existing PodcastEpisode documents */
  connect?: InputMaybe<Array<PodcastEpisodeWhereUniqueInput>>
  /** Create and connect multiple existing PodcastEpisode documents */
  create?: InputMaybe<Array<PodcastEpisodeCreateInput>>
}

export type PodcastEpisodeCreateOneInlineInput = {
  /** Connect one existing PodcastEpisode document */
  connect?: InputMaybe<PodcastEpisodeWhereUniqueInput>
  /** Create and connect one PodcastEpisode document */
  create?: InputMaybe<PodcastEpisodeCreateInput>
}

/** An edge in a connection. */
export type PodcastEpisodeEdge = {
  __typename?: 'PodcastEpisodeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PodcastEpisode
}

/** Identifies documents */
export type PodcastEpisodeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastEpisodeWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastEpisodeWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastEpisodeWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  authors?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  authors_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  authors_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  authors_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  authors_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  authors_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  authors_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  authors_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  authors_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  authors_starts_with?: InputMaybe<Scalars['String']['input']>
  coverImage?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  coverImage_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  coverImage_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  coverImage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  coverImage_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  coverImage_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  coverImage_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  coverImage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  coverImage_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  coverImage_starts_with?: InputMaybe<Scalars['String']['input']>
  createDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<PodcastEpisodeWhereStageInput>
  documentInStages_none?: InputMaybe<PodcastEpisodeWhereStageInput>
  documentInStages_some?: InputMaybe<PodcastEpisodeWhereStageInput>
  duration?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  duration_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  duration_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  duration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  duration_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  duration_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  duration_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  duration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  lastSyncTimestamp?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  lastSyncTimestamp_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  lastSyncTimestamp_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  lastSyncTimestamp_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  lastSyncTimestamp_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  lastSyncTimestamp_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  lastSyncTimestamp_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  lastSyncTimestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  number?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  permalink?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  permalink_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  permalink_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  permalink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  permalink_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  permalink_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  permalink_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  permalink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  permalink_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  permalink_starts_with?: InputMaybe<Scalars['String']['input']>
  podcastName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  podcastName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  podcastName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  podcastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  podcastName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  podcastName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  podcastName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  podcastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  podcastName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  podcastName_starts_with?: InputMaybe<Scalars['String']['input']>
  podigeeId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  podigeeId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  podigeeId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  podigeeId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  podigeeId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  podigeeId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  podigeeId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  podigeeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  podigeePodcastId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  podigeePodcastId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  podigeePodcastId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  podigeePodcastId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  podigeePodcastId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  podigeePodcastId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  podigeePodcastId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  podigeePodcastId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  publishDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  season?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  season_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  season_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  season_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  season_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  season_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  season_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  season_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updateDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updateDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updateDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updateDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updateDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updateDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updateDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updateDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum PodcastEpisodeOrderByInput {
  AuthorsAsc = 'authors_ASC',
  AuthorsDesc = 'authors_DESC',
  CoverImageAsc = 'coverImage_ASC',
  CoverImageDesc = 'coverImage_DESC',
  CreateDateTimeAsc = 'createDateTime_ASC',
  CreateDateTimeDesc = 'createDateTime_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LastSyncTimestampAsc = 'lastSyncTimestamp_ASC',
  LastSyncTimestampDesc = 'lastSyncTimestamp_DESC',
  NumberAsc = 'number_ASC',
  NumberDesc = 'number_DESC',
  PermalinkAsc = 'permalink_ASC',
  PermalinkDesc = 'permalink_DESC',
  PodcastNameAsc = 'podcastName_ASC',
  PodcastNameDesc = 'podcastName_DESC',
  PodigeeIdAsc = 'podigeeId_ASC',
  PodigeeIdDesc = 'podigeeId_DESC',
  PodigeePodcastIdAsc = 'podigeePodcastId_ASC',
  PodigeePodcastIdDesc = 'podigeePodcastId_DESC',
  PublishDateTimeAsc = 'publishDateTime_ASC',
  PublishDateTimeDesc = 'publishDateTime_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeasonAsc = 'season_ASC',
  SeasonDesc = 'season_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdateDateTimeAsc = 'updateDateTime_ASC',
  UpdateDateTimeDesc = 'updateDateTime_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type PodcastEpisodeUpdateInput = {
  authors?: InputMaybe<Scalars['String']['input']>
  coverImage?: InputMaybe<Scalars['String']['input']>
  createDateTime?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  lastSyncTimestamp?: InputMaybe<Scalars['DateTime']['input']>
  number?: InputMaybe<Scalars['Int']['input']>
  permalink?: InputMaybe<Scalars['String']['input']>
  podcastName?: InputMaybe<Scalars['String']['input']>
  podigeeId?: InputMaybe<Scalars['Int']['input']>
  podigeePodcastId?: InputMaybe<Scalars['Int']['input']>
  publishDateTime?: InputMaybe<Scalars['DateTime']['input']>
  season?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updateDateTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type PodcastEpisodeUpdateManyInlineInput = {
  /** Connect multiple existing PodcastEpisode documents */
  connect?: InputMaybe<Array<PodcastEpisodeConnectInput>>
  /** Create and connect multiple PodcastEpisode documents */
  create?: InputMaybe<Array<PodcastEpisodeCreateInput>>
  /** Delete multiple PodcastEpisode documents */
  delete?: InputMaybe<Array<PodcastEpisodeWhereUniqueInput>>
  /** Disconnect multiple PodcastEpisode documents */
  disconnect?: InputMaybe<Array<PodcastEpisodeWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing PodcastEpisode documents */
  set?: InputMaybe<Array<PodcastEpisodeWhereUniqueInput>>
  /** Update multiple PodcastEpisode documents */
  update?: InputMaybe<Array<PodcastEpisodeUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple PodcastEpisode documents */
  upsert?: InputMaybe<Array<PodcastEpisodeUpsertWithNestedWhereUniqueInput>>
}

export type PodcastEpisodeUpdateManyInput = {
  authors?: InputMaybe<Scalars['String']['input']>
  coverImage?: InputMaybe<Scalars['String']['input']>
  createDateTime?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  lastSyncTimestamp?: InputMaybe<Scalars['DateTime']['input']>
  number?: InputMaybe<Scalars['Int']['input']>
  podcastName?: InputMaybe<Scalars['String']['input']>
  podigeePodcastId?: InputMaybe<Scalars['Int']['input']>
  publishDateTime?: InputMaybe<Scalars['DateTime']['input']>
  season?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updateDateTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type PodcastEpisodeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PodcastEpisodeUpdateManyInput
  /** Document search */
  where: PodcastEpisodeWhereInput
}

export type PodcastEpisodeUpdateOneInlineInput = {
  /** Connect existing PodcastEpisode document */
  connect?: InputMaybe<PodcastEpisodeWhereUniqueInput>
  /** Create and connect one PodcastEpisode document */
  create?: InputMaybe<PodcastEpisodeCreateInput>
  /** Delete currently connected PodcastEpisode document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected PodcastEpisode document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PodcastEpisode document */
  update?: InputMaybe<PodcastEpisodeUpdateWithNestedWhereUniqueInput>
  /** Upsert single PodcastEpisode document */
  upsert?: InputMaybe<PodcastEpisodeUpsertWithNestedWhereUniqueInput>
}

export type PodcastEpisodeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PodcastEpisodeUpdateInput
  /** Unique document search */
  where: PodcastEpisodeWhereUniqueInput
}

export type PodcastEpisodeUpsertInput = {
  /** Create document if it didn't exist */
  create: PodcastEpisodeCreateInput
  /** Update document if it exists */
  update: PodcastEpisodeUpdateInput
}

export type PodcastEpisodeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PodcastEpisodeUpsertInput
  /** Unique document search */
  where: PodcastEpisodeWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type PodcastEpisodeWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type PodcastEpisodeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastEpisodeWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastEpisodeWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastEpisodeWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  authors?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  authors_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  authors_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  authors_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  authors_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  authors_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  authors_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  authors_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  authors_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  authors_starts_with?: InputMaybe<Scalars['String']['input']>
  coverImage?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  coverImage_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  coverImage_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  coverImage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  coverImage_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  coverImage_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  coverImage_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  coverImage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  coverImage_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  coverImage_starts_with?: InputMaybe<Scalars['String']['input']>
  createDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<PodcastEpisodeWhereStageInput>
  documentInStages_none?: InputMaybe<PodcastEpisodeWhereStageInput>
  documentInStages_some?: InputMaybe<PodcastEpisodeWhereStageInput>
  duration?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  duration_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  duration_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  duration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  duration_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  duration_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  duration_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  duration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  lastSyncTimestamp?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  lastSyncTimestamp_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  lastSyncTimestamp_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  lastSyncTimestamp_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  lastSyncTimestamp_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  lastSyncTimestamp_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  lastSyncTimestamp_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  lastSyncTimestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  number?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  permalink?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  permalink_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  permalink_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  permalink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  permalink_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  permalink_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  permalink_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  permalink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  permalink_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  permalink_starts_with?: InputMaybe<Scalars['String']['input']>
  podcastName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  podcastName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  podcastName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  podcastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  podcastName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  podcastName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  podcastName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  podcastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  podcastName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  podcastName_starts_with?: InputMaybe<Scalars['String']['input']>
  podigeeId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  podigeeId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  podigeeId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  podigeeId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  podigeeId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  podigeeId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  podigeeId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  podigeeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  podigeePodcastId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  podigeePodcastId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  podigeePodcastId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  podigeePodcastId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  podigeePodcastId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  podigeePodcastId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  podigeePodcastId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  podigeePodcastId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  publishDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  season?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  season_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  season_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  season_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  season_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  season_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  season_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  season_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updateDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updateDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updateDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updateDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updateDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updateDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updateDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updateDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PodcastEpisodeWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastEpisodeWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastEpisodeWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastEpisodeWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PodcastEpisodeWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References PodcastEpisode record uniquely */
export type PodcastEpisodeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  permalink?: InputMaybe<Scalars['String']['input']>
  podigeeId?: InputMaybe<Scalars['Int']['input']>
}

/** Podcast Groups */
export type PodcastGroup = Entity &
  Node & {
    __typename?: 'PodcastGroup'
    /** Audio preview/trailer of podcast group */
    audioPreviewUrl?: Maybe<Scalars['String']['output']>
    /** Desktop background URL. Suggested size 1320x350 */
    backgroundImage: Asset
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Short podcast group description */
    description: Scalars['String']['output']
    /** Get the document in other stages */
    documentInStages: Array<PodcastGroup>
    /** Podigee feed page URL */
    feedUrl?: Maybe<Scalars['String']['output']>
    /** List of PodcastGroup versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    keyVisual?: Maybe<Asset>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<PodcastGroup>
    /** Mobile background URL. Suggested size 320x160. Fallbacks to background image if not provided */
    mobileBackgroundImage?: Maybe<Asset>
    /** Podcast group name */
    name: Scalars['String']['output']
    /** Podcast group page URL */
    pageUrl: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** Reference all related social media sources */
    socialMedia?: Maybe<Social>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Podcast Groups */
export type PodcastGroupBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Podcast Groups */
export type PodcastGroupCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Podcast Groups */
export type PodcastGroupCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Podcast Groups */
export type PodcastGroupDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Podcast Groups */
export type PodcastGroupHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Podcast Groups */
export type PodcastGroupKeyVisualArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Podcast Groups */
export type PodcastGroupLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Podcast Groups */
export type PodcastGroupMobileBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Podcast Groups */
export type PodcastGroupPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Podcast Groups */
export type PodcastGroupPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Podcast Groups */
export type PodcastGroupScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Podcast Groups */
export type PodcastGroupSocialMediaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Podcast Groups */
export type PodcastGroupUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Podcast Groups */
export type PodcastGroupUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PodcastGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PodcastGroupWhereUniqueInput
}

/** A connection to a list of items. */
export type PodcastGroupConnection = {
  __typename?: 'PodcastGroupConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PodcastGroupEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PodcastGroupCreateInput = {
  audioPreviewUrl?: InputMaybe<Scalars['String']['input']>
  backgroundImage: AssetCreateOneInlineInput
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  feedUrl?: InputMaybe<Scalars['String']['input']>
  keyVisual?: InputMaybe<AssetCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PodcastGroupCreateLocalizationsInput>
  mobileBackgroundImage?: InputMaybe<AssetCreateOneInlineInput>
  name: Scalars['String']['input']
  pageUrl: Scalars['String']['input']
  podcastGroup?: InputMaybe<PodcastGroupLinkCreateManyInlineInput>
  socialMedia?: InputMaybe<SocialCreateOneInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PodcastGroupCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PodcastGroupCreateLocalizationInput = {
  /** Localization input */
  data: PodcastGroupCreateLocalizationDataInput
  locale: Locale
}

export type PodcastGroupCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PodcastGroupCreateLocalizationInput>>
}

export type PodcastGroupCreateManyInlineInput = {
  /** Connect multiple existing PodcastGroup documents */
  connect?: InputMaybe<Array<PodcastGroupWhereUniqueInput>>
  /** Create and connect multiple existing PodcastGroup documents */
  create?: InputMaybe<Array<PodcastGroupCreateInput>>
}

export type PodcastGroupCreateOneInlineInput = {
  /** Connect one existing PodcastGroup document */
  connect?: InputMaybe<PodcastGroupWhereUniqueInput>
  /** Create and connect one PodcastGroup document */
  create?: InputMaybe<PodcastGroupCreateInput>
}

/** An edge in a connection. */
export type PodcastGroupEdge = {
  __typename?: 'PodcastGroupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PodcastGroup
}

/** Component used when linking to a podcast group */
export type PodcastGroupLink = Entity & {
  __typename?: 'PodcastGroupLink'
  highlighted?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  podcast: PodcastGroup
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Component used when linking to a podcast group */
export type PodcastGroupLinkPodcastArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PodcastGroupLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PodcastGroupLinkWhereUniqueInput
}

/** A connection to a list of items. */
export type PodcastGroupLinkConnection = {
  __typename?: 'PodcastGroupLinkConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PodcastGroupLinkEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PodcastGroupLinkCreateInput = {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>
  podcast: PodcastGroupCreateOneInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PodcastGroupLinkCreateManyInlineInput = {
  /** Create and connect multiple existing PodcastGroupLink documents */
  create?: InputMaybe<Array<PodcastGroupLinkCreateInput>>
}

export type PodcastGroupLinkCreateOneInlineInput = {
  /** Create and connect one PodcastGroupLink document */
  create?: InputMaybe<PodcastGroupLinkCreateInput>
}

export type PodcastGroupLinkCreateWithPositionInput = {
  /** Document to create */
  data: PodcastGroupLinkCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type PodcastGroupLinkEdge = {
  __typename?: 'PodcastGroupLinkEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PodcastGroupLink
}

/** Identifies documents */
export type PodcastGroupLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastGroupLinkWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastGroupLinkWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastGroupLinkWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  highlighted?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  highlighted_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  podcast?: InputMaybe<PodcastGroupWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum PodcastGroupLinkOrderByInput {
  HighlightedAsc = 'highlighted_ASC',
  HighlightedDesc = 'highlighted_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type PodcastGroupLinkParent = HubPageSectionPodcasts

export type PodcastGroupLinkParentConnectInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsConnectInput>
}

export type PodcastGroupLinkParentCreateInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsCreateInput>
}

export type PodcastGroupLinkParentCreateManyInlineInput = {
  /** Create and connect multiple existing PodcastGroupLinkParent documents */
  create?: InputMaybe<Array<PodcastGroupLinkParentCreateInput>>
}

export type PodcastGroupLinkParentCreateOneInlineInput = {
  /** Create and connect one PodcastGroupLinkParent document */
  create?: InputMaybe<PodcastGroupLinkParentCreateInput>
}

export type PodcastGroupLinkParentCreateWithPositionInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsCreateWithPositionInput>
}

export type PodcastGroupLinkParentUpdateInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpdateInput>
}

export type PodcastGroupLinkParentUpdateManyInlineInput = {
  /** Create and connect multiple PodcastGroupLinkParent component instances */
  create?: InputMaybe<Array<PodcastGroupLinkParentCreateWithPositionInput>>
  /** Delete multiple PodcastGroupLinkParent documents */
  delete?: InputMaybe<Array<PodcastGroupLinkParentWhereUniqueInput>>
  /** Update multiple PodcastGroupLinkParent component instances */
  update?: InputMaybe<Array<PodcastGroupLinkParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple PodcastGroupLinkParent component instances */
  upsert?: InputMaybe<Array<PodcastGroupLinkParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type PodcastGroupLinkParentUpdateManyWithNestedWhereInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpdateManyWithNestedWhereInput>
}

export type PodcastGroupLinkParentUpdateOneInlineInput = {
  /** Create and connect one PodcastGroupLinkParent document */
  create?: InputMaybe<PodcastGroupLinkParentCreateInput>
  /** Delete currently connected PodcastGroupLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PodcastGroupLinkParent document */
  update?: InputMaybe<PodcastGroupLinkParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single PodcastGroupLinkParent document */
  upsert?: InputMaybe<PodcastGroupLinkParentUpsertWithNestedWhereUniqueInput>
}

export type PodcastGroupLinkParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpdateWithNestedWhereUniqueAndPositionInput>
}

export type PodcastGroupLinkParentUpdateWithNestedWhereUniqueInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpdateWithNestedWhereUniqueInput>
}

export type PodcastGroupLinkParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpsertWithNestedWhereUniqueAndPositionInput>
}

export type PodcastGroupLinkParentUpsertWithNestedWhereUniqueInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsUpsertWithNestedWhereUniqueInput>
}

export type PodcastGroupLinkParentWhereInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsWhereInput>
}

export type PodcastGroupLinkParentWhereUniqueInput = {
  HubPageSectionPodcasts?: InputMaybe<HubPageSectionPodcastsWhereUniqueInput>
}

export type PodcastGroupLinkUpdateInput = {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>
  podcast?: InputMaybe<PodcastGroupUpdateOneInlineInput>
}

export type PodcastGroupLinkUpdateManyInlineInput = {
  /** Create and connect multiple PodcastGroupLink component instances */
  create?: InputMaybe<Array<PodcastGroupLinkCreateWithPositionInput>>
  /** Delete multiple PodcastGroupLink documents */
  delete?: InputMaybe<Array<PodcastGroupLinkWhereUniqueInput>>
  /** Update multiple PodcastGroupLink component instances */
  update?: InputMaybe<Array<PodcastGroupLinkUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple PodcastGroupLink component instances */
  upsert?: InputMaybe<Array<PodcastGroupLinkUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type PodcastGroupLinkUpdateManyInput = {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>
}

export type PodcastGroupLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PodcastGroupLinkUpdateManyInput
  /** Document search */
  where: PodcastGroupLinkWhereInput
}

export type PodcastGroupLinkUpdateOneInlineInput = {
  /** Create and connect one PodcastGroupLink document */
  create?: InputMaybe<PodcastGroupLinkCreateInput>
  /** Delete currently connected PodcastGroupLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PodcastGroupLink document */
  update?: InputMaybe<PodcastGroupLinkUpdateWithNestedWhereUniqueInput>
  /** Upsert single PodcastGroupLink document */
  upsert?: InputMaybe<PodcastGroupLinkUpsertWithNestedWhereUniqueInput>
}

export type PodcastGroupLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<PodcastGroupLinkUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: PodcastGroupLinkWhereUniqueInput
}

export type PodcastGroupLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PodcastGroupLinkUpdateInput
  /** Unique document search */
  where: PodcastGroupLinkWhereUniqueInput
}

export type PodcastGroupLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: PodcastGroupLinkCreateInput
  /** Update document if it exists */
  update: PodcastGroupLinkUpdateInput
}

export type PodcastGroupLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<PodcastGroupLinkUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: PodcastGroupLinkWhereUniqueInput
}

export type PodcastGroupLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PodcastGroupLinkUpsertInput
  /** Unique document search */
  where: PodcastGroupLinkWhereUniqueInput
}

/** Identifies documents */
export type PodcastGroupLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastGroupLinkWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastGroupLinkWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastGroupLinkWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  highlighted?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  highlighted_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  podcast?: InputMaybe<PodcastGroupWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References PodcastGroupLink record uniquely */
export type PodcastGroupLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Identifies documents */
export type PodcastGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastGroupWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastGroupWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastGroupWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audioPreviewUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  audioPreviewUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  audioPreviewUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  audioPreviewUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  audioPreviewUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  audioPreviewUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  audioPreviewUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  audioPreviewUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  audioPreviewUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  audioPreviewUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  backgroundImage?: InputMaybe<AssetWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<PodcastGroupWhereStageInput>
  documentInStages_none?: InputMaybe<PodcastGroupWhereStageInput>
  documentInStages_some?: InputMaybe<PodcastGroupWhereStageInput>
  feedUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  feedUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  feedUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  feedUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  feedUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  feedUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  feedUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  feedUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  feedUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  feedUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  keyVisual?: InputMaybe<AssetWhereInput>
  mobileBackgroundImage?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pageUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pageUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pageUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pageUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pageUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  socialMedia?: InputMaybe<SocialWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum PodcastGroupOrderByInput {
  AudioPreviewUrlAsc = 'audioPreviewUrl_ASC',
  AudioPreviewUrlDesc = 'audioPreviewUrl_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  FeedUrlAsc = 'feedUrl_ASC',
  FeedUrlDesc = 'feedUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageUrlAsc = 'pageUrl_ASC',
  PageUrlDesc = 'pageUrl_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type PodcastGroupUpdateInput = {
  audioPreviewUrl?: InputMaybe<Scalars['String']['input']>
  backgroundImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  feedUrl?: InputMaybe<Scalars['String']['input']>
  keyVisual?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<PodcastGroupUpdateLocalizationsInput>
  mobileBackgroundImage?: InputMaybe<AssetUpdateOneInlineInput>
  name?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  podcastGroup?: InputMaybe<PodcastGroupLinkUpdateManyInlineInput>
  socialMedia?: InputMaybe<SocialUpdateOneInlineInput>
}

export type PodcastGroupUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type PodcastGroupUpdateLocalizationInput = {
  data: PodcastGroupUpdateLocalizationDataInput
  locale: Locale
}

export type PodcastGroupUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PodcastGroupCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<PodcastGroupUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<PodcastGroupUpsertLocalizationInput>>
}

export type PodcastGroupUpdateManyInlineInput = {
  /** Connect multiple existing PodcastGroup documents */
  connect?: InputMaybe<Array<PodcastGroupConnectInput>>
  /** Create and connect multiple PodcastGroup documents */
  create?: InputMaybe<Array<PodcastGroupCreateInput>>
  /** Delete multiple PodcastGroup documents */
  delete?: InputMaybe<Array<PodcastGroupWhereUniqueInput>>
  /** Disconnect multiple PodcastGroup documents */
  disconnect?: InputMaybe<Array<PodcastGroupWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing PodcastGroup documents */
  set?: InputMaybe<Array<PodcastGroupWhereUniqueInput>>
  /** Update multiple PodcastGroup documents */
  update?: InputMaybe<Array<PodcastGroupUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple PodcastGroup documents */
  upsert?: InputMaybe<Array<PodcastGroupUpsertWithNestedWhereUniqueInput>>
}

export type PodcastGroupUpdateManyInput = {
  audioPreviewUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  feedUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<PodcastGroupUpdateManyLocalizationsInput>
  pageUrl?: InputMaybe<Scalars['String']['input']>
}

export type PodcastGroupUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type PodcastGroupUpdateManyLocalizationInput = {
  data: PodcastGroupUpdateManyLocalizationDataInput
  locale: Locale
}

export type PodcastGroupUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PodcastGroupUpdateManyLocalizationInput>>
}

export type PodcastGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PodcastGroupUpdateManyInput
  /** Document search */
  where: PodcastGroupWhereInput
}

export type PodcastGroupUpdateOneInlineInput = {
  /** Connect existing PodcastGroup document */
  connect?: InputMaybe<PodcastGroupWhereUniqueInput>
  /** Create and connect one PodcastGroup document */
  create?: InputMaybe<PodcastGroupCreateInput>
  /** Delete currently connected PodcastGroup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected PodcastGroup document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PodcastGroup document */
  update?: InputMaybe<PodcastGroupUpdateWithNestedWhereUniqueInput>
  /** Upsert single PodcastGroup document */
  upsert?: InputMaybe<PodcastGroupUpsertWithNestedWhereUniqueInput>
}

export type PodcastGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PodcastGroupUpdateInput
  /** Unique document search */
  where: PodcastGroupWhereUniqueInput
}

export type PodcastGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: PodcastGroupCreateInput
  /** Update document if it exists */
  update: PodcastGroupUpdateInput
}

export type PodcastGroupUpsertLocalizationInput = {
  create: PodcastGroupCreateLocalizationDataInput
  locale: Locale
  update: PodcastGroupUpdateLocalizationDataInput
}

export type PodcastGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PodcastGroupUpsertInput
  /** Unique document search */
  where: PodcastGroupWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type PodcastGroupWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type PodcastGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastGroupWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastGroupWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastGroupWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audioPreviewUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  audioPreviewUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  audioPreviewUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  audioPreviewUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  audioPreviewUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  audioPreviewUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  audioPreviewUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  audioPreviewUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  audioPreviewUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  audioPreviewUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  backgroundImage?: InputMaybe<AssetWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<PodcastGroupWhereStageInput>
  documentInStages_none?: InputMaybe<PodcastGroupWhereStageInput>
  documentInStages_some?: InputMaybe<PodcastGroupWhereStageInput>
  feedUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  feedUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  feedUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  feedUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  feedUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  feedUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  feedUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  feedUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  feedUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  feedUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  keyVisual?: InputMaybe<AssetWhereInput>
  mobileBackgroundImage?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pageUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pageUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pageUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pageUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pageUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  socialMedia?: InputMaybe<SocialWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PodcastGroupWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastGroupWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastGroupWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastGroupWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PodcastGroupWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References PodcastGroup record uniquely */
export type PodcastGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type PpcReviewsProduct = Entity & {
  __typename?: 'PpcReviewsProduct'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<PpcReviewsProduct>
  ppcDescription?: Maybe<Scalars['String']['output']>
  reviewsProduct?: Maybe<ReviewsProduct>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url: Scalars['String']['output']
  /** View Tracking Link for EPOM */
  viewUrl?: Maybe<Scalars['String']['output']>
}

export type PpcReviewsProductLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type PpcReviewsProductReviewsProductArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PpcReviewsProductUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type PpcReviewsProductConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PpcReviewsProductWhereUniqueInput
}

/** A connection to a list of items. */
export type PpcReviewsProductConnection = {
  __typename?: 'PpcReviewsProductConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PpcReviewsProductEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PpcReviewsProductCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PpcReviewsProductCreateLocalizationsInput>
  /** ppcDescription input for default locale (de) */
  ppcDescription?: InputMaybe<Scalars['String']['input']>
  reviewsProduct?: InputMaybe<ReviewsProductCreateOneInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** url input for default locale (de) */
  url: Scalars['String']['input']
  /** viewUrl input for default locale (de) */
  viewUrl?: InputMaybe<Scalars['String']['input']>
}

export type PpcReviewsProductCreateLocalizationDataInput = {
  ppcDescription?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  url: Scalars['String']['input']
  viewUrl?: InputMaybe<Scalars['String']['input']>
}

export type PpcReviewsProductCreateLocalizationInput = {
  /** Localization input */
  data: PpcReviewsProductCreateLocalizationDataInput
  locale: Locale
}

export type PpcReviewsProductCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PpcReviewsProductCreateLocalizationInput>>
}

export type PpcReviewsProductCreateManyInlineInput = {
  /** Create and connect multiple existing PpcReviewsProduct documents */
  create?: InputMaybe<Array<PpcReviewsProductCreateInput>>
}

export type PpcReviewsProductCreateOneInlineInput = {
  /** Create and connect one PpcReviewsProduct document */
  create?: InputMaybe<PpcReviewsProductCreateInput>
}

export type PpcReviewsProductCreateWithPositionInput = {
  /** Document to create */
  data: PpcReviewsProductCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type PpcReviewsProductEdge = {
  __typename?: 'PpcReviewsProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PpcReviewsProduct
}

/** Identifies documents */
export type PpcReviewsProductManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PpcReviewsProductWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PpcReviewsProductWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PpcReviewsProductWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  reviewsProduct?: InputMaybe<ReviewsProductWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum PpcReviewsProductOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PpcDescriptionAsc = 'ppcDescription_ASC',
  PpcDescriptionDesc = 'ppcDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  ViewUrlAsc = 'viewUrl_ASC',
  ViewUrlDesc = 'viewUrl_DESC',
}

export type PpcReviewsProductParent = LandingPage

export type PpcReviewsProductParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type PpcReviewsProductParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type PpcReviewsProductParentCreateManyInlineInput = {
  /** Connect multiple existing PpcReviewsProductParent documents */
  connect?: InputMaybe<Array<PpcReviewsProductParentWhereUniqueInput>>
  /** Create and connect multiple existing PpcReviewsProductParent documents */
  create?: InputMaybe<Array<PpcReviewsProductParentCreateInput>>
}

export type PpcReviewsProductParentCreateOneInlineInput = {
  /** Connect one existing PpcReviewsProductParent document */
  connect?: InputMaybe<PpcReviewsProductParentWhereUniqueInput>
  /** Create and connect one PpcReviewsProductParent document */
  create?: InputMaybe<PpcReviewsProductParentCreateInput>
}

export type PpcReviewsProductParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type PpcReviewsProductParentUpdateManyInlineInput = {
  /** Connect multiple existing PpcReviewsProductParent documents */
  connect?: InputMaybe<Array<PpcReviewsProductParentConnectInput>>
  /** Create and connect multiple PpcReviewsProductParent documents */
  create?: InputMaybe<Array<PpcReviewsProductParentCreateInput>>
  /** Delete multiple PpcReviewsProductParent documents */
  delete?: InputMaybe<Array<PpcReviewsProductParentWhereUniqueInput>>
  /** Disconnect multiple PpcReviewsProductParent documents */
  disconnect?: InputMaybe<Array<PpcReviewsProductParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing PpcReviewsProductParent documents */
  set?: InputMaybe<Array<PpcReviewsProductParentWhereUniqueInput>>
  /** Update multiple PpcReviewsProductParent documents */
  update?: InputMaybe<Array<PpcReviewsProductParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple PpcReviewsProductParent documents */
  upsert?: InputMaybe<Array<PpcReviewsProductParentUpsertWithNestedWhereUniqueInput>>
}

export type PpcReviewsProductParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type PpcReviewsProductParentUpdateOneInlineInput = {
  /** Connect existing PpcReviewsProductParent document */
  connect?: InputMaybe<PpcReviewsProductParentWhereUniqueInput>
  /** Create and connect one PpcReviewsProductParent document */
  create?: InputMaybe<PpcReviewsProductParentCreateInput>
  /** Delete currently connected PpcReviewsProductParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected PpcReviewsProductParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PpcReviewsProductParent document */
  update?: InputMaybe<PpcReviewsProductParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single PpcReviewsProductParent document */
  upsert?: InputMaybe<PpcReviewsProductParentUpsertWithNestedWhereUniqueInput>
}

export type PpcReviewsProductParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type PpcReviewsProductParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type PpcReviewsProductParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type PpcReviewsProductParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type PpcReviewsProductUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<PpcReviewsProductUpdateLocalizationsInput>
  /** ppcDescription input for default locale (de) */
  ppcDescription?: InputMaybe<Scalars['String']['input']>
  reviewsProduct?: InputMaybe<ReviewsProductUpdateOneInlineInput>
  /** url input for default locale (de) */
  url?: InputMaybe<Scalars['String']['input']>
  /** viewUrl input for default locale (de) */
  viewUrl?: InputMaybe<Scalars['String']['input']>
}

export type PpcReviewsProductUpdateLocalizationDataInput = {
  ppcDescription?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  viewUrl?: InputMaybe<Scalars['String']['input']>
}

export type PpcReviewsProductUpdateLocalizationInput = {
  data: PpcReviewsProductUpdateLocalizationDataInput
  locale: Locale
}

export type PpcReviewsProductUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PpcReviewsProductCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<PpcReviewsProductUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<PpcReviewsProductUpsertLocalizationInput>>
}

export type PpcReviewsProductUpdateManyInlineInput = {
  /** Create and connect multiple PpcReviewsProduct component instances */
  create?: InputMaybe<Array<PpcReviewsProductCreateWithPositionInput>>
  /** Delete multiple PpcReviewsProduct documents */
  delete?: InputMaybe<Array<PpcReviewsProductWhereUniqueInput>>
  /** Update multiple PpcReviewsProduct component instances */
  update?: InputMaybe<Array<PpcReviewsProductUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple PpcReviewsProduct component instances */
  upsert?: InputMaybe<Array<PpcReviewsProductUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type PpcReviewsProductUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<PpcReviewsProductUpdateManyLocalizationsInput>
  /** ppcDescription input for default locale (de) */
  ppcDescription?: InputMaybe<Scalars['String']['input']>
  /** url input for default locale (de) */
  url?: InputMaybe<Scalars['String']['input']>
  /** viewUrl input for default locale (de) */
  viewUrl?: InputMaybe<Scalars['String']['input']>
}

export type PpcReviewsProductUpdateManyLocalizationDataInput = {
  ppcDescription?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  viewUrl?: InputMaybe<Scalars['String']['input']>
}

export type PpcReviewsProductUpdateManyLocalizationInput = {
  data: PpcReviewsProductUpdateManyLocalizationDataInput
  locale: Locale
}

export type PpcReviewsProductUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PpcReviewsProductUpdateManyLocalizationInput>>
}

export type PpcReviewsProductUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PpcReviewsProductUpdateManyInput
  /** Document search */
  where: PpcReviewsProductWhereInput
}

export type PpcReviewsProductUpdateOneInlineInput = {
  /** Create and connect one PpcReviewsProduct document */
  create?: InputMaybe<PpcReviewsProductCreateInput>
  /** Delete currently connected PpcReviewsProduct document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PpcReviewsProduct document */
  update?: InputMaybe<PpcReviewsProductUpdateWithNestedWhereUniqueInput>
  /** Upsert single PpcReviewsProduct document */
  upsert?: InputMaybe<PpcReviewsProductUpsertWithNestedWhereUniqueInput>
}

export type PpcReviewsProductUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<PpcReviewsProductUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: PpcReviewsProductWhereUniqueInput
}

export type PpcReviewsProductUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PpcReviewsProductUpdateInput
  /** Unique document search */
  where: PpcReviewsProductWhereUniqueInput
}

export type PpcReviewsProductUpsertInput = {
  /** Create document if it didn't exist */
  create: PpcReviewsProductCreateInput
  /** Update document if it exists */
  update: PpcReviewsProductUpdateInput
}

export type PpcReviewsProductUpsertLocalizationInput = {
  create: PpcReviewsProductCreateLocalizationDataInput
  locale: Locale
  update: PpcReviewsProductUpdateLocalizationDataInput
}

export type PpcReviewsProductUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<PpcReviewsProductUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: PpcReviewsProductWhereUniqueInput
}

export type PpcReviewsProductUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PpcReviewsProductUpsertInput
  /** Unique document search */
  where: PpcReviewsProductWhereUniqueInput
}

/** Identifies documents */
export type PpcReviewsProductWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PpcReviewsProductWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PpcReviewsProductWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PpcReviewsProductWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  ppcDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ppcDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ppcDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ppcDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ppcDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ppcDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ppcDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ppcDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ppcDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ppcDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  reviewsProduct?: InputMaybe<ReviewsProductWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
  viewUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  viewUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  viewUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  viewUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  viewUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  viewUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  viewUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  viewUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  viewUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  viewUrl_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** References PpcReviewsProduct record uniquely */
export type PpcReviewsProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section showing some quick actions. */
export type PreviewCardList = Entity & {
  __typename?: 'PreviewCardList'
  card: Array<Slide>
  /** Number of columns we want to show cards with */
  columns: Scalars['Int']['output']
  /** Description of the section */
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<PreviewCardList>
  /** System stage field */
  stage: Stage
  /** Title of the section */
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section showing some quick actions. */
export type PreviewCardListCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SlideOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SlideWhereInput>
}

/** Section showing some quick actions. */
export type PreviewCardListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing some quick actions. */
export type PreviewCardListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type PreviewCardListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PreviewCardListWhereUniqueInput
}

/** A connection to a list of items. */
export type PreviewCardListConnection = {
  __typename?: 'PreviewCardListConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PreviewCardListEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PreviewCardListCreateInput = {
  card: SlideCreateManyInlineInput
  columns: Scalars['Int']['input']
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PreviewCardListCreateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PreviewCardListCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PreviewCardListCreateLocalizationInput = {
  /** Localization input */
  data: PreviewCardListCreateLocalizationDataInput
  locale: Locale
}

export type PreviewCardListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PreviewCardListCreateLocalizationInput>>
}

export type PreviewCardListCreateManyInlineInput = {
  /** Create and connect multiple existing PreviewCardList documents */
  create?: InputMaybe<Array<PreviewCardListCreateInput>>
}

export type PreviewCardListCreateOneInlineInput = {
  /** Create and connect one PreviewCardList document */
  create?: InputMaybe<PreviewCardListCreateInput>
}

export type PreviewCardListCreateWithPositionInput = {
  /** Document to create */
  data: PreviewCardListCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type PreviewCardListEdge = {
  __typename?: 'PreviewCardListEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PreviewCardList
}

/** Identifies documents */
export type PreviewCardListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PreviewCardListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PreviewCardListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PreviewCardListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  card_every?: InputMaybe<SlideWhereInput>
  card_none?: InputMaybe<SlideWhereInput>
  card_some?: InputMaybe<SlideWhereInput>
  columns?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  columns_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  columns_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  columns_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  columns_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  columns_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  columns_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  columns_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum PreviewCardListOrderByInput {
  ColumnsAsc = 'columns_ASC',
  ColumnsDesc = 'columns_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type PreviewCardListParent = EventPage | LandingPage

export type PreviewCardListParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type PreviewCardListParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type PreviewCardListParentCreateManyInlineInput = {
  /** Connect multiple existing PreviewCardListParent documents */
  connect?: InputMaybe<Array<PreviewCardListParentWhereUniqueInput>>
  /** Create and connect multiple existing PreviewCardListParent documents */
  create?: InputMaybe<Array<PreviewCardListParentCreateInput>>
}

export type PreviewCardListParentCreateOneInlineInput = {
  /** Connect one existing PreviewCardListParent document */
  connect?: InputMaybe<PreviewCardListParentWhereUniqueInput>
  /** Create and connect one PreviewCardListParent document */
  create?: InputMaybe<PreviewCardListParentCreateInput>
}

export type PreviewCardListParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type PreviewCardListParentUpdateManyInlineInput = {
  /** Connect multiple existing PreviewCardListParent documents */
  connect?: InputMaybe<Array<PreviewCardListParentConnectInput>>
  /** Create and connect multiple PreviewCardListParent documents */
  create?: InputMaybe<Array<PreviewCardListParentCreateInput>>
  /** Delete multiple PreviewCardListParent documents */
  delete?: InputMaybe<Array<PreviewCardListParentWhereUniqueInput>>
  /** Disconnect multiple PreviewCardListParent documents */
  disconnect?: InputMaybe<Array<PreviewCardListParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing PreviewCardListParent documents */
  set?: InputMaybe<Array<PreviewCardListParentWhereUniqueInput>>
  /** Update multiple PreviewCardListParent documents */
  update?: InputMaybe<Array<PreviewCardListParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple PreviewCardListParent documents */
  upsert?: InputMaybe<Array<PreviewCardListParentUpsertWithNestedWhereUniqueInput>>
}

export type PreviewCardListParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type PreviewCardListParentUpdateOneInlineInput = {
  /** Connect existing PreviewCardListParent document */
  connect?: InputMaybe<PreviewCardListParentWhereUniqueInput>
  /** Create and connect one PreviewCardListParent document */
  create?: InputMaybe<PreviewCardListParentCreateInput>
  /** Delete currently connected PreviewCardListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected PreviewCardListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PreviewCardListParent document */
  update?: InputMaybe<PreviewCardListParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single PreviewCardListParent document */
  upsert?: InputMaybe<PreviewCardListParentUpsertWithNestedWhereUniqueInput>
}

export type PreviewCardListParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type PreviewCardListParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type PreviewCardListParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type PreviewCardListParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type PreviewCardListUpdateInput = {
  card?: InputMaybe<SlideUpdateManyInlineInput>
  columns?: InputMaybe<Scalars['Int']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<PreviewCardListUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type PreviewCardListUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type PreviewCardListUpdateLocalizationInput = {
  data: PreviewCardListUpdateLocalizationDataInput
  locale: Locale
}

export type PreviewCardListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PreviewCardListCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<PreviewCardListUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<PreviewCardListUpsertLocalizationInput>>
}

export type PreviewCardListUpdateManyInlineInput = {
  /** Create and connect multiple PreviewCardList component instances */
  create?: InputMaybe<Array<PreviewCardListCreateWithPositionInput>>
  /** Delete multiple PreviewCardList documents */
  delete?: InputMaybe<Array<PreviewCardListWhereUniqueInput>>
  /** Update multiple PreviewCardList component instances */
  update?: InputMaybe<Array<PreviewCardListUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple PreviewCardList component instances */
  upsert?: InputMaybe<Array<PreviewCardListUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type PreviewCardListUpdateManyInput = {
  columns?: InputMaybe<Scalars['Int']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<PreviewCardListUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type PreviewCardListUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type PreviewCardListUpdateManyLocalizationInput = {
  data: PreviewCardListUpdateManyLocalizationDataInput
  locale: Locale
}

export type PreviewCardListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PreviewCardListUpdateManyLocalizationInput>>
}

export type PreviewCardListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PreviewCardListUpdateManyInput
  /** Document search */
  where: PreviewCardListWhereInput
}

export type PreviewCardListUpdateOneInlineInput = {
  /** Create and connect one PreviewCardList document */
  create?: InputMaybe<PreviewCardListCreateInput>
  /** Delete currently connected PreviewCardList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PreviewCardList document */
  update?: InputMaybe<PreviewCardListUpdateWithNestedWhereUniqueInput>
  /** Upsert single PreviewCardList document */
  upsert?: InputMaybe<PreviewCardListUpsertWithNestedWhereUniqueInput>
}

export type PreviewCardListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<PreviewCardListUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: PreviewCardListWhereUniqueInput
}

export type PreviewCardListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PreviewCardListUpdateInput
  /** Unique document search */
  where: PreviewCardListWhereUniqueInput
}

export type PreviewCardListUpsertInput = {
  /** Create document if it didn't exist */
  create: PreviewCardListCreateInput
  /** Update document if it exists */
  update: PreviewCardListUpdateInput
}

export type PreviewCardListUpsertLocalizationInput = {
  create: PreviewCardListCreateLocalizationDataInput
  locale: Locale
  update: PreviewCardListUpdateLocalizationDataInput
}

export type PreviewCardListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<PreviewCardListUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: PreviewCardListWhereUniqueInput
}

export type PreviewCardListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PreviewCardListUpsertInput
  /** Unique document search */
  where: PreviewCardListWhereUniqueInput
}

/** Identifies documents */
export type PreviewCardListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PreviewCardListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PreviewCardListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PreviewCardListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  card_every?: InputMaybe<SlideWhereInput>
  card_none?: InputMaybe<SlideWhereInput>
  card_some?: InputMaybe<SlideWhereInput>
  columns?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  columns_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  columns_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  columns_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  columns_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  columns_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  columns_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  columns_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References PreviewCardList record uniquely */
export type PreviewCardListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTier = Entity &
  Node & {
    __typename?: 'PricingTier'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<PricingTier>
    /** Features are separated by new line */
    features: Scalars['String']['output']
    featuresTitle: Scalars['String']['output']
    freeIncentiveBudget: Scalars['Int']['output']
    /** eg. '€ Guthaben' */
    freeIncentiveBudgetSuffix: Scalars['String']['output']
    /** eg. 'für Bewertungsaktionen' */
    freeIncentiveDescription: Scalars['String']['output']
    hasPrice?: Maybe<Scalars['Boolean']['output']>
    /** List of PricingTier versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    isRecommended?: Maybe<Scalars['Boolean']['output']>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<PricingTier>
    /** eg. 'auf Anfrage' */
    noPriceBottomline?: Maybe<Scalars['String']['output']>
    /** eg. 'Preis' */
    noPriceTopline?: Maybe<Scalars['String']['output']>
    /** eg. ' / Monat' */
    paidPer?: Maybe<Scalars['String']['output']>
    priceValue?: Maybe<Scalars['Int']['output']>
    /** eg. '(im Jahresabo)' */
    pricingDescription?: Maybe<Scalars['String']['output']>
    /** eg. Bestseller */
    pricingTierRecommendationLabel: Scalars['String']['output']
    pricingTierSubTitle: Scalars['String']['output']
    pricingTierTitle: Scalars['String']['output']
    /** Icon for Pricing Tier Title */
    pricingTierTitleIcon: SectionPricingTiersTitleIcon
    primaryCtaLabel?: Maybe<Scalars['String']['output']>
    primaryCtaLink?: Maybe<Scalars['String']['output']>
    /** Tracking identifier which will be used to generate data-track attribute for action */
    primaryCtaTrackingId?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    secondaryCtaLabel?: Maybe<Scalars['String']['output']>
    secondaryCtaLink?: Maybe<Scalars['String']['output']>
    /** Tracking identifier which will be used to generate data-track attribute for action */
    secondaryCtaTrackingId?: Maybe<Scalars['String']['output']>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Pricing Tier for B2B Landing Pages */
export type PricingTierCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Pricing Tier for B2B Landing Pages */
export type PricingTierUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type PricingTierConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: PricingTierWhereUniqueInput
}

/** A connection to a list of items. */
export type PricingTierConnection = {
  __typename?: 'PricingTierConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<PricingTierEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PricingTierCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** features input for default locale (de) */
  features: Scalars['String']['input']
  /** featuresTitle input for default locale (de) */
  featuresTitle: Scalars['String']['input']
  freeIncentiveBudget: Scalars['Int']['input']
  /** freeIncentiveBudgetSuffix input for default locale (de) */
  freeIncentiveBudgetSuffix: Scalars['String']['input']
  /** freeIncentiveDescription input for default locale (de) */
  freeIncentiveDescription: Scalars['String']['input']
  hasPrice?: InputMaybe<Scalars['Boolean']['input']>
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PricingTierCreateLocalizationsInput>
  /** noPriceBottomline input for default locale (de) */
  noPriceBottomline?: InputMaybe<Scalars['String']['input']>
  /** noPriceTopline input for default locale (de) */
  noPriceTopline?: InputMaybe<Scalars['String']['input']>
  /** paidPer input for default locale (de) */
  paidPer?: InputMaybe<Scalars['String']['input']>
  parentPricingTier?: InputMaybe<SectionPricingTiersCreateManyInlineInput>
  priceValue?: InputMaybe<Scalars['Int']['input']>
  /** pricingDescription input for default locale (de) */
  pricingDescription?: InputMaybe<Scalars['String']['input']>
  /** pricingTierRecommendationLabel input for default locale (de) */
  pricingTierRecommendationLabel: Scalars['String']['input']
  /** pricingTierSubTitle input for default locale (de) */
  pricingTierSubTitle: Scalars['String']['input']
  /** pricingTierTitle input for default locale (de) */
  pricingTierTitle: Scalars['String']['input']
  pricingTierTitleIcon: SectionPricingTiersTitleIcon
  /** primaryCtaLabel input for default locale (de) */
  primaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  /** primaryCtaLink input for default locale (de) */
  primaryCtaLink?: InputMaybe<Scalars['String']['input']>
  primaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
  /** secondaryCtaLabel input for default locale (de) */
  secondaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  /** secondaryCtaLink input for default locale (de) */
  secondaryCtaLink?: InputMaybe<Scalars['String']['input']>
  secondaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PricingTierCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  features: Scalars['String']['input']
  featuresTitle: Scalars['String']['input']
  freeIncentiveBudgetSuffix: Scalars['String']['input']
  freeIncentiveDescription: Scalars['String']['input']
  noPriceBottomline?: InputMaybe<Scalars['String']['input']>
  noPriceTopline?: InputMaybe<Scalars['String']['input']>
  paidPer?: InputMaybe<Scalars['String']['input']>
  pricingDescription?: InputMaybe<Scalars['String']['input']>
  pricingTierRecommendationLabel: Scalars['String']['input']
  pricingTierSubTitle: Scalars['String']['input']
  pricingTierTitle: Scalars['String']['input']
  primaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  primaryCtaLink?: InputMaybe<Scalars['String']['input']>
  secondaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  secondaryCtaLink?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PricingTierCreateLocalizationInput = {
  /** Localization input */
  data: PricingTierCreateLocalizationDataInput
  locale: Locale
}

export type PricingTierCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PricingTierCreateLocalizationInput>>
}

export type PricingTierCreateManyInlineInput = {
  /** Connect multiple existing PricingTier documents */
  connect?: InputMaybe<Array<PricingTierWhereUniqueInput>>
  /** Create and connect multiple existing PricingTier documents */
  create?: InputMaybe<Array<PricingTierCreateInput>>
}

export type PricingTierCreateOneInlineInput = {
  /** Connect one existing PricingTier document */
  connect?: InputMaybe<PricingTierWhereUniqueInput>
  /** Create and connect one PricingTier document */
  create?: InputMaybe<PricingTierCreateInput>
}

/** An edge in a connection. */
export type PricingTierEdge = {
  __typename?: 'PricingTierEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: PricingTier
}

/** Identifies documents */
export type PricingTierManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PricingTierWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PricingTierWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PricingTierWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<PricingTierWhereStageInput>
  documentInStages_none?: InputMaybe<PricingTierWhereStageInput>
  documentInStages_some?: InputMaybe<PricingTierWhereStageInput>
  freeIncentiveBudget?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  freeIncentiveBudget_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  freeIncentiveBudget_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  freeIncentiveBudget_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  freeIncentiveBudget_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  freeIncentiveBudget_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  freeIncentiveBudget_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  freeIncentiveBudget_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  hasPrice?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hasPrice_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isRecommended_not?: InputMaybe<Scalars['Boolean']['input']>
  priceValue?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  priceValue_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  priceValue_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  priceValue_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  priceValue_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  priceValue_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  priceValue_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  priceValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  pricingTierTitleIcon?: InputMaybe<SectionPricingTiersTitleIcon>
  /** All values that are contained in given list. */
  pricingTierTitleIcon_in?: InputMaybe<Array<InputMaybe<SectionPricingTiersTitleIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  pricingTierTitleIcon_not?: InputMaybe<SectionPricingTiersTitleIcon>
  /** All values that are not contained in given list. */
  pricingTierTitleIcon_not_in?: InputMaybe<Array<InputMaybe<SectionPricingTiersTitleIcon>>>
  primaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  primaryCtaTrackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  primaryCtaTrackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  primaryCtaTrackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  primaryCtaTrackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  primaryCtaTrackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  primaryCtaTrackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  primaryCtaTrackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  primaryCtaTrackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  primaryCtaTrackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  secondaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  secondaryCtaTrackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  secondaryCtaTrackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  secondaryCtaTrackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  secondaryCtaTrackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  secondaryCtaTrackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  secondaryCtaTrackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  secondaryCtaTrackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  secondaryCtaTrackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  secondaryCtaTrackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum PricingTierOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FeaturesTitleAsc = 'featuresTitle_ASC',
  FeaturesTitleDesc = 'featuresTitle_DESC',
  FeaturesAsc = 'features_ASC',
  FeaturesDesc = 'features_DESC',
  FreeIncentiveBudgetSuffixAsc = 'freeIncentiveBudgetSuffix_ASC',
  FreeIncentiveBudgetSuffixDesc = 'freeIncentiveBudgetSuffix_DESC',
  FreeIncentiveBudgetAsc = 'freeIncentiveBudget_ASC',
  FreeIncentiveBudgetDesc = 'freeIncentiveBudget_DESC',
  FreeIncentiveDescriptionAsc = 'freeIncentiveDescription_ASC',
  FreeIncentiveDescriptionDesc = 'freeIncentiveDescription_DESC',
  HasPriceAsc = 'hasPrice_ASC',
  HasPriceDesc = 'hasPrice_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsRecommendedAsc = 'isRecommended_ASC',
  IsRecommendedDesc = 'isRecommended_DESC',
  NoPriceBottomlineAsc = 'noPriceBottomline_ASC',
  NoPriceBottomlineDesc = 'noPriceBottomline_DESC',
  NoPriceToplineAsc = 'noPriceTopline_ASC',
  NoPriceToplineDesc = 'noPriceTopline_DESC',
  PaidPerAsc = 'paidPer_ASC',
  PaidPerDesc = 'paidPer_DESC',
  PriceValueAsc = 'priceValue_ASC',
  PriceValueDesc = 'priceValue_DESC',
  PricingDescriptionAsc = 'pricingDescription_ASC',
  PricingDescriptionDesc = 'pricingDescription_DESC',
  PricingTierRecommendationLabelAsc = 'pricingTierRecommendationLabel_ASC',
  PricingTierRecommendationLabelDesc = 'pricingTierRecommendationLabel_DESC',
  PricingTierSubTitleAsc = 'pricingTierSubTitle_ASC',
  PricingTierSubTitleDesc = 'pricingTierSubTitle_DESC',
  PricingTierTitleIconAsc = 'pricingTierTitleIcon_ASC',
  PricingTierTitleIconDesc = 'pricingTierTitleIcon_DESC',
  PricingTierTitleAsc = 'pricingTierTitle_ASC',
  PricingTierTitleDesc = 'pricingTierTitle_DESC',
  PrimaryCtaLabelAsc = 'primaryCtaLabel_ASC',
  PrimaryCtaLabelDesc = 'primaryCtaLabel_DESC',
  PrimaryCtaLinkAsc = 'primaryCtaLink_ASC',
  PrimaryCtaLinkDesc = 'primaryCtaLink_DESC',
  PrimaryCtaTrackingIdAsc = 'primaryCtaTrackingId_ASC',
  PrimaryCtaTrackingIdDesc = 'primaryCtaTrackingId_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SecondaryCtaLabelAsc = 'secondaryCtaLabel_ASC',
  SecondaryCtaLabelDesc = 'secondaryCtaLabel_DESC',
  SecondaryCtaLinkAsc = 'secondaryCtaLink_ASC',
  SecondaryCtaLinkDesc = 'secondaryCtaLink_DESC',
  SecondaryCtaTrackingIdAsc = 'secondaryCtaTrackingId_ASC',
  SecondaryCtaTrackingIdDesc = 'secondaryCtaTrackingId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type PricingTierUpdateInput = {
  /** features input for default locale (de) */
  features?: InputMaybe<Scalars['String']['input']>
  /** featuresTitle input for default locale (de) */
  featuresTitle?: InputMaybe<Scalars['String']['input']>
  freeIncentiveBudget?: InputMaybe<Scalars['Int']['input']>
  /** freeIncentiveBudgetSuffix input for default locale (de) */
  freeIncentiveBudgetSuffix?: InputMaybe<Scalars['String']['input']>
  /** freeIncentiveDescription input for default locale (de) */
  freeIncentiveDescription?: InputMaybe<Scalars['String']['input']>
  hasPrice?: InputMaybe<Scalars['Boolean']['input']>
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<PricingTierUpdateLocalizationsInput>
  /** noPriceBottomline input for default locale (de) */
  noPriceBottomline?: InputMaybe<Scalars['String']['input']>
  /** noPriceTopline input for default locale (de) */
  noPriceTopline?: InputMaybe<Scalars['String']['input']>
  /** paidPer input for default locale (de) */
  paidPer?: InputMaybe<Scalars['String']['input']>
  parentPricingTier?: InputMaybe<SectionPricingTiersUpdateManyInlineInput>
  priceValue?: InputMaybe<Scalars['Int']['input']>
  /** pricingDescription input for default locale (de) */
  pricingDescription?: InputMaybe<Scalars['String']['input']>
  /** pricingTierRecommendationLabel input for default locale (de) */
  pricingTierRecommendationLabel?: InputMaybe<Scalars['String']['input']>
  /** pricingTierSubTitle input for default locale (de) */
  pricingTierSubTitle?: InputMaybe<Scalars['String']['input']>
  /** pricingTierTitle input for default locale (de) */
  pricingTierTitle?: InputMaybe<Scalars['String']['input']>
  pricingTierTitleIcon?: InputMaybe<SectionPricingTiersTitleIcon>
  /** primaryCtaLabel input for default locale (de) */
  primaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  /** primaryCtaLink input for default locale (de) */
  primaryCtaLink?: InputMaybe<Scalars['String']['input']>
  primaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
  /** secondaryCtaLabel input for default locale (de) */
  secondaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  /** secondaryCtaLink input for default locale (de) */
  secondaryCtaLink?: InputMaybe<Scalars['String']['input']>
  secondaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
}

export type PricingTierUpdateLocalizationDataInput = {
  features?: InputMaybe<Scalars['String']['input']>
  featuresTitle?: InputMaybe<Scalars['String']['input']>
  freeIncentiveBudgetSuffix?: InputMaybe<Scalars['String']['input']>
  freeIncentiveDescription?: InputMaybe<Scalars['String']['input']>
  noPriceBottomline?: InputMaybe<Scalars['String']['input']>
  noPriceTopline?: InputMaybe<Scalars['String']['input']>
  paidPer?: InputMaybe<Scalars['String']['input']>
  pricingDescription?: InputMaybe<Scalars['String']['input']>
  pricingTierRecommendationLabel?: InputMaybe<Scalars['String']['input']>
  pricingTierSubTitle?: InputMaybe<Scalars['String']['input']>
  pricingTierTitle?: InputMaybe<Scalars['String']['input']>
  primaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  primaryCtaLink?: InputMaybe<Scalars['String']['input']>
  secondaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  secondaryCtaLink?: InputMaybe<Scalars['String']['input']>
}

export type PricingTierUpdateLocalizationInput = {
  data: PricingTierUpdateLocalizationDataInput
  locale: Locale
}

export type PricingTierUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PricingTierCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<PricingTierUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<PricingTierUpsertLocalizationInput>>
}

export type PricingTierUpdateManyInlineInput = {
  /** Connect multiple existing PricingTier documents */
  connect?: InputMaybe<Array<PricingTierConnectInput>>
  /** Create and connect multiple PricingTier documents */
  create?: InputMaybe<Array<PricingTierCreateInput>>
  /** Delete multiple PricingTier documents */
  delete?: InputMaybe<Array<PricingTierWhereUniqueInput>>
  /** Disconnect multiple PricingTier documents */
  disconnect?: InputMaybe<Array<PricingTierWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing PricingTier documents */
  set?: InputMaybe<Array<PricingTierWhereUniqueInput>>
  /** Update multiple PricingTier documents */
  update?: InputMaybe<Array<PricingTierUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple PricingTier documents */
  upsert?: InputMaybe<Array<PricingTierUpsertWithNestedWhereUniqueInput>>
}

export type PricingTierUpdateManyInput = {
  /** features input for default locale (de) */
  features?: InputMaybe<Scalars['String']['input']>
  /** featuresTitle input for default locale (de) */
  featuresTitle?: InputMaybe<Scalars['String']['input']>
  freeIncentiveBudget?: InputMaybe<Scalars['Int']['input']>
  /** freeIncentiveBudgetSuffix input for default locale (de) */
  freeIncentiveBudgetSuffix?: InputMaybe<Scalars['String']['input']>
  /** freeIncentiveDescription input for default locale (de) */
  freeIncentiveDescription?: InputMaybe<Scalars['String']['input']>
  hasPrice?: InputMaybe<Scalars['Boolean']['input']>
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<PricingTierUpdateManyLocalizationsInput>
  /** noPriceBottomline input for default locale (de) */
  noPriceBottomline?: InputMaybe<Scalars['String']['input']>
  /** noPriceTopline input for default locale (de) */
  noPriceTopline?: InputMaybe<Scalars['String']['input']>
  /** paidPer input for default locale (de) */
  paidPer?: InputMaybe<Scalars['String']['input']>
  priceValue?: InputMaybe<Scalars['Int']['input']>
  /** pricingDescription input for default locale (de) */
  pricingDescription?: InputMaybe<Scalars['String']['input']>
  /** pricingTierRecommendationLabel input for default locale (de) */
  pricingTierRecommendationLabel?: InputMaybe<Scalars['String']['input']>
  /** pricingTierSubTitle input for default locale (de) */
  pricingTierSubTitle?: InputMaybe<Scalars['String']['input']>
  /** pricingTierTitle input for default locale (de) */
  pricingTierTitle?: InputMaybe<Scalars['String']['input']>
  pricingTierTitleIcon?: InputMaybe<SectionPricingTiersTitleIcon>
  /** primaryCtaLabel input for default locale (de) */
  primaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  /** primaryCtaLink input for default locale (de) */
  primaryCtaLink?: InputMaybe<Scalars['String']['input']>
  primaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
  /** secondaryCtaLabel input for default locale (de) */
  secondaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  /** secondaryCtaLink input for default locale (de) */
  secondaryCtaLink?: InputMaybe<Scalars['String']['input']>
  secondaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
}

export type PricingTierUpdateManyLocalizationDataInput = {
  features?: InputMaybe<Scalars['String']['input']>
  featuresTitle?: InputMaybe<Scalars['String']['input']>
  freeIncentiveBudgetSuffix?: InputMaybe<Scalars['String']['input']>
  freeIncentiveDescription?: InputMaybe<Scalars['String']['input']>
  noPriceBottomline?: InputMaybe<Scalars['String']['input']>
  noPriceTopline?: InputMaybe<Scalars['String']['input']>
  paidPer?: InputMaybe<Scalars['String']['input']>
  pricingDescription?: InputMaybe<Scalars['String']['input']>
  pricingTierRecommendationLabel?: InputMaybe<Scalars['String']['input']>
  pricingTierSubTitle?: InputMaybe<Scalars['String']['input']>
  pricingTierTitle?: InputMaybe<Scalars['String']['input']>
  primaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  primaryCtaLink?: InputMaybe<Scalars['String']['input']>
  secondaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  secondaryCtaLink?: InputMaybe<Scalars['String']['input']>
}

export type PricingTierUpdateManyLocalizationInput = {
  data: PricingTierUpdateManyLocalizationDataInput
  locale: Locale
}

export type PricingTierUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PricingTierUpdateManyLocalizationInput>>
}

export type PricingTierUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PricingTierUpdateManyInput
  /** Document search */
  where: PricingTierWhereInput
}

export type PricingTierUpdateOneInlineInput = {
  /** Connect existing PricingTier document */
  connect?: InputMaybe<PricingTierWhereUniqueInput>
  /** Create and connect one PricingTier document */
  create?: InputMaybe<PricingTierCreateInput>
  /** Delete currently connected PricingTier document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected PricingTier document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single PricingTier document */
  update?: InputMaybe<PricingTierUpdateWithNestedWhereUniqueInput>
  /** Upsert single PricingTier document */
  upsert?: InputMaybe<PricingTierUpsertWithNestedWhereUniqueInput>
}

export type PricingTierUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PricingTierUpdateInput
  /** Unique document search */
  where: PricingTierWhereUniqueInput
}

export type PricingTierUpsertInput = {
  /** Create document if it didn't exist */
  create: PricingTierCreateInput
  /** Update document if it exists */
  update: PricingTierUpdateInput
}

export type PricingTierUpsertLocalizationInput = {
  create: PricingTierCreateLocalizationDataInput
  locale: Locale
  update: PricingTierUpdateLocalizationDataInput
}

export type PricingTierUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PricingTierUpsertInput
  /** Unique document search */
  where: PricingTierWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type PricingTierWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type PricingTierWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PricingTierWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PricingTierWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PricingTierWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<PricingTierWhereStageInput>
  documentInStages_none?: InputMaybe<PricingTierWhereStageInput>
  documentInStages_some?: InputMaybe<PricingTierWhereStageInput>
  features?: InputMaybe<Scalars['String']['input']>
  featuresTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  featuresTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  featuresTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  featuresTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  featuresTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  featuresTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  featuresTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  featuresTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  featuresTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  featuresTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  features_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  features_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  features_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  features_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  features_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  features_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  features_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  features_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  features_starts_with?: InputMaybe<Scalars['String']['input']>
  freeIncentiveBudget?: InputMaybe<Scalars['Int']['input']>
  freeIncentiveBudgetSuffix?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  freeIncentiveBudgetSuffix_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  freeIncentiveBudgetSuffix_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  freeIncentiveBudgetSuffix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  freeIncentiveBudgetSuffix_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  freeIncentiveBudgetSuffix_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  freeIncentiveBudgetSuffix_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  freeIncentiveBudgetSuffix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  freeIncentiveBudgetSuffix_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  freeIncentiveBudgetSuffix_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values greater than the given value. */
  freeIncentiveBudget_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  freeIncentiveBudget_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  freeIncentiveBudget_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  freeIncentiveBudget_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  freeIncentiveBudget_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  freeIncentiveBudget_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  freeIncentiveBudget_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  freeIncentiveDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  freeIncentiveDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  freeIncentiveDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  freeIncentiveDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  freeIncentiveDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  freeIncentiveDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  freeIncentiveDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  freeIncentiveDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  freeIncentiveDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  freeIncentiveDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  hasPrice?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hasPrice_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isRecommended_not?: InputMaybe<Scalars['Boolean']['input']>
  noPriceBottomline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  noPriceBottomline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  noPriceBottomline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  noPriceBottomline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  noPriceBottomline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  noPriceBottomline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  noPriceBottomline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  noPriceBottomline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  noPriceBottomline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  noPriceBottomline_starts_with?: InputMaybe<Scalars['String']['input']>
  noPriceTopline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  noPriceTopline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  noPriceTopline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  noPriceTopline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  noPriceTopline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  noPriceTopline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  noPriceTopline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  noPriceTopline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  noPriceTopline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  noPriceTopline_starts_with?: InputMaybe<Scalars['String']['input']>
  paidPer?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  paidPer_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  paidPer_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  paidPer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  paidPer_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  paidPer_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  paidPer_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  paidPer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  paidPer_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  paidPer_starts_with?: InputMaybe<Scalars['String']['input']>
  priceValue?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  priceValue_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  priceValue_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  priceValue_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  priceValue_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  priceValue_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  priceValue_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  priceValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  pricingDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pricingDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pricingDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pricingDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pricingDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pricingDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pricingDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pricingDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pricingDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pricingDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  pricingTierRecommendationLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pricingTierRecommendationLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pricingTierRecommendationLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pricingTierRecommendationLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pricingTierRecommendationLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pricingTierRecommendationLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pricingTierRecommendationLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pricingTierRecommendationLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pricingTierRecommendationLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pricingTierRecommendationLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  pricingTierSubTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  pricingTierSubTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pricingTierSubTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pricingTierSubTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pricingTierSubTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pricingTierSubTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pricingTierSubTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pricingTierSubTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pricingTierSubTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pricingTierSubTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  pricingTierTitle?: InputMaybe<Scalars['String']['input']>
  pricingTierTitleIcon?: InputMaybe<SectionPricingTiersTitleIcon>
  /** All values that are contained in given list. */
  pricingTierTitleIcon_in?: InputMaybe<Array<InputMaybe<SectionPricingTiersTitleIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  pricingTierTitleIcon_not?: InputMaybe<SectionPricingTiersTitleIcon>
  /** All values that are not contained in given list. */
  pricingTierTitleIcon_not_in?: InputMaybe<Array<InputMaybe<SectionPricingTiersTitleIcon>>>
  /** All values containing the given string. */
  pricingTierTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  pricingTierTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  pricingTierTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  pricingTierTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  pricingTierTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  pricingTierTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  pricingTierTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  pricingTierTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  pricingTierTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  primaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  primaryCtaLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  primaryCtaLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  primaryCtaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  primaryCtaLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  primaryCtaLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  primaryCtaLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  primaryCtaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  primaryCtaLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  primaryCtaLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  primaryCtaLink?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  primaryCtaLink_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  primaryCtaLink_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  primaryCtaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  primaryCtaLink_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  primaryCtaLink_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  primaryCtaLink_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  primaryCtaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  primaryCtaLink_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  primaryCtaLink_starts_with?: InputMaybe<Scalars['String']['input']>
  primaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  primaryCtaTrackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  primaryCtaTrackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  primaryCtaTrackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  primaryCtaTrackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  primaryCtaTrackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  primaryCtaTrackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  primaryCtaTrackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  primaryCtaTrackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  primaryCtaTrackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  secondaryCtaLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  secondaryCtaLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  secondaryCtaLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  secondaryCtaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  secondaryCtaLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  secondaryCtaLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  secondaryCtaLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  secondaryCtaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  secondaryCtaLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  secondaryCtaLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  secondaryCtaLink?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  secondaryCtaLink_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  secondaryCtaLink_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  secondaryCtaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  secondaryCtaLink_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  secondaryCtaLink_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  secondaryCtaLink_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  secondaryCtaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  secondaryCtaLink_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  secondaryCtaLink_starts_with?: InputMaybe<Scalars['String']['input']>
  secondaryCtaTrackingId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  secondaryCtaTrackingId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  secondaryCtaTrackingId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  secondaryCtaTrackingId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  secondaryCtaTrackingId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  secondaryCtaTrackingId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  secondaryCtaTrackingId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  secondaryCtaTrackingId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  secondaryCtaTrackingId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  secondaryCtaTrackingId_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PricingTierWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PricingTierWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PricingTierWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PricingTierWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PricingTierWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References PricingTier record uniquely */
export type PricingTierWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type ProcessStep = Entity & {
  __typename?: 'ProcessStep'
  ctaText?: Maybe<Scalars['String']['output']>
  ctaUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  /** Option to display section decorations, false by default */
  displayDecorations?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<ProcessStep>
  /** Select a custom padding for this section, otherwise default is used. */
  sectionPadding?: Maybe<SectionPadding>
  /** System stage field */
  stage: Stage
  /** Numbered according to the order */
  steps: Array<Scalars['String']['output']>
  styleVariant?: Maybe<ComponentStyle>
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ProcessStepLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type ProcessStepUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type ProcessStepConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ProcessStepWhereUniqueInput
}

/** A connection to a list of items. */
export type ProcessStepConnection = {
  __typename?: 'ProcessStepConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ProcessStepEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ProcessStepCreateInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ProcessStepCreateLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** steps input for default locale (de) */
  steps: Array<Scalars['String']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ProcessStepCreateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  steps: Array<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ProcessStepCreateLocalizationInput = {
  /** Localization input */
  data: ProcessStepCreateLocalizationDataInput
  locale: Locale
}

export type ProcessStepCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ProcessStepCreateLocalizationInput>>
}

export type ProcessStepCreateManyInlineInput = {
  /** Create and connect multiple existing ProcessStep documents */
  create?: InputMaybe<Array<ProcessStepCreateInput>>
}

export type ProcessStepCreateOneInlineInput = {
  /** Create and connect one ProcessStep document */
  create?: InputMaybe<ProcessStepCreateInput>
}

export type ProcessStepCreateWithPositionInput = {
  /** Document to create */
  data: ProcessStepCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type ProcessStepEdge = {
  __typename?: 'ProcessStepEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ProcessStep
}

/** Identifies documents */
export type ProcessStepManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProcessStepWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProcessStepWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProcessStepWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  displayDecorations_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum ProcessStepOrderByInput {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DisplayDecorationsAsc = 'displayDecorations_ASC',
  DisplayDecorationsDesc = 'displayDecorations_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SectionPaddingAsc = 'sectionPadding_ASC',
  SectionPaddingDesc = 'sectionPadding_DESC',
  StepsAsc = 'steps_ASC',
  StepsDesc = 'steps_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ProcessStepParent = EventPage

export type ProcessStepParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type ProcessStepParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type ProcessStepParentCreateManyInlineInput = {
  /** Connect multiple existing ProcessStepParent documents */
  connect?: InputMaybe<Array<ProcessStepParentWhereUniqueInput>>
  /** Create and connect multiple existing ProcessStepParent documents */
  create?: InputMaybe<Array<ProcessStepParentCreateInput>>
}

export type ProcessStepParentCreateOneInlineInput = {
  /** Connect one existing ProcessStepParent document */
  connect?: InputMaybe<ProcessStepParentWhereUniqueInput>
  /** Create and connect one ProcessStepParent document */
  create?: InputMaybe<ProcessStepParentCreateInput>
}

export type ProcessStepParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type ProcessStepParentUpdateManyInlineInput = {
  /** Connect multiple existing ProcessStepParent documents */
  connect?: InputMaybe<Array<ProcessStepParentConnectInput>>
  /** Create and connect multiple ProcessStepParent documents */
  create?: InputMaybe<Array<ProcessStepParentCreateInput>>
  /** Delete multiple ProcessStepParent documents */
  delete?: InputMaybe<Array<ProcessStepParentWhereUniqueInput>>
  /** Disconnect multiple ProcessStepParent documents */
  disconnect?: InputMaybe<Array<ProcessStepParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ProcessStepParent documents */
  set?: InputMaybe<Array<ProcessStepParentWhereUniqueInput>>
  /** Update multiple ProcessStepParent documents */
  update?: InputMaybe<Array<ProcessStepParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ProcessStepParent documents */
  upsert?: InputMaybe<Array<ProcessStepParentUpsertWithNestedWhereUniqueInput>>
}

export type ProcessStepParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type ProcessStepParentUpdateOneInlineInput = {
  /** Connect existing ProcessStepParent document */
  connect?: InputMaybe<ProcessStepParentWhereUniqueInput>
  /** Create and connect one ProcessStepParent document */
  create?: InputMaybe<ProcessStepParentCreateInput>
  /** Delete currently connected ProcessStepParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ProcessStepParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ProcessStepParent document */
  update?: InputMaybe<ProcessStepParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single ProcessStepParent document */
  upsert?: InputMaybe<ProcessStepParentUpsertWithNestedWhereUniqueInput>
}

export type ProcessStepParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type ProcessStepParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type ProcessStepParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type ProcessStepParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type ProcessStepUpdateInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ProcessStepUpdateLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** steps input for default locale (de) */
  steps?: InputMaybe<Array<Scalars['String']['input']>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ProcessStepUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  steps?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ProcessStepUpdateLocalizationInput = {
  data: ProcessStepUpdateLocalizationDataInput
  locale: Locale
}

export type ProcessStepUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ProcessStepCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ProcessStepUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ProcessStepUpsertLocalizationInput>>
}

export type ProcessStepUpdateManyInlineInput = {
  /** Create and connect multiple ProcessStep component instances */
  create?: InputMaybe<Array<ProcessStepCreateWithPositionInput>>
  /** Delete multiple ProcessStep documents */
  delete?: InputMaybe<Array<ProcessStepWhereUniqueInput>>
  /** Update multiple ProcessStep component instances */
  update?: InputMaybe<Array<ProcessStepUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple ProcessStep component instances */
  upsert?: InputMaybe<Array<ProcessStepUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type ProcessStepUpdateManyInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ProcessStepUpdateManyLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** steps input for default locale (de) */
  steps?: InputMaybe<Array<Scalars['String']['input']>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type ProcessStepUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  steps?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ProcessStepUpdateManyLocalizationInput = {
  data: ProcessStepUpdateManyLocalizationDataInput
  locale: Locale
}

export type ProcessStepUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ProcessStepUpdateManyLocalizationInput>>
}

export type ProcessStepUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProcessStepUpdateManyInput
  /** Document search */
  where: ProcessStepWhereInput
}

export type ProcessStepUpdateOneInlineInput = {
  /** Create and connect one ProcessStep document */
  create?: InputMaybe<ProcessStepCreateInput>
  /** Delete currently connected ProcessStep document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ProcessStep document */
  update?: InputMaybe<ProcessStepUpdateWithNestedWhereUniqueInput>
  /** Upsert single ProcessStep document */
  upsert?: InputMaybe<ProcessStepUpsertWithNestedWhereUniqueInput>
}

export type ProcessStepUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ProcessStepUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ProcessStepWhereUniqueInput
}

export type ProcessStepUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProcessStepUpdateInput
  /** Unique document search */
  where: ProcessStepWhereUniqueInput
}

export type ProcessStepUpsertInput = {
  /** Create document if it didn't exist */
  create: ProcessStepCreateInput
  /** Update document if it exists */
  update: ProcessStepUpdateInput
}

export type ProcessStepUpsertLocalizationInput = {
  create: ProcessStepCreateLocalizationDataInput
  locale: Locale
  update: ProcessStepUpdateLocalizationDataInput
}

export type ProcessStepUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ProcessStepUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: ProcessStepWhereUniqueInput
}

export type ProcessStepUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProcessStepUpsertInput
  /** Unique document search */
  where: ProcessStepWhereUniqueInput
}

/** Identifies documents */
export type ProcessStepWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProcessStepWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProcessStepWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProcessStepWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  displayDecorations_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  steps?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  steps_contains_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  steps_contains_none?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  steps_contains_some?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  steps_not?: InputMaybe<Array<Scalars['String']['input']>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References ProcessStep record uniquely */
export type ProcessStepWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Available Product Widgets */
export enum ProductWidgetEnum {
  AlternativeToolsInCategory = 'alternativeToolsInCategory',
  FreeToolsInCategory = 'freeToolsInCategory',
  PaidToolsInCategory = 'paidToolsInCategory',
  TopRatedToolsInCategory = 'topRatedToolsInCategory',
}

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale
  /** Stages to publish selected locales to */
  stages: Array<Stage>
}

export type Query = {
  __typename?: 'Query'
  /** Retrieve a single animatedCounter */
  animatedCounter?: Maybe<AnimatedCounter>
  /** Retrieve document version */
  animatedCounterVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple animatedCounters */
  animatedCounters: Array<AnimatedCounter>
  /** Retrieve multiple animatedCounters using the Relay connection interface */
  animatedCountersConnection: AnimatedCounterConnection
  /** Retrieve a single article */
  article?: Maybe<Article>
  /** Retrieve multiple articleCategories */
  articleCategories: Array<ArticleCategory>
  /** Retrieve multiple articleCategories using the Relay connection interface */
  articleCategoriesConnection: ArticleCategoryConnection
  /** Retrieve a single articleCategory */
  articleCategory?: Maybe<ArticleCategory>
  /** Retrieve document version */
  articleCategoryVersion?: Maybe<DocumentVersion>
  /** Retrieve a single articlePageView */
  articlePageView?: Maybe<ArticlePageView>
  /** Retrieve document version */
  articlePageViewVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple articlePageViews */
  articlePageViews: Array<ArticlePageView>
  /** Retrieve multiple articlePageViews using the Relay connection interface */
  articlePageViewsConnection: ArticlePageViewConnection
  /** Retrieve document version */
  articleVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple articles */
  articles: Array<Article>
  /** Retrieve multiple articles using the Relay connection interface */
  articlesConnection: ArticleConnection
  /** Retrieve a single asset */
  asset?: Maybe<Asset>
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple assets */
  assets: Array<Asset>
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection
  /** Retrieve a single author */
  author?: Maybe<Author>
  /** Retrieve document version */
  authorVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple authors */
  authors: Array<Author>
  /** Retrieve multiple authors using the Relay connection interface */
  authorsConnection: AuthorConnection
  /** Retrieve a single booth */
  booth?: Maybe<Booth>
  /** Retrieve document version */
  boothVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple booths */
  booths: Array<Booth>
  /** Retrieve multiple booths using the Relay connection interface */
  boothsConnection: BoothConnection
  /** Retrieve a single careerPage */
  careerPage?: Maybe<CareerPage>
  /** Retrieve document version */
  careerPageVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple careerPages */
  careerPages: Array<CareerPage>
  /** Retrieve multiple careerPages using the Relay connection interface */
  careerPagesConnection: CareerPageConnection
  /** Retrieve a single contentReference */
  contentReference?: Maybe<ContentReference>
  /** Retrieve document version */
  contentReferenceVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple contentReferences */
  contentReferences: Array<ContentReference>
  /** Retrieve multiple contentReferences using the Relay connection interface */
  contentReferencesConnection: ContentReferenceConnection
  /** Retrieve a single educationReport */
  educationReport?: Maybe<EducationReport>
  /** Retrieve document version */
  educationReportVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple educationReports */
  educationReports: Array<EducationReport>
  /** Retrieve multiple educationReports using the Relay connection interface */
  educationReportsConnection: EducationReportConnection
  /** Retrieve a single educationSeminar */
  educationSeminar?: Maybe<EducationSeminar>
  /** Retrieve document version */
  educationSeminarVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple educationSeminars */
  educationSeminars: Array<EducationSeminar>
  /** Retrieve multiple educationSeminars using the Relay connection interface */
  educationSeminarsConnection: EducationSeminarConnection
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>
  /** Retrieve a single event */
  event?: Maybe<Event>
  /** Retrieve a single eventAppPage */
  eventAppPage?: Maybe<EventAppPage>
  /** Retrieve document version */
  eventAppPageVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple eventAppPages */
  eventAppPages: Array<EventAppPage>
  /** Retrieve multiple eventAppPages using the Relay connection interface */
  eventAppPagesConnection: EventAppPageConnection
  /** Retrieve a single eventPage */
  eventPage?: Maybe<EventPage>
  /** Retrieve document version */
  eventPageVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple eventPages */
  eventPages: Array<EventPage>
  /** Retrieve multiple eventPages using the Relay connection interface */
  eventPagesConnection: EventPageConnection
  /** Retrieve a single eventStage */
  eventStage?: Maybe<EventStage>
  /** Retrieve document version */
  eventStageVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple eventStages */
  eventStages: Array<EventStage>
  /** Retrieve multiple eventStages using the Relay connection interface */
  eventStagesConnection: EventStageConnection
  /** Retrieve document version */
  eventVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple events */
  events: Array<Event>
  /** Retrieve multiple events using the Relay connection interface */
  eventsConnection: EventConnection
  /** Retrieve a single exhibitorListOrder */
  exhibitorListOrder?: Maybe<ExhibitorListOrder>
  /** Retrieve document version */
  exhibitorListOrderVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple exhibitorListOrders */
  exhibitorListOrders: Array<ExhibitorListOrder>
  /** Retrieve multiple exhibitorListOrders using the Relay connection interface */
  exhibitorListOrdersConnection: ExhibitorListOrderConnection
  /** Retrieve a single faqQuestion */
  faqQuestion?: Maybe<FaqQuestion>
  /** Retrieve document version */
  faqQuestionVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple faqQuestions */
  faqQuestions: Array<FaqQuestion>
  /** Retrieve multiple faqQuestions using the Relay connection interface */
  faqQuestionsConnection: FaqQuestionConnection
  /** Retrieve a single footer */
  footer?: Maybe<Footer>
  /** Retrieve document version */
  footerVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple footers */
  footers: Array<Footer>
  /** Retrieve multiple footers using the Relay connection interface */
  footersConnection: FooterConnection
  /** Retrieve multiple glossaries */
  glossaries: Array<Glossary>
  /** Retrieve multiple glossaries using the Relay connection interface */
  glossariesConnection: GlossaryConnection
  /** Retrieve a single glossary */
  glossary?: Maybe<Glossary>
  /** Retrieve document version */
  glossaryVersion?: Maybe<DocumentVersion>
  /** Retrieve a single header */
  header?: Maybe<Header>
  /** Retrieve document version */
  headerVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple headers */
  headers: Array<Header>
  /** Retrieve multiple headers using the Relay connection interface */
  headersConnection: HeaderConnection
  /** Retrieve a single hotel */
  hotel?: Maybe<Hotel>
  /** Retrieve document version */
  hotelVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple hotels */
  hotels: Array<Hotel>
  /** Retrieve multiple hotels using the Relay connection interface */
  hotelsConnection: HotelConnection
  /** Retrieve a single htmlEmbed */
  htmlEmbed?: Maybe<HtmlEmbed>
  /** Retrieve document version */
  htmlEmbedVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple htmlEmbeds */
  htmlEmbeds: Array<HtmlEmbed>
  /** Retrieve multiple htmlEmbeds using the Relay connection interface */
  htmlEmbedsConnection: HtmlEmbedConnection
  /** Retrieve multiple hubContentEntries */
  hubContentEntries: Array<HubContentEntry>
  /** Retrieve multiple hubContentEntries using the Relay connection interface */
  hubContentEntriesConnection: HubContentEntryConnection
  /** Retrieve a single hubContentEntry */
  hubContentEntry?: Maybe<HubContentEntry>
  /** Retrieve document version */
  hubContentEntryVersion?: Maybe<DocumentVersion>
  /** Retrieve a single hubPage */
  hubPage?: Maybe<HubPage>
  /** Retrieve a single hubPageCountdownHero */
  hubPageCountdownHero?: Maybe<HubPageCountdownHero>
  /** Retrieve document version */
  hubPageCountdownHeroVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple hubPageCountdownHeroes */
  hubPageCountdownHeroes: Array<HubPageCountdownHero>
  /** Retrieve multiple hubPageCountdownHeroes using the Relay connection interface */
  hubPageCountdownHeroesConnection: HubPageCountdownHeroConnection
  /** Retrieve document version */
  hubPageVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple hubPages */
  hubPages: Array<HubPage>
  /** Retrieve multiple hubPages using the Relay connection interface */
  hubPagesConnection: HubPageConnection
  /** Retrieve a single imageGalleryEmbed */
  imageGalleryEmbed?: Maybe<ImageGalleryEmbed>
  /** Retrieve document version */
  imageGalleryEmbedVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple imageGalleryEmbeds */
  imageGalleryEmbeds: Array<ImageGalleryEmbed>
  /** Retrieve multiple imageGalleryEmbeds using the Relay connection interface */
  imageGalleryEmbedsConnection: ImageGalleryEmbedConnection
  /** Retrieve a single interest */
  interest?: Maybe<Interest>
  /** Retrieve document version */
  interestVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple interests */
  interests: Array<Interest>
  /** Retrieve multiple interests using the Relay connection interface */
  interestsConnection: InterestConnection
  /** Retrieve a single jobListing */
  jobListing?: Maybe<JobListing>
  /** Retrieve document version */
  jobListingVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple jobListings */
  jobListings: Array<JobListing>
  /** Retrieve multiple jobListings using the Relay connection interface */
  jobListingsConnection: JobListingConnection
  /** Retrieve a single journey */
  journey?: Maybe<Journey>
  /** Retrieve document version */
  journeyVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple journeys */
  journeys: Array<Journey>
  /** Retrieve multiple journeys using the Relay connection interface */
  journeysConnection: JourneyConnection
  /** Retrieve a single landingPage */
  landingPage?: Maybe<LandingPage>
  /** Retrieve document version */
  landingPageVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple landingPages */
  landingPages: Array<LandingPage>
  /** Retrieve multiple landingPages using the Relay connection interface */
  landingPagesConnection: LandingPageConnection
  /** Retrieve a single manageContentConfig */
  manageContentConfig?: Maybe<ManageContentConfig>
  /** Retrieve document version */
  manageContentConfigVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple manageContentConfigs */
  manageContentConfigs: Array<ManageContentConfig>
  /** Retrieve multiple manageContentConfigs using the Relay connection interface */
  manageContentConfigsConnection: ManageContentConfigConnection
  /** Retrieve a single mapMarker */
  mapMarker?: Maybe<MapMarker>
  /** Retrieve a single mapMarkerIcon */
  mapMarkerIcon?: Maybe<MapMarkerIcon>
  /** Retrieve document version */
  mapMarkerIconVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple mapMarkerIcons */
  mapMarkerIcons: Array<MapMarkerIcon>
  /** Retrieve multiple mapMarkerIcons using the Relay connection interface */
  mapMarkerIconsConnection: MapMarkerIconConnection
  /** Retrieve document version */
  mapMarkerVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple mapMarkers */
  mapMarkers: Array<MapMarker>
  /** Retrieve multiple mapMarkers using the Relay connection interface */
  mapMarkersConnection: MapMarkerConnection
  /** Retrieve a single newsletterAudience */
  newsletterAudience?: Maybe<NewsletterAudience>
  /** Retrieve document version */
  newsletterAudienceVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple newsletterAudiences */
  newsletterAudiences: Array<NewsletterAudience>
  /** Retrieve multiple newsletterAudiences using the Relay connection interface */
  newsletterAudiencesConnection: NewsletterAudienceConnection
  /** Fetches an object given its ID */
  node?: Maybe<Node>
  /** Retrieve a single notification */
  notification?: Maybe<Notification>
  /** Retrieve document version */
  notificationVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple notifications */
  notifications: Array<Notification>
  /** Retrieve multiple notifications using the Relay connection interface */
  notificationsConnection: NotificationConnection
  /** Retrieve a single oMRPartner */
  oMRPartner?: Maybe<OmrPartner>
  /** Retrieve document version */
  oMRPartnerVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple oMRPartners */
  oMRPartners: Array<OmrPartner>
  /** Retrieve multiple oMRPartners using the Relay connection interface */
  oMRPartnersConnection: OmrPartnerConnection
  /** Retrieve multiple partnerCompanies */
  partnerCompanies: Array<PartnerCompany>
  /** Retrieve multiple partnerCompanies using the Relay connection interface */
  partnerCompaniesConnection: PartnerCompanyConnection
  /** Retrieve a single partnerCompany */
  partnerCompany?: Maybe<PartnerCompany>
  /** Retrieve document version */
  partnerCompanyVersion?: Maybe<DocumentVersion>
  /** Retrieve a single physicalLocation */
  physicalLocation?: Maybe<PhysicalLocation>
  /** Retrieve document version */
  physicalLocationVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple physicalLocations */
  physicalLocations: Array<PhysicalLocation>
  /** Retrieve multiple physicalLocations using the Relay connection interface */
  physicalLocationsConnection: PhysicalLocationConnection
  /** Retrieve a single podcastEpisode */
  podcastEpisode?: Maybe<PodcastEpisode>
  /** Retrieve document version */
  podcastEpisodeVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple podcastEpisodes */
  podcastEpisodes: Array<PodcastEpisode>
  /** Retrieve multiple podcastEpisodes using the Relay connection interface */
  podcastEpisodesConnection: PodcastEpisodeConnection
  /** Retrieve a single podcastGroup */
  podcastGroup?: Maybe<PodcastGroup>
  /** Retrieve document version */
  podcastGroupVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple podcastGroups */
  podcastGroups: Array<PodcastGroup>
  /** Retrieve multiple podcastGroups using the Relay connection interface */
  podcastGroupsConnection: PodcastGroupConnection
  /** Retrieve a single pricingTier */
  pricingTier?: Maybe<PricingTier>
  /** Retrieve document version */
  pricingTierVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple pricingTiers */
  pricingTiers: Array<PricingTier>
  /** Retrieve multiple pricingTiers using the Relay connection interface */
  pricingTiersConnection: PricingTierConnection
  /** Retrieve a single recommendationFood */
  recommendationFood?: Maybe<RecommendationFood>
  /** Retrieve document version */
  recommendationFoodVersion?: Maybe<DocumentVersion>
  /** Retrieve a single recommendationNightOut */
  recommendationNightOut?: Maybe<RecommendationNightOut>
  /** Retrieve document version */
  recommendationNightOutVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple recommendationsFood */
  recommendationsFood: Array<RecommendationFood>
  /** Retrieve multiple recommendationsFood using the Relay connection interface */
  recommendationsFoodConnection: RecommendationFoodConnection
  /** Retrieve multiple recommendationsNightOut */
  recommendationsNightOut: Array<RecommendationNightOut>
  /** Retrieve multiple recommendationsNightOut using the Relay connection interface */
  recommendationsNightOutConnection: RecommendationNightOutConnection
  /** Retrieve multiple reviewsAgencies */
  reviewsAgencies: Array<ReviewsAgency>
  /** Retrieve multiple reviewsAgencies using the Relay connection interface */
  reviewsAgenciesConnection: ReviewsAgencyConnection
  /** Retrieve a single reviewsAgency */
  reviewsAgency?: Maybe<ReviewsAgency>
  /** Retrieve document version */
  reviewsAgencyVersion?: Maybe<DocumentVersion>
  /** Retrieve a single reviewsFeatureRow */
  reviewsFeatureRow?: Maybe<ReviewsFeatureRow>
  /** Retrieve document version */
  reviewsFeatureRowVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple reviewsFeatureRows */
  reviewsFeatureRows: Array<ReviewsFeatureRow>
  /** Retrieve multiple reviewsFeatureRows using the Relay connection interface */
  reviewsFeatureRowsConnection: ReviewsFeatureRowConnection
  /** Retrieve a single reviewsFeaturesSection */
  reviewsFeaturesSection?: Maybe<ReviewsFeaturesSection>
  /** Retrieve document version */
  reviewsFeaturesSectionVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple reviewsFeaturesSections */
  reviewsFeaturesSections: Array<ReviewsFeaturesSection>
  /** Retrieve multiple reviewsFeaturesSections using the Relay connection interface */
  reviewsFeaturesSectionsConnection: ReviewsFeaturesSectionConnection
  /** Retrieve a single reviewsProduct */
  reviewsProduct?: Maybe<ReviewsProduct>
  /** Retrieve multiple reviewsProductCategories */
  reviewsProductCategories: Array<ReviewsProductCategory>
  /** Retrieve multiple reviewsProductCategories using the Relay connection interface */
  reviewsProductCategoriesConnection: ReviewsProductCategoryConnection
  /** Retrieve a single reviewsProductCategory */
  reviewsProductCategory?: Maybe<ReviewsProductCategory>
  /** Retrieve document version */
  reviewsProductCategoryVersion?: Maybe<DocumentVersion>
  /** Retrieve document version */
  reviewsProductVersion?: Maybe<DocumentVersion>
  /** Retrieve a single reviewsProductWidget */
  reviewsProductWidget?: Maybe<ReviewsProductWidget>
  /** Retrieve document version */
  reviewsProductWidgetVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple reviewsProductWidgets */
  reviewsProductWidgets: Array<ReviewsProductWidget>
  /** Retrieve multiple reviewsProductWidgets using the Relay connection interface */
  reviewsProductWidgetsConnection: ReviewsProductWidgetConnection
  /** Retrieve multiple reviewsProducts */
  reviewsProducts: Array<ReviewsProduct>
  /** Retrieve multiple reviewsProducts using the Relay connection interface */
  reviewsProductsConnection: ReviewsProductConnection
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection
  /** Retrieve a single siteSection */
  siteSection?: Maybe<SiteSection>
  /** Retrieve document version */
  siteSectionVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple siteSections */
  siteSections: Array<SiteSection>
  /** Retrieve multiple siteSections using the Relay connection interface */
  siteSectionsConnection: SiteSectionConnection
  /** Retrieve a single socialEmbed */
  socialEmbed?: Maybe<SocialEmbed>
  /** Retrieve document version */
  socialEmbedVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple socialEmbeds */
  socialEmbeds: Array<SocialEmbed>
  /** Retrieve multiple socialEmbeds using the Relay connection interface */
  socialEmbedsConnection: SocialEmbedConnection
  /** Retrieve a single speaker */
  speaker?: Maybe<Speaker>
  /** Retrieve a single speakerListOrder */
  speakerListOrder?: Maybe<SpeakerListOrder>
  /** Retrieve document version */
  speakerListOrderVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple speakerListOrders */
  speakerListOrders: Array<SpeakerListOrder>
  /** Retrieve multiple speakerListOrders using the Relay connection interface */
  speakerListOrdersConnection: SpeakerListOrderConnection
  /** Retrieve document version */
  speakerVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple speakers */
  speakers: Array<Speaker>
  /** Retrieve multiple speakers using the Relay connection interface */
  speakersConnection: SpeakerConnection
  /** Retrieve a single tabContent */
  tabContent?: Maybe<TabContent>
  /** Retrieve document version */
  tabContentVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple tabContents */
  tabContents: Array<TabContent>
  /** Retrieve multiple tabContents using the Relay connection interface */
  tabContentsConnection: TabContentConnection
  /** Retrieve a single tag */
  tag?: Maybe<Tag>
  /** Retrieve document version */
  tagVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple tags */
  tags: Array<Tag>
  /** Retrieve multiple tags using the Relay connection interface */
  tagsConnection: TagConnection
  /** Retrieve a single ticketsTableColumn */
  ticketsTableColumn?: Maybe<TicketsTableColumn>
  /** Retrieve document version */
  ticketsTableColumnVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple ticketsTableColumns */
  ticketsTableColumns: Array<TicketsTableColumn>
  /** Retrieve multiple ticketsTableColumns using the Relay connection interface */
  ticketsTableColumnsConnection: TicketsTableColumnConnection
  /** Retrieve a single topicPage */
  topicPage?: Maybe<TopicPage>
  /** Retrieve multiple topicPageCategories */
  topicPageCategories: Array<TopicPageCategory>
  /** Retrieve multiple topicPageCategories using the Relay connection interface */
  topicPageCategoriesConnection: TopicPageCategoryConnection
  /** Retrieve a single topicPageCategory */
  topicPageCategory?: Maybe<TopicPageCategory>
  /** Retrieve document version */
  topicPageCategoryVersion?: Maybe<DocumentVersion>
  /** Retrieve document version */
  topicPageVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple topicPages */
  topicPages: Array<TopicPage>
  /** Retrieve multiple topicPages using the Relay connection interface */
  topicPagesConnection: TopicPageConnection
  /** Retrieve a single user */
  user?: Maybe<User>
  /** Retrieve multiple users */
  users: Array<User>
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection
  /** Retrieve a single vGWort */
  vGWort?: Maybe<VgWort>
  /** Retrieve document version */
  vGWortVersion?: Maybe<DocumentVersion>
  /** Retrieve multiple vGWorts */
  vGWorts: Array<VgWort>
  /** Retrieve multiple vGWorts using the Relay connection interface */
  vGWortsConnection: VgWortConnection
}

export type QueryAnimatedCounterArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: AnimatedCounterWhereUniqueInput
}

export type QueryAnimatedCounterVersionArgs = {
  where: VersionWhereInput
}

export type QueryAnimatedCountersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<AnimatedCounterOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<AnimatedCounterWhereInput>
}

export type QueryAnimatedCountersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<AnimatedCounterOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<AnimatedCounterWhereInput>
}

export type QueryArticleArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ArticleWhereUniqueInput
}

export type QueryArticleCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ArticleCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ArticleCategoryWhereInput>
}

export type QueryArticleCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ArticleCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ArticleCategoryWhereInput>
}

export type QueryArticleCategoryArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ArticleCategoryWhereUniqueInput
}

export type QueryArticleCategoryVersionArgs = {
  where: VersionWhereInput
}

export type QueryArticlePageViewArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ArticlePageViewWhereUniqueInput
}

export type QueryArticlePageViewVersionArgs = {
  where: VersionWhereInput
}

export type QueryArticlePageViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ArticlePageViewOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ArticlePageViewWhereInput>
}

export type QueryArticlePageViewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ArticlePageViewOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ArticlePageViewWhereInput>
}

export type QueryArticleVersionArgs = {
  where: VersionWhereInput
}

export type QueryArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ArticleWhereInput>
}

export type QueryArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ArticleWhereInput>
}

export type QueryAssetArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: AssetWhereUniqueInput
}

export type QueryAssetVersionArgs = {
  where: VersionWhereInput
}

export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<AssetOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<AssetWhereInput>
}

export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<AssetOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<AssetWhereInput>
}

export type QueryAuthorArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: AuthorWhereUniqueInput
}

export type QueryAuthorVersionArgs = {
  where: VersionWhereInput
}

export type QueryAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<AuthorOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<AuthorWhereInput>
}

export type QueryAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<AuthorOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<AuthorWhereInput>
}

export type QueryBoothArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: BoothWhereUniqueInput
}

export type QueryBoothVersionArgs = {
  where: VersionWhereInput
}

export type QueryBoothsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<BoothOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<BoothWhereInput>
}

export type QueryBoothsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<BoothOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<BoothWhereInput>
}

export type QueryCareerPageArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: CareerPageWhereUniqueInput
}

export type QueryCareerPageVersionArgs = {
  where: VersionWhereInput
}

export type QueryCareerPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<CareerPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<CareerPageWhereInput>
}

export type QueryCareerPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<CareerPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<CareerPageWhereInput>
}

export type QueryContentReferenceArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ContentReferenceWhereUniqueInput
}

export type QueryContentReferenceVersionArgs = {
  where: VersionWhereInput
}

export type QueryContentReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ContentReferenceOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ContentReferenceWhereInput>
}

export type QueryContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ContentReferenceOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ContentReferenceWhereInput>
}

export type QueryEducationReportArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: EducationReportWhereUniqueInput
}

export type QueryEducationReportVersionArgs = {
  where: VersionWhereInput
}

export type QueryEducationReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EducationReportOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EducationReportWhereInput>
}

export type QueryEducationReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EducationReportOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EducationReportWhereInput>
}

export type QueryEducationSeminarArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: EducationSeminarWhereUniqueInput
}

export type QueryEducationSeminarVersionArgs = {
  where: VersionWhereInput
}

export type QueryEducationSeminarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EducationSeminarOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EducationSeminarWhereInput>
}

export type QueryEducationSeminarsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EducationSeminarOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EducationSeminarWhereInput>
}

export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>
  where: Array<EntityWhereInput>
}

export type QueryEventArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: EventWhereUniqueInput
}

export type QueryEventAppPageArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: EventAppPageWhereUniqueInput
}

export type QueryEventAppPageVersionArgs = {
  where: VersionWhereInput
}

export type QueryEventAppPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EventAppPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EventAppPageWhereInput>
}

export type QueryEventAppPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EventAppPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EventAppPageWhereInput>
}

export type QueryEventPageArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: EventPageWhereUniqueInput
}

export type QueryEventPageVersionArgs = {
  where: VersionWhereInput
}

export type QueryEventPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EventPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EventPageWhereInput>
}

export type QueryEventPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EventPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EventPageWhereInput>
}

export type QueryEventStageArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: EventStageWhereUniqueInput
}

export type QueryEventStageVersionArgs = {
  where: VersionWhereInput
}

export type QueryEventStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EventStageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EventStageWhereInput>
}

export type QueryEventStagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EventStageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EventStageWhereInput>
}

export type QueryEventVersionArgs = {
  where: VersionWhereInput
}

export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EventOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EventWhereInput>
}

export type QueryEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<EventOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<EventWhereInput>
}

export type QueryExhibitorListOrderArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ExhibitorListOrderWhereUniqueInput
}

export type QueryExhibitorListOrderVersionArgs = {
  where: VersionWhereInput
}

export type QueryExhibitorListOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ExhibitorListOrderOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ExhibitorListOrderWhereInput>
}

export type QueryExhibitorListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ExhibitorListOrderOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ExhibitorListOrderWhereInput>
}

export type QueryFaqQuestionArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: FaqQuestionWhereUniqueInput
}

export type QueryFaqQuestionVersionArgs = {
  where: VersionWhereInput
}

export type QueryFaqQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<FaqQuestionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<FaqQuestionWhereInput>
}

export type QueryFaqQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<FaqQuestionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<FaqQuestionWhereInput>
}

export type QueryFooterArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: FooterWhereUniqueInput
}

export type QueryFooterVersionArgs = {
  where: VersionWhereInput
}

export type QueryFootersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<FooterOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<FooterWhereInput>
}

export type QueryFootersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<FooterOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<FooterWhereInput>
}

export type QueryGlossariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<GlossaryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<GlossaryWhereInput>
}

export type QueryGlossariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<GlossaryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<GlossaryWhereInput>
}

export type QueryGlossaryArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: GlossaryWhereUniqueInput
}

export type QueryGlossaryVersionArgs = {
  where: VersionWhereInput
}

export type QueryHeaderArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: HeaderWhereUniqueInput
}

export type QueryHeaderVersionArgs = {
  where: VersionWhereInput
}

export type QueryHeadersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HeaderOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HeaderWhereInput>
}

export type QueryHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HeaderOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HeaderWhereInput>
}

export type QueryHotelArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: HotelWhereUniqueInput
}

export type QueryHotelVersionArgs = {
  where: VersionWhereInput
}

export type QueryHotelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HotelOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HotelWhereInput>
}

export type QueryHotelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HotelOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HotelWhereInput>
}

export type QueryHtmlEmbedArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: HtmlEmbedWhereUniqueInput
}

export type QueryHtmlEmbedVersionArgs = {
  where: VersionWhereInput
}

export type QueryHtmlEmbedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HtmlEmbedOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HtmlEmbedWhereInput>
}

export type QueryHtmlEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HtmlEmbedOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HtmlEmbedWhereInput>
}

export type QueryHubContentEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HubContentEntryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HubContentEntryWhereInput>
}

export type QueryHubContentEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HubContentEntryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HubContentEntryWhereInput>
}

export type QueryHubContentEntryArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: HubContentEntryWhereUniqueInput
}

export type QueryHubContentEntryVersionArgs = {
  where: VersionWhereInput
}

export type QueryHubPageArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: HubPageWhereUniqueInput
}

export type QueryHubPageCountdownHeroArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: HubPageCountdownHeroWhereUniqueInput
}

export type QueryHubPageCountdownHeroVersionArgs = {
  where: VersionWhereInput
}

export type QueryHubPageCountdownHeroesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HubPageCountdownHeroOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HubPageCountdownHeroWhereInput>
}

export type QueryHubPageCountdownHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HubPageCountdownHeroOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HubPageCountdownHeroWhereInput>
}

export type QueryHubPageVersionArgs = {
  where: VersionWhereInput
}

export type QueryHubPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HubPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HubPageWhereInput>
}

export type QueryHubPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<HubPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<HubPageWhereInput>
}

export type QueryImageGalleryEmbedArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ImageGalleryEmbedWhereUniqueInput
}

export type QueryImageGalleryEmbedVersionArgs = {
  where: VersionWhereInput
}

export type QueryImageGalleryEmbedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ImageGalleryEmbedOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ImageGalleryEmbedWhereInput>
}

export type QueryImageGalleryEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ImageGalleryEmbedOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ImageGalleryEmbedWhereInput>
}

export type QueryInterestArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: InterestWhereUniqueInput
}

export type QueryInterestVersionArgs = {
  where: VersionWhereInput
}

export type QueryInterestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<InterestWhereInput>
}

export type QueryInterestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<InterestWhereInput>
}

export type QueryJobListingArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: JobListingWhereUniqueInput
}

export type QueryJobListingVersionArgs = {
  where: VersionWhereInput
}

export type QueryJobListingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<JobListingOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<JobListingWhereInput>
}

export type QueryJobListingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<JobListingOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<JobListingWhereInput>
}

export type QueryJourneyArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: JourneyWhereUniqueInput
}

export type QueryJourneyVersionArgs = {
  where: VersionWhereInput
}

export type QueryJourneysArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<JourneyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<JourneyWhereInput>
}

export type QueryJourneysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<JourneyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<JourneyWhereInput>
}

export type QueryLandingPageArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: LandingPageWhereUniqueInput
}

export type QueryLandingPageVersionArgs = {
  where: VersionWhereInput
}

export type QueryLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<LandingPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<LandingPageWhereInput>
}

export type QueryLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<LandingPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<LandingPageWhereInput>
}

export type QueryManageContentConfigArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ManageContentConfigWhereUniqueInput
}

export type QueryManageContentConfigVersionArgs = {
  where: VersionWhereInput
}

export type QueryManageContentConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ManageContentConfigOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ManageContentConfigWhereInput>
}

export type QueryManageContentConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ManageContentConfigOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ManageContentConfigWhereInput>
}

export type QueryMapMarkerArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: MapMarkerWhereUniqueInput
}

export type QueryMapMarkerIconArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: MapMarkerIconWhereUniqueInput
}

export type QueryMapMarkerIconVersionArgs = {
  where: VersionWhereInput
}

export type QueryMapMarkerIconsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<MapMarkerIconOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<MapMarkerIconWhereInput>
}

export type QueryMapMarkerIconsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<MapMarkerIconOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<MapMarkerIconWhereInput>
}

export type QueryMapMarkerVersionArgs = {
  where: VersionWhereInput
}

export type QueryMapMarkersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<MapMarkerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<MapMarkerWhereInput>
}

export type QueryMapMarkersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<MapMarkerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<MapMarkerWhereInput>
}

export type QueryNewsletterAudienceArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: NewsletterAudienceWhereUniqueInput
}

export type QueryNewsletterAudienceVersionArgs = {
  where: VersionWhereInput
}

export type QueryNewsletterAudiencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<NewsletterAudienceOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<NewsletterAudienceWhereInput>
}

export type QueryNewsletterAudiencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<NewsletterAudienceOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<NewsletterAudienceWhereInput>
}

export type QueryNodeArgs = {
  id: Scalars['ID']['input']
  locales?: Array<Locale>
  stage?: Stage
}

export type QueryNotificationArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: NotificationWhereUniqueInput
}

export type QueryNotificationVersionArgs = {
  where: VersionWhereInput
}

export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<NotificationOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<NotificationWhereInput>
}

export type QueryNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<NotificationOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<NotificationWhereInput>
}

export type QueryOMrPartnerArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: OmrPartnerWhereUniqueInput
}

export type QueryOMrPartnerVersionArgs = {
  where: VersionWhereInput
}

export type QueryOMrPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<OmrPartnerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<OmrPartnerWhereInput>
}

export type QueryOMrPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<OmrPartnerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<OmrPartnerWhereInput>
}

export type QueryPartnerCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PartnerCompanyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PartnerCompanyWhereInput>
}

export type QueryPartnerCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PartnerCompanyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PartnerCompanyWhereInput>
}

export type QueryPartnerCompanyArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: PartnerCompanyWhereUniqueInput
}

export type QueryPartnerCompanyVersionArgs = {
  where: VersionWhereInput
}

export type QueryPhysicalLocationArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: PhysicalLocationWhereUniqueInput
}

export type QueryPhysicalLocationVersionArgs = {
  where: VersionWhereInput
}

export type QueryPhysicalLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PhysicalLocationOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PhysicalLocationWhereInput>
}

export type QueryPhysicalLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PhysicalLocationOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PhysicalLocationWhereInput>
}

export type QueryPodcastEpisodeArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: PodcastEpisodeWhereUniqueInput
}

export type QueryPodcastEpisodeVersionArgs = {
  where: VersionWhereInput
}

export type QueryPodcastEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PodcastEpisodeWhereInput>
}

export type QueryPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PodcastEpisodeWhereInput>
}

export type QueryPodcastGroupArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: PodcastGroupWhereUniqueInput
}

export type QueryPodcastGroupVersionArgs = {
  where: VersionWhereInput
}

export type QueryPodcastGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PodcastGroupOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PodcastGroupWhereInput>
}

export type QueryPodcastGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PodcastGroupOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PodcastGroupWhereInput>
}

export type QueryPricingTierArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: PricingTierWhereUniqueInput
}

export type QueryPricingTierVersionArgs = {
  where: VersionWhereInput
}

export type QueryPricingTiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PricingTierOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PricingTierWhereInput>
}

export type QueryPricingTiersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<PricingTierOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<PricingTierWhereInput>
}

export type QueryRecommendationFoodArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: RecommendationFoodWhereUniqueInput
}

export type QueryRecommendationFoodVersionArgs = {
  where: VersionWhereInput
}

export type QueryRecommendationNightOutArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: RecommendationNightOutWhereUniqueInput
}

export type QueryRecommendationNightOutVersionArgs = {
  where: VersionWhereInput
}

export type QueryRecommendationsFoodArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<RecommendationFoodOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<RecommendationFoodWhereInput>
}

export type QueryRecommendationsFoodConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<RecommendationFoodOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<RecommendationFoodWhereInput>
}

export type QueryRecommendationsNightOutArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<RecommendationNightOutOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<RecommendationNightOutWhereInput>
}

export type QueryRecommendationsNightOutConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<RecommendationNightOutOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<RecommendationNightOutWhereInput>
}

export type QueryReviewsAgenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsAgencyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsAgencyWhereInput>
}

export type QueryReviewsAgenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsAgencyOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsAgencyWhereInput>
}

export type QueryReviewsAgencyArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ReviewsAgencyWhereUniqueInput
}

export type QueryReviewsAgencyVersionArgs = {
  where: VersionWhereInput
}

export type QueryReviewsFeatureRowArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ReviewsFeatureRowWhereUniqueInput
}

export type QueryReviewsFeatureRowVersionArgs = {
  where: VersionWhereInput
}

export type QueryReviewsFeatureRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsFeatureRowOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsFeatureRowWhereInput>
}

export type QueryReviewsFeatureRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsFeatureRowOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsFeatureRowWhereInput>
}

export type QueryReviewsFeaturesSectionArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ReviewsFeaturesSectionWhereUniqueInput
}

export type QueryReviewsFeaturesSectionVersionArgs = {
  where: VersionWhereInput
}

export type QueryReviewsFeaturesSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsFeaturesSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsFeaturesSectionWhereInput>
}

export type QueryReviewsFeaturesSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsFeaturesSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsFeaturesSectionWhereInput>
}

export type QueryReviewsProductArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ReviewsProductWhereUniqueInput
}

export type QueryReviewsProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsProductCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsProductCategoryWhereInput>
}

export type QueryReviewsProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsProductCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsProductCategoryWhereInput>
}

export type QueryReviewsProductCategoryArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ReviewsProductCategoryWhereUniqueInput
}

export type QueryReviewsProductCategoryVersionArgs = {
  where: VersionWhereInput
}

export type QueryReviewsProductVersionArgs = {
  where: VersionWhereInput
}

export type QueryReviewsProductWidgetArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ReviewsProductWidgetWhereUniqueInput
}

export type QueryReviewsProductWidgetVersionArgs = {
  where: VersionWhereInput
}

export type QueryReviewsProductWidgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsProductWidgetOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsProductWidgetWhereInput>
}

export type QueryReviewsProductWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsProductWidgetOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsProductWidgetWhereInput>
}

export type QueryReviewsProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsProductOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsProductWhereInput>
}

export type QueryReviewsProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ReviewsProductOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ReviewsProductWhereInput>
}

export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ScheduledOperationWhereUniqueInput
}

export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: ScheduledReleaseWhereUniqueInput
}

export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ScheduledReleaseWhereInput>
}

export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<ScheduledReleaseWhereInput>
}

export type QuerySiteSectionArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: SiteSectionWhereUniqueInput
}

export type QuerySiteSectionVersionArgs = {
  where: VersionWhereInput
}

export type QuerySiteSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<SiteSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<SiteSectionWhereInput>
}

export type QuerySiteSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<SiteSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<SiteSectionWhereInput>
}

export type QuerySocialEmbedArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: SocialEmbedWhereUniqueInput
}

export type QuerySocialEmbedVersionArgs = {
  where: VersionWhereInput
}

export type QuerySocialEmbedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<SocialEmbedOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<SocialEmbedWhereInput>
}

export type QuerySocialEmbedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<SocialEmbedOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<SocialEmbedWhereInput>
}

export type QuerySpeakerArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: SpeakerWhereUniqueInput
}

export type QuerySpeakerListOrderArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: SpeakerListOrderWhereUniqueInput
}

export type QuerySpeakerListOrderVersionArgs = {
  where: VersionWhereInput
}

export type QuerySpeakerListOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<SpeakerListOrderOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<SpeakerListOrderWhereInput>
}

export type QuerySpeakerListOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<SpeakerListOrderOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<SpeakerListOrderWhereInput>
}

export type QuerySpeakerVersionArgs = {
  where: VersionWhereInput
}

export type QuerySpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<SpeakerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<SpeakerWhereInput>
}

export type QuerySpeakersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<SpeakerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<SpeakerWhereInput>
}

export type QueryTabContentArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: TabContentWhereUniqueInput
}

export type QueryTabContentVersionArgs = {
  where: VersionWhereInput
}

export type QueryTabContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TabContentOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TabContentWhereInput>
}

export type QueryTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TabContentOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TabContentWhereInput>
}

export type QueryTagArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: TagWhereUniqueInput
}

export type QueryTagVersionArgs = {
  where: VersionWhereInput
}

export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TagOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TagWhereInput>
}

export type QueryTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TagOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TagWhereInput>
}

export type QueryTicketsTableColumnArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: TicketsTableColumnWhereUniqueInput
}

export type QueryTicketsTableColumnVersionArgs = {
  where: VersionWhereInput
}

export type QueryTicketsTableColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TicketsTableColumnOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TicketsTableColumnWhereInput>
}

export type QueryTicketsTableColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TicketsTableColumnOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TicketsTableColumnWhereInput>
}

export type QueryTopicPageArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: TopicPageWhereUniqueInput
}

export type QueryTopicPageCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TopicPageCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TopicPageCategoryWhereInput>
}

export type QueryTopicPageCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TopicPageCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TopicPageCategoryWhereInput>
}

export type QueryTopicPageCategoryArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: TopicPageCategoryWhereUniqueInput
}

export type QueryTopicPageCategoryVersionArgs = {
  where: VersionWhereInput
}

export type QueryTopicPageVersionArgs = {
  where: VersionWhereInput
}

export type QueryTopicPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TopicPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TopicPageWhereInput>
}

export type QueryTopicPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<TopicPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<TopicPageWhereInput>
}

export type QueryUserArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: UserWhereUniqueInput
}

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<UserOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<UserWhereInput>
}

export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<UserOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<UserWhereInput>
}

export type QueryVgWortArgs = {
  locales?: Array<Locale>
  stage?: Stage
  where: VgWortWhereUniqueInput
}

export type QueryVgWortVersionArgs = {
  where: VersionWhereInput
}

export type QueryVgWortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<VgWortOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<VgWortWhereInput>
}

export type QueryVgWortsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: Array<Locale>
  orderBy?: InputMaybe<VgWortOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  stage?: Stage
  where?: InputMaybe<VgWortWhereInput>
}

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA'
  a: Scalars['RGBATransparency']['output']
  b: Scalars['RGBAHue']['output']
  g: Scalars['RGBAHue']['output']
  r: Scalars['RGBAHue']['output']
}

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency']['input']
  b: Scalars['RGBAHue']['input']
  g: Scalars['RGBAHue']['input']
  r: Scalars['RGBAHue']['input']
}

/** a stand with food at the festival */
export type RecommendationFood = Entity &
  Node & {
    __typename?: 'RecommendationFood'
    /** for example A0 FT11.05 */
    boothNumber?: Maybe<Scalars['String']['output']>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** label for CTA link */
    ctaText?: Maybe<Scalars['String']['output']>
    /** link target for CTA */
    ctaUrl?: Maybe<Scalars['String']['output']>
    /** a short description of the food stand */
    description: Scalars['String']['output']
    /** Get the document in other stages */
    documentInStages: Array<RecommendationFood>
    /** List of RecommendationFood versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<RecommendationFood>
    /** the name of the stand */
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    typeOfFood: Array<FestivalFoodType>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** a stand with food at the festival */
export type RecommendationFoodCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** a stand with food at the festival */
export type RecommendationFoodCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** a stand with food at the festival */
export type RecommendationFoodDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** a stand with food at the festival */
export type RecommendationFoodHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** a stand with food at the festival */
export type RecommendationFoodLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** a stand with food at the festival */
export type RecommendationFoodPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** a stand with food at the festival */
export type RecommendationFoodPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** a stand with food at the festival */
export type RecommendationFoodScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** a stand with food at the festival */
export type RecommendationFoodUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** a stand with food at the festival */
export type RecommendationFoodUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type RecommendationFoodConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: RecommendationFoodWhereUniqueInput
}

/** A connection to a list of items. */
export type RecommendationFoodConnection = {
  __typename?: 'RecommendationFoodConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<RecommendationFoodEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RecommendationFoodCreateInput = {
  boothNumber?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<RecommendationFoodCreateLocalizationsInput>
  name: Scalars['String']['input']
  typeOfFood?: InputMaybe<Array<FestivalFoodType>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type RecommendationFoodCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type RecommendationFoodCreateLocalizationInput = {
  /** Localization input */
  data: RecommendationFoodCreateLocalizationDataInput
  locale: Locale
}

export type RecommendationFoodCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<RecommendationFoodCreateLocalizationInput>>
}

export type RecommendationFoodCreateManyInlineInput = {
  /** Connect multiple existing RecommendationFood documents */
  connect?: InputMaybe<Array<RecommendationFoodWhereUniqueInput>>
  /** Create and connect multiple existing RecommendationFood documents */
  create?: InputMaybe<Array<RecommendationFoodCreateInput>>
}

export type RecommendationFoodCreateOneInlineInput = {
  /** Connect one existing RecommendationFood document */
  connect?: InputMaybe<RecommendationFoodWhereUniqueInput>
  /** Create and connect one RecommendationFood document */
  create?: InputMaybe<RecommendationFoodCreateInput>
}

/** An edge in a connection. */
export type RecommendationFoodEdge = {
  __typename?: 'RecommendationFoodEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: RecommendationFood
}

/** Identifies documents */
export type RecommendationFoodManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecommendationFoodWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecommendationFoodWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecommendationFoodWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  boothNumber?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  boothNumber_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  boothNumber_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  boothNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  boothNumber_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  boothNumber_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  boothNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  boothNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  boothNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  boothNumber_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<RecommendationFoodWhereStageInput>
  documentInStages_none?: InputMaybe<RecommendationFoodWhereStageInput>
  documentInStages_some?: InputMaybe<RecommendationFoodWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  typeOfFood?: InputMaybe<Array<FestivalFoodType>>
  /** Matches if the field array contains *all* items provided to the filter */
  typeOfFood_contains_all?: InputMaybe<Array<FestivalFoodType>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  typeOfFood_contains_none?: InputMaybe<Array<FestivalFoodType>>
  /** Matches if the field array contains at least one item provided to the filter */
  typeOfFood_contains_some?: InputMaybe<Array<FestivalFoodType>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  typeOfFood_not?: InputMaybe<Array<FestivalFoodType>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum RecommendationFoodOrderByInput {
  BoothNumberAsc = 'boothNumber_ASC',
  BoothNumberDesc = 'boothNumber_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TypeOfFoodAsc = 'typeOfFood_ASC',
  TypeOfFoodDesc = 'typeOfFood_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type RecommendationFoodUpdateInput = {
  boothNumber?: InputMaybe<Scalars['String']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<RecommendationFoodUpdateLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  typeOfFood?: InputMaybe<Array<FestivalFoodType>>
}

export type RecommendationFoodUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
}

export type RecommendationFoodUpdateLocalizationInput = {
  data: RecommendationFoodUpdateLocalizationDataInput
  locale: Locale
}

export type RecommendationFoodUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<RecommendationFoodCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<RecommendationFoodUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<RecommendationFoodUpsertLocalizationInput>>
}

export type RecommendationFoodUpdateManyInlineInput = {
  /** Connect multiple existing RecommendationFood documents */
  connect?: InputMaybe<Array<RecommendationFoodConnectInput>>
  /** Create and connect multiple RecommendationFood documents */
  create?: InputMaybe<Array<RecommendationFoodCreateInput>>
  /** Delete multiple RecommendationFood documents */
  delete?: InputMaybe<Array<RecommendationFoodWhereUniqueInput>>
  /** Disconnect multiple RecommendationFood documents */
  disconnect?: InputMaybe<Array<RecommendationFoodWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing RecommendationFood documents */
  set?: InputMaybe<Array<RecommendationFoodWhereUniqueInput>>
  /** Update multiple RecommendationFood documents */
  update?: InputMaybe<Array<RecommendationFoodUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple RecommendationFood documents */
  upsert?: InputMaybe<Array<RecommendationFoodUpsertWithNestedWhereUniqueInput>>
}

export type RecommendationFoodUpdateManyInput = {
  boothNumber?: InputMaybe<Scalars['String']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<RecommendationFoodUpdateManyLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  typeOfFood?: InputMaybe<Array<FestivalFoodType>>
}

export type RecommendationFoodUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
}

export type RecommendationFoodUpdateManyLocalizationInput = {
  data: RecommendationFoodUpdateManyLocalizationDataInput
  locale: Locale
}

export type RecommendationFoodUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<RecommendationFoodUpdateManyLocalizationInput>>
}

export type RecommendationFoodUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecommendationFoodUpdateManyInput
  /** Document search */
  where: RecommendationFoodWhereInput
}

export type RecommendationFoodUpdateOneInlineInput = {
  /** Connect existing RecommendationFood document */
  connect?: InputMaybe<RecommendationFoodWhereUniqueInput>
  /** Create and connect one RecommendationFood document */
  create?: InputMaybe<RecommendationFoodCreateInput>
  /** Delete currently connected RecommendationFood document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected RecommendationFood document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single RecommendationFood document */
  update?: InputMaybe<RecommendationFoodUpdateWithNestedWhereUniqueInput>
  /** Upsert single RecommendationFood document */
  upsert?: InputMaybe<RecommendationFoodUpsertWithNestedWhereUniqueInput>
}

export type RecommendationFoodUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecommendationFoodUpdateInput
  /** Unique document search */
  where: RecommendationFoodWhereUniqueInput
}

export type RecommendationFoodUpsertInput = {
  /** Create document if it didn't exist */
  create: RecommendationFoodCreateInput
  /** Update document if it exists */
  update: RecommendationFoodUpdateInput
}

export type RecommendationFoodUpsertLocalizationInput = {
  create: RecommendationFoodCreateLocalizationDataInput
  locale: Locale
  update: RecommendationFoodUpdateLocalizationDataInput
}

export type RecommendationFoodUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecommendationFoodUpsertInput
  /** Unique document search */
  where: RecommendationFoodWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type RecommendationFoodWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type RecommendationFoodWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecommendationFoodWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecommendationFoodWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecommendationFoodWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  boothNumber?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  boothNumber_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  boothNumber_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  boothNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  boothNumber_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  boothNumber_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  boothNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  boothNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  boothNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  boothNumber_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<RecommendationFoodWhereStageInput>
  documentInStages_none?: InputMaybe<RecommendationFoodWhereStageInput>
  documentInStages_some?: InputMaybe<RecommendationFoodWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  typeOfFood?: InputMaybe<Array<FestivalFoodType>>
  /** Matches if the field array contains *all* items provided to the filter */
  typeOfFood_contains_all?: InputMaybe<Array<FestivalFoodType>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  typeOfFood_contains_none?: InputMaybe<Array<FestivalFoodType>>
  /** Matches if the field array contains at least one item provided to the filter */
  typeOfFood_contains_some?: InputMaybe<Array<FestivalFoodType>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  typeOfFood_not?: InputMaybe<Array<FestivalFoodType>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecommendationFoodWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecommendationFoodWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecommendationFoodWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecommendationFoodWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecommendationFoodWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References RecommendationFood record uniquely */
export type RecommendationFoodWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** a place to go at night during the festival */
export type RecommendationNightOut = Entity &
  Node & {
    __typename?: 'RecommendationNightOut'
    /** street and postcode with town */
    address: Scalars['String']['output']
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** label for CTA link */
    ctaText?: Maybe<Scalars['String']['output']>
    /** link target for CTA */
    ctaUrl?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<RecommendationNightOut>
    /** List of RecommendationNightOut versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<RecommendationNightOut>
    /** the name of the place */
    name: Scalars['String']['output']
    /** with leading +49 xx xxxxxxx */
    phoneNumber?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    typeOfNightOut: FestivalNightOutType
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** a place to go at night during the festival */
export type RecommendationNightOutCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** a place to go at night during the festival */
export type RecommendationNightOutCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** a place to go at night during the festival */
export type RecommendationNightOutDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** a place to go at night during the festival */
export type RecommendationNightOutHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** a place to go at night during the festival */
export type RecommendationNightOutLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** a place to go at night during the festival */
export type RecommendationNightOutPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** a place to go at night during the festival */
export type RecommendationNightOutPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** a place to go at night during the festival */
export type RecommendationNightOutScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** a place to go at night during the festival */
export type RecommendationNightOutUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** a place to go at night during the festival */
export type RecommendationNightOutUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type RecommendationNightOutConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: RecommendationNightOutWhereUniqueInput
}

/** A connection to a list of items. */
export type RecommendationNightOutConnection = {
  __typename?: 'RecommendationNightOutConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<RecommendationNightOutEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RecommendationNightOutCreateInput = {
  address: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<RecommendationNightOutCreateLocalizationsInput>
  name: Scalars['String']['input']
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  typeOfNightOut: FestivalNightOutType
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type RecommendationNightOutCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type RecommendationNightOutCreateLocalizationInput = {
  /** Localization input */
  data: RecommendationNightOutCreateLocalizationDataInput
  locale: Locale
}

export type RecommendationNightOutCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<RecommendationNightOutCreateLocalizationInput>>
}

export type RecommendationNightOutCreateManyInlineInput = {
  /** Connect multiple existing RecommendationNightOut documents */
  connect?: InputMaybe<Array<RecommendationNightOutWhereUniqueInput>>
  /** Create and connect multiple existing RecommendationNightOut documents */
  create?: InputMaybe<Array<RecommendationNightOutCreateInput>>
}

export type RecommendationNightOutCreateOneInlineInput = {
  /** Connect one existing RecommendationNightOut document */
  connect?: InputMaybe<RecommendationNightOutWhereUniqueInput>
  /** Create and connect one RecommendationNightOut document */
  create?: InputMaybe<RecommendationNightOutCreateInput>
}

/** An edge in a connection. */
export type RecommendationNightOutEdge = {
  __typename?: 'RecommendationNightOutEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: RecommendationNightOut
}

/** Identifies documents */
export type RecommendationNightOutManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecommendationNightOutWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecommendationNightOutWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecommendationNightOutWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  address?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  address_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  address_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  address_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  address_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  address_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  address_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  address_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<RecommendationNightOutWhereStageInput>
  documentInStages_none?: InputMaybe<RecommendationNightOutWhereStageInput>
  documentInStages_some?: InputMaybe<RecommendationNightOutWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  phoneNumber_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  phoneNumber_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  phoneNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  phoneNumber_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  phoneNumber_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  phoneNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  phoneNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  phoneNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  phoneNumber_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  typeOfNightOut?: InputMaybe<FestivalNightOutType>
  /** All values that are contained in given list. */
  typeOfNightOut_in?: InputMaybe<Array<InputMaybe<FestivalNightOutType>>>
  /** Any other value that exists and is not equal to the given value. */
  typeOfNightOut_not?: InputMaybe<FestivalNightOutType>
  /** All values that are not contained in given list. */
  typeOfNightOut_not_in?: InputMaybe<Array<InputMaybe<FestivalNightOutType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum RecommendationNightOutOrderByInput {
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TypeOfNightOutAsc = 'typeOfNightOut_ASC',
  TypeOfNightOutDesc = 'typeOfNightOut_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type RecommendationNightOutUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<RecommendationNightOutUpdateLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  typeOfNightOut?: InputMaybe<FestivalNightOutType>
}

export type RecommendationNightOutUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
}

export type RecommendationNightOutUpdateLocalizationInput = {
  data: RecommendationNightOutUpdateLocalizationDataInput
  locale: Locale
}

export type RecommendationNightOutUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<RecommendationNightOutCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<RecommendationNightOutUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<RecommendationNightOutUpsertLocalizationInput>>
}

export type RecommendationNightOutUpdateManyInlineInput = {
  /** Connect multiple existing RecommendationNightOut documents */
  connect?: InputMaybe<Array<RecommendationNightOutConnectInput>>
  /** Create and connect multiple RecommendationNightOut documents */
  create?: InputMaybe<Array<RecommendationNightOutCreateInput>>
  /** Delete multiple RecommendationNightOut documents */
  delete?: InputMaybe<Array<RecommendationNightOutWhereUniqueInput>>
  /** Disconnect multiple RecommendationNightOut documents */
  disconnect?: InputMaybe<Array<RecommendationNightOutWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing RecommendationNightOut documents */
  set?: InputMaybe<Array<RecommendationNightOutWhereUniqueInput>>
  /** Update multiple RecommendationNightOut documents */
  update?: InputMaybe<Array<RecommendationNightOutUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple RecommendationNightOut documents */
  upsert?: InputMaybe<Array<RecommendationNightOutUpsertWithNestedWhereUniqueInput>>
}

export type RecommendationNightOutUpdateManyInput = {
  address?: InputMaybe<Scalars['String']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<RecommendationNightOutUpdateManyLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  typeOfNightOut?: InputMaybe<FestivalNightOutType>
}

export type RecommendationNightOutUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
}

export type RecommendationNightOutUpdateManyLocalizationInput = {
  data: RecommendationNightOutUpdateManyLocalizationDataInput
  locale: Locale
}

export type RecommendationNightOutUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<RecommendationNightOutUpdateManyLocalizationInput>>
}

export type RecommendationNightOutUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecommendationNightOutUpdateManyInput
  /** Document search */
  where: RecommendationNightOutWhereInput
}

export type RecommendationNightOutUpdateOneInlineInput = {
  /** Connect existing RecommendationNightOut document */
  connect?: InputMaybe<RecommendationNightOutWhereUniqueInput>
  /** Create and connect one RecommendationNightOut document */
  create?: InputMaybe<RecommendationNightOutCreateInput>
  /** Delete currently connected RecommendationNightOut document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected RecommendationNightOut document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single RecommendationNightOut document */
  update?: InputMaybe<RecommendationNightOutUpdateWithNestedWhereUniqueInput>
  /** Upsert single RecommendationNightOut document */
  upsert?: InputMaybe<RecommendationNightOutUpsertWithNestedWhereUniqueInput>
}

export type RecommendationNightOutUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecommendationNightOutUpdateInput
  /** Unique document search */
  where: RecommendationNightOutWhereUniqueInput
}

export type RecommendationNightOutUpsertInput = {
  /** Create document if it didn't exist */
  create: RecommendationNightOutCreateInput
  /** Update document if it exists */
  update: RecommendationNightOutUpdateInput
}

export type RecommendationNightOutUpsertLocalizationInput = {
  create: RecommendationNightOutCreateLocalizationDataInput
  locale: Locale
  update: RecommendationNightOutUpdateLocalizationDataInput
}

export type RecommendationNightOutUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecommendationNightOutUpsertInput
  /** Unique document search */
  where: RecommendationNightOutWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type RecommendationNightOutWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type RecommendationNightOutWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecommendationNightOutWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecommendationNightOutWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecommendationNightOutWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  address?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  address_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  address_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  address_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  address_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  address_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  address_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  address_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  address_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  address_starts_with?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<RecommendationNightOutWhereStageInput>
  documentInStages_none?: InputMaybe<RecommendationNightOutWhereStageInput>
  documentInStages_some?: InputMaybe<RecommendationNightOutWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  phoneNumber_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  phoneNumber_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  phoneNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  phoneNumber_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  phoneNumber_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  phoneNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  phoneNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  phoneNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  phoneNumber_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  typeOfNightOut?: InputMaybe<FestivalNightOutType>
  /** All values that are contained in given list. */
  typeOfNightOut_in?: InputMaybe<Array<InputMaybe<FestivalNightOutType>>>
  /** Any other value that exists and is not equal to the given value. */
  typeOfNightOut_not?: InputMaybe<FestivalNightOutType>
  /** All values that are not contained in given list. */
  typeOfNightOut_not_in?: InputMaybe<Array<InputMaybe<FestivalNightOutType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecommendationNightOutWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecommendationNightOutWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecommendationNightOutWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecommendationNightOutWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecommendationNightOutWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References RecommendationNightOut record uniquely */
export type RecommendationNightOutWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum ResultCreationOptions {
  Filter = 'filter',
  Sort = 'sort',
}

/** Reviews Agencies synchronised from reviews-api service */
export type ReviewsAgency = Entity &
  Node & {
    __typename?: 'ReviewsAgency'
    articles: Array<Article>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<ReviewsAgency>
    /** List of ReviewsAgency versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    logoUrl?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    published?: Maybe<Scalars['Boolean']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    uniqueId?: Maybe<Scalars['Int']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Reviews Agencies synchronised from reviews-api service */
export type ReviewsAgencyArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleWhereInput>
}

/** Reviews Agencies synchronised from reviews-api service */
export type ReviewsAgencyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Agencies synchronised from reviews-api service */
export type ReviewsAgencyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Reviews Agencies synchronised from reviews-api service */
export type ReviewsAgencyHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Reviews Agencies synchronised from reviews-api service */
export type ReviewsAgencyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Agencies synchronised from reviews-api service */
export type ReviewsAgencyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Reviews Agencies synchronised from reviews-api service */
export type ReviewsAgencyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ReviewsAgencyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ReviewsAgencyWhereUniqueInput
}

/** A connection to a list of items. */
export type ReviewsAgencyConnection = {
  __typename?: 'ReviewsAgencyConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ReviewsAgencyEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ReviewsAgencyCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  published?: InputMaybe<Scalars['Boolean']['input']>
  slug: Scalars['String']['input']
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsAgencyCreateManyInlineInput = {
  /** Connect multiple existing ReviewsAgency documents */
  connect?: InputMaybe<Array<ReviewsAgencyWhereUniqueInput>>
  /** Create and connect multiple existing ReviewsAgency documents */
  create?: InputMaybe<Array<ReviewsAgencyCreateInput>>
}

export type ReviewsAgencyCreateOneInlineInput = {
  /** Connect one existing ReviewsAgency document */
  connect?: InputMaybe<ReviewsAgencyWhereUniqueInput>
  /** Create and connect one ReviewsAgency document */
  create?: InputMaybe<ReviewsAgencyCreateInput>
}

/** An edge in a connection. */
export type ReviewsAgencyEdge = {
  __typename?: 'ReviewsAgencyEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ReviewsAgency
}

/** Identifies documents */
export type ReviewsAgencyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsAgencyWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsAgencyWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsAgencyWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsAgencyWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsAgencyWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsAgencyWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  logoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  logoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  logoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  logoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  logoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  logoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  logoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Boolean']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  uniqueId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  uniqueId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  uniqueId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  uniqueId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  uniqueId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  uniqueId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  uniqueId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ReviewsAgencyOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LogoUrlAsc = 'logoUrl_ASC',
  LogoUrlDesc = 'logoUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UniqueIdAsc = 'uniqueId_ASC',
  UniqueIdDesc = 'uniqueId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ReviewsAgencyUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
}

export type ReviewsAgencyUpdateManyInlineInput = {
  /** Connect multiple existing ReviewsAgency documents */
  connect?: InputMaybe<Array<ReviewsAgencyConnectInput>>
  /** Create and connect multiple ReviewsAgency documents */
  create?: InputMaybe<Array<ReviewsAgencyCreateInput>>
  /** Delete multiple ReviewsAgency documents */
  delete?: InputMaybe<Array<ReviewsAgencyWhereUniqueInput>>
  /** Disconnect multiple ReviewsAgency documents */
  disconnect?: InputMaybe<Array<ReviewsAgencyWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ReviewsAgency documents */
  set?: InputMaybe<Array<ReviewsAgencyWhereUniqueInput>>
  /** Update multiple ReviewsAgency documents */
  update?: InputMaybe<Array<ReviewsAgencyUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ReviewsAgency documents */
  upsert?: InputMaybe<Array<ReviewsAgencyUpsertWithNestedWhereUniqueInput>>
}

export type ReviewsAgencyUpdateManyInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
}

export type ReviewsAgencyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ReviewsAgencyUpdateManyInput
  /** Document search */
  where: ReviewsAgencyWhereInput
}

export type ReviewsAgencyUpdateOneInlineInput = {
  /** Connect existing ReviewsAgency document */
  connect?: InputMaybe<ReviewsAgencyWhereUniqueInput>
  /** Create and connect one ReviewsAgency document */
  create?: InputMaybe<ReviewsAgencyCreateInput>
  /** Delete currently connected ReviewsAgency document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ReviewsAgency document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ReviewsAgency document */
  update?: InputMaybe<ReviewsAgencyUpdateWithNestedWhereUniqueInput>
  /** Upsert single ReviewsAgency document */
  upsert?: InputMaybe<ReviewsAgencyUpsertWithNestedWhereUniqueInput>
}

export type ReviewsAgencyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ReviewsAgencyUpdateInput
  /** Unique document search */
  where: ReviewsAgencyWhereUniqueInput
}

export type ReviewsAgencyUpsertInput = {
  /** Create document if it didn't exist */
  create: ReviewsAgencyCreateInput
  /** Update document if it exists */
  update: ReviewsAgencyUpdateInput
}

export type ReviewsAgencyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ReviewsAgencyUpsertInput
  /** Unique document search */
  where: ReviewsAgencyWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ReviewsAgencyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ReviewsAgencyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsAgencyWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsAgencyWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsAgencyWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsAgencyWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsAgencyWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsAgencyWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  logoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  logoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  logoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  logoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  logoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  logoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  logoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Boolean']['input']>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  uniqueId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  uniqueId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  uniqueId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  uniqueId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  uniqueId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  uniqueId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  uniqueId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ReviewsAgencyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsAgencyWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsAgencyWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsAgencyWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ReviewsAgencyWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ReviewsAgency record uniquely */
export type ReviewsAgencyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
}

/** Row in a Features Table */
export type ReviewsFeatureRow = Entity &
  Node & {
    __typename?: 'ReviewsFeatureRow'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<ReviewsFeatureRow>
    /** n = not included, y = included, 'your Text' = text output */
    featureDescription: Scalars['String']['output']
    featureTitle?: Maybe<Scalars['String']['output']>
    /** List of ReviewsFeatureRow versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<ReviewsFeatureRow>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    relatedFeatureSection: Array<ReviewsFeaturesSection>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Row in a Features Table */
export type ReviewsFeatureRowCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Row in a Features Table */
export type ReviewsFeatureRowCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Row in a Features Table */
export type ReviewsFeatureRowDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Row in a Features Table */
export type ReviewsFeatureRowHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Row in a Features Table */
export type ReviewsFeatureRowLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Row in a Features Table */
export type ReviewsFeatureRowPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Row in a Features Table */
export type ReviewsFeatureRowPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Row in a Features Table */
export type ReviewsFeatureRowRelatedFeatureSectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsFeaturesSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsFeaturesSectionWhereInput>
}

/** Row in a Features Table */
export type ReviewsFeatureRowScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Row in a Features Table */
export type ReviewsFeatureRowUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Row in a Features Table */
export type ReviewsFeatureRowUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ReviewsFeatureRowConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ReviewsFeatureRowWhereUniqueInput
}

/** A connection to a list of items. */
export type ReviewsFeatureRowConnection = {
  __typename?: 'ReviewsFeatureRowConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ReviewsFeatureRowEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ReviewsFeatureRowCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** featureDescription input for default locale (de) */
  featureDescription: Scalars['String']['input']
  /** featureTitle input for default locale (de) */
  featureTitle?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ReviewsFeatureRowCreateLocalizationsInput>
  relatedFeatureSection?: InputMaybe<ReviewsFeaturesSectionCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsFeatureRowCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  featureDescription: Scalars['String']['input']
  featureTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsFeatureRowCreateLocalizationInput = {
  /** Localization input */
  data: ReviewsFeatureRowCreateLocalizationDataInput
  locale: Locale
}

export type ReviewsFeatureRowCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ReviewsFeatureRowCreateLocalizationInput>>
}

export type ReviewsFeatureRowCreateManyInlineInput = {
  /** Connect multiple existing ReviewsFeatureRow documents */
  connect?: InputMaybe<Array<ReviewsFeatureRowWhereUniqueInput>>
  /** Create and connect multiple existing ReviewsFeatureRow documents */
  create?: InputMaybe<Array<ReviewsFeatureRowCreateInput>>
}

export type ReviewsFeatureRowCreateOneInlineInput = {
  /** Connect one existing ReviewsFeatureRow document */
  connect?: InputMaybe<ReviewsFeatureRowWhereUniqueInput>
  /** Create and connect one ReviewsFeatureRow document */
  create?: InputMaybe<ReviewsFeatureRowCreateInput>
}

/** An edge in a connection. */
export type ReviewsFeatureRowEdge = {
  __typename?: 'ReviewsFeatureRowEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ReviewsFeatureRow
}

/** Identifies documents */
export type ReviewsFeatureRowManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsFeatureRowWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsFeatureRowWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsFeatureRowWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsFeatureRowWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsFeatureRowWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsFeatureRowWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  relatedFeatureSection_every?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  relatedFeatureSection_none?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  relatedFeatureSection_some?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ReviewsFeatureRowOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FeatureDescriptionAsc = 'featureDescription_ASC',
  FeatureDescriptionDesc = 'featureDescription_DESC',
  FeatureTitleAsc = 'featureTitle_ASC',
  FeatureTitleDesc = 'featureTitle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ReviewsFeatureRowUpdateInput = {
  /** featureDescription input for default locale (de) */
  featureDescription?: InputMaybe<Scalars['String']['input']>
  /** featureTitle input for default locale (de) */
  featureTitle?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ReviewsFeatureRowUpdateLocalizationsInput>
  relatedFeatureSection?: InputMaybe<ReviewsFeaturesSectionUpdateManyInlineInput>
}

export type ReviewsFeatureRowUpdateLocalizationDataInput = {
  featureDescription?: InputMaybe<Scalars['String']['input']>
  featureTitle?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsFeatureRowUpdateLocalizationInput = {
  data: ReviewsFeatureRowUpdateLocalizationDataInput
  locale: Locale
}

export type ReviewsFeatureRowUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ReviewsFeatureRowCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsFeatureRowUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ReviewsFeatureRowUpsertLocalizationInput>>
}

export type ReviewsFeatureRowUpdateManyInlineInput = {
  /** Connect multiple existing ReviewsFeatureRow documents */
  connect?: InputMaybe<Array<ReviewsFeatureRowConnectInput>>
  /** Create and connect multiple ReviewsFeatureRow documents */
  create?: InputMaybe<Array<ReviewsFeatureRowCreateInput>>
  /** Delete multiple ReviewsFeatureRow documents */
  delete?: InputMaybe<Array<ReviewsFeatureRowWhereUniqueInput>>
  /** Disconnect multiple ReviewsFeatureRow documents */
  disconnect?: InputMaybe<Array<ReviewsFeatureRowWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ReviewsFeatureRow documents */
  set?: InputMaybe<Array<ReviewsFeatureRowWhereUniqueInput>>
  /** Update multiple ReviewsFeatureRow documents */
  update?: InputMaybe<Array<ReviewsFeatureRowUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ReviewsFeatureRow documents */
  upsert?: InputMaybe<Array<ReviewsFeatureRowUpsertWithNestedWhereUniqueInput>>
}

export type ReviewsFeatureRowUpdateManyInput = {
  /** featureDescription input for default locale (de) */
  featureDescription?: InputMaybe<Scalars['String']['input']>
  /** featureTitle input for default locale (de) */
  featureTitle?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ReviewsFeatureRowUpdateManyLocalizationsInput>
}

export type ReviewsFeatureRowUpdateManyLocalizationDataInput = {
  featureDescription?: InputMaybe<Scalars['String']['input']>
  featureTitle?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsFeatureRowUpdateManyLocalizationInput = {
  data: ReviewsFeatureRowUpdateManyLocalizationDataInput
  locale: Locale
}

export type ReviewsFeatureRowUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsFeatureRowUpdateManyLocalizationInput>>
}

export type ReviewsFeatureRowUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ReviewsFeatureRowUpdateManyInput
  /** Document search */
  where: ReviewsFeatureRowWhereInput
}

export type ReviewsFeatureRowUpdateOneInlineInput = {
  /** Connect existing ReviewsFeatureRow document */
  connect?: InputMaybe<ReviewsFeatureRowWhereUniqueInput>
  /** Create and connect one ReviewsFeatureRow document */
  create?: InputMaybe<ReviewsFeatureRowCreateInput>
  /** Delete currently connected ReviewsFeatureRow document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ReviewsFeatureRow document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ReviewsFeatureRow document */
  update?: InputMaybe<ReviewsFeatureRowUpdateWithNestedWhereUniqueInput>
  /** Upsert single ReviewsFeatureRow document */
  upsert?: InputMaybe<ReviewsFeatureRowUpsertWithNestedWhereUniqueInput>
}

export type ReviewsFeatureRowUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ReviewsFeatureRowUpdateInput
  /** Unique document search */
  where: ReviewsFeatureRowWhereUniqueInput
}

export type ReviewsFeatureRowUpsertInput = {
  /** Create document if it didn't exist */
  create: ReviewsFeatureRowCreateInput
  /** Update document if it exists */
  update: ReviewsFeatureRowUpdateInput
}

export type ReviewsFeatureRowUpsertLocalizationInput = {
  create: ReviewsFeatureRowCreateLocalizationDataInput
  locale: Locale
  update: ReviewsFeatureRowUpdateLocalizationDataInput
}

export type ReviewsFeatureRowUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ReviewsFeatureRowUpsertInput
  /** Unique document search */
  where: ReviewsFeatureRowWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ReviewsFeatureRowWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ReviewsFeatureRowWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsFeatureRowWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsFeatureRowWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsFeatureRowWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsFeatureRowWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsFeatureRowWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsFeatureRowWhereStageInput>
  featureDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  featureDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  featureDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  featureDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  featureDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  featureDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  featureDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  featureDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  featureDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  featureDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  featureTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  featureTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  featureTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  featureTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  featureTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  featureTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  featureTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  featureTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  featureTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  featureTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  relatedFeatureSection_every?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  relatedFeatureSection_none?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  relatedFeatureSection_some?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ReviewsFeatureRowWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsFeatureRowWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsFeatureRowWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsFeatureRowWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ReviewsFeatureRowWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ReviewsFeatureRow record uniquely */
export type ReviewsFeatureRowWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section of Features */
export type ReviewsFeaturesSection = Entity &
  Node & {
    __typename?: 'ReviewsFeaturesSection'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<ReviewsFeaturesSection>
    featureSectionDescription?: Maybe<Scalars['String']['output']>
    featureSectionFeatures: Array<ReviewsFeatureRow>
    featureSectionTitle?: Maybe<Scalars['String']['output']>
    /** List of ReviewsFeaturesSection versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<ReviewsFeaturesSection>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Section of Features */
export type ReviewsFeaturesSectionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Section of Features */
export type ReviewsFeaturesSectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section of Features */
export type ReviewsFeaturesSectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Section of Features */
export type ReviewsFeaturesSectionFeatureSectionFeaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsFeatureRowOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsFeatureRowWhereInput>
}

/** Section of Features */
export type ReviewsFeaturesSectionHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Section of Features */
export type ReviewsFeaturesSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section of Features */
export type ReviewsFeaturesSectionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Section of Features */
export type ReviewsFeaturesSectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section of Features */
export type ReviewsFeaturesSectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Section of Features */
export type ReviewsFeaturesSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Section of Features */
export type ReviewsFeaturesSectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ReviewsFeaturesSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ReviewsFeaturesSectionWhereUniqueInput
}

/** A connection to a list of items. */
export type ReviewsFeaturesSectionConnection = {
  __typename?: 'ReviewsFeaturesSectionConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ReviewsFeaturesSectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ReviewsFeaturesSectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** featureSectionDescription input for default locale (de) */
  featureSectionDescription?: InputMaybe<Scalars['String']['input']>
  featureSectionFeatures?: InputMaybe<ReviewsFeatureRowCreateManyInlineInput>
  /** featureSectionTitle input for default locale (de) */
  featureSectionTitle?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ReviewsFeaturesSectionCreateLocalizationsInput>
  relatedFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsFeaturesSectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  featureSectionDescription?: InputMaybe<Scalars['String']['input']>
  featureSectionTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsFeaturesSectionCreateLocalizationInput = {
  /** Localization input */
  data: ReviewsFeaturesSectionCreateLocalizationDataInput
  locale: Locale
}

export type ReviewsFeaturesSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ReviewsFeaturesSectionCreateLocalizationInput>>
}

export type ReviewsFeaturesSectionCreateManyInlineInput = {
  /** Connect multiple existing ReviewsFeaturesSection documents */
  connect?: InputMaybe<Array<ReviewsFeaturesSectionWhereUniqueInput>>
  /** Create and connect multiple existing ReviewsFeaturesSection documents */
  create?: InputMaybe<Array<ReviewsFeaturesSectionCreateInput>>
}

export type ReviewsFeaturesSectionCreateOneInlineInput = {
  /** Connect one existing ReviewsFeaturesSection document */
  connect?: InputMaybe<ReviewsFeaturesSectionWhereUniqueInput>
  /** Create and connect one ReviewsFeaturesSection document */
  create?: InputMaybe<ReviewsFeaturesSectionCreateInput>
}

/** An edge in a connection. */
export type ReviewsFeaturesSectionEdge = {
  __typename?: 'ReviewsFeaturesSectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ReviewsFeaturesSection
}

/** Identifies documents */
export type ReviewsFeaturesSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsFeaturesSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsFeaturesSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsFeaturesSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsFeaturesSectionWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsFeaturesSectionWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsFeaturesSectionWhereStageInput>
  featureSectionFeatures_every?: InputMaybe<ReviewsFeatureRowWhereInput>
  featureSectionFeatures_none?: InputMaybe<ReviewsFeatureRowWhereInput>
  featureSectionFeatures_some?: InputMaybe<ReviewsFeatureRowWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ReviewsFeaturesSectionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FeatureSectionDescriptionAsc = 'featureSectionDescription_ASC',
  FeatureSectionDescriptionDesc = 'featureSectionDescription_DESC',
  FeatureSectionTitleAsc = 'featureSectionTitle_ASC',
  FeatureSectionTitleDesc = 'featureSectionTitle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ReviewsFeaturesSectionUpdateInput = {
  /** featureSectionDescription input for default locale (de) */
  featureSectionDescription?: InputMaybe<Scalars['String']['input']>
  featureSectionFeatures?: InputMaybe<ReviewsFeatureRowUpdateManyInlineInput>
  /** featureSectionTitle input for default locale (de) */
  featureSectionTitle?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ReviewsFeaturesSectionUpdateLocalizationsInput>
  relatedFeaturesTable?: InputMaybe<SectionReviewsFeaturesTableUpdateManyInlineInput>
}

export type ReviewsFeaturesSectionUpdateLocalizationDataInput = {
  featureSectionDescription?: InputMaybe<Scalars['String']['input']>
  featureSectionTitle?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsFeaturesSectionUpdateLocalizationInput = {
  data: ReviewsFeaturesSectionUpdateLocalizationDataInput
  locale: Locale
}

export type ReviewsFeaturesSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ReviewsFeaturesSectionCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsFeaturesSectionUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ReviewsFeaturesSectionUpsertLocalizationInput>>
}

export type ReviewsFeaturesSectionUpdateManyInlineInput = {
  /** Connect multiple existing ReviewsFeaturesSection documents */
  connect?: InputMaybe<Array<ReviewsFeaturesSectionConnectInput>>
  /** Create and connect multiple ReviewsFeaturesSection documents */
  create?: InputMaybe<Array<ReviewsFeaturesSectionCreateInput>>
  /** Delete multiple ReviewsFeaturesSection documents */
  delete?: InputMaybe<Array<ReviewsFeaturesSectionWhereUniqueInput>>
  /** Disconnect multiple ReviewsFeaturesSection documents */
  disconnect?: InputMaybe<Array<ReviewsFeaturesSectionWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ReviewsFeaturesSection documents */
  set?: InputMaybe<Array<ReviewsFeaturesSectionWhereUniqueInput>>
  /** Update multiple ReviewsFeaturesSection documents */
  update?: InputMaybe<Array<ReviewsFeaturesSectionUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ReviewsFeaturesSection documents */
  upsert?: InputMaybe<Array<ReviewsFeaturesSectionUpsertWithNestedWhereUniqueInput>>
}

export type ReviewsFeaturesSectionUpdateManyInput = {
  /** featureSectionDescription input for default locale (de) */
  featureSectionDescription?: InputMaybe<Scalars['String']['input']>
  /** featureSectionTitle input for default locale (de) */
  featureSectionTitle?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ReviewsFeaturesSectionUpdateManyLocalizationsInput>
}

export type ReviewsFeaturesSectionUpdateManyLocalizationDataInput = {
  featureSectionDescription?: InputMaybe<Scalars['String']['input']>
  featureSectionTitle?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsFeaturesSectionUpdateManyLocalizationInput = {
  data: ReviewsFeaturesSectionUpdateManyLocalizationDataInput
  locale: Locale
}

export type ReviewsFeaturesSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsFeaturesSectionUpdateManyLocalizationInput>>
}

export type ReviewsFeaturesSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ReviewsFeaturesSectionUpdateManyInput
  /** Document search */
  where: ReviewsFeaturesSectionWhereInput
}

export type ReviewsFeaturesSectionUpdateOneInlineInput = {
  /** Connect existing ReviewsFeaturesSection document */
  connect?: InputMaybe<ReviewsFeaturesSectionWhereUniqueInput>
  /** Create and connect one ReviewsFeaturesSection document */
  create?: InputMaybe<ReviewsFeaturesSectionCreateInput>
  /** Delete currently connected ReviewsFeaturesSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ReviewsFeaturesSection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ReviewsFeaturesSection document */
  update?: InputMaybe<ReviewsFeaturesSectionUpdateWithNestedWhereUniqueInput>
  /** Upsert single ReviewsFeaturesSection document */
  upsert?: InputMaybe<ReviewsFeaturesSectionUpsertWithNestedWhereUniqueInput>
}

export type ReviewsFeaturesSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ReviewsFeaturesSectionUpdateInput
  /** Unique document search */
  where: ReviewsFeaturesSectionWhereUniqueInput
}

export type ReviewsFeaturesSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: ReviewsFeaturesSectionCreateInput
  /** Update document if it exists */
  update: ReviewsFeaturesSectionUpdateInput
}

export type ReviewsFeaturesSectionUpsertLocalizationInput = {
  create: ReviewsFeaturesSectionCreateLocalizationDataInput
  locale: Locale
  update: ReviewsFeaturesSectionUpdateLocalizationDataInput
}

export type ReviewsFeaturesSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ReviewsFeaturesSectionUpsertInput
  /** Unique document search */
  where: ReviewsFeaturesSectionWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ReviewsFeaturesSectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ReviewsFeaturesSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsFeaturesSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsFeaturesSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsFeaturesSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsFeaturesSectionWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsFeaturesSectionWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsFeaturesSectionWhereStageInput>
  featureSectionDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  featureSectionDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  featureSectionDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  featureSectionDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  featureSectionDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  featureSectionDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  featureSectionDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  featureSectionDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  featureSectionDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  featureSectionDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  featureSectionFeatures_every?: InputMaybe<ReviewsFeatureRowWhereInput>
  featureSectionFeatures_none?: InputMaybe<ReviewsFeatureRowWhereInput>
  featureSectionFeatures_some?: InputMaybe<ReviewsFeatureRowWhereInput>
  featureSectionTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  featureSectionTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  featureSectionTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  featureSectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  featureSectionTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  featureSectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  featureSectionTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  featureSectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  featureSectionTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  featureSectionTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ReviewsFeaturesSectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsFeaturesSectionWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsFeaturesSectionWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsFeaturesSectionWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ReviewsFeaturesSectionWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ReviewsFeaturesSection record uniquely */
export type ReviewsFeaturesSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProduct = Entity &
  Node & {
    __typename?: 'ReviewsProduct'
    article: Array<Article>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<ReviewsProduct>
    /** List of ReviewsProduct versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    isSuite?: Maybe<Scalars['Boolean']['output']>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<ReviewsProduct>
    logoUrl?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    partnerCompany?: Maybe<PartnerCompany>
    published?: Maybe<Scalars['Boolean']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    rating?: Maybe<Scalars['Float']['output']>
    ratingsCount?: Maybe<Scalars['Int']['output']>
    reviewsProductCategories: Array<ReviewsProductCategory>
    scheduledIn: Array<ScheduledOperation>
    /** Optional configuration if you want to have specific SEO Attributes. */
    seoAttributes?: Maybe<Seo>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    tags: Array<Tag>
    /** Backend ID */
    uniqueId?: Maybe<Scalars['Int']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleWhereInput>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductPartnerCompanyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductReviewsProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsProductCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductCategoryWhereInput>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductSeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TagOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TagWhereInput>
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Reviews Products synchronised from reviews-api service */
export type ReviewsProductUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategory = Entity &
  Node & {
    __typename?: 'ReviewsProductCategory'
    articles: Array<Article>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<ReviewsProductCategory>
    /** List of ReviewsProductCategory versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Determines if this is a product or agency category */
    kind: ReviewsProductCategoryKind
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<ReviewsProductCategory>
    name: Scalars['String']['output']
    productWidget: Array<ReviewsProductWidget>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    reviewsProducts: Array<ReviewsProduct>
    scheduledIn: Array<ScheduledOperation>
    /** Optional configuration if you want to have specific SEO Attributes. */
    seoAttributes?: Maybe<Seo>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    tags: Array<Tag>
    /** Backend ID */
    uniqueId?: Maybe<Scalars['Int']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleWhereInput>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryProductWidgetArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsProductWidgetOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductWidgetWhereInput>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryReviewsProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsProductOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductWhereInput>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategorySeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TagOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TagWhereInput>
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Reviews Category for Products or Agencies */
export type ReviewsProductCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ReviewsProductCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ReviewsProductCategoryWhereUniqueInput
}

/** A connection to a list of items. */
export type ReviewsProductCategoryConnection = {
  __typename?: 'ReviewsProductCategoryConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ReviewsProductCategoryEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ReviewsProductCategoryCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  kind: ReviewsProductCategoryKind
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ReviewsProductCategoryCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  productWidget?: InputMaybe<ReviewsProductWidgetCreateManyInlineInput>
  reviewsProducts?: InputMaybe<ReviewsProductCreateManyInlineInput>
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  slug: Scalars['String']['input']
  tags?: InputMaybe<TagCreateManyInlineInput>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsProductCategoryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsProductCategoryCreateLocalizationInput = {
  /** Localization input */
  data: ReviewsProductCategoryCreateLocalizationDataInput
  locale: Locale
}

export type ReviewsProductCategoryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ReviewsProductCategoryCreateLocalizationInput>>
}

export type ReviewsProductCategoryCreateManyInlineInput = {
  /** Connect multiple existing ReviewsProductCategory documents */
  connect?: InputMaybe<Array<ReviewsProductCategoryWhereUniqueInput>>
  /** Create and connect multiple existing ReviewsProductCategory documents */
  create?: InputMaybe<Array<ReviewsProductCategoryCreateInput>>
}

export type ReviewsProductCategoryCreateOneInlineInput = {
  /** Connect one existing ReviewsProductCategory document */
  connect?: InputMaybe<ReviewsProductCategoryWhereUniqueInput>
  /** Create and connect one ReviewsProductCategory document */
  create?: InputMaybe<ReviewsProductCategoryCreateInput>
}

/** An edge in a connection. */
export type ReviewsProductCategoryEdge = {
  __typename?: 'ReviewsProductCategoryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ReviewsProductCategory
}

/** Defines the type of the category */
export enum ReviewsProductCategoryKind {
  Agency = 'agency',
  Product = 'product',
}

/** Identifies documents */
export type ReviewsProductCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductCategoryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductCategoryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductCategoryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsProductCategoryWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsProductCategoryWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsProductCategoryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<ReviewsProductCategoryKind>
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<ReviewsProductCategoryKind>>>
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<ReviewsProductCategoryKind>
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<ReviewsProductCategoryKind>>>
  productWidget_every?: InputMaybe<ReviewsProductWidgetWhereInput>
  productWidget_none?: InputMaybe<ReviewsProductWidgetWhereInput>
  productWidget_some?: InputMaybe<ReviewsProductWidgetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reviewsProducts_every?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_none?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_some?: InputMaybe<ReviewsProductWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  tags_every?: InputMaybe<TagWhereInput>
  tags_none?: InputMaybe<TagWhereInput>
  tags_some?: InputMaybe<TagWhereInput>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  uniqueId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  uniqueId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  uniqueId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  uniqueId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  uniqueId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  uniqueId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  uniqueId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ReviewsProductCategoryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UniqueIdAsc = 'uniqueId_ASC',
  UniqueIdDesc = 'uniqueId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ReviewsProductCategoryUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<ReviewsProductCategoryKind>
  /** Manage document localizations */
  localizations?: InputMaybe<ReviewsProductCategoryUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  productWidget?: InputMaybe<ReviewsProductWidgetUpdateManyInlineInput>
  reviewsProducts?: InputMaybe<ReviewsProductUpdateManyInlineInput>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<TagUpdateManyInlineInput>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
}

export type ReviewsProductCategoryUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsProductCategoryUpdateLocalizationInput = {
  data: ReviewsProductCategoryUpdateLocalizationDataInput
  locale: Locale
}

export type ReviewsProductCategoryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ReviewsProductCategoryCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsProductCategoryUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ReviewsProductCategoryUpsertLocalizationInput>>
}

export type ReviewsProductCategoryUpdateManyInlineInput = {
  /** Connect multiple existing ReviewsProductCategory documents */
  connect?: InputMaybe<Array<ReviewsProductCategoryConnectInput>>
  /** Create and connect multiple ReviewsProductCategory documents */
  create?: InputMaybe<Array<ReviewsProductCategoryCreateInput>>
  /** Delete multiple ReviewsProductCategory documents */
  delete?: InputMaybe<Array<ReviewsProductCategoryWhereUniqueInput>>
  /** Disconnect multiple ReviewsProductCategory documents */
  disconnect?: InputMaybe<Array<ReviewsProductCategoryWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ReviewsProductCategory documents */
  set?: InputMaybe<Array<ReviewsProductCategoryWhereUniqueInput>>
  /** Update multiple ReviewsProductCategory documents */
  update?: InputMaybe<Array<ReviewsProductCategoryUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ReviewsProductCategory documents */
  upsert?: InputMaybe<Array<ReviewsProductCategoryUpsertWithNestedWhereUniqueInput>>
}

export type ReviewsProductCategoryUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<ReviewsProductCategoryKind>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ReviewsProductCategoryUpdateManyLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsProductCategoryUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsProductCategoryUpdateManyLocalizationInput = {
  data: ReviewsProductCategoryUpdateManyLocalizationDataInput
  locale: Locale
}

export type ReviewsProductCategoryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsProductCategoryUpdateManyLocalizationInput>>
}

export type ReviewsProductCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ReviewsProductCategoryUpdateManyInput
  /** Document search */
  where: ReviewsProductCategoryWhereInput
}

export type ReviewsProductCategoryUpdateOneInlineInput = {
  /** Connect existing ReviewsProductCategory document */
  connect?: InputMaybe<ReviewsProductCategoryWhereUniqueInput>
  /** Create and connect one ReviewsProductCategory document */
  create?: InputMaybe<ReviewsProductCategoryCreateInput>
  /** Delete currently connected ReviewsProductCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ReviewsProductCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ReviewsProductCategory document */
  update?: InputMaybe<ReviewsProductCategoryUpdateWithNestedWhereUniqueInput>
  /** Upsert single ReviewsProductCategory document */
  upsert?: InputMaybe<ReviewsProductCategoryUpsertWithNestedWhereUniqueInput>
}

export type ReviewsProductCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ReviewsProductCategoryUpdateInput
  /** Unique document search */
  where: ReviewsProductCategoryWhereUniqueInput
}

export type ReviewsProductCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: ReviewsProductCategoryCreateInput
  /** Update document if it exists */
  update: ReviewsProductCategoryUpdateInput
}

export type ReviewsProductCategoryUpsertLocalizationInput = {
  create: ReviewsProductCategoryCreateLocalizationDataInput
  locale: Locale
  update: ReviewsProductCategoryUpdateLocalizationDataInput
}

export type ReviewsProductCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ReviewsProductCategoryUpsertInput
  /** Unique document search */
  where: ReviewsProductCategoryWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ReviewsProductCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ReviewsProductCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductCategoryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductCategoryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductCategoryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<ReviewsProductCategoryWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsProductCategoryWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsProductCategoryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<ReviewsProductCategoryKind>
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<ReviewsProductCategoryKind>>>
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<ReviewsProductCategoryKind>
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<ReviewsProductCategoryKind>>>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  productWidget_every?: InputMaybe<ReviewsProductWidgetWhereInput>
  productWidget_none?: InputMaybe<ReviewsProductWidgetWhereInput>
  productWidget_some?: InputMaybe<ReviewsProductWidgetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reviewsProducts_every?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_none?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_some?: InputMaybe<ReviewsProductWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  tags_every?: InputMaybe<TagWhereInput>
  tags_none?: InputMaybe<TagWhereInput>
  tags_some?: InputMaybe<TagWhereInput>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  uniqueId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  uniqueId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  uniqueId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  uniqueId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  uniqueId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  uniqueId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  uniqueId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ReviewsProductCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductCategoryWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductCategoryWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductCategoryWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ReviewsProductCategoryWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ReviewsProductCategory record uniquely */
export type ReviewsProductCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
}

export type ReviewsProductConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ReviewsProductWhereUniqueInput
}

/** A connection to a list of items. */
export type ReviewsProductConnection = {
  __typename?: 'ReviewsProductConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ReviewsProductEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ReviewsProductCreateInput = {
  article?: InputMaybe<ArticleCreateManyInlineInput>
  cm03pfq6y2ct906tc3rzw3utq?: InputMaybe<PpcReviewsProductCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  isSuite?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ReviewsProductCreateLocalizationsInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  partnerCompany?: InputMaybe<PartnerCompanyCreateOneInlineInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  rating?: InputMaybe<Scalars['Float']['input']>
  ratingsCount?: InputMaybe<Scalars['Int']['input']>
  reviewsProductCategories?: InputMaybe<ReviewsProductCategoryCreateManyInlineInput>
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  slug: Scalars['String']['input']
  tags?: InputMaybe<TagCreateManyInlineInput>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsProductCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsProductCreateLocalizationInput = {
  /** Localization input */
  data: ReviewsProductCreateLocalizationDataInput
  locale: Locale
}

export type ReviewsProductCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ReviewsProductCreateLocalizationInput>>
}

export type ReviewsProductCreateManyInlineInput = {
  /** Connect multiple existing ReviewsProduct documents */
  connect?: InputMaybe<Array<ReviewsProductWhereUniqueInput>>
  /** Create and connect multiple existing ReviewsProduct documents */
  create?: InputMaybe<Array<ReviewsProductCreateInput>>
}

export type ReviewsProductCreateOneInlineInput = {
  /** Connect one existing ReviewsProduct document */
  connect?: InputMaybe<ReviewsProductWhereUniqueInput>
  /** Create and connect one ReviewsProduct document */
  create?: InputMaybe<ReviewsProductCreateInput>
}

/** An edge in a connection. */
export type ReviewsProductEdge = {
  __typename?: 'ReviewsProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ReviewsProduct
}

/** Identifies documents */
export type ReviewsProductManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  article_every?: InputMaybe<ArticleWhereInput>
  article_none?: InputMaybe<ArticleWhereInput>
  article_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsProductWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsProductWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsProductWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isSuite?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isSuite_not?: InputMaybe<Scalars['Boolean']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  logoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  logoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  logoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  logoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  logoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  logoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  logoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyWhereInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Boolean']['input']>
  rating?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  rating_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  rating_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  rating_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  rating_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  rating_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  rating_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  rating_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  ratingsCount?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  ratingsCount_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  ratingsCount_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  ratingsCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  ratingsCount_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  ratingsCount_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  ratingsCount_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  ratingsCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  reviewsProductCategories_every?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_none?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_some?: InputMaybe<ReviewsProductCategoryWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  tags_every?: InputMaybe<TagWhereInput>
  tags_none?: InputMaybe<TagWhereInput>
  tags_some?: InputMaybe<TagWhereInput>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  uniqueId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  uniqueId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  uniqueId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  uniqueId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  uniqueId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  uniqueId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  uniqueId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ReviewsProductOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsSuiteAsc = 'isSuite_ASC',
  IsSuiteDesc = 'isSuite_DESC',
  LogoUrlAsc = 'logoUrl_ASC',
  LogoUrlDesc = 'logoUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  RatingAsc = 'rating_ASC',
  RatingDesc = 'rating_DESC',
  RatingsCountAsc = 'ratingsCount_ASC',
  RatingsCountDesc = 'ratingsCount_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UniqueIdAsc = 'uniqueId_ASC',
  UniqueIdDesc = 'uniqueId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ReviewsProductUpdateInput = {
  article?: InputMaybe<ArticleUpdateManyInlineInput>
  cm03pfq6y2ct906tc3rzw3utq?: InputMaybe<PpcReviewsProductUpdateManyInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  isSuite?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ReviewsProductUpdateLocalizationsInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyUpdateOneInlineInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  rating?: InputMaybe<Scalars['Float']['input']>
  ratingsCount?: InputMaybe<Scalars['Int']['input']>
  reviewsProductCategories?: InputMaybe<ReviewsProductCategoryUpdateManyInlineInput>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<TagUpdateManyInlineInput>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
}

export type ReviewsProductUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsProductUpdateLocalizationInput = {
  data: ReviewsProductUpdateLocalizationDataInput
  locale: Locale
}

export type ReviewsProductUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ReviewsProductCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsProductUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ReviewsProductUpsertLocalizationInput>>
}

export type ReviewsProductUpdateManyInlineInput = {
  /** Connect multiple existing ReviewsProduct documents */
  connect?: InputMaybe<Array<ReviewsProductConnectInput>>
  /** Create and connect multiple ReviewsProduct documents */
  create?: InputMaybe<Array<ReviewsProductCreateInput>>
  /** Delete multiple ReviewsProduct documents */
  delete?: InputMaybe<Array<ReviewsProductWhereUniqueInput>>
  /** Disconnect multiple ReviewsProduct documents */
  disconnect?: InputMaybe<Array<ReviewsProductWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ReviewsProduct documents */
  set?: InputMaybe<Array<ReviewsProductWhereUniqueInput>>
  /** Update multiple ReviewsProduct documents */
  update?: InputMaybe<Array<ReviewsProductUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ReviewsProduct documents */
  upsert?: InputMaybe<Array<ReviewsProductUpsertWithNestedWhereUniqueInput>>
}

export type ReviewsProductUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  isSuite?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ReviewsProductUpdateManyLocalizationsInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  rating?: InputMaybe<Scalars['Float']['input']>
  ratingsCount?: InputMaybe<Scalars['Int']['input']>
}

export type ReviewsProductUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsProductUpdateManyLocalizationInput = {
  data: ReviewsProductUpdateManyLocalizationDataInput
  locale: Locale
}

export type ReviewsProductUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsProductUpdateManyLocalizationInput>>
}

export type ReviewsProductUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ReviewsProductUpdateManyInput
  /** Document search */
  where: ReviewsProductWhereInput
}

export type ReviewsProductUpdateOneInlineInput = {
  /** Connect existing ReviewsProduct document */
  connect?: InputMaybe<ReviewsProductWhereUniqueInput>
  /** Create and connect one ReviewsProduct document */
  create?: InputMaybe<ReviewsProductCreateInput>
  /** Delete currently connected ReviewsProduct document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ReviewsProduct document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ReviewsProduct document */
  update?: InputMaybe<ReviewsProductUpdateWithNestedWhereUniqueInput>
  /** Upsert single ReviewsProduct document */
  upsert?: InputMaybe<ReviewsProductUpsertWithNestedWhereUniqueInput>
}

export type ReviewsProductUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ReviewsProductUpdateInput
  /** Unique document search */
  where: ReviewsProductWhereUniqueInput
}

export type ReviewsProductUpsertInput = {
  /** Create document if it didn't exist */
  create: ReviewsProductCreateInput
  /** Update document if it exists */
  update: ReviewsProductUpdateInput
}

export type ReviewsProductUpsertLocalizationInput = {
  create: ReviewsProductCreateLocalizationDataInput
  locale: Locale
  update: ReviewsProductUpdateLocalizationDataInput
}

export type ReviewsProductUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ReviewsProductUpsertInput
  /** Unique document search */
  where: ReviewsProductWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ReviewsProductWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ReviewsProductWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  article_every?: InputMaybe<ArticleWhereInput>
  article_none?: InputMaybe<ArticleWhereInput>
  article_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<ReviewsProductWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsProductWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsProductWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isSuite?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isSuite_not?: InputMaybe<Scalars['Boolean']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  logoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  logoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  logoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  logoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  logoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  logoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  logoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyWhereInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Boolean']['input']>
  rating?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than the given value. */
  rating_gt?: InputMaybe<Scalars['Float']['input']>
  /** All values greater than or equal the given value. */
  rating_gte?: InputMaybe<Scalars['Float']['input']>
  /** All values that are contained in given list. */
  rating_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  /** All values less than the given value. */
  rating_lt?: InputMaybe<Scalars['Float']['input']>
  /** All values less than or equal the given value. */
  rating_lte?: InputMaybe<Scalars['Float']['input']>
  /** Any other value that exists and is not equal to the given value. */
  rating_not?: InputMaybe<Scalars['Float']['input']>
  /** All values that are not contained in given list. */
  rating_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  ratingsCount?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  ratingsCount_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  ratingsCount_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  ratingsCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  ratingsCount_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  ratingsCount_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  ratingsCount_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  ratingsCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  reviewsProductCategories_every?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_none?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_some?: InputMaybe<ReviewsProductCategoryWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  tags_every?: InputMaybe<TagWhereInput>
  tags_none?: InputMaybe<TagWhereInput>
  tags_some?: InputMaybe<TagWhereInput>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  uniqueId_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  uniqueId_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  uniqueId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  uniqueId_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  uniqueId_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  uniqueId_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  uniqueId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ReviewsProductWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ReviewsProductWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ReviewsProduct record uniquely */
export type ReviewsProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  uniqueId?: InputMaybe<Scalars['Int']['input']>
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidget = Entity &
  Node & {
    __typename?: 'ReviewsProductWidget'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<ReviewsProductWidget>
    /** Widget Headline */
    headline?: Maybe<Scalars['String']['output']>
    /** List of ReviewsProductWidget versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<ReviewsProductWidget>
    /** Disable the minimum amount of products needed for showing the widget. */
    noMinimum?: Maybe<Scalars['Boolean']['output']>
    /** Choose Category for products shown in this widget */
    productCategory: ReviewsProductCategory
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** Widget Subtext */
    subtext?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    /** Choose ProductWidget Type */
    widgetType: ProductWidgetEnum
  }

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetProductCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Widgets to display pre-configurate productgroups in Contenthub */
export type ReviewsProductWidgetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ReviewsProductWidgetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ReviewsProductWidgetWhereUniqueInput
}

/** A connection to a list of items. */
export type ReviewsProductWidgetConnection = {
  __typename?: 'ReviewsProductWidgetConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ReviewsProductWidgetEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ReviewsProductWidgetCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ReviewsProductWidgetCreateLocalizationsInput>
  noMinimum?: InputMaybe<Scalars['Boolean']['input']>
  productCategory: ReviewsProductCategoryCreateOneInlineInput
  /** subtext input for default locale (de) */
  subtext?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  widgetType: ProductWidgetEnum
}

export type ReviewsProductWidgetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  headline?: InputMaybe<Scalars['String']['input']>
  subtext?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ReviewsProductWidgetCreateLocalizationInput = {
  /** Localization input */
  data: ReviewsProductWidgetCreateLocalizationDataInput
  locale: Locale
}

export type ReviewsProductWidgetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ReviewsProductWidgetCreateLocalizationInput>>
}

export type ReviewsProductWidgetCreateManyInlineInput = {
  /** Connect multiple existing ReviewsProductWidget documents */
  connect?: InputMaybe<Array<ReviewsProductWidgetWhereUniqueInput>>
  /** Create and connect multiple existing ReviewsProductWidget documents */
  create?: InputMaybe<Array<ReviewsProductWidgetCreateInput>>
}

export type ReviewsProductWidgetCreateOneInlineInput = {
  /** Connect one existing ReviewsProductWidget document */
  connect?: InputMaybe<ReviewsProductWidgetWhereUniqueInput>
  /** Create and connect one ReviewsProductWidget document */
  create?: InputMaybe<ReviewsProductWidgetCreateInput>
}

/** An edge in a connection. */
export type ReviewsProductWidgetEdge = {
  __typename?: 'ReviewsProductWidgetEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ReviewsProductWidget
}

/** Identifies documents */
export type ReviewsProductWidgetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductWidgetWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductWidgetWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductWidgetWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsProductWidgetWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsProductWidgetWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsProductWidgetWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  noMinimum?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  noMinimum_not?: InputMaybe<Scalars['Boolean']['input']>
  productCategory?: InputMaybe<ReviewsProductCategoryWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  widgetType?: InputMaybe<ProductWidgetEnum>
  /** All values that are contained in given list. */
  widgetType_in?: InputMaybe<Array<InputMaybe<ProductWidgetEnum>>>
  /** Any other value that exists and is not equal to the given value. */
  widgetType_not?: InputMaybe<ProductWidgetEnum>
  /** All values that are not contained in given list. */
  widgetType_not_in?: InputMaybe<Array<InputMaybe<ProductWidgetEnum>>>
}

export enum ReviewsProductWidgetOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NoMinimumAsc = 'noMinimum_ASC',
  NoMinimumDesc = 'noMinimum_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SubtextAsc = 'subtext_ASC',
  SubtextDesc = 'subtext_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidgetTypeAsc = 'widgetType_ASC',
  WidgetTypeDesc = 'widgetType_DESC',
}

export type ReviewsProductWidgetUpdateInput = {
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<ReviewsProductWidgetUpdateLocalizationsInput>
  noMinimum?: InputMaybe<Scalars['Boolean']['input']>
  productCategory?: InputMaybe<ReviewsProductCategoryUpdateOneInlineInput>
  /** subtext input for default locale (de) */
  subtext?: InputMaybe<Scalars['String']['input']>
  widgetType?: InputMaybe<ProductWidgetEnum>
}

export type ReviewsProductWidgetUpdateLocalizationDataInput = {
  headline?: InputMaybe<Scalars['String']['input']>
  subtext?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsProductWidgetUpdateLocalizationInput = {
  data: ReviewsProductWidgetUpdateLocalizationDataInput
  locale: Locale
}

export type ReviewsProductWidgetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ReviewsProductWidgetCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsProductWidgetUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<ReviewsProductWidgetUpsertLocalizationInput>>
}

export type ReviewsProductWidgetUpdateManyInlineInput = {
  /** Connect multiple existing ReviewsProductWidget documents */
  connect?: InputMaybe<Array<ReviewsProductWidgetConnectInput>>
  /** Create and connect multiple ReviewsProductWidget documents */
  create?: InputMaybe<Array<ReviewsProductWidgetCreateInput>>
  /** Delete multiple ReviewsProductWidget documents */
  delete?: InputMaybe<Array<ReviewsProductWidgetWhereUniqueInput>>
  /** Disconnect multiple ReviewsProductWidget documents */
  disconnect?: InputMaybe<Array<ReviewsProductWidgetWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ReviewsProductWidget documents */
  set?: InputMaybe<Array<ReviewsProductWidgetWhereUniqueInput>>
  /** Update multiple ReviewsProductWidget documents */
  update?: InputMaybe<Array<ReviewsProductWidgetUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ReviewsProductWidget documents */
  upsert?: InputMaybe<Array<ReviewsProductWidgetUpsertWithNestedWhereUniqueInput>>
}

export type ReviewsProductWidgetUpdateManyInput = {
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<ReviewsProductWidgetUpdateManyLocalizationsInput>
  noMinimum?: InputMaybe<Scalars['Boolean']['input']>
  /** subtext input for default locale (de) */
  subtext?: InputMaybe<Scalars['String']['input']>
  widgetType?: InputMaybe<ProductWidgetEnum>
}

export type ReviewsProductWidgetUpdateManyLocalizationDataInput = {
  headline?: InputMaybe<Scalars['String']['input']>
  subtext?: InputMaybe<Scalars['String']['input']>
}

export type ReviewsProductWidgetUpdateManyLocalizationInput = {
  data: ReviewsProductWidgetUpdateManyLocalizationDataInput
  locale: Locale
}

export type ReviewsProductWidgetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ReviewsProductWidgetUpdateManyLocalizationInput>>
}

export type ReviewsProductWidgetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ReviewsProductWidgetUpdateManyInput
  /** Document search */
  where: ReviewsProductWidgetWhereInput
}

export type ReviewsProductWidgetUpdateOneInlineInput = {
  /** Connect existing ReviewsProductWidget document */
  connect?: InputMaybe<ReviewsProductWidgetWhereUniqueInput>
  /** Create and connect one ReviewsProductWidget document */
  create?: InputMaybe<ReviewsProductWidgetCreateInput>
  /** Delete currently connected ReviewsProductWidget document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ReviewsProductWidget document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ReviewsProductWidget document */
  update?: InputMaybe<ReviewsProductWidgetUpdateWithNestedWhereUniqueInput>
  /** Upsert single ReviewsProductWidget document */
  upsert?: InputMaybe<ReviewsProductWidgetUpsertWithNestedWhereUniqueInput>
}

export type ReviewsProductWidgetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ReviewsProductWidgetUpdateInput
  /** Unique document search */
  where: ReviewsProductWidgetWhereUniqueInput
}

export type ReviewsProductWidgetUpsertInput = {
  /** Create document if it didn't exist */
  create: ReviewsProductWidgetCreateInput
  /** Update document if it exists */
  update: ReviewsProductWidgetUpdateInput
}

export type ReviewsProductWidgetUpsertLocalizationInput = {
  create: ReviewsProductWidgetCreateLocalizationDataInput
  locale: Locale
  update: ReviewsProductWidgetUpdateLocalizationDataInput
}

export type ReviewsProductWidgetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ReviewsProductWidgetUpsertInput
  /** Unique document search */
  where: ReviewsProductWidgetWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type ReviewsProductWidgetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ReviewsProductWidgetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductWidgetWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductWidgetWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductWidgetWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<ReviewsProductWidgetWhereStageInput>
  documentInStages_none?: InputMaybe<ReviewsProductWidgetWhereStageInput>
  documentInStages_some?: InputMaybe<ReviewsProductWidgetWhereStageInput>
  headline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  noMinimum?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  noMinimum_not?: InputMaybe<Scalars['Boolean']['input']>
  productCategory?: InputMaybe<ReviewsProductCategoryWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  subtext?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtext_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtext_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtext_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtext_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtext_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtext_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtext_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtext_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtext_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  widgetType?: InputMaybe<ProductWidgetEnum>
  /** All values that are contained in given list. */
  widgetType_in?: InputMaybe<Array<InputMaybe<ProductWidgetEnum>>>
  /** Any other value that exists and is not equal to the given value. */
  widgetType_not?: InputMaybe<ProductWidgetEnum>
  /** All values that are not contained in given list. */
  widgetType_not_in?: InputMaybe<Array<InputMaybe<ProductWidgetEnum>>>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ReviewsProductWidgetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewsProductWidgetWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewsProductWidgetWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewsProductWidgetWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ReviewsProductWidgetWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References ReviewsProductWidget record uniquely */
export type ReviewsProductWidgetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type RichContent = Entity & {
  __typename?: 'RichContent'
  content: RichContentContentRichText
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<RichContent>
  /** Show a clickable table of contents above the content. Entries are generated automatically from the content's headings (see TOC Header Level) — no manual upkeep. The table of contents stays hidden when fewer than 2 matching headings exist. Off by default. */
  showToc?: Maybe<Scalars['Boolean']['output']>
  /** System stage field */
  stage: Stage
  /** Heading level whose headings become the table of contents entries (single level, no sub-points). Falls back to Heading 2 (H2) when left empty. */
  tocHeaderLevel?: Maybe<TocHeaderLevel>
  /** Title shown above the table of contents, and as the label of the collapsed table of contents on mobile. Falls back to 'Inhaltsverzeichnis' when left empty. */
  tocTitle?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type RichContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type RichContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type RichContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: RichContentWhereUniqueInput
}

/** A connection to a list of items. */
export type RichContentConnection = {
  __typename?: 'RichContentConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<RichContentEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RichContentContentRichText = {
  __typename?: 'RichContentContentRichText'
  /** Returns HTMl representation */
  html: Scalars['String']['output']
  json: Scalars['RichTextAST']['output']
  /** Returns Markdown representation */
  markdown: Scalars['String']['output']
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output']
  references: Array<RichContentContentRichTextEmbeddedTypes>
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output']
}

export type RichContentContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
}

export type RichContentContentRichTextEmbeddedTypes = Asset | HtmlEmbed

export type RichContentCreateInput = {
  /** content input for default locale (de) */
  content: Scalars['RichTextAST']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<RichContentCreateLocalizationsInput>
  showToc?: InputMaybe<Scalars['Boolean']['input']>
  tocHeaderLevel?: InputMaybe<TocHeaderLevel>
  tocTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type RichContentCreateLocalizationDataInput = {
  content: Scalars['RichTextAST']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type RichContentCreateLocalizationInput = {
  /** Localization input */
  data: RichContentCreateLocalizationDataInput
  locale: Locale
}

export type RichContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<RichContentCreateLocalizationInput>>
}

export type RichContentCreateManyInlineInput = {
  /** Create and connect multiple existing RichContent documents */
  create?: InputMaybe<Array<RichContentCreateInput>>
}

export type RichContentCreateOneInlineInput = {
  /** Create and connect one RichContent document */
  create?: InputMaybe<RichContentCreateInput>
}

export type RichContentCreateWithPositionInput = {
  /** Document to create */
  data: RichContentCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type RichContentEdge = {
  __typename?: 'RichContentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: RichContent
}

/** Identifies documents */
export type RichContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RichContentWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RichContentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RichContentWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  showToc?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showToc_not?: InputMaybe<Scalars['Boolean']['input']>
  tocHeaderLevel?: InputMaybe<TocHeaderLevel>
  /** All values that are contained in given list. */
  tocHeaderLevel_in?: InputMaybe<Array<InputMaybe<TocHeaderLevel>>>
  /** Any other value that exists and is not equal to the given value. */
  tocHeaderLevel_not?: InputMaybe<TocHeaderLevel>
  /** All values that are not contained in given list. */
  tocHeaderLevel_not_in?: InputMaybe<Array<InputMaybe<TocHeaderLevel>>>
  tocTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  tocTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  tocTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tocTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  tocTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  tocTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  tocTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  tocTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  tocTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  tocTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum RichContentOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ShowTocAsc = 'showToc_ASC',
  ShowTocDesc = 'showToc_DESC',
  TocHeaderLevelAsc = 'tocHeaderLevel_ASC',
  TocHeaderLevelDesc = 'tocHeaderLevel_DESC',
  TocTitleAsc = 'tocTitle_ASC',
  TocTitleDesc = 'tocTitle_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type RichContentParent = CareerPage | EventPage | LandingPage | TopicPageSection

export type RichContentParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
  TopicPageSection?: InputMaybe<TopicPageSectionConnectInput>
}

export type RichContentParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
  TopicPageSection?: InputMaybe<TopicPageSectionCreateInput>
}

export type RichContentParentCreateManyInlineInput = {
  /** Connect multiple existing RichContentParent documents */
  connect?: InputMaybe<Array<RichContentParentWhereUniqueInput>>
  /** Create and connect multiple existing RichContentParent documents */
  create?: InputMaybe<Array<RichContentParentCreateInput>>
}

export type RichContentParentCreateOneInlineInput = {
  /** Connect one existing RichContentParent document */
  connect?: InputMaybe<RichContentParentWhereUniqueInput>
  /** Create and connect one RichContentParent document */
  create?: InputMaybe<RichContentParentCreateInput>
}

export type RichContentParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateInput>
}

export type RichContentParentUpdateManyInlineInput = {
  /** Connect multiple existing RichContentParent documents */
  connect?: InputMaybe<Array<RichContentParentConnectInput>>
  /** Create and connect multiple RichContentParent documents */
  create?: InputMaybe<Array<RichContentParentCreateInput>>
  /** Delete multiple RichContentParent documents */
  delete?: InputMaybe<Array<RichContentParentWhereUniqueInput>>
  /** Disconnect multiple RichContentParent documents */
  disconnect?: InputMaybe<Array<RichContentParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing RichContentParent documents */
  set?: InputMaybe<Array<RichContentParentWhereUniqueInput>>
  /** Update multiple RichContentParent documents */
  update?: InputMaybe<Array<RichContentParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple RichContentParent documents */
  upsert?: InputMaybe<Array<RichContentParentUpsertWithNestedWhereUniqueInput>>
}

export type RichContentParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateManyWithNestedWhereInput>
}

export type RichContentParentUpdateOneInlineInput = {
  /** Connect existing RichContentParent document */
  connect?: InputMaybe<RichContentParentWhereUniqueInput>
  /** Create and connect one RichContentParent document */
  create?: InputMaybe<RichContentParentCreateInput>
  /** Delete currently connected RichContentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected RichContentParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single RichContentParent document */
  update?: InputMaybe<RichContentParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single RichContentParent document */
  upsert?: InputMaybe<RichContentParentUpsertWithNestedWhereUniqueInput>
}

export type RichContentParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueInput>
}

export type RichContentParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueInput>
}

export type RichContentParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
  TopicPageSection?: InputMaybe<TopicPageSectionWhereInput>
}

export type RichContentParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
  TopicPageSection?: InputMaybe<TopicPageSectionWhereUniqueInput>
}

export type RichContentUpdateInput = {
  /** content input for default locale (de) */
  content?: InputMaybe<Scalars['RichTextAST']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<RichContentUpdateLocalizationsInput>
  showToc?: InputMaybe<Scalars['Boolean']['input']>
  tocHeaderLevel?: InputMaybe<TocHeaderLevel>
  tocTitle?: InputMaybe<Scalars['String']['input']>
}

export type RichContentUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type RichContentUpdateLocalizationInput = {
  data: RichContentUpdateLocalizationDataInput
  locale: Locale
}

export type RichContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<RichContentCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<RichContentUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<RichContentUpsertLocalizationInput>>
}

export type RichContentUpdateManyInlineInput = {
  /** Create and connect multiple RichContent component instances */
  create?: InputMaybe<Array<RichContentCreateWithPositionInput>>
  /** Delete multiple RichContent documents */
  delete?: InputMaybe<Array<RichContentWhereUniqueInput>>
  /** Update multiple RichContent component instances */
  update?: InputMaybe<Array<RichContentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple RichContent component instances */
  upsert?: InputMaybe<Array<RichContentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type RichContentUpdateManyInput = {
  /** content input for default locale (de) */
  content?: InputMaybe<Scalars['RichTextAST']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<RichContentUpdateManyLocalizationsInput>
  showToc?: InputMaybe<Scalars['Boolean']['input']>
  tocHeaderLevel?: InputMaybe<TocHeaderLevel>
  tocTitle?: InputMaybe<Scalars['String']['input']>
}

export type RichContentUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type RichContentUpdateManyLocalizationInput = {
  data: RichContentUpdateManyLocalizationDataInput
  locale: Locale
}

export type RichContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<RichContentUpdateManyLocalizationInput>>
}

export type RichContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RichContentUpdateManyInput
  /** Document search */
  where: RichContentWhereInput
}

export type RichContentUpdateOneInlineInput = {
  /** Create and connect one RichContent document */
  create?: InputMaybe<RichContentCreateInput>
  /** Delete currently connected RichContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single RichContent document */
  update?: InputMaybe<RichContentUpdateWithNestedWhereUniqueInput>
  /** Upsert single RichContent document */
  upsert?: InputMaybe<RichContentUpsertWithNestedWhereUniqueInput>
}

export type RichContentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<RichContentUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: RichContentWhereUniqueInput
}

export type RichContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RichContentUpdateInput
  /** Unique document search */
  where: RichContentWhereUniqueInput
}

export type RichContentUpsertInput = {
  /** Create document if it didn't exist */
  create: RichContentCreateInput
  /** Update document if it exists */
  update: RichContentUpdateInput
}

export type RichContentUpsertLocalizationInput = {
  create: RichContentCreateLocalizationDataInput
  locale: Locale
  update: RichContentUpdateLocalizationDataInput
}

export type RichContentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<RichContentUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: RichContentWhereUniqueInput
}

export type RichContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RichContentUpsertInput
  /** Unique document search */
  where: RichContentWhereUniqueInput
}

/** Identifies documents */
export type RichContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RichContentWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RichContentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RichContentWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  showToc?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showToc_not?: InputMaybe<Scalars['Boolean']['input']>
  tocHeaderLevel?: InputMaybe<TocHeaderLevel>
  /** All values that are contained in given list. */
  tocHeaderLevel_in?: InputMaybe<Array<InputMaybe<TocHeaderLevel>>>
  /** Any other value that exists and is not equal to the given value. */
  tocHeaderLevel_not?: InputMaybe<TocHeaderLevel>
  /** All values that are not contained in given list. */
  tocHeaderLevel_not_in?: InputMaybe<Array<InputMaybe<TocHeaderLevel>>>
  tocTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  tocTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  tocTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tocTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  tocTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  tocTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  tocTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  tocTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  tocTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  tocTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References RichContent record uniquely */
export type RichContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText'
  /** Returns HTMl representation */
  html: Scalars['String']['output']
  /** Returns Markdown representation */
  markdown: Scalars['String']['output']
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output']
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output']
}

/** Section component for richt text with media. */
export type RichTextMedia = Entity & {
  __typename?: 'RichTextMedia'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<RichTextMedia>
  media: Asset
  mediaPosition: RichTextMediaPosition
  /** System stage field */
  stage: Stage
  /** Text to be displayed */
  text: RichText
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section component for richt text with media. */
export type RichTextMediaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section component for richt text with media. */
export type RichTextMediaMediaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Section component for richt text with media. */
export type RichTextMediaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type RichTextMediaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: RichTextMediaWhereUniqueInput
}

/** A connection to a list of items. */
export type RichTextMediaConnection = {
  __typename?: 'RichTextMediaConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<RichTextMediaEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RichTextMediaCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<RichTextMediaCreateLocalizationsInput>
  media: AssetCreateOneInlineInput
  mediaPosition: RichTextMediaPosition
  /** text input for default locale (de) */
  text: Scalars['RichTextAST']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type RichTextMediaCreateLocalizationDataInput = {
  text: Scalars['RichTextAST']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type RichTextMediaCreateLocalizationInput = {
  /** Localization input */
  data: RichTextMediaCreateLocalizationDataInput
  locale: Locale
}

export type RichTextMediaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<RichTextMediaCreateLocalizationInput>>
}

export type RichTextMediaCreateManyInlineInput = {
  /** Create and connect multiple existing RichTextMedia documents */
  create?: InputMaybe<Array<RichTextMediaCreateInput>>
}

export type RichTextMediaCreateOneInlineInput = {
  /** Create and connect one RichTextMedia document */
  create?: InputMaybe<RichTextMediaCreateInput>
}

export type RichTextMediaCreateWithPositionInput = {
  /** Document to create */
  data: RichTextMediaCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type RichTextMediaEdge = {
  __typename?: 'RichTextMediaEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: RichTextMedia
}

/** Identifies documents */
export type RichTextMediaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RichTextMediaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RichTextMediaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RichTextMediaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  media?: InputMaybe<AssetWhereInput>
  mediaPosition?: InputMaybe<RichTextMediaPosition>
  /** All values that are contained in given list. */
  mediaPosition_in?: InputMaybe<Array<InputMaybe<RichTextMediaPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  mediaPosition_not?: InputMaybe<RichTextMediaPosition>
  /** All values that are not contained in given list. */
  mediaPosition_not_in?: InputMaybe<Array<InputMaybe<RichTextMediaPosition>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum RichTextMediaOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type RichTextMediaParent = TopicPageSection

export type RichTextMediaParentConnectInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionConnectInput>
}

export type RichTextMediaParentCreateInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionCreateInput>
}

export type RichTextMediaParentCreateManyInlineInput = {
  /** Create and connect multiple existing RichTextMediaParent documents */
  create?: InputMaybe<Array<RichTextMediaParentCreateInput>>
}

export type RichTextMediaParentCreateOneInlineInput = {
  /** Create and connect one RichTextMediaParent document */
  create?: InputMaybe<RichTextMediaParentCreateInput>
}

export type RichTextMediaParentCreateWithPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionCreateWithPositionInput>
}

export type RichTextMediaParentUpdateInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateInput>
}

export type RichTextMediaParentUpdateManyInlineInput = {
  /** Create and connect multiple RichTextMediaParent component instances */
  create?: InputMaybe<Array<RichTextMediaParentCreateWithPositionInput>>
  /** Delete multiple RichTextMediaParent documents */
  delete?: InputMaybe<Array<RichTextMediaParentWhereUniqueInput>>
  /** Update multiple RichTextMediaParent component instances */
  update?: InputMaybe<Array<RichTextMediaParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple RichTextMediaParent component instances */
  upsert?: InputMaybe<Array<RichTextMediaParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type RichTextMediaParentUpdateManyWithNestedWhereInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateManyWithNestedWhereInput>
}

export type RichTextMediaParentUpdateOneInlineInput = {
  /** Create and connect one RichTextMediaParent document */
  create?: InputMaybe<RichTextMediaParentCreateInput>
  /** Delete currently connected RichTextMediaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single RichTextMediaParent document */
  update?: InputMaybe<RichTextMediaParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single RichTextMediaParent document */
  upsert?: InputMaybe<RichTextMediaParentUpsertWithNestedWhereUniqueInput>
}

export type RichTextMediaParentUpdateWithNestedWhereUniqueAndPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueAndPositionInput>
}

export type RichTextMediaParentUpdateWithNestedWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueInput>
}

export type RichTextMediaParentUpsertWithNestedWhereUniqueAndPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueAndPositionInput>
}

export type RichTextMediaParentUpsertWithNestedWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueInput>
}

export type RichTextMediaParentWhereInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionWhereInput>
}

export type RichTextMediaParentWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionWhereUniqueInput>
}

export enum RichTextMediaPosition {
  Left = 'left',
  Right = 'right',
}

export type RichTextMediaUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<RichTextMediaUpdateLocalizationsInput>
  media?: InputMaybe<AssetUpdateOneInlineInput>
  mediaPosition?: InputMaybe<RichTextMediaPosition>
  /** text input for default locale (de) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type RichTextMediaUpdateLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type RichTextMediaUpdateLocalizationInput = {
  data: RichTextMediaUpdateLocalizationDataInput
  locale: Locale
}

export type RichTextMediaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<RichTextMediaCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<RichTextMediaUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<RichTextMediaUpsertLocalizationInput>>
}

export type RichTextMediaUpdateManyInlineInput = {
  /** Create and connect multiple RichTextMedia component instances */
  create?: InputMaybe<Array<RichTextMediaCreateWithPositionInput>>
  /** Delete multiple RichTextMedia documents */
  delete?: InputMaybe<Array<RichTextMediaWhereUniqueInput>>
  /** Update multiple RichTextMedia component instances */
  update?: InputMaybe<Array<RichTextMediaUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple RichTextMedia component instances */
  upsert?: InputMaybe<Array<RichTextMediaUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type RichTextMediaUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<RichTextMediaUpdateManyLocalizationsInput>
  mediaPosition?: InputMaybe<RichTextMediaPosition>
  /** text input for default locale (de) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type RichTextMediaUpdateManyLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type RichTextMediaUpdateManyLocalizationInput = {
  data: RichTextMediaUpdateManyLocalizationDataInput
  locale: Locale
}

export type RichTextMediaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<RichTextMediaUpdateManyLocalizationInput>>
}

export type RichTextMediaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RichTextMediaUpdateManyInput
  /** Document search */
  where: RichTextMediaWhereInput
}

export type RichTextMediaUpdateOneInlineInput = {
  /** Create and connect one RichTextMedia document */
  create?: InputMaybe<RichTextMediaCreateInput>
  /** Delete currently connected RichTextMedia document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single RichTextMedia document */
  update?: InputMaybe<RichTextMediaUpdateWithNestedWhereUniqueInput>
  /** Upsert single RichTextMedia document */
  upsert?: InputMaybe<RichTextMediaUpsertWithNestedWhereUniqueInput>
}

export type RichTextMediaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<RichTextMediaUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: RichTextMediaWhereUniqueInput
}

export type RichTextMediaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RichTextMediaUpdateInput
  /** Unique document search */
  where: RichTextMediaWhereUniqueInput
}

export type RichTextMediaUpsertInput = {
  /** Create document if it didn't exist */
  create: RichTextMediaCreateInput
  /** Update document if it exists */
  update: RichTextMediaUpdateInput
}

export type RichTextMediaUpsertLocalizationInput = {
  create: RichTextMediaCreateLocalizationDataInput
  locale: Locale
  update: RichTextMediaUpdateLocalizationDataInput
}

export type RichTextMediaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<RichTextMediaUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: RichTextMediaWhereUniqueInput
}

export type RichTextMediaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RichTextMediaUpsertInput
  /** Unique document search */
  where: RichTextMediaWhereUniqueInput
}

/** Identifies documents */
export type RichTextMediaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RichTextMediaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RichTextMediaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RichTextMediaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  media?: InputMaybe<AssetWhereInput>
  mediaPosition?: InputMaybe<RichTextMediaPosition>
  /** All values that are contained in given list. */
  mediaPosition_in?: InputMaybe<Array<InputMaybe<RichTextMediaPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  mediaPosition_not?: InputMaybe<RichTextMediaPosition>
  /** All values that are not contained in given list. */
  mediaPosition_not_in?: InputMaybe<Array<InputMaybe<RichTextMediaPosition>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References RichTextMedia record uniquely */
export type RichTextMediaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Scheduled Operation system model */
export type ScheduledOperation = Entity &
  Node & {
    __typename?: 'ScheduledOperation'
    affectedDocuments: Array<ScheduledOperationAffectedDocument>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Operation description */
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<ScheduledOperation>
    /** Operation error message */
    errorMessage?: Maybe<Scalars['String']['output']>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    /** Raw operation payload including all details, this field is subject to change */
    rawPayload: Scalars['Json']['output']
    /** The release this operation is scheduled for */
    release?: Maybe<ScheduledRelease>
    /** System stage field */
    stage: Stage
    /** operation Status */
    status: ScheduledOperationStatus
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ScheduledOperationAffectedDocument =
  | AnimatedCounter
  | Article
  | ArticleCategory
  | ArticlePageView
  | Asset
  | Author
  | Booth
  | CareerPage
  | ContentReference
  | EducationReport
  | EducationSeminar
  | Event
  | EventAppPage
  | EventPage
  | EventStage
  | ExhibitorListOrder
  | FaqQuestion
  | Footer
  | Glossary
  | Header
  | Hotel
  | HtmlEmbed
  | HubContentEntry
  | HubPage
  | HubPageCountdownHero
  | ImageGalleryEmbed
  | Interest
  | JobListing
  | Journey
  | LandingPage
  | ManageContentConfig
  | MapMarker
  | MapMarkerIcon
  | NewsletterAudience
  | Notification
  | OmrPartner
  | PartnerCompany
  | PhysicalLocation
  | PodcastEpisode
  | PodcastGroup
  | PricingTier
  | RecommendationFood
  | RecommendationNightOut
  | ReviewsAgency
  | ReviewsFeatureRow
  | ReviewsFeaturesSection
  | ReviewsProduct
  | ReviewsProductCategory
  | ReviewsProductWidget
  | SiteSection
  | SocialEmbed
  | Speaker
  | SpeakerListOrder
  | TabContent
  | Tag
  | TicketsTableColumn
  | TopicPage
  | TopicPageCategory
  | VgWort

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput
}

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>
}

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>
}

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ScheduledOperation
}

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>
  release?: InputMaybe<ScheduledReleaseWhereInput>
  status?: InputMaybe<ScheduledOperationStatus>
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>
}

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>
  release?: InputMaybe<ScheduledReleaseWhereInput>
  status?: InputMaybe<ScheduledOperationStatus>
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Scheduled Release system model */
export type ScheduledRelease = Entity &
  Node & {
    __typename?: 'ScheduledRelease'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Release description */
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<ScheduledRelease>
    /** Release error message */
    errorMessage?: Maybe<Scalars['String']['output']>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Whether scheduled release should be run */
    isActive: Scalars['Boolean']['output']
    /** Whether scheduled release is implicit */
    isImplicit: Scalars['Boolean']['output']
    /** Operations to run with this release */
    operations: Array<ScheduledOperation>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    /** Release date and time */
    releaseAt?: Maybe<Scalars['DateTime']['output']>
    /** System stage field */
    stage: Stage
    /** Release Status */
    status: ScheduledReleaseStatus
    /** Release Title */
    title?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput
}

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>
}

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>
}

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: ScheduledRelease
}

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>
  operations_every?: InputMaybe<ScheduledOperationWhereInput>
  operations_none?: InputMaybe<ScheduledOperationWhereInput>
  operations_some?: InputMaybe<ScheduledOperationWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  status?: InputMaybe<ScheduledReleaseStatus>
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum ScheduledReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  IsImplicitAsc = 'isImplicit_ASC',
  IsImplicitDesc = 'isImplicit_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReleaseAtAsc = 'releaseAt_ASC',
  ReleaseAtDesc = 'releaseAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>
}

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput
  /** Document search */
  where: ScheduledReleaseWhereInput
}

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>
}

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput
}

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput
}

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput
}

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>
  operations_every?: InputMaybe<ScheduledOperationWhereInput>
  operations_none?: InputMaybe<ScheduledOperationWhereInput>
  operations_some?: InputMaybe<ScheduledOperationWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  status?: InputMaybe<ScheduledReleaseStatus>
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Area on the page that could be linked to with an anchor */
export type SectionAnchorTarget = Entity & {
  __typename?: 'SectionAnchorTarget'
  anchorId: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionAnchorTargetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionAnchorTargetWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionAnchorTargetConnection = {
  __typename?: 'SectionAnchorTargetConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionAnchorTargetEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionAnchorTargetCreateInput = {
  anchorId: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionAnchorTargetCreateManyInlineInput = {
  /** Create and connect multiple existing SectionAnchorTarget documents */
  create?: InputMaybe<Array<SectionAnchorTargetCreateInput>>
}

export type SectionAnchorTargetCreateOneInlineInput = {
  /** Create and connect one SectionAnchorTarget document */
  create?: InputMaybe<SectionAnchorTargetCreateInput>
}

export type SectionAnchorTargetCreateWithPositionInput = {
  /** Document to create */
  data: SectionAnchorTargetCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionAnchorTargetEdge = {
  __typename?: 'SectionAnchorTargetEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionAnchorTarget
}

/** Identifies documents */
export type SectionAnchorTargetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionAnchorTargetWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionAnchorTargetWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionAnchorTargetWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  anchorId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  anchorId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  anchorId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  anchorId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  anchorId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  anchorId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  anchorId_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionAnchorTargetOrderByInput {
  AnchorIdAsc = 'anchorId_ASC',
  AnchorIdDesc = 'anchorId_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionAnchorTargetParent = EventPage | LandingPage

export type SectionAnchorTargetParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionAnchorTargetParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionAnchorTargetParentCreateManyInlineInput = {
  /** Connect multiple existing SectionAnchorTargetParent documents */
  connect?: InputMaybe<Array<SectionAnchorTargetParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionAnchorTargetParent documents */
  create?: InputMaybe<Array<SectionAnchorTargetParentCreateInput>>
}

export type SectionAnchorTargetParentCreateOneInlineInput = {
  /** Connect one existing SectionAnchorTargetParent document */
  connect?: InputMaybe<SectionAnchorTargetParentWhereUniqueInput>
  /** Create and connect one SectionAnchorTargetParent document */
  create?: InputMaybe<SectionAnchorTargetParentCreateInput>
}

export type SectionAnchorTargetParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionAnchorTargetParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionAnchorTargetParent documents */
  connect?: InputMaybe<Array<SectionAnchorTargetParentConnectInput>>
  /** Create and connect multiple SectionAnchorTargetParent documents */
  create?: InputMaybe<Array<SectionAnchorTargetParentCreateInput>>
  /** Delete multiple SectionAnchorTargetParent documents */
  delete?: InputMaybe<Array<SectionAnchorTargetParentWhereUniqueInput>>
  /** Disconnect multiple SectionAnchorTargetParent documents */
  disconnect?: InputMaybe<Array<SectionAnchorTargetParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionAnchorTargetParent documents */
  set?: InputMaybe<Array<SectionAnchorTargetParentWhereUniqueInput>>
  /** Update multiple SectionAnchorTargetParent documents */
  update?: InputMaybe<Array<SectionAnchorTargetParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionAnchorTargetParent documents */
  upsert?: InputMaybe<Array<SectionAnchorTargetParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionAnchorTargetParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionAnchorTargetParentUpdateOneInlineInput = {
  /** Connect existing SectionAnchorTargetParent document */
  connect?: InputMaybe<SectionAnchorTargetParentWhereUniqueInput>
  /** Create and connect one SectionAnchorTargetParent document */
  create?: InputMaybe<SectionAnchorTargetParentCreateInput>
  /** Delete currently connected SectionAnchorTargetParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionAnchorTargetParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionAnchorTargetParent document */
  update?: InputMaybe<SectionAnchorTargetParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionAnchorTargetParent document */
  upsert?: InputMaybe<SectionAnchorTargetParentUpsertWithNestedWhereUniqueInput>
}

export type SectionAnchorTargetParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionAnchorTargetParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionAnchorTargetParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionAnchorTargetParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionAnchorTargetUpdateInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>
}

export type SectionAnchorTargetUpdateManyInlineInput = {
  /** Create and connect multiple SectionAnchorTarget component instances */
  create?: InputMaybe<Array<SectionAnchorTargetCreateWithPositionInput>>
  /** Delete multiple SectionAnchorTarget documents */
  delete?: InputMaybe<Array<SectionAnchorTargetWhereUniqueInput>>
  /** Update multiple SectionAnchorTarget component instances */
  update?: InputMaybe<Array<SectionAnchorTargetUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionAnchorTarget component instances */
  upsert?: InputMaybe<Array<SectionAnchorTargetUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionAnchorTargetUpdateManyInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>
}

export type SectionAnchorTargetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionAnchorTargetUpdateManyInput
  /** Document search */
  where: SectionAnchorTargetWhereInput
}

export type SectionAnchorTargetUpdateOneInlineInput = {
  /** Create and connect one SectionAnchorTarget document */
  create?: InputMaybe<SectionAnchorTargetCreateInput>
  /** Delete currently connected SectionAnchorTarget document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionAnchorTarget document */
  update?: InputMaybe<SectionAnchorTargetUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionAnchorTarget document */
  upsert?: InputMaybe<SectionAnchorTargetUpsertWithNestedWhereUniqueInput>
}

export type SectionAnchorTargetUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionAnchorTargetUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionAnchorTargetWhereUniqueInput
}

export type SectionAnchorTargetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionAnchorTargetUpdateInput
  /** Unique document search */
  where: SectionAnchorTargetWhereUniqueInput
}

export type SectionAnchorTargetUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionAnchorTargetCreateInput
  /** Update document if it exists */
  update: SectionAnchorTargetUpdateInput
}

export type SectionAnchorTargetUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionAnchorTargetUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionAnchorTargetWhereUniqueInput
}

export type SectionAnchorTargetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionAnchorTargetUpsertInput
  /** Unique document search */
  where: SectionAnchorTargetWhereUniqueInput
}

/** Identifies documents */
export type SectionAnchorTargetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionAnchorTargetWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionAnchorTargetWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionAnchorTargetWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  anchorId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  anchorId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  anchorId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  anchorId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  anchorId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  anchorId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  anchorId_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionAnchorTarget record uniquely */
export type SectionAnchorTargetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Call to action for App Download */
export type SectionAppCta = Entity & {
  __typename?: 'SectionAppCta'
  appStoreButton?: Maybe<Asset>
  appStoreUrl?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionAppCta>
  playStoreButton?: Maybe<Asset>
  playStoreUrl?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Call to action for App Download */
export type SectionAppCtaAppStoreButtonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Call to action for App Download */
export type SectionAppCtaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Call to action for App Download */
export type SectionAppCtaPlayStoreButtonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Call to action for App Download */
export type SectionAppCtaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionAppCtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionAppCtaWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionAppCtaConnection = {
  __typename?: 'SectionAppCtaConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionAppCtaEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionAppCtaCreateInput = {
  appStoreButton?: InputMaybe<AssetCreateOneInlineInput>
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionAppCtaCreateLocalizationsInput>
  playStoreButton?: InputMaybe<AssetCreateOneInlineInput>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionAppCtaCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionAppCtaCreateLocalizationInput = {
  /** Localization input */
  data: SectionAppCtaCreateLocalizationDataInput
  locale: Locale
}

export type SectionAppCtaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionAppCtaCreateLocalizationInput>>
}

export type SectionAppCtaCreateManyInlineInput = {
  /** Create and connect multiple existing SectionAppCta documents */
  create?: InputMaybe<Array<SectionAppCtaCreateInput>>
}

export type SectionAppCtaCreateOneInlineInput = {
  /** Create and connect one SectionAppCta document */
  create?: InputMaybe<SectionAppCtaCreateInput>
}

export type SectionAppCtaCreateWithPositionInput = {
  /** Document to create */
  data: SectionAppCtaCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionAppCtaEdge = {
  __typename?: 'SectionAppCtaEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionAppCta
}

/** Identifies documents */
export type SectionAppCtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionAppCtaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionAppCtaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionAppCtaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  appStoreButton?: InputMaybe<AssetWhereInput>
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  appStoreUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  appStoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  appStoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  appStoreUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  appStoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  appStoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  appStoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  appStoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  appStoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  playStoreButton?: InputMaybe<AssetWhereInput>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  playStoreUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  playStoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  playStoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  playStoreUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  playStoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  playStoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  playStoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  playStoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  playStoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionAppCtaOrderByInput {
  AppStoreUrlAsc = 'appStoreUrl_ASC',
  AppStoreUrlDesc = 'appStoreUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PlayStoreUrlAsc = 'playStoreUrl_ASC',
  PlayStoreUrlDesc = 'playStoreUrl_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionAppCtaParent = EventPage

export type SectionAppCtaParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionAppCtaParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionAppCtaParentCreateManyInlineInput = {
  /** Connect multiple existing SectionAppCtaParent documents */
  connect?: InputMaybe<Array<SectionAppCtaParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionAppCtaParent documents */
  create?: InputMaybe<Array<SectionAppCtaParentCreateInput>>
}

export type SectionAppCtaParentCreateOneInlineInput = {
  /** Connect one existing SectionAppCtaParent document */
  connect?: InputMaybe<SectionAppCtaParentWhereUniqueInput>
  /** Create and connect one SectionAppCtaParent document */
  create?: InputMaybe<SectionAppCtaParentCreateInput>
}

export type SectionAppCtaParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionAppCtaParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionAppCtaParent documents */
  connect?: InputMaybe<Array<SectionAppCtaParentConnectInput>>
  /** Create and connect multiple SectionAppCtaParent documents */
  create?: InputMaybe<Array<SectionAppCtaParentCreateInput>>
  /** Delete multiple SectionAppCtaParent documents */
  delete?: InputMaybe<Array<SectionAppCtaParentWhereUniqueInput>>
  /** Disconnect multiple SectionAppCtaParent documents */
  disconnect?: InputMaybe<Array<SectionAppCtaParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionAppCtaParent documents */
  set?: InputMaybe<Array<SectionAppCtaParentWhereUniqueInput>>
  /** Update multiple SectionAppCtaParent documents */
  update?: InputMaybe<Array<SectionAppCtaParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionAppCtaParent documents */
  upsert?: InputMaybe<Array<SectionAppCtaParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionAppCtaParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionAppCtaParentUpdateOneInlineInput = {
  /** Connect existing SectionAppCtaParent document */
  connect?: InputMaybe<SectionAppCtaParentWhereUniqueInput>
  /** Create and connect one SectionAppCtaParent document */
  create?: InputMaybe<SectionAppCtaParentCreateInput>
  /** Delete currently connected SectionAppCtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionAppCtaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionAppCtaParent document */
  update?: InputMaybe<SectionAppCtaParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionAppCtaParent document */
  upsert?: InputMaybe<SectionAppCtaParentUpsertWithNestedWhereUniqueInput>
}

export type SectionAppCtaParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionAppCtaParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionAppCtaParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionAppCtaParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionAppCtaUpdateInput = {
  appStoreButton?: InputMaybe<AssetUpdateOneInlineInput>
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionAppCtaUpdateLocalizationsInput>
  playStoreButton?: InputMaybe<AssetUpdateOneInlineInput>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionAppCtaUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionAppCtaUpdateLocalizationInput = {
  data: SectionAppCtaUpdateLocalizationDataInput
  locale: Locale
}

export type SectionAppCtaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionAppCtaCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionAppCtaUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionAppCtaUpsertLocalizationInput>>
}

export type SectionAppCtaUpdateManyInlineInput = {
  /** Create and connect multiple SectionAppCta component instances */
  create?: InputMaybe<Array<SectionAppCtaCreateWithPositionInput>>
  /** Delete multiple SectionAppCta documents */
  delete?: InputMaybe<Array<SectionAppCtaWhereUniqueInput>>
  /** Update multiple SectionAppCta component instances */
  update?: InputMaybe<Array<SectionAppCtaUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionAppCta component instances */
  upsert?: InputMaybe<Array<SectionAppCtaUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionAppCtaUpdateManyInput = {
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionAppCtaUpdateManyLocalizationsInput>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionAppCtaUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionAppCtaUpdateManyLocalizationInput = {
  data: SectionAppCtaUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionAppCtaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionAppCtaUpdateManyLocalizationInput>>
}

export type SectionAppCtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionAppCtaUpdateManyInput
  /** Document search */
  where: SectionAppCtaWhereInput
}

export type SectionAppCtaUpdateOneInlineInput = {
  /** Create and connect one SectionAppCta document */
  create?: InputMaybe<SectionAppCtaCreateInput>
  /** Delete currently connected SectionAppCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionAppCta document */
  update?: InputMaybe<SectionAppCtaUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionAppCta document */
  upsert?: InputMaybe<SectionAppCtaUpsertWithNestedWhereUniqueInput>
}

export type SectionAppCtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionAppCtaUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionAppCtaWhereUniqueInput
}

export type SectionAppCtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionAppCtaUpdateInput
  /** Unique document search */
  where: SectionAppCtaWhereUniqueInput
}

export type SectionAppCtaUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionAppCtaCreateInput
  /** Update document if it exists */
  update: SectionAppCtaUpdateInput
}

export type SectionAppCtaUpsertLocalizationInput = {
  create: SectionAppCtaCreateLocalizationDataInput
  locale: Locale
  update: SectionAppCtaUpdateLocalizationDataInput
}

export type SectionAppCtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionAppCtaUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionAppCtaWhereUniqueInput
}

export type SectionAppCtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionAppCtaUpsertInput
  /** Unique document search */
  where: SectionAppCtaWhereUniqueInput
}

/** Identifies documents */
export type SectionAppCtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionAppCtaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionAppCtaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionAppCtaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  appStoreButton?: InputMaybe<AssetWhereInput>
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  appStoreUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  appStoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  appStoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  appStoreUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  appStoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  appStoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  appStoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  appStoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  appStoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  playStoreButton?: InputMaybe<AssetWhereInput>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  playStoreUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  playStoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  playStoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  playStoreUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  playStoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  playStoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  playStoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  playStoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  playStoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionAppCta record uniquely */
export type SectionAppCtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionBanner = Entity & {
  __typename?: 'SectionBanner'
  banner: Asset
  /** If this is not set, none will be shown. */
  ctaText?: Maybe<Scalars['String']['output']>
  ctaUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionBanner>
  /** Logo for display over the banner */
  logo?: Maybe<Asset>
  /** System stage field */
  stage: Stage
  subtitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionBannerBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionBannerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionBannerLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionBannerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionBannerWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionBannerConnection = {
  __typename?: 'SectionBannerConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionBannerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionBannerCreateInput = {
  banner: AssetCreateOneInlineInput
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionBannerCreateLocalizationsInput>
  logo?: InputMaybe<AssetCreateOneInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionBannerCreateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionBannerCreateLocalizationInput = {
  /** Localization input */
  data: SectionBannerCreateLocalizationDataInput
  locale: Locale
}

export type SectionBannerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionBannerCreateLocalizationInput>>
}

export type SectionBannerCreateManyInlineInput = {
  /** Create and connect multiple existing SectionBanner documents */
  create?: InputMaybe<Array<SectionBannerCreateInput>>
}

export type SectionBannerCreateOneInlineInput = {
  /** Create and connect one SectionBanner document */
  create?: InputMaybe<SectionBannerCreateInput>
}

export type SectionBannerCreateWithPositionInput = {
  /** Document to create */
  data: SectionBannerCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionBannerEdge = {
  __typename?: 'SectionBannerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionBanner
}

/** Identifies documents */
export type SectionBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionBannerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionBannerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionBannerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  banner?: InputMaybe<AssetWhereInput>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionBannerOrderByInput {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionBannerParent = EventPage | LandingPage

export type SectionBannerParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionBannerParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionBannerParentCreateManyInlineInput = {
  /** Connect multiple existing SectionBannerParent documents */
  connect?: InputMaybe<Array<SectionBannerParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionBannerParent documents */
  create?: InputMaybe<Array<SectionBannerParentCreateInput>>
}

export type SectionBannerParentCreateOneInlineInput = {
  /** Connect one existing SectionBannerParent document */
  connect?: InputMaybe<SectionBannerParentWhereUniqueInput>
  /** Create and connect one SectionBannerParent document */
  create?: InputMaybe<SectionBannerParentCreateInput>
}

export type SectionBannerParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionBannerParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionBannerParent documents */
  connect?: InputMaybe<Array<SectionBannerParentConnectInput>>
  /** Create and connect multiple SectionBannerParent documents */
  create?: InputMaybe<Array<SectionBannerParentCreateInput>>
  /** Delete multiple SectionBannerParent documents */
  delete?: InputMaybe<Array<SectionBannerParentWhereUniqueInput>>
  /** Disconnect multiple SectionBannerParent documents */
  disconnect?: InputMaybe<Array<SectionBannerParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionBannerParent documents */
  set?: InputMaybe<Array<SectionBannerParentWhereUniqueInput>>
  /** Update multiple SectionBannerParent documents */
  update?: InputMaybe<Array<SectionBannerParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionBannerParent documents */
  upsert?: InputMaybe<Array<SectionBannerParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionBannerParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionBannerParentUpdateOneInlineInput = {
  /** Connect existing SectionBannerParent document */
  connect?: InputMaybe<SectionBannerParentWhereUniqueInput>
  /** Create and connect one SectionBannerParent document */
  create?: InputMaybe<SectionBannerParentCreateInput>
  /** Delete currently connected SectionBannerParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionBannerParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionBannerParent document */
  update?: InputMaybe<SectionBannerParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionBannerParent document */
  upsert?: InputMaybe<SectionBannerParentUpsertWithNestedWhereUniqueInput>
}

export type SectionBannerParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionBannerParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionBannerParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionBannerParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionBannerUpdateInput = {
  banner?: InputMaybe<AssetUpdateOneInlineInput>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionBannerUpdateLocalizationsInput>
  logo?: InputMaybe<AssetUpdateOneInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionBannerUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionBannerUpdateLocalizationInput = {
  data: SectionBannerUpdateLocalizationDataInput
  locale: Locale
}

export type SectionBannerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionBannerCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionBannerUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionBannerUpsertLocalizationInput>>
}

export type SectionBannerUpdateManyInlineInput = {
  /** Create and connect multiple SectionBanner component instances */
  create?: InputMaybe<Array<SectionBannerCreateWithPositionInput>>
  /** Delete multiple SectionBanner documents */
  delete?: InputMaybe<Array<SectionBannerWhereUniqueInput>>
  /** Update multiple SectionBanner component instances */
  update?: InputMaybe<Array<SectionBannerUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionBanner component instances */
  upsert?: InputMaybe<Array<SectionBannerUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionBannerUpdateManyInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionBannerUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionBannerUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionBannerUpdateManyLocalizationInput = {
  data: SectionBannerUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionBannerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionBannerUpdateManyLocalizationInput>>
}

export type SectionBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionBannerUpdateManyInput
  /** Document search */
  where: SectionBannerWhereInput
}

export type SectionBannerUpdateOneInlineInput = {
  /** Create and connect one SectionBanner document */
  create?: InputMaybe<SectionBannerCreateInput>
  /** Delete currently connected SectionBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionBanner document */
  update?: InputMaybe<SectionBannerUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionBanner document */
  upsert?: InputMaybe<SectionBannerUpsertWithNestedWhereUniqueInput>
}

export type SectionBannerUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionBannerUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionBannerWhereUniqueInput
}

export type SectionBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionBannerUpdateInput
  /** Unique document search */
  where: SectionBannerWhereUniqueInput
}

export type SectionBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionBannerCreateInput
  /** Update document if it exists */
  update: SectionBannerUpdateInput
}

export type SectionBannerUpsertLocalizationInput = {
  create: SectionBannerCreateLocalizationDataInput
  locale: Locale
  update: SectionBannerUpdateLocalizationDataInput
}

export type SectionBannerUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionBannerUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionBannerWhereUniqueInput
}

export type SectionBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionBannerUpsertInput
  /** Unique document search */
  where: SectionBannerWhereUniqueInput
}

/** Identifies documents */
export type SectionBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionBannerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionBannerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionBannerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  banner?: InputMaybe<AssetWhereInput>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionBanner record uniquely */
export type SectionBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section displaying items with bold numbers with the description below and optional call to action */
export type SectionByTheNumbers = Entity & {
  __typename?: 'SectionByTheNumbers'
  /** Component is designed to handle 3 counters. Addig more or less will not break the component, but design can look weird. */
  counters: Array<AnimatedCounter>
  cta?: Maybe<CallToAction>
  /** Provide length in milliseconds. If not provided, defaults to 1500ms (1.5 seconds) */
  duration?: Maybe<Scalars['Int']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  items: Array<ExplanationStep>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionByTheNumbers>
  /** Select a custom padding for this section, otherwise default is used. */
  sectionPadding?: Maybe<SectionPadding>
  /** System stage field */
  stage: Stage
  /** Sets component color scheme. */
  styleVariant?: Maybe<ComponentStyle>
  /** Section subtitle */
  subtitle?: Maybe<Scalars['String']['output']>
  /** Section title */
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section displaying items with bold numbers with the description below and optional call to action */
export type SectionByTheNumbersCountersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<AnimatedCounterOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AnimatedCounterWhereInput>
}

/** Section displaying items with bold numbers with the description below and optional call to action */
export type SectionByTheNumbersCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section displaying items with bold numbers with the description below and optional call to action */
export type SectionByTheNumbersItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ExplanationStepOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ExplanationStepWhereInput>
}

/** Section displaying items with bold numbers with the description below and optional call to action */
export type SectionByTheNumbersLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section displaying items with bold numbers with the description below and optional call to action */
export type SectionByTheNumbersUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionByTheNumbersConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionByTheNumbersWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionByTheNumbersConnection = {
  __typename?: 'SectionByTheNumbersConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionByTheNumbersEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionByTheNumbersCreateInput = {
  counters: AnimatedCounterCreateManyInlineInput
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  duration?: InputMaybe<Scalars['Int']['input']>
  items?: InputMaybe<ExplanationStepCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionByTheNumbersCreateLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionByTheNumbersCreateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionByTheNumbersCreateLocalizationInput = {
  /** Localization input */
  data: SectionByTheNumbersCreateLocalizationDataInput
  locale: Locale
}

export type SectionByTheNumbersCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionByTheNumbersCreateLocalizationInput>>
}

export type SectionByTheNumbersCreateManyInlineInput = {
  /** Create and connect multiple existing SectionByTheNumbers documents */
  create?: InputMaybe<Array<SectionByTheNumbersCreateInput>>
}

export type SectionByTheNumbersCreateOneInlineInput = {
  /** Create and connect one SectionByTheNumbers document */
  create?: InputMaybe<SectionByTheNumbersCreateInput>
}

export type SectionByTheNumbersCreateWithPositionInput = {
  /** Document to create */
  data: SectionByTheNumbersCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionByTheNumbersEdge = {
  __typename?: 'SectionByTheNumbersEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionByTheNumbers
}

/** Identifies documents */
export type SectionByTheNumbersManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionByTheNumbersWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionByTheNumbersWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionByTheNumbersWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  counters_every?: InputMaybe<AnimatedCounterWhereInput>
  counters_none?: InputMaybe<AnimatedCounterWhereInput>
  counters_some?: InputMaybe<AnimatedCounterWhereInput>
  cta?: InputMaybe<CallToActionWhereInput>
  duration?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  duration_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  duration_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  duration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  duration_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  duration_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  duration_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  duration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  items_every?: InputMaybe<ExplanationStepWhereInput>
  items_none?: InputMaybe<ExplanationStepWhereInput>
  items_some?: InputMaybe<ExplanationStepWhereInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionByTheNumbersOrderByInput {
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SectionPaddingAsc = 'sectionPadding_ASC',
  SectionPaddingDesc = 'sectionPadding_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionByTheNumbersParent = EventPage | LandingPage

export type SectionByTheNumbersParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionByTheNumbersParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionByTheNumbersParentCreateManyInlineInput = {
  /** Connect multiple existing SectionByTheNumbersParent documents */
  connect?: InputMaybe<Array<SectionByTheNumbersParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionByTheNumbersParent documents */
  create?: InputMaybe<Array<SectionByTheNumbersParentCreateInput>>
}

export type SectionByTheNumbersParentCreateOneInlineInput = {
  /** Connect one existing SectionByTheNumbersParent document */
  connect?: InputMaybe<SectionByTheNumbersParentWhereUniqueInput>
  /** Create and connect one SectionByTheNumbersParent document */
  create?: InputMaybe<SectionByTheNumbersParentCreateInput>
}

export type SectionByTheNumbersParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionByTheNumbersParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionByTheNumbersParent documents */
  connect?: InputMaybe<Array<SectionByTheNumbersParentConnectInput>>
  /** Create and connect multiple SectionByTheNumbersParent documents */
  create?: InputMaybe<Array<SectionByTheNumbersParentCreateInput>>
  /** Delete multiple SectionByTheNumbersParent documents */
  delete?: InputMaybe<Array<SectionByTheNumbersParentWhereUniqueInput>>
  /** Disconnect multiple SectionByTheNumbersParent documents */
  disconnect?: InputMaybe<Array<SectionByTheNumbersParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionByTheNumbersParent documents */
  set?: InputMaybe<Array<SectionByTheNumbersParentWhereUniqueInput>>
  /** Update multiple SectionByTheNumbersParent documents */
  update?: InputMaybe<Array<SectionByTheNumbersParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionByTheNumbersParent documents */
  upsert?: InputMaybe<Array<SectionByTheNumbersParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionByTheNumbersParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionByTheNumbersParentUpdateOneInlineInput = {
  /** Connect existing SectionByTheNumbersParent document */
  connect?: InputMaybe<SectionByTheNumbersParentWhereUniqueInput>
  /** Create and connect one SectionByTheNumbersParent document */
  create?: InputMaybe<SectionByTheNumbersParentCreateInput>
  /** Delete currently connected SectionByTheNumbersParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionByTheNumbersParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionByTheNumbersParent document */
  update?: InputMaybe<SectionByTheNumbersParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionByTheNumbersParent document */
  upsert?: InputMaybe<SectionByTheNumbersParentUpsertWithNestedWhereUniqueInput>
}

export type SectionByTheNumbersParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionByTheNumbersParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionByTheNumbersParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionByTheNumbersParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionByTheNumbersUpdateInput = {
  counters?: InputMaybe<AnimatedCounterUpdateManyInlineInput>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  duration?: InputMaybe<Scalars['Int']['input']>
  items?: InputMaybe<ExplanationStepUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionByTheNumbersUpdateLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionByTheNumbersUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionByTheNumbersUpdateLocalizationInput = {
  data: SectionByTheNumbersUpdateLocalizationDataInput
  locale: Locale
}

export type SectionByTheNumbersUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionByTheNumbersCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionByTheNumbersUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionByTheNumbersUpsertLocalizationInput>>
}

export type SectionByTheNumbersUpdateManyInlineInput = {
  /** Create and connect multiple SectionByTheNumbers component instances */
  create?: InputMaybe<Array<SectionByTheNumbersCreateWithPositionInput>>
  /** Delete multiple SectionByTheNumbers documents */
  delete?: InputMaybe<Array<SectionByTheNumbersWhereUniqueInput>>
  /** Update multiple SectionByTheNumbers component instances */
  update?: InputMaybe<Array<SectionByTheNumbersUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionByTheNumbers component instances */
  upsert?: InputMaybe<Array<SectionByTheNumbersUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionByTheNumbersUpdateManyInput = {
  duration?: InputMaybe<Scalars['Int']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionByTheNumbersUpdateManyLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionByTheNumbersUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionByTheNumbersUpdateManyLocalizationInput = {
  data: SectionByTheNumbersUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionByTheNumbersUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionByTheNumbersUpdateManyLocalizationInput>>
}

export type SectionByTheNumbersUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionByTheNumbersUpdateManyInput
  /** Document search */
  where: SectionByTheNumbersWhereInput
}

export type SectionByTheNumbersUpdateOneInlineInput = {
  /** Create and connect one SectionByTheNumbers document */
  create?: InputMaybe<SectionByTheNumbersCreateInput>
  /** Delete currently connected SectionByTheNumbers document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionByTheNumbers document */
  update?: InputMaybe<SectionByTheNumbersUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionByTheNumbers document */
  upsert?: InputMaybe<SectionByTheNumbersUpsertWithNestedWhereUniqueInput>
}

export type SectionByTheNumbersUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionByTheNumbersUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionByTheNumbersWhereUniqueInput
}

export type SectionByTheNumbersUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionByTheNumbersUpdateInput
  /** Unique document search */
  where: SectionByTheNumbersWhereUniqueInput
}

export type SectionByTheNumbersUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionByTheNumbersCreateInput
  /** Update document if it exists */
  update: SectionByTheNumbersUpdateInput
}

export type SectionByTheNumbersUpsertLocalizationInput = {
  create: SectionByTheNumbersCreateLocalizationDataInput
  locale: Locale
  update: SectionByTheNumbersUpdateLocalizationDataInput
}

export type SectionByTheNumbersUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionByTheNumbersUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionByTheNumbersWhereUniqueInput
}

export type SectionByTheNumbersUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionByTheNumbersUpsertInput
  /** Unique document search */
  where: SectionByTheNumbersWhereUniqueInput
}

/** Identifies documents */
export type SectionByTheNumbersWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionByTheNumbersWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionByTheNumbersWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionByTheNumbersWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  counters_every?: InputMaybe<AnimatedCounterWhereInput>
  counters_none?: InputMaybe<AnimatedCounterWhereInput>
  counters_some?: InputMaybe<AnimatedCounterWhereInput>
  cta?: InputMaybe<CallToActionWhereInput>
  duration?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  duration_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  duration_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  duration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  duration_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  duration_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  duration_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  duration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  items_every?: InputMaybe<ExplanationStepWhereInput>
  items_none?: InputMaybe<ExplanationStepWhereInput>
  items_some?: InputMaybe<ExplanationStepWhereInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionByTheNumbers record uniquely */
export type SectionByTheNumbersWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Text will be collapsed and only title will be shown */
export type SectionCollapsedRichContent = Entity & {
  __typename?: 'SectionCollapsedRichContent'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionCollapsedRichContent>
  /** System stage field */
  stage: Stage
  /** Text to be displayed */
  text: RichText
  /** Title of the collapsed content */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Text will be collapsed and only title will be shown */
export type SectionCollapsedRichContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Text will be collapsed and only title will be shown */
export type SectionCollapsedRichContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionCollapsedRichContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionCollapsedRichContentWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionCollapsedRichContentConnection = {
  __typename?: 'SectionCollapsedRichContentConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionCollapsedRichContentEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionCollapsedRichContentCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionCollapsedRichContentCreateLocalizationsInput>
  /** text input for default locale (de) */
  text: Scalars['RichTextAST']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionCollapsedRichContentCreateLocalizationDataInput = {
  text: Scalars['RichTextAST']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionCollapsedRichContentCreateLocalizationInput = {
  /** Localization input */
  data: SectionCollapsedRichContentCreateLocalizationDataInput
  locale: Locale
}

export type SectionCollapsedRichContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionCollapsedRichContentCreateLocalizationInput>>
}

export type SectionCollapsedRichContentCreateManyInlineInput = {
  /** Create and connect multiple existing SectionCollapsedRichContent documents */
  create?: InputMaybe<Array<SectionCollapsedRichContentCreateInput>>
}

export type SectionCollapsedRichContentCreateOneInlineInput = {
  /** Create and connect one SectionCollapsedRichContent document */
  create?: InputMaybe<SectionCollapsedRichContentCreateInput>
}

export type SectionCollapsedRichContentCreateWithPositionInput = {
  /** Document to create */
  data: SectionCollapsedRichContentCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionCollapsedRichContentEdge = {
  __typename?: 'SectionCollapsedRichContentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionCollapsedRichContent
}

/** Identifies documents */
export type SectionCollapsedRichContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionCollapsedRichContentWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionCollapsedRichContentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionCollapsedRichContentWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionCollapsedRichContentOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionCollapsedRichContentParent = TopicPageSection

export type SectionCollapsedRichContentParentConnectInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionConnectInput>
}

export type SectionCollapsedRichContentParentCreateInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionCreateInput>
}

export type SectionCollapsedRichContentParentCreateManyInlineInput = {
  /** Create and connect multiple existing SectionCollapsedRichContentParent documents */
  create?: InputMaybe<Array<SectionCollapsedRichContentParentCreateInput>>
}

export type SectionCollapsedRichContentParentCreateOneInlineInput = {
  /** Create and connect one SectionCollapsedRichContentParent document */
  create?: InputMaybe<SectionCollapsedRichContentParentCreateInput>
}

export type SectionCollapsedRichContentParentCreateWithPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionCreateWithPositionInput>
}

export type SectionCollapsedRichContentParentUpdateInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateInput>
}

export type SectionCollapsedRichContentParentUpdateManyInlineInput = {
  /** Create and connect multiple SectionCollapsedRichContentParent component instances */
  create?: InputMaybe<Array<SectionCollapsedRichContentParentCreateWithPositionInput>>
  /** Delete multiple SectionCollapsedRichContentParent documents */
  delete?: InputMaybe<Array<SectionCollapsedRichContentParentWhereUniqueInput>>
  /** Update multiple SectionCollapsedRichContentParent component instances */
  update?: InputMaybe<Array<SectionCollapsedRichContentParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionCollapsedRichContentParent component instances */
  upsert?: InputMaybe<Array<SectionCollapsedRichContentParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionCollapsedRichContentParentUpdateManyWithNestedWhereInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateManyWithNestedWhereInput>
}

export type SectionCollapsedRichContentParentUpdateOneInlineInput = {
  /** Create and connect one SectionCollapsedRichContentParent document */
  create?: InputMaybe<SectionCollapsedRichContentParentCreateInput>
  /** Delete currently connected SectionCollapsedRichContentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionCollapsedRichContentParent document */
  update?: InputMaybe<SectionCollapsedRichContentParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionCollapsedRichContentParent document */
  upsert?: InputMaybe<SectionCollapsedRichContentParentUpsertWithNestedWhereUniqueInput>
}

export type SectionCollapsedRichContentParentUpdateWithNestedWhereUniqueAndPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueAndPositionInput>
}

export type SectionCollapsedRichContentParentUpdateWithNestedWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueInput>
}

export type SectionCollapsedRichContentParentUpsertWithNestedWhereUniqueAndPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueAndPositionInput>
}

export type SectionCollapsedRichContentParentUpsertWithNestedWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueInput>
}

export type SectionCollapsedRichContentParentWhereInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionWhereInput>
}

export type SectionCollapsedRichContentParentWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionWhereUniqueInput>
}

export type SectionCollapsedRichContentUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<SectionCollapsedRichContentUpdateLocalizationsInput>
  /** text input for default locale (de) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCollapsedRichContentUpdateLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCollapsedRichContentUpdateLocalizationInput = {
  data: SectionCollapsedRichContentUpdateLocalizationDataInput
  locale: Locale
}

export type SectionCollapsedRichContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionCollapsedRichContentCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionCollapsedRichContentUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionCollapsedRichContentUpsertLocalizationInput>>
}

export type SectionCollapsedRichContentUpdateManyInlineInput = {
  /** Create and connect multiple SectionCollapsedRichContent component instances */
  create?: InputMaybe<Array<SectionCollapsedRichContentCreateWithPositionInput>>
  /** Delete multiple SectionCollapsedRichContent documents */
  delete?: InputMaybe<Array<SectionCollapsedRichContentWhereUniqueInput>>
  /** Update multiple SectionCollapsedRichContent component instances */
  update?: InputMaybe<Array<SectionCollapsedRichContentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionCollapsedRichContent component instances */
  upsert?: InputMaybe<Array<SectionCollapsedRichContentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionCollapsedRichContentUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionCollapsedRichContentUpdateManyLocalizationsInput>
  /** text input for default locale (de) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCollapsedRichContentUpdateManyLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCollapsedRichContentUpdateManyLocalizationInput = {
  data: SectionCollapsedRichContentUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionCollapsedRichContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionCollapsedRichContentUpdateManyLocalizationInput>>
}

export type SectionCollapsedRichContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionCollapsedRichContentUpdateManyInput
  /** Document search */
  where: SectionCollapsedRichContentWhereInput
}

export type SectionCollapsedRichContentUpdateOneInlineInput = {
  /** Create and connect one SectionCollapsedRichContent document */
  create?: InputMaybe<SectionCollapsedRichContentCreateInput>
  /** Delete currently connected SectionCollapsedRichContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionCollapsedRichContent document */
  update?: InputMaybe<SectionCollapsedRichContentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionCollapsedRichContent document */
  upsert?: InputMaybe<SectionCollapsedRichContentUpsertWithNestedWhereUniqueInput>
}

export type SectionCollapsedRichContentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionCollapsedRichContentUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionCollapsedRichContentWhereUniqueInput
}

export type SectionCollapsedRichContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionCollapsedRichContentUpdateInput
  /** Unique document search */
  where: SectionCollapsedRichContentWhereUniqueInput
}

export type SectionCollapsedRichContentUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionCollapsedRichContentCreateInput
  /** Update document if it exists */
  update: SectionCollapsedRichContentUpdateInput
}

export type SectionCollapsedRichContentUpsertLocalizationInput = {
  create: SectionCollapsedRichContentCreateLocalizationDataInput
  locale: Locale
  update: SectionCollapsedRichContentUpdateLocalizationDataInput
}

export type SectionCollapsedRichContentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionCollapsedRichContentUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionCollapsedRichContentWhereUniqueInput
}

export type SectionCollapsedRichContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionCollapsedRichContentUpsertInput
  /** Unique document search */
  where: SectionCollapsedRichContentWhereUniqueInput
}

/** Identifies documents */
export type SectionCollapsedRichContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionCollapsedRichContentWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionCollapsedRichContentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionCollapsedRichContentWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionCollapsedRichContent record uniquely */
export type SectionCollapsedRichContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionContact = Entity & {
  __typename?: 'SectionContact'
  /** Text alignment centered */
  centered?: Maybe<Scalars['Boolean']['output']>
  contact: Array<Contact>
  /** Select a decoration pattern for this component. */
  decorationPattern?: Maybe<DecorationPattern>
  description?: Maybe<Scalars['String']['output']>
  /** A contact button below the contact cards. */
  generalCTA?: Maybe<CallToAction>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionContact>
  /** System stage field */
  stage: Stage
  /** Sets component color scheme. */
  styleVariant?: Maybe<ComponentStyle>
  /** Choose between light + dark theme. Light theme is default. */
  theme?: Maybe<OmrThemeVariant>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionContactContactArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ContactOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ContactWhereInput>
}

export type SectionContactGeneralCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SectionContactLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionContactUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionContactConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionContactWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionContactConnection = {
  __typename?: 'SectionContactConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionContactEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionContactCreateInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  contact?: InputMaybe<ContactCreateManyInlineInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  generalCTA?: InputMaybe<CallToActionCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionContactCreateLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionContactCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionContactCreateLocalizationInput = {
  /** Localization input */
  data: SectionContactCreateLocalizationDataInput
  locale: Locale
}

export type SectionContactCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionContactCreateLocalizationInput>>
}

export type SectionContactCreateManyInlineInput = {
  /** Create and connect multiple existing SectionContact documents */
  create?: InputMaybe<Array<SectionContactCreateInput>>
}

export type SectionContactCreateOneInlineInput = {
  /** Create and connect one SectionContact document */
  create?: InputMaybe<SectionContactCreateInput>
}

export type SectionContactCreateWithPositionInput = {
  /** Document to create */
  data: SectionContactCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionContactEdge = {
  __typename?: 'SectionContactEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionContact
}

/** Identifies documents */
export type SectionContactManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionContactWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionContactWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionContactWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>
  contact_every?: InputMaybe<ContactWhereInput>
  contact_none?: InputMaybe<ContactWhereInput>
  contact_some?: InputMaybe<ContactWhereInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  generalCTA?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionContactOrderByInput {
  CenteredAsc = 'centered_ASC',
  CenteredDesc = 'centered_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionContactParent = CareerPage | EventPage | LandingPage

export type SectionContactParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionContactParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionContactParentCreateManyInlineInput = {
  /** Connect multiple existing SectionContactParent documents */
  connect?: InputMaybe<Array<SectionContactParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionContactParent documents */
  create?: InputMaybe<Array<SectionContactParentCreateInput>>
}

export type SectionContactParentCreateOneInlineInput = {
  /** Connect one existing SectionContactParent document */
  connect?: InputMaybe<SectionContactParentWhereUniqueInput>
  /** Create and connect one SectionContactParent document */
  create?: InputMaybe<SectionContactParentCreateInput>
}

export type SectionContactParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionContactParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionContactParent documents */
  connect?: InputMaybe<Array<SectionContactParentConnectInput>>
  /** Create and connect multiple SectionContactParent documents */
  create?: InputMaybe<Array<SectionContactParentCreateInput>>
  /** Delete multiple SectionContactParent documents */
  delete?: InputMaybe<Array<SectionContactParentWhereUniqueInput>>
  /** Disconnect multiple SectionContactParent documents */
  disconnect?: InputMaybe<Array<SectionContactParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionContactParent documents */
  set?: InputMaybe<Array<SectionContactParentWhereUniqueInput>>
  /** Update multiple SectionContactParent documents */
  update?: InputMaybe<Array<SectionContactParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionContactParent documents */
  upsert?: InputMaybe<Array<SectionContactParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionContactParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionContactParentUpdateOneInlineInput = {
  /** Connect existing SectionContactParent document */
  connect?: InputMaybe<SectionContactParentWhereUniqueInput>
  /** Create and connect one SectionContactParent document */
  create?: InputMaybe<SectionContactParentCreateInput>
  /** Delete currently connected SectionContactParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionContactParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionContactParent document */
  update?: InputMaybe<SectionContactParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionContactParent document */
  upsert?: InputMaybe<SectionContactParentUpsertWithNestedWhereUniqueInput>
}

export type SectionContactParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionContactParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionContactParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionContactParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionContactUpdateInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  contact?: InputMaybe<ContactUpdateManyInlineInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  generalCTA?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionContactUpdateLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionContactUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionContactUpdateLocalizationInput = {
  data: SectionContactUpdateLocalizationDataInput
  locale: Locale
}

export type SectionContactUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionContactCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionContactUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionContactUpsertLocalizationInput>>
}

export type SectionContactUpdateManyInlineInput = {
  /** Create and connect multiple SectionContact component instances */
  create?: InputMaybe<Array<SectionContactCreateWithPositionInput>>
  /** Delete multiple SectionContact documents */
  delete?: InputMaybe<Array<SectionContactWhereUniqueInput>>
  /** Update multiple SectionContact component instances */
  update?: InputMaybe<Array<SectionContactUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionContact component instances */
  upsert?: InputMaybe<Array<SectionContactUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionContactUpdateManyInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionContactUpdateManyLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionContactUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionContactUpdateManyLocalizationInput = {
  data: SectionContactUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionContactUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionContactUpdateManyLocalizationInput>>
}

export type SectionContactUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionContactUpdateManyInput
  /** Document search */
  where: SectionContactWhereInput
}

export type SectionContactUpdateOneInlineInput = {
  /** Create and connect one SectionContact document */
  create?: InputMaybe<SectionContactCreateInput>
  /** Delete currently connected SectionContact document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionContact document */
  update?: InputMaybe<SectionContactUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionContact document */
  upsert?: InputMaybe<SectionContactUpsertWithNestedWhereUniqueInput>
}

export type SectionContactUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionContactUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionContactWhereUniqueInput
}

export type SectionContactUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionContactUpdateInput
  /** Unique document search */
  where: SectionContactWhereUniqueInput
}

export type SectionContactUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionContactCreateInput
  /** Update document if it exists */
  update: SectionContactUpdateInput
}

export type SectionContactUpsertLocalizationInput = {
  create: SectionContactCreateLocalizationDataInput
  locale: Locale
  update: SectionContactUpdateLocalizationDataInput
}

export type SectionContactUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionContactUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionContactWhereUniqueInput
}

export type SectionContactUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionContactUpsertInput
  /** Unique document search */
  where: SectionContactWhereUniqueInput
}

/** Identifies documents */
export type SectionContactWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionContactWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionContactWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionContactWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>
  contact_every?: InputMaybe<ContactWhereInput>
  contact_none?: InputMaybe<ContactWhereInput>
  contact_some?: InputMaybe<ContactWhereInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  generalCTA?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionContact record uniquely */
export type SectionContactWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section to reference different content items. */
export type SectionContentReference = Entity & {
  __typename?: 'SectionContentReference'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Reference to multiple content items. */
  references: Array<Union_References_Cm0qshprp123q07te06v2bu9e>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section to reference different content items. */
export type SectionContentReferenceReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

export type SectionContentReferenceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionContentReferenceWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionContentReferenceConnection = {
  __typename?: 'SectionContentReferenceConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionContentReferenceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionContentReferenceCreateInput = {
  references?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionContentReferenceCreateManyInlineInput = {
  /** Create and connect multiple existing SectionContentReference documents */
  create?: InputMaybe<Array<SectionContentReferenceCreateInput>>
}

export type SectionContentReferenceCreateOneInlineInput = {
  /** Create and connect one SectionContentReference document */
  create?: InputMaybe<SectionContentReferenceCreateInput>
}

export type SectionContentReferenceCreateWithPositionInput = {
  /** Document to create */
  data: SectionContentReferenceCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionContentReferenceEdge = {
  __typename?: 'SectionContentReferenceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionContentReference
}

/** Identifies documents */
export type SectionContentReferenceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionContentReferenceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionContentReferenceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionContentReferenceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty */
  references_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the union contains at least one connection to the provided item to the filter */
  references_some?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionContentReferenceOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionContentReferenceParent = TopicPageSection

export type SectionContentReferenceParentConnectInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionConnectInput>
}

export type SectionContentReferenceParentCreateInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionCreateInput>
}

export type SectionContentReferenceParentCreateManyInlineInput = {
  /** Create and connect multiple existing SectionContentReferenceParent documents */
  create?: InputMaybe<Array<SectionContentReferenceParentCreateInput>>
}

export type SectionContentReferenceParentCreateOneInlineInput = {
  /** Create and connect one SectionContentReferenceParent document */
  create?: InputMaybe<SectionContentReferenceParentCreateInput>
}

export type SectionContentReferenceParentCreateWithPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionCreateWithPositionInput>
}

export type SectionContentReferenceParentUpdateInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateInput>
}

export type SectionContentReferenceParentUpdateManyInlineInput = {
  /** Create and connect multiple SectionContentReferenceParent component instances */
  create?: InputMaybe<Array<SectionContentReferenceParentCreateWithPositionInput>>
  /** Delete multiple SectionContentReferenceParent documents */
  delete?: InputMaybe<Array<SectionContentReferenceParentWhereUniqueInput>>
  /** Update multiple SectionContentReferenceParent component instances */
  update?: InputMaybe<Array<SectionContentReferenceParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionContentReferenceParent component instances */
  upsert?: InputMaybe<Array<SectionContentReferenceParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionContentReferenceParentUpdateManyWithNestedWhereInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateManyWithNestedWhereInput>
}

export type SectionContentReferenceParentUpdateOneInlineInput = {
  /** Create and connect one SectionContentReferenceParent document */
  create?: InputMaybe<SectionContentReferenceParentCreateInput>
  /** Delete currently connected SectionContentReferenceParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionContentReferenceParent document */
  update?: InputMaybe<SectionContentReferenceParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionContentReferenceParent document */
  upsert?: InputMaybe<SectionContentReferenceParentUpsertWithNestedWhereUniqueInput>
}

export type SectionContentReferenceParentUpdateWithNestedWhereUniqueAndPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueAndPositionInput>
}

export type SectionContentReferenceParentUpdateWithNestedWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueInput>
}

export type SectionContentReferenceParentUpsertWithNestedWhereUniqueAndPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueAndPositionInput>
}

export type SectionContentReferenceParentUpsertWithNestedWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueInput>
}

export type SectionContentReferenceParentWhereInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionWhereInput>
}

export type SectionContentReferenceParentWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionWhereUniqueInput>
}

export type SectionContentReferenceUpdateInput = {
  references?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eUpdateManyInlineInput>
}

export type SectionContentReferenceUpdateManyInlineInput = {
  /** Create and connect multiple SectionContentReference component instances */
  create?: InputMaybe<Array<SectionContentReferenceCreateWithPositionInput>>
  /** Delete multiple SectionContentReference documents */
  delete?: InputMaybe<Array<SectionContentReferenceWhereUniqueInput>>
  /** Update multiple SectionContentReference component instances */
  update?: InputMaybe<Array<SectionContentReferenceUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionContentReference component instances */
  upsert?: InputMaybe<Array<SectionContentReferenceUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionContentReferenceUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type SectionContentReferenceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionContentReferenceUpdateManyInput
  /** Document search */
  where: SectionContentReferenceWhereInput
}

export type SectionContentReferenceUpdateOneInlineInput = {
  /** Create and connect one SectionContentReference document */
  create?: InputMaybe<SectionContentReferenceCreateInput>
  /** Delete currently connected SectionContentReference document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionContentReference document */
  update?: InputMaybe<SectionContentReferenceUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionContentReference document */
  upsert?: InputMaybe<SectionContentReferenceUpsertWithNestedWhereUniqueInput>
}

export type SectionContentReferenceUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionContentReferenceUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionContentReferenceWhereUniqueInput
}

export type SectionContentReferenceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionContentReferenceUpdateInput
  /** Unique document search */
  where: SectionContentReferenceWhereUniqueInput
}

export type SectionContentReferenceUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionContentReferenceCreateInput
  /** Update document if it exists */
  update: SectionContentReferenceUpdateInput
}

export type SectionContentReferenceUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionContentReferenceUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionContentReferenceWhereUniqueInput
}

export type SectionContentReferenceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionContentReferenceUpsertInput
  /** Unique document search */
  where: SectionContentReferenceWhereUniqueInput
}

/** Identifies documents */
export type SectionContentReferenceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionContentReferenceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionContentReferenceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionContentReferenceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty */
  references_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the union contains at least one connection to the provided item to the filter */
  references_some?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionContentReference record uniquely */
export type SectionContentReferenceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionCta = Entity & {
  __typename?: 'SectionCta'
  appStoreUrl?: Maybe<Scalars['String']['output']>
  /** Defines text and CTA position. Allowed (left center right) Default (center) */
  contentPosition?: Maybe<ElementPosition>
  ctaExternal?: Maybe<Scalars['Boolean']['output']>
  /** Optional content image for left/right aligned content. */
  ctaImage?: Maybe<Asset>
  ctaTarget: Scalars['String']['output']
  ctaText: Scalars['String']['output']
  ctaUrl: Scalars['String']['output']
  darkTheme?: Maybe<Scalars['Boolean']['output']>
  /** Defines a decoration pattern to use with the component is is used for. */
  decorationPattern?: Maybe<DecorationPattern>
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Reference an internal page */
  internalPageLink?: Maybe<EventPage>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionCta>
  partnerLogo?: Maybe<Asset>
  playStoreUrl?: Maybe<Scalars['String']['output']>
  showDecoration?: Maybe<Scalars['Boolean']['output']>
  /** System stage field */
  stage: Stage
  styleVariant?: Maybe<ComponentStyle>
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionCtaCtaImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionCtaInternalPageLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SectionCtaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionCtaPartnerLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionCtaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionCtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionCtaWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionCtaConnection = {
  __typename?: 'SectionCtaConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionCtaEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionCtaCreateInput = {
  /** appStoreUrl input for default locale (de) */
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  contentPosition?: InputMaybe<ElementPosition>
  ctaExternal?: InputMaybe<Scalars['Boolean']['input']>
  ctaImage?: InputMaybe<AssetCreateOneInlineInput>
  /** ctaTarget input for default locale (de) */
  ctaTarget: Scalars['String']['input']
  /** ctaText input for default locale (de) */
  ctaText: Scalars['String']['input']
  /** ctaUrl input for default locale (de) */
  ctaUrl: Scalars['String']['input']
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  internalPageLink?: InputMaybe<EventPageCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionCtaCreateLocalizationsInput>
  partnerLogo?: InputMaybe<AssetCreateOneInlineInput>
  /** playStoreUrl input for default locale (de) */
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  showDecoration?: InputMaybe<Scalars['Boolean']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionCtaCreateLocalizationDataInput = {
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  ctaTarget: Scalars['String']['input']
  ctaText: Scalars['String']['input']
  ctaUrl: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionCtaCreateLocalizationInput = {
  /** Localization input */
  data: SectionCtaCreateLocalizationDataInput
  locale: Locale
}

export type SectionCtaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionCtaCreateLocalizationInput>>
}

export type SectionCtaCreateManyInlineInput = {
  /** Create and connect multiple existing SectionCta documents */
  create?: InputMaybe<Array<SectionCtaCreateInput>>
}

export type SectionCtaCreateOneInlineInput = {
  /** Create and connect one SectionCta document */
  create?: InputMaybe<SectionCtaCreateInput>
}

export type SectionCtaCreateWithPositionInput = {
  /** Document to create */
  data: SectionCtaCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionCtaEdge = {
  __typename?: 'SectionCtaEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionCta
}

/** Identifies documents */
export type SectionCtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionCtaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionCtaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionCtaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  contentPosition?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  contentPosition_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  contentPosition_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  contentPosition_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  ctaExternal?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  ctaExternal_not?: InputMaybe<Scalars['Boolean']['input']>
  ctaImage?: InputMaybe<AssetWhereInput>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkTheme_not?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  internalPageLink?: InputMaybe<EventPageWhereInput>
  partnerLogo?: InputMaybe<AssetWhereInput>
  showDecoration?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showDecoration_not?: InputMaybe<Scalars['Boolean']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionCtaOrderByInput {
  AppStoreUrlAsc = 'appStoreUrl_ASC',
  AppStoreUrlDesc = 'appStoreUrl_DESC',
  ContentPositionAsc = 'contentPosition_ASC',
  ContentPositionDesc = 'contentPosition_DESC',
  CtaExternalAsc = 'ctaExternal_ASC',
  CtaExternalDesc = 'ctaExternal_DESC',
  CtaTargetAsc = 'ctaTarget_ASC',
  CtaTargetDesc = 'ctaTarget_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DarkThemeAsc = 'darkTheme_ASC',
  DarkThemeDesc = 'darkTheme_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PlayStoreUrlAsc = 'playStoreUrl_ASC',
  PlayStoreUrlDesc = 'playStoreUrl_DESC',
  ShowDecorationAsc = 'showDecoration_ASC',
  ShowDecorationDesc = 'showDecoration_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionCtaParent = CareerPage | EventPage | LandingPage

export type SectionCtaParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionCtaParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionCtaParentCreateManyInlineInput = {
  /** Connect multiple existing SectionCtaParent documents */
  connect?: InputMaybe<Array<SectionCtaParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionCtaParent documents */
  create?: InputMaybe<Array<SectionCtaParentCreateInput>>
}

export type SectionCtaParentCreateOneInlineInput = {
  /** Connect one existing SectionCtaParent document */
  connect?: InputMaybe<SectionCtaParentWhereUniqueInput>
  /** Create and connect one SectionCtaParent document */
  create?: InputMaybe<SectionCtaParentCreateInput>
}

export type SectionCtaParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionCtaParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionCtaParent documents */
  connect?: InputMaybe<Array<SectionCtaParentConnectInput>>
  /** Create and connect multiple SectionCtaParent documents */
  create?: InputMaybe<Array<SectionCtaParentCreateInput>>
  /** Delete multiple SectionCtaParent documents */
  delete?: InputMaybe<Array<SectionCtaParentWhereUniqueInput>>
  /** Disconnect multiple SectionCtaParent documents */
  disconnect?: InputMaybe<Array<SectionCtaParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionCtaParent documents */
  set?: InputMaybe<Array<SectionCtaParentWhereUniqueInput>>
  /** Update multiple SectionCtaParent documents */
  update?: InputMaybe<Array<SectionCtaParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionCtaParent documents */
  upsert?: InputMaybe<Array<SectionCtaParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionCtaParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionCtaParentUpdateOneInlineInput = {
  /** Connect existing SectionCtaParent document */
  connect?: InputMaybe<SectionCtaParentWhereUniqueInput>
  /** Create and connect one SectionCtaParent document */
  create?: InputMaybe<SectionCtaParentCreateInput>
  /** Delete currently connected SectionCtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionCtaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionCtaParent document */
  update?: InputMaybe<SectionCtaParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionCtaParent document */
  upsert?: InputMaybe<SectionCtaParentUpsertWithNestedWhereUniqueInput>
}

export type SectionCtaParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionCtaParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionCtaParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionCtaParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionCtaUpdateInput = {
  /** appStoreUrl input for default locale (de) */
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  contentPosition?: InputMaybe<ElementPosition>
  ctaExternal?: InputMaybe<Scalars['Boolean']['input']>
  ctaImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** ctaTarget input for default locale (de) */
  ctaTarget?: InputMaybe<Scalars['String']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  internalPageLink?: InputMaybe<EventPageUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionCtaUpdateLocalizationsInput>
  partnerLogo?: InputMaybe<AssetUpdateOneInlineInput>
  /** playStoreUrl input for default locale (de) */
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  showDecoration?: InputMaybe<Scalars['Boolean']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCtaUpdateLocalizationDataInput = {
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  ctaTarget?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCtaUpdateLocalizationInput = {
  data: SectionCtaUpdateLocalizationDataInput
  locale: Locale
}

export type SectionCtaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionCtaCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionCtaUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionCtaUpsertLocalizationInput>>
}

export type SectionCtaUpdateManyInlineInput = {
  /** Create and connect multiple SectionCta component instances */
  create?: InputMaybe<Array<SectionCtaCreateWithPositionInput>>
  /** Delete multiple SectionCta documents */
  delete?: InputMaybe<Array<SectionCtaWhereUniqueInput>>
  /** Update multiple SectionCta component instances */
  update?: InputMaybe<Array<SectionCtaUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionCta component instances */
  upsert?: InputMaybe<Array<SectionCtaUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionCtaUpdateManyInput = {
  /** appStoreUrl input for default locale (de) */
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  contentPosition?: InputMaybe<ElementPosition>
  ctaExternal?: InputMaybe<Scalars['Boolean']['input']>
  /** ctaTarget input for default locale (de) */
  ctaTarget?: InputMaybe<Scalars['String']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionCtaUpdateManyLocalizationsInput>
  /** playStoreUrl input for default locale (de) */
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  showDecoration?: InputMaybe<Scalars['Boolean']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCtaUpdateManyLocalizationDataInput = {
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  ctaTarget?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCtaUpdateManyLocalizationInput = {
  data: SectionCtaUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionCtaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionCtaUpdateManyLocalizationInput>>
}

export type SectionCtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionCtaUpdateManyInput
  /** Document search */
  where: SectionCtaWhereInput
}

export type SectionCtaUpdateOneInlineInput = {
  /** Create and connect one SectionCta document */
  create?: InputMaybe<SectionCtaCreateInput>
  /** Delete currently connected SectionCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionCta document */
  update?: InputMaybe<SectionCtaUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionCta document */
  upsert?: InputMaybe<SectionCtaUpsertWithNestedWhereUniqueInput>
}

export type SectionCtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionCtaUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionCtaWhereUniqueInput
}

export type SectionCtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionCtaUpdateInput
  /** Unique document search */
  where: SectionCtaWhereUniqueInput
}

export type SectionCtaUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionCtaCreateInput
  /** Update document if it exists */
  update: SectionCtaUpdateInput
}

export type SectionCtaUpsertLocalizationInput = {
  create: SectionCtaCreateLocalizationDataInput
  locale: Locale
  update: SectionCtaUpdateLocalizationDataInput
}

export type SectionCtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionCtaUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionCtaWhereUniqueInput
}

export type SectionCtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionCtaUpsertInput
  /** Unique document search */
  where: SectionCtaWhereUniqueInput
}

/** Identifies documents */
export type SectionCtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionCtaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionCtaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionCtaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  appStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  appStoreUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  appStoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  appStoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  appStoreUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  appStoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  appStoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  appStoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  appStoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  appStoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  contentPosition?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  contentPosition_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  contentPosition_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  contentPosition_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  ctaExternal?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  ctaExternal_not?: InputMaybe<Scalars['Boolean']['input']>
  ctaImage?: InputMaybe<AssetWhereInput>
  ctaTarget?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaTarget_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaTarget_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaTarget_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaTarget_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaTarget_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkTheme_not?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  internalPageLink?: InputMaybe<EventPageWhereInput>
  partnerLogo?: InputMaybe<AssetWhereInput>
  playStoreUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  playStoreUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  playStoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  playStoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  playStoreUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  playStoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  playStoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  playStoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  playStoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  playStoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  showDecoration?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showDecoration_not?: InputMaybe<Scalars['Boolean']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionCta record uniquely */
export type SectionCtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Showing a curated list of speakers */
export type SectionCuratedSpeakerList = Entity & {
  __typename?: 'SectionCuratedSpeakerList'
  description: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionCuratedSpeakerList>
  /** The top speakers or artist list. */
  speakers: Array<Speaker>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Showing a curated list of speakers */
export type SectionCuratedSpeakerListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Showing a curated list of speakers */
export type SectionCuratedSpeakerListSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SpeakerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerWhereInput>
}

/** Showing a curated list of speakers */
export type SectionCuratedSpeakerListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionCuratedSpeakerListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionCuratedSpeakerListWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionCuratedSpeakerListConnection = {
  __typename?: 'SectionCuratedSpeakerListConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionCuratedSpeakerListEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionCuratedSpeakerListCreateInput = {
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionCuratedSpeakerListCreateLocalizationsInput>
  speakers: SpeakerCreateManyInlineInput
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionCuratedSpeakerListCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionCuratedSpeakerListCreateLocalizationInput = {
  /** Localization input */
  data: SectionCuratedSpeakerListCreateLocalizationDataInput
  locale: Locale
}

export type SectionCuratedSpeakerListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionCuratedSpeakerListCreateLocalizationInput>>
}

export type SectionCuratedSpeakerListCreateManyInlineInput = {
  /** Create and connect multiple existing SectionCuratedSpeakerList documents */
  create?: InputMaybe<Array<SectionCuratedSpeakerListCreateInput>>
}

export type SectionCuratedSpeakerListCreateOneInlineInput = {
  /** Create and connect one SectionCuratedSpeakerList document */
  create?: InputMaybe<SectionCuratedSpeakerListCreateInput>
}

export type SectionCuratedSpeakerListCreateWithPositionInput = {
  /** Document to create */
  data: SectionCuratedSpeakerListCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionCuratedSpeakerListEdge = {
  __typename?: 'SectionCuratedSpeakerListEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionCuratedSpeakerList
}

/** Identifies documents */
export type SectionCuratedSpeakerListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionCuratedSpeakerListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionCuratedSpeakerListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionCuratedSpeakerListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  speakers_every?: InputMaybe<SpeakerWhereInput>
  speakers_none?: InputMaybe<SpeakerWhereInput>
  speakers_some?: InputMaybe<SpeakerWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionCuratedSpeakerListOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionCuratedSpeakerListParent = LandingPage

export type SectionCuratedSpeakerListParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionCuratedSpeakerListParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionCuratedSpeakerListParentCreateManyInlineInput = {
  /** Connect multiple existing SectionCuratedSpeakerListParent documents */
  connect?: InputMaybe<Array<SectionCuratedSpeakerListParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionCuratedSpeakerListParent documents */
  create?: InputMaybe<Array<SectionCuratedSpeakerListParentCreateInput>>
}

export type SectionCuratedSpeakerListParentCreateOneInlineInput = {
  /** Connect one existing SectionCuratedSpeakerListParent document */
  connect?: InputMaybe<SectionCuratedSpeakerListParentWhereUniqueInput>
  /** Create and connect one SectionCuratedSpeakerListParent document */
  create?: InputMaybe<SectionCuratedSpeakerListParentCreateInput>
}

export type SectionCuratedSpeakerListParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionCuratedSpeakerListParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionCuratedSpeakerListParent documents */
  connect?: InputMaybe<Array<SectionCuratedSpeakerListParentConnectInput>>
  /** Create and connect multiple SectionCuratedSpeakerListParent documents */
  create?: InputMaybe<Array<SectionCuratedSpeakerListParentCreateInput>>
  /** Delete multiple SectionCuratedSpeakerListParent documents */
  delete?: InputMaybe<Array<SectionCuratedSpeakerListParentWhereUniqueInput>>
  /** Disconnect multiple SectionCuratedSpeakerListParent documents */
  disconnect?: InputMaybe<Array<SectionCuratedSpeakerListParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionCuratedSpeakerListParent documents */
  set?: InputMaybe<Array<SectionCuratedSpeakerListParentWhereUniqueInput>>
  /** Update multiple SectionCuratedSpeakerListParent documents */
  update?: InputMaybe<Array<SectionCuratedSpeakerListParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionCuratedSpeakerListParent documents */
  upsert?: InputMaybe<Array<SectionCuratedSpeakerListParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionCuratedSpeakerListParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionCuratedSpeakerListParentUpdateOneInlineInput = {
  /** Connect existing SectionCuratedSpeakerListParent document */
  connect?: InputMaybe<SectionCuratedSpeakerListParentWhereUniqueInput>
  /** Create and connect one SectionCuratedSpeakerListParent document */
  create?: InputMaybe<SectionCuratedSpeakerListParentCreateInput>
  /** Delete currently connected SectionCuratedSpeakerListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionCuratedSpeakerListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionCuratedSpeakerListParent document */
  update?: InputMaybe<SectionCuratedSpeakerListParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionCuratedSpeakerListParent document */
  upsert?: InputMaybe<SectionCuratedSpeakerListParentUpsertWithNestedWhereUniqueInput>
}

export type SectionCuratedSpeakerListParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionCuratedSpeakerListParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionCuratedSpeakerListParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionCuratedSpeakerListParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionCuratedSpeakerListUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionCuratedSpeakerListUpdateLocalizationsInput>
  speakers?: InputMaybe<SpeakerUpdateManyInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCuratedSpeakerListUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCuratedSpeakerListUpdateLocalizationInput = {
  data: SectionCuratedSpeakerListUpdateLocalizationDataInput
  locale: Locale
}

export type SectionCuratedSpeakerListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionCuratedSpeakerListCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionCuratedSpeakerListUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionCuratedSpeakerListUpsertLocalizationInput>>
}

export type SectionCuratedSpeakerListUpdateManyInlineInput = {
  /** Create and connect multiple SectionCuratedSpeakerList component instances */
  create?: InputMaybe<Array<SectionCuratedSpeakerListCreateWithPositionInput>>
  /** Delete multiple SectionCuratedSpeakerList documents */
  delete?: InputMaybe<Array<SectionCuratedSpeakerListWhereUniqueInput>>
  /** Update multiple SectionCuratedSpeakerList component instances */
  update?: InputMaybe<Array<SectionCuratedSpeakerListUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionCuratedSpeakerList component instances */
  upsert?: InputMaybe<Array<SectionCuratedSpeakerListUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionCuratedSpeakerListUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionCuratedSpeakerListUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCuratedSpeakerListUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionCuratedSpeakerListUpdateManyLocalizationInput = {
  data: SectionCuratedSpeakerListUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionCuratedSpeakerListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionCuratedSpeakerListUpdateManyLocalizationInput>>
}

export type SectionCuratedSpeakerListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionCuratedSpeakerListUpdateManyInput
  /** Document search */
  where: SectionCuratedSpeakerListWhereInput
}

export type SectionCuratedSpeakerListUpdateOneInlineInput = {
  /** Create and connect one SectionCuratedSpeakerList document */
  create?: InputMaybe<SectionCuratedSpeakerListCreateInput>
  /** Delete currently connected SectionCuratedSpeakerList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionCuratedSpeakerList document */
  update?: InputMaybe<SectionCuratedSpeakerListUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionCuratedSpeakerList document */
  upsert?: InputMaybe<SectionCuratedSpeakerListUpsertWithNestedWhereUniqueInput>
}

export type SectionCuratedSpeakerListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionCuratedSpeakerListUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionCuratedSpeakerListWhereUniqueInput
}

export type SectionCuratedSpeakerListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionCuratedSpeakerListUpdateInput
  /** Unique document search */
  where: SectionCuratedSpeakerListWhereUniqueInput
}

export type SectionCuratedSpeakerListUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionCuratedSpeakerListCreateInput
  /** Update document if it exists */
  update: SectionCuratedSpeakerListUpdateInput
}

export type SectionCuratedSpeakerListUpsertLocalizationInput = {
  create: SectionCuratedSpeakerListCreateLocalizationDataInput
  locale: Locale
  update: SectionCuratedSpeakerListUpdateLocalizationDataInput
}

export type SectionCuratedSpeakerListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionCuratedSpeakerListUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionCuratedSpeakerListWhereUniqueInput
}

export type SectionCuratedSpeakerListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionCuratedSpeakerListUpsertInput
  /** Unique document search */
  where: SectionCuratedSpeakerListWhereUniqueInput
}

/** Identifies documents */
export type SectionCuratedSpeakerListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionCuratedSpeakerListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionCuratedSpeakerListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionCuratedSpeakerListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  speakers_every?: InputMaybe<SpeakerWhereInput>
  speakers_none?: InputMaybe<SpeakerWhereInput>
  speakers_some?: InputMaybe<SpeakerWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionCuratedSpeakerList record uniquely */
export type SectionCuratedSpeakerListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** A proportions how whole section is divided into columns. */
export enum SectionDivision {
  FiftyFifty = 'fifty_fifty',
  SeventyThirty = 'seventy_thirty',
  ThirtySeventy = 'thirty_seventy',
}

export type SectionDownloads = Entity & {
  __typename?: 'SectionDownloads'
  description?: Maybe<Scalars['String']['output']>
  downloads: Array<Download>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionDownloads>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionDownloadsDownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<DownloadOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<DownloadWhereInput>
}

export type SectionDownloadsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionDownloadsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionDownloadsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionDownloadsWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionDownloadsConnection = {
  __typename?: 'SectionDownloadsConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionDownloadsEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionDownloadsCreateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  downloads?: InputMaybe<DownloadCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionDownloadsCreateLocalizationsInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionDownloadsCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionDownloadsCreateLocalizationInput = {
  /** Localization input */
  data: SectionDownloadsCreateLocalizationDataInput
  locale: Locale
}

export type SectionDownloadsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionDownloadsCreateLocalizationInput>>
}

export type SectionDownloadsCreateManyInlineInput = {
  /** Create and connect multiple existing SectionDownloads documents */
  create?: InputMaybe<Array<SectionDownloadsCreateInput>>
}

export type SectionDownloadsCreateOneInlineInput = {
  /** Create and connect one SectionDownloads document */
  create?: InputMaybe<SectionDownloadsCreateInput>
}

export type SectionDownloadsCreateWithPositionInput = {
  /** Document to create */
  data: SectionDownloadsCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionDownloadsEdge = {
  __typename?: 'SectionDownloadsEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionDownloads
}

/** Identifies documents */
export type SectionDownloadsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionDownloadsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionDownloadsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionDownloadsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  downloads_every?: InputMaybe<DownloadWhereInput>
  downloads_none?: InputMaybe<DownloadWhereInput>
  downloads_some?: InputMaybe<DownloadWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionDownloadsOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionDownloadsParent = EventPage

export type SectionDownloadsParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionDownloadsParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionDownloadsParentCreateManyInlineInput = {
  /** Connect multiple existing SectionDownloadsParent documents */
  connect?: InputMaybe<Array<SectionDownloadsParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionDownloadsParent documents */
  create?: InputMaybe<Array<SectionDownloadsParentCreateInput>>
}

export type SectionDownloadsParentCreateOneInlineInput = {
  /** Connect one existing SectionDownloadsParent document */
  connect?: InputMaybe<SectionDownloadsParentWhereUniqueInput>
  /** Create and connect one SectionDownloadsParent document */
  create?: InputMaybe<SectionDownloadsParentCreateInput>
}

export type SectionDownloadsParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionDownloadsParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionDownloadsParent documents */
  connect?: InputMaybe<Array<SectionDownloadsParentConnectInput>>
  /** Create and connect multiple SectionDownloadsParent documents */
  create?: InputMaybe<Array<SectionDownloadsParentCreateInput>>
  /** Delete multiple SectionDownloadsParent documents */
  delete?: InputMaybe<Array<SectionDownloadsParentWhereUniqueInput>>
  /** Disconnect multiple SectionDownloadsParent documents */
  disconnect?: InputMaybe<Array<SectionDownloadsParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionDownloadsParent documents */
  set?: InputMaybe<Array<SectionDownloadsParentWhereUniqueInput>>
  /** Update multiple SectionDownloadsParent documents */
  update?: InputMaybe<Array<SectionDownloadsParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionDownloadsParent documents */
  upsert?: InputMaybe<Array<SectionDownloadsParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionDownloadsParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionDownloadsParentUpdateOneInlineInput = {
  /** Connect existing SectionDownloadsParent document */
  connect?: InputMaybe<SectionDownloadsParentWhereUniqueInput>
  /** Create and connect one SectionDownloadsParent document */
  create?: InputMaybe<SectionDownloadsParentCreateInput>
  /** Delete currently connected SectionDownloadsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionDownloadsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionDownloadsParent document */
  update?: InputMaybe<SectionDownloadsParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionDownloadsParent document */
  upsert?: InputMaybe<SectionDownloadsParentUpsertWithNestedWhereUniqueInput>
}

export type SectionDownloadsParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionDownloadsParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionDownloadsParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionDownloadsParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionDownloadsUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  downloads?: InputMaybe<DownloadUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionDownloadsUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionDownloadsUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionDownloadsUpdateLocalizationInput = {
  data: SectionDownloadsUpdateLocalizationDataInput
  locale: Locale
}

export type SectionDownloadsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionDownloadsCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionDownloadsUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionDownloadsUpsertLocalizationInput>>
}

export type SectionDownloadsUpdateManyInlineInput = {
  /** Create and connect multiple SectionDownloads component instances */
  create?: InputMaybe<Array<SectionDownloadsCreateWithPositionInput>>
  /** Delete multiple SectionDownloads documents */
  delete?: InputMaybe<Array<SectionDownloadsWhereUniqueInput>>
  /** Update multiple SectionDownloads component instances */
  update?: InputMaybe<Array<SectionDownloadsUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionDownloads component instances */
  upsert?: InputMaybe<Array<SectionDownloadsUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionDownloadsUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionDownloadsUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionDownloadsUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionDownloadsUpdateManyLocalizationInput = {
  data: SectionDownloadsUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionDownloadsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionDownloadsUpdateManyLocalizationInput>>
}

export type SectionDownloadsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionDownloadsUpdateManyInput
  /** Document search */
  where: SectionDownloadsWhereInput
}

export type SectionDownloadsUpdateOneInlineInput = {
  /** Create and connect one SectionDownloads document */
  create?: InputMaybe<SectionDownloadsCreateInput>
  /** Delete currently connected SectionDownloads document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionDownloads document */
  update?: InputMaybe<SectionDownloadsUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionDownloads document */
  upsert?: InputMaybe<SectionDownloadsUpsertWithNestedWhereUniqueInput>
}

export type SectionDownloadsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionDownloadsUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionDownloadsWhereUniqueInput
}

export type SectionDownloadsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionDownloadsUpdateInput
  /** Unique document search */
  where: SectionDownloadsWhereUniqueInput
}

export type SectionDownloadsUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionDownloadsCreateInput
  /** Update document if it exists */
  update: SectionDownloadsUpdateInput
}

export type SectionDownloadsUpsertLocalizationInput = {
  create: SectionDownloadsCreateLocalizationDataInput
  locale: Locale
  update: SectionDownloadsUpdateLocalizationDataInput
}

export type SectionDownloadsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionDownloadsUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionDownloadsWhereUniqueInput
}

export type SectionDownloadsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionDownloadsUpsertInput
  /** Unique document search */
  where: SectionDownloadsWhereUniqueInput
}

/** Identifies documents */
export type SectionDownloadsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionDownloadsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionDownloadsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionDownloadsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  downloads_every?: InputMaybe<DownloadWhereInput>
  downloads_none?: InputMaybe<DownloadWhereInput>
  downloads_some?: InputMaybe<DownloadWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionDownloads record uniquely */
export type SectionDownloadsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Shows timetable for Event offers in list view modes. */
export type SectionEventOffersTimetable = Entity & {
  __typename?: 'SectionEventOffersTimetable'
  /** Call to action element */
  cta?: Maybe<CallToAction>
  /** Provide day to preselect in yyyy-MM-dd format */
  dayPreselect?: Maybe<Scalars['String']['output']>
  /** Select the event type to display by default (MC, GT, or SE) */
  defaultEventType?: Maybe<TimetableEventType>
  /** Enables the journey filter for the event offers timetable. Off by default. */
  enableJourneyFilter?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Select interests to filter event offers. Multiple selection supported. */
  interestsFilter: Array<Interest>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionEventOffersTimetable>
  optionalDescription?: Maybe<Scalars['String']['output']>
  optionalTitle?: Maybe<Scalars['String']['output']>
  pageSize?: Maybe<Scalars['Int']['output']>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Shows timetable for Event offers in list view modes. */
export type SectionEventOffersTimetableCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Shows timetable for Event offers in list view modes. */
export type SectionEventOffersTimetableInterestsFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestWhereInput>
}

/** Shows timetable for Event offers in list view modes. */
export type SectionEventOffersTimetableLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Shows timetable for Event offers in list view modes. */
export type SectionEventOffersTimetableUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionEventOffersTimetableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionEventOffersTimetableWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionEventOffersTimetableConnection = {
  __typename?: 'SectionEventOffersTimetableConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionEventOffersTimetableEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionEventOffersTimetableCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  defaultEventType?: InputMaybe<TimetableEventType>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  interestsFilter?: InputMaybe<InterestCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionEventOffersTimetableCreateLocalizationsInput>
  /** optionalDescription input for default locale (de) */
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionEventOffersTimetableCreateLocalizationDataInput = {
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionEventOffersTimetableCreateLocalizationInput = {
  /** Localization input */
  data: SectionEventOffersTimetableCreateLocalizationDataInput
  locale: Locale
}

export type SectionEventOffersTimetableCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionEventOffersTimetableCreateLocalizationInput>>
}

export type SectionEventOffersTimetableCreateManyInlineInput = {
  /** Create and connect multiple existing SectionEventOffersTimetable documents */
  create?: InputMaybe<Array<SectionEventOffersTimetableCreateInput>>
}

export type SectionEventOffersTimetableCreateOneInlineInput = {
  /** Create and connect one SectionEventOffersTimetable document */
  create?: InputMaybe<SectionEventOffersTimetableCreateInput>
}

export type SectionEventOffersTimetableCreateWithPositionInput = {
  /** Document to create */
  data: SectionEventOffersTimetableCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionEventOffersTimetableEdge = {
  __typename?: 'SectionEventOffersTimetableEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionEventOffersTimetable
}

/** Identifies documents */
export type SectionEventOffersTimetableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionEventOffersTimetableWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionEventOffersTimetableWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionEventOffersTimetableWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  dayPreselect_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  dayPreselect_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  dayPreselect_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  dayPreselect_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  dayPreselect_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  dayPreselect_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  dayPreselect_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  dayPreselect_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  dayPreselect_starts_with?: InputMaybe<Scalars['String']['input']>
  defaultEventType?: InputMaybe<TimetableEventType>
  /** All values that are contained in given list. */
  defaultEventType_in?: InputMaybe<Array<InputMaybe<TimetableEventType>>>
  /** Any other value that exists and is not equal to the given value. */
  defaultEventType_not?: InputMaybe<TimetableEventType>
  /** All values that are not contained in given list. */
  defaultEventType_not_in?: InputMaybe<Array<InputMaybe<TimetableEventType>>>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableJourneyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interestsFilter_every?: InputMaybe<InterestWhereInput>
  interestsFilter_none?: InputMaybe<InterestWhereInput>
  interestsFilter_some?: InputMaybe<InterestWhereInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageSize_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageSize_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageSize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageSize_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageSize_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageSize_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionEventOffersTimetableOrderByInput {
  DayPreselectAsc = 'dayPreselect_ASC',
  DayPreselectDesc = 'dayPreselect_DESC',
  DefaultEventTypeAsc = 'defaultEventType_ASC',
  DefaultEventTypeDesc = 'defaultEventType_DESC',
  EnableJourneyFilterAsc = 'enableJourneyFilter_ASC',
  EnableJourneyFilterDesc = 'enableJourneyFilter_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OptionalDescriptionAsc = 'optionalDescription_ASC',
  OptionalDescriptionDesc = 'optionalDescription_DESC',
  OptionalTitleAsc = 'optionalTitle_ASC',
  OptionalTitleDesc = 'optionalTitle_DESC',
  PageSizeAsc = 'pageSize_ASC',
  PageSizeDesc = 'pageSize_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionEventOffersTimetableParent = EventPage

export type SectionEventOffersTimetableParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionEventOffersTimetableParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionEventOffersTimetableParentCreateManyInlineInput = {
  /** Connect multiple existing SectionEventOffersTimetableParent documents */
  connect?: InputMaybe<Array<SectionEventOffersTimetableParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionEventOffersTimetableParent documents */
  create?: InputMaybe<Array<SectionEventOffersTimetableParentCreateInput>>
}

export type SectionEventOffersTimetableParentCreateOneInlineInput = {
  /** Connect one existing SectionEventOffersTimetableParent document */
  connect?: InputMaybe<SectionEventOffersTimetableParentWhereUniqueInput>
  /** Create and connect one SectionEventOffersTimetableParent document */
  create?: InputMaybe<SectionEventOffersTimetableParentCreateInput>
}

export type SectionEventOffersTimetableParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionEventOffersTimetableParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionEventOffersTimetableParent documents */
  connect?: InputMaybe<Array<SectionEventOffersTimetableParentConnectInput>>
  /** Create and connect multiple SectionEventOffersTimetableParent documents */
  create?: InputMaybe<Array<SectionEventOffersTimetableParentCreateInput>>
  /** Delete multiple SectionEventOffersTimetableParent documents */
  delete?: InputMaybe<Array<SectionEventOffersTimetableParentWhereUniqueInput>>
  /** Disconnect multiple SectionEventOffersTimetableParent documents */
  disconnect?: InputMaybe<Array<SectionEventOffersTimetableParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionEventOffersTimetableParent documents */
  set?: InputMaybe<Array<SectionEventOffersTimetableParentWhereUniqueInput>>
  /** Update multiple SectionEventOffersTimetableParent documents */
  update?: InputMaybe<Array<SectionEventOffersTimetableParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionEventOffersTimetableParent documents */
  upsert?: InputMaybe<Array<SectionEventOffersTimetableParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionEventOffersTimetableParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionEventOffersTimetableParentUpdateOneInlineInput = {
  /** Connect existing SectionEventOffersTimetableParent document */
  connect?: InputMaybe<SectionEventOffersTimetableParentWhereUniqueInput>
  /** Create and connect one SectionEventOffersTimetableParent document */
  create?: InputMaybe<SectionEventOffersTimetableParentCreateInput>
  /** Delete currently connected SectionEventOffersTimetableParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionEventOffersTimetableParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionEventOffersTimetableParent document */
  update?: InputMaybe<SectionEventOffersTimetableParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionEventOffersTimetableParent document */
  upsert?: InputMaybe<SectionEventOffersTimetableParentUpsertWithNestedWhereUniqueInput>
}

export type SectionEventOffersTimetableParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionEventOffersTimetableParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionEventOffersTimetableParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionEventOffersTimetableParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionEventOffersTimetableUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  defaultEventType?: InputMaybe<TimetableEventType>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  interestsFilter?: InputMaybe<InterestUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionEventOffersTimetableUpdateLocalizationsInput>
  /** optionalDescription input for default locale (de) */
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type SectionEventOffersTimetableUpdateLocalizationDataInput = {
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionEventOffersTimetableUpdateLocalizationInput = {
  data: SectionEventOffersTimetableUpdateLocalizationDataInput
  locale: Locale
}

export type SectionEventOffersTimetableUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionEventOffersTimetableCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionEventOffersTimetableUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionEventOffersTimetableUpsertLocalizationInput>>
}

export type SectionEventOffersTimetableUpdateManyInlineInput = {
  /** Create and connect multiple SectionEventOffersTimetable component instances */
  create?: InputMaybe<Array<SectionEventOffersTimetableCreateWithPositionInput>>
  /** Delete multiple SectionEventOffersTimetable documents */
  delete?: InputMaybe<Array<SectionEventOffersTimetableWhereUniqueInput>>
  /** Update multiple SectionEventOffersTimetable component instances */
  update?: InputMaybe<Array<SectionEventOffersTimetableUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionEventOffersTimetable component instances */
  upsert?: InputMaybe<Array<SectionEventOffersTimetableUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionEventOffersTimetableUpdateManyInput = {
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  defaultEventType?: InputMaybe<TimetableEventType>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionEventOffersTimetableUpdateManyLocalizationsInput>
  /** optionalDescription input for default locale (de) */
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type SectionEventOffersTimetableUpdateManyLocalizationDataInput = {
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionEventOffersTimetableUpdateManyLocalizationInput = {
  data: SectionEventOffersTimetableUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionEventOffersTimetableUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionEventOffersTimetableUpdateManyLocalizationInput>>
}

export type SectionEventOffersTimetableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionEventOffersTimetableUpdateManyInput
  /** Document search */
  where: SectionEventOffersTimetableWhereInput
}

export type SectionEventOffersTimetableUpdateOneInlineInput = {
  /** Create and connect one SectionEventOffersTimetable document */
  create?: InputMaybe<SectionEventOffersTimetableCreateInput>
  /** Delete currently connected SectionEventOffersTimetable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionEventOffersTimetable document */
  update?: InputMaybe<SectionEventOffersTimetableUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionEventOffersTimetable document */
  upsert?: InputMaybe<SectionEventOffersTimetableUpsertWithNestedWhereUniqueInput>
}

export type SectionEventOffersTimetableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionEventOffersTimetableUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionEventOffersTimetableWhereUniqueInput
}

export type SectionEventOffersTimetableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionEventOffersTimetableUpdateInput
  /** Unique document search */
  where: SectionEventOffersTimetableWhereUniqueInput
}

export type SectionEventOffersTimetableUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionEventOffersTimetableCreateInput
  /** Update document if it exists */
  update: SectionEventOffersTimetableUpdateInput
}

export type SectionEventOffersTimetableUpsertLocalizationInput = {
  create: SectionEventOffersTimetableCreateLocalizationDataInput
  locale: Locale
  update: SectionEventOffersTimetableUpdateLocalizationDataInput
}

export type SectionEventOffersTimetableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionEventOffersTimetableUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionEventOffersTimetableWhereUniqueInput
}

export type SectionEventOffersTimetableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionEventOffersTimetableUpsertInput
  /** Unique document search */
  where: SectionEventOffersTimetableWhereUniqueInput
}

/** Identifies documents */
export type SectionEventOffersTimetableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionEventOffersTimetableWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionEventOffersTimetableWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionEventOffersTimetableWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  dayPreselect_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  dayPreselect_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  dayPreselect_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  dayPreselect_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  dayPreselect_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  dayPreselect_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  dayPreselect_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  dayPreselect_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  dayPreselect_starts_with?: InputMaybe<Scalars['String']['input']>
  defaultEventType?: InputMaybe<TimetableEventType>
  /** All values that are contained in given list. */
  defaultEventType_in?: InputMaybe<Array<InputMaybe<TimetableEventType>>>
  /** Any other value that exists and is not equal to the given value. */
  defaultEventType_not?: InputMaybe<TimetableEventType>
  /** All values that are not contained in given list. */
  defaultEventType_not_in?: InputMaybe<Array<InputMaybe<TimetableEventType>>>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableJourneyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interestsFilter_every?: InputMaybe<InterestWhereInput>
  interestsFilter_none?: InputMaybe<InterestWhereInput>
  interestsFilter_some?: InputMaybe<InterestWhereInput>
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  optionalDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  optionalDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  optionalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  optionalDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  optionalDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  optionalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  optionalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  optionalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  optionalDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  optionalTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  optionalTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  optionalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  optionalTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  optionalTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  optionalTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  optionalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  optionalTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  optionalTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageSize_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageSize_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageSize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageSize_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageSize_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageSize_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionEventOffersTimetable record uniquely */
export type SectionEventOffersTimetableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum SectionExhibitorsOptions {
  AllExhibitors = 'allExhibitors',
  PremiumExhibitors = 'premiumExhibitors',
  TopExhibitorsOnly = 'topExhibitorsOnly',
}

/** Section displaying items in columns with picture title description and optional call to action */
export type SectionExplanationBlocks = Entity & {
  __typename?: 'SectionExplanationBlocks'
  /** Text alignment centered */
  centered?: Maybe<Scalars['Boolean']['output']>
  /** How many items are displayed horizontally on desktop, defaults (unset) to three */
  columns?: Maybe<ColumnLayout>
  /** Call to action element rendered below blocks */
  cta?: Maybe<CallToAction>
  /** Option to display section decorations, false by default */
  displayDecorations?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  items: Array<ExplanationStep>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionExplanationBlocks>
  /** Select custom padding for this section, otherwise default is used. */
  sectionPadding?: Maybe<SectionPadding>
  /** System stage field */
  stage: Stage
  styleVariant?: Maybe<ComponentStyle>
  /** Section subtitle */
  subtitle?: Maybe<Scalars['String']['output']>
  /** Section title */
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section displaying items in columns with picture title description and optional call to action */
export type SectionExplanationBlocksCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section displaying items in columns with picture title description and optional call to action */
export type SectionExplanationBlocksItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ExplanationStepOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ExplanationStepWhereInput>
}

/** Section displaying items in columns with picture title description and optional call to action */
export type SectionExplanationBlocksLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section displaying items in columns with picture title description and optional call to action */
export type SectionExplanationBlocksUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionExplanationBlocksConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionExplanationBlocksWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionExplanationBlocksConnection = {
  __typename?: 'SectionExplanationBlocksConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionExplanationBlocksEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionExplanationBlocksCreateInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  columns?: InputMaybe<ColumnLayout>
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  items?: InputMaybe<ExplanationStepCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionExplanationBlocksCreateLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionExplanationBlocksCreateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionExplanationBlocksCreateLocalizationInput = {
  /** Localization input */
  data: SectionExplanationBlocksCreateLocalizationDataInput
  locale: Locale
}

export type SectionExplanationBlocksCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionExplanationBlocksCreateLocalizationInput>>
}

export type SectionExplanationBlocksCreateManyInlineInput = {
  /** Create and connect multiple existing SectionExplanationBlocks documents */
  create?: InputMaybe<Array<SectionExplanationBlocksCreateInput>>
}

export type SectionExplanationBlocksCreateOneInlineInput = {
  /** Create and connect one SectionExplanationBlocks document */
  create?: InputMaybe<SectionExplanationBlocksCreateInput>
}

export type SectionExplanationBlocksCreateWithPositionInput = {
  /** Document to create */
  data: SectionExplanationBlocksCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionExplanationBlocksEdge = {
  __typename?: 'SectionExplanationBlocksEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionExplanationBlocks
}

/** Identifies documents */
export type SectionExplanationBlocksManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionExplanationBlocksWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionExplanationBlocksWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionExplanationBlocksWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>
  columns?: InputMaybe<ColumnLayout>
  /** All values that are contained in given list. */
  columns_in?: InputMaybe<Array<InputMaybe<ColumnLayout>>>
  /** Any other value that exists and is not equal to the given value. */
  columns_not?: InputMaybe<ColumnLayout>
  /** All values that are not contained in given list. */
  columns_not_in?: InputMaybe<Array<InputMaybe<ColumnLayout>>>
  cta?: InputMaybe<CallToActionWhereInput>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  displayDecorations_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  items_every?: InputMaybe<ExplanationStepWhereInput>
  items_none?: InputMaybe<ExplanationStepWhereInput>
  items_some?: InputMaybe<ExplanationStepWhereInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionExplanationBlocksOrderByInput {
  CenteredAsc = 'centered_ASC',
  CenteredDesc = 'centered_DESC',
  ColumnsAsc = 'columns_ASC',
  ColumnsDesc = 'columns_DESC',
  DisplayDecorationsAsc = 'displayDecorations_ASC',
  DisplayDecorationsDesc = 'displayDecorations_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SectionPaddingAsc = 'sectionPadding_ASC',
  SectionPaddingDesc = 'sectionPadding_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionExplanationBlocksParent = CareerPage | EventPage | LandingPage

export type SectionExplanationBlocksParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionExplanationBlocksParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionExplanationBlocksParentCreateManyInlineInput = {
  /** Connect multiple existing SectionExplanationBlocksParent documents */
  connect?: InputMaybe<Array<SectionExplanationBlocksParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionExplanationBlocksParent documents */
  create?: InputMaybe<Array<SectionExplanationBlocksParentCreateInput>>
}

export type SectionExplanationBlocksParentCreateOneInlineInput = {
  /** Connect one existing SectionExplanationBlocksParent document */
  connect?: InputMaybe<SectionExplanationBlocksParentWhereUniqueInput>
  /** Create and connect one SectionExplanationBlocksParent document */
  create?: InputMaybe<SectionExplanationBlocksParentCreateInput>
}

export type SectionExplanationBlocksParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionExplanationBlocksParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionExplanationBlocksParent documents */
  connect?: InputMaybe<Array<SectionExplanationBlocksParentConnectInput>>
  /** Create and connect multiple SectionExplanationBlocksParent documents */
  create?: InputMaybe<Array<SectionExplanationBlocksParentCreateInput>>
  /** Delete multiple SectionExplanationBlocksParent documents */
  delete?: InputMaybe<Array<SectionExplanationBlocksParentWhereUniqueInput>>
  /** Disconnect multiple SectionExplanationBlocksParent documents */
  disconnect?: InputMaybe<Array<SectionExplanationBlocksParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionExplanationBlocksParent documents */
  set?: InputMaybe<Array<SectionExplanationBlocksParentWhereUniqueInput>>
  /** Update multiple SectionExplanationBlocksParent documents */
  update?: InputMaybe<Array<SectionExplanationBlocksParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionExplanationBlocksParent documents */
  upsert?: InputMaybe<Array<SectionExplanationBlocksParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionExplanationBlocksParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionExplanationBlocksParentUpdateOneInlineInput = {
  /** Connect existing SectionExplanationBlocksParent document */
  connect?: InputMaybe<SectionExplanationBlocksParentWhereUniqueInput>
  /** Create and connect one SectionExplanationBlocksParent document */
  create?: InputMaybe<SectionExplanationBlocksParentCreateInput>
  /** Delete currently connected SectionExplanationBlocksParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionExplanationBlocksParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionExplanationBlocksParent document */
  update?: InputMaybe<SectionExplanationBlocksParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionExplanationBlocksParent document */
  upsert?: InputMaybe<SectionExplanationBlocksParentUpsertWithNestedWhereUniqueInput>
}

export type SectionExplanationBlocksParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionExplanationBlocksParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionExplanationBlocksParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionExplanationBlocksParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionExplanationBlocksUpdateInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  columns?: InputMaybe<ColumnLayout>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  items?: InputMaybe<ExplanationStepUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionExplanationBlocksUpdateLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionExplanationBlocksUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionExplanationBlocksUpdateLocalizationInput = {
  data: SectionExplanationBlocksUpdateLocalizationDataInput
  locale: Locale
}

export type SectionExplanationBlocksUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionExplanationBlocksCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionExplanationBlocksUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionExplanationBlocksUpsertLocalizationInput>>
}

export type SectionExplanationBlocksUpdateManyInlineInput = {
  /** Create and connect multiple SectionExplanationBlocks component instances */
  create?: InputMaybe<Array<SectionExplanationBlocksCreateWithPositionInput>>
  /** Delete multiple SectionExplanationBlocks documents */
  delete?: InputMaybe<Array<SectionExplanationBlocksWhereUniqueInput>>
  /** Update multiple SectionExplanationBlocks component instances */
  update?: InputMaybe<Array<SectionExplanationBlocksUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionExplanationBlocks component instances */
  upsert?: InputMaybe<Array<SectionExplanationBlocksUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionExplanationBlocksUpdateManyInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  columns?: InputMaybe<ColumnLayout>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionExplanationBlocksUpdateManyLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionExplanationBlocksUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionExplanationBlocksUpdateManyLocalizationInput = {
  data: SectionExplanationBlocksUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionExplanationBlocksUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionExplanationBlocksUpdateManyLocalizationInput>>
}

export type SectionExplanationBlocksUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionExplanationBlocksUpdateManyInput
  /** Document search */
  where: SectionExplanationBlocksWhereInput
}

export type SectionExplanationBlocksUpdateOneInlineInput = {
  /** Create and connect one SectionExplanationBlocks document */
  create?: InputMaybe<SectionExplanationBlocksCreateInput>
  /** Delete currently connected SectionExplanationBlocks document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionExplanationBlocks document */
  update?: InputMaybe<SectionExplanationBlocksUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionExplanationBlocks document */
  upsert?: InputMaybe<SectionExplanationBlocksUpsertWithNestedWhereUniqueInput>
}

export type SectionExplanationBlocksUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionExplanationBlocksUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionExplanationBlocksWhereUniqueInput
}

export type SectionExplanationBlocksUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionExplanationBlocksUpdateInput
  /** Unique document search */
  where: SectionExplanationBlocksWhereUniqueInput
}

export type SectionExplanationBlocksUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionExplanationBlocksCreateInput
  /** Update document if it exists */
  update: SectionExplanationBlocksUpdateInput
}

export type SectionExplanationBlocksUpsertLocalizationInput = {
  create: SectionExplanationBlocksCreateLocalizationDataInput
  locale: Locale
  update: SectionExplanationBlocksUpdateLocalizationDataInput
}

export type SectionExplanationBlocksUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionExplanationBlocksUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionExplanationBlocksWhereUniqueInput
}

export type SectionExplanationBlocksUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionExplanationBlocksUpsertInput
  /** Unique document search */
  where: SectionExplanationBlocksWhereUniqueInput
}

/** Identifies documents */
export type SectionExplanationBlocksWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionExplanationBlocksWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionExplanationBlocksWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionExplanationBlocksWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>
  columns?: InputMaybe<ColumnLayout>
  /** All values that are contained in given list. */
  columns_in?: InputMaybe<Array<InputMaybe<ColumnLayout>>>
  /** Any other value that exists and is not equal to the given value. */
  columns_not?: InputMaybe<ColumnLayout>
  /** All values that are not contained in given list. */
  columns_not_in?: InputMaybe<Array<InputMaybe<ColumnLayout>>>
  cta?: InputMaybe<CallToActionWhereInput>
  displayDecorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  displayDecorations_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  items_every?: InputMaybe<ExplanationStepWhereInput>
  items_none?: InputMaybe<ExplanationStepWhereInput>
  items_some?: InputMaybe<ExplanationStepWhereInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionExplanationBlocks record uniquely */
export type SectionExplanationBlocksWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Shows timetable for Festival stages in 2D and list view modes. */
export type SectionFestivalTimetable = Entity & {
  __typename?: 'SectionFestivalTimetable'
  /** Call to action element */
  cta?: Maybe<CallToAction>
  darkHeader?: Maybe<Scalars['Boolean']['output']>
  /** Provide day to preselect in yyyy-MM-dd format */
  dayPreselect?: Maybe<Scalars['String']['output']>
  /** If value set, default view mode will be applied to festival timetable. If not set, when showing view swithcher default is Grid, otherwise list. */
  defaultViewMode?: Maybe<TimetableViewModes>
  enableCompanyFilter: Scalars['Boolean']['output']
  /** Enables the journey filter for the festival timetable. Off by default. */
  enableJourneyFilter?: Maybe<Scalars['Boolean']['output']>
  eventStage?: Maybe<EventStage>
  /** If value set, only those exhibitors will be shown that has corresponding event type associated to them. Default is 'stage'. */
  eventType?: Maybe<SpeakerEventTypes>
  hideViewSwitcher?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Select interests to filter event offers. Multiple selection supported. */
  interestsFilter: Array<Interest>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionFestivalTimetable>
  optionalDescription?: Maybe<Scalars['String']['output']>
  optionalTitle?: Maybe<Scalars['String']['output']>
  pageSize?: Maybe<Scalars['Int']['output']>
  /** System stage field */
  stage: Stage
  /** If value set, tabs will be shown according to the selected setting. If no value, tab filter is not visible. */
  tabFilterType?: Maybe<TimetableTabFilterTypes>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Shows timetable for Festival stages in 2D and list view modes. */
export type SectionFestivalTimetableCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Shows timetable for Festival stages in 2D and list view modes. */
export type SectionFestivalTimetableEventStageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Shows timetable for Festival stages in 2D and list view modes. */
export type SectionFestivalTimetableInterestsFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestWhereInput>
}

/** Shows timetable for Festival stages in 2D and list view modes. */
export type SectionFestivalTimetableLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Shows timetable for Festival stages in 2D and list view modes. */
export type SectionFestivalTimetableUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionFestivalTimetableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionFestivalTimetableWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionFestivalTimetableConnection = {
  __typename?: 'SectionFestivalTimetableConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionFestivalTimetableEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionFestivalTimetableCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  defaultViewMode?: InputMaybe<TimetableViewModes>
  enableCompanyFilter: Scalars['Boolean']['input']
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  eventStage?: InputMaybe<EventStageCreateOneInlineInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  hideViewSwitcher?: InputMaybe<Scalars['Boolean']['input']>
  interestsFilter?: InputMaybe<InterestCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionFestivalTimetableCreateLocalizationsInput>
  /** optionalDescription input for default locale (de) */
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  tabFilterType?: InputMaybe<TimetableTabFilterTypes>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionFestivalTimetableCreateLocalizationDataInput = {
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionFestivalTimetableCreateLocalizationInput = {
  /** Localization input */
  data: SectionFestivalTimetableCreateLocalizationDataInput
  locale: Locale
}

export type SectionFestivalTimetableCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionFestivalTimetableCreateLocalizationInput>>
}

export type SectionFestivalTimetableCreateManyInlineInput = {
  /** Create and connect multiple existing SectionFestivalTimetable documents */
  create?: InputMaybe<Array<SectionFestivalTimetableCreateInput>>
}

export type SectionFestivalTimetableCreateOneInlineInput = {
  /** Create and connect one SectionFestivalTimetable document */
  create?: InputMaybe<SectionFestivalTimetableCreateInput>
}

export type SectionFestivalTimetableCreateWithPositionInput = {
  /** Document to create */
  data: SectionFestivalTimetableCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionFestivalTimetableEdge = {
  __typename?: 'SectionFestivalTimetableEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionFestivalTimetable
}

/** Identifies documents */
export type SectionFestivalTimetableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionFestivalTimetableWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionFestivalTimetableWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionFestivalTimetableWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkHeader_not?: InputMaybe<Scalars['Boolean']['input']>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  dayPreselect_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  dayPreselect_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  dayPreselect_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  dayPreselect_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  dayPreselect_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  dayPreselect_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  dayPreselect_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  dayPreselect_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  dayPreselect_starts_with?: InputMaybe<Scalars['String']['input']>
  defaultViewMode?: InputMaybe<TimetableViewModes>
  /** All values that are contained in given list. */
  defaultViewMode_in?: InputMaybe<Array<InputMaybe<TimetableViewModes>>>
  /** Any other value that exists and is not equal to the given value. */
  defaultViewMode_not?: InputMaybe<TimetableViewModes>
  /** All values that are not contained in given list. */
  defaultViewMode_not_in?: InputMaybe<Array<InputMaybe<TimetableViewModes>>>
  enableCompanyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableCompanyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableJourneyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  eventStage?: InputMaybe<EventStageWhereInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  /** All values that are contained in given list. */
  eventType_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  /** Any other value that exists and is not equal to the given value. */
  eventType_not?: InputMaybe<SpeakerEventTypes>
  /** All values that are not contained in given list. */
  eventType_not_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  hideViewSwitcher?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideViewSwitcher_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interestsFilter_every?: InputMaybe<InterestWhereInput>
  interestsFilter_none?: InputMaybe<InterestWhereInput>
  interestsFilter_some?: InputMaybe<InterestWhereInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageSize_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageSize_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageSize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageSize_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageSize_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageSize_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  tabFilterType?: InputMaybe<TimetableTabFilterTypes>
  /** All values that are contained in given list. */
  tabFilterType_in?: InputMaybe<Array<InputMaybe<TimetableTabFilterTypes>>>
  /** Any other value that exists and is not equal to the given value. */
  tabFilterType_not?: InputMaybe<TimetableTabFilterTypes>
  /** All values that are not contained in given list. */
  tabFilterType_not_in?: InputMaybe<Array<InputMaybe<TimetableTabFilterTypes>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionFestivalTimetableOrderByInput {
  DarkHeaderAsc = 'darkHeader_ASC',
  DarkHeaderDesc = 'darkHeader_DESC',
  DayPreselectAsc = 'dayPreselect_ASC',
  DayPreselectDesc = 'dayPreselect_DESC',
  DefaultViewModeAsc = 'defaultViewMode_ASC',
  DefaultViewModeDesc = 'defaultViewMode_DESC',
  EnableCompanyFilterAsc = 'enableCompanyFilter_ASC',
  EnableCompanyFilterDesc = 'enableCompanyFilter_DESC',
  EnableJourneyFilterAsc = 'enableJourneyFilter_ASC',
  EnableJourneyFilterDesc = 'enableJourneyFilter_DESC',
  EventTypeAsc = 'eventType_ASC',
  EventTypeDesc = 'eventType_DESC',
  HideViewSwitcherAsc = 'hideViewSwitcher_ASC',
  HideViewSwitcherDesc = 'hideViewSwitcher_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OptionalDescriptionAsc = 'optionalDescription_ASC',
  OptionalDescriptionDesc = 'optionalDescription_DESC',
  OptionalTitleAsc = 'optionalTitle_ASC',
  OptionalTitleDesc = 'optionalTitle_DESC',
  PageSizeAsc = 'pageSize_ASC',
  PageSizeDesc = 'pageSize_DESC',
  TabFilterTypeAsc = 'tabFilterType_ASC',
  TabFilterTypeDesc = 'tabFilterType_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionFestivalTimetableParent = EventPage

export type SectionFestivalTimetableParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionFestivalTimetableParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionFestivalTimetableParentCreateManyInlineInput = {
  /** Connect multiple existing SectionFestivalTimetableParent documents */
  connect?: InputMaybe<Array<SectionFestivalTimetableParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionFestivalTimetableParent documents */
  create?: InputMaybe<Array<SectionFestivalTimetableParentCreateInput>>
}

export type SectionFestivalTimetableParentCreateOneInlineInput = {
  /** Connect one existing SectionFestivalTimetableParent document */
  connect?: InputMaybe<SectionFestivalTimetableParentWhereUniqueInput>
  /** Create and connect one SectionFestivalTimetableParent document */
  create?: InputMaybe<SectionFestivalTimetableParentCreateInput>
}

export type SectionFestivalTimetableParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionFestivalTimetableParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionFestivalTimetableParent documents */
  connect?: InputMaybe<Array<SectionFestivalTimetableParentConnectInput>>
  /** Create and connect multiple SectionFestivalTimetableParent documents */
  create?: InputMaybe<Array<SectionFestivalTimetableParentCreateInput>>
  /** Delete multiple SectionFestivalTimetableParent documents */
  delete?: InputMaybe<Array<SectionFestivalTimetableParentWhereUniqueInput>>
  /** Disconnect multiple SectionFestivalTimetableParent documents */
  disconnect?: InputMaybe<Array<SectionFestivalTimetableParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionFestivalTimetableParent documents */
  set?: InputMaybe<Array<SectionFestivalTimetableParentWhereUniqueInput>>
  /** Update multiple SectionFestivalTimetableParent documents */
  update?: InputMaybe<Array<SectionFestivalTimetableParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionFestivalTimetableParent documents */
  upsert?: InputMaybe<Array<SectionFestivalTimetableParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionFestivalTimetableParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionFestivalTimetableParentUpdateOneInlineInput = {
  /** Connect existing SectionFestivalTimetableParent document */
  connect?: InputMaybe<SectionFestivalTimetableParentWhereUniqueInput>
  /** Create and connect one SectionFestivalTimetableParent document */
  create?: InputMaybe<SectionFestivalTimetableParentCreateInput>
  /** Delete currently connected SectionFestivalTimetableParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionFestivalTimetableParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionFestivalTimetableParent document */
  update?: InputMaybe<SectionFestivalTimetableParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionFestivalTimetableParent document */
  upsert?: InputMaybe<SectionFestivalTimetableParentUpsertWithNestedWhereUniqueInput>
}

export type SectionFestivalTimetableParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionFestivalTimetableParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionFestivalTimetableParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionFestivalTimetableParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionFestivalTimetableUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  defaultViewMode?: InputMaybe<TimetableViewModes>
  enableCompanyFilter?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  eventStage?: InputMaybe<EventStageUpdateOneInlineInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  hideViewSwitcher?: InputMaybe<Scalars['Boolean']['input']>
  interestsFilter?: InputMaybe<InterestUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionFestivalTimetableUpdateLocalizationsInput>
  /** optionalDescription input for default locale (de) */
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  tabFilterType?: InputMaybe<TimetableTabFilterTypes>
}

export type SectionFestivalTimetableUpdateLocalizationDataInput = {
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionFestivalTimetableUpdateLocalizationInput = {
  data: SectionFestivalTimetableUpdateLocalizationDataInput
  locale: Locale
}

export type SectionFestivalTimetableUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionFestivalTimetableCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionFestivalTimetableUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionFestivalTimetableUpsertLocalizationInput>>
}

export type SectionFestivalTimetableUpdateManyInlineInput = {
  /** Create and connect multiple SectionFestivalTimetable component instances */
  create?: InputMaybe<Array<SectionFestivalTimetableCreateWithPositionInput>>
  /** Delete multiple SectionFestivalTimetable documents */
  delete?: InputMaybe<Array<SectionFestivalTimetableWhereUniqueInput>>
  /** Update multiple SectionFestivalTimetable component instances */
  update?: InputMaybe<Array<SectionFestivalTimetableUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionFestivalTimetable component instances */
  upsert?: InputMaybe<Array<SectionFestivalTimetableUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionFestivalTimetableUpdateManyInput = {
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  defaultViewMode?: InputMaybe<TimetableViewModes>
  enableCompanyFilter?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  eventType?: InputMaybe<SpeakerEventTypes>
  hideViewSwitcher?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionFestivalTimetableUpdateManyLocalizationsInput>
  /** optionalDescription input for default locale (de) */
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  tabFilterType?: InputMaybe<TimetableTabFilterTypes>
}

export type SectionFestivalTimetableUpdateManyLocalizationDataInput = {
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionFestivalTimetableUpdateManyLocalizationInput = {
  data: SectionFestivalTimetableUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionFestivalTimetableUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionFestivalTimetableUpdateManyLocalizationInput>>
}

export type SectionFestivalTimetableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionFestivalTimetableUpdateManyInput
  /** Document search */
  where: SectionFestivalTimetableWhereInput
}

export type SectionFestivalTimetableUpdateOneInlineInput = {
  /** Create and connect one SectionFestivalTimetable document */
  create?: InputMaybe<SectionFestivalTimetableCreateInput>
  /** Delete currently connected SectionFestivalTimetable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionFestivalTimetable document */
  update?: InputMaybe<SectionFestivalTimetableUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionFestivalTimetable document */
  upsert?: InputMaybe<SectionFestivalTimetableUpsertWithNestedWhereUniqueInput>
}

export type SectionFestivalTimetableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionFestivalTimetableUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionFestivalTimetableWhereUniqueInput
}

export type SectionFestivalTimetableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionFestivalTimetableUpdateInput
  /** Unique document search */
  where: SectionFestivalTimetableWhereUniqueInput
}

export type SectionFestivalTimetableUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionFestivalTimetableCreateInput
  /** Update document if it exists */
  update: SectionFestivalTimetableUpdateInput
}

export type SectionFestivalTimetableUpsertLocalizationInput = {
  create: SectionFestivalTimetableCreateLocalizationDataInput
  locale: Locale
  update: SectionFestivalTimetableUpdateLocalizationDataInput
}

export type SectionFestivalTimetableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionFestivalTimetableUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionFestivalTimetableWhereUniqueInput
}

export type SectionFestivalTimetableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionFestivalTimetableUpsertInput
  /** Unique document search */
  where: SectionFestivalTimetableWhereUniqueInput
}

/** Identifies documents */
export type SectionFestivalTimetableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionFestivalTimetableWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionFestivalTimetableWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionFestivalTimetableWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkHeader_not?: InputMaybe<Scalars['Boolean']['input']>
  dayPreselect?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  dayPreselect_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  dayPreselect_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  dayPreselect_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  dayPreselect_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  dayPreselect_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  dayPreselect_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  dayPreselect_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  dayPreselect_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  dayPreselect_starts_with?: InputMaybe<Scalars['String']['input']>
  defaultViewMode?: InputMaybe<TimetableViewModes>
  /** All values that are contained in given list. */
  defaultViewMode_in?: InputMaybe<Array<InputMaybe<TimetableViewModes>>>
  /** Any other value that exists and is not equal to the given value. */
  defaultViewMode_not?: InputMaybe<TimetableViewModes>
  /** All values that are not contained in given list. */
  defaultViewMode_not_in?: InputMaybe<Array<InputMaybe<TimetableViewModes>>>
  enableCompanyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableCompanyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableJourneyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  eventStage?: InputMaybe<EventStageWhereInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  /** All values that are contained in given list. */
  eventType_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  /** Any other value that exists and is not equal to the given value. */
  eventType_not?: InputMaybe<SpeakerEventTypes>
  /** All values that are not contained in given list. */
  eventType_not_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  hideViewSwitcher?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideViewSwitcher_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interestsFilter_every?: InputMaybe<InterestWhereInput>
  interestsFilter_none?: InputMaybe<InterestWhereInput>
  interestsFilter_some?: InputMaybe<InterestWhereInput>
  optionalDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  optionalDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  optionalDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  optionalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  optionalDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  optionalDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  optionalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  optionalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  optionalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  optionalDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  optionalTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  optionalTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  optionalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  optionalTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  optionalTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  optionalTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  optionalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  optionalTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  optionalTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageSize_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageSize_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageSize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageSize_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageSize_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageSize_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  tabFilterType?: InputMaybe<TimetableTabFilterTypes>
  /** All values that are contained in given list. */
  tabFilterType_in?: InputMaybe<Array<InputMaybe<TimetableTabFilterTypes>>>
  /** Any other value that exists and is not equal to the given value. */
  tabFilterType_not?: InputMaybe<TimetableTabFilterTypes>
  /** All values that are not contained in given list. */
  tabFilterType_not_in?: InputMaybe<Array<InputMaybe<TimetableTabFilterTypes>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionFestivalTimetable record uniquely */
export type SectionFestivalTimetableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section Flip Counter component */
export type SectionFlipCounter = Entity & {
  __typename?: 'SectionFlipCounter'
  /** Call to action */
  cta?: Maybe<CallToAction>
  ctaInformationText?: Maybe<Scalars['String']['output']>
  darkMode?: Maybe<Scalars['Boolean']['output']>
  decorations?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionFlipCounter>
  optionalTitle?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  subtext?: Maybe<Scalars['String']['output']>
  targetDateTime: Scalars['DateTime']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section Flip Counter component */
export type SectionFlipCounterCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section Flip Counter component */
export type SectionFlipCounterLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section Flip Counter component */
export type SectionFlipCounterUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionFlipCounterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionFlipCounterWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionFlipCounterConnection = {
  __typename?: 'SectionFlipCounterConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionFlipCounterEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionFlipCounterCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** ctaInformationText input for default locale (de) */
  ctaInformationText?: InputMaybe<Scalars['String']['input']>
  darkMode?: InputMaybe<Scalars['Boolean']['input']>
  decorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionFlipCounterCreateLocalizationsInput>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  /** subtext input for default locale (de) */
  subtext?: InputMaybe<Scalars['String']['input']>
  targetDateTime: Scalars['DateTime']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionFlipCounterCreateLocalizationDataInput = {
  ctaInformationText?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  subtext?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionFlipCounterCreateLocalizationInput = {
  /** Localization input */
  data: SectionFlipCounterCreateLocalizationDataInput
  locale: Locale
}

export type SectionFlipCounterCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionFlipCounterCreateLocalizationInput>>
}

export type SectionFlipCounterCreateManyInlineInput = {
  /** Create and connect multiple existing SectionFlipCounter documents */
  create?: InputMaybe<Array<SectionFlipCounterCreateInput>>
}

export type SectionFlipCounterCreateOneInlineInput = {
  /** Create and connect one SectionFlipCounter document */
  create?: InputMaybe<SectionFlipCounterCreateInput>
}

export type SectionFlipCounterCreateWithPositionInput = {
  /** Document to create */
  data: SectionFlipCounterCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionFlipCounterEdge = {
  __typename?: 'SectionFlipCounterEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionFlipCounter
}

/** Identifies documents */
export type SectionFlipCounterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionFlipCounterWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionFlipCounterWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionFlipCounterWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  darkMode?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkMode_not?: InputMaybe<Scalars['Boolean']['input']>
  decorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  decorations_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  targetDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  targetDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  targetDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  targetDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  targetDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  targetDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  targetDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  targetDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionFlipCounterOrderByInput {
  CtaInformationTextAsc = 'ctaInformationText_ASC',
  CtaInformationTextDesc = 'ctaInformationText_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  DecorationsAsc = 'decorations_ASC',
  DecorationsDesc = 'decorations_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OptionalTitleAsc = 'optionalTitle_ASC',
  OptionalTitleDesc = 'optionalTitle_DESC',
  SubtextAsc = 'subtext_ASC',
  SubtextDesc = 'subtext_DESC',
  TargetDateTimeAsc = 'targetDateTime_ASC',
  TargetDateTimeDesc = 'targetDateTime_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionFlipCounterParent = EventPage

export type SectionFlipCounterParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionFlipCounterParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionFlipCounterParentCreateManyInlineInput = {
  /** Connect multiple existing SectionFlipCounterParent documents */
  connect?: InputMaybe<Array<SectionFlipCounterParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionFlipCounterParent documents */
  create?: InputMaybe<Array<SectionFlipCounterParentCreateInput>>
}

export type SectionFlipCounterParentCreateOneInlineInput = {
  /** Connect one existing SectionFlipCounterParent document */
  connect?: InputMaybe<SectionFlipCounterParentWhereUniqueInput>
  /** Create and connect one SectionFlipCounterParent document */
  create?: InputMaybe<SectionFlipCounterParentCreateInput>
}

export type SectionFlipCounterParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionFlipCounterParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionFlipCounterParent documents */
  connect?: InputMaybe<Array<SectionFlipCounterParentConnectInput>>
  /** Create and connect multiple SectionFlipCounterParent documents */
  create?: InputMaybe<Array<SectionFlipCounterParentCreateInput>>
  /** Delete multiple SectionFlipCounterParent documents */
  delete?: InputMaybe<Array<SectionFlipCounterParentWhereUniqueInput>>
  /** Disconnect multiple SectionFlipCounterParent documents */
  disconnect?: InputMaybe<Array<SectionFlipCounterParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionFlipCounterParent documents */
  set?: InputMaybe<Array<SectionFlipCounterParentWhereUniqueInput>>
  /** Update multiple SectionFlipCounterParent documents */
  update?: InputMaybe<Array<SectionFlipCounterParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionFlipCounterParent documents */
  upsert?: InputMaybe<Array<SectionFlipCounterParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionFlipCounterParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionFlipCounterParentUpdateOneInlineInput = {
  /** Connect existing SectionFlipCounterParent document */
  connect?: InputMaybe<SectionFlipCounterParentWhereUniqueInput>
  /** Create and connect one SectionFlipCounterParent document */
  create?: InputMaybe<SectionFlipCounterParentCreateInput>
  /** Delete currently connected SectionFlipCounterParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionFlipCounterParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionFlipCounterParent document */
  update?: InputMaybe<SectionFlipCounterParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionFlipCounterParent document */
  upsert?: InputMaybe<SectionFlipCounterParentUpsertWithNestedWhereUniqueInput>
}

export type SectionFlipCounterParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionFlipCounterParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionFlipCounterParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionFlipCounterParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionFlipCounterUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** ctaInformationText input for default locale (de) */
  ctaInformationText?: InputMaybe<Scalars['String']['input']>
  darkMode?: InputMaybe<Scalars['Boolean']['input']>
  decorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionFlipCounterUpdateLocalizationsInput>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  /** subtext input for default locale (de) */
  subtext?: InputMaybe<Scalars['String']['input']>
  targetDateTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionFlipCounterUpdateLocalizationDataInput = {
  ctaInformationText?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  subtext?: InputMaybe<Scalars['String']['input']>
}

export type SectionFlipCounterUpdateLocalizationInput = {
  data: SectionFlipCounterUpdateLocalizationDataInput
  locale: Locale
}

export type SectionFlipCounterUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionFlipCounterCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionFlipCounterUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionFlipCounterUpsertLocalizationInput>>
}

export type SectionFlipCounterUpdateManyInlineInput = {
  /** Create and connect multiple SectionFlipCounter component instances */
  create?: InputMaybe<Array<SectionFlipCounterCreateWithPositionInput>>
  /** Delete multiple SectionFlipCounter documents */
  delete?: InputMaybe<Array<SectionFlipCounterWhereUniqueInput>>
  /** Update multiple SectionFlipCounter component instances */
  update?: InputMaybe<Array<SectionFlipCounterUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionFlipCounter component instances */
  upsert?: InputMaybe<Array<SectionFlipCounterUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionFlipCounterUpdateManyInput = {
  /** ctaInformationText input for default locale (de) */
  ctaInformationText?: InputMaybe<Scalars['String']['input']>
  darkMode?: InputMaybe<Scalars['Boolean']['input']>
  decorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionFlipCounterUpdateManyLocalizationsInput>
  /** optionalTitle input for default locale (de) */
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  /** subtext input for default locale (de) */
  subtext?: InputMaybe<Scalars['String']['input']>
  targetDateTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionFlipCounterUpdateManyLocalizationDataInput = {
  ctaInformationText?: InputMaybe<Scalars['String']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  subtext?: InputMaybe<Scalars['String']['input']>
}

export type SectionFlipCounterUpdateManyLocalizationInput = {
  data: SectionFlipCounterUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionFlipCounterUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionFlipCounterUpdateManyLocalizationInput>>
}

export type SectionFlipCounterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionFlipCounterUpdateManyInput
  /** Document search */
  where: SectionFlipCounterWhereInput
}

export type SectionFlipCounterUpdateOneInlineInput = {
  /** Create and connect one SectionFlipCounter document */
  create?: InputMaybe<SectionFlipCounterCreateInput>
  /** Delete currently connected SectionFlipCounter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionFlipCounter document */
  update?: InputMaybe<SectionFlipCounterUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionFlipCounter document */
  upsert?: InputMaybe<SectionFlipCounterUpsertWithNestedWhereUniqueInput>
}

export type SectionFlipCounterUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionFlipCounterUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionFlipCounterWhereUniqueInput
}

export type SectionFlipCounterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionFlipCounterUpdateInput
  /** Unique document search */
  where: SectionFlipCounterWhereUniqueInput
}

export type SectionFlipCounterUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionFlipCounterCreateInput
  /** Update document if it exists */
  update: SectionFlipCounterUpdateInput
}

export type SectionFlipCounterUpsertLocalizationInput = {
  create: SectionFlipCounterCreateLocalizationDataInput
  locale: Locale
  update: SectionFlipCounterUpdateLocalizationDataInput
}

export type SectionFlipCounterUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionFlipCounterUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionFlipCounterWhereUniqueInput
}

export type SectionFlipCounterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionFlipCounterUpsertInput
  /** Unique document search */
  where: SectionFlipCounterWhereUniqueInput
}

/** Identifies documents */
export type SectionFlipCounterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionFlipCounterWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionFlipCounterWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionFlipCounterWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  ctaInformationText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaInformationText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaInformationText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaInformationText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaInformationText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaInformationText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaInformationText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaInformationText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaInformationText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaInformationText_starts_with?: InputMaybe<Scalars['String']['input']>
  darkMode?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkMode_not?: InputMaybe<Scalars['Boolean']['input']>
  decorations?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  decorations_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  optionalTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  optionalTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  optionalTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  optionalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  optionalTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  optionalTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  optionalTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  optionalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  optionalTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  optionalTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  subtext?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtext_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtext_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtext_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtext_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtext_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtext_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtext_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtext_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtext_starts_with?: InputMaybe<Scalars['String']['input']>
  targetDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  targetDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  targetDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  targetDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  targetDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  targetDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  targetDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  targetDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionFlipCounter record uniquely */
export type SectionFlipCounterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionFramesHero = Entity & {
  __typename?: 'SectionFramesHero'
  /** Decoration image indside the content area on the left side */
  contentBackgroundLeft?: Maybe<Asset>
  /** Decoration image indside the content area on the right side */
  contentBackgroundRight?: Maybe<Asset>
  /** The unique identifier */
  id: Scalars['ID']['output']
  intro?: Maybe<Scalars['String']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionFramesHero>
  /** Logo to appear above title */
  logo?: Maybe<Asset>
  /** System stage field */
  stage: Stage
  styleVariant?: Maybe<ComponentStyle>
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionFramesHeroContentBackgroundLeftArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionFramesHeroContentBackgroundRightArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionFramesHeroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionFramesHeroLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionFramesHeroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionFramesHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionFramesHeroWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionFramesHeroConnection = {
  __typename?: 'SectionFramesHeroConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionFramesHeroEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionFramesHeroCreateInput = {
  contentBackgroundLeft?: InputMaybe<AssetCreateOneInlineInput>
  contentBackgroundRight?: InputMaybe<AssetCreateOneInlineInput>
  /** intro input for default locale (de) */
  intro?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionFramesHeroCreateLocalizationsInput>
  logo?: InputMaybe<AssetCreateOneInlineInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionFramesHeroCreateLocalizationDataInput = {
  intro?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionFramesHeroCreateLocalizationInput = {
  /** Localization input */
  data: SectionFramesHeroCreateLocalizationDataInput
  locale: Locale
}

export type SectionFramesHeroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionFramesHeroCreateLocalizationInput>>
}

export type SectionFramesHeroCreateManyInlineInput = {
  /** Create and connect multiple existing SectionFramesHero documents */
  create?: InputMaybe<Array<SectionFramesHeroCreateInput>>
}

export type SectionFramesHeroCreateOneInlineInput = {
  /** Create and connect one SectionFramesHero document */
  create?: InputMaybe<SectionFramesHeroCreateInput>
}

export type SectionFramesHeroCreateWithPositionInput = {
  /** Document to create */
  data: SectionFramesHeroCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionFramesHeroEdge = {
  __typename?: 'SectionFramesHeroEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionFramesHero
}

/** Identifies documents */
export type SectionFramesHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionFramesHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionFramesHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionFramesHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  contentBackgroundLeft?: InputMaybe<AssetWhereInput>
  contentBackgroundRight?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionFramesHeroOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IntroAsc = 'intro_ASC',
  IntroDesc = 'intro_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionFramesHeroParent = LandingPage

export type SectionFramesHeroParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionFramesHeroParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionFramesHeroParentCreateManyInlineInput = {
  /** Connect multiple existing SectionFramesHeroParent documents */
  connect?: InputMaybe<Array<SectionFramesHeroParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionFramesHeroParent documents */
  create?: InputMaybe<Array<SectionFramesHeroParentCreateInput>>
}

export type SectionFramesHeroParentCreateOneInlineInput = {
  /** Connect one existing SectionFramesHeroParent document */
  connect?: InputMaybe<SectionFramesHeroParentWhereUniqueInput>
  /** Create and connect one SectionFramesHeroParent document */
  create?: InputMaybe<SectionFramesHeroParentCreateInput>
}

export type SectionFramesHeroParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionFramesHeroParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionFramesHeroParent documents */
  connect?: InputMaybe<Array<SectionFramesHeroParentConnectInput>>
  /** Create and connect multiple SectionFramesHeroParent documents */
  create?: InputMaybe<Array<SectionFramesHeroParentCreateInput>>
  /** Delete multiple SectionFramesHeroParent documents */
  delete?: InputMaybe<Array<SectionFramesHeroParentWhereUniqueInput>>
  /** Disconnect multiple SectionFramesHeroParent documents */
  disconnect?: InputMaybe<Array<SectionFramesHeroParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionFramesHeroParent documents */
  set?: InputMaybe<Array<SectionFramesHeroParentWhereUniqueInput>>
  /** Update multiple SectionFramesHeroParent documents */
  update?: InputMaybe<Array<SectionFramesHeroParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionFramesHeroParent documents */
  upsert?: InputMaybe<Array<SectionFramesHeroParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionFramesHeroParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionFramesHeroParentUpdateOneInlineInput = {
  /** Connect existing SectionFramesHeroParent document */
  connect?: InputMaybe<SectionFramesHeroParentWhereUniqueInput>
  /** Create and connect one SectionFramesHeroParent document */
  create?: InputMaybe<SectionFramesHeroParentCreateInput>
  /** Delete currently connected SectionFramesHeroParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionFramesHeroParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionFramesHeroParent document */
  update?: InputMaybe<SectionFramesHeroParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionFramesHeroParent document */
  upsert?: InputMaybe<SectionFramesHeroParentUpsertWithNestedWhereUniqueInput>
}

export type SectionFramesHeroParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionFramesHeroParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionFramesHeroParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionFramesHeroParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionFramesHeroUpdateInput = {
  contentBackgroundLeft?: InputMaybe<AssetUpdateOneInlineInput>
  contentBackgroundRight?: InputMaybe<AssetUpdateOneInlineInput>
  /** intro input for default locale (de) */
  intro?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionFramesHeroUpdateLocalizationsInput>
  logo?: InputMaybe<AssetUpdateOneInlineInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionFramesHeroUpdateLocalizationDataInput = {
  intro?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionFramesHeroUpdateLocalizationInput = {
  data: SectionFramesHeroUpdateLocalizationDataInput
  locale: Locale
}

export type SectionFramesHeroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionFramesHeroCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionFramesHeroUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionFramesHeroUpsertLocalizationInput>>
}

export type SectionFramesHeroUpdateManyInlineInput = {
  /** Create and connect multiple SectionFramesHero component instances */
  create?: InputMaybe<Array<SectionFramesHeroCreateWithPositionInput>>
  /** Delete multiple SectionFramesHero documents */
  delete?: InputMaybe<Array<SectionFramesHeroWhereUniqueInput>>
  /** Update multiple SectionFramesHero component instances */
  update?: InputMaybe<Array<SectionFramesHeroUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionFramesHero component instances */
  upsert?: InputMaybe<Array<SectionFramesHeroUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionFramesHeroUpdateManyInput = {
  /** intro input for default locale (de) */
  intro?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionFramesHeroUpdateManyLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionFramesHeroUpdateManyLocalizationDataInput = {
  intro?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionFramesHeroUpdateManyLocalizationInput = {
  data: SectionFramesHeroUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionFramesHeroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionFramesHeroUpdateManyLocalizationInput>>
}

export type SectionFramesHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionFramesHeroUpdateManyInput
  /** Document search */
  where: SectionFramesHeroWhereInput
}

export type SectionFramesHeroUpdateOneInlineInput = {
  /** Create and connect one SectionFramesHero document */
  create?: InputMaybe<SectionFramesHeroCreateInput>
  /** Delete currently connected SectionFramesHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionFramesHero document */
  update?: InputMaybe<SectionFramesHeroUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionFramesHero document */
  upsert?: InputMaybe<SectionFramesHeroUpsertWithNestedWhereUniqueInput>
}

export type SectionFramesHeroUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionFramesHeroUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionFramesHeroWhereUniqueInput
}

export type SectionFramesHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionFramesHeroUpdateInput
  /** Unique document search */
  where: SectionFramesHeroWhereUniqueInput
}

export type SectionFramesHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionFramesHeroCreateInput
  /** Update document if it exists */
  update: SectionFramesHeroUpdateInput
}

export type SectionFramesHeroUpsertLocalizationInput = {
  create: SectionFramesHeroCreateLocalizationDataInput
  locale: Locale
  update: SectionFramesHeroUpdateLocalizationDataInput
}

export type SectionFramesHeroUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionFramesHeroUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionFramesHeroWhereUniqueInput
}

export type SectionFramesHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionFramesHeroUpsertInput
  /** Unique document search */
  where: SectionFramesHeroWhereUniqueInput
}

/** Identifies documents */
export type SectionFramesHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionFramesHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionFramesHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionFramesHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  contentBackgroundLeft?: InputMaybe<AssetWhereInput>
  contentBackgroundRight?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  intro?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<AssetWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionFramesHero record uniquely */
export type SectionFramesHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionHero = Entity & {
  __typename?: 'SectionHero'
  background: Asset
  /** Half screen height component with no subhead and description. */
  compact?: Maybe<Scalars['Boolean']['output']>
  /** Call to action element rendered below text content */
  cta?: Maybe<CallToAction>
  ctaOnMobileOnly?: Maybe<Scalars['Boolean']['output']>
  /** CTA will be rendered under the text component. */
  ctaSecondary?: Maybe<CallToAction>
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionHero>
  /** Logo for display over the Hero */
  logo?: Maybe<Asset>
  /** Optional Background for Mobile Screens */
  mobileBackground?: Maybe<Asset>
  /** System stage field */
  stage: Stage
  subtitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  titleDecoration?: Maybe<Asset>
  titleIsTransparent?: Maybe<Scalars['Boolean']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  video?: Maybe<Asset>
}

export type SectionHeroBackgroundArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionHeroCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SectionHeroCtaSecondaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SectionHeroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionHeroLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionHeroMobileBackgroundArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionHeroTitleDecorationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionHeroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionHeroVideoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionHeroWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionHeroConnection = {
  __typename?: 'SectionHeroConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionHeroEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionHeroCreateInput = {
  background: AssetCreateOneInlineInput
  compact?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  ctaOnMobileOnly?: InputMaybe<Scalars['Boolean']['input']>
  ctaSecondary?: InputMaybe<CallToActionCreateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionHeroCreateLocalizationsInput>
  logo?: InputMaybe<AssetCreateOneInlineInput>
  mobileBackground?: InputMaybe<AssetCreateOneInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  titleDecoration?: InputMaybe<AssetCreateOneInlineInput>
  titleIsTransparent?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  video?: InputMaybe<AssetCreateOneInlineInput>
}

export type SectionHeroCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionHeroCreateLocalizationInput = {
  /** Localization input */
  data: SectionHeroCreateLocalizationDataInput
  locale: Locale
}

export type SectionHeroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionHeroCreateLocalizationInput>>
}

export type SectionHeroCreateManyInlineInput = {
  /** Create and connect multiple existing SectionHero documents */
  create?: InputMaybe<Array<SectionHeroCreateInput>>
}

export type SectionHeroCreateOneInlineInput = {
  /** Create and connect one SectionHero document */
  create?: InputMaybe<SectionHeroCreateInput>
}

export type SectionHeroCreateWithPositionInput = {
  /** Document to create */
  data: SectionHeroCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionHeroEdge = {
  __typename?: 'SectionHeroEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionHero
}

/** Identifies documents */
export type SectionHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  background?: InputMaybe<AssetWhereInput>
  compact?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  compact_not?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  ctaOnMobileOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  ctaOnMobileOnly_not?: InputMaybe<Scalars['Boolean']['input']>
  ctaSecondary?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  mobileBackground?: InputMaybe<AssetWhereInput>
  titleDecoration?: InputMaybe<AssetWhereInput>
  titleIsTransparent?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  titleIsTransparent_not?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  video?: InputMaybe<AssetWhereInput>
}

export enum SectionHeroOrderByInput {
  CompactAsc = 'compact_ASC',
  CompactDesc = 'compact_DESC',
  CtaOnMobileOnlyAsc = 'ctaOnMobileOnly_ASC',
  CtaOnMobileOnlyDesc = 'ctaOnMobileOnly_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleIsTransparentAsc = 'titleIsTransparent_ASC',
  TitleIsTransparentDesc = 'titleIsTransparent_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionHeroParent = EventPage | LandingPage

export type SectionHeroParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionHeroParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionHeroParentCreateManyInlineInput = {
  /** Connect multiple existing SectionHeroParent documents */
  connect?: InputMaybe<Array<SectionHeroParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionHeroParent documents */
  create?: InputMaybe<Array<SectionHeroParentCreateInput>>
}

export type SectionHeroParentCreateOneInlineInput = {
  /** Connect one existing SectionHeroParent document */
  connect?: InputMaybe<SectionHeroParentWhereUniqueInput>
  /** Create and connect one SectionHeroParent document */
  create?: InputMaybe<SectionHeroParentCreateInput>
}

export type SectionHeroParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionHeroParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionHeroParent documents */
  connect?: InputMaybe<Array<SectionHeroParentConnectInput>>
  /** Create and connect multiple SectionHeroParent documents */
  create?: InputMaybe<Array<SectionHeroParentCreateInput>>
  /** Delete multiple SectionHeroParent documents */
  delete?: InputMaybe<Array<SectionHeroParentWhereUniqueInput>>
  /** Disconnect multiple SectionHeroParent documents */
  disconnect?: InputMaybe<Array<SectionHeroParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionHeroParent documents */
  set?: InputMaybe<Array<SectionHeroParentWhereUniqueInput>>
  /** Update multiple SectionHeroParent documents */
  update?: InputMaybe<Array<SectionHeroParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionHeroParent documents */
  upsert?: InputMaybe<Array<SectionHeroParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionHeroParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionHeroParentUpdateOneInlineInput = {
  /** Connect existing SectionHeroParent document */
  connect?: InputMaybe<SectionHeroParentWhereUniqueInput>
  /** Create and connect one SectionHeroParent document */
  create?: InputMaybe<SectionHeroParentCreateInput>
  /** Delete currently connected SectionHeroParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionHeroParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionHeroParent document */
  update?: InputMaybe<SectionHeroParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionHeroParent document */
  upsert?: InputMaybe<SectionHeroParentUpsertWithNestedWhereUniqueInput>
}

export type SectionHeroParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionHeroParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionHeroParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionHeroParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionHeroUpdateInput = {
  background?: InputMaybe<AssetUpdateOneInlineInput>
  compact?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  ctaOnMobileOnly?: InputMaybe<Scalars['Boolean']['input']>
  ctaSecondary?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionHeroUpdateLocalizationsInput>
  logo?: InputMaybe<AssetUpdateOneInlineInput>
  mobileBackground?: InputMaybe<AssetUpdateOneInlineInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  titleDecoration?: InputMaybe<AssetUpdateOneInlineInput>
  titleIsTransparent?: InputMaybe<Scalars['Boolean']['input']>
  video?: InputMaybe<AssetUpdateOneInlineInput>
}

export type SectionHeroUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionHeroUpdateLocalizationInput = {
  data: SectionHeroUpdateLocalizationDataInput
  locale: Locale
}

export type SectionHeroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionHeroCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionHeroUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionHeroUpsertLocalizationInput>>
}

export type SectionHeroUpdateManyInlineInput = {
  /** Create and connect multiple SectionHero component instances */
  create?: InputMaybe<Array<SectionHeroCreateWithPositionInput>>
  /** Delete multiple SectionHero documents */
  delete?: InputMaybe<Array<SectionHeroWhereUniqueInput>>
  /** Update multiple SectionHero component instances */
  update?: InputMaybe<Array<SectionHeroUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionHero component instances */
  upsert?: InputMaybe<Array<SectionHeroUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionHeroUpdateManyInput = {
  compact?: InputMaybe<Scalars['Boolean']['input']>
  ctaOnMobileOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionHeroUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  titleIsTransparent?: InputMaybe<Scalars['Boolean']['input']>
}

export type SectionHeroUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionHeroUpdateManyLocalizationInput = {
  data: SectionHeroUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionHeroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionHeroUpdateManyLocalizationInput>>
}

export type SectionHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionHeroUpdateManyInput
  /** Document search */
  where: SectionHeroWhereInput
}

export type SectionHeroUpdateOneInlineInput = {
  /** Create and connect one SectionHero document */
  create?: InputMaybe<SectionHeroCreateInput>
  /** Delete currently connected SectionHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionHero document */
  update?: InputMaybe<SectionHeroUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionHero document */
  upsert?: InputMaybe<SectionHeroUpsertWithNestedWhereUniqueInput>
}

export type SectionHeroUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionHeroUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionHeroWhereUniqueInput
}

export type SectionHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionHeroUpdateInput
  /** Unique document search */
  where: SectionHeroWhereUniqueInput
}

export type SectionHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionHeroCreateInput
  /** Update document if it exists */
  update: SectionHeroUpdateInput
}

export type SectionHeroUpsertLocalizationInput = {
  create: SectionHeroCreateLocalizationDataInput
  locale: Locale
  update: SectionHeroUpdateLocalizationDataInput
}

export type SectionHeroUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionHeroUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionHeroWhereUniqueInput
}

export type SectionHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionHeroUpsertInput
  /** Unique document search */
  where: SectionHeroWhereUniqueInput
}

/** Identifies documents */
export type SectionHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  background?: InputMaybe<AssetWhereInput>
  compact?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  compact_not?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  ctaOnMobileOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  ctaOnMobileOnly_not?: InputMaybe<Scalars['Boolean']['input']>
  ctaSecondary?: InputMaybe<CallToActionWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  logo?: InputMaybe<AssetWhereInput>
  mobileBackground?: InputMaybe<AssetWhereInput>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  titleDecoration?: InputMaybe<AssetWhereInput>
  titleIsTransparent?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  titleIsTransparent_not?: InputMaybe<Scalars['Boolean']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  video?: InputMaybe<AssetWhereInput>
}

/** References SectionHero record uniquely */
export type SectionHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section showing the list of hotels. */
export type SectionHotel = Entity & {
  __typename?: 'SectionHotel'
  description: Scalars['String']['output']
  hotels: Array<Hotel>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionHotel>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section showing the list of hotels. */
export type SectionHotelHotelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<HotelOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<HotelWhereInput>
}

/** Section showing the list of hotels. */
export type SectionHotelLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing the list of hotels. */
export type SectionHotelUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionHotelConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionHotelWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionHotelConnection = {
  __typename?: 'SectionHotelConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionHotelEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionHotelCreateInput = {
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  hotels: HotelCreateManyInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionHotelCreateLocalizationsInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionHotelCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionHotelCreateLocalizationInput = {
  /** Localization input */
  data: SectionHotelCreateLocalizationDataInput
  locale: Locale
}

export type SectionHotelCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionHotelCreateLocalizationInput>>
}

export type SectionHotelCreateManyInlineInput = {
  /** Create and connect multiple existing SectionHotel documents */
  create?: InputMaybe<Array<SectionHotelCreateInput>>
}

export type SectionHotelCreateOneInlineInput = {
  /** Create and connect one SectionHotel document */
  create?: InputMaybe<SectionHotelCreateInput>
}

export type SectionHotelCreateWithPositionInput = {
  /** Document to create */
  data: SectionHotelCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionHotelEdge = {
  __typename?: 'SectionHotelEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionHotel
}

/** Identifies documents */
export type SectionHotelManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionHotelWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionHotelWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionHotelWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  hotels_every?: InputMaybe<HotelWhereInput>
  hotels_none?: InputMaybe<HotelWhereInput>
  hotels_some?: InputMaybe<HotelWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionHotelOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionHotelParent = EventPage

export type SectionHotelParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionHotelParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionHotelParentCreateManyInlineInput = {
  /** Connect multiple existing SectionHotelParent documents */
  connect?: InputMaybe<Array<SectionHotelParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionHotelParent documents */
  create?: InputMaybe<Array<SectionHotelParentCreateInput>>
}

export type SectionHotelParentCreateOneInlineInput = {
  /** Connect one existing SectionHotelParent document */
  connect?: InputMaybe<SectionHotelParentWhereUniqueInput>
  /** Create and connect one SectionHotelParent document */
  create?: InputMaybe<SectionHotelParentCreateInput>
}

export type SectionHotelParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionHotelParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionHotelParent documents */
  connect?: InputMaybe<Array<SectionHotelParentConnectInput>>
  /** Create and connect multiple SectionHotelParent documents */
  create?: InputMaybe<Array<SectionHotelParentCreateInput>>
  /** Delete multiple SectionHotelParent documents */
  delete?: InputMaybe<Array<SectionHotelParentWhereUniqueInput>>
  /** Disconnect multiple SectionHotelParent documents */
  disconnect?: InputMaybe<Array<SectionHotelParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionHotelParent documents */
  set?: InputMaybe<Array<SectionHotelParentWhereUniqueInput>>
  /** Update multiple SectionHotelParent documents */
  update?: InputMaybe<Array<SectionHotelParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionHotelParent documents */
  upsert?: InputMaybe<Array<SectionHotelParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionHotelParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionHotelParentUpdateOneInlineInput = {
  /** Connect existing SectionHotelParent document */
  connect?: InputMaybe<SectionHotelParentWhereUniqueInput>
  /** Create and connect one SectionHotelParent document */
  create?: InputMaybe<SectionHotelParentCreateInput>
  /** Delete currently connected SectionHotelParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionHotelParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionHotelParent document */
  update?: InputMaybe<SectionHotelParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionHotelParent document */
  upsert?: InputMaybe<SectionHotelParentUpsertWithNestedWhereUniqueInput>
}

export type SectionHotelParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionHotelParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionHotelParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionHotelParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionHotelUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hotels?: InputMaybe<HotelUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionHotelUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionHotelUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionHotelUpdateLocalizationInput = {
  data: SectionHotelUpdateLocalizationDataInput
  locale: Locale
}

export type SectionHotelUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionHotelCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionHotelUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionHotelUpsertLocalizationInput>>
}

export type SectionHotelUpdateManyInlineInput = {
  /** Create and connect multiple SectionHotel component instances */
  create?: InputMaybe<Array<SectionHotelCreateWithPositionInput>>
  /** Delete multiple SectionHotel documents */
  delete?: InputMaybe<Array<SectionHotelWhereUniqueInput>>
  /** Update multiple SectionHotel component instances */
  update?: InputMaybe<Array<SectionHotelUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionHotel component instances */
  upsert?: InputMaybe<Array<SectionHotelUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionHotelUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionHotelUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionHotelUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionHotelUpdateManyLocalizationInput = {
  data: SectionHotelUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionHotelUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionHotelUpdateManyLocalizationInput>>
}

export type SectionHotelUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionHotelUpdateManyInput
  /** Document search */
  where: SectionHotelWhereInput
}

export type SectionHotelUpdateOneInlineInput = {
  /** Create and connect one SectionHotel document */
  create?: InputMaybe<SectionHotelCreateInput>
  /** Delete currently connected SectionHotel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionHotel document */
  update?: InputMaybe<SectionHotelUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionHotel document */
  upsert?: InputMaybe<SectionHotelUpsertWithNestedWhereUniqueInput>
}

export type SectionHotelUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionHotelUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionHotelWhereUniqueInput
}

export type SectionHotelUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionHotelUpdateInput
  /** Unique document search */
  where: SectionHotelWhereUniqueInput
}

export type SectionHotelUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionHotelCreateInput
  /** Update document if it exists */
  update: SectionHotelUpdateInput
}

export type SectionHotelUpsertLocalizationInput = {
  create: SectionHotelCreateLocalizationDataInput
  locale: Locale
  update: SectionHotelUpdateLocalizationDataInput
}

export type SectionHotelUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionHotelUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionHotelWhereUniqueInput
}

export type SectionHotelUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionHotelUpsertInput
  /** Unique document search */
  where: SectionHotelWhereUniqueInput
}

/** Identifies documents */
export type SectionHotelWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionHotelWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionHotelWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionHotelWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  hotels_every?: InputMaybe<HotelWhereInput>
  hotels_none?: InputMaybe<HotelWhereInput>
  hotels_some?: InputMaybe<HotelWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionHotel record uniquely */
export type SectionHotelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Embed a Hubspot form section on the page */
export type SectionHubspotForm = Entity & {
  __typename?: 'SectionHubspotForm'
  formId: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionHubspotForm>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Embed a Hubspot form section on the page */
export type SectionHubspotFormLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Embed a Hubspot form section on the page */
export type SectionHubspotFormUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionHubspotFormConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionHubspotFormWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionHubspotFormConnection = {
  __typename?: 'SectionHubspotFormConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionHubspotFormEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionHubspotFormCreateInput = {
  /** formId input for default locale (de) */
  formId: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionHubspotFormCreateLocalizationsInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionHubspotFormCreateLocalizationDataInput = {
  formId: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionHubspotFormCreateLocalizationInput = {
  /** Localization input */
  data: SectionHubspotFormCreateLocalizationDataInput
  locale: Locale
}

export type SectionHubspotFormCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionHubspotFormCreateLocalizationInput>>
}

export type SectionHubspotFormCreateManyInlineInput = {
  /** Create and connect multiple existing SectionHubspotForm documents */
  create?: InputMaybe<Array<SectionHubspotFormCreateInput>>
}

export type SectionHubspotFormCreateOneInlineInput = {
  /** Create and connect one SectionHubspotForm document */
  create?: InputMaybe<SectionHubspotFormCreateInput>
}

export type SectionHubspotFormCreateWithPositionInput = {
  /** Document to create */
  data: SectionHubspotFormCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionHubspotFormEdge = {
  __typename?: 'SectionHubspotFormEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionHubspotForm
}

/** Identifies documents */
export type SectionHubspotFormManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionHubspotFormWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionHubspotFormWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionHubspotFormWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionHubspotFormOrderByInput {
  FormIdAsc = 'formId_ASC',
  FormIdDesc = 'formId_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionHubspotFormParent = EventPage | LandingPage

export type SectionHubspotFormParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionHubspotFormParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionHubspotFormParentCreateManyInlineInput = {
  /** Connect multiple existing SectionHubspotFormParent documents */
  connect?: InputMaybe<Array<SectionHubspotFormParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionHubspotFormParent documents */
  create?: InputMaybe<Array<SectionHubspotFormParentCreateInput>>
}

export type SectionHubspotFormParentCreateOneInlineInput = {
  /** Connect one existing SectionHubspotFormParent document */
  connect?: InputMaybe<SectionHubspotFormParentWhereUniqueInput>
  /** Create and connect one SectionHubspotFormParent document */
  create?: InputMaybe<SectionHubspotFormParentCreateInput>
}

export type SectionHubspotFormParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionHubspotFormParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionHubspotFormParent documents */
  connect?: InputMaybe<Array<SectionHubspotFormParentConnectInput>>
  /** Create and connect multiple SectionHubspotFormParent documents */
  create?: InputMaybe<Array<SectionHubspotFormParentCreateInput>>
  /** Delete multiple SectionHubspotFormParent documents */
  delete?: InputMaybe<Array<SectionHubspotFormParentWhereUniqueInput>>
  /** Disconnect multiple SectionHubspotFormParent documents */
  disconnect?: InputMaybe<Array<SectionHubspotFormParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionHubspotFormParent documents */
  set?: InputMaybe<Array<SectionHubspotFormParentWhereUniqueInput>>
  /** Update multiple SectionHubspotFormParent documents */
  update?: InputMaybe<Array<SectionHubspotFormParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionHubspotFormParent documents */
  upsert?: InputMaybe<Array<SectionHubspotFormParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionHubspotFormParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionHubspotFormParentUpdateOneInlineInput = {
  /** Connect existing SectionHubspotFormParent document */
  connect?: InputMaybe<SectionHubspotFormParentWhereUniqueInput>
  /** Create and connect one SectionHubspotFormParent document */
  create?: InputMaybe<SectionHubspotFormParentCreateInput>
  /** Delete currently connected SectionHubspotFormParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionHubspotFormParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionHubspotFormParent document */
  update?: InputMaybe<SectionHubspotFormParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionHubspotFormParent document */
  upsert?: InputMaybe<SectionHubspotFormParentUpsertWithNestedWhereUniqueInput>
}

export type SectionHubspotFormParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionHubspotFormParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionHubspotFormParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionHubspotFormParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionHubspotFormUpdateInput = {
  /** formId input for default locale (de) */
  formId?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionHubspotFormUpdateLocalizationsInput>
}

export type SectionHubspotFormUpdateLocalizationDataInput = {
  formId?: InputMaybe<Scalars['String']['input']>
}

export type SectionHubspotFormUpdateLocalizationInput = {
  data: SectionHubspotFormUpdateLocalizationDataInput
  locale: Locale
}

export type SectionHubspotFormUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionHubspotFormCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionHubspotFormUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionHubspotFormUpsertLocalizationInput>>
}

export type SectionHubspotFormUpdateManyInlineInput = {
  /** Create and connect multiple SectionHubspotForm component instances */
  create?: InputMaybe<Array<SectionHubspotFormCreateWithPositionInput>>
  /** Delete multiple SectionHubspotForm documents */
  delete?: InputMaybe<Array<SectionHubspotFormWhereUniqueInput>>
  /** Update multiple SectionHubspotForm component instances */
  update?: InputMaybe<Array<SectionHubspotFormUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionHubspotForm component instances */
  upsert?: InputMaybe<Array<SectionHubspotFormUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionHubspotFormUpdateManyInput = {
  /** formId input for default locale (de) */
  formId?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionHubspotFormUpdateManyLocalizationsInput>
}

export type SectionHubspotFormUpdateManyLocalizationDataInput = {
  formId?: InputMaybe<Scalars['String']['input']>
}

export type SectionHubspotFormUpdateManyLocalizationInput = {
  data: SectionHubspotFormUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionHubspotFormUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionHubspotFormUpdateManyLocalizationInput>>
}

export type SectionHubspotFormUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionHubspotFormUpdateManyInput
  /** Document search */
  where: SectionHubspotFormWhereInput
}

export type SectionHubspotFormUpdateOneInlineInput = {
  /** Create and connect one SectionHubspotForm document */
  create?: InputMaybe<SectionHubspotFormCreateInput>
  /** Delete currently connected SectionHubspotForm document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionHubspotForm document */
  update?: InputMaybe<SectionHubspotFormUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionHubspotForm document */
  upsert?: InputMaybe<SectionHubspotFormUpsertWithNestedWhereUniqueInput>
}

export type SectionHubspotFormUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionHubspotFormUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionHubspotFormWhereUniqueInput
}

export type SectionHubspotFormUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionHubspotFormUpdateInput
  /** Unique document search */
  where: SectionHubspotFormWhereUniqueInput
}

export type SectionHubspotFormUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionHubspotFormCreateInput
  /** Update document if it exists */
  update: SectionHubspotFormUpdateInput
}

export type SectionHubspotFormUpsertLocalizationInput = {
  create: SectionHubspotFormCreateLocalizationDataInput
  locale: Locale
  update: SectionHubspotFormUpdateLocalizationDataInput
}

export type SectionHubspotFormUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionHubspotFormUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionHubspotFormWhereUniqueInput
}

export type SectionHubspotFormUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionHubspotFormUpsertInput
  /** Unique document search */
  where: SectionHubspotFormWhereUniqueInput
}

/** Identifies documents */
export type SectionHubspotFormWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionHubspotFormWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionHubspotFormWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionHubspotFormWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  formId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  formId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  formId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  formId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  formId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  formId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  formId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  formId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  formId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  formId_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionHubspotForm record uniquely */
export type SectionHubspotFormWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Image slider component. */
export type SectionImageSlider = Entity & {
  __typename?: 'SectionImageSlider'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Images for the image slider */
  images: Array<Asset>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Image slider component. */
export type SectionImageSliderImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<AssetOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AssetWhereInput>
}

export type SectionImageSliderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionImageSliderWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionImageSliderConnection = {
  __typename?: 'SectionImageSliderConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionImageSliderEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionImageSliderCreateInput = {
  images: AssetCreateManyInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionImageSliderCreateManyInlineInput = {
  /** Create and connect multiple existing SectionImageSlider documents */
  create?: InputMaybe<Array<SectionImageSliderCreateInput>>
}

export type SectionImageSliderCreateOneInlineInput = {
  /** Create and connect one SectionImageSlider document */
  create?: InputMaybe<SectionImageSliderCreateInput>
}

export type SectionImageSliderCreateWithPositionInput = {
  /** Document to create */
  data: SectionImageSliderCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionImageSliderEdge = {
  __typename?: 'SectionImageSliderEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionImageSlider
}

/** Identifies documents */
export type SectionImageSliderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionImageSliderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionImageSliderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionImageSliderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  images_every?: InputMaybe<AssetWhereInput>
  images_none?: InputMaybe<AssetWhereInput>
  images_some?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionImageSliderOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionImageSliderParent = CareerPage | LandingPage

export type SectionImageSliderParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionImageSliderParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionImageSliderParentCreateManyInlineInput = {
  /** Connect multiple existing SectionImageSliderParent documents */
  connect?: InputMaybe<Array<SectionImageSliderParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionImageSliderParent documents */
  create?: InputMaybe<Array<SectionImageSliderParentCreateInput>>
}

export type SectionImageSliderParentCreateOneInlineInput = {
  /** Connect one existing SectionImageSliderParent document */
  connect?: InputMaybe<SectionImageSliderParentWhereUniqueInput>
  /** Create and connect one SectionImageSliderParent document */
  create?: InputMaybe<SectionImageSliderParentCreateInput>
}

export type SectionImageSliderParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionImageSliderParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionImageSliderParent documents */
  connect?: InputMaybe<Array<SectionImageSliderParentConnectInput>>
  /** Create and connect multiple SectionImageSliderParent documents */
  create?: InputMaybe<Array<SectionImageSliderParentCreateInput>>
  /** Delete multiple SectionImageSliderParent documents */
  delete?: InputMaybe<Array<SectionImageSliderParentWhereUniqueInput>>
  /** Disconnect multiple SectionImageSliderParent documents */
  disconnect?: InputMaybe<Array<SectionImageSliderParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionImageSliderParent documents */
  set?: InputMaybe<Array<SectionImageSliderParentWhereUniqueInput>>
  /** Update multiple SectionImageSliderParent documents */
  update?: InputMaybe<Array<SectionImageSliderParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionImageSliderParent documents */
  upsert?: InputMaybe<Array<SectionImageSliderParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionImageSliderParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionImageSliderParentUpdateOneInlineInput = {
  /** Connect existing SectionImageSliderParent document */
  connect?: InputMaybe<SectionImageSliderParentWhereUniqueInput>
  /** Create and connect one SectionImageSliderParent document */
  create?: InputMaybe<SectionImageSliderParentCreateInput>
  /** Delete currently connected SectionImageSliderParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionImageSliderParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionImageSliderParent document */
  update?: InputMaybe<SectionImageSliderParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionImageSliderParent document */
  upsert?: InputMaybe<SectionImageSliderParentUpsertWithNestedWhereUniqueInput>
}

export type SectionImageSliderParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionImageSliderParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionImageSliderParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionImageSliderParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionImageSliderUpdateInput = {
  images?: InputMaybe<AssetUpdateManyInlineInput>
}

export type SectionImageSliderUpdateManyInlineInput = {
  /** Create and connect multiple SectionImageSlider component instances */
  create?: InputMaybe<Array<SectionImageSliderCreateWithPositionInput>>
  /** Delete multiple SectionImageSlider documents */
  delete?: InputMaybe<Array<SectionImageSliderWhereUniqueInput>>
  /** Update multiple SectionImageSlider component instances */
  update?: InputMaybe<Array<SectionImageSliderUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionImageSlider component instances */
  upsert?: InputMaybe<Array<SectionImageSliderUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionImageSliderUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type SectionImageSliderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionImageSliderUpdateManyInput
  /** Document search */
  where: SectionImageSliderWhereInput
}

export type SectionImageSliderUpdateOneInlineInput = {
  /** Create and connect one SectionImageSlider document */
  create?: InputMaybe<SectionImageSliderCreateInput>
  /** Delete currently connected SectionImageSlider document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionImageSlider document */
  update?: InputMaybe<SectionImageSliderUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionImageSlider document */
  upsert?: InputMaybe<SectionImageSliderUpsertWithNestedWhereUniqueInput>
}

export type SectionImageSliderUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionImageSliderUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionImageSliderWhereUniqueInput
}

export type SectionImageSliderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionImageSliderUpdateInput
  /** Unique document search */
  where: SectionImageSliderWhereUniqueInput
}

export type SectionImageSliderUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionImageSliderCreateInput
  /** Update document if it exists */
  update: SectionImageSliderUpdateInput
}

export type SectionImageSliderUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionImageSliderUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionImageSliderWhereUniqueInput
}

export type SectionImageSliderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionImageSliderUpsertInput
  /** Unique document search */
  where: SectionImageSliderWhereUniqueInput
}

/** Identifies documents */
export type SectionImageSliderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionImageSliderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionImageSliderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionImageSliderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  images_every?: InputMaybe<AssetWhereInput>
  images_none?: InputMaybe<AssetWhereInput>
  images_some?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionImageSlider record uniquely */
export type SectionImageSliderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionIntro = Entity & {
  __typename?: 'SectionIntro'
  centered?: Maybe<Scalars['Boolean']['output']>
  /** Call to action element rendered below text content */
  cta?: Maybe<CallToAction>
  /** Select a decoration pattern for this component. */
  decorationPattern?: Maybe<DecorationPattern>
  description: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionIntro>
  sectionHead?: Maybe<Scalars['Boolean']['output']>
  /** Select a custom padding for this section, otherwise default is used. */
  sectionPadding?: Maybe<SectionPadding>
  /** System stage field */
  stage: Stage
  theme?: Maybe<OmrThemeVariant>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionIntroCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SectionIntroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionIntroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionIntroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionIntroWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionIntroConnection = {
  __typename?: 'SectionIntroConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionIntroEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionIntroCreateInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionIntroCreateLocalizationsInput>
  sectionHead?: InputMaybe<Scalars['Boolean']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionIntroCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionIntroCreateLocalizationInput = {
  /** Localization input */
  data: SectionIntroCreateLocalizationDataInput
  locale: Locale
}

export type SectionIntroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionIntroCreateLocalizationInput>>
}

export type SectionIntroCreateManyInlineInput = {
  /** Create and connect multiple existing SectionIntro documents */
  create?: InputMaybe<Array<SectionIntroCreateInput>>
}

export type SectionIntroCreateOneInlineInput = {
  /** Create and connect one SectionIntro document */
  create?: InputMaybe<SectionIntroCreateInput>
}

export type SectionIntroCreateWithPositionInput = {
  /** Document to create */
  data: SectionIntroCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionIntroEdge = {
  __typename?: 'SectionIntroEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionIntro
}

/** Identifies documents */
export type SectionIntroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionIntroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionIntroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionIntroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  sectionHead?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  sectionHead_not?: InputMaybe<Scalars['Boolean']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionIntroOrderByInput {
  CenteredAsc = 'centered_ASC',
  CenteredDesc = 'centered_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SectionHeadAsc = 'sectionHead_ASC',
  SectionHeadDesc = 'sectionHead_DESC',
  SectionPaddingAsc = 'sectionPadding_ASC',
  SectionPaddingDesc = 'sectionPadding_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionIntroParent = CareerPage | EventPage | LandingPage

export type SectionIntroParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionIntroParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionIntroParentCreateManyInlineInput = {
  /** Connect multiple existing SectionIntroParent documents */
  connect?: InputMaybe<Array<SectionIntroParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionIntroParent documents */
  create?: InputMaybe<Array<SectionIntroParentCreateInput>>
}

export type SectionIntroParentCreateOneInlineInput = {
  /** Connect one existing SectionIntroParent document */
  connect?: InputMaybe<SectionIntroParentWhereUniqueInput>
  /** Create and connect one SectionIntroParent document */
  create?: InputMaybe<SectionIntroParentCreateInput>
}

export type SectionIntroParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionIntroParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionIntroParent documents */
  connect?: InputMaybe<Array<SectionIntroParentConnectInput>>
  /** Create and connect multiple SectionIntroParent documents */
  create?: InputMaybe<Array<SectionIntroParentCreateInput>>
  /** Delete multiple SectionIntroParent documents */
  delete?: InputMaybe<Array<SectionIntroParentWhereUniqueInput>>
  /** Disconnect multiple SectionIntroParent documents */
  disconnect?: InputMaybe<Array<SectionIntroParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionIntroParent documents */
  set?: InputMaybe<Array<SectionIntroParentWhereUniqueInput>>
  /** Update multiple SectionIntroParent documents */
  update?: InputMaybe<Array<SectionIntroParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionIntroParent documents */
  upsert?: InputMaybe<Array<SectionIntroParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionIntroParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionIntroParentUpdateOneInlineInput = {
  /** Connect existing SectionIntroParent document */
  connect?: InputMaybe<SectionIntroParentWhereUniqueInput>
  /** Create and connect one SectionIntroParent document */
  create?: InputMaybe<SectionIntroParentCreateInput>
  /** Delete currently connected SectionIntroParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionIntroParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionIntroParent document */
  update?: InputMaybe<SectionIntroParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionIntroParent document */
  upsert?: InputMaybe<SectionIntroParentUpsertWithNestedWhereUniqueInput>
}

export type SectionIntroParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionIntroParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionIntroParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionIntroParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionIntroUpdateInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionIntroUpdateLocalizationsInput>
  sectionHead?: InputMaybe<Scalars['Boolean']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionIntroUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionIntroUpdateLocalizationInput = {
  data: SectionIntroUpdateLocalizationDataInput
  locale: Locale
}

export type SectionIntroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionIntroCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionIntroUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionIntroUpsertLocalizationInput>>
}

export type SectionIntroUpdateManyInlineInput = {
  /** Create and connect multiple SectionIntro component instances */
  create?: InputMaybe<Array<SectionIntroCreateWithPositionInput>>
  /** Delete multiple SectionIntro documents */
  delete?: InputMaybe<Array<SectionIntroWhereUniqueInput>>
  /** Update multiple SectionIntro component instances */
  update?: InputMaybe<Array<SectionIntroUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionIntro component instances */
  upsert?: InputMaybe<Array<SectionIntroUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionIntroUpdateManyInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionIntroUpdateManyLocalizationsInput>
  sectionHead?: InputMaybe<Scalars['Boolean']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionIntroUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionIntroUpdateManyLocalizationInput = {
  data: SectionIntroUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionIntroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionIntroUpdateManyLocalizationInput>>
}

export type SectionIntroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionIntroUpdateManyInput
  /** Document search */
  where: SectionIntroWhereInput
}

export type SectionIntroUpdateOneInlineInput = {
  /** Create and connect one SectionIntro document */
  create?: InputMaybe<SectionIntroCreateInput>
  /** Delete currently connected SectionIntro document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionIntro document */
  update?: InputMaybe<SectionIntroUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionIntro document */
  upsert?: InputMaybe<SectionIntroUpsertWithNestedWhereUniqueInput>
}

export type SectionIntroUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionIntroUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionIntroWhereUniqueInput
}

export type SectionIntroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionIntroUpdateInput
  /** Unique document search */
  where: SectionIntroWhereUniqueInput
}

export type SectionIntroUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionIntroCreateInput
  /** Update document if it exists */
  update: SectionIntroUpdateInput
}

export type SectionIntroUpsertLocalizationInput = {
  create: SectionIntroCreateLocalizationDataInput
  locale: Locale
  update: SectionIntroUpdateLocalizationDataInput
}

export type SectionIntroUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionIntroUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionIntroWhereUniqueInput
}

export type SectionIntroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionIntroUpsertInput
  /** Unique document search */
  where: SectionIntroWhereUniqueInput
}

/** Identifies documents */
export type SectionIntroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionIntroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionIntroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionIntroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  sectionHead?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  sectionHead_not?: InputMaybe<Scalars['Boolean']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionIntro record uniquely */
export type SectionIntroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionJobList = Entity & {
  __typename?: 'SectionJobList'
  /** The unique identifier */
  id: Scalars['ID']['output']
  jobs: Array<JobListing>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionJobListJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<JobListingOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<JobListingWhereInput>
}

export type SectionJobListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionJobListWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionJobListConnection = {
  __typename?: 'SectionJobListConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionJobListEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionJobListCreateInput = {
  jobs?: InputMaybe<JobListingCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionJobListCreateManyInlineInput = {
  /** Create and connect multiple existing SectionJobList documents */
  create?: InputMaybe<Array<SectionJobListCreateInput>>
}

export type SectionJobListCreateOneInlineInput = {
  /** Create and connect one SectionJobList document */
  create?: InputMaybe<SectionJobListCreateInput>
}

export type SectionJobListCreateWithPositionInput = {
  /** Document to create */
  data: SectionJobListCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionJobListEdge = {
  __typename?: 'SectionJobListEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionJobList
}

/** Identifies documents */
export type SectionJobListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionJobListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionJobListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionJobListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  jobs_every?: InputMaybe<JobListingWhereInput>
  jobs_none?: InputMaybe<JobListingWhereInput>
  jobs_some?: InputMaybe<JobListingWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionJobListOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionJobListParent = EventPage

export type SectionJobListParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionJobListParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionJobListParentCreateManyInlineInput = {
  /** Connect multiple existing SectionJobListParent documents */
  connect?: InputMaybe<Array<SectionJobListParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionJobListParent documents */
  create?: InputMaybe<Array<SectionJobListParentCreateInput>>
}

export type SectionJobListParentCreateOneInlineInput = {
  /** Connect one existing SectionJobListParent document */
  connect?: InputMaybe<SectionJobListParentWhereUniqueInput>
  /** Create and connect one SectionJobListParent document */
  create?: InputMaybe<SectionJobListParentCreateInput>
}

export type SectionJobListParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionJobListParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionJobListParent documents */
  connect?: InputMaybe<Array<SectionJobListParentConnectInput>>
  /** Create and connect multiple SectionJobListParent documents */
  create?: InputMaybe<Array<SectionJobListParentCreateInput>>
  /** Delete multiple SectionJobListParent documents */
  delete?: InputMaybe<Array<SectionJobListParentWhereUniqueInput>>
  /** Disconnect multiple SectionJobListParent documents */
  disconnect?: InputMaybe<Array<SectionJobListParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionJobListParent documents */
  set?: InputMaybe<Array<SectionJobListParentWhereUniqueInput>>
  /** Update multiple SectionJobListParent documents */
  update?: InputMaybe<Array<SectionJobListParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionJobListParent documents */
  upsert?: InputMaybe<Array<SectionJobListParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionJobListParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionJobListParentUpdateOneInlineInput = {
  /** Connect existing SectionJobListParent document */
  connect?: InputMaybe<SectionJobListParentWhereUniqueInput>
  /** Create and connect one SectionJobListParent document */
  create?: InputMaybe<SectionJobListParentCreateInput>
  /** Delete currently connected SectionJobListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionJobListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionJobListParent document */
  update?: InputMaybe<SectionJobListParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionJobListParent document */
  upsert?: InputMaybe<SectionJobListParentUpsertWithNestedWhereUniqueInput>
}

export type SectionJobListParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionJobListParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionJobListParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionJobListParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionJobListUpdateInput = {
  jobs?: InputMaybe<JobListingUpdateManyInlineInput>
}

export type SectionJobListUpdateManyInlineInput = {
  /** Create and connect multiple SectionJobList component instances */
  create?: InputMaybe<Array<SectionJobListCreateWithPositionInput>>
  /** Delete multiple SectionJobList documents */
  delete?: InputMaybe<Array<SectionJobListWhereUniqueInput>>
  /** Update multiple SectionJobList component instances */
  update?: InputMaybe<Array<SectionJobListUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionJobList component instances */
  upsert?: InputMaybe<Array<SectionJobListUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionJobListUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type SectionJobListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionJobListUpdateManyInput
  /** Document search */
  where: SectionJobListWhereInput
}

export type SectionJobListUpdateOneInlineInput = {
  /** Create and connect one SectionJobList document */
  create?: InputMaybe<SectionJobListCreateInput>
  /** Delete currently connected SectionJobList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionJobList document */
  update?: InputMaybe<SectionJobListUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionJobList document */
  upsert?: InputMaybe<SectionJobListUpsertWithNestedWhereUniqueInput>
}

export type SectionJobListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionJobListUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionJobListWhereUniqueInput
}

export type SectionJobListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionJobListUpdateInput
  /** Unique document search */
  where: SectionJobListWhereUniqueInput
}

export type SectionJobListUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionJobListCreateInput
  /** Update document if it exists */
  update: SectionJobListUpdateInput
}

export type SectionJobListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionJobListUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionJobListWhereUniqueInput
}

export type SectionJobListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionJobListUpsertInput
  /** Unique document search */
  where: SectionJobListWhereUniqueInput
}

/** Identifies documents */
export type SectionJobListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionJobListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionJobListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionJobListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  jobs_every?: InputMaybe<JobListingWhereInput>
  jobs_none?: InputMaybe<JobListingWhereInput>
  jobs_some?: InputMaybe<JobListingWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionJobList record uniquely */
export type SectionJobListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionLivestreams = Entity & {
  __typename?: 'SectionLivestreams'
  ctaText?: Maybe<Scalars['String']['output']>
  ctaUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionLivestreams>
  /** System stage field */
  stage: Stage
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  ytEmbed: Array<YtEmbed>
}

export type SectionLivestreamsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionLivestreamsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionLivestreamsYtEmbedArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<YtEmbedOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<YtEmbedWhereInput>
}

export type SectionLivestreamsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionLivestreamsWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionLivestreamsConnection = {
  __typename?: 'SectionLivestreamsConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionLivestreamsEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionLivestreamsCreateInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionLivestreamsCreateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  ytEmbed?: InputMaybe<YtEmbedCreateManyInlineInput>
}

export type SectionLivestreamsCreateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionLivestreamsCreateLocalizationInput = {
  /** Localization input */
  data: SectionLivestreamsCreateLocalizationDataInput
  locale: Locale
}

export type SectionLivestreamsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionLivestreamsCreateLocalizationInput>>
}

export type SectionLivestreamsCreateManyInlineInput = {
  /** Create and connect multiple existing SectionLivestreams documents */
  create?: InputMaybe<Array<SectionLivestreamsCreateInput>>
}

export type SectionLivestreamsCreateOneInlineInput = {
  /** Create and connect one SectionLivestreams document */
  create?: InputMaybe<SectionLivestreamsCreateInput>
}

export type SectionLivestreamsCreateWithPositionInput = {
  /** Document to create */
  data: SectionLivestreamsCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionLivestreamsEdge = {
  __typename?: 'SectionLivestreamsEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionLivestreams
}

/** Identifies documents */
export type SectionLivestreamsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionLivestreamsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionLivestreamsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionLivestreamsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  ytEmbed_every?: InputMaybe<YtEmbedWhereInput>
  ytEmbed_none?: InputMaybe<YtEmbedWhereInput>
  ytEmbed_some?: InputMaybe<YtEmbedWhereInput>
}

export enum SectionLivestreamsOrderByInput {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionLivestreamsParent = EventPage

export type SectionLivestreamsParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionLivestreamsParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionLivestreamsParentCreateManyInlineInput = {
  /** Connect multiple existing SectionLivestreamsParent documents */
  connect?: InputMaybe<Array<SectionLivestreamsParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionLivestreamsParent documents */
  create?: InputMaybe<Array<SectionLivestreamsParentCreateInput>>
}

export type SectionLivestreamsParentCreateOneInlineInput = {
  /** Connect one existing SectionLivestreamsParent document */
  connect?: InputMaybe<SectionLivestreamsParentWhereUniqueInput>
  /** Create and connect one SectionLivestreamsParent document */
  create?: InputMaybe<SectionLivestreamsParentCreateInput>
}

export type SectionLivestreamsParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionLivestreamsParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionLivestreamsParent documents */
  connect?: InputMaybe<Array<SectionLivestreamsParentConnectInput>>
  /** Create and connect multiple SectionLivestreamsParent documents */
  create?: InputMaybe<Array<SectionLivestreamsParentCreateInput>>
  /** Delete multiple SectionLivestreamsParent documents */
  delete?: InputMaybe<Array<SectionLivestreamsParentWhereUniqueInput>>
  /** Disconnect multiple SectionLivestreamsParent documents */
  disconnect?: InputMaybe<Array<SectionLivestreamsParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionLivestreamsParent documents */
  set?: InputMaybe<Array<SectionLivestreamsParentWhereUniqueInput>>
  /** Update multiple SectionLivestreamsParent documents */
  update?: InputMaybe<Array<SectionLivestreamsParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionLivestreamsParent documents */
  upsert?: InputMaybe<Array<SectionLivestreamsParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionLivestreamsParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionLivestreamsParentUpdateOneInlineInput = {
  /** Connect existing SectionLivestreamsParent document */
  connect?: InputMaybe<SectionLivestreamsParentWhereUniqueInput>
  /** Create and connect one SectionLivestreamsParent document */
  create?: InputMaybe<SectionLivestreamsParentCreateInput>
  /** Delete currently connected SectionLivestreamsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionLivestreamsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionLivestreamsParent document */
  update?: InputMaybe<SectionLivestreamsParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionLivestreamsParent document */
  upsert?: InputMaybe<SectionLivestreamsParentUpsertWithNestedWhereUniqueInput>
}

export type SectionLivestreamsParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionLivestreamsParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionLivestreamsParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionLivestreamsParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionLivestreamsUpdateInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionLivestreamsUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  ytEmbed?: InputMaybe<YtEmbedUpdateManyInlineInput>
}

export type SectionLivestreamsUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionLivestreamsUpdateLocalizationInput = {
  data: SectionLivestreamsUpdateLocalizationDataInput
  locale: Locale
}

export type SectionLivestreamsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionLivestreamsCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionLivestreamsUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionLivestreamsUpsertLocalizationInput>>
}

export type SectionLivestreamsUpdateManyInlineInput = {
  /** Create and connect multiple SectionLivestreams component instances */
  create?: InputMaybe<Array<SectionLivestreamsCreateWithPositionInput>>
  /** Delete multiple SectionLivestreams documents */
  delete?: InputMaybe<Array<SectionLivestreamsWhereUniqueInput>>
  /** Update multiple SectionLivestreams component instances */
  update?: InputMaybe<Array<SectionLivestreamsUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionLivestreams component instances */
  upsert?: InputMaybe<Array<SectionLivestreamsUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionLivestreamsUpdateManyInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionLivestreamsUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionLivestreamsUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionLivestreamsUpdateManyLocalizationInput = {
  data: SectionLivestreamsUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionLivestreamsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionLivestreamsUpdateManyLocalizationInput>>
}

export type SectionLivestreamsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionLivestreamsUpdateManyInput
  /** Document search */
  where: SectionLivestreamsWhereInput
}

export type SectionLivestreamsUpdateOneInlineInput = {
  /** Create and connect one SectionLivestreams document */
  create?: InputMaybe<SectionLivestreamsCreateInput>
  /** Delete currently connected SectionLivestreams document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionLivestreams document */
  update?: InputMaybe<SectionLivestreamsUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionLivestreams document */
  upsert?: InputMaybe<SectionLivestreamsUpsertWithNestedWhereUniqueInput>
}

export type SectionLivestreamsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionLivestreamsUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionLivestreamsWhereUniqueInput
}

export type SectionLivestreamsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionLivestreamsUpdateInput
  /** Unique document search */
  where: SectionLivestreamsWhereUniqueInput
}

export type SectionLivestreamsUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionLivestreamsCreateInput
  /** Update document if it exists */
  update: SectionLivestreamsUpdateInput
}

export type SectionLivestreamsUpsertLocalizationInput = {
  create: SectionLivestreamsCreateLocalizationDataInput
  locale: Locale
  update: SectionLivestreamsUpdateLocalizationDataInput
}

export type SectionLivestreamsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionLivestreamsUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionLivestreamsWhereUniqueInput
}

export type SectionLivestreamsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionLivestreamsUpsertInput
  /** Unique document search */
  where: SectionLivestreamsWhereUniqueInput
}

/** Identifies documents */
export type SectionLivestreamsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionLivestreamsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionLivestreamsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionLivestreamsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  ytEmbed_every?: InputMaybe<YtEmbedWhereInput>
  ytEmbed_none?: InputMaybe<YtEmbedWhereInput>
  ytEmbed_some?: InputMaybe<YtEmbedWhereInput>
}

/** References SectionLivestreams record uniquely */
export type SectionLivestreamsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Manage the logged in user's interests */
export type SectionManageInterests = Entity & {
  __typename?: 'SectionManageInterests'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionManageInterestsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionManageInterestsWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionManageInterestsConnection = {
  __typename?: 'SectionManageInterestsConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionManageInterestsEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionManageInterestsCreateInput = {
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionManageInterestsCreateManyInlineInput = {
  /** Create and connect multiple existing SectionManageInterests documents */
  create?: InputMaybe<Array<SectionManageInterestsCreateInput>>
}

export type SectionManageInterestsCreateOneInlineInput = {
  /** Create and connect one SectionManageInterests document */
  create?: InputMaybe<SectionManageInterestsCreateInput>
}

export type SectionManageInterestsCreateWithPositionInput = {
  /** Document to create */
  data: SectionManageInterestsCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionManageInterestsEdge = {
  __typename?: 'SectionManageInterestsEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionManageInterests
}

/** Identifies documents */
export type SectionManageInterestsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionManageInterestsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionManageInterestsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionManageInterestsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionManageInterestsOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionManageInterestsParent = EventPage

export type SectionManageInterestsParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionManageInterestsParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionManageInterestsParentCreateManyInlineInput = {
  /** Connect multiple existing SectionManageInterestsParent documents */
  connect?: InputMaybe<Array<SectionManageInterestsParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionManageInterestsParent documents */
  create?: InputMaybe<Array<SectionManageInterestsParentCreateInput>>
}

export type SectionManageInterestsParentCreateOneInlineInput = {
  /** Connect one existing SectionManageInterestsParent document */
  connect?: InputMaybe<SectionManageInterestsParentWhereUniqueInput>
  /** Create and connect one SectionManageInterestsParent document */
  create?: InputMaybe<SectionManageInterestsParentCreateInput>
}

export type SectionManageInterestsParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionManageInterestsParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionManageInterestsParent documents */
  connect?: InputMaybe<Array<SectionManageInterestsParentConnectInput>>
  /** Create and connect multiple SectionManageInterestsParent documents */
  create?: InputMaybe<Array<SectionManageInterestsParentCreateInput>>
  /** Delete multiple SectionManageInterestsParent documents */
  delete?: InputMaybe<Array<SectionManageInterestsParentWhereUniqueInput>>
  /** Disconnect multiple SectionManageInterestsParent documents */
  disconnect?: InputMaybe<Array<SectionManageInterestsParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionManageInterestsParent documents */
  set?: InputMaybe<Array<SectionManageInterestsParentWhereUniqueInput>>
  /** Update multiple SectionManageInterestsParent documents */
  update?: InputMaybe<Array<SectionManageInterestsParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionManageInterestsParent documents */
  upsert?: InputMaybe<Array<SectionManageInterestsParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionManageInterestsParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionManageInterestsParentUpdateOneInlineInput = {
  /** Connect existing SectionManageInterestsParent document */
  connect?: InputMaybe<SectionManageInterestsParentWhereUniqueInput>
  /** Create and connect one SectionManageInterestsParent document */
  create?: InputMaybe<SectionManageInterestsParentCreateInput>
  /** Delete currently connected SectionManageInterestsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionManageInterestsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionManageInterestsParent document */
  update?: InputMaybe<SectionManageInterestsParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionManageInterestsParent document */
  upsert?: InputMaybe<SectionManageInterestsParentUpsertWithNestedWhereUniqueInput>
}

export type SectionManageInterestsParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionManageInterestsParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionManageInterestsParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionManageInterestsParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionManageInterestsUpdateInput = {
  /** No fields in update input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type SectionManageInterestsUpdateManyInlineInput = {
  /** Create and connect multiple SectionManageInterests component instances */
  create?: InputMaybe<Array<SectionManageInterestsCreateWithPositionInput>>
  /** Delete multiple SectionManageInterests documents */
  delete?: InputMaybe<Array<SectionManageInterestsWhereUniqueInput>>
  /** Update multiple SectionManageInterests component instances */
  update?: InputMaybe<Array<SectionManageInterestsUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionManageInterests component instances */
  upsert?: InputMaybe<Array<SectionManageInterestsUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionManageInterestsUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type SectionManageInterestsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionManageInterestsUpdateManyInput
  /** Document search */
  where: SectionManageInterestsWhereInput
}

export type SectionManageInterestsUpdateOneInlineInput = {
  /** Create and connect one SectionManageInterests document */
  create?: InputMaybe<SectionManageInterestsCreateInput>
  /** Delete currently connected SectionManageInterests document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionManageInterests document */
  update?: InputMaybe<SectionManageInterestsUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionManageInterests document */
  upsert?: InputMaybe<SectionManageInterestsUpsertWithNestedWhereUniqueInput>
}

export type SectionManageInterestsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionManageInterestsUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionManageInterestsWhereUniqueInput
}

export type SectionManageInterestsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionManageInterestsUpdateInput
  /** Unique document search */
  where: SectionManageInterestsWhereUniqueInput
}

export type SectionManageInterestsUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionManageInterestsCreateInput
  /** Update document if it exists */
  update: SectionManageInterestsUpdateInput
}

export type SectionManageInterestsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionManageInterestsUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionManageInterestsWhereUniqueInput
}

export type SectionManageInterestsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionManageInterestsUpsertInput
  /** Unique document search */
  where: SectionManageInterestsWhereUniqueInput
}

/** Identifies documents */
export type SectionManageInterestsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionManageInterestsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionManageInterestsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionManageInterestsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionManageInterests record uniquely */
export type SectionManageInterestsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Map component using OpenStreetMap to showcase markers on it. */
export type SectionMap = Entity & {
  __typename?: 'SectionMap'
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  initialZoom?: Maybe<Scalars['Int']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionMap>
  /** Default center used on the map. If not provided defaults to Hamburg Messe Halle. */
  mapCenter?: Maybe<Location>
  /** Markers displayed on the map. */
  markers: Array<MapMarker>
  /** System stage field */
  stage: Stage
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Map component using OpenStreetMap to showcase markers on it. */
export type SectionMapLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Map component using OpenStreetMap to showcase markers on it. */
export type SectionMapMarkersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<MapMarkerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MapMarkerWhereInput>
}

/** Map component using OpenStreetMap to showcase markers on it. */
export type SectionMapUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionMapConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionMapWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionMapConnection = {
  __typename?: 'SectionMapConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionMapEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionMapCreateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  initialZoom?: InputMaybe<Scalars['Int']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionMapCreateLocalizationsInput>
  mapCenter?: InputMaybe<LocationInput>
  markers: MapMarkerCreateManyInlineInput
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionMapCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionMapCreateLocalizationInput = {
  /** Localization input */
  data: SectionMapCreateLocalizationDataInput
  locale: Locale
}

export type SectionMapCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionMapCreateLocalizationInput>>
}

export type SectionMapCreateManyInlineInput = {
  /** Create and connect multiple existing SectionMap documents */
  create?: InputMaybe<Array<SectionMapCreateInput>>
}

export type SectionMapCreateOneInlineInput = {
  /** Create and connect one SectionMap document */
  create?: InputMaybe<SectionMapCreateInput>
}

export type SectionMapCreateWithPositionInput = {
  /** Document to create */
  data: SectionMapCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionMapEdge = {
  __typename?: 'SectionMapEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionMap
}

/** Identifies documents */
export type SectionMapManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionMapWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionMapWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionMapWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  initialZoom?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  initialZoom_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  initialZoom_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  initialZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  initialZoom_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  initialZoom_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  initialZoom_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  initialZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  markers_every?: InputMaybe<MapMarkerWhereInput>
  markers_none?: InputMaybe<MapMarkerWhereInput>
  markers_some?: InputMaybe<MapMarkerWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionMapOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InitialZoomAsc = 'initialZoom_ASC',
  InitialZoomDesc = 'initialZoom_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionMapParent = EventPage

export type SectionMapParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionMapParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionMapParentCreateManyInlineInput = {
  /** Connect multiple existing SectionMapParent documents */
  connect?: InputMaybe<Array<SectionMapParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionMapParent documents */
  create?: InputMaybe<Array<SectionMapParentCreateInput>>
}

export type SectionMapParentCreateOneInlineInput = {
  /** Connect one existing SectionMapParent document */
  connect?: InputMaybe<SectionMapParentWhereUniqueInput>
  /** Create and connect one SectionMapParent document */
  create?: InputMaybe<SectionMapParentCreateInput>
}

export type SectionMapParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionMapParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionMapParent documents */
  connect?: InputMaybe<Array<SectionMapParentConnectInput>>
  /** Create and connect multiple SectionMapParent documents */
  create?: InputMaybe<Array<SectionMapParentCreateInput>>
  /** Delete multiple SectionMapParent documents */
  delete?: InputMaybe<Array<SectionMapParentWhereUniqueInput>>
  /** Disconnect multiple SectionMapParent documents */
  disconnect?: InputMaybe<Array<SectionMapParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionMapParent documents */
  set?: InputMaybe<Array<SectionMapParentWhereUniqueInput>>
  /** Update multiple SectionMapParent documents */
  update?: InputMaybe<Array<SectionMapParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionMapParent documents */
  upsert?: InputMaybe<Array<SectionMapParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionMapParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionMapParentUpdateOneInlineInput = {
  /** Connect existing SectionMapParent document */
  connect?: InputMaybe<SectionMapParentWhereUniqueInput>
  /** Create and connect one SectionMapParent document */
  create?: InputMaybe<SectionMapParentCreateInput>
  /** Delete currently connected SectionMapParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionMapParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionMapParent document */
  update?: InputMaybe<SectionMapParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionMapParent document */
  upsert?: InputMaybe<SectionMapParentUpsertWithNestedWhereUniqueInput>
}

export type SectionMapParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionMapParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionMapParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionMapParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionMapUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  initialZoom?: InputMaybe<Scalars['Int']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionMapUpdateLocalizationsInput>
  mapCenter?: InputMaybe<LocationInput>
  markers?: InputMaybe<MapMarkerUpdateManyInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMapUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMapUpdateLocalizationInput = {
  data: SectionMapUpdateLocalizationDataInput
  locale: Locale
}

export type SectionMapUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionMapCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionMapUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionMapUpsertLocalizationInput>>
}

export type SectionMapUpdateManyInlineInput = {
  /** Create and connect multiple SectionMap component instances */
  create?: InputMaybe<Array<SectionMapCreateWithPositionInput>>
  /** Delete multiple SectionMap documents */
  delete?: InputMaybe<Array<SectionMapWhereUniqueInput>>
  /** Update multiple SectionMap component instances */
  update?: InputMaybe<Array<SectionMapUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionMap component instances */
  upsert?: InputMaybe<Array<SectionMapUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionMapUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  initialZoom?: InputMaybe<Scalars['Int']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionMapUpdateManyLocalizationsInput>
  mapCenter?: InputMaybe<LocationInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMapUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMapUpdateManyLocalizationInput = {
  data: SectionMapUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionMapUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionMapUpdateManyLocalizationInput>>
}

export type SectionMapUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionMapUpdateManyInput
  /** Document search */
  where: SectionMapWhereInput
}

export type SectionMapUpdateOneInlineInput = {
  /** Create and connect one SectionMap document */
  create?: InputMaybe<SectionMapCreateInput>
  /** Delete currently connected SectionMap document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionMap document */
  update?: InputMaybe<SectionMapUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionMap document */
  upsert?: InputMaybe<SectionMapUpsertWithNestedWhereUniqueInput>
}

export type SectionMapUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionMapUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionMapWhereUniqueInput
}

export type SectionMapUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionMapUpdateInput
  /** Unique document search */
  where: SectionMapWhereUniqueInput
}

export type SectionMapUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionMapCreateInput
  /** Update document if it exists */
  update: SectionMapUpdateInput
}

export type SectionMapUpsertLocalizationInput = {
  create: SectionMapCreateLocalizationDataInput
  locale: Locale
  update: SectionMapUpdateLocalizationDataInput
}

export type SectionMapUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionMapUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionMapWhereUniqueInput
}

export type SectionMapUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionMapUpsertInput
  /** Unique document search */
  where: SectionMapWhereUniqueInput
}

/** Identifies documents */
export type SectionMapWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionMapWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionMapWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionMapWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  initialZoom?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  initialZoom_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  initialZoom_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  initialZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  initialZoom_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  initialZoom_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  initialZoom_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  initialZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  markers_every?: InputMaybe<MapMarkerWhereInput>
  markers_none?: InputMaybe<MapMarkerWhereInput>
  markers_some?: InputMaybe<MapMarkerWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionMap record uniquely */
export type SectionMapWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitors = Entity & {
  __typename?: 'SectionMyomrExhibitors'
  /** Call to action element */
  cta?: Maybe<CallToAction>
  description: Scalars['String']['output']
  enableBookmarking?: Maybe<Scalars['Boolean']['output']>
  /** Enables the journey filter for the myomr exhibitors section. Off by default. */
  enableJourneyFilter?: Maybe<Scalars['Boolean']['output']>
  /** The event whose exhibitors this section shows, e.g. omr27. Leave empty to use the event of the festival URL the page is shown on. The selected exhibitor list must belong to the same event, otherwise nothing is shown in filter mode. Bookmarks follow this event as well. */
  event?: Maybe<Event>
  /** If value set, only those exhibitors will be shown that has corresponding event type associated to them. */
  eventType?: Maybe<SpeakerEventTypes>
  /** Maximum exhibitors shown initially on desktop. */
  exhibitorsLimitDesktop: Scalars['Int']['output']
  /** Maximum exhibitors shown initially on mobile. */
  exhibitorsLimitMobile: Scalars['Int']['output']
  hideDetailPages?: Maybe<Scalars['Boolean']['output']>
  hideFilters?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Applies interest filter for the incoming data. */
  interestFilter?: Maybe<Interest>
  /** Select interests to filter exhibitors. Multiple selection supported. */
  interestsFilter: Array<Interest>
  /** This option will set if provided ordered list will be used to filter or to sort the result set. */
  listOption: ResultCreationOptions
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionMyomrExhibitors>
  /** Selected custom sorting model for the exhibitors. */
  order?: Maybe<ExhibitorListOrder>
  premiumOnly?: Maybe<Scalars['Boolean']['output']>
  /** Randomizes the order in every 4 hours.  */
  randomizeOrder?: Maybe<Scalars['Boolean']['output']>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsInterestFilterArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsInterestsFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestWhereInput>
}

/** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsOrderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionMyomrExhibitorsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionMyomrExhibitorsWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionMyomrExhibitorsConnection = {
  __typename?: 'SectionMyomrExhibitorsConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionMyomrExhibitorsEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionMyomrExhibitorsCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  event?: InputMaybe<EventCreateOneInlineInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  exhibitorsLimitDesktop: Scalars['Int']['input']
  exhibitorsLimitMobile: Scalars['Int']['input']
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  interestFilter?: InputMaybe<InterestCreateOneInlineInput>
  interestsFilter?: InputMaybe<InterestCreateManyInlineInput>
  listOption: ResultCreationOptions
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionMyomrExhibitorsCreateLocalizationsInput>
  order?: InputMaybe<ExhibitorListOrderCreateOneInlineInput>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionMyomrExhibitorsCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionMyomrExhibitorsCreateLocalizationInput = {
  /** Localization input */
  data: SectionMyomrExhibitorsCreateLocalizationDataInput
  locale: Locale
}

export type SectionMyomrExhibitorsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionMyomrExhibitorsCreateLocalizationInput>>
}

export type SectionMyomrExhibitorsCreateManyInlineInput = {
  /** Create and connect multiple existing SectionMyomrExhibitors documents */
  create?: InputMaybe<Array<SectionMyomrExhibitorsCreateInput>>
}

export type SectionMyomrExhibitorsCreateOneInlineInput = {
  /** Create and connect one SectionMyomrExhibitors document */
  create?: InputMaybe<SectionMyomrExhibitorsCreateInput>
}

export type SectionMyomrExhibitorsCreateWithPositionInput = {
  /** Document to create */
  data: SectionMyomrExhibitorsCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionMyomrExhibitorsEdge = {
  __typename?: 'SectionMyomrExhibitorsEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionMyomrExhibitors
}

/** Section showing a sorted list of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsList = Entity & {
  __typename?: 'SectionMyomrExhibitorsList'
  description: Scalars['String']['output']
  event?: Maybe<Event>
  hideDetailPages?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionMyomrExhibitorsList>
  premiumOnly?: Maybe<Scalars['Boolean']['output']>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section showing a sorted list of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsListEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a sorted list of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing a sorted list of Exhibitors from MyOMR datasource. */
export type SectionMyomrExhibitorsListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionMyomrExhibitorsListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionMyomrExhibitorsListWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionMyomrExhibitorsListConnection = {
  __typename?: 'SectionMyomrExhibitorsListConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionMyomrExhibitorsListEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionMyomrExhibitorsListCreateInput = {
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  event?: InputMaybe<EventCreateOneInlineInput>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionMyomrExhibitorsListCreateLocalizationsInput>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionMyomrExhibitorsListCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionMyomrExhibitorsListCreateLocalizationInput = {
  /** Localization input */
  data: SectionMyomrExhibitorsListCreateLocalizationDataInput
  locale: Locale
}

export type SectionMyomrExhibitorsListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionMyomrExhibitorsListCreateLocalizationInput>>
}

export type SectionMyomrExhibitorsListCreateManyInlineInput = {
  /** Create and connect multiple existing SectionMyomrExhibitorsList documents */
  create?: InputMaybe<Array<SectionMyomrExhibitorsListCreateInput>>
}

export type SectionMyomrExhibitorsListCreateOneInlineInput = {
  /** Create and connect one SectionMyomrExhibitorsList document */
  create?: InputMaybe<SectionMyomrExhibitorsListCreateInput>
}

export type SectionMyomrExhibitorsListCreateWithPositionInput = {
  /** Document to create */
  data: SectionMyomrExhibitorsListCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionMyomrExhibitorsListEdge = {
  __typename?: 'SectionMyomrExhibitorsListEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionMyomrExhibitorsList
}

/** Identifies documents */
export type SectionMyomrExhibitorsListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionMyomrExhibitorsListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionMyomrExhibitorsListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionMyomrExhibitorsListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  event?: InputMaybe<EventWhereInput>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideDetailPages_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  premiumOnly_not?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionMyomrExhibitorsListOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HideDetailPagesAsc = 'hideDetailPages_ASC',
  HideDetailPagesDesc = 'hideDetailPages_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PremiumOnlyAsc = 'premiumOnly_ASC',
  PremiumOnlyDesc = 'premiumOnly_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionMyomrExhibitorsListParent = EventPage

export type SectionMyomrExhibitorsListParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionMyomrExhibitorsListParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionMyomrExhibitorsListParentCreateManyInlineInput = {
  /** Connect multiple existing SectionMyomrExhibitorsListParent documents */
  connect?: InputMaybe<Array<SectionMyomrExhibitorsListParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionMyomrExhibitorsListParent documents */
  create?: InputMaybe<Array<SectionMyomrExhibitorsListParentCreateInput>>
}

export type SectionMyomrExhibitorsListParentCreateOneInlineInput = {
  /** Connect one existing SectionMyomrExhibitorsListParent document */
  connect?: InputMaybe<SectionMyomrExhibitorsListParentWhereUniqueInput>
  /** Create and connect one SectionMyomrExhibitorsListParent document */
  create?: InputMaybe<SectionMyomrExhibitorsListParentCreateInput>
}

export type SectionMyomrExhibitorsListParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionMyomrExhibitorsListParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionMyomrExhibitorsListParent documents */
  connect?: InputMaybe<Array<SectionMyomrExhibitorsListParentConnectInput>>
  /** Create and connect multiple SectionMyomrExhibitorsListParent documents */
  create?: InputMaybe<Array<SectionMyomrExhibitorsListParentCreateInput>>
  /** Delete multiple SectionMyomrExhibitorsListParent documents */
  delete?: InputMaybe<Array<SectionMyomrExhibitorsListParentWhereUniqueInput>>
  /** Disconnect multiple SectionMyomrExhibitorsListParent documents */
  disconnect?: InputMaybe<Array<SectionMyomrExhibitorsListParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionMyomrExhibitorsListParent documents */
  set?: InputMaybe<Array<SectionMyomrExhibitorsListParentWhereUniqueInput>>
  /** Update multiple SectionMyomrExhibitorsListParent documents */
  update?: InputMaybe<Array<SectionMyomrExhibitorsListParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionMyomrExhibitorsListParent documents */
  upsert?: InputMaybe<Array<SectionMyomrExhibitorsListParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionMyomrExhibitorsListParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionMyomrExhibitorsListParentUpdateOneInlineInput = {
  /** Connect existing SectionMyomrExhibitorsListParent document */
  connect?: InputMaybe<SectionMyomrExhibitorsListParentWhereUniqueInput>
  /** Create and connect one SectionMyomrExhibitorsListParent document */
  create?: InputMaybe<SectionMyomrExhibitorsListParentCreateInput>
  /** Delete currently connected SectionMyomrExhibitorsListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionMyomrExhibitorsListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionMyomrExhibitorsListParent document */
  update?: InputMaybe<SectionMyomrExhibitorsListParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionMyomrExhibitorsListParent document */
  upsert?: InputMaybe<SectionMyomrExhibitorsListParentUpsertWithNestedWhereUniqueInput>
}

export type SectionMyomrExhibitorsListParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionMyomrExhibitorsListParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionMyomrExhibitorsListParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionMyomrExhibitorsListParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionMyomrExhibitorsListUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  event?: InputMaybe<EventUpdateOneInlineInput>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionMyomrExhibitorsListUpdateLocalizationsInput>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMyomrExhibitorsListUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMyomrExhibitorsListUpdateLocalizationInput = {
  data: SectionMyomrExhibitorsListUpdateLocalizationDataInput
  locale: Locale
}

export type SectionMyomrExhibitorsListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionMyomrExhibitorsListCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionMyomrExhibitorsListUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionMyomrExhibitorsListUpsertLocalizationInput>>
}

export type SectionMyomrExhibitorsListUpdateManyInlineInput = {
  /** Create and connect multiple SectionMyomrExhibitorsList component instances */
  create?: InputMaybe<Array<SectionMyomrExhibitorsListCreateWithPositionInput>>
  /** Delete multiple SectionMyomrExhibitorsList documents */
  delete?: InputMaybe<Array<SectionMyomrExhibitorsListWhereUniqueInput>>
  /** Update multiple SectionMyomrExhibitorsList component instances */
  update?: InputMaybe<Array<SectionMyomrExhibitorsListUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionMyomrExhibitorsList component instances */
  upsert?: InputMaybe<Array<SectionMyomrExhibitorsListUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionMyomrExhibitorsListUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionMyomrExhibitorsListUpdateManyLocalizationsInput>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMyomrExhibitorsListUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMyomrExhibitorsListUpdateManyLocalizationInput = {
  data: SectionMyomrExhibitorsListUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionMyomrExhibitorsListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionMyomrExhibitorsListUpdateManyLocalizationInput>>
}

export type SectionMyomrExhibitorsListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionMyomrExhibitorsListUpdateManyInput
  /** Document search */
  where: SectionMyomrExhibitorsListWhereInput
}

export type SectionMyomrExhibitorsListUpdateOneInlineInput = {
  /** Create and connect one SectionMyomrExhibitorsList document */
  create?: InputMaybe<SectionMyomrExhibitorsListCreateInput>
  /** Delete currently connected SectionMyomrExhibitorsList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionMyomrExhibitorsList document */
  update?: InputMaybe<SectionMyomrExhibitorsListUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionMyomrExhibitorsList document */
  upsert?: InputMaybe<SectionMyomrExhibitorsListUpsertWithNestedWhereUniqueInput>
}

export type SectionMyomrExhibitorsListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionMyomrExhibitorsListUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionMyomrExhibitorsListWhereUniqueInput
}

export type SectionMyomrExhibitorsListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionMyomrExhibitorsListUpdateInput
  /** Unique document search */
  where: SectionMyomrExhibitorsListWhereUniqueInput
}

export type SectionMyomrExhibitorsListUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionMyomrExhibitorsListCreateInput
  /** Update document if it exists */
  update: SectionMyomrExhibitorsListUpdateInput
}

export type SectionMyomrExhibitorsListUpsertLocalizationInput = {
  create: SectionMyomrExhibitorsListCreateLocalizationDataInput
  locale: Locale
  update: SectionMyomrExhibitorsListUpdateLocalizationDataInput
}

export type SectionMyomrExhibitorsListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionMyomrExhibitorsListUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionMyomrExhibitorsListWhereUniqueInput
}

export type SectionMyomrExhibitorsListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionMyomrExhibitorsListUpsertInput
  /** Unique document search */
  where: SectionMyomrExhibitorsListWhereUniqueInput
}

/** Identifies documents */
export type SectionMyomrExhibitorsListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionMyomrExhibitorsListWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionMyomrExhibitorsListWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionMyomrExhibitorsListWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  event?: InputMaybe<EventWhereInput>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideDetailPages_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  premiumOnly_not?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionMyomrExhibitorsList record uniquely */
export type SectionMyomrExhibitorsListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Identifies documents */
export type SectionMyomrExhibitorsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionMyomrExhibitorsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionMyomrExhibitorsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionMyomrExhibitorsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableBookmarking_not?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableJourneyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  event?: InputMaybe<EventWhereInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  /** All values that are contained in given list. */
  eventType_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  /** Any other value that exists and is not equal to the given value. */
  eventType_not?: InputMaybe<SpeakerEventTypes>
  /** All values that are not contained in given list. */
  eventType_not_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  exhibitorsLimitDesktop?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  exhibitorsLimitDesktop_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  exhibitorsLimitDesktop_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  exhibitorsLimitDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  exhibitorsLimitDesktop_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  exhibitorsLimitDesktop_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  exhibitorsLimitDesktop_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  exhibitorsLimitDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  exhibitorsLimitMobile?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  exhibitorsLimitMobile_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  exhibitorsLimitMobile_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  exhibitorsLimitMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  exhibitorsLimitMobile_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  exhibitorsLimitMobile_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  exhibitorsLimitMobile_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  exhibitorsLimitMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideDetailPages_not?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideFilters_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interestFilter?: InputMaybe<InterestWhereInput>
  interestsFilter_every?: InputMaybe<InterestWhereInput>
  interestsFilter_none?: InputMaybe<InterestWhereInput>
  interestsFilter_some?: InputMaybe<InterestWhereInput>
  listOption?: InputMaybe<ResultCreationOptions>
  /** All values that are contained in given list. */
  listOption_in?: InputMaybe<Array<InputMaybe<ResultCreationOptions>>>
  /** Any other value that exists and is not equal to the given value. */
  listOption_not?: InputMaybe<ResultCreationOptions>
  /** All values that are not contained in given list. */
  listOption_not_in?: InputMaybe<Array<InputMaybe<ResultCreationOptions>>>
  order?: InputMaybe<ExhibitorListOrderWhereInput>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  premiumOnly_not?: InputMaybe<Scalars['Boolean']['input']>
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  randomizeOrder_not?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionMyomrExhibitorsOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EnableBookmarkingAsc = 'enableBookmarking_ASC',
  EnableBookmarkingDesc = 'enableBookmarking_DESC',
  EnableJourneyFilterAsc = 'enableJourneyFilter_ASC',
  EnableJourneyFilterDesc = 'enableJourneyFilter_DESC',
  EventTypeAsc = 'eventType_ASC',
  EventTypeDesc = 'eventType_DESC',
  ExhibitorsLimitDesktopAsc = 'exhibitorsLimitDesktop_ASC',
  ExhibitorsLimitDesktopDesc = 'exhibitorsLimitDesktop_DESC',
  ExhibitorsLimitMobileAsc = 'exhibitorsLimitMobile_ASC',
  ExhibitorsLimitMobileDesc = 'exhibitorsLimitMobile_DESC',
  HideDetailPagesAsc = 'hideDetailPages_ASC',
  HideDetailPagesDesc = 'hideDetailPages_DESC',
  HideFiltersAsc = 'hideFilters_ASC',
  HideFiltersDesc = 'hideFilters_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ListOptionAsc = 'listOption_ASC',
  ListOptionDesc = 'listOption_DESC',
  PremiumOnlyAsc = 'premiumOnly_ASC',
  PremiumOnlyDesc = 'premiumOnly_DESC',
  RandomizeOrderAsc = 'randomizeOrder_ASC',
  RandomizeOrderDesc = 'randomizeOrder_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionMyomrExhibitorsParent = EventPage

export type SectionMyomrExhibitorsParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionMyomrExhibitorsParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionMyomrExhibitorsParentCreateManyInlineInput = {
  /** Connect multiple existing SectionMyomrExhibitorsParent documents */
  connect?: InputMaybe<Array<SectionMyomrExhibitorsParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionMyomrExhibitorsParent documents */
  create?: InputMaybe<Array<SectionMyomrExhibitorsParentCreateInput>>
}

export type SectionMyomrExhibitorsParentCreateOneInlineInput = {
  /** Connect one existing SectionMyomrExhibitorsParent document */
  connect?: InputMaybe<SectionMyomrExhibitorsParentWhereUniqueInput>
  /** Create and connect one SectionMyomrExhibitorsParent document */
  create?: InputMaybe<SectionMyomrExhibitorsParentCreateInput>
}

export type SectionMyomrExhibitorsParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionMyomrExhibitorsParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionMyomrExhibitorsParent documents */
  connect?: InputMaybe<Array<SectionMyomrExhibitorsParentConnectInput>>
  /** Create and connect multiple SectionMyomrExhibitorsParent documents */
  create?: InputMaybe<Array<SectionMyomrExhibitorsParentCreateInput>>
  /** Delete multiple SectionMyomrExhibitorsParent documents */
  delete?: InputMaybe<Array<SectionMyomrExhibitorsParentWhereUniqueInput>>
  /** Disconnect multiple SectionMyomrExhibitorsParent documents */
  disconnect?: InputMaybe<Array<SectionMyomrExhibitorsParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionMyomrExhibitorsParent documents */
  set?: InputMaybe<Array<SectionMyomrExhibitorsParentWhereUniqueInput>>
  /** Update multiple SectionMyomrExhibitorsParent documents */
  update?: InputMaybe<Array<SectionMyomrExhibitorsParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionMyomrExhibitorsParent documents */
  upsert?: InputMaybe<Array<SectionMyomrExhibitorsParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionMyomrExhibitorsParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionMyomrExhibitorsParentUpdateOneInlineInput = {
  /** Connect existing SectionMyomrExhibitorsParent document */
  connect?: InputMaybe<SectionMyomrExhibitorsParentWhereUniqueInput>
  /** Create and connect one SectionMyomrExhibitorsParent document */
  create?: InputMaybe<SectionMyomrExhibitorsParentCreateInput>
  /** Delete currently connected SectionMyomrExhibitorsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionMyomrExhibitorsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionMyomrExhibitorsParent document */
  update?: InputMaybe<SectionMyomrExhibitorsParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionMyomrExhibitorsParent document */
  upsert?: InputMaybe<SectionMyomrExhibitorsParentUpsertWithNestedWhereUniqueInput>
}

export type SectionMyomrExhibitorsParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionMyomrExhibitorsParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionMyomrExhibitorsParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionMyomrExhibitorsParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionMyomrExhibitorsUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  event?: InputMaybe<EventUpdateOneInlineInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  exhibitorsLimitDesktop?: InputMaybe<Scalars['Int']['input']>
  exhibitorsLimitMobile?: InputMaybe<Scalars['Int']['input']>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  interestFilter?: InputMaybe<InterestUpdateOneInlineInput>
  interestsFilter?: InputMaybe<InterestUpdateManyInlineInput>
  listOption?: InputMaybe<ResultCreationOptions>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionMyomrExhibitorsUpdateLocalizationsInput>
  order?: InputMaybe<ExhibitorListOrderUpdateOneInlineInput>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMyomrExhibitorsUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMyomrExhibitorsUpdateLocalizationInput = {
  data: SectionMyomrExhibitorsUpdateLocalizationDataInput
  locale: Locale
}

export type SectionMyomrExhibitorsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionMyomrExhibitorsCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionMyomrExhibitorsUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionMyomrExhibitorsUpsertLocalizationInput>>
}

export type SectionMyomrExhibitorsUpdateManyInlineInput = {
  /** Create and connect multiple SectionMyomrExhibitors component instances */
  create?: InputMaybe<Array<SectionMyomrExhibitorsCreateWithPositionInput>>
  /** Delete multiple SectionMyomrExhibitors documents */
  delete?: InputMaybe<Array<SectionMyomrExhibitorsWhereUniqueInput>>
  /** Update multiple SectionMyomrExhibitors component instances */
  update?: InputMaybe<Array<SectionMyomrExhibitorsUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionMyomrExhibitors component instances */
  upsert?: InputMaybe<Array<SectionMyomrExhibitorsUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionMyomrExhibitorsUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  eventType?: InputMaybe<SpeakerEventTypes>
  exhibitorsLimitDesktop?: InputMaybe<Scalars['Int']['input']>
  exhibitorsLimitMobile?: InputMaybe<Scalars['Int']['input']>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  listOption?: InputMaybe<ResultCreationOptions>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionMyomrExhibitorsUpdateManyLocalizationsInput>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMyomrExhibitorsUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionMyomrExhibitorsUpdateManyLocalizationInput = {
  data: SectionMyomrExhibitorsUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionMyomrExhibitorsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionMyomrExhibitorsUpdateManyLocalizationInput>>
}

export type SectionMyomrExhibitorsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionMyomrExhibitorsUpdateManyInput
  /** Document search */
  where: SectionMyomrExhibitorsWhereInput
}

export type SectionMyomrExhibitorsUpdateOneInlineInput = {
  /** Create and connect one SectionMyomrExhibitors document */
  create?: InputMaybe<SectionMyomrExhibitorsCreateInput>
  /** Delete currently connected SectionMyomrExhibitors document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionMyomrExhibitors document */
  update?: InputMaybe<SectionMyomrExhibitorsUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionMyomrExhibitors document */
  upsert?: InputMaybe<SectionMyomrExhibitorsUpsertWithNestedWhereUniqueInput>
}

export type SectionMyomrExhibitorsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionMyomrExhibitorsUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionMyomrExhibitorsWhereUniqueInput
}

export type SectionMyomrExhibitorsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionMyomrExhibitorsUpdateInput
  /** Unique document search */
  where: SectionMyomrExhibitorsWhereUniqueInput
}

export type SectionMyomrExhibitorsUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionMyomrExhibitorsCreateInput
  /** Update document if it exists */
  update: SectionMyomrExhibitorsUpdateInput
}

export type SectionMyomrExhibitorsUpsertLocalizationInput = {
  create: SectionMyomrExhibitorsCreateLocalizationDataInput
  locale: Locale
  update: SectionMyomrExhibitorsUpdateLocalizationDataInput
}

export type SectionMyomrExhibitorsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionMyomrExhibitorsUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionMyomrExhibitorsWhereUniqueInput
}

export type SectionMyomrExhibitorsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionMyomrExhibitorsUpsertInput
  /** Unique document search */
  where: SectionMyomrExhibitorsWhereUniqueInput
}

/** Identifies documents */
export type SectionMyomrExhibitorsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionMyomrExhibitorsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionMyomrExhibitorsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionMyomrExhibitorsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableBookmarking_not?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableJourneyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  event?: InputMaybe<EventWhereInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  /** All values that are contained in given list. */
  eventType_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  /** Any other value that exists and is not equal to the given value. */
  eventType_not?: InputMaybe<SpeakerEventTypes>
  /** All values that are not contained in given list. */
  eventType_not_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  exhibitorsLimitDesktop?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  exhibitorsLimitDesktop_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  exhibitorsLimitDesktop_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  exhibitorsLimitDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  exhibitorsLimitDesktop_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  exhibitorsLimitDesktop_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  exhibitorsLimitDesktop_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  exhibitorsLimitDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  exhibitorsLimitMobile?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  exhibitorsLimitMobile_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  exhibitorsLimitMobile_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  exhibitorsLimitMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  exhibitorsLimitMobile_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  exhibitorsLimitMobile_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  exhibitorsLimitMobile_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  exhibitorsLimitMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideDetailPages_not?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideFilters_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interestFilter?: InputMaybe<InterestWhereInput>
  interestsFilter_every?: InputMaybe<InterestWhereInput>
  interestsFilter_none?: InputMaybe<InterestWhereInput>
  interestsFilter_some?: InputMaybe<InterestWhereInput>
  listOption?: InputMaybe<ResultCreationOptions>
  /** All values that are contained in given list. */
  listOption_in?: InputMaybe<Array<InputMaybe<ResultCreationOptions>>>
  /** Any other value that exists and is not equal to the given value. */
  listOption_not?: InputMaybe<ResultCreationOptions>
  /** All values that are not contained in given list. */
  listOption_not_in?: InputMaybe<Array<InputMaybe<ResultCreationOptions>>>
  order?: InputMaybe<ExhibitorListOrderWhereInput>
  premiumOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  premiumOnly_not?: InputMaybe<Scalars['Boolean']['input']>
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  randomizeOrder_not?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionMyomrExhibitors record uniquely */
export type SectionMyomrExhibitorsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section showing newsletter subscription form. */
export type SectionNewsletter = Entity & {
  __typename?: 'SectionNewsletter'
  audience?: Maybe<Scalars['String']['output']>
  cta?: Maybe<CallToAction>
  description: Scalars['String']['output']
  disclaimer?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  linkTarget?: Maybe<Scalars['String']['output']>
  linkText?: Maybe<Scalars['String']['output']>
  linkUrl?: Maybe<Scalars['String']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionNewsletter>
  /** System stage field */
  stage: Stage
  successMessage?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section showing newsletter subscription form. */
export type SectionNewsletterCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing newsletter subscription form. */
export type SectionNewsletterLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing newsletter subscription form. */
export type SectionNewsletterUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Section showing newsletter audiences where user can subscribe. */
export type SectionNewsletterAudience = Entity & {
  __typename?: 'SectionNewsletterAudience'
  audiences: Array<NewsletterAudience>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section showing newsletter audiences where user can subscribe. */
export type SectionNewsletterAudienceAudiencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<NewsletterAudienceOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<NewsletterAudienceWhereInput>
}

export type SectionNewsletterAudienceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionNewsletterAudienceWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionNewsletterAudienceConnection = {
  __typename?: 'SectionNewsletterAudienceConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionNewsletterAudienceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionNewsletterAudienceCreateInput = {
  audiences?: InputMaybe<NewsletterAudienceCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionNewsletterAudienceCreateManyInlineInput = {
  /** Create and connect multiple existing SectionNewsletterAudience documents */
  create?: InputMaybe<Array<SectionNewsletterAudienceCreateInput>>
}

export type SectionNewsletterAudienceCreateOneInlineInput = {
  /** Create and connect one SectionNewsletterAudience document */
  create?: InputMaybe<SectionNewsletterAudienceCreateInput>
}

export type SectionNewsletterAudienceCreateWithPositionInput = {
  /** Document to create */
  data: SectionNewsletterAudienceCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionNewsletterAudienceEdge = {
  __typename?: 'SectionNewsletterAudienceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionNewsletterAudience
}

/** Identifies documents */
export type SectionNewsletterAudienceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionNewsletterAudienceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionNewsletterAudienceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionNewsletterAudienceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audiences_every?: InputMaybe<NewsletterAudienceWhereInput>
  audiences_none?: InputMaybe<NewsletterAudienceWhereInput>
  audiences_some?: InputMaybe<NewsletterAudienceWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionNewsletterAudienceOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionNewsletterAudienceParent = LandingPage

export type SectionNewsletterAudienceParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionNewsletterAudienceParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionNewsletterAudienceParentCreateManyInlineInput = {
  /** Connect multiple existing SectionNewsletterAudienceParent documents */
  connect?: InputMaybe<Array<SectionNewsletterAudienceParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionNewsletterAudienceParent documents */
  create?: InputMaybe<Array<SectionNewsletterAudienceParentCreateInput>>
}

export type SectionNewsletterAudienceParentCreateOneInlineInput = {
  /** Connect one existing SectionNewsletterAudienceParent document */
  connect?: InputMaybe<SectionNewsletterAudienceParentWhereUniqueInput>
  /** Create and connect one SectionNewsletterAudienceParent document */
  create?: InputMaybe<SectionNewsletterAudienceParentCreateInput>
}

export type SectionNewsletterAudienceParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionNewsletterAudienceParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionNewsletterAudienceParent documents */
  connect?: InputMaybe<Array<SectionNewsletterAudienceParentConnectInput>>
  /** Create and connect multiple SectionNewsletterAudienceParent documents */
  create?: InputMaybe<Array<SectionNewsletterAudienceParentCreateInput>>
  /** Delete multiple SectionNewsletterAudienceParent documents */
  delete?: InputMaybe<Array<SectionNewsletterAudienceParentWhereUniqueInput>>
  /** Disconnect multiple SectionNewsletterAudienceParent documents */
  disconnect?: InputMaybe<Array<SectionNewsletterAudienceParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionNewsletterAudienceParent documents */
  set?: InputMaybe<Array<SectionNewsletterAudienceParentWhereUniqueInput>>
  /** Update multiple SectionNewsletterAudienceParent documents */
  update?: InputMaybe<Array<SectionNewsletterAudienceParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionNewsletterAudienceParent documents */
  upsert?: InputMaybe<Array<SectionNewsletterAudienceParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionNewsletterAudienceParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionNewsletterAudienceParentUpdateOneInlineInput = {
  /** Connect existing SectionNewsletterAudienceParent document */
  connect?: InputMaybe<SectionNewsletterAudienceParentWhereUniqueInput>
  /** Create and connect one SectionNewsletterAudienceParent document */
  create?: InputMaybe<SectionNewsletterAudienceParentCreateInput>
  /** Delete currently connected SectionNewsletterAudienceParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionNewsletterAudienceParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionNewsletterAudienceParent document */
  update?: InputMaybe<SectionNewsletterAudienceParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionNewsletterAudienceParent document */
  upsert?: InputMaybe<SectionNewsletterAudienceParentUpsertWithNestedWhereUniqueInput>
}

export type SectionNewsletterAudienceParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionNewsletterAudienceParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionNewsletterAudienceParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionNewsletterAudienceParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionNewsletterAudienceUpdateInput = {
  audiences?: InputMaybe<NewsletterAudienceUpdateManyInlineInput>
}

export type SectionNewsletterAudienceUpdateManyInlineInput = {
  /** Create and connect multiple SectionNewsletterAudience component instances */
  create?: InputMaybe<Array<SectionNewsletterAudienceCreateWithPositionInput>>
  /** Delete multiple SectionNewsletterAudience documents */
  delete?: InputMaybe<Array<SectionNewsletterAudienceWhereUniqueInput>>
  /** Update multiple SectionNewsletterAudience component instances */
  update?: InputMaybe<Array<SectionNewsletterAudienceUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionNewsletterAudience component instances */
  upsert?: InputMaybe<Array<SectionNewsletterAudienceUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionNewsletterAudienceUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type SectionNewsletterAudienceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionNewsletterAudienceUpdateManyInput
  /** Document search */
  where: SectionNewsletterAudienceWhereInput
}

export type SectionNewsletterAudienceUpdateOneInlineInput = {
  /** Create and connect one SectionNewsletterAudience document */
  create?: InputMaybe<SectionNewsletterAudienceCreateInput>
  /** Delete currently connected SectionNewsletterAudience document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionNewsletterAudience document */
  update?: InputMaybe<SectionNewsletterAudienceUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionNewsletterAudience document */
  upsert?: InputMaybe<SectionNewsletterAudienceUpsertWithNestedWhereUniqueInput>
}

export type SectionNewsletterAudienceUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionNewsletterAudienceUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionNewsletterAudienceWhereUniqueInput
}

export type SectionNewsletterAudienceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionNewsletterAudienceUpdateInput
  /** Unique document search */
  where: SectionNewsletterAudienceWhereUniqueInput
}

export type SectionNewsletterAudienceUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionNewsletterAudienceCreateInput
  /** Update document if it exists */
  update: SectionNewsletterAudienceUpdateInput
}

export type SectionNewsletterAudienceUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionNewsletterAudienceUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionNewsletterAudienceWhereUniqueInput
}

export type SectionNewsletterAudienceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionNewsletterAudienceUpsertInput
  /** Unique document search */
  where: SectionNewsletterAudienceWhereUniqueInput
}

/** Identifies documents */
export type SectionNewsletterAudienceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionNewsletterAudienceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionNewsletterAudienceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionNewsletterAudienceWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audiences_every?: InputMaybe<NewsletterAudienceWhereInput>
  audiences_none?: InputMaybe<NewsletterAudienceWhereInput>
  audiences_some?: InputMaybe<NewsletterAudienceWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionNewsletterAudience record uniquely */
export type SectionNewsletterAudienceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionNewsletterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionNewsletterWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionNewsletterConnection = {
  __typename?: 'SectionNewsletterConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionNewsletterEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionNewsletterCreateInput = {
  audience?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  /** disclaimer input for default locale (de) */
  disclaimer?: InputMaybe<Scalars['String']['input']>
  linkTarget?: InputMaybe<Scalars['String']['input']>
  /** linkText input for default locale (de) */
  linkText?: InputMaybe<Scalars['String']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionNewsletterCreateLocalizationsInput>
  /** successMessage input for default locale (de) */
  successMessage?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionNewsletterCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  disclaimer?: InputMaybe<Scalars['String']['input']>
  linkText?: InputMaybe<Scalars['String']['input']>
  successMessage?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionNewsletterCreateLocalizationInput = {
  /** Localization input */
  data: SectionNewsletterCreateLocalizationDataInput
  locale: Locale
}

export type SectionNewsletterCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionNewsletterCreateLocalizationInput>>
}

export type SectionNewsletterCreateManyInlineInput = {
  /** Create and connect multiple existing SectionNewsletter documents */
  create?: InputMaybe<Array<SectionNewsletterCreateInput>>
}

export type SectionNewsletterCreateOneInlineInput = {
  /** Create and connect one SectionNewsletter document */
  create?: InputMaybe<SectionNewsletterCreateInput>
}

export type SectionNewsletterCreateWithPositionInput = {
  /** Document to create */
  data: SectionNewsletterCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionNewsletterEdge = {
  __typename?: 'SectionNewsletterEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionNewsletter
}

/** Identifies documents */
export type SectionNewsletterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionNewsletterWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionNewsletterWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionNewsletterWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audience?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  audience_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  audience_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  audience_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  audience_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  audience_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  audience_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  audience_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  audience_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  audience_starts_with?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  linkTarget?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkTarget_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkTarget_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkTarget_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkTarget_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkTarget_starts_with?: InputMaybe<Scalars['String']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionNewsletterOrderByInput {
  AudienceAsc = 'audience_ASC',
  AudienceDesc = 'audience_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DisclaimerAsc = 'disclaimer_ASC',
  DisclaimerDesc = 'disclaimer_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkTargetAsc = 'linkTarget_ASC',
  LinkTargetDesc = 'linkTarget_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkUrlAsc = 'linkUrl_ASC',
  LinkUrlDesc = 'linkUrl_DESC',
  SuccessMessageAsc = 'successMessage_ASC',
  SuccessMessageDesc = 'successMessage_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionNewsletterParent = EventPage | LandingPage

export type SectionNewsletterParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionNewsletterParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionNewsletterParentCreateManyInlineInput = {
  /** Connect multiple existing SectionNewsletterParent documents */
  connect?: InputMaybe<Array<SectionNewsletterParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionNewsletterParent documents */
  create?: InputMaybe<Array<SectionNewsletterParentCreateInput>>
}

export type SectionNewsletterParentCreateOneInlineInput = {
  /** Connect one existing SectionNewsletterParent document */
  connect?: InputMaybe<SectionNewsletterParentWhereUniqueInput>
  /** Create and connect one SectionNewsletterParent document */
  create?: InputMaybe<SectionNewsletterParentCreateInput>
}

export type SectionNewsletterParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionNewsletterParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionNewsletterParent documents */
  connect?: InputMaybe<Array<SectionNewsletterParentConnectInput>>
  /** Create and connect multiple SectionNewsletterParent documents */
  create?: InputMaybe<Array<SectionNewsletterParentCreateInput>>
  /** Delete multiple SectionNewsletterParent documents */
  delete?: InputMaybe<Array<SectionNewsletterParentWhereUniqueInput>>
  /** Disconnect multiple SectionNewsletterParent documents */
  disconnect?: InputMaybe<Array<SectionNewsletterParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionNewsletterParent documents */
  set?: InputMaybe<Array<SectionNewsletterParentWhereUniqueInput>>
  /** Update multiple SectionNewsletterParent documents */
  update?: InputMaybe<Array<SectionNewsletterParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionNewsletterParent documents */
  upsert?: InputMaybe<Array<SectionNewsletterParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionNewsletterParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionNewsletterParentUpdateOneInlineInput = {
  /** Connect existing SectionNewsletterParent document */
  connect?: InputMaybe<SectionNewsletterParentWhereUniqueInput>
  /** Create and connect one SectionNewsletterParent document */
  create?: InputMaybe<SectionNewsletterParentCreateInput>
  /** Delete currently connected SectionNewsletterParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionNewsletterParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionNewsletterParent document */
  update?: InputMaybe<SectionNewsletterParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionNewsletterParent document */
  upsert?: InputMaybe<SectionNewsletterParentUpsertWithNestedWhereUniqueInput>
}

export type SectionNewsletterParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionNewsletterParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionNewsletterParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionNewsletterParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionNewsletterUpdateInput = {
  audience?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** disclaimer input for default locale (de) */
  disclaimer?: InputMaybe<Scalars['String']['input']>
  linkTarget?: InputMaybe<Scalars['String']['input']>
  /** linkText input for default locale (de) */
  linkText?: InputMaybe<Scalars['String']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionNewsletterUpdateLocalizationsInput>
  /** successMessage input for default locale (de) */
  successMessage?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionNewsletterUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  disclaimer?: InputMaybe<Scalars['String']['input']>
  linkText?: InputMaybe<Scalars['String']['input']>
  successMessage?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionNewsletterUpdateLocalizationInput = {
  data: SectionNewsletterUpdateLocalizationDataInput
  locale: Locale
}

export type SectionNewsletterUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionNewsletterCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionNewsletterUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionNewsletterUpsertLocalizationInput>>
}

export type SectionNewsletterUpdateManyInlineInput = {
  /** Create and connect multiple SectionNewsletter component instances */
  create?: InputMaybe<Array<SectionNewsletterCreateWithPositionInput>>
  /** Delete multiple SectionNewsletter documents */
  delete?: InputMaybe<Array<SectionNewsletterWhereUniqueInput>>
  /** Update multiple SectionNewsletter component instances */
  update?: InputMaybe<Array<SectionNewsletterUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionNewsletter component instances */
  upsert?: InputMaybe<Array<SectionNewsletterUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionNewsletterUpdateManyInput = {
  audience?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** disclaimer input for default locale (de) */
  disclaimer?: InputMaybe<Scalars['String']['input']>
  linkTarget?: InputMaybe<Scalars['String']['input']>
  /** linkText input for default locale (de) */
  linkText?: InputMaybe<Scalars['String']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionNewsletterUpdateManyLocalizationsInput>
  /** successMessage input for default locale (de) */
  successMessage?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionNewsletterUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  disclaimer?: InputMaybe<Scalars['String']['input']>
  linkText?: InputMaybe<Scalars['String']['input']>
  successMessage?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionNewsletterUpdateManyLocalizationInput = {
  data: SectionNewsletterUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionNewsletterUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionNewsletterUpdateManyLocalizationInput>>
}

export type SectionNewsletterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionNewsletterUpdateManyInput
  /** Document search */
  where: SectionNewsletterWhereInput
}

export type SectionNewsletterUpdateOneInlineInput = {
  /** Create and connect one SectionNewsletter document */
  create?: InputMaybe<SectionNewsletterCreateInput>
  /** Delete currently connected SectionNewsletter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionNewsletter document */
  update?: InputMaybe<SectionNewsletterUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionNewsletter document */
  upsert?: InputMaybe<SectionNewsletterUpsertWithNestedWhereUniqueInput>
}

export type SectionNewsletterUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionNewsletterUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionNewsletterWhereUniqueInput
}

export type SectionNewsletterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionNewsletterUpdateInput
  /** Unique document search */
  where: SectionNewsletterWhereUniqueInput
}

export type SectionNewsletterUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionNewsletterCreateInput
  /** Update document if it exists */
  update: SectionNewsletterUpdateInput
}

export type SectionNewsletterUpsertLocalizationInput = {
  create: SectionNewsletterCreateLocalizationDataInput
  locale: Locale
  update: SectionNewsletterUpdateLocalizationDataInput
}

export type SectionNewsletterUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionNewsletterUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionNewsletterWhereUniqueInput
}

export type SectionNewsletterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionNewsletterUpsertInput
  /** Unique document search */
  where: SectionNewsletterWhereUniqueInput
}

/** Identifies documents */
export type SectionNewsletterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionNewsletterWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionNewsletterWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionNewsletterWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  audience?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  audience_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  audience_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  audience_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  audience_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  audience_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  audience_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  audience_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  audience_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  audience_starts_with?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  disclaimer?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  disclaimer_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  disclaimer_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  disclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  disclaimer_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  disclaimer_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  disclaimer_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  disclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  disclaimer_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  disclaimer_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  linkTarget?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkTarget_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkTarget_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkTarget_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkTarget_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkTarget_starts_with?: InputMaybe<Scalars['String']['input']>
  linkText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkText_starts_with?: InputMaybe<Scalars['String']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  successMessage?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  successMessage_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  successMessage_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  successMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  successMessage_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  successMessage_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  successMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  successMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  successMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  successMessage_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionNewsletter record uniquely */
export type SectionNewsletterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Logo field of OMR partners with external linking. Partners/Media Partners etc. */
export type SectionOmrPartner = Entity & {
  __typename?: 'SectionOMRPartner'
  /** Render partner logos as slider with horizontal auto scroll */
  asSlider?: Maybe<Scalars['Boolean']['output']>
  darkTheme?: Maybe<Scalars['Boolean']['output']>
  /** Select a decoration pattern for this component. */
  decorationPattern?: Maybe<DecorationPattern>
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionOmrPartner>
  omrPartners: Array<OmrPartner>
  /** Select a custom padding for this section, otherwise default is used. */
  sectionPadding?: Maybe<SectionPadding>
  /** System stage field */
  stage: Stage
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Logo field of OMR partners with external linking. Partners/Media Partners etc. */
export type SectionOmrPartnerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Logo field of OMR partners with external linking. Partners/Media Partners etc. */
export type SectionOmrPartnerOmrPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<OmrPartnerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<OmrPartnerWhereInput>
}

/** Logo field of OMR partners with external linking. Partners/Media Partners etc. */
export type SectionOmrPartnerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionOmrPartnerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionOmrPartnerWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionOmrPartnerConnection = {
  __typename?: 'SectionOMRPartnerConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionOmrPartnerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionOmrPartnerCreateInput = {
  asSlider?: InputMaybe<Scalars['Boolean']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionOmrPartnerCreateLocalizationsInput>
  omrPartners?: InputMaybe<OmrPartnerCreateManyInlineInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionOmrPartnerCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionOmrPartnerCreateLocalizationInput = {
  /** Localization input */
  data: SectionOmrPartnerCreateLocalizationDataInput
  locale: Locale
}

export type SectionOmrPartnerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionOmrPartnerCreateLocalizationInput>>
}

export type SectionOmrPartnerCreateManyInlineInput = {
  /** Create and connect multiple existing SectionOMRPartner documents */
  create?: InputMaybe<Array<SectionOmrPartnerCreateInput>>
}

export type SectionOmrPartnerCreateOneInlineInput = {
  /** Create and connect one SectionOMRPartner document */
  create?: InputMaybe<SectionOmrPartnerCreateInput>
}

export type SectionOmrPartnerCreateWithPositionInput = {
  /** Document to create */
  data: SectionOmrPartnerCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionOmrPartnerEdge = {
  __typename?: 'SectionOMRPartnerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionOmrPartner
}

/** Identifies documents */
export type SectionOmrPartnerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionOmrPartnerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionOmrPartnerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionOmrPartnerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  asSlider?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  asSlider_not?: InputMaybe<Scalars['Boolean']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkTheme_not?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  omrPartners_every?: InputMaybe<OmrPartnerWhereInput>
  omrPartners_none?: InputMaybe<OmrPartnerWhereInput>
  omrPartners_some?: InputMaybe<OmrPartnerWhereInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionOmrPartnerOrderByInput {
  AsSliderAsc = 'asSlider_ASC',
  AsSliderDesc = 'asSlider_DESC',
  DarkThemeAsc = 'darkTheme_ASC',
  DarkThemeDesc = 'darkTheme_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SectionPaddingAsc = 'sectionPadding_ASC',
  SectionPaddingDesc = 'sectionPadding_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionOmrPartnerParent = EventPage | LandingPage

export type SectionOmrPartnerParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionOmrPartnerParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionOmrPartnerParentCreateManyInlineInput = {
  /** Connect multiple existing SectionOMRPartnerParent documents */
  connect?: InputMaybe<Array<SectionOmrPartnerParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionOMRPartnerParent documents */
  create?: InputMaybe<Array<SectionOmrPartnerParentCreateInput>>
}

export type SectionOmrPartnerParentCreateOneInlineInput = {
  /** Connect one existing SectionOMRPartnerParent document */
  connect?: InputMaybe<SectionOmrPartnerParentWhereUniqueInput>
  /** Create and connect one SectionOMRPartnerParent document */
  create?: InputMaybe<SectionOmrPartnerParentCreateInput>
}

export type SectionOmrPartnerParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionOmrPartnerParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionOMRPartnerParent documents */
  connect?: InputMaybe<Array<SectionOmrPartnerParentConnectInput>>
  /** Create and connect multiple SectionOMRPartnerParent documents */
  create?: InputMaybe<Array<SectionOmrPartnerParentCreateInput>>
  /** Delete multiple SectionOMRPartnerParent documents */
  delete?: InputMaybe<Array<SectionOmrPartnerParentWhereUniqueInput>>
  /** Disconnect multiple SectionOMRPartnerParent documents */
  disconnect?: InputMaybe<Array<SectionOmrPartnerParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionOMRPartnerParent documents */
  set?: InputMaybe<Array<SectionOmrPartnerParentWhereUniqueInput>>
  /** Update multiple SectionOMRPartnerParent documents */
  update?: InputMaybe<Array<SectionOmrPartnerParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionOMRPartnerParent documents */
  upsert?: InputMaybe<Array<SectionOmrPartnerParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionOmrPartnerParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionOmrPartnerParentUpdateOneInlineInput = {
  /** Connect existing SectionOMRPartnerParent document */
  connect?: InputMaybe<SectionOmrPartnerParentWhereUniqueInput>
  /** Create and connect one SectionOMRPartnerParent document */
  create?: InputMaybe<SectionOmrPartnerParentCreateInput>
  /** Delete currently connected SectionOMRPartnerParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionOMRPartnerParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionOMRPartnerParent document */
  update?: InputMaybe<SectionOmrPartnerParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionOMRPartnerParent document */
  upsert?: InputMaybe<SectionOmrPartnerParentUpsertWithNestedWhereUniqueInput>
}

export type SectionOmrPartnerParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionOmrPartnerParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionOmrPartnerParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionOmrPartnerParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionOmrPartnerUpdateInput = {
  asSlider?: InputMaybe<Scalars['Boolean']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionOmrPartnerUpdateLocalizationsInput>
  omrPartners?: InputMaybe<OmrPartnerUpdateManyInlineInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionOmrPartnerUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionOmrPartnerUpdateLocalizationInput = {
  data: SectionOmrPartnerUpdateLocalizationDataInput
  locale: Locale
}

export type SectionOmrPartnerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionOmrPartnerCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionOmrPartnerUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionOmrPartnerUpsertLocalizationInput>>
}

export type SectionOmrPartnerUpdateManyInlineInput = {
  /** Create and connect multiple SectionOMRPartner component instances */
  create?: InputMaybe<Array<SectionOmrPartnerCreateWithPositionInput>>
  /** Delete multiple SectionOMRPartner documents */
  delete?: InputMaybe<Array<SectionOmrPartnerWhereUniqueInput>>
  /** Update multiple SectionOMRPartner component instances */
  update?: InputMaybe<Array<SectionOmrPartnerUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionOMRPartner component instances */
  upsert?: InputMaybe<Array<SectionOmrPartnerUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionOmrPartnerUpdateManyInput = {
  asSlider?: InputMaybe<Scalars['Boolean']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionOmrPartnerUpdateManyLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionOmrPartnerUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionOmrPartnerUpdateManyLocalizationInput = {
  data: SectionOmrPartnerUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionOmrPartnerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionOmrPartnerUpdateManyLocalizationInput>>
}

export type SectionOmrPartnerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionOmrPartnerUpdateManyInput
  /** Document search */
  where: SectionOmrPartnerWhereInput
}

export type SectionOmrPartnerUpdateOneInlineInput = {
  /** Create and connect one SectionOMRPartner document */
  create?: InputMaybe<SectionOmrPartnerCreateInput>
  /** Delete currently connected SectionOMRPartner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionOMRPartner document */
  update?: InputMaybe<SectionOmrPartnerUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionOMRPartner document */
  upsert?: InputMaybe<SectionOmrPartnerUpsertWithNestedWhereUniqueInput>
}

export type SectionOmrPartnerUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionOmrPartnerUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionOmrPartnerWhereUniqueInput
}

export type SectionOmrPartnerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionOmrPartnerUpdateInput
  /** Unique document search */
  where: SectionOmrPartnerWhereUniqueInput
}

export type SectionOmrPartnerUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionOmrPartnerCreateInput
  /** Update document if it exists */
  update: SectionOmrPartnerUpdateInput
}

export type SectionOmrPartnerUpsertLocalizationInput = {
  create: SectionOmrPartnerCreateLocalizationDataInput
  locale: Locale
  update: SectionOmrPartnerUpdateLocalizationDataInput
}

export type SectionOmrPartnerUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionOmrPartnerUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionOmrPartnerWhereUniqueInput
}

export type SectionOmrPartnerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionOmrPartnerUpsertInput
  /** Unique document search */
  where: SectionOmrPartnerWhereUniqueInput
}

/** Identifies documents */
export type SectionOmrPartnerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionOmrPartnerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionOmrPartnerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionOmrPartnerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  asSlider?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  asSlider_not?: InputMaybe<Scalars['Boolean']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkTheme_not?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  omrPartners_every?: InputMaybe<OmrPartnerWhereInput>
  omrPartners_none?: InputMaybe<OmrPartnerWhereInput>
  omrPartners_some?: InputMaybe<OmrPartnerWhereInput>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionOMRPartner record uniquely */
export type SectionOmrPartnerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** One shot component for static content. */
export type SectionOneShot = Entity & {
  __typename?: 'SectionOneShot'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Type of one shot */
  oneShotType: SectionOneShotType
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionOneShotConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionOneShotWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionOneShotConnection = {
  __typename?: 'SectionOneShotConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionOneShotEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionOneShotCreateInput = {
  oneShotType: SectionOneShotType
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionOneShotCreateManyInlineInput = {
  /** Create and connect multiple existing SectionOneShot documents */
  create?: InputMaybe<Array<SectionOneShotCreateInput>>
}

export type SectionOneShotCreateOneInlineInput = {
  /** Create and connect one SectionOneShot document */
  create?: InputMaybe<SectionOneShotCreateInput>
}

export type SectionOneShotCreateWithPositionInput = {
  /** Document to create */
  data: SectionOneShotCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionOneShotEdge = {
  __typename?: 'SectionOneShotEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionOneShot
}

/** Identifies documents */
export type SectionOneShotManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionOneShotWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionOneShotWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionOneShotWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  oneShotType?: InputMaybe<SectionOneShotType>
  /** All values that are contained in given list. */
  oneShotType_in?: InputMaybe<Array<InputMaybe<SectionOneShotType>>>
  /** Any other value that exists and is not equal to the given value. */
  oneShotType_not?: InputMaybe<SectionOneShotType>
  /** All values that are not contained in given list. */
  oneShotType_not_in?: InputMaybe<Array<InputMaybe<SectionOneShotType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionOneShotOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OneShotTypeAsc = 'oneShotType_ASC',
  OneShotTypeDesc = 'oneShotType_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionOneShotParent = LandingPage

export type SectionOneShotParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionOneShotParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionOneShotParentCreateManyInlineInput = {
  /** Connect multiple existing SectionOneShotParent documents */
  connect?: InputMaybe<Array<SectionOneShotParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionOneShotParent documents */
  create?: InputMaybe<Array<SectionOneShotParentCreateInput>>
}

export type SectionOneShotParentCreateOneInlineInput = {
  /** Connect one existing SectionOneShotParent document */
  connect?: InputMaybe<SectionOneShotParentWhereUniqueInput>
  /** Create and connect one SectionOneShotParent document */
  create?: InputMaybe<SectionOneShotParentCreateInput>
}

export type SectionOneShotParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionOneShotParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionOneShotParent documents */
  connect?: InputMaybe<Array<SectionOneShotParentConnectInput>>
  /** Create and connect multiple SectionOneShotParent documents */
  create?: InputMaybe<Array<SectionOneShotParentCreateInput>>
  /** Delete multiple SectionOneShotParent documents */
  delete?: InputMaybe<Array<SectionOneShotParentWhereUniqueInput>>
  /** Disconnect multiple SectionOneShotParent documents */
  disconnect?: InputMaybe<Array<SectionOneShotParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionOneShotParent documents */
  set?: InputMaybe<Array<SectionOneShotParentWhereUniqueInput>>
  /** Update multiple SectionOneShotParent documents */
  update?: InputMaybe<Array<SectionOneShotParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionOneShotParent documents */
  upsert?: InputMaybe<Array<SectionOneShotParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionOneShotParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionOneShotParentUpdateOneInlineInput = {
  /** Connect existing SectionOneShotParent document */
  connect?: InputMaybe<SectionOneShotParentWhereUniqueInput>
  /** Create and connect one SectionOneShotParent document */
  create?: InputMaybe<SectionOneShotParentCreateInput>
  /** Delete currently connected SectionOneShotParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionOneShotParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionOneShotParent document */
  update?: InputMaybe<SectionOneShotParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionOneShotParent document */
  upsert?: InputMaybe<SectionOneShotParentUpsertWithNestedWhereUniqueInput>
}

export type SectionOneShotParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionOneShotParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionOneShotParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionOneShotParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

/** Type of one shot */
export enum SectionOneShotType {
  AlwaysHamburg = 'alwaysHamburg',
  Omr50Ranking = 'omr50Ranking',
}

export type SectionOneShotUpdateInput = {
  oneShotType?: InputMaybe<SectionOneShotType>
}

export type SectionOneShotUpdateManyInlineInput = {
  /** Create and connect multiple SectionOneShot component instances */
  create?: InputMaybe<Array<SectionOneShotCreateWithPositionInput>>
  /** Delete multiple SectionOneShot documents */
  delete?: InputMaybe<Array<SectionOneShotWhereUniqueInput>>
  /** Update multiple SectionOneShot component instances */
  update?: InputMaybe<Array<SectionOneShotUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionOneShot component instances */
  upsert?: InputMaybe<Array<SectionOneShotUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionOneShotUpdateManyInput = {
  oneShotType?: InputMaybe<SectionOneShotType>
}

export type SectionOneShotUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionOneShotUpdateManyInput
  /** Document search */
  where: SectionOneShotWhereInput
}

export type SectionOneShotUpdateOneInlineInput = {
  /** Create and connect one SectionOneShot document */
  create?: InputMaybe<SectionOneShotCreateInput>
  /** Delete currently connected SectionOneShot document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionOneShot document */
  update?: InputMaybe<SectionOneShotUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionOneShot document */
  upsert?: InputMaybe<SectionOneShotUpsertWithNestedWhereUniqueInput>
}

export type SectionOneShotUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionOneShotUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionOneShotWhereUniqueInput
}

export type SectionOneShotUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionOneShotUpdateInput
  /** Unique document search */
  where: SectionOneShotWhereUniqueInput
}

export type SectionOneShotUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionOneShotCreateInput
  /** Update document if it exists */
  update: SectionOneShotUpdateInput
}

export type SectionOneShotUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionOneShotUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionOneShotWhereUniqueInput
}

export type SectionOneShotUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionOneShotUpsertInput
  /** Unique document search */
  where: SectionOneShotWhereUniqueInput
}

/** Identifies documents */
export type SectionOneShotWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionOneShotWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionOneShotWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionOneShotWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  oneShotType?: InputMaybe<SectionOneShotType>
  /** All values that are contained in given list. */
  oneShotType_in?: InputMaybe<Array<InputMaybe<SectionOneShotType>>>
  /** Any other value that exists and is not equal to the given value. */
  oneShotType_not?: InputMaybe<SectionOneShotType>
  /** All values that are not contained in given list. */
  oneShotType_not_in?: InputMaybe<Array<InputMaybe<SectionOneShotType>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionOneShot record uniquely */
export type SectionOneShotWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum SectionPadding {
  Extraskinny = 'extraskinny',
  NoBottom = 'noBottom',
  NoTop = 'noTop',
  None = 'none',
  ReducedBottom = 'reducedBottom',
  ReducedTop = 'reducedTop',
  Skinny = 'skinny',
}

/** Section for Pricing Tiers */
export type SectionPricingTiers = Entity & {
  __typename?: 'SectionPricingTiers'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionPricingTiers>
  sectionPricingTiersItems: Array<PricingTier>
  sectionPricingTiersTitle?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section for Pricing Tiers */
export type SectionPricingTiersLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section for Pricing Tiers */
export type SectionPricingTiersSectionPricingTiersItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<PricingTierOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PricingTierWhereInput>
}

/** Section for Pricing Tiers */
export type SectionPricingTiersUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionPricingTiersConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionPricingTiersWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionPricingTiersConnection = {
  __typename?: 'SectionPricingTiersConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionPricingTiersEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionPricingTiersCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionPricingTiersCreateLocalizationsInput>
  sectionPricingTiersItems?: InputMaybe<PricingTierCreateManyInlineInput>
  /** sectionPricingTiersTitle input for default locale (de) */
  sectionPricingTiersTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionPricingTiersCreateLocalizationDataInput = {
  sectionPricingTiersTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionPricingTiersCreateLocalizationInput = {
  /** Localization input */
  data: SectionPricingTiersCreateLocalizationDataInput
  locale: Locale
}

export type SectionPricingTiersCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionPricingTiersCreateLocalizationInput>>
}

export type SectionPricingTiersCreateManyInlineInput = {
  /** Create and connect multiple existing SectionPricingTiers documents */
  create?: InputMaybe<Array<SectionPricingTiersCreateInput>>
}

export type SectionPricingTiersCreateOneInlineInput = {
  /** Create and connect one SectionPricingTiers document */
  create?: InputMaybe<SectionPricingTiersCreateInput>
}

export type SectionPricingTiersCreateWithPositionInput = {
  /** Document to create */
  data: SectionPricingTiersCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionPricingTiersEdge = {
  __typename?: 'SectionPricingTiersEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionPricingTiers
}

/** Identifies documents */
export type SectionPricingTiersManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionPricingTiersWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionPricingTiersWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionPricingTiersWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  sectionPricingTiersItems_every?: InputMaybe<PricingTierWhereInput>
  sectionPricingTiersItems_none?: InputMaybe<PricingTierWhereInput>
  sectionPricingTiersItems_some?: InputMaybe<PricingTierWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionPricingTiersOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SectionPricingTiersTitleAsc = 'sectionPricingTiersTitle_ASC',
  SectionPricingTiersTitleDesc = 'sectionPricingTiersTitle_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionPricingTiersParent = LandingPage

export type SectionPricingTiersParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionPricingTiersParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionPricingTiersParentCreateManyInlineInput = {
  /** Connect multiple existing SectionPricingTiersParent documents */
  connect?: InputMaybe<Array<SectionPricingTiersParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionPricingTiersParent documents */
  create?: InputMaybe<Array<SectionPricingTiersParentCreateInput>>
}

export type SectionPricingTiersParentCreateOneInlineInput = {
  /** Connect one existing SectionPricingTiersParent document */
  connect?: InputMaybe<SectionPricingTiersParentWhereUniqueInput>
  /** Create and connect one SectionPricingTiersParent document */
  create?: InputMaybe<SectionPricingTiersParentCreateInput>
}

export type SectionPricingTiersParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionPricingTiersParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionPricingTiersParent documents */
  connect?: InputMaybe<Array<SectionPricingTiersParentConnectInput>>
  /** Create and connect multiple SectionPricingTiersParent documents */
  create?: InputMaybe<Array<SectionPricingTiersParentCreateInput>>
  /** Delete multiple SectionPricingTiersParent documents */
  delete?: InputMaybe<Array<SectionPricingTiersParentWhereUniqueInput>>
  /** Disconnect multiple SectionPricingTiersParent documents */
  disconnect?: InputMaybe<Array<SectionPricingTiersParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionPricingTiersParent documents */
  set?: InputMaybe<Array<SectionPricingTiersParentWhereUniqueInput>>
  /** Update multiple SectionPricingTiersParent documents */
  update?: InputMaybe<Array<SectionPricingTiersParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionPricingTiersParent documents */
  upsert?: InputMaybe<Array<SectionPricingTiersParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionPricingTiersParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionPricingTiersParentUpdateOneInlineInput = {
  /** Connect existing SectionPricingTiersParent document */
  connect?: InputMaybe<SectionPricingTiersParentWhereUniqueInput>
  /** Create and connect one SectionPricingTiersParent document */
  create?: InputMaybe<SectionPricingTiersParentCreateInput>
  /** Delete currently connected SectionPricingTiersParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionPricingTiersParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionPricingTiersParent document */
  update?: InputMaybe<SectionPricingTiersParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionPricingTiersParent document */
  upsert?: InputMaybe<SectionPricingTiersParentUpsertWithNestedWhereUniqueInput>
}

export type SectionPricingTiersParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionPricingTiersParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionPricingTiersParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionPricingTiersParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

/** Icon for Pricing Tier Title */
export enum SectionPricingTiersTitleIcon {
  AwardIcon = 'AwardIcon',
  BriefcaseBusinessIcon = 'BriefcaseBusinessIcon',
  Building2Icon = 'Building2Icon',
  ClockIcon = 'ClockIcon',
  CoinsIcon = 'CoinsIcon',
  GiftIcon = 'GiftIcon',
  HandshakeIcon = 'HandshakeIcon',
  RocketIcon = 'RocketIcon',
  UserIcon = 'UserIcon',
  UsersIcon = 'UsersIcon',
}

export type SectionPricingTiersUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<SectionPricingTiersUpdateLocalizationsInput>
  sectionPricingTiersItems?: InputMaybe<PricingTierUpdateManyInlineInput>
  /** sectionPricingTiersTitle input for default locale (de) */
  sectionPricingTiersTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionPricingTiersUpdateLocalizationDataInput = {
  sectionPricingTiersTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionPricingTiersUpdateLocalizationInput = {
  data: SectionPricingTiersUpdateLocalizationDataInput
  locale: Locale
}

export type SectionPricingTiersUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionPricingTiersCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionPricingTiersUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionPricingTiersUpsertLocalizationInput>>
}

export type SectionPricingTiersUpdateManyInlineInput = {
  /** Create and connect multiple SectionPricingTiers component instances */
  create?: InputMaybe<Array<SectionPricingTiersCreateWithPositionInput>>
  /** Delete multiple SectionPricingTiers documents */
  delete?: InputMaybe<Array<SectionPricingTiersWhereUniqueInput>>
  /** Update multiple SectionPricingTiers component instances */
  update?: InputMaybe<Array<SectionPricingTiersUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionPricingTiers component instances */
  upsert?: InputMaybe<Array<SectionPricingTiersUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionPricingTiersUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionPricingTiersUpdateManyLocalizationsInput>
  /** sectionPricingTiersTitle input for default locale (de) */
  sectionPricingTiersTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionPricingTiersUpdateManyLocalizationDataInput = {
  sectionPricingTiersTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionPricingTiersUpdateManyLocalizationInput = {
  data: SectionPricingTiersUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionPricingTiersUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionPricingTiersUpdateManyLocalizationInput>>
}

export type SectionPricingTiersUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionPricingTiersUpdateManyInput
  /** Document search */
  where: SectionPricingTiersWhereInput
}

export type SectionPricingTiersUpdateOneInlineInput = {
  /** Create and connect one SectionPricingTiers document */
  create?: InputMaybe<SectionPricingTiersCreateInput>
  /** Delete currently connected SectionPricingTiers document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionPricingTiers document */
  update?: InputMaybe<SectionPricingTiersUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionPricingTiers document */
  upsert?: InputMaybe<SectionPricingTiersUpsertWithNestedWhereUniqueInput>
}

export type SectionPricingTiersUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionPricingTiersUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionPricingTiersWhereUniqueInput
}

export type SectionPricingTiersUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionPricingTiersUpdateInput
  /** Unique document search */
  where: SectionPricingTiersWhereUniqueInput
}

export type SectionPricingTiersUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionPricingTiersCreateInput
  /** Update document if it exists */
  update: SectionPricingTiersUpdateInput
}

export type SectionPricingTiersUpsertLocalizationInput = {
  create: SectionPricingTiersCreateLocalizationDataInput
  locale: Locale
  update: SectionPricingTiersUpdateLocalizationDataInput
}

export type SectionPricingTiersUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionPricingTiersUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionPricingTiersWhereUniqueInput
}

export type SectionPricingTiersUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionPricingTiersUpsertInput
  /** Unique document search */
  where: SectionPricingTiersWhereUniqueInput
}

/** Identifies documents */
export type SectionPricingTiersWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionPricingTiersWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionPricingTiersWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionPricingTiersWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  sectionPricingTiersItems_every?: InputMaybe<PricingTierWhereInput>
  sectionPricingTiersItems_none?: InputMaybe<PricingTierWhereInput>
  sectionPricingTiersItems_some?: InputMaybe<PricingTierWhereInput>
  sectionPricingTiersTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  sectionPricingTiersTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  sectionPricingTiersTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  sectionPricingTiersTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPricingTiersTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  sectionPricingTiersTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  sectionPricingTiersTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  sectionPricingTiersTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  sectionPricingTiersTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  sectionPricingTiersTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionPricingTiers record uniquely */
export type SectionPricingTiersWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section representing quote */
export type SectionQuote = Entity & {
  __typename?: 'SectionQuote'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionQuote>
  /** Author name */
  name: Scalars['String']['output']
  /** Authors position in the company */
  position: Scalars['String']['output']
  /** Quote text content */
  quote: Scalars['String']['output']
  /** Image shown left to signature. Can be a company logo */
  signatureImage: Asset
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section representing quote */
export type SectionQuoteLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section representing quote */
export type SectionQuoteSignatureImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Section representing quote */
export type SectionQuoteUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionQuoteConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionQuoteWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionQuoteConnection = {
  __typename?: 'SectionQuoteConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionQuoteEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionQuoteCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionQuoteCreateLocalizationsInput>
  name: Scalars['String']['input']
  /** position input for default locale (de) */
  position: Scalars['String']['input']
  /** quote input for default locale (de) */
  quote: Scalars['String']['input']
  signatureImage: AssetCreateOneInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionQuoteCreateLocalizationDataInput = {
  position: Scalars['String']['input']
  quote: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionQuoteCreateLocalizationInput = {
  /** Localization input */
  data: SectionQuoteCreateLocalizationDataInput
  locale: Locale
}

export type SectionQuoteCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionQuoteCreateLocalizationInput>>
}

export type SectionQuoteCreateManyInlineInput = {
  /** Create and connect multiple existing SectionQuote documents */
  create?: InputMaybe<Array<SectionQuoteCreateInput>>
}

export type SectionQuoteCreateOneInlineInput = {
  /** Create and connect one SectionQuote document */
  create?: InputMaybe<SectionQuoteCreateInput>
}

export type SectionQuoteCreateWithPositionInput = {
  /** Document to create */
  data: SectionQuoteCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionQuoteEdge = {
  __typename?: 'SectionQuoteEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionQuote
}

/** Identifies documents */
export type SectionQuoteManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionQuoteWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionQuoteWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionQuoteWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  signatureImage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionQuoteOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  QuoteAsc = 'quote_ASC',
  QuoteDesc = 'quote_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionQuoteParent = TopicPageSection

export type SectionQuoteParentConnectInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionConnectInput>
}

export type SectionQuoteParentCreateInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionCreateInput>
}

export type SectionQuoteParentCreateManyInlineInput = {
  /** Create and connect multiple existing SectionQuoteParent documents */
  create?: InputMaybe<Array<SectionQuoteParentCreateInput>>
}

export type SectionQuoteParentCreateOneInlineInput = {
  /** Create and connect one SectionQuoteParent document */
  create?: InputMaybe<SectionQuoteParentCreateInput>
}

export type SectionQuoteParentCreateWithPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionCreateWithPositionInput>
}

export type SectionQuoteParentUpdateInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateInput>
}

export type SectionQuoteParentUpdateManyInlineInput = {
  /** Create and connect multiple SectionQuoteParent component instances */
  create?: InputMaybe<Array<SectionQuoteParentCreateWithPositionInput>>
  /** Delete multiple SectionQuoteParent documents */
  delete?: InputMaybe<Array<SectionQuoteParentWhereUniqueInput>>
  /** Update multiple SectionQuoteParent component instances */
  update?: InputMaybe<Array<SectionQuoteParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionQuoteParent component instances */
  upsert?: InputMaybe<Array<SectionQuoteParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionQuoteParentUpdateManyWithNestedWhereInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateManyWithNestedWhereInput>
}

export type SectionQuoteParentUpdateOneInlineInput = {
  /** Create and connect one SectionQuoteParent document */
  create?: InputMaybe<SectionQuoteParentCreateInput>
  /** Delete currently connected SectionQuoteParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionQuoteParent document */
  update?: InputMaybe<SectionQuoteParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionQuoteParent document */
  upsert?: InputMaybe<SectionQuoteParentUpsertWithNestedWhereUniqueInput>
}

export type SectionQuoteParentUpdateWithNestedWhereUniqueAndPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueAndPositionInput>
}

export type SectionQuoteParentUpdateWithNestedWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueInput>
}

export type SectionQuoteParentUpsertWithNestedWhereUniqueAndPositionInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueAndPositionInput>
}

export type SectionQuoteParentUpsertWithNestedWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueInput>
}

export type SectionQuoteParentWhereInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionWhereInput>
}

export type SectionQuoteParentWhereUniqueInput = {
  TopicPageSection?: InputMaybe<TopicPageSectionWhereUniqueInput>
}

export type SectionQuoteUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<SectionQuoteUpdateLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** position input for default locale (de) */
  position?: InputMaybe<Scalars['String']['input']>
  /** quote input for default locale (de) */
  quote?: InputMaybe<Scalars['String']['input']>
  signatureImage?: InputMaybe<AssetUpdateOneInlineInput>
}

export type SectionQuoteUpdateLocalizationDataInput = {
  position?: InputMaybe<Scalars['String']['input']>
  quote?: InputMaybe<Scalars['String']['input']>
}

export type SectionQuoteUpdateLocalizationInput = {
  data: SectionQuoteUpdateLocalizationDataInput
  locale: Locale
}

export type SectionQuoteUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionQuoteCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionQuoteUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionQuoteUpsertLocalizationInput>>
}

export type SectionQuoteUpdateManyInlineInput = {
  /** Create and connect multiple SectionQuote component instances */
  create?: InputMaybe<Array<SectionQuoteCreateWithPositionInput>>
  /** Delete multiple SectionQuote documents */
  delete?: InputMaybe<Array<SectionQuoteWhereUniqueInput>>
  /** Update multiple SectionQuote component instances */
  update?: InputMaybe<Array<SectionQuoteUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionQuote component instances */
  upsert?: InputMaybe<Array<SectionQuoteUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionQuoteUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionQuoteUpdateManyLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** position input for default locale (de) */
  position?: InputMaybe<Scalars['String']['input']>
  /** quote input for default locale (de) */
  quote?: InputMaybe<Scalars['String']['input']>
}

export type SectionQuoteUpdateManyLocalizationDataInput = {
  position?: InputMaybe<Scalars['String']['input']>
  quote?: InputMaybe<Scalars['String']['input']>
}

export type SectionQuoteUpdateManyLocalizationInput = {
  data: SectionQuoteUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionQuoteUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionQuoteUpdateManyLocalizationInput>>
}

export type SectionQuoteUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionQuoteUpdateManyInput
  /** Document search */
  where: SectionQuoteWhereInput
}

export type SectionQuoteUpdateOneInlineInput = {
  /** Create and connect one SectionQuote document */
  create?: InputMaybe<SectionQuoteCreateInput>
  /** Delete currently connected SectionQuote document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionQuote document */
  update?: InputMaybe<SectionQuoteUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionQuote document */
  upsert?: InputMaybe<SectionQuoteUpsertWithNestedWhereUniqueInput>
}

export type SectionQuoteUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionQuoteUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionQuoteWhereUniqueInput
}

export type SectionQuoteUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionQuoteUpdateInput
  /** Unique document search */
  where: SectionQuoteWhereUniqueInput
}

export type SectionQuoteUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionQuoteCreateInput
  /** Update document if it exists */
  update: SectionQuoteUpdateInput
}

export type SectionQuoteUpsertLocalizationInput = {
  create: SectionQuoteCreateLocalizationDataInput
  locale: Locale
  update: SectionQuoteUpdateLocalizationDataInput
}

export type SectionQuoteUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionQuoteUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionQuoteWhereUniqueInput
}

export type SectionQuoteUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionQuoteUpsertInput
  /** Unique document search */
  where: SectionQuoteWhereUniqueInput
}

/** Identifies documents */
export type SectionQuoteWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionQuoteWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionQuoteWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionQuoteWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  position_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  position_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  position_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  position_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  position_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  position_starts_with?: InputMaybe<Scalars['String']['input']>
  quote?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  quote_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  quote_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  quote_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  quote_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  quote_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  quote_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  quote_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  quote_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  quote_starts_with?: InputMaybe<Scalars['String']['input']>
  signatureImage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionQuote record uniquely */
export type SectionQuoteWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** show a grid of places to eat or go out at night during the festival */
export type SectionRecommendations = Entity & {
  __typename?: 'SectionRecommendations'
  /** The unique identifier */
  id: Scalars['ID']['output']
  recommendations: Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpy>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** show a grid of places to eat or go out at night during the festival */
export type SectionRecommendationsRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

export type SectionRecommendationsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionRecommendationsWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionRecommendationsConnection = {
  __typename?: 'SectionRecommendationsConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionRecommendationsEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionRecommendationsCreateInput = {
  recommendations?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionRecommendationsCreateManyInlineInput = {
  /** Create and connect multiple existing SectionRecommendations documents */
  create?: InputMaybe<Array<SectionRecommendationsCreateInput>>
}

export type SectionRecommendationsCreateOneInlineInput = {
  /** Create and connect one SectionRecommendations document */
  create?: InputMaybe<SectionRecommendationsCreateInput>
}

export type SectionRecommendationsCreateWithPositionInput = {
  /** Document to create */
  data: SectionRecommendationsCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionRecommendationsEdge = {
  __typename?: 'SectionRecommendationsEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionRecommendations
}

/** Identifies documents */
export type SectionRecommendationsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionRecommendationsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionRecommendationsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionRecommendationsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty */
  recommendations_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the union contains at least one connection to the provided item to the filter */
  recommendations_some?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionRecommendationsOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionRecommendationsParent = EventPage

export type SectionRecommendationsParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionRecommendationsParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionRecommendationsParentCreateManyInlineInput = {
  /** Connect multiple existing SectionRecommendationsParent documents */
  connect?: InputMaybe<Array<SectionRecommendationsParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionRecommendationsParent documents */
  create?: InputMaybe<Array<SectionRecommendationsParentCreateInput>>
}

export type SectionRecommendationsParentCreateOneInlineInput = {
  /** Connect one existing SectionRecommendationsParent document */
  connect?: InputMaybe<SectionRecommendationsParentWhereUniqueInput>
  /** Create and connect one SectionRecommendationsParent document */
  create?: InputMaybe<SectionRecommendationsParentCreateInput>
}

export type SectionRecommendationsParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionRecommendationsParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionRecommendationsParent documents */
  connect?: InputMaybe<Array<SectionRecommendationsParentConnectInput>>
  /** Create and connect multiple SectionRecommendationsParent documents */
  create?: InputMaybe<Array<SectionRecommendationsParentCreateInput>>
  /** Delete multiple SectionRecommendationsParent documents */
  delete?: InputMaybe<Array<SectionRecommendationsParentWhereUniqueInput>>
  /** Disconnect multiple SectionRecommendationsParent documents */
  disconnect?: InputMaybe<Array<SectionRecommendationsParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionRecommendationsParent documents */
  set?: InputMaybe<Array<SectionRecommendationsParentWhereUniqueInput>>
  /** Update multiple SectionRecommendationsParent documents */
  update?: InputMaybe<Array<SectionRecommendationsParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionRecommendationsParent documents */
  upsert?: InputMaybe<Array<SectionRecommendationsParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionRecommendationsParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionRecommendationsParentUpdateOneInlineInput = {
  /** Connect existing SectionRecommendationsParent document */
  connect?: InputMaybe<SectionRecommendationsParentWhereUniqueInput>
  /** Create and connect one SectionRecommendationsParent document */
  create?: InputMaybe<SectionRecommendationsParentCreateInput>
  /** Delete currently connected SectionRecommendationsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionRecommendationsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionRecommendationsParent document */
  update?: InputMaybe<SectionRecommendationsParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionRecommendationsParent document */
  upsert?: InputMaybe<SectionRecommendationsParentUpsertWithNestedWhereUniqueInput>
}

export type SectionRecommendationsParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionRecommendationsParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionRecommendationsParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionRecommendationsParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionRecommendationsUpdateInput = {
  recommendations?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpdateManyInlineInput>
}

export type SectionRecommendationsUpdateManyInlineInput = {
  /** Create and connect multiple SectionRecommendations component instances */
  create?: InputMaybe<Array<SectionRecommendationsCreateWithPositionInput>>
  /** Delete multiple SectionRecommendations documents */
  delete?: InputMaybe<Array<SectionRecommendationsWhereUniqueInput>>
  /** Update multiple SectionRecommendations component instances */
  update?: InputMaybe<Array<SectionRecommendationsUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionRecommendations component instances */
  upsert?: InputMaybe<Array<SectionRecommendationsUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionRecommendationsUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type SectionRecommendationsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionRecommendationsUpdateManyInput
  /** Document search */
  where: SectionRecommendationsWhereInput
}

export type SectionRecommendationsUpdateOneInlineInput = {
  /** Create and connect one SectionRecommendations document */
  create?: InputMaybe<SectionRecommendationsCreateInput>
  /** Delete currently connected SectionRecommendations document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionRecommendations document */
  update?: InputMaybe<SectionRecommendationsUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionRecommendations document */
  upsert?: InputMaybe<SectionRecommendationsUpsertWithNestedWhereUniqueInput>
}

export type SectionRecommendationsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionRecommendationsUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionRecommendationsWhereUniqueInput
}

export type SectionRecommendationsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionRecommendationsUpdateInput
  /** Unique document search */
  where: SectionRecommendationsWhereUniqueInput
}

export type SectionRecommendationsUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionRecommendationsCreateInput
  /** Update document if it exists */
  update: SectionRecommendationsUpdateInput
}

export type SectionRecommendationsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionRecommendationsUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionRecommendationsWhereUniqueInput
}

export type SectionRecommendationsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionRecommendationsUpsertInput
  /** Unique document search */
  where: SectionRecommendationsWhereUniqueInput
}

/** Identifies documents */
export type SectionRecommendationsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionRecommendationsWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionRecommendationsWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionRecommendationsWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty */
  recommendations_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the union contains at least one connection to the provided item to the filter */
  recommendations_some?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionRecommendations record uniquely */
export type SectionRecommendationsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Table build of Reviews Feature Sections */
export type SectionReviewsFeaturesTable = Entity & {
  __typename?: 'SectionReviewsFeaturesTable'
  featureTableSections: Array<ReviewsFeaturesSection>
  /** Basically the pricing plan names */
  featuresTableColumns: Array<Scalars['String']['output']>
  featuresTableDescription?: Maybe<Scalars['String']['output']>
  featuresTableTitle?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionReviewsFeaturesTable>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Table build of Reviews Feature Sections */
export type SectionReviewsFeaturesTableFeatureTableSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsFeaturesSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsFeaturesSectionWhereInput>
}

/** Table build of Reviews Feature Sections */
export type SectionReviewsFeaturesTableLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Table build of Reviews Feature Sections */
export type SectionReviewsFeaturesTableUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionReviewsFeaturesTableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionReviewsFeaturesTableWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionReviewsFeaturesTableConnection = {
  __typename?: 'SectionReviewsFeaturesTableConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionReviewsFeaturesTableEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionReviewsFeaturesTableCreateInput = {
  featureTableSections?: InputMaybe<ReviewsFeaturesSectionCreateManyInlineInput>
  /** featuresTableColumns input for default locale (de) */
  featuresTableColumns: Array<Scalars['String']['input']>
  /** featuresTableDescription input for default locale (de) */
  featuresTableDescription?: InputMaybe<Scalars['String']['input']>
  /** featuresTableTitle input for default locale (de) */
  featuresTableTitle?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionReviewsFeaturesTableCreateLocalizationsInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionReviewsFeaturesTableCreateLocalizationDataInput = {
  featuresTableColumns: Array<Scalars['String']['input']>
  featuresTableDescription?: InputMaybe<Scalars['String']['input']>
  featuresTableTitle?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionReviewsFeaturesTableCreateLocalizationInput = {
  /** Localization input */
  data: SectionReviewsFeaturesTableCreateLocalizationDataInput
  locale: Locale
}

export type SectionReviewsFeaturesTableCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionReviewsFeaturesTableCreateLocalizationInput>>
}

export type SectionReviewsFeaturesTableCreateManyInlineInput = {
  /** Create and connect multiple existing SectionReviewsFeaturesTable documents */
  create?: InputMaybe<Array<SectionReviewsFeaturesTableCreateInput>>
}

export type SectionReviewsFeaturesTableCreateOneInlineInput = {
  /** Create and connect one SectionReviewsFeaturesTable document */
  create?: InputMaybe<SectionReviewsFeaturesTableCreateInput>
}

export type SectionReviewsFeaturesTableCreateWithPositionInput = {
  /** Document to create */
  data: SectionReviewsFeaturesTableCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionReviewsFeaturesTableEdge = {
  __typename?: 'SectionReviewsFeaturesTableEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionReviewsFeaturesTable
}

/** Identifies documents */
export type SectionReviewsFeaturesTableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionReviewsFeaturesTableWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionReviewsFeaturesTableWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionReviewsFeaturesTableWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  featureTableSections_every?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  featureTableSections_none?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  featureTableSections_some?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionReviewsFeaturesTableOrderByInput {
  FeaturesTableColumnsAsc = 'featuresTableColumns_ASC',
  FeaturesTableColumnsDesc = 'featuresTableColumns_DESC',
  FeaturesTableDescriptionAsc = 'featuresTableDescription_ASC',
  FeaturesTableDescriptionDesc = 'featuresTableDescription_DESC',
  FeaturesTableTitleAsc = 'featuresTableTitle_ASC',
  FeaturesTableTitleDesc = 'featuresTableTitle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionReviewsFeaturesTableParent = LandingPage

export type SectionReviewsFeaturesTableParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionReviewsFeaturesTableParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionReviewsFeaturesTableParentCreateManyInlineInput = {
  /** Connect multiple existing SectionReviewsFeaturesTableParent documents */
  connect?: InputMaybe<Array<SectionReviewsFeaturesTableParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionReviewsFeaturesTableParent documents */
  create?: InputMaybe<Array<SectionReviewsFeaturesTableParentCreateInput>>
}

export type SectionReviewsFeaturesTableParentCreateOneInlineInput = {
  /** Connect one existing SectionReviewsFeaturesTableParent document */
  connect?: InputMaybe<SectionReviewsFeaturesTableParentWhereUniqueInput>
  /** Create and connect one SectionReviewsFeaturesTableParent document */
  create?: InputMaybe<SectionReviewsFeaturesTableParentCreateInput>
}

export type SectionReviewsFeaturesTableParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionReviewsFeaturesTableParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionReviewsFeaturesTableParent documents */
  connect?: InputMaybe<Array<SectionReviewsFeaturesTableParentConnectInput>>
  /** Create and connect multiple SectionReviewsFeaturesTableParent documents */
  create?: InputMaybe<Array<SectionReviewsFeaturesTableParentCreateInput>>
  /** Delete multiple SectionReviewsFeaturesTableParent documents */
  delete?: InputMaybe<Array<SectionReviewsFeaturesTableParentWhereUniqueInput>>
  /** Disconnect multiple SectionReviewsFeaturesTableParent documents */
  disconnect?: InputMaybe<Array<SectionReviewsFeaturesTableParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionReviewsFeaturesTableParent documents */
  set?: InputMaybe<Array<SectionReviewsFeaturesTableParentWhereUniqueInput>>
  /** Update multiple SectionReviewsFeaturesTableParent documents */
  update?: InputMaybe<Array<SectionReviewsFeaturesTableParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionReviewsFeaturesTableParent documents */
  upsert?: InputMaybe<Array<SectionReviewsFeaturesTableParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionReviewsFeaturesTableParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionReviewsFeaturesTableParentUpdateOneInlineInput = {
  /** Connect existing SectionReviewsFeaturesTableParent document */
  connect?: InputMaybe<SectionReviewsFeaturesTableParentWhereUniqueInput>
  /** Create and connect one SectionReviewsFeaturesTableParent document */
  create?: InputMaybe<SectionReviewsFeaturesTableParentCreateInput>
  /** Delete currently connected SectionReviewsFeaturesTableParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionReviewsFeaturesTableParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionReviewsFeaturesTableParent document */
  update?: InputMaybe<SectionReviewsFeaturesTableParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionReviewsFeaturesTableParent document */
  upsert?: InputMaybe<SectionReviewsFeaturesTableParentUpsertWithNestedWhereUniqueInput>
}

export type SectionReviewsFeaturesTableParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionReviewsFeaturesTableParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionReviewsFeaturesTableParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionReviewsFeaturesTableParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionReviewsFeaturesTableUpdateInput = {
  featureTableSections?: InputMaybe<ReviewsFeaturesSectionUpdateManyInlineInput>
  /** featuresTableColumns input for default locale (de) */
  featuresTableColumns?: InputMaybe<Array<Scalars['String']['input']>>
  /** featuresTableDescription input for default locale (de) */
  featuresTableDescription?: InputMaybe<Scalars['String']['input']>
  /** featuresTableTitle input for default locale (de) */
  featuresTableTitle?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionReviewsFeaturesTableUpdateLocalizationsInput>
}

export type SectionReviewsFeaturesTableUpdateLocalizationDataInput = {
  featuresTableColumns?: InputMaybe<Array<Scalars['String']['input']>>
  featuresTableDescription?: InputMaybe<Scalars['String']['input']>
  featuresTableTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionReviewsFeaturesTableUpdateLocalizationInput = {
  data: SectionReviewsFeaturesTableUpdateLocalizationDataInput
  locale: Locale
}

export type SectionReviewsFeaturesTableUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionReviewsFeaturesTableCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionReviewsFeaturesTableUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionReviewsFeaturesTableUpsertLocalizationInput>>
}

export type SectionReviewsFeaturesTableUpdateManyInlineInput = {
  /** Create and connect multiple SectionReviewsFeaturesTable component instances */
  create?: InputMaybe<Array<SectionReviewsFeaturesTableCreateWithPositionInput>>
  /** Delete multiple SectionReviewsFeaturesTable documents */
  delete?: InputMaybe<Array<SectionReviewsFeaturesTableWhereUniqueInput>>
  /** Update multiple SectionReviewsFeaturesTable component instances */
  update?: InputMaybe<Array<SectionReviewsFeaturesTableUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionReviewsFeaturesTable component instances */
  upsert?: InputMaybe<Array<SectionReviewsFeaturesTableUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionReviewsFeaturesTableUpdateManyInput = {
  /** featuresTableColumns input for default locale (de) */
  featuresTableColumns?: InputMaybe<Array<Scalars['String']['input']>>
  /** featuresTableDescription input for default locale (de) */
  featuresTableDescription?: InputMaybe<Scalars['String']['input']>
  /** featuresTableTitle input for default locale (de) */
  featuresTableTitle?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionReviewsFeaturesTableUpdateManyLocalizationsInput>
}

export type SectionReviewsFeaturesTableUpdateManyLocalizationDataInput = {
  featuresTableColumns?: InputMaybe<Array<Scalars['String']['input']>>
  featuresTableDescription?: InputMaybe<Scalars['String']['input']>
  featuresTableTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionReviewsFeaturesTableUpdateManyLocalizationInput = {
  data: SectionReviewsFeaturesTableUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionReviewsFeaturesTableUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionReviewsFeaturesTableUpdateManyLocalizationInput>>
}

export type SectionReviewsFeaturesTableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionReviewsFeaturesTableUpdateManyInput
  /** Document search */
  where: SectionReviewsFeaturesTableWhereInput
}

export type SectionReviewsFeaturesTableUpdateOneInlineInput = {
  /** Create and connect one SectionReviewsFeaturesTable document */
  create?: InputMaybe<SectionReviewsFeaturesTableCreateInput>
  /** Delete currently connected SectionReviewsFeaturesTable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionReviewsFeaturesTable document */
  update?: InputMaybe<SectionReviewsFeaturesTableUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionReviewsFeaturesTable document */
  upsert?: InputMaybe<SectionReviewsFeaturesTableUpsertWithNestedWhereUniqueInput>
}

export type SectionReviewsFeaturesTableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionReviewsFeaturesTableUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionReviewsFeaturesTableWhereUniqueInput
}

export type SectionReviewsFeaturesTableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionReviewsFeaturesTableUpdateInput
  /** Unique document search */
  where: SectionReviewsFeaturesTableWhereUniqueInput
}

export type SectionReviewsFeaturesTableUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionReviewsFeaturesTableCreateInput
  /** Update document if it exists */
  update: SectionReviewsFeaturesTableUpdateInput
}

export type SectionReviewsFeaturesTableUpsertLocalizationInput = {
  create: SectionReviewsFeaturesTableCreateLocalizationDataInput
  locale: Locale
  update: SectionReviewsFeaturesTableUpdateLocalizationDataInput
}

export type SectionReviewsFeaturesTableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionReviewsFeaturesTableUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionReviewsFeaturesTableWhereUniqueInput
}

export type SectionReviewsFeaturesTableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionReviewsFeaturesTableUpsertInput
  /** Unique document search */
  where: SectionReviewsFeaturesTableWhereUniqueInput
}

/** Identifies documents */
export type SectionReviewsFeaturesTableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionReviewsFeaturesTableWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionReviewsFeaturesTableWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionReviewsFeaturesTableWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  featureTableSections_every?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  featureTableSections_none?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  featureTableSections_some?: InputMaybe<ReviewsFeaturesSectionWhereInput>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  featuresTableColumns?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  featuresTableColumns_contains_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  featuresTableColumns_contains_none?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  featuresTableColumns_contains_some?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  featuresTableColumns_not?: InputMaybe<Array<Scalars['String']['input']>>
  featuresTableDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  featuresTableDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  featuresTableDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  featuresTableDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  featuresTableDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  featuresTableDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  featuresTableDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  featuresTableDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  featuresTableDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  featuresTableDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  featuresTableTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  featuresTableTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  featuresTableTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  featuresTableTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  featuresTableTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  featuresTableTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  featuresTableTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  featuresTableTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  featuresTableTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  featuresTableTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionReviewsFeaturesTable record uniquely */
export type SectionReviewsFeaturesTableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section for Slim CTA */
export type SectionSlimCta = Entity & {
  __typename?: 'SectionSlimCta'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionSlimCta>
  slimCtaBody: Scalars['String']['output']
  slimCtaCta?: Maybe<CallToAction>
  /** Reference: https://lucide.dev/icons/ */
  slimCtaHeaderIcon?: Maybe<LucideIcon>
  slimCtaHeadline?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section for Slim CTA */
export type SectionSlimCtaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section for Slim CTA */
export type SectionSlimCtaSlimCtaCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section for Slim CTA */
export type SectionSlimCtaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionSlimCtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionSlimCtaWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionSlimCtaConnection = {
  __typename?: 'SectionSlimCtaConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionSlimCtaEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionSlimCtaCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionSlimCtaCreateLocalizationsInput>
  /** slimCtaBody input for default locale (de) */
  slimCtaBody: Scalars['String']['input']
  slimCtaCta?: InputMaybe<CallToActionCreateOneInlineInput>
  slimCtaHeaderIcon?: InputMaybe<LucideIcon>
  /** slimCtaHeadline input for default locale (de) */
  slimCtaHeadline?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionSlimCtaCreateLocalizationDataInput = {
  slimCtaBody: Scalars['String']['input']
  slimCtaHeadline?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionSlimCtaCreateLocalizationInput = {
  /** Localization input */
  data: SectionSlimCtaCreateLocalizationDataInput
  locale: Locale
}

export type SectionSlimCtaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionSlimCtaCreateLocalizationInput>>
}

export type SectionSlimCtaCreateManyInlineInput = {
  /** Create and connect multiple existing SectionSlimCta documents */
  create?: InputMaybe<Array<SectionSlimCtaCreateInput>>
}

export type SectionSlimCtaCreateOneInlineInput = {
  /** Create and connect one SectionSlimCta document */
  create?: InputMaybe<SectionSlimCtaCreateInput>
}

export type SectionSlimCtaCreateWithPositionInput = {
  /** Document to create */
  data: SectionSlimCtaCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionSlimCtaEdge = {
  __typename?: 'SectionSlimCtaEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionSlimCta
}

/** Identifies documents */
export type SectionSlimCtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionSlimCtaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionSlimCtaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionSlimCtaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  slimCtaCta?: InputMaybe<CallToActionWhereInput>
  slimCtaHeaderIcon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  slimCtaHeaderIcon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  slimCtaHeaderIcon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  slimCtaHeaderIcon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionSlimCtaOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SlimCtaBodyAsc = 'slimCtaBody_ASC',
  SlimCtaBodyDesc = 'slimCtaBody_DESC',
  SlimCtaHeaderIconAsc = 'slimCtaHeaderIcon_ASC',
  SlimCtaHeaderIconDesc = 'slimCtaHeaderIcon_DESC',
  SlimCtaHeadlineAsc = 'slimCtaHeadline_ASC',
  SlimCtaHeadlineDesc = 'slimCtaHeadline_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionSlimCtaParent = LandingPage

export type SectionSlimCtaParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionSlimCtaParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionSlimCtaParentCreateManyInlineInput = {
  /** Connect multiple existing SectionSlimCtaParent documents */
  connect?: InputMaybe<Array<SectionSlimCtaParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionSlimCtaParent documents */
  create?: InputMaybe<Array<SectionSlimCtaParentCreateInput>>
}

export type SectionSlimCtaParentCreateOneInlineInput = {
  /** Connect one existing SectionSlimCtaParent document */
  connect?: InputMaybe<SectionSlimCtaParentWhereUniqueInput>
  /** Create and connect one SectionSlimCtaParent document */
  create?: InputMaybe<SectionSlimCtaParentCreateInput>
}

export type SectionSlimCtaParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionSlimCtaParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionSlimCtaParent documents */
  connect?: InputMaybe<Array<SectionSlimCtaParentConnectInput>>
  /** Create and connect multiple SectionSlimCtaParent documents */
  create?: InputMaybe<Array<SectionSlimCtaParentCreateInput>>
  /** Delete multiple SectionSlimCtaParent documents */
  delete?: InputMaybe<Array<SectionSlimCtaParentWhereUniqueInput>>
  /** Disconnect multiple SectionSlimCtaParent documents */
  disconnect?: InputMaybe<Array<SectionSlimCtaParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionSlimCtaParent documents */
  set?: InputMaybe<Array<SectionSlimCtaParentWhereUniqueInput>>
  /** Update multiple SectionSlimCtaParent documents */
  update?: InputMaybe<Array<SectionSlimCtaParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionSlimCtaParent documents */
  upsert?: InputMaybe<Array<SectionSlimCtaParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionSlimCtaParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionSlimCtaParentUpdateOneInlineInput = {
  /** Connect existing SectionSlimCtaParent document */
  connect?: InputMaybe<SectionSlimCtaParentWhereUniqueInput>
  /** Create and connect one SectionSlimCtaParent document */
  create?: InputMaybe<SectionSlimCtaParentCreateInput>
  /** Delete currently connected SectionSlimCtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionSlimCtaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionSlimCtaParent document */
  update?: InputMaybe<SectionSlimCtaParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionSlimCtaParent document */
  upsert?: InputMaybe<SectionSlimCtaParentUpsertWithNestedWhereUniqueInput>
}

export type SectionSlimCtaParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionSlimCtaParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionSlimCtaParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionSlimCtaParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionSlimCtaUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<SectionSlimCtaUpdateLocalizationsInput>
  /** slimCtaBody input for default locale (de) */
  slimCtaBody?: InputMaybe<Scalars['String']['input']>
  slimCtaCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  slimCtaHeaderIcon?: InputMaybe<LucideIcon>
  /** slimCtaHeadline input for default locale (de) */
  slimCtaHeadline?: InputMaybe<Scalars['String']['input']>
}

export type SectionSlimCtaUpdateLocalizationDataInput = {
  slimCtaBody?: InputMaybe<Scalars['String']['input']>
  slimCtaHeadline?: InputMaybe<Scalars['String']['input']>
}

export type SectionSlimCtaUpdateLocalizationInput = {
  data: SectionSlimCtaUpdateLocalizationDataInput
  locale: Locale
}

export type SectionSlimCtaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionSlimCtaCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionSlimCtaUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionSlimCtaUpsertLocalizationInput>>
}

export type SectionSlimCtaUpdateManyInlineInput = {
  /** Create and connect multiple SectionSlimCta component instances */
  create?: InputMaybe<Array<SectionSlimCtaCreateWithPositionInput>>
  /** Delete multiple SectionSlimCta documents */
  delete?: InputMaybe<Array<SectionSlimCtaWhereUniqueInput>>
  /** Update multiple SectionSlimCta component instances */
  update?: InputMaybe<Array<SectionSlimCtaUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionSlimCta component instances */
  upsert?: InputMaybe<Array<SectionSlimCtaUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionSlimCtaUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionSlimCtaUpdateManyLocalizationsInput>
  /** slimCtaBody input for default locale (de) */
  slimCtaBody?: InputMaybe<Scalars['String']['input']>
  slimCtaHeaderIcon?: InputMaybe<LucideIcon>
  /** slimCtaHeadline input for default locale (de) */
  slimCtaHeadline?: InputMaybe<Scalars['String']['input']>
}

export type SectionSlimCtaUpdateManyLocalizationDataInput = {
  slimCtaBody?: InputMaybe<Scalars['String']['input']>
  slimCtaHeadline?: InputMaybe<Scalars['String']['input']>
}

export type SectionSlimCtaUpdateManyLocalizationInput = {
  data: SectionSlimCtaUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionSlimCtaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionSlimCtaUpdateManyLocalizationInput>>
}

export type SectionSlimCtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionSlimCtaUpdateManyInput
  /** Document search */
  where: SectionSlimCtaWhereInput
}

export type SectionSlimCtaUpdateOneInlineInput = {
  /** Create and connect one SectionSlimCta document */
  create?: InputMaybe<SectionSlimCtaCreateInput>
  /** Delete currently connected SectionSlimCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionSlimCta document */
  update?: InputMaybe<SectionSlimCtaUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionSlimCta document */
  upsert?: InputMaybe<SectionSlimCtaUpsertWithNestedWhereUniqueInput>
}

export type SectionSlimCtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionSlimCtaUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionSlimCtaWhereUniqueInput
}

export type SectionSlimCtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionSlimCtaUpdateInput
  /** Unique document search */
  where: SectionSlimCtaWhereUniqueInput
}

export type SectionSlimCtaUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionSlimCtaCreateInput
  /** Update document if it exists */
  update: SectionSlimCtaUpdateInput
}

export type SectionSlimCtaUpsertLocalizationInput = {
  create: SectionSlimCtaCreateLocalizationDataInput
  locale: Locale
  update: SectionSlimCtaUpdateLocalizationDataInput
}

export type SectionSlimCtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionSlimCtaUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionSlimCtaWhereUniqueInput
}

export type SectionSlimCtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionSlimCtaUpsertInput
  /** Unique document search */
  where: SectionSlimCtaWhereUniqueInput
}

/** Identifies documents */
export type SectionSlimCtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionSlimCtaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionSlimCtaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionSlimCtaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  slimCtaBody?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slimCtaBody_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slimCtaBody_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slimCtaBody_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slimCtaBody_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slimCtaBody_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slimCtaBody_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slimCtaBody_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slimCtaBody_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slimCtaBody_starts_with?: InputMaybe<Scalars['String']['input']>
  slimCtaCta?: InputMaybe<CallToActionWhereInput>
  slimCtaHeaderIcon?: InputMaybe<LucideIcon>
  /** All values that are contained in given list. */
  slimCtaHeaderIcon_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  /** Any other value that exists and is not equal to the given value. */
  slimCtaHeaderIcon_not?: InputMaybe<LucideIcon>
  /** All values that are not contained in given list. */
  slimCtaHeaderIcon_not_in?: InputMaybe<Array<InputMaybe<LucideIcon>>>
  slimCtaHeadline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slimCtaHeadline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slimCtaHeadline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slimCtaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slimCtaHeadline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slimCtaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slimCtaHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slimCtaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slimCtaHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slimCtaHeadline_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionSlimCta record uniquely */
export type SectionSlimCtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakers = Entity & {
  __typename?: 'SectionSpeakers'
  /** Call to action element */
  cta?: Maybe<CallToAction>
  darkHeader?: Maybe<Scalars['Boolean']['output']>
  description: Scalars['String']['output']
  enableBookmarking?: Maybe<Scalars['Boolean']['output']>
  /** Enables the journey filter for the speakers section. Off by default. */
  enableJourneyFilter?: Maybe<Scalars['Boolean']['output']>
  /** The event whose speakers this section shows, e.g. omr27. Leave empty to use the event this page belongs to. The selected speaker list must belong to the same event, otherwise nothing is shown in filter mode. The day filter and bookmarks follow this event as well. */
  event?: Maybe<Event>
  eventStage?: Maybe<EventStage>
  /** If value set, only those speakers will be shown that has corresponding event type associated to them. */
  eventType?: Maybe<SpeakerEventTypes>
  hideDayFilter?: Maybe<Scalars['Boolean']['output']>
  hideDetailPages?: Maybe<Scalars['Boolean']['output']>
  hideFilters?: Maybe<Scalars['Boolean']['output']>
  hideInterestTags?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Applies interest filter for the incoming data. */
  interestFilter?: Maybe<Interest>
  /** Select interests to filter speakers. Multiple selection supported. */
  interestsFilter: Array<Interest>
  /** This option will set if provided ordered list will be used to filter or to sort the result set. */
  listOption: ResultCreationOptions
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionSpeakers>
  /** Selected custom sorting model for the speakers. */
  order?: Maybe<SpeakerListOrder>
  pageSize?: Maybe<Scalars['Int']['output']>
  showFfwd?: Maybe<Scalars['Boolean']['output']>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakersCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakersEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakersEventStageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakersInterestFilterArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakersInterestsFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestWhereInput>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakersLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakersOrderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section showing a filterable grid of Speakers from MyOMR datasource. Old SpeakerSection component is depracated and should be used only for static list generation. */
export type SectionSpeakersUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionSpeakersConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionSpeakersWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionSpeakersConnection = {
  __typename?: 'SectionSpeakersConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionSpeakersEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionSpeakersCreateInput = {
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  event?: InputMaybe<EventCreateOneInlineInput>
  eventStage?: InputMaybe<EventStageCreateOneInlineInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  hideDayFilter?: InputMaybe<Scalars['Boolean']['input']>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  hideInterestTags?: InputMaybe<Scalars['Boolean']['input']>
  interestFilter?: InputMaybe<InterestCreateOneInlineInput>
  interestsFilter?: InputMaybe<InterestCreateManyInlineInput>
  listOption: ResultCreationOptions
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionSpeakersCreateLocalizationsInput>
  order?: InputMaybe<SpeakerListOrderCreateOneInlineInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  showFfwd?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionSpeakersCreateLocalizationDataInput = {
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionSpeakersCreateLocalizationInput = {
  /** Localization input */
  data: SectionSpeakersCreateLocalizationDataInput
  locale: Locale
}

export type SectionSpeakersCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionSpeakersCreateLocalizationInput>>
}

export type SectionSpeakersCreateManyInlineInput = {
  /** Create and connect multiple existing SectionSpeakers documents */
  create?: InputMaybe<Array<SectionSpeakersCreateInput>>
}

export type SectionSpeakersCreateOneInlineInput = {
  /** Create and connect one SectionSpeakers document */
  create?: InputMaybe<SectionSpeakersCreateInput>
}

export type SectionSpeakersCreateWithPositionInput = {
  /** Document to create */
  data: SectionSpeakersCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionSpeakersEdge = {
  __typename?: 'SectionSpeakersEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionSpeakers
}

/** Identifies documents */
export type SectionSpeakersManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionSpeakersWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionSpeakersWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionSpeakersWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkHeader_not?: InputMaybe<Scalars['Boolean']['input']>
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableBookmarking_not?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableJourneyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  event?: InputMaybe<EventWhereInput>
  eventStage?: InputMaybe<EventStageWhereInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  /** All values that are contained in given list. */
  eventType_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  /** Any other value that exists and is not equal to the given value. */
  eventType_not?: InputMaybe<SpeakerEventTypes>
  /** All values that are not contained in given list. */
  eventType_not_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  hideDayFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideDayFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideDetailPages_not?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideFilters_not?: InputMaybe<Scalars['Boolean']['input']>
  hideInterestTags?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideInterestTags_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interestFilter?: InputMaybe<InterestWhereInput>
  interestsFilter_every?: InputMaybe<InterestWhereInput>
  interestsFilter_none?: InputMaybe<InterestWhereInput>
  interestsFilter_some?: InputMaybe<InterestWhereInput>
  listOption?: InputMaybe<ResultCreationOptions>
  /** All values that are contained in given list. */
  listOption_in?: InputMaybe<Array<InputMaybe<ResultCreationOptions>>>
  /** Any other value that exists and is not equal to the given value. */
  listOption_not?: InputMaybe<ResultCreationOptions>
  /** All values that are not contained in given list. */
  listOption_not_in?: InputMaybe<Array<InputMaybe<ResultCreationOptions>>>
  order?: InputMaybe<SpeakerListOrderWhereInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageSize_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageSize_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageSize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageSize_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageSize_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageSize_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  showFfwd?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showFfwd_not?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionSpeakersOrderByInput {
  DarkHeaderAsc = 'darkHeader_ASC',
  DarkHeaderDesc = 'darkHeader_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EnableBookmarkingAsc = 'enableBookmarking_ASC',
  EnableBookmarkingDesc = 'enableBookmarking_DESC',
  EnableJourneyFilterAsc = 'enableJourneyFilter_ASC',
  EnableJourneyFilterDesc = 'enableJourneyFilter_DESC',
  EventTypeAsc = 'eventType_ASC',
  EventTypeDesc = 'eventType_DESC',
  HideDayFilterAsc = 'hideDayFilter_ASC',
  HideDayFilterDesc = 'hideDayFilter_DESC',
  HideDetailPagesAsc = 'hideDetailPages_ASC',
  HideDetailPagesDesc = 'hideDetailPages_DESC',
  HideFiltersAsc = 'hideFilters_ASC',
  HideFiltersDesc = 'hideFilters_DESC',
  HideInterestTagsAsc = 'hideInterestTags_ASC',
  HideInterestTagsDesc = 'hideInterestTags_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ListOptionAsc = 'listOption_ASC',
  ListOptionDesc = 'listOption_DESC',
  PageSizeAsc = 'pageSize_ASC',
  PageSizeDesc = 'pageSize_DESC',
  ShowFfwdAsc = 'showFfwd_ASC',
  ShowFfwdDesc = 'showFfwd_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionSpeakersParent = EventPage

export type SectionSpeakersParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionSpeakersParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionSpeakersParentCreateManyInlineInput = {
  /** Connect multiple existing SectionSpeakersParent documents */
  connect?: InputMaybe<Array<SectionSpeakersParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionSpeakersParent documents */
  create?: InputMaybe<Array<SectionSpeakersParentCreateInput>>
}

export type SectionSpeakersParentCreateOneInlineInput = {
  /** Connect one existing SectionSpeakersParent document */
  connect?: InputMaybe<SectionSpeakersParentWhereUniqueInput>
  /** Create and connect one SectionSpeakersParent document */
  create?: InputMaybe<SectionSpeakersParentCreateInput>
}

export type SectionSpeakersParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionSpeakersParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionSpeakersParent documents */
  connect?: InputMaybe<Array<SectionSpeakersParentConnectInput>>
  /** Create and connect multiple SectionSpeakersParent documents */
  create?: InputMaybe<Array<SectionSpeakersParentCreateInput>>
  /** Delete multiple SectionSpeakersParent documents */
  delete?: InputMaybe<Array<SectionSpeakersParentWhereUniqueInput>>
  /** Disconnect multiple SectionSpeakersParent documents */
  disconnect?: InputMaybe<Array<SectionSpeakersParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionSpeakersParent documents */
  set?: InputMaybe<Array<SectionSpeakersParentWhereUniqueInput>>
  /** Update multiple SectionSpeakersParent documents */
  update?: InputMaybe<Array<SectionSpeakersParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionSpeakersParent documents */
  upsert?: InputMaybe<Array<SectionSpeakersParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionSpeakersParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionSpeakersParentUpdateOneInlineInput = {
  /** Connect existing SectionSpeakersParent document */
  connect?: InputMaybe<SectionSpeakersParentWhereUniqueInput>
  /** Create and connect one SectionSpeakersParent document */
  create?: InputMaybe<SectionSpeakersParentCreateInput>
  /** Delete currently connected SectionSpeakersParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionSpeakersParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionSpeakersParent document */
  update?: InputMaybe<SectionSpeakersParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionSpeakersParent document */
  upsert?: InputMaybe<SectionSpeakersParentUpsertWithNestedWhereUniqueInput>
}

export type SectionSpeakersParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionSpeakersParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionSpeakersParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionSpeakersParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionSpeakersUpdateInput = {
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  event?: InputMaybe<EventUpdateOneInlineInput>
  eventStage?: InputMaybe<EventStageUpdateOneInlineInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  hideDayFilter?: InputMaybe<Scalars['Boolean']['input']>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  hideInterestTags?: InputMaybe<Scalars['Boolean']['input']>
  interestFilter?: InputMaybe<InterestUpdateOneInlineInput>
  interestsFilter?: InputMaybe<InterestUpdateManyInlineInput>
  listOption?: InputMaybe<ResultCreationOptions>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionSpeakersUpdateLocalizationsInput>
  order?: InputMaybe<SpeakerListOrderUpdateOneInlineInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  showFfwd?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionSpeakersUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionSpeakersUpdateLocalizationInput = {
  data: SectionSpeakersUpdateLocalizationDataInput
  locale: Locale
}

export type SectionSpeakersUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionSpeakersCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionSpeakersUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionSpeakersUpsertLocalizationInput>>
}

export type SectionSpeakersUpdateManyInlineInput = {
  /** Create and connect multiple SectionSpeakers component instances */
  create?: InputMaybe<Array<SectionSpeakersCreateWithPositionInput>>
  /** Delete multiple SectionSpeakers documents */
  delete?: InputMaybe<Array<SectionSpeakersWhereUniqueInput>>
  /** Update multiple SectionSpeakers component instances */
  update?: InputMaybe<Array<SectionSpeakersUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionSpeakers component instances */
  upsert?: InputMaybe<Array<SectionSpeakersUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionSpeakersUpdateManyInput = {
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  eventType?: InputMaybe<SpeakerEventTypes>
  hideDayFilter?: InputMaybe<Scalars['Boolean']['input']>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  hideInterestTags?: InputMaybe<Scalars['Boolean']['input']>
  listOption?: InputMaybe<ResultCreationOptions>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionSpeakersUpdateManyLocalizationsInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  showFfwd?: InputMaybe<Scalars['Boolean']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionSpeakersUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionSpeakersUpdateManyLocalizationInput = {
  data: SectionSpeakersUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionSpeakersUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionSpeakersUpdateManyLocalizationInput>>
}

export type SectionSpeakersUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionSpeakersUpdateManyInput
  /** Document search */
  where: SectionSpeakersWhereInput
}

export type SectionSpeakersUpdateOneInlineInput = {
  /** Create and connect one SectionSpeakers document */
  create?: InputMaybe<SectionSpeakersCreateInput>
  /** Delete currently connected SectionSpeakers document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionSpeakers document */
  update?: InputMaybe<SectionSpeakersUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionSpeakers document */
  upsert?: InputMaybe<SectionSpeakersUpsertWithNestedWhereUniqueInput>
}

export type SectionSpeakersUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionSpeakersUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionSpeakersWhereUniqueInput
}

export type SectionSpeakersUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionSpeakersUpdateInput
  /** Unique document search */
  where: SectionSpeakersWhereUniqueInput
}

export type SectionSpeakersUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionSpeakersCreateInput
  /** Update document if it exists */
  update: SectionSpeakersUpdateInput
}

export type SectionSpeakersUpsertLocalizationInput = {
  create: SectionSpeakersCreateLocalizationDataInput
  locale: Locale
  update: SectionSpeakersUpdateLocalizationDataInput
}

export type SectionSpeakersUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionSpeakersUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionSpeakersWhereUniqueInput
}

export type SectionSpeakersUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionSpeakersUpsertInput
  /** Unique document search */
  where: SectionSpeakersWhereUniqueInput
}

/** Identifies documents */
export type SectionSpeakersWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionSpeakersWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionSpeakersWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionSpeakersWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkHeader_not?: InputMaybe<Scalars['Boolean']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  enableBookmarking?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableBookmarking_not?: InputMaybe<Scalars['Boolean']['input']>
  enableJourneyFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableJourneyFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  event?: InputMaybe<EventWhereInput>
  eventStage?: InputMaybe<EventStageWhereInput>
  eventType?: InputMaybe<SpeakerEventTypes>
  /** All values that are contained in given list. */
  eventType_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  /** Any other value that exists and is not equal to the given value. */
  eventType_not?: InputMaybe<SpeakerEventTypes>
  /** All values that are not contained in given list. */
  eventType_not_in?: InputMaybe<Array<InputMaybe<SpeakerEventTypes>>>
  hideDayFilter?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideDayFilter_not?: InputMaybe<Scalars['Boolean']['input']>
  hideDetailPages?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideDetailPages_not?: InputMaybe<Scalars['Boolean']['input']>
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideFilters_not?: InputMaybe<Scalars['Boolean']['input']>
  hideInterestTags?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideInterestTags_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  interestFilter?: InputMaybe<InterestWhereInput>
  interestsFilter_every?: InputMaybe<InterestWhereInput>
  interestsFilter_none?: InputMaybe<InterestWhereInput>
  interestsFilter_some?: InputMaybe<InterestWhereInput>
  listOption?: InputMaybe<ResultCreationOptions>
  /** All values that are contained in given list. */
  listOption_in?: InputMaybe<Array<InputMaybe<ResultCreationOptions>>>
  /** Any other value that exists and is not equal to the given value. */
  listOption_not?: InputMaybe<ResultCreationOptions>
  /** All values that are not contained in given list. */
  listOption_not_in?: InputMaybe<Array<InputMaybe<ResultCreationOptions>>>
  order?: InputMaybe<SpeakerListOrderWhereInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  pageSize_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  pageSize_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  pageSize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  pageSize_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  pageSize_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  pageSize_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  pageSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  showFfwd?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  showFfwd_not?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionSpeakers record uniquely */
export type SectionSpeakersWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionStorytelling = Entity & {
  __typename?: 'SectionStorytelling'
  benefitsCard: Array<BenefitsCard>
  ctaText: Scalars['String']['output']
  ctaUrl?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  /** Overrides any URL - important, Hubspot must be loaded on this page through TagManager */
  hubspot?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionStorytelling>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionStorytellingBenefitsCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<BenefitsCardOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BenefitsCardWhereInput>
}

export type SectionStorytellingLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionStorytellingUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionStorytellingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionStorytellingWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionStorytellingConnection = {
  __typename?: 'SectionStorytellingConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionStorytellingEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionStorytellingCreateInput = {
  benefitsCard?: InputMaybe<BenefitsCardCreateManyInlineInput>
  /** ctaText input for default locale (de) */
  ctaText: Scalars['String']['input']
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  hubspot?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionStorytellingCreateLocalizationsInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionStorytellingCreateLocalizationDataInput = {
  ctaText: Scalars['String']['input']
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionStorytellingCreateLocalizationInput = {
  /** Localization input */
  data: SectionStorytellingCreateLocalizationDataInput
  locale: Locale
}

export type SectionStorytellingCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionStorytellingCreateLocalizationInput>>
}

export type SectionStorytellingCreateManyInlineInput = {
  /** Create and connect multiple existing SectionStorytelling documents */
  create?: InputMaybe<Array<SectionStorytellingCreateInput>>
}

export type SectionStorytellingCreateOneInlineInput = {
  /** Create and connect one SectionStorytelling document */
  create?: InputMaybe<SectionStorytellingCreateInput>
}

export type SectionStorytellingCreateWithPositionInput = {
  /** Document to create */
  data: SectionStorytellingCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionStorytellingEdge = {
  __typename?: 'SectionStorytellingEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionStorytelling
}

/** Identifies documents */
export type SectionStorytellingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionStorytellingWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionStorytellingWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionStorytellingWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  benefitsCard_every?: InputMaybe<BenefitsCardWhereInput>
  benefitsCard_none?: InputMaybe<BenefitsCardWhereInput>
  benefitsCard_some?: InputMaybe<BenefitsCardWhereInput>
  hubspot?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hubspot_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionStorytellingOrderByInput {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HubspotAsc = 'hubspot_ASC',
  HubspotDesc = 'hubspot_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionStorytellingParent = EventPage

export type SectionStorytellingParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionStorytellingParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionStorytellingParentCreateManyInlineInput = {
  /** Connect multiple existing SectionStorytellingParent documents */
  connect?: InputMaybe<Array<SectionStorytellingParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionStorytellingParent documents */
  create?: InputMaybe<Array<SectionStorytellingParentCreateInput>>
}

export type SectionStorytellingParentCreateOneInlineInput = {
  /** Connect one existing SectionStorytellingParent document */
  connect?: InputMaybe<SectionStorytellingParentWhereUniqueInput>
  /** Create and connect one SectionStorytellingParent document */
  create?: InputMaybe<SectionStorytellingParentCreateInput>
}

export type SectionStorytellingParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionStorytellingParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionStorytellingParent documents */
  connect?: InputMaybe<Array<SectionStorytellingParentConnectInput>>
  /** Create and connect multiple SectionStorytellingParent documents */
  create?: InputMaybe<Array<SectionStorytellingParentCreateInput>>
  /** Delete multiple SectionStorytellingParent documents */
  delete?: InputMaybe<Array<SectionStorytellingParentWhereUniqueInput>>
  /** Disconnect multiple SectionStorytellingParent documents */
  disconnect?: InputMaybe<Array<SectionStorytellingParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionStorytellingParent documents */
  set?: InputMaybe<Array<SectionStorytellingParentWhereUniqueInput>>
  /** Update multiple SectionStorytellingParent documents */
  update?: InputMaybe<Array<SectionStorytellingParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionStorytellingParent documents */
  upsert?: InputMaybe<Array<SectionStorytellingParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionStorytellingParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionStorytellingParentUpdateOneInlineInput = {
  /** Connect existing SectionStorytellingParent document */
  connect?: InputMaybe<SectionStorytellingParentWhereUniqueInput>
  /** Create and connect one SectionStorytellingParent document */
  create?: InputMaybe<SectionStorytellingParentCreateInput>
  /** Delete currently connected SectionStorytellingParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionStorytellingParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionStorytellingParent document */
  update?: InputMaybe<SectionStorytellingParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionStorytellingParent document */
  upsert?: InputMaybe<SectionStorytellingParentUpsertWithNestedWhereUniqueInput>
}

export type SectionStorytellingParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionStorytellingParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionStorytellingParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionStorytellingParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionStorytellingUpdateInput = {
  benefitsCard?: InputMaybe<BenefitsCardUpdateManyInlineInput>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hubspot?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionStorytellingUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionStorytellingUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionStorytellingUpdateLocalizationInput = {
  data: SectionStorytellingUpdateLocalizationDataInput
  locale: Locale
}

export type SectionStorytellingUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionStorytellingCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionStorytellingUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionStorytellingUpsertLocalizationInput>>
}

export type SectionStorytellingUpdateManyInlineInput = {
  /** Create and connect multiple SectionStorytelling component instances */
  create?: InputMaybe<Array<SectionStorytellingCreateWithPositionInput>>
  /** Delete multiple SectionStorytelling documents */
  delete?: InputMaybe<Array<SectionStorytellingWhereUniqueInput>>
  /** Update multiple SectionStorytelling component instances */
  update?: InputMaybe<Array<SectionStorytellingUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionStorytelling component instances */
  upsert?: InputMaybe<Array<SectionStorytellingUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionStorytellingUpdateManyInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hubspot?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionStorytellingUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionStorytellingUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionStorytellingUpdateManyLocalizationInput = {
  data: SectionStorytellingUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionStorytellingUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionStorytellingUpdateManyLocalizationInput>>
}

export type SectionStorytellingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionStorytellingUpdateManyInput
  /** Document search */
  where: SectionStorytellingWhereInput
}

export type SectionStorytellingUpdateOneInlineInput = {
  /** Create and connect one SectionStorytelling document */
  create?: InputMaybe<SectionStorytellingCreateInput>
  /** Delete currently connected SectionStorytelling document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionStorytelling document */
  update?: InputMaybe<SectionStorytellingUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionStorytelling document */
  upsert?: InputMaybe<SectionStorytellingUpsertWithNestedWhereUniqueInput>
}

export type SectionStorytellingUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionStorytellingUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionStorytellingWhereUniqueInput
}

export type SectionStorytellingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionStorytellingUpdateInput
  /** Unique document search */
  where: SectionStorytellingWhereUniqueInput
}

export type SectionStorytellingUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionStorytellingCreateInput
  /** Update document if it exists */
  update: SectionStorytellingUpdateInput
}

export type SectionStorytellingUpsertLocalizationInput = {
  create: SectionStorytellingCreateLocalizationDataInput
  locale: Locale
  update: SectionStorytellingUpdateLocalizationDataInput
}

export type SectionStorytellingUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionStorytellingUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionStorytellingWhereUniqueInput
}

export type SectionStorytellingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionStorytellingUpsertInput
  /** Unique document search */
  where: SectionStorytellingWhereUniqueInput
}

/** Identifies documents */
export type SectionStorytellingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionStorytellingWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionStorytellingWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionStorytellingWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  benefitsCard_every?: InputMaybe<BenefitsCardWhereInput>
  benefitsCard_none?: InputMaybe<BenefitsCardWhereInput>
  benefitsCard_some?: InputMaybe<BenefitsCardWhereInput>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  hubspot?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hubspot_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionStorytelling record uniquely */
export type SectionStorytellingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Hero section with predefined styles */
export type SectionStyledHero = Entity & {
  __typename?: 'SectionStyledHero'
  /** Textline with additional info below the buttons */
  additionalText?: Maybe<Scalars['String']['output']>
  /** USE STYLE TOGETHER WITH THEME INSTEAD */
  backgroundColor?: Maybe<SectionStyledHeroBackground>
  /** 4:3 aspect ratio image - only applicable for primary landing page split image style */
  constrainImage?: Maybe<Scalars['Boolean']['output']>
  /** Section description with markdown support */
  description?: Maybe<Scalars['String']['output']>
  /** USE NEW HERO IMAGE COMPONENT */
  desktopImage?: Maybe<Asset>
  /** Responsive images/video with layout options. */
  heroImage?: Maybe<HeroImage>
  /** Second media element for Split Image layouts. */
  heroImageRight?: Maybe<HeroImage>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** USE NEW HERO IMAGE COMPONENT */
  laptopImage?: Maybe<Asset>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionStyledHero>
  /** USE NEW HERO IMAGE COMPONENT */
  mobileImage?: Maybe<Asset>
  /** Determines the height of the component. */
  paddingSize?: Maybe<PaddingSize>
  partnerBadge?: Maybe<PartnerBadge>
  primaryCta?: Maybe<CallToAction>
  secondaryCta?: Maybe<CallToAction>
  /** A spacer element in px for the bottom of the styled hero to create empty space and increase height. Only available for Left variants, please refer to component library for examples. */
  spacer?: Maybe<Scalars['Int']['output']>
  /** System stage field */
  stage: Stage
  /** Choose a variant. Note that not all elements can be displayed for each variant. See Figma for an overview of all variants. */
  style: SectionStyledHeroStyle
  /** Choose a style. Default is White/Black depending on the theme. */
  styleVariant?: Maybe<OmrStyleVariant>
  /** USE NEW HERO IMAGE COMPONENT */
  tabletImage?: Maybe<Asset>
  theme: OmrThemeVariant
  title: HighlightedText
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Hero section with predefined styles */
export type SectionStyledHeroDesktopImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Hero section with predefined styles */
export type SectionStyledHeroHeroImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero section with predefined styles */
export type SectionStyledHeroHeroImageRightArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero section with predefined styles */
export type SectionStyledHeroLaptopImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Hero section with predefined styles */
export type SectionStyledHeroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Hero section with predefined styles */
export type SectionStyledHeroMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Hero section with predefined styles */
export type SectionStyledHeroPartnerBadgeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero section with predefined styles */
export type SectionStyledHeroPrimaryCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero section with predefined styles */
export type SectionStyledHeroSecondaryCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero section with predefined styles */
export type SectionStyledHeroTabletImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Hero section with predefined styles */
export type SectionStyledHeroTitleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Hero section with predefined styles */
export type SectionStyledHeroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Background for Section Styled Hero */
export enum SectionStyledHeroBackground {
  Black = 'black',
  PrimarySubtle = 'primarySubtle',
  PrimarySubtler = 'primarySubtler',
  PrimarySubtlest = 'primarySubtlest',
  SecondarySubtle = 'secondarySubtle',
  SecondarySubtler = 'secondarySubtler',
  SecondarySubtlest = 'secondarySubtlest',
  White = 'white',
}

export type SectionStyledHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionStyledHeroWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionStyledHeroConnection = {
  __typename?: 'SectionStyledHeroConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionStyledHeroEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionStyledHeroCreateInput = {
  additionalText?: InputMaybe<Scalars['String']['input']>
  backgroundColor?: InputMaybe<SectionStyledHeroBackground>
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  desktopImage?: InputMaybe<AssetCreateOneInlineInput>
  heroImage?: InputMaybe<HeroImageCreateOneInlineInput>
  heroImageRight?: InputMaybe<HeroImageCreateOneInlineInput>
  laptopImage?: InputMaybe<AssetCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionStyledHeroCreateLocalizationsInput>
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>
  paddingSize?: InputMaybe<PaddingSize>
  partnerBadge?: InputMaybe<PartnerBadgeCreateOneInlineInput>
  primaryCta?: InputMaybe<CallToActionCreateOneInlineInput>
  secondaryCta?: InputMaybe<CallToActionCreateOneInlineInput>
  spacer?: InputMaybe<Scalars['Int']['input']>
  style: SectionStyledHeroStyle
  styleVariant?: InputMaybe<OmrStyleVariant>
  tabletImage?: InputMaybe<AssetCreateOneInlineInput>
  theme: OmrThemeVariant
  title: HighlightedTextCreateOneInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionStyledHeroCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionStyledHeroCreateLocalizationInput = {
  /** Localization input */
  data: SectionStyledHeroCreateLocalizationDataInput
  locale: Locale
}

export type SectionStyledHeroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionStyledHeroCreateLocalizationInput>>
}

export type SectionStyledHeroCreateManyInlineInput = {
  /** Create and connect multiple existing SectionStyledHero documents */
  create?: InputMaybe<Array<SectionStyledHeroCreateInput>>
}

export type SectionStyledHeroCreateOneInlineInput = {
  /** Create and connect one SectionStyledHero document */
  create?: InputMaybe<SectionStyledHeroCreateInput>
}

export type SectionStyledHeroCreateWithPositionInput = {
  /** Document to create */
  data: SectionStyledHeroCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionStyledHeroEdge = {
  __typename?: 'SectionStyledHeroEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionStyledHero
}

/** Identifies documents */
export type SectionStyledHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionStyledHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionStyledHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionStyledHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  additionalText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  additionalText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  additionalText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  additionalText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  additionalText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  additionalText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  additionalText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  additionalText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  additionalText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  additionalText_starts_with?: InputMaybe<Scalars['String']['input']>
  backgroundColor?: InputMaybe<SectionStyledHeroBackground>
  /** All values that are contained in given list. */
  backgroundColor_in?: InputMaybe<Array<InputMaybe<SectionStyledHeroBackground>>>
  /** Any other value that exists and is not equal to the given value. */
  backgroundColor_not?: InputMaybe<SectionStyledHeroBackground>
  /** All values that are not contained in given list. */
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<SectionStyledHeroBackground>>>
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  constrainImage_not?: InputMaybe<Scalars['Boolean']['input']>
  desktopImage?: InputMaybe<AssetWhereInput>
  heroImage?: InputMaybe<HeroImageWhereInput>
  heroImageRight?: InputMaybe<HeroImageWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  laptopImage?: InputMaybe<AssetWhereInput>
  mobileImage?: InputMaybe<AssetWhereInput>
  paddingSize?: InputMaybe<PaddingSize>
  /** All values that are contained in given list. */
  paddingSize_in?: InputMaybe<Array<InputMaybe<PaddingSize>>>
  /** Any other value that exists and is not equal to the given value. */
  paddingSize_not?: InputMaybe<PaddingSize>
  /** All values that are not contained in given list. */
  paddingSize_not_in?: InputMaybe<Array<InputMaybe<PaddingSize>>>
  partnerBadge?: InputMaybe<PartnerBadgeWhereInput>
  primaryCta?: InputMaybe<CallToActionWhereInput>
  secondaryCta?: InputMaybe<CallToActionWhereInput>
  spacer?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  spacer_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  spacer_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  spacer_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  spacer_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  spacer_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  spacer_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  spacer_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  style?: InputMaybe<SectionStyledHeroStyle>
  styleVariant?: InputMaybe<OmrStyleVariant>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<OmrStyleVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<OmrStyleVariant>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<OmrStyleVariant>>>
  /** All values that are contained in given list. */
  style_in?: InputMaybe<Array<InputMaybe<SectionStyledHeroStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  style_not?: InputMaybe<SectionStyledHeroStyle>
  /** All values that are not contained in given list. */
  style_not_in?: InputMaybe<Array<InputMaybe<SectionStyledHeroStyle>>>
  tabletImage?: InputMaybe<AssetWhereInput>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  title?: InputMaybe<HighlightedTextWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionStyledHeroOrderByInput {
  AdditionalTextAsc = 'additionalText_ASC',
  AdditionalTextDesc = 'additionalText_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  ConstrainImageAsc = 'constrainImage_ASC',
  ConstrainImageDesc = 'constrainImage_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PaddingSizeAsc = 'paddingSize_ASC',
  PaddingSizeDesc = 'paddingSize_DESC',
  SpacerAsc = 'spacer_ASC',
  SpacerDesc = 'spacer_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  StyleAsc = 'style_ASC',
  StyleDesc = 'style_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionStyledHeroParent = CareerPage | EventPage | LandingPage

export type SectionStyledHeroParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionStyledHeroParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionStyledHeroParentCreateManyInlineInput = {
  /** Connect multiple existing SectionStyledHeroParent documents */
  connect?: InputMaybe<Array<SectionStyledHeroParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionStyledHeroParent documents */
  create?: InputMaybe<Array<SectionStyledHeroParentCreateInput>>
}

export type SectionStyledHeroParentCreateOneInlineInput = {
  /** Connect one existing SectionStyledHeroParent document */
  connect?: InputMaybe<SectionStyledHeroParentWhereUniqueInput>
  /** Create and connect one SectionStyledHeroParent document */
  create?: InputMaybe<SectionStyledHeroParentCreateInput>
}

export type SectionStyledHeroParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionStyledHeroParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionStyledHeroParent documents */
  connect?: InputMaybe<Array<SectionStyledHeroParentConnectInput>>
  /** Create and connect multiple SectionStyledHeroParent documents */
  create?: InputMaybe<Array<SectionStyledHeroParentCreateInput>>
  /** Delete multiple SectionStyledHeroParent documents */
  delete?: InputMaybe<Array<SectionStyledHeroParentWhereUniqueInput>>
  /** Disconnect multiple SectionStyledHeroParent documents */
  disconnect?: InputMaybe<Array<SectionStyledHeroParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionStyledHeroParent documents */
  set?: InputMaybe<Array<SectionStyledHeroParentWhereUniqueInput>>
  /** Update multiple SectionStyledHeroParent documents */
  update?: InputMaybe<Array<SectionStyledHeroParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionStyledHeroParent documents */
  upsert?: InputMaybe<Array<SectionStyledHeroParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionStyledHeroParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionStyledHeroParentUpdateOneInlineInput = {
  /** Connect existing SectionStyledHeroParent document */
  connect?: InputMaybe<SectionStyledHeroParentWhereUniqueInput>
  /** Create and connect one SectionStyledHeroParent document */
  create?: InputMaybe<SectionStyledHeroParentCreateInput>
  /** Delete currently connected SectionStyledHeroParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionStyledHeroParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionStyledHeroParent document */
  update?: InputMaybe<SectionStyledHeroParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionStyledHeroParent document */
  upsert?: InputMaybe<SectionStyledHeroParentUpsertWithNestedWhereUniqueInput>
}

export type SectionStyledHeroParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionStyledHeroParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionStyledHeroParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionStyledHeroParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

/** Style for Section Styled Hero */
export enum SectionStyledHeroStyle {
  Centered = 'centered',
  ImageAspect43 = 'imageAspect43',
  ImageContainedAspect = 'imageContainedAspect',
  ImageLarge = 'imageLarge',
  Left = 'left',
  PrimaryLandingPageFullImage = 'primaryLandingPageFullImage',
  PrimaryLandingPageSplitImage = 'primaryLandingPageSplitImage',
  SecondaryLandingPageFullImage = 'secondaryLandingPageFullImage',
  SplitImage = 'splitImage',
  SplitImage916 = 'splitImage916',
  SplitImageBackground = 'splitImageBackground',
  VideoBackground = 'videoBackground',
  VideoContainedAspect = 'videoContainedAspect',
  VideoLarge = 'videoLarge',
}

export type SectionStyledHeroUpdateInput = {
  additionalText?: InputMaybe<Scalars['String']['input']>
  backgroundColor?: InputMaybe<SectionStyledHeroBackground>
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  desktopImage?: InputMaybe<AssetUpdateOneInlineInput>
  heroImage?: InputMaybe<HeroImageUpdateOneInlineInput>
  heroImageRight?: InputMaybe<HeroImageUpdateOneInlineInput>
  laptopImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionStyledHeroUpdateLocalizationsInput>
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>
  paddingSize?: InputMaybe<PaddingSize>
  partnerBadge?: InputMaybe<PartnerBadgeUpdateOneInlineInput>
  primaryCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  secondaryCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  spacer?: InputMaybe<Scalars['Int']['input']>
  style?: InputMaybe<SectionStyledHeroStyle>
  styleVariant?: InputMaybe<OmrStyleVariant>
  tabletImage?: InputMaybe<AssetUpdateOneInlineInput>
  theme?: InputMaybe<OmrThemeVariant>
  title?: InputMaybe<HighlightedTextUpdateOneInlineInput>
}

export type SectionStyledHeroUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type SectionStyledHeroUpdateLocalizationInput = {
  data: SectionStyledHeroUpdateLocalizationDataInput
  locale: Locale
}

export type SectionStyledHeroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionStyledHeroCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionStyledHeroUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionStyledHeroUpsertLocalizationInput>>
}

export type SectionStyledHeroUpdateManyInlineInput = {
  /** Create and connect multiple SectionStyledHero component instances */
  create?: InputMaybe<Array<SectionStyledHeroCreateWithPositionInput>>
  /** Delete multiple SectionStyledHero documents */
  delete?: InputMaybe<Array<SectionStyledHeroWhereUniqueInput>>
  /** Update multiple SectionStyledHero component instances */
  update?: InputMaybe<Array<SectionStyledHeroUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionStyledHero component instances */
  upsert?: InputMaybe<Array<SectionStyledHeroUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionStyledHeroUpdateManyInput = {
  additionalText?: InputMaybe<Scalars['String']['input']>
  backgroundColor?: InputMaybe<SectionStyledHeroBackground>
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionStyledHeroUpdateManyLocalizationsInput>
  paddingSize?: InputMaybe<PaddingSize>
  spacer?: InputMaybe<Scalars['Int']['input']>
  style?: InputMaybe<SectionStyledHeroStyle>
  styleVariant?: InputMaybe<OmrStyleVariant>
  theme?: InputMaybe<OmrThemeVariant>
}

export type SectionStyledHeroUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type SectionStyledHeroUpdateManyLocalizationInput = {
  data: SectionStyledHeroUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionStyledHeroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionStyledHeroUpdateManyLocalizationInput>>
}

export type SectionStyledHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionStyledHeroUpdateManyInput
  /** Document search */
  where: SectionStyledHeroWhereInput
}

export type SectionStyledHeroUpdateOneInlineInput = {
  /** Create and connect one SectionStyledHero document */
  create?: InputMaybe<SectionStyledHeroCreateInput>
  /** Delete currently connected SectionStyledHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionStyledHero document */
  update?: InputMaybe<SectionStyledHeroUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionStyledHero document */
  upsert?: InputMaybe<SectionStyledHeroUpsertWithNestedWhereUniqueInput>
}

export type SectionStyledHeroUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionStyledHeroUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionStyledHeroWhereUniqueInput
}

export type SectionStyledHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionStyledHeroUpdateInput
  /** Unique document search */
  where: SectionStyledHeroWhereUniqueInput
}

export type SectionStyledHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionStyledHeroCreateInput
  /** Update document if it exists */
  update: SectionStyledHeroUpdateInput
}

export type SectionStyledHeroUpsertLocalizationInput = {
  create: SectionStyledHeroCreateLocalizationDataInput
  locale: Locale
  update: SectionStyledHeroUpdateLocalizationDataInput
}

export type SectionStyledHeroUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionStyledHeroUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionStyledHeroWhereUniqueInput
}

export type SectionStyledHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionStyledHeroUpsertInput
  /** Unique document search */
  where: SectionStyledHeroWhereUniqueInput
}

/** Identifies documents */
export type SectionStyledHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionStyledHeroWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionStyledHeroWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionStyledHeroWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  additionalText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  additionalText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  additionalText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  additionalText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  additionalText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  additionalText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  additionalText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  additionalText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  additionalText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  additionalText_starts_with?: InputMaybe<Scalars['String']['input']>
  backgroundColor?: InputMaybe<SectionStyledHeroBackground>
  /** All values that are contained in given list. */
  backgroundColor_in?: InputMaybe<Array<InputMaybe<SectionStyledHeroBackground>>>
  /** Any other value that exists and is not equal to the given value. */
  backgroundColor_not?: InputMaybe<SectionStyledHeroBackground>
  /** All values that are not contained in given list. */
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<SectionStyledHeroBackground>>>
  constrainImage?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  constrainImage_not?: InputMaybe<Scalars['Boolean']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  desktopImage?: InputMaybe<AssetWhereInput>
  heroImage?: InputMaybe<HeroImageWhereInput>
  heroImageRight?: InputMaybe<HeroImageWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  laptopImage?: InputMaybe<AssetWhereInput>
  mobileImage?: InputMaybe<AssetWhereInput>
  paddingSize?: InputMaybe<PaddingSize>
  /** All values that are contained in given list. */
  paddingSize_in?: InputMaybe<Array<InputMaybe<PaddingSize>>>
  /** Any other value that exists and is not equal to the given value. */
  paddingSize_not?: InputMaybe<PaddingSize>
  /** All values that are not contained in given list. */
  paddingSize_not_in?: InputMaybe<Array<InputMaybe<PaddingSize>>>
  partnerBadge?: InputMaybe<PartnerBadgeWhereInput>
  primaryCta?: InputMaybe<CallToActionWhereInput>
  secondaryCta?: InputMaybe<CallToActionWhereInput>
  spacer?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  spacer_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  spacer_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  spacer_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  spacer_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  spacer_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  spacer_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  spacer_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  style?: InputMaybe<SectionStyledHeroStyle>
  styleVariant?: InputMaybe<OmrStyleVariant>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<OmrStyleVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<OmrStyleVariant>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<OmrStyleVariant>>>
  /** All values that are contained in given list. */
  style_in?: InputMaybe<Array<InputMaybe<SectionStyledHeroStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  style_not?: InputMaybe<SectionStyledHeroStyle>
  /** All values that are not contained in given list. */
  style_not_in?: InputMaybe<Array<InputMaybe<SectionStyledHeroStyle>>>
  tabletImage?: InputMaybe<AssetWhereInput>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  title?: InputMaybe<HighlightedTextWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionStyledHero record uniquely */
export type SectionStyledHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section showing a tab view on desktop and accordions on mobile. */
export type SectionTab = Entity & {
  __typename?: 'SectionTab'
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionTab>
  /** System stage field */
  stage: Stage
  tabContents: Array<TabContent>
  title?: Maybe<Scalars['String']['output']>
  /** Only left and center are supported */
  titlePosition?: Maybe<ElementPosition>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section showing a tab view on desktop and accordions on mobile. */
export type SectionTabLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing a tab view on desktop and accordions on mobile. */
export type SectionTabTabContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TabContentOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TabContentWhereInput>
}

/** Section showing a tab view on desktop and accordions on mobile. */
export type SectionTabUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionTabConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionTabWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionTabConnection = {
  __typename?: 'SectionTabConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionTabEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionTabCreateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionTabCreateLocalizationsInput>
  tabContents: TabContentCreateManyInlineInput
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  titlePosition?: InputMaybe<ElementPosition>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTabCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTabCreateLocalizationInput = {
  /** Localization input */
  data: SectionTabCreateLocalizationDataInput
  locale: Locale
}

export type SectionTabCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionTabCreateLocalizationInput>>
}

export type SectionTabCreateManyInlineInput = {
  /** Create and connect multiple existing SectionTab documents */
  create?: InputMaybe<Array<SectionTabCreateInput>>
}

export type SectionTabCreateOneInlineInput = {
  /** Create and connect one SectionTab document */
  create?: InputMaybe<SectionTabCreateInput>
}

export type SectionTabCreateWithPositionInput = {
  /** Document to create */
  data: SectionTabCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionTabEdge = {
  __typename?: 'SectionTabEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionTab
}

/** Identifies documents */
export type SectionTabManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTabWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTabWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTabWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  tabContents_every?: InputMaybe<TabContentWhereInput>
  tabContents_none?: InputMaybe<TabContentWhereInput>
  tabContents_some?: InputMaybe<TabContentWhereInput>
  titlePosition?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  titlePosition_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  titlePosition_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  titlePosition_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionTabOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitlePositionAsc = 'titlePosition_ASC',
  TitlePositionDesc = 'titlePosition_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionTabParent = EventPage | LandingPage

export type SectionTabParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionTabParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionTabParentCreateManyInlineInput = {
  /** Connect multiple existing SectionTabParent documents */
  connect?: InputMaybe<Array<SectionTabParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionTabParent documents */
  create?: InputMaybe<Array<SectionTabParentCreateInput>>
}

export type SectionTabParentCreateOneInlineInput = {
  /** Connect one existing SectionTabParent document */
  connect?: InputMaybe<SectionTabParentWhereUniqueInput>
  /** Create and connect one SectionTabParent document */
  create?: InputMaybe<SectionTabParentCreateInput>
}

export type SectionTabParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionTabParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionTabParent documents */
  connect?: InputMaybe<Array<SectionTabParentConnectInput>>
  /** Create and connect multiple SectionTabParent documents */
  create?: InputMaybe<Array<SectionTabParentCreateInput>>
  /** Delete multiple SectionTabParent documents */
  delete?: InputMaybe<Array<SectionTabParentWhereUniqueInput>>
  /** Disconnect multiple SectionTabParent documents */
  disconnect?: InputMaybe<Array<SectionTabParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionTabParent documents */
  set?: InputMaybe<Array<SectionTabParentWhereUniqueInput>>
  /** Update multiple SectionTabParent documents */
  update?: InputMaybe<Array<SectionTabParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionTabParent documents */
  upsert?: InputMaybe<Array<SectionTabParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionTabParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionTabParentUpdateOneInlineInput = {
  /** Connect existing SectionTabParent document */
  connect?: InputMaybe<SectionTabParentWhereUniqueInput>
  /** Create and connect one SectionTabParent document */
  create?: InputMaybe<SectionTabParentCreateInput>
  /** Delete currently connected SectionTabParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionTabParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTabParent document */
  update?: InputMaybe<SectionTabParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTabParent document */
  upsert?: InputMaybe<SectionTabParentUpsertWithNestedWhereUniqueInput>
}

export type SectionTabParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionTabParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionTabParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionTabParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionTabUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionTabUpdateLocalizationsInput>
  tabContents?: InputMaybe<TabContentUpdateManyInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  titlePosition?: InputMaybe<ElementPosition>
}

export type SectionTabUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionTabUpdateLocalizationInput = {
  data: SectionTabUpdateLocalizationDataInput
  locale: Locale
}

export type SectionTabUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionTabCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTabUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionTabUpsertLocalizationInput>>
}

export type SectionTabUpdateManyInlineInput = {
  /** Create and connect multiple SectionTab component instances */
  create?: InputMaybe<Array<SectionTabCreateWithPositionInput>>
  /** Delete multiple SectionTab documents */
  delete?: InputMaybe<Array<SectionTabWhereUniqueInput>>
  /** Update multiple SectionTab component instances */
  update?: InputMaybe<Array<SectionTabUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionTab component instances */
  upsert?: InputMaybe<Array<SectionTabUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionTabUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionTabUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  titlePosition?: InputMaybe<ElementPosition>
}

export type SectionTabUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionTabUpdateManyLocalizationInput = {
  data: SectionTabUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionTabUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTabUpdateManyLocalizationInput>>
}

export type SectionTabUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionTabUpdateManyInput
  /** Document search */
  where: SectionTabWhereInput
}

export type SectionTabUpdateOneInlineInput = {
  /** Create and connect one SectionTab document */
  create?: InputMaybe<SectionTabCreateInput>
  /** Delete currently connected SectionTab document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTab document */
  update?: InputMaybe<SectionTabUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTab document */
  upsert?: InputMaybe<SectionTabUpsertWithNestedWhereUniqueInput>
}

export type SectionTabUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionTabUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTabWhereUniqueInput
}

export type SectionTabUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionTabUpdateInput
  /** Unique document search */
  where: SectionTabWhereUniqueInput
}

export type SectionTabUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionTabCreateInput
  /** Update document if it exists */
  update: SectionTabUpdateInput
}

export type SectionTabUpsertLocalizationInput = {
  create: SectionTabCreateLocalizationDataInput
  locale: Locale
  update: SectionTabUpdateLocalizationDataInput
}

export type SectionTabUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionTabUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTabWhereUniqueInput
}

export type SectionTabUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionTabUpsertInput
  /** Unique document search */
  where: SectionTabWhereUniqueInput
}

/** Identifies documents */
export type SectionTabWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTabWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTabWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTabWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  tabContents_every?: InputMaybe<TabContentWhereInput>
  tabContents_none?: InputMaybe<TabContentWhereInput>
  tabContents_some?: InputMaybe<TabContentWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  titlePosition?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  titlePosition_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  titlePosition_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  titlePosition_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionTab record uniquely */
export type SectionTabWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionTeaser = Entity & {
  __typename?: 'SectionTeaser'
  /** DEPRECATED: use new responsive image fields for Desktop etc */
  background: Asset
  cta?: Maybe<CallToAction>
  /** DEPRECATED use CTA component */
  ctaLabel?: Maybe<Scalars['String']['output']>
  ctaSecondary?: Maybe<CallToAction>
  /** DEPRECATED use CTA component */
  ctaUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  /** Desktop Image for Section Teaser */
  desktopImage?: Maybe<Asset>
  headline: Scalars['String']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Display background across full screen width? False will keep the background within the grid width. */
  isBgFulWidth?: Maybe<Scalars['Boolean']['output']>
  /** Optional: Laptop Image for Section Teaser */
  laptopImage?: Maybe<Asset>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionTeaser>
  /** Mobile Image for Section Teaser */
  mobileImage?: Maybe<Asset>
  /** Supported: center (default), left, right */
  position?: Maybe<ElementPosition>
  /** System stage field */
  stage: Stage
  /** Sets component color scheme. */
  styleVariant?: Maybe<ComponentStyle>
  /** Optional: Tablet Image for Section Teaser */
  tabletImage?: Maybe<Asset>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionTeaserBackgroundArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionTeaserCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SectionTeaserCtaSecondaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SectionTeaserDesktopImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionTeaserLaptopImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionTeaserLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionTeaserMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionTeaserTabletImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SectionTeaserUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionTeaserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionTeaserWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionTeaserConnection = {
  __typename?: 'SectionTeaserConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionTeaserEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionTeaserCreateInput = {
  background: AssetCreateOneInlineInput
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** ctaLabel input for default locale (de) */
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  ctaSecondary?: InputMaybe<CallToActionCreateOneInlineInput>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  desktopImage?: InputMaybe<AssetCreateOneInlineInput>
  /** headline input for default locale (de) */
  headline: Scalars['String']['input']
  isBgFulWidth?: InputMaybe<Scalars['Boolean']['input']>
  laptopImage?: InputMaybe<AssetCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionTeaserCreateLocalizationsInput>
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>
  position?: InputMaybe<ElementPosition>
  styleVariant?: InputMaybe<ComponentStyle>
  tabletImage?: InputMaybe<AssetCreateOneInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTeaserCreateLocalizationDataInput = {
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  headline: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTeaserCreateLocalizationInput = {
  /** Localization input */
  data: SectionTeaserCreateLocalizationDataInput
  locale: Locale
}

export type SectionTeaserCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionTeaserCreateLocalizationInput>>
}

export type SectionTeaserCreateManyInlineInput = {
  /** Create and connect multiple existing SectionTeaser documents */
  create?: InputMaybe<Array<SectionTeaserCreateInput>>
}

export type SectionTeaserCreateOneInlineInput = {
  /** Create and connect one SectionTeaser document */
  create?: InputMaybe<SectionTeaserCreateInput>
}

export type SectionTeaserCreateWithPositionInput = {
  /** Document to create */
  data: SectionTeaserCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionTeaserEdge = {
  __typename?: 'SectionTeaserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionTeaser
}

/** Identifies documents */
export type SectionTeaserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTeaserWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTeaserWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTeaserWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  background?: InputMaybe<AssetWhereInput>
  cta?: InputMaybe<CallToActionWhereInput>
  ctaSecondary?: InputMaybe<CallToActionWhereInput>
  desktopImage?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isBgFulWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isBgFulWidth_not?: InputMaybe<Scalars['Boolean']['input']>
  laptopImage?: InputMaybe<AssetWhereInput>
  mobileImage?: InputMaybe<AssetWhereInput>
  position?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  tabletImage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionTeaserOrderByInput {
  CtaLabelAsc = 'ctaLabel_ASC',
  CtaLabelDesc = 'ctaLabel_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsBgFulWidthAsc = 'isBgFulWidth_ASC',
  IsBgFulWidthDesc = 'isBgFulWidth_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionTeaserParent = CareerPage | EventPage | LandingPage

export type SectionTeaserParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionTeaserParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionTeaserParentCreateManyInlineInput = {
  /** Connect multiple existing SectionTeaserParent documents */
  connect?: InputMaybe<Array<SectionTeaserParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionTeaserParent documents */
  create?: InputMaybe<Array<SectionTeaserParentCreateInput>>
}

export type SectionTeaserParentCreateOneInlineInput = {
  /** Connect one existing SectionTeaserParent document */
  connect?: InputMaybe<SectionTeaserParentWhereUniqueInput>
  /** Create and connect one SectionTeaserParent document */
  create?: InputMaybe<SectionTeaserParentCreateInput>
}

export type SectionTeaserParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionTeaserParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionTeaserParent documents */
  connect?: InputMaybe<Array<SectionTeaserParentConnectInput>>
  /** Create and connect multiple SectionTeaserParent documents */
  create?: InputMaybe<Array<SectionTeaserParentCreateInput>>
  /** Delete multiple SectionTeaserParent documents */
  delete?: InputMaybe<Array<SectionTeaserParentWhereUniqueInput>>
  /** Disconnect multiple SectionTeaserParent documents */
  disconnect?: InputMaybe<Array<SectionTeaserParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionTeaserParent documents */
  set?: InputMaybe<Array<SectionTeaserParentWhereUniqueInput>>
  /** Update multiple SectionTeaserParent documents */
  update?: InputMaybe<Array<SectionTeaserParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionTeaserParent documents */
  upsert?: InputMaybe<Array<SectionTeaserParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionTeaserParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionTeaserParentUpdateOneInlineInput = {
  /** Connect existing SectionTeaserParent document */
  connect?: InputMaybe<SectionTeaserParentWhereUniqueInput>
  /** Create and connect one SectionTeaserParent document */
  create?: InputMaybe<SectionTeaserParentCreateInput>
  /** Delete currently connected SectionTeaserParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionTeaserParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTeaserParent document */
  update?: InputMaybe<SectionTeaserParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTeaserParent document */
  upsert?: InputMaybe<SectionTeaserParentUpsertWithNestedWhereUniqueInput>
}

export type SectionTeaserParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionTeaserParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionTeaserParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionTeaserParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionTeaserUpdateInput = {
  background?: InputMaybe<AssetUpdateOneInlineInput>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** ctaLabel input for default locale (de) */
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  ctaSecondary?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  desktopImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  isBgFulWidth?: InputMaybe<Scalars['Boolean']['input']>
  laptopImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionTeaserUpdateLocalizationsInput>
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>
  position?: InputMaybe<ElementPosition>
  styleVariant?: InputMaybe<ComponentStyle>
  tabletImage?: InputMaybe<AssetUpdateOneInlineInput>
}

export type SectionTeaserUpdateLocalizationDataInput = {
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  headline?: InputMaybe<Scalars['String']['input']>
}

export type SectionTeaserUpdateLocalizationInput = {
  data: SectionTeaserUpdateLocalizationDataInput
  locale: Locale
}

export type SectionTeaserUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionTeaserCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTeaserUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionTeaserUpsertLocalizationInput>>
}

export type SectionTeaserUpdateManyInlineInput = {
  /** Create and connect multiple SectionTeaser component instances */
  create?: InputMaybe<Array<SectionTeaserCreateWithPositionInput>>
  /** Delete multiple SectionTeaser documents */
  delete?: InputMaybe<Array<SectionTeaserWhereUniqueInput>>
  /** Update multiple SectionTeaser component instances */
  update?: InputMaybe<Array<SectionTeaserUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionTeaser component instances */
  upsert?: InputMaybe<Array<SectionTeaserUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionTeaserUpdateManyInput = {
  /** ctaLabel input for default locale (de) */
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** headline input for default locale (de) */
  headline?: InputMaybe<Scalars['String']['input']>
  isBgFulWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionTeaserUpdateManyLocalizationsInput>
  position?: InputMaybe<ElementPosition>
  styleVariant?: InputMaybe<ComponentStyle>
}

export type SectionTeaserUpdateManyLocalizationDataInput = {
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  headline?: InputMaybe<Scalars['String']['input']>
}

export type SectionTeaserUpdateManyLocalizationInput = {
  data: SectionTeaserUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionTeaserUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTeaserUpdateManyLocalizationInput>>
}

export type SectionTeaserUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionTeaserUpdateManyInput
  /** Document search */
  where: SectionTeaserWhereInput
}

export type SectionTeaserUpdateOneInlineInput = {
  /** Create and connect one SectionTeaser document */
  create?: InputMaybe<SectionTeaserCreateInput>
  /** Delete currently connected SectionTeaser document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTeaser document */
  update?: InputMaybe<SectionTeaserUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTeaser document */
  upsert?: InputMaybe<SectionTeaserUpsertWithNestedWhereUniqueInput>
}

export type SectionTeaserUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionTeaserUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTeaserWhereUniqueInput
}

export type SectionTeaserUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionTeaserUpdateInput
  /** Unique document search */
  where: SectionTeaserWhereUniqueInput
}

export type SectionTeaserUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionTeaserCreateInput
  /** Update document if it exists */
  update: SectionTeaserUpdateInput
}

export type SectionTeaserUpsertLocalizationInput = {
  create: SectionTeaserCreateLocalizationDataInput
  locale: Locale
  update: SectionTeaserUpdateLocalizationDataInput
}

export type SectionTeaserUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionTeaserUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTeaserWhereUniqueInput
}

export type SectionTeaserUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionTeaserUpsertInput
  /** Unique document search */
  where: SectionTeaserWhereUniqueInput
}

/** Identifies documents */
export type SectionTeaserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTeaserWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTeaserWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTeaserWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  background?: InputMaybe<AssetWhereInput>
  cta?: InputMaybe<CallToActionWhereInput>
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaSecondary?: InputMaybe<CallToActionWhereInput>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  desktopImage?: InputMaybe<AssetWhereInput>
  headline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isBgFulWidth?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isBgFulWidth_not?: InputMaybe<Scalars['Boolean']['input']>
  laptopImage?: InputMaybe<AssetWhereInput>
  mobileImage?: InputMaybe<AssetWhereInput>
  position?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  tabletImage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionTeaser record uniquely */
export type SectionTeaserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section representing single testimonial */
export type SectionTestimonial = Entity & {
  __typename?: 'SectionTestimonial'
  companyName?: Maybe<Scalars['String']['output']>
  /** Call to action for individual testimonial */
  cta?: Maybe<CallToAction>
  /** Defines style for the testimonial section. Default (square) */
  decorationStyle?: Maybe<DecorationStyle>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Testimonial author image or other visual representation */
  image: Asset
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionTestimonial>
  /** Role in the company */
  position?: Maybe<Scalars['String']['output']>
  /** Testimonial author signature */
  signature: Scalars['String']['output']
  /** Image shown below signature. Can be a company logo */
  signatureImage?: Maybe<Asset>
  /** System stage field */
  stage: Stage
  /** 1 - 5, leaving blank will hide stars */
  starRating?: Maybe<Scalars['Int']['output']>
  /** Testimonial text content */
  testimonial: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section representing single testimonial */
export type SectionTestimonialCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Section representing single testimonial */
export type SectionTestimonialImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Section representing single testimonial */
export type SectionTestimonialLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section representing single testimonial */
export type SectionTestimonialSignatureImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Section representing single testimonial */
export type SectionTestimonialUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionTestimonialConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionTestimonialWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionTestimonialConnection = {
  __typename?: 'SectionTestimonialConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionTestimonialEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionTestimonialCreateInput = {
  companyName?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  decorationStyle?: InputMaybe<DecorationStyle>
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionTestimonialCreateLocalizationsInput>
  /** position input for default locale (de) */
  position?: InputMaybe<Scalars['String']['input']>
  signature: Scalars['String']['input']
  signatureImage?: InputMaybe<AssetCreateOneInlineInput>
  starRating?: InputMaybe<Scalars['Int']['input']>
  /** testimonial input for default locale (de) */
  testimonial: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTestimonialCreateLocalizationDataInput = {
  position?: InputMaybe<Scalars['String']['input']>
  testimonial: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTestimonialCreateLocalizationInput = {
  /** Localization input */
  data: SectionTestimonialCreateLocalizationDataInput
  locale: Locale
}

export type SectionTestimonialCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionTestimonialCreateLocalizationInput>>
}

export type SectionTestimonialCreateManyInlineInput = {
  /** Create and connect multiple existing SectionTestimonial documents */
  create?: InputMaybe<Array<SectionTestimonialCreateInput>>
}

export type SectionTestimonialCreateOneInlineInput = {
  /** Create and connect one SectionTestimonial document */
  create?: InputMaybe<SectionTestimonialCreateInput>
}

export type SectionTestimonialCreateWithPositionInput = {
  /** Document to create */
  data: SectionTestimonialCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionTestimonialEdge = {
  __typename?: 'SectionTestimonialEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionTestimonial
}

/** Identifies documents */
export type SectionTestimonialManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTestimonialWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTestimonialWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTestimonialWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  companyName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  companyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  companyName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  companyName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  companyName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  companyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  companyName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  companyName_starts_with?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  decorationStyle?: InputMaybe<DecorationStyle>
  /** All values that are contained in given list. */
  decorationStyle_in?: InputMaybe<Array<InputMaybe<DecorationStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationStyle_not?: InputMaybe<DecorationStyle>
  /** All values that are not contained in given list. */
  decorationStyle_not_in?: InputMaybe<Array<InputMaybe<DecorationStyle>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  signature?: InputMaybe<Scalars['String']['input']>
  signatureImage?: InputMaybe<AssetWhereInput>
  /** All values containing the given string. */
  signature_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  signature_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  signature_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  signature_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  signature_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  signature_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  signature_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  signature_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  signature_starts_with?: InputMaybe<Scalars['String']['input']>
  starRating?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  starRating_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  starRating_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  starRating_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  starRating_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  starRating_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  starRating_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  starRating_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionTestimonialOrderByInput {
  CompanyNameAsc = 'companyName_ASC',
  CompanyNameDesc = 'companyName_DESC',
  DecorationStyleAsc = 'decorationStyle_ASC',
  DecorationStyleDesc = 'decorationStyle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  SignatureAsc = 'signature_ASC',
  SignatureDesc = 'signature_DESC',
  StarRatingAsc = 'starRating_ASC',
  StarRatingDesc = 'starRating_DESC',
  TestimonialAsc = 'testimonial_ASC',
  TestimonialDesc = 'testimonial_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionTestimonialParent = LandingPage | TestimonialSlider

export type SectionTestimonialParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderConnectInput>
}

export type SectionTestimonialParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderCreateInput>
}

export type SectionTestimonialParentCreateManyInlineInput = {
  /** Connect multiple existing SectionTestimonialParent documents */
  connect?: InputMaybe<Array<SectionTestimonialParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionTestimonialParent documents */
  create?: InputMaybe<Array<SectionTestimonialParentCreateInput>>
}

export type SectionTestimonialParentCreateOneInlineInput = {
  /** Connect one existing SectionTestimonialParent document */
  connect?: InputMaybe<SectionTestimonialParentWhereUniqueInput>
  /** Create and connect one SectionTestimonialParent document */
  create?: InputMaybe<SectionTestimonialParentCreateInput>
}

export type SectionTestimonialParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateInput>
}

export type SectionTestimonialParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionTestimonialParent documents */
  connect?: InputMaybe<Array<SectionTestimonialParentConnectInput>>
  /** Create and connect multiple SectionTestimonialParent documents */
  create?: InputMaybe<Array<SectionTestimonialParentCreateInput>>
  /** Delete multiple SectionTestimonialParent documents */
  delete?: InputMaybe<Array<SectionTestimonialParentWhereUniqueInput>>
  /** Disconnect multiple SectionTestimonialParent documents */
  disconnect?: InputMaybe<Array<SectionTestimonialParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionTestimonialParent documents */
  set?: InputMaybe<Array<SectionTestimonialParentWhereUniqueInput>>
  /** Update multiple SectionTestimonialParent documents */
  update?: InputMaybe<Array<SectionTestimonialParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionTestimonialParent documents */
  upsert?: InputMaybe<Array<SectionTestimonialParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionTestimonialParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateManyWithNestedWhereInput>
}

export type SectionTestimonialParentUpdateOneInlineInput = {
  /** Connect existing SectionTestimonialParent document */
  connect?: InputMaybe<SectionTestimonialParentWhereUniqueInput>
  /** Create and connect one SectionTestimonialParent document */
  create?: InputMaybe<SectionTestimonialParentCreateInput>
  /** Delete currently connected SectionTestimonialParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionTestimonialParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTestimonialParent document */
  update?: InputMaybe<SectionTestimonialParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTestimonialParent document */
  upsert?: InputMaybe<SectionTestimonialParentUpsertWithNestedWhereUniqueInput>
}

export type SectionTestimonialParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpdateWithNestedWhereUniqueInput>
}

export type SectionTestimonialParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderUpsertWithNestedWhereUniqueInput>
}

export type SectionTestimonialParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderWhereInput>
}

export type SectionTestimonialParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
  TestimonialSlider?: InputMaybe<TestimonialSliderWhereUniqueInput>
}

export type SectionTestimonialUpdateInput = {
  companyName?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  decorationStyle?: InputMaybe<DecorationStyle>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionTestimonialUpdateLocalizationsInput>
  /** position input for default locale (de) */
  position?: InputMaybe<Scalars['String']['input']>
  signature?: InputMaybe<Scalars['String']['input']>
  signatureImage?: InputMaybe<AssetUpdateOneInlineInput>
  starRating?: InputMaybe<Scalars['Int']['input']>
  /** testimonial input for default locale (de) */
  testimonial?: InputMaybe<Scalars['String']['input']>
}

export type SectionTestimonialUpdateLocalizationDataInput = {
  position?: InputMaybe<Scalars['String']['input']>
  testimonial?: InputMaybe<Scalars['String']['input']>
}

export type SectionTestimonialUpdateLocalizationInput = {
  data: SectionTestimonialUpdateLocalizationDataInput
  locale: Locale
}

export type SectionTestimonialUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionTestimonialCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTestimonialUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionTestimonialUpsertLocalizationInput>>
}

export type SectionTestimonialUpdateManyInlineInput = {
  /** Create and connect multiple SectionTestimonial component instances */
  create?: InputMaybe<Array<SectionTestimonialCreateWithPositionInput>>
  /** Delete multiple SectionTestimonial documents */
  delete?: InputMaybe<Array<SectionTestimonialWhereUniqueInput>>
  /** Update multiple SectionTestimonial component instances */
  update?: InputMaybe<Array<SectionTestimonialUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionTestimonial component instances */
  upsert?: InputMaybe<Array<SectionTestimonialUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionTestimonialUpdateManyInput = {
  companyName?: InputMaybe<Scalars['String']['input']>
  decorationStyle?: InputMaybe<DecorationStyle>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionTestimonialUpdateManyLocalizationsInput>
  /** position input for default locale (de) */
  position?: InputMaybe<Scalars['String']['input']>
  signature?: InputMaybe<Scalars['String']['input']>
  starRating?: InputMaybe<Scalars['Int']['input']>
  /** testimonial input for default locale (de) */
  testimonial?: InputMaybe<Scalars['String']['input']>
}

export type SectionTestimonialUpdateManyLocalizationDataInput = {
  position?: InputMaybe<Scalars['String']['input']>
  testimonial?: InputMaybe<Scalars['String']['input']>
}

export type SectionTestimonialUpdateManyLocalizationInput = {
  data: SectionTestimonialUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionTestimonialUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTestimonialUpdateManyLocalizationInput>>
}

export type SectionTestimonialUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionTestimonialUpdateManyInput
  /** Document search */
  where: SectionTestimonialWhereInput
}

export type SectionTestimonialUpdateOneInlineInput = {
  /** Create and connect one SectionTestimonial document */
  create?: InputMaybe<SectionTestimonialCreateInput>
  /** Delete currently connected SectionTestimonial document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTestimonial document */
  update?: InputMaybe<SectionTestimonialUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTestimonial document */
  upsert?: InputMaybe<SectionTestimonialUpsertWithNestedWhereUniqueInput>
}

export type SectionTestimonialUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionTestimonialUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTestimonialWhereUniqueInput
}

export type SectionTestimonialUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionTestimonialUpdateInput
  /** Unique document search */
  where: SectionTestimonialWhereUniqueInput
}

export type SectionTestimonialUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionTestimonialCreateInput
  /** Update document if it exists */
  update: SectionTestimonialUpdateInput
}

export type SectionTestimonialUpsertLocalizationInput = {
  create: SectionTestimonialCreateLocalizationDataInput
  locale: Locale
  update: SectionTestimonialUpdateLocalizationDataInput
}

export type SectionTestimonialUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionTestimonialUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTestimonialWhereUniqueInput
}

export type SectionTestimonialUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionTestimonialUpsertInput
  /** Unique document search */
  where: SectionTestimonialWhereUniqueInput
}

/** Identifies documents */
export type SectionTestimonialWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTestimonialWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTestimonialWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTestimonialWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  companyName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  companyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  companyName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  companyName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  companyName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  companyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  companyName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  companyName_starts_with?: InputMaybe<Scalars['String']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  decorationStyle?: InputMaybe<DecorationStyle>
  /** All values that are contained in given list. */
  decorationStyle_in?: InputMaybe<Array<InputMaybe<DecorationStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationStyle_not?: InputMaybe<DecorationStyle>
  /** All values that are not contained in given list. */
  decorationStyle_not_in?: InputMaybe<Array<InputMaybe<DecorationStyle>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  position?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  position_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  position_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  position_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  position_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  position_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  position_starts_with?: InputMaybe<Scalars['String']['input']>
  signature?: InputMaybe<Scalars['String']['input']>
  signatureImage?: InputMaybe<AssetWhereInput>
  /** All values containing the given string. */
  signature_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  signature_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  signature_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  signature_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  signature_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  signature_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  signature_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  signature_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  signature_starts_with?: InputMaybe<Scalars['String']['input']>
  starRating?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than the given value. */
  starRating_gt?: InputMaybe<Scalars['Int']['input']>
  /** All values greater than or equal the given value. */
  starRating_gte?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  starRating_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** All values less than the given value. */
  starRating_lt?: InputMaybe<Scalars['Int']['input']>
  /** All values less than or equal the given value. */
  starRating_lte?: InputMaybe<Scalars['Int']['input']>
  /** Any other value that exists and is not equal to the given value. */
  starRating_not?: InputMaybe<Scalars['Int']['input']>
  /** All values that are not contained in given list. */
  starRating_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  testimonial?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  testimonial_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  testimonial_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  testimonial_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  testimonial_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  testimonial_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  testimonial_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  testimonial_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  testimonial_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  testimonial_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionTestimonial record uniquely */
export type SectionTestimonialWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionTicketsTable = Entity & {
  __typename?: 'SectionTicketsTable'
  /** 1-4 ticket columns. Order determines rendering order and cell index alignment. */
  columns: Array<TicketsTableColumn>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionTicketsTable>
  /** Comparison rows. Each row's `cells` align by index with the section's `columns`. */
  rows: Array<TicketsTableRow>
  /** System stage field */
  stage: Stage
  ticketInfoMessage?: Maybe<Scalars['String']['output']>
  ticketShopLabel: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SectionTicketsTableColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TicketsTableColumnOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TicketsTableColumnWhereInput>
}

export type SectionTicketsTableLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SectionTicketsTableRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TicketsTableRowOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TicketsTableRowWhereInput>
}

export type SectionTicketsTableUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionTicketsTableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionTicketsTableWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionTicketsTableConnection = {
  __typename?: 'SectionTicketsTableConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionTicketsTableEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionTicketsTableCreateInput = {
  columns?: InputMaybe<TicketsTableColumnCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionTicketsTableCreateLocalizationsInput>
  rows?: InputMaybe<TicketsTableRowCreateManyInlineInput>
  /** ticketInfoMessage input for default locale (de) */
  ticketInfoMessage?: InputMaybe<Scalars['String']['input']>
  /** ticketShopLabel input for default locale (de) */
  ticketShopLabel: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTicketsTableCreateLocalizationDataInput = {
  ticketInfoMessage?: InputMaybe<Scalars['String']['input']>
  ticketShopLabel: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTicketsTableCreateLocalizationInput = {
  /** Localization input */
  data: SectionTicketsTableCreateLocalizationDataInput
  locale: Locale
}

export type SectionTicketsTableCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionTicketsTableCreateLocalizationInput>>
}

export type SectionTicketsTableCreateManyInlineInput = {
  /** Create and connect multiple existing SectionTicketsTable documents */
  create?: InputMaybe<Array<SectionTicketsTableCreateInput>>
}

export type SectionTicketsTableCreateOneInlineInput = {
  /** Create and connect one SectionTicketsTable document */
  create?: InputMaybe<SectionTicketsTableCreateInput>
}

export type SectionTicketsTableCreateWithPositionInput = {
  /** Document to create */
  data: SectionTicketsTableCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionTicketsTableEdge = {
  __typename?: 'SectionTicketsTableEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionTicketsTable
}

/** Identifies documents */
export type SectionTicketsTableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTicketsTableWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTicketsTableWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTicketsTableWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  columns_every?: InputMaybe<TicketsTableColumnWhereInput>
  columns_none?: InputMaybe<TicketsTableColumnWhereInput>
  columns_some?: InputMaybe<TicketsTableColumnWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  rows_every?: InputMaybe<TicketsTableRowWhereInput>
  rows_none?: InputMaybe<TicketsTableRowWhereInput>
  rows_some?: InputMaybe<TicketsTableRowWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionTicketsTableOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TicketInfoMessageAsc = 'ticketInfoMessage_ASC',
  TicketInfoMessageDesc = 'ticketInfoMessage_DESC',
  TicketShopLabelAsc = 'ticketShopLabel_ASC',
  TicketShopLabelDesc = 'ticketShopLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionTicketsTableParent = EventPage

export type SectionTicketsTableParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
}

export type SectionTicketsTableParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
}

export type SectionTicketsTableParentCreateManyInlineInput = {
  /** Connect multiple existing SectionTicketsTableParent documents */
  connect?: InputMaybe<Array<SectionTicketsTableParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionTicketsTableParent documents */
  create?: InputMaybe<Array<SectionTicketsTableParentCreateInput>>
}

export type SectionTicketsTableParentCreateOneInlineInput = {
  /** Connect one existing SectionTicketsTableParent document */
  connect?: InputMaybe<SectionTicketsTableParentWhereUniqueInput>
  /** Create and connect one SectionTicketsTableParent document */
  create?: InputMaybe<SectionTicketsTableParentCreateInput>
}

export type SectionTicketsTableParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
}

export type SectionTicketsTableParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionTicketsTableParent documents */
  connect?: InputMaybe<Array<SectionTicketsTableParentConnectInput>>
  /** Create and connect multiple SectionTicketsTableParent documents */
  create?: InputMaybe<Array<SectionTicketsTableParentCreateInput>>
  /** Delete multiple SectionTicketsTableParent documents */
  delete?: InputMaybe<Array<SectionTicketsTableParentWhereUniqueInput>>
  /** Disconnect multiple SectionTicketsTableParent documents */
  disconnect?: InputMaybe<Array<SectionTicketsTableParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionTicketsTableParent documents */
  set?: InputMaybe<Array<SectionTicketsTableParentWhereUniqueInput>>
  /** Update multiple SectionTicketsTableParent documents */
  update?: InputMaybe<Array<SectionTicketsTableParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionTicketsTableParent documents */
  upsert?: InputMaybe<Array<SectionTicketsTableParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionTicketsTableParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
}

export type SectionTicketsTableParentUpdateOneInlineInput = {
  /** Connect existing SectionTicketsTableParent document */
  connect?: InputMaybe<SectionTicketsTableParentWhereUniqueInput>
  /** Create and connect one SectionTicketsTableParent document */
  create?: InputMaybe<SectionTicketsTableParentCreateInput>
  /** Delete currently connected SectionTicketsTableParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionTicketsTableParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTicketsTableParent document */
  update?: InputMaybe<SectionTicketsTableParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTicketsTableParent document */
  upsert?: InputMaybe<SectionTicketsTableParentUpsertWithNestedWhereUniqueInput>
}

export type SectionTicketsTableParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
}

export type SectionTicketsTableParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
}

export type SectionTicketsTableParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
}

export type SectionTicketsTableParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
}

export type SectionTicketsTableUpdateInput = {
  columns?: InputMaybe<TicketsTableColumnUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionTicketsTableUpdateLocalizationsInput>
  rows?: InputMaybe<TicketsTableRowUpdateManyInlineInput>
  /** ticketInfoMessage input for default locale (de) */
  ticketInfoMessage?: InputMaybe<Scalars['String']['input']>
  /** ticketShopLabel input for default locale (de) */
  ticketShopLabel?: InputMaybe<Scalars['String']['input']>
}

export type SectionTicketsTableUpdateLocalizationDataInput = {
  ticketInfoMessage?: InputMaybe<Scalars['String']['input']>
  ticketShopLabel?: InputMaybe<Scalars['String']['input']>
}

export type SectionTicketsTableUpdateLocalizationInput = {
  data: SectionTicketsTableUpdateLocalizationDataInput
  locale: Locale
}

export type SectionTicketsTableUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionTicketsTableCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTicketsTableUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionTicketsTableUpsertLocalizationInput>>
}

export type SectionTicketsTableUpdateManyInlineInput = {
  /** Create and connect multiple SectionTicketsTable component instances */
  create?: InputMaybe<Array<SectionTicketsTableCreateWithPositionInput>>
  /** Delete multiple SectionTicketsTable documents */
  delete?: InputMaybe<Array<SectionTicketsTableWhereUniqueInput>>
  /** Update multiple SectionTicketsTable component instances */
  update?: InputMaybe<Array<SectionTicketsTableUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionTicketsTable component instances */
  upsert?: InputMaybe<Array<SectionTicketsTableUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionTicketsTableUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionTicketsTableUpdateManyLocalizationsInput>
  /** ticketInfoMessage input for default locale (de) */
  ticketInfoMessage?: InputMaybe<Scalars['String']['input']>
  /** ticketShopLabel input for default locale (de) */
  ticketShopLabel?: InputMaybe<Scalars['String']['input']>
}

export type SectionTicketsTableUpdateManyLocalizationDataInput = {
  ticketInfoMessage?: InputMaybe<Scalars['String']['input']>
  ticketShopLabel?: InputMaybe<Scalars['String']['input']>
}

export type SectionTicketsTableUpdateManyLocalizationInput = {
  data: SectionTicketsTableUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionTicketsTableUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTicketsTableUpdateManyLocalizationInput>>
}

export type SectionTicketsTableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionTicketsTableUpdateManyInput
  /** Document search */
  where: SectionTicketsTableWhereInput
}

export type SectionTicketsTableUpdateOneInlineInput = {
  /** Create and connect one SectionTicketsTable document */
  create?: InputMaybe<SectionTicketsTableCreateInput>
  /** Delete currently connected SectionTicketsTable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTicketsTable document */
  update?: InputMaybe<SectionTicketsTableUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTicketsTable document */
  upsert?: InputMaybe<SectionTicketsTableUpsertWithNestedWhereUniqueInput>
}

export type SectionTicketsTableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionTicketsTableUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTicketsTableWhereUniqueInput
}

export type SectionTicketsTableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionTicketsTableUpdateInput
  /** Unique document search */
  where: SectionTicketsTableWhereUniqueInput
}

export type SectionTicketsTableUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionTicketsTableCreateInput
  /** Update document if it exists */
  update: SectionTicketsTableUpdateInput
}

export type SectionTicketsTableUpsertLocalizationInput = {
  create: SectionTicketsTableCreateLocalizationDataInput
  locale: Locale
  update: SectionTicketsTableUpdateLocalizationDataInput
}

export type SectionTicketsTableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionTicketsTableUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTicketsTableWhereUniqueInput
}

export type SectionTicketsTableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionTicketsTableUpsertInput
  /** Unique document search */
  where: SectionTicketsTableWhereUniqueInput
}

/** Identifies documents */
export type SectionTicketsTableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTicketsTableWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTicketsTableWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTicketsTableWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  columns_every?: InputMaybe<TicketsTableColumnWhereInput>
  columns_none?: InputMaybe<TicketsTableColumnWhereInput>
  columns_some?: InputMaybe<TicketsTableColumnWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  rows_every?: InputMaybe<TicketsTableRowWhereInput>
  rows_none?: InputMaybe<TicketsTableRowWhereInput>
  rows_some?: InputMaybe<TicketsTableRowWhereInput>
  ticketInfoMessage?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ticketInfoMessage_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ticketInfoMessage_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ticketInfoMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ticketInfoMessage_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ticketInfoMessage_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ticketInfoMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ticketInfoMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ticketInfoMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ticketInfoMessage_starts_with?: InputMaybe<Scalars['String']['input']>
  ticketShopLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ticketShopLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ticketShopLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ticketShopLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ticketShopLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ticketShopLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ticketShopLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ticketShopLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ticketShopLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ticketShopLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionTicketsTable record uniquely */
export type SectionTicketsTableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Section consisting of responsive tiles */
export type SectionTiles = Entity & {
  __typename?: 'SectionTiles'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionTiles>
  /** System stage field */
  stage: Stage
  /** Section subtitle */
  subtitle?: Maybe<Scalars['String']['output']>
  /** Theme for Section Tiles */
  theme: OmrThemeVariant
  /** List of section tiles */
  tiles: Array<SectionTilestilesUnion>
  /** Section title */
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section consisting of responsive tiles */
export type SectionTilesLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section consisting of responsive tiles */
export type SectionTilesTilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

/** Section consisting of responsive tiles */
export type SectionTilesUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionTilesConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionTilesWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionTilesConnection = {
  __typename?: 'SectionTilesConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionTilesEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionTilesCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionTilesCreateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  theme: OmrThemeVariant
  tiles?: InputMaybe<SectionTilestilesUnionCreateManyInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTilesCreateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SectionTilesCreateLocalizationInput = {
  /** Localization input */
  data: SectionTilesCreateLocalizationDataInput
  locale: Locale
}

export type SectionTilesCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionTilesCreateLocalizationInput>>
}

export type SectionTilesCreateManyInlineInput = {
  /** Create and connect multiple existing SectionTiles documents */
  create?: InputMaybe<Array<SectionTilesCreateInput>>
}

export type SectionTilesCreateOneInlineInput = {
  /** Create and connect one SectionTiles document */
  create?: InputMaybe<SectionTilesCreateInput>
}

export type SectionTilesCreateWithPositionInput = {
  /** Document to create */
  data: SectionTilesCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionTilesEdge = {
  __typename?: 'SectionTilesEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionTiles
}

/** Identifies documents */
export type SectionTilesManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTilesWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTilesWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTilesWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** All values in which the union is empty. */
  tiles_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  tiles_some?: InputMaybe<SectionTilestilesUnionWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SectionTilesOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SectionTilesParent = EventPage | LandingPage

export type SectionTilesParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionTilesParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionTilesParentCreateManyInlineInput = {
  /** Connect multiple existing SectionTilesParent documents */
  connect?: InputMaybe<Array<SectionTilesParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionTilesParent documents */
  create?: InputMaybe<Array<SectionTilesParentCreateInput>>
}

export type SectionTilesParentCreateOneInlineInput = {
  /** Connect one existing SectionTilesParent document */
  connect?: InputMaybe<SectionTilesParentWhereUniqueInput>
  /** Create and connect one SectionTilesParent document */
  create?: InputMaybe<SectionTilesParentCreateInput>
}

export type SectionTilesParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionTilesParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionTilesParent documents */
  connect?: InputMaybe<Array<SectionTilesParentConnectInput>>
  /** Create and connect multiple SectionTilesParent documents */
  create?: InputMaybe<Array<SectionTilesParentCreateInput>>
  /** Delete multiple SectionTilesParent documents */
  delete?: InputMaybe<Array<SectionTilesParentWhereUniqueInput>>
  /** Disconnect multiple SectionTilesParent documents */
  disconnect?: InputMaybe<Array<SectionTilesParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionTilesParent documents */
  set?: InputMaybe<Array<SectionTilesParentWhereUniqueInput>>
  /** Update multiple SectionTilesParent documents */
  update?: InputMaybe<Array<SectionTilesParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionTilesParent documents */
  upsert?: InputMaybe<Array<SectionTilesParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionTilesParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionTilesParentUpdateOneInlineInput = {
  /** Connect existing SectionTilesParent document */
  connect?: InputMaybe<SectionTilesParentWhereUniqueInput>
  /** Create and connect one SectionTilesParent document */
  create?: InputMaybe<SectionTilesParentCreateInput>
  /** Delete currently connected SectionTilesParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionTilesParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTilesParent document */
  update?: InputMaybe<SectionTilesParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTilesParent document */
  upsert?: InputMaybe<SectionTilesParentUpsertWithNestedWhereUniqueInput>
}

export type SectionTilesParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionTilesParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionTilesParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionTilesParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionTilesUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<SectionTilesUpdateLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  theme?: InputMaybe<OmrThemeVariant>
  tiles?: InputMaybe<SectionTilestilesUnionUpdateManyInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionTilesUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionTilesUpdateLocalizationInput = {
  data: SectionTilesUpdateLocalizationDataInput
  locale: Locale
}

export type SectionTilesUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionTilesCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTilesUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionTilesUpsertLocalizationInput>>
}

export type SectionTilesUpdateManyInlineInput = {
  /** Create and connect multiple SectionTiles component instances */
  create?: InputMaybe<Array<SectionTilesCreateWithPositionInput>>
  /** Delete multiple SectionTiles documents */
  delete?: InputMaybe<Array<SectionTilesWhereUniqueInput>>
  /** Update multiple SectionTiles component instances */
  update?: InputMaybe<Array<SectionTilesUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionTiles component instances */
  upsert?: InputMaybe<Array<SectionTilesUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionTilesUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionTilesUpdateManyLocalizationsInput>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionTilesUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SectionTilesUpdateManyLocalizationInput = {
  data: SectionTilesUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionTilesUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionTilesUpdateManyLocalizationInput>>
}

export type SectionTilesUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionTilesUpdateManyInput
  /** Document search */
  where: SectionTilesWhereInput
}

export type SectionTilesUpdateOneInlineInput = {
  /** Create and connect one SectionTiles document */
  create?: InputMaybe<SectionTilesCreateInput>
  /** Delete currently connected SectionTiles document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTiles document */
  update?: InputMaybe<SectionTilesUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTiles document */
  upsert?: InputMaybe<SectionTilesUpsertWithNestedWhereUniqueInput>
}

export type SectionTilesUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionTilesUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTilesWhereUniqueInput
}

export type SectionTilesUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionTilesUpdateInput
  /** Unique document search */
  where: SectionTilesWhereUniqueInput
}

export type SectionTilesUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionTilesCreateInput
  /** Update document if it exists */
  update: SectionTilesUpdateInput
}

export type SectionTilesUpsertLocalizationInput = {
  create: SectionTilesCreateLocalizationDataInput
  locale: Locale
  update: SectionTilesUpdateLocalizationDataInput
}

export type SectionTilesUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionTilesUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionTilesWhereUniqueInput
}

export type SectionTilesUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionTilesUpsertInput
  /** Unique document search */
  where: SectionTilesWhereUniqueInput
}

/** Identifies documents */
export type SectionTilesWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionTilesWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionTilesWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionTilesWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** All values in which the union is empty. */
  tiles_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  tiles_some?: InputMaybe<SectionTilestilesUnionWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SectionTiles record uniquely */
export type SectionTilesWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SectionTilestilesUnion =
  | HubPageAdTile
  | HubPageArticleListTile
  | HubPageContentTile
  | HubPageImageTile
  | HubPageInfoTile
  | HubPageLatestArticleTile
  | HubPageNewsletterSubscriptionTile
  | HubPagePartnerCompanyTile
  | HubPageReferenceListTile
  | HubPageSocialMediaTile
  | HubPageSpeakerTile
  | HubPageStaticTile

export type SectionTilestilesUnionConnectInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileConnectInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileConnectInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileConnectInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileConnectInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileConnectInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileConnectInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileConnectInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileConnectInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileConnectInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileConnectInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileConnectInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileConnectInput>
}

export type SectionTilestilesUnionCreateInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileCreateInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileCreateInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileCreateInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileCreateInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileCreateInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileCreateInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileCreateInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileCreateInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileCreateInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileCreateInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileCreateInput>
}

export type SectionTilestilesUnionCreateManyInlineInput = {
  /** Create and connect multiple existing SectionTilestilesUnion documents */
  create?: InputMaybe<Array<SectionTilestilesUnionCreateInput>>
}

export type SectionTilestilesUnionCreateOneInlineInput = {
  /** Create and connect one SectionTilestilesUnion document */
  create?: InputMaybe<SectionTilestilesUnionCreateInput>
}

export type SectionTilestilesUnionCreateWithPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileCreateWithPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileCreateWithPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileCreateWithPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileCreateWithPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileCreateWithPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileCreateWithPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileCreateWithPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileCreateWithPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileCreateWithPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileCreateWithPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileCreateWithPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileCreateWithPositionInput>
}

export type SectionTilestilesUnionUpdateInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateInput>
}

export type SectionTilestilesUnionUpdateManyInlineInput = {
  /** Create and connect multiple SectionTilestilesUnion component instances */
  create?: InputMaybe<Array<SectionTilestilesUnionCreateWithPositionInput>>
  /** Delete multiple SectionTilestilesUnion documents */
  delete?: InputMaybe<Array<SectionTilestilesUnionWhereUniqueInput>>
  /** Update multiple SectionTilestilesUnion component instances */
  update?: InputMaybe<Array<SectionTilestilesUnionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionTilestilesUnion component instances */
  upsert?: InputMaybe<Array<SectionTilestilesUnionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionTilestilesUnionUpdateManyWithNestedWhereInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateManyWithNestedWhereInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateManyWithNestedWhereInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateManyWithNestedWhereInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateManyWithNestedWhereInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateManyWithNestedWhereInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateManyWithNestedWhereInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateManyWithNestedWhereInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateManyWithNestedWhereInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateManyWithNestedWhereInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateManyWithNestedWhereInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateManyWithNestedWhereInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateManyWithNestedWhereInput>
}

export type SectionTilestilesUnionUpdateOneInlineInput = {
  /** Create and connect one SectionTilestilesUnion document */
  create?: InputMaybe<SectionTilestilesUnionCreateInput>
  /** Delete currently connected SectionTilestilesUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionTilestilesUnion document */
  update?: InputMaybe<SectionTilestilesUnionUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionTilestilesUnion document */
  upsert?: InputMaybe<SectionTilestilesUnionUpsertWithNestedWhereUniqueInput>
}

export type SectionTilestilesUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateWithNestedWhereUniqueAndPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateWithNestedWhereUniqueAndPositionInput>
}

export type SectionTilestilesUnionUpdateWithNestedWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpdateWithNestedWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpdateWithNestedWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpdateWithNestedWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpdateWithNestedWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpdateWithNestedWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpdateWithNestedWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpdateWithNestedWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpdateWithNestedWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpdateWithNestedWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpdateWithNestedWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpdateWithNestedWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpdateWithNestedWhereUniqueInput>
}

export type SectionTilestilesUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpsertWithNestedWhereUniqueAndPositionInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpsertWithNestedWhereUniqueAndPositionInput>
}

export type SectionTilestilesUnionUpsertWithNestedWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileUpsertWithNestedWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileUpsertWithNestedWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileUpsertWithNestedWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileUpsertWithNestedWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileUpsertWithNestedWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileUpsertWithNestedWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileUpsertWithNestedWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileUpsertWithNestedWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileUpsertWithNestedWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileUpsertWithNestedWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileUpsertWithNestedWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileUpsertWithNestedWhereUniqueInput>
}

export type SectionTilestilesUnionWhereInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileWhereInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileWhereInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileWhereInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileWhereInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileWhereInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileWhereInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileWhereInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileWhereInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileWhereInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileWhereInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileWhereInput>
}

export type SectionTilestilesUnionWhereUniqueInput = {
  HubPageAdTile?: InputMaybe<HubPageAdTileWhereUniqueInput>
  HubPageArticleListTile?: InputMaybe<HubPageArticleListTileWhereUniqueInput>
  HubPageContentTile?: InputMaybe<HubPageContentTileWhereUniqueInput>
  HubPageImageTile?: InputMaybe<HubPageImageTileWhereUniqueInput>
  HubPageInfoTile?: InputMaybe<HubPageInfoTileWhereUniqueInput>
  HubPageLatestArticleTile?: InputMaybe<HubPageLatestArticleTileWhereUniqueInput>
  HubPageNewsletterSubscriptionTile?: InputMaybe<HubPageNewsletterSubscriptionTileWhereUniqueInput>
  HubPagePartnerCompanyTile?: InputMaybe<HubPagePartnerCompanyTileWhereUniqueInput>
  HubPageReferenceListTile?: InputMaybe<HubPageReferenceListTileWhereUniqueInput>
  HubPageSocialMediaTile?: InputMaybe<HubPageSocialMediaTileWhereUniqueInput>
  HubPageSpeakerTile?: InputMaybe<HubPageSpeakerTileWhereUniqueInput>
  HubPageStaticTile?: InputMaybe<HubPageStaticTileWhereUniqueInput>
}

/** Section showing a video with a title. */
export type SectionVideo = Entity & {
  __typename?: 'SectionVideo'
  dates: Array<Scalars['String']['output']>
  /** Select a decoration pattern for this component. */
  decorationPattern?: Maybe<DecorationPattern>
  description?: Maybe<Scalars['String']['output']>
  /** Hide the Section Head for Livestream Layout */
  hideSectionHead?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SectionVideo>
  /** System stage field */
  stage: Stage
  styleVariant?: Maybe<ComponentStyle>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  vidTitle?: Maybe<Scalars['String']['output']>
  ytVideoId: Scalars['String']['output']
  ytVideoTitle: Scalars['String']['output']
}

/** Section showing a video with a title. */
export type SectionVideoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section showing a video with a title. */
export type SectionVideoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SectionVideoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SectionVideoWhereUniqueInput
}

/** A connection to a list of items. */
export type SectionVideoConnection = {
  __typename?: 'SectionVideoConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SectionVideoEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SectionVideoCreateInput = {
  /** dates input for default locale (de) */
  dates?: InputMaybe<Array<Scalars['String']['input']>>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hideSectionHead?: InputMaybe<Scalars['Boolean']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionVideoCreateLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** vidTitle input for default locale (de) */
  vidTitle?: InputMaybe<Scalars['String']['input']>
  ytVideoId: Scalars['String']['input']
  ytVideoTitle: Scalars['String']['input']
}

export type SectionVideoCreateLocalizationDataInput = {
  dates?: InputMaybe<Array<Scalars['String']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  vidTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionVideoCreateLocalizationInput = {
  /** Localization input */
  data: SectionVideoCreateLocalizationDataInput
  locale: Locale
}

export type SectionVideoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionVideoCreateLocalizationInput>>
}

export type SectionVideoCreateManyInlineInput = {
  /** Create and connect multiple existing SectionVideo documents */
  create?: InputMaybe<Array<SectionVideoCreateInput>>
}

export type SectionVideoCreateOneInlineInput = {
  /** Create and connect one SectionVideo document */
  create?: InputMaybe<SectionVideoCreateInput>
}

export type SectionVideoCreateWithPositionInput = {
  /** Document to create */
  data: SectionVideoCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SectionVideoEdge = {
  __typename?: 'SectionVideoEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SectionVideo
}

/** Identifies documents */
export type SectionVideoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionVideoWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionVideoWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionVideoWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  hideSectionHead?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideSectionHead_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  ytVideoId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ytVideoId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ytVideoId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ytVideoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ytVideoId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ytVideoId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ytVideoId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ytVideoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ytVideoId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ytVideoId_starts_with?: InputMaybe<Scalars['String']['input']>
  ytVideoTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ytVideoTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ytVideoTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ytVideoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ytVideoTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ytVideoTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ytVideoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ytVideoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ytVideoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ytVideoTitle_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum SectionVideoOrderByInput {
  DatesAsc = 'dates_ASC',
  DatesDesc = 'dates_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HideSectionHeadAsc = 'hideSectionHead_ASC',
  HideSectionHeadDesc = 'hideSectionHead_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VidTitleAsc = 'vidTitle_ASC',
  VidTitleDesc = 'vidTitle_DESC',
  YtVideoIdAsc = 'ytVideoId_ASC',
  YtVideoIdDesc = 'ytVideoId_DESC',
  YtVideoTitleAsc = 'ytVideoTitle_ASC',
  YtVideoTitleDesc = 'ytVideoTitle_DESC',
}

export type SectionVideoParent = CareerPage | EventPage | LandingPage

export type SectionVideoParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SectionVideoParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SectionVideoParentCreateManyInlineInput = {
  /** Connect multiple existing SectionVideoParent documents */
  connect?: InputMaybe<Array<SectionVideoParentWhereUniqueInput>>
  /** Create and connect multiple existing SectionVideoParent documents */
  create?: InputMaybe<Array<SectionVideoParentCreateInput>>
}

export type SectionVideoParentCreateOneInlineInput = {
  /** Connect one existing SectionVideoParent document */
  connect?: InputMaybe<SectionVideoParentWhereUniqueInput>
  /** Create and connect one SectionVideoParent document */
  create?: InputMaybe<SectionVideoParentCreateInput>
}

export type SectionVideoParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SectionVideoParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionVideoParent documents */
  connect?: InputMaybe<Array<SectionVideoParentConnectInput>>
  /** Create and connect multiple SectionVideoParent documents */
  create?: InputMaybe<Array<SectionVideoParentCreateInput>>
  /** Delete multiple SectionVideoParent documents */
  delete?: InputMaybe<Array<SectionVideoParentWhereUniqueInput>>
  /** Disconnect multiple SectionVideoParent documents */
  disconnect?: InputMaybe<Array<SectionVideoParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SectionVideoParent documents */
  set?: InputMaybe<Array<SectionVideoParentWhereUniqueInput>>
  /** Update multiple SectionVideoParent documents */
  update?: InputMaybe<Array<SectionVideoParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SectionVideoParent documents */
  upsert?: InputMaybe<Array<SectionVideoParentUpsertWithNestedWhereUniqueInput>>
}

export type SectionVideoParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SectionVideoParentUpdateOneInlineInput = {
  /** Connect existing SectionVideoParent document */
  connect?: InputMaybe<SectionVideoParentWhereUniqueInput>
  /** Create and connect one SectionVideoParent document */
  create?: InputMaybe<SectionVideoParentCreateInput>
  /** Delete currently connected SectionVideoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SectionVideoParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionVideoParent document */
  update?: InputMaybe<SectionVideoParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionVideoParent document */
  upsert?: InputMaybe<SectionVideoParentUpsertWithNestedWhereUniqueInput>
}

export type SectionVideoParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SectionVideoParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SectionVideoParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SectionVideoParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SectionVideoUpdateInput = {
  /** dates input for default locale (de) */
  dates?: InputMaybe<Array<Scalars['String']['input']>>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hideSectionHead?: InputMaybe<Scalars['Boolean']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SectionVideoUpdateLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  /** vidTitle input for default locale (de) */
  vidTitle?: InputMaybe<Scalars['String']['input']>
  ytVideoId?: InputMaybe<Scalars['String']['input']>
  ytVideoTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionVideoUpdateLocalizationDataInput = {
  dates?: InputMaybe<Array<Scalars['String']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  vidTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionVideoUpdateLocalizationInput = {
  data: SectionVideoUpdateLocalizationDataInput
  locale: Locale
}

export type SectionVideoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionVideoCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SectionVideoUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SectionVideoUpsertLocalizationInput>>
}

export type SectionVideoUpdateManyInlineInput = {
  /** Create and connect multiple SectionVideo component instances */
  create?: InputMaybe<Array<SectionVideoCreateWithPositionInput>>
  /** Delete multiple SectionVideo documents */
  delete?: InputMaybe<Array<SectionVideoWhereUniqueInput>>
  /** Update multiple SectionVideo component instances */
  update?: InputMaybe<Array<SectionVideoUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SectionVideo component instances */
  upsert?: InputMaybe<Array<SectionVideoUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SectionVideoUpdateManyInput = {
  /** dates input for default locale (de) */
  dates?: InputMaybe<Array<Scalars['String']['input']>>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  hideSectionHead?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionVideoUpdateManyLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  /** vidTitle input for default locale (de) */
  vidTitle?: InputMaybe<Scalars['String']['input']>
  ytVideoId?: InputMaybe<Scalars['String']['input']>
  ytVideoTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionVideoUpdateManyLocalizationDataInput = {
  dates?: InputMaybe<Array<Scalars['String']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  vidTitle?: InputMaybe<Scalars['String']['input']>
}

export type SectionVideoUpdateManyLocalizationInput = {
  data: SectionVideoUpdateManyLocalizationDataInput
  locale: Locale
}

export type SectionVideoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionVideoUpdateManyLocalizationInput>>
}

export type SectionVideoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionVideoUpdateManyInput
  /** Document search */
  where: SectionVideoWhereInput
}

export type SectionVideoUpdateOneInlineInput = {
  /** Create and connect one SectionVideo document */
  create?: InputMaybe<SectionVideoCreateInput>
  /** Delete currently connected SectionVideo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SectionVideo document */
  update?: InputMaybe<SectionVideoUpdateWithNestedWhereUniqueInput>
  /** Upsert single SectionVideo document */
  upsert?: InputMaybe<SectionVideoUpsertWithNestedWhereUniqueInput>
}

export type SectionVideoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionVideoUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionVideoWhereUniqueInput
}

export type SectionVideoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionVideoUpdateInput
  /** Unique document search */
  where: SectionVideoWhereUniqueInput
}

export type SectionVideoUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionVideoCreateInput
  /** Update document if it exists */
  update: SectionVideoUpdateInput
}

export type SectionVideoUpsertLocalizationInput = {
  create: SectionVideoCreateLocalizationDataInput
  locale: Locale
  update: SectionVideoUpdateLocalizationDataInput
}

export type SectionVideoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionVideoUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SectionVideoWhereUniqueInput
}

export type SectionVideoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionVideoUpsertInput
  /** Unique document search */
  where: SectionVideoWhereUniqueInput
}

/** Identifies documents */
export type SectionVideoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionVideoWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionVideoWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionVideoWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  dates?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  dates_contains_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  dates_contains_none?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  dates_contains_some?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  dates_not?: InputMaybe<Array<Scalars['String']['input']>>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  hideSectionHead?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  hideSectionHead_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  vidTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  vidTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  vidTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  vidTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  vidTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  vidTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  vidTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  vidTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  vidTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  vidTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  ytVideoId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ytVideoId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ytVideoId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ytVideoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ytVideoId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ytVideoId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ytVideoId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ytVideoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ytVideoId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ytVideoId_starts_with?: InputMaybe<Scalars['String']['input']>
  ytVideoTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ytVideoTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ytVideoTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ytVideoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ytVideoTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ytVideoTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ytVideoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ytVideoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ytVideoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ytVideoTitle_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** References SectionVideo record uniquely */
export type SectionVideoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Semantic size for a button */
export enum SemanticButtonSizeEnum {
  L = 'l',
  M = 'm',
  S = 's',
  Xs = 'xs',
}

/** Semantic style for a button */
export enum SemanticButtonStyleEnum {
  OutlineColor = 'outline_color',
  OutlineDestructive = 'outline_destructive',
  OutlineNeutral = 'outline_neutral',
  OutlineSuccess = 'outline_success',
  PrimaryColor = 'primary_color',
  PrimaryDestructive = 'primary_destructive',
  PrimaryNeutral = 'primary_neutral',
  PrimarySuccess = 'primary_success',
  SecondaryColor = 'secondary_color',
  SecondaryDestructive = 'secondary_destructive',
  SecondaryNeutral = 'secondary_neutral',
  SecondarySuccess = 'secondary_success',
}

export type Seo = Entity & {
  __typename?: 'Seo'
  /** If not provided we will fallback to article snippet */
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  keywords: Array<Scalars['String']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<Seo>
  noFollow?: Maybe<Scalars['Boolean']['output']>
  /** If true, the page will not be indexed by search engines as well as our internal global search. */
  noIndex?: Maybe<Scalars['Boolean']['output']>
  /** If not provided we will fallback to SEO description */
  ogDescription?: Maybe<Scalars['String']['output']>
  ogImage?: Maybe<Asset>
  /** If not provided we will fallback to SEO title */
  ogTitle?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  /** If not provided we will fallback to page/article title */
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SeoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SeoOgImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SeoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SeoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SeoWhereUniqueInput
}

/** A connection to a list of items. */
export type SeoConnection = {
  __typename?: 'SeoConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SeoEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SeoContentAttribute = Entity & {
  __typename?: 'SeoContentAttribute'
  bottomSectionBody?: Maybe<RichText>
  bottomSectionHeadline?: Maybe<Scalars['String']['output']>
  h1?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SeoContentAttribute>
  /** System stage field */
  stage: Stage
  topSectionBody?: Maybe<RichText>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SeoContentAttributeLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SeoContentAttributeUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SeoContentAttributeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SeoContentAttributeWhereUniqueInput
}

/** A connection to a list of items. */
export type SeoContentAttributeConnection = {
  __typename?: 'SeoContentAttributeConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SeoContentAttributeEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SeoContentAttributeCreateInput = {
  /** bottomSectionBody input for default locale (de) */
  bottomSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
  /** bottomSectionHeadline input for default locale (de) */
  bottomSectionHeadline?: InputMaybe<Scalars['String']['input']>
  /** h1 input for default locale (de) */
  h1?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SeoContentAttributeCreateLocalizationsInput>
  /** topSectionBody input for default locale (de) */
  topSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SeoContentAttributeCreateLocalizationDataInput = {
  bottomSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
  bottomSectionHeadline?: InputMaybe<Scalars['String']['input']>
  h1?: InputMaybe<Scalars['String']['input']>
  topSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SeoContentAttributeCreateLocalizationInput = {
  /** Localization input */
  data: SeoContentAttributeCreateLocalizationDataInput
  locale: Locale
}

export type SeoContentAttributeCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SeoContentAttributeCreateLocalizationInput>>
}

export type SeoContentAttributeCreateManyInlineInput = {
  /** Create and connect multiple existing SeoContentAttribute documents */
  create?: InputMaybe<Array<SeoContentAttributeCreateInput>>
}

export type SeoContentAttributeCreateOneInlineInput = {
  /** Create and connect one SeoContentAttribute document */
  create?: InputMaybe<SeoContentAttributeCreateInput>
}

export type SeoContentAttributeCreateWithPositionInput = {
  /** Document to create */
  data: SeoContentAttributeCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SeoContentAttributeEdge = {
  __typename?: 'SeoContentAttributeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SeoContentAttribute
}

/** Identifies documents */
export type SeoContentAttributeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoContentAttributeWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoContentAttributeWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoContentAttributeWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SeoContentAttributeOrderByInput {
  BottomSectionHeadlineAsc = 'bottomSectionHeadline_ASC',
  BottomSectionHeadlineDesc = 'bottomSectionHeadline_DESC',
  H1Asc = 'h1_ASC',
  H1Desc = 'h1_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SeoContentAttributeParent = LandingPage | Tag

export type SeoContentAttributeParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
  Tag?: InputMaybe<TagConnectInput>
}

export type SeoContentAttributeParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
  Tag?: InputMaybe<TagCreateInput>
}

export type SeoContentAttributeParentCreateManyInlineInput = {
  /** Connect multiple existing SeoContentAttributeParent documents */
  connect?: InputMaybe<Array<SeoContentAttributeParentWhereUniqueInput>>
  /** Create and connect multiple existing SeoContentAttributeParent documents */
  create?: InputMaybe<Array<SeoContentAttributeParentCreateInput>>
}

export type SeoContentAttributeParentCreateOneInlineInput = {
  /** Connect one existing SeoContentAttributeParent document */
  connect?: InputMaybe<SeoContentAttributeParentWhereUniqueInput>
  /** Create and connect one SeoContentAttributeParent document */
  create?: InputMaybe<SeoContentAttributeParentCreateInput>
}

export type SeoContentAttributeParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
  Tag?: InputMaybe<TagUpdateInput>
}

export type SeoContentAttributeParentUpdateManyInlineInput = {
  /** Connect multiple existing SeoContentAttributeParent documents */
  connect?: InputMaybe<Array<SeoContentAttributeParentConnectInput>>
  /** Create and connect multiple SeoContentAttributeParent documents */
  create?: InputMaybe<Array<SeoContentAttributeParentCreateInput>>
  /** Delete multiple SeoContentAttributeParent documents */
  delete?: InputMaybe<Array<SeoContentAttributeParentWhereUniqueInput>>
  /** Disconnect multiple SeoContentAttributeParent documents */
  disconnect?: InputMaybe<Array<SeoContentAttributeParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SeoContentAttributeParent documents */
  set?: InputMaybe<Array<SeoContentAttributeParentWhereUniqueInput>>
  /** Update multiple SeoContentAttributeParent documents */
  update?: InputMaybe<Array<SeoContentAttributeParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SeoContentAttributeParent documents */
  upsert?: InputMaybe<Array<SeoContentAttributeParentUpsertWithNestedWhereUniqueInput>>
}

export type SeoContentAttributeParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
  Tag?: InputMaybe<TagUpdateManyWithNestedWhereInput>
}

export type SeoContentAttributeParentUpdateOneInlineInput = {
  /** Connect existing SeoContentAttributeParent document */
  connect?: InputMaybe<SeoContentAttributeParentWhereUniqueInput>
  /** Create and connect one SeoContentAttributeParent document */
  create?: InputMaybe<SeoContentAttributeParentCreateInput>
  /** Delete currently connected SeoContentAttributeParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SeoContentAttributeParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SeoContentAttributeParent document */
  update?: InputMaybe<SeoContentAttributeParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SeoContentAttributeParent document */
  upsert?: InputMaybe<SeoContentAttributeParentUpsertWithNestedWhereUniqueInput>
}

export type SeoContentAttributeParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
  Tag?: InputMaybe<TagUpdateWithNestedWhereUniqueInput>
}

export type SeoContentAttributeParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
  Tag?: InputMaybe<TagUpsertWithNestedWhereUniqueInput>
}

export type SeoContentAttributeParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
  Tag?: InputMaybe<TagWhereInput>
}

export type SeoContentAttributeParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
  Tag?: InputMaybe<TagWhereUniqueInput>
}

export type SeoContentAttributeUpdateInput = {
  /** bottomSectionBody input for default locale (de) */
  bottomSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
  /** bottomSectionHeadline input for default locale (de) */
  bottomSectionHeadline?: InputMaybe<Scalars['String']['input']>
  /** h1 input for default locale (de) */
  h1?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SeoContentAttributeUpdateLocalizationsInput>
  /** topSectionBody input for default locale (de) */
  topSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type SeoContentAttributeUpdateLocalizationDataInput = {
  bottomSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
  bottomSectionHeadline?: InputMaybe<Scalars['String']['input']>
  h1?: InputMaybe<Scalars['String']['input']>
  topSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type SeoContentAttributeUpdateLocalizationInput = {
  data: SeoContentAttributeUpdateLocalizationDataInput
  locale: Locale
}

export type SeoContentAttributeUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SeoContentAttributeCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SeoContentAttributeUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SeoContentAttributeUpsertLocalizationInput>>
}

export type SeoContentAttributeUpdateManyInlineInput = {
  /** Create and connect multiple SeoContentAttribute component instances */
  create?: InputMaybe<Array<SeoContentAttributeCreateWithPositionInput>>
  /** Delete multiple SeoContentAttribute documents */
  delete?: InputMaybe<Array<SeoContentAttributeWhereUniqueInput>>
  /** Update multiple SeoContentAttribute component instances */
  update?: InputMaybe<Array<SeoContentAttributeUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SeoContentAttribute component instances */
  upsert?: InputMaybe<Array<SeoContentAttributeUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SeoContentAttributeUpdateManyInput = {
  /** bottomSectionBody input for default locale (de) */
  bottomSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
  /** bottomSectionHeadline input for default locale (de) */
  bottomSectionHeadline?: InputMaybe<Scalars['String']['input']>
  /** h1 input for default locale (de) */
  h1?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SeoContentAttributeUpdateManyLocalizationsInput>
  /** topSectionBody input for default locale (de) */
  topSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type SeoContentAttributeUpdateManyLocalizationDataInput = {
  bottomSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
  bottomSectionHeadline?: InputMaybe<Scalars['String']['input']>
  h1?: InputMaybe<Scalars['String']['input']>
  topSectionBody?: InputMaybe<Scalars['RichTextAST']['input']>
}

export type SeoContentAttributeUpdateManyLocalizationInput = {
  data: SeoContentAttributeUpdateManyLocalizationDataInput
  locale: Locale
}

export type SeoContentAttributeUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SeoContentAttributeUpdateManyLocalizationInput>>
}

export type SeoContentAttributeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SeoContentAttributeUpdateManyInput
  /** Document search */
  where: SeoContentAttributeWhereInput
}

export type SeoContentAttributeUpdateOneInlineInput = {
  /** Create and connect one SeoContentAttribute document */
  create?: InputMaybe<SeoContentAttributeCreateInput>
  /** Delete currently connected SeoContentAttribute document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SeoContentAttribute document */
  update?: InputMaybe<SeoContentAttributeUpdateWithNestedWhereUniqueInput>
  /** Upsert single SeoContentAttribute document */
  upsert?: InputMaybe<SeoContentAttributeUpsertWithNestedWhereUniqueInput>
}

export type SeoContentAttributeUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SeoContentAttributeUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SeoContentAttributeWhereUniqueInput
}

export type SeoContentAttributeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SeoContentAttributeUpdateInput
  /** Unique document search */
  where: SeoContentAttributeWhereUniqueInput
}

export type SeoContentAttributeUpsertInput = {
  /** Create document if it didn't exist */
  create: SeoContentAttributeCreateInput
  /** Update document if it exists */
  update: SeoContentAttributeUpdateInput
}

export type SeoContentAttributeUpsertLocalizationInput = {
  create: SeoContentAttributeCreateLocalizationDataInput
  locale: Locale
  update: SeoContentAttributeUpdateLocalizationDataInput
}

export type SeoContentAttributeUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SeoContentAttributeUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SeoContentAttributeWhereUniqueInput
}

export type SeoContentAttributeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SeoContentAttributeUpsertInput
  /** Unique document search */
  where: SeoContentAttributeWhereUniqueInput
}

/** Identifies documents */
export type SeoContentAttributeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoContentAttributeWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoContentAttributeWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoContentAttributeWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  bottomSectionHeadline?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  bottomSectionHeadline_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  bottomSectionHeadline_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  bottomSectionHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  bottomSectionHeadline_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  bottomSectionHeadline_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  bottomSectionHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  bottomSectionHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  bottomSectionHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  bottomSectionHeadline_starts_with?: InputMaybe<Scalars['String']['input']>
  h1?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  h1_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  h1_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  h1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  h1_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  h1_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  h1_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  h1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  h1_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  h1_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SeoContentAttribute record uniquely */
export type SeoContentAttributeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type SeoCreateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** keywords input for default locale (de) */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SeoCreateLocalizationsInput>
  noFollow?: InputMaybe<Scalars['Boolean']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** ogDescription input for default locale (de) */
  ogDescription?: InputMaybe<Scalars['String']['input']>
  ogImage?: InputMaybe<AssetCreateOneInlineInput>
  /** ogTitle input for default locale (de) */
  ogTitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SeoCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  ogDescription?: InputMaybe<Scalars['String']['input']>
  ogTitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SeoCreateLocalizationInput = {
  /** Localization input */
  data: SeoCreateLocalizationDataInput
  locale: Locale
}

export type SeoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SeoCreateLocalizationInput>>
}

export type SeoCreateManyInlineInput = {
  /** Create and connect multiple existing Seo documents */
  create?: InputMaybe<Array<SeoCreateInput>>
}

export type SeoCreateOneInlineInput = {
  /** Create and connect one Seo document */
  create?: InputMaybe<SeoCreateInput>
}

export type SeoCreateWithPositionInput = {
  /** Document to create */
  data: SeoCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SeoEdge = {
  __typename?: 'SeoEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Seo
}

/** Identifies documents */
export type SeoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  noFollow?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  noFollow_not?: InputMaybe<Scalars['Boolean']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']['input']>
  ogImage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SeoOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  KeywordsAsc = 'keywords_ASC',
  KeywordsDesc = 'keywords_DESC',
  NoFollowAsc = 'noFollow_ASC',
  NoFollowDesc = 'noFollow_DESC',
  NoIndexAsc = 'noIndex_ASC',
  NoIndexDesc = 'noIndex_DESC',
  OgDescriptionAsc = 'ogDescription_ASC',
  OgDescriptionDesc = 'ogDescription_DESC',
  OgTitleAsc = 'ogTitle_ASC',
  OgTitleDesc = 'ogTitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SeoParent =
  | Article
  | ArticleCategory
  | Author
  | CareerPage
  | EventPage
  | Glossary
  | LandingPage
  | ReviewsProduct
  | ReviewsProductCategory
  | Tag
  | TopicPage

export type SeoParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>
  ArticleCategory?: InputMaybe<ArticleCategoryConnectInput>
  Author?: InputMaybe<AuthorConnectInput>
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  Glossary?: InputMaybe<GlossaryConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
  ReviewsProduct?: InputMaybe<ReviewsProductConnectInput>
  ReviewsProductCategory?: InputMaybe<ReviewsProductCategoryConnectInput>
  Tag?: InputMaybe<TagConnectInput>
  TopicPage?: InputMaybe<TopicPageConnectInput>
}

export type SeoParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>
  ArticleCategory?: InputMaybe<ArticleCategoryCreateInput>
  Author?: InputMaybe<AuthorCreateInput>
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  Glossary?: InputMaybe<GlossaryCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
  ReviewsProduct?: InputMaybe<ReviewsProductCreateInput>
  ReviewsProductCategory?: InputMaybe<ReviewsProductCategoryCreateInput>
  Tag?: InputMaybe<TagCreateInput>
  TopicPage?: InputMaybe<TopicPageCreateInput>
}

export type SeoParentCreateManyInlineInput = {
  /** Connect multiple existing SeoParent documents */
  connect?: InputMaybe<Array<SeoParentWhereUniqueInput>>
  /** Create and connect multiple existing SeoParent documents */
  create?: InputMaybe<Array<SeoParentCreateInput>>
}

export type SeoParentCreateOneInlineInput = {
  /** Connect one existing SeoParent document */
  connect?: InputMaybe<SeoParentWhereUniqueInput>
  /** Create and connect one SeoParent document */
  create?: InputMaybe<SeoParentCreateInput>
}

export type SeoParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>
  ArticleCategory?: InputMaybe<ArticleCategoryUpdateInput>
  Author?: InputMaybe<AuthorUpdateInput>
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  Glossary?: InputMaybe<GlossaryUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
  ReviewsProduct?: InputMaybe<ReviewsProductUpdateInput>
  ReviewsProductCategory?: InputMaybe<ReviewsProductCategoryUpdateInput>
  Tag?: InputMaybe<TagUpdateInput>
  TopicPage?: InputMaybe<TopicPageUpdateInput>
}

export type SeoParentUpdateManyInlineInput = {
  /** Connect multiple existing SeoParent documents */
  connect?: InputMaybe<Array<SeoParentConnectInput>>
  /** Create and connect multiple SeoParent documents */
  create?: InputMaybe<Array<SeoParentCreateInput>>
  /** Delete multiple SeoParent documents */
  delete?: InputMaybe<Array<SeoParentWhereUniqueInput>>
  /** Disconnect multiple SeoParent documents */
  disconnect?: InputMaybe<Array<SeoParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SeoParent documents */
  set?: InputMaybe<Array<SeoParentWhereUniqueInput>>
  /** Update multiple SeoParent documents */
  update?: InputMaybe<Array<SeoParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SeoParent documents */
  upsert?: InputMaybe<Array<SeoParentUpsertWithNestedWhereUniqueInput>>
}

export type SeoParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>
  ArticleCategory?: InputMaybe<ArticleCategoryUpdateManyWithNestedWhereInput>
  Author?: InputMaybe<AuthorUpdateManyWithNestedWhereInput>
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  Glossary?: InputMaybe<GlossaryUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
  ReviewsProduct?: InputMaybe<ReviewsProductUpdateManyWithNestedWhereInput>
  ReviewsProductCategory?: InputMaybe<ReviewsProductCategoryUpdateManyWithNestedWhereInput>
  Tag?: InputMaybe<TagUpdateManyWithNestedWhereInput>
  TopicPage?: InputMaybe<TopicPageUpdateManyWithNestedWhereInput>
}

export type SeoParentUpdateOneInlineInput = {
  /** Connect existing SeoParent document */
  connect?: InputMaybe<SeoParentWhereUniqueInput>
  /** Create and connect one SeoParent document */
  create?: InputMaybe<SeoParentCreateInput>
  /** Delete currently connected SeoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SeoParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SeoParent document */
  update?: InputMaybe<SeoParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SeoParent document */
  upsert?: InputMaybe<SeoParentUpsertWithNestedWhereUniqueInput>
}

export type SeoParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>
  ArticleCategory?: InputMaybe<ArticleCategoryUpdateWithNestedWhereUniqueInput>
  Author?: InputMaybe<AuthorUpdateWithNestedWhereUniqueInput>
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  Glossary?: InputMaybe<GlossaryUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
  ReviewsProduct?: InputMaybe<ReviewsProductUpdateWithNestedWhereUniqueInput>
  ReviewsProductCategory?: InputMaybe<ReviewsProductCategoryUpdateWithNestedWhereUniqueInput>
  Tag?: InputMaybe<TagUpdateWithNestedWhereUniqueInput>
  TopicPage?: InputMaybe<TopicPageUpdateWithNestedWhereUniqueInput>
}

export type SeoParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>
  ArticleCategory?: InputMaybe<ArticleCategoryUpsertWithNestedWhereUniqueInput>
  Author?: InputMaybe<AuthorUpsertWithNestedWhereUniqueInput>
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  Glossary?: InputMaybe<GlossaryUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
  ReviewsProduct?: InputMaybe<ReviewsProductUpsertWithNestedWhereUniqueInput>
  ReviewsProductCategory?: InputMaybe<ReviewsProductCategoryUpsertWithNestedWhereUniqueInput>
  Tag?: InputMaybe<TagUpsertWithNestedWhereUniqueInput>
  TopicPage?: InputMaybe<TopicPageUpsertWithNestedWhereUniqueInput>
}

export type SeoParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>
  ArticleCategory?: InputMaybe<ArticleCategoryWhereInput>
  Author?: InputMaybe<AuthorWhereInput>
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  Glossary?: InputMaybe<GlossaryWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
  ReviewsProduct?: InputMaybe<ReviewsProductWhereInput>
  ReviewsProductCategory?: InputMaybe<ReviewsProductCategoryWhereInput>
  Tag?: InputMaybe<TagWhereInput>
  TopicPage?: InputMaybe<TopicPageWhereInput>
}

export type SeoParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>
  ArticleCategory?: InputMaybe<ArticleCategoryWhereUniqueInput>
  Author?: InputMaybe<AuthorWhereUniqueInput>
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  Glossary?: InputMaybe<GlossaryWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
  ReviewsProduct?: InputMaybe<ReviewsProductWhereUniqueInput>
  ReviewsProductCategory?: InputMaybe<ReviewsProductCategoryWhereUniqueInput>
  Tag?: InputMaybe<TagWhereUniqueInput>
  TopicPage?: InputMaybe<TopicPageWhereUniqueInput>
}

export type SeoUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** keywords input for default locale (de) */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  /** Manage document localizations */
  localizations?: InputMaybe<SeoUpdateLocalizationsInput>
  noFollow?: InputMaybe<Scalars['Boolean']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** ogDescription input for default locale (de) */
  ogDescription?: InputMaybe<Scalars['String']['input']>
  ogImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** ogTitle input for default locale (de) */
  ogTitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SeoUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  ogDescription?: InputMaybe<Scalars['String']['input']>
  ogTitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SeoUpdateLocalizationInput = {
  data: SeoUpdateLocalizationDataInput
  locale: Locale
}

export type SeoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SeoCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SeoUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SeoUpsertLocalizationInput>>
}

export type SeoUpdateManyInlineInput = {
  /** Create and connect multiple Seo component instances */
  create?: InputMaybe<Array<SeoCreateWithPositionInput>>
  /** Delete multiple Seo documents */
  delete?: InputMaybe<Array<SeoWhereUniqueInput>>
  /** Update multiple Seo component instances */
  update?: InputMaybe<Array<SeoUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple Seo component instances */
  upsert?: InputMaybe<Array<SeoUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SeoUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** keywords input for default locale (de) */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SeoUpdateManyLocalizationsInput>
  noFollow?: InputMaybe<Scalars['Boolean']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** ogDescription input for default locale (de) */
  ogDescription?: InputMaybe<Scalars['String']['input']>
  /** ogTitle input for default locale (de) */
  ogTitle?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SeoUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  ogDescription?: InputMaybe<Scalars['String']['input']>
  ogTitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SeoUpdateManyLocalizationInput = {
  data: SeoUpdateManyLocalizationDataInput
  locale: Locale
}

export type SeoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SeoUpdateManyLocalizationInput>>
}

export type SeoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SeoUpdateManyInput
  /** Document search */
  where: SeoWhereInput
}

export type SeoUpdateOneInlineInput = {
  /** Create and connect one Seo document */
  create?: InputMaybe<SeoCreateInput>
  /** Delete currently connected Seo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Seo document */
  update?: InputMaybe<SeoUpdateWithNestedWhereUniqueInput>
  /** Upsert single Seo document */
  upsert?: InputMaybe<SeoUpsertWithNestedWhereUniqueInput>
}

export type SeoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SeoUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SeoWhereUniqueInput
}

export type SeoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SeoUpdateInput
  /** Unique document search */
  where: SeoWhereUniqueInput
}

export type SeoUpsertInput = {
  /** Create document if it didn't exist */
  create: SeoCreateInput
  /** Update document if it exists */
  update: SeoUpdateInput
}

export type SeoUpsertLocalizationInput = {
  create: SeoCreateLocalizationDataInput
  locale: Locale
  update: SeoUpdateLocalizationDataInput
}

export type SeoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SeoUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SeoWhereUniqueInput
}

export type SeoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SeoUpsertInput
  /** Unique document search */
  where: SeoWhereUniqueInput
}

/** Identifies documents */
export type SeoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  keywords_contains_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  keywords_contains_none?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  keywords_contains_some?: InputMaybe<Array<Scalars['String']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  keywords_not?: InputMaybe<Array<Scalars['String']['input']>>
  noFollow?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  noFollow_not?: InputMaybe<Scalars['Boolean']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']['input']>
  ogDescription?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ogDescription_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ogDescription_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ogDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ogDescription_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ogDescription_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ogDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ogDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ogDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ogDescription_starts_with?: InputMaybe<Scalars['String']['input']>
  ogImage?: InputMaybe<AssetWhereInput>
  ogTitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ogTitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ogTitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ogTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ogTitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ogTitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ogTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ogTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ogTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ogTitle_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References Seo record uniquely */
export type SeoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Site section for different OMR business units. */
export type SiteSection = Entity &
  Node & {
    __typename?: 'SiteSection'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<SiteSection>
    /** List of SiteSection versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** Slug for the site section to be used in the URL. */
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Site section for different OMR business units. */
export type SiteSectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Site section for different OMR business units. */
export type SiteSectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Site section for different OMR business units. */
export type SiteSectionHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Site section for different OMR business units. */
export type SiteSectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Site section for different OMR business units. */
export type SiteSectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Site section for different OMR business units. */
export type SiteSectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SiteSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SiteSectionWhereUniqueInput
}

/** A connection to a list of items. */
export type SiteSectionConnection = {
  __typename?: 'SiteSectionConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SiteSectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SiteSectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  landingPageSiteSection?: InputMaybe<LandingPageCreateManyInlineInput>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SiteSectionCreateManyInlineInput = {
  /** Connect multiple existing SiteSection documents */
  connect?: InputMaybe<Array<SiteSectionWhereUniqueInput>>
  /** Create and connect multiple existing SiteSection documents */
  create?: InputMaybe<Array<SiteSectionCreateInput>>
}

export type SiteSectionCreateOneInlineInput = {
  /** Connect one existing SiteSection document */
  connect?: InputMaybe<SiteSectionWhereUniqueInput>
  /** Create and connect one SiteSection document */
  create?: InputMaybe<SiteSectionCreateInput>
}

/** An edge in a connection. */
export type SiteSectionEdge = {
  __typename?: 'SiteSectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SiteSection
}

/** Identifies documents */
export type SiteSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SiteSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SiteSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SiteSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<SiteSectionWhereStageInput>
  documentInStages_none?: InputMaybe<SiteSectionWhereStageInput>
  documentInStages_some?: InputMaybe<SiteSectionWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum SiteSectionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SiteSectionUpdateInput = {
  landingPageSiteSection?: InputMaybe<LandingPageUpdateManyInlineInput>
  name?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type SiteSectionUpdateManyInlineInput = {
  /** Connect multiple existing SiteSection documents */
  connect?: InputMaybe<Array<SiteSectionConnectInput>>
  /** Create and connect multiple SiteSection documents */
  create?: InputMaybe<Array<SiteSectionCreateInput>>
  /** Delete multiple SiteSection documents */
  delete?: InputMaybe<Array<SiteSectionWhereUniqueInput>>
  /** Disconnect multiple SiteSection documents */
  disconnect?: InputMaybe<Array<SiteSectionWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SiteSection documents */
  set?: InputMaybe<Array<SiteSectionWhereUniqueInput>>
  /** Update multiple SiteSection documents */
  update?: InputMaybe<Array<SiteSectionUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SiteSection documents */
  upsert?: InputMaybe<Array<SiteSectionUpsertWithNestedWhereUniqueInput>>
}

export type SiteSectionUpdateManyInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type SiteSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SiteSectionUpdateManyInput
  /** Document search */
  where: SiteSectionWhereInput
}

export type SiteSectionUpdateOneInlineInput = {
  /** Connect existing SiteSection document */
  connect?: InputMaybe<SiteSectionWhereUniqueInput>
  /** Create and connect one SiteSection document */
  create?: InputMaybe<SiteSectionCreateInput>
  /** Delete currently connected SiteSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SiteSection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SiteSection document */
  update?: InputMaybe<SiteSectionUpdateWithNestedWhereUniqueInput>
  /** Upsert single SiteSection document */
  upsert?: InputMaybe<SiteSectionUpsertWithNestedWhereUniqueInput>
}

export type SiteSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SiteSectionUpdateInput
  /** Unique document search */
  where: SiteSectionWhereUniqueInput
}

export type SiteSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: SiteSectionCreateInput
  /** Update document if it exists */
  update: SiteSectionUpdateInput
}

export type SiteSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SiteSectionUpsertInput
  /** Unique document search */
  where: SiteSectionWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type SiteSectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type SiteSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SiteSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SiteSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SiteSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<SiteSectionWhereStageInput>
  documentInStages_none?: InputMaybe<SiteSectionWhereStageInput>
  documentInStages_some?: InputMaybe<SiteSectionWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SiteSectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SiteSectionWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SiteSectionWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SiteSectionWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SiteSectionWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References SiteSection record uniquely */
export type SiteSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type Slide = Entity & {
  __typename?: 'Slide'
  ctaText?: Maybe<Scalars['String']['output']>
  ctaUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  heading?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  image: Asset
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<Slide>
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SlideImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SlideLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SlideUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SlideConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SlideWhereUniqueInput
}

/** A connection to a list of items. */
export type SlideConnection = {
  __typename?: 'SlideConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SlideEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SlideCreateInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** heading input for default locale (de) */
  heading?: InputMaybe<Scalars['String']['input']>
  image: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SlideCreateLocalizationsInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SlideCreateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  heading?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SlideCreateLocalizationInput = {
  /** Localization input */
  data: SlideCreateLocalizationDataInput
  locale: Locale
}

export type SlideCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SlideCreateLocalizationInput>>
}

export type SlideCreateManyInlineInput = {
  /** Create and connect multiple existing Slide documents */
  create?: InputMaybe<Array<SlideCreateInput>>
}

export type SlideCreateOneInlineInput = {
  /** Create and connect one Slide document */
  create?: InputMaybe<SlideCreateInput>
}

export type SlideCreateWithPositionInput = {
  /** Document to create */
  data: SlideCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SlideEdge = {
  __typename?: 'SlideEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Slide
}

/** Identifies documents */
export type SlideManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SlideWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SlideWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SlideWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SlideOrderByInput {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SlideParent = ImageSlider | PreviewCardList

export type SlideParentConnectInput = {
  ImageSlider?: InputMaybe<ImageSliderConnectInput>
  PreviewCardList?: InputMaybe<PreviewCardListConnectInput>
}

export type SlideParentCreateInput = {
  ImageSlider?: InputMaybe<ImageSliderCreateInput>
  PreviewCardList?: InputMaybe<PreviewCardListCreateInput>
}

export type SlideParentCreateManyInlineInput = {
  /** Create and connect multiple existing SlideParent documents */
  create?: InputMaybe<Array<SlideParentCreateInput>>
}

export type SlideParentCreateOneInlineInput = {
  /** Create and connect one SlideParent document */
  create?: InputMaybe<SlideParentCreateInput>
}

export type SlideParentCreateWithPositionInput = {
  ImageSlider?: InputMaybe<ImageSliderCreateWithPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListCreateWithPositionInput>
}

export type SlideParentUpdateInput = {
  ImageSlider?: InputMaybe<ImageSliderUpdateInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateInput>
}

export type SlideParentUpdateManyInlineInput = {
  /** Create and connect multiple SlideParent component instances */
  create?: InputMaybe<Array<SlideParentCreateWithPositionInput>>
  /** Delete multiple SlideParent documents */
  delete?: InputMaybe<Array<SlideParentWhereUniqueInput>>
  /** Update multiple SlideParent component instances */
  update?: InputMaybe<Array<SlideParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SlideParent component instances */
  upsert?: InputMaybe<Array<SlideParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SlideParentUpdateManyWithNestedWhereInput = {
  ImageSlider?: InputMaybe<ImageSliderUpdateManyWithNestedWhereInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateManyWithNestedWhereInput>
}

export type SlideParentUpdateOneInlineInput = {
  /** Create and connect one SlideParent document */
  create?: InputMaybe<SlideParentCreateInput>
  /** Delete currently connected SlideParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SlideParent document */
  update?: InputMaybe<SlideParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SlideParent document */
  upsert?: InputMaybe<SlideParentUpsertWithNestedWhereUniqueInput>
}

export type SlideParentUpdateWithNestedWhereUniqueAndPositionInput = {
  ImageSlider?: InputMaybe<ImageSliderUpdateWithNestedWhereUniqueAndPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateWithNestedWhereUniqueAndPositionInput>
}

export type SlideParentUpdateWithNestedWhereUniqueInput = {
  ImageSlider?: InputMaybe<ImageSliderUpdateWithNestedWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpdateWithNestedWhereUniqueInput>
}

export type SlideParentUpsertWithNestedWhereUniqueAndPositionInput = {
  ImageSlider?: InputMaybe<ImageSliderUpsertWithNestedWhereUniqueAndPositionInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpsertWithNestedWhereUniqueAndPositionInput>
}

export type SlideParentUpsertWithNestedWhereUniqueInput = {
  ImageSlider?: InputMaybe<ImageSliderUpsertWithNestedWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListUpsertWithNestedWhereUniqueInput>
}

export type SlideParentWhereInput = {
  ImageSlider?: InputMaybe<ImageSliderWhereInput>
  PreviewCardList?: InputMaybe<PreviewCardListWhereInput>
}

export type SlideParentWhereUniqueInput = {
  ImageSlider?: InputMaybe<ImageSliderWhereUniqueInput>
  PreviewCardList?: InputMaybe<PreviewCardListWhereUniqueInput>
}

export type SlideUpdateInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** heading input for default locale (de) */
  heading?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<SlideUpdateLocalizationsInput>
}

export type SlideUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  heading?: InputMaybe<Scalars['String']['input']>
}

export type SlideUpdateLocalizationInput = {
  data: SlideUpdateLocalizationDataInput
  locale: Locale
}

export type SlideUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SlideCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SlideUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SlideUpsertLocalizationInput>>
}

export type SlideUpdateManyInlineInput = {
  /** Create and connect multiple Slide component instances */
  create?: InputMaybe<Array<SlideCreateWithPositionInput>>
  /** Delete multiple Slide documents */
  delete?: InputMaybe<Array<SlideWhereUniqueInput>>
  /** Update multiple Slide component instances */
  update?: InputMaybe<Array<SlideUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple Slide component instances */
  upsert?: InputMaybe<Array<SlideUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SlideUpdateManyInput = {
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** heading input for default locale (de) */
  heading?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SlideUpdateManyLocalizationsInput>
}

export type SlideUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  heading?: InputMaybe<Scalars['String']['input']>
}

export type SlideUpdateManyLocalizationInput = {
  data: SlideUpdateManyLocalizationDataInput
  locale: Locale
}

export type SlideUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SlideUpdateManyLocalizationInput>>
}

export type SlideUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SlideUpdateManyInput
  /** Document search */
  where: SlideWhereInput
}

export type SlideUpdateOneInlineInput = {
  /** Create and connect one Slide document */
  create?: InputMaybe<SlideCreateInput>
  /** Delete currently connected Slide document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Slide document */
  update?: InputMaybe<SlideUpdateWithNestedWhereUniqueInput>
  /** Upsert single Slide document */
  upsert?: InputMaybe<SlideUpsertWithNestedWhereUniqueInput>
}

export type SlideUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SlideUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SlideWhereUniqueInput
}

export type SlideUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SlideUpdateInput
  /** Unique document search */
  where: SlideWhereUniqueInput
}

export type SlideUpsertInput = {
  /** Create document if it didn't exist */
  create: SlideCreateInput
  /** Update document if it exists */
  update: SlideUpdateInput
}

export type SlideUpsertLocalizationInput = {
  create: SlideCreateLocalizationDataInput
  locale: Locale
  update: SlideUpdateLocalizationDataInput
}

export type SlideUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SlideUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SlideWhereUniqueInput
}

export type SlideUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SlideUpsertInput
  /** Unique document search */
  where: SlideWhereUniqueInput
}

/** Identifies documents */
export type SlideWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SlideWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SlideWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SlideWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  heading?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References Slide record uniquely */
export type SlideWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum SliderLayout {
  Landscape = 'landscape',
  Portrait = 'portrait',
}

/** Social media related links */
export type Social = Entity & {
  __typename?: 'Social'
  facebookUrl?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  instagramUrl?: Maybe<Scalars['String']['output']>
  linkedInUrl?: Maybe<Scalars['String']['output']>
  newsletterUrl?: Maybe<Scalars['String']['output']>
  /** System stage field */
  stage: Stage
  tikTokUrl?: Maybe<Scalars['String']['output']>
  twitterUrl?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  youTubeUrl?: Maybe<Scalars['String']['output']>
}

export type SocialConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SocialWhereUniqueInput
}

/** A connection to a list of items. */
export type SocialConnection = {
  __typename?: 'SocialConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SocialEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SocialCreateInput = {
  facebookUrl?: InputMaybe<Scalars['String']['input']>
  instagramUrl?: InputMaybe<Scalars['String']['input']>
  linkedInUrl?: InputMaybe<Scalars['String']['input']>
  newsletterUrl?: InputMaybe<Scalars['String']['input']>
  tikTokUrl?: InputMaybe<Scalars['String']['input']>
  twitterUrl?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  youTubeUrl?: InputMaybe<Scalars['String']['input']>
}

export type SocialCreateManyInlineInput = {
  /** Create and connect multiple existing Social documents */
  create?: InputMaybe<Array<SocialCreateInput>>
}

export type SocialCreateOneInlineInput = {
  /** Create and connect one Social document */
  create?: InputMaybe<SocialCreateInput>
}

export type SocialCreateWithPositionInput = {
  /** Document to create */
  data: SocialCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SocialEdge = {
  __typename?: 'SocialEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Social
}

/** Social embeds for Blog Content. Instagram, Podigee, Tiktok etc */
export type SocialEmbed = Entity &
  Node & {
    __typename?: 'SocialEmbed'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<SocialEmbed>
    /** List of SocialEmbed versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    provider: SocialEmbedProvider
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    url: Scalars['String']['output']
    /** Optional wordpress reference used by importer */
    wpId?: Maybe<Scalars['String']['output']>
  }

/** Social embeds for Blog Content. Instagram, Podigee, Tiktok etc */
export type SocialEmbedCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Social embeds for Blog Content. Instagram, Podigee, Tiktok etc */
export type SocialEmbedDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Social embeds for Blog Content. Instagram, Podigee, Tiktok etc */
export type SocialEmbedHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Social embeds for Blog Content. Instagram, Podigee, Tiktok etc */
export type SocialEmbedPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Social embeds for Blog Content. Instagram, Podigee, Tiktok etc */
export type SocialEmbedScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Social embeds for Blog Content. Instagram, Podigee, Tiktok etc */
export type SocialEmbedUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SocialEmbedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SocialEmbedWhereUniqueInput
}

/** A connection to a list of items. */
export type SocialEmbedConnection = {
  __typename?: 'SocialEmbedConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SocialEmbedEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SocialEmbedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  provider: SocialEmbedProvider
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  url: Scalars['String']['input']
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type SocialEmbedCreateManyInlineInput = {
  /** Connect multiple existing SocialEmbed documents */
  connect?: InputMaybe<Array<SocialEmbedWhereUniqueInput>>
  /** Create and connect multiple existing SocialEmbed documents */
  create?: InputMaybe<Array<SocialEmbedCreateInput>>
}

export type SocialEmbedCreateOneInlineInput = {
  /** Connect one existing SocialEmbed document */
  connect?: InputMaybe<SocialEmbedWhereUniqueInput>
  /** Create and connect one SocialEmbed document */
  create?: InputMaybe<SocialEmbedCreateInput>
}

/** An edge in a connection. */
export type SocialEmbedEdge = {
  __typename?: 'SocialEmbedEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SocialEmbed
}

/** Identifies documents */
export type SocialEmbedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialEmbedWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialEmbedWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialEmbedWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<SocialEmbedWhereStageInput>
  documentInStages_none?: InputMaybe<SocialEmbedWhereStageInput>
  documentInStages_some?: InputMaybe<SocialEmbedWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  provider?: InputMaybe<SocialEmbedProvider>
  /** All values that are contained in given list. */
  provider_in?: InputMaybe<Array<InputMaybe<SocialEmbedProvider>>>
  /** Any other value that exists and is not equal to the given value. */
  provider_not?: InputMaybe<SocialEmbedProvider>
  /** All values that are not contained in given list. */
  provider_not_in?: InputMaybe<Array<InputMaybe<SocialEmbedProvider>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum SocialEmbedOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProviderAsc = 'provider_ASC',
  ProviderDesc = 'provider_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WpIdAsc = 'wpId_ASC',
  WpIdDesc = 'wpId_DESC',
}

export enum SocialEmbedProvider {
  Facebook = 'Facebook',
  Iframe = 'Iframe',
  Instagram = 'Instagram',
  Podigee = 'Podigee',
  Reddit = 'Reddit',
  TikTok = 'TikTok',
  Twitter = 'Twitter',
  Vimeo = 'Vimeo',
  YouTube = 'YouTube',
}

export type SocialEmbedUpdateInput = {
  provider?: InputMaybe<SocialEmbedProvider>
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type SocialEmbedUpdateManyInlineInput = {
  /** Connect multiple existing SocialEmbed documents */
  connect?: InputMaybe<Array<SocialEmbedConnectInput>>
  /** Create and connect multiple SocialEmbed documents */
  create?: InputMaybe<Array<SocialEmbedCreateInput>>
  /** Delete multiple SocialEmbed documents */
  delete?: InputMaybe<Array<SocialEmbedWhereUniqueInput>>
  /** Disconnect multiple SocialEmbed documents */
  disconnect?: InputMaybe<Array<SocialEmbedWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SocialEmbed documents */
  set?: InputMaybe<Array<SocialEmbedWhereUniqueInput>>
  /** Update multiple SocialEmbed documents */
  update?: InputMaybe<Array<SocialEmbedUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SocialEmbed documents */
  upsert?: InputMaybe<Array<SocialEmbedUpsertWithNestedWhereUniqueInput>>
}

export type SocialEmbedUpdateManyInput = {
  provider?: InputMaybe<SocialEmbedProvider>
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type SocialEmbedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SocialEmbedUpdateManyInput
  /** Document search */
  where: SocialEmbedWhereInput
}

export type SocialEmbedUpdateOneInlineInput = {
  /** Connect existing SocialEmbed document */
  connect?: InputMaybe<SocialEmbedWhereUniqueInput>
  /** Create and connect one SocialEmbed document */
  create?: InputMaybe<SocialEmbedCreateInput>
  /** Delete currently connected SocialEmbed document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SocialEmbed document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SocialEmbed document */
  update?: InputMaybe<SocialEmbedUpdateWithNestedWhereUniqueInput>
  /** Upsert single SocialEmbed document */
  upsert?: InputMaybe<SocialEmbedUpsertWithNestedWhereUniqueInput>
}

export type SocialEmbedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SocialEmbedUpdateInput
  /** Unique document search */
  where: SocialEmbedWhereUniqueInput
}

export type SocialEmbedUpsertInput = {
  /** Create document if it didn't exist */
  create: SocialEmbedCreateInput
  /** Update document if it exists */
  update: SocialEmbedUpdateInput
}

export type SocialEmbedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SocialEmbedUpsertInput
  /** Unique document search */
  where: SocialEmbedWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type SocialEmbedWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type SocialEmbedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialEmbedWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialEmbedWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialEmbedWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<SocialEmbedWhereStageInput>
  documentInStages_none?: InputMaybe<SocialEmbedWhereStageInput>
  documentInStages_some?: InputMaybe<SocialEmbedWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  provider?: InputMaybe<SocialEmbedProvider>
  /** All values that are contained in given list. */
  provider_in?: InputMaybe<Array<InputMaybe<SocialEmbedProvider>>>
  /** Any other value that exists and is not equal to the given value. */
  provider_not?: InputMaybe<SocialEmbedProvider>
  /** All values that are not contained in given list. */
  provider_not_in?: InputMaybe<Array<InputMaybe<SocialEmbedProvider>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  url?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SocialEmbedWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialEmbedWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialEmbedWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialEmbedWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SocialEmbedWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References SocialEmbed record uniquely */
export type SocialEmbedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type SocialLink = Entity & {
  __typename?: 'SocialLink'
  /** The unique identifier */
  id: Scalars['ID']['output']
  link: Scalars['String']['output']
  logo?: Maybe<Asset>
  name: Scalars['String']['output']
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SocialLinkLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type SocialLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SocialLinkWhereUniqueInput
}

/** A connection to a list of items. */
export type SocialLinkConnection = {
  __typename?: 'SocialLinkConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SocialLinkEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SocialLinkCreateInput = {
  link: Scalars['String']['input']
  logo?: InputMaybe<AssetCreateOneInlineInput>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SocialLinkCreateManyInlineInput = {
  /** Create and connect multiple existing SocialLink documents */
  create?: InputMaybe<Array<SocialLinkCreateInput>>
}

export type SocialLinkCreateOneInlineInput = {
  /** Create and connect one SocialLink document */
  create?: InputMaybe<SocialLinkCreateInput>
}

export type SocialLinkCreateWithPositionInput = {
  /** Document to create */
  data: SocialLinkCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SocialLinkEdge = {
  __typename?: 'SocialLinkEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SocialLink
}

/** Identifies documents */
export type SocialLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialLinkWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialLinkWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialLinkWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SocialLinkOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SocialLinkParent = Footer | Header

export type SocialLinkParentConnectInput = {
  Footer?: InputMaybe<FooterConnectInput>
  Header?: InputMaybe<HeaderConnectInput>
}

export type SocialLinkParentCreateInput = {
  Footer?: InputMaybe<FooterCreateInput>
  Header?: InputMaybe<HeaderCreateInput>
}

export type SocialLinkParentCreateManyInlineInput = {
  /** Connect multiple existing SocialLinkParent documents */
  connect?: InputMaybe<Array<SocialLinkParentWhereUniqueInput>>
  /** Create and connect multiple existing SocialLinkParent documents */
  create?: InputMaybe<Array<SocialLinkParentCreateInput>>
}

export type SocialLinkParentCreateOneInlineInput = {
  /** Connect one existing SocialLinkParent document */
  connect?: InputMaybe<SocialLinkParentWhereUniqueInput>
  /** Create and connect one SocialLinkParent document */
  create?: InputMaybe<SocialLinkParentCreateInput>
}

export type SocialLinkParentUpdateInput = {
  Footer?: InputMaybe<FooterUpdateInput>
  Header?: InputMaybe<HeaderUpdateInput>
}

export type SocialLinkParentUpdateManyInlineInput = {
  /** Connect multiple existing SocialLinkParent documents */
  connect?: InputMaybe<Array<SocialLinkParentConnectInput>>
  /** Create and connect multiple SocialLinkParent documents */
  create?: InputMaybe<Array<SocialLinkParentCreateInput>>
  /** Delete multiple SocialLinkParent documents */
  delete?: InputMaybe<Array<SocialLinkParentWhereUniqueInput>>
  /** Disconnect multiple SocialLinkParent documents */
  disconnect?: InputMaybe<Array<SocialLinkParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SocialLinkParent documents */
  set?: InputMaybe<Array<SocialLinkParentWhereUniqueInput>>
  /** Update multiple SocialLinkParent documents */
  update?: InputMaybe<Array<SocialLinkParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SocialLinkParent documents */
  upsert?: InputMaybe<Array<SocialLinkParentUpsertWithNestedWhereUniqueInput>>
}

export type SocialLinkParentUpdateManyWithNestedWhereInput = {
  Footer?: InputMaybe<FooterUpdateManyWithNestedWhereInput>
  Header?: InputMaybe<HeaderUpdateManyWithNestedWhereInput>
}

export type SocialLinkParentUpdateOneInlineInput = {
  /** Connect existing SocialLinkParent document */
  connect?: InputMaybe<SocialLinkParentWhereUniqueInput>
  /** Create and connect one SocialLinkParent document */
  create?: InputMaybe<SocialLinkParentCreateInput>
  /** Delete currently connected SocialLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SocialLinkParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SocialLinkParent document */
  update?: InputMaybe<SocialLinkParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SocialLinkParent document */
  upsert?: InputMaybe<SocialLinkParentUpsertWithNestedWhereUniqueInput>
}

export type SocialLinkParentUpdateWithNestedWhereUniqueInput = {
  Footer?: InputMaybe<FooterUpdateWithNestedWhereUniqueInput>
  Header?: InputMaybe<HeaderUpdateWithNestedWhereUniqueInput>
}

export type SocialLinkParentUpsertWithNestedWhereUniqueInput = {
  Footer?: InputMaybe<FooterUpsertWithNestedWhereUniqueInput>
  Header?: InputMaybe<HeaderUpsertWithNestedWhereUniqueInput>
}

export type SocialLinkParentWhereInput = {
  Footer?: InputMaybe<FooterWhereInput>
  Header?: InputMaybe<HeaderWhereInput>
}

export type SocialLinkParentWhereUniqueInput = {
  Footer?: InputMaybe<FooterWhereUniqueInput>
  Header?: InputMaybe<HeaderWhereUniqueInput>
}

export type SocialLinkUpdateInput = {
  link?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<AssetUpdateOneInlineInput>
  name?: InputMaybe<Scalars['String']['input']>
}

export type SocialLinkUpdateManyInlineInput = {
  /** Create and connect multiple SocialLink component instances */
  create?: InputMaybe<Array<SocialLinkCreateWithPositionInput>>
  /** Delete multiple SocialLink documents */
  delete?: InputMaybe<Array<SocialLinkWhereUniqueInput>>
  /** Update multiple SocialLink component instances */
  update?: InputMaybe<Array<SocialLinkUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SocialLink component instances */
  upsert?: InputMaybe<Array<SocialLinkUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SocialLinkUpdateManyInput = {
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type SocialLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SocialLinkUpdateManyInput
  /** Document search */
  where: SocialLinkWhereInput
}

export type SocialLinkUpdateOneInlineInput = {
  /** Create and connect one SocialLink document */
  create?: InputMaybe<SocialLinkCreateInput>
  /** Delete currently connected SocialLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SocialLink document */
  update?: InputMaybe<SocialLinkUpdateWithNestedWhereUniqueInput>
  /** Upsert single SocialLink document */
  upsert?: InputMaybe<SocialLinkUpsertWithNestedWhereUniqueInput>
}

export type SocialLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SocialLinkUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SocialLinkWhereUniqueInput
}

export type SocialLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SocialLinkUpdateInput
  /** Unique document search */
  where: SocialLinkWhereUniqueInput
}

export type SocialLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: SocialLinkCreateInput
  /** Update document if it exists */
  update: SocialLinkUpdateInput
}

export type SocialLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SocialLinkUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SocialLinkWhereUniqueInput
}

export type SocialLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SocialLinkUpsertInput
  /** Unique document search */
  where: SocialLinkWhereUniqueInput
}

/** Identifies documents */
export type SocialLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialLinkWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialLinkWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialLinkWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<AssetWhereInput>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SocialLink record uniquely */
export type SocialLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Identifies documents */
export type SocialManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  facebookUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  facebookUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  facebookUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  facebookUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  facebookUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  facebookUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  facebookUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  facebookUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  facebookUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  facebookUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  instagramUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  instagramUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  instagramUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  instagramUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  instagramUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  instagramUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  instagramUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  instagramUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  instagramUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  instagramUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  linkedInUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  newsletterUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  newsletterUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  newsletterUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  newsletterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  newsletterUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  newsletterUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  newsletterUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  newsletterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  newsletterUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  newsletterUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  tikTokUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  tikTokUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  tikTokUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tikTokUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  tikTokUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  tikTokUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  tikTokUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  tikTokUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  tikTokUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  tikTokUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  twitterUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  twitterUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  twitterUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  twitterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  twitterUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  twitterUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  twitterUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  twitterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  twitterUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  twitterUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  youTubeUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  youTubeUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  youTubeUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  youTubeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  youTubeUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  youTubeUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  youTubeUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  youTubeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  youTubeUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  youTubeUrl_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum SocialOrderByInput {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NewsletterUrlAsc = 'newsletterUrl_ASC',
  NewsletterUrlDesc = 'newsletterUrl_DESC',
  TikTokUrlAsc = 'tikTokUrl_ASC',
  TikTokUrlDesc = 'tikTokUrl_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  YouTubeUrlAsc = 'youTubeUrl_ASC',
  YouTubeUrlDesc = 'youTubeUrl_DESC',
}

export type SocialParent = PodcastGroup

export type SocialParentConnectInput = {
  PodcastGroup?: InputMaybe<PodcastGroupConnectInput>
}

export type SocialParentCreateInput = {
  PodcastGroup?: InputMaybe<PodcastGroupCreateInput>
}

export type SocialParentCreateManyInlineInput = {
  /** Connect multiple existing SocialParent documents */
  connect?: InputMaybe<Array<SocialParentWhereUniqueInput>>
  /** Create and connect multiple existing SocialParent documents */
  create?: InputMaybe<Array<SocialParentCreateInput>>
}

export type SocialParentCreateOneInlineInput = {
  /** Connect one existing SocialParent document */
  connect?: InputMaybe<SocialParentWhereUniqueInput>
  /** Create and connect one SocialParent document */
  create?: InputMaybe<SocialParentCreateInput>
}

export type SocialParentUpdateInput = {
  PodcastGroup?: InputMaybe<PodcastGroupUpdateInput>
}

export type SocialParentUpdateManyInlineInput = {
  /** Connect multiple existing SocialParent documents */
  connect?: InputMaybe<Array<SocialParentConnectInput>>
  /** Create and connect multiple SocialParent documents */
  create?: InputMaybe<Array<SocialParentCreateInput>>
  /** Delete multiple SocialParent documents */
  delete?: InputMaybe<Array<SocialParentWhereUniqueInput>>
  /** Disconnect multiple SocialParent documents */
  disconnect?: InputMaybe<Array<SocialParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SocialParent documents */
  set?: InputMaybe<Array<SocialParentWhereUniqueInput>>
  /** Update multiple SocialParent documents */
  update?: InputMaybe<Array<SocialParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SocialParent documents */
  upsert?: InputMaybe<Array<SocialParentUpsertWithNestedWhereUniqueInput>>
}

export type SocialParentUpdateManyWithNestedWhereInput = {
  PodcastGroup?: InputMaybe<PodcastGroupUpdateManyWithNestedWhereInput>
}

export type SocialParentUpdateOneInlineInput = {
  /** Connect existing SocialParent document */
  connect?: InputMaybe<SocialParentWhereUniqueInput>
  /** Create and connect one SocialParent document */
  create?: InputMaybe<SocialParentCreateInput>
  /** Delete currently connected SocialParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SocialParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SocialParent document */
  update?: InputMaybe<SocialParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SocialParent document */
  upsert?: InputMaybe<SocialParentUpsertWithNestedWhereUniqueInput>
}

export type SocialParentUpdateWithNestedWhereUniqueInput = {
  PodcastGroup?: InputMaybe<PodcastGroupUpdateWithNestedWhereUniqueInput>
}

export type SocialParentUpsertWithNestedWhereUniqueInput = {
  PodcastGroup?: InputMaybe<PodcastGroupUpsertWithNestedWhereUniqueInput>
}

export type SocialParentWhereInput = {
  PodcastGroup?: InputMaybe<PodcastGroupWhereInput>
}

export type SocialParentWhereUniqueInput = {
  PodcastGroup?: InputMaybe<PodcastGroupWhereUniqueInput>
}

export type SocialUpdateInput = {
  facebookUrl?: InputMaybe<Scalars['String']['input']>
  instagramUrl?: InputMaybe<Scalars['String']['input']>
  linkedInUrl?: InputMaybe<Scalars['String']['input']>
  newsletterUrl?: InputMaybe<Scalars['String']['input']>
  tikTokUrl?: InputMaybe<Scalars['String']['input']>
  twitterUrl?: InputMaybe<Scalars['String']['input']>
  youTubeUrl?: InputMaybe<Scalars['String']['input']>
}

export type SocialUpdateManyInlineInput = {
  /** Create and connect multiple Social component instances */
  create?: InputMaybe<Array<SocialCreateWithPositionInput>>
  /** Delete multiple Social documents */
  delete?: InputMaybe<Array<SocialWhereUniqueInput>>
  /** Update multiple Social component instances */
  update?: InputMaybe<Array<SocialUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple Social component instances */
  upsert?: InputMaybe<Array<SocialUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SocialUpdateManyInput = {
  facebookUrl?: InputMaybe<Scalars['String']['input']>
  instagramUrl?: InputMaybe<Scalars['String']['input']>
  linkedInUrl?: InputMaybe<Scalars['String']['input']>
  newsletterUrl?: InputMaybe<Scalars['String']['input']>
  tikTokUrl?: InputMaybe<Scalars['String']['input']>
  twitterUrl?: InputMaybe<Scalars['String']['input']>
  youTubeUrl?: InputMaybe<Scalars['String']['input']>
}

export type SocialUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SocialUpdateManyInput
  /** Document search */
  where: SocialWhereInput
}

export type SocialUpdateOneInlineInput = {
  /** Create and connect one Social document */
  create?: InputMaybe<SocialCreateInput>
  /** Delete currently connected Social document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Social document */
  update?: InputMaybe<SocialUpdateWithNestedWhereUniqueInput>
  /** Upsert single Social document */
  upsert?: InputMaybe<SocialUpsertWithNestedWhereUniqueInput>
}

export type SocialUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SocialUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SocialWhereUniqueInput
}

export type SocialUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SocialUpdateInput
  /** Unique document search */
  where: SocialWhereUniqueInput
}

export type SocialUpsertInput = {
  /** Create document if it didn't exist */
  create: SocialCreateInput
  /** Update document if it exists */
  update: SocialUpdateInput
}

export type SocialUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SocialUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SocialWhereUniqueInput
}

export type SocialUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SocialUpsertInput
  /** Unique document search */
  where: SocialWhereUniqueInput
}

/** Identifies documents */
export type SocialWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  facebookUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  facebookUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  facebookUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  facebookUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  facebookUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  facebookUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  facebookUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  facebookUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  facebookUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  facebookUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  instagramUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  instagramUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  instagramUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  instagramUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  instagramUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  instagramUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  instagramUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  instagramUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  instagramUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  instagramUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  linkedInUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  newsletterUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  newsletterUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  newsletterUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  newsletterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  newsletterUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  newsletterUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  newsletterUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  newsletterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  newsletterUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  newsletterUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  tikTokUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  tikTokUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  tikTokUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tikTokUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  tikTokUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  tikTokUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  tikTokUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  tikTokUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  tikTokUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  tikTokUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  twitterUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  twitterUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  twitterUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  twitterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  twitterUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  twitterUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  twitterUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  twitterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  twitterUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  twitterUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  youTubeUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  youTubeUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  youTubeUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  youTubeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  youTubeUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  youTubeUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  youTubeUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  youTubeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  youTubeUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  youTubeUrl_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** References Social record uniquely */
export type SocialWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type Speaker = Entity &
  Node & {
    __typename?: 'Speaker'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<Speaker>
    eventsAsArtist: Array<Event>
    eventsAsSpeaker: Array<Event>
    facebook?: Maybe<Scalars['String']['output']>
    firstname?: Maybe<Scalars['String']['output']>
    /** List of Speaker versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    instagram?: Maybe<Scalars['String']['output']>
    interests: Array<Interest>
    isTop?: Maybe<Scalars['Boolean']['output']>
    lastname?: Maybe<Scalars['String']['output']>
    linkedin?: Maybe<Scalars['String']['output']>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Speaker>
    name?: Maybe<Scalars['String']['output']>
    partnerCompany?: Maybe<PartnerCompany>
    partnerCompanyName?: Maybe<Scalars['String']['output']>
    photoUrl?: Maybe<Scalars['String']['output']>
    position?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    tiktok?: Maybe<Scalars['String']['output']>
    title?: Maybe<Scalars['String']['output']>
    twitter?: Maybe<Scalars['String']['output']>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    website?: Maybe<Scalars['String']['output']>
    youtube?: Maybe<Scalars['String']['output']>
  }

export type SpeakerCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SpeakerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SpeakerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type SpeakerEventsAsArtistArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventWhereInput>
}

export type SpeakerEventsAsSpeakerArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<EventOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<EventWhereInput>
}

export type SpeakerHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type SpeakerInterestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<InterestOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<InterestWhereInput>
}

export type SpeakerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SpeakerPartnerCompanyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SpeakerPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SpeakerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SpeakerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type SpeakerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SpeakerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SpeakerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SpeakerWhereUniqueInput
}

/** A connection to a list of items. */
export type SpeakerConnection = {
  __typename?: 'SpeakerConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SpeakerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SpeakerCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  curatedSpeakers?: InputMaybe<SectionCuratedSpeakerListCreateManyInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  eventsAsArtist?: InputMaybe<EventCreateManyInlineInput>
  eventsAsSpeaker?: InputMaybe<EventCreateManyInlineInput>
  facebook?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  interests?: InputMaybe<InterestCreateManyInlineInput>
  isTop?: InputMaybe<Scalars['Boolean']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SpeakerCreateLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyCreateOneInlineInput>
  partnerCompanyName?: InputMaybe<Scalars['String']['input']>
  photoUrl?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
  speakerOrder?: InputMaybe<SpeakerListOrderCreateManyInlineInput>
  tiktok?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
}

export type SpeakerCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SpeakerCreateLocalizationInput = {
  /** Localization input */
  data: SpeakerCreateLocalizationDataInput
  locale: Locale
}

export type SpeakerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SpeakerCreateLocalizationInput>>
}

export type SpeakerCreateManyInlineInput = {
  /** Connect multiple existing Speaker documents */
  connect?: InputMaybe<Array<SpeakerWhereUniqueInput>>
  /** Create and connect multiple existing Speaker documents */
  create?: InputMaybe<Array<SpeakerCreateInput>>
}

export type SpeakerCreateOneInlineInput = {
  /** Connect one existing Speaker document */
  connect?: InputMaybe<SpeakerWhereUniqueInput>
  /** Create and connect one Speaker document */
  create?: InputMaybe<SpeakerCreateInput>
}

/** An edge in a connection. */
export type SpeakerEdge = {
  __typename?: 'SpeakerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Speaker
}

export enum SpeakerEventTypes {
  GuidedTour = 'guidedTour',
  Masterclass = 'masterclass',
  SideEvent = 'sideEvent',
  Stage = 'stage',
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrder = Entity &
  Node & {
    __typename?: 'SpeakerListOrder'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<SpeakerListOrder>
    event: Event
    /** List of SpeakerListOrder versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** The top speakers or artist list. */
    speakers: Array<Speaker>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrderCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrderDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrderEventArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrderHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrderPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrderScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrderSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SpeakerOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SpeakerWhereInput>
}

/** Model to hold ordering information used by myomr sorting. This order will be reflected eg. on speakers pages or in the mobile app. */
export type SpeakerListOrderUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type SpeakerListOrderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SpeakerListOrderWhereUniqueInput
}

/** A connection to a list of items. */
export type SpeakerListOrderConnection = {
  __typename?: 'SpeakerListOrderConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SpeakerListOrderEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SpeakerListOrderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  event: EventCreateOneInlineInput
  hubPageSpeakerTileSpeakerListOrder?: InputMaybe<HubPageSpeakerTileCreateOneInlineInput>
  sectionsMyomrSpeakers?: InputMaybe<SectionSpeakersCreateManyInlineInput>
  slug: Scalars['String']['input']
  speakers: SpeakerCreateManyInlineInput
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SpeakerListOrderCreateManyInlineInput = {
  /** Connect multiple existing SpeakerListOrder documents */
  connect?: InputMaybe<Array<SpeakerListOrderWhereUniqueInput>>
  /** Create and connect multiple existing SpeakerListOrder documents */
  create?: InputMaybe<Array<SpeakerListOrderCreateInput>>
}

export type SpeakerListOrderCreateOneInlineInput = {
  /** Connect one existing SpeakerListOrder document */
  connect?: InputMaybe<SpeakerListOrderWhereUniqueInput>
  /** Create and connect one SpeakerListOrder document */
  create?: InputMaybe<SpeakerListOrderCreateInput>
}

/** An edge in a connection. */
export type SpeakerListOrderEdge = {
  __typename?: 'SpeakerListOrderEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SpeakerListOrder
}

/** Identifies documents */
export type SpeakerListOrderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpeakerListOrderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpeakerListOrderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpeakerListOrderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<SpeakerListOrderWhereStageInput>
  documentInStages_none?: InputMaybe<SpeakerListOrderWhereStageInput>
  documentInStages_some?: InputMaybe<SpeakerListOrderWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  speakers_every?: InputMaybe<SpeakerWhereInput>
  speakers_none?: InputMaybe<SpeakerWhereInput>
  speakers_some?: InputMaybe<SpeakerWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum SpeakerListOrderOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SpeakerListOrderUpdateInput = {
  event?: InputMaybe<EventUpdateOneInlineInput>
  hubPageSpeakerTileSpeakerListOrder?: InputMaybe<HubPageSpeakerTileUpdateOneInlineInput>
  sectionsMyomrSpeakers?: InputMaybe<SectionSpeakersUpdateManyInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  speakers?: InputMaybe<SpeakerUpdateManyInlineInput>
}

export type SpeakerListOrderUpdateManyInlineInput = {
  /** Connect multiple existing SpeakerListOrder documents */
  connect?: InputMaybe<Array<SpeakerListOrderConnectInput>>
  /** Create and connect multiple SpeakerListOrder documents */
  create?: InputMaybe<Array<SpeakerListOrderCreateInput>>
  /** Delete multiple SpeakerListOrder documents */
  delete?: InputMaybe<Array<SpeakerListOrderWhereUniqueInput>>
  /** Disconnect multiple SpeakerListOrder documents */
  disconnect?: InputMaybe<Array<SpeakerListOrderWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SpeakerListOrder documents */
  set?: InputMaybe<Array<SpeakerListOrderWhereUniqueInput>>
  /** Update multiple SpeakerListOrder documents */
  update?: InputMaybe<Array<SpeakerListOrderUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SpeakerListOrder documents */
  upsert?: InputMaybe<Array<SpeakerListOrderUpsertWithNestedWhereUniqueInput>>
}

export type SpeakerListOrderUpdateManyInput = {
  slug?: InputMaybe<Scalars['String']['input']>
}

export type SpeakerListOrderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SpeakerListOrderUpdateManyInput
  /** Document search */
  where: SpeakerListOrderWhereInput
}

export type SpeakerListOrderUpdateOneInlineInput = {
  /** Connect existing SpeakerListOrder document */
  connect?: InputMaybe<SpeakerListOrderWhereUniqueInput>
  /** Create and connect one SpeakerListOrder document */
  create?: InputMaybe<SpeakerListOrderCreateInput>
  /** Delete currently connected SpeakerListOrder document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SpeakerListOrder document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SpeakerListOrder document */
  update?: InputMaybe<SpeakerListOrderUpdateWithNestedWhereUniqueInput>
  /** Upsert single SpeakerListOrder document */
  upsert?: InputMaybe<SpeakerListOrderUpsertWithNestedWhereUniqueInput>
}

export type SpeakerListOrderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SpeakerListOrderUpdateInput
  /** Unique document search */
  where: SpeakerListOrderWhereUniqueInput
}

export type SpeakerListOrderUpsertInput = {
  /** Create document if it didn't exist */
  create: SpeakerListOrderCreateInput
  /** Update document if it exists */
  update: SpeakerListOrderUpdateInput
}

export type SpeakerListOrderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SpeakerListOrderUpsertInput
  /** Unique document search */
  where: SpeakerListOrderWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type SpeakerListOrderWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type SpeakerListOrderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpeakerListOrderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpeakerListOrderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpeakerListOrderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<SpeakerListOrderWhereStageInput>
  documentInStages_none?: InputMaybe<SpeakerListOrderWhereStageInput>
  documentInStages_some?: InputMaybe<SpeakerListOrderWhereStageInput>
  event?: InputMaybe<EventWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  speakers_every?: InputMaybe<SpeakerWhereInput>
  speakers_none?: InputMaybe<SpeakerWhereInput>
  speakers_some?: InputMaybe<SpeakerWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SpeakerListOrderWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpeakerListOrderWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpeakerListOrderWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpeakerListOrderWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SpeakerListOrderWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References SpeakerListOrder record uniquely */
export type SpeakerListOrderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Identifies documents */
export type SpeakerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpeakerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpeakerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpeakerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<SpeakerWhereStageInput>
  documentInStages_none?: InputMaybe<SpeakerWhereStageInput>
  documentInStages_some?: InputMaybe<SpeakerWhereStageInput>
  eventsAsArtist_every?: InputMaybe<EventWhereInput>
  eventsAsArtist_none?: InputMaybe<EventWhereInput>
  eventsAsArtist_some?: InputMaybe<EventWhereInput>
  eventsAsSpeaker_every?: InputMaybe<EventWhereInput>
  eventsAsSpeaker_none?: InputMaybe<EventWhereInput>
  eventsAsSpeaker_some?: InputMaybe<EventWhereInput>
  facebook?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  facebook_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  facebook_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  facebook_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  facebook_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  facebook_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  facebook_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  facebook_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  facebook_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  facebook_starts_with?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  firstname_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  firstname_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  firstname_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  firstname_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  firstname_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  firstname_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  firstname_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  firstname_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  firstname_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  instagram_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  instagram_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  instagram_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  instagram_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  instagram_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  instagram_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  instagram_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  instagram_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  instagram_starts_with?: InputMaybe<Scalars['String']['input']>
  interests_every?: InputMaybe<InterestWhereInput>
  interests_none?: InputMaybe<InterestWhereInput>
  interests_some?: InputMaybe<InterestWhereInput>
  isTop?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isTop_not?: InputMaybe<Scalars['Boolean']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  lastname_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  lastname_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  lastname_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  lastname_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  lastname_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  lastname_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  lastname_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  lastname_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  lastname_starts_with?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedin_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedin_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedin_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedin_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedin_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedin_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedin_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedin_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedin_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyWhereInput>
  partnerCompanyName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  partnerCompanyName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  partnerCompanyName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  partnerCompanyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  partnerCompanyName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  partnerCompanyName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  partnerCompanyName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  partnerCompanyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  partnerCompanyName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  partnerCompanyName_starts_with?: InputMaybe<Scalars['String']['input']>
  photoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  photoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  photoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  photoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  photoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  photoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  photoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  photoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  photoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  photoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  position_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  position_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  position_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  position_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  position_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  position_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  tiktok?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  tiktok_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  tiktok_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tiktok_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  tiktok_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  tiktok_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  tiktok_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  tiktok_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  tiktok_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  tiktok_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  twitter_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  twitter_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  twitter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  twitter_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  twitter_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  twitter_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  twitter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  twitter_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  twitter_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  website?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  youtube_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  youtube_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  youtube_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  youtube_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  youtube_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  youtube_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  youtube_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  youtube_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  youtube_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum SpeakerOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  FirstnameAsc = 'firstname_ASC',
  FirstnameDesc = 'firstname_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  IsTopAsc = 'isTop_ASC',
  IsTopDesc = 'isTop_DESC',
  LastnameAsc = 'lastname_ASC',
  LastnameDesc = 'lastname_DESC',
  LinkedinAsc = 'linkedin_ASC',
  LinkedinDesc = 'linkedin_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PartnerCompanyNameAsc = 'partnerCompanyName_ASC',
  PartnerCompanyNameDesc = 'partnerCompanyName_DESC',
  PhotoUrlAsc = 'photoUrl_ASC',
  PhotoUrlDesc = 'photoUrl_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TiktokAsc = 'tiktok_ASC',
  TiktokDesc = 'tiktok_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WebsiteAsc = 'website_ASC',
  WebsiteDesc = 'website_DESC',
  YoutubeAsc = 'youtube_ASC',
  YoutubeDesc = 'youtube_DESC',
}

/** Speaker/Artist displays this type with any manually added sorted to the top. Custom displays a sorted list and ONLY this list. */
export enum SpeakerRole {
  Artist = 'Artist',
  Speaker = 'Speaker',
  Custom = 'custom',
}

export type SpeakerUpdateInput = {
  curatedSpeakers?: InputMaybe<SectionCuratedSpeakerListUpdateManyInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  eventsAsArtist?: InputMaybe<EventUpdateManyInlineInput>
  eventsAsSpeaker?: InputMaybe<EventUpdateManyInlineInput>
  facebook?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  interests?: InputMaybe<InterestUpdateManyInlineInput>
  isTop?: InputMaybe<Scalars['Boolean']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SpeakerUpdateLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyUpdateOneInlineInput>
  partnerCompanyName?: InputMaybe<Scalars['String']['input']>
  photoUrl?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  speakerOrder?: InputMaybe<SpeakerListOrderUpdateManyInlineInput>
  tiktok?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
}

export type SpeakerUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type SpeakerUpdateLocalizationInput = {
  data: SpeakerUpdateLocalizationDataInput
  locale: Locale
}

export type SpeakerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SpeakerCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SpeakerUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SpeakerUpsertLocalizationInput>>
}

export type SpeakerUpdateManyInlineInput = {
  /** Connect multiple existing Speaker documents */
  connect?: InputMaybe<Array<SpeakerConnectInput>>
  /** Create and connect multiple Speaker documents */
  create?: InputMaybe<Array<SpeakerCreateInput>>
  /** Delete multiple Speaker documents */
  delete?: InputMaybe<Array<SpeakerWhereUniqueInput>>
  /** Disconnect multiple Speaker documents */
  disconnect?: InputMaybe<Array<SpeakerWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Speaker documents */
  set?: InputMaybe<Array<SpeakerWhereUniqueInput>>
  /** Update multiple Speaker documents */
  update?: InputMaybe<Array<SpeakerUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Speaker documents */
  upsert?: InputMaybe<Array<SpeakerUpsertWithNestedWhereUniqueInput>>
}

export type SpeakerUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  facebook?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  isTop?: InputMaybe<Scalars['Boolean']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SpeakerUpdateManyLocalizationsInput>
  name?: InputMaybe<Scalars['String']['input']>
  partnerCompanyName?: InputMaybe<Scalars['String']['input']>
  photoUrl?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  tiktok?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
}

export type SpeakerUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
}

export type SpeakerUpdateManyLocalizationInput = {
  data: SpeakerUpdateManyLocalizationDataInput
  locale: Locale
}

export type SpeakerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SpeakerUpdateManyLocalizationInput>>
}

export type SpeakerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SpeakerUpdateManyInput
  /** Document search */
  where: SpeakerWhereInput
}

export type SpeakerUpdateOneInlineInput = {
  /** Connect existing Speaker document */
  connect?: InputMaybe<SpeakerWhereUniqueInput>
  /** Create and connect one Speaker document */
  create?: InputMaybe<SpeakerCreateInput>
  /** Delete currently connected Speaker document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Speaker document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Speaker document */
  update?: InputMaybe<SpeakerUpdateWithNestedWhereUniqueInput>
  /** Upsert single Speaker document */
  upsert?: InputMaybe<SpeakerUpsertWithNestedWhereUniqueInput>
}

export type SpeakerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SpeakerUpdateInput
  /** Unique document search */
  where: SpeakerWhereUniqueInput
}

export type SpeakerUpsertInput = {
  /** Create document if it didn't exist */
  create: SpeakerCreateInput
  /** Update document if it exists */
  update: SpeakerUpdateInput
}

export type SpeakerUpsertLocalizationInput = {
  create: SpeakerCreateLocalizationDataInput
  locale: Locale
  update: SpeakerUpdateLocalizationDataInput
}

export type SpeakerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SpeakerUpsertInput
  /** Unique document search */
  where: SpeakerWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type SpeakerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type SpeakerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpeakerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpeakerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpeakerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<SpeakerWhereStageInput>
  documentInStages_none?: InputMaybe<SpeakerWhereStageInput>
  documentInStages_some?: InputMaybe<SpeakerWhereStageInput>
  eventsAsArtist_every?: InputMaybe<EventWhereInput>
  eventsAsArtist_none?: InputMaybe<EventWhereInput>
  eventsAsArtist_some?: InputMaybe<EventWhereInput>
  eventsAsSpeaker_every?: InputMaybe<EventWhereInput>
  eventsAsSpeaker_none?: InputMaybe<EventWhereInput>
  eventsAsSpeaker_some?: InputMaybe<EventWhereInput>
  facebook?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  facebook_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  facebook_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  facebook_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  facebook_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  facebook_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  facebook_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  facebook_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  facebook_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  facebook_starts_with?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  firstname_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  firstname_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  firstname_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  firstname_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  firstname_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  firstname_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  firstname_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  firstname_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  firstname_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  instagram_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  instagram_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  instagram_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  instagram_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  instagram_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  instagram_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  instagram_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  instagram_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  instagram_starts_with?: InputMaybe<Scalars['String']['input']>
  interests_every?: InputMaybe<InterestWhereInput>
  interests_none?: InputMaybe<InterestWhereInput>
  interests_some?: InputMaybe<InterestWhereInput>
  isTop?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isTop_not?: InputMaybe<Scalars['Boolean']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  lastname_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  lastname_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  lastname_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  lastname_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  lastname_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  lastname_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  lastname_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  lastname_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  lastname_starts_with?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  linkedin_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  linkedin_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  linkedin_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  linkedin_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  linkedin_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  linkedin_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  linkedin_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  linkedin_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  linkedin_starts_with?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  partnerCompany?: InputMaybe<PartnerCompanyWhereInput>
  partnerCompanyName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  partnerCompanyName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  partnerCompanyName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  partnerCompanyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  partnerCompanyName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  partnerCompanyName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  partnerCompanyName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  partnerCompanyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  partnerCompanyName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  partnerCompanyName_starts_with?: InputMaybe<Scalars['String']['input']>
  photoUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  photoUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  photoUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  photoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  photoUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  photoUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  photoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  photoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  photoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  photoUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  position_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  position_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  position_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  position_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  position_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  position_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  tiktok?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  tiktok_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  tiktok_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tiktok_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  tiktok_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  tiktok_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  tiktok_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  tiktok_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  tiktok_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  tiktok_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  twitter_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  twitter_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  twitter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  twitter_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  twitter_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  twitter_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  twitter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  twitter_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  twitter_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  website?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>
  youtube?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  youtube_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  youtube_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  youtube_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  youtube_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  youtube_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  youtube_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  youtube_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  youtube_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  youtube_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SpeakerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpeakerWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpeakerWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpeakerWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SpeakerWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Speaker record uniquely */
export type SpeakerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED',
}

export type SubscriptionTeaser = Entity & {
  __typename?: 'SubscriptionTeaser'
  bannerText: Scalars['String']['output']
  ctaText: Scalars['String']['output']
  ctaUrl: Scalars['String']['output']
  /** Select a decoration pattern for this component. */
  decorationPattern?: Maybe<DecorationPattern>
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<SubscriptionTeaser>
  /** Select a custom padding for this section, otherwise default is used. */
  sectionPadding?: Maybe<SectionPadding>
  /** System stage field */
  stage: Stage
  styleVariant?: Maybe<ComponentStyle>
  subBannerText?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SubscriptionTeaserLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type SubscriptionTeaserUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type SubscriptionTeaserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: SubscriptionTeaserWhereUniqueInput
}

/** A connection to a list of items. */
export type SubscriptionTeaserConnection = {
  __typename?: 'SubscriptionTeaserConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<SubscriptionTeaserEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SubscriptionTeaserCreateInput = {
  /** bannerText input for default locale (de) */
  bannerText: Scalars['String']['input']
  /** ctaText input for default locale (de) */
  ctaText: Scalars['String']['input']
  /** ctaUrl input for default locale (de) */
  ctaUrl: Scalars['String']['input']
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SubscriptionTeaserCreateLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subBannerText input for default locale (de) */
  subBannerText?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SubscriptionTeaserCreateLocalizationDataInput = {
  bannerText: Scalars['String']['input']
  ctaText: Scalars['String']['input']
  ctaUrl: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  subBannerText?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SubscriptionTeaserCreateLocalizationInput = {
  /** Localization input */
  data: SubscriptionTeaserCreateLocalizationDataInput
  locale: Locale
}

export type SubscriptionTeaserCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SubscriptionTeaserCreateLocalizationInput>>
}

export type SubscriptionTeaserCreateManyInlineInput = {
  /** Create and connect multiple existing SubscriptionTeaser documents */
  create?: InputMaybe<Array<SubscriptionTeaserCreateInput>>
}

export type SubscriptionTeaserCreateOneInlineInput = {
  /** Create and connect one SubscriptionTeaser document */
  create?: InputMaybe<SubscriptionTeaserCreateInput>
}

export type SubscriptionTeaserCreateWithPositionInput = {
  /** Document to create */
  data: SubscriptionTeaserCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type SubscriptionTeaserEdge = {
  __typename?: 'SubscriptionTeaserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: SubscriptionTeaser
}

/** Identifies documents */
export type SubscriptionTeaserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubscriptionTeaserWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubscriptionTeaserWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubscriptionTeaserWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum SubscriptionTeaserOrderByInput {
  BannerTextAsc = 'bannerText_ASC',
  BannerTextDesc = 'bannerText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SectionPaddingAsc = 'sectionPadding_ASC',
  SectionPaddingDesc = 'sectionPadding_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  SubBannerTextAsc = 'subBannerText_ASC',
  SubBannerTextDesc = 'subBannerText_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type SubscriptionTeaserParent = EventPage | LandingPage

export type SubscriptionTeaserParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type SubscriptionTeaserParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type SubscriptionTeaserParentCreateManyInlineInput = {
  /** Connect multiple existing SubscriptionTeaserParent documents */
  connect?: InputMaybe<Array<SubscriptionTeaserParentWhereUniqueInput>>
  /** Create and connect multiple existing SubscriptionTeaserParent documents */
  create?: InputMaybe<Array<SubscriptionTeaserParentCreateInput>>
}

export type SubscriptionTeaserParentCreateOneInlineInput = {
  /** Connect one existing SubscriptionTeaserParent document */
  connect?: InputMaybe<SubscriptionTeaserParentWhereUniqueInput>
  /** Create and connect one SubscriptionTeaserParent document */
  create?: InputMaybe<SubscriptionTeaserParentCreateInput>
}

export type SubscriptionTeaserParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type SubscriptionTeaserParentUpdateManyInlineInput = {
  /** Connect multiple existing SubscriptionTeaserParent documents */
  connect?: InputMaybe<Array<SubscriptionTeaserParentConnectInput>>
  /** Create and connect multiple SubscriptionTeaserParent documents */
  create?: InputMaybe<Array<SubscriptionTeaserParentCreateInput>>
  /** Delete multiple SubscriptionTeaserParent documents */
  delete?: InputMaybe<Array<SubscriptionTeaserParentWhereUniqueInput>>
  /** Disconnect multiple SubscriptionTeaserParent documents */
  disconnect?: InputMaybe<Array<SubscriptionTeaserParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing SubscriptionTeaserParent documents */
  set?: InputMaybe<Array<SubscriptionTeaserParentWhereUniqueInput>>
  /** Update multiple SubscriptionTeaserParent documents */
  update?: InputMaybe<Array<SubscriptionTeaserParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple SubscriptionTeaserParent documents */
  upsert?: InputMaybe<Array<SubscriptionTeaserParentUpsertWithNestedWhereUniqueInput>>
}

export type SubscriptionTeaserParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type SubscriptionTeaserParentUpdateOneInlineInput = {
  /** Connect existing SubscriptionTeaserParent document */
  connect?: InputMaybe<SubscriptionTeaserParentWhereUniqueInput>
  /** Create and connect one SubscriptionTeaserParent document */
  create?: InputMaybe<SubscriptionTeaserParentCreateInput>
  /** Delete currently connected SubscriptionTeaserParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected SubscriptionTeaserParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SubscriptionTeaserParent document */
  update?: InputMaybe<SubscriptionTeaserParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single SubscriptionTeaserParent document */
  upsert?: InputMaybe<SubscriptionTeaserParentUpsertWithNestedWhereUniqueInput>
}

export type SubscriptionTeaserParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type SubscriptionTeaserParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type SubscriptionTeaserParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type SubscriptionTeaserParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type SubscriptionTeaserUpdateInput = {
  /** bannerText input for default locale (de) */
  bannerText?: InputMaybe<Scalars['String']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<SubscriptionTeaserUpdateLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subBannerText input for default locale (de) */
  subBannerText?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SubscriptionTeaserUpdateLocalizationDataInput = {
  bannerText?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  subBannerText?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SubscriptionTeaserUpdateLocalizationInput = {
  data: SubscriptionTeaserUpdateLocalizationDataInput
  locale: Locale
}

export type SubscriptionTeaserUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SubscriptionTeaserCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<SubscriptionTeaserUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<SubscriptionTeaserUpsertLocalizationInput>>
}

export type SubscriptionTeaserUpdateManyInlineInput = {
  /** Create and connect multiple SubscriptionTeaser component instances */
  create?: InputMaybe<Array<SubscriptionTeaserCreateWithPositionInput>>
  /** Delete multiple SubscriptionTeaser documents */
  delete?: InputMaybe<Array<SubscriptionTeaserWhereUniqueInput>>
  /** Update multiple SubscriptionTeaser component instances */
  update?: InputMaybe<Array<SubscriptionTeaserUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple SubscriptionTeaser component instances */
  upsert?: InputMaybe<Array<SubscriptionTeaserUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type SubscriptionTeaserUpdateManyInput = {
  /** bannerText input for default locale (de) */
  bannerText?: InputMaybe<Scalars['String']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<SubscriptionTeaserUpdateManyLocalizationsInput>
  sectionPadding?: InputMaybe<SectionPadding>
  styleVariant?: InputMaybe<ComponentStyle>
  /** subBannerText input for default locale (de) */
  subBannerText?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type SubscriptionTeaserUpdateManyLocalizationDataInput = {
  bannerText?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  subBannerText?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type SubscriptionTeaserUpdateManyLocalizationInput = {
  data: SubscriptionTeaserUpdateManyLocalizationDataInput
  locale: Locale
}

export type SubscriptionTeaserUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SubscriptionTeaserUpdateManyLocalizationInput>>
}

export type SubscriptionTeaserUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SubscriptionTeaserUpdateManyInput
  /** Document search */
  where: SubscriptionTeaserWhereInput
}

export type SubscriptionTeaserUpdateOneInlineInput = {
  /** Create and connect one SubscriptionTeaser document */
  create?: InputMaybe<SubscriptionTeaserCreateInput>
  /** Delete currently connected SubscriptionTeaser document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single SubscriptionTeaser document */
  update?: InputMaybe<SubscriptionTeaserUpdateWithNestedWhereUniqueInput>
  /** Upsert single SubscriptionTeaser document */
  upsert?: InputMaybe<SubscriptionTeaserUpsertWithNestedWhereUniqueInput>
}

export type SubscriptionTeaserUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SubscriptionTeaserUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SubscriptionTeaserWhereUniqueInput
}

export type SubscriptionTeaserUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SubscriptionTeaserUpdateInput
  /** Unique document search */
  where: SubscriptionTeaserWhereUniqueInput
}

export type SubscriptionTeaserUpsertInput = {
  /** Create document if it didn't exist */
  create: SubscriptionTeaserCreateInput
  /** Update document if it exists */
  update: SubscriptionTeaserUpdateInput
}

export type SubscriptionTeaserUpsertLocalizationInput = {
  create: SubscriptionTeaserCreateLocalizationDataInput
  locale: Locale
  update: SubscriptionTeaserUpdateLocalizationDataInput
}

export type SubscriptionTeaserUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SubscriptionTeaserUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: SubscriptionTeaserWhereUniqueInput
}

export type SubscriptionTeaserUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SubscriptionTeaserUpsertInput
  /** Unique document search */
  where: SubscriptionTeaserWhereUniqueInput
}

/** Identifies documents */
export type SubscriptionTeaserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubscriptionTeaserWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubscriptionTeaserWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubscriptionTeaserWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  bannerText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  bannerText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  bannerText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  bannerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  bannerText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  bannerText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  bannerText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  bannerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  bannerText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  bannerText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  subBannerText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subBannerText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subBannerText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subBannerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subBannerText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subBannerText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subBannerText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subBannerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subBannerText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subBannerText_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References SubscriptionTeaser record uniquely */
export type SubscriptionTeaserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION',
}

export type TabContent = Entity &
  Node & {
    __typename?: 'TabContent'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    description?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<TabContent>
    downloads: Array<Download>
    /** List of TabContent versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    image?: Maybe<Asset>
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<TabContent>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    tabName: Scalars['String']['output']
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

export type TabContentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type TabContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type TabContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type TabContentDownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<DownloadOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<DownloadWhereInput>
}

export type TabContentHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

export type TabContentImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type TabContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type TabContentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type TabContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type TabContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

export type TabContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type TabContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type TabContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TabContentWhereUniqueInput
}

/** A connection to a list of items. */
export type TabContentConnection = {
  __typename?: 'TabContentConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TabContentEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TabContentCreateInput = {
  contentInSection?: InputMaybe<SectionTabCreateOneInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  downloads?: InputMaybe<DownloadCreateManyInlineInput>
  image?: InputMaybe<AssetCreateOneInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TabContentCreateLocalizationsInput>
  /** tabName input for default locale (de) */
  tabName: Scalars['String']['input']
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TabContentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  tabName: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TabContentCreateLocalizationInput = {
  /** Localization input */
  data: TabContentCreateLocalizationDataInput
  locale: Locale
}

export type TabContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TabContentCreateLocalizationInput>>
}

export type TabContentCreateManyInlineInput = {
  /** Connect multiple existing TabContent documents */
  connect?: InputMaybe<Array<TabContentWhereUniqueInput>>
  /** Create and connect multiple existing TabContent documents */
  create?: InputMaybe<Array<TabContentCreateInput>>
}

export type TabContentCreateOneInlineInput = {
  /** Connect one existing TabContent document */
  connect?: InputMaybe<TabContentWhereUniqueInput>
  /** Create and connect one TabContent document */
  create?: InputMaybe<TabContentCreateInput>
}

/** An edge in a connection. */
export type TabContentEdge = {
  __typename?: 'TabContentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TabContent
}

/** Identifies documents */
export type TabContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<TabContentWhereStageInput>
  documentInStages_none?: InputMaybe<TabContentWhereStageInput>
  documentInStages_some?: InputMaybe<TabContentWhereStageInput>
  downloads_every?: InputMaybe<DownloadWhereInput>
  downloads_none?: InputMaybe<DownloadWhereInput>
  downloads_some?: InputMaybe<DownloadWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum TabContentOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TabNameAsc = 'tabName_ASC',
  TabNameDesc = 'tabName_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type TabContentUpdateInput = {
  contentInSection?: InputMaybe<SectionTabUpdateOneInlineInput>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  downloads?: InputMaybe<DownloadUpdateManyInlineInput>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<TabContentUpdateLocalizationsInput>
  /** tabName input for default locale (de) */
  tabName?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TabContentUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  tabName?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TabContentUpdateLocalizationInput = {
  data: TabContentUpdateLocalizationDataInput
  locale: Locale
}

export type TabContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TabContentCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TabContentUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TabContentUpsertLocalizationInput>>
}

export type TabContentUpdateManyInlineInput = {
  /** Connect multiple existing TabContent documents */
  connect?: InputMaybe<Array<TabContentConnectInput>>
  /** Create and connect multiple TabContent documents */
  create?: InputMaybe<Array<TabContentCreateInput>>
  /** Delete multiple TabContent documents */
  delete?: InputMaybe<Array<TabContentWhereUniqueInput>>
  /** Disconnect multiple TabContent documents */
  disconnect?: InputMaybe<Array<TabContentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing TabContent documents */
  set?: InputMaybe<Array<TabContentWhereUniqueInput>>
  /** Update multiple TabContent documents */
  update?: InputMaybe<Array<TabContentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple TabContent documents */
  upsert?: InputMaybe<Array<TabContentUpsertWithNestedWhereUniqueInput>>
}

export type TabContentUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<TabContentUpdateManyLocalizationsInput>
  /** tabName input for default locale (de) */
  tabName?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TabContentUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  tabName?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TabContentUpdateManyLocalizationInput = {
  data: TabContentUpdateManyLocalizationDataInput
  locale: Locale
}

export type TabContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TabContentUpdateManyLocalizationInput>>
}

export type TabContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TabContentUpdateManyInput
  /** Document search */
  where: TabContentWhereInput
}

export type TabContentUpdateOneInlineInput = {
  /** Connect existing TabContent document */
  connect?: InputMaybe<TabContentWhereUniqueInput>
  /** Create and connect one TabContent document */
  create?: InputMaybe<TabContentCreateInput>
  /** Delete currently connected TabContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected TabContent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TabContent document */
  update?: InputMaybe<TabContentUpdateWithNestedWhereUniqueInput>
  /** Upsert single TabContent document */
  upsert?: InputMaybe<TabContentUpsertWithNestedWhereUniqueInput>
}

export type TabContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TabContentUpdateInput
  /** Unique document search */
  where: TabContentWhereUniqueInput
}

export type TabContentUpsertInput = {
  /** Create document if it didn't exist */
  create: TabContentCreateInput
  /** Update document if it exists */
  update: TabContentUpdateInput
}

export type TabContentUpsertLocalizationInput = {
  create: TabContentCreateLocalizationDataInput
  locale: Locale
  update: TabContentUpdateLocalizationDataInput
}

export type TabContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TabContentUpsertInput
  /** Unique document search */
  where: TabContentWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type TabContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type TabContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<TabContentWhereStageInput>
  documentInStages_none?: InputMaybe<TabContentWhereStageInput>
  documentInStages_some?: InputMaybe<TabContentWhereStageInput>
  downloads_every?: InputMaybe<DownloadWhereInput>
  downloads_none?: InputMaybe<DownloadWhereInput>
  downloads_some?: InputMaybe<DownloadWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  tabName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  tabName_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  tabName_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tabName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  tabName_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  tabName_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  tabName_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  tabName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  tabName_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  tabName_starts_with?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TabContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TabContentWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References TabContent record uniquely */
export type TabContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type Tag = Entity &
  Node & {
    __typename?: 'Tag'
    articles: Array<Article>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<Tag>
    /** List of Tag versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<Tag>
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    reviewsProductCategories: Array<ReviewsProductCategory>
    reviewsProducts: Array<ReviewsProduct>
    scheduledIn: Array<ScheduledOperation>
    /** Optional configuration if you want to have specific SEO Meta Attributes. */
    seoAttributes?: Maybe<Seo>
    /** Optional configuration if you want to have specific SEO Content Attributes. */
    seoContentAttributes?: Maybe<SeoContentAttribute>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
    /** Wordpress tag ID (required for migration) */
    wpId?: Maybe<Scalars['String']['output']>
  }

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ArticleOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ArticleWhereInput>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagReviewsProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsProductCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductCategoryWhereInput>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagReviewsProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<ReviewsProductOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ReviewsProductWhereInput>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagSeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagSeoContentAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Content Tags which can be used to cross reference across multiple content types. For SEO Purposes keep Tags general and not too specific.  */
export type TagUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type TagConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TagWhereUniqueInput
}

/** A connection to a list of items. */
export type TagConnection = {
  __typename?: 'TagConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TagEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TagCreateInput = {
  articleByTag?: InputMaybe<ArticlesByTagCreateOneInlineInput>
  articles?: InputMaybe<ArticleCreateManyInlineInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  hubPageContentSliderItemTag?: InputMaybe<HubPageContentSliderItemCreateManyInlineInput>
  hubPageContentTileTag?: InputMaybe<HubPageContentTileCreateManyInlineInput>
  hubPageReferenceTag?: InputMaybe<HubPageReferenceCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TagCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  reviewsProductCategories?: InputMaybe<ReviewsProductCategoryCreateManyInlineInput>
  reviewsProducts?: InputMaybe<ReviewsProductCreateManyInlineInput>
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  seoContentAttributes?: InputMaybe<SeoContentAttributeCreateOneInlineInput>
  slug: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type TagCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TagCreateLocalizationInput = {
  /** Localization input */
  data: TagCreateLocalizationDataInput
  locale: Locale
}

export type TagCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TagCreateLocalizationInput>>
}

export type TagCreateManyInlineInput = {
  /** Connect multiple existing Tag documents */
  connect?: InputMaybe<Array<TagWhereUniqueInput>>
  /** Create and connect multiple existing Tag documents */
  create?: InputMaybe<Array<TagCreateInput>>
}

export type TagCreateOneInlineInput = {
  /** Connect one existing Tag document */
  connect?: InputMaybe<TagWhereUniqueInput>
  /** Create and connect one Tag document */
  create?: InputMaybe<TagCreateInput>
}

/** An edge in a connection. */
export type TagEdge = {
  __typename?: 'TagEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Tag
}

/** Identifies documents */
export type TagManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TagWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TagWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TagWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<TagWhereStageInput>
  documentInStages_none?: InputMaybe<TagWhereStageInput>
  documentInStages_some?: InputMaybe<TagWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reviewsProductCategories_every?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_none?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_some?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProducts_every?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_none?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_some?: InputMaybe<ReviewsProductWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  seoContentAttributes?: InputMaybe<SeoContentAttributeWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

export enum TagOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WpIdAsc = 'wpId_ASC',
  WpIdDesc = 'wpId_DESC',
}

export type TagUpdateInput = {
  articleByTag?: InputMaybe<ArticlesByTagUpdateOneInlineInput>
  articles?: InputMaybe<ArticleUpdateManyInlineInput>
  hubPageContentSliderItemTag?: InputMaybe<HubPageContentSliderItemUpdateManyInlineInput>
  hubPageContentTileTag?: InputMaybe<HubPageContentTileUpdateManyInlineInput>
  hubPageReferenceTag?: InputMaybe<HubPageReferenceUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<TagUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  reviewsProductCategories?: InputMaybe<ReviewsProductCategoryUpdateManyInlineInput>
  reviewsProducts?: InputMaybe<ReviewsProductUpdateManyInlineInput>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  seoContentAttributes?: InputMaybe<SeoContentAttributeUpdateOneInlineInput>
  slug?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

export type TagUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type TagUpdateLocalizationInput = {
  data: TagUpdateLocalizationDataInput
  locale: Locale
}

export type TagUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TagCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TagUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TagUpsertLocalizationInput>>
}

export type TagUpdateManyInlineInput = {
  /** Connect multiple existing Tag documents */
  connect?: InputMaybe<Array<TagConnectInput>>
  /** Create and connect multiple Tag documents */
  create?: InputMaybe<Array<TagCreateInput>>
  /** Delete multiple Tag documents */
  delete?: InputMaybe<Array<TagWhereUniqueInput>>
  /** Disconnect multiple Tag documents */
  disconnect?: InputMaybe<Array<TagWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Tag documents */
  set?: InputMaybe<Array<TagWhereUniqueInput>>
  /** Update multiple Tag documents */
  update?: InputMaybe<Array<TagUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Tag documents */
  upsert?: InputMaybe<Array<TagUpsertWithNestedWhereUniqueInput>>
}

export type TagUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type TagUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TagUpdateManyInput
  /** Document search */
  where: TagWhereInput
}

export type TagUpdateOneInlineInput = {
  /** Connect existing Tag document */
  connect?: InputMaybe<TagWhereUniqueInput>
  /** Create and connect one Tag document */
  create?: InputMaybe<TagCreateInput>
  /** Delete currently connected Tag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Tag document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Tag document */
  update?: InputMaybe<TagUpdateWithNestedWhereUniqueInput>
  /** Upsert single Tag document */
  upsert?: InputMaybe<TagUpsertWithNestedWhereUniqueInput>
}

export type TagUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TagUpdateInput
  /** Unique document search */
  where: TagWhereUniqueInput
}

export type TagUpsertInput = {
  /** Create document if it didn't exist */
  create: TagCreateInput
  /** Update document if it exists */
  update: TagUpdateInput
}

export type TagUpsertLocalizationInput = {
  create: TagCreateLocalizationDataInput
  locale: Locale
  update: TagUpdateLocalizationDataInput
}

export type TagUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TagUpsertInput
  /** Unique document search */
  where: TagWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type TagWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type TagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TagWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TagWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TagWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  articles_every?: InputMaybe<ArticleWhereInput>
  articles_none?: InputMaybe<ArticleWhereInput>
  articles_some?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<TagWhereStageInput>
  documentInStages_none?: InputMaybe<TagWhereStageInput>
  documentInStages_some?: InputMaybe<TagWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  reviewsProductCategories_every?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_none?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProductCategories_some?: InputMaybe<ReviewsProductCategoryWhereInput>
  reviewsProducts_every?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_none?: InputMaybe<ReviewsProductWhereInput>
  reviewsProducts_some?: InputMaybe<ReviewsProductWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  seoContentAttributes?: InputMaybe<SeoContentAttributeWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
  wpId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  wpId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  wpId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  wpId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  wpId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  wpId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  wpId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  wpId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  wpId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  wpId_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TagWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TagWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TagWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TagWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TagWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References Tag record uniquely */
export type TagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  wpId?: InputMaybe<Scalars['String']['input']>
}

/** A section with multiple testimonials rendered as a slider. */
export type TestimonialSlider = Entity & {
  __typename?: 'TestimonialSlider'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<TestimonialSlider>
  slide: Array<SectionTestimonial>
  /** System stage field */
  stage: Stage
  /** Sets component color scheme. */
  styleVariant?: Maybe<ComponentStyle>
  /** Choose between light + dark theme. Light theme is default. */
  theme?: Maybe<OmrThemeVariant>
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** A section with multiple testimonials rendered as a slider. */
export type TestimonialSliderLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** A section with multiple testimonials rendered as a slider. */
export type TestimonialSliderSlideArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<SectionTestimonialOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SectionTestimonialWhereInput>
}

/** A section with multiple testimonials rendered as a slider. */
export type TestimonialSliderUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type TestimonialSliderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TestimonialSliderWhereUniqueInput
}

/** A connection to a list of items. */
export type TestimonialSliderConnection = {
  __typename?: 'TestimonialSliderConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TestimonialSliderEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TestimonialSliderCreateInput = {
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TestimonialSliderCreateLocalizationsInput>
  slide?: InputMaybe<SectionTestimonialCreateManyInlineInput>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TestimonialSliderCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TestimonialSliderCreateLocalizationInput = {
  /** Localization input */
  data: TestimonialSliderCreateLocalizationDataInput
  locale: Locale
}

export type TestimonialSliderCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TestimonialSliderCreateLocalizationInput>>
}

export type TestimonialSliderCreateManyInlineInput = {
  /** Create and connect multiple existing TestimonialSlider documents */
  create?: InputMaybe<Array<TestimonialSliderCreateInput>>
}

export type TestimonialSliderCreateOneInlineInput = {
  /** Create and connect one TestimonialSlider document */
  create?: InputMaybe<TestimonialSliderCreateInput>
}

export type TestimonialSliderCreateWithPositionInput = {
  /** Document to create */
  data: TestimonialSliderCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type TestimonialSliderEdge = {
  __typename?: 'TestimonialSliderEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TestimonialSlider
}

/** Identifies documents */
export type TestimonialSliderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestimonialSliderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestimonialSliderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestimonialSliderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  slide_every?: InputMaybe<SectionTestimonialWhereInput>
  slide_none?: InputMaybe<SectionTestimonialWhereInput>
  slide_some?: InputMaybe<SectionTestimonialWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum TestimonialSliderOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StyleVariantAsc = 'styleVariant_ASC',
  StyleVariantDesc = 'styleVariant_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type TestimonialSliderParent = EventPage | LandingPage

export type TestimonialSliderParentConnectInput = {
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type TestimonialSliderParentCreateInput = {
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type TestimonialSliderParentCreateManyInlineInput = {
  /** Connect multiple existing TestimonialSliderParent documents */
  connect?: InputMaybe<Array<TestimonialSliderParentWhereUniqueInput>>
  /** Create and connect multiple existing TestimonialSliderParent documents */
  create?: InputMaybe<Array<TestimonialSliderParentCreateInput>>
}

export type TestimonialSliderParentCreateOneInlineInput = {
  /** Connect one existing TestimonialSliderParent document */
  connect?: InputMaybe<TestimonialSliderParentWhereUniqueInput>
  /** Create and connect one TestimonialSliderParent document */
  create?: InputMaybe<TestimonialSliderParentCreateInput>
}

export type TestimonialSliderParentUpdateInput = {
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type TestimonialSliderParentUpdateManyInlineInput = {
  /** Connect multiple existing TestimonialSliderParent documents */
  connect?: InputMaybe<Array<TestimonialSliderParentConnectInput>>
  /** Create and connect multiple TestimonialSliderParent documents */
  create?: InputMaybe<Array<TestimonialSliderParentCreateInput>>
  /** Delete multiple TestimonialSliderParent documents */
  delete?: InputMaybe<Array<TestimonialSliderParentWhereUniqueInput>>
  /** Disconnect multiple TestimonialSliderParent documents */
  disconnect?: InputMaybe<Array<TestimonialSliderParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing TestimonialSliderParent documents */
  set?: InputMaybe<Array<TestimonialSliderParentWhereUniqueInput>>
  /** Update multiple TestimonialSliderParent documents */
  update?: InputMaybe<Array<TestimonialSliderParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple TestimonialSliderParent documents */
  upsert?: InputMaybe<Array<TestimonialSliderParentUpsertWithNestedWhereUniqueInput>>
}

export type TestimonialSliderParentUpdateManyWithNestedWhereInput = {
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type TestimonialSliderParentUpdateOneInlineInput = {
  /** Connect existing TestimonialSliderParent document */
  connect?: InputMaybe<TestimonialSliderParentWhereUniqueInput>
  /** Create and connect one TestimonialSliderParent document */
  create?: InputMaybe<TestimonialSliderParentCreateInput>
  /** Delete currently connected TestimonialSliderParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected TestimonialSliderParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TestimonialSliderParent document */
  update?: InputMaybe<TestimonialSliderParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single TestimonialSliderParent document */
  upsert?: InputMaybe<TestimonialSliderParentUpsertWithNestedWhereUniqueInput>
}

export type TestimonialSliderParentUpdateWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type TestimonialSliderParentUpsertWithNestedWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type TestimonialSliderParentWhereInput = {
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type TestimonialSliderParentWhereUniqueInput = {
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type TestimonialSliderUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<TestimonialSliderUpdateLocalizationsInput>
  slide?: InputMaybe<SectionTestimonialUpdateManyInlineInput>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TestimonialSliderUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type TestimonialSliderUpdateLocalizationInput = {
  data: TestimonialSliderUpdateLocalizationDataInput
  locale: Locale
}

export type TestimonialSliderUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TestimonialSliderCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TestimonialSliderUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TestimonialSliderUpsertLocalizationInput>>
}

export type TestimonialSliderUpdateManyInlineInput = {
  /** Create and connect multiple TestimonialSlider component instances */
  create?: InputMaybe<Array<TestimonialSliderCreateWithPositionInput>>
  /** Delete multiple TestimonialSlider documents */
  delete?: InputMaybe<Array<TestimonialSliderWhereUniqueInput>>
  /** Update multiple TestimonialSlider component instances */
  update?: InputMaybe<Array<TestimonialSliderUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple TestimonialSlider component instances */
  upsert?: InputMaybe<Array<TestimonialSliderUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type TestimonialSliderUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<TestimonialSliderUpdateManyLocalizationsInput>
  styleVariant?: InputMaybe<ComponentStyle>
  theme?: InputMaybe<OmrThemeVariant>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TestimonialSliderUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type TestimonialSliderUpdateManyLocalizationInput = {
  data: TestimonialSliderUpdateManyLocalizationDataInput
  locale: Locale
}

export type TestimonialSliderUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TestimonialSliderUpdateManyLocalizationInput>>
}

export type TestimonialSliderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TestimonialSliderUpdateManyInput
  /** Document search */
  where: TestimonialSliderWhereInput
}

export type TestimonialSliderUpdateOneInlineInput = {
  /** Create and connect one TestimonialSlider document */
  create?: InputMaybe<TestimonialSliderCreateInput>
  /** Delete currently connected TestimonialSlider document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TestimonialSlider document */
  update?: InputMaybe<TestimonialSliderUpdateWithNestedWhereUniqueInput>
  /** Upsert single TestimonialSlider document */
  upsert?: InputMaybe<TestimonialSliderUpsertWithNestedWhereUniqueInput>
}

export type TestimonialSliderUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TestimonialSliderUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TestimonialSliderWhereUniqueInput
}

export type TestimonialSliderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TestimonialSliderUpdateInput
  /** Unique document search */
  where: TestimonialSliderWhereUniqueInput
}

export type TestimonialSliderUpsertInput = {
  /** Create document if it didn't exist */
  create: TestimonialSliderCreateInput
  /** Update document if it exists */
  update: TestimonialSliderUpdateInput
}

export type TestimonialSliderUpsertLocalizationInput = {
  create: TestimonialSliderCreateLocalizationDataInput
  locale: Locale
  update: TestimonialSliderUpdateLocalizationDataInput
}

export type TestimonialSliderUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TestimonialSliderUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TestimonialSliderWhereUniqueInput
}

export type TestimonialSliderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TestimonialSliderUpsertInput
  /** Unique document search */
  where: TestimonialSliderWhereUniqueInput
}

/** Identifies documents */
export type TestimonialSliderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestimonialSliderWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestimonialSliderWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestimonialSliderWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  slide_every?: InputMaybe<SectionTestimonialWhereInput>
  slide_none?: InputMaybe<SectionTestimonialWhereInput>
  slide_some?: InputMaybe<SectionTestimonialWhereInput>
  styleVariant?: InputMaybe<ComponentStyle>
  /** All values that are contained in given list. */
  styleVariant_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  styleVariant_not?: InputMaybe<ComponentStyle>
  /** All values that are not contained in given list. */
  styleVariant_not_in?: InputMaybe<Array<InputMaybe<ComponentStyle>>>
  theme?: InputMaybe<OmrThemeVariant>
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<OmrThemeVariant>
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<OmrThemeVariant>>>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References TestimonialSlider record uniquely */
export type TestimonialSliderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** A section representing media asset next to text content with optional CTA */
export type TextMedia = Entity & {
  __typename?: 'TextMedia'
  /** Text alignment centered */
  centered?: Maybe<Scalars['Boolean']['output']>
  /** Call to action element rendered below text content */
  cta?: Maybe<CallToAction>
  /** DEPRECATED use CTA component */
  ctaText?: Maybe<Scalars['String']['output']>
  /** DEPRECATED use CTA component */
  ctaUrl?: Maybe<Scalars['String']['output']>
  darkTheme?: Maybe<Scalars['Boolean']['output']>
  decorationPattern?: Maybe<DecorationPattern>
  decorationStyle?: Maybe<DecorationStyle>
  description: Scalars['String']['output']
  enableDescriptionStyling?: Maybe<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Video or image to render */
  image: Asset
  /** Hide media asset on mobile devices */
  imageHiddenOnMobile?: Maybe<Scalars['Boolean']['output']>
  /** CTA url for image media asset */
  imageLinkUrl?: Maybe<Scalars['String']['output']>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<TextMedia>
  /** Position of the media asset (defaults to left) */
  position?: Maybe<ElementPosition>
  /** A proportions how whole section is divided into columns. */
  sectionDivision?: Maybe<SectionDivision>
  /** Select a custom padding for this section, otherwise default is used. */
  sectionPadding?: Maybe<SectionPadding>
  /** System stage field */
  stage: Stage
  subtitle?: Maybe<Scalars['String']['output']>
  tag?: Maybe<Scalars['String']['output']>
  textBanner?: Maybe<Asset>
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Render image belo text content */
  vertical?: Maybe<Scalars['Boolean']['output']>
}

/** A section representing media asset next to text content with optional CTA */
export type TextMediaCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** A section representing media asset next to text content with optional CTA */
export type TextMediaImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** A section representing media asset next to text content with optional CTA */
export type TextMediaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** A section representing media asset next to text content with optional CTA */
export type TextMediaTextBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** A section representing media asset next to text content with optional CTA */
export type TextMediaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type TextMediaBanner = Entity & {
  __typename?: 'TextMediaBanner'
  description?: Maybe<Scalars['String']['output']>
  desktopBanner: Asset
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<TextMediaBanner>
  mobileBanner: Asset
  /** System stage field */
  stage: Stage
  textMediaBannerCta?: Maybe<CallToAction>
  title?: Maybe<Scalars['String']['output']>
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TextMediaBannerDesktopBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type TextMediaBannerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type TextMediaBannerMobileBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

export type TextMediaBannerTextMediaBannerCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type TextMediaBannerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type TextMediaBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TextMediaBannerWhereUniqueInput
}

/** A connection to a list of items. */
export type TextMediaBannerConnection = {
  __typename?: 'TextMediaBannerConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TextMediaBannerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TextMediaBannerCreateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  desktopBanner: AssetCreateOneInlineInput
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TextMediaBannerCreateLocalizationsInput>
  mobileBanner: AssetCreateOneInlineInput
  textMediaBannerCta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TextMediaBannerCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TextMediaBannerCreateLocalizationInput = {
  /** Localization input */
  data: TextMediaBannerCreateLocalizationDataInput
  locale: Locale
}

export type TextMediaBannerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TextMediaBannerCreateLocalizationInput>>
}

export type TextMediaBannerCreateManyInlineInput = {
  /** Create and connect multiple existing TextMediaBanner documents */
  create?: InputMaybe<Array<TextMediaBannerCreateInput>>
}

export type TextMediaBannerCreateOneInlineInput = {
  /** Create and connect one TextMediaBanner document */
  create?: InputMaybe<TextMediaBannerCreateInput>
}

export type TextMediaBannerCreateWithPositionInput = {
  /** Document to create */
  data: TextMediaBannerCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type TextMediaBannerEdge = {
  __typename?: 'TextMediaBannerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TextMediaBanner
}

/** Identifies documents */
export type TextMediaBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextMediaBannerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextMediaBannerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextMediaBannerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  desktopBanner?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  mobileBanner?: InputMaybe<AssetWhereInput>
  textMediaBannerCta?: InputMaybe<CallToActionWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum TextMediaBannerOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type TextMediaBannerParent = LandingPage

export type TextMediaBannerParentConnectInput = {
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type TextMediaBannerParentCreateInput = {
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type TextMediaBannerParentCreateManyInlineInput = {
  /** Connect multiple existing TextMediaBannerParent documents */
  connect?: InputMaybe<Array<TextMediaBannerParentWhereUniqueInput>>
  /** Create and connect multiple existing TextMediaBannerParent documents */
  create?: InputMaybe<Array<TextMediaBannerParentCreateInput>>
}

export type TextMediaBannerParentCreateOneInlineInput = {
  /** Connect one existing TextMediaBannerParent document */
  connect?: InputMaybe<TextMediaBannerParentWhereUniqueInput>
  /** Create and connect one TextMediaBannerParent document */
  create?: InputMaybe<TextMediaBannerParentCreateInput>
}

export type TextMediaBannerParentUpdateInput = {
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type TextMediaBannerParentUpdateManyInlineInput = {
  /** Connect multiple existing TextMediaBannerParent documents */
  connect?: InputMaybe<Array<TextMediaBannerParentConnectInput>>
  /** Create and connect multiple TextMediaBannerParent documents */
  create?: InputMaybe<Array<TextMediaBannerParentCreateInput>>
  /** Delete multiple TextMediaBannerParent documents */
  delete?: InputMaybe<Array<TextMediaBannerParentWhereUniqueInput>>
  /** Disconnect multiple TextMediaBannerParent documents */
  disconnect?: InputMaybe<Array<TextMediaBannerParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing TextMediaBannerParent documents */
  set?: InputMaybe<Array<TextMediaBannerParentWhereUniqueInput>>
  /** Update multiple TextMediaBannerParent documents */
  update?: InputMaybe<Array<TextMediaBannerParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple TextMediaBannerParent documents */
  upsert?: InputMaybe<Array<TextMediaBannerParentUpsertWithNestedWhereUniqueInput>>
}

export type TextMediaBannerParentUpdateManyWithNestedWhereInput = {
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type TextMediaBannerParentUpdateOneInlineInput = {
  /** Connect existing TextMediaBannerParent document */
  connect?: InputMaybe<TextMediaBannerParentWhereUniqueInput>
  /** Create and connect one TextMediaBannerParent document */
  create?: InputMaybe<TextMediaBannerParentCreateInput>
  /** Delete currently connected TextMediaBannerParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected TextMediaBannerParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TextMediaBannerParent document */
  update?: InputMaybe<TextMediaBannerParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single TextMediaBannerParent document */
  upsert?: InputMaybe<TextMediaBannerParentUpsertWithNestedWhereUniqueInput>
}

export type TextMediaBannerParentUpdateWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type TextMediaBannerParentUpsertWithNestedWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type TextMediaBannerParentWhereInput = {
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type TextMediaBannerParentWhereUniqueInput = {
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type TextMediaBannerUpdateInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  desktopBanner?: InputMaybe<AssetUpdateOneInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<TextMediaBannerUpdateLocalizationsInput>
  mobileBanner?: InputMaybe<AssetUpdateOneInlineInput>
  textMediaBannerCta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TextMediaBannerUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TextMediaBannerUpdateLocalizationInput = {
  data: TextMediaBannerUpdateLocalizationDataInput
  locale: Locale
}

export type TextMediaBannerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TextMediaBannerCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TextMediaBannerUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TextMediaBannerUpsertLocalizationInput>>
}

export type TextMediaBannerUpdateManyInlineInput = {
  /** Create and connect multiple TextMediaBanner component instances */
  create?: InputMaybe<Array<TextMediaBannerCreateWithPositionInput>>
  /** Delete multiple TextMediaBanner documents */
  delete?: InputMaybe<Array<TextMediaBannerWhereUniqueInput>>
  /** Update multiple TextMediaBanner component instances */
  update?: InputMaybe<Array<TextMediaBannerUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple TextMediaBanner component instances */
  upsert?: InputMaybe<Array<TextMediaBannerUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type TextMediaBannerUpdateManyInput = {
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<TextMediaBannerUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TextMediaBannerUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TextMediaBannerUpdateManyLocalizationInput = {
  data: TextMediaBannerUpdateManyLocalizationDataInput
  locale: Locale
}

export type TextMediaBannerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TextMediaBannerUpdateManyLocalizationInput>>
}

export type TextMediaBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TextMediaBannerUpdateManyInput
  /** Document search */
  where: TextMediaBannerWhereInput
}

export type TextMediaBannerUpdateOneInlineInput = {
  /** Create and connect one TextMediaBanner document */
  create?: InputMaybe<TextMediaBannerCreateInput>
  /** Delete currently connected TextMediaBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TextMediaBanner document */
  update?: InputMaybe<TextMediaBannerUpdateWithNestedWhereUniqueInput>
  /** Upsert single TextMediaBanner document */
  upsert?: InputMaybe<TextMediaBannerUpsertWithNestedWhereUniqueInput>
}

export type TextMediaBannerUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TextMediaBannerUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TextMediaBannerWhereUniqueInput
}

export type TextMediaBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TextMediaBannerUpdateInput
  /** Unique document search */
  where: TextMediaBannerWhereUniqueInput
}

export type TextMediaBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: TextMediaBannerCreateInput
  /** Update document if it exists */
  update: TextMediaBannerUpdateInput
}

export type TextMediaBannerUpsertLocalizationInput = {
  create: TextMediaBannerCreateLocalizationDataInput
  locale: Locale
  update: TextMediaBannerUpdateLocalizationDataInput
}

export type TextMediaBannerUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TextMediaBannerUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TextMediaBannerWhereUniqueInput
}

export type TextMediaBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TextMediaBannerUpsertInput
  /** Unique document search */
  where: TextMediaBannerWhereUniqueInput
}

/** Identifies documents */
export type TextMediaBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextMediaBannerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextMediaBannerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextMediaBannerWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  desktopBanner?: InputMaybe<AssetWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  mobileBanner?: InputMaybe<AssetWhereInput>
  textMediaBannerCta?: InputMaybe<CallToActionWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References TextMediaBanner record uniquely */
export type TextMediaBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type TextMediaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TextMediaWhereUniqueInput
}

/** A connection to a list of items. */
export type TextMediaConnection = {
  __typename?: 'TextMediaConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TextMediaEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TextMediaCreateInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionCreateOneInlineInput>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  decorationStyle?: InputMaybe<DecorationStyle>
  /** description input for default locale (de) */
  description: Scalars['String']['input']
  enableDescriptionStyling?: InputMaybe<Scalars['Boolean']['input']>
  image: AssetCreateOneInlineInput
  imageHiddenOnMobile?: InputMaybe<Scalars['Boolean']['input']>
  imageLinkUrl?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TextMediaCreateLocalizationsInput>
  position?: InputMaybe<ElementPosition>
  sectionDivision?: InputMaybe<SectionDivision>
  sectionPadding?: InputMaybe<SectionPadding>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** tag input for default locale (de) */
  tag?: InputMaybe<Scalars['String']['input']>
  textBanner?: InputMaybe<AssetCreateOneInlineInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  vertical?: InputMaybe<Scalars['Boolean']['input']>
}

export type TextMediaCreateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TextMediaCreateLocalizationInput = {
  /** Localization input */
  data: TextMediaCreateLocalizationDataInput
  locale: Locale
}

export type TextMediaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TextMediaCreateLocalizationInput>>
}

export type TextMediaCreateManyInlineInput = {
  /** Create and connect multiple existing TextMedia documents */
  create?: InputMaybe<Array<TextMediaCreateInput>>
}

export type TextMediaCreateOneInlineInput = {
  /** Create and connect one TextMedia document */
  create?: InputMaybe<TextMediaCreateInput>
}

export type TextMediaCreateWithPositionInput = {
  /** Document to create */
  data: TextMediaCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type TextMediaEdge = {
  __typename?: 'TextMediaEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TextMedia
}

/** Identifies documents */
export type TextMediaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextMediaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextMediaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextMediaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkTheme_not?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  decorationStyle?: InputMaybe<DecorationStyle>
  /** All values that are contained in given list. */
  decorationStyle_in?: InputMaybe<Array<InputMaybe<DecorationStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationStyle_not?: InputMaybe<DecorationStyle>
  /** All values that are not contained in given list. */
  decorationStyle_not_in?: InputMaybe<Array<InputMaybe<DecorationStyle>>>
  enableDescriptionStyling?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableDescriptionStyling_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  imageHiddenOnMobile?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  imageHiddenOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>
  imageLinkUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  imageLinkUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  imageLinkUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  imageLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  imageLinkUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  imageLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  imageLinkUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  imageLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  imageLinkUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  imageLinkUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  sectionDivision?: InputMaybe<SectionDivision>
  /** All values that are contained in given list. */
  sectionDivision_in?: InputMaybe<Array<InputMaybe<SectionDivision>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionDivision_not?: InputMaybe<SectionDivision>
  /** All values that are not contained in given list. */
  sectionDivision_not_in?: InputMaybe<Array<InputMaybe<SectionDivision>>>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  textBanner?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  vertical?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  vertical_not?: InputMaybe<Scalars['Boolean']['input']>
}

export enum TextMediaOrderByInput {
  CenteredAsc = 'centered_ASC',
  CenteredDesc = 'centered_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  DarkThemeAsc = 'darkTheme_ASC',
  DarkThemeDesc = 'darkTheme_DESC',
  DecorationPatternAsc = 'decorationPattern_ASC',
  DecorationPatternDesc = 'decorationPattern_DESC',
  DecorationStyleAsc = 'decorationStyle_ASC',
  DecorationStyleDesc = 'decorationStyle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EnableDescriptionStylingAsc = 'enableDescriptionStyling_ASC',
  EnableDescriptionStylingDesc = 'enableDescriptionStyling_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageHiddenOnMobileAsc = 'imageHiddenOnMobile_ASC',
  ImageHiddenOnMobileDesc = 'imageHiddenOnMobile_DESC',
  ImageLinkUrlAsc = 'imageLinkUrl_ASC',
  ImageLinkUrlDesc = 'imageLinkUrl_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  SectionDivisionAsc = 'sectionDivision_ASC',
  SectionDivisionDesc = 'sectionDivision_DESC',
  SectionPaddingAsc = 'sectionPadding_ASC',
  SectionPaddingDesc = 'sectionPadding_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TagAsc = 'tag_ASC',
  TagDesc = 'tag_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VerticalAsc = 'vertical_ASC',
  VerticalDesc = 'vertical_DESC',
}

export type TextMediaParent = CareerPage | EventPage | LandingPage

export type TextMediaParentConnectInput = {
  CareerPage?: InputMaybe<CareerPageConnectInput>
  EventPage?: InputMaybe<EventPageConnectInput>
  LandingPage?: InputMaybe<LandingPageConnectInput>
}

export type TextMediaParentCreateInput = {
  CareerPage?: InputMaybe<CareerPageCreateInput>
  EventPage?: InputMaybe<EventPageCreateInput>
  LandingPage?: InputMaybe<LandingPageCreateInput>
}

export type TextMediaParentCreateManyInlineInput = {
  /** Connect multiple existing TextMediaParent documents */
  connect?: InputMaybe<Array<TextMediaParentWhereUniqueInput>>
  /** Create and connect multiple existing TextMediaParent documents */
  create?: InputMaybe<Array<TextMediaParentCreateInput>>
}

export type TextMediaParentCreateOneInlineInput = {
  /** Connect one existing TextMediaParent document */
  connect?: InputMaybe<TextMediaParentWhereUniqueInput>
  /** Create and connect one TextMediaParent document */
  create?: InputMaybe<TextMediaParentCreateInput>
}

export type TextMediaParentUpdateInput = {
  CareerPage?: InputMaybe<CareerPageUpdateInput>
  EventPage?: InputMaybe<EventPageUpdateInput>
  LandingPage?: InputMaybe<LandingPageUpdateInput>
}

export type TextMediaParentUpdateManyInlineInput = {
  /** Connect multiple existing TextMediaParent documents */
  connect?: InputMaybe<Array<TextMediaParentConnectInput>>
  /** Create and connect multiple TextMediaParent documents */
  create?: InputMaybe<Array<TextMediaParentCreateInput>>
  /** Delete multiple TextMediaParent documents */
  delete?: InputMaybe<Array<TextMediaParentWhereUniqueInput>>
  /** Disconnect multiple TextMediaParent documents */
  disconnect?: InputMaybe<Array<TextMediaParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing TextMediaParent documents */
  set?: InputMaybe<Array<TextMediaParentWhereUniqueInput>>
  /** Update multiple TextMediaParent documents */
  update?: InputMaybe<Array<TextMediaParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple TextMediaParent documents */
  upsert?: InputMaybe<Array<TextMediaParentUpsertWithNestedWhereUniqueInput>>
}

export type TextMediaParentUpdateManyWithNestedWhereInput = {
  CareerPage?: InputMaybe<CareerPageUpdateManyWithNestedWhereInput>
  EventPage?: InputMaybe<EventPageUpdateManyWithNestedWhereInput>
  LandingPage?: InputMaybe<LandingPageUpdateManyWithNestedWhereInput>
}

export type TextMediaParentUpdateOneInlineInput = {
  /** Connect existing TextMediaParent document */
  connect?: InputMaybe<TextMediaParentWhereUniqueInput>
  /** Create and connect one TextMediaParent document */
  create?: InputMaybe<TextMediaParentCreateInput>
  /** Delete currently connected TextMediaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected TextMediaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TextMediaParent document */
  update?: InputMaybe<TextMediaParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single TextMediaParent document */
  upsert?: InputMaybe<TextMediaParentUpsertWithNestedWhereUniqueInput>
}

export type TextMediaParentUpdateWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpdateWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpdateWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpdateWithNestedWhereUniqueInput>
}

export type TextMediaParentUpsertWithNestedWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageUpsertWithNestedWhereUniqueInput>
  EventPage?: InputMaybe<EventPageUpsertWithNestedWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageUpsertWithNestedWhereUniqueInput>
}

export type TextMediaParentWhereInput = {
  CareerPage?: InputMaybe<CareerPageWhereInput>
  EventPage?: InputMaybe<EventPageWhereInput>
  LandingPage?: InputMaybe<LandingPageWhereInput>
}

export type TextMediaParentWhereUniqueInput = {
  CareerPage?: InputMaybe<CareerPageWhereUniqueInput>
  EventPage?: InputMaybe<EventPageWhereUniqueInput>
  LandingPage?: InputMaybe<LandingPageWhereUniqueInput>
}

export type TextMediaUpdateInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionUpdateOneInlineInput>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  decorationStyle?: InputMaybe<DecorationStyle>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  enableDescriptionStyling?: InputMaybe<Scalars['Boolean']['input']>
  image?: InputMaybe<AssetUpdateOneInlineInput>
  imageHiddenOnMobile?: InputMaybe<Scalars['Boolean']['input']>
  imageLinkUrl?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<TextMediaUpdateLocalizationsInput>
  position?: InputMaybe<ElementPosition>
  sectionDivision?: InputMaybe<SectionDivision>
  sectionPadding?: InputMaybe<SectionPadding>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** tag input for default locale (de) */
  tag?: InputMaybe<Scalars['String']['input']>
  textBanner?: InputMaybe<AssetUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  vertical?: InputMaybe<Scalars['Boolean']['input']>
}

export type TextMediaUpdateLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TextMediaUpdateLocalizationInput = {
  data: TextMediaUpdateLocalizationDataInput
  locale: Locale
}

export type TextMediaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TextMediaCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TextMediaUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TextMediaUpsertLocalizationInput>>
}

export type TextMediaUpdateManyInlineInput = {
  /** Create and connect multiple TextMedia component instances */
  create?: InputMaybe<Array<TextMediaCreateWithPositionInput>>
  /** Delete multiple TextMedia documents */
  delete?: InputMaybe<Array<TextMediaWhereUniqueInput>>
  /** Update multiple TextMedia component instances */
  update?: InputMaybe<Array<TextMediaUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple TextMedia component instances */
  upsert?: InputMaybe<Array<TextMediaUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type TextMediaUpdateManyInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** ctaText input for default locale (de) */
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** ctaUrl input for default locale (de) */
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  decorationStyle?: InputMaybe<DecorationStyle>
  /** description input for default locale (de) */
  description?: InputMaybe<Scalars['String']['input']>
  enableDescriptionStyling?: InputMaybe<Scalars['Boolean']['input']>
  imageHiddenOnMobile?: InputMaybe<Scalars['Boolean']['input']>
  imageLinkUrl?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<TextMediaUpdateManyLocalizationsInput>
  position?: InputMaybe<ElementPosition>
  sectionDivision?: InputMaybe<SectionDivision>
  sectionPadding?: InputMaybe<SectionPadding>
  /** subtitle input for default locale (de) */
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** tag input for default locale (de) */
  tag?: InputMaybe<Scalars['String']['input']>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  vertical?: InputMaybe<Scalars['Boolean']['input']>
}

export type TextMediaUpdateManyLocalizationDataInput = {
  ctaText?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TextMediaUpdateManyLocalizationInput = {
  data: TextMediaUpdateManyLocalizationDataInput
  locale: Locale
}

export type TextMediaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TextMediaUpdateManyLocalizationInput>>
}

export type TextMediaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TextMediaUpdateManyInput
  /** Document search */
  where: TextMediaWhereInput
}

export type TextMediaUpdateOneInlineInput = {
  /** Create and connect one TextMedia document */
  create?: InputMaybe<TextMediaCreateInput>
  /** Delete currently connected TextMedia document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TextMedia document */
  update?: InputMaybe<TextMediaUpdateWithNestedWhereUniqueInput>
  /** Upsert single TextMedia document */
  upsert?: InputMaybe<TextMediaUpsertWithNestedWhereUniqueInput>
}

export type TextMediaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TextMediaUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TextMediaWhereUniqueInput
}

export type TextMediaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TextMediaUpdateInput
  /** Unique document search */
  where: TextMediaWhereUniqueInput
}

export type TextMediaUpsertInput = {
  /** Create document if it didn't exist */
  create: TextMediaCreateInput
  /** Update document if it exists */
  update: TextMediaUpdateInput
}

export type TextMediaUpsertLocalizationInput = {
  create: TextMediaCreateLocalizationDataInput
  locale: Locale
  update: TextMediaUpdateLocalizationDataInput
}

export type TextMediaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TextMediaUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TextMediaWhereUniqueInput
}

export type TextMediaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TextMediaUpsertInput
  /** Unique document search */
  where: TextMediaWhereUniqueInput
}

/** Identifies documents */
export type TextMediaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextMediaWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextMediaWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextMediaWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  centered?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>
  cta?: InputMaybe<CallToActionWhereInput>
  ctaText?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaText_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaText_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaText_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaText_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaText_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaText_starts_with?: InputMaybe<Scalars['String']['input']>
  ctaUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  darkTheme_not?: InputMaybe<Scalars['Boolean']['input']>
  decorationPattern?: InputMaybe<DecorationPattern>
  /** All values that are contained in given list. */
  decorationPattern_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationPattern_not?: InputMaybe<DecorationPattern>
  /** All values that are not contained in given list. */
  decorationPattern_not_in?: InputMaybe<Array<InputMaybe<DecorationPattern>>>
  decorationStyle?: InputMaybe<DecorationStyle>
  /** All values that are contained in given list. */
  decorationStyle_in?: InputMaybe<Array<InputMaybe<DecorationStyle>>>
  /** Any other value that exists and is not equal to the given value. */
  decorationStyle_not?: InputMaybe<DecorationStyle>
  /** All values that are not contained in given list. */
  decorationStyle_not_in?: InputMaybe<Array<InputMaybe<DecorationStyle>>>
  description?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>
  enableDescriptionStyling?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  enableDescriptionStyling_not?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<AssetWhereInput>
  imageHiddenOnMobile?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  imageHiddenOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>
  imageLinkUrl?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  imageLinkUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  imageLinkUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  imageLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  imageLinkUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  imageLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  imageLinkUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  imageLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  imageLinkUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  imageLinkUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<ElementPosition>
  /** All values that are contained in given list. */
  position_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  /** Any other value that exists and is not equal to the given value. */
  position_not?: InputMaybe<ElementPosition>
  /** All values that are not contained in given list. */
  position_not_in?: InputMaybe<Array<InputMaybe<ElementPosition>>>
  sectionDivision?: InputMaybe<SectionDivision>
  /** All values that are contained in given list. */
  sectionDivision_in?: InputMaybe<Array<InputMaybe<SectionDivision>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionDivision_not?: InputMaybe<SectionDivision>
  /** All values that are not contained in given list. */
  sectionDivision_not_in?: InputMaybe<Array<InputMaybe<SectionDivision>>>
  sectionPadding?: InputMaybe<SectionPadding>
  /** All values that are contained in given list. */
  sectionPadding_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  /** Any other value that exists and is not equal to the given value. */
  sectionPadding_not?: InputMaybe<SectionPadding>
  /** All values that are not contained in given list. */
  sectionPadding_not_in?: InputMaybe<Array<InputMaybe<SectionPadding>>>
  subtitle?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  tag_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  tag_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  tag_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  tag_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  tag_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  tag_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  tag_starts_with?: InputMaybe<Scalars['String']['input']>
  textBanner?: InputMaybe<AssetWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  vertical?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  vertical_not?: InputMaybe<Scalars['Boolean']['input']>
}

/** References TextMedia record uniquely */
export type TextMediaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumn = Entity &
  Node & {
    __typename?: 'TicketsTableColumn'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** When set, renders a discount badge with this text on this column. */
    discountLabel?: Maybe<Scalars['String']['output']>
    /** Get the document in other stages */
    documentInStages: Array<TicketsTableColumn>
    /** List of TicketsTableColumn versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<TicketsTableColumn>
    price: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    shopUrl: Scalars['String']['output']
    /** Overrides the section default Buy button label for this column. */
    shopUrlLabel?: Maybe<Scalars['String']['output']>
    /** System stage field */
    stage: Stage
    type: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** A single ticket column rendered in a SectionTicketsTable. */
export type TicketsTableColumnUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type TicketsTableColumnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TicketsTableColumnWhereUniqueInput
}

/** A connection to a list of items. */
export type TicketsTableColumnConnection = {
  __typename?: 'TicketsTableColumnConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TicketsTableColumnEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TicketsTableColumnCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** discountLabel input for default locale (de) */
  discountLabel?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TicketsTableColumnCreateLocalizationsInput>
  price: Scalars['String']['input']
  sectionTicketsTable?: InputMaybe<SectionTicketsTableCreateManyInlineInput>
  /** shopUrl input for default locale (de) */
  shopUrl: Scalars['String']['input']
  /** shopUrlLabel input for default locale (de) */
  shopUrlLabel?: InputMaybe<Scalars['String']['input']>
  /** type input for default locale (de) */
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TicketsTableColumnCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  discountLabel?: InputMaybe<Scalars['String']['input']>
  shopUrl: Scalars['String']['input']
  shopUrlLabel?: InputMaybe<Scalars['String']['input']>
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TicketsTableColumnCreateLocalizationInput = {
  /** Localization input */
  data: TicketsTableColumnCreateLocalizationDataInput
  locale: Locale
}

export type TicketsTableColumnCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TicketsTableColumnCreateLocalizationInput>>
}

export type TicketsTableColumnCreateManyInlineInput = {
  /** Connect multiple existing TicketsTableColumn documents */
  connect?: InputMaybe<Array<TicketsTableColumnWhereUniqueInput>>
  /** Create and connect multiple existing TicketsTableColumn documents */
  create?: InputMaybe<Array<TicketsTableColumnCreateInput>>
}

export type TicketsTableColumnCreateOneInlineInput = {
  /** Connect one existing TicketsTableColumn document */
  connect?: InputMaybe<TicketsTableColumnWhereUniqueInput>
  /** Create and connect one TicketsTableColumn document */
  create?: InputMaybe<TicketsTableColumnCreateInput>
}

/** An edge in a connection. */
export type TicketsTableColumnEdge = {
  __typename?: 'TicketsTableColumnEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TicketsTableColumn
}

/** Identifies documents */
export type TicketsTableColumnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TicketsTableColumnWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TicketsTableColumnWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TicketsTableColumnWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<TicketsTableColumnWhereStageInput>
  documentInStages_none?: InputMaybe<TicketsTableColumnWhereStageInput>
  documentInStages_some?: InputMaybe<TicketsTableColumnWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  price?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  price_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  price_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  price_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  price_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  price_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  price_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  price_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  price_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum TicketsTableColumnOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DiscountLabelAsc = 'discountLabel_ASC',
  DiscountLabelDesc = 'discountLabel_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShopUrlLabelAsc = 'shopUrlLabel_ASC',
  ShopUrlLabelDesc = 'shopUrlLabel_DESC',
  ShopUrlAsc = 'shopUrl_ASC',
  ShopUrlDesc = 'shopUrl_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type TicketsTableColumnUpdateInput = {
  /** discountLabel input for default locale (de) */
  discountLabel?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<TicketsTableColumnUpdateLocalizationsInput>
  price?: InputMaybe<Scalars['String']['input']>
  sectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateManyInlineInput>
  /** shopUrl input for default locale (de) */
  shopUrl?: InputMaybe<Scalars['String']['input']>
  /** shopUrlLabel input for default locale (de) */
  shopUrlLabel?: InputMaybe<Scalars['String']['input']>
  /** type input for default locale (de) */
  type?: InputMaybe<Scalars['String']['input']>
}

export type TicketsTableColumnUpdateLocalizationDataInput = {
  discountLabel?: InputMaybe<Scalars['String']['input']>
  shopUrl?: InputMaybe<Scalars['String']['input']>
  shopUrlLabel?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type TicketsTableColumnUpdateLocalizationInput = {
  data: TicketsTableColumnUpdateLocalizationDataInput
  locale: Locale
}

export type TicketsTableColumnUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TicketsTableColumnCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TicketsTableColumnUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TicketsTableColumnUpsertLocalizationInput>>
}

export type TicketsTableColumnUpdateManyInlineInput = {
  /** Connect multiple existing TicketsTableColumn documents */
  connect?: InputMaybe<Array<TicketsTableColumnConnectInput>>
  /** Create and connect multiple TicketsTableColumn documents */
  create?: InputMaybe<Array<TicketsTableColumnCreateInput>>
  /** Delete multiple TicketsTableColumn documents */
  delete?: InputMaybe<Array<TicketsTableColumnWhereUniqueInput>>
  /** Disconnect multiple TicketsTableColumn documents */
  disconnect?: InputMaybe<Array<TicketsTableColumnWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing TicketsTableColumn documents */
  set?: InputMaybe<Array<TicketsTableColumnWhereUniqueInput>>
  /** Update multiple TicketsTableColumn documents */
  update?: InputMaybe<Array<TicketsTableColumnUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple TicketsTableColumn documents */
  upsert?: InputMaybe<Array<TicketsTableColumnUpsertWithNestedWhereUniqueInput>>
}

export type TicketsTableColumnUpdateManyInput = {
  /** discountLabel input for default locale (de) */
  discountLabel?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<TicketsTableColumnUpdateManyLocalizationsInput>
  price?: InputMaybe<Scalars['String']['input']>
  /** shopUrl input for default locale (de) */
  shopUrl?: InputMaybe<Scalars['String']['input']>
  /** shopUrlLabel input for default locale (de) */
  shopUrlLabel?: InputMaybe<Scalars['String']['input']>
  /** type input for default locale (de) */
  type?: InputMaybe<Scalars['String']['input']>
}

export type TicketsTableColumnUpdateManyLocalizationDataInput = {
  discountLabel?: InputMaybe<Scalars['String']['input']>
  shopUrl?: InputMaybe<Scalars['String']['input']>
  shopUrlLabel?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type TicketsTableColumnUpdateManyLocalizationInput = {
  data: TicketsTableColumnUpdateManyLocalizationDataInput
  locale: Locale
}

export type TicketsTableColumnUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TicketsTableColumnUpdateManyLocalizationInput>>
}

export type TicketsTableColumnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TicketsTableColumnUpdateManyInput
  /** Document search */
  where: TicketsTableColumnWhereInput
}

export type TicketsTableColumnUpdateOneInlineInput = {
  /** Connect existing TicketsTableColumn document */
  connect?: InputMaybe<TicketsTableColumnWhereUniqueInput>
  /** Create and connect one TicketsTableColumn document */
  create?: InputMaybe<TicketsTableColumnCreateInput>
  /** Delete currently connected TicketsTableColumn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected TicketsTableColumn document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TicketsTableColumn document */
  update?: InputMaybe<TicketsTableColumnUpdateWithNestedWhereUniqueInput>
  /** Upsert single TicketsTableColumn document */
  upsert?: InputMaybe<TicketsTableColumnUpsertWithNestedWhereUniqueInput>
}

export type TicketsTableColumnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TicketsTableColumnUpdateInput
  /** Unique document search */
  where: TicketsTableColumnWhereUniqueInput
}

export type TicketsTableColumnUpsertInput = {
  /** Create document if it didn't exist */
  create: TicketsTableColumnCreateInput
  /** Update document if it exists */
  update: TicketsTableColumnUpdateInput
}

export type TicketsTableColumnUpsertLocalizationInput = {
  create: TicketsTableColumnCreateLocalizationDataInput
  locale: Locale
  update: TicketsTableColumnUpdateLocalizationDataInput
}

export type TicketsTableColumnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TicketsTableColumnUpsertInput
  /** Unique document search */
  where: TicketsTableColumnWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type TicketsTableColumnWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type TicketsTableColumnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TicketsTableColumnWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TicketsTableColumnWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TicketsTableColumnWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  discountLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  discountLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  discountLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  discountLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  discountLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  discountLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  discountLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  discountLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  discountLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  discountLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  documentInStages_every?: InputMaybe<TicketsTableColumnWhereStageInput>
  documentInStages_none?: InputMaybe<TicketsTableColumnWhereStageInput>
  documentInStages_some?: InputMaybe<TicketsTableColumnWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  price?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  price_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  price_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  price_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  price_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  price_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  price_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  price_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  price_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  shopUrl?: InputMaybe<Scalars['String']['input']>
  shopUrlLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  shopUrlLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  shopUrlLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  shopUrlLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  shopUrlLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  shopUrlLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  shopUrlLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  shopUrlLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  shopUrlLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  shopUrlLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  shopUrl_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  shopUrl_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  shopUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  shopUrl_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  shopUrl_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  shopUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  shopUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  shopUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  shopUrl_starts_with?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  type_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  type_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  type_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  type_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TicketsTableColumnWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TicketsTableColumnWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TicketsTableColumnWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TicketsTableColumnWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TicketsTableColumnWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References TicketsTableColumn record uniquely */
export type TicketsTableColumnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type TicketsTableRow = Entity & {
  __typename?: 'TicketsTableRow'
  /** One boolean per ticket column, in column order. 1-4 entries. */
  cells: Array<Scalars['Boolean']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<TicketsTableRow>
  rowLabel: Scalars['String']['output']
  /** System stage field */
  stage: Stage
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TicketsTableRowLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type TicketsTableRowUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type TicketsTableRowConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TicketsTableRowWhereUniqueInput
}

/** A connection to a list of items. */
export type TicketsTableRowConnection = {
  __typename?: 'TicketsTableRowConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TicketsTableRowEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TicketsTableRowCreateInput = {
  cells?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TicketsTableRowCreateLocalizationsInput>
  /** rowLabel input for default locale (de) */
  rowLabel: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TicketsTableRowCreateLocalizationDataInput = {
  rowLabel: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TicketsTableRowCreateLocalizationInput = {
  /** Localization input */
  data: TicketsTableRowCreateLocalizationDataInput
  locale: Locale
}

export type TicketsTableRowCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TicketsTableRowCreateLocalizationInput>>
}

export type TicketsTableRowCreateManyInlineInput = {
  /** Create and connect multiple existing TicketsTableRow documents */
  create?: InputMaybe<Array<TicketsTableRowCreateInput>>
}

export type TicketsTableRowCreateOneInlineInput = {
  /** Create and connect one TicketsTableRow document */
  create?: InputMaybe<TicketsTableRowCreateInput>
}

export type TicketsTableRowCreateWithPositionInput = {
  /** Document to create */
  data: TicketsTableRowCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type TicketsTableRowEdge = {
  __typename?: 'TicketsTableRowEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TicketsTableRow
}

/** Identifies documents */
export type TicketsTableRowManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TicketsTableRowWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TicketsTableRowWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TicketsTableRowWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  cells?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  cells_contains_all?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  cells_contains_none?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  cells_contains_some?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  cells_not?: InputMaybe<Array<Scalars['Boolean']['input']>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum TicketsTableRowOrderByInput {
  CellsAsc = 'cells_ASC',
  CellsDesc = 'cells_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  RowLabelAsc = 'rowLabel_ASC',
  RowLabelDesc = 'rowLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type TicketsTableRowParent = SectionTicketsTable

export type TicketsTableRowParentConnectInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableConnectInput>
}

export type TicketsTableRowParentCreateInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableCreateInput>
}

export type TicketsTableRowParentCreateManyInlineInput = {
  /** Create and connect multiple existing TicketsTableRowParent documents */
  create?: InputMaybe<Array<TicketsTableRowParentCreateInput>>
}

export type TicketsTableRowParentCreateOneInlineInput = {
  /** Create and connect one TicketsTableRowParent document */
  create?: InputMaybe<TicketsTableRowParentCreateInput>
}

export type TicketsTableRowParentCreateWithPositionInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableCreateWithPositionInput>
}

export type TicketsTableRowParentUpdateInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateInput>
}

export type TicketsTableRowParentUpdateManyInlineInput = {
  /** Create and connect multiple TicketsTableRowParent component instances */
  create?: InputMaybe<Array<TicketsTableRowParentCreateWithPositionInput>>
  /** Delete multiple TicketsTableRowParent documents */
  delete?: InputMaybe<Array<TicketsTableRowParentWhereUniqueInput>>
  /** Update multiple TicketsTableRowParent component instances */
  update?: InputMaybe<Array<TicketsTableRowParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple TicketsTableRowParent component instances */
  upsert?: InputMaybe<Array<TicketsTableRowParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type TicketsTableRowParentUpdateManyWithNestedWhereInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateManyWithNestedWhereInput>
}

export type TicketsTableRowParentUpdateOneInlineInput = {
  /** Create and connect one TicketsTableRowParent document */
  create?: InputMaybe<TicketsTableRowParentCreateInput>
  /** Delete currently connected TicketsTableRowParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TicketsTableRowParent document */
  update?: InputMaybe<TicketsTableRowParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single TicketsTableRowParent document */
  upsert?: InputMaybe<TicketsTableRowParentUpsertWithNestedWhereUniqueInput>
}

export type TicketsTableRowParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateWithNestedWhereUniqueAndPositionInput>
}

export type TicketsTableRowParentUpdateWithNestedWhereUniqueInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpdateWithNestedWhereUniqueInput>
}

export type TicketsTableRowParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpsertWithNestedWhereUniqueAndPositionInput>
}

export type TicketsTableRowParentUpsertWithNestedWhereUniqueInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableUpsertWithNestedWhereUniqueInput>
}

export type TicketsTableRowParentWhereInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableWhereInput>
}

export type TicketsTableRowParentWhereUniqueInput = {
  SectionTicketsTable?: InputMaybe<SectionTicketsTableWhereUniqueInput>
}

export type TicketsTableRowUpdateInput = {
  cells?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Manage document localizations */
  localizations?: InputMaybe<TicketsTableRowUpdateLocalizationsInput>
  /** rowLabel input for default locale (de) */
  rowLabel?: InputMaybe<Scalars['String']['input']>
}

export type TicketsTableRowUpdateLocalizationDataInput = {
  rowLabel?: InputMaybe<Scalars['String']['input']>
}

export type TicketsTableRowUpdateLocalizationInput = {
  data: TicketsTableRowUpdateLocalizationDataInput
  locale: Locale
}

export type TicketsTableRowUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TicketsTableRowCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TicketsTableRowUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TicketsTableRowUpsertLocalizationInput>>
}

export type TicketsTableRowUpdateManyInlineInput = {
  /** Create and connect multiple TicketsTableRow component instances */
  create?: InputMaybe<Array<TicketsTableRowCreateWithPositionInput>>
  /** Delete multiple TicketsTableRow documents */
  delete?: InputMaybe<Array<TicketsTableRowWhereUniqueInput>>
  /** Update multiple TicketsTableRow component instances */
  update?: InputMaybe<Array<TicketsTableRowUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple TicketsTableRow component instances */
  upsert?: InputMaybe<Array<TicketsTableRowUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type TicketsTableRowUpdateManyInput = {
  cells?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Optional updates to localizations */
  localizations?: InputMaybe<TicketsTableRowUpdateManyLocalizationsInput>
  /** rowLabel input for default locale (de) */
  rowLabel?: InputMaybe<Scalars['String']['input']>
}

export type TicketsTableRowUpdateManyLocalizationDataInput = {
  rowLabel?: InputMaybe<Scalars['String']['input']>
}

export type TicketsTableRowUpdateManyLocalizationInput = {
  data: TicketsTableRowUpdateManyLocalizationDataInput
  locale: Locale
}

export type TicketsTableRowUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TicketsTableRowUpdateManyLocalizationInput>>
}

export type TicketsTableRowUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TicketsTableRowUpdateManyInput
  /** Document search */
  where: TicketsTableRowWhereInput
}

export type TicketsTableRowUpdateOneInlineInput = {
  /** Create and connect one TicketsTableRow document */
  create?: InputMaybe<TicketsTableRowCreateInput>
  /** Delete currently connected TicketsTableRow document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TicketsTableRow document */
  update?: InputMaybe<TicketsTableRowUpdateWithNestedWhereUniqueInput>
  /** Upsert single TicketsTableRow document */
  upsert?: InputMaybe<TicketsTableRowUpsertWithNestedWhereUniqueInput>
}

export type TicketsTableRowUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TicketsTableRowUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TicketsTableRowWhereUniqueInput
}

export type TicketsTableRowUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TicketsTableRowUpdateInput
  /** Unique document search */
  where: TicketsTableRowWhereUniqueInput
}

export type TicketsTableRowUpsertInput = {
  /** Create document if it didn't exist */
  create: TicketsTableRowCreateInput
  /** Update document if it exists */
  update: TicketsTableRowUpdateInput
}

export type TicketsTableRowUpsertLocalizationInput = {
  create: TicketsTableRowCreateLocalizationDataInput
  locale: Locale
  update: TicketsTableRowUpdateLocalizationDataInput
}

export type TicketsTableRowUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TicketsTableRowUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TicketsTableRowWhereUniqueInput
}

export type TicketsTableRowUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TicketsTableRowUpsertInput
  /** Unique document search */
  where: TicketsTableRowWhereUniqueInput
}

/** Identifies documents */
export type TicketsTableRowWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TicketsTableRowWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TicketsTableRowWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TicketsTableRowWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  cells?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Matches if the field array contains *all* items provided to the filter */
  cells_contains_all?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Matches if the field array does not contain any of the items provided to the filter */
  cells_contains_none?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Matches if the field array contains at least one item provided to the filter */
  cells_contains_some?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  cells_not?: InputMaybe<Array<Scalars['Boolean']['input']>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  rowLabel?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  rowLabel_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  rowLabel_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  rowLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  rowLabel_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  rowLabel_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  rowLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  rowLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  rowLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  rowLabel_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References TicketsTableRow record uniquely */
export type TicketsTableRowWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum TimetableEventType {
  GuidedTour = 'GuidedTour',
  Masterclass = 'Masterclass',
  SideEvent = 'SideEvent',
}

export enum TimetableTabFilterTypes {
  Track = 'track',
  Type = 'type',
}

export enum TimetableViewModes {
  Grid = 'grid',
  List = 'list',
}

/** Heading level that generates the entries of a table of contents */
export enum TocHeaderLevel {
  HeadingFive = 'heading_five',
  HeadingFour = 'heading_four',
  HeadingOne = 'heading_one',
  HeadingSix = 'heading_six',
  HeadingThree = 'heading_three',
  HeadingTwo = 'heading_two',
}

/** Base model for all topic pages. */
export type TopicPage = Entity &
  Node & {
    __typename?: 'TopicPage'
    authors: Array<Author>
    categories: Array<TopicPageCategory>
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<TopicPage>
    glossaryRedirect: Array<Glossary>
    /** List of TopicPage versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Intro text displayed at the top of the page. */
    intro: RichText
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<TopicPage>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** Section list Content of the page. */
    sections: Array<TopicPageSection>
    /** Optional configuration if you want to have specific SEO Attributes. */
    seoAttributes?: Maybe<Seo>
    /** Unique identifier for the page used in the URL. */
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    /** Thumbnail image to be displayed when linking eg. on hompage */
    thumbnailImage: Asset
    /** Headline/Title of the page. */
    title: Scalars['String']['output']
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Base model for all topic pages. */
export type TopicPageAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<AuthorOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AuthorWhereInput>
}

/** Base model for all topic pages. */
export type TopicPageCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TopicPageCategoryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageCategoryWhereInput>
}

/** Base model for all topic pages. */
export type TopicPageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Base model for all topic pages. */
export type TopicPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Base model for all topic pages. */
export type TopicPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Base model for all topic pages. */
export type TopicPageGlossaryRedirectArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<GlossaryOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<GlossaryWhereInput>
}

/** Base model for all topic pages. */
export type TopicPageHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Base model for all topic pages. */
export type TopicPageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Base model for all topic pages. */
export type TopicPagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Base model for all topic pages. */
export type TopicPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Base model for all topic pages. */
export type TopicPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Base model for all topic pages. */
export type TopicPageSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TopicPageSectionOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageSectionWhereInput>
}

/** Base model for all topic pages. */
export type TopicPageSeoAttributesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Base model for all topic pages. */
export type TopicPageThumbnailImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
  where?: InputMaybe<AssetSingleRelationWhereInput>
}

/** Base model for all topic pages. */
export type TopicPageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Base model for all topic pages. */
export type TopicPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Topc page category */
export type TopicPageCategory = Entity &
  Node & {
    __typename?: 'TopicPageCategory'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<TopicPageCategory>
    /** List of TopicPageCategory versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** System Locale field */
    locale: Locale
    /** Get the other localizations for this document */
    localizations: Array<TopicPageCategory>
    name: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    slug: Scalars['String']['output']
    /** System stage field */
    stage: Stage
    topicPages: Array<TopicPage>
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** Topc page category */
export type TopicPageCategoryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Topc page category */
export type TopicPageCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Topc page category */
export type TopicPageCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** Topc page category */
export type TopicPageCategoryHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** Topc page category */
export type TopicPageCategoryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Topc page category */
export type TopicPageCategoryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Topc page category */
export type TopicPageCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** Topc page category */
export type TopicPageCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** Topc page category */
export type TopicPageCategoryTopicPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  orderBy?: InputMaybe<TopicPageOrderByInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<TopicPageWhereInput>
}

/** Topc page category */
export type TopicPageCategoryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

/** Topc page category */
export type TopicPageCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type TopicPageCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TopicPageCategoryWhereUniqueInput
}

/** A connection to a list of items. */
export type TopicPageCategoryConnection = {
  __typename?: 'TopicPageCategoryConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TopicPageCategoryEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TopicPageCategoryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TopicPageCategoryCreateLocalizationsInput>
  /** name input for default locale (de) */
  name: Scalars['String']['input']
  /** slug input for default locale (de) */
  slug: Scalars['String']['input']
  topicPages?: InputMaybe<TopicPageCreateManyInlineInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TopicPageCategoryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TopicPageCategoryCreateLocalizationInput = {
  /** Localization input */
  data: TopicPageCategoryCreateLocalizationDataInput
  locale: Locale
}

export type TopicPageCategoryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TopicPageCategoryCreateLocalizationInput>>
}

export type TopicPageCategoryCreateManyInlineInput = {
  /** Connect multiple existing TopicPageCategory documents */
  connect?: InputMaybe<Array<TopicPageCategoryWhereUniqueInput>>
  /** Create and connect multiple existing TopicPageCategory documents */
  create?: InputMaybe<Array<TopicPageCategoryCreateInput>>
}

export type TopicPageCategoryCreateOneInlineInput = {
  /** Connect one existing TopicPageCategory document */
  connect?: InputMaybe<TopicPageCategoryWhereUniqueInput>
  /** Create and connect one TopicPageCategory document */
  create?: InputMaybe<TopicPageCategoryCreateInput>
}

/** An edge in a connection. */
export type TopicPageCategoryEdge = {
  __typename?: 'TopicPageCategoryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TopicPageCategory
}

/** Identifies documents */
export type TopicPageCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TopicPageCategoryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TopicPageCategoryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TopicPageCategoryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<TopicPageCategoryWhereStageInput>
  documentInStages_none?: InputMaybe<TopicPageCategoryWhereStageInput>
  documentInStages_some?: InputMaybe<TopicPageCategoryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  topicPages_every?: InputMaybe<TopicPageWhereInput>
  topicPages_none?: InputMaybe<TopicPageWhereInput>
  topicPages_some?: InputMaybe<TopicPageWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum TopicPageCategoryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type TopicPageCategoryUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<TopicPageCategoryUpdateLocalizationsInput>
  /** name input for default locale (de) */
  name?: InputMaybe<Scalars['String']['input']>
  /** slug input for default locale (de) */
  slug?: InputMaybe<Scalars['String']['input']>
  topicPages?: InputMaybe<TopicPageUpdateManyInlineInput>
}

export type TopicPageCategoryUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageCategoryUpdateLocalizationInput = {
  data: TopicPageCategoryUpdateLocalizationDataInput
  locale: Locale
}

export type TopicPageCategoryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TopicPageCategoryCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TopicPageCategoryUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TopicPageCategoryUpsertLocalizationInput>>
}

export type TopicPageCategoryUpdateManyInlineInput = {
  /** Connect multiple existing TopicPageCategory documents */
  connect?: InputMaybe<Array<TopicPageCategoryConnectInput>>
  /** Create and connect multiple TopicPageCategory documents */
  create?: InputMaybe<Array<TopicPageCategoryCreateInput>>
  /** Delete multiple TopicPageCategory documents */
  delete?: InputMaybe<Array<TopicPageCategoryWhereUniqueInput>>
  /** Disconnect multiple TopicPageCategory documents */
  disconnect?: InputMaybe<Array<TopicPageCategoryWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing TopicPageCategory documents */
  set?: InputMaybe<Array<TopicPageCategoryWhereUniqueInput>>
  /** Update multiple TopicPageCategory documents */
  update?: InputMaybe<Array<TopicPageCategoryUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple TopicPageCategory documents */
  upsert?: InputMaybe<Array<TopicPageCategoryUpsertWithNestedWhereUniqueInput>>
}

export type TopicPageCategoryUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TopicPageCategoryUpdateManyInput
  /** Document search */
  where: TopicPageCategoryWhereInput
}

export type TopicPageCategoryUpdateOneInlineInput = {
  /** Connect existing TopicPageCategory document */
  connect?: InputMaybe<TopicPageCategoryWhereUniqueInput>
  /** Create and connect one TopicPageCategory document */
  create?: InputMaybe<TopicPageCategoryCreateInput>
  /** Delete currently connected TopicPageCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected TopicPageCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TopicPageCategory document */
  update?: InputMaybe<TopicPageCategoryUpdateWithNestedWhereUniqueInput>
  /** Upsert single TopicPageCategory document */
  upsert?: InputMaybe<TopicPageCategoryUpsertWithNestedWhereUniqueInput>
}

export type TopicPageCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TopicPageCategoryUpdateInput
  /** Unique document search */
  where: TopicPageCategoryWhereUniqueInput
}

export type TopicPageCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: TopicPageCategoryCreateInput
  /** Update document if it exists */
  update: TopicPageCategoryUpdateInput
}

export type TopicPageCategoryUpsertLocalizationInput = {
  create: TopicPageCategoryCreateLocalizationDataInput
  locale: Locale
  update: TopicPageCategoryUpdateLocalizationDataInput
}

export type TopicPageCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TopicPageCategoryUpsertInput
  /** Unique document search */
  where: TopicPageCategoryWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type TopicPageCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type TopicPageCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TopicPageCategoryWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TopicPageCategoryWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TopicPageCategoryWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<TopicPageCategoryWhereStageInput>
  documentInStages_none?: InputMaybe<TopicPageCategoryWhereStageInput>
  documentInStages_some?: InputMaybe<TopicPageCategoryWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  topicPages_every?: InputMaybe<TopicPageWhereInput>
  topicPages_none?: InputMaybe<TopicPageWhereInput>
  topicPages_some?: InputMaybe<TopicPageWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TopicPageCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TopicPageCategoryWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TopicPageCategoryWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TopicPageCategoryWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TopicPageCategoryWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References TopicPageCategory record uniquely */
export type TopicPageCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type TopicPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TopicPageWhereUniqueInput
}

/** A connection to a list of items. */
export type TopicPageConnection = {
  __typename?: 'TopicPageConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TopicPageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TopicPageCreateInput = {
  authors: AuthorCreateManyInlineInput
  categories: TopicPageCategoryCreateManyInlineInput
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  glossaryRedirect?: InputMaybe<GlossaryCreateManyInlineInput>
  /** intro input for default locale (de) */
  intro: Scalars['RichTextAST']['input']
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TopicPageCreateLocalizationsInput>
  sections?: InputMaybe<TopicPageSectionCreateManyInlineInput>
  seoAttributes?: InputMaybe<SeoCreateOneInlineInput>
  /** slug input for default locale (de) */
  slug: Scalars['String']['input']
  thumbnailImage: AssetCreateOneInlineInput
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TopicPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  intro: Scalars['RichTextAST']['input']
  slug: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TopicPageCreateLocalizationInput = {
  /** Localization input */
  data: TopicPageCreateLocalizationDataInput
  locale: Locale
}

export type TopicPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TopicPageCreateLocalizationInput>>
}

export type TopicPageCreateManyInlineInput = {
  /** Connect multiple existing TopicPage documents */
  connect?: InputMaybe<Array<TopicPageWhereUniqueInput>>
  /** Create and connect multiple existing TopicPage documents */
  create?: InputMaybe<Array<TopicPageCreateInput>>
}

export type TopicPageCreateOneInlineInput = {
  /** Connect one existing TopicPage document */
  connect?: InputMaybe<TopicPageWhereUniqueInput>
  /** Create and connect one TopicPage document */
  create?: InputMaybe<TopicPageCreateInput>
}

/** An edge in a connection. */
export type TopicPageEdge = {
  __typename?: 'TopicPageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TopicPage
}

/** Identifies documents */
export type TopicPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TopicPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TopicPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TopicPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  authors_every?: InputMaybe<AuthorWhereInput>
  authors_none?: InputMaybe<AuthorWhereInput>
  authors_some?: InputMaybe<AuthorWhereInput>
  categories_every?: InputMaybe<TopicPageCategoryWhereInput>
  categories_none?: InputMaybe<TopicPageCategoryWhereInput>
  categories_some?: InputMaybe<TopicPageCategoryWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<TopicPageWhereStageInput>
  documentInStages_none?: InputMaybe<TopicPageWhereStageInput>
  documentInStages_some?: InputMaybe<TopicPageWhereStageInput>
  glossaryRedirect_every?: InputMaybe<GlossaryWhereInput>
  glossaryRedirect_none?: InputMaybe<GlossaryWhereInput>
  glossaryRedirect_some?: InputMaybe<GlossaryWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  sections_every?: InputMaybe<TopicPageSectionWhereInput>
  sections_none?: InputMaybe<TopicPageSectionWhereInput>
  sections_some?: InputMaybe<TopicPageSectionWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  thumbnailImage?: InputMaybe<AssetWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum TopicPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Section component for topic pages. */
export type TopicPageSection = Entity & {
  __typename?: 'TopicPageSection'
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Content structure build upon multiple content components such as richt text, references, etc. */
  layout: Array<TopicPageSectionlayoutUnion>
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<TopicPageSection>
  /** System stage field */
  stage: Stage
  /** Title/headline leading each section. Also used for generating table of content entries. */
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Section component for topic pages. */
export type TopicPageSectionLayoutArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
}

/** Section component for topic pages. */
export type TopicPageSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

/** Section component for topic pages. */
export type TopicPageSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type TopicPageSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: TopicPageSectionWhereUniqueInput
}

/** A connection to a list of items. */
export type TopicPageSectionConnection = {
  __typename?: 'TopicPageSectionConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<TopicPageSectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type TopicPageSectionCreateInput = {
  layout?: InputMaybe<TopicPageSectionlayoutUnionCreateManyInlineInput>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TopicPageSectionCreateLocalizationsInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TopicPageSectionCreateLocalizationDataInput = {
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TopicPageSectionCreateLocalizationInput = {
  /** Localization input */
  data: TopicPageSectionCreateLocalizationDataInput
  locale: Locale
}

export type TopicPageSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TopicPageSectionCreateLocalizationInput>>
}

export type TopicPageSectionCreateManyInlineInput = {
  /** Create and connect multiple existing TopicPageSection documents */
  create?: InputMaybe<Array<TopicPageSectionCreateInput>>
}

export type TopicPageSectionCreateOneInlineInput = {
  /** Create and connect one TopicPageSection document */
  create?: InputMaybe<TopicPageSectionCreateInput>
}

export type TopicPageSectionCreateWithPositionInput = {
  /** Document to create */
  data: TopicPageSectionCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type TopicPageSectionEdge = {
  __typename?: 'TopicPageSectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: TopicPageSection
}

/** Identifies documents */
export type TopicPageSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TopicPageSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TopicPageSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TopicPageSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty. */
  layout_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  layout_some?: InputMaybe<TopicPageSectionlayoutUnionWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum TopicPageSectionOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type TopicPageSectionParent = TopicPage

export type TopicPageSectionParentConnectInput = {
  TopicPage?: InputMaybe<TopicPageConnectInput>
}

export type TopicPageSectionParentCreateInput = {
  TopicPage?: InputMaybe<TopicPageCreateInput>
}

export type TopicPageSectionParentCreateManyInlineInput = {
  /** Connect multiple existing TopicPageSectionParent documents */
  connect?: InputMaybe<Array<TopicPageSectionParentWhereUniqueInput>>
  /** Create and connect multiple existing TopicPageSectionParent documents */
  create?: InputMaybe<Array<TopicPageSectionParentCreateInput>>
}

export type TopicPageSectionParentCreateOneInlineInput = {
  /** Connect one existing TopicPageSectionParent document */
  connect?: InputMaybe<TopicPageSectionParentWhereUniqueInput>
  /** Create and connect one TopicPageSectionParent document */
  create?: InputMaybe<TopicPageSectionParentCreateInput>
}

export type TopicPageSectionParentUpdateInput = {
  TopicPage?: InputMaybe<TopicPageUpdateInput>
}

export type TopicPageSectionParentUpdateManyInlineInput = {
  /** Connect multiple existing TopicPageSectionParent documents */
  connect?: InputMaybe<Array<TopicPageSectionParentConnectInput>>
  /** Create and connect multiple TopicPageSectionParent documents */
  create?: InputMaybe<Array<TopicPageSectionParentCreateInput>>
  /** Delete multiple TopicPageSectionParent documents */
  delete?: InputMaybe<Array<TopicPageSectionParentWhereUniqueInput>>
  /** Disconnect multiple TopicPageSectionParent documents */
  disconnect?: InputMaybe<Array<TopicPageSectionParentWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing TopicPageSectionParent documents */
  set?: InputMaybe<Array<TopicPageSectionParentWhereUniqueInput>>
  /** Update multiple TopicPageSectionParent documents */
  update?: InputMaybe<Array<TopicPageSectionParentUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple TopicPageSectionParent documents */
  upsert?: InputMaybe<Array<TopicPageSectionParentUpsertWithNestedWhereUniqueInput>>
}

export type TopicPageSectionParentUpdateManyWithNestedWhereInput = {
  TopicPage?: InputMaybe<TopicPageUpdateManyWithNestedWhereInput>
}

export type TopicPageSectionParentUpdateOneInlineInput = {
  /** Connect existing TopicPageSectionParent document */
  connect?: InputMaybe<TopicPageSectionParentWhereUniqueInput>
  /** Create and connect one TopicPageSectionParent document */
  create?: InputMaybe<TopicPageSectionParentCreateInput>
  /** Delete currently connected TopicPageSectionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected TopicPageSectionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TopicPageSectionParent document */
  update?: InputMaybe<TopicPageSectionParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single TopicPageSectionParent document */
  upsert?: InputMaybe<TopicPageSectionParentUpsertWithNestedWhereUniqueInput>
}

export type TopicPageSectionParentUpdateWithNestedWhereUniqueInput = {
  TopicPage?: InputMaybe<TopicPageUpdateWithNestedWhereUniqueInput>
}

export type TopicPageSectionParentUpsertWithNestedWhereUniqueInput = {
  TopicPage?: InputMaybe<TopicPageUpsertWithNestedWhereUniqueInput>
}

export type TopicPageSectionParentWhereInput = {
  TopicPage?: InputMaybe<TopicPageWhereInput>
}

export type TopicPageSectionParentWhereUniqueInput = {
  TopicPage?: InputMaybe<TopicPageWhereUniqueInput>
}

export type TopicPageSectionUpdateInput = {
  layout?: InputMaybe<TopicPageSectionlayoutUnionUpdateManyInlineInput>
  /** Manage document localizations */
  localizations?: InputMaybe<TopicPageSectionUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageSectionUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageSectionUpdateLocalizationInput = {
  data: TopicPageSectionUpdateLocalizationDataInput
  locale: Locale
}

export type TopicPageSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TopicPageSectionCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TopicPageSectionUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TopicPageSectionUpsertLocalizationInput>>
}

export type TopicPageSectionUpdateManyInlineInput = {
  /** Create and connect multiple TopicPageSection component instances */
  create?: InputMaybe<Array<TopicPageSectionCreateWithPositionInput>>
  /** Delete multiple TopicPageSection documents */
  delete?: InputMaybe<Array<TopicPageSectionWhereUniqueInput>>
  /** Update multiple TopicPageSection component instances */
  update?: InputMaybe<Array<TopicPageSectionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple TopicPageSection component instances */
  upsert?: InputMaybe<Array<TopicPageSectionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type TopicPageSectionUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<TopicPageSectionUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageSectionUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageSectionUpdateManyLocalizationInput = {
  data: TopicPageSectionUpdateManyLocalizationDataInput
  locale: Locale
}

export type TopicPageSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TopicPageSectionUpdateManyLocalizationInput>>
}

export type TopicPageSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TopicPageSectionUpdateManyInput
  /** Document search */
  where: TopicPageSectionWhereInput
}

export type TopicPageSectionUpdateOneInlineInput = {
  /** Create and connect one TopicPageSection document */
  create?: InputMaybe<TopicPageSectionCreateInput>
  /** Delete currently connected TopicPageSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TopicPageSection document */
  update?: InputMaybe<TopicPageSectionUpdateWithNestedWhereUniqueInput>
  /** Upsert single TopicPageSection document */
  upsert?: InputMaybe<TopicPageSectionUpsertWithNestedWhereUniqueInput>
}

export type TopicPageSectionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TopicPageSectionUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TopicPageSectionWhereUniqueInput
}

export type TopicPageSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TopicPageSectionUpdateInput
  /** Unique document search */
  where: TopicPageSectionWhereUniqueInput
}

export type TopicPageSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: TopicPageSectionCreateInput
  /** Update document if it exists */
  update: TopicPageSectionUpdateInput
}

export type TopicPageSectionUpsertLocalizationInput = {
  create: TopicPageSectionCreateLocalizationDataInput
  locale: Locale
  update: TopicPageSectionUpdateLocalizationDataInput
}

export type TopicPageSectionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TopicPageSectionUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: TopicPageSectionWhereUniqueInput
}

export type TopicPageSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TopicPageSectionUpsertInput
  /** Unique document search */
  where: TopicPageSectionWhereUniqueInput
}

/** Identifies documents */
export type TopicPageSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TopicPageSectionWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TopicPageSectionWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TopicPageSectionWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values in which the union is empty. */
  layout_empty?: InputMaybe<Scalars['Boolean']['input']>
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  layout_some?: InputMaybe<TopicPageSectionlayoutUnionWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** References TopicPageSection record uniquely */
export type TopicPageSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type TopicPageSectionlayoutUnion = RichContent | RichTextMedia | SectionCollapsedRichContent | SectionContentReference | SectionQuote

export type TopicPageSectionlayoutUnionConnectInput = {
  RichContent?: InputMaybe<RichContentConnectInput>
  RichTextMedia?: InputMaybe<RichTextMediaConnectInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentConnectInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceConnectInput>
  SectionQuote?: InputMaybe<SectionQuoteConnectInput>
}

export type TopicPageSectionlayoutUnionCreateInput = {
  RichContent?: InputMaybe<RichContentCreateInput>
  RichTextMedia?: InputMaybe<RichTextMediaCreateInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentCreateInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceCreateInput>
  SectionQuote?: InputMaybe<SectionQuoteCreateInput>
}

export type TopicPageSectionlayoutUnionCreateManyInlineInput = {
  /** Create and connect multiple existing TopicPageSectionlayoutUnion documents */
  create?: InputMaybe<Array<TopicPageSectionlayoutUnionCreateInput>>
}

export type TopicPageSectionlayoutUnionCreateOneInlineInput = {
  /** Create and connect one TopicPageSectionlayoutUnion document */
  create?: InputMaybe<TopicPageSectionlayoutUnionCreateInput>
}

export type TopicPageSectionlayoutUnionCreateWithPositionInput = {
  RichContent?: InputMaybe<RichContentCreateWithPositionInput>
  RichTextMedia?: InputMaybe<RichTextMediaCreateWithPositionInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentCreateWithPositionInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceCreateWithPositionInput>
  SectionQuote?: InputMaybe<SectionQuoteCreateWithPositionInput>
}

export type TopicPageSectionlayoutUnionUpdateInput = {
  RichContent?: InputMaybe<RichContentUpdateInput>
  RichTextMedia?: InputMaybe<RichTextMediaUpdateInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentUpdateInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceUpdateInput>
  SectionQuote?: InputMaybe<SectionQuoteUpdateInput>
}

export type TopicPageSectionlayoutUnionUpdateManyInlineInput = {
  /** Create and connect multiple TopicPageSectionlayoutUnion component instances */
  create?: InputMaybe<Array<TopicPageSectionlayoutUnionCreateWithPositionInput>>
  /** Delete multiple TopicPageSectionlayoutUnion documents */
  delete?: InputMaybe<Array<TopicPageSectionlayoutUnionWhereUniqueInput>>
  /** Update multiple TopicPageSectionlayoutUnion component instances */
  update?: InputMaybe<Array<TopicPageSectionlayoutUnionUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple TopicPageSectionlayoutUnion component instances */
  upsert?: InputMaybe<Array<TopicPageSectionlayoutUnionUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type TopicPageSectionlayoutUnionUpdateManyWithNestedWhereInput = {
  RichContent?: InputMaybe<RichContentUpdateManyWithNestedWhereInput>
  RichTextMedia?: InputMaybe<RichTextMediaUpdateManyWithNestedWhereInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentUpdateManyWithNestedWhereInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceUpdateManyWithNestedWhereInput>
  SectionQuote?: InputMaybe<SectionQuoteUpdateManyWithNestedWhereInput>
}

export type TopicPageSectionlayoutUnionUpdateOneInlineInput = {
  /** Create and connect one TopicPageSectionlayoutUnion document */
  create?: InputMaybe<TopicPageSectionlayoutUnionCreateInput>
  /** Delete currently connected TopicPageSectionlayoutUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TopicPageSectionlayoutUnion document */
  update?: InputMaybe<TopicPageSectionlayoutUnionUpdateWithNestedWhereUniqueInput>
  /** Upsert single TopicPageSectionlayoutUnion document */
  upsert?: InputMaybe<TopicPageSectionlayoutUnionUpsertWithNestedWhereUniqueInput>
}

export type TopicPageSectionlayoutUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  RichContent?: InputMaybe<RichContentUpdateWithNestedWhereUniqueAndPositionInput>
  RichTextMedia?: InputMaybe<RichTextMediaUpdateWithNestedWhereUniqueAndPositionInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentUpdateWithNestedWhereUniqueAndPositionInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceUpdateWithNestedWhereUniqueAndPositionInput>
  SectionQuote?: InputMaybe<SectionQuoteUpdateWithNestedWhereUniqueAndPositionInput>
}

export type TopicPageSectionlayoutUnionUpdateWithNestedWhereUniqueInput = {
  RichContent?: InputMaybe<RichContentUpdateWithNestedWhereUniqueInput>
  RichTextMedia?: InputMaybe<RichTextMediaUpdateWithNestedWhereUniqueInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentUpdateWithNestedWhereUniqueInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceUpdateWithNestedWhereUniqueInput>
  SectionQuote?: InputMaybe<SectionQuoteUpdateWithNestedWhereUniqueInput>
}

export type TopicPageSectionlayoutUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  RichContent?: InputMaybe<RichContentUpsertWithNestedWhereUniqueAndPositionInput>
  RichTextMedia?: InputMaybe<RichTextMediaUpsertWithNestedWhereUniqueAndPositionInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentUpsertWithNestedWhereUniqueAndPositionInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceUpsertWithNestedWhereUniqueAndPositionInput>
  SectionQuote?: InputMaybe<SectionQuoteUpsertWithNestedWhereUniqueAndPositionInput>
}

export type TopicPageSectionlayoutUnionUpsertWithNestedWhereUniqueInput = {
  RichContent?: InputMaybe<RichContentUpsertWithNestedWhereUniqueInput>
  RichTextMedia?: InputMaybe<RichTextMediaUpsertWithNestedWhereUniqueInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentUpsertWithNestedWhereUniqueInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceUpsertWithNestedWhereUniqueInput>
  SectionQuote?: InputMaybe<SectionQuoteUpsertWithNestedWhereUniqueInput>
}

export type TopicPageSectionlayoutUnionWhereInput = {
  RichContent?: InputMaybe<RichContentWhereInput>
  RichTextMedia?: InputMaybe<RichTextMediaWhereInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentWhereInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceWhereInput>
  SectionQuote?: InputMaybe<SectionQuoteWhereInput>
}

export type TopicPageSectionlayoutUnionWhereUniqueInput = {
  RichContent?: InputMaybe<RichContentWhereUniqueInput>
  RichTextMedia?: InputMaybe<RichTextMediaWhereUniqueInput>
  SectionCollapsedRichContent?: InputMaybe<SectionCollapsedRichContentWhereUniqueInput>
  SectionContentReference?: InputMaybe<SectionContentReferenceWhereUniqueInput>
  SectionQuote?: InputMaybe<SectionQuoteWhereUniqueInput>
}

export type TopicPageUpdateInput = {
  authors?: InputMaybe<AuthorUpdateManyInlineInput>
  categories?: InputMaybe<TopicPageCategoryUpdateManyInlineInput>
  glossaryRedirect?: InputMaybe<GlossaryUpdateManyInlineInput>
  /** intro input for default locale (de) */
  intro?: InputMaybe<Scalars['RichTextAST']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<TopicPageUpdateLocalizationsInput>
  sections?: InputMaybe<TopicPageSectionUpdateManyInlineInput>
  seoAttributes?: InputMaybe<SeoUpdateOneInlineInput>
  /** slug input for default locale (de) */
  slug?: InputMaybe<Scalars['String']['input']>
  thumbnailImage?: InputMaybe<AssetUpdateOneInlineInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageUpdateLocalizationDataInput = {
  intro?: InputMaybe<Scalars['RichTextAST']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageUpdateLocalizationInput = {
  data: TopicPageUpdateLocalizationDataInput
  locale: Locale
}

export type TopicPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TopicPageCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<TopicPageUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<TopicPageUpsertLocalizationInput>>
}

export type TopicPageUpdateManyInlineInput = {
  /** Connect multiple existing TopicPage documents */
  connect?: InputMaybe<Array<TopicPageConnectInput>>
  /** Create and connect multiple TopicPage documents */
  create?: InputMaybe<Array<TopicPageCreateInput>>
  /** Delete multiple TopicPage documents */
  delete?: InputMaybe<Array<TopicPageWhereUniqueInput>>
  /** Disconnect multiple TopicPage documents */
  disconnect?: InputMaybe<Array<TopicPageWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing TopicPage documents */
  set?: InputMaybe<Array<TopicPageWhereUniqueInput>>
  /** Update multiple TopicPage documents */
  update?: InputMaybe<Array<TopicPageUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple TopicPage documents */
  upsert?: InputMaybe<Array<TopicPageUpsertWithNestedWhereUniqueInput>>
}

export type TopicPageUpdateManyInput = {
  /** intro input for default locale (de) */
  intro?: InputMaybe<Scalars['RichTextAST']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<TopicPageUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageUpdateManyLocalizationDataInput = {
  intro?: InputMaybe<Scalars['RichTextAST']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TopicPageUpdateManyLocalizationInput = {
  data: TopicPageUpdateManyLocalizationDataInput
  locale: Locale
}

export type TopicPageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TopicPageUpdateManyLocalizationInput>>
}

export type TopicPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TopicPageUpdateManyInput
  /** Document search */
  where: TopicPageWhereInput
}

export type TopicPageUpdateOneInlineInput = {
  /** Connect existing TopicPage document */
  connect?: InputMaybe<TopicPageWhereUniqueInput>
  /** Create and connect one TopicPage document */
  create?: InputMaybe<TopicPageCreateInput>
  /** Delete currently connected TopicPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected TopicPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single TopicPage document */
  update?: InputMaybe<TopicPageUpdateWithNestedWhereUniqueInput>
  /** Upsert single TopicPage document */
  upsert?: InputMaybe<TopicPageUpsertWithNestedWhereUniqueInput>
}

export type TopicPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TopicPageUpdateInput
  /** Unique document search */
  where: TopicPageWhereUniqueInput
}

export type TopicPageUpsertInput = {
  /** Create document if it didn't exist */
  create: TopicPageCreateInput
  /** Update document if it exists */
  update: TopicPageUpdateInput
}

export type TopicPageUpsertLocalizationInput = {
  create: TopicPageCreateLocalizationDataInput
  locale: Locale
  update: TopicPageUpdateLocalizationDataInput
}

export type TopicPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TopicPageUpsertInput
  /** Unique document search */
  where: TopicPageWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type TopicPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type TopicPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TopicPageWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TopicPageWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TopicPageWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  authors_every?: InputMaybe<AuthorWhereInput>
  authors_none?: InputMaybe<AuthorWhereInput>
  authors_some?: InputMaybe<AuthorWhereInput>
  categories_every?: InputMaybe<TopicPageCategoryWhereInput>
  categories_none?: InputMaybe<TopicPageCategoryWhereInput>
  categories_some?: InputMaybe<TopicPageCategoryWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<TopicPageWhereStageInput>
  documentInStages_none?: InputMaybe<TopicPageWhereStageInput>
  documentInStages_some?: InputMaybe<TopicPageWhereStageInput>
  glossaryRedirect_every?: InputMaybe<GlossaryWhereInput>
  glossaryRedirect_none?: InputMaybe<GlossaryWhereInput>
  glossaryRedirect_some?: InputMaybe<GlossaryWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  sections_every?: InputMaybe<TopicPageSectionWhereInput>
  sections_none?: InputMaybe<TopicPageSectionWhereInput>
  sections_some?: InputMaybe<TopicPageSectionWhereInput>
  seoAttributes?: InputMaybe<SeoWhereInput>
  slug?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>
  thumbnailImage?: InputMaybe<AssetWhereInput>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TopicPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TopicPageWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TopicPageWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TopicPageWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TopicPageWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References TopicPage record uniquely */
export type TopicPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpy = RecommendationFood | RecommendationNightOut

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyConnectInput = {
  RecommendationFood?: InputMaybe<RecommendationFoodConnectInput>
  RecommendationNightOut?: InputMaybe<RecommendationNightOutConnectInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyCreateInput = {
  RecommendationFood?: InputMaybe<RecommendationFoodCreateInput>
  RecommendationNightOut?: InputMaybe<RecommendationNightOutCreateInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyCreateManyInlineInput = {
  /** Connect multiple existing Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  connect?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereUniqueInput>>
  /** Create and connect multiple existing Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  create?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyCreateInput>>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyCreateOneInlineInput = {
  /** Connect one existing Union_recommendations_clgkwf1vg03eq01ug96koewpy document */
  connect?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereUniqueInput>
  /** Create and connect one Union_recommendations_clgkwf1vg03eq01ug96koewpy document */
  create?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyCreateInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpdateInput = {
  RecommendationFood?: InputMaybe<RecommendationFoodUpdateInput>
  RecommendationNightOut?: InputMaybe<RecommendationNightOutUpdateInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpdateManyInlineInput = {
  /** Connect multiple existing Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  connect?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyConnectInput>>
  /** Create and connect multiple Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  create?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyCreateInput>>
  /** Delete multiple Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  delete?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereUniqueInput>>
  /** Disconnect multiple Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  disconnect?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  set?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereUniqueInput>>
  /** Update multiple Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  update?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Union_recommendations_clgkwf1vg03eq01ug96koewpy documents */
  upsert?: InputMaybe<Array<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpsertWithNestedWhereUniqueInput>>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpdateManyWithNestedWhereInput = {
  RecommendationFood?: InputMaybe<RecommendationFoodUpdateManyWithNestedWhereInput>
  RecommendationNightOut?: InputMaybe<RecommendationNightOutUpdateManyWithNestedWhereInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpdateOneInlineInput = {
  /** Connect existing Union_recommendations_clgkwf1vg03eq01ug96koewpy document */
  connect?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereUniqueInput>
  /** Create and connect one Union_recommendations_clgkwf1vg03eq01ug96koewpy document */
  create?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyCreateInput>
  /** Delete currently connected Union_recommendations_clgkwf1vg03eq01ug96koewpy document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Union_recommendations_clgkwf1vg03eq01ug96koewpy document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Union_recommendations_clgkwf1vg03eq01ug96koewpy document */
  update?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpdateWithNestedWhereUniqueInput>
  /** Upsert single Union_recommendations_clgkwf1vg03eq01ug96koewpy document */
  upsert?: InputMaybe<Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpsertWithNestedWhereUniqueInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpdateWithNestedWhereUniqueInput = {
  RecommendationFood?: InputMaybe<RecommendationFoodUpdateWithNestedWhereUniqueInput>
  RecommendationNightOut?: InputMaybe<RecommendationNightOutUpdateWithNestedWhereUniqueInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyUpsertWithNestedWhereUniqueInput = {
  RecommendationFood?: InputMaybe<RecommendationFoodUpsertWithNestedWhereUniqueInput>
  RecommendationNightOut?: InputMaybe<RecommendationNightOutUpsertWithNestedWhereUniqueInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereInput = {
  RecommendationFood?: InputMaybe<RecommendationFoodWhereInput>
  RecommendationNightOut?: InputMaybe<RecommendationNightOutWhereInput>
}

export type Union_Recommendations_Clgkwf1vg03eq01ug96koewpyWhereUniqueInput = {
  RecommendationFood?: InputMaybe<RecommendationFoodWhereUniqueInput>
  RecommendationNightOut?: InputMaybe<RecommendationNightOutWhereUniqueInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9z = EducationReport | EducationSeminar | HubContentEntry

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zConnectInput = {
  EducationReport?: InputMaybe<EducationReportConnectInput>
  EducationSeminar?: InputMaybe<EducationSeminarConnectInput>
  HubContentEntry?: InputMaybe<HubContentEntryConnectInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zCreateInput = {
  EducationReport?: InputMaybe<EducationReportCreateInput>
  EducationSeminar?: InputMaybe<EducationSeminarCreateInput>
  HubContentEntry?: InputMaybe<HubContentEntryCreateInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zCreateManyInlineInput = {
  /** Connect multiple existing Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  connect?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereUniqueInput>>
  /** Create and connect multiple existing Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  create?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zCreateInput>>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zCreateOneInlineInput = {
  /** Connect one existing Union_reference_cmbs1lgxn0j0907te5p4aay9z document */
  connect?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereUniqueInput>
  /** Create and connect one Union_reference_cmbs1lgxn0j0907te5p4aay9z document */
  create?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zCreateInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpdateInput = {
  EducationReport?: InputMaybe<EducationReportUpdateInput>
  EducationSeminar?: InputMaybe<EducationSeminarUpdateInput>
  HubContentEntry?: InputMaybe<HubContentEntryUpdateInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpdateManyInlineInput = {
  /** Connect multiple existing Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  connect?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zConnectInput>>
  /** Create and connect multiple Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  create?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zCreateInput>>
  /** Delete multiple Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  delete?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereUniqueInput>>
  /** Disconnect multiple Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  disconnect?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  set?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereUniqueInput>>
  /** Update multiple Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  update?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Union_reference_cmbs1lgxn0j0907te5p4aay9z documents */
  upsert?: InputMaybe<Array<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpsertWithNestedWhereUniqueInput>>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpdateManyWithNestedWhereInput = {
  EducationReport?: InputMaybe<EducationReportUpdateManyWithNestedWhereInput>
  EducationSeminar?: InputMaybe<EducationSeminarUpdateManyWithNestedWhereInput>
  HubContentEntry?: InputMaybe<HubContentEntryUpdateManyWithNestedWhereInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpdateOneInlineInput = {
  /** Connect existing Union_reference_cmbs1lgxn0j0907te5p4aay9z document */
  connect?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereUniqueInput>
  /** Create and connect one Union_reference_cmbs1lgxn0j0907te5p4aay9z document */
  create?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zCreateInput>
  /** Delete currently connected Union_reference_cmbs1lgxn0j0907te5p4aay9z document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Union_reference_cmbs1lgxn0j0907te5p4aay9z document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Union_reference_cmbs1lgxn0j0907te5p4aay9z document */
  update?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpdateWithNestedWhereUniqueInput>
  /** Upsert single Union_reference_cmbs1lgxn0j0907te5p4aay9z document */
  upsert?: InputMaybe<Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpsertWithNestedWhereUniqueInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpdateWithNestedWhereUniqueInput = {
  EducationReport?: InputMaybe<EducationReportUpdateWithNestedWhereUniqueInput>
  EducationSeminar?: InputMaybe<EducationSeminarUpdateWithNestedWhereUniqueInput>
  HubContentEntry?: InputMaybe<HubContentEntryUpdateWithNestedWhereUniqueInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zUpsertWithNestedWhereUniqueInput = {
  EducationReport?: InputMaybe<EducationReportUpsertWithNestedWhereUniqueInput>
  EducationSeminar?: InputMaybe<EducationSeminarUpsertWithNestedWhereUniqueInput>
  HubContentEntry?: InputMaybe<HubContentEntryUpsertWithNestedWhereUniqueInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereInput = {
  EducationReport?: InputMaybe<EducationReportWhereInput>
  EducationSeminar?: InputMaybe<EducationSeminarWhereInput>
  HubContentEntry?: InputMaybe<HubContentEntryWhereInput>
}

export type Union_Reference_Cmbs1lgxn0j0907te5p4aay9zWhereUniqueInput = {
  EducationReport?: InputMaybe<EducationReportWhereUniqueInput>
  EducationSeminar?: InputMaybe<EducationSeminarWhereUniqueInput>
  HubContentEntry?: InputMaybe<HubContentEntryWhereUniqueInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9e =
  | Article
  | ContentReference
  | EducationReport
  | EducationSeminar
  | PodcastEpisode
  | ReviewsProduct

export type Union_References_Cm0qshprp123q07te06v2bu9eConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>
  ContentReference?: InputMaybe<ContentReferenceConnectInput>
  EducationReport?: InputMaybe<EducationReportConnectInput>
  EducationSeminar?: InputMaybe<EducationSeminarConnectInput>
  PodcastEpisode?: InputMaybe<PodcastEpisodeConnectInput>
  ReviewsProduct?: InputMaybe<ReviewsProductConnectInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>
  ContentReference?: InputMaybe<ContentReferenceCreateInput>
  EducationReport?: InputMaybe<EducationReportCreateInput>
  EducationSeminar?: InputMaybe<EducationSeminarCreateInput>
  PodcastEpisode?: InputMaybe<PodcastEpisodeCreateInput>
  ReviewsProduct?: InputMaybe<ReviewsProductCreateInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eCreateManyInlineInput = {
  /** Connect multiple existing Union_references_cm0qshprp123q07te06v2bu9e documents */
  connect?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eWhereUniqueInput>>
  /** Create and connect multiple existing Union_references_cm0qshprp123q07te06v2bu9e documents */
  create?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eCreateInput>>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eCreateOneInlineInput = {
  /** Connect one existing Union_references_cm0qshprp123q07te06v2bu9e document */
  connect?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eWhereUniqueInput>
  /** Create and connect one Union_references_cm0qshprp123q07te06v2bu9e document */
  create?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eCreateInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>
  ContentReference?: InputMaybe<ContentReferenceUpdateInput>
  EducationReport?: InputMaybe<EducationReportUpdateInput>
  EducationSeminar?: InputMaybe<EducationSeminarUpdateInput>
  PodcastEpisode?: InputMaybe<PodcastEpisodeUpdateInput>
  ReviewsProduct?: InputMaybe<ReviewsProductUpdateInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eUpdateManyInlineInput = {
  /** Connect multiple existing Union_references_cm0qshprp123q07te06v2bu9e documents */
  connect?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eConnectInput>>
  /** Create and connect multiple Union_references_cm0qshprp123q07te06v2bu9e documents */
  create?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eCreateInput>>
  /** Delete multiple Union_references_cm0qshprp123q07te06v2bu9e documents */
  delete?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eWhereUniqueInput>>
  /** Disconnect multiple Union_references_cm0qshprp123q07te06v2bu9e documents */
  disconnect?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing Union_references_cm0qshprp123q07te06v2bu9e documents */
  set?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eWhereUniqueInput>>
  /** Update multiple Union_references_cm0qshprp123q07te06v2bu9e documents */
  update?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple Union_references_cm0qshprp123q07te06v2bu9e documents */
  upsert?: InputMaybe<Array<Union_References_Cm0qshprp123q07te06v2bu9eUpsertWithNestedWhereUniqueInput>>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>
  ContentReference?: InputMaybe<ContentReferenceUpdateManyWithNestedWhereInput>
  EducationReport?: InputMaybe<EducationReportUpdateManyWithNestedWhereInput>
  EducationSeminar?: InputMaybe<EducationSeminarUpdateManyWithNestedWhereInput>
  PodcastEpisode?: InputMaybe<PodcastEpisodeUpdateManyWithNestedWhereInput>
  ReviewsProduct?: InputMaybe<ReviewsProductUpdateManyWithNestedWhereInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eUpdateOneInlineInput = {
  /** Connect existing Union_references_cm0qshprp123q07te06v2bu9e document */
  connect?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eWhereUniqueInput>
  /** Create and connect one Union_references_cm0qshprp123q07te06v2bu9e document */
  create?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eCreateInput>
  /** Delete currently connected Union_references_cm0qshprp123q07te06v2bu9e document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected Union_references_cm0qshprp123q07te06v2bu9e document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single Union_references_cm0qshprp123q07te06v2bu9e document */
  update?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eUpdateWithNestedWhereUniqueInput>
  /** Upsert single Union_references_cm0qshprp123q07te06v2bu9e document */
  upsert?: InputMaybe<Union_References_Cm0qshprp123q07te06v2bu9eUpsertWithNestedWhereUniqueInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>
  ContentReference?: InputMaybe<ContentReferenceUpdateWithNestedWhereUniqueInput>
  EducationReport?: InputMaybe<EducationReportUpdateWithNestedWhereUniqueInput>
  EducationSeminar?: InputMaybe<EducationSeminarUpdateWithNestedWhereUniqueInput>
  PodcastEpisode?: InputMaybe<PodcastEpisodeUpdateWithNestedWhereUniqueInput>
  ReviewsProduct?: InputMaybe<ReviewsProductUpdateWithNestedWhereUniqueInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>
  ContentReference?: InputMaybe<ContentReferenceUpsertWithNestedWhereUniqueInput>
  EducationReport?: InputMaybe<EducationReportUpsertWithNestedWhereUniqueInput>
  EducationSeminar?: InputMaybe<EducationSeminarUpsertWithNestedWhereUniqueInput>
  PodcastEpisode?: InputMaybe<PodcastEpisodeUpsertWithNestedWhereUniqueInput>
  ReviewsProduct?: InputMaybe<ReviewsProductUpsertWithNestedWhereUniqueInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>
  ContentReference?: InputMaybe<ContentReferenceWhereInput>
  EducationReport?: InputMaybe<EducationReportWhereInput>
  EducationSeminar?: InputMaybe<EducationSeminarWhereInput>
  PodcastEpisode?: InputMaybe<PodcastEpisodeWhereInput>
  ReviewsProduct?: InputMaybe<ReviewsProductWhereInput>
}

export type Union_References_Cm0qshprp123q07te06v2bu9eWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>
  ContentReference?: InputMaybe<ContentReferenceWhereUniqueInput>
  EducationReport?: InputMaybe<EducationReportWhereUniqueInput>
  EducationSeminar?: InputMaybe<EducationSeminarWhereUniqueInput>
  PodcastEpisode?: InputMaybe<PodcastEpisodeWhereUniqueInput>
  ReviewsProduct?: InputMaybe<ReviewsProductWhereUniqueInput>
}

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>
}

/** User system model */
export type User = Entity &
  Node & {
    __typename?: 'User'
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** Get the document in other stages */
    documentInStages: Array<User>
    /** The unique identifier */
    id: Scalars['ID']['output']
    /** Flag to determine if user is active or not */
    isActive: Scalars['Boolean']['output']
    /** User Kind. Can be either MEMBER, PAT or PUBLIC */
    kind: UserKind
    /** The username */
    name: Scalars['String']['output']
    /** Profile Picture url */
    picture?: Maybe<Scalars['String']['output']>
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
  }

/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: UserWhereUniqueInput
}

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<UserEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>
}

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>
}

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: User
}

/** System User Kind */
export enum UserKind {
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK',
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  documentInStages_every?: InputMaybe<UserWhereStageInput>
  documentInStages_none?: InputMaybe<UserWhereStageInput>
  documentInStages_some?: InputMaybe<UserWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<UserKind>
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  picture?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>
}

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
}

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  documentInStages_every?: InputMaybe<UserWhereStageInput>
  documentInStages_none?: InputMaybe<UserWhereStageInput>
  documentInStages_some?: InputMaybe<UserWhereStageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<UserKind>
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>
  name?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  picture?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** VG Wort integration data */
export type VgWort = Entity &
  Node & {
    __typename?: 'VGWort'
    article: Article
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output']
    /** User that created this document */
    createdBy?: Maybe<User>
    /** Get the document in other stages */
    documentInStages: Array<VgWort>
    domain: Scalars['String']['output']
    /** List of VGWort versions */
    history: Array<Version>
    /** The unique identifier */
    id: Scalars['ID']['output']
    orderDateTime: Scalars['DateTime']['output']
    privateIdentificationId: Scalars['String']['output']
    publicIdentificationId: Scalars['String']['output']
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>
    /** User that last published this document */
    publishedBy?: Maybe<User>
    scheduledIn: Array<ScheduledOperation>
    /** System stage field */
    stage: Stage
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output']
    /** User that last updated this document */
    updatedBy?: Maybe<User>
  }

/** VG Wort integration data */
export type VgWortArticleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** VG Wort integration data */
export type VgWortCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** VG Wort integration data */
export type VgWortDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  inheritLocale?: Scalars['Boolean']['input']
  stages?: Array<Stage>
}

/** VG Wort integration data */
export type VgWortHistoryArgs = {
  limit?: Scalars['Int']['input']
  skip?: Scalars['Int']['input']
  stageOverride?: InputMaybe<Stage>
}

/** VG Wort integration data */
export type VgWortPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

/** VG Wort integration data */
export type VgWortScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  locales?: InputMaybe<Array<Locale>>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ScheduledOperationWhereInput>
}

/** VG Wort integration data */
export type VgWortUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>
  locales?: InputMaybe<Array<Locale>>
}

export type VgWortConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: VgWortWhereUniqueInput
}

/** A connection to a list of items. */
export type VgWortConnection = {
  __typename?: 'VGWortConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<VgWortEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type VgWortCreateInput = {
  article: ArticleCreateOneInlineInput
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  domain: Scalars['String']['input']
  orderDateTime: Scalars['DateTime']['input']
  privateIdentificationId: Scalars['String']['input']
  publicIdentificationId: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type VgWortCreateManyInlineInput = {
  /** Connect multiple existing VGWort documents */
  connect?: InputMaybe<Array<VgWortWhereUniqueInput>>
  /** Create and connect multiple existing VGWort documents */
  create?: InputMaybe<Array<VgWortCreateInput>>
}

export type VgWortCreateOneInlineInput = {
  /** Connect one existing VGWort document */
  connect?: InputMaybe<VgWortWhereUniqueInput>
  /** Create and connect one VGWort document */
  create?: InputMaybe<VgWortCreateInput>
}

/** An edge in a connection. */
export type VgWortEdge = {
  __typename?: 'VGWortEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: VgWort
}

/** Identifies documents */
export type VgWortManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VgWortWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VgWortWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VgWortWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  article?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<VgWortWhereStageInput>
  documentInStages_none?: InputMaybe<VgWortWhereStageInput>
  documentInStages_some?: InputMaybe<VgWortWhereStageInput>
  domain?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  domain_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  domain_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  domain_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  domain_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  domain_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  domain_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  domain_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  domain_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  domain_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  orderDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  orderDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  orderDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  orderDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  orderDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  orderDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  orderDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  orderDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  privateIdentificationId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  privateIdentificationId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  privateIdentificationId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  privateIdentificationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  privateIdentificationId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  privateIdentificationId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  privateIdentificationId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  privateIdentificationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  privateIdentificationId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  privateIdentificationId_starts_with?: InputMaybe<Scalars['String']['input']>
  publicIdentificationId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  publicIdentificationId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  publicIdentificationId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  publicIdentificationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  publicIdentificationId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  publicIdentificationId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  publicIdentificationId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  publicIdentificationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  publicIdentificationId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  publicIdentificationId_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

export enum VgWortOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DomainAsc = 'domain_ASC',
  DomainDesc = 'domain_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OrderDateTimeAsc = 'orderDateTime_ASC',
  OrderDateTimeDesc = 'orderDateTime_DESC',
  PrivateIdentificationIdAsc = 'privateIdentificationId_ASC',
  PrivateIdentificationIdDesc = 'privateIdentificationId_DESC',
  PublicIdentificationIdAsc = 'publicIdentificationId_ASC',
  PublicIdentificationIdDesc = 'publicIdentificationId_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type VgWortUpdateInput = {
  article?: InputMaybe<ArticleUpdateOneInlineInput>
  domain?: InputMaybe<Scalars['String']['input']>
  orderDateTime?: InputMaybe<Scalars['DateTime']['input']>
  privateIdentificationId?: InputMaybe<Scalars['String']['input']>
  publicIdentificationId?: InputMaybe<Scalars['String']['input']>
}

export type VgWortUpdateManyInlineInput = {
  /** Connect multiple existing VGWort documents */
  connect?: InputMaybe<Array<VgWortConnectInput>>
  /** Create and connect multiple VGWort documents */
  create?: InputMaybe<Array<VgWortCreateInput>>
  /** Delete multiple VGWort documents */
  delete?: InputMaybe<Array<VgWortWhereUniqueInput>>
  /** Disconnect multiple VGWort documents */
  disconnect?: InputMaybe<Array<VgWortWhereUniqueInput>>
  /** Override currently-connected documents with multiple existing VGWort documents */
  set?: InputMaybe<Array<VgWortWhereUniqueInput>>
  /** Update multiple VGWort documents */
  update?: InputMaybe<Array<VgWortUpdateWithNestedWhereUniqueInput>>
  /** Upsert multiple VGWort documents */
  upsert?: InputMaybe<Array<VgWortUpsertWithNestedWhereUniqueInput>>
}

export type VgWortUpdateManyInput = {
  domain?: InputMaybe<Scalars['String']['input']>
  orderDateTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type VgWortUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VgWortUpdateManyInput
  /** Document search */
  where: VgWortWhereInput
}

export type VgWortUpdateOneInlineInput = {
  /** Connect existing VGWort document */
  connect?: InputMaybe<VgWortWhereUniqueInput>
  /** Create and connect one VGWort document */
  create?: InputMaybe<VgWortCreateInput>
  /** Delete currently connected VGWort document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Disconnect currently connected VGWort document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single VGWort document */
  update?: InputMaybe<VgWortUpdateWithNestedWhereUniqueInput>
  /** Upsert single VGWort document */
  upsert?: InputMaybe<VgWortUpsertWithNestedWhereUniqueInput>
}

export type VgWortUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VgWortUpdateInput
  /** Unique document search */
  where: VgWortWhereUniqueInput
}

export type VgWortUpsertInput = {
  /** Create document if it didn't exist */
  create: VgWortCreateInput
  /** Update document if it exists */
  update: VgWortUpdateInput
}

export type VgWortUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VgWortUpsertInput
  /** Unique document search */
  where: VgWortWhereUniqueInput
}

/** This contains a set of filters that can be used to compare values internally */
export type VgWortWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>
}

/** Identifies documents */
export type VgWortWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VgWortWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VgWortWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VgWortWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  article?: InputMaybe<ArticleWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdBy?: InputMaybe<UserWhereInput>
  documentInStages_every?: InputMaybe<VgWortWhereStageInput>
  documentInStages_none?: InputMaybe<VgWortWhereStageInput>
  documentInStages_some?: InputMaybe<VgWortWhereStageInput>
  domain?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  domain_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  domain_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  domain_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  domain_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  domain_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  domain_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  domain_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  domain_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  domain_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  orderDateTime?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  orderDateTime_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  orderDateTime_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  orderDateTime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  orderDateTime_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  orderDateTime_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  orderDateTime_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  orderDateTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  privateIdentificationId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  privateIdentificationId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  privateIdentificationId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  privateIdentificationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  privateIdentificationId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  privateIdentificationId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  privateIdentificationId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  privateIdentificationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  privateIdentificationId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  privateIdentificationId_starts_with?: InputMaybe<Scalars['String']['input']>
  publicIdentificationId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  publicIdentificationId_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  publicIdentificationId_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  publicIdentificationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  publicIdentificationId_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  publicIdentificationId_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  publicIdentificationId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  publicIdentificationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  publicIdentificationId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  publicIdentificationId_starts_with?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedBy?: InputMaybe<UserWhereInput>
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedBy?: InputMaybe<UserWhereInput>
}

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VgWortWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VgWortWhereStageInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VgWortWhereStageInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VgWortWhereStageInput>>
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VgWortWhereComparatorInput>
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>
}

/** References VGWort record uniquely */
export type VgWortWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  privateIdentificationId?: InputMaybe<Scalars['String']['input']>
  publicIdentificationId?: InputMaybe<Scalars['String']['input']>
}

export type Version = {
  __typename?: 'Version'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  revision: Scalars['Int']['output']
  stage: Stage
}

export type VersionWhereInput = {
  id: Scalars['ID']['input']
  revision: Scalars['Int']['input']
  stage: Stage
}

/** Workflow system enumeration */
export enum Workflow {
  /** This is the final step by default. You can adjust the configuration */
  TestingTestingCompleted = 'testing_testingCompleted',
  /** This is the first step by default. You can adjust the configuration */
  TestingTestingStarted = 'testing_testingStarted',
}

export type YtEmbed = Entity & {
  __typename?: 'YTEmbed'
  date?: Maybe<Scalars['String']['output']>
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** System Locale field */
  locale: Locale
  /** Get the other localizations for this document */
  localizations: Array<YtEmbed>
  /** System stage field */
  stage: Stage
  title: Scalars['String']['output']
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  videoID?: Maybe<Scalars['String']['output']>
}

export type YtEmbedLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input']
  locales?: Array<Locale>
}

export type YtEmbedUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation
}

export type YtEmbedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Document to connect */
  where: YtEmbedWhereUniqueInput
}

/** A connection to a list of items. */
export type YtEmbedConnection = {
  __typename?: 'YTEmbedConnection'
  aggregate: Aggregate
  /** A list of edges. */
  edges: Array<YtEmbedEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type YtEmbedCreateInput = {
  /** date input for default locale (de) */
  date?: InputMaybe<Scalars['String']['input']>
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<YtEmbedCreateLocalizationsInput>
  /** title input for default locale (de) */
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** videoID input for default locale (de) */
  videoID?: InputMaybe<Scalars['String']['input']>
}

export type YtEmbedCreateLocalizationDataInput = {
  date?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  videoID?: InputMaybe<Scalars['String']['input']>
}

export type YtEmbedCreateLocalizationInput = {
  /** Localization input */
  data: YtEmbedCreateLocalizationDataInput
  locale: Locale
}

export type YtEmbedCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<YtEmbedCreateLocalizationInput>>
}

export type YtEmbedCreateManyInlineInput = {
  /** Create and connect multiple existing YTEmbed documents */
  create?: InputMaybe<Array<YtEmbedCreateInput>>
}

export type YtEmbedCreateOneInlineInput = {
  /** Create and connect one YTEmbed document */
  create?: InputMaybe<YtEmbedCreateInput>
}

export type YtEmbedCreateWithPositionInput = {
  /** Document to create */
  data: YtEmbedCreateInput
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
}

/** An edge in a connection. */
export type YtEmbedEdge = {
  __typename?: 'YTEmbedEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: YtEmbed
}

/** Identifies documents */
export type YtEmbedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<YtEmbedWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<YtEmbedWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<YtEmbedWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

export enum YtEmbedOrderByInput {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VideoIdAsc = 'videoID_ASC',
  VideoIdDesc = 'videoID_DESC',
}

export type YtEmbedParent = SectionLivestreams

export type YtEmbedParentConnectInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsConnectInput>
}

export type YtEmbedParentCreateInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsCreateInput>
}

export type YtEmbedParentCreateManyInlineInput = {
  /** Create and connect multiple existing YTEmbedParent documents */
  create?: InputMaybe<Array<YtEmbedParentCreateInput>>
}

export type YtEmbedParentCreateOneInlineInput = {
  /** Create and connect one YTEmbedParent document */
  create?: InputMaybe<YtEmbedParentCreateInput>
}

export type YtEmbedParentCreateWithPositionInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsCreateWithPositionInput>
}

export type YtEmbedParentUpdateInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpdateInput>
}

export type YtEmbedParentUpdateManyInlineInput = {
  /** Create and connect multiple YTEmbedParent component instances */
  create?: InputMaybe<Array<YtEmbedParentCreateWithPositionInput>>
  /** Delete multiple YTEmbedParent documents */
  delete?: InputMaybe<Array<YtEmbedParentWhereUniqueInput>>
  /** Update multiple YTEmbedParent component instances */
  update?: InputMaybe<Array<YtEmbedParentUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple YTEmbedParent component instances */
  upsert?: InputMaybe<Array<YtEmbedParentUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type YtEmbedParentUpdateManyWithNestedWhereInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpdateManyWithNestedWhereInput>
}

export type YtEmbedParentUpdateOneInlineInput = {
  /** Create and connect one YTEmbedParent document */
  create?: InputMaybe<YtEmbedParentCreateInput>
  /** Delete currently connected YTEmbedParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single YTEmbedParent document */
  update?: InputMaybe<YtEmbedParentUpdateWithNestedWhereUniqueInput>
  /** Upsert single YTEmbedParent document */
  upsert?: InputMaybe<YtEmbedParentUpsertWithNestedWhereUniqueInput>
}

export type YtEmbedParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpdateWithNestedWhereUniqueAndPositionInput>
}

export type YtEmbedParentUpdateWithNestedWhereUniqueInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpdateWithNestedWhereUniqueInput>
}

export type YtEmbedParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpsertWithNestedWhereUniqueAndPositionInput>
}

export type YtEmbedParentUpsertWithNestedWhereUniqueInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsUpsertWithNestedWhereUniqueInput>
}

export type YtEmbedParentWhereInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsWhereInput>
}

export type YtEmbedParentWhereUniqueInput = {
  SectionLivestreams?: InputMaybe<SectionLivestreamsWhereUniqueInput>
}

export type YtEmbedUpdateInput = {
  /** date input for default locale (de) */
  date?: InputMaybe<Scalars['String']['input']>
  /** Manage document localizations */
  localizations?: InputMaybe<YtEmbedUpdateLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  /** videoID input for default locale (de) */
  videoID?: InputMaybe<Scalars['String']['input']>
}

export type YtEmbedUpdateLocalizationDataInput = {
  date?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  videoID?: InputMaybe<Scalars['String']['input']>
}

export type YtEmbedUpdateLocalizationInput = {
  data: YtEmbedUpdateLocalizationDataInput
  locale: Locale
}

export type YtEmbedUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<YtEmbedCreateLocalizationInput>>
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>
  /** Localizations to update */
  update?: InputMaybe<Array<YtEmbedUpdateLocalizationInput>>
  upsert?: InputMaybe<Array<YtEmbedUpsertLocalizationInput>>
}

export type YtEmbedUpdateManyInlineInput = {
  /** Create and connect multiple YTEmbed component instances */
  create?: InputMaybe<Array<YtEmbedCreateWithPositionInput>>
  /** Delete multiple YTEmbed documents */
  delete?: InputMaybe<Array<YtEmbedWhereUniqueInput>>
  /** Update multiple YTEmbed component instances */
  update?: InputMaybe<Array<YtEmbedUpdateWithNestedWhereUniqueAndPositionInput>>
  /** Upsert multiple YTEmbed component instances */
  upsert?: InputMaybe<Array<YtEmbedUpsertWithNestedWhereUniqueAndPositionInput>>
}

export type YtEmbedUpdateManyInput = {
  /** date input for default locale (de) */
  date?: InputMaybe<Scalars['String']['input']>
  /** Optional updates to localizations */
  localizations?: InputMaybe<YtEmbedUpdateManyLocalizationsInput>
  /** title input for default locale (de) */
  title?: InputMaybe<Scalars['String']['input']>
  /** videoID input for default locale (de) */
  videoID?: InputMaybe<Scalars['String']['input']>
}

export type YtEmbedUpdateManyLocalizationDataInput = {
  date?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  videoID?: InputMaybe<Scalars['String']['input']>
}

export type YtEmbedUpdateManyLocalizationInput = {
  data: YtEmbedUpdateManyLocalizationDataInput
  locale: Locale
}

export type YtEmbedUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<YtEmbedUpdateManyLocalizationInput>>
}

export type YtEmbedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: YtEmbedUpdateManyInput
  /** Document search */
  where: YtEmbedWhereInput
}

export type YtEmbedUpdateOneInlineInput = {
  /** Create and connect one YTEmbed document */
  create?: InputMaybe<YtEmbedCreateInput>
  /** Delete currently connected YTEmbed document */
  delete?: InputMaybe<Scalars['Boolean']['input']>
  /** Update single YTEmbed document */
  update?: InputMaybe<YtEmbedUpdateWithNestedWhereUniqueInput>
  /** Upsert single YTEmbed document */
  upsert?: InputMaybe<YtEmbedUpsertWithNestedWhereUniqueInput>
}

export type YtEmbedUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<YtEmbedUpdateInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: YtEmbedWhereUniqueInput
}

export type YtEmbedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: YtEmbedUpdateInput
  /** Unique document search */
  where: YtEmbedWhereUniqueInput
}

export type YtEmbedUpsertInput = {
  /** Create document if it didn't exist */
  create: YtEmbedCreateInput
  /** Update document if it exists */
  update: YtEmbedUpdateInput
}

export type YtEmbedUpsertLocalizationInput = {
  create: YtEmbedCreateLocalizationDataInput
  locale: Locale
  update: YtEmbedUpdateLocalizationDataInput
}

export type YtEmbedUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<YtEmbedUpsertInput>
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>
  /** Unique component instance search */
  where: YtEmbedWhereUniqueInput
}

export type YtEmbedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: YtEmbedUpsertInput
  /** Unique document search */
  where: YtEmbedWhereUniqueInput
}

/** Identifies documents */
export type YtEmbedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<YtEmbedWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<YtEmbedWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<YtEmbedWhereInput>>
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  date_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  date_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  date_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  date_starts_with?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  videoID?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  videoID_contains?: InputMaybe<Scalars['String']['input']>
  /** All values ending with the given string. */
  videoID_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  videoID_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Any other value that exists and is not equal to the given value. */
  videoID_not?: InputMaybe<Scalars['String']['input']>
  /** All values not containing the given string. */
  videoID_not_contains?: InputMaybe<Scalars['String']['input']>
  /** All values not ending with the given string */
  videoID_not_ends_with?: InputMaybe<Scalars['String']['input']>
  /** All values that are not contained in given list. */
  videoID_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** All values not starting with the given string. */
  videoID_not_starts_with?: InputMaybe<Scalars['String']['input']>
  /** All values starting with the given string. */
  videoID_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** References YTEmbed record uniquely */
export type YtEmbedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum _FilterKind {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR',
  Contains = 'contains',
  ContainsAll = 'contains_all',
  ContainsNone = 'contains_none',
  ContainsSome = 'contains_some',
  DescendantsOf = 'descendants_of',
  EndsWith = 'ends_with',
  Eq = 'eq',
  EqNot = 'eq_not',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  JsonPathExists = 'json_path_exists',
  JsonValueRecursive = 'json_value_recursive',
  Lt = 'lt',
  Lte = 'lte',
  NotContains = 'not_contains',
  NotEndsWith = 'not_ends_with',
  NotIn = 'not_in',
  NotStartsWith = 'not_starts_with',
  RelationalEvery = 'relational_every',
  RelationalNone = 'relational_none',
  RelationalSingle = 'relational_single',
  RelationalSome = 'relational_some',
  Search = 'search',
  StartsWith = 'starts_with',
  UnionEmpty = 'union_empty',
  UnionEvery = 'union_every',
  UnionNone = 'union_none',
  UnionSingle = 'union_single',
  UnionSome = 'union_some',
}

export enum _MutationInputFieldKind {
  Enum = 'enum',
  Relation = 'relation',
  RichText = 'richText',
  RichTextWithEmbeds = 'richTextWithEmbeds',
  Scalar = 'scalar',
  Union = 'union',
  Virtual = 'virtual',
}

export enum _MutationKind {
  Create = 'create',
  Delete = 'delete',
  DeleteMany = 'deleteMany',
  Publish = 'publish',
  PublishMany = 'publishMany',
  SchedulePublish = 'schedulePublish',
  ScheduleUnpublish = 'scheduleUnpublish',
  Unpublish = 'unpublish',
  UnpublishMany = 'unpublishMany',
  Update = 'update',
  UpdateMany = 'updateMany',
  Upsert = 'upsert',
}

export enum _OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum _RelationInputCardinality {
  Many = 'many',
  One = 'one',
}

export enum _RelationInputKind {
  Create = 'create',
  Update = 'update',
}

export enum _RelationKind {
  Regular = 'regular',
  Union = 'union',
}

export enum _SystemDateTimeFieldVariation {
  Base = 'base',
  Combined = 'combined',
  Localization = 'localization',
}

export type SectionFlipCounterFieldsFragment = {
  __typename: 'SectionFlipCounter'
  id: string
  optionalTitle?: string | null
  targetDateTime: any
  decorations?: boolean | null
  subtext?: string | null
  ctaInformationText?: string | null
  darkMode?: boolean | null
  cta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
}

export type LandingPageLayoutFieldsFragment = {
  __typename?: 'LandingPage'
  pageLayout: Array<
    | ({ __typename?: 'Faq' } & SectionFaqFieldsFragment)
    | ({ __typename?: 'PpcReviewsProduct' } & PpcReviewsProductFieldsFragment)
    | { __typename?: 'PreviewCardList' }
    | ({ __typename?: 'RichContent' } & SectionRichContentFieldsFragment)
    | ({ __typename?: 'SectionAnchorTarget' } & SectionAnchorTargetFieldsFragment)
    | { __typename?: 'SectionBanner' }
    | ({ __typename?: 'SectionByTheNumbers' } & SectionByTheNumbersFieldsFragment)
    | ({ __typename?: 'SectionContact' } & SectionContactFieldsFragment)
    | ({ __typename?: 'SectionCta' } & SectionCtaFieldsFragment)
    | { __typename?: 'SectionCuratedSpeakerList' }
    | ({ __typename?: 'SectionExplanationBlocks' } & SectionExplanationBlocksFieldsFragment)
    | { __typename?: 'SectionFramesHero' }
    | ({ __typename?: 'SectionHero' } & SectionHeroFieldsFragment)
    | ({ __typename?: 'SectionHubspotForm' } & SectionHubspotFormFieldsFragment)
    | { __typename?: 'SectionImageSlider' }
    | ({ __typename?: 'SectionIntro' } & SectionIntroFieldsFragment)
    | { __typename?: 'SectionNewsletter' }
    | ({ __typename?: 'SectionNewsletterAudience' } & SectionNewsletterAudiencesFieldsFragment)
    | ({ __typename?: 'SectionOMRPartner' } & SectionOmrPartnerFieldsFragment)
    | { __typename?: 'SectionOneShot' }
    | ({ __typename?: 'SectionPricingTiers' } & SectionPricingTiersFieldsFragment)
    | ({ __typename?: 'SectionReviewsFeaturesTable' } & SectionReviewsFeaturesTableFieldsFragment)
    | ({ __typename?: 'SectionSlimCta' } & SectionSlimCtaFieldsFragment)
    | ({ __typename?: 'SectionStyledHero' } & SectionStyledHeroFieldsFragment)
    | ({ __typename?: 'SectionTab' } & SectionTabsFieldsFragment)
    | ({ __typename?: 'SectionTeaser' } & SectionTeaserFieldsFragment)
    | { __typename?: 'SectionTestimonial' }
    | ({ __typename?: 'SectionTiles' } & SectionTilesFieldsFragment)
    | ({ __typename?: 'SectionVideo' } & SectionVideoFieldsFragment)
    | ({ __typename?: 'SubscriptionTeaser' } & SubscriptionTeaserFieldsFragment)
    | ({ __typename?: 'TestimonialSlider' } & SectionTestimonialSliderFieldsFragment)
    | ({ __typename?: 'TextMedia' } & SectionTextMediaFieldsFragment)
    | { __typename?: 'TextMediaBanner' }
  >
}

export type LandingPageLayoutBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
  locale: Array<Locale> | Locale
  imageLocales: Array<Locale> | Locale
  stage?: InputMaybe<Stage>
}>

export type LandingPageLayoutBySlugQuery = {
  __typename?: 'Query'
  landingPage?:
    | ({ __typename?: 'LandingPage'; id: string; slug: string; stage: Stage; title: string } & LandingPageLayoutFieldsFragment)
    | null
}

export type FooterFieldsFragment = {
  __typename?: 'Footer'
  id: string
  omrFooterLinks: Array<{ __typename?: 'FooterLink'; id: string; name?: string | null; link?: string | null }>
  omrFooterSocials: Array<{
    __typename?: 'SocialLink'
    id: string
    name: string
    link: string
    logo?: { __typename?: 'Asset'; url: string } | null
  }>
}

export type HeaderFieldsFragment = {
  __typename?: 'Header'
  id: string
  logo?: { __typename?: 'Asset'; url: string } | null
  mobileLogo?: { __typename?: 'Asset'; url: string } | null
  omrHeaderMenuItems: Array<{
    __typename?: 'HeaderMenuItem'
    id: string
    slug: string
    name: string
    link: string
    omrHeaderSubmenuItems: Array<{
      __typename?: 'HeaderSubMenuItem'
      id: string
      name: string
      link: string
      omrHeaderSubSubmenuItems: Array<{ __typename?: 'HeaderSubSubMenuItem'; id: string; name: string; link: string }>
    }>
    omrHeaderSubmenuCta?: { __typename?: 'CallToAction'; label: string; url: string } | null
  }>
  omrHeaderPartners: Array<{
    __typename?: 'OMRPartner'
    id: string
    name: string
    partnerUrl?: string | null
    logo: { __typename?: 'Asset'; url: string; title?: string | null }
  }>
  omrHeaderSocials: Array<{
    __typename?: 'SocialLink'
    id: string
    name: string
    link: string
    logo?: { __typename?: 'Asset'; url: string } | null
  }>
}

export type PpcReviewsProductFieldsFragment = {
  __typename: 'PpcReviewsProduct'
  ppcDescription?: string | null
  id: string
  url: string
  viewUrl?: string | null
  reviewsProduct?: {
    __typename?: 'ReviewsProduct'
    id: string
    name: string
    rating?: number | null
    ratingsCount?: number | null
    logoUrl?: string | null
  } | null
}

export type ProcessStepFieldsFragment = {
  __typename: 'ProcessStep'
  id: string
  steps: Array<string>
  sectionPadding?: SectionPadding | null
  styleVariant?: ComponentStyle | null
  displayDecorations?: boolean | null
  optionalTitle?: string | null
  optionalDescription?: string | null
  optionalCtaText?: string | null
  optionalCtaUrl?: string | null
}

export type SectionAnchorTargetFieldsFragment = { __typename: 'SectionAnchorTarget'; id: string; anchorId: string }

export type SectionByTheNumbersFieldsFragment = {
  __typename: 'SectionByTheNumbers'
  id: string
  sectionPadding?: SectionPadding | null
  styleVariant?: ComponentStyle | null
  duration?: number | null
  optionalTitle?: string | null
  optionalSubtitle?: string | null
  counters: Array<{
    __typename?: 'AnimatedCounter'
    target: number
    start?: number | null
    prefix?: string | null
    suffix?: string | null
    subhead?: string | null
  }>
  cta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
}

export type SectionContactFieldsFragment = {
  __typename: 'SectionContact'
  id: string
  title: string
  decorationPattern?: DecorationPattern | null
  styleVariant?: ComponentStyle | null
  centered?: boolean | null
  optionalDescription?: string | null
  omrTheme?: OmrThemeVariant | null
  contact: Array<{
    __typename?: 'Contact'
    email?: string | null
    id: string
    phone?: string | null
    title: string
    description: string
    department?: string | null
    departmentUrl?: string | null
    contactIcons?: boolean | null
    contactPhoto: { __typename?: 'Asset' } & AssetFieldsFragment
  }>
  generalCTA?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
}

export type SectionCtaFieldsFragment = {
  __typename: 'SectionCta'
  id: string
  ctaText: string
  ctaUrl: string
  ctaTarget: string
  ctaExternal?: boolean | null
  contentPosition?: ElementPosition | null
  showDecoration?: boolean | null
  decorationPattern?: DecorationPattern | null
  appStoreUrl?: string | null
  playStoreUrl?: string | null
  darkTheme?: boolean | null
  styleVariant?: ComponentStyle | null
  optionalTitle?: string | null
  optionalDescription?: string | null
  ctaImage?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  internalPageLink?: { __typename?: 'EventPage'; slug: string; event?: { __typename?: 'Event'; slug: string } | null } | null
  partnerLogo?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
}

export type SectionExplanationBlocksFieldsFragment = {
  __typename: 'SectionExplanationBlocks'
  id: string
  centered?: boolean | null
  styleVariant?: ComponentStyle | null
  sectionPadding?: SectionPadding | null
  displayDecorations?: boolean | null
  columns?: ColumnLayout | null
  optionalTitle?: string | null
  optionalSubtitle?: string | null
  cta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
  items: Array<{ __typename?: 'ExplanationStep' } & ExplanationStepFieldsFragment>
}

export type SectionFaqFieldsFragment = {
  __typename: 'Faq'
  id: string
  title: string
  description: string
  styleVariant?: ComponentStyle | null
  decorationPattern?: DecorationPattern | null
  verticalLayout?: boolean | null
  optionalCtaText?: string | null
  optionalCtaUrl?: string | null
  questions: Array<{
    __typename?: 'FaqQuestion'
    id: string
    question?: string | null
    answer?: string | null
    answerRte?: { __typename?: 'RichText'; html: string } | null
  }>
}

export type SectionReviewsFeaturesTableFieldsFragment = {
  __typename: 'SectionReviewsFeaturesTable'
  id: string
  featuresTableTitle?: string | null
  featuresTableDescription?: string | null
  featuresTableColumns: Array<string>
  featureTableSections: Array<{
    __typename?: 'ReviewsFeaturesSection'
    id: string
    featureSectionTitle?: string | null
    featureSectionDescription?: string | null
    featureSectionFeatures: Array<{
      __typename?: 'ReviewsFeatureRow'
      id: string
      featureTitle?: string | null
      featureDescription: string
    }>
  }>
}

export type SectionFestivalNewsletterFieldsFragment = {
  __typename: 'SectionNewsletter'
  id: string
  title: string
  description: string
  linkText?: string | null
  linkTarget?: string | null
  linkUrl?: string | null
  audience?: string | null
}

export type SectionHeroFieldsFragment = {
  __typename: 'SectionHero'
  id: string
  compact?: boolean | null
  ctaOnMobileOnly?: boolean | null
  titleIsTransparent?: boolean | null
  optionalTitle?: string | null
  optionalSubtitle?: string | null
  optionalDescription?: string | null
  cta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
  ctaSecondary?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
  background: { __typename?: 'Asset' } & AssetFieldsFragment
  mobileBackground?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  logo?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  video?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
}

export type SectionHotelsFieldsFragment = {
  __typename: 'SectionHotel'
  id: string
  title: string
  description: string
  hotels: Array<{
    __typename?: 'Hotel'
    id: string
    name: string
    description: string
    rating: string
    distance: string
    url: string
    logo: { __typename?: 'Asset' } & AssetFieldsFragment
  }>
}

export type SectionHubspotFormFieldsFragment = { __typename: 'SectionHubspotForm'; id: string; formId: string }

export type SectionIntroFieldsFragment = {
  __typename: 'SectionIntro'
  id: string
  title: string
  description: string
  sectionHead?: boolean | null
  sectionPadding?: SectionPadding | null
  centered?: boolean | null
  omrTheme?: OmrThemeVariant | null
  cta?: { __typename?: 'CallToAction'; label: string; url: string; target?: string | null } | null
}

export type SectionNewsletterAudiencesFieldsFragment = {
  __typename: 'SectionNewsletterAudience'
  id: string
  audiences: Array<{
    __typename?: 'NewsletterAudience'
    slug: string
    name: string
    description?: string | null
    private?: boolean | null
    previewCta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
  }>
}

export type SectionOmrPartnerFieldsFragment = {
  __typename: 'SectionOMRPartner'
  id: string
  asSlider?: boolean | null
  sectionPadding?: SectionPadding | null
  darkTheme?: boolean | null
  decorationPattern?: DecorationPattern | null
  optionalTitle?: string | null
  optionalDescription?: string | null
  omrPartners: Array<{ __typename?: 'OMRPartner' } & OmrPartnerFieldsFragment>
}

export type SectionPricingTiersFieldsFragment = {
  __typename: 'SectionPricingTiers'
  id: string
  sectionPricingTiersTitle?: string | null
  sectionPricingTiersItems: Array<{
    __typename?: 'PricingTier'
    id: string
    isRecommended?: boolean | null
    pricingTierRecommendationLabel: string
    pricingTierTitleIcon: SectionPricingTiersTitleIcon
    pricingTierTitle: string
    pricingTierSubTitle: string
    features: string
    featuresTitle: string
    freeIncentiveBudget: number
    freeIncentiveBudgetSuffix: string
    freeIncentiveDescription: string
    hasPrice?: boolean | null
    priceValue?: number | null
    paidPer?: string | null
    pricingDescription?: string | null
    noPriceBottomline?: string | null
    noPriceTopline?: string | null
    primaryCtaLabel?: string | null
    primaryCtaLink?: string | null
    primaryCtaTrackingId?: string | null
    secondaryCtaLabel?: string | null
    secondaryCtaLink?: string | null
    secondaryCtaTrackingId?: string | null
  }>
}

export type SectionRichContentFieldsFragment = {
  __typename: 'RichContent'
  id: string
  showToc?: boolean | null
  tocTitle?: string | null
  tocHeaderLevel?: TocHeaderLevel | null
  content: {
    __typename?: 'RichContentContentRichText'
    raw: any
    references: Array<{ __typename: 'Asset'; id: string; url: string } | { __typename: 'HtmlEmbed'; id: string; rawHtml: string }>
  }
}

export type SectionSlimCtaFieldsFragment = {
  __typename: 'SectionSlimCta'
  id: string
  slimCtaHeaderIcon?: LucideIcon | null
  slimCtaHeadline?: string | null
  slimCtaBody: string
  slimCtaCta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
}

export type SectionStyledHeroFieldsFragment = {
  __typename: 'SectionStyledHero'
  id: string
  style: SectionStyledHeroStyle
  theme: OmrThemeVariant
  backgroundColor?: SectionStyledHeroBackground | null
  additionalText?: string | null
  paddingSize?: PaddingSize | null
  spacer?: number | null
  heroDescription?: string | null
  bgStyleVariant?: OmrStyleVariant | null
  highlitedTitle: {
    __typename?: 'HighlightedText'
    style: HighlightedTextStyle
    text: string
    headlineSize?: HighlightedTextSize | null
    headlineCase?: HighlightedTextCase | null
  }
  partnerBadge?: {
    __typename?: 'PartnerBadge'
    partnerBadgeLabel: string
    partnerBadgeLogo: { __typename?: 'Asset' } & AssetFieldsFragment
  } | null
  heroImage?: {
    __typename?: 'HeroImage'
    horizontalDesktopPosition?: HeroImageHorizontalPosition | null
    horizontalMobilePosition?: HeroImageHorizontalPosition | null
    verticalDesktopPosition?: HeroImageVerticalPosition | null
    verticalMobilePosition?: HeroImageVerticalPosition | null
    videoAutoplay?: boolean | null
    laptopImage?: { __typename?: 'Asset'; url: string } | null
    mobileImage?: { __typename?: 'Asset'; url: string } | null
    tabletImage?: { __typename?: 'Asset'; url: string } | null
    desktopImage?: { __typename?: 'Asset'; url: string } | null
    video?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  } | null
  heroImageRight?: {
    __typename?: 'HeroImage'
    horizontalDesktopPosition?: HeroImageHorizontalPosition | null
    horizontalMobilePosition?: HeroImageHorizontalPosition | null
    verticalDesktopPosition?: HeroImageVerticalPosition | null
    verticalMobilePosition?: HeroImageVerticalPosition | null
    laptopImage?: { __typename?: 'Asset'; url: string } | null
    mobileImage?: { __typename?: 'Asset'; url: string } | null
    tabletImage?: { __typename?: 'Asset'; url: string } | null
    desktopImage?: { __typename?: 'Asset'; url: string } | null
  } | null
  mobileImage?: { __typename?: 'Asset'; url: string } | null
  tabletImage?: { __typename?: 'Asset'; url: string } | null
  laptopImage?: { __typename?: 'Asset'; url: string } | null
  desktopImage?: { __typename?: 'Asset'; url: string } | null
  primaryCta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
  secondaryCta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
}

export type SectionTabsFieldsFragment = {
  __typename: 'SectionTab'
  id: string
  titlePosition?: ElementPosition | null
  optionalTitle?: string | null
  optionalDescription?: string | null
  tabContents: Array<{
    __typename?: 'TabContent'
    id: string
    tabName: string
    title: string
    description?: string | null
    imageEN?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
    imageDE?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
    downloads: Array<{
      __typename?: 'Download'
      date: any
      description: string
      title: string
      id: string
      previewimage?: { __typename?: 'Asset'; url: string; title?: string | null } | null
      downloadDe?: { __typename?: 'Asset'; url: string; fileName: string } | null
      downloadEn?: { __typename?: 'Asset'; url: string; fileName: string } | null
    }>
  }>
}

export type SectionTeaserFieldsFragment = {
  __typename: 'SectionTeaser'
  id: string
  headline: string
  styleVariant?: ComponentStyle | null
  position?: ElementPosition | null
  isBgFulWidth?: boolean | null
  optionalDescription?: string | null
  optionalCtaUrl?: string | null
  optionalCtaLabel?: string | null
  background: { __typename?: 'Asset' } & AssetFieldsFragment
  desktopImage?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  mobileImage?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  laptopImage?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  tabletImage?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  cta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
  ctaSecondary?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
}

export type SectionTestimonialSliderFieldsFragment = {
  __typename: 'TestimonialSlider'
  id: string
  styleVariant?: ComponentStyle | null
  optionalTitle?: string | null
  sliderTheme?: OmrThemeVariant | null
  slide: Array<{ __typename?: 'SectionTestimonial' } & SectionTestimonialFieldsFragment>
}

export type SectionTextMediaFieldsFragment = {
  __typename: 'TextMedia'
  id: string
  title: string
  subtitle?: string | null
  tag?: string | null
  sectionPadding?: SectionPadding | null
  sectionDivision?: SectionDivision | null
  darkTheme?: boolean | null
  centered?: boolean | null
  description: string
  imageLinkUrl?: string | null
  imageHiddenOnMobile?: boolean | null
  vertical?: boolean | null
  enableDescriptionStyling?: boolean | null
  optionalCtaUrl?: string | null
  optionalCtaText?: string | null
  elementPosition?: ElementPosition | null
  cta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
  image: { __typename?: 'Asset' } & AssetFieldsFragment
  imageEN: { __typename?: 'Asset' } & AssetFieldsFragment
  imageDE: { __typename?: 'Asset' } & AssetFieldsFragment
}

export type SectionTilesFieldsFragment = {
  __typename?: 'SectionTiles'
  id: string
  theme: OmrThemeVariant
  optionalTitle?: string | null
  optionalSubtitle?: string | null
  tiles: Array<
    | { __typename: 'HubPageAdTile'; id: string }
    | { __typename: 'HubPageArticleListTile'; id: string }
    | ({ __typename: 'HubPageContentTile' } & ContentTileFieldsFragment)
    | { __typename: 'HubPageImageTile'; id: string }
    | { __typename: 'HubPageInfoTile'; id: string }
    | { __typename: 'HubPageLatestArticleTile'; id: string }
    | { __typename: 'HubPageNewsletterSubscriptionTile'; id: string }
    | { __typename: 'HubPagePartnerCompanyTile'; id: string }
    | { __typename: 'HubPageReferenceListTile'; id: string }
    | { __typename: 'HubPageSocialMediaTile'; id: string }
    | { __typename: 'HubPageSpeakerTile'; id: string }
    | { __typename: 'HubPageStaticTile'; id: string }
  >
}

export type SectionVideoFieldsFragment = {
  __typename: 'SectionVideo'
  id: string
  title: string
  hideSectionHead?: boolean | null
  ytVideoId: string
  ytVideoTitle: string
  vidTitle?: string | null
  dates: Array<string>
  styleVariant?: ComponentStyle | null
  optionalDescription?: string | null
}

export type SubscriptionTeaserFieldsFragment = {
  __typename: 'SubscriptionTeaser'
  id: string
  bannerText: string
  ctaText: string
  ctaUrl: string
  sectionPadding?: SectionPadding | null
  styleVariant?: ComponentStyle | null
  decorationPattern?: DecorationPattern | null
  optionalTitle?: string | null
  optionalDescription?: string | null
  optionalSubBannerText?: string | null
}

export type ContentTileFieldsFragment = {
  __typename?: 'HubPageContentTile'
  id: string
  title: string
  subtitle?: string | null
  theme: OmrThemeVariant
  tag?: { __typename?: 'Tag'; id: string; name: string; slug: string } | null
  tileSizes: { __typename?: 'HubPageTileSizes' } & TileSizesFragment
  image: { __typename?: 'Asset' } & HubAssetFieldsFragment
  cta: { __typename?: 'CallToAction' } & CallToActionFieldsFragment
}

export type HubAssetFieldsFragment = {
  __typename?: 'Asset'
  title?: string | null
  description?: string | null
  mimeType?: string | null
  url: string
  originalUrl: string
}

export type TileSizesFragment = {
  __typename?: 'HubPageTileSizes'
  mobileSize: HubPageTileSize
  tabletSize: HubPageTileSize
  laptopSize: HubPageTileSize
}

export type AssetFieldsFragment = {
  __typename?: 'Asset'
  url: string
  title?: string | null
  description?: string | null
  mimeType?: string | null
}

export type CallToActionFieldsFragment = {
  __typename?: 'CallToAction'
  label: string
  url: string
  target?: string | null
  external?: boolean | null
  type?: CallToActionType | null
  color?: CallToActionColor | null
  size?: CallToActionSize | null
  trackingId?: string | null
  lucideIcon?: LucideIcon | null
  callToActionSemanticButtonSize?: SemanticButtonSizeEnum | null
  callToActionSemanticButtonStyle?: SemanticButtonStyleEnum | null
}

export type ExplanationStepFieldsFragment = {
  __typename?: 'ExplanationStep'
  title?: string | null
  description: string
  icon?: IconEnum | null
  lucideIcon?: LucideIcon | null
  picture?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  cta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
}

export type OmrPartnerFieldsFragment = {
  __typename?: 'OMRPartner'
  id: string
  name: string
  partnerUrl?: string | null
  logo: { __typename?: 'Asset' } & AssetFieldsFragment
}

export type SectionQuoteFieldsFragment = {
  __typename?: 'SectionQuote'
  quote: string
  name: string
  position: string
  signatureImage: { __typename?: 'Asset' } & AssetFieldsFragment
}

export type SectionTestimonialFieldsFragment = {
  __typename?: 'SectionTestimonial'
  id: string
  testimonial: string
  signature: string
  position?: string | null
  companyName?: string | null
  starRating?: number | null
  signatureImage?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  image: { __typename?: 'Asset'; url: string; title?: string | null; description?: string | null; optimisedUrl: string }
  cta?: ({ __typename?: 'CallToAction' } & CallToActionFieldsFragment) | null
}

export type LandingPageBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input']
  locale: Array<Locale> | Locale
  imageLocales: Array<Locale> | Locale
}>

export type LandingPageBySlugQuery = {
  __typename?: 'Query'
  landingPage?:
    | ({
        __typename?: 'LandingPage'
        id: string
        slug: string
        stage: Stage
        title: string
        seoContentAttributes?: {
          __typename?: 'SeoContentAttribute'
          bottomSectionHeadline?: string | null
          h1?: string | null
          id: string
          bottomSectionBody?: { __typename?: 'RichText'; markdown: string } | null
          topSectionBody?: { __typename?: 'RichText'; markdown: string } | null
        } | null
      } & LandingPageLayoutFieldsFragment)
    | null
}

export type ManageContentConfigsQueryVariables = Exact<{
  locales: Array<Locale> | Locale
}>

export type ManageContentConfigsQuery = {
  __typename?: 'Query'
  manageContentConfigs: Array<{
    __typename?: 'ManageContentConfig'
    id: string
    contentSlug: string
    loggedInSlug?: string | null
    anonymousSlug?: string | null
    menuTitle?: string | null
    customerTypes: Array<CustomerType>
  }>
}

export const CallToActionFieldsFragmentDoc = gql`
  fragment CallToActionFields on CallToAction {
    label
    url
    target
    external
    type
    color
    size
    trackingId
    lucideIcon
    callToActionSemanticButtonSize
    callToActionSemanticButtonStyle
  }
`
export const SectionFlipCounterFieldsFragmentDoc = gql`
  fragment SectionFlipCounterFields on SectionFlipCounter {
    __typename
    id
    optionalTitle
    targetDateTime
    decorations
    subtext
    ctaInformationText
    cta {
      ...CallToActionFields
    }
    darkMode
  }
  ${CallToActionFieldsFragmentDoc}
`
export const SectionByTheNumbersFieldsFragmentDoc = gql`
  fragment SectionByTheNumbersFields on SectionByTheNumbers {
    __typename
    id
    optionalTitle: title
    optionalSubtitle: subtitle
    sectionPadding
    styleVariant
    duration
    counters {
      target
      start
      prefix
      suffix
      subhead
    }
    cta {
      ...CallToActionFields
    }
  }
  ${CallToActionFieldsFragmentDoc}
`
export const AssetFieldsFragmentDoc = gql`
  fragment AssetFields on Asset {
    url
    title
    description
    mimeType
  }
`
export const SectionContactFieldsFragmentDoc = gql`
  fragment SectionContactFields on SectionContact {
    __typename
    id
    optionalDescription: description
    title
    contact {
      email
      id
      phone
      title
      description
      department
      departmentUrl
      contactIcons
      contactPhoto(locales: de) {
        ...AssetFields
      }
    }
    decorationPattern
    styleVariant
    omrTheme: theme
    centered
    generalCTA {
      ...CallToActionFields
    }
  }
  ${AssetFieldsFragmentDoc}
  ${CallToActionFieldsFragmentDoc}
`
export const SectionCtaFieldsFragmentDoc = gql`
  fragment SectionCtaFields on SectionCta {
    __typename
    id
    optionalTitle: title
    optionalDescription: description
    ctaText
    ctaUrl
    ctaTarget
    ctaImage(locales: de) {
      ...AssetFields
    }
    ctaExternal
    contentPosition
    showDecoration
    decorationPattern
    appStoreUrl
    playStoreUrl
    darkTheme
    styleVariant
    internalPageLink {
      event {
        slug
      }
      slug
    }
    partnerLogo(locales: de) {
      ...AssetFields
    }
  }
  ${AssetFieldsFragmentDoc}
`
export const ExplanationStepFieldsFragmentDoc = gql`
  fragment ExplanationStepFields on ExplanationStep {
    title
    description
    picture(locales: de) {
      ...AssetFields
    }
    icon
    lucideIcon
    cta {
      ...CallToActionFields
    }
  }
  ${AssetFieldsFragmentDoc}
  ${CallToActionFieldsFragmentDoc}
`
export const SectionExplanationBlocksFieldsFragmentDoc = gql`
  fragment SectionExplanationBlocksFields on SectionExplanationBlocks {
    __typename
    id
    cta {
      ...CallToActionFields
    }
    optionalTitle: title
    optionalSubtitle: subtitle
    centered
    items {
      ...ExplanationStepFields
    }
    styleVariant
    sectionPadding
    displayDecorations
    columns
  }
  ${CallToActionFieldsFragmentDoc}
  ${ExplanationStepFieldsFragmentDoc}
`
export const SectionFaqFieldsFragmentDoc = gql`
  fragment SectionFaqFields on Faq {
    __typename
    id
    title
    description
    optionalCtaText: ctaText
    optionalCtaUrl: ctaUrl
    questions: questions {
      ... on FaqQuestion {
        id
        question
        answer
        answerRte {
          html
        }
      }
    }
    styleVariant
    decorationPattern
    verticalLayout
  }
`
export const SectionHeroFieldsFragmentDoc = gql`
  fragment SectionHeroFields on SectionHero {
    __typename
    id
    optionalTitle: title
    optionalSubtitle: subtitle
    optionalDescription: description
    compact
    cta {
      ...CallToActionFields
    }
    ctaSecondary {
      ...CallToActionFields
    }
    ctaOnMobileOnly
    background(locales: de) {
      ...AssetFields
    }
    mobileBackground(locales: de) {
      ...AssetFields
    }
    logo(locales: de) {
      ...AssetFields
    }
    video(locales: de) {
      ...AssetFields
    }
    titleIsTransparent
  }
  ${CallToActionFieldsFragmentDoc}
  ${AssetFieldsFragmentDoc}
`
export const SectionIntroFieldsFragmentDoc = gql`
  fragment SectionIntroFields on SectionIntro {
    __typename
    id
    title
    description
    sectionHead
    sectionPadding
    centered
    omrTheme: theme
    cta {
      label
      url
      target
    }
  }
`
export const OmrPartnerFieldsFragmentDoc = gql`
  fragment OMRPartnerFields on OMRPartner {
    id
    name
    partnerUrl
    logo(locales: de) {
      ...AssetFields
    }
  }
  ${AssetFieldsFragmentDoc}
`
export const SectionOmrPartnerFieldsFragmentDoc = gql`
  fragment SectionOMRPartnerFields on SectionOMRPartner {
    __typename
    id
    optionalTitle: title
    optionalDescription: description
    asSlider
    sectionPadding
    darkTheme
    omrPartners {
      ...OMRPartnerFields
    }
    decorationPattern
  }
  ${OmrPartnerFieldsFragmentDoc}
`
export const SectionRichContentFieldsFragmentDoc = gql`
  fragment SectionRichContentFields on RichContent {
    __typename
    id
    showToc
    tocTitle
    tocHeaderLevel
    content {
      raw
      references {
        ... on Asset {
          __typename
          id
          url
        }
        ... on HtmlEmbed {
          __typename
          id
          rawHtml
        }
      }
    }
  }
`
export const SectionTeaserFieldsFragmentDoc = gql`
  fragment SectionTeaserFields on SectionTeaser {
    __typename
    id
    headline
    background(locales: de) {
      ...AssetFields
    }
    desktopImage(locales: de) {
      ...AssetFields
    }
    mobileImage(locales: de) {
      ...AssetFields
    }
    laptopImage(locales: de) {
      ...AssetFields
    }
    tabletImage(locales: de) {
      ...AssetFields
    }
    cta {
      ...CallToActionFields
    }
    ctaSecondary {
      ...CallToActionFields
    }
    optionalDescription: description
    optionalCtaUrl: ctaUrl
    optionalCtaLabel: ctaLabel
    styleVariant
    position
    isBgFulWidth
  }
  ${AssetFieldsFragmentDoc}
  ${CallToActionFieldsFragmentDoc}
`
export const SectionTestimonialFieldsFragmentDoc = gql`
  fragment SectionTestimonialFields on SectionTestimonial {
    id
    testimonial
    signature
    signatureImage(locales: de) {
      ...AssetFields
    }
    image(locales: de) {
      url
      optimisedUrl: url(
        transformation: {
          image: { quality: { value: 70 }, resize: { width: 1024, height: 1024, fit: clip } }
          document: { output: { format: webp } }
        }
      )
      title
      description
    }
    position
    companyName
    starRating
    cta {
      ...CallToActionFields
    }
  }
  ${AssetFieldsFragmentDoc}
  ${CallToActionFieldsFragmentDoc}
`
export const SectionTestimonialSliderFieldsFragmentDoc = gql`
  fragment SectionTestimonialSliderFields on TestimonialSlider {
    __typename
    id
    optionalTitle: title
    styleVariant
    sliderTheme: theme
    slide {
      ...SectionTestimonialFields
    }
  }
  ${SectionTestimonialFieldsFragmentDoc}
`
export const SectionTextMediaFieldsFragmentDoc = gql`
  fragment SectionTextMediaFields on TextMedia {
    __typename
    id
    title
    subtitle
    tag
    optionalCtaUrl: ctaUrl
    optionalCtaText: ctaText
    cta {
      ...CallToActionFields
    }
    sectionPadding
    sectionDivision
    darkTheme
    centered
    description
    image(locales: de) {
      ...AssetFields
    }
    imageEN: image(locales: en) {
      ...AssetFields
    }
    imageDE: image(locales: de) {
      ...AssetFields
    }
    elementPosition: position
    imageLinkUrl
    imageHiddenOnMobile
    vertical
    enableDescriptionStyling
  }
  ${CallToActionFieldsFragmentDoc}
  ${AssetFieldsFragmentDoc}
`
export const SectionNewsletterAudiencesFieldsFragmentDoc = gql`
  fragment SectionNewsletterAudiencesFields on SectionNewsletterAudience {
    __typename
    id
    audiences {
      slug
      name
      description
      private
      previewCta {
        ...CallToActionFields
      }
    }
  }
  ${CallToActionFieldsFragmentDoc}
`
export const SectionTabsFieldsFragmentDoc = gql`
  fragment SectionTabsFields on SectionTab {
    __typename
    id
    optionalTitle: title
    optionalDescription: description
    titlePosition
    tabContents: tabContents {
      ... on TabContent {
        id
        tabName
        title
        description
        imageEN: image(locales: en) {
          ...AssetFields
        }
        imageDE: image(locales: de) {
          ...AssetFields
        }
        downloads {
          date
          description
          title
          previewimage {
            url
            title
          }
          id
          downloadDe {
            url
            fileName
          }
          downloadEn {
            url
            fileName
          }
        }
      }
    }
  }
  ${AssetFieldsFragmentDoc}
`
export const SubscriptionTeaserFieldsFragmentDoc = gql`
  fragment SubscriptionTeaserFields on SubscriptionTeaser {
    __typename
    id
    optionalTitle: title
    optionalDescription: description
    bannerText
    optionalSubBannerText: subBannerText
    ctaText
    ctaUrl
    sectionPadding
    styleVariant
    decorationPattern
  }
`
export const PpcReviewsProductFieldsFragmentDoc = gql`
  fragment PpcReviewsProductFields on PpcReviewsProduct {
    __typename
    ppcDescription
    id
    url
    viewUrl
    reviewsProduct {
      id
      name
      rating
      ratingsCount
      logoUrl
    }
  }
`
export const SectionHubspotFormFieldsFragmentDoc = gql`
  fragment SectionHubspotFormFields on SectionHubspotForm {
    __typename
    id
    formId
  }
`
export const SectionAnchorTargetFieldsFragmentDoc = gql`
  fragment SectionAnchorTargetFields on SectionAnchorTarget {
    __typename
    id
    anchorId
  }
`
export const SectionStyledHeroFieldsFragmentDoc = gql`
  fragment SectionStyledHeroFields on SectionStyledHero {
    __typename
    id
    style
    theme
    backgroundColor
    highlitedTitle: title {
      style
      text
      headlineSize
      headlineCase
    }
    heroDescription: description
    partnerBadge {
      partnerBadgeLabel
      partnerBadgeLogo(locales: de) {
        ...AssetFields
      }
    }
    heroImage {
      horizontalDesktopPosition
      horizontalMobilePosition
      laptopImage {
        url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
      }
      verticalDesktopPosition
      verticalMobilePosition
      mobileImage {
        url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
      }
      tabletImage {
        url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
      }
      desktopImage {
        url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
      }
      video(locales: de) {
        ...AssetFields
      }
      videoAutoplay
    }
    heroImageRight {
      horizontalDesktopPosition
      horizontalMobilePosition
      laptopImage {
        url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
      }
      verticalDesktopPosition
      verticalMobilePosition
      mobileImage {
        url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
      }
      tabletImage {
        url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
      }
      desktopImage {
        url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
      }
    }
    mobileImage(locales: de) {
      url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
    }
    tabletImage(locales: de) {
      url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
    }
    laptopImage(locales: de) {
      url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
    }
    desktopImage(locales: de) {
      url(transformation: { image: { quality: { value: 60 } }, document: { output: { format: webp } } })
    }
    primaryCta {
      ...CallToActionFields
    }
    secondaryCta {
      ...CallToActionFields
    }
    additionalText
    paddingSize
    bgStyleVariant: styleVariant
    spacer
  }
  ${AssetFieldsFragmentDoc}
  ${CallToActionFieldsFragmentDoc}
`
export const SectionPricingTiersFieldsFragmentDoc = gql`
  fragment SectionPricingTiersFields on SectionPricingTiers {
    __typename
    id
    sectionPricingTiersTitle
    sectionPricingTiersItems {
      id
      isRecommended
      pricingTierRecommendationLabel
      pricingTierTitleIcon
      pricingTierTitle
      pricingTierSubTitle
      features
      featuresTitle
      freeIncentiveBudget
      freeIncentiveBudgetSuffix
      freeIncentiveDescription
      hasPrice
      priceValue
      paidPer
      pricingDescription
      noPriceBottomline
      noPriceTopline
      primaryCtaLabel
      primaryCtaLink
      primaryCtaTrackingId
      secondaryCtaLabel
      secondaryCtaLink
      secondaryCtaTrackingId
    }
  }
`
export const SectionReviewsFeaturesTableFieldsFragmentDoc = gql`
  fragment SectionReviewsFeaturesTableFields on SectionReviewsFeaturesTable {
    __typename
    id
    featuresTableTitle
    featuresTableDescription
    featuresTableColumns
    featureTableSections {
      id
      featureSectionTitle
      featureSectionDescription
      featureSectionFeatures {
        id
        featureTitle
        featureDescription
      }
    }
  }
`
export const SectionSlimCtaFieldsFragmentDoc = gql`
  fragment SectionSlimCtaFields on SectionSlimCta {
    __typename
    id
    slimCtaHeaderIcon
    slimCtaHeadline
    slimCtaBody
    slimCtaCta {
      ...CallToActionFields
    }
  }
  ${CallToActionFieldsFragmentDoc}
`
export const TileSizesFragmentDoc = gql`
  fragment TileSizes on HubPageTileSizes {
    mobileSize
    tabletSize
    laptopSize
  }
`
export const HubAssetFieldsFragmentDoc = gql`
  fragment HubAssetFields on Asset {
    title
    description
    mimeType
    originalUrl: url
    url(transformation: { image: { quality: { value: 50 } }, document: { output: { format: webp } } })
  }
`
export const ContentTileFieldsFragmentDoc = gql`
  fragment ContentTileFields on HubPageContentTile {
    id
    title
    subtitle
    tag {
      id
      name
      slug
    }
    theme
    tileSizes {
      ...TileSizes
    }
    image(locales: $imageLocales) {
      ...HubAssetFields
    }
    cta {
      ...CallToActionFields
    }
  }
  ${TileSizesFragmentDoc}
  ${HubAssetFieldsFragmentDoc}
  ${CallToActionFieldsFragmentDoc}
`
export const SectionTilesFieldsFragmentDoc = gql`
  fragment SectionTilesFields on SectionTiles {
    id
    theme
    optionalTitle: title
    optionalSubtitle: subtitle
    tiles {
      __typename
      ...ContentTileFields
      ... on HubPageSocialMediaTile {
        id
      }
      ... on HubPageArticleListTile {
        id
      }
      ... on HubPageLatestArticleTile {
        id
      }
      ... on HubPageNewsletterSubscriptionTile {
        id
      }
      ... on HubPageReferenceListTile {
        id
      }
      ... on HubPageInfoTile {
        id
      }
      ... on HubPageImageTile {
        id
      }
      ... on HubPageStaticTile {
        id
      }
      ... on HubPageAdTile {
        id
      }
      ... on HubPageSpeakerTile {
        id
      }
      ... on HubPagePartnerCompanyTile {
        id
      }
    }
  }
  ${ContentTileFieldsFragmentDoc}
`
export const SectionVideoFieldsFragmentDoc = gql`
  fragment SectionVideoFields on SectionVideo {
    __typename
    id
    title
    optionalDescription: description
    hideSectionHead
    ytVideoId
    ytVideoTitle
    vidTitle
    dates
    styleVariant
  }
`
export const LandingPageLayoutFieldsFragmentDoc = gql`
  fragment LandingPageLayoutFields on LandingPage {
    pageLayout {
      ...SectionByTheNumbersFields
      ...SectionContactFields
      ...SectionCtaFields
      ...SectionExplanationBlocksFields
      ...SectionFaqFields
      ...SectionHeroFields
      ...SectionIntroFields
      ...SectionOMRPartnerFields
      ...SectionRichContentFields
      ...SectionTeaserFields
      ...SectionTestimonialSliderFields
      ...SectionTextMediaFields
      ...SectionNewsletterAudiencesFields
      ...SectionTabsFields
      ...SubscriptionTeaserFields
      ...PpcReviewsProductFields
      ...SectionHubspotFormFields
      ...SectionAnchorTargetFields
      ...SectionStyledHeroFields
      ...SectionPricingTiersFields
      ...SectionReviewsFeaturesTableFields
      ...SectionSlimCtaFields
      ...SectionTilesFields
      ...SectionVideoFields
    }
  }
  ${SectionByTheNumbersFieldsFragmentDoc}
  ${SectionContactFieldsFragmentDoc}
  ${SectionCtaFieldsFragmentDoc}
  ${SectionExplanationBlocksFieldsFragmentDoc}
  ${SectionFaqFieldsFragmentDoc}
  ${SectionHeroFieldsFragmentDoc}
  ${SectionIntroFieldsFragmentDoc}
  ${SectionOmrPartnerFieldsFragmentDoc}
  ${SectionRichContentFieldsFragmentDoc}
  ${SectionTeaserFieldsFragmentDoc}
  ${SectionTestimonialSliderFieldsFragmentDoc}
  ${SectionTextMediaFieldsFragmentDoc}
  ${SectionNewsletterAudiencesFieldsFragmentDoc}
  ${SectionTabsFieldsFragmentDoc}
  ${SubscriptionTeaserFieldsFragmentDoc}
  ${PpcReviewsProductFieldsFragmentDoc}
  ${SectionHubspotFormFieldsFragmentDoc}
  ${SectionAnchorTargetFieldsFragmentDoc}
  ${SectionStyledHeroFieldsFragmentDoc}
  ${SectionPricingTiersFieldsFragmentDoc}
  ${SectionReviewsFeaturesTableFieldsFragmentDoc}
  ${SectionSlimCtaFieldsFragmentDoc}
  ${SectionTilesFieldsFragmentDoc}
  ${SectionVideoFieldsFragmentDoc}
`
export const FooterFieldsFragmentDoc = gql`
  fragment FooterFields on Footer {
    id
    omrFooterLinks {
      id
      name
      link
    }
    omrFooterSocials {
      id
      name
      link
      logo(locales: de) {
        url
      }
    }
  }
`
export const HeaderFieldsFragmentDoc = gql`
  fragment HeaderFields on Header {
    id
    logo(locales: de) {
      url
    }
    mobileLogo(locales: de) {
      url
    }
    omrHeaderMenuItems {
      id
      slug
      name
      link
      omrHeaderSubmenuItems {
        id
        name
        link
        omrHeaderSubSubmenuItems {
          id
          name
          link
        }
      }
      omrHeaderSubmenuCta {
        label
        url
      }
    }
    omrHeaderPartners {
      id
      name
      logo(locales: de) {
        url
        title
      }
      partnerUrl
    }
    omrHeaderSocials {
      id
      name
      link
      logo(locales: de) {
        url
      }
    }
  }
`
export const ProcessStepFieldsFragmentDoc = gql`
  fragment ProcessStepFields on ProcessStep {
    __typename
    id
    optionalTitle: title
    optionalDescription: description
    optionalCtaText: ctaText
    optionalCtaUrl: ctaUrl
    steps
    sectionPadding
    styleVariant
    displayDecorations
  }
`
export const SectionFestivalNewsletterFieldsFragmentDoc = gql`
  fragment SectionFestivalNewsletterFields on SectionNewsletter {
    __typename
    id
    title
    description
    linkText
    linkTarget
    linkUrl
    audience
  }
`
export const SectionHotelsFieldsFragmentDoc = gql`
  fragment SectionHotelsFields on SectionHotel {
    __typename
    id
    title
    description
    hotels: hotels {
      ... on Hotel {
        id
        name
        description
        rating
        distance
        url
        logo(locales: de) {
          ...AssetFields
        }
      }
    }
  }
  ${AssetFieldsFragmentDoc}
`
export const SectionQuoteFieldsFragmentDoc = gql`
  fragment SectionQuoteFields on SectionQuote {
    quote
    name
    signatureImage(locales: de) {
      ...AssetFields
    }
    position
  }
  ${AssetFieldsFragmentDoc}
`
export const LandingPageLayoutBySlugDocument = gql`
  query landingPageLayoutBySlug($slug: String!, $locale: [Locale!]!, $imageLocales: [Locale!]!, $stage: Stage = PUBLISHED) {
    landingPage(where: { slug: $slug }, stage: $stage, locales: $locale) {
      id
      slug
      stage
      title
      ...LandingPageLayoutFields
    }
  }
  ${LandingPageLayoutFieldsFragmentDoc}
`

/**
 * __useLandingPageLayoutBySlugQuery__
 *
 * To run a query within a Vue component, call `useLandingPageLayoutBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageLayoutBySlugQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLandingPageLayoutBySlugQuery({
 *   slug: // value for 'slug'
 *   locale: // value for 'locale'
 *   imageLocales: // value for 'imageLocales'
 *   stage: // value for 'stage'
 * });
 */
export function useLandingPageLayoutBySlugQuery(
  variables:
    | LandingPageLayoutBySlugQueryVariables
    | VueCompositionApi.Ref<LandingPageLayoutBySlugQueryVariables>
    | ReactiveFunction<LandingPageLayoutBySlugQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<LandingPageLayoutBySlugQuery, LandingPageLayoutBySlugQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LandingPageLayoutBySlugQuery, LandingPageLayoutBySlugQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<LandingPageLayoutBySlugQuery, LandingPageLayoutBySlugQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<LandingPageLayoutBySlugQuery, LandingPageLayoutBySlugQueryVariables>(
    LandingPageLayoutBySlugDocument,
    variables,
    options,
  )
}
export function useLandingPageLayoutBySlugLazyQuery(
  variables?:
    | LandingPageLayoutBySlugQueryVariables
    | VueCompositionApi.Ref<LandingPageLayoutBySlugQueryVariables>
    | ReactiveFunction<LandingPageLayoutBySlugQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<LandingPageLayoutBySlugQuery, LandingPageLayoutBySlugQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LandingPageLayoutBySlugQuery, LandingPageLayoutBySlugQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<LandingPageLayoutBySlugQuery, LandingPageLayoutBySlugQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<LandingPageLayoutBySlugQuery, LandingPageLayoutBySlugQueryVariables>(
    LandingPageLayoutBySlugDocument,
    variables,
    options,
  )
}
export type LandingPageLayoutBySlugQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  LandingPageLayoutBySlugQuery,
  LandingPageLayoutBySlugQueryVariables
>
export const LandingPageBySlugDocument = gql`
  query landingPageBySlug($slug: String!, $locale: [Locale!]!, $imageLocales: [Locale!]!) {
    landingPage(where: { slug: $slug }, locales: $locale) {
      id
      ...LandingPageLayoutFields
      seoContentAttributes {
        bottomSectionBody {
          markdown
        }
        bottomSectionHeadline
        h1
        id
        topSectionBody {
          markdown
        }
      }
      slug
      stage
      title
    }
  }
  ${LandingPageLayoutFieldsFragmentDoc}
`

/**
 * __useLandingPageBySlugQuery__
 *
 * To run a query within a Vue component, call `useLandingPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageBySlugQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLandingPageBySlugQuery({
 *   slug: // value for 'slug'
 *   locale: // value for 'locale'
 *   imageLocales: // value for 'imageLocales'
 * });
 */
export function useLandingPageBySlugQuery(
  variables:
    | LandingPageBySlugQueryVariables
    | VueCompositionApi.Ref<LandingPageBySlugQueryVariables>
    | ReactiveFunction<LandingPageBySlugQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<LandingPageBySlugQuery, LandingPageBySlugQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LandingPageBySlugQuery, LandingPageBySlugQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<LandingPageBySlugQuery, LandingPageBySlugQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<LandingPageBySlugQuery, LandingPageBySlugQueryVariables>(
    LandingPageBySlugDocument,
    variables,
    options,
  )
}
export function useLandingPageBySlugLazyQuery(
  variables?:
    | LandingPageBySlugQueryVariables
    | VueCompositionApi.Ref<LandingPageBySlugQueryVariables>
    | ReactiveFunction<LandingPageBySlugQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<LandingPageBySlugQuery, LandingPageBySlugQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LandingPageBySlugQuery, LandingPageBySlugQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<LandingPageBySlugQuery, LandingPageBySlugQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<LandingPageBySlugQuery, LandingPageBySlugQueryVariables>(
    LandingPageBySlugDocument,
    variables,
    options,
  )
}
export type LandingPageBySlugQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  LandingPageBySlugQuery,
  LandingPageBySlugQueryVariables
>
export const ManageContentConfigsDocument = gql`
  query manageContentConfigs($locales: [Locale!]!) {
    manageContentConfigs(locales: $locales) {
      id
      contentSlug
      loggedInSlug
      anonymousSlug
      menuTitle
      customerTypes
    }
  }
`

/**
 * __useManageContentConfigsQuery__
 *
 * To run a query within a Vue component, call `useManageContentConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageContentConfigsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useManageContentConfigsQuery({
 *   locales: // value for 'locales'
 * });
 */
export function useManageContentConfigsQuery(
  variables:
    | ManageContentConfigsQueryVariables
    | VueCompositionApi.Ref<ManageContentConfigsQueryVariables>
    | ReactiveFunction<ManageContentConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ManageContentConfigsQuery, ManageContentConfigsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ManageContentConfigsQuery, ManageContentConfigsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ManageContentConfigsQuery, ManageContentConfigsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ManageContentConfigsQuery, ManageContentConfigsQueryVariables>(
    ManageContentConfigsDocument,
    variables,
    options,
  )
}
export function useManageContentConfigsLazyQuery(
  variables?:
    | ManageContentConfigsQueryVariables
    | VueCompositionApi.Ref<ManageContentConfigsQueryVariables>
    | ReactiveFunction<ManageContentConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ManageContentConfigsQuery, ManageContentConfigsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ManageContentConfigsQuery, ManageContentConfigsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ManageContentConfigsQuery, ManageContentConfigsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ManageContentConfigsQuery, ManageContentConfigsQueryVariables>(
    ManageContentConfigsDocument,
    variables,
    options,
  )
}
export type ManageContentConfigsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ManageContentConfigsQuery,
  ManageContentConfigsQueryVariables
>
